/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.components', [
        // residents
        'BlurAdmin.residentsListCom',
        'BlurAdmin.residentDetailCom',
        // bulletin
        'BlurAdmin.bulletinBoardListCom',
        'BlurAdmin.bulletinBoardDetailCom',
        //users
        'BlurAdmin.usersListCom',
        'BlurAdmin.userDetailCom',
        // announcements
        'Tagaste.announcementDetail',
        'Tagaste.announcementsListCom',
        // avatar
        'BlurAdmin.avatar',
        // Carteen
        'BlurAdmin.canteenNewComponent',
        'BlurAdmin.canteenAppUsersListComponent',
        'BlurAdmin.canteenInDish',
        'BlurAdmin.canteenListComponent',
        'BlurAdmin.canteenDetailCom',
        'BlurAdmin.canteenSelectCourseCom',
        'BlurAdmin.canteenReserveNewCom',
        'BlurAdmin.canteenCommentsCom',
        //servicios
        'BlurAdmin.inServiceListComponent',
        'BlurAdmin.inServiceDetailComponent',
        'Tagaste.inServiceReserveCom',
        'Tagaste.schedule',
        // Rooms
        'Tagaste.roomSchedule',
        // datepicker
        'Tagaste.datePickerCom',
        //incidents
        'Tagaste.incidentDetailCom',
        'Tagaste.incidentsListCom',
        //tasks
        'Tagaste.taskDetailCom',
        'Tagaste.tasksListCom',
        //activities
        'Tagaste.activitiesListCom',
        'Tagaste.activityDetailCom',
        'Tagaste.reserveListCom',
        'Tagaste.reserveNewCom',
        //notifications push
        'Tagaste.notificationPushCom',
        'BlurAdmin.selectCountry',
        'BlurAdmin.chat.chatlist',
        'BlurAdmin.chat.ModNew',
        'BlurAdmin.chat.chatconv',
        // file
        'BlurAdmin.file',
        'BlurAdmin.logbookCom',
        //rooms
        'BlurAdmin.roomsListCom',
        'BlurAdmin.roomsDetailCom',
        'BlurAdmin.cardFile',
        // scheduler
        'BlurAdmin.inWorkerTaskListComponent',
        'BlurAdmin.inWorkerTaskDetailComponent',
        // payment
        'BlurAdmin.paymentCom',
        //task
        'Tagaste.taskSchedulerListCom',
        'Tagaste.taskSchedulerDetailCom',
        // bedrooms
        'Tagaste.bedroomsListCom',
        'Tagaste.bedroomDetailCom',
        //Requests
        'Tagaste.requestsListComponent',
        'Tagaste.requestsDetailComponent',
        //Reservations
        'Tagaste.reservationsListComponent',
        'Tagaste.reservationDetailComponent',
        // masterTables
        'Tagaste.masterTablesPanelComponent',
        'Tagaste.masterTablesConfigComponent',
        'Tagaste.masterTablesStatusComponent',
        'Tagaste.masterTablesMenuComponent',
        'Tagaste.masterTablesDishComponent',
        'Tagaste.masterTablesTaskComponent',
        'Tagaste.masterTablesRoomRateComponent',
        'Tagaste.masterTablesEmailComponent',
        'Tagaste.masterTablesTaxComponent',
        'Tagaste.masterTablesCustomConceptsComponent',
        // billing
        'Tagaste.billingListComponent',
        'Tagaste.billingDetailComponent'
    ]);

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.config', [
        'LocalStorageModule'
    ])
        .config(routeConfig)
        .config(['$logProvider', 'ENV', function ($logProvider, ENV) {
            $logProvider.debugEnabled(ENV.debug);
        }])
        .config(function (localStorageServiceProvider) {
            localStorageServiceProvider.setStorageType('sessionStorage');
        })
        .constant('ENV', {
            'env': 'prod',
            // 'env': 'dev',
            'debug': true,
            // 'backOffice': 'https://api.tagaste.com',
            'backOffice': 'https://api3.tagaste.talentosoftware.com',
            //'backOffice': 'http://localhost:3000',
            'version': '/v3/',
            'defaultLanguage': 'es',
            'availableLanguages': ['es'],
            'baPanelAnim': 'fade-in-left',
            'formatDate': 'dd/MM/yyyy',
            'secondsToRenew': 120,
            'limitMaxUsers': 999999,
            'toolbarOptions': [
                ['h1', 'h2', 'h3', 'p', 'pre', 'quote'],
                ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent']
            ]
        })
        .constant('Roles', {
            director: 'DIRECTOR',
            manager: 'MANAGER',
            maintenanceGroup: ['MAINTENANCE', 'MAINTENANCE_WORKER', 'RECEPTION'],
            cleaningGroup: ['CLEANING', 'CLEANING_WORKER'],
            cleaningWorker: 'CLEANING_WORKER'
        })
        .constant('DishTypes', {
            extra: '00',
            extraVarTitle: 'extra',
            first: '01',
            second: '02',
            dessert: '03'
        })
        .constant('CleaningTasks', {
            others: '04'
        })
        .constant('Funcionalities', {
            activity: 'Actividad',
            service: 'Servicio',
            menu: 'Menu',
            incident: 'Incidencia',
            task: 'Tarea'
        })
        .constant('Fields', {
            id: '_id',
            appUser: 'appUser'
        })
        .constant('userKind', {
            appUser: 'AppUser',
            guest: 'Guest',
            user: 'User'
        })
        .constant('chatConfig', {
            'sendMessage': 'send-message',
            'message': 'message',
            'error': 'error',
            'readMessage': 'read-message',
            'markRead': 'mark-read'
        })
        .constant('state', {
            'chat': 'chatPanel',
            'announcement': 'annoucemnts',
            'billing': 'billing'
        })
        .constant('routeConf', {
            'masterTable': 'masterTable',
            'branch': 'branch',
            'file': 'file',
            'signedUpload': 'signedUpload',
            'generateThumb': 'generateThumb',
            'signedUrl': 'signedUrl',
            'app': 'app',
            'bboard': 'bboard',
            'allergyType': 'allergyType',
            'menuType': 'menuType',
            'dishType': 'dishType',
            'tours': 'tours',
            'user': 'user',
            'incident': 'incident',
            'statusType': 'statusType',
            'incidentStatus': 'incidentStatus',
            'agenda': 'agenda',
            'notice': 'notice',
            'resident': 'resident',
            'accessRequest': 'accessRequest',
            'accessConfirmed': 'accessConfirmed',
            'docType': 'docType',
            'service': 'service',
            'menu': 'menu',
            'metrics': 'metrics',
            'incidentsOpened': 'incidentsOpened',
            'incidentsHistory': 'incidentsHistory',
            'actualOccupancy': 'actualOccupancy',
            'menuReservation': 'menuReservation',
            'chat': 'chat',
            'getChatGroup': 'getChatGroup',
            'getChatMsg': 'getChatMsg',
            'chatGroup': 'chatGroup',
            'guest': 'guest',
            'agendaSignAPP': 'agendaSignAPP',
            'agendaSignPanel': 'agendaSignPanel',
            'menuPanel': 'menuPanel',
            'findScheduledFacility': 'findScheduledFacility',
            'facility': 'facility',
            'facilityBook': 'facilityBook',
            'ReportMReserveService': 'ReportMReserveService',
            'rgpd': 'rgpd',
            'userManual': 'userManual',
            'occupancy': 'occupancy',
            'away': 'away',
            'config': 'config',
            'spot': 'spot',
            'taskType': 'taskType',
            'role': 'role',
            'planningRoom': 'planningRoom',
            'task': 'task',
            'workerTask': 'workerTask',
            'reservation': 'reservation',
            'unblock': 'unblock',
            'planner': 'planner',
            'university': 'university',
            'faculty': 'faculty',
            'carrerCollege': 'carrerCollege',
            'request': 'request',
            'BillingPrintService': 'BillingPrintService',
        })
        .constant('roomColors', {
            'isOccupied': '#80fec1',
            'isBlocked': '#000000',
            'isEmpty': 'rgb(255,255,255)',
            'isReserved': 'rgb(206,145,120)'
        })
        .constant('masterTables', [
            {
                'translatekey': 'MASTERTABLES.OPTION.KNOWABOUTUS',
                'resource': 'knowAboutUs',
                'component': 'config',
                'lockedItems': ['others']
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.INTERVIEWRATING',
                'resource': 'interviewRating',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.PAYTYPE',
                'resource': 'payType',
                'component': 'config',
                'locked': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.PARENT_TASKTYPE',
                'resource': 'taskTypes',
                'component': 'config',
                'lockedItems': ['cleaning', 'maintenance']
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.TASKTYPE',
                'resource': 'taskTypes',
                'component': 'tasktypes',
                'branches': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.BILLINGTYPE',
                'resource': 'billingType',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.BILLINGCHECKOUTTYPE',
                'resource': 'billingCheckoutType',
                'component': 'config',
                'locked': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.MENUSPECIALTYPE',
                'resource': 'menuSpecialType',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.MENUSERVICE',
                'resource': 'menuService',
                'component': 'config',
                'lockedItems': ['01', '02', '03']
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.AWAYPERIOD',
                'resource': 'awayPeriod',
                'component': 'config',
                'locked': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.ADMONITION',
                'resource': 'admonition',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.ROOMTYPE',
                'resource': 'roomType',
                'component': 'config',
                'branches': true,
                'multipleBranch': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.MODALITY',
                'resource': 'modality',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.CONTACTTYPE',
                'resource': 'contactType',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.ALLERGYTYPES',
                'resource': 'allergyTypes',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.DOCTYPES',
                'resource': 'docTypes',
                'component': 'config',
                'locked': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.INVENTORYTAGS',
                'resource': 'inventoryTags',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.STATESROOM',
                'resource': 'statesRoom',
                'component': 'config',
                'locked': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.STATUSTYPES',
                'resource': 'statusTypes',
                'component': 'statustypes'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.MENUTYPES',
                'resource': 'menuTypes',
                'component': 'menutypes',
                'locked': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.DISHTYPES',
                'resource': 'dishTypes',
                'component': 'dishtypes',
                'locked': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.UNIVERSITIES',
                'resource': 'universities',
                'component': 'config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.FACULTIES',
                'resource': 'faculties',
                'component': 'config',
                'related': 'universities',
                'relatedTable': 'Config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.STUDIES',
                'resource': 'studies',
                'component': 'config',
                'related': 'faculties',
                'relatedTable': 'Config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.ROOM_RATES',
                'resource': 'roomRate',
                'component': 'roomrate',
                'related': 'roomType',
                'relatedTable': 'Config'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.EMAILS',
                'resource': 'email',
                'component': 'email',
                'branches': true
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.TAXES',
                'resource': 'tax',
                'component': 'tax'
            },
            {
                'translatekey': 'MASTERTABLES.OPTION.CUSTOMCONCEPTS',
                'resource': 'customConcept',
                'component': 'customConcept'
            }
        ])
        .constant('masterTablesFields', {
            binary: [
                {translatekey: 'BUTTONS.YES', value: true},
                {translatekey: 'BUTTONS.NO', value: false}
            ],
            functionalities: ['Incidencia', 'workerTask'],
            templates: [
                {translatekey: 'MASTERTABLES.TEMPLATES.APPLICATIONS', value: 'applications'},
                {translatekey: 'MASTERTABLES.TEMPLATES.RESERVES', value: 'reserves'}
            ]
        })
        .factory('serviceConf', ['ENV', function (ENV) {
            return {
                UserService: {
                    user: ENV.backOffice + ENV.version + 'user/:idU',
                    createSession: ENV.backOffice + ENV.version + 'user/createSession/:idU',
                    renewSession: ENV.backOffice + ENV.version + 'user/renewSession/:idU',
                    changePass: ENV.backOffice + ENV.version + 'user/changePass/:idU',
                    resetPassReq: ENV.backOffice + ENV.version + 'user/resetPassRequest/:idU',
                    resetPassConf: ENV.backOffice + ENV.version + 'user/resetPassConfirm/:idU',
                    cancelAccess: ENV.backOffice + ENV.version + 'user/cancelAccess/:idU',
                },
                ResidentsService: ENV.backOffice + ENV.version + 'resident/:idR',
                ResidentRenewAccess: ENV.backOffice + ENV.version + 'resident/renewAccess/:idR',
                ResidentCancelAccess: ENV.backOffice + ENV.version + 'resident/cancelAccess/:idR',
                ResidentsAdmonition: ENV.backOffice + ENV.version + 'resident/:idR/admonition',
                BulletinService: ENV.backOffice + ENV.version + 'app/bboard/:idB',
                NoticeService: ENV.backOffice + ENV.version + 'app/notice/:idN',
                MenuService: ENV.backOffice + ENV.version + 'app/menu/:idM/:idS',
                DishService: ENV.backOffice + ENV.version + 'app/dish/:idD',
                DishTypeService: ENV.backOffice + ENV.version + 'masterTable/dishType',
                MenuTypeService: ENV.backOffice + ENV.version + 'masterTable/menuType',
                MenuNextService: ENV.backOffice + ENV.version + 'app/menuNext',
                BranchService: ENV.backOffice + ENV.version + 'masterTable/branch/:idB',
                ServicesService: ENV.backOffice + ENV.version + 'app/service/:idS',
                RolesService: ENV.backOffice + ENV.version + 'masterTable/role',
                ChatGroupsService: ENV.backOffice + ENV.version + 'chat/getChatGroup/:idC',
                ReportMReserveService: ENV.backOffice + ENV.version + 'app/reports/menu/reservelist/:idR',
                ReportDishesService: ENV.backOffice + ENV.version + 'app/reports/menu/dishes/:idR',
                ReportPeopleIn: ENV.backOffice + ENV.version + 'reports/peopleIn/:idR',
                MasterTableService: ENV.backOffice + ENV.version + ':idT/:idJ/:idP',
                ConfigService: ENV.backOffice + ENV.version + 'config/:idR',
                OccupancyService: ENV.backOffice + ENV.version + 'occupancy/:idO/away/:idA',
                OccupancyResident: ENV.backOffice + ENV.version + 'occupancy/:idT/:idR/:idJ/:idP',
                GuestInvitations: ENV.backOffice + ENV.version + 'guestInvitations/:idI/:idR',
                AdmonitionService: ENV.backOffice + ENV.version + 'admonition/:idR',
                HistoryMenu: ENV.backOffice + ENV.version + 'resident/:idR/historymenu',
                HistoryAgenda: ENV.backOffice + ENV.version + 'resident/:idR/historyagenda',
                HistoryIncident: ENV.backOffice + ENV.version + 'resident/:idR/historyincident',
                HistoryService: ENV.backOffice + ENV.version + 'resident/:idR/historyservice',
                LogbookService: ENV.backOffice + ENV.version + 'logbook/:idL',
                LogbookComments: ENV.backOffice + ENV.version + 'logbook/:idL/comment/:idC',
                AppUserService: ENV.backOffice + ENV.version + 'appUser/:idU',
                UsersServiceByBranch: ENV.backOffice + ENV.version + 'user/:idU',
                WorkerTaskService: ENV.backOffice + ENV.version + 'workerTask/getAsCalendar',
                WorkerTaskUpdateService: ENV.backOffice + ENV.version + 'workerTask/:idT/period/:idP',
                WorkerTaskOpenService: ENV.backOffice + ENV.version + 'workerTask/open',
                RequestService: ENV.backOffice + ENV.version + 'application/:idR',
                BillingService: ENV.backOffice + ENV.version + 'billing/:idR',
                BillingPrintService: ENV.backOffice + ENV.version + 'billing/:idR/print',
                BillingExportService: ENV.backOffice + ENV.version + 'billing/export',
                ConceptService: ENV.backOffice + ENV.version + 'concept/:idR',
                RequestAcceptService: ENV.backOffice + ENV.version + 'application/:idR/accept',
                RequestExportService: ENV.backOffice + ENV.version + 'applications/export',
                ResidentExportService: ENV.backOffice + ENV.version + 'residents/export',
                IncidentsExportService: ENV.backOffice + ENV.version + 'incidents/export',
                TaskExportService: ENV.backOffice + ENV.version + 'tasks/export',
                ActivitiesExportService: ENV.backOffice + ENV.version + 'activities/export',
                ActivityDetailsExportService: ENV.backOffice + ENV.version + 'activity-details/export',
                MenuExportService: ENV.backOffice + ENV.version + 'menu/export',
                ServiceListExportService: ENV.backOffice + ENV.version + 'app/service/export',
                InWorkerTaskListExportService: ENV.backOffice + ENV.version + 'workerTask/export',
                UserExportListService: ENV.backOffice + ENV.version + 'user/export',
                ReservationExportListService: ENV.backOffice + ENV.version + 'app/reservation/export',
                ReservationNoShowService: ENV.backOffice + ENV.version + 'app/reservation/:idR/noshow',
                ReservationAcceptService: ENV.backOffice + ENV.version + 'app/reservation/:idR/accept',
                ReservationCancelBillingsService: ENV.backOffice + ENV.version + 'app/reservation/:idR/cancelBillings',
                SpotService: ENV.backOffice + ENV.version + 'spot/:idS',
                GuestService: ENV.backOffice + ENV.version + 'guest/:idR',
                SESListTemplatesService: ENV.backOffice + ENV.version + 'SESListTemplates',
                RoomsOccupancyService: ENV.backOffice + ENV.version + 'roomsOccupancy',
                OccupancyByRangeService: ENV.backOffice + ENV.version + 'occupancy/byRange',
            };
        }])
        .directive('checkAvatar', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    attrs.$observe('ngSrc', function (ngSrc) {
                        if (!ngSrc) {
                            element.attr('src', 'app/components/uploadAvatar/assets/avatarDefault.png');
                        }
                    });
                }
            };
        })
        .directive('checkImage', function () {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    attrs.$observe('ngSrc', function (ngSrc) {
                        if (!ngSrc) {
                            element.attr('src', 'app/components/uploadAvatar/assets/picDefault.png');
                        }
                    });
                }
            };
        });

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('config', {
                title: 'config',
                abstract: false
            });
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.login', [
        'ui.router',
        'ngRoute',
        'BlurAdmin.config',
        'BlurAdmin.service',
        'BlurAdmin.service.permissions',
        'LocalStorageModule',
        'ngAnimate',
        'toastr',
        'ui.bootstrap'
    ]).config(function($locationProvider){
        $locationProvider.html5Mode({
            enabled:true,
            requireBase: false
        });
    });
})();

/**
 * @author Talento Software
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages', [
        'ui.router',
        'LocalStorageModule',
        'pascalprecht.translate',
        'BlurAdmin.pages.dashboard',
        'BlurAdmin.pages.residents',
        'BlurAdmin',
        'BlurAdmin.config',
        'BlurAdmin.service',
        'BlurAdmin.service.permissions',
        'Tagaste.annoucements',
        'BlurAdmin.pages.bulletinBoard',
        'BlurAdmin.pages.canteen',
        'BlurAdmin.pages.services',
        'Tagaste.pages.incidents',
        'Tagaste.pages.tasks',
        'Tagaste.pages.activities',
        'Tagaste.pages.chat',
        // 'Tagaste.pages.rooms',
        'Tagaste.pages.workerTask',
        'Tagaste.pages.requests',
        'Tagaste.pages.masterTables',
        // 'Tagaste.pages.bedrooms',
        'Tagaste.pages.requests',
        'Tagaste.pages.occupancy',
        'Tagaste.pages.reservations',
        'Tagaste.pages.billing'
    ])
        .config(routeConfig)
        .run(['$locale', function ($locale) {
            $locale.NUMBER_FORMATS.DECIMAL_SEP = '.';
        }])
        .directive('validNumber', function ($locale) {
            return {
                require: '?ngModel',
                link: function (scope, element, attrs, ngModelCtrl) {
                    if (!ngModelCtrl) {
                        return;
                    }
                    var formats = $locale.NUMBER_FORMATS;
                    ngModelCtrl.$parsers.push(function (val) {
                        if (angular.isUndefined(val)) {
                            val = '';
                        }
                        var regularExp = new RegExp('[^0-9\\' + formats.DECIMAL_SEP + ']', 'g');
                        var clean = val.replace(regularExp, '');
                        var decimalCheck = clean.split(formats.DECIMAL_SEP);

                        if (!angular.isUndefined(decimalCheck[1])) {
                            decimalCheck[1] = decimalCheck[1].slice(0, 2);
                            clean = decimalCheck[0] + formats.DECIMAL_SEP + decimalCheck[1];
                        }

                        if (val !== clean) {
                            ngModelCtrl.$setViewValue(clean);
                            ngModelCtrl.$render();
                        }
                        return clean;
                    });

                    element.bind('keypress', function (event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });
                }
            };
        })
        .directive('ngEnter', function () {
            return function (scope, element, attrs) {
                element.bind('keydown keypress', function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngEnter);
                        });

                        event.preventDefault();
                    }
                });
            };
        })
        .filter('findTags', function () {
            return function (list, params) {
                if (params) {
                    params.alredy = (params.alredy) ? params.alredy : [];
                } else {
                    params = {
                        alredy: [],
                        find: ''
                    };
                }
                var rs = _.differenceBy(_.filter(list, function (item) {
                    return (
                        (params.find.trim() === '' || (
                                (_.deburr(item).toUpperCase().indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                            )
                        ));
                }), params.alredy);

                if (rs.length === 0) {
                    return [_.deburr(params.find).toLowerCase()];
                } else {
                    rs.push(_.deburr(params.find).toLowerCase());
                }
                return rs;
            };
        })
        .filter('findResidence', function () {
            return function (list, params) {
                if (params) {
                    params.alredy = (params.alredy) ? params.alredy : [];
                } else {
                    params = {
                        alredy: [],
                        find: ''
                    };
                }
                return _.differenceBy(_.filter(list, function (item) {
                    return (
                        (params.find.trim() === '' || (
                                (_.deburr(item.description).toUpperCase()
                                    .indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                            )
                        ));
                }), params.alredy, '_id');
            };
        })
        .filter('dummyDataIfEmpty', ['TranslationService', function (TranslationService) {
            return function (list, dummy) {
                if ((dummy !== undefined) && (dummy.length > 0)) {
                    return dummy;
                } else {
                    return list;
                }
            };
        }])
        .filter('findUserRole', function () {
            return function (list, params) {
                if (params) {
                    params.alredy = (params.alredy) ? params.alredy : [];
                } else {
                    params = {
                        alredy: [],
                        find: ''
                    };
                }
                return _.differenceBy(_.filter(list, function (item) {
                    return (
                        (params.find.trim() === '' || (
                            (_.deburr(item.fullName).toUpperCase()
                                .indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                        )));
                }), params.alredy, '_id');
            };
        })
        .filter('filterChatGroups', function () {
            return function (list, findTerm) {
                return _.filter(list, function (item) {
                    return (
                        (findTerm.trim() === '' || ((_.deburr(item.name).toUpperCase().indexOf(
                            _.deburr(findTerm).toUpperCase()) >= 0))));
                });
            };
        })
        .filter('showErrorNoData', ['TranslationService', function (TranslationService) {
            return function (list) {
                if (list && !list.length) {
                    list.push({error: TranslationService.errors.noDataInTable});
                }
                return list;
            };
        }])
        .filter('uiSelectFilter', function (NgTableFilterService) {
            return function (items, props) {
                var out = [];
                if (angular.isArray(items)) {
                    out = NgTableFilterService.fill(items, props);
                }
                return out;
            };
        })
        .run(['TourService',
            function (TourService) {
                TourService.getUserTours();
            }
        ]);

    /** @ngInject */
    function routeConfig($urlRouterProvider, $locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: true
        });
        var defUrl = '/dashboard';
        $urlRouterProvider.otherwise(defUrl);
    }

})();

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular
        .module('BlurAdmin.service.constants', [])
        .service('ConstantsService', ConstantsService);

    ConstantsService.$inject = ['UsersService', 'localStorageService', 'MasterTableService', 'RolesService','BranchService'];

    /* @ngInject */
    function ConstantsService(UsersService, localStorageService, MasterTableService, RolesService,BranchService) {
        var vm = this;

        vm.user = null;
        vm.roles = null;

        vm.getUser = function () {
            return new Promise(function (f, r) {
                vm.user = (vm.user) ? vm.user : localStorageService.get('user');
                if (!vm.user) {
                    UsersService.get({idU: localStorageService.get('userId')}, function (data) {
                        vm.user = data;
                        localStorageService.set('user', data);
                        f(vm.user);
                    });
                } else {
                    f(vm.user);
                }
            });
        };

        vm.getRoles = function () {
            return new Promise(function (f, r) {
                vm.roles = (vm.roles) ? vm.roles : localStorageService.get('roles');
                if (!vm.roles) {
                    RolesService.query({sortField:'level'}, function (data) {
                        vm.roles = data;
                        localStorageService.set('roles', data);
                        f(vm.roles);
                    });
                } else {
                    f(vm.roles);
                }
            });
        };

        vm.getBranchesDetail = function() {
            return new Promise(function (full,reject) {
                 if (localStorageService.get('branchesFull')) {
                    full(localStorageService.get('branchesFull'));
                 }  else {
                     BranchService.query({}, function (data) {
                         localStorageService.set('branchesFull',data);
                         full(data);
                     });
                 }
            });
        };

        vm.getBranches = function () {
            return localStorageService.get('branches');
        };

        vm.getPermissions = function () {
            return (localStorageService.get('permissions'));
        };
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */
angular.module('BlurAdmin.service.exceptionHandler', [])
    .factory('$exceptionHandler', ['$injector',
        function ($injector) {
            return function myExceptionHandler(exception, cause) {
                var TranslationService, toastr, $log, exce, ENV;
                TranslationService = TranslationService || $injector.get('TranslationService');

                toastr = toastr || $injector.get('toastr');
                $log = $log || $injector.get('$log');
                ENV = ENV || $injector.get('ENV');
                var msgToastr = '';

                if (exception && exception.message) {
                    if (ENV.debug) {
                        msgToastr = exception.message;
                        $log.error('--- Tagaste exception ---\n', exception);
                    }
                } else {
                    try {
                        exce = angular.fromJson(exception.replace('Possibly unhandled rejection: ', ''));
                        if (exce.status === 405) {
                            if (exce.data && exce.data.error) {
                                if (exce.data.error.indexOf('MEN40501') >= 0) {
                                    msgToastr = TranslationService.errors.MENU40501;
                                } else if (exce.data.error.indexOf('MEN40501') >= 0) {
                                    msgToastr = TranslationService.errors.MENU40502;
                                } else if (exce.data.error.indexOf('USER40501') >= 0) {
                                    msgToastr = TranslationService.errors.USER40501;
                                } else if (exce.data.error.indexOf('USER40502') >= 0) {
                                    msgToastr = TranslationService.errors.USER40502;
                                } else if (exce.data.error.indexOf('GEN40501') >= 0) {
                                    msgToastr = TranslationService.errors.GEN40501;
                                } else if (exce.data.error.indexOf('GEN40502') >= 0) {
                                    msgToastr = TranslationService.errors.GEN40502;
                                } else if (exce.data.error.indexOf('SER40501') >= 0) {
                                    msgToastr = TranslationService.errors.SER40501;
                                } else if (exce.data.error.indexOf('USER40503') >= 0) {
                                    msgToastr = TranslationService.errors.USER40503;
                                }
                            }
                        }
                        $log.error(exce);

                    } catch (e) {
                        $log.error(e, exception);
                    }

                    msgToastr = (msgToastr) ?
                        msgToastr : TranslationService.errors.e500;

                    if (exception.indexOf('backdrop click') >= 0 || exception.indexOf('scape key press') >= 0) {
                        msgToastr = '';
                    }
                }
                if (msgToastr) {
                    toastr.error(msgToastr, TranslationService.errors.error, {
                        'autoDismiss': true,
                        'positionClass': 'toast-top-right',
                        'type': 'info',
                        'timeOut': '5000',
                        'extendedTimeOut': (ENV.debug) ? '13000' : '3000',
                        'allowHtml': false,
                        'closeButton': true,
                        'tapToDismiss': false,
                        'progressBar': true,
                        'newestOnTop': true,
                        'maxOpened': 0,
                        'preventDuplicates': true,
                        'preventOpenDuplicates': true
                    });
                }
            };
        }]);
/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.service', [
        'ngResource',
        'BlurAdmin.service.translations',
        'BlurAdmin.service.tour',
        'BlurAdmin.service.permissions',
        'BlurAdmin.service.ngTableFilterService',
        'BlurAdmin.service.exceptionHandler',
        'LocalStorageModule',
        'bm.uiTour',
        'tmh.dynamicLocale',
        'BlurAdmin.service.validation',
        'BlurAdmin.service.constants',
        'Tagaste.socketService',
        'Tagaste.utils'

    ])
        .config(routeConfig)
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('httpProviderSessionInterceptor');
        }])
        .factory('ActivitiesExportService', ActivitiesExportService)
        .factory('ActivityDetailsExportService', ActivityDetailsExportService)
        .factory('UsersService', UsersService)
        .factory('UsersServiceCreateSession', UsersServiceCreateSession)
        .factory('UsersServiceRenewSession', UsersServiceRenewSession)
        .factory('UsersServiceChangePass', UsersServiceChangePass)
        .factory('UsersServiceResetPassReq', UsersServiceResetPassReq)
        .factory('UsersServiceResetPassConf', UsersServiceResetPassConf)
        .factory('UsersServiceCancelAccess', UsersServiceCancelAccess)
        .factory('ResidentsService', ResidentsService)
        .factory('NoticeService', NoticeService)
        .factory('BulletinBoardService', BulletinBoardService)
        .factory('MenuService', MenuService)
        .factory('DishService', DishService)
        .factory('ResidentExportService', ResidentExportService)
        .factory('RequestService', RequestService)
        .factory('BillingService', BillingService)
        .factory('BillingExportService', BillingExportService)
        .factory('BillingPrintService', BillingPrintService)
        .factory('ConceptService', ConceptService)
        .factory('RequestAcceptService', RequestAcceptService)
        .factory('RequestExportService', RequestExportService)
        .factory('ReservationAcceptService', ReservationAcceptService)
        .factory('ReservationNoShowService', ReservationNoShowService)
        .factory('ReservationCancelBillingsService', ReservationCancelBillingsService)
        .factory('NoticeService', NoticeService)
        .factory('BulletinBoardService', BulletinBoardService)
        .factory('MenuNextService', MenuNextService)
        .factory('BranchService', BranchService)
        .factory('MenuTypeService', MenuTypeService)
        .factory('DishTypeService', DishTypeService)
        .factory('ServicesService', ServicesService)
        .factory('RolesService', RolesService)
        .factory('MasterTableService', MasterTableService)
        .factory('ResRenewAccessService', ResRenewAccessService)
        .factory('ResCancelAccessService', ResCancelAccessService)
        .factory('ChatGroupsService', ChatGroupsService)
        .factory('ReportMReserveService', ReportMReserveService)
        .factory('OccupancyService', OccupancyService)
        .factory('OccupancyResident', OccupancyResident)
        .factory('ConfigService', ConfigService)
        .factory('GuestInvitations', GuestInvitations)
        .factory('AdmonitionService', AdmonitionService)
        .factory('ResidentsAdmonition', ResidentsAdmonition)
        .factory('GuestInvitations', GuestInvitations)
        .factory('HistoryMenu', HistoryMenu)
        .factory('HistoryAgenda', HistoryAgenda)
        .factory('HistoryIncident', HistoryIncident)
        .factory('HistoryService', HistoryService)
        .factory('IncidentsExportService', IncidentsExportService)
        .factory('LogbookService', LogbookService)
        .factory('LogbookComments', LogbookComments)
        .factory('AdmonitionService', AdmonitionService)
        .factory('AppUserService', AppUserService)
        .factory('UsersServiceByBranch', UsersServiceByBranch)
        .factory('WorkerTaskService', WorkerTaskService)
        .factory('WorkerTaskUpdateService', WorkerTaskUpdateService)
        .factory('WorkerTaskOpenService', WorkerTaskOpenService)
        .factory('TaskExportService', TaskExportService)
        .factory('MenuExportService', MenuExportService)
        .factory('ServiceListExportService', ServiceListExportService)
        .factory('UserExportListService', UserExportListService)
        .factory('ReservationExportListService', ReservationExportListService)
        .factory('InWorkerTaskListExportService', InWorkerTaskListExportService)
        .factory('SpotService', SpotService)
        .factory('GuestService', GuestService)
        .factory('SESListTemplatesService', SESListTemplatesService)
        .factory('RoomsOccupancyService', RoomsOccupancyService)
        .factory('OccupancyByRangeService', OccupancyByRangeService)
        .controller('SetLanguageCtrl', SetLanguageCtrl)
        .run(inRunConfig)
        ;
    function inRunConfig(TranslationService, SocketService) {
        TranslationService.translateAll();
    }

    function SetLanguageCtrl(tmhDynamicLocale) {
        tmhDynamicLocale.set(moment.locale());
    }

    /** @ngInject */
    function routeConfig($stateProvider, $translateProvider, ENV) {
        moment.locale(getLanguage());
        moment.defaultFormat = 'L';

        $stateProvider
            .state('service', {
                title: 'service',
                abstract: false
            });

        $translateProvider
            .addInterpolation('$translateMessageFormatInterpolation')
            .preferredLanguage(getLanguage())
            .fallbackLanguage(getLanguage())
            .useStaticFilesLoader({
                prefix: '/app/config/i18n/',
                suffix: '.json'
            })
            .useSanitizeValueStrategy(null);

        function getLanguage() {
            var lang = window.navigator.language || window.navigator.userLanguage;
            lang = lang.substring(0, 2);
            if (ENV.availableLanguages.indexOf(lang) === -1) {
                return ENV.defaultLanguage;
            }
            return lang;
        }
    }

    UserExportListService.$inject = ['$resource', 'serviceConf'];
    function UserExportListService($resource, serviceConf) {
        return $resource(serviceConf.UserExportListService, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    ReservationExportListService.$inject = ['$resource', 'serviceConf'];
    function ReservationExportListService($resource, serviceConf) {
        return $resource(serviceConf.ReservationExportListService, '@data', {
            post: {
                method: 'POST'
            }
        });
    }


    WorkerTaskOpenService.$inject = ['$resource', 'serviceConf'];
    function WorkerTaskOpenService($resource, serviceConf) {
        return $resource(serviceConf.WorkerTaskOpenService, '@data', {
            get: {
                method: 'GET',
                isArray: false
            },
            query: {
                method: 'GET',
                isArray: true
            }
        });
    }

    WorkerTaskUpdateService.$inject = ['$resource', 'serviceConf'];
    function WorkerTaskUpdateService($resource, serviceConf) {
        return $resource(serviceConf.WorkerTaskUpdateService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    WorkerTaskService.$inject = ['$resource', 'serviceConf'];
    function WorkerTaskService($resource, serviceConf) {
        return $resource(serviceConf.WorkerTaskService, '@data', {
            get: {
                method: 'GET',
                isArray: false
            },
            query: {
                method: 'GET',
                isArray: true
            }
        });
    }

    UsersService.$inject = ['$resource', 'serviceConf'];
    function UsersService($resource, serviceConf) {
        return $resource(serviceConf.UserService.user, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE',
                isArray: false
            }
        });
    }

    UsersServiceCreateSession.$inject = ['$resource', 'serviceConf'];
    function UsersServiceCreateSession($resource, serviceConf) {
        return $resource(serviceConf.UserService.createSession, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    UsersServiceRenewSession.$inject = ['$resource', 'serviceConf'];
    function UsersServiceRenewSession($resource, serviceConf) {
        return $resource(serviceConf.UserService.renewSession, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    UsersServiceChangePass.$inject = ['$resource', 'serviceConf'];
    function UsersServiceChangePass($resource, serviceConf) {
        return $resource(serviceConf.UserService.changePass, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    UsersServiceResetPassReq.$inject = ['$resource', 'serviceConf'];
    function UsersServiceResetPassReq($resource, serviceConf) {
        return $resource(serviceConf.UserService.resetPassReq, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    UsersServiceResetPassConf.$inject = ['$resource', 'serviceConf'];
    function UsersServiceResetPassConf($resource, serviceConf) {
        return $resource(serviceConf.UserService.resetPassConf, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    UsersServiceCancelAccess.$inject = ['$resource', 'serviceConf'];
    function UsersServiceCancelAccess($resource, serviceConf) {
        return $resource(serviceConf.UserService.cancelAccess, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    ResRenewAccessService.$inject = ['$resource', 'serviceConf'];
    function ResRenewAccessService($resource, serviceConf) {
        return $resource(serviceConf.ResidentRenewAccess, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    ResCancelAccessService.$inject = ['$resource', 'serviceConf'];
    function ResCancelAccessService($resource, serviceConf) {
        return $resource(serviceConf.ResidentCancelAccess, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    ResidentsService.$inject = ['$resource', 'serviceConf'];
    function ResidentsService($resource, serviceConf) {
        return $resource(serviceConf.ResidentsService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    HistoryMenu.$inject = ['$resource', 'serviceConf'];
    function HistoryMenu($resource, serviceConf) {
        return $resource(serviceConf.HistoryMenu, '@data', {
            get: {
                method: 'GET'
            }
        });
    }

    HistoryAgenda.$inject = ['$resource', 'serviceConf'];
    function HistoryAgenda($resource, serviceConf) {
        return $resource(serviceConf.HistoryAgenda, '@data', {
            get: {
                method: 'GET'
            }
        });
    }

    HistoryIncident.$inject = ['$resource', 'serviceConf'];
    function HistoryIncident($resource, serviceConf) {
        return $resource(serviceConf.HistoryIncident, '@data', {
            get: {
                method: 'GET'
            }
        });
    }

    HistoryService.$inject = ['$resource', 'serviceConf'];
    function HistoryService($resource, serviceConf) {
        return $resource(serviceConf.HistoryService, '@data', {
            get: {
                method: 'GET'
            }
        });
    }

    OccupancyService.$inject = ['$resource', 'serviceConf'];
    function OccupancyService($resource, serviceConf) {
        return $resource(serviceConf.OccupancyService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    OccupancyResident.$inject = ['$resource', 'serviceConf'];
    function OccupancyResident($resource, serviceConf) {
        return $resource(serviceConf.OccupancyResident, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    SpotService.$inject = ['$resource', 'serviceConf'];
    function SpotService($resource, serviceConf) {
        return $resource(serviceConf.SpotService, '@data', {
            post: {
                method: 'POST'
            }
        });
    }

    GuestInvitations.$inject = ['$resource', 'serviceConf'];
    function GuestInvitations($resource, serviceConf) {
        return $resource(serviceConf.GuestInvitations, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    ResidentsAdmonition.$inject = ['$resource', 'serviceConf'];
    function ResidentsAdmonition($resource, serviceConf) {
        return $resource(serviceConf.ResidentsAdmonition, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    AdmonitionService.$inject = ['$resource', 'serviceConf'];
    function AdmonitionService($resource, serviceConf) {
        return $resource(serviceConf.AdmonitionService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    LogbookService.$inject = ['$resource', 'serviceConf'];
    function LogbookService($resource, serviceConf) {
        return $resource(serviceConf.LogbookService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    LogbookComments.$inject = ['$resource', 'serviceConf'];
    function LogbookComments($resource, serviceConf) {
        return $resource(serviceConf.LogbookComments, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    AppUserService.$inject = ['$resource', 'serviceConf'];
    function AppUserService($resource, serviceConf) {
        return $resource(serviceConf.AppUserService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    UsersServiceByBranch.$inject = ['$resource', 'serviceConf'];
    function UsersServiceByBranch($resource, serviceConf) {
        return $resource(serviceConf.UsersServiceByBranch, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    BulletinBoardService.$inject = ['$resource', 'serviceConf'];
    function BulletinBoardService($resource, serviceConf) {
        return $resource(serviceConf.BulletinService, '@data', {
            get: {
                method: 'GET'
            },
            post: {
                method: 'POST'
            }
        });
    }

    NoticeService.$inject = ['$resource', 'serviceConf'];
    function NoticeService($resource, serviceConf) {
        return $resource(serviceConf.NoticeService, '@data', {
            get: {
                method: 'GET'
            }
        });
    }

    MenuService.$inject = ['$resource', 'serviceConf'];
    function MenuService($resource, serviceConf) {
        return $resource(serviceConf.MenuService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ChatGroupsService.$inject = ['$resource', 'serviceConf'];
    function ChatGroupsService($resource, serviceConf) {
        return $resource(serviceConf.ChatGroupsService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    MenuNextService.$inject = ['$resource', 'serviceConf'];
    function MenuNextService($resource, serviceConf) {
        return $resource(serviceConf.MenuNextService, '@data', {
            get: {
                method: 'GET',
                isArray: true
            }
        });
    }

    DishService.$inject = ['$resource', 'serviceConf'];
    function DishService($resource, serviceConf) {
        return $resource(serviceConf.DishService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: true
            },
            post: {
                method: 'POST'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    BranchService.$inject = ['$resource', 'serviceConf'];
    function BranchService($resource, serviceConf) {
        return $resource(serviceConf.BranchService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: true
            },
            post: {
                method: 'POST'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    RolesService.$inject = ['$resource', 'serviceConf'];
    function RolesService($resource, serviceConf) {
        return $resource(serviceConf.RolesService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: true
            },
            post: {
                method: 'POST'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    MenuTypeService.$inject = ['$resource', 'serviceConf'];
    function MenuTypeService($resource, serviceConf) {
        return $resource(serviceConf.MenuTypeService, '@data', {
            get: {
                method: 'GET',
                isArray: true
            }
        });
    }

    DishTypeService.$inject = ['$resource', 'serviceConf'];
    function DishTypeService($resource, serviceConf) {
        return $resource(serviceConf.DishTypeService, '@data', {
            get: {
                method: 'GET',
                isArray: true
            }
        });
    }

    ServicesService.$inject = ['$resource', 'serviceConf'];
    function ServicesService($resource, serviceConf) {
        return $resource(serviceConf.ServicesService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: true
            },
            post: {
                method: 'POST'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    MasterTableService.$inject = ['$resource', 'serviceConf'];
    function MasterTableService($resource, serviceConf) {
        return $resource(serviceConf.MasterTableService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: true
            },
            post: {
                method: 'POST'
            },
            delete: {
                method: 'DELETE'
            },
            postArr: {
                method: 'POST',
                isArray: true
            },
        });
    }

    ConfigService.$inject = ['$resource', 'serviceConf'];
    function ConfigService($resource, serviceConf) {
        return $resource(serviceConf.ConfigService, '@data', {
            query: {
                method: 'GET',
                isArray: true
            },
            post: {
                method: 'POST'
            },
            put: {
                method: 'POST'
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    ReportMReserveService.$inject = ['$resource', 'serviceConf'];
    function ReportMReserveService($resource, serviceConf) {
        return $resource(serviceConf.ReportMReserveService, '@data', {
            get: {
                method: 'GET'
            }
        });
    }

    BillingService.$inject = ['$resource', 'serviceConf'];
    function BillingService($resource, serviceConf) {
        return $resource(serviceConf.BillingService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    BillingPrintService.$inject = ['$resource', 'serviceConf'];
    function BillingPrintService($resource, serviceConf) {
        return $resource(serviceConf.BillingPrintService, '@data', {
            get: {
                method: 'GET'
            }
        });
    }

    BillingExportService.$inject = ['$resource', 'serviceConf'];
    function BillingExportService($resource, serviceConf) {
        return $resource(serviceConf.BillingExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ConceptService.$inject = ['$resource', 'serviceConf'];
    function ConceptService($resource, serviceConf) {
        return $resource(serviceConf.ConceptService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    RequestService.$inject = ['$resource', 'serviceConf'];
    function RequestService($resource, serviceConf) {
        return $resource(serviceConf.RequestService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    RequestAcceptService.$inject = ['$resource', 'serviceConf'];
    function RequestAcceptService($resource, serviceConf) {
        return $resource(serviceConf.RequestAcceptService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    RequestExportService.$inject = ['$resource', 'serviceConf'];
    function RequestExportService($resource, serviceConf) {
        return $resource(serviceConf.RequestExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ReservationAcceptService.$inject = ['$resource', 'serviceConf'];
    function ReservationAcceptService($resource, serviceConf) {
        return $resource(serviceConf.ReservationAcceptService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ReservationNoShowService.$inject = ['$resource', 'serviceConf'];
    function ReservationNoShowService($resource, serviceConf) {
        return $resource(serviceConf.ReservationNoShowService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ReservationCancelBillingsService.$inject = ['$resource', 'serviceConf'];
    function ReservationCancelBillingsService($resource, serviceConf) {
        return $resource(serviceConf.ReservationCancelBillingsService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ResidentExportService.$inject = ['$resource', 'serviceConf'];
    function ResidentExportService($resource, serviceConf) {
        return $resource(serviceConf.ResidentExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    IncidentsExportService.$inject = ['$resource', 'serviceConf'];
    function IncidentsExportService($resource, serviceConf) {
        return $resource(serviceConf.IncidentsExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ActivityDetailsExportService.$inject = ['$resource', 'serviceConf'];
    function ActivityDetailsExportService($resource, serviceConf) {
        return $resource(serviceConf.ActivityDetailsExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }


    TaskExportService.$inject = ['$resource', 'serviceConf'];
    function TaskExportService($resource, serviceConf) {
        return $resource(serviceConf.TaskExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    ActivitiesExportService.$inject = ['$resource', 'serviceConf'];
    function ActivitiesExportService($resource, serviceConf) {
        return $resource(serviceConf.ActivitiesExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }


    MenuExportService.$inject = ['$resource', 'serviceConf'];
    function MenuExportService($resource, serviceConf) {
        return $resource(serviceConf.MenuExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    // ServiceListExportService
    ServiceListExportService.$inject = ['$resource', 'serviceConf'];
    function ServiceListExportService($resource, serviceConf) {
        return $resource(serviceConf.ServiceListExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    // InWorkerTaskList
    InWorkerTaskListExportService.$inject = ['$resource', 'serviceConf'];
    function InWorkerTaskListExportService($resource, serviceConf) {
        return $resource(serviceConf.InWorkerTaskListExportService, '@data', {
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    GuestService.$inject = ['$resource', 'serviceConf'];
    function GuestService($resource, serviceConf)  {
        return $resource(serviceConf.GuestService, '@data', {
            get: {
                method: 'GET'
            },
            query: {
                method: 'GET',
                isArray: false
            },
            post: {
                method: 'POST',
                isArray: false
            }
        });
    }

    RoomsOccupancyService.$inject = ['$resource', 'serviceConf'];
    function RoomsOccupancyService($resource, serviceConf)  {
        return $resource(serviceConf.RoomsOccupancyService, '@data', {
            query: {
                method: 'GET',
                isArray: true
            }
        });
    }

    OccupancyByRangeService.$inject = ['$resource', 'serviceConf'];
    function OccupancyByRangeService($resource, serviceConf)  {
        return $resource(serviceConf.OccupancyByRangeService, '@data', {
            query: {
                method: 'GET',
                isArray: true
            }
        });
    }

    SESListTemplatesService.$inject = ['$resource', 'serviceConf'];
    function SESListTemplatesService($resource, serviceConf) {
        return $resource(serviceConf.SESListTemplatesService, '@data', {
            query: {
                method: 'GET',
                isArray: true
            }
        });
    }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'ngSanitize',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * Created by sfernandez on 03/04/2019
 */
angular
    .module('BlurAdmin.cardFile', []).filter('cut', function () {
        return function (value, wordwise, max, tail) {
            if (!value) { 
                return '';
            }

            max = parseInt(max, 10);
            if (!max) {
                return value;
            } 
            if (value.length <= max) {
                return value;
            } 

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                  //Also remove . and , so its gives a cleaner result.
                  if (value.charAt(lastspace-1) === '.' || value.charAt(lastspace-1) === ',') {
                    lastspace = lastspace - 1;
                  }
                  value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    });
angular
    .module('Tagaste.datePickerCom', [])
    .directive('mooFocusExpression', function ($timeout) {
        return {
            restrict: 'A',
            link: {
                post: function postLink(scope, element, attrs) {
                    scope.$watch(attrs.mooFocusExpression, function (value) {
                        if (attrs.mooFocusExpression) {
                            if (scope.$eval(attrs.mooFocusExpression)) {
                                $timeout(function () {
                                    element[0].focus();
                                }, 100);
                            }
                        }
                    });
                }
            }
        };
    });
angular
    .module('Tagaste.notificationPushCom', []);
/**
 * Created by sila.fernandez on 18/03/2019.
 */
angular
    .module('BlurAdmin.logbookCom', []);
angular
    .module('Tagaste.roomSchedule',
    ['gantt',
        // 'gantt.sortable',
        'gantt.movable',
        'gantt.drawtask',
        // 'gantt.tooltips',
        // 'gantt.bounds',
        // 'gantt.progress',
        'gantt.table',
        // 'gantt.tree',
        // 'gantt.groups',
        'gantt.resizeSensor',
        // 'gantt.overlap',
        // 'gantt.dependencies',
        // 'gantt.labels' deprecated
        'gantt.table'
    ]);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('Tagaste.schedule', []);
/**
 * Created by sfernandez on 11/05/2018
 */
angular
    .module('BlurAdmin.file', []);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.avatar', []);
// /**
//  * @author lavg
//  * created on 17/13/2017
//  */
//
// (function () {
//     'use strict';
//
//     angular.module('BlurAdmin.login.register', [])
//         .config(routeConfig);
//
//     /** @ngInject */
//     function routeConfig($stateProvider) {
//         $stateProvider
//             .state('register', {
//                 url: '/register',
//                 templateUrl: 'app/login/register/register.html',
//                 controller:'RegisterController',
//                 controllerAs: 'ur',
//                 title: 'Register',
//                 abstract: false
//             });
//     }
// })();
(function () {
    'use strict';

    angular.module('Tagaste.pages.activities', ['Tagaste.activities.activitiesList'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('activities', {
                title: 'activities',
                abstract: false
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('Tagaste.annoucements', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('annoucemnts', {
                url: '/announcements',
                templateUrl: 'app/pages/annoucements/annoucements.html',
                controller:'AnnoucementsController',
                controllerAs: 'ace',
                abstract: false,
                title: 'Avisos',
                sidebarMeta: {
                    icon: 'ion-ios-bell',
                    order: 250,
                    permission: 'NOTICE'
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.pages.bedrooms', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
            $stateProvider
            .state('occupancy.bedrooms', {
                url: '/rooms',
                templateUrl: 'app/pages/bedrooms/bedrooms.html',
                title: 'Habitaciones',
                controllerAs: 'brc',
                controller: 'BedroomsController',
                sidebarMeta: {
                    // icon: 'ion-key rotate-icon',
                    order: 1201,
                    permission: 'RESIDENT'
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.pages.billing', [
        'Tagaste.billing.billingList'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('billing', {
                url: '/billing',
                templateUrl: 'app/pages/billing/billingList/billingList.html',
                title: 'billing',
                abstract: false
            });
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.bulletinBoard', ['BlurAdmin.bulletinBoard.bulletinBoardList'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('bulletinBoard', {
                title: 'bulletinBoard',
                abstract: false
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.canteen', [
        'BlurAdmin.pages.canteen.canteenPanel'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('canteen', {
                title: 'canteen',
                abstract: false
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('Tagaste.pages.chat', [
        'Tagaste.pages.chat.panel'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('chat', {
                title: 'Chat',
                abstract: false
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.configWb', [
        'BlurAdmin.configWb.userList'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('configWb', {
                // url: '/usuarios',
                abstract: false,
                title: 'Config'
        });
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard', {
                url: '/dashboard',
                templateUrl: 'app/pages/dashboard/dashboard.html',
                title: 'Dashboard',
                controllerAs: 'dc',
                controller: DashboardController,
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0
                }
            });
    }

})();



(function () {
    'use strict';

    angular.module('Tagaste.pages.incidents', ['Tagaste.incidents.incidentsList'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('incidents', {
                title: 'incidents',
                abstract: false
            });
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.pages.masterTables', [
        'Tagaste.masterTables.masterTablesList'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('masterTables', {
                title: 'masterTables',
                abstract: false
            });
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.pages.occupancy', [
        'Tagaste.pages.rooms',
        'Tagaste.pages.bedrooms'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('occupancy', {
                //url: '/occupancy',
                title: 'Ocupacion',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                sidebarMeta: {
                    icon: 'ion-key rotate-icon',
                    order: 1200,
                    permission: 'RESIDENT'
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.pages.requests', [
         'Tagaste.requests.requestsList'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('requests', {
                title: 'requests',
                abstract: false
            });
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.pages.reservations', [
        'Tagaste.reservations.reservationsList'
    ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('reservations', {
                title: 'reservations',
                abstract: false
            });
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.residents', [
        'BlurAdmin.users.residentsList'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('residents', {
                title: 'residents',
                abstract: false
            });
    }
})();
/**
 * @author sila.fernandez
 * created on 22/03/2019
 */
(function () {
    'use strict';

    angular.module('Tagaste.pages.rooms', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('occupancy.rooms', {
                url: '/occupancy',
                parent: 'occupancy',
                templateUrl: 'app/pages/rooms/rooms.html',
                title: 'Ocupación',
                controllerAs: 'roc',
                controller: 'RoomsController',
                abstract: false,
                sidebarMeta: {
                    // icon: 'ion-pie-graph',
                    order: 1201,
                    permission: 'RESIDENT'
                }
            });
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.services', [
        'BlurAdmin.services.servicesMenu'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('services', {
                title: 'services',
                abstract: false
            });
    }
})();
/**
 * @author jgr
 * created on 05/11/2019
 */

(function () {
    'use strict';

    angular.module('Tagaste.pages.tasks', ['Tagaste.tasks.tasksList'])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('tasks', {
                title: 'tasks',
                abstract: false
            });
    }
})();
/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui', [
    'BlurAdmin.pages.ui.typography',
    'BlurAdmin.pages.ui.buttons',
    'BlurAdmin.pages.ui.icons',
    'BlurAdmin.pages.ui.modals',
    'BlurAdmin.pages.ui.grid',
    'BlurAdmin.pages.ui.alerts',
    'BlurAdmin.pages.ui.progressBars',
    'BlurAdmin.pages.ui.notifications',
    'BlurAdmin.pages.ui.tabs',
    'BlurAdmin.pages.ui.slider',
    'BlurAdmin.pages.ui.panels'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',
          sidebarMeta: {
            icon: 'ion-android-laptop',
            order: 200
          }
        });
  }

})();

/**
 * @author sila.fernandez
 * created on 06/05/2019
 */

(function () {
    'use strict';

    angular.module('Tagaste.pages.workerTask', [
        'BlurAdmin.workerTask.workerTaskList'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('workerTask', {
                title: 'workerTask',
                abstract: false
            });
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

angular
    .module('Tagaste.activitiesListCom', []);
angular
    .module('Tagaste.activityDetailCom', []);
angular
    .module('Tagaste.reserveListCom', []);
angular
    .module('Tagaste.reserveNewCom', []);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('Tagaste.announcementDetail', [])
    .filter('findAppUserGroupe', function () {
        return function (list, params) {
            if (params) {
                params.alredy = (params.alredy) ? params.alredy : [];
            } else {
                params = {
                    alredy: [],
                    find: ''
                };
            }
            return _.differenceBy(_.filter(list, function (item) {
                return (
                !(_.find(params.alredyFloor, function (selectedFloor) {
                    return (item.branches._id === selectedFloor.branches._id &&
                    selectedFloor.floor === item.floor);
                })) && (
                    (params.find.trim() === '' || (
                            (_.deburr(item.nameRoom).toUpperCase()
                                .indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                        )
                    )));
            }), params.alredy, '_id');
        };
    });
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('Tagaste.announcementsListCom', []);
angular
    .module('Tagaste.billingDetailComponent', []);

angular
    .module('Tagaste.billingListComponent', []);

angular
    .module('Tagaste.bedroomDetailCom', []);

angular
    .module('Tagaste.bedroomsListCom', []);



angular
    .module('BlurAdmin.bulletinBoardDetailCom', []);




angular
    .module('BlurAdmin.bulletinBoardListCom', []);
/**
 * Created by sila.fernandez on 05/02/2019.
 */
angular
    .module('BlurAdmin.canteenCommentsCom', []);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.canteenDetailCom', []);

/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.canteenAppUsersListComponent', []);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.canteenListComponent', []);
angular
    .module('BlurAdmin.canteenReserveNewCom', []);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.canteenSelectCourseCom', [])
    .filter('findParams', function () {
        return function (list, params, alreadycourses) {
            var res = [];
            res = _.filter(list, function (item) {
                    var alrgen = true;
                    if (item.allergyTypes && item.allergyTypes.length > 0) {
                        _.forEach(item.allergyTypes, function (a) {
                            var exist = (_.includes(params.allergyType.ids, a._id));
                            if (!(exist && alrgen)) {
                                alrgen = false;
                            }
                        });
                    } else {
                        alrgen = true;
                    }
                    return (
                        ( params.findTerm.trim() === '' || (
                            (_.deburr(item.title).toUpperCase()
                                .indexOf(_.deburr(params.findTerm).toUpperCase()) >= 0) ||
                            (_.deburr(item.text).toUpperCase()
                                .indexOf(_.deburr(params.findTerm).toUpperCase()) >= 0)) ||
                            (_.deburr(item.tags.toString().toLowerCase())
                                .indexOf(_.deburr(params.findTerm.trim().toLowerCase())) >= 0 )) &&
                        ( params.dishType.code === '' || item.dishType &&
                            params.dishType.code.indexOf(item.dishType.code) >= 0
                        ) && ( (_.filter(alreadycourses, function (bla) {
                            return (bla._id === item._id);
                        })).length === 0) && alrgen === true
                    );
                }
            );
            return res;
        };
    });
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.chat.chatconv', []);


/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.chat.chatlist', []);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.chat.ModNew', [])
    .filter('findAppUserGroup', function () {
        return function (list, params) {
            if (params) {
                params.alredy = (params.alredy) ? params.alredy : [];
            } else {
                params = {
                    alredy: [],
                    find: ''
                };
            }
            return _.differenceBy(_.filter(list, function (item) {
                return (
                !(_.find(params.alredyFloor, function (selectedFloor) {
                    return (item.branches._id === selectedFloor.branches._id &&
                    selectedFloor.floor === item.floor);
                })) && (
                    (params.find.trim() === '' || (
                            (_.deburr(item.nameRoom).toUpperCase()
                                .indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                        )
                    )));
            }), params.alredy, '_id');
        };
    });
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.selectCountry', [])
    .constant('CountryList', [
        {
            name: '',
            states:[]
        },
        {
        name: 'España',
        states: [
            'A Coruña',
            'Álava',
            'Albacete',
            'Alicante',
            'Almería',
            'Asturias',
            'Ávila',
            'Badajoz',
            'Islas Baleares',
            'Barcelona',
            'Burgos',
            'Cáceres',
            'Cádiz',
            'Cantabria',
            'Castellón',
            'Ceuta',
            'Ciudad Real',
            'Córdoba',
            'Cuenca',
            'Girona',
            'Granada',
            'Guadalajara',
            'Guipúzcoa',
            'Huelva',
            'Huesca',
            'Jaén',
            'La Rioja',
            'Las Palmas',
            'León',
            'Lleida',
            'Lugo',
            'Madrid',
            'Málaga',
            'Melilla',
            'Murcia',
            'Navarra',
            'Orense',
            'Palencia',
            'Pontevedra',
            'Salamanca',
            'Segovia',
            'Sevilla',
            'Soria',
            'Tarragona',
            'Santa Cruz de Tenerife',
            'Teruel',
            'Toledo',
            'Valencia',
            'Valladolid',
            'Vizcaya',
            'Zamora',
            'Zaragoza'
        ],
        'divider': false
    },
        {
            name: 'Afghanistan',
            states: [
                'Badakhshan',
                'Badghis',
                'Baghlan',
                'Balkh',
                'Bamian',
                'Farah',
                'Faryab',
                'Ghazni',
                'Ghowr',
                'Helmand',
                'Herat',
                'Jowzjan',
                'Kabol',
                'Kandahar',
                'Kapisa',
                'Konar',
                'Kondoz',
                'Laghman',
                'Lowgar',
                'Nangarhar',
                'Nimruz',
                'Oruzgan',
                'Paktia',
                'Paktika',
                'Parvan',
                'Samangan',
                'Sar-e Pol',
                'Takhar',
                'Vardak',
                'Zabol'
            ],
            'divider': false
        },
        {
            name: 'Albania',
            states: [
                'Berat',
                'Bulqize',
                'Delvine',
                'Devoll (Bilisht)',
                'Diber (Peshkopi)',
                'Durres',
                'Elbasan',
                'Fier',
                'Gjirokaster',
                'Gramsh',
                'Has (Krume)',
                'Kavaje',
                'Kolonje (Erseke)',
                'Korce',
                'Kruje',
                'Kucove',
                'Kukes',
                'Kurbin',
                'Lezhe',
                'Librazhd',
                'Lushnje',
                'Malesi e Madhe (Koplik)',
                'Mallakaster (Ballsh)',
                'Mat (Burrel)',
                'Mirdite (Rreshen)',
                'Peqin',
                'Permet',
                'Pogradec',
                'Puke',
                'Sarande',
                'Shkoder',
                'Skrapar (Corovode)',
                'Tepelene',
                'Tirane (Tirana)',
                'Tirane (Tirana)',
                'Tropoje (Bajram Curri)',
                'Vlore'
            ],
            'divider': false
        },
        {
            name: 'Algeria',
            states: [
                'Adrar',
                'Ain Defla',
                'Ain Temouchent',
                'Alger',
                'Annaba',
                'Batna',
                'Bechar',
                'Bejaia',
                'Biskra',
                'Blida',
                'Bordj Bou Arreridj',
                'Bouira',
                'Boumerdes',
                'Chlef',
                'Constantine',
                'Djelfa',
                'El Bayadh',
                'El Oued',
                'El Tarf',
                'Ghardaia',
                'Guelma',
                'Illizi',
                'Jijel',
                'Khenchela',
                'Laghouat',
                'M\'Sila',
                'Mascara',
                'Medea',
                'Mila',
                'Mostaganem',
                'Naama',
                'Oran',
                'Ouargla',
                'Oum el Bouaghi',
                'Relizane',
                'Saida',
                'Setif',
                'Sidi Bel Abbes',
                'Skikda',
                'Souk Ahras',
                'Tamanghasset',
                'Tebessa',
                'Tiaret',
                'Tindouf',
                'Tipaza',
                'Tissemsilt',
                'Tizi Ouzou',
                'Tlemcen'
            ],
            'divider': false
        },
        {
            name: 'American Samoa',
            states: [
                'Eastern',
                'Manu\'a',
                'Rose Island',
                'Swains Island',
                'Western'
            ],
            'divider': false
        },
        {
            name: 'Angola',
            states: [
                'Andorra la Vella',
                'Bengo',
                'Benguela',
                'Bie',
                'Cabinda',
                'Canillo',
                'Cuando Cubango',
                'Cuanza Norte',
                'Cuanza Sul',
                'Cunene',
                'Encamp',
                'Escaldes-Engordany',
                'Huambo',
                'Huila',
                'La Massana',
                'Luanda',
                'Lunda Norte',
                'Lunda Sul',
                'Malanje',
                'Moxico',
                'Namibe',
                'Ordino',
                'Sant Julia de Loria',
                'Uige',
                'Zaire'
            ],
            'divider': false
        },
        {
            name: 'Anguilla',
            states: [
                'Anguilla'
            ],
            'divider': false
        },
        {
            name: 'Antartica',
            states: [
                'Antartica'
            ],
            'divider': false
        },
        {
            name: 'Antigua and Barbuda',
            states: [
                'Barbuda',
                'Redonda',
                'Saint George',
                'Saint John',
                'Saint Mary',
                'Saint Paul',
                'Saint Peter',
                'Saint Philip'
            ],
            'divider': false
        },
        {
            name: 'Argentina',
            states: [
                'Antartica e Islas del Atlantico Sur',
                'Buenos Aires',
                'Buenos Aires Capital Federal',
                'Catamarca',
                'Chaco',
                'Chubut',
                'Cordoba',
                'Corrientes',
                'Entre Rios',
                'Formosa',
                'Jujuy',
                'La Pampa',
                'La Rioja',
                'Mendoza',
                'Misiones',
                'Neuquen',
                'Rio Negro',
                'Salta',
                'San Juan',
                'San Luis',
                'Santa Cruz',
                'Santa Fe',
                'Santiago del Estero',
                'Tierra del Fuego',
                'Tucuman'
            ],
            'divider': false
        },
        {
            name: 'Armenia',
            states: [
                'Aragatsotn',
                'Ararat',
                'Armavir',
                'Geghark\'unik\'',
                'Kotayk\'',
                'Lorri',
                'Shirak',
                'Syunik\'',
                'Tavush',
                'Vayots\' Dzor\'',
                'Yerevan'
            ],
            'divider': false
        },
        {
            name: 'Aruba',
            states: [
                'Aruba'
            ],
            'divider': false
        },
        {
            name: 'Ashmore and Cartier Island',
            states: [
                'Ashmore and Cartier Island'
            ],
            'divider': false
        },
        {
            name: 'Australia',
            states: [
                'Australian Capital Territory',
                'New South Wales',
                'Northern Territory',
                'Queensland',
                'South Australia',
                'Tasmania',
                'Victoria',
                'Western Australia'
            ],
            'divider': false
        },
        {
            name: 'Austria',
            states: [
                'Burgenland',
                'Kaernten',
                'Niederoesterreich',
                'Oberoesterreich',
                'Salzburg',
                'Steiermark',
                'Tirol',
                'Vorarlberg',
                'Wien'
            ],
            'divider': false
        },
        {
            name: 'Azerbaijan',
            states: [
                'Abseron Rayonu',
                'Agcabadi Rayonu',
                'Agdam Rayonu',
                'Agdas Rayonu',
                'Agstafa Rayonu',
                'Agsu Rayonu',
                'Ali Bayramli Sahari',
                'Astara Rayonu',
                'Baki Sahari',
                'Balakan Rayonu',
                'Barda Rayonu',
                'Beylaqan Rayonu',
                'Bilasuvar Rayonu',
                'Cabrayil Rayonu',
                'Calilabad Rayonu',
                'Daskasan Rayonu',
                'Davaci Rayonu',
                'Fuzuli Rayonu',
                'Gadabay Rayonu',
                'Ganca Sahari',
                'Goranboy Rayonu',
                'Goycay Rayonu',
                'Haciqabul Rayonu',
                'Imisli Rayonu',
                'Ismayilli Rayonu',
                'Kalbacar Rayonu',
                'Kurdamir Rayonu',
                'Lacin Rayonu',
                'Lankaran Rayonu',
                'Lankaran Sahari',
                'Lerik Rayonu',
                'Masalli Rayonu',
                'Mingacevir Sahari',
                'Naftalan Sahari',
                'Naxcivan Muxtar Respublikasi',
                'Neftcala Rayonu',
                'Oguz Rayonu',
                'Qabala Rayonu',
                'Qax Rayonu',
                'Qazax Rayonu',
                'Qobustan Rayonu',
                'Quba Rayonu',
                'Qubadli Rayonu',
                'Qusar Rayonu',
                'Saatli Rayonu',
                'Sabirabad Rayonu',
                'Saki Rayonu',
                'Saki Sahari',
                'Salyan Rayonu',
                'Samaxi Rayonu',
                'Samkir Rayonu',
                'Samux Rayonu',
                'Siyazan Rayonu',
                'Sumqayit Sahari',
                'Susa Rayonu',
                'Susa Sahari',
                'Tartar Rayonu',
                'Tovuz Rayonu',
                'Ucar Rayonu',
                'Xacmaz Rayonu',
                'Xankandi Sahari',
                'Xanlar Rayonu',
                'Xizi Rayonu',
                'Xocali Rayonu',
                'Xocavand Rayonu',
                'Yardimli Rayonu',
                'Yevlax Rayonu',
                'Yevlax Sahari',
                'Zangilan Rayonu',
                'Zaqatala Rayonu',
                'Zardab Rayonu'
            ],
            'divider': false
        },
        {
            name: 'Bahamas',
            states: [
                'Acklins and Crooked Islands',
                'Bimini',
                'Cat Island',
                'Exuma',
                'Freeport',
                'Fresh Creek',
                'Governor\'s Harbour',
                'Green Turtle Cay',
                'Harbour Island',
                'High Rock',
                'Inagua',
                'Kemps Bay',
                'Long Island',
                'Marsh Harbour',
                'Mayaguana',
                'New Providence',
                'Nicholls Town and Berry Islands',
                'Ragged Island',
                'Rock Sound',
                'San Salvador and Rum Cay',
                'Sandy Point'
            ],
            'divider': false
        },
        {
            name: 'Bahrain',
            states: [
                'Al Hadd',
                'Al Manamah',
                'Al Mintaqah al Gharbiyah',
                'Al Mintaqah al Wusta',
                'Al Mintaqah ash Shamaliyah',
                'Al Muharraq',
                'Ar Rifa\' wa al Mintaqah al Janubiyah',
                'Jidd Hafs',
                'Juzur Hawar',
                'Madinat \'Isa',
                'Madinat Hamad',
                'Sitrah'
            ],
            'divider': false
        },
        {
            name: 'Bangladesh',
            states: [
                'Barguna',
                'Barisal',
                'Bhola',
                'Jhalokati',
                'Patuakhali',
                'Pirojpur',
                'Bandarban',
                'Brahmanbaria',
                'Chandpur',
                'Chittagong',
                'Comilla',
                'Cox\'s Bazar',
                'Feni',
                'Khagrachari',
                'Lakshmipur',
                'Noakhali',
                'Rangamati',
                'Dhaka',
                'Faridpur',
                'Gazipur',
                'Gopalganj',
                'Jamalpur',
                'Kishoreganj',
                'Madaripur',
                'Manikganj',
                'Munshiganj',
                'Mymensingh',
                'Narayanganj',
                'Narsingdi',
                'Netrokona',
                'Rajbari',
                'Shariatpur',
                'Sherpur',
                'Tangail',
                'Bagerhat',
                'Chuadanga',
                'Jessore',
                'Jhenaidah',
                'Khulna',
                'Kushtia',
                'Magura',
                'Meherpur',
                'Narail',
                'Satkhira',
                'Bogra',
                'Dinajpur',
                'Gaibandha',
                'Jaipurhat',
                'Kurigram',
                'Lalmonirhat',
                'Naogaon',
                'Natore',
                'Nawabganj',
                'Nilphamari',
                'Pabna',
                'Panchagarh',
                'Rajshahi',
                'Rangpur',
                'Sirajganj',
                'Thakurgaon',
                'Habiganj',
                'Maulvi bazar',
                'Sunamganj',
                'Sylhet'
            ],
            'divider': false
        },
        {
            name: 'Barbados',
            states: [
                'Bridgetown',
                'Christ Church',
                'Saint Andrew',
                'Saint George',
                'Saint James',
                'Saint John',
                'Saint Joseph',
                'Saint Lucy',
                'Saint Michael',
                'Saint Peter',
                'Saint Philip',
                'Saint Thomas'
            ],
            'divider': false
        },
        {
            name: 'Belarus',
            states: [
                'Brestskaya (Brest)',
                'Homyel\'skaya(Homyel\')',
                'Horad Minsk',
                'Hrodzyenskaya (Hrodna)',
                'Mahilyowskaya (Mahilyow)',
                'Minskaya',
                'Vitsyebskaya (Vitsyebsk)'
            ],
            'divider': false
        },
        {
            name: 'Belgium',
            states: [
                'Antwerpen',
                'Brabant Wallon',
                'Brussels Capitol Region',
                'Hainaut',
                'Liege',
                'Limburg',
                'Luxembourg',
                'Namur',
                'Oost-Vlaanderen',
                'Vlaams Brabant',
                'West-Vlaanderen'
            ],
            'divider': false
        },
        {
            name: 'Belize',
            states: [
                'Belize',
                'Cayo',
                'Corozal',
                'Orange Walk',
                'Stann Creek',
                'Toledo'
            ],
            'divider': false
        },
        {
            name: 'Benin',
            states: [
                'Alibori',
                'Atakora',
                'Atlantique',
                'Borgou',
                'Collines',
                'Couffo',
                'Donga',
                'Littoral',
                'Mono',
                'Oueme',
                'Plateau',
                'Zou'
            ],
            'divider': false
        },
        {
            name: 'Bermuda',
            states: [
                'Devonshire',
                'Hamilton',
                'Hamilton',
                'Paget',
                'Pembroke',
                'Saint George',
                'Saint Georges',
                'Sandys',
                'Smiths',
                'Southampton',
                'Warwick'
            ],
            'divider': false
        },
        {
            name: 'Bhutan',
            states: [
                'Bumthang',
                'Chhukha',
                'Chirang',
                'Daga',
                'Geylegphug',
                'Ha',
                'Lhuntshi',
                'Mongar',
                'Paro',
                'Pemagatsel',
                'Punakha',
                'Samchi',
                'Samdrup Jongkhar',
                'Shemgang',
                'Tashigang',
                'Thimphu',
                'Tongsa',
                'Wangdi Phodrang'
            ],
            'divider': false
        },
        {
            name: 'Bolivia',
            states: [
                'Beni',
                'Chuquisaca',
                'Cochabamba',
                'La Paz',
                'Oruro',
                'Pando',
                'Potosi',
                'Santa Cruz',
                'Tarija'
            ],
            'divider': false
        },
        {
            name: 'Bosnia and Herzegovina',
            states: [
                'Federation of Bosnia and Herzegovina',
                'Republika Srpska'
            ],
            'divider': false
        },
        {
            name: 'Botswana',
            states: [
                'Central',
                'Chobe',
                'Francistown',
                'Gaborone',
                'Ghanzi',
                'Kgalagadi',
                'Kgatleng',
                'Kweneng',
                'Lobatse',
                'Ngamiland',
                'North-East',
                'Selebi-Pikwe',
                'South-East',
                'Southern'
            ],
            'divider': false
        },
        {
            name: 'Brazil',
            states: [
                'Acre',
                'Alagoas',
                'Amapa',
                'Amazonas',
                'Bahia',
                'Ceara',
                'Distrito Federal',
                'Espirito Santo',
                'Goias',
                'Maranhao',
                'Mato Grosso',
                'Mato Grosso do Sul',
                'Minas Gerais',
                'Para',
                'Paraiba',
                'Parana',
                'Pernambuco',
                'Piaui',
                'Rio de Janeiro',
                'Rio Grande do Norte',
                'Rio Grande do Sul',
                'Rondonia',
                'Roraima',
                'Santa Catarina',
                'Sao Paulo',
                'Sergipe',
                'Tocantins'
            ],
            'divider': false
        },
        {
            name: 'British Virgin Islands',
            states: [
                'Anegada',
                'Jost Van Dyke',
                'Tortola',
                'Virgin Gorda'
            ],
            'divider': false
        },
        {
            name: 'Brunei',
            states: [
                'Belait',
                'Brunei and Muara',
                'Temburong',
                'Tutong'
            ],
            'divider': false
        },
        {
            name: 'Bulgaria',
            states: [
                'Blagoevgrad',
                'Burgas',
                'Dobrich',
                'Gabrovo',
                'Khaskovo',
                'Kurdzhali',
                'Kyustendil',
                'Lovech',
                'Montana',
                'Pazardzhik',
                'Pernik',
                'Pleven',
                'Plovdiv',
                'Razgrad',
                'Ruse',
                'Shumen',
                'Silistra',
                'Sliven',
                'Smolyan',
                'Sofiya',
                'Sofiya-Grad',
                'Stara Zagora',
                'Turgovishte',
                'Varna',
                'Veliko Turnovo',
                'Vidin',
                'Vratsa',
                'Yambol'
            ],
            'divider': false
        },
        {
            name: 'Burkina Faso',
            states: [
                'Bale',
                'Bam',
                'Banwa',
                'Bazega',
                'Bougouriba',
                'Boulgou',
                'Boulkiemde',
                'Comoe',
                'Ganzourgou',
                'Gnagna',
                'Gourma',
                'Houet',
                'Ioba',
                'Kadiogo',
                'Kenedougou',
                'Komandjari',
                'Kompienga',
                'Kossi',
                'Koupelogo',
                'Kouritenga',
                'Kourweogo',
                'Leraba',
                'Loroum',
                'Mouhoun',
                'Nahouri',
                'Namentenga',
                'Naumbiel',
                'Nayala',
                'Oubritenga',
                'Oudalan',
                'Passore',
                'Poni',
                'Samentenga',
                'Sanguie',
                'Seno',
                'Sissili',
                'Soum',
                'Sourou',
                'Tapoa',
                'Tuy',
                'Yagha',
                'Yatenga',
                'Ziro',
                'Zondomo',
                'Zoundweogo'
            ],
            'divider': false
        },
        {
            name: 'Burma',
            states: [
                'Ayeyarwady',
                'Bago',
                'Chin State',
                'Kachin State',
                'Kayah State',
                'Kayin State',
                'Magway',
                'Mandalay',
                'Mon State',
                'Rakhine State',
                'Sagaing',
                'Shan State',
                'Tanintharyi',
                'Yangon'
            ],
            'divider': false
        },
        {
            name: 'Burundi',
            states: [
                'Bubanza',
                'Bujumbura',
                'Bururi',
                'Cankuzo',
                'Cibitoke',
                'Gitega',
                'Karuzi',
                'Kayanza',
                'Kirundo',
                'Makamba',
                'Muramvya',
                'Muyinga',
                'Mwaro',
                'Ngozi',
                'Rutana',
                'Ruyigi'
            ],
            'divider': false
        },
        {
            name: 'Cambodia',
            states: [
                'Banteay Mean Cheay',
                'Batdambang',
                'Kampong Cham',
                'Kampong Chhnang',
                'Kampong Spoe',
                'Kampong Thum',
                'Kampot',
                'Kandal',
                'Kaoh Kong',
                'Keb',
                'Kracheh',
                'Mondol Kiri',
                'Otdar Mean Cheay',
                'Pailin',
                'Phnum Penh',
                'Pouthisat',
                'Preah Seihanu (Sihanoukville)',
                'Preah Vihear',
                'Prey Veng',
                'Rotanah Kiri',
                'Siem Reab',
                'Stoeng Treng',
                'Svay Rieng',
                'Takev'
            ],
            'divider': false
        },
        {
            name: 'Cameroon',
            states: [
                'Adamaoua',
                'Centre',
                'Est',
                'Extreme-Nord',
                'Littoral',
                'Nord',
                'Nord-Ouest',
                'Ouest',
                'Sud',
                'Sud-Ouest'
            ],
            'divider': false
        },
        {
            name: 'Canada',
            states: [
                'Alberta',
                'British Columbia',
                'Manitoba',
                'New Brunswick',
                'Newfoundland',
                'Northwest Territories',
                'Nova Scotia',
                'Nunavut',
                'Ontario',
                'Prince Edward Island',
                'Quebec',
                'Saskatchewan',
                'Yukon Territory'
            ],
            'divider': false
        },
        {
            name: 'Cape Verde',
            states: [
                'Boa Vista',
                'Brava',
                'Maio',
                'Mosteiros',
                'Paul',
                'Porto Novo',
                'Praia',
                'Ribeira Grande',
                'Sal',
                'Santa Catarina',
                'Santa Cruz',
                'Sao Domingos',
                'Sao Filipe',
                'Sao Nicolau',
                'Sao Vicente',
                'Tarrafal'
            ],
            'divider': false
        },
        {
            name: 'Cayman Islands',
            states: [
                'Creek',
                'Eastern',
                'Midland',
                'South Town',
                'Spot Bay',
                'Stake Bay',
                'West End',
                'Western'
            ],
            'divider': false
        },
        {
            name: 'Central African Republic',
            states: [
                'Bamingui-Bangoran',
                'Bangui',
                'Basse-Kotto',
                'Gribingui',
                'Haut-Mbomou',
                'Haute-Kotto',
                'Haute-Sangha',
                'Kemo-Gribingui',
                'Lobaye',
                'Mbomou',
                'Nana-Mambere',
                'Ombella-Mpoko',
                'Ouaka',
                'Ouham',
                'Ouham-Pende',
                'Sangha',
                'Vakaga'
            ],
            'divider': false
        },
        {
            name: 'Chad',
            states: [
                'Batha',
                'Biltine',
                'Borkou-Ennedi-Tibesti',
                'Chari-Baguirmi',
                'Guera',
                'Kanem',
                'Lac',
                'Logone Occidental',
                'Logone Oriental',
                'Mayo-Kebbi',
                'Moyen-Chari',
                'Ouaddai',
                'Salamat',
                'Tandjile'
            ],
            'divider': false
        },
        {
            name: 'Chile',
            states: [
                'Aisen del General Carlos Ibanez del Campo',
                'Antofagasta',
                'Araucania',
                'Atacama',
                'Bio-Bio',
                'Coquimbo',
                'Libertador General Bernardo O\'Higgins',
                'Los Lagos',
                'Magallanes y de la Antartica Chilena',
                'Maule',
                'Region Metropolitana (Santiago)',
                'Tarapaca',
                'Valparaiso'
            ],
            'divider': false
        },
        {
            name: 'China',
            states: [
                'Anhui',
                'Beijing',
                'Chongqing',
                'Fujian',
                'Gansu',
                'Guangdong',
                'Guangxi',
                'Guizhou',
                'Hainan',
                'Hebei',
                'Heilongjiang',
                'Henan',
                'Hubei',
                'Hunan',
                'Jiangsu',
                'Jiangxi',
                'Jilin',
                'Liaoning',
                'Nei Mongol',
                'Ningxia',
                'Qinghai',
                'Shaanxi',
                'Shandong',
                'Shanghai',
                'Shanxi',
                'Sichuan',
                'Tianjin',
                'Xinjiang',
                'Xizang (Tibet)',
                'Yunnan',
                'Zhejiang'
            ],
            'divider': false
        },
        {
            name: 'Christmas Island',
            states: [
                'Christmas Island'
            ],
            'divider': false
        },
        {
            name: 'Clipperton Island',
            states: [
                'Clipperton Island'
            ],
            'divider': false
        },
        {
            name: 'Cocos (Keeling) Islands',
            states: [
                'Direction Island',
                'Home Island',
                'Horsburgh Island',
                'North Keeling Island',
                'South Island',
                'West Island'
            ],
            'divider': false
        },
        {
            name: 'Colombia',
            states: [
                'Amazonas',
                'Antioquia',
                'Arauca',
                'Atlantico',
                'Bolivar',
                'Boyaca',
                'Caldas',
                'Caqueta',
                'Casanare',
                'Cauca',
                'Cesar',
                'Choco',
                'Cordoba',
                'Cundinamarca',
                'Distrito Capital de Santa Fe de Bogota',
                'Guainia',
                'Guaviare',
                'Huila',
                'La Guajira',
                'Magdalena',
                'Meta',
                'Narino',
                'Norte de Santander',
                'Putumayo',
                'Quindio',
                'Risaralda',
                'San Andres y Providencia',
                'Santander',
                'Sucre',
                'Tolima',
                'Valle del Cauca',
                'Vaupes',
                'Vichada'
            ],
            'divider': false
        },
        {
            name: 'Comoros',
            states: [
                'Anjouan (Nzwani)',
                'Domoni',
                'Fomboni',
                'Grande Comore (Njazidja)',
                'Moheli (Mwali)',
                'Moroni',
                'Moutsamoudou'
            ],
            'divider': false
        },
        {
            name: 'Congo, Democratic Republic of the',
            states: [
                'Bandundu',
                'Bas-Congo',
                'Equateur',
                'Kasai-Occidental',
                'Kasai-Oriental',
                'Katanga',
                'Kinshasa',
                'Maniema',
                'Nord-Kivu',
                'Orientale',
                'Sud-Kivu'
            ],
            'divider': false
        },
        {
            name: 'Congo, Republic of the',
            states: [
                'Bouenza',
                'Brazzaville',
                'Cuvette',
                'Kouilou',
                'Lekoumou',
                'Likouala',
                'Niari',
                'Plateaux',
                'Pool',
                'Sangha'
            ],
            'divider': false
        },
        {
            name: 'Cook Islands',
            states: [
                'Aitutaki',
                'Atiu',
                'Avarua',
                'Mangaia',
                'Manihiki',
                'Manuae',
                'Mauke',
                'Mitiaro',
                'Nassau Island',
                'Palmerston',
                'Penrhyn',
                'Pukapuka',
                'Rakahanga',
                'Rarotonga',
                'Suwarrow',
                'Takutea'
            ],
            'divider': false
        },
        {
            name: 'Costa Rica',
            states: [
                'Alajuela',
                'Cartago',
                'Guanacaste',
                'Heredia',
                'Limon',
                'Puntarenas',
                'San Jose'
            ],
            'divider': false
        },
        {
            name: 'Cote d\'Ivoire',
            states: [
                'Abengourou',
                'Abidjan',
                'Aboisso',
                'Adiake\'',
                'Adzope',
                'Agboville',
                'Agnibilekrou',
                'Ale\'pe\'',
                'Bangolo',
                'Beoumi',
                'Biankouma',
                'Bocanda',
                'Bondoukou',
                'Bongouanou',
                'Bouafle',
                'Bouake',
                'Bouna',
                'Boundiali',
                'Dabakala',
                'Dabon',
                'Daloa',
                'Danane',
                'Daoukro',
                'Dimbokro',
                'Divo',
                'Duekoue',
                'Ferkessedougou',
                'Gagnoa',
                'Grand Bassam',
                'Grand-Lahou',
                'Guiglo',
                'Issia',
                'Jacqueville',
                'Katiola',
                'Korhogo',
                'Lakota',
                'Man',
                'Mankono',
                'Mbahiakro',
                'Odienne',
                'Oume',
                'Sakassou',
                'San-Pedro',
                'Sassandra',
                'Seguela',
                'Sinfra',
                'Soubre',
                'Tabou',
                'Tanda',
                'Tiassale',
                'Tiebissou',
                'Tingrela',
                'Touba',
                'Toulepleu',
                'Toumodi',
                'Vavoua',
                'Yamoussoukro',
                'Zuenoula'
            ],
            'divider': false
        },
        {
            name: 'Croatia',
            states: [
                'Bjelovarsko-Bilogorska Zupanija',
                'Brodsko-Posavska Zupanija',
                'Dubrovacko-Neretvanska Zupanija',
                'Istarska Zupanija',
                'Karlovacka Zupanija',
                'Koprivnicko-Krizevacka Zupanija',
                'Krapinsko-Zagorska Zupanija',
                'Licko-Senjska Zupanija',
                'Medimurska Zupanija',
                'Osjecko-Baranjska Zupanija',
                'Pozesko-Slavonska Zupanija',
                'Primorsko-Goranska Zupanija',
                'Sibensko-Kninska Zupanija',
                'Sisacko-Moslavacka Zupanija',
                'Splitsko-Dalmatinska Zupanija',
                'Varazdinska Zupanija',
                'Viroviticko-Podravska Zupanija',
                'Vukovarsko-Srijemska Zupanija',
                'Zadarska Zupanija',
                'Zagreb',
                'Zagrebacka Zupanija'
            ],
            'divider': false
        },
        {
            name: 'Cuba',
            states: [
                'Camaguey',
                'Ciego de Avila',
                'Cienfuegos',
                'Ciudad de La Habana',
                'Granma',
                'Guantanamo',
                'Holguin',
                'Isla de la Juventud',
                'La Habana',
                'Las Tunas',
                'Matanzas',
                'Pinar del Rio',
                'Sancti Spiritus',
                'Santiago de Cuba',
                'Villa Clara'
            ],
            'divider': false
        },
        {
            name: 'Cyprus',
            states: [
                'Famagusta',
                'Kyrenia',
                'Larnaca',
                'Limassol',
                'Nicosia',
                'Paphos'
            ],
            'divider': false
        },
        {
            name: 'Czeck Republic',
            states: [
                'Brnensky',
                'Budejovicky',
                'Jihlavsky',
                'Karlovarsky',
                'Kralovehradecky',
                'Liberecky',
                'Olomoucky',
                'Ostravsky',
                'Pardubicky',
                'Plzensky',
                'Praha',
                'Stredocesky',
                'Ustecky',
                'Zlinsky'
            ],
            'divider': false
        },
        {
            name: 'Denmark',
            states: [
                'Arhus',
                'Bornholm',
                'Fredericksberg',
                'Frederiksborg',
                'Fyn',
                'Kobenhavn',
                'Kobenhavns',
                'Nordjylland',
                'Ribe',
                'Ringkobing',
                'Roskilde',
                'Sonderjylland',
                'Storstrom',
                'Vejle',
                'Vestsjalland',
                'Viborg'
            ],
            'divider': false
        },
        {
            name: 'Djibouti',
            states: [
                '\'Ali Sabih',
                'Dikhil',
                'Djibouti',
                'Obock',
                'Tadjoura'
            ],
            'divider': false
        },
        {
            name: 'Dominica',
            states: [
                'Saint Andrew',
                'Saint David',
                'Saint George',
                'Saint John',
                'Saint Joseph',
                'Saint Luke',
                'Saint Mark',
                'Saint Patrick',
                'Saint Paul',
                'Saint Peter'
            ],
            'divider': false
        },
        {
            name: 'Dominican Republic',
            states: [
                'Azua',
                'Baoruco',
                'Barahona',
                'Dajabon',
                'Distrito Nacional',
                'Duarte',
                'El Seibo',
                'Elias Pina',
                'Espaillat',
                'Hato Mayor',
                'Independencia',
                'La Altagracia',
                'La Romana',
                'La Vega',
                'Maria Trinidad Sanchez',
                'Monsenor Nouel',
                'Monte Cristi',
                'Monte Plata',
                'Pedernales',
                'Peravia',
                'Puerto Plata',
                'Salcedo',
                'Samana',
                'San Cristobal',
                'San Juan',
                'San Pedro de Macoris',
                'Sanchez Ramirez',
                'Santiago',
                'Santiago Rodriguez',
                'Valverde'
            ],
            'divider': false
        },
        {
            name: 'Ecuador',
            states: [
                'Azuay',
                'Bolivar',
                'Canar',
                'Carchi',
                'Chimborazo',
                'Cotopaxi',
                'El Oro',
                'Esmeraldas',
                'Galapagos',
                'Guayas',
                'Imbabura',
                'Loja',
                'Los Rios',
                'Manabi',
                'Morona-Santiago',
                'Napo',
                'Orellana',
                'Pastaza',
                'Pichincha',
                'Sucumbios',
                'Tungurahua',
                'Zamora-Chinchipe'
            ],
            'divider': false
        },
        {
            name: 'Egypt',
            states: [
                'Ad Daqahliyah',
                'Al Bahr al Ahmar',
                'Al Buhayrah',
                'Al Fayyum',
                'Al Gharbiyah',
                'Al Iskandariyah',
                'Al Isma\'iliyah',
                'Al Jizah',
                'Al Minufiyah',
                'Al Minya',
                'Al Qahirah',
                'Al Qalyubiyah',
                'Al Wadi al Jadid',
                'As Suways',
                'Ash Sharqiyah',
                'Aswan',
                'Asyut',
                'Bani Suwayf',
                'Bur Sa\'id',
                'Dumyat',
                'Janub Sina\'',
                'Kafr ash Shaykh',
                'Matruh',
                'Qina',
                'Shamal Sina\'',
                'Suhaj'
            ],
            'divider': false
        },
        {
            name: 'El Salvador',
            states: [
                'Ahuachapan',
                'Cabanas',
                'Chalatenango',
                'Cuscatlan',
                'La Libertad',
                'La Paz',
                'La Union',
                'Morazan',
                'San Miguel',
                'San Salvador',
                'San Vicente',
                'Santa Ana',
                'Sonsonate',
                'Usulutan'
            ],
            'divider': false
        },
        {
            name: 'Equatorial Guinea',
            states: [
                'Annobon',
                'Bioko Norte',
                'Bioko Sur',
                'Centro Sur',
                'Kie-Ntem',
                'Litoral',
                'Wele-Nzas'
            ],
            'divider': false
        },
        {
            name: 'Eritrea',
            states: [
                'Akale Guzay',
                'Barka',
                'Denkel',
                'Hamasen',
                'Sahil',
                'Semhar',
                'Senhit',
                'Seraye'
            ],
            'divider': false
        },
        {
            name: 'Estonia',
            states: [
                'Harjumaa (Tallinn)',
                'Hiiumaa (Kardla)',
                'Ida-Virumaa (Johvi)',
                'Jarvamaa (Paide)',
                'Jogevamaa (Jogeva)',
                'Laane-Virumaa (Rakvere)',
                'Laanemaa (Haapsalu)',
                'Parnumaa (Parnu)',
                'Polvamaa (Polva)',
                'Raplamaa (Rapla)',
                'Saaremaa (Kuessaare)',
                'Tartumaa (Tartu)',
                'Valgamaa (Valga)',
                'Viljandimaa (Viljandi)',
                'Vorumaa (Voru)'
            ],
            'divider': false
        },
        {
            name: 'Ethiopia',
            states: [
                'Adis Abeba (Addis Ababa)',
                'Afar',
                'Amara',
                'Dire Dawa',
                'Gambela Hizboch',
                'Hareri Hizb',
                'Oromiya',
                'Sumale',
                'Tigray',
                'YeDebub Biheroch Bihereseboch na Hizboch'
            ],
            'divider': false
        },
        {
            name: 'Europa Island',
            states: [
                'Europa Island'
            ],
            'divider': false
        },
        {
            name: 'Falkland Islands (Islas Malvinas)',
            states: [
                'Falkland Islands (Islas Malvinas)'
            ],
            'divider': false
        },
        {
            name: 'Faroe Islands',
            states: [
                'Bordoy',
                'Eysturoy',
                'Mykines',
                'Sandoy',
                'Skuvoy',
                'Streymoy',
                'Suduroy',
                'Tvoroyri',
                'Vagar'
            ],
            'divider': false
        },
        {
            name: 'Fiji',
            states: [
                'Central',
                'Eastern',
                'Northern',
                'Rotuma',
                'Western'
            ],
            'divider': false
        },
        {
            name: 'Finland',
            states: [
                'Aland',
                'Etela-Suomen Laani',
                'Ita-Suomen Laani',
                'Lansi-Suomen Laani',
                'Lappi',
                'Oulun Laani'
            ],
            'divider': false
        },
        {
            name: 'France',
            states: [
                'Alsace',
                'Aquitaine',
                'Auvergne',
                'Basse-Normandie',
                'Bourgogne',
                'Bretagne',
                'Centre',
                'Champagne-Ardenne',
                'Corse',
                'Franche-Comte',
                'Haute-Normandie',
                'Ile-de-France',
                'Languedoc-Roussillon',
                'Limousin',
                'Lorraine',
                'Midi-Pyrenees',
                'Nord-Pas-de-Calais',
                'Pays de la Loire',
                'Picardie',
                'Poitou-Charentes',
                'Provence-Alpes-Cote d\'Azur',
                'Rhone-Alpes'
            ],
            'divider': false
        },
        {
            name: 'French Guiana',
            states: [
                'French Guiana'
            ],
            'divider': false
        },
        {
            name: 'French Polynesia',
            states: [
                'Archipel des Marquises',
                'Archipel des Tuamotu',
                'Archipel des Tubuai',
                'Iles du Vent',
                'Iles Sous-le-Vent'
            ],
            'divider': false
        },
        {
            name: 'French Southern and Antarctic Lands',
            states: [
                'Adelie Land',
                'Ile Crozet',
                'Iles Kerguelen',
                'Iles Saint-Paul et Amsterdam'
            ],
            'divider': false
        },
        {
            name: 'Gabon',
            states: [
                'Estuaire',
                'Haut-Ogooue',
                'Moyen-Ogooue',
                'Ngounie',
                'Nyanga',
                'Ogooue-Ivindo',
                'Ogooue-Lolo',
                'Ogooue-Maritime',
                'Woleu-Ntem'
            ],
            'divider': false
        },
        {
            name: 'Gambia, The',
            states: [
                'Banjul',
                'Central River',
                'Lower River',
                'North Bank',
                'Upper River',
                'Western'
            ],
            'divider': false
        },
        {
            name: 'Gaza Strip',
            states: [
                'Gaza Strip'
            ],
            'divider': false
        },
        {
            name: 'Georgia',
            states: [
                'Abashis',
                'Abkhazia or Ap\'khazet\'is Avtonomiuri Respublika (Sokhumi)',
                'Adigenis',
                'Ajaria or Acharis Avtonomiuri Respublika (Bat\'umi)',
                'Akhalgoris',
                'Akhalk\'alak\'is',
                'Akhalts\'ikhis',
                'Akhmetis',
                'Ambrolauris',
                'Aspindzis',
                'Baghdat\'is',
                'Bolnisis',
                'Borjomis',
                'Ch\'khorotsqus',
                'Ch\'okhatauris',
                'Chiat\'ura',
                'Dedop\'listsqaros',
                'Dmanisis',
                'Dushet\'is',
                'Gardabanis',
                'Gori',
                'Goris',
                'Gurjaanis',
                'Javis',
                'K\'arelis ',
                'K\'utaisi',
                'Kaspis',
                'Kharagaulis',
                'Khashuris',
                'Khobis',
                'Khonis',
                'Lagodekhis',
                'Lanch\'khut\'is',
                'Lentekhis',
                'Marneulis',
                'Martvilis',
                'Mestiis',
                'Mts\'khet\'is',
                'Ninotsmindis',
                'Onis',
                'Ozurget\'is',
                'P\'ot\'i',
                'Qazbegis',
                'Qvarlis',
                'Rust\'avi',
                'Sach\'kheris',
                'Sagarejos',
                'Samtrediis',
                'Senakis',
                'Sighnaghis',
                'T\'bilisi',
                'T\'elavis',
                'T\'erjolis',
                'T\'et\'ritsqaros',
                'T\'ianet\'is',
                'Tqibuli',
                'Ts\'ageris',
                'Tsalenjikhis',
                'Tsalkis',
                'Tsqaltubo',
                'Vanis',
                'Zestap\'onis',
                'Zugdidi',
                'Zugdidis'
            ],
            'divider': false
        },
        {
            name: 'Germany',
            states: [
                'Baden-Wuerttemberg',
                'Bayern',
                'Berlin',
                'Brandenburg',
                'Bremen',
                'Hamburg',
                'Hessen',
                'Mecklenburg-Vorpommern',
                'Niedersachsen',
                'Nordrhein-Westfalen',
                'Rheinland-Pfalz',
                'Saarland',
                'Sachsen',
                'Sachsen-Anhalt',
                'Schleswig-Holstein',
                'Thueringen'
            ],
            'divider': false
        }, {
            name: 'Ghana',
            states: [
                'Ashanti',
                'Brong-Ahafo',
                'Central',
                'Eastern',
                'Greater Accra',
                'Northern',
                'Upper East',
                'Upper West',
                'Volta',
                'Western'
            ],
            'divider': false
        }, {
            name: 'Gibraltar',
            states: [
                'Gibraltar'
            ],
            'divider': false
        },
        {
            name: 'Glorioso Islands',
            states: [
                'Ile du Lys',
                'Ile Glorieuse'
            ],
            'divider': false
        },
        {
            name: 'Greece',
            states: [
                'Aitolia kai Akarnania',
                'Akhaia',
                'Argolis',
                'Arkadhia',
                'Arta',
                'Attiki',
                'Ayion Oros (Mt. Athos)',
                'Dhodhekanisos',
                'Drama',
                'Evritania',
                'Evros',
                'Evvoia',
                'Florina',
                'Fokis',
                'Fthiotis',
                'Grevena',
                'Ilia',
                'Imathia',
                'Ioannina',
                'Irakleion',
                'Kardhitsa',
                'Kastoria',
                'Kavala',
                'Kefallinia',
                'Kerkyra',
                'Khalkidhiki',
                'Khania',
                'Khios',
                'Kikladhes',
                'Kilkis',
                'Korinthia',
                'Kozani',
                'Lakonia',
                'Larisa',
                'Lasithi',
                'Lesvos',
                'Levkas',
                'Magnisia',
                'Messinia',
                'Pella',
                'Pieria',
                'Preveza',
                'Rethimni',
                'Rodhopi',
                'Samos',
                'Serrai',
                'Thesprotia',
                'Thessaloniki',
                'Trikala',
                'Voiotia',
                'Xanthi',
                'Zakinthos'
            ],
            'divider': false
        }, {
            name: 'Greenland',
            states: [
                'Avannaa (Nordgronland)',
                'Kitaa (Vestgronland)',
                'Tunu (Ostgronland)'
            ],
            'divider': false
        }, {
            name: 'Grenada',
            states: [
                'Carriacou and Petit Martinique',
                'Saint Andrew',
                'Saint David',
                'Saint George',
                'Saint John',
                'Saint Mark',
                'Saint Patrick'
            ],
            'divider': false
        }, {
            name: 'Guadeloupe',
            states: [
                'Basse-Terre',
                'Grande-Terre',
                'Iles de la Petite Terre',
                'Iles des Saintes',
                'Marie-Galante'
            ],
            'divider': false
        },
        {
            name: 'Guam',
            states: [
                'Guam'
            ],
            'divider': false
        },
        {
            name: 'Guatemala',
            states: [
                'Alta Verapaz',
                'Baja Verapaz',
                'Chimaltenango',
                'Chiquimula',
                'El Progreso',
                'Escuintla',
                'Guatemala',
                'Huehuetenango',
                'Izabal',
                'Jalapa',
                'Jutiapa',
                'Peten',
                'Quetzaltenango',
                'Quiche',
                'Retalhuleu',
                'Sacatepequez',
                'San Marcos',
                'Santa Rosa',
                'Solola',
                'Suchitepequez',
                'Totonicapan',
                'Zacapa'
            ],
            'divider': false
        },
        {
            name: 'Guernsey',
            states: [
                'Castel',
                'Forest',
                'St. Andrew',
                'St. Martin',
                'St. Peter Port',
                'St. Pierre du Bois',
                'St. Sampson',
                'St. Saviour',
                'Torteval',
                'Vale'
            ],
            'divider': false
        },
        {
            name: 'Guinea',
            states: [
                'Beyla',
                'Boffa',
                'Boke',
                'Conakry',
                'Coyah',
                'Dabola',
                'Dalaba',
                'Dinguiraye',
                'Dubreka',
                'Faranah',
                'Forecariah',
                'Fria',
                'Gaoual',
                'Gueckedou',
                'Kankan',
                'Kerouane',
                'Kindia',
                'Kissidougou',
                'Koubia',
                'Koundara',
                'Kouroussa',
                'Labe',
                'Lelouma',
                'Lola',
                'Macenta',
                'Mali',
                'Mamou',
                'Mandiana',
                'Nzerekore',
                'Pita',
                'Siguiri',
                'Telimele',
                'Tougue',
                'Yomou'
            ],
            'divider': false
        }
        ,
        {
            name: 'Guinea-Bissau',
            states: [
                'Bafata',
                'Biombo',
                'Bissau',
                'Bolama-Bijagos',
                'Cacheu',
                'Gabu',
                'Oio',
                'Quinara',
                'Tombali'
            ],
            'divider': false
        },
        {
            name: 'Guyana',
            states: [
                'Barima-Waini',
                'Cuyuni-Mazaruni',
                'Demerara-Mahaica',
                'East Berbice-Corentyne',
                'Essequibo Islands-West Demerara',
                'Mahaica-Berbice',
                'Pomeroon-Supenaam',
                'Potaro-Siparuni',
                'Upper Demerara-Berbice',
                'Upper Takutu-Upper Essequibo'
            ],
            'divider': false
        },
        {
            name: 'Haiti',
            states: [
                'Artibonite',
                'Centre',
                'Grand\'Anse',
                'Nord',
                'Nord-Est',
                'Nord-Ouest',
                'Ouest',
                'Sud',
                'Sud-Est'
            ],
            'divider': false
        },
        {
            name: 'Heard Island and McDonald Islands',
            states: [
                'Heard Island and McDonald Islands'
            ],
            'divider': false
        }, {
            name: 'Holy See (Vatican City)',
            states: [
                'Holy See (Vatican City)'
            ],
            'divider': false
        }, {
            name: 'Honduras',
            states: [
                'Atlantida',
                'Choluteca',
                'Colon',
                'Comayagua',
                'Copan',
                'Cortes',
                'El Paraiso',
                'Francisco Morazan',
                'Gracias a Dios',
                'Intibuca',
                'Islas de la Bahia',
                'La Paz',
                'Lempira',
                'Ocotepeque',
                'Olancho',
                'Santa Barbara',
                'Valle',
                'Yoro'
            ],
            'divider': false
        }, {
            name: 'Hong Kong',
            states: [
                'Hong Kong'
            ],
            'divider': false
        }, {
            name: 'Howland Island',
            states: [
                'Howland Island'
            ],
            'divider': false
        }, {
            name: 'Hungary',
            states: [
                'Bacs-Kiskun',
                'Baranya',
                'Bekes',
                'Bekescsaba',
                'Borsod-Abauj-Zemplen',
                'Budapest',
                'Csongrad',
                'Debrecen',
                'Dunaujvaros',
                'Eger',
                'Fejer',
                'Gyor',
                'Gyor-Moson-Sopron',
                'Hajdu-Bihar',
                'Heves',
                'Hodmezovasarhely',
                'Jasz-Nagykun-Szolnok',
                'Kaposvar',
                'Kecskemet',
                'Komarom-Esztergom',
                'Miskolc',
                'Nagykanizsa',
                'Nograd',
                'Nyiregyhaza',
                'Pecs',
                'Pest',
                'Somogy',
                'Sopron',
                'Szabolcs-Szatmar-Bereg',
                'Szeged',
                'Szekesfehervar',
                'Szolnok',
                'Szombathely',
                'Tatabanya',
                'Tolna',
                'Vas',
                'Veszprem',
                'Veszprem',
                'Zala',
                'Zalaegerszeg'
            ],
            'divider': false
        }, {
            name: 'Iceland',
            states: [
                'Akranes',
                'Akureyri',
                'Arnessysla',
                'Austur-Bardhastrandarsysla',
                'Austur-Hunavatnssysla',
                'Austur-Skaftafellssysla',
                'Borgarfjardharsysla',
                'Dalasysla',
                'Eyjafjardharsysla',
                'Gullbringusysla',
                'Hafnarfjordhur',
                'Husavik',
                'Isafjordhur',
                'Keflavik',
                'Kjosarsysla',
                'Kopavogur',
                'Myrasysla',
                'Neskaupstadhur',
                'Nordhur-Isafjardharsysla',
                'Nordhur-Mulasys-la',
                'Nordhur-Thingeyjarsysla',
                'Olafsfjordhur',
                'Rangarvallasysla',
                'Reykjavik',
                'Saudharkrokur',
                'Seydhisfjordhur',
                'Siglufjordhur',
                'Skagafjardharsysla',
                'Snaefellsnes-og Hnappadalssysla',
                'Strandasysla',
                'Sudhur-Mulasysla',
                'Sudhur-Thingeyjarsysla',
                'Vesttmannaeyjar',
                'Vestur-Bardhastrandarsysla',
                'Vestur-Hunavatnssysla',
                'Vestur-Isafjardharsysla',
                'Vestur-Skaftafellssysla'
            ],
            'divider': false
        }, {
            name: 'India',
            states: [
                'Andaman and Nicobar Islands',
                'Andhra Pradesh',
                'Arunachal Pradesh',
                'Assam',
                'Bihar',
                'Chandigarh',
                'Chhattisgarh',
                'Dadra and Nagar Haveli',
                'Daman and Diu',
                'Delhi',
                'Goa',
                'Gujarat',
                'Haryana',
                'Himachal Pradesh',
                'Jammu and Kashmir',
                'Jharkhand',
                'Karnataka',
                'Kerala',
                'Lakshadweep',
                'Madhya Pradesh',
                'Maharashtra',
                'Manipur',
                'Meghalaya',
                'Mizoram',
                'Nagaland',
                'Orissa',
                'Pondicherry',
                'Punjab',
                'Rajasthan',
                'Sikkim',
                'Tamil Nadu',
                'Tripura',
                'Uttar Pradesh',
                'Uttaranchal',
                'West Bengal'
            ],
            'divider': false
        }, {
            name: 'Indonesia',
            states: [
                'Aceh',
                'Bali',
                'Banten',
                'Bengkulu',
                'East Timor',
                'Gorontalo',
                'Irian Jaya',
                'Jakarta Raya',
                'Jambi',
                'Jawa Barat',
                'Jawa Tengah',
                'Jawa Timur',
                'Kalimantan Barat',
                'Kalimantan Selatan',
                'Kalimantan Tengah',
                'Kalimantan Timur',
                'Kepulauan Bangka Belitung',
                'Lampung',
                'Maluku',
                'Maluku Utara',
                'Nusa Tenggara Barat',
                'Nusa Tenggara Timur',
                'Riau',
                'Sulawesi Selatan',
                'Sulawesi Tengah',
                'Sulawesi Tenggara',
                'Sulawesi Utara',
                'Sumatera Barat',
                'Sumatera Selatan',
                'Sumatera Utara',
                'Yogyakarta'
            ],
            'divider': false
        }, {
            name: 'Iran',
            states: [
                'Ardabil',
                'Azarbayjan-e Gharbi',
                'Azarbayjan-e Sharqi',
                'Bushehr',
                'Chahar Mahall va Bakhtiari',
                'Esfahan',
                'Fars',
                'Gilan',
                'Golestan',
                'Hamadan',
                'Hormozgan',
                'Ilam',
                'Kerman',
                'Kermanshah',
                'Khorasan',
                'Khuzestan',
                'Kohgiluyeh va Buyer Ahmad',
                'Kordestan',
                'Lorestan',
                'Markazi',
                'Mazandaran',
                'Qazvin',
                'Qom',
                'Semnan',
                'Sistan va Baluchestan',
                'Tehran',
                'Yazd',
                'Zanjan'
            ],
            'divider': false
        }, {
            name: 'Iraq',
            states: [
                'Al Anbar',
                'Al Basrah',
                'Al Muthanna',
                'Al Qadisiyah',
                'An Najaf',
                'Arbil',
                'As Sulaymaniyah',
                'At Ta\'mim',
                'Babil',
                'Baghdad',
                'Dahuk',
                'Dhi Qar',
                'Diyala',
                'Karbala\'',
                'Maysan',
                'Ninawa',
                'Salah ad Din',
                'Wasit'
            ],
            'divider': false
        }, {
            name: 'Ireland',
            states: [
                'Carlow',
                'Cavan',
                'Clare',
                'Cork',
                'Donegal',
                'Dublin',
                'Galway',
                'Kerry',
                'Kildare',
                'Kilkenny',
                'Laois',
                'Leitrim',
                'Limerick',
                'Longford',
                'Louth',
                'Mayo',
                'Meath',
                'Monaghan',
                'Offaly',
                'Roscommon',
                'Sligo',
                'Tipperary',
                'Waterford',
                'Westmeath',
                'Wexford',
                'Wicklow'
            ],
            'divider': false
        }, {
            name: 'Ireland, Northern',
            states: [
                'Antrim',
                'Ards',
                'Armagh',
                'Ballymena',
                'Ballymoney',
                'Banbridge',
                'Belfast',
                'Carrickfergus',
                'Castlereagh',
                'Coleraine',
                'Cookstown',
                'Craigavon',
                'Derry',
                'Down',
                'Dungannon',
                'Fermanagh',
                'Larne',
                'Limavady',
                'Lisburn',
                'Magherafelt',
                'Moyle',
                'Newry and Mourne',
                'Newtownabbey',
                'North Down',
                'Omagh',
                'Strabane'
            ],
            'divider': false
        }
        ,
        {
            name: 'Israel',
            states: [
                'Central',
                'Haifa',
                'Jerusalem',
                'Northern',
                'Southern',
                'Tel Aviv'
            ],
            'divider': false
        }
        ,
        {
            name: 'Italy',
            states: [
                'Abruzzo',
                'Basilicata',
                'Calabria',
                'Campania',
                'Emilia-Romagna',
                'Friuli-Venezia Giulia',
                'Lazio',
                'Liguria',
                'Lombardia',
                'Marche',
                'Molise',
                'Piemonte',
                'Puglia',
                'Sardegna',
                'Sicilia',
                'Toscana',
                'Trentino-Alto Adige',
                'Umbria',
                'Valle d\'Aosta',
                'Veneto'
            ],
            'divider': false
        }
        ,
        {
            name: 'Jamaica',
            states: [
                'Clarendon',
                'Hanover',
                'Kingston',
                'Manchester',
                'Portland',
                'Saint Andrew',
                'Saint Ann',
                'Saint Catherine',
                'Saint Elizabeth',
                'Saint James',
                'Saint Mary',
                'Saint Thomas',
                'Trelawny',
                'Westmoreland'
            ],
            'divider': false
        }
        ,
        {
            name: 'Jan Mayen',
            states: [
                'Jan Mayen'
            ],
            'divider': false
        }
        ,
        {
            name: 'Japan',
            states: [
                'Aichi',
                'Akita',
                'Aomori',
                'Chiba',
                'Ehime',
                'Fukui',
                'Fukuoka',
                'Fukushima',
                'Gifu',
                'Gumma',
                'Hiroshima',
                'Hokkaido',
                'Hyogo',
                'Ibaraki',
                'Ishikawa',
                'Iwate',
                'Kagawa',
                'Kagoshima',
                'Kanagawa',
                'Kochi',
                'Kumamoto',
                'Kyoto',
                'Mie',
                'Miyagi',
                'Miyazaki',
                'Nagano',
                'Nagasaki',
                'Nara',
                'Niigata',
                'Oita',
                'Okayama',
                'Okinawa',
                'Osaka',
                'Saga',
                'Saitama',
                'Shiga',
                'Shimane',
                'Shizuoka',
                'Tochigi',
                'Tokushima',
                'Tokyo',
                'Tottori',
                'Toyama',
                'Wakayama',
                'Yamagata',
                'Yamaguchi',
                'Yamanashi'
            ],
            'divider': false
        }
        ,
        {
            name: 'Jarvis Island',
            states: [
                'Jarvis Island'
            ],
            'divider': false
        }
        ,
        {
            name: 'Jersey',
            states: [
                'Jersey'
            ],
            'divider': false
        }
        ,
        {
            name: 'Johnston Atoll',
            states: [
                'Johnston Atoll'
            ],
            'divider': false
        }
        ,
        {
            name: 'Jordan',
            states: [
                '\'Amman',
                'Ajlun',
                'Al \'Aqabah',
                'Al Balqa\'',
                'Al Karak',
                'Al Mafraq',
                'At Tafilah',
                'Az Zarqa\'',
                'Irbid',
                'Jarash',
                'Ma\'an',
                'Madaba'
            ],
            'divider': false
        }
        ,
        {
            name: 'Juan de Nova Island',
            states: [
                'Juan de Nova Island'
            ],
            'divider': false
        }
        ,
        {
            name: 'Kazakhstan',
            states: [
                'Almaty',
                'Aqmola',
                'Aqtobe',
                'Astana',
                'Atyrau',
                'Batys Qazaqstan',
                'Bayqongyr',
                'Mangghystau',
                'Ongtustik Qazaqstan',
                'Pavlodar',
                'Qaraghandy',
                'Qostanay',
                'Qyzylorda',
                'Shyghys Qazaqstan',
                'Soltustik Qazaqstan',
                'Zhambyl'
            ],
            'divider': false
        }
        ,
        {
            name: 'Kenya',
            states: [
                'Central',
                'Coast',
                'Eastern',
                'Nairobi Area',
                'North Eastern',
                'Nyanza',
                'Rift Valley',
                'Western'
            ],
            'divider': false
        }
        ,
        {
            name: 'Kiribati',
            states: [
                'Abaiang',
                'Abemama',
                'Aranuka',
                'Arorae',
                'Banaba',
                'Banaba',
                'Beru',
                'Butaritari',
                'Central Gilberts',
                'Gilbert Islands',
                'Kanton',
                'Kiritimati',
                'Kuria',
                'Line Islands',
                'Line Islands',
                'Maiana',
                'Makin',
                'Marakei',
                'Nikunau',
                'Nonouti',
                'Northern Gilberts',
                'Onotoa',
                'Phoenix Islands',
                'Southern Gilberts',
                'Tabiteuea',
                'Tabuaeran',
                'Tamana',
                'Tarawa',
                'Tarawa',
                'Teraina'
            ],
            'divider': false
        }
        ,
        {
            name: 'Korea, North',
            states: [
                'Chagang-do (Chagang Province)',
                'Hamgyong-bukto (North Hamgyong Province)',
                'Hamgyong-namdo (South Hamgyong Province)',
                'Hwanghae-bukto (North Hwanghae Province)',
                'Hwanghae-namdo (South Hwanghae Province)',
                'Kaesong-si (Kaesong City)',
                'Kangwon-do (Kangwon Province)',
                'Namp\'o - si(Namp\'o City)',
                'P\'yongan - bukto(North P\'yongan Province)',
                'P\'yongan - namdo(South P\'yongan Province)',
                'P\'yongyang - si(P\'yongyang City)',
                'Yanggang-do (Yanggang Province)'
            ],
            'divider': false
        }
        ,
        {
            name: 'Korea, South',
            states: [
                'Ch\'ungch\'ong-bukto',
                'Ch\'ungch\'ong-namdo',
                'Cheju-do',
                'Cholla-bukto',
                'Cholla-namdo',
                'Inch\'on - gwangyoksi',
                'Kangwon-do',
                'Kwangju-gwangyoksi',
                'Kyonggi-do',
                'Kyongsang-bukto',
                'Kyongsang-namdo',
                'Pusan-gwangyoksi',
                'Soul-t\'ukpyolsi',
                'Taegu-gwangyoksi',
                'Taejon-gwangyoksi',
                'Ulsan-gwangyoksi'
            ],
            'divider': false
        }
        ,
        {
            name: 'Kuwait',
            states: [
                'Al \'Asimah',
                'Al Ahmadi',
                'Al Farwaniyah',
                'Al Jahra\'',
                'Hawalli'
            ],
            'divider': false
        }
        ,
        {
            name: 'Kyrgyzstan',
            states: [
                'Batken Oblasty',
                'Bishkek Shaary',
                'Chuy Oblasty (Bishkek)',
                'Jalal-Abad Oblasty',
                'Naryn Oblasty',
                'Osh Oblasty',
                'Talas Oblasty',
                'Ysyk-Kol Oblasty (Karakol)'
            ],
            'divider': false
        }
        ,
        {
            name: 'Laos',
            states: [
                'Attapu',
                'Bokeo',
                'Bolikhamxai',
                'Champasak',
                'Houaphan',
                'Khammouan',
                'Louangnamtha',
                'Louangphabang',
                'Oudomxai',
                'Phongsali',
                'Salavan',
                'Savannakhet',
                'Viangchan',
                'Viangchan',
                'Xaignabouli',
                'Xaisomboun',
                'Xekong',
                'Xiangkhoang'
            ],
            'divider': false
        },
        {
            name: 'Latvia',
            states: [
                'Aizkraukles Rajons',
                'Aluksnes Rajons',
                'Balvu Rajons',
                'Bauskas Rajons',
                'Cesu Rajons',
                'Daugavpils',
                'Daugavpils Rajons',
                'Dobeles Rajons',
                'Gulbenes Rajons',
                'Jekabpils Rajons',
                'Jelgava',
                'Jelgavas Rajons',
                'Jurmala',
                'Kraslavas Rajons',
                'Kuldigas Rajons',
                'Leipaja',
                'Liepajas Rajons',
                'Limbazu Rajons',
                'Ludzas Rajons',
                'Madonas Rajons',
                'Ogres Rajons',
                'Preilu Rajons',
                'Rezekne',
                'Rezeknes Rajons',
                'Riga',
                'Rigas Rajons',
                'Saldus Rajons',
                'Talsu Rajons',
                'Tukuma Rajons',
                'Valkas Rajons',
                'Valmieras Rajons',
                'Ventspils',
                'Ventspils Rajons'
            ],
            'divider': false
        },
        {
            name: 'Lebanon',
            states: [
                'Beyrouth',
                'Ech Chimal',
                'Ej Jnoub',
                'El Bekaa',
                'Jabal Loubnane'
            ],
            'divider': false
        },
        {
            name: 'Lesotho',
            states: [
                'Berea',
                'Butha-Buthe',
                'Leribe',
                'Mafeteng',
                'Maseru',
                'Mohales Hoek',
                'Mokhotlong',
                'Qacha\'s Nek',
                'Quthing',
                'Thaba-Tseka'
            ],
            'divider': false
        },
        {
            name: 'Liberia',
            states: [
                'Bomi',
                'Bong',
                'Grand Bassa',
                'Grand Cape Mount',
                'Grand Gedeh',
                'Grand Kru',
                'Lofa',
                'Margibi',
                'Maryland',
                'Montserrado',
                'Nimba',
                'River Cess',
                'Sinoe'
            ],
            'divider': false
        },
        {
            name: 'Libya',
            states: [
                'Ajdabiya',
                'Al \'Aziziyah',
                'Al Fatih',
                'Al Jabal al Akhdar',
                'Al Jufrah',
                'Al Khums',
                'Al Kufrah',
                'An Nuqat al Khams',
                'Ash Shati\'',
                'Awbari',
                'Az Zawiyah',
                'Banghazi',
                'Darnah',
                'Ghadamis',
                'Gharyan',
                'Misratah',
                'Murzuq',
                'Sabha',
                'Sawfajjin',
                'Surt',
                'Tarabulus',
                'Tarhunah',
                'Tubruq',
                'Yafran',
                'Zlitan'
            ],
            'divider': false
        }
        ,
        {
            name: 'Liechtenstein',
            states: [
                'Balzers',
                'Eschen',
                'Gamprin',
                'Mauren',
                'Planken',
                'Ruggell',
                'Schaan',
                'Schellenberg',
                'Triesen',
                'Triesenberg',
                'Vaduz'
            ],
            'divider': false
        }
        ,
        {
            name: 'Lithuania',
            states: [
                'Akmenes Rajonas',
                'Alytaus Rajonas',
                'Alytus',
                'Anyksciu Rajonas',
                'Birstonas',
                'Birzu Rajonas',
                'Druskininkai',
                'Ignalinos Rajonas',
                'Jonavos Rajonas',
                'Joniskio Rajonas',
                'Jurbarko Rajonas',
                'Kaisiadoriu Rajonas',
                'Kaunas',
                'Kauno Rajonas',
                'Kedainiu Rajonas',
                'Kelmes Rajonas',
                'Klaipeda',
                'Klaipedos Rajonas',
                'Kretingos Rajonas',
                'Kupiskio Rajonas',
                'Lazdiju Rajonas',
                'Marijampole',
                'Marijampoles Rajonas',
                'Mazeikiu Rajonas',
                'Moletu Rajonas',
                'Neringa Pakruojo Rajonas',
                'Palanga',
                'Panevezio Rajonas',
                'Panevezys',
                'Pasvalio Rajonas',
                'Plunges Rajonas',
                'Prienu Rajonas',
                'Radviliskio Rajonas',
                'Raseiniu Rajonas',
                'Rokiskio Rajonas',
                'Sakiu Rajonas',
                'Salcininku Rajonas',
                'Siauliai',
                'Siauliu Rajonas',
                'Silales Rajonas',
                'Silutes Rajonas',
                'Sirvintu Rajonas',
                'Skuodo Rajonas',
                'Svencioniu Rajonas',
                'Taurages Rajonas',
                'Telsiu Rajonas',
                'Traku Rajonas',
                'Ukmerges Rajonas',
                'Utenos Rajonas',
                'Varenos Rajonas',
                'Vilkaviskio Rajonas',
                'Vilniaus Rajonas',
                'Vilnius',
                'Zarasu Rajonas'
            ],
            'divider': false
        }
        ,
        {
            name: 'Luxembourg',
            states: [
                'Diekirch',
                'Grevenmacher',
                'Luxembourg'
            ],
            'divider': false
        }
        ,
        {
            name: 'Macau',
            states: [
                'Macau'
            ],
            'divider': false
        }
        ,
        {
            name: 'Macedonia, Former Yugoslav Republic of',
            states: [
                'Aracinovo',
                'Bac',
                'Belcista',
                'Berovo',
                'Bistrica',
                'Bitola',
                'Blatec',
                'Bogdanci',
                'Bogomila',
                'Bogovinje',
                'Bosilovo',
                'Brvenica',
                'Cair (Skopje)',
                'Capari',
                'Caska',
                'Cegrane',
                'Centar (Skopje)',
                'Centar Zupa',
                'Cesinovo',
                'Cucer-Sandevo',
                'Debar',
                'Delcevo',
                'Delogozdi',
                'Demir Hisar',
                'Demir Kapija',
                'Dobrusevo',
                'Dolna Banjica',
                'Dolneni',
                'Dorce Petrov (Skopje)',
                'Drugovo',
                'Dzepciste',
                'Gazi Baba (Skopje)',
                'Gevgelija',
                'Gostivar',
                'Gradsko',
                'Ilinden',
                'Izvor',
                'Jegunovce',
                'Kamenjane',
                'Karbinci',
                'Karpos (Skopje)',
                'Kavadarci',
                'Kicevo',
                'Kisela Voda (Skopje)',
                'Klecevce',
                'Kocani',
                'Konce',
                'Kondovo',
                'Konopiste',
                'Kosel',
                'Kratovo',
                'Kriva Palanka',
                'Krivogastani',
                'Krusevo',
                'Kuklis',
                'Kukurecani',
                'Kumanovo',
                'Labunista',
                'Lipkovo',
                'Lozovo',
                'Lukovo',
                'Makedonska Kamenica',
                'Makedonski Brod',
                'Mavrovi Anovi',
                'Meseista',
                'Miravci',
                'Mogila',
                'Murtino',
                'Negotino',
                'Negotino-Poloska',
                'Novaci',
                'Novo Selo',
                'Oblesevo',
                'Ohrid',
                'Orasac',
                'Orizari',
                'Oslomej',
                'Pehcevo',
                'Petrovec',
                'Plasnia',
                'Podares',
                'Prilep',
                'Probistip',
                'Radovis',
                'Rankovce',
                'Resen',
                'Rosoman',
                'Rostusa',
                'Samokov',
                'Saraj',
                'Sipkovica',
                'Sopiste',
                'Sopotnika',
                'Srbinovo',
                'Star Dojran',
                'Staravina',
                'Staro Nagoricane',
                'Stip',
                'Struga',
                'Strumica',
                'Studenicani',
                'Suto Orizari (Skopje)',
                'Sveti Nikole',
                'Tearce',
                'Tetovo',
                'Topolcani',
                'Valandovo',
                'Vasilevo',
                'Veles',
                'Velesta',
                'Vevcani',
                'Vinica',
                'Vitoliste',
                'Vranestica',
                'Vrapciste',
                'Vratnica',
                'Vrutok',
                'Zajas',
                'Zelenikovo',
                'Zileno',
                'Zitose',
                'Zletovo',
                'Zrnovci'
            ],
            'divider': false
        }
        ,
        {
            name: 'Madagascar',
            states: [
                'Antananarivo',
                'Antsiranana',
                'Fianarantsoa',
                'Mahajanga',
                'Toamasina',
                'Toliara'
            ],
            'divider': false
        }
        ,
        {
            name: 'Malawi',
            states: [
                'Balaka',
                'Blantyre',
                'Chikwawa',
                'Chiradzulu',
                'Chitipa',
                'Dedza',
                'Dowa',
                'Karonga',
                'Kasungu',
                'Likoma',
                'Lilongwe',
                'Machinga (Kasupe)',
                'Mangochi',
                'Mchinji',
                'Mulanje',
                'Mwanza',
                'Mzimba',
                'Nkhata Bay',
                'Nkhotakota',
                'Nsanje',
                'Ntcheu',
                'Ntchisi',
                'Phalombe',
                'Rumphi',
                'Salima',
                'Thyolo',
                'Zomba'
            ],
            'divider': false
        }
        ,
        {
            name: 'Malaysia',
            states: [
                'Johor',
                'Kedah',
                'Kelantan',
                'Labuan',
                'Melaka',
                'Negeri Sembilan',
                'Pahang',
                'Perak',
                'Perlis',
                'Pulau Pinang',
                'Sabah',
                'Sarawak',
                'Selangor',
                'Terengganu',
                'Wilayah Persekutuan'
            ],
            'divider': false
        }
        ,
        {
            name: 'Maldives',
            states: [
                'Alifu',
                'Baa',
                'Dhaalu',
                'Faafu',
                'Gaafu Alifu',
                'Gaafu Dhaalu',
                'Gnaviyani',
                'Haa Alifu',
                'Haa Dhaalu',
                'Kaafu',
                'Laamu',
                'Lhaviyani',
                'Maale',
                'Meemu',
                'Noonu',
                'Raa',
                'Seenu',
                'Shaviyani',
                'Thaa',
                'Vaavu'
            ],
            'divider': false
        }
        ,
        {
            name: 'Mali',
            states: [
                'Gao',
                'Kayes',
                'Kidal',
                'Koulikoro',
                'Mopti',
                'Segou',
                'Sikasso',
                'Tombouctou'
            ],
            'divider': false
        }
        ,
        {
            name: 'Malta',
            states: [
                'Valletta'
            ],
            'divider': false
        }
        ,
        {
            name: 'Man, Isle of',
            states: [
                'Man, Isle of'
            ],
            'divider': false
        }
        ,
        {
            name: 'Marshall Islands',
            states: [
                'Ailinginae',
                'Ailinglaplap',
                'Ailuk',
                'Arno',
                'Aur',
                'Bikar',
                'Bikini',
                'Bokak',
                'Ebon',
                'Enewetak',
                'Erikub',
                'Jabat',
                'Jaluit',
                'Jemo',
                'Kili',
                'Kwajalein',
                'Lae',
                'Lib',
                'Likiep',
                'Majuro',
                'Maloelap',
                'Mejit',
                'Mili',
                'Namorik',
                'Namu',
                'Rongelap',
                'Rongrik',
                'Toke',
                'Ujae',
                'Ujelang',
                'Utirik',
                'Wotho',
                'Wotje'
            ],
            'divider': false
        }
        ,
        {
            name: 'Martinique',
            states: [
                'Martinique'
            ],
            'divider': false
        }
        ,
        {
            name: 'Mauritania',
            states: [
                'Adrar',
                'Assaba',
                'Brakna',
                'Dakhlet Nouadhibou',
                'Gorgol',
                'Guidimaka',
                'Hodh Ech Chargui',
                'Hodh El Gharbi',
                'Inchiri',
                'Nouakchott',
                'Tagant',
                'Tiris Zemmour',
                'Trarza'
            ],
            'divider': false
        }
        ,
        {
            name: 'Mauritius',
            states: [
                'Agalega Islands',
                'Black River',
                'Cargados Carajos Shoals',
                'Flacq',
                'Grand Port',
                'Moka',
                'Pamplemousses',
                'Plaines Wilhems',
                'Port Louis',
                'Riviere du Rempart',
                'Rodrigues',
                'Savanne'
            ],
            'divider': false
        }
        ,
        {
            name: 'Mayotte',
            states: [
                'Mayotte'
            ],
            'divider': false
        }
        ,
        {
            name: 'Mexico',
            states: [
                'Aguascalientes',
                'Baja California',
                'Baja California Sur',
                'Campeche',
                'Chiapas',
                'Chihuahua',
                'Coahuila de Zaragoza',
                'Colima',
                'Distrito Federal',
                'Durango',
                'Guanajuato',
                'Guerrero',
                'Hidalgo',
                'Jalisco',
                'Mexico',
                'Michoacan de Ocampo',
                'Morelos',
                'Nayarit',
                'Nuevo Leon',
                'Oaxaca',
                'Puebla',
                'Queretaro de Arteaga',
                'Quintana Roo',
                'San Luis Potosi',
                'Sinaloa',
                'Sonora',
                'Tabasco',
                'Tamaulipas',
                'Tlaxcala',
                'Veracruz-Llave',
                'Yucatan',
                'Zacatecas'
            ],
            'divider': false
        }
        ,
        {
            name: 'Micronesia, Federated States of',
            states: [
                'Chuuk (Truk)',
                'Kosrae',
                'Pohnpei',
                'Yap'
            ],
            'divider': false
        }
        ,
        {
            name: 'Midway Islands',
            states: [
                'Midway Islands'
            ],
            'divider': false
        }
        ,
        {
            name: 'Moldova',
            states: [
                'Balti',
                'Cahul',
                'Chisinau',
                'Chisinau',
                'Dubasari',
                'Edinet',
                'Gagauzia',
                'Lapusna',
                'Orhei',
                'Soroca',
                'Tighina',
                'Ungheni'
            ],
            'divider': false
        }
        ,
        {
            name: 'Monaco',
            states: [
                'Fontvieille',
                'La Condamine',
                'Monaco-Ville',
                'Monte-Carlo'
            ],
            'divider': false
        }
        ,
        {
            name: 'Mongolia',
            states: [
                'Arhangay',
                'Bayan-Olgiy',
                'Bayanhongor',
                'Bulgan',
                'Darhan',
                'Dornod',
                'Dornogovi',
                'Dundgovi',
                'Dzavhan',
                'Erdenet',
                'Govi-Altay',
                'Hentiy',
                'Hovd',
                'Hovsgol',
                'Omnogovi',
                'Ovorhangay',
                'Selenge',
                'Suhbaatar',
                'Tov',
                'Ulaanbaatar',
                'Uvs'
            ],
            'divider': false
        }
        ,
        {
            name: 'Montserrat',
            states: [
                'Saint Anthony',
                'Saint Georges',
                'Saint Peter\'s'
            ],
            'divider': false
        }
        ,
        {
            name: 'Morocco',
            states: [
                'Agadir',
                'Al Hoceima',
                'Azilal',
                'Ben Slimane',
                'Beni Mellal',
                'Boulemane',
                'Casablanca',
                'Chaouen',
                'El Jadida',
                'El Kelaa des Srarhna',
                'Er Rachidia',
                'Essaouira',
                'Fes',
                'Figuig',
                'Guelmim',
                'Ifrane',
                'Kenitra',
                'Khemisset',
                'Khenifra',
                'Khouribga',
                'Laayoune',
                'Larache',
                'Marrakech',
                'Meknes',
                'Nador',
                'Ouarzazate',
                'Oujda',
                'Rabat-Sale',
                'Safi',
                'Settat',
                'Sidi Kacem',
                'Tan-Tan',
                'Tanger',
                'Taounate',
                'Taroudannt',
                'Tata',
                'Taza',
                'Tetouan',
                'Tiznit'
            ],
            'divider': false
        }
        ,
        {
            name: 'Mozambique',
            states: [
                'Cabo Delgado',
                'Gaza',
                'Inhambane',
                'Manica',
                'Maputo',
                'Nampula',
                'Niassa',
                'Sofala',
                'Tete',
                'Zambezia'
            ],
            'divider': false
        }
        ,
        {
            name: 'Namibia',
            states: [
                'Caprivi',
                'Erongo',
                'Hardap',
                'Karas',
                'Khomas',
                'Kunene',
                'Ohangwena',
                'Okavango',
                'Omaheke',
                'Omusati',
                'Oshana',
                'Oshikoto',
                'Otjozondjupa'
            ],
            'divider': false
        }
        ,
        {
            name: 'Nauru',
            states: [
                'Aiwo',
                'Anabar',
                'Anetan',
                'Anibare',
                'Baiti',
                'Boe',
                'Buada',
                'Denigomodu',
                'Ewa',
                'Ijuw',
                'Meneng',
                'Nibok',
                'Uaboe',
                'Yaren'
            ],
            'divider': false
        }
        ,
        {
            name: 'Nepal',
            states: [
                'Bagmati',
                'Bheri',
                'Dhawalagiri',
                'Gandaki',
                'Janakpur',
                'Karnali',
                'Kosi',
                'Lumbini',
                'Mahakali',
                'Mechi',
                'Narayani',
                'Rapti',
                'Sagarmatha',
                'Seti'
            ],
            'divider': false
        }
        ,
        {
            name: 'Netherlands',
            states: [
                'Drenthe',
                'Flevoland',
                'Friesland',
                'Gelderland',
                'Groningen',
                'Limburg',
                'Noord-Brabant',
                'Noord-Holland',
                'Overijssel',
                'Utrecht',
                'Zeeland',
                'Zuid-Holland'
            ],
            'divider': false
        }
        ,
        {
            name: 'Netherlands Antilles',
            states: [
                'Netherlands Antilles'
            ],
            'divider': false
        }
        ,
        {
            name: 'New Caledonia',
            states: [
                'Iles Loyaute',
                'Nord',
                'Sud'
            ],
            'divider': false
        }
        ,
        {
            name: 'New Zealand',
            states: [
                'Akaroa',
                'Amuri',
                'Ashburton',
                'Bay of Islands',
                'Bruce',
                'Buller',
                'Chatham Islands',
                'Cheviot',
                'Clifton',
                'Clutha',
                'Cook',
                'Dannevirke',
                'Egmont',
                'Eketahuna',
                'Ellesmere',
                'Eltham',
                'Eyre',
                'Featherston',
                'Franklin',
                'Golden Bay',
                'Great Barrier Island',
                'Grey',
                'Hauraki Plains',
                'Hawera',
                'Hawke\'s Bay',
                'Heathcote',
                'Hikurangi',
                'Hobson',
                'Hokianga',
                'Horowhenua',
                'Hurunui',
                'Hutt',
                'Inangahua',
                'Inglewood',
                'Kaikoura',
                'Kairanga',
                'Kiwitea',
                'Lake',
                'Mackenzie',
                'Malvern',
                'Manaia',
                'Manawatu',
                'Mangonui',
                'Maniototo',
                'Marlborough',
                'Masterton',
                'Matamata',
                'Mount Herbert',
                'Ohinemuri',
                'Opotiki',
                'Oroua',
                'Otamatea',
                'Otorohanga',
                'Oxford',
                'Pahiatua',
                'Paparua',
                'Patea',
                'Piako',
                'Pohangina',
                'Raglan',
                'Rangiora',
                'Rangitikei',
                'Rodney',
                'Rotorua',
                'Runanga',
                'Saint Kilda',
                'Silverpeaks',
                'Southland',
                'Stewart Island',
                'Stratford',
                'Strathallan',
                'Taranaki',
                'Taumarunui',
                'Taupo',
                'Tauranga',
                'Thames-Coromandel',
                'Tuapeka',
                'Vincent',
                'Waiapu',
                'Waiheke',
                'Waihemo',
                'Waikato',
                'Waikohu',
                'Waimairi',
                'Waimarino',
                'Waimate',
                'Waimate West',
                'Waimea',
                'Waipa',
                'Waipawa',
                'Waipukurau',
                'Wairarapa South',
                'Wairewa',
                'Wairoa',
                'Waitaki',
                'Waitomo',
                'Waitotara',
                'Wallace',
                'Wanganui',
                'Waverley',
                'Westland',
                'Whakatane',
                'Whangarei',
                'Whangaroa',
                'Woodville'
            ],
            'divider': false
        }
        ,
        {
            name: 'Nicaragua',
            states: [
                'Atlantico Norte',
                'Atlantico Sur',
                'Boaco',
                'Carazo',
                'Chinandega',
                'Chontales',
                'Esteli',
                'Granada',
                'Jinotega',
                'Leon',
                'Madriz',
                'Managua',
                'Masaya',
                'Matagalpa',
                'Nueva Segovia',
                'Rio San Juan',
                'Rivas'
            ],
            'divider': false
        }
        ,
        {
            name: 'Niger',
            states: [
                'Agadez',
                'Diffa',
                'Dosso',
                'Maradi',
                'Niamey',
                'Tahoua',
                'Tillaberi',
                'Zinder'
            ],
            'divider': false
        }
        ,
        {
            name: 'Nigeria',
            states: [
                'Abia',
                'Abuja Federal Capital Territory',
                'Adamawa',
                'Akwa Ibom',
                'Anambra',
                'Bauchi',
                'Bayelsa',
                'Benue',
                'Borno',
                'Cross River',
                'Delta',
                'Ebonyi',
                'Edo',
                'Ekiti',
                'Enugu',
                'Gombe',
                'Imo',
                'Jigawa',
                'Kaduna',
                'Kano',
                'Katsina',
                'Kebbi',
                'Kogi',
                'Kwara',
                'Lagos',
                'Nassarawa',
                'Niger',
                'Ogun',
                'Ondo',
                'Osun',
                'Oyo',
                'Plateau',
                'Rivers',
                'Sokoto',
                'Taraba',
                'Yobe',
                'Zamfara'
            ],
            'divider': false
        }
        ,
        {
            name: 'Niue',
            states: [
                'Niue'
            ],
            'divider': false
        }
        ,
        {
            name: 'Norfolk Island',
            states: [
                'Norfolk Island'
            ],
            'divider': false
        }
        ,
        {
            name: 'Northern Mariana Islands',
            states: [
                'Northern Islands',
                'Rota',
                'Saipan',
                'Tinian'
            ],
            'divider': false
        }
        ,
        {
            name: 'Norway',
            states: [
                'Akershus',
                'Aust-Agder',
                'Buskerud',
                'Finnmark',
                'Hedmark',
                'Hordaland',
                'More og Romsdal',
                'Nord-Trondelag',
                'Nordland',
                'Oppland',
                'Oslo',
                'Ostfold',
                'Rogaland',
                'Sogn og Fjordane',
                'Sor-Trondelag',
                'Telemark',
                'Troms',
                'Vest-Agder',
                'Vestfold'
            ],
            'divider': false
        }
        ,
        {
            name: 'Oman',
            states: [
                'Ad Dakhiliyah',
                'Al Batinah',
                'Al Wusta',
                'Ash Sharqiyah',
                'Az Zahirah',
                'Masqat',
                'Musandam',
                'Zufar'
            ],
            'divider': false
        }
        ,
        {
            name: 'Pakistan',
            states: [
                'Balochistan',
                'Federally Administered Tribal Areas',
                'Islamabad Capital Territory',
                'North-West Frontier Province',
                'Punjab',
                'Sindh'
            ],
            'divider': false
        }
        ,
        {
            name: 'Palau',
            states: [
                'Aimeliik',
                'Airai',
                'Angaur',
                'Hatobohei',
                'Kayangel',
                'Koror',
                'Melekeok',
                'Ngaraard',
                'Ngarchelong',
                'Ngardmau',
                'Ngatpang',
                'Ngchesar',
                'Ngeremlengui',
                'Ngiwal',
                'Palau Island',
                'Peleliu',
                'Sonsoral',
                'Tobi'
            ],
            'divider': false
        }
        ,
        {
            name: 'Panama',
            states: [
                'Bocas del Toro',
                'Chiriqui',
                'Cocle',
                'Colon',
                'Darien',
                'Herrera',
                'Los Santos',
                'Panama',
                'San Blas',
                'Veraguas'
            ],
            'divider': false
        }
        ,
        {
            name: 'Papua New Guinea',
            states: [
                'Bougainville',
                'Central',
                'Chimbu',
                'East New Britain',
                'East Sepik',
                'Eastern Highlands',
                'Enga',
                'Gulf',
                'Madang',
                'Manus',
                'Milne Bay',
                'Morobe',
                'National Capital',
                'New Ireland',
                'Northern',
                'Sandaun',
                'Southern Highlands',
                'West New Britain',
                'Western',
                'Western Highlands'
            ],
            'divider': false
        }
        ,
        {
            name: 'Paraguay',
            states: [
                'Alto Paraguay',
                'Alto Parana',
                'Amambay',
                'Asuncion (city)',
                'Boqueron',
                'Caaguazu',
                'Caazapa',
                'Canindeyu',
                'Central',
                'Concepcion',
                'Cordillera',
                'Guaira',
                'Itapua',
                'Misiones',
                'Neembucu',
                'Paraguari',
                'Presidente Hayes',
                'San Pedro'
            ],
            'divider': false
        }
        ,
        {
            name: 'Peru',
            states: [
                'Amazonas',
                'Ancash',
                'Apurimac',
                'Arequipa',
                'Ayacucho',
                'Cajamarca',
                'Callao',
                'Cusco',
                'Huancavelica',
                'Huanuco',
                'Ica',
                'Junin',
                'La Libertad',
                'Lambayeque',
                'Lima',
                'Loreto',
                'Madre de Dios',
                'Moquegua',
                'Pasco',
                'Piura',
                'Puno',
                'San Martin',
                'Tacna',
                'Tumbes',
                'Ucayali'
            ],
            'divider': false
        }
        ,
        {
            name: 'Philippines',
            states: [
                'Abra',
                'Agusan del Norte',
                'Agusan del Sur',
                'Aklan',
                'Albay',
                'Angeles',
                'Antique',
                'Aurora',
                'Bacolod',
                'Bago',
                'Baguio',
                'Bais',
                'Basilan',
                'Basilan City',
                'Bataan',
                'Batanes',
                'Batangas',
                'Batangas City',
                'Benguet',
                'Bohol',
                'Bukidnon',
                'Bulacan',
                'Butuan',
                'Cabanatuan',
                'Cadiz',
                'Cagayan',
                'Cagayan de Oro',
                'Calbayog',
                'Caloocan',
                'Camarines Norte',
                'Camarines Sur',
                'Camiguin',
                'Canlaon',
                'Capiz',
                'Catanduanes',
                'Cavite',
                'Cavite City',
                'Cebu',
                'Cebu City',
                'Cotabato',
                'Dagupan',
                'Danao',
                'Dapitan',
                'Davao City Davao',
                'Davao del Sur',
                'Davao Oriental',
                'Dipolog',
                'Dumaguete',
                'Eastern Samar',
                'General Santos',
                'Gingoog',
                'Ifugao',
                'Iligan',
                'Ilocos Norte',
                'Ilocos Sur',
                'Iloilo',
                'Iloilo City',
                'Iriga',
                'Isabela',
                'Kalinga-Apayao',
                'La Carlota',
                'La Union',
                'Laguna',
                'Lanao del Norte',
                'Lanao del Sur',
                'Laoag',
                'Lapu-Lapu',
                'Legaspi',
                'Leyte',
                'Lipa',
                'Lucena',
                'Maguindanao',
                'Mandaue',
                'Manila',
                'Marawi',
                'Marinduque',
                'Masbate',
                'Mindoro Occidental',
                'Mindoro Oriental',
                'Misamis Occidental',
                'Misamis Oriental',
                'Mountain',
                'Naga',
                'Negros Occidental',
                'Negros Oriental',
                'North Cotabato',
                'Northern Samar',
                'Nueva Ecija',
                'Nueva Vizcaya',
                'Olongapo',
                'Ormoc',
                'Oroquieta',
                'Ozamis',
                'Pagadian',
                'Palawan',
                'Palayan',
                'Pampanga',
                'Pangasinan',
                'Pasay',
                'Puerto Princesa',
                'Quezon',
                'Quezon City',
                'Quirino',
                'Rizal',
                'Romblon',
                'Roxas',
                'Samar',
                'San Carlos (in Negros Occidental)',
                'San Carlos (in Pangasinan)',
                'San Jose',
                'San Pablo',
                'Silay',
                'Siquijor',
                'Sorsogon',
                'South Cotabato',
                'Southern Leyte',
                'Sultan Kudarat',
                'Sulu',
                'Surigao',
                'Surigao del Norte',
                'Surigao del Sur',
                'Tacloban',
                'Tagaytay',
                'Tagbilaran',
                'Tangub',
                'Tarlac',
                'Tawitawi',
                'Toledo',
                'Trece Martires',
                'Zambales',
                'Zamboanga',
                'Zamboanga del Norte',
                'Zamboanga del Sur'
            ],
            'divider': false
        }
        ,
        {
            name: 'Pitcaim Islands',
            states: [
                'Pitcaim Islands'
            ],
            'divider': false
        }
        ,
        {
            name: 'Poland',
            states: [
                'Dolnoslaskie',
                'Kujawsko-Pomorskie',
                'Lodzkie',
                'Lubelskie',
                'Lubuskie',
                'Malopolskie',
                'Mazowieckie',
                'Opolskie',
                'Podkarpackie',
                'Podlaskie',
                'Pomorskie',
                'Slaskie',
                'Swietokrzyskie',
                'Warminsko-Mazurskie',
                'Wielkopolskie',
                'Zachodniopomorskie'
            ],
            'divider': false
        }
        ,
        {
            name: 'Portugal',
            states: [
                'Acores (Azores)',
                'Aveiro',
                'Beja',
                'Braga',
                'Braganca',
                'Castelo Branco',
                'Coimbra',
                'Evora',
                'Faro',
                'Guarda',
                'Leiria',
                'Lisboa',
                'Madeira',
                'Portalegre',
                'Porto',
                'Santarem',
                'Setubal',
                'Viana do Castelo',
                'Vila Real',
                'Viseu'
            ],
            'divider': false
        }
        ,
        {
            name: 'Puerto Rico',
            states: [
                'Adjuntas',
                'Aguada',
                'Aguadilla',
                'Aguas Buenas',
                'Aibonito',
                'Anasco',
                'Arecibo',
                'Arroyo',
                'Barceloneta',
                'Barranquitas',
                'Bayamon',
                'Cabo Rojo',
                'Caguas',
                'Camuy',
                'Canovanas',
                'Carolina',
                'Catano',
                'Cayey',
                'Ceiba',
                'Ciales',
                'Cidra',
                'Coamo',
                'Comerio',
                'Corozal',
                'Culebra',
                'Dorado',
                'Fajardo',
                'Florida',
                'Guanica',
                'Guayama',
                'Guayanilla',
                'Guaynabo',
                'Gurabo',
                'Hatillo',
                'Hormigueros',
                'Humacao',
                'Isabela',
                'Jayuya',
                'Juana Diaz',
                'Juncos',
                'Lajas',
                'Lares',
                'Las Marias',
                'Las Piedras',
                'Loiza',
                'Luquillo',
                'Manati',
                'Maricao',
                'Maunabo',
                'Mayaguez',
                'Moca',
                'Morovis',
                'Naguabo',
                'Naranjito',
                'Orocovis',
                'Patillas',
                'Penuelas',
                'Ponce',
                'Quebradillas',
                'Rincon',
                'Rio Grande',
                'Sabana Grande',
                'Salinas',
                'San German',
                'San Juan',
                'San Lorenzo',
                'San Sebastian',
                'Santa Isabel',
                'Toa Alta',
                'Toa Baja',
                'Trujillo Alto',
                'Utuado',
                'Vega Alta',
                'Vega Baja',
                'Vieques',
                'Villalba',
                'Yabucoa',
                'Yauco'
            ],
            'divider': false
        }
        ,
        {
            name: 'Qatar',
            states: [
                'Ad Dawhah',
                'Al Ghuwayriyah',
                'Al Jumayliyah',
                'Al Khawr',
                'Al Wakrah',
                'Ar Rayyan',
                'Jarayan al Batinah',
                'Madinat ash Shamal',
                'Umm Salal'
            ],
            'divider': false
        }
        ,
        {
            name: 'Reunion',
            states: [
                'Reunion'
            ],
            'divider': false
        }
        ,
        {
            name: 'Romainia',
            states: [
                'Alba',
                'Arad',
                'Arges',
                'Bacau',
                'Bihor',
                'Bistrita-Nasaud',
                'Botosani',
                'Braila',
                'Brasov',
                'Bucuresti',
                'Buzau',
                'Calarasi',
                'Caras-Severin',
                'Cluj',
                'Constanta',
                'Covasna',
                'Dimbovita',
                'Dolj',
                'Galati',
                'Giurgiu',
                'Gorj',
                'Harghita',
                'Hunedoara',
                'Ialomita',
                'Iasi',
                'Maramures',
                'Mehedinti',
                'Mures',
                'Neamt',
                'Olt',
                'Prahova',
                'Salaj',
                'Satu Mare',
                'Sibiu',
                'Suceava',
                'Teleorman',
                'Timis',
                'Tulcea',
                'Vaslui',
                'Vilcea',
                'Vrancea'
            ],
            'divider': false
        }
        ,
        {
            name: 'Russia',
            states: [
                'Adygeya (Maykop)',
                'Aginskiy Buryatskiy (Aginskoye)',
                'Altay (Gorno-Altaysk)',
                'Altayskiy (Barnaul)',
                'Amurskaya (Blagoveshchensk)',
                'Arkhangel\'skaya',
                'Astrakhanskaya',
                'Bashkortostan (Ufa)',
                'Belgorodskaya',
                'Bryanskaya',
                'Buryatiya (Ulan-Ude)',
                'Chechnya (Groznyy)',
                'Chelyabinskaya',
                'Chitinskaya',
                'Chukotskiy (Anadyr\')',
                'Chuvashiya (Cheboksary)',
                'Dagestan (Makhachkala)',
                'Evenkiyskiy (Tura)',
                'Ingushetiya (Nazran\')',
                'Irkutskaya',
                'Ivanovskaya',
                'Kabardino-Balkariya (Nal\'chik)',
                'Kaliningradskaya',
                'Kalmykiya (Elista)',
                'Kaluzhskaya',
                'Kamchatskaya (Petropavlovsk-Kamchatskiy)',
                'Karachayevo-Cherkesiya (Cherkessk)',
                'Kareliya (Petrozavodsk)',
                'Kemerovskaya',
                'Khabarovskiy',
                'Khakasiya (Abakan)',
                'Khanty-Mansiyskiy (Khanty-Mansiysk)',
                'Kirovskaya',
                'Komi (Syktyvkar)',
                'Komi-Permyatskiy (Kudymkar)',
                'Koryakskiy (Palana)',
                'Kostromskaya',
                'Krasnodarskiy',
                'Krasnoyarskiy',
                'Kurganskaya',
                'Kurskaya',
                'Leningradskaya',
                'Lipetskaya',
                'Magadanskaya',
                'Mariy-El (Yoshkar-Ola)',
                'Mordoviya (Saransk)',
                'Moskovskaya',
                'Moskva (Moscow)',
                'Murmanskaya',
                'Nenetskiy (Nar\'yan - Mar)',
                'Nizhegorodskaya',
                'Novgorodskaya',
                'Novosibirskaya',
                'Omskaya',
                'Orenburgskaya',
                'Orlovskaya (Orel)',
                'Penzenskaya',
                'Permskaya',
                'Primorskiy (Vladivostok)',
                'Pskovskaya',
                'Rostovskaya',
                'Ryazanskaya',
                'Sakha (Yakutsk)',
                'Sakhalinskaya (Yuzhno-Sakhalinsk)',
                'Samarskaya',
                'Sankt-Peterburg (Saint Petersburg)',
                'Saratovskaya',
                'Severnaya Osetiya-Alaniya [North Ossetia] (Vladikavkaz)',
                'Smolenskaya',
                'Stavropol\'skiy',
                'Sverdlovskaya (Yekaterinburg)',
                'Tambovskaya',
                'Tatarstan (Kazan\')',
                'Taymyrskiy (Dudinka)',
                'Tomskaya',
                'Tul\'skaya',
                'Tverskaya',
                'Tyumenskaya',
                'Tyva (Kyzyl)',
                'Udmurtiya (Izhevsk)',
                'Ul\'yanovskaya',
                'Ust\' - Ordynskiy Buryatskiy(Ust\' - Ordynskiy)',
                'Vladimirskaya',
                'Volgogradskaya',
                'Vologodskaya',
                'Voronezhskaya',
                'Yamalo-Nenetskiy (Salekhard)',
                'Yaroslavskaya',
                'Yevreyskaya'
            ],
            'divider': false
        },
        {
            name: 'Rwanda',
            states: [
                'Butare',
                'Byumba',
                'Cyangugu',
                'Gikongoro',
                'Gisenyi',
                'Gitarama',
                'Kibungo',
                'Kibuye',
                'Kigali Rurale',
                'Kigali-ville',
                'Ruhengeri',
                'Umutara'
            ],
            'divider': false
        }
        ,
        {
            name: 'Saint Helena',
            states: [
                'Ascension',
                'Saint Helena',
                'Tristan da Cunha'
            ],
            'divider': false
        }
        ,
        {
            name: 'Saint Kitts and Nevis',
            states: [
                'Christ Church Nichola Town',
                'Saint Anne Sandy Point',
                'Saint George Basseterre',
                'Saint George Gingerland',
                'Saint James Windward',
                'Saint John Capisterre',
                'Saint John Figtree',
                'Saint Mary Cayon',
                'Saint Paul Capisterre',
                'Saint Paul Charlestown',
                'Saint Peter Basseterre',
                'Saint Thomas Lowland',
                'Saint Thomas Middle Island',
                'Trinity Palmetto Point'
            ],
            'divider': false
        }
        ,
        {
            name: 'Saint Lucia',
            states: [
                'Anse-la-Raye',
                'Castries',
                'Choiseul',
                'Dauphin',
                'Dennery',
                'Gros Islet',
                'Laborie',
                'Micoud',
                'Praslin',
                'Soufriere',
                'Vieux Fort'
            ],
            'divider': false
        }
        ,
        {
            name: 'Saint Pierre and Miquelon',
            states: [
                'Miquelon',
                'Saint Pierre'
            ],
            'divider': false
        }
        ,
        {
            name: 'Saint Vincent and the Grenadines',
            states: [
                'Charlotte',
                'Grenadines',
                'Saint Andrew',
                'Saint David',
                'Saint George',
                'Saint Patrick'
            ],
            'divider': false
        }
        ,
        {
            name: 'Samoa',
            states: [
                'A\'ana',
                'Aiga-i-le-Tai',
                'Atua',
                'Fa\'asaleleaga',
                'Gaga\'emauga',
                'Gagaifomauga',
                'Palauli',
                'Satupa\'itea',
                'Tuamasaga',
                'Va\'a - o - Fonoti',
                'Vaisigano'
            ],
            'divider': false
        }
        ,
        {
            name: 'San Marino',
            states: [
                'Acquaviva',
                'Borgo Maggiore',
                'Chiesanuova',
                'Domagnano',
                'Faetano',
                'Fiorentino',
                'Monte Giardino',
                'San Marino',
                'Serravalle'
            ],
            'divider': false
        }
        ,
        {
            name: 'Sao Tome and Principe',
            states: [
                'Principe',
                'Sao Tome'
            ],
            'divider': false
        }
        ,
        {
            name: 'Saudi Arabia',
            states: [
                '\'Asir',
                'Al Bahah',
                'Al Hudud ash Shamaliyah',
                'Al Jawf',
                'Al Madinah',
                'Al Qasim',
                'Ar Riyad',
                'Ash Sharqiyah (Eastern Province)',
                'Ha\'il',
                'Jizan',
                'Makkah',
                'Najran',
                'Tabuk'
            ],
            'divider': false
        }
        ,
        {
            name: 'Scotland',
            states: [
                'Aberdeen City',
                'Aberdeenshire',
                'Angus',
                'Argyll and Bute',
                'City of Edinburgh',
                'Clackmannanshire',
                'Dumfries and Galloway',
                'Dundee City',
                'East Ayrshire',
                'East Dunbartonshire',
                'East Lothian',
                'East Renfrewshire',
                'Eilean Siar (Western Isles)',
                'Falkirk',
                'Fife',
                'Glasgow City',
                'Highland',
                'Inverclyde',
                'Midlothian',
                'Moray',
                'North Ayrshire',
                'North Lanarkshire',
                'Orkney Islands',
                'Perth and Kinross',
                'Renfrewshire',
                'Shetland Islands',
                'South Ayrshire',
                'South Lanarkshire',
                'Stirling',
                'The Scottish Borders',
                'West Dunbartonshire',
                'West Lothian'
            ],
            'divider': false
        }
        ,
        {
            name: 'Senegal',
            states: [
                'Dakar',
                'Diourbel',
                'Fatick',
                'Kaolack',
                'Kolda',
                'Louga',
                'Saint-Louis',
                'Tambacounda',
                'Thies',
                'Ziguinchor'
            ],
            'divider': false
        }
        ,
        {
            name: 'Seychelles',
            states: [
                'Anse aux Pins',
                'Anse Boileau',
                'Anse Etoile',
                'Anse Louis',
                'Anse Royale',
                'Baie Lazare',
                'Baie Sainte Anne',
                'Beau Vallon',
                'Bel Air',
                'Bel Ombre',
                'Cascade',
                'Glacis',
                'Grand\' Anse(on Mahe)',
                'Grand\'Anse',
                'La Digue',
                'La Riviere Anglaise',
                'Mont Buxton',
                'Mont Fleuri',
                'Plaisance',
                'Pointe La Rue',
                'Port Glaud',
                'Saint Louis',
                'Takamaka'
            ],
            'divider': false
        }
        ,
        {
            name: 'Sierra Leone',
            states: [
                'Eastern',
                'Northern',
                'Southern',
                'Western'
            ],
            'divider': false
        }
        ,
        {
            name: 'Singapore',
            states: [
                'Singapore'
            ],
            'divider': false
        }
        ,
        {
            name: 'Slovakia',
            states: [
                'Banskobystricky',
                'Bratislavsky',
                'Kosicky',
                'Nitriansky',
                'Presovsky',
                'Trenciansky',
                'Trnavsky',
                'Zilinsky'
            ],
            'divider': false
        }
        ,
        {
            name: 'Slovenia',
            states: [
                'Ajdovscina',
                'Beltinci',
                'Bled',
                'Bohinj',
                'Borovnica',
                'Bovec',
                'Brda',
                'Brezice',
                'Brezovica',
                'Cankova-Tisina',
                'Celje',
                'Cerklje na Gorenjskem',
                'Cerknica',
                'Cerkno',
                'Crensovci',
                'Crna na Koroskem',
                'Crnomelj',
                'Destrnik-Trnovska Vas',
                'Divaca',
                'Dobrepolje',
                'Dobrova-Horjul-Polhov Gradec',
                'Dol pri Ljubljani',
                'Domzale',
                'Dornava',
                'Dravograd',
                'Duplek',
                'Gorenja Vas-Poljane',
                'Gorisnica',
                'Gornja Radgona',
                'Gornji Grad',
                'Gornji Petrovci',
                'Grosuplje',
                'Hodos Salovci',
                'Hrastnik',
                'Hrpelje-Kozina',
                'Idrija',
                'Ig',
                'Ilirska Bistrica',
                'Ivancna Gorica',
                'Izola',
                'Jesenice',
                'Jursinci',
                'Kamnik',
                'Kanal',
                'Kidricevo',
                'Kobarid',
                'Kobilje',
                'Kocevje',
                'Komen',
                'Koper',
                'Kozje',
                'Kranj',
                'Kranjska Gora',
                'Krsko',
                'Kungota',
                'Kuzma',
                'Lasko',
                'Lenart',
                'Lendava',
                'Litija',
                'Ljubljana',
                'Ljubno',
                'Ljutomer',
                'Logatec',
                'Loska Dolina',
                'Loski Potok',
                'Luce',
                'Lukovica',
                'Majsperk',
                'Maribor',
                'Medvode',
                'Menges',
                'Metlika',
                'Mezica',
                'Miren-Kostanjevica',
                'Mislinja',
                'Moravce',
                'Moravske Toplice',
                'Mozirje',
                'Murska Sobota',
                'Muta',
                'Naklo',
                'Nazarje',
                'Nova Gorica',
                'Novo Mesto',
                'Odranci',
                'Ormoz',
                'Osilnica',
                'Pesnica',
                'Piran',
                'Pivka',
                'Podcetrtek',
                'Podvelka-Ribnica',
                'Postojna',
                'Preddvor',
                'Ptuj',
                'Puconci',
                'Race-Fram',
                'Radece',
                'Radenci',
                'Radlje ob Dravi',
                'Radovljica',
                'Ravne-Prevalje',
                'Ribnica',
                'Rogasevci',
                'Rogaska Slatina',
                'Rogatec',
                'Ruse',
                'Semic',
                'Sencur',
                'Sentilj',
                'Sentjernej',
                'Sentjur pri Celju',
                'Sevnica',
                'Sezana',
                'Skocjan',
                'Skofja Loka',
                'Skofljica',
                'Slovenj Gradec',
                'Slovenska Bistrica',
                'Slovenske Konjice',
                'Smarje pri Jelsah',
                'Smartno ob Paki',
                'Sostanj',
                'Starse',
                'Store',
                'Sveti Jurij',
                'Tolmin',
                'Trbovlje',
                'Trebnje',
                'Trzic',
                'Turnisce',
                'Velenje',
                'Velike Lasce',
                'Videm',
                'Vipava',
                'Vitanje',
                'Vodice',
                'Vojnik',
                'Vrhnika',
                'Vuzenica',
                'Zagorje ob Savi',
                'Zalec',
                'Zavrc',
                'Zelezniki',
                'Ziri',
                'Zrece'
            ],
            'divider': false
        }
        ,
        {
            name: 'Solomon Islands',
            states: [
                'Bellona',
                'Central',
                'Choiseul (Lauru)',
                'Guadalcanal',
                'Honiara',
                'Isabel',
                'Makira',
                'Malaita',
                'Rennell',
                'Temotu',
                'Western'
            ],
            'divider': false
        }
        ,
        {
            name: 'Somalia',
            states: [
                'Awdal',
                'Bakool',
                'Banaadir',
                'Bari',
                'Bay',
                'Galguduud',
                'Gedo',
                'Hiiraan',
                'Jubbada Dhexe',
                'Jubbada Hoose',
                'Mudug',
                'Nugaal',
                'Sanaag',
                'Shabeellaha Dhexe',
                'Shabeellaha Hoose',
                'Sool',
                'Togdheer',
                'Woqooyi Galbeed'
            ],
            'divider': false
        }
        ,
        {
            name: 'South Africa',
            states: [
                'Eastern Cape',
                'Free State',
                'Gauteng',
                'KwaZulu-Natal',
                'Mpumalanga',
                'North-West',
                'Northern Cape',
                'Northern Province',
                'Western Cape'
            ],
            'divider': false
        }
        ,
        {
            name: 'South Georgia and South Sandwich Islands',
            states: [
                'Bird Island',
                'Bristol Island',
                'Clerke Rocks',
                'Montagu Island',
                'Saunders Island',
                'South Georgia',
                'Southern Thule',
                'Traversay Islands'
            ],
            'divider': false
        }
        ,
        {
            name: 'Spratly Islands',
            states: [
                'Spratly Islands'
            ],
            'divider': false
        }
        ,
        {
            name: 'Sri Lanka',
            states: [
                'Central',
                'Eastern',
                'North Central',
                'North Eastern',
                'North Western',
                'Northern',
                'Sabaragamuwa',
                'Southern',
                'Uva',
                'Western'
            ],
            'divider': false
        }
        ,
        {
            name: 'Sudan',
            states: [
                'A\'ali an Nil',
                'Al Bahr al Ahmar',
                'Al Buhayrat',
                'Al Jazirah',
                'Al Khartum',
                'Al Qadarif',
                'Al Wahdah',
                'An Nil al Abyad',
                'An Nil al Azraq',
                'Ash Shamaliyah',
                'Bahr al Jabal',
                'Gharb al Istiwa\'iyah',
                'Gharb Bahr al Ghazal',
                'Gharb Darfur',
                'Gharb Kurdufan',
                'Janub Darfur',
                'Janub Kurdufan',
                'Junqali',
                'Kassala',
                'Nahr an Nil',
                'Shamal Bahr al Ghazal',
                'Shamal Darfur',
                'Shamal Kurdufan',
                'Sharq al Istiwa\'iyah',
                'Sinnar',
                'Warab'
            ],
            'divider': false
        }
        ,
        {
            name: 'Suriname',
            states: [
                'Brokopondo',
                'Commewijne',
                'Coronie',
                'Marowijne',
                'Nickerie',
                'Para',
                'Paramaribo',
                'Saramacca',
                'Sipaliwini',
                'Wanica'
            ],
            'divider': false
        }
        ,
        {
            name: 'Svalbard',
            states: [
                'Barentsoya',
                'Bjornoya',
                'Edgeoya',
                'Hopen',
                'Kvitoya',
                'Nordaustandet',
                'Prins Karls Forland',
                'Spitsbergen'
            ],
            'divider': false
        }
        ,
        {
            name: 'Swaziland',
            states: [
                'Hhohho',
                'Lubombo',
                'Manzini',
                'Shiselweni'
            ],
            'divider': false
        }
        ,
        {
            name: 'Sweden',
            states: [
                'Blekinge',
                'Dalarnas',
                'Gavleborgs',
                'Gotlands',
                'Hallands',
                'Jamtlands',
                'Jonkopings',
                'Kalmar',
                'Kronobergs',
                'Norrbottens',
                'Orebro',
                'Ostergotlands',
                'Skane',
                'Sodermanlands',
                'Stockholms',
                'Uppsala',
                'Varmlands',
                'Vasterbottens',
                'Vasternorrlands',
                'Vastmanlands',
                'Vastra Gotalands'
            ],
            'divider': false
        }
        ,
        {
            name: 'Switzerland',
            states: [
                'Aargau',
                'Ausser-Rhoden',
                'Basel-Landschaft',
                'Basel-Stadt',
                'Bern',
                'Fribourg',
                'Geneve',
                'Glarus',
                'Graubunden',
                'Inner-Rhoden',
                'Jura',
                'Luzern',
                'Neuchatel',
                'Nidwalden',
                'Obwalden',
                'Sankt Gallen',
                'Schaffhausen',
                'Schwyz',
                'Solothurn',
                'Thurgau',
                'Ticino',
                'Uri',
                'Valais',
                'Vaud',
                'Zug',
                'Zurich'
            ],
            'divider': false
        }
        ,
        {
            name: 'Syria',
            states: [
                'Al Hasakah',
                'Al Ladhiqiyah',
                'Al Qunaytirah',
                'Ar Raqqah',
                'As Suwayda\'',
                'Dar\'a',
                'Dayr az Zawr',
                'Dimashq',
                'Halab',
                'Hamah',
                'Hims',
                'Idlib',
                'Rif Dimashq',
                'Tartus'
            ],
            'divider': false
        }
        ,
        {
            name: 'Taiwan',
            states: [
                'Chang-hua',
                'Chi-lung',
                'Chia-i',
                'Chia-i',
                'Chung-hsing-hsin-ts\'un',
                'Hsin-chu',
                'Hsin-chu',
                'Hua-lien',
                'I-lan',
                'Kao-hsiung',
                'Kao-hsiung',
                'Miao-li',
                'Nan-t\'ou',
                'P\'eng - hu',
                'P\'ing - tung',
                'T\'ai - chung',
                'T\'ai - chung',
                'T\'ai - nan',
                'T\'ai - nan',
                'T\'ai - pei',
                'T\'ai - pei',
                'T\'ai - tung',
                'T\'ao - yuan',
                'Yun-lin'
            ],
            'divider': false
        }
        ,
        {
            name: 'Tajikistan',
            states: [
                'Viloyati Khatlon',
                'Viloyati Leninobod',
                'Viloyati Mukhtori Kuhistoni Badakhshon'
            ],
            'divider': false
        }
        ,
        {
            name: 'Tanzania',
            states: [
                'Arusha',
                'Dar es Salaam',
                'Dodoma',
                'Iringa',
                'Kagera',
                'Kigoma',
                'Kilimanjaro',
                'Lindi',
                'Mara',
                'Mbeya',
                'Morogoro',
                'Mtwara',
                'Mwanza',
                'Pemba North',
                'Pemba South',
                'Pwani',
                'Rukwa',
                'Ruvuma',
                'Shinyanga',
                'Singida',
                'Tabora',
                'Tanga',
                'Zanzibar Central/South',
                'Zanzibar North',
                'Zanzibar Urban/West'
            ],
            'divider': false
        }
        ,
        {
            name: 'Thailand',
            states: [
                'Amnat Charoen',
                'Ang Thong',
                'Buriram',
                'Chachoengsao',
                'Chai Nat',
                'Chaiyaphum',
                'Chanthaburi',
                'Chiang Mai',
                'Chiang Rai',
                'Chon Buri',
                'Chumphon',
                'Kalasin',
                'Kamphaeng Phet',
                'Kanchanaburi',
                'Khon Kaen',
                'Krabi',
                'Krung Thep Mahanakhon (Bangkok)',
                'Lampang',
                'Lamphun',
                'Loei',
                'Lop Buri',
                'Mae Hong Son',
                'Maha Sarakham',
                'Mukdahan',
                'Nakhon Nayok',
                'Nakhon Pathom',
                'Nakhon Phanom',
                'Nakhon Ratchasima',
                'Nakhon Sawan',
                'Nakhon Si Thammarat',
                'Nan',
                'Narathiwat',
                'Nong Bua Lamphu',
                'Nong Khai',
                'Nonthaburi',
                'Pathum Thani',
                'Pattani',
                'Phangnga',
                'Phatthalung',
                'Phayao',
                'Phetchabun',
                'Phetchaburi',
                'Phichit',
                'Phitsanulok',
                'Phra Nakhon Si Ayutthaya',
                'Phrae',
                'Phuket',
                'Prachin Buri',
                'Prachuap Khiri Khan',
                'Ranong',
                'Ratchaburi',
                'Rayong',
                'Roi Et',
                'Sa Kaeo',
                'Sakon Nakhon',
                'Samut Prakan',
                'Samut Sakhon',
                'Samut Songkhram',
                'Sara Buri',
                'Satun',
                'Sing Buri',
                'Sisaket',
                'Songkhla',
                'Sukhothai',
                'Suphan Buri',
                'Surat Thani',
                'Surin',
                'Tak',
                'Trang',
                'Trat',
                'Ubon Ratchathani',
                'Udon Thani',
                'Uthai Thani',
                'Uttaradit',
                'Yala',
                'Yasothon'
            ],
            'divider': false
        }
        ,
        {
            name: 'Tobago',
            states: [
                'Tobago'
            ],
            'divider': false
        }
        ,
        {
            name: 'Toga',
            states: [
                'De La Kara',
                'Des Plateaux',
                'Des Savanes',
                'Du Centre',
                'Maritime'
            ],
            'divider': false
        }
        ,
        {
            name: 'Tokelau',
            states: [
                'Atafu',
                'Fakaofo',
                'Nukunonu'
            ],
            'divider': false
        }
        ,
        {
            name: 'Tonga',
            states: [
                'Ha\'apai',
                'Tongatapu',
                'Vava\'u'
            ],
            'divider': false
        }
        ,
        {
            name: 'Trinidad',
            states: [
                'Arima',
                'Caroni',
                'Mayaro',
                'Nariva',
                'Port-of-Spain',
                'Saint Andrew',
                'Saint David',
                'Saint George',
                'Saint Patrick',
                'San Fernando',
                'Victoria'
            ],
            'divider': false
        }
        ,
        {
            name: 'Tunisia',
            states: [
                'Ariana',
                'Beja',
                'Ben Arous',
                'Bizerte',
                'El Kef',
                'Gabes',
                'Gafsa',
                'Jendouba',
                'Kairouan',
                'Kasserine',
                'Kebili',
                'Mahdia',
                'Medenine',
                'Monastir',
                'Nabeul',
                'Sfax',
                'Sidi Bou Zid',
                'Siliana',
                'Sousse',
                'Tataouine',
                'Tozeur',
                'Tunis',
                'Zaghouan'
            ],
            'divider': false
        }
        ,
        {
            name: 'Turkey',
            states: [
                'Adana',
                'Adiyaman',
                'Afyon',
                'Agri',
                'Aksaray',
                'Amasya',
                'Ankara',
                'Antalya',
                'Ardahan',
                'Artvin',
                'Aydin',
                'Balikesir',
                'Bartin',
                'Batman',
                'Bayburt',
                'Bilecik',
                'Bingol',
                'Bitlis',
                'Bolu',
                'Burdur',
                'Bursa',
                'Canakkale',
                'Cankiri',
                'Corum',
                'Denizli',
                'Diyarbakir',
                'Duzce',
                'Edirne',
                'Elazig',
                'Erzincan',
                'Erzurum',
                'Eskisehir',
                'Gaziantep',
                'Giresun',
                'Gumushane',
                'Hakkari',
                'Hatay',
                'Icel',
                'Igdir',
                'Isparta',
                'Istanbul',
                'Izmir',
                'Kahramanmaras',
                'Karabuk',
                'Karaman',
                'Kars',
                'Kastamonu',
                'Kayseri',
                'Kilis',
                'Kirikkale',
                'Kirklareli',
                'Kirsehir',
                'Kocaeli',
                'Konya',
                'Kutahya',
                'Malatya',
                'Manisa',
                'Mardin',
                'Mugla',
                'Mus',
                'Nevsehir',
                'Nigde',
                'Ordu',
                'Osmaniye',
                'Rize',
                'Sakarya',
                'Samsun',
                'Sanliurfa',
                'Siirt',
                'Sinop',
                'Sirnak',
                'Sivas',
                'Tekirdag',
                'Tokat',
                'Trabzon',
                'Tunceli',
                'Usak',
                'Van',
                'Yalova',
                'Yozgat',
                'Zonguldak'
            ],
            'divider': false
        }
        ,
        {
            name: 'Turkmenistan',
            states: [
                'Ahal Welayaty',
                'Balkan Welayaty',
                'Dashhowuz Welayaty',
                'Lebap Welayaty',
                'Mary Welayaty'
            ],
            'divider': false
        }
        ,
        {
            name: 'Tuvalu',
            states: [
                'Tuvalu'
            ],
            'divider': false
        }
        ,
        {
            name: 'Uganda',
            states: [
                'Adjumani',
                'Apac',
                'Arua',
                'Bugiri',
                'Bundibugyo',
                'Bushenyi',
                'Busia',
                'Gulu',
                'Hoima',
                'Iganga',
                'Jinja',
                'Kabale',
                'Kabarole',
                'Kalangala',
                'Kampala',
                'Kamuli',
                'Kapchorwa',
                'Kasese',
                'Katakwi',
                'Kibale',
                'Kiboga',
                'Kisoro',
                'Kitgum',
                'Kotido',
                'Kumi',
                'Lira',
                'Luwero',
                'Masaka',
                'Masindi',
                'Mbale',
                'Mbarara',
                'Moroto',
                'Moyo',
                'Mpigi',
                'Mubende',
                'Mukono',
                'Nakasongola',
                'Nebbi',
                'Ntungamo',
                'Pallisa',
                'Rakai',
                'Rukungiri',
                'Sembabule',
                'Soroti',
                'Tororo'
            ],
            'divider': false
        }
        ,
        {
            name: 'Ukraine',
            states: [
                'Avtonomna Respublika Krym (Simferopol\')',
                'Cherkas\'ka(Cherkasy)',
                'Chernihivs\'ka(Chernihiv)',
                'Chernivets\'ka(Chernivtsi)',
                'Dnipropetrovs\'ka(Dnipropetrovs\'k)',
                'Donets\'ka(Donets\'k)',
                'Ivano-Frankivs\'ka(Ivano - Frankivs\'k)',
                'Kharkivs\'ka(Kharkiv)',
                'Khersons\'ka(Kherson)',
                'Khmel\'nyts\'ka (Khmel\'nyts\'kyy)',
                'Kirovohrads\'ka(Kirovohrad)',
                'Kyyiv',
                'Kyyivs\'ka(Kiev)',
                'L\'vivs\'ka (L\'viv)',
                'Luhans\'ka(Luhans\'k)',
                'Mykolayivs\'ka(Mykolayiv)',
                'Odes\'ka(Odesa)',
                'Poltavs\'ka(Poltava)',
                'Rivnens\'ka(Rivne)',
                'Sevastopol\'',
                'Sums\'ka(Sumy)',
                'Ternopil\'s\'ka (Ternopil\')',
                'Vinnyts\'ka(Vinnytsya)',
                'Volyns\'ka(Luts\'k)',
                'Zakarpats\'ka(Uzhhorod)',
                'Zaporiz\'ka(Zaporizhzhya)',
                'Zhytomyrs\'ka(Zhytomyr)'
            ],
            'divider': false
        },
        {
            name: 'United Arab Emirates',
            states: [
                '\'Ajman',
                'Abu Zaby (Abu Dhabi)',
                'Al Fujayrah',
                'Ash Shariqah (Sharjah)',
                'Dubayy (Dubai)',
                'Ra\'s al Khaymah',
                'Umm al Qaywayn'
            ],
            'divider': false
        }
        ,
        {
            name: 'United Kingdom',
            states: [
                'Barking and Dagenham',
                'Barnet',
                'Barnsley',
                'Bath and North East Somerset',
                'Bedfordshire',
                'Bexley',
                'Birmingham',
                'Blackburn with Darwen',
                'Blackpool',
                'Bolton',
                'Bournemouth',
                'Bracknell Forest',
                'Bradford',
                'Brent',
                'Brighton and Hove',
                'Bromley',
                'Buckinghamshire',
                'Bury',
                'Calderdale',
                'Cambridgeshire',
                'Camden',
                'Cheshire',
                'City of Bristol',
                'City of Kingston upon Hull',
                'City of London',
                'Cornwall',
                'Coventry',
                'Croydon',
                'Cumbria',
                'Darlington',
                'Derby',
                'Derbyshire',
                'Devon',
                'Doncaster',
                'Dorset',
                'Dudley',
                'Durham',
                'Ealing',
                'East Riding of Yorkshire',
                'East Sussex',
                'Enfield',
                'Essex',
                'Gateshead',
                'Gloucestershire',
                'Greenwich',
                'Hackney',
                'Halton',
                'Hammersmith and Fulham',
                'Hampshire',
                'Haringey',
                'Harrow',
                'Hartlepool',
                'Havering',
                'Herefordshire',
                'Hertfordshire',
                'Hillingdon',
                'Hounslow',
                'Isle of Wight',
                'Islington',
                'Kensington and Chelsea',
                'Kent',
                'Kingston upon Thames',
                'Kirklees',
                'Knowsley',
                'Lambeth',
                'Lancashire',
                'Leeds',
                'Leicester',
                'Leicestershire',
                'Lewisham',
                'Lincolnshire',
                'Liverpool',
                'Luton',
                'Manchester',
                'Medway',
                'Merton',
                'Middlesbrough',
                'Milton Keynes',
                'Newcastle upon Tyne',
                'Newham',
                'Norfolk',
                'North East Lincolnshire',
                'North Lincolnshire',
                'North Somerset',
                'North Tyneside',
                'North Yorkshire',
                'Northamptonshire',
                'Northumberland',
                'Nottingham',
                'Nottinghamshire',
                'Oldham',
                'Oxfordshire',
                'Peterborough',
                'Plymouth',
                'Poole',
                'Portsmouth',
                'Reading',
                'Redbridge',
                'Redcar and Cleveland',
                'Richmond upon Thames',
                'Rochdale',
                'Rotherham',
                'Rutland',
                'Salford',
                'Sandwell',
                'Sefton',
                'Sheffield',
                'Shropshire',
                'Slough',
                'Solihull',
                'Somerset',
                'South Gloucestershire',
                'South Tyneside',
                'Southampton',
                'Southend-on-Sea',
                'Southwark',
                'St. Helens',
                'Staffordshire',
                'Stockport',
                'Stockton-on-Tees',
                'Stoke-on-Trent',
                'Suffolk',
                'Sunderland',
                'Surrey',
                'Sutton',
                'Swindon',
                'Tameside',
                'Telford and Wrekin',
                'Thurrock',
                'Torbay',
                'Tower Hamlets',
                'Trafford',
                'Wakefield',
                'Walsall',
                'Waltham Forest',
                'Wandsworth',
                'Warrington',
                'Warwickshire',
                'West Berkshire',
                'West Sussex',
                'Westminster',
                'Wigan',
                'Wiltshire',
                'Windsor and Maidenhead',
                'Wirral',
                'Wokingham',
                'Wolverhampton',
                'Worcestershire',
                'York'
            ],
            'divider': false
        },
        {
            name: 'United States',
            states: [
                'Alabama',
                'Alaska',
                'Arizona',
                'Arkansas',
                'California',
                'Colorado',
                'Connecticut',
                'Delaware',
                'District of Columbia',
                'Florida',
                'Georgia',
                'Hawaii',
                'Idaho',
                'Illinois',
                'Indiana',
                'Iowa',
                'Kansas',
                'Kentucky',
                'Louisiana',
                'Maine',
                'Maryland',
                'Massachusetts',
                'Michigan',
                'Minnesota',
                'Mississippi',
                'Missouri',
                'Montana',
                'Nebraska',
                'Nevada',
                'New Hampshire',
                'New Jersey',
                'New Mexico',
                'New York',
                'North Carolina',
                'North Dakota',
                'Ohio',
                'Oklahoma',
                'Oregon',
                'Pennsylvania',
                'Rhode Island',
                'South Carolina',
                'South Dakota',
                'Tennessee',
                'Texas',
                'Utah',
                'Vermont',
                'Virginia',
                'Washington',
                'West Virginia',
                'Wisconsin',
                'Wyoming'
            ],
            'divider': false
        },
        {
            name: 'Uruguay',
            states: [
                'Artigas',
                'Canelones',
                'Cerro Largo',
                'Colonia',
                'Durazno',
                'Flores',
                'Florida',
                'Lavalleja',
                'Maldonado',
                'Montevideo',
                'Paysandu',
                'Rio Negro',
                'Rivera',
                'Rocha',
                'Salto',
                'San Jose',
                'Soriano',
                'Tacuarembo',
                'Treinta y Tres'
            ],
            'divider': false
        }
        ,
        {
            name: 'Uzbekistan',
            states: [
                'Andijon Wiloyati',
                'Bukhoro Wiloyati',
                'Farghona Wiloyati',
                'Jizzakh Wiloyati',
                'Khorazm Wiloyati (Urganch)',
                'Namangan Wiloyati',
                'Nawoiy Wiloyati',
                'Qashqadaryo Wiloyati (Qarshi)',
                'Qoraqalpoghiston (Nukus)',
                'Samarqand Wiloyati',
                'Sirdaryo Wiloyati (Guliston)',
                'Surkhondaryo Wiloyati (Termiz)',
                'Toshkent Shahri',
                'Toshkent Wiloyati'
            ],
            'divider': false
        }
        ,
        {
            name: 'Vanuatu',
            states: [
                'Malampa',
                'Penama',
                'Sanma',
                'Shefa',
                'Tafea',
                'Torba'
            ],
            'divider': false
        }
        ,
        {
            name: 'Venezuela',
            states: [
                'Amazonas',
                'Anzoategui',
                'Apure',
                'Aragua',
                'Barinas',
                'Bolivar',
                'Carabobo',
                'Cojedes',
                'Delta Amacuro',
                'Dependencias Federales',
                'Distrito Federal',
                'Falcon',
                'Guarico',
                'Lara',
                'Merida',
                'Miranda',
                'Monagas',
                'Nueva Esparta',
                'Portuguesa',
                'Sucre',
                'Tachira',
                'Trujillo',
                'Vargas',
                'Yaracuy',
                'Zulia'
            ],
            'divider': false
        }
        ,
        {
            name: 'Vietnam',
            states: [
                'An Giang',
                'Ba Ria-Vung Tau',
                'Bac Giang',
                'Bac Kan',
                'Bac Lieu',
                'Bac Ninh',
                'Ben Tre',
                'Binh Dinh',
                'Binh Duong',
                'Binh Phuoc',
                'Binh Thuan',
                'Ca Mau',
                'Can Tho',
                'Cao Bang',
                'Da Nang',
                'Dac Lak',
                'Dong Nai',
                'Dong Thap',
                'Gia Lai',
                'Ha Giang',
                'Ha Nam',
                'Ha Noi',
                'Ha Tay',
                'Ha Tinh',
                'Hai Duong',
                'Hai Phong',
                'Ho Chi Minh',
                'Hoa Binh',
                'Hung Yen',
                'Khanh Hoa',
                'Kien Giang',
                'Kon Tum',
                'Lai Chau',
                'Lam Dong',
                'Lang Son',
                'Lao Cai',
                'Long An',
                'Nam Dinh',
                'Nghe An',
                'Ninh Binh',
                'Ninh Thuan',
                'Phu Tho',
                'Phu Yen',
                'Quang Binh',
                'Quang Nam',
                'Quang Ngai',
                'Quang Ninh',
                'Quang Tri',
                'Soc Trang',
                'Son La',
                'Tay Ninh',
                'Thai Binh',
                'Thai Nguyen',
                'Thanh Hoa',
                'Thua Thien-Hue',
                'Tien Giang',
                'Tra Vinh',
                'Tuyen Quang',
                'Vinh Long',
                'Vinh Phuc',
                'Yen Bai'
            ],
            'divider': false
        }
        ,
        {
            name: 'Virgin Islands',
            states: [
                'Saint Croix',
                'Saint John',
                'Saint Thomas'
            ],
            'divider': false
        }
        ,
        {
            name: 'Wales',
            states: [
                'Blaenau Gwent',
                'Bridgend',
                'Caerphilly',
                'Cardiff',
                'Carmarthenshire',
                'Ceredigion',
                'Conwy',
                'Denbighshire',
                'Flintshire',
                'Gwynedd',
                'Isle of Anglesey',
                'Merthyr Tydfil',
                'Monmouthshire',
                'Neath Port Talbot',
                'Newport',
                'Pembrokeshire',
                'Powys',
                'Rhondda Cynon Taff',
                'Swansea',
                'The Vale of Glamorgan',
                'Torfaen',
                'Wrexham'
            ],
            'divider': false
        }
        ,
        {
            name: 'Wallis and Futuna',
            states: [
                'Alo',
                'Sigave',
                'Wallis'
            ],
            'divider': false
        }
        ,
        {
            name: 'West Bank',
            states: [
                'West Bank'
            ],
            'divider': false
        }
        ,
        {
            name: 'Western Sahara',
            states: [
                'Western Sahara'
            ],
            'divider': false
        }
        ,
        {
            name: 'Yemen',
            states: [
                '\'Adan',
                '\'Ataq',
                'Abyan',
                'Al Bayda\'',
                'Al Hudaydah',
                'Al Jawf',
                'Al Mahrah',
                'Al Mahwit',
                'Dhamar',
                'Hadhramawt',
                'Hajjah',
                'Ibb',
                'Lahij',
                'Ma\'rib',
                'Sa\'dah',
                'San\'a\'',
                'Ta\'izz'
            ],
            'divider': false
        }
        ,
        {
            name: 'Yugoslavia',
            states: [
                'Kosovo',
                'Montenegro',
                'Serbia',
                'Vojvodina'
            ],
            'divider': false
        }
        ,
        {
            name: 'Zambia',
            states: [
                'Central',
                'Copperbelt',
                'Eastern',
                'Luapula',
                'Lusaka',
                'North-Western',
                'Northern',
                'Southern',
                'Western'
            ],
            'divider': false
        }
        ,
        {
            name: 'Zimbabwe',
            states: [
                'Bulawayo',
                'Harare',
                'Manicaland',
                'Mashonaland Central',
                'Mashonaland East',
                'Mashonaland West',
                'Masvingo',
                'Matabeleland North',
                'Matabeleland South',
                'Midlands'
            ],
            'divider': false
        }
    ]);


/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.inServiceDetailComponent', [])
    .filter('filterBooking', function () {
        return function (list, dates) {
            var res = [];
            res = _.filter(list, function (item) {
                return ((!dates.dateFrom || moment(dates.dateFrom).isSameOrBefore(moment.utc(item.dateTo))) &&
                (!dates.dateTo || moment(dates.dateTo).isSameOrAfter(moment.utc(item.dateFrom))));
            });
            return res;
        };
    });

/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.inServiceListComponent', []);
angular
    .module('Tagaste.inServiceReserveCom', []);
angular
    .module('Tagaste.incidentDetailCom', []);
angular
    .module('Tagaste.incidentsListCom', []);
/**
 * Created by sila.fernandez
 * created on 07/05/2019
 */
angular
    .module('BlurAdmin.inWorkerTaskDetailComponent', []);

/**
 * Created by sila.fernandez
 * created on 06/05/2019
 */
angular
    .module('BlurAdmin.inWorkerTaskListComponent', []);
angular
    .module('Tagaste.masterTablesConfigComponent', []);
angular
    .module('Tagaste.masterTablesCustomConceptsComponent', []);

angular
    .module('Tagaste.masterTablesDishComponent', []);

angular
    .module('Tagaste.masterTablesEmailComponent', []);

angular
    .module('Tagaste.masterTablesMenuComponent', []);

angular
    .module('Tagaste.masterTablesPanelComponent', []);
angular
    .module('Tagaste.masterTablesRoomRateComponent', []);

angular
    .module('Tagaste.masterTablesStatusComponent', []);

angular
    .module('Tagaste.masterTablesTaskComponent', []);

angular
    .module('Tagaste.masterTablesTaxComponent', []);

angular
    .module('Tagaste.reservationDetailComponent', []);

angular
    .module('Tagaste.reservationsListComponent', []);

/**
 * Created by sila.fernandez on 20/05/2019
 */
angular
    .module('BlurAdmin.paymentCom', [])
    .filter('findCard', function (){
        return function (list, params) {
            if (params) {
                params.alredy = (params.alredy) ? params.alredy : [];
            } else {
                params = {
                    alredy: [],
                    find: ''
                };
            }
            return _.differenceBy(_.filter(list, function (item) {
                return (
                    (params.find.trim() === '' || (
                            (_.deburr(item.number).toUpperCase()
                                .indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                        )
                    ));
            }), params.alredy, '_id');
        };
    });;

/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.residentDetailCom', []) 
    .filter('findCard', function (){
        return function (list, params) {
            if (params) {
                params.alredy = (params.alredy) ? params.alredy : [];
            } else {
                params = {
                    alredy: [],
                    find: ''
                };
            }
            return _.differenceBy(_.filter(list, function (item) {
                return (
                    (params.find.trim() === '' || (
                            (_.deburr(item.number).toUpperCase()
                                .indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                        )
                    ));
            }), params.alredy, '_id');
        };
    });

/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.residentsListCom', []);
angular
    .module('Tagaste.requestsDetailComponent', []);

angular
    .module('Tagaste.requestsListComponent', []);

/**
 * Created by sila.fernandez
 * created on 22/03/2019
 */
angular
    .module('BlurAdmin.roomsDetailCom', []);

/**
 * Created by sila.fernandez on 22/03/2019.
 */
angular
    .module('BlurAdmin.roomsListCom', []);
angular
    .module('Tagaste.taskDetailCom', []);
angular
    .module('Tagaste.taskSchedulerDetailCom', []);
angular
    .module('Tagaste.taskSchedulerListCom', []);
angular
    .module('Tagaste.tasksListCom', []);
/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.userDetailCom', []);

/**
 * Created by Talento Software on 17/13/2017.
 */
angular
    .module('BlurAdmin.usersListCom', []);

(function () {
    'use strict';

    angular.module('Tagaste.activities.activitiesList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('activitiesList', {
                url: '/activities',
                templateUrl: 'app/pages/activities/activitiesList/activitiesList.html',
                controller:'activitiesListController',
                controllerAs: 'alc',
                abstract: false,
                title: 'Actividades',
                sidebarMeta: {
                    icon: 'ion-pin',
                    order: 250,
                    permission : 'AGENDA'
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.billing.billingList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('billingList', {
                url: '/billing',
                templateUrl: 'app/pages/billing/billingList/billingList.html',
                title: 'Facturación',
                controllerAs: 'bilc',
                controller: 'billingListController',
                abstract: false,
                sidebarMeta: {
                    icon: 'ion-social-euro',
                    order: 1500,
                    permission: 'BILLING'
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.bulletinBoard.bulletinBoardList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('bulletinBoardList', {
                url: '/bulletinBoard',
                templateUrl: 'app/pages/bulletinBoard/bulletinBoardList/bulletinBoardList.html',
                controller:'bulletinBoardListController',
                controllerAs: 'bblst',
                abstract: false,
                title: 'Tablón Anuncios',
                sidebarMeta: {
                    icon: 'ion-android-list',
                    order: 250,
                    permission: 'BBOARD'
                }
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.canteen.canteenPanel', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('canteenPan', {
                url: '/canteenPanel',
                templateUrl: 'app/pages/canteen/canteenPanel/canteenPanel.html',
                controller:'canteenPanelController',
                controllerAs: 'cntine',
                abstract: false,
                title: 'Comedor',
                sidebarMeta: {
                    icon: 'tagaste-spoon-knife',
                    order: 250,
                    permission:'MENU'
                }
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('Tagaste.pages.chat.panel', [
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('chatPanel', {
                url: '/chatPanel',
                templateUrl: 'app/pages/chat/chatPanel/chatPanel.html',
                controller: 'chatPanelController',
                controllerAs: 'cpn',
                abstract: false,
                title: 'Chat',
                sidebarMeta: {
                    icon: 'ion-chatbox-working',
                    order: 250,
                     permission: 'CHAT'
                }
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.configWb.userList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {

        $stateProvider
            .state('userList', {
                url: '/users',
                templateUrl: 'app/pages/config/userList/userList.html',
                controller: 'userListController',
                controllerAs: 'ulst',
                abstract: false,
                title: 'Usuarios',
                sidebarMeta: {
                    icon: 'ion-ios-gear',
                    order: 250,
                    permission: 'USER'

                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.incidents.incidentsList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('incidentsList', {
                url: '/incidents',
                templateUrl: 'app/pages/incidents/incidentsList/incidentsList.html',
                controller:'incidentsListController',
                controllerAs: 'ilc',
                abstract: false,
                title: 'Incidencias',
                sidebarMeta: {
                    icon: 'ion-alert-circled',
                    order: 250,
                    permission:'INCIDENT'
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.masterTables.masterTablesList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('masterTablesList', {
                url: '/masterTables',
                templateUrl: 'app/pages/masterTables/masterTablesList/masterTablesList.html',
                controller:'masterTablesListController',
                controllerAs: 'mtlc',
                abstract: false,
                title: 'Tablas maestras',
                sidebarMeta: {
                    icon: 'ion-gear-a',
                    order: 1600,
                    permission: 'ADMIN'
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.requests.requestsList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('requestsList', {
                url: '/requests',
                templateUrl: 'app/pages/requests/requestsList/requestsList.html',
                title: 'Solicitudes',
                controllerAs: 'rqlc',
                controller: 'requestsListController',
                abstract: false,
                sidebarMeta: {
                    icon: 'ion-folder',
                    order: 1500,
                    permission: 'APPLICATION'
                }
            });
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.reservations.reservationsList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('reservationsList', {
                url: '/reservations',
                templateUrl: 'app/pages/reservations/reservationsList/reservationsList.html',
                title: 'Reservas',
                controllerAs: 'rslc',
                controller: 'reservationsListController',
                abstract: false,
                sidebarMeta: {
                    icon: 'ion-folder',
                    order: 1500,
                    permission: 'RESERVATION'
                }
            });
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.users.residentsList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('residentsList', {
                url: '/residents',
                templateUrl: 'app/pages/residents/residentsList/residentsList.html',
                controller: 'residentsListController',
                controllerAs: 'rlst',
                abstract: false,
                title: 'Residentes',
                sidebarMeta: {
                    icon: 'ion-person-stalker',
                    order: 250,
                    permission: 'RESIDENT'
                }
            });
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.services.servicesMenu', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('ServiceMenu', {
                url: '/services',
                templateUrl: 'app/pages/services/servicesMenu/serviceMenu.html',
                controller: 'ServicesMenuController',
                controllerAs: 'sces',
                abstract: false,
                title: 'Servicios',
                sidebarMeta: {
                    icon: 'ion-ios-keypad',
                    order: 250,
                    permission: 'SERVICE'
                }
            });
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.tasks.tasksList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('tasksList', {
                url: '/tasks',
                templateUrl: 'app/pages/tasks/tasksList/tasksList.html',
                controller:'tasksListController',
                controllerAs: 'tlc',
                abstract: false,
                title: 'Tareas',
                sidebarMeta: {
                    icon: 'ion-clipboard',
                    order: 250,
                    permission:'CLEANING UPDATE|MAINTENANCE UPDATE'
                }
            });
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500
          }
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

/**
 * @author sila.fernandez
 * created on 06/05/2019
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.workerTask.workerTaskList', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('workerTaskList', {
                url: '/workerTask',
                templateUrl: 'app/pages/workerTask/workerTaskList/workerTaskList.html',
                controller: 'WorkerTaskListController',
                controllerAs: 'slc',
                abstract: false,
                title: 'Calendario',
                sidebarMeta: {
                    icon: 'ion-calendar',
                    order: 900,
                    permission: 'USER'
                }
            });
    }
})();
/**
 * Created by Talento Software on 09/01/2018
 */
angular
    .module('BlurAdmin.canteenNewComponent', []);


angular
    .module('BlurAdmin.canteenInDish', []);
'use strict';

angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    'xeditable',
    'ui.slimscroll',
    'ngJsTree',
    'BlurAdmin.components',
    'angular-progress-button-styles',
    'BlurAdmin.theme',
    'BlurAdmin.pages',
    'BlurAdmin.config',
    'BlurAdmin.login',
    'BlurAdmin.service',
    'BlurAdmin.service.permissions',
    'BlurAdmin.configWb',
    'ngResource',
    'ngCookies',
    'ngAnimate',
    'toastr',
    'ngTable',
    'ngAnimate',
    // Required for avatar component
    'BlurAdmin.blob.service',
    'naif.base64',
    // 'ngImgCrop',
    'uiCropper',
    // End required avatar component
    'ng-mfb',
    'ui.select',
    'bm.uiTour',
    'ngFileUpload',
    'tmh.dynamicLocale',
    'bootstrapLightbox',
    'luegg.directives',
    'ngRoute',
    'ngFileSaver',
    'nzToggle',
    'weeklyScheduler',
    'weeklySchedulerI18N',
    'ui.carousel',
    'infinite-scroll',
    'color.picker',
    'textAngular'
]).config(function (tmhDynamicLocaleProvider, $rootScopeProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern('../angular/i18n/angular-locale_{{locale}}.js');
    $rootScopeProvider.digestTtl(100);
}).run(['PermissionsService', 'UsersService', 'localStorageService', 'toastr', 'TranslationService',
    'TourService', '$rootScope', '$location', 'ConstantsService',

    function (PermissionsService, UsersService, localStorageService, toastr, TranslationService, TourService,
              $rootScope, $location, $urlRouterProvider) {

        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (toState) {
                if (!PermissionsService.isUserLogged()) {
                    // redirect back to login
                    window.location.href = window.location.protocol + '//' + window.location.host + '/auth.html';
                } else {
                    PermissionsService.gotAccess(toState.url).then(function (r) {
                        event.preventDefault();
                        if (!r) {
                            $location.url('/dashboard');
                        } else {
                            $location.url(toState.url);
                        }
                    });
                }
            }
        });
    }]);

(function () {
    'use strict';

    angular.module('BlurAdmin.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    LoginController.$inject = ['$http', '$log', 'ENV', 'PermissionsService', 'localStorageService', 'toastr', '$location', '$timeout', '$uibModal', 'TranslationService'];
    function LoginController($http, $log, ENV, PermissionsService, localStorageService, toastr, $location, $timeout, $uibModal, TranslationService) {
        var vm = this;

        $('.tlt').textillate({
            minDisplayTime: 3400,
            in: {effect: 'fadeIn', sequence: true},
            out: {effect: 'fadeOut', sync: true},
            loop: true
        });

        // Step 1 forgot pass (User click on forgot password)
        vm.forgotPassword = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'modalForgotPassword.html',
                controller: 'RecoveryPasswordModalController',
                controllerAs: '$ctrl',
                backdrop: 'static',
                size: 'sm'
            });
            // Function when open modal
            modalInstance.result.then(function () {
            }, function () {
            });
        };

        // Step 2 forgot password (User enter in app from recovery email)
        if ($location.search().recPass) {
            // POST to server with token /resetPassword
            var token = {
                'token': $location.search().recPass
            };
            $http.post(ENV.backOffice + ENV.version + 'user/resetPassConfirm', token)
                .then(function (pResult) {
                    toastr.success(TranslationService.forgotpassword.resetok,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                })
                .catch(function (err) {
                    toastr.error(TranslationService.forgotpassword.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
        } else {
        }

        // If user is logged goto dashboard
        if (PermissionsService.isUserLogged()) {
            window.location.href = window.location.protocol + '//' + window.location.host + '/dashboard';
        }
        if (localStorageService.get('sessionExpired') === true) {
            $timeout(function () {
                toastr.error(TranslationService.login.sessionexpired);
                $log.error('Sesion Expired');
                localStorageService.remove('sessionExpired');
            });
        }

        vm.load = false;
        $timeout(function () {
            vm.load = true;
        }, 100);

        vm.login = function () {
            // fix when username: vm.username.toLowerCase() on empty
            if (!vm.username || !vm.password) {
                toastr.warning(TranslationService.login.error401);
            } else {
                $http.post(ENV.backOffice + ENV.version + 'user/createSession', {
                    username: vm.username.toLowerCase(),
                    password: vm.password
                }).then(function (response) {
                    // Go to permissionService to store data on localStorage
                    PermissionsService.newSession(response.data.userId, response.data.token, response.data.expDate);
                    PermissionsService.setSessionRenew(response.data);
                    window.location.href = window.location.protocol + '//' + window.location.host + '/dashboard';
                }).catch(function (response) {
                    switch (response.status) {
                        case 400:
                            toastr.warning(TranslationService.login.error400);
                            $log.error('Error: ', response);
                            break;
                        case 401:
                            toastr.warning(TranslationService.login.error401);
                            $log.error('Error: ', response);
                            break;
                        default:
                            toastr.error(TranslationService.login.errordefault);
                            $log.error('Error: ', response);
                            break;
                    }
                });
            }
        };
    }

    /** Recovery password **/
    angular.module('BlurAdmin.login').controller('RecoveryPasswordModalController', RecoveryPasswordModalController);
    RecoveryPasswordModalController.$inject = ['$uibModalInstance', '$http', '$log', 'ENV', 'toastr', 'TranslationService'];
    /* @ngInject */
    function RecoveryPasswordModalController($uibModalInstance, $http, $log, ENV, toastr, TranslationService) {
        var $ctrl = this;

        $ctrl.ok = function () {
            $log.debug('[ManagementUsersEditController - HomeController] (Recovery Password) - username: ', $ctrl.username);
            $http.post(ENV.backOffice + ENV.version + 'user/resetPassRequest', {'username': $ctrl.username}).then(function (pResult) {
                $log.debug('Mail sended successful to ', $ctrl.username);
                if (pResult.status >= 200 && pResult.status < 300) {
                    toastr.success(TranslationService.forgotpassword.successmail,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                } else {
                    toastr.error(TranslationService.forgotpassword.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                }
            }).catch(function (pResult) {
                switch (pResult.status) {
                    default:
                        toastr.error(TranslationService.forgotpassword.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        $log.debug('Error sending mail: ', pResult);
                }
            });
            $uibModalInstance.close();
        };

        $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();


/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular
        .module('BlurAdmin.service.validation', [])
        .service('ValidationService', ValidationService);

    ValidationService.$inject = [];

    /* @ngInject */
    function ValidationService() {
        var vm = this;

        vm.validDniNie = function (input,type){
            var validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';
            var nifRexp = /^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
            var nieRexp = /^[XYZ]{1}[0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/i;
            var str = input.toString().toUpperCase();
            if (type === 'DNI' && !nifRexp.test(str)){
                return false;
            }
            if (type=== 'NIE' && !nieRexp.test(str)){
                return false;
            }
            var nie = str
                .replace(/^[X]/, '0')
                .replace(/^[Y]/, '1')
                .replace(/^[Z]/, '2');

            var letter = str.substr(-1);
            var charIndex = parseInt(nie.substr(0, 8)) % 23;

            return validChars.charAt(charIndex) === letter;
        };

        vm.validEmail = function (input) {
            var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,13})$\gi/;
            return reg.test(input);
        };

        vm.validMobile = function (input) {
            if(input) {
                var reg = '';
                if (!input.startsWith('+') || input.startsWith('+34')) {
                    reg = /^(\+[0-9]{2,4})?\)?[-. ]?([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{3})$/;
                } else {
                    reg = /^(\+[0-9]{2,4})?\)?[-. ]?([0-9]{3,13})$/;
                }
                return reg.test(input);
            } else {
                return false;
            }

        };

        vm.validSwift = function(input){
            var reg = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
            return reg.test(input);
        };

        vm.validIban = function(input){
            var reg = /^([A-Z]{2}[ \-]?[0-9]{2})(?=(?:[ \-]?[A-Z0-9]){9,30}$)((?:[ \-]?[A-Z0-9]{3,5}){2,7})([ \-]?[A-Z0-9]{1,3})?$/;
            return reg.test(input);
        };

        this.ignoreDiacritics = ignoreDiacritics;

        function ignoreDiacritics(text) {
            return _.deburr(text.toUpperCase());
        }
    }
})();

(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name BlurAdmin:httpProviderSessionInterceptor
     * @description
     * Interceptor to inject session permissions to server requests
     */
    // factory.$inject = ['PermissionsService', '$location', '$injector', '$q'];

    angular
        .module('BlurAdmin.service')
        .factory('httpProviderSessionInterceptor', factory);

    /* @ngInject */
    // function factory(PermissionsService, $location, $injector, $q) {
    // TODO Check this if permissionService is useless
    // function factory(PermissionsService,ENV, $location, $injector, $q, localStorageService) {
    function factory(ENV, $location, $injector, $q, localStorageService) {

        // TODO Check ignore routes (Copied from magna)
        var excludedRenewRequests = [
            // '/file/signedUpload'
        ];
        var _factory = {
            'request': function (config) {
            //          ////    /////    /* Intercept requests to the server to handle session credentials */
            //          ////    /////    var token = localStorageService.get('sessionToken');
            //          ////    /////    // config.headers['Authorization'] = 'Bearer ' + ENV.devtoken;
            //          ////    /////    //console.log(token);
            //          ////    /////    config.headers['Authorization'] = 'Bearer ' + token;
                if( _.startsWith(config.url, ENV.backOffice + ENV.version) ) {
                    var sessionToken = localStorageService.get('sessionToken');
                    if (_.isString(sessionToken)) {
                        var PermissionsService = $injector.get('PermissionsService');
                        if (_.isUndefined(PermissionsService.renewInterval)) {
                            /* Keep renew activated while user i sending requests */
                            var notExcludedFromRenewToken =
                                _.isEmpty(
                                    _.find(excludedRenewRequests, function (itUrl) {
                                        return _.includes(config.url, itUrl);
                                    })
                                );
                            if (notExcludedFromRenewToken) {
                                PermissionsService.activateSessionRenew();
                            }
                        }
                        config.headers['Authorization'] = 'Bearer ' + sessionToken;
                    }
                }
                return config;
            },
            /* Intercept responses from the server to handle session credentials */
            'responseError': function (pRejection) {
                if (pRejection.status === 401) {
                    $location.path('/auth');
                    var aux=$location.$$url.split('?');
                    if (aux[0]!=='/') {
                        /* The service can't be injected in the factory since it's loaded at initialization stage */
                        var translateService = $injector.get('$translate');
                        translateService(['EXPIRED_SESSION']).then(function (pTranslations) {
                            // Todo Toastr
                          /*  toastr.error(pTranslations['EXPIRED_SESSION'],
                                {progressBar: true, timeOut: 6000, extendedTimeOut: 1000, tapToDismiss: true});*/
                        });
                        // TODO Go to login
                    }
                }

                return $q.reject(pRejection);
            }
        };
        return _factory;
    }

})();
/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name BlurAdmin.service.PermissionsService:PermissionsService
     * @description
     * Service that returns user info
     */
    angular
        .module('BlurAdmin.service.ngTableFilterService', [])
        .service('NgTableFilterService', NgTableFilterService);
    NgTableFilterService.$inject = ['ValidationService', '$log'];

    /* @ngInject */
    function NgTableFilterService(ValidationService, $log) {
        var vm = this;

        /**
         * @ngdoc method
         * @name newSession
         * @methodOf BlurAdmin.service:PermissionsService
         * @description
         *   filter ignore diatrics
         * @param {string} data of ngtable
         * @param {string} filterValues user's filter val
         * @return {object}a function for ngtable
         */
        vm.fill = function (data, filterValues) {
            return data.filter(function (item) {
                var propertyNames = [];
                _.forOwn(filterValues, function (value, key) {
                    if (value) {
                        propertyNames.push(key);
                    }
                });
                var booleanArray = [];
                for (var i = 0; i < propertyNames.length; i++) {
                    if (angular.isNumber(filterValues[propertyNames[i]])) {
                        booleanArray.push({
                            value: item[propertyNames[i]] && ValidationService
                                .ignoreDiacritics(item[propertyNames[i]].toString())
                                .startsWith(ValidationService
                                    .ignoreDiacritics(filterValues[propertyNames[i]].toString()))
                        });
                    }
                    else {
                        booleanArray.push({
                            value: item[propertyNames[i]] && ValidationService.ignoreDiacritics(item[propertyNames[i]])
                                .indexOf(ValidationService
                                    .ignoreDiacritics(filterValues[propertyNames[i]])) !== -1
                        });
                    }
                }
                return _.findIndex(booleanArray, function (o) {
                        return o.value === false || o.value === undefined;
                    }) === -1;
            });
        };
    }
})();




/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name BlurAdmin.service.PermissionsService:PermissionsService
     * @description
     * Service that returns user info
     */
    angular
        .module('BlurAdmin.service.permissions', [
            'LocalStorageModule',
            'angular-jwt'
        ])
        .service('PermissionsService', PermissionsService);

    /* @ngInject */
    function PermissionsService(localStorageService, $log, ENV, $q, $timeout, jwtHelper, $http, ConstantsService) {
        var _thisService = this;
        this.newSession = newSession;
        this.isUserLogged = isUserLogged;
        this.renewSession = renewSession;
        this.destroySession = destroySession;
        this.activateSessionRenew = activateSessionRenew;
        this.setSessionRenew = setSessionRenew;
        // this.setUserLocalStorage = setUserLocalStorage;
        this.gotAccess = gotAccess;
        this.gotPermission = gotPermission;

        /**
         * @ngdoc method
         * @name gotPermission
         * @methodOf BlurAdmin.service:PermissionsService
         * @description
         *   permission check
         * @param {string} permissionsK permission key
         * @param {string} mode way mode
         * @return {boolean} access rights boolean
         */
        function gotPermission(permissionsK, mode) {
            var permissions = ConstantsService.getPermissions();
            mode = (mode) ? mode.toUpperCase() : 'READ';
            var access = (permissions[permissionsK] && permissions[permissionsK][mode]) ?
                permissions[permissionsK][mode] : false;
            // $log.debug('permissions[' + permissionsK + '][' + mode + '] : ' + access);
            return (access);
        }

        /**
         * @ngdoc method
         * @name gotAccess
         * @methodOf BlurAdmin.service:PermissionsService
         * @description
         *   url access check
         * @param {string} url url to acces
         * @return {boolean} access rights boolean
         */
        function gotAccess(url) {
            return new Promise(function (full, reject) {
                var access = false;
                if (url.toLowerCase().startsWith('/users')) {
                    access = gotPermission('USER');
                } else if (url.toLowerCase().startsWith('/dashboard')) {
                    access = true;
                } else if (url.toLowerCase().startsWith('/residents')) {
                    access = gotPermission('RESIDENT');
                } else if (url.toLowerCase().startsWith('/announcements')) {
                    access = gotPermission('NOTICE');
                } else if (url.toLowerCase().startsWith('/bulletinboard')) {
                    access = gotPermission('BBOARD');
                } else if (url.toLowerCase().startsWith('/canteenpanel')) {
                    access = gotPermission('MENU');
                } else if (url.toLowerCase().startsWith('/services')) {
                    access = gotPermission('SERVICE');
                } else if (url.toLowerCase().startsWith('/incidents')) {
                    access = gotPermission('INCIDENT');
                } else if (url.toLowerCase().startsWith('/activities')) {
                    access = gotPermission('AGENDA');
                } else if (url.toLowerCase().startsWith('/chat')) {
                    access = gotPermission('CHAT');
                } else if (url.toLowerCase().startsWith('/occupancy')) {
                    access = gotPermission('RESIDENT');
                } else if (url.toLowerCase().startsWith('/rooms')) {
                    access = gotPermission('RESIDENT');
                } else if (url.toLowerCase().startsWith('/workertask')) {
                    access = gotPermission('USER');
                } else if (url.toLowerCase().startsWith('/tasks')) {
                    access = true;
                } else if (url.toLowerCase().startsWith('/requests')) {
                    access = gotPermission('APPLICATION');
                } else if (url.toLowerCase().startsWith('/reservations')) {
                    access = gotPermission('RESERVATION');
                } else if (url.toLowerCase().startsWith('/billing')) {
                    access = gotPermission('BILLING');
                } else if (url.toLowerCase().startsWith('/mastertables')) {
                    access = gotPermission('ADMIN');
                }
                full(access);
            });
        }

        /**
         * @ngdoc method
         * @name newSession
         * @methodOf BlurAdmin.service:PermissionsService
         * @description
         *   Starts a new user session
         * @param {string} pUserId The user id
         * @param {string} pSessionToken The session token for the user
         * @param {date} expDate The session expiration date
         * @return {object} A promise that resolves when session is created
         */
        function newSession(pUserId, pSessionToken, expDate) {
            localStorageService.set('sessionToken', pSessionToken);
            $log.debug('newToken: ', pSessionToken);
            if (pUserId) {
                localStorageService.set('userId', pUserId);
                localStorageService.set('userKind', 'User');

            }
            localStorageService.set('expDate', expDate);

            // Get permissions from token
            var tokenSplit = pSessionToken.split('.');
            var token = JSON.parse(window.atob(tokenSplit[1]));
            localStorageService.set('permissions', token.permissions);
            localStorageService.set('branches', token.branches);
            return true;
        }

        /**
         * @ngdoc method
         * @name destroySession
         * @methodOf BlurAdmin.permissions.service:PermissionsService
         * @description
         *   Destroy the current user session and all related data
         */
        function destroySession() {
            localStorageService.clearAll();
            localStorageService.set('sessionExpired', true);
            window.location.href = window.location.protocol + '//' + window.location.host + '/auth.html';
        }

        /**
         * @ngdoc method
         * @name isUserLogged
         * @methodOf BlurAdmin.service:PermissionsService
         * @description
         *   Checks user token
         * @return {boolean} True if user is logged or false if user token expires or not exist
         */
        function isUserLogged() {
            // If user have a token
            if (localStorageService.get('sessionToken')) {
                // If token has been expired
                return !(jwtHelper.isTokenExpired(localStorageService.get('sessionToken')));
            } else {
                return false;
            }
        }

        /************** New to renew session **************************/

        /**
         * @ngdoc method
         * @name renewSession
         * @methodOf Magna.permissions.service:PermissionsService
         * @description
         *   Sends a request to renew user session token
         */
        function renewSession() {
            $log.debug('[permission-service] renewSession');

            var promise = $http.post(ENV.backOffice + ENV.version + 'user/renewSession');
            promise.then(function (pResponse) {
                /* Success renew: Renew session */
                $log.debug('[permission-service] - api/renewUserToken --> ', pResponse);
                newSession(pResponse.data.userId, pResponse.data.token, pResponse.data.expDate);
                setSessionRenew(pResponse.data);
                _thisService.renewInterval = undefined;
            }, function (pError) {
                /* Failed renew */
                destroySession();
                $log.error('[permission-service] - api/renewUserToken ERROR --> ', pError);
                _thisService.renewInterval = undefined;
            });
            return promise;
        }

        /**
         * @ngdoc method
         * @name activateSessionRenew
         * @methodOf Magna.permissions.service:PermissionsService
         * @description
         *   Activates the renew timer
         */
        function activateSessionRenew() {
            var expTime = localStorageService.get('expDate');
            $log.debug('[permission-service] exptime: ', expTime);
            var renewTime = _.round(expTime - ((new Date().getTime()) / 1000) - ENV.secondsToRenew);
            $log.debug('[permission-service] renewTime: ', renewTime);
            if (_.isNumber(renewTime) && renewTime > 0) {
                _thisService.renewInterval = $timeout(function () {
                    $log.debug('[permission-service] renewInterval triggered');
                    renewSession();
                }, renewTime * 1000);
            } else {
                $log.error('Error on renewSession()');
                destroySession();
            }
        }

        /**
         * @ngdoc method
         * @name setSessionRenew
         * @methodOf Magna.permissions.service:PermissionsService
         * @description
         *   Sets the session renew interval
         * @param pOriginalTokenData {object} The original token data from the server
         */
        function setSessionRenew(pOriginalTokenData) {
            /* Expiration time - 1 minute */
            _thisService.sessionRenewExpirationTime = localStorageService.get('expDate');
        }
    }
})();

angular
    .module('Tagaste.socketService', [])
    .service('SocketService', SocketService);

SocketService.$inject = ['$rootScope', 'localStorageService', '$log', 'chatConfig', '$location', 'ENV'];

function SocketService($rootScope, localStorageService, $log, chatConfig, $location, ENV) {
    var vm = this;

    vm.socket = null;
    vm.unReadMessages = false;

    vm.inChat = {
        groupSelected: ''
    };

    vm.getUnReadMessages = function () {
        $log.debug('getUnReadMessages',vm.unReadMessages);
        return vm.unReadMessages;
    };

    vm.setUnReadMessages = function (val) {
        vm.unReadMessages = val;
    };

    function startSocket() {
        var connectPayload = {
            _id: localStorageService.get('userId'),
            userKind: localStorageService.get('userKind'),
            isAPP: false,
            branch: localStorageService.get('branches')
        };
        vm.socket = io(ENV.backOffice, {query: connectPayload});
    }

    if (localStorageService.get('userId')){
        startSocket();
        vm.socket.on(chatConfig.message, function (data) {
            $log.debug('CHAT: received message: ', data);
            $log.debug('data.room: ', data.room);
            var aux = $location.$$url.split('?');
            if(aux.indexOf('/chatPanel') > -1){
                $rootScope.$emit('newMsgChat', data);
            }else{
                $rootScope.$emit('newMsgChatNotification');
            }
            $rootScope.$digest();
        });

        /*Received error mesasage*/
        vm.socket.on(chatConfig.error, function (data) {
            $log.error(data);
            $rootScope.$digest();
            throw Error(data);
        });
    }

    vm.sendNewMsg = function (message) {
        vm.socket.emit(chatConfig.sendMessage, message);
    };
}
/**
 * @author jjrubio
 * created on 15/01/2017
 */
(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name BlurAdmin.service.TourService
     * @description
     * Tour service
     */
    angular
        .module('BlurAdmin.service.tour', [])
        .service('TourService', TourService);

    TourService.$inject = ['localStorageService', 'uiTourService', 'TranslationService', '$log', 'MasterTableService',
        'routeConf', '$rootScope', '$timeout', '$q', 'PermissionsService', '$location'];

    /* @ngInject */
    function TourService(localStorageService, uiTourService, TranslationService, $log, MasterTableService,
                         routeConf, $rootScope, $timeout, $q, PermissionsService, $location) {
        var vm = this;

        // Store user tours into localStorage
        vm.getUserTours = function () {
            $log.debug('[tourService] getUserTours INIT');
            MasterTableService.get({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                },
                function (data) {
                    // If mastertable not return empty tours object
                    if (!data.tours) {
                        localStorageService.set('tours', []);
                    } else {
                        localStorageService.set('tours', data.tours);
                    }
                    $log.debug('[tourService] getUserTours saved info to localStorageService');
                }, function (err) {
                    $log.error('[tourService] getUserTours error load user tours', err);
                });
        };

        // Save user tours into DB
        vm.setUserTours = function () {
            // POST MasterTable...
        };

        vm.dashboardTour = function (forceTour) {
            var userTours = localStorageService.get('tours');

            var tourDashboard = uiTourService.createDetachedTour('tourDashboard', {
                name: 'tourDashboard',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourDashboardTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourDashboard.hasStep(0)) {
                tourDashboard.createStep({
                    selector: 'body',
                    appendToBody: true,
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.dashboard.title,
                    content: TranslationService.tour.dashboard.welcome,
                    orphan: true
                });
            }
            if (!tourDashboard.hasStep(1)) {
                tourDashboard.createStep({
                    selector: '#sidebarToggleMenu',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.dashboard.title,
                    content: TranslationService.tour.dashboard.step1MenuD,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourDashboard.hasStep(2)) {
                tourDashboard.createStep({
                    // selector: '#userProfile',
                    selector: '#tourAvatar',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.dashboard.title,
                    content: TranslationService.tour.dashboard.step2AvatarD,
                    placement: 'bottom-right',
                    appendToBody: true
                });
            }
            if (!tourDashboard.hasStep(3)) {
                tourDashboard.createStep({
                    selector: '.al-sidebar-list > li',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.dashboard.title,
                    content: TranslationService.tour.dashboard.step3MainmenuD,
                    placement: 'right-top',
                    appendToBody: true
                });
            }

            var unbindDASHBOARDWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    $log.debug('[tourService] Dashboard stateChangeStart');
                    tourDashboard.end();
                });

            // Save into DB
            tourDashboard.on('ended', function () {
                $log.debug('[tourService] Dashboard tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'DASHBOARD': true}
                }, function (data) {
                    $log.debug('[tourService] Dashboard tour updated to DB');
                    vm.getUserTours();
                    $log.debug('[tourService] Dashboard tour updated info on localStorage');
                    unbindDASHBOARDWatcher();
                    $rootScope.$broadcast('enableClickEvents');
                }, function (err) {
                    $log.error('[tourService] Dashboard. Error saving user tour into DB: ', err);
                });
            });


            if ($location.path() === '/dashboard' && (!userTours.DASHBOARD || forceTour)) {
                $log.debug('[tourService] Dashboard tour start');
                $rootScope.$broadcast('disableClickEvents');
                tourDashboard.start();
            }
        };

        vm.shouldShowDashboardTour = function () {
            var $$q = $q.defer();
            var userTours = localStorageService.get('tours');
            if (userTours) {
                $$q.resolve(!userTours.DASHBOARD);
            } else {
                MasterTableService.get({
                        idT: routeConf.user,
                        idJ: routeConf.tours
                    },
                    function (data) {
                        if (!data.tours) {
                            localStorageService.set('tours', []);
                            $$q.resolve(true);
                        } else {
                            localStorageService.set('tours', data.tours);
                            $$q.resolve(!_.get(data, 'tours.DASHBOARD', false));
                        }

                    }, function (err) {
                        $log.error('[tourService] getUserTours error load user tours', err);
                        $$q.reject(err);
                    });
            }
            return $$q.promise;
        };


        vm.initBulletinBoardTour = function () {
            var $$q = $q.defer();

            var tourBulletinBoard = uiTourService.createDetachedTour('tourBulletinBoard', {
                name: 'tourBulletinBoard',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourBulletinBoardTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourBulletinBoard.hasStep(0)) {
                tourBulletinBoard.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step0Welcome,
                    orphan: true,
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(1)) {
                tourBulletinBoard.createStep({
                    selector: '#bboardList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(2)) {
                tourBulletinBoard.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(3)) {
                tourBulletinBoard.createStep({
                    selector: '.firstListRow',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step3TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(4) && PermissionsService.gotPermission('BBOARD', 'update')) {
                tourBulletinBoard.createStep({
                    selector: '.firstListRow .fa-pencil',
                    stepId: 'step4',
                    order: 4,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step4TableEditButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(5) && PermissionsService.gotPermission('BBOARD', 'delete')) {
                tourBulletinBoard.createStep({
                    selector: '.firstListRow .fa-trash-o',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step5TableDeleteButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(6)) {
                tourBulletinBoard.createStep({
                    selector: '#totalItems',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step6TableTotalItems,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(7) && PermissionsService.gotPermission('BBOARD', 'update')) {
                tourBulletinBoard.createStep({
                    selector: '#newBulletinButton',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.bulletinBoard.title,
                    content: TranslationService.tour.bulletinBoard.step7TableNewButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourBulletinBoard.hasStep(8)) {
                tourBulletinBoard.createStep({
                    selector: 'body',
                    stepId: 'step8',
                    order: 8,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }

            tourBulletinBoard.on('stepChanged', function (data) {
                if (data.stepId === 'step8') {
                    $rootScope.$emit('openBulletinDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourBulletinBoard.hasStep(9)) {
                            tourBulletinBoard.createStep({
                                selector: '#bboardDetail',
                                stepId: 'step9',
                                order: 9,
                                title: TranslationService.tour.bulletinBoard.title,
                                content: TranslationService.tour.bulletinBoard.step9BulletinDetail,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        tourBulletinBoard.next();
                        if (!tourBulletinBoard.hasStep(10)) {
                            tourBulletinBoard.createStep({
                                selector: '#bboardDetailImg',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.bulletinBoard.title,
                                content: TranslationService.tour.bulletinBoard.step10BulletinDetailImg,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourBulletinBoard.hasStep(11)) {
                            tourBulletinBoard.createStep({
                                selector: '#bboardDetailHighlight',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.bulletinBoard.title,
                                content: TranslationService.tour.bulletinBoard.step11BulletinDetailHighlight,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourBulletinBoard.hasStep(12)) {
                            tourBulletinBoard.createStep({
                                selector: '#bboardDetailTooltip',
                                stepId: 'step12',
                                order: 12,
                                title: TranslationService.tour.bulletinBoard.title,
                                content: TranslationService.tour.bulletinBoard.step12BulletinDetailTooltip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourBulletinBoard.hasStep(13)) {
                            tourBulletinBoard.createStep({
                                selector: '#bboardDetailVisibleFrom input',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.bulletinBoard.title,
                                content: TranslationService.tour.bulletinBoard.step13BulletinDetailVisibleFrom,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourBulletinBoard.hasStep(14)) {
                            tourBulletinBoard.createStep({
                                selector: '#bboardDetailVisibleTo input',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.bulletinBoard.title,
                                content: TranslationService.tour.bulletinBoard.step14BulletinDetailVisibleTo,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourBulletinBoard.hasStep(15)) {
                            tourBulletinBoard.createStep({
                                selector: '#bboardDetailCancel',
                                stepId: 'step15',
                                order: 15,
                                title: TranslationService.tour.bulletinBoard.title,
                                content: TranslationService.tour.bulletinBoard.step15BulletinDetailCancelButton,
                                placement: 'top-right',
                                appendToBody: true
                            });
                        }
                        if (!tourBulletinBoard.hasStep(16)) {
                            tourBulletinBoard.createStep({
                                selector: 'body',
                                stepId: 'step16',
                                order: 16,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 500);

                    tourBulletinBoard.on('stepChanged', function (data) {
                        if (data.stepId === 'step16') {
                            $rootScope.$emit('closeBulletinDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourBulletinBoard.hasStep(17)) {
                                    tourBulletinBoard.createStep({
                                        selector: '.resumeTourContainer span',
                                        stepId: 'step17',
                                        order: 17,
                                        title: TranslationService.tour.bulletinBoard.title,
                                        content: TranslationService.tour.bulletinBoard.step17ResumeTourButton,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourBulletinBoard.next();
                            }, 500);
                        }
                    });
                }
            });
            var unbindBBWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourBulletinBoard.end();
                    return $$q.promise;
                });

            // Save into DB
            tourBulletinBoard.on('ended', function () {
                $log.debug('BulletinBoard tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'BBOARD': true}
                }, function (data) {
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindBBWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('closeBulletinDetail');
            $rootScope.$broadcast('disableClickEvents');
            tourBulletinBoard.start();

            return $$q.promise;
        };

        vm.shouldShowBulletinBoardTour = function () {
            var userTours = localStorageService.get('tours');
            return !userTours.BBOARD;
        };

        vm.initResidentsTour = function () {
            var $$q = $q.defer();
            var userBranch = localStorageService.get('branches');
            var oneBranchMode = (userBranch.length === 1);

            var tourResidents = uiTourService.createDetachedTour('tourResidents', {
                name: 'tourResidents',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourResidentsTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourResidents.hasStep(0)) {
                tourResidents.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step0Welcome,
                    orphan: true,
                    appendToBody: true
                });
            }
            if (!tourResidents.hasStep(1)) {
                tourResidents.createStep({
                    selector: '#residentsList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourResidents.hasStep(2)) {
                tourResidents.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (oneBranchMode) {
                if (!tourResidents.hasStep(3)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th',
                        stepId: 'step3',
                        order: 3,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3DelColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }
                if (!tourResidents.hasStep(4)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th',
                        stepId: 'step4',
                        order: 4,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3AbsentColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }
                if (!tourResidents.hasStep(5)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th+th',
                        stepId: 'step5',
                        order: 5,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3ResColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }

                if (!tourResidents.hasStep(6)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th+th+th',
                        stepId: 'step6',
                        order: 6,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3AppColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }
            } else {
                if (!tourResidents.hasStep(3)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th',
                        stepId: 'step3',
                        order: 3,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3DelColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }
                if (!tourResidents.hasStep(4)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th+th',
                        stepId: 'step4',
                        order: 4,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3AbsentColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }
                if (!tourResidents.hasStep(5)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th+th+th',
                        stepId: 'step5',
                        order: 5,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3ResColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }
                if (!tourResidents.hasStep(6)) {
                    tourResidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th+th+th+th',
                        stepId: 'step6',
                        order: 6,
                        title: TranslationService.tour.residents.title,
                        content: TranslationService.tour.residents.step3AppColumn,
                        placement: 'left',
                        appendToBody: true
                    });
                }
            }

            if (!tourResidents.hasStep(7)) {
                tourResidents.createStep({
                    selector: '.firstListRow',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step4TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourResidents.hasStep(8) && PermissionsService.gotPermission('RESIDENT', 'update')) {
                tourResidents.createStep({
                    selector: '.firstListRow .fa-pencil',
                    stepId: 'step8',
                    order: 8,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step5TableEditButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourResidents.hasStep(9) && PermissionsService.gotPermission('RESIDENT', 'delete')) {
                tourResidents.createStep({
                    selector: '.firstListRow .fa-trash-o',
                    stepId: 'step9',
                    order: 9,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step6TableDeleteButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourResidents.hasStep(10)) {
                tourResidents.createStep({
                    selector: '#totalItems',
                    stepId: 'step10',
                    order: 10,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step7TableTotalItems,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourResidents.hasStep(11) && PermissionsService.gotPermission('RESIDENT', 'update')) {
                tourResidents.createStep({
                    selector: '#newResidentButton',
                    stepId: 'step11',
                    order: 11,
                    title: TranslationService.tour.residents.title,
                    content: TranslationService.tour.residents.step8TableNewButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourResidents.hasStep(12)) {
                tourResidents.createStep({
                    selector: 'body',
                    stepId: 'step12',
                    order: 12,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }

            tourResidents.on('stepChanged', function (data) {
                if (data.stepId === 'step12') {
                    $rootScope.$emit('openResidentDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourResidents.hasStep(13)) {
                            tourResidents.createStep({
                                selector: '#residentDetail',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step10ResidentDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        tourResidents.next();
                        if (!tourResidents.hasStep(14)) {
                            tourResidents.createStep({
                                selector: '#residentresidentDetailImg',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step11ResidentDetailImg,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourResidents.hasStep(15)) {
                            tourResidents.createStep({
                                selector: '#residentDetailTooltip',
                                stepId: 'step15',
                                order: 15,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step12ResidentDetailTooltip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }

                        if (!tourResidents.hasStep(16)) {
                            tourResidents.createStep({
                                selector: '#residentDetailRoom',
                                stepId: 'step16',
                                order: 16,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step17ResidentDetailRoom,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }


                        if (!tourResidents.hasStep(17)) {
                            tourResidents.createStep({
                                selector: '#residentDetailIdentification',
                                stepId: 'step17',
                                order: 17,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step13ResidentDetailIdentification,
                                placement: 'right',
                                appendToBody: true
                            });
                        }

                        if (!tourResidents.hasStep(18)) {
                            tourResidents.createStep({
                                selector: '#residentDetailContactInfo',
                                stepId: 'step18',
                                order: 18,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step17ResidentDetailContactInfo,
                                placement: 'top',
                                appendToBody: true
                            });
                        }

                        /**if (!tourResidents.hasStep(19)) {
                            tourResidents.createStep({
                                selector: '#residentDetailOtherInfo',
                                stepId: 'step19',
                                order: 19,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step17ResidentDetailOtherInfo,
                                placement: 'bottom-right',
                                appendToBody: true
                            });
                        }

                         if (!tourResidents.hasStep(20)) {
                            tourResidents.createStep({
                                selector: '#residentDetailStays',
                                stepId: 'step20',
                                order: 20,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step14ResidentDetailStays,
                                placement: 'top-right',
                                appendToBody: true
                            });
                        }


                         if (!tourResidents.hasStep(21)) {
                            tourResidents.createStep({
                                selector: '#residentDetailHistory',
                                stepId: 'step21',
                                order: 21,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step17ResidentDetailHistory,
                                placement: 'top-right',
                                appendToBody: true
                            });
                        } **/
                        if (!tourResidents.hasStep(22)) {
                            tourResidents.createStep({
                                selector: '#residentDetailCancel',
                                stepId: 'step22',
                                order: 22,
                                title: TranslationService.tour.residents.title,
                                content: TranslationService.tour.residents.step15ResidentDetailCancelButton,
                                placement: 'top-right',
                                appendToBody: true
                            });
                        }
                        if (!tourResidents.hasStep(23)) {
                            tourResidents.createStep({
                                selector: 'body',
                                stepId: 'step23',
                                order: 23,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);

                    tourResidents.on('stepChanged', function (data) {
                        if (data.stepId === 'step23') {
                            $rootScope.$emit('closeResidentDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourResidents.hasStep(24)) {
                                    tourResidents.createStep({
                                        selector: '.resumeTourContainer span',
                                        stepId: 'step24',
                                        order: 24,
                                        title: TranslationService.tour.residents.title,
                                        content: TranslationService.tour.residents.step17ResumeTourButton,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourResidents.next();
                            }, 500);
                        }
                    });
                }
            });

            var unbindResidentsWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    if ($location.path() === '/residents') {
                        tourResidents.end();
                        return $$q.promise;
                    }
                });
            // Save into DB
            tourResidents.on('ended', function () {
                $log.debug('Residents tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'APPUSER': true}
                }, function (data) {
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindResidentsWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourResidents.start();

            return $$q.promise;
        };

        vm.shouldShowResidentsTour = function () {
            var userTours = localStorageService.get('tours');
            return !userTours.APPUSER;
        };

        vm.initAnnouncementsTour = function () {
            var $$q = $q.defer();
            var userBranch = localStorageService.get('branches');
            var oneBranchMode = (userBranch.length === 1);

            var tourAnnouncements = uiTourService.createDetachedTour('tourAnnouncements', {
                name: 'tourAnnouncements',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourAnnouncementsTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourAnnouncements.hasStep(0)) {
                tourAnnouncements.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.announcements.title,
                    content: TranslationService.tour.announcements.step0Welcome,
                    orphan: true,
                    appendToBody: true

                });
            }
            if (!tourAnnouncements.hasStep(1)) {
                tourAnnouncements.createStep({
                    selector: '#announcementsList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.announcements.title,
                    content: TranslationService.tour.announcements.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAnnouncements.hasStep(2)) {
                tourAnnouncements.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.announcements.title,
                    content: TranslationService.tour.announcements.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (oneBranchMode) {
                if ((!tourAnnouncements.hasStep(3)) &&
                    ($('#tableParams .ng-table-sort-header > th+th+th+th+th').length > 0)) {
                    tourAnnouncements.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th',
                        stepId: 'step3',
                        order: 3,
                        title: TranslationService.tour.announcements.title,
                        content: TranslationService.tour.announcements.step3RelatedColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
                if ((!tourAnnouncements.hasStep(4)) &&
                    ($('#tableParams .ng-table-sort-header > th+th+th+th+th+th').length > 0)) {
                    tourAnnouncements.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th',
                        stepId: 'step4',
                        order: 4,
                        title: TranslationService.tour.announcements.title,
                        content: TranslationService.tour.announcements.step4PushColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
            } else {
                if ((!tourAnnouncements.hasStep(3)) &&
                    ($('#tableParams .ng-table-sort-header > th+th+th+th+th+th').length > 0)) {
                    tourAnnouncements.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th',
                        stepId: 'step3',
                        order: 3,
                        title: TranslationService.tour.announcements.title,
                        content: TranslationService.tour.announcements.step3RelatedColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
                if ((!tourAnnouncements.hasStep(4)) &&
                    ($('#tableParams .ng-table-sort-header > th+th+th+th+th+th+th').length > 0)) {
                    tourAnnouncements.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th',
                        stepId: 'step4',
                        order: 4,
                        title: TranslationService.tour.announcements.title,
                        content: TranslationService.tour.announcements.step4PushColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
            }

            if (!tourAnnouncements.hasStep(5)) {
                tourAnnouncements.createStep({
                    selector: '.firstListRow',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.announcements.title,
                    content: TranslationService.tour.announcements.step5TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAnnouncements.hasStep(6)) {
                tourAnnouncements.createStep({
                    selector: '#totalItems',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.announcements.title,
                    content: TranslationService.tour.announcements.step6TableTotalItems,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAnnouncements.hasStep(7) && PermissionsService.gotPermission('NOTICE', 'update')) {
                tourAnnouncements.createStep({
                    selector: '#newAnnouncementButton',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.announcements.title,
                    content: TranslationService.tour.announcements.step7TableNewButton,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAnnouncements.hasStep(8)) {
                tourAnnouncements.createStep({
                    selector: 'body',
                    stepId: 'step8',
                    order: 8,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }

            tourAnnouncements.on('stepChanged', function (data) {
                if (data.stepId === 'step8') {
                    $rootScope.$emit('openAnnouncementDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourAnnouncements.hasStep(9)) {
                            tourAnnouncements.createStep({
                                selector: '#acessappRightPanel',
                                stepId: 'step9',
                                order: 9,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step9AnnouncementDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        tourAnnouncements.next();
                        if (!tourAnnouncements.hasStep(10)) {
                            tourAnnouncements.createStep({
                                selector: '#announcementDetailPlaces',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step10AnnouncementDetailPlaces,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAnnouncements.hasStep(11)) {
                            tourAnnouncements.createStep({
                                selector: '#announcementDetailGlobal .switcher.primary',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step11AnnouncementDetailGlobal,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAnnouncements.hasStep(12)) {
                            tourAnnouncements.createStep({
                                selector: '#announcementDetailResidents',
                                stepId: 'step12',
                                order: 12,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step12AnnouncementDetailResidents,
                                placement: 'top-right',
                                appendToBody: true
                            });
                        }
                        if (!tourAnnouncements.hasStep(13)) {
                            tourAnnouncements.createStep({
                                selector: '#announcementDetailTitle',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step13AnnouncementDetailTitle,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAnnouncements.hasStep(14)) {
                            tourAnnouncements.createStep({
                                selector: '#announcementDetailBody',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step14AnnouncementDetailBody,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAnnouncements.hasStep(15)) {
                            tourAnnouncements.createStep({
                                selector: '#announcementDetailPush .switcher.primary',
                                stepId: 'step15',
                                order: 15,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step15AnnouncementDetailPush,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAnnouncements.hasStep(16)) {
                            tourAnnouncements.createStep({
                                selector: '#announcementDetailCancel',
                                stepId: 'step16',
                                order: 16,
                                title: TranslationService.tour.announcements.title,
                                content: TranslationService.tour.announcements.step16AnnouncementDetailCancel,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourAnnouncements.hasStep(17)) {
                            tourAnnouncements.createStep({
                                selector: 'body',
                                stepId: 'step17',
                                order: 17,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);

                    tourAnnouncements.on('stepChanged', function (data) {
                        if (data.stepId === 'step17') {
                            $rootScope.$emit('closeAnnouncementDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourAnnouncements.hasStep(18)) {
                                    tourAnnouncements.createStep({
                                        selector: '.resumeTourContainer span',
                                        stepId: 'step18',
                                        order: 18,
                                        title: TranslationService.tour.announcements.title,
                                        content: TranslationService.tour.announcements.step18ResumeTourButton,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourAnnouncements.next();
                            }, 500);
                        }
                    });
                }
            });
            var unbindAnnouncementsWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourAnnouncements.end();
                    return $$q.promise;
                });

            // Save into DB
            tourAnnouncements.on('ended', function () {
                $log.debug('Announcements tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'NOTICE': true}
                }, function (data) {
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindAnnouncementsWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourAnnouncements.start();

            return $$q.promise;
        };

        vm.shouldShowAnnouncementsTour = function () {
            var userTours = localStorageService.get('tours');
            return !userTours.NOTICE;
        };

        vm.initMenuTour = function () {
            var $$q = $q.defer();

            var tourMenu = uiTourService.createDetachedTour('tourMenu', {
                name: 'tourMenu',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourMenuTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourMenu.hasStep(0)) {
                tourMenu.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step0Welcome,
                    orphan: true,
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(1)) {
                tourMenu.createStep({
                    selector: '#menuList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(2)) {
                tourMenu.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(3)) {
                tourMenu.createStep({
                    selector: '#menuUserRemark',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step3Comments,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(4)) {
                tourMenu.createStep({
                    selector: '#menuSactive',
                    stepId: 'step4',
                    order: 4,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step4StatusColumn,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(5)) {
                tourMenu.createStep({
                    selector: '.firstListRow',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step5TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(6)) {
                tourMenu.createStep({
                    selector: '#totalItems',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step6TableTotalItems,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(7) && PermissionsService.gotPermission('MENU', 'update')) {
                tourMenu.createStep({
                    selector: '#newMenuButton',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.menu.title,
                    content: TranslationService.tour.menu.step7TableNewButton,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourMenu.hasStep(8)) {
                tourMenu.createStep({
                    selector: 'body',
                    stepId: 'step8',
                    order: 8,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourMenu.on('stepChanged', function (data) {
                if (data.stepId === 'step8') {
                    $rootScope.$emit('openMenuDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourMenu.hasStep(9)) {
                            tourMenu.createStep({
                                selector: '#carteendetail',
                                stepId: 'step9',
                                order: 9,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step9MenuDetail,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        tourMenu.next();
                        if (!tourMenu.hasStep(10)) {
                            tourMenu.createStep({
                                selector: '#menuDetailDateFrom input',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step10MenuDetailDateFrom,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(11)) {
                            tourMenu.createStep({
                                selector: '#menuDetailDateTo input',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step11MenuDetailDateTo,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(12)) {
                            tourMenu.createStep({
                                selector: '#menuDetailPlaces',
                                stepId: 'step12',
                                order: 12,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step12MenuDetailPlace,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(13)) {
                            tourMenu.createStep({
                                selector: '#menuDetailType',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step13MenuDetailType,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(14)) {
                            tourMenu.createStep({
                                selector: '#reserveMenuButton',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step14MenuDetailReserve,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(15)) {
                            tourMenu.createStep({
                                selector: '#pendingMenuButton',
                                stepId: 'step15',
                                order: 15,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step15MenuDetailPending,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(16)) {
                            tourMenu.createStep({
                                selector: '#menuDetailFields',
                                stepId: 'step16',
                                order: 16,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step16MenuDetailGroupInputs,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(17) && PermissionsService.gotPermission('MENU', 'update')) {
                            tourMenu.createStep({
                                selector: '#firstDish .addDishButton',
                                stepId: 'step17',
                                order: 17,
                                title: TranslationService.tour.menu.title,
                                content: TranslationService.tour.menu.step17MenuDetailPlusDish,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourMenu.hasStep(18) && PermissionsService.gotPermission('MENU', 'update')) {
                            tourMenu.createStep({
                                selector: 'body',
                                stepId: 'step18',
                                order: 18,
                                placement: 'top',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);
                    tourMenu.on('stepChanged', function (data) {
                        if (data.stepId === 'step18' && PermissionsService.gotPermission('MENU', 'update')) {
                            $rootScope.$emit('openNewDish');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourMenu.hasStep(19)) {
                                    tourMenu.createStep({
                                        selector: '#dishSearch',
                                        stepId: 'step19',
                                        order: 19,
                                        title: TranslationService.tour.menu.title,
                                        content: TranslationService.tour.menu.step19MenuSelectSearch,
                                        placement: 'top-left',
                                        appendToBody: true
                                    });
                                }
                                tourMenu.next();
                                if (!tourMenu.hasStep(20)) {
                                    tourMenu.createStep({
                                        selector: '#dishTypeFilter > button',
                                        stepId: 'step20',
                                        order: 20,
                                        title: TranslationService.tour.menu.title,
                                        content: TranslationService.tour.menu.step20MenuSelectType,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                if (!tourMenu.hasStep(21)) {
                                    tourMenu.createStep({
                                        selector: '.cartenSelectCourseAllergens',
                                        stepId: 'step21',
                                        order: 21,
                                        title: TranslationService.tour.menu.title,
                                        content: TranslationService.tour.menu.step21MenuSelectAllergen,
                                        placement: 'right',
                                        appendToBody: true
                                    });
                                }
                                if (!tourMenu.hasStep(22)) {
                                    tourMenu.createStep({
                                        selector: '.dishes > in-dish-com .inDish',
                                        stepId: 'step22',
                                        order: 22,
                                        title: TranslationService.tour.menu.title,
                                        content: TranslationService.tour.menu.step22MenuSelectDish,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                if (!tourMenu.hasStep(22)) {
                                    tourMenu.createStep({
                                        selector: '.dishes > in-dish-com .inDish .fa-pencil-square-o',
                                        stepId: 'step23',
                                        order: 23,
                                        title: TranslationService.tour.menu.title,
                                        content: TranslationService.tour.menu.step23MenuSelectEdit,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                if (!tourMenu.hasStep(24)) {
                                    tourMenu.createStep({
                                        selector: '#newDish',
                                        stepId: 'step24',
                                        order: 24,
                                        title: TranslationService.tour.menu.title,
                                        content: TranslationService.tour.menu.step24MenuSelectNewButton,
                                        placement: 'left',
                                        appendToBody: true
                                    });
                                }
                                if (!tourMenu.hasStep(25)) {
                                    tourMenu.createStep({
                                        selector: 'body',
                                        stepId: 'step25',
                                        order: 25,
                                        placement: 'top',
                                        appendToBody: false,
                                        backdropZIndex: -1
                                    });
                                }
                            }, 1000);
                            tourMenu.on('stepChanged', function (data) {
                                if (data.stepId === 'step25') {
                                    $rootScope.$emit('openCreateNewDish');
                                    $timeout(function () {
                                        $rootScope.$broadcast('disableClickEvents');
                                        if (!tourMenu.hasStep(26)) {
                                            tourMenu.createStep({
                                                selector: '#newDishImg',
                                                stepId: 'step26',
                                                order: 26,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step26MenuNewDishImg,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        tourMenu.next();
                                        if (!tourMenu.hasStep(27)) {
                                            tourMenu.createStep({
                                                selector: '#newDishType > label',
                                                stepId: 'step27',
                                                order: 27,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step27MenuNewDishType,
                                                placement: 'left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourMenu.hasStep(28)) {
                                            tourMenu.createStep({
                                                selector: '#newDishAllergen',
                                                stepId: 'step28',
                                                order: 28,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step28MenuNewDishAllergen,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourMenu.hasStep(29)) {
                                            tourMenu.createStep({
                                                selector: '#newDishName input',
                                                stepId: 'step29',
                                                order: 29,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step29MenuNewDishTitle,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourMenu.hasStep(30)) {
                                            tourMenu.createStep({
                                                selector: '#newDishKal',
                                                stepId: 'step30',
                                                order: 30,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step30MenuNewDishKal,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourMenu.hasStep(31)) {
                                            tourMenu.createStep({
                                                selector: '#newDishTags',
                                                stepId: 'step31',
                                                order: 31,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step31MenuNewDishTags,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourMenu.hasStep(32)) {
                                            tourMenu.createStep({
                                                selector: '#newDishSave',
                                                stepId: 'step32',
                                                order: 32,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step32MenuNewDishSave,
                                                placement: 'left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourMenu.hasStep(33)) {
                                            tourMenu.createStep({
                                                selector: '#newDishCancel',
                                                stepId: 'step33',
                                                order: 33,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step33MenuNewDishBack,
                                                placement: 'left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourMenu.hasStep(34)) {
                                            tourMenu.createStep({
                                                selector: 'body',
                                                stepId: 'step34',
                                                order: 34,
                                                placement: 'bottom-left',
                                                appendToBody: false,
                                                backdropZIndex: -1
                                            });
                                        }
                                    }, 1000);
                                    tourMenu.on('stepChanged', function (data) {
                                        if (data.stepId === 'step34') {
                                            $rootScope.$emit('cancelCreateNewDish');
                                            $timeout(function () {
                                                $rootScope.$broadcast('disableClickEvents');
                                                if (!tourMenu.hasStep(35)) {
                                                    tourMenu.createStep({
                                                        selector: '.dishes > in-dish-com .inDish',
                                                        stepId: 'step35',
                                                        order: 35,
                                                        title: TranslationService.tour.menu.title,
                                                        content: TranslationService.tour.menu.step35MenuSelectAddDish,
                                                        placement: 'bottom-left',
                                                        appendToBody: true
                                                    });
                                                }
                                                tourMenu.next();
                                                if (!tourMenu.hasStep(36)) {
                                                    tourMenu.createStep({
                                                        selector: 'body',
                                                        stepId: 'step36',
                                                        order: 36,
                                                        placement: 'bottom-left',
                                                        appendToBody: false,
                                                        backdropZIndex: -1
                                                    });
                                                }
                                            }, 500);
                                            tourMenu.on('stepChanged', function (data) {
                                                if (data.stepId === 'step36') {
                                                    $rootScope.$emit('addNewDish');
                                                    $timeout(function () {
                                                        $rootScope.$broadcast('disableClickEvents');
                                                        if (!tourMenu.hasStep(37)) {
                                                            tourMenu.createStep({
                                                                selector: '#newDishBack',
                                                                stepId: 'step37',
                                                                order: 37,
                                                                title: TranslationService.tour.menu.title,
                                                                content: TranslationService.tour.menu.step37MenuSelectBack,
                                                                placement: 'left',
                                                                appendToBody: true
                                                            });
                                                        }
                                                        tourMenu.next();
                                                        if (!tourMenu.hasStep(38)) {
                                                            tourMenu.createStep({
                                                                selector: 'body',
                                                                stepId: 'step38',
                                                                order: 38,
                                                                placement: 'bottom-left',
                                                                appendToBody: false,
                                                                backdropZIndex: -1
                                                            });
                                                        }
                                                    }, 500);
                                                    tourMenu.on('stepChanged', function (data) {
                                                        if (data.stepId === 'step38') {
                                                            $rootScope.$emit('backCreateNewDish');
                                                            $timeout(function () {
                                                                $rootScope.$broadcast('disableClickEvents');
                                                                if (!tourMenu.hasStep(39)) {
                                                                    tourMenu.createStep({
                                                                        selector: '#firstDish',
                                                                        stepId: 'step39',
                                                                        order: 39,
                                                                        title: TranslationService.tour.menu.title,
                                                                        content: TranslationService.tour.menu.step39MenuDetailFirstDish,
                                                                        placement: 'bottom-left',
                                                                        appendToBody: true
                                                                    });
                                                                }
                                                                tourMenu.next();
                                                                if (!tourMenu.hasStep(40)) {
                                                                    tourMenu.createStep({
                                                                        selector: '#secondDish .addDishButton',
                                                                        stepId: 'step40',
                                                                        order: 40,
                                                                        title: TranslationService.tour.menu.title,
                                                                        content: TranslationService.tour.menu.step40MenuDetailAddSecond,
                                                                        placement: 'right',
                                                                        appendToBody: true
                                                                    });
                                                                }
                                                                if (!tourMenu.hasStep(41)) {
                                                                    tourMenu.createStep({
                                                                        selector: '#dessertDish .addDishButton',
                                                                        stepId: 'step41',
                                                                        order: 41,
                                                                        title: TranslationService.tour.menu.title,
                                                                        content: TranslationService.tour.menu.step41MenuDetailAddDessert,
                                                                        placement: 'right',
                                                                        appendToBody: true
                                                                    });
                                                                }
                                                                if (!tourMenu.hasStep(42)) {
                                                                    tourMenu.createStep({
                                                                        selector: 'div .ion-minus-circled.inDishIcon.delete',
                                                                        stepId: 'step42',
                                                                        order: 42,
                                                                        title: TranslationService.tour.menu.title,
                                                                        content: TranslationService.tour.menu.step42MenuDetailEdit,
                                                                        placement: 'bottom-left',
                                                                        appendToBody: true
                                                                    });
                                                                }
                                                                if (!tourMenu.hasStep(43)) {
                                                                    tourMenu.createStep({
                                                                        selector: '#carteendetail #printReports',
                                                                        stepId: 'step43',
                                                                        order: 43,
                                                                        title: TranslationService.tour.menu.title,
                                                                        content: TranslationService.tour.menu.step42MenuDetailPrintReport,
                                                                        placement: 'bottom-left',
                                                                        appendToBody: true
                                                                    });
                                                                }
                                                                if (!tourMenu.hasStep(44)) {
                                                                    tourMenu.createStep({
                                                                        selector: '#carteendetail #saveMenuChanges',
                                                                        stepId: 'step44',
                                                                        order: 44,
                                                                        title: TranslationService.tour.menu.title,
                                                                        content: TranslationService.tour.menu.step43MenuDetailSave,
                                                                        placement: 'left',
                                                                        appendToBody: true
                                                                    });
                                                                }
                                                                if (!tourMenu.hasStep(45)) {
                                                                    tourMenu.createStep({
                                                                        selector: '#carteendetail #cancelMenuChanges',
                                                                        stepId: 'step45',
                                                                        order: 45,
                                                                        title: TranslationService.tour.menu.title,
                                                                        content: TranslationService.tour.menu.step44MenuDetailBack,
                                                                        placement: 'left',
                                                                        appendToBody: true
                                                                    });
                                                                }
                                                                if (!tourMenu.hasStep(46)) {
                                                                    tourMenu.createStep({
                                                                        selector: 'body',
                                                                        stepId: 'step46',
                                                                        order: 46,
                                                                        placement: 'bottom-left',
                                                                        appendToBody: false,
                                                                        backdropZIndex: -1
                                                                    });
                                                                }
                                                            }, 1000);
                                                            tourMenu.on('stepChanged', function (data) {
                                                                if (data.stepId === 'step46') {
                                                                    $rootScope.$emit('closeNewDish');
                                                                    $timeout(function () {
                                                                        $rootScope.$broadcast('disableClickEvents');
                                                                        if (!tourMenu.hasStep(47)) {
                                                                            tourMenu.createStep({
                                                                                selector: '.resumeTourContainer span',
                                                                                stepId: 'step47',
                                                                                order: 47,
                                                                                title: TranslationService.tour.menu.title,
                                                                                content: TranslationService.tour.menu.step46ResumeTourButton,
                                                                                placement: 'bottom-left',
                                                                                appendToBody: true
                                                                            });
                                                                        }
                                                                        tourMenu.next();
                                                                    }, 500);
                                                                }
                                                            });
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        } else if (data.stepId === 'step14' && !PermissionsService.gotPermission('MENU', 'update')) {
                            if (!tourMenu.hasStep(42)) {
                                tourMenu.createStep({
                                    selector: '#carteendetail #cancelMenuChanges',
                                    stepId: 'step42',
                                    order: 42,
                                    title: TranslationService.tour.menu.title,
                                    content: TranslationService.tour.menu.step42MenuDetailBack,
                                    placement: 'left',
                                    appendToBody: true
                                });
                            }

                            if (!tourMenu.hasStep(43)) {
                                tourMenu.createStep({
                                    selector: 'body',
                                    stepId: 'step43',
                                    order: 43,
                                    placement: 'bottom-left',
                                    appendToBody: false,
                                    backdropZIndex: -1
                                });
                            }
                            tourMenu.on('stepChanged', function (data) {
                                if (data.stepId === 'step43') {
                                    $rootScope.$emit('closeNewDish');
                                    $timeout(function () {
                                        $rootScope.$broadcast('disableClickEvents');
                                        if (!tourMenu.hasStep(44)) {
                                            tourMenu.createStep({
                                                selector: '.resumeTourContainer span',
                                                stepId: 'step44',
                                                order: 44,
                                                title: TranslationService.tour.menu.title,
                                                content: TranslationService.tour.menu.step44ResumeTourButton,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        tourMenu.next();
                                    }, 500);
                                }
                            });
                        }
                    });
                }
            });
            var unbindMenuWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourMenu.end();
                    return $$q.promise;
                });
            // Save into DB
            tourMenu.on('ended', function () {
                $log.debug('Menu tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'MENU': true}
                }, function (data) {
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindMenuWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourMenu.start();

            return $$q.promise;
        };

        vm.shouldShowMenuTour = function () {
            var userTours = localStorageService.get('tours');
            return !userTours.MENU;
        };

        vm.initServicesTour = function () {
            var $$q = $q.defer();
            var userBranch = localStorageService.get('branches');
            var oneBranchMode = (userBranch.length === 1);

            var tourServices = uiTourService.createDetachedTour('tourServices', {
                name: 'tourServices',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourServicesTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourServices.hasStep(0)) {
                tourServices.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step0Welcome,
                    orphan: true,
                    appendToBody: true

                });
            }
            if (!tourServices.hasStep(1)) {
                tourServices.createStep({
                    selector: '#servicesList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(2)) {
                tourServices.createStep({
                    selector: '#servicesScheduler',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step2Scheduler,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(3)) {
                tourServices.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step3Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(4)) {
                tourServices.createStep({
                    selector: '.firstListRow',
                    stepId: 'step5',
                    order: 4,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step4TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(5) && PermissionsService.gotPermission('SERVICE', 'update')) {
                tourServices.createStep({
                    selector: '.firstListRow .fa-pencil',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step5TableEditButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(6) && PermissionsService.gotPermission('SERVICE', 'delete')) {
                tourServices.createStep({
                    selector: '.firstListRow .fa-trash-o',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step6TableDeleteButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(7)) {
                tourServices.createStep({
                    selector: '#totalItems',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step7TableTotalItems,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(8) && PermissionsService.gotPermission('SERVICE', 'update')) {
                tourServices.createStep({
                    selector: '#newServiceButton',
                    stepId: 'step8',
                    order: 8,
                    title: TranslationService.tour.services.title,
                    content: TranslationService.tour.services.step8TableNewButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourServices.hasStep(9)) {
                tourServices.createStep({
                    selector: 'body',
                    stepId: 'step9',
                    order: 9,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourServices.on('stepChanged', function (data) {
                if (data.stepId === 'step9') {
                    $rootScope.$emit('openServiceDetail');
                    $timeout(function () {
                        tourServices.next();
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourServices.hasStep(10) && ($('#serviceDetail').length > 0)) {
                            tourServices.createStep({
                                selector: '#serviceDetail',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.services.title,
                                content: TranslationService.tour.services.step10ServDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }

                        if (!tourServices.hasStep(11) && ($('#serviceDetail').length > 0)) {
                            tourServices.createStep({
                                selector: '#idTootipPlacement',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.services.title,
                                content: TranslationService.tour.services.step11ServDetailTootlip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourServices.hasStep(12) && ($('#serviceDetail').length > 0)) {
                            tourServices.createStep({
                                selector: '.my-timetable',
                                stepId: 'step12',
                                order: 12,
                                title: TranslationService.tour.services.title,
                                content: TranslationService.tour.services.step12ServDetailTimetable,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourServices.hasStep(13) && ($('#serviceDetail').length > 0)) {
                            tourServices.createStep({
                                selector: '#serviceSaveButton',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.services.title,
                                content: TranslationService.tour.services.step13ServDetailSaveButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourServices.hasStep(14) && ($('#serviceDetail').length > 0)) {
                            tourServices.createStep({
                                selector: '#serviceCancelButton',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.services.title,
                                content: TranslationService.tour.services.step14ServDetailCancelButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourServices.hasStep(15)) {
                            tourServices.createStep({
                                selector: 'body',
                                stepId: 'step15',
                                order: 15,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);
                    tourServices.on('stepChanged', function (data) {
                        if (data.stepId === 'step15') {
                            $rootScope.$emit('closeServiceDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourServices.hasStep(16)) {
                                    tourServices.createStep({
                                        selector: '.firstListRow',
                                        stepId: 'step16',
                                        order: 16,
                                        title: TranslationService.tour.services.title,
                                        content: TranslationService.tour.services.step16ServFirstRow,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourServices.next();
                                if (!tourServices.hasStep(17)) {
                                    tourServices.createStep({
                                        selector: 'body',
                                        stepId: 'step17',
                                        order: 17,
                                        placement: 'bottom-left',
                                        appendToBody: false,
                                        backdropZIndex: -1
                                    });
                                }
                            }, 500);
                            tourServices.on('stepChanged', function (data) {
                                if (data.stepId === 'step17') {
                                    //$rootScope.$emit('openIncidentDetailFirstRow');
                                    $rootScope.$emit('openServiceDetailFirstRow');
                                    $timeout(function () {
                                        tourServices.next();
                                        $rootScope.$broadcast('disableClickEvents');
                                        if (!tourServices.hasStep(18) && ($('#servicePush').length > 0)) {
                                            tourServices.createStep({
                                                selector: '#servicePush',
                                                stepId: 'step18',
                                                order: 18,
                                                title: TranslationService.tour.services.title,
                                                content: TranslationService.tour.services.step18ServDetailPush,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourServices.hasStep(19)) {
                                            tourServices.createStep({
                                                selector: 'body',
                                                stepId: 'step19',
                                                order: 19,
                                                placement: 'bottom-left',
                                                appendToBody: false,
                                                backdropZIndex: -1
                                            });
                                        }
                                    }, 1000);
                                    tourServices.on('stepChanged', function (data) {
                                        if (data.stepId === 'step19') {
                                            $rootScope.$emit('closeServiceDetail');
                                            $timeout(function () {
                                                $rootScope.$broadcast('disableClickEvents');
                                                if (!tourServices.hasStep(20)) {
                                                    tourServices.createStep({
                                                        selector: '.resumeTourContainer',
                                                        stepId: 'step20',
                                                        order: 20,
                                                        title: TranslationService.tour.services.title,
                                                        content: TranslationService.tour.services.step20ResumeTourButton,
                                                        placement: 'bottom-left',
                                                        appendToBody: true
                                                    });
                                                }
                                                tourServices.next();
                                            }, 1000);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
            var unbindServicesWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourServices.end();
                    return $$q.promise;
                });

            // Save into DB
            tourServices.on('ended', function () {
                $log.debug('Services tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'SERVICES': true}
                }, function (data) {
                    $log.debug(data);
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindServicesWatcher();
                    $rootScope.$emit('refreshScheduler');
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourServices.start();

            return $$q.promise;
        };

        vm.shouldShowServicesTour = function () {
            var userTours = localStorageService.get('tours');

            return !userTours.SERVICES;
        };

        vm.initWorkerTaskTour = function () {
            var $$q = $q.defer();
            var userBranch = localStorageService.get('branches');
            var oneBranchMode = (userBranch.length === 1);

            var tourWorkerTask = uiTourService.createDetachedTour('tourWorkerTask', {
                name: 'tourWorkerTask',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourWorkerTaskTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourWorkerTask.hasStep(0)) {
                tourWorkerTask.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.workerTask.title,
                    content: TranslationService.tour.workerTask.step0Welcome,
                    orphan: true,
                    appendToBody: true

                });
            }
            if (!tourWorkerTask.hasStep(1)) {
                tourWorkerTask.createStep({
                    selector: '#workerTaskList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.workerTask.title,
                    content: TranslationService.tour.workerTask.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourWorkerTask.hasStep(2)) {
                tourWorkerTask.createStep({
                    selector: '#workerTaskScheduler',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.workerTask.title,
                    content: TranslationService.tour.workerTask.step2Scheduler,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourWorkerTask.hasStep(3)) {
                tourWorkerTask.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.workerTask.title,
                    content: TranslationService.tour.workerTask.step3Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourWorkerTask.hasStep(4)) {
                tourWorkerTask.createStep({
                    selector: '.firstListRow',
                    stepId: 'step5',
                    order: 4,
                    title: TranslationService.tour.workerTask.title,
                    content: TranslationService.tour.workerTask.step4TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourWorkerTask.hasStep(5) && PermissionsService.gotPermission('SERVICE', 'update')) {
                tourWorkerTask.createStep({
                    selector: '.firstListRow .fa-pencil',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.workerTask.title,
                    content: TranslationService.tour.workerTask.step5TableEditButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourWorkerTask.hasStep(9)) {
                tourWorkerTask.createStep({
                    selector: 'body',
                    stepId: 'step9',
                    order: 9,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourWorkerTask.on('stepChanged', function (data) {
                if (data.stepId === 'step9') {
                    $rootScope.$emit('openWorkerTaskDetail');
                    $timeout(function () {
                        tourWorkerTask.next();
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourWorkerTask.hasStep(10) && ($('#workerTaskDetail').length > 0)) {
                            tourWorkerTask.createStep({
                                selector: '#workerTaskDetail',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.workerTask.title,
                                content: TranslationService.tour.workerTask.step10workerTaskDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }

                        if (!tourWorkerTask.hasStep(11) && ($('#workerTaskDetail').length > 0)) {
                            tourWorkerTask.createStep({
                                selector: '#idWTTootipPlacement',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.workerTask.title,
                                content: TranslationService.tour.workerTask.step11workerTaskDetailTootlip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourWorkerTask.hasStep(13) && ($('#workerTaskDetail').length > 0)) {
                            tourWorkerTask.createStep({
                                selector: '#workerTaskSaveButton',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.workerTask.title,
                                content: TranslationService.tour.workerTask.step13workerTaskDetailSaveButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourWorkerTask.hasStep(14) && ($('#workerTaskDetail').length > 0)) {
                            tourWorkerTask.createStep({
                                selector: '#workerTaskCancelButton',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.workerTask.title,
                                content: TranslationService.tour.workerTask.step14workerTaskDetailCancelButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourWorkerTask.hasStep(15)) {
                            tourWorkerTask.createStep({
                                selector: 'body',
                                stepId: 'step15',
                                order: 15,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);

                    tourWorkerTask.on('stepChanged', function (data) {
                        if (data.stepId === 'step15') {
                            $rootScope.$emit('closeWorkerTaskDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourWorkerTask.hasStep(20)) {
                                    tourWorkerTask.createStep({
                                        selector: '.resumeTourContainer',
                                        stepId: 'step20',
                                        order: 20,
                                        title: TranslationService.tour.workerTask.title,
                                        content: TranslationService.tour.workerTask.step20ResumeTourButton,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourWorkerTask.next();
                            }, 1000);
                        }
                    });

                }
            });

            var unbindWorkerTaskWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourWorkerTask.end();
                    return $$q.promise;
                });
            // Save into DB
            tourWorkerTask.on('ended', function () {
                $log.debug('workerTask tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'WORKERTASK': true}
                }, function (data) {
                    $log.debug(data);
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindWorkerTaskWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourWorkerTask.start();

            return $$q.promise;
        };

        vm.shouldShowWorkerTaskTour = function () {
            var userTours = localStorageService.get('tours');

            return !userTours.SCHEDULER;
        };

        vm.initIncidentsTour = function () {
            var $$q = $q.defer();
            var userBranch = localStorageService.get('branches');
            var oneBranchMode = (userBranch.length === 1);

            var tourIncidents = uiTourService.createDetachedTour('tourIncidents', {
                name: 'tourIncidents',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourIncidentsTemplate.html',
                backdropZIndex: 10000
            });
            if (!tourIncidents.hasStep(0)) {
                tourIncidents.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.incidents.title,
                    content: TranslationService.tour.incidents.step0Welcome,
                    orphan: true,
                    appendToBody: true
                });
            }
            if (!tourIncidents.hasStep(1)) {
                tourIncidents.createStep({
                    selector: '#incidentsList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.incidents.title,
                    content: TranslationService.tour.incidents.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourIncidents.hasStep(2)) {
                tourIncidents.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.incidents.title,
                    content: TranslationService.tour.incidents.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (oneBranchMode) {
                if (!tourIncidents.hasStep(3)) {
                    tourIncidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th',
                        stepId: 'step3',
                        order: 3,
                        title: TranslationService.tour.incidents.title,
                        content: TranslationService.tour.incidents.step3PriorityColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
                if (!tourIncidents.hasStep(4)) {
                    tourIncidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th',
                        stepId: 'step4',
                        order: 4,
                        title: TranslationService.tour.incidents.title,
                        content: TranslationService.tour.incidents.step4StatusColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
            } else {
                if (!tourIncidents.hasStep(3)) {
                    tourIncidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th',
                        stepId: 'step3',
                        order: 3,
                        title: TranslationService.tour.incidents.title,
                        content: TranslationService.tour.incidents.step3PriorityColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
                if (!tourIncidents.hasStep(4)) {
                    tourIncidents.createStep({
                        selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th',
                        stepId: 'step4',
                        order: 4,
                        title: TranslationService.tour.incidents.title,
                        content: TranslationService.tour.incidents.step4StatusColumn,
                        placement: 'bottom-left',
                        appendToBody: true
                    });
                }
            }

            if (!tourIncidents.hasStep(5)) {
                tourIncidents.createStep({
                    selector: '.firstListRow',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.incidents.title,
                    content: TranslationService.tour.incidents.step5TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourIncidents.hasStep(6)) {
                tourIncidents.createStep({
                    selector: '#totalItems',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.incidents.title,
                    content: TranslationService.tour.incidents.step6TableTotalItems,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourIncidents.hasStep(7) && PermissionsService.gotPermission('INCIDENT', 'UPDATE')) {
                tourIncidents.createStep({
                    selector: '#newIncidentButton',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.incidents.title,
                    content: TranslationService.tour.incidents.step7TableNewButton,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourIncidents.hasStep(8)) {
                tourIncidents.createStep({
                    selector: 'body',
                    stepId: 'step8',
                    order: 8,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourIncidents.on('stepChanged', function (data) {
                if (data.stepId === 'step8') {
                    $rootScope.$emit('openIncidentDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourIncidents.hasStep(9)) {
                            tourIncidents.createStep({
                                selector: '#incidentDetail',
                                stepId: 'step9',
                                order: 9,
                                title: TranslationService.tour.incidents.title,
                                content: TranslationService.tour.incidents.step9IncidentDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        tourIncidents.next();
                        if (!tourIncidents.hasStep(10)) {
                            tourIncidents.createStep({
                                selector: '#incidentRightCol span',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.incidents.title,
                                content: TranslationService.tour.incidents.step10IncidentDetailTootlip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourIncidents.hasStep(11)) {
                            tourIncidents.createStep({
                                selector: '#incidentName input',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.incidents.title,
                                content: TranslationService.tour.incidents.step11IncidentDetailName,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourIncidents.hasStep(12)) {
                            tourIncidents.createStep({
                                selector: '#priority',
                                stepId: 'step12',
                                order: 12,
                                title: TranslationService.tour.incidents.title,
                                content: TranslationService.tour.incidents.step12IncidentDetailPriority,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourIncidents.hasStep(13)) {
                            tourIncidents.createStep({
                                selector: '#incidentImg',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.incidents.title,
                                content: TranslationService.tour.incidents.step13IncidentDetailImg,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourIncidents.hasStep(14)) {
                            tourIncidents.createStep({
                                selector: '#incidentSaveButton',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.incidents.title,
                                content: TranslationService.tour.incidents.step14IncidentDetailSaveButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourIncidents.hasStep(15)) {
                            tourIncidents.createStep({
                                selector: '#incidentCancelButton',
                                stepId: 'step15',
                                order: 15,
                                title: TranslationService.tour.incidents.title,
                                content: TranslationService.tour.incidents.step15IncidentDetailCancelButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourIncidents.hasStep(16)) {
                            tourIncidents.createStep({
                                selector: 'body',
                                stepId: 'step16',
                                order: 16,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);
                    tourIncidents.on('stepChanged', function (data) {
                        if (data.stepId === 'step16') {
                            $rootScope.$emit('closeIncidentDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourIncidents.hasStep(17)) {
                                    tourIncidents.createStep({
                                        selector: '.firstListRow',
                                        stepId: 'step17',
                                        order: 17,
                                        title: TranslationService.tour.incidents.title,
                                        content: TranslationService.tour.incidents.step17IncidentFirstRow,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourIncidents.next();
                                if (!tourIncidents.hasStep(18)) {
                                    tourIncidents.createStep({
                                        selector: 'body',
                                        stepId: 'step18',
                                        order: 18,
                                        placement: 'bottom-left',
                                        appendToBody: false,
                                        backdropZIndex: -1
                                    });
                                }
                            }, 500);
                            tourIncidents.on('stepChanged', function (data) {
                                if (data.stepId === 'step18') {
                                    $rootScope.$emit('openIncidentDetailFirstRow');
                                    $timeout(function () {
                                        tourIncidents.next();
                                        $rootScope.$broadcast('disableClickEvents');
                                        if (!tourIncidents.hasStep(20)) {
                                            tourIncidents.createStep({
                                                selector: '#incidentNewComment',
                                                stepId: 'step20',
                                                order: 20,
                                                title: TranslationService.tour.incidents.title,
                                                content: TranslationService.tour.incidents.step20IncidentDetailRightCol,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        if ((!tourIncidents.hasStep(21)) &&
                                            ($('#incidentPush > label > .switcher').length > 0)) {
                                            tourIncidents.createStep({
                                                selector: '#incidentPush > label > .switcher',
                                                stepId: 'step21',
                                                order: 21,
                                                title: TranslationService.tour.incidents.title,
                                                content: TranslationService.tour.incidents.step21IncidentDetailPush,
                                                placement: 'bottom-left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourIncidents.hasStep(22)) {
                                            tourIncidents.createStep({
                                                selector: 'body',
                                                stepId: 'step22',
                                                order: 22,
                                                placement: 'bottom-left',
                                                appendToBody: false,
                                                backdropZIndex: -1
                                            });
                                        }
                                    }, 1000);
                                    tourIncidents.on('stepChanged', function (data) {
                                        if (data.stepId === 'step22') {
                                            $rootScope.$emit('closeIncidentDetail');
                                            $timeout(function () {
                                                $rootScope.$broadcast('disableClickEvents');
                                                if ((!tourIncidents.hasStep(23))) {
                                                    tourIncidents.createStep({
                                                        selector: '#tableParams .ng-table-sort-header > th',
                                                        stepId: 'step23',
                                                        order: 23,
                                                        title: TranslationService.tour.incidents.title,
                                                        content: TranslationService.tour.incidents.step22Timeout,
                                                        placement: 'bottom-left',
                                                        appendToBody: true
                                                    });
                                                }
                                                if (!tourIncidents.hasStep(24)) {
                                                    tourIncidents.createStep({
                                                        selector: '.resumeTourContainer',
                                                        stepId: 'step24',
                                                        order: 24,
                                                        title: TranslationService.tour.incidents.title,
                                                        content: TranslationService.tour.incidents.step23ResumeTourButton,
                                                        placement: 'bottom-left',
                                                        appendToBody: true
                                                    });
                                                }
                                                tourIncidents.next();
                                            }, 1000);
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            });
            var unbindIncidentsWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourIncidents.end();
                    return $$q.promise;
                });

            // Save into DB
            tourIncidents.on('ended', function () {
                $log.debug('Incidents tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'INCIDENTS': true}
                }, function (data) {
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindIncidentsWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourIncidents.start();

            return $$q.promise;

        };

        vm.shouldShowIncidentsTour = function () {
            var userTours = localStorageService.get('tours');
            return !userTours.INCIDENTS;
        };

        vm.initAgendaTour = function () {
            var $$q = $q.defer();
            var userBranch = localStorageService.get('branches');

            var tourAgenda = uiTourService.createDetachedTour('tourAgenda', {
                name: 'tourAgenda',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourAgendaTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourAgenda.hasStep(0)) {
                tourAgenda.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step0Welcome,
                    orphan: true,
                    appendToBody: true

                });
            }
            if (!tourAgenda.hasStep(1)) {
                tourAgenda.createStep({
                    selector: '#agendaList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(2)) {
                tourAgenda.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(3)) {
                tourAgenda.createStep({
                    selector: '.ng-table-counts',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step3Footer,
                    placement: 'top',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(4)) {
                tourAgenda.createStep({
                    selector: '.firstListRow',
                    stepId: 'step4',
                    order: 4,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step4TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(5) && PermissionsService.gotPermission('AGENDA', 'update')) {
                tourAgenda.createStep({
                    selector: '.firstListRow .fa-pencil',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step5TableEditButton,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(6) && PermissionsService.gotPermission('AGENDA', 'delete')) {
                tourAgenda.createStep({
                    selector: '.firstListRow .fa-trash-o',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step6TableDeleteButton,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(7)) {
                tourAgenda.createStep({
                    selector: '#totalItems',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step7TableTotalItems,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(8) && PermissionsService.gotPermission('AGENDA', 'update')) {
                tourAgenda.createStep({
                    selector: '#newAgendaButton',
                    stepId: 'step8',
                    order: 8,
                    title: TranslationService.tour.agenda.title,
                    content: TranslationService.tour.agenda.step8TableNewButton,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAgenda.hasStep(9)) {
                tourAgenda.createStep({
                    selector: 'body',
                    stepId: 'step9',
                    order: 9,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourAgenda.on('stepChanged', function (data) {
                if (data.stepId === 'step9') {
                    $rootScope.$emit('openAgendaDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourAgenda.hasStep(10)) {
                            tourAgenda.createStep({
                                selector: '#agendaDetail',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.agenda.title,
                                content: TranslationService.tour.agenda.step10AgendaDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        tourAgenda.next();
                        if (!tourAgenda.hasStep(11)) {
                            tourAgenda.createStep({
                                selector: '.input-group > span',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.agenda.title,
                                content: TranslationService.tour.agenda.step11AgendaDetailTootlip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAgenda.hasStep(12)) {
                            tourAgenda.createStep({
                                selector: 'input[name="visibleTo"]',
                                stepId: 'step11',
                                order: 12,
                                title: TranslationService.tour.agenda.title,
                                content: TranslationService.tour.agenda.step12AgendaDetailVisible,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAgenda.hasStep(13)) {
                            tourAgenda.createStep({
                                selector: 'input[name="dateLimit"]',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.agenda.title,
                                content: TranslationService.tour.agenda.step13AgendaDetailLimitDate,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourAgenda.hasStep(14)) {
                            tourAgenda.createStep({
                                selector: '#agendaSaveButton',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.agenda.title,
                                content: TranslationService.tour.agenda.step14AgendaDetailSaveButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourAgenda.hasStep(15)) {
                            tourAgenda.createStep({
                                selector: '#agendaCancelButton',
                                stepId: 'step15',
                                order: 15,
                                title: TranslationService.tour.agenda.title,
                                content: TranslationService.tour.agenda.step15AgendaDetailCancelButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourAgenda.hasStep(16)) {
                            tourAgenda.createStep({
                                selector: 'body',
                                stepId: 'step16',
                                order: 16,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);
                    tourAgenda.on('stepChanged', function (data) {
                        if (data.stepId === 'step16') {
                            $rootScope.$emit('closeAgendaDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourAgenda.hasStep(17)) {
                                    tourAgenda.createStep({
                                        selector: '.resumeTourContainer',
                                        stepId: 'step17',
                                        order: 17,
                                        title: TranslationService.tour.agenda.title,
                                        content: TranslationService.tour.agenda.step17ResumeTourButton,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourAgenda.next();
                            }, 1000);
                        }
                    });
                }
            });
            var unbindAgendaWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourAgenda.end();
                    return $$q.promise;
                });
            // Save into DB
            tourAgenda.on('ended', function () {
                $log.debug('Agenda tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'AGENDA': true}
                }, function (data) {
                    $log.debug(data);
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindAgendaWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourAgenda.start();

            return $$q.promise;

        };

        vm.shouldShowAgendaTour = function () {
            var userTours = localStorageService.get('tours');

            return !userTours.AGENDA;
        };

        vm.initUsersTour = function () {
            var $$q = $q.defer();

            var tourUsers = uiTourService.createDetachedTour('tourUsers', {
                name: 'tourUsers',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourUsersTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourUsers.hasStep(0)) {
                tourUsers.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step0Welcome,
                    orphan: true,
                    appendToBody: true

                });
            }
            if (!tourUsers.hasStep(1)) {
                tourUsers.createStep({
                    selector: '#usersList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(2)) {
                tourUsers.createStep({
                    selector: '#tableParam > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(3)) {
                tourUsers.createStep({
                    selector: '.ng-table-pager',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step3Footer,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(4)) {
                tourUsers.createStep({
                    selector: '.firstListRow',
                    stepId: 'step4',
                    order: 4,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step4TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(5) && PermissionsService.gotPermission('USER', 'update')) {
                tourUsers.createStep({
                    selector: '.firstListRow .fa-pencil',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step5TableEditButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(6) && PermissionsService.gotPermission('USER', 'delete')) {
                tourUsers.createStep({
                    selector: '.firstListRow .fa-trash-o',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step6TableDeleteButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(7)) {
                tourUsers.createStep({
                    selector: '#totalItems',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step7TableTotalItems,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(8) && PermissionsService.gotPermission('USER', 'update')) {
                tourUsers.createStep({
                    selector: '#newUsersButton',
                    stepId: 'step8',
                    order: 8,
                    title: TranslationService.tour.users.title,
                    content: TranslationService.tour.users.step8TableNewButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourUsers.hasStep(9)) {
                tourUsers.createStep({
                    selector: 'body',
                    stepId: 'step9',
                    order: 9,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourUsers.on('stepChanged', function (data) {
                if (data.stepId === 'step9') {
                    $rootScope.$emit('openUsersDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourUsers.hasStep(10) && ($('#usersDetail').length > 0)) {
                            tourUsers.createStep({
                                selector: '#usersDetail',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.users.title,
                                content: TranslationService.tour.users.step10UsersDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        tourUsers.next();
                        if (!tourUsers.hasStep(11) && ($('#usersDetail').length > 0)) {
                            tourUsers.createStep({
                                selector: '.avatar-main',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.users.title,
                                content: TranslationService.tour.users.step11UsersDetailImage,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourUsers.hasStep(12) && ($('#usersDetail').length > 0)) {
                            tourUsers.createStep({
                                selector: '.input-group',
                                stepId: 'step12',
                                order: 12,
                                title: TranslationService.tour.users.title,
                                content: TranslationService.tour.users.step12UsersDetailResidencias,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourUsers.hasStep(13) && ($('#usersDetail').length > 0)) {
                            tourUsers.createStep({
                                selector: 'input[name="name"]',
                                stepId: 'step13',
                                order: 13,
                                title: TranslationService.tour.users.title,
                                content: TranslationService.tour.users.step13UsersDetailTootlip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourUsers.hasStep(14) && ($('#usersDetail').length > 0)) {
                            tourUsers.createStep({
                                selector: 'input[name="email"]',
                                stepId: 'step14',
                                order: 14,
                                title: TranslationService.tour.users.title,
                                content: TranslationService.tour.users.step14UsersDetailEmail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourUsers.hasStep(15) && ($('#usersDetail').length > 0)) {
                            tourUsers.createStep({
                                selector: '#usersSaveButton',
                                stepId: 'step15',
                                order: 15,
                                title: TranslationService.tour.users.title,
                                content: TranslationService.tour.users.step15UsersDetailSaveButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourUsers.hasStep(16) && ($('#usersDetail').length > 0)) {
                            tourUsers.createStep({
                                selector: '#usersCancelButton',
                                stepId: 'step16',
                                order: 16,
                                title: TranslationService.tour.users.title,
                                content: TranslationService.tour.users.step16UsersDetailCancelButton,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourUsers.hasStep(17)) {
                            tourUsers.createStep({
                                selector: 'body',
                                stepId: 'step17',
                                order: 17,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);

                    tourUsers.on('stepChanged', function (data) {
                        if (data.stepId === 'step17') {
                            $rootScope.$emit('closeUsersDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourUsers.hasStep(18)) {
                                    tourUsers.createStep({
                                        selector: '.resumeTourContainer',
                                        stepId: 'step18',
                                        order: 18,
                                        title: TranslationService.tour.users.title,
                                        content: TranslationService.tour.users.step18ResumeTourButton,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                                tourUsers.next();
                            }, 1000);
                        }
                    });
                }
            });
            var unbindUsersWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourUsers.end();
                    return $$q.promise;
                });
            // Save into DB
            tourUsers.on('ended', function () {
                $log.debug('users tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'USERS': true}
                }, function (data) {
                    $log.debug(data);
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindUsersWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            $rootScope.$broadcast('disableClickEvents');
            tourUsers.start();

            return $$q.promise;
        };

        vm.shouldShowUsersTour = function () {
            var userTours = localStorageService.get('tours');

            return !userTours.USERS;
        };

        vm.accessappTour = function (forceTour) {
            var userTours = localStorageService.get('tours');
            var $$q = $q.defer();

            var tourAccessapp = uiTourService.createDetachedTour('tourAccessapp', {
                name: 'tourAccessapp',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourAccessappTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourAccessapp.hasStep(0)) {
                tourAccessapp.createStep({
                    selector: '.rightPanel',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.accessapp.title,
                    content: TranslationService.tour.accessapp.step0Welcome,
                    orphan: true,
                    appendToBody: true
                });
            }

            if (!tourAccessapp.hasStep(1)) {
                tourAccessapp.createStep({
                    selector: '#acessappRightPanel',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.accessapp.title,
                    content: TranslationService.tour.accessapp.step1AccessappDetail,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAccessapp.hasStep(2)) {
                tourAccessapp.createStep({
                    selector: '#announcementForm',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.accessapp.title,
                    content: TranslationService.tour.accessapp.step2AccessappDetailData,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAccessapp.hasStep(3)) {
                tourAccessapp.createStep({
                    selector: 'div[name="appUser"]',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.accessapp.title,
                    content: TranslationService.tour.accessapp.step3AccessappDetailResidents,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourAccessapp.hasStep(4)) {
                tourAccessapp.createStep({
                    selector: '#announcementDetailSave',
                    stepId: 'step4',
                    order: 4,
                    title: TranslationService.tour.accessapp.title,
                    content: TranslationService.tour.accessapp.step4AccessappDetailSaveButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            if (!tourAccessapp.hasStep(5)) {
                tourAccessapp.createStep({
                    selector: '#announcementDetailCancel',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.accessapp.title,
                    content: TranslationService.tour.accessapp.step5AccessappDetailCancelButton,
                    placement: 'left',
                    appendToBody: true
                });
            }
            var unbindAcessAPPWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourAccessapp.end();
                    return $$q.promise;
                });
            // Save into DB
            tourAccessapp.on('ended', function () {
                $log.debug('Accessapp tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'ACCESSAPP': true}
                }, function (data) {
                    $log.debug(data);
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindAcessAPPWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            if (!userTours.ACCESSAPP || forceTour) {
                $rootScope.$broadcast('disableClickEvents');
                tourAccessapp.start();
            }
            return $$q.promise;
        };

        vm.initChatTour = function () {
            var $$q = $q.defer();

            var tourChat = uiTourService.createDetachedTour('tourChat', {
                name: 'tourChat',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourChatTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourChat.hasStep(0)) {
                tourChat.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step0Welcome,
                    orphan: true,
                    appendToBody: true

                });
            }
            if (!tourChat.hasStep(1)) {
                tourChat.createStep({
                    selector: '#inChatList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourChat.hasStep(2)) {
                tourChat.createStep({
                    selector: '#menuDetailPlaces',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step2FilterPlace,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourChat.hasStep(3)) {
                tourChat.createStep({
                    selector: '#findTerms',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step3Filter,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourChat.hasStep(4)) {
                tourChat.createStep({
                    selector: '.firstListRow',
                    stepId: 'step4',
                    order: 4,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step4Row,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourChat.hasStep(5) && PermissionsService.gotPermission('CHAT', 'update')) {
                tourChat.createStep({
                    selector: '.firstListRow .fa-pencil',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step5Edit,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourChat.hasStep(6) && PermissionsService.gotPermission('CHAT', 'delete')) {
                tourChat.createStep({
                    selector: '.firstListRow .fa-trash-o',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step6Delete,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourChat.hasStep(7) && PermissionsService.gotPermission('CHAT', 'update')) {
                tourChat.createStep({
                    selector: '#newUsersButton',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.chat.title,
                    content: TranslationService.tour.chat.step7New,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourChat.hasStep(8)) {
                tourChat.createStep({
                    selector: 'body',
                    stepId: 'step8',
                    order: 8,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourChat.on('stepChanged', function (data) {
                if (data.stepId === 'step8') {
                    $rootScope.$emit('openNewChat');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourChat.hasStep(9)) {
                            tourChat.createStep({
                                selector: '#usersDetail',
                                stepId: 'step9',
                                order: 9,
                                title: TranslationService.tour.chat.title,
                                content: TranslationService.tour.chat.step9ChatDetail,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        tourChat.next();
                        if (!tourChat.hasStep(10)) {
                            tourChat.createStep({
                                selector: '#usersDetail .input-group > span',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.chat.title,
                                content: TranslationService.tour.chat.step10ChatDetailTooltip,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourChat.hasStep(11)) {
                            tourChat.createStep({
                                selector: '#cnModNewSaveButton',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.chat.title,
                                content: TranslationService.tour.chat.step11ChatDetailSave,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourChat.hasStep(12)) {
                            tourChat.createStep({
                                selector: 'body',
                                stepId: 'step12',
                                order: 12,
                                placement: 'bottom-left',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                    }, 1000);
                    tourChat.on('stepChanged', function (data) {
                        if (data.stepId === 'step12') {
                            $rootScope.$emit('closeChatDetail');
                            $timeout(function () {
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourChat.hasStep(13)) {
                                    tourChat.createStep({
                                        selector: '#tourChatbox',
                                        stepId: 'step13',
                                        order: 13,
                                        title: TranslationService.tour.chat.title,
                                        content: TranslationService.tour.chat.step13Count,
                                        placement: 'bottom-right',
                                        appendToBody: false
                                    });
                                }
                                tourChat.next();
                                if (!tourChat.hasStep(14)) {
                                    tourChat.createStep({
                                        selector: '.resumeTourContainer',
                                        stepId: 'step14',
                                        order: 14,
                                        title: TranslationService.tour.chat.title,
                                        content: TranslationService.tour.chat.step14ResumeTourButton,
                                        placement: 'bottom-left',
                                        appendToBody: true
                                    });
                                }
                            }, 1000);
                        }
                    });
                }
            });

            var unbindChatWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourChat.end();
                    return $$q.promise;
                });
            // Save into DB
            tourChat.on('ended', function () {
                $log.debug('Chat tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'CHAT': true}
                }, function (data) {
                    $log.debug(data);
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindChatWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });

            $rootScope.$broadcast('disableClickEvents');
            tourChat.start();

            return $$q.promise;

        };

        vm.shouldShowChatTour = function () {
            var userTours = localStorageService.get('tours');
            return !userTours.CHAT;
        };

        vm.rackRoomTour = function (forceTour) {
            var userTours = localStorageService.get('tours');
            var $$q = $q.defer();

            var tourRackRoom = uiTourService.createDetachedTour('tourRackRoom', {
                name: 'tourRackRoom',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourRackRoomTemplate.html',
                backdropZIndex: 10000
            });

            if (!tourRackRoom.hasStep(0)) {
                tourRackRoom.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.rack.title,
                    content: TranslationService.tour.rack.step0Welcome,
                    orphan: true,
                    appendToBody: true
                });
            }
            if (!tourRackRoom.hasStep(1)) {
                tourRackRoom.createStep({
                    selector: '#rackFilter',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.rack.title,
                    content: TranslationService.tour.rack.step1Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRackRoom.hasStep(2)) {
                tourRackRoom.createStep({
                    selector: '#rackLegend',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.rack.title,
                    content: TranslationService.tour.rack.step2Legend,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRackRoom.hasStep(3)) {
                tourRackRoom.createStep({
                    selector: '.firstRoom',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.rack.title,
                    content: TranslationService.tour.rack.step3Rack,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRackRoom.hasStep(4) && PermissionsService.gotPermission('RESIDENT', 'update')) {
                tourRackRoom.createStep({
                    selector: 'body',
                    stepId: 'step4',
                    order: 4,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourRackRoom.on('stepChanged', function (data) {
                if (data.stepId === 'step4') {
                    $rootScope.$emit('openRoomDetail');
                    $timeout(function () {
                        tourRackRoom.next();
                        $rootScope.$broadcast('disableClickEvents');
                        if (!tourRackRoom.hasStep(5) && ($('#bedroomDetail').length > 0)) {
                            tourRackRoom.createStep({
                                selector: '#bedroomDetail',
                                stepId: 'step5',
                                order: 5,
                                title: TranslationService.tour.rack.title,
                                content: TranslationService.tour.rack.step6NewBedRoom,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourRackRoom.hasStep(6) && ($('#bedroomDetail').length > 0)) {
                            tourRackRoom.createStep({
                                selector: '#bedroomDetailTooltip',
                                stepId: 'step6',
                                order: 6,
                                title: TranslationService.tour.rack.title,
                                content: TranslationService.tour.rack.step7BedRoomDetailTooltip,
                                placement: 'left',
                                appendToBody: true
                            });
                        }
                        if (!tourRackRoom.hasStep(7)) {
                            tourRackRoom.createStep({
                                selector: 'body',
                                stepId: 'step7',
                                order: 7,
                                placement: 'top',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                        tourRackRoom.on('stepChanged', function (data) {
                            if (data.stepId === 'step7') {
                                $rootScope.$emit('openInventory');
                                tourRackRoom.next();
                                $rootScope.$broadcast('disableClickEvents');
                                if (!tourRackRoom.hasStep(8) && ($('#bedroomDetail').length > 0)) {
                                    tourRackRoom.createStep({
                                        selector: '#addInventoryItemButton',
                                        stepId: 'step8',
                                        order: 8,
                                        title: TranslationService.tour.rack.title,
                                        content: TranslationService.tour.rack.step9AddInventory,
                                        placement: 'left',
                                        appendToBody: true
                                    });
                                }
                                if (!tourRackRoom.hasStep(9) && ($('#bedroomDetail').length > 0)) {
                                    tourRackRoom.createStep({
                                        selector: '#saveInventoryButton',
                                        stepId: 'step9',
                                        order: 9,
                                        title: TranslationService.tour.rack.title,
                                        content: TranslationService.tour.rack.step10SaveInventory,
                                        placement: 'top',
                                        appendToBody: true
                                    });
                                }
                                if (!tourRackRoom.hasStep(10)) {
                                    tourRackRoom.createStep({
                                        selector: 'body',
                                        stepId: 'step10',
                                        order: 10,
                                        placement: 'top',
                                        appendToBody: false,
                                        backdropZIndex: -1
                                    });
                                }
                                tourRackRoom.on('stepChanged', function (data) {
                                    if (data.stepId === 'step10') {
                                        $rootScope.$emit('openRoomType');
                                        tourRackRoom.next();
                                        $rootScope.$broadcast('disableClickEvents');
                                        if (!tourRackRoom.hasStep(11) && ($('#bedroomDetail').length > 0)) {
                                            tourRackRoom.createStep({
                                                selector: '#roomRates',
                                                stepId: 'step11',
                                                order: 11,
                                                title: TranslationService.tour.rack.title,
                                                content: TranslationService.tour.rack.step12RoomType,
                                                placement: 'left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourRackRoom.hasStep(12) && ($('#bedroomDetail').length > 0)) {
                                            tourRackRoom.createStep({
                                                selector: '#roomRatesTable',
                                                stepId: 'step12',
                                                order: 12,
                                                title: TranslationService.tour.rack.title,
                                                content: TranslationService.tour.rack.step13RoomRate,
                                                placement: 'left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourRackRoom.hasStep(13)) {
                                            tourRackRoom.createStep({
                                                selector: '#workertask',
                                                stepId: 'step13',
                                                order: 13,
                                                title: TranslationService.tour.rack.title,
                                                content: TranslationService.tour.rack.step19ActiveTask,
                                                placement: 'left',
                                                appendToBody: true
                                            });
                                        }
                                        if (!tourRackRoom.hasStep(14)) {
                                            tourRackRoom.createStep({
                                                selector: 'body',
                                                stepId: 'step14',
                                                order: 14,
                                                placement: 'top',
                                                appendToBody: false,
                                                backdropZIndex: -1
                                            });
                                        }
                                        tourRackRoom.on('stepChanged', function (data) {
                                            if (data.stepId === 'step14') {
                                                $rootScope.$emit('openActiveTask');
                                                tourRackRoom.next();
                                                $rootScope.$broadcast('disableClickEvents');
                                                if (!tourRackRoom.hasStep(15)) {
                                                    tourRackRoom.createStep({
                                                        selector: '#buttonSetToClean',
                                                        stepId: 'step15',
                                                        order: 15,
                                                        title: TranslationService.tour.rack.title,
                                                        content: TranslationService.tour.rack.step21CleanRoom,
                                                        placement: 'left',
                                                        appendToBody: true
                                                    });
                                                }
                                                if (!tourRackRoom.hasStep(16)) {
                                                    tourRackRoom.createStep({
                                                        selector: 'body',
                                                        stepId: 'step16',
                                                        order: 16,
                                                        placement: 'top',
                                                        appendToBody: false,
                                                        backdropZIndex: -1
                                                    });
                                                }
                                                tourRackRoom.on('stepChanged', function (data) {
                                                    if (data.stepId === 'step16') {
                                                        $rootScope.$emit('setToClean');
                                                        $timeout(function () {
                                                            tourRackRoom.next();
                                                            $rootScope.$broadcast('disableClickEvents');
                                                            if (!tourRackRoom.hasStep(17)) {
                                                                tourRackRoom.createStep({
                                                                    selector: '#buttonSaveTask',
                                                                    stepId: 'step17',
                                                                    order: 17,
                                                                    title: TranslationService.tour.rack.title,
                                                                    content: TranslationService.tour.rack.step23SaveTask,
                                                                    placement: 'left',
                                                                    appendToBody: true
                                                                });
                                                            }
                                                            if (!tourRackRoom.hasStep(18)) {
                                                                tourRackRoom.createStep({
                                                                    selector: '#incidentPanel',
                                                                    stepId: 'step18',
                                                                    order: 18,
                                                                    title: TranslationService.tour.rack.title,
                                                                    content: TranslationService.tour.rack.step24IncidentPanel,
                                                                    placement: 'left',
                                                                    appendToBody: true
                                                                });
                                                            }
                                                            if (!tourRackRoom.hasStep(19)) {
                                                                tourRackRoom.createStep({
                                                                    selector: 'body',
                                                                    stepId: 'step19',
                                                                    order: 19,
                                                                    placement: 'top',
                                                                    appendToBody: false,
                                                                    backdropZIndex: -1
                                                                });
                                                            }
                                                            tourRackRoom.on('stepChanged', function (data) {
                                                                if (data.stepId === 'step19') {
                                                                    $rootScope.$emit('closeRoomDetail');
                                                                    $timeout(function () {
                                                                        tourRackRoom.next();
                                                                        $rootScope.$broadcast('disableClickEvents');
                                                                        if (!tourRackRoom.hasStep(20)) {
                                                                            tourRackRoom.createStep({
                                                                                selector: '.resumeTourContainer',
                                                                                stepId: 'step20',
                                                                                order: 20,
                                                                                title: TranslationService.tour.rack.title,
                                                                                content: TranslationService.tour.rack.step25ResumeTour,
                                                                                placement: 'bottom',
                                                                                appendToBody: true
                                                                            });
                                                                        }
                                                                    });
                                                                }
                                                            });
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }, 1000);
                }
            });
            var unbindAcessAPPWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourRackRoom.end();
                    return $$q.promise;
                });
            // Save into DB
            tourRackRoom.on('ended', function () {
                $log.debug('RackRoom tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'RACKROOM': true}
                }, function (data) {
                    $log.debug(data);
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindAcessAPPWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });


            if (!userTours.RACKROOM || forceTour) {
                $rootScope.$broadcast('disableClickEvents');
                tourRackRoom.start();
            }
            return $$q.promise;
        };

        vm.shouldShowRackRoomTour = function () {
            var userTours = localStorageService.get('tours');

            return !userTours.RACKROOM;
        };


        vm.initRequestsTour = function () {
            var $$q = $q.defer();

            var tourRequests = uiTourService.createDetachedTour('tourRequests', {
                name: 'tourRequests',
                debug: true,
                backdrop: true,
                useHotkeys: true,
                templateUrl: 'tourRequestsTemplate.html',
                backdropZIndex: 10000
            });
            if (!tourRequests.hasStep(0)) {
                tourRequests.createStep({
                    selector: 'body',
                    stepId: 'step0',
                    order: 0,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step0Welcome,
                    orphan: true,
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(1)) {
                tourRequests.createStep({
                    selector: '#requestsList',
                    stepId: 'step1',
                    order: 1,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step1List,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(2)) {
                tourRequests.createStep({
                    selector: '#tableParams > .ng-scope',
                    stepId: 'step2',
                    order: 2,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step2Filters,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(3)) {
                tourRequests.createStep({
                    selector: '#tableParams .ng-table-sort-header > th+th+th+th+th',
                    stepId: 'step3',
                    order: 3,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step3DateColumns,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(4)) {
                tourRequests.createStep({
                    selector: '#tableParams .ng-table-sort-header > th+th+th+th+th+th+th+th+th',
                    stepId: 'step4',
                    order: 4,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step4RatingColumn,
                    placement: 'bottom-right',
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(5)) {
                tourRequests.createStep({
                    selector: '.firstListRow',
                    stepId: 'step5',
                    order: 5,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step5TableRow,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(6)) {
                tourRequests.createStep({
                    selector: '#totalItems',
                    stepId: 'step6',
                    order: 6,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step6TableTotalItems,
                    placement: 'bottom-left',
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(7)) {
                tourRequests.createStep({
                    selector: '#newRequestButton',
                    stepId: 'step7',
                    order: 7,
                    title: TranslationService.tour.requests.title,
                    content: TranslationService.tour.requests.step7TableNewButton,
                    placement: 'bottom',
                    appendToBody: true
                });
            }
            if (!tourRequests.hasStep(8)) {
                tourRequests.createStep({
                    selector: 'body',
                    stepId: 'step8',
                    order: 8,
                    placement: 'top',
                    appendToBody: false,
                    backdropZIndex: -1
                });
            }
            tourRequests.on('stepChanged', function (data) {
                if (data.stepId === 'step8') {
                    $rootScope.$emit('openRequestDetail');
                    $timeout(function () {
                        $rootScope.$broadcast('disableClickEvents');
                        tourRequests.next();
                        if (!tourRequests.hasStep(9)) {
                            tourRequests.createStep({
                                selector: '.dniModal .swal2-content',
                                stepId: 'step9',
                                order: 9,
                                title: TranslationService.tour.requests.title,
                                content: TranslationService.tour.requests.stepDniInput,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        $rootScope.$emit('setDummyDni');
                        if (!tourRequests.hasStep(10)) {
                            tourRequests.createStep({
                                selector: '.dniModal .swal2-cancel',
                                stepId: 'step10',
                                order: 10,
                                title: TranslationService.tour.requests.title,
                                content: TranslationService.tour.requests.stepDniInputCancel,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourRequests.hasStep(11)) {
                            tourRequests.createStep({
                                selector: '.dniModal .swal2-confirm',
                                stepId: 'step11',
                                order: 11,
                                title: TranslationService.tour.requests.title,
                                content: TranslationService.tour.requests.stepDniInputConfirm,
                                placement: 'bottom-left',
                                appendToBody: true
                            });
                        }
                        if (!tourRequests.hasStep(12)) {
                            tourRequests.createStep({
                                selector: 'body',
                                stepId: 'step12',
                                order: 12,
                                placement: 'top',
                                appendToBody: false,
                                backdropZIndex: -1
                            });
                        }
                        tourRequests.on('stepChanged', function (data) {
                            if (data.stepId === 'step12') {
                                $rootScope.$emit('confirmDummyDni');
                                $timeout(function () {
                                    $rootScope.$broadcast('disableClickEvents');
                                    if (!tourRequests.hasStep(13)) {
                                        tourRequests.createStep({
                                            selector: '#requestDetail',
                                            stepId: 'step13',
                                            order: 13,
                                            title: TranslationService.tour.requests.title,
                                            content: TranslationService.tour.requests.step8RequestDetail,
                                            placement: 'bottom-left',
                                            appendToBody: true
                                        });
                                    }
                                    tourRequests.next();
                                    if (!tourRequests.hasStep(14)) {
                                        tourRequests.createStep({
                                            selector: '#requestDetail .input-group > span',
                                            stepId: 'step14',
                                            order: 14,
                                            title: TranslationService.tour.requests.title,
                                            content: TranslationService.tour.requests.step9RequestDetailTooltip,
                                            placement: 'bottom-left',
                                            appendToBody: true
                                        });
                                    }
                                    if (!tourRequests.hasStep(15)) {
                                        tourRequests.createStep({
                                            selector: '#requestSaveButton',
                                            stepId: 'step15',
                                            order: 15,
                                            title: TranslationService.tour.requests.title,
                                            content: TranslationService.tour.requests.step10RequestDetailSaveButton,
                                            placement: 'bottom-right',
                                            appendToBody: true
                                        });
                                    }
                                    if (!tourRequests.hasStep(16)) {
                                        tourRequests.createStep({
                                            selector: '#requestCancelButton',
                                            stepId: 'step16',
                                            order: 16,
                                            title: TranslationService.tour.requests.title,
                                            content: TranslationService.tour.requests.step11RequestDetailCancelButton,
                                            placement: 'left',
                                            appendToBody: true
                                        });
                                    }
                                    if (!tourRequests.hasStep(17)) {
                                        tourRequests.createStep({
                                            selector: 'body',
                                            stepId: 'step17',
                                            order: 17,
                                            placement: 'bottom-left',
                                            appendToBody: false,
                                            backdropZIndex: -1
                                        });
                                    }
                                    tourRequests.on('stepChanged', function (data) {
                                        if (data.stepId === 'step17') {
                                            $rootScope.$emit('closeRequestDetail');
                                            $timeout(function () {
                                                $rootScope.$broadcast('disableClickEvents');
                                                if (!tourRequests.hasStep(18)) {
                                                    tourRequests.createStep({
                                                        selector: '.firstListRow',
                                                        stepId: 'step18',
                                                        order: 18,
                                                        title: TranslationService.tour.requests.title,
                                                        content: TranslationService.tour.requests.step12RequestsFirstRow,
                                                        placement: 'bottom-left',
                                                        appendToBody: true
                                                    });
                                                }
                                                if (!tourRequests.hasStep(19)) {
                                                    tourRequests.createStep({
                                                        selector: '#exportButton',
                                                        stepId: 'step19',
                                                        order: 19,
                                                        title: TranslationService.tour.requests.title,
                                                        content: TranslationService.tour.requests.step13RequestExport,
                                                        placement: 'left',
                                                        appendToBody: true
                                                    });
                                                }
                                                if (!tourRequests.hasStep(20)) {
                                                    tourRequests.createStep({
                                                        selector: '.resumeTourContainer',
                                                        stepId: 'step20',
                                                        order: 20,
                                                        title: TranslationService.tour.requests.title,
                                                        content: TranslationService.tour.requests.step14ResumeTourButton,
                                                        placement: 'bottom-left',
                                                        appendToBody: true
                                                    });
                                                }
                                                tourRequests.next();
                                            }, 1000);
                                        }
                                    });
                                }, 1000);
                            }
                        });
                    }, 1000);
                }
            });
            var unbindRequestsWatcher = $rootScope.$on('$stateChangeStart',
                function () {
                    tourRequests.end();
                    return $$q.promise;
                });

            // Save into DB
            tourRequests.on('ended', function () {
                $log.debug('Requests tour ended');
                MasterTableService.post({
                    idT: routeConf.user,
                    idJ: routeConf.tours
                }, {
                    'tours': {'REQUESTS': true}
                }, function (data) {
                    vm.getUserTours();
                    $rootScope.$broadcast('enableClickEvents');
                    unbindRequestsWatcher();
                    $$q.resolve();
                }, function (err) {
                    $log.error('Error saving user tour into DB: ', err);
                    $$q.reject(err);
                });
            });

            $rootScope.$broadcast('disableClickEvents');
            tourRequests.start();

            return $$q.promise;

        };

        vm.shouldShowRequestsTour = function () {
            var userTours = localStorageService.get('tours');
            return !userTours.REQUESTS;
        };

    }
})();

/**
 * Created by plobato on 24/05/2017.
 */
(function () {
    'use strict';

    angular
        .module('Tagaste.utils', [])
        .factory('LanguageFactory', LanguageFactory)
        //     .provider('LanguageFactory', LanguageFactory);
        //
        // LanguageFactory.$inject = ['ENV'];
        //
        // /* @ngInject */
        // function LanguageFactory(ENV) {
        //     var service = {
        //         getLanguage: getLanguage
        //     };
        //     return service;
        //
        //     ////////////////
        //     /**
        //      * @ngdoc method
        //      * @name getLanguage
        //      * @methodOf Magna
        //      * @description
        //      * Function that set language based on browser language
        //      */
        //     function getLanguage() {
        //         var lang = window.navigator.language || window.navigator.userLanguage;
        //         lang = lang.substring(0, 2);
        //         if (ENV.availableLanguages.indexOf(lang) === -1) {
        //             return ENV.defaultLanguage;
        //         }
        //         return lang;
        //     }
        //
        //     var useTinfoilShielding = false;
        //
        //     this.useTinfoilShielding = function(value) {
        //         useTinfoilShielding = !!value;
        //     };
        //
        //     this.$get = ["apiToken", function unicornLauncherFactory(apiToken) {
        //
        //         // let's assume that the UnicornLauncher constructor was also changed to
        //         // accept and use the useTinfoilShielding argument
        //         return new UnicornLauncher(apiToken, useTinfoilShielding);
        //     }];
        // }
        .provider('Language', ['ENV', function (ENV) {
            var lang = '';
            this.getLanguage = getLanguage(ENV);

            this.$get = function () {


                return lang;
            };
        }]);

    LanguageFactory.$inject = ['ENV'];

        /* @ngInject */
        function LanguageFactory(ENV) {
            var service = {
                getLanguage: getLanguage(ENV)
            };
            return service;
        }



    /** @ngdoc method
     * @name getLanguage
     * @methodOf Tagaste
     * @description
     * Function that set language based on browser language
     */
    function getLanguage(ENV) {
        var lang = '';
        lang = window.navigator.language || window.navigator.userLanguage;
        lang = lang.substring(0, 2);
        if (ENV.availableLanguages.indexOf(lang) === -1) {
            return ENV.defaultLanguage;
        }
        return lang;
    }

})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 2000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/*
 * @author sfernandez
 * created on 03/04/2019
 */
(function () {
    'use strict';

CardFileController.$inject = ['$uibModal', '$rootScope', 'MasterTableService', 'routeConf', '$log', 'Lightbox', 'toastr', 'TranslationService'];

function CardFileController($uibModal, $rootScope, MasterTableService, routeConf, $log, Lightbox, toastr, TranslationService) {
    var vm = this;
    vm.fileShowedArray = [];
    vm.progressVisible = true;
    vm.default = {
        size: '120px',
        shape: 'square'
    };
    vm._CONTROLLER = 'CardFileController';

    vm.$onInit = function () {
        vm.progressPercentage = 0;
        vm.uploading = false;
        vm.showOverlay = false;
        if (!vm.readonly) {
            vm.readonly = false;
        } else {
            vm.readonly = true;
        }
        if (!vm.size) {
            vm.size = vm.default.size;
        }
        if (!vm.shape) {
            vm.shape = vm.default.shape;
        }
        if (vm.attached.visibility){
            if (vm.attached.visibility.isPublic){
                vm.attached.visibilityType = 'Publico';
            } else if (vm.attached.visibility.isPrivate){
                vm.attached.visibilityType = 'Privado';
            } else {
                vm.attached.visibilityType = 'Jerarquia';
            }
        } else {
            vm.attached.visibilityType = 'Publico';
        }
    };

    /**
     * @ngdoc method
     * @name deleteAttach
     * @methodOf Tagaste.residentDetailCom.controller:residentDetailController
     * @description
     * Method that delete an attach
     * @param attachment is object attach to delete
     */
    vm.delete = function (attachment) {
        $rootScope.$emit('deleteAttach', attachment);
    };

    vm.edit = function (attachment, onlyUsers) {
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'modalEditCardFile.html',
            controller: 'modalEditCardFile',
            controllerAs: '$ctrl',
            backdrop: 'static',
            size: 'sm',
            resolve: {
                attachment: function () { return attachment; },
                onlyUsers: function () { return onlyUsers; }
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            //close function
            vm.attached.visibility = result.visibility;
            //vm.$onInit();
        }, function () {
            //dismiss function
        });

    };

    /**
     * @ngdoc method
     * @name openLightboxModal
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that show an image in a modal
     * @param file is the image to show
     */
    vm.openLightboxModal = function (file) {
        $log.debug('file', file);
        var urlDownload = '';
        MasterTableService.get({
            idT: routeConf.file, idJ: routeConf.signedUrl, key: file.original.key,
            bucket: file.original.bucket
        }, function (data) {
            $log.debug('signedUrl', data);
            file.url = data.url;
            urlDownload = data.url;
            var index = _.findIndex(vm.fileShowedArray, {'_id': file._id});
            if (index < 0) {
                vm.fileShowedArray.push(file);
                index = vm.fileShowedArray.length - 1;
            }
            // Lightbox.templateUrl = 'lightbox.html';
            // Lightbox.templateUrl = '/assets/templates/lightbox.html';
            if(getTypeFile(file.filename) === 'img') {
                Lightbox.openModal(vm.fileShowedArray, index);
            } else {
                window.open(file.url);
            }
        }, function (err) {
            $log.debug('error load attached file', err);
            toastr.error(TranslationService.errors.noImage, TranslationService.warning,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });

    };

    /**
     * @ngdoc method
     * @name getTypeFile
     * @param filename filename
     */
    function getTypeFile(fileName) {
        var extension = fileName.split('.').pop();
        var classExtension = '';
        switch (extension) {
            case 'pdf':
                classExtension = 'pdf';
                break;
            case 'docx':
                classExtension = 'docx';
                break;
            case 'png':
            case 'jpg':
            case 'gif':
            case 'bmp':
            case 'ico':
                classExtension = 'img';
                break;
            case 'xls':
            case 'xlt':
                classExtension = 'xls';
                break;
            case 'txt':
                classExtension = 'txt';
                break;
            case 'zip':
            case 'rar':
            case '7z':
                classExtension = 'rar';
                break;
            case 'avi':
            case 'mpeg':
            case 'mp4':
            case 'asf':
                classExtension = 'video';
                break;
            case 'mp3':
            case 'ra':
            case 'wav':
                classExtension = 'audio';
                break;
        }

        return classExtension;
    }
}

angular
    .module('BlurAdmin.cardFile')
    .component('cardFile', {
        templateUrl: 'app/components/cardFile/cardFile.html',
        controllerAs: 'cflc',
        controller: CardFileController,
        bindings: {
            attached: '=',
            readonly: '<',
            uploading: '=',
            onlyUsers: '<',
            maxLongName: '<'
        }
    });

    angular.module('BlurAdmin.cardFile')
    .controller('modalEditCardFile', modalEditCardFile)
    .filter('findUserGroupe', function () {
        return function (list, params) {
            if (params) {
                params.alredy = (params.alredy) ? params.alredy : [];
            } else {
                params = {
                    alredy: [],
                    find: ''
                };
            }
            return _.differenceBy(_.filter(list, function (item) {
                return (
                !(_.find(params.alredyFloor, function (selectedFloor) {
                    return (item.branches._id === selectedFloor.branches._id &&
                    selectedFloor.floor === item.floor);
                })) && (
                    (params.find.trim() === '' || (
                            (_.deburr(item.nameRoom).toUpperCase()
                                .indexOf(_.deburr(params.find).toUpperCase()) >= 0)
                        )
                    )));
            }), params.alredy, '_id');
        };
    });

    modalEditCardFile.$inject = ['$rootScope', '$uibModalInstance', 'attachment', 'onlyUsers', '$log',
                                'ResidentsService', 'UsersServiceByBranch', 'localStorageService'];
    /* @ngInject */
    function modalEditCardFile($rootScope, $uibModalInstance, attachment, onlyUsers, $log,
                                ResidentsService, UsersServiceByBranch, localStorageService) {
        var $ctrl = this;

        $ctrl.attachment = attachment;
        $ctrl.onlyUsers = onlyUsers;

        $ctrl.userBranch = localStorageService.get('branches');
        $ctrl.selectedBar = localStorageService.get('selectedBarResidence');

        if($ctrl.attachment.visibility){

            if ($ctrl.attachment.visibility.isPublic) {
                $ctrl.cardFileType = 'public';
            }

            if ($ctrl.attachment.visibility.isHierarchy) {
                $ctrl.cardFileType = 'hierarchy';
            }

            if ($ctrl.attachment.visibility.isPrivate) {
                $ctrl.cardFileType = 'private';
            }

        } else {
            $ctrl.cardFileType = 'public';
        }

        if($ctrl.attachment.visibility && $ctrl.attachment.visibility.relatedUser) {
            $ctrl.receivers = [];
            _.forEach($ctrl.attachment.visibility.relatedUser, function(u) {
                var user = u.item;
                if (user.usuario) {
                    user.nameRoom = '[' + user.usuario + '] ' + user.name + ' ' + user.surname;
                } else {
                    user.nameRoom = '[usuario] ' + user.name + ' ' + user.surname;
                }
                user.kind = 'User';

                $ctrl.receivers.push(user);
            });

        } else {
            $ctrl.receivers = [];
        }


        $ctrl.changeType = function (value) {
            $ctrl.cardFileType = value;
        };

        $ctrl.parseUserListBy = function () {
            $ctrl.alredyFloor = _.filter($ctrl.receivers, function (user) {
                if (user.allFloor) {
                    return user;
                }
            });
        };

        $ctrl.parseUserList = function (users) {
            var usrList = angular.copy(users);
            var listByBran = [];
            _.forEach(usrList, function (item) {
                item.branches = item.branches[0];
                var b = _.find(listByBran, function (a) {
                    return a._id === item.branches._id;
                });
                if (!b) {
                    listByBran.push({
                        _id: item.branches._id,
                        usr: [item]
                    });
                } else {
                    b.usr.push(item);
                }
            });
            var list = [];
            _.forEach(listByBran, function (bran) {
                bran.usr = _.orderBy(bran.usr, ['fullName', 'asc']);
                _.forEach(bran.usr, function (i) {
                    list.push(i);
                });
            });
            var lastFloor = -1;
            var out = [];
            _.forEach(list, function (user) {
                if (user.usuario) {
                    user.nameRoom = '[' + user.usuario + '] ' + user.name + ' ' + user.surname;
                } else {
                    user.nameRoom = '[usuario] ' + user.name + ' ' + user.surname;
                }
                if (lastFloor !== ('Usuario' + ' ' + user.branches.description)) {
                    lastFloor = 'Usuario' + ' ' + user.branches.description;
                    out.push({
                        nameRoom: 'Usuario' + ' ' + user.branches.description,
                        allFloor: 'Usuario' + ' ' + user.branches.description,
                        floor: 'Usuario',
                        branches: user.branches,
                        _id: user.branches._id + 'Usuario'
                    });
                }
                user.kind = 'User';
                out.push(user);
            });
            return out;
        };

        $ctrl.parseResidentList = function (users) {
            var usrList = angular.copy(users);
            var listByBran = [];
            _.forEach(usrList, function (item) {
                item.branches = item.branches[0];
                var b = _.find(listByBran, function (a) {
                    return a._id === item.branches._id;
                });
                if (!b) {
                    listByBran.push({
                        _id: item.branches._id,
                        usr: [item]
                    });
                } else {
                    b.usr.push(item);
                }
            });
            var list = [];
            _.forEach(listByBran, function (bran) {
                bran.usr = _.orderBy(bran.usr, ['room', 'asc']);
                _.forEach(bran.usr, function (i) {
                    list.push(i);
                });
            });

            var lastFloor = -1;
            var out = [];
            _.forEach(list, function (user) {
                user.nameRoom = '[' + user.room + '] ' + user.name + ' ' + user.surname;
                if (lastFloor !== user.floor) {
                    lastFloor = user.floor;
                    // TODO: translate
                    out.push({
                        nameRoom: 'Planta ' + user.floor + ' ' + user.branches.description,
                        allFloor: user.floor,
                        floor: user.floor,
                        branches: user.branches,
                        _id: user.branches._id + user.floor
                    });
                }
                user.kind = 'AppUser';
                out.push(user);
            });
            return out;
        };

        function clearUsersByBranch(br) {
            var list = [];
            _.forEach($ctrl.receivers, function (user) {
                var correct = _.find(br, function (ba) {
                    return (ba._id === user.branches._id);
                });
                if (correct) {
                    list.push(user);
                }
            });
            return list;
        }

        function checkAvailableUsers(branches) {
            // $ctrl.receivers = clearUsersByBranch(branches);
        }

        function getSourcesUsers() {
            return new Promise(function (full, reject) {
                var queryUsers = {branch:  ($ctrl.selectedBar && !$ctrl.selectedBar.all) ?
                    $ctrl.selectedBar._id : $ctrl.userBranch};
                UsersServiceByBranch.get(queryUsers, function (data) {
                }, function (err) {
                    $log.error('error getting employees : ', err);
                }).$promise.then(function (data) {
                    full(data);
                });
            });
        }

        function getSourcesAppUsers() {
            return new Promise(function (full, reject) {
                var queryAppUsers = {branch: ($ctrl.selectedBar && !$ctrl.selectedBar.all) ?
                    $ctrl.selectedBar._id : $ctrl.userBranch};
                    ResidentsService.get(queryAppUsers, function (data) {
                }, function (err) {
                    $log.error('error getting appUsers : ', err);
                }).$promise.then(function (data) {
                    full(data);
                });
            });
        }

        $ctrl.save = function (cardfileForm) {
            $ctrl.attachment.isModified=true;
            if ( $ctrl.cardFileType === 'public'){
                $ctrl.attachment.visibility = {
                    isHierarchy: false,
                    isPrivate: false,
                    isPublic: true,
                    relatedUser: []
                };

                $ctrl.attachment.visibilityType = 'Publico';
            } else if ( $ctrl.cardFileType === 'private') {
                $ctrl.attachment.visibility = {
                    isHierarchy: false,
                    isPrivate: true,
                    isPublic: false,
                    relatedUser: []
                };
                $ctrl.attachment.visibilityType = 'Privado';
                _.forEach($ctrl.receivers, function (user) {
                    $ctrl.attachment.visibility.relatedUser.push({
                        kind: user.kind,
                        item: user
                    });
                });
            } else {
                $ctrl.attachment.visibility = {
                    isHierarchy: true,
                    isPrivate: false,
                    isPublic: false,
                    relatedUser: [{
                        kind: localStorageService.get('userKind'),
                        item: localStorageService.get('userId')
                    }]
                };
                $ctrl.attachment.visibilityType = 'Jerarquia';
            }
            $uibModalInstance.close($ctrl.attachment);
        };

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            $ctrl.selectedBar = data;
            $ctrl.init();
        });

        $ctrl.init = function() {
            getSourcesUsers().then(function (data1) {
                if($ctrl.onlyUsers){
                    $ctrl.users1 = $ctrl.parseUserList(data1.data);
                    $ctrl.users =  angular.copy($ctrl.users1);
                    if ($ctrl.users && $ctrl.users.length > 0) {
                        checkAvailableUsers();
                        $ctrl.parseUserListBy();
                    }
                } else {
                    getSourcesAppUsers().then(function (data2) {
                        $ctrl.users1 = $ctrl.parseUserList(data1.data);
                        $ctrl.users2 = $ctrl.parseResidentList(data2.data);
                        $ctrl.users = _.concat($ctrl.users1 , $ctrl.users2 );
                        if ($ctrl.users && $ctrl.users.length > 0) {
                            checkAvailableUsers();
                            $ctrl.parseUserListBy();
                        }
                    });
                }
            });
        };

        $uibModalInstance.opened.then($ctrl.init);

        $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
    })();



/*
* Component parameters:
*   dateValue: value to show in date picker(Obligatory attribute)
*   formReference: reference of form where component is placed(Obligatory attribute for validations)
*   nameField: name of component field(Obligatory field for validations)
*   tooltipText: text to show in tooltip
*   tooltipPlacement: position tooltip
*   modeReadOnly: To disable edit , true or false
*   isRequired: indicate if this field is required or not
*   dateOptions: options to date picker as minDate,maxDate
*   showRequiredError: boolean to show required message
*   msgInvalidDate: text to show in message error invalid date
*   msgObligatoryField: text to show in message error obligatory field
*   msgSpecialValidation: text to show in message error special validation
*   specialValidation: function for special validation(example check if a date is after or other date)
*   placeholder: text to show in field
    iconCalendar: icon to show,default ion-calendar
    iconSize: font size of icon,default 14px
*
* Example of use
*<date-picker-comp tooltip-text="tooltip"  tooltip-placement="top-left"
* date-value="bbdc.visibleFrom" is-required="true" mode-read-only="bbdc.modeReadOnly" date-options="bbdc.dateOptions"
* show-required-error="bbdc.showError" form-reference="bulletinForm" special-validation="bbdc.checkDates()"
* name-field="'visibleFrom'"></date-picker-comp>
*/

function datePickerController(ENV, tmhDynamicLocale, $log) {
    var vm = this;

    /**
     * @ngdoc method
     * @name openDatepicker
     * @methodOf Tagaste.datePickerCom.controller:datePickerController
     * @description
     * Method that open popup calendar
     *
     */
    vm.openDatepicker = function () {
        if (!vm.modeReadOnly && !vm.popup.opened) {
            vm.popup.opened = true;
        }
    };

    vm.$onInit = function () {
        if (vm.minMode) {
            vm.dateOptions['minMode'] = vm.minMode;
        }
        vm.format = vm.minMode === 'month' ? 'MM/yyyy' : ENV.formatDate;
        vm.popup = {
            opened: false
        };
        vm.appendToBodyPicker = vm.appendToBody !== undefined ? vm.appendToBody : true;
    };
}

angular
    .module('Tagaste.datePickerCom')
    .component('datePickerComp', {
        templateUrl: 'app/components/datePicker/datePicker.html',
        controllerAs: 'dpc',
        controller: datePickerController,
        bindings: {
            tooltipText: '<',
            tooltipPlacement: '@',
            modeReadOnly: '<',
            dateValue: '=',
            isRequired: '<',
            dateOptions: '<',
            showRequiredError: '<',
            formReference: '<',
            msgInvalidDate: '<',
            msgObligatoryField: '<',
            specialValidation: '&',
            nameField: '<',
            minMode: '<',
            msgSpecialValidation: '<',
            placeholder: '<',
            iconCalendar: '<',
            iconSize: '<',
            customClass: '<',
            appendToBody: '<',
            dateChanges: '&'
        }
    });

notificationPush.$inject = ['$timeout', '$log', 'routeConf', 'MasterTableService', 'toastr', 'TranslationService' , 'Fields'];

function notificationPush($timeout, $log, routeConf, MasterTableService, toastr, TranslationService, Fields) {
    var vm = this;
    vm.listUsers = {};

    vm._CONTROLLER = "notificationPush";

    vm.$onInit = function () {
        vm.listUsers = angular.copy(vm.notification.user);
    };

    vm.cancel = function () {
        //vm.notification = undefined;
        vm.notification.showPanel = false;
        $log.debug('cancel notification',vm.notification);
    };

    vm.isModeReadOnly = function () {
        if ( vm.listUsers.length < 2 ){
            return true;
        }
        else{
            return false;
        }
    };

    vm.save = function (form) {
        vm.showError = false;
        if (form.$valid) {
            vm.notification.user = vm.listUsers;
            vm.notification.appUsers = [];
            vm.notification.branches = _.map(vm.notification.branches, Fields.id);
            $log.debug('notification to send',vm.notification);
            var query ={
                idT:routeConf.app,
                idJ:vm.notification.type,
                idP:routeConf.notice
            };
            MasterTableService.post(query,vm.notification,function (data) {
               $log.debug('notification created success',data);
                vm.notification = undefined;
                toastr.success(TranslationService.notificationPush.success);
            });
        }else{
            vm.showError = true;
        }
    };
}

angular
    .module('Tagaste.notificationPushCom')
    .component('notificationPush', {
        templateUrl: 'app/components/notificationsPush/notificationPush.html',
        controllerAs: 'npc',
        controller: notificationPush,
        bindings: {
            notification: '='
        }
    });
/*
 * @author sila.fernandez
 * created on 18/03/2019
 */

LogbookController.$inject = ['LogbookService', 'LogbookComments', 'BranchService', '$timeout',
                                'TranslationService', 'ResidentsService', 'toastr', '$log', 'TourService',
                                '$rootScope', 'PermissionsService', '$filter', 'localStorageService', '$scope', '$location'];

function LogbookController(LogbookService, LogbookComments, BranchService, $timeout,
                                TranslationService, ResidentsService, toastr, $log, TourService,
                                $rootScope, PermissionsService, $filter, localStorageService, $scope, $location) {
    var vm = this;
    vm.text = null;
    vm.logbook = [];
    vm.logbookTotal = 0;
    vm.submitted = false;
    vm.date = moment().toDate();
    vm.editcommentid = null;
    vm.editlogbookid = null;
    vm.dateOptions = {
//        maxDate: moment().toDate(),
        showWeeks: false
    };
    vm.constants = {
        residences: []
    };
    vm.selectedBranch = null;

    vm._CONTROLLER = 'logbookController';
    vm.logbookUpdate = PermissionsService.gotPermission('LOGBOOK', 'update');

    $scope.$watch('lbc.date', function(newValue, oldValue){
        if(newValue !== oldValue){
            var queryA = {};
            if(vm.selectedBranch) {
               queryA.branch = vm.selectedBranch._id;
            }
            if(vm.date) {
                queryA.date = moment(vm.date).format('YYYY/MM/DD');
            }

            getSources(queryA).then(function (data) {
                vm.logbook = data;
                $rootScope.$digest();
            });
        }
    });

    vm.save = function (resForm) {

        if ((!vm.submitted && !resForm.$valid) || !resForm.$valid ||
            resForm.comment.$untouched) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {

            var dataLogbook = {};
            if(vm.editcommentid) {
                // Edit comment
                dataLogbook = {
                    comment:  vm.text
                };

                LogbookComments.post( {idL: vm.editlogbookid, idC: vm.editcommentid}, dataLogbook, function (data1) {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.text = null;

                }, function (err) {
                    $log.error('error saving logbook : ', err);
                }).$promise.then(function (data2) {
                    vm.editcommentid = null;
                    vm.editlogbookid = null;

                    // resForm.comment.$touched || lbc.submitted
                    vm.submitted = false;

                    $log.debug('saving logbook : ', dataLogbook);
                    var queryB = {
                        branch : vm.selectedBranch._id,
                        date : moment(vm.date).format('YYYY/MM/DD')
                    };
                    getSources(queryB).then(function (data3) {
                        vm.logbook = data3;
                        vm.submitted = false;
                    });
                });

            } else {
                // New comment
                dataLogbook = {
                    branch: vm.selectedBranch._id,
                    comment: vm.text,
                    date: moment.utc(vm.date).startOf('day')
                };
                LogbookService.post({}, dataLogbook, function (data1) {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.text = null;
                }, function (err) {
                    $log.error('error saving logbook : ', err);
                }).$promise.then(function (data2) {
                    $log.debug('saving logbook : ', dataLogbook);
                    var queryB = {
                        branch : vm.selectedBranch._id,
                        date : moment(vm.date).format('YYYY/MM/DD')
                    };
                    getSources(queryB).then(function (data3) {
                        vm.logbook = data3;
                        vm.submitted = false;
                    });
                });
            }

        }
    };

    vm.editid = null;

    vm.changeBranches = function () {
        $log.debug('reload logbook about residence ');
        var queryC = {};
        if(vm.selectedBranch) {
           queryC.branch = vm.selectedBranch._id;
        }
        if(vm.date) {
            queryC.date = moment(vm.date).format('YYYY/MM/DD');
        }

        getSources(queryC).then(function (data) {
            vm.logbook = data;
            $rootScope.$digest();
        });
    };

    function getBranches(queryOffset, list) {
        return new Promise(function (full, reject) {
            BranchService.query({}, function (data) {
                $log.debug('Load BranchService list: ', data);
            }, function (err) {
                $log.error('error getting BranchService: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                return list;
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    function getSources(queryParams) {
        return new Promise(function (full, reject) {
            var query = (queryParams) ? queryParams : {};
            LogbookService.get(query, function (data) {
                $log.debug('Load LogbookService list: ', data);
            }, function (err) {
                $log.error('error getting LogbookService: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                return [];
            }).$promise.then(function (data) {
                for (var i = 0; i < data.data.length; i++) {
                    if(data.data[i].shiftEnd && data.data[i].shiftEnd.length > 0 ) {
                        for (var j = 0; j <  data.data[i].shiftEnd.length; j++) {
                            data.data[i].shiftEnd[j].dateFormated = moment(data.data[i].shiftEnd[j].datetime).format('lll');
                        }
                    }
                }
                full(data.data);
            });
        });
    }

    vm.editLog = function(shift, logbookid) {
        // IDS
        vm.editlogbookid = logbookid;
        vm.editcommentid = shift._id;

        // Textarea
        vm.text = shift.comment;
    };

    var selectedBar = localStorageService.get('selectedBarResidence');
    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/dashboard' && !data.all) {
            vm.selectedBranch = data;
            vm.changeBranches();
        }
    });
    $scope.$on('$destroy', unregister);
    vm.$onInit = function () {
        if (vm.initialized) {
            return;
        }
        getBranches().then(function (data1) {
            var availableBranchesByUser = localStorageService.get('branches');
            vm.constants.residences = _.filter(data1, function(item) {
                return _.find(availableBranchesByUser, function (availableBranch) {
                    return availableBranch === item._id;
                });
            });
            if (selectedBar && !selectedBar.all) {
                vm.selectedBranch = selectedBar;
            } else {
                vm.selectedBranch = vm.constants.residences[0];
            }
            var queryD = {
                branch : vm.selectedBranch._id,
                date : moment(vm.date).format('YYYY/MM/DD')
            };

            getSources(queryD).then(function (data2) {
                vm.logbook = data2;
            });
        });

    };
}

angular
    .module('BlurAdmin.logbookCom')
    .component('logbook', {
        templateUrl: 'app/components/logbook/logbook.html',
        controllerAs: 'lbc',
        controller: LogbookController,
        bindings: {
        }
    });


RoomScheduleController.$inject = ['$http', 'serviceConf', '$log', '$scope', 'MasterTableService', 'routeConf', 'toastr', 'TranslationService', '$rootScope', 'localStorageService', 'roomColors', '$uibModal', '$location'];
function RoomScheduleController($http, serviceConf, $log, $scope,  MasterTableService, routeConf, toastr, TranslationService, $rootScope, localStorageService, roomColors, $uibModal, $location) {

    var vm = this;

    vm.selectedBranchID = undefined;

    vm.statusColors = roomColors;

    /**
     * Options for angular-gantt
     */
    vm.options = {
        currentDate:'column',
        currentDateValue: new Date()
    };
    // vm.api = undefined;

    // Datepicker options
    vm.dpoptions = {
        showWeeks: false
    };
    vm.dpvalue = null;

    vm.roomTitle = TranslationService.roomscheduler.room;

    vm.apigantt = function(api){
        api.directives.on.new($scope, function (dName, dScope, dElement, dAttrs, dController) {
            if (dName === 'ganttTask') {
                dElement.bind('click', function (event) {
                    // $log.debug('Click on task with data: ', dScope.task.model.data);
                    vm.taskClick(dScope.task.model.data);
                });
            }

            if(dName === 'ganttRowLabel') {
                dElement.bind('click', function (event) {
                    // console.log(dScope);
                    // Buscar el estado de hoy de la habitacion dScope.getValue();
                    var detailData = _.find(vm.xhr[0].data, ['spot.description', dScope.getValue()]);
                    // console.log(vm.xhr[0].data);
                    vm.taskClick(detailData);
                });
            }
        });
    };

    /**
     * Function to get resident list pdf
     */
    vm.getPeopleIn = function(){
        var urlId = serviceConf.ReportPeopleIn;
        urlId = urlId.replace(':idR', vm.selectedBranchID);
        var con = {
            headers: {
                'authentication': 'Bearer ' + localStorageService.get('sessionToken')
            },
            responseType: 'arraybuffer'
        };
        var daySelected = sessionStorage.getItem('dayRoomList');
        if(daySelected){
            urlId = urlId + '?date=' + moment(daySelected).toDate();
        }
        $http.get(urlId, con).then(function mySuccess(response) {
            vm.pdfName = TranslationService.roomschedulerdetail.peopleList;
            vm.timeBarAppUser = 51;
            var url = window.URL;
            var myBlobObject = new Blob([response.data], {type: 'application/pdf'});
            vm.timeBarAppUser = 81;
            var fileURL = url.createObjectURL(myBlobObject);
            var link = document.createElement('a');
            link.setAttribute('type', 'hidden');
            link.download = vm.pdfName;
            link.href = fileURL;
            link.target = '_self';
            link.click();
            vm.downloadingAppUser = false;
            vm.timeBarAppUser = 98;
        });
    };

    /**
     * Function to get API Data
     */
    vm.getXHRData = function(branch, dateFrom, dateTo) {
        $log.debug('Getting xhr data from roomSchedule');
        vm.data = [];

        MasterTableService.query({idT: routeConf.planningRoom, dateFrom: moment(dateFrom).format('YYYY-MM-DD'), dateTo: moment(dateTo).format('YYYY-MM-DD'), branch: branch}, function (data) {
            vm.xhr = data;
            var numberToClean = 0;
            _.forEach(vm.xhr[0].data, function(item){
                var itemContent = '<div><span class="room-name"><span>H.<b>' + item.spot.code + '</b></span></span>';
                if(item.today.isEmpty) {
                    itemContent = itemContent + '<img width=15 class=\"room-icon\" tooltip-append-to-body="true" ' +
                        'uib-tooltip=\"{{\'ROOMSCHEDULER.AVAILABLE\' | translate }}\" src="assets/tagaste/available.svg">';
                }
                if(item.today.isOccupied && !item.today.isBlocked) {
                    itemContent = itemContent + '<img width=15 class=\"room-icon\" tooltip-append-to-body="true" ' +
                        'uib-tooltip=\"{{\'ROOMSCHEDULER.BUSY\' | translate }}\" src="assets/tagaste/busy.svg">';
                }
                if(item.today.isBlocked) {
                    itemContent = itemContent + '<img width=15 class=\"room-icon\" tooltip-append-to-body="true" ' +
                        'uib-tooltip=\"{{\'ROOMSCHEDULER.LOCKED\' | translate }}\" src="assets/tagaste/locked.svg">';
                }
                if(item.today.isToClean) {
                    numberToClean++;
                    itemContent = itemContent + '<img width=15 class=\"room-icon\" tooltip-append-to-body="true" ' +
                        'uib-tooltip=\"{{\'ROOMSCHEDULER.CLEAN\' | translate }}\" src="assets/tagaste/clean.svg">';
                }
                if(item.today.isReserved && !item.today.isOccupied) {
                    itemContent = itemContent + '<img width=15 class=\"room-icon\" tooltip-append-to-body="true" ' +
                        'uib-tooltip=\"{{\'ROOMSCHEDULER.RESERVED\' | translate }}\" src="assets/tagaste/reserved.svg">';
                }
                if(item.today.isOutToday) {
                    itemContent = itemContent + '<img width=15 class=\"room-icon\" tooltip-append-to-body="true" ' +
                        'uib-tooltip=\"{{\'ROOMSCHEDULER.EXITTODAY\' | translate }}\" src="assets/tagaste/out.svg">';
                }

                // Schedules
                var tasks = [];
                var color;
                var type;
                var data;
                _.forEach(item.schedulesComplete, function(sch) {
                    console.log('item', sch);
                    if(sch.isBlocked || sch.isBlock) {
                        color = roomColors.isBlocked;
                        type = 'isBlocked';
                        // console.error('Locked room: ', sch);
                        data = { id: sch._id, spotid: item.spot._id, spot: item.spot, type: 'isBlocked', dateTo: sch.dateTo };
                    }

                    if(sch.isOccupied && !sch.isBlocked) {
                        color = roomColors.isOccupied;
                        type = 'isOccupied';
                        data = { id: sch._id, type: type };
                    }

                    if(sch.isEmpty) {
                        color = roomColors.isEmpty;
                        type = 'isEmpty';
                    }

                    if(sch.isReserved && !sch.isOccupied) {
                        color = roomColors.isReserved;
                        type = 'isReserved';
                        data = { id: null, spotid: item.spot._id, spot: item.spot, type: type, idArray: sch.idArray };
                    }

                    tasks.push({
                        from: moment(sch.dateFrom),
                        to: moment(sch.dateTo),
                        color: color,
                        data: data
                    });
                });

                vm.data.push({
                    name: item.spot.description,
                    content: itemContent,
                    tasks: tasks
                });
            });
            $rootScope.$emit('updateCleaningNumber', numberToClean);
        }, function (err) {
            $log.error('error load planningRoom: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    /**
     * Open Room Detail
     */
    // vm.openRoomDetail = function (attachment, onlyUsers) {
        // Como parametro iria la id de la habitacion (Evento)
    vm.openRoomDetail = function (data) {
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/modal/modalRoomDetail/modalRoomDetail.html',
            controller: 'ModalRoomDetailController',
            controllerAs: 'mrdc',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalBinding: function () { return data; },
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            //close function
        }, function (closemsg) {
            //dismiss function
            if(closemsg === 'checkin' || closemsg === 'checkout' || closemsg === 'unblock' || closemsg === 'toClean' || closemsg === 'reservation'){
                vm.getXHRData(vm.selectedBranchID, vm.dateFrom, vm.dateTo);
            }
            if(closemsg === 'datesUpdate'){
                vm.getXHRData(vm.selectedBranchID, vm.dateFrom, vm.dateTo);
            }
            if(closemsg === 'checkout'){
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/modal/activityList/activityList.html',
                    controller: 'ModalActivityListController',
                    controllerAs: 'mrdc',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        modalBinding: function () { return data; },
                    }
                });
                // Function when open modal
                modalInstance.result.then(function (result) {
                    //close function
                }, function () {
                    //dismiss function
                });
            }
        });
    };


    /**
     * Selected Branch
     */
    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        vm.selectedBranchID = selectedBar._id;
        // viewParams = {filterResidentsList : {residenceDesc : selectedBar.description} };
    }

    if (selectedBar && selectedBar.all) {
        vm.selectedBranchID = null;
    }
    /**
     * First load (Today + 6 days)
     */
    vm.dateFrom = moment().toDate();
    vm.dateTo = moment().add(6, 'days');
    vm.datesRange = moment($scope.dateFrom).format('DD MMM') + ' - ' + moment(vm.dateTo).format('DD MMM');

    if (vm.selectedBranchID) {
        vm.getXHRData(vm.selectedBranchID, vm.dateFrom, vm.dateTo);
    }
    // Franja verde (Revisar)
    vm.currentdate = new Date();

    /**
     * Function to change next week
     */
    vm.nextWeek = function() {
        vm.dateFrom = moment(vm.dateFrom).add(6, 'days');
        vm.dateTo = moment(vm.dateTo).add(6, 'days');
        vm.datesRange = moment(vm.dateFrom).format('DD MMM') + ' - ' + moment(vm.dateTo).format('DD MMM');

        vm.getXHRData(vm.selectedBranchID, vm.dateFrom, vm.dateTo);
    };

    /**
     * Function to change prev week
     */
    vm.prevWeek = function() {
        vm.dateFrom = moment(vm.dateFrom).subtract(6, 'days');
        vm.dateTo = moment(vm.dateTo).subtract(6, 'days');
        vm.datesRange = moment(vm.dateFrom).format('DD MMM') + ' - ' + moment(vm.dateTo).format('DD MMM');

        vm.getXHRData(vm.selectedBranchID, vm.dateFrom, vm.dateTo);
    };

    /**
     * Function to change week with datepicker
     */
    vm.dpchangeweek = function() {
        window.setTimeout(function() {
            // console.log('Date selected?', vm.dpvalue);
            vm.dateFrom = moment(vm.dpvalue);
            vm.dateTo = moment(vm.dpvalue).add(6, 'days');
            vm.datesRange = moment(vm.dateFrom).format('DD MMM') + ' - ' + moment(vm.dateTo).format('DD MMM');
            vm.getXHRData(vm.selectedBranchID, vm.dateFrom, vm.dateTo);
            sessionStorage.setItem('dayRoomList', vm.dpvalue);
            $rootScope.$emit('DateRoomListChange');
        }, 500);
    };

    /**
     * Function when click on an gantt event
     */
    vm.taskClick = function(data) {
        vm.openRoomDetail(data);
    };

    // Init empty data array
    vm.data = [];

    /**
     * Detect when user change branch
     */
    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if(data._id) {
            vm.selectedBranchID = data._id;
            if($location.path() === '/occupancy') {
                vm.getXHRData(vm.selectedBranchID, vm.dateFrom, vm.dateTo);
            }

        } else {
            vm.selectedBranchID = undefined;
        }
    });
    $scope.$on('$destroy', unregister);
}

angular.module('Tagaste.roomSchedule').component('roomSchedule', {
    templateUrl: 'app/components/roomSchedule/roomSchedule.html',
    controllerAs: 'rsc',
    controller: RoomScheduleController,
    bindings: {}
});

/**
 * Created by plobato on 29/05/2017.
 */
ScheduleController.$inject = ['$log'];
function ScheduleController($log) {
    var ctrl = this;

    var scheduleDayMoment = moment().startOf('day');
    ctrl.scheduleDay = scheduleDayMoment.format('LL');

    ctrl.subDay = function () {
        scheduleDayMoment = scheduleDayMoment.subtract(1, 'day');
        ctrl.scheduleDay = scheduleDayMoment.format('LL');
        ctrl.onChange({day: scheduleDayMoment});
    };

    ctrl.addDay = function () {
        scheduleDayMoment = scheduleDayMoment.add(1, 'day');
        ctrl.scheduleDay = scheduleDayMoment.format('LL');
        ctrl.onChange({day: scheduleDayMoment});
    };

    ctrl.loaded = function() {
        document.getElementsByClassName('schedule-area-container')[0].scrollLeft=9999;
    };

    ctrl.doSomething = function (itemIndex, scheduleIndex, scheduleValue) {
        $log.debug('The model has changed!', itemIndex, scheduleIndex, scheduleValue);
    };
}

angular
    .module('Tagaste.schedule')
    .component('schedule', {
    templateUrl: 'app/components/schedule/schedule.html',
    //controllerAs: '$ctrl',
    controller: ScheduleController,
    bindings: {
        model: '<',
        onChange: '&',
        istour: '<'
    }
});

/*
 * @author sfernandez
 * created on 11/05/2018
 */

/*
 * Component parameters:
 *   type: Type of file (person, food, picture...)
 *   readonly: To disable edit , true or false
 *   size: Size of file (only number)
 *   shape: Shape of picture (squaravatare, circle)
 *   file-style: (CSS Rules)
 *   file: File or base64
 * Example of use
 * <file type="food" shape="square" size="200" readonly="false" file="rutaFichero o base64"
 *       file-style="margin-top:10px"></file>
 */

FileController.$inject = ['$routeParams', '$uibModal', 'BlobService', 'toastr', '$log', 'TranslationService',
    'MasterTableService', 'Upload', 'routeConf', '$q', '$timeout'];

function FileController($routeParams, $uibModal, BlobService, toastr, $log, TranslationService, MasterTableService,
                        Upload, routeConf, $q, $timeout) {
    var vm = this;

    vm.progressVisible = true;
    vm.default = {
        size: '120px',
        shape: 'square'
    };

    vm._CONTROLLER = 'FileController';

    vm.$onInit = function () {
        vm.progressPercentage = 0;
        vm.uploading = false;
        vm.showOverlay = false;
        if (!vm.readonly) {
            vm.readonly = false;
        } else {
            vm.readonly = true;
        }
        if (!vm.size) {
            vm.size = vm.default.size;
        }
        if (!vm.shape) {
            vm.shape = vm.default.shape;
        }
    };


    function getSignedUpload(fileFile) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                    idT: routeConf.file,
                    idJ: routeConf.signedUpload,
                    filename: fileFile.name,
                    type: fileFile.type
                },
                function (data) {
                    full(data);
                }, function (err) {
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    $log.debug('error get signedUpload', err);
                    reject(err);
                });
        });
    }

    function uploadFile(picFile, result) {
        return new Promise(function (full, reject) {
            var key = result.fields.key;
            Upload.upload({
                url: result.url, //s3Url
                transformRequest: function (data, headersGetter) {
                    var headers = headersGetter();
                    delete headers.Authorization;
                    return data;
                },
                fields: result.fields, //credentials
                method: 'POST',
                file: picFile
            }).progress(function (evt) {
                vm.progressPercentage = parseInt(80.0 * evt.loaded / evt.total);
                $log.debug('progress: ' + vm.progressPercentage);
            }).success(function (data, status, headers, config) {
                // file is uploaded successfully
                $log.debug('file ' + config.file.name + 'is uploaded successfully. Response: ' + data);
                vm.progressPercentage = parseInt(90.0);
                full(data);
            }).error(function (err) {
                $log.error('error upload file to s3', err);
                toastr.error(TranslationService.errmsg.uploadError, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                reject(err);
            });
        });
    }

    function addFile(fileFile) {
        return new Promise(function (full, reject) {
            MasterTableService.post({idT: routeConf.file, idJ: routeConf.generateThumb}, {key: fileFile.original.key},
                function (data) {
                    $log.debug('file post correctly', data);
                    vm.progressPercentage = parseInt(95.0);
                    full(data);
                }, function (err) {
                    $log.error('error post file', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    reject(err);
            });
        });
    }

    /**
     * @ngdoc method
     * @name onFileSelect
     * @methodOf BlurAdmin.file:FileController
     * @description
     * Function that load a file
     *
     */
    vm.onFileSelect = function (picFile) {
        $log.debug('file', picFile);
        //vm.picFile = picFile;
        if ((vm.uploading === false) && (picFile !== null) && (picFile !== undefined)) {
            var fileFile = {
                original: {},
                thumb: {},
                extension: picFile.name.substring(picFile.name.lastIndexOf('.') + 1).toLowerCase(),
                filename: picFile.name
            };
            vm.uploading = true;
            vm.progressPercentage = 0;
            getSignedUpload(picFile)
                .then(function (result1) {
                    fileFile.original.key = result1.fields.key;
                    fileFile.signedUrl = result1.url + '/' + result1.fields.key;
                    return uploadFile(picFile, result1);
                })
                .then(function (result2) {
                    return addFile(fileFile);
                })
                .then(function (result3) {
                    vm.progressPercentage = parseInt(99.0);
                    fileFile.thumb.key = result3.thumb.key;
                    fileFile.thumb.bucket = result3.thumb.bucket;
                    fileFile.thumb.signedUrl = result3.thumb.signedUrl;
                    fileFile.original.bucket = result3.thumb.bucket;
                    if (vm.attachedsList) {
                        var newattached = fileFile;
                        if (vm.attached){
                            if (vm.attached._id){
                                newattached.oldattached = {_id : vm.attached._id};
                            }else if (vm.attached.oldattached && vm.attached.oldattached._id){
                                newattached.oldattached = {_id : vm.attached.oldattached._id};
                            }
                        }
                        vm.attached = newattached;
                        if(vm.styleButton){
                            if(!vm.attachedsList){
                                vm.attachedsList = [];
                            }
                            vm.attachedsList.push(newattached);
                        }
                    }
                    vm.progressPercentage = parseInt(99.0);
                    $timeout(function () {

                        vm.uploading = false;
                    }, 500);
                })
                .catch(function (err) {
                    // Handle errors of getSignedUpload and uploadFile
                    $log.error('error post file', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    vm.uploading = false;
                });
        }
    };
}

angular
    .module('BlurAdmin.file')
    .component('file', {
        templateUrl: 'app/components/tmpFile/file.html',
        controllerAs: 'flc',
        controller: FileController,
        bindings: {
            type: '@',
            shape: '@',
            size: '<',
            readonly: '<',
            img: '=',
            fileStyle: '@',
            onClick: '&',
            attached: '<',
            styleButton: '<',
            attachedsList: '=',
            uploading: '='
        }
    });

/*
 * @author jjrubio
 * created on 03/01/2018
 */

/*
 * Component parameters:
 *   type: Type of image (to set default image) (person, food, picture...)
 *   readonly: To disable edit , true or false
 *   size: Size of image (only number)
 *   shape: Shape of picture (square, circle, rectangle)
 *   avatar-style: (CSS Rules)
 *   img: File or base64
 * Example of use
 * <avatar type="food" shape="square" size="200" readonly="false" img="rutaFichero o base64"
 *       avatar-style="margin-top:10px"></avatar>
 */

AvatarController.$inject = ['$routeParams', '$uibModal', 'BlobService', 'toastr', '$log', 'TranslationService',
    'MasterTableService', 'Upload', 'routeConf'];

function AvatarController($routeParams, $uibModal, BlobService, toastr, $log, TranslationService, MasterTableService,
                          Upload, routeConf) {
    var vm = this;

    vm.label = TranslationService.avatar.changeimage;

    vm.default = {
        food: 'app/components/uploadAvatar/assets/foodDefault.png',
        person: 'app/components/uploadAvatar/assets/avatarDefault.png',
        picture: 'app/components/uploadAvatar/assets/picDefault.png',
        size: '128px',
        shape: 'square'
    };

    vm.$onInit = function () {
        vm.showOverlay = false;
        if (!vm.readonly) {
            vm.readonly = false;
        } else {
            vm.readonly = true;
        }
        if (!vm.size) {
            vm.size = vm.default.size;
        }
        if (!vm.shape) {
            vm.shape = vm.default.shape;
        }

        switch (vm.type) {
            case 'food':
                vm.defaultImg = vm.default.food;
                break;
            case 'person':
                vm.defaultImg = vm.default.person;
                break;
            default:
                vm.defaultImg = vm.default.picture;
                break;
        }
    };

    vm.changeImage = function () {
        if (vm.istour){
            return;
        }
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'imageCropContent.html',
            controller: 'ImageCropModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                shape: function () {
                    return vm.shape;
                }
            }
        });
        modalInstance.result.then(function (selectedImage) {
            vm.selected = selectedImage;
            if(vm.selected.file.filetype.includes('image')){
                var imgPrefix = 'data:image/png;base64,';
                vm.avatar = imgPrefix + vm.selected.croppedImage;
                $log.debug('vm.selected: ', vm.selected);
                var blob = BlobService.base64toBlob(vm.selected.croppedImage, {type: vm.selected.file.filetype});
                var file = new File([blob], vm.selected.file.filename);
                var photoFiles = [];
                photoFiles.push(file);
                $log.debug('file', file);
                vm.onFileSelect(photoFiles, true, imgPrefix + vm.selected.croppedImage);
                vm.img = vm.avatar;
            }
            else{
                toastr.warning(TranslationService.errors.onlyImage, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            }
        }, function () {
        });
    };

    /**
     * @ngdoc method
     * @name onFileSelect
     * @methodOf BlurAdmin.avatar:AvatarController
     * @description
     * Function that load a file
     *
     */
    vm.onFileSelect = function (files, avatar, imageAvatar) {
        var avatarFile = {
            original: {},
            thumb: {}
        };
        if (files && files.length > 0) {
            vm.uploading = true;
            var type = files[0].type;
            avatarFile.extension = files[0].name.substring(files[0].name.lastIndexOf('.') + 1).toLowerCase();
            $log.debug('type', type);
            MasterTableService.get({
                    idT: routeConf.file,
                    idJ: routeConf.signedUpload,
                    filename: files[0].name,
                    type: type
                },
                function (result) {
                    avatarFile.filename = files[0].name;
                    $log.debug('dataFileUpload', result);
                    var key = result.fields.key;
                    Upload.upload({
                        url: result.url, //s3Url
                        transformRequest: function (data, headersGetter) {
                            var headers = headersGetter();
                            delete headers.Authorization;
                            return data;
                        },
                        fields: result.fields, //credentials
                        method: 'POST',
                        file: files[0]
                    }).progress(function (evt) {
                        $log.debug('progress: ' + parseInt(100.0 * evt.loaded / evt.total));
                    }).success(function (data, status, headers, config) {
                        // file is uploaded successfully
                        $log.debug('file ' + config.file.name + 'is uploaded successfully. Response: ' + data);
                        avatarFile.original.key = result.fields.key;
                        avatarFile.signedUrl = result.url + '/' + result.fields.key;
                        //generate thumbnail
                        MasterTableService.post({idT: routeConf.file, idJ: routeConf.generateThumb}, {key: key},
                            function (dataFile) {
                                $log.debug('avatar file post correctly', dataFile);
                                avatarFile.thumb.key = dataFile.thumb.key;
                                avatarFile.thumb.bucket = dataFile.thumb.bucket;
                                avatarFile.thumb.signedUrl = dataFile.thumb.signedUrl;
                                avatarFile.original.bucket = dataFile.thumb.bucket;
                                if (avatar) {
                                    var newphoto = avatarFile;
                                    if (vm.photo){
                                        if (vm.photo._id){
                                            newphoto.oldPhoto = {_id : vm.photo._id};
                                        } else if (vm.photo.oldPhoto && vm.photo.oldPhoto._id){
                                            newphoto.oldPhoto = {_id : vm.photo.oldPhoto._id};
                                        }
                                    }
                                    vm.photo = newphoto;
                                    if(vm.styleButton){
                                        if(!vm.photoList){
                                            vm.photoList = [];
                                        }
                                        vm.photoList.push(newphoto);
                                    }
                                    vm.uploading = false;
                                }
                            }, function (err) {
                                $log.error('error post avatar file', err);
                                toastr.error(TranslationService.errors.e500, TranslationService.error,
                                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                            });
                    }).error(function (err) {
                        $log.error('error upload file to s3', err);
                    });
                }, function (err) {
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    $log.debug('error get signedUpload', err);
                });
        }
    };
}

angular
    .module('BlurAdmin.avatar')
    .component('avatar', {
        templateUrl: 'app/components/uploadAvatar/avatar.html',
        controllerAs: 'avc',
        controller: AvatarController,
        bindings: {
            type: '@',
            shape: '@',
            size: '<',
            readonly: '<',
            img: '=',
            avatarStyle: '@',
            onClick: '&',
            photo: '=',
            styleButton:'<',
            photoList:'=',
            uploading: '=',
            istour: '<'
        }
    });
/*
* @author jjrubio
* created on 03/01/2018
*/

angular.module('BlurAdmin.components')
    .controller('ImageCropModalController', ImageCropModalController);

ImageCropModalController.$inject = ['$uibModalInstance', '$log', 'shape'];

function ImageCropModalController($uibModalInstance, $log ,shape){
    var $ctrl = this;

    var imgPrefix = 'data:image/png;base64,';
    $ctrl.croppedImage = '';
    $ctrl.file = {base64: ''};
    $ctrl.image = '';
    $ctrl.shape  = shape;

    if(!$ctrl.shape){
        $ctrl.shape = 'square';
    }

    var response = {
        file: {},
        croppedImage: {}
    };

    $ctrl.ok = function () {
        response.file = $ctrl.file;
        response.croppedImage = $ctrl.croppedImage.replace(imgPrefix, '');
        $uibModalInstance.close(response);
    };

    $ctrl.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $ctrl.onChange = function () {
        $ctrl.image = imgPrefix + $ctrl.file.base64;
    };

}
// /**
//  * @author lavg
//  * created on 17/13/2017
//  */
// (function () {
//     'use strict';
//
//     angular.module('BlurAdmin.login.register')
//         .controller('RegisterController', RegisterController);
//
//     /** @ngInject */
//     function RegisterController($timeout) {
//         function initialize() {
//            console.error('RegisterControllr is coming..');
//         }
//         //
//         $timeout(function(){
//             initialize();
//         }, 100);
//     }
//
// })();

!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e(require("angular")):"function"==typeof define&&define.amd?define(["../../bower_components/angular/angular"],e):"object"==typeof exports?exports["ng-table"]=e(require("angular")):t["ng-table"]=e(t.angular)}(this,function(t){return function(t){function e(r){if(n[r])return n[r].exports;var a=n[r]={i:r,l:!1,exports:{}};return t[r].call(a.exports,a,a.exports,e),a.l=!0,a.exports}var n={};return e.m=t,e.c=n,e.i=function(t){return t},e.d=function(t, n, r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=51)}([function(e,n){e.exports=t},function(t,e,n){"use strict";function r(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}var a=n(0),i=n(3),s=n(37),o=n(7),l=n(10),u=n(9),c=n(8),p=a.module("ngTable-core",[]).provider("ngTableDefaultGetData",i.NgTableDefaultGetDataProvider).factory("ngTableDefaultGetGroups",s.ngTableDefaultGetGroups).value("ngTableDefaults",o.ngTableDefaults).service("ngTableEventsChannel",c.NgTableEventsChannel).service("ngTableSettings",l.NgTableSettings).run(u.NgTableParams.init);e.ngTableCoreModule=p,p.value("NgTableParams",u.NgTableParams);var g=n(7);e.IDefaults=g.IDefaults,r(n(8));var f=n(10);e.ISettings=f.ISettings,r(n(9)),r(n(3)),r(n(36)),r(n(39)),r(n(40)),r(n(41))},function(t,e,n){"use strict";function r(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}var a=n(0),i=n(13),s=n(14),o=n(15),l=n(16);e.NgTableController=l.NgTableController;var u=n(17),c=n(18);e.NgTableFilterConfigProvider=c.NgTableFilterConfigProvider,e.NgTableFilterConfig=c.NgTableFilterConfig;var p=n(19),g=n(20),f=n(21),h=n(22),m=n(23),d=n(24),b=n(25),v=n(26);n(43),n(45),n(44),n(46),n(49),n(48);var $=a.module("ngTable-browser",[]).directive("ngTable",i.ngTable).service("ngTableColumn",s.NgTableColumn).directive("ngTableColumnsBinding",o.ngTableColumnsBinding).controller("ngTableController",l.NgTableController).directive("ngTableDynamic",u.ngTableDynamic).provider("ngTableFilterConfig",c.NgTableFilterConfigProvider).directive("ngTableFilterRow",p.ngTableFilterRow).controller("ngTableFilterRowController",g.NgTableFilterRowController).directive("ngTableGroupRow",f.ngTableGroupRow).controller("ngTableGroupRowController",h.NgTableGroupRowController).directive("ngTablePagination",m.ngTablePagination).directive("ngTableSelectFilterDs",d.ngTableSelectFilterDs).directive("ngTableSorterRow",b.ngTableSorterRow).controller("ngTableSorterRowController",v.NgTableSorterRowController);e.ngTableBrowserModule=$,r(n(27))},function(t,e,n){"use strict";function r(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}r(n(28)),r(n(29)),r(n(30)),r(n(31)),r(n(32))},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e){"use strict";e.ngTableDefaults={params:{},settings:{}}},function(t,e,n){"use strict";var r=n(0),a=function(){function t(t){this.$rootScope=t;var e=this;e=this.addTableParamsEvent("afterCreated",e),e=this.addTableParamsEvent("afterReloadData",e),e=this.addTableParamsEvent("datasetChanged",e),e=this.addTableParamsEvent("pagesChanged",e),e=this.addTableParamsEvent("afterDataFiltered",e),e=this.addTableParamsEvent("afterDataSorted",e)}return t.prototype.addTableParamsEvent=function(t,e){var n=t.charAt(0).toUpperCase()+t.substring(1),a=(i={},i["on"+n]=this.createEventSubscriptionFn(t),i["publish"+n]=this.createPublishEventFn(t),i);return r.extend(e,a);var i},t.prototype.createPublishEventFn=function(t){var e=this;return function(){for(var n=[],r=0;r<arguments.length;r++)n[r-0]=arguments[r];(a=e.$rootScope).$broadcast.apply(a,["ngTable:"+t].concat(n));var a}},t.prototype.createEventSubscriptionFn=function(t){function e(t){return t?n(t)?t:function(e){return e===t}:function(t){return!0}}function n(t){return"function"==typeof t}function r(t){return t&&"function"==typeof t.$new}var a=this;return function(n,i,s){var o,l=a.$rootScope;return r(i)?(l=i,o=e(s)):o=e(i),l.$on("ngTable:"+t,function(t,e){for(var r=[],a=2;a<arguments.length;a++)r[a-2]=arguments[a];if(!e.isNullInstance){var i=[e].concat(r);o.apply(this,i)&&n.apply(this,i)}})}},t.$inject=["$rootScope"],t}();e.NgTableEventsChannel=a},function(t,e,n){"use strict";function r(t){return!isNaN(parseFloat(t))&&isFinite(t)}var a=n(0),i=n(11),s=function(){function t(e,n){var r=this;this.data=[],this.defaultSettings=t.ngTableSettings.createDefaults(),this.isCommittedDataset=!1,this.initialEvents=[],this._params={page:1,count:10,filter:{},sorting:{},group:{}},this._settings=this.defaultSettings,"boolean"==typeof e&&(this.isNullInstance=!0),this.reloadPages=function(){var e;return function(){var n=e,i=r.generatePagesArray(r.page(),r.total(),r.count());a.equals(n,i)||(e=i,t.ngTableEventsChannel.publishPagesChanged(r,i,n))}}(),a.extend(this._params,t.ngTableDefaults.params),this.settings(n),this.parameters(e,!0),t.ngTableEventsChannel.publishAfterCreated(this),a.forEach(this.initialEvents,function(t){t()}),this.initialEvents=null}return t.prototype.count=function(t){return void 0!==t?this.parameters({count:t,page:1}):this._params.count},t.prototype.filter=function(t){if(null!=t&&"object"==typeof t)return this.parameters({filter:t,page:1});if(t===!0){for(var e=Object.keys(this._params.filter),n={},r=0;r<e.length;r++){var a=this._params.filter[e[r]];null!=a&&""!==a&&(n[e[r]]=a)}return n}return this._params.filter},t.prototype.generatePagesArray=function(t,e,n,r){arguments.length||(t=this.page(),e=this.total(),n=this.count());var a,i,s,o;r=r&&r<6?6:r;var l=[];if(o=Math.ceil(e/n),o>1){l.push({type:"prev",number:Math.max(1,t-1),active:t>1}),l.push({type:"first",number:1,active:t>1,current:1===t}),i=Math.round((this._settings.paginationMaxBlocks-this._settings.paginationMinBlocks)/2),s=Math.max(2,t-i),a=Math.min(o-1,t+2*i-(t-s)),s=Math.max(2,s-(2*i-(a-s)));for(var u=s;u<=a;)u===s&&2!==u||u===a&&u!==o-1?l.push({type:"more",active:!1}):l.push({type:"page",number:u,active:t!==u,current:t===u}),u++;l.push({type:"last",number:o,active:t!==o,current:t===o}),l.push({type:"next",number:Math.min(o,t+1),active:t<o})}return l},t.prototype.group=function(t,e){if(void 0===t)return this._params.group;var n={page:1};return i.isGroupingFun(t)&&void 0!==e?(t.sortDirection=e,n.group=t):"string"==typeof t&&void 0!==e?n.group=(r={},r[t]=e,r):n.group=t,this.parameters(n),this;var r},t.prototype.hasErrorState=function(){return!(!this.errParamsMemento||!a.equals(this.errParamsMemento,this.createComparableParams()))},t.prototype.hasFilter=function(){return Object.keys(this.filter(!0)).length>0},t.prototype.hasFilterChanges=function(){var t=this.prevParamsMemento&&this.prevParamsMemento.params.filter;return!a.equals(this._params.filter,t)||this.hasGlobalSearchFieldChanges()},t.prototype.hasGroup=function(t,e){return null==t?i.isGroupingFun(this._params.group)||Object.keys(this._params.group).length>0:i.isGroupingFun(t)?null==e?this._params.group===t:this._params.group===t&&t.sortDirection===e:null==e?Object.keys(this._params.group).indexOf(t)!==-1:this._params.group[t]===e},t.prototype.isDataReloadRequired=function(){return!this.isCommittedDataset||!a.equals(this.createComparableParams(),this.prevParamsMemento)||this.hasGlobalSearchFieldChanges()},t.prototype.isSortBy=function(t,e){return void 0!==e?void 0!==this._params.sorting[t]&&this._params.sorting[t]==e:void 0!==this._params.sorting[t]},t.prototype.orderBy=function(){return i.convertSortToOrderBy(this._params.sorting)},t.prototype.page=function(t){return void 0!==t?this.parameters({page:t}):this._params.page},t.prototype.parameters=function(t,e){if(e=e||!1,void 0!==typeof t){for(var n in t){var i=t[n];if(e&&n.indexOf("[")>=0){for(var s=n.split(/\[(.*)\]/).reverse(),o="",l=0,u=s.length;l<u;l++){var c=s[l];if(""!==c){var p=i;i={},i[o=c]=r(p)?parseFloat(p):p}}"sorting"===o&&(this._params[o]={}),this._params[o]=a.extend(this._params[o]||{},i[o])}else"group"===n?this._params[n]=this.parseGroup(t[n]):this._params[n]=r(t[n])?parseFloat(t[n]):t[n]}return this.log("ngTable: set parameters",this._params),this}return this._params},t.prototype.reload=function(){var e=this,n=null;if(this._settings.$loading=!0,this.prevParamsMemento=a.copy(this.createComparableParams()),this.isCommittedDataset=!0,this.hasGroup())n=this.runInterceptorPipeline(t.$q.when(this._settings.getGroups(this)));else{var r=this._settings.getData;n=this.runInterceptorPipeline(t.$q.when(r(this)))}this.log("ngTable: reload data");var i=this.data;return n.then(function(n){return e._settings.$loading=!1,e.errParamsMemento=null,e.data=n,t.ngTableEventsChannel.publishAfterReloadData(e,n,i),e.reloadPages(),n}).catch(function(n){return e.errParamsMemento=e.prevParamsMemento,t.$q.reject(n)})},t.prototype.settings=function(e){var n=this;if(a.isDefined(e)){var r=t.ngTableSettings.merge(this._settings,e),i=this._settings.dataset;this._settings=r;var s=e.hasOwnProperty("dataset")&&e.dataset!=i;if(s){this.isCommittedDataset&&this.page(1),this.isCommittedDataset=!1;var o=function(){t.ngTableEventsChannel.publishDatasetChanged(n,e.dataset,i)};this.initialEvents?this.initialEvents.push(o):o()}return this.log("ngTable: set settings",this._settings),this}return this._settings},t.prototype.sorting=function(t,e){return"string"==typeof t?(this.parameters({sorting:(n={},n[t]=e,n)}),this):void 0!==t?this.parameters({sorting:t}):this._params.sorting;var n},t.prototype.total=function(t){return void 0!==t?this.settings({total:t}):this._settings.total},t.prototype.url=function(t){function e(t,e){n(i)?i.push(e+"="+encodeURIComponent(t)):i[e]=encodeURIComponent(t)}function n(e){return t}function r(t,e){return"group"===e||void 0!==typeof t&&""!==t}t=t||!1;var i=t?[]:{};for(var s in this._params)if(this._params.hasOwnProperty(s)){var o=this._params[s],l=encodeURIComponent(s);if("object"==typeof o){for(var u in o)if(r(o[u],s)){var c=l+"["+encodeURIComponent(u)+"]";e(o[u],c)}}else!a.isFunction(o)&&r(o,s)&&e(o,l)}return i},t.prototype.createComparableParams=function(){var t=this._params.group;return{params:this._params,groupSortDirection:i.isGroupingFun(t)?t.sortDirection:void 0}},t.prototype.hasGlobalSearchFieldChanges=function(){var t=this._params.filter&&this._params.filter.$,e=this.prevParamsMemento&&this.prevParamsMemento.params.filter&&this.prevParamsMemento.params.filter.$;return!a.equals(t,e)},t.prototype.log=function(){for(var e=[],n=0;n<arguments.length;n++)e[n-0]=arguments[n];this._settings.debugMode&&t.$log.debug&&(r=t.$log).debug.apply(r,e);var r},t.prototype.parseGroup=function(t){var e=this._settings.groupOptions&&this._settings.groupOptions.defaultSort;if(t){if(i.isGroupingFun(t))return null==t.sortDirection&&(t.sortDirection=e),t;if("object"==typeof t){for(var n in t)null==t[n]&&(t[n]=e);return t}return r={},r[t]=e,r}return t;var r},t.prototype.runInterceptorPipeline=function(e){var n=this,r=this._settings.interceptors||[];return r.reduce(function(e,r){var a=r.response&&r.response.bind(r)||t.$q.when,i=r.responseError&&r.responseError.bind(r)||t.$q.reject;return e.then(function(t){return a(t,n)},function(t){return i(t,n)})},e)},t.init=function(e,n,r,a,i){t.$q=e,t.$log=n,t.ngTableDefaults=r,t.ngTableEventsChannel=a,t.ngTableSettings=i},t}();e.NgTableParams=s,s.init.$inject=["$q","$log","ngTableDefaults","ngTableEventsChannel","ngTableSettings"]},function(t,e,n){"use strict";var r=n(0),a=function(){function t(t,e,n){var r=this;this.ngTableDefaults=t,this.ngTableDefaultGetData=e,this.ngTableDefaultGetGroups=n,this.defaults={$loading:!1,dataset:null,total:0,defaultSort:"desc",counts:[10,25,50,100],filterOptions:{filterComparator:void 0,filterDelay:500,filterDelayThreshold:1e4,filterFilterName:void 0,filterFn:void 0,filterLayout:"stack"},getData:function(t){return r.ngTableDefaultGetData(t.settings().dataset,t)},getGroups:this.ngTableDefaultGetGroups,groupOptions:{defaultSort:"asc",isExpanded:!0},interceptors:[],paginationMaxBlocks:11,paginationMinBlocks:5,sortingIndicator:"span"}}return t.prototype.createDefaults=function(){return this.merge(this.defaults,this.ngTableDefaults.settings)},t.prototype.merge=function(t,e){e=r.extend({},e),e.filterOptions&&(e.filterOptions=r.extend({},t.filterOptions||{},e.filterOptions)),e.groupOptions&&(e.groupOptions=r.extend({},t.groupOptions||{},e.groupOptions)),r.isArray(e.dataset)&&(e.total=e.dataset.length);var n=r.extend({},t,e);return r.isArray(e.dataset)&&this.optimizeFilterDelay(n),r.extend({},t,e)},t.prototype.optimizeFilterDelay=function(t){t.filterOptions.filterDelay===this.defaults.filterOptions.filterDelay&&t.total<=t.filterOptions.filterDelayThreshold&&t.getData===this.defaults.getData&&(t.filterOptions.filterDelay=0)},t.$inject=["ngTableDefaults","ngTableDefaultGetData","ngTableDefaultGetGroups"],t}();e.NgTableSettings=a},function(t,e){"use strict";function n(t){var e=[];for(var n in t)e.push(("asc"===t[n]?"+":"-")+n);return e}function r(t){return"function"==typeof t}e.convertSortToOrderBy=n,e.isGroupingFun=r},,function(t,e,n){"use strict";function r(t,e){return{restrict:"A",priority:1001,scope:!0,controller:"ngTableController",compile:function(t){var n,r,i=[],s=0,o=[];if(a.forEach(t.find("tr"),function(t){o.push(a.element(t))}),n=o.filter(function(t){return!t.hasClass("ng-table-group")})[0],r=o.filter(function(t){return t.hasClass("ng-table-group")})[0],n)return a.forEach(n.find("td"),function(t){var n=a.element(t);if(!n.attr("ignore-cell")||"true"!==n.attr("ignore-cell")){var o=function(t){return n.attr("x-data-"+t)||n.attr("data-"+t)||n.attr(t)},l=function(t,e){n.attr("x-data-"+t)?n.attr("x-data-"+t,e):n.attr("data"+t)?n.attr("data"+t,e):n.attr(t,e)},u=function(t){var n=o(t);if(n){var r,a=function(t){return void 0!==r?r:e(n)(t)};return a.assign=function(t,a){var i=e(n);i.assign?i.assign(t.$parent,a):r=a},a}},c=o("title-alt")||o("title");c&&n.attr("data-title-text","{{"+c+"}}"),i.push({id:s++,title:u("title"),titleAlt:u("title-alt"),headerTitle:u("header-title"),sortable:u("sortable"),class:u("header-class"),filter:u("filter"),groupable:u("groupable"),headerTemplateURL:u("header"),filterData:u("filter-data"),show:n.attr("ng-if")?u("ng-if"):void 0}),(r||n.attr("ng-if"))&&l("ng-if","$columns["+(i.length-1)+"].show(this)")}}),function(t,e,n,r){t.$columns=i=r.buildColumns(i),r.setupBindingsToInternalScope(n.ngTable),r.loadFilterData(i),r.compileDirectiveTemplates()}}}}var a=n(0);r.$inject=["$q","$parse"],e.ngTable=r},function(t,e,n){"use strict";function r(t){return null!=t&&a.isFunction(t.$new)}var a=n(0),i=function(){function t(){}return t.prototype.buildColumn=function(t,e,n){var i=Object.create(t),s=this.createDefaults(),o=function(o){if(void 0===i[o]&&(i[o]=s[o]),!a.isFunction(i[o])){var l=function e(){return 1!==arguments.length||r(arguments[0])?t[o]:void e.assign(null,arguments[0])};l.assign=function(e,n){t[o]=n},i[o]=l}var u=i[o];if(i[o]=function(){if(1!==arguments.length||r(arguments[0])){var s=arguments[0]||e,o=Object.create(s);return a.extend(o,{$column:i,$columns:n}),u.call(t,o)}u.assign(e,arguments[0])},u.assign)i[o].assign=u.assign;else{var c,p=i[o],l=function t(){return 1!==arguments.length||r(arguments[0])?void 0!=c?c:p.apply(i,arguments):void t.assign(null,arguments[0])};l.assign=function(t,e){c=e},i[o]=l}};for(var l in s)o(l);return i},t.prototype.createDefaults=function(){return{class:this.createGetterSetter(""),filter:this.createGetterSetter(!1),groupable:this.createGetterSetter(!1),filterData:a.noop,headerTemplateURL:this.createGetterSetter(!1),headerTitle:this.createGetterSetter(""),sortable:this.createGetterSetter(!1),show:this.createGetterSetter(!0),title:this.createGetterSetter(""),titleAlt:this.createGetterSetter("")}},t.prototype.createGetterSetter=function(t){var e=t,n=function t(){return 1!==arguments.length||r(arguments[0])?e:void t.assign(null,arguments[0])};return n.assign=function(t,n){e=n},n},t.$inject=[],t}();e.NgTableColumn=i},function(t,e){"use strict";function n(t){function e(e,n,r){var a=t(r.ngTableColumnsBinding).assign;a&&e.$watch("$columns",function(t){var n=(t||[]).slice(0);a(e,n)})}var n={restrict:"A",link:e};return n}n.$inject=["$parse"],e.ngTableColumnsBinding=n},function(t,e,n){"use strict";var r=n(0),a=n(1),i=function(){function t(t,e,n,r,i,s,o,l,u){this.$scope=t,this.$parse=n,this.$compile=r,this.$attrs=i,this.$element=s,this.$document=o,this.ngTableColumn=l,this.ngTableEventsChannel=u;t.$filterRow={disabled:!1},t.$loading=!1,t.hasOwnProperty("params")||(t.params=new a.NgTableParams(!0)),this.delayFilter=function(){var t;return function(n,r){e.cancel(t),t=e(n,r)}}(),this.$scope.$watch("params",function(t,e){t!==e&&t&&t.reload()},!1),this.subscribeToTableEvents()}return Object.defineProperty(t.prototype,"hasVisibleFilterColumn",{get:function(){var t=this;return!!this.$scope.$columns&&this.some(this.$scope.$columns,function(e){return e.show(t.$scope)&&!!e.filter(t.$scope)})},enumerable:!0,configurable:!0}),t.prototype.onDataReloadStatusChange=function(t){if(t&&!this.$scope.params.hasErrorState()){var e=this.$scope.params,n=e.settings().filterOptions;if(e.hasFilterChanges()){var r=function(){e.page(1),e.reload()};n.filterDelay?this.delayFilter(r,n.filterDelay):r()}else e.reload()}},t.prototype.compileDirectiveTemplates=function(){if(!this.$element.hasClass("ng-table")){this.$scope.templates={header:this.$attrs.templateHeader?this.$attrs.templateHeader:"ng-table/header.html",pagination:this.$attrs.templatePagination?this.$attrs.templatePagination:"ng-table/pager.html"},this.$element.addClass("ng-table");var t=null,e=!1;r.forEach(this.$element.children(),function(t){"THEAD"===t.tagName&&(e=!0)}),e||(t=r.element('<thead ng-include="templates.header"></thead>',this.$document),this.$element.prepend(t));var n=r.element('<div ng-table-pagination="params" template-url="templates.pagination"></div>',this.$document);this.$element.after(n),t&&this.$compile(t)(this.$scope),this.$compile(n)(this.$scope)}},t.prototype.loadFilterData=function(t){function e(t){return t&&"object"==typeof t&&"function"==typeof t.then}var n=this;r.forEach(t,function(t){var a=t.filterData(n.$scope);return a?e(a)?(delete t.filterData,a.then(function(e){r.isArray(e)||r.isFunction(e)||r.isObject(e)||(e=[]),t.data=e})):t.data=a:void delete t.filterData})},t.prototype.buildColumns=function(t){var e=this,n=[];return(t||[]).forEach(function(t){n.push(e.ngTableColumn.buildColumn(t,e.$scope,n))}),n},t.prototype.parseNgTableDynamicExpr=function(t){if(!t||t.indexOf(" with ")>-1){var e=t.split(/\s+with\s+/);return{tableParams:e[0],columns:e[1]}}throw new Error("Parse error (expected example: ng-table-dynamic='tableParams with cols')")},t.prototype.setupBindingsToInternalScope=function(t){var e=this;this.$scope.$watch(t,function(t){void 0!==t&&(e.$scope.params=t)},!1),this.setupFilterRowBindingsToInternalScope(),this.setupGroupRowBindingsToInternalScope()},t.prototype.setupFilterRowBindingsToInternalScope=function(){var t=this;this.$attrs.showFilter?this.$scope.$parent.$watch(this.$attrs.showFilter,function(e){t.$scope.show_filter=e}):this.$scope.$watch(function(){return t.hasVisibleFilterColumn},function(e){t.$scope.show_filter=e}),this.$attrs.disableFilter&&this.$scope.$parent.$watch(this.$attrs.disableFilter,function(e){t.$scope.$filterRow.disabled=e})},t.prototype.setupGroupRowBindingsToInternalScope=function(){var t=this;if(this.$scope.$groupRow={show:!1},this.$attrs.showGroup){var e=this.$parse(this.$attrs.showGroup);this.$scope.$parent.$watch(e,function(e){t.$scope.$groupRow.show=e}),e.assign&&this.$scope.$watch("$groupRow.show",function(n){e.assign(t.$scope.$parent,n)})}else this.$scope.$watch("params.hasGroup()",function(e){t.$scope.$groupRow.show=e})},t.prototype.getVisibleColumns=function(){var t=this;return(this.$scope.$columns||[]).filter(function(e){return e.show(t.$scope)})},t.prototype.subscribeToTableEvents=function(){var t=this;this.$scope.$watch("params.isDataReloadRequired()",function(e){t.onDataReloadStatusChange(e)}),this.ngTableEventsChannel.onAfterReloadData(function(e,n){var r=t.getVisibleColumns();e.hasGroup()?(t.$scope.$groups=n||[],t.$scope.$groups.visibleColumnCount=r.length):(t.$scope.$data=n||[],t.$scope.$data.visibleColumnCount=r.length)},this.$scope,function(e){return t.$scope.params===e}),this.ngTableEventsChannel.onPagesChanged(function(e,n){t.$scope.pages=n},this.$scope,function(e){return t.$scope.params===e})},t.prototype.some=function(t,e){for(var n=!1,r=0;r<t.length;r++){var a=t[r];if(e(a)){n=!0;break}}return n},t.$inject=["$scope","$timeout","$parse","$compile","$attrs","$element","$document","ngTableColumn","ngTableEventsChannel"],t}();e.NgTableController=i},function(t,e,n){"use strict";function r(){return{restrict:"A",priority:1001,scope:!0,controller:"ngTableController",compile:function(t){var e;if(a.forEach(t.find("tr"),function(t){t=a.element(t),t.hasClass("ng-table-group")||e||(e=t)}),e)return a.forEach(e.find("td"),function(t){var e=a.element(t),n=function(t){return e.attr("x-data-"+t)||e.attr("data-"+t)||e.attr(t)},r=n("title");r||e.attr("data-title-text","{{$columns[$index].titleAlt(this) || $columns[$index].title(this)}}");var i=e.attr("ng-if");i||e.attr("ng-if","$columns[$index].show(this)")}),function(t,e,n,r){var a=r.parseNgTableDynamicExpr(n.ngTableDynamic);r.setupBindingsToInternalScope(a.tableParams),r.compileDirectiveTemplates(),t.$watchCollection(a.columns,function(e){t.$columns=r.buildColumns(e),r.loadFilterData(t.$columns)})}}}}var a=n(0);r.$inject=[],e.ngTableDynamic=r},function(t,e,n){"use strict";var r=n(0),a=function(){function t(t){var e=this;this.defaultConfig={defaultBaseUrl:"ng-table/filters/",defaultExt:".html",aliasUrls:{}},this.$get=function(){return t.instantiate(i,{config:r.copy(e.config)})},this.$get.$inject=[],this.resetConfigs()}return t.prototype.resetConfigs=function(){this.config=this.defaultConfig},t.prototype.setConfig=function(t){var e=r.extend({},this.config,t);e.aliasUrls=r.extend({},this.config.aliasUrls,t.aliasUrls),this.config=e},t.$inject=["$injector"],t}();e.NgTableFilterConfigProvider=a;var i=function(){function t(t){this.config=t}return t.prototype.getUrlForAlias=function(t,e){return this.config.aliasUrls[t]||this.config.defaultBaseUrl+t+this.config.defaultExt},t.prototype.getTemplateUrl=function(t,e){var n;return n="string"!=typeof t?t.id:t,n.indexOf("/")!==-1?n:this.getUrlForAlias(n,e)},t.$inject=["config"],t}();e.NgTableFilterConfig=i},function(t,e,n){"use strict";function r(){var t={restrict:"E",replace:!0,templateUrl:a,scope:!0,controller:"ngTableFilterRowController",controllerAs:"$ctrl"};return t}var a=n(42);r.$inject=[],e.ngTableFilterRow=r},function(t,e){"use strict";var n=function(){function t(t,e){this.config=e,t.getFilterPlaceholderValue=this.getFilterPlaceholderValue.bind(this)}return t.prototype.getFilterCellCss=function(t,e){if("horizontal"!==e)return"s12";var n=Object.keys(t).length,r=parseInt((12/n).toString(),10);return"s"+r},t.prototype.getFilterPlaceholderValue=function(t,e){return"string"==typeof t?"":t.placeholder},t.$inject=["$scope","ngTableFilterConfig"],t}();e.NgTableFilterRowController=n},function(t,e,n){"use strict";function r(){var t={restrict:"E",replace:!0,templateUrl:a,scope:!0,controller:"ngTableGroupRowController",controllerAs:"$ctrl"};return t}var a=n(47);r.$inject=[],e.ngTableGroupRow=r},function(t,e){"use strict";var n=function(){function t(t){var e=this;this.$scope=t,this.groupFns=[],t.$watch("params.group()",function(t){e.setGroup(t)},!0)}return t.prototype.getGroupables=function(){var t=this,e=this.$scope.$columns.filter(function(e){return!!e.groupable(t.$scope)});return this.groupFns.concat(e)},t.prototype.getGroupTitle=function(t){return this.isGroupingFunc(t)?t.title:t.title(this.$scope)},t.prototype.getVisibleColumns=function(){var t=this;return this.$scope.$columns.filter(function(e){return e.show(t.$scope)})},t.prototype.groupBy=function(t){this.isSelectedGroup(t)?this.changeSortDirection():this.isGroupingFunc(t)?this.$scope.params.group(t):this.$scope.params.group(t.groupable(this.$scope))},t.prototype.isSelectedGroup=function(t){return this.isGroupingFunc(t)?t===this.$scope.$selGroup:t.groupable(this.$scope)===this.$scope.$selGroup},t.prototype.toggleDetail=function(){return this.$scope.params.settings().groupOptions.isExpanded=!this.$scope.params.settings().groupOptions.isExpanded,this.$scope.params.reload()},t.prototype.changeSortDirection=function(){var t;t=this.$scope.params.hasGroup(this.$scope.$selGroup,"asc")?"desc":this.$scope.params.hasGroup(this.$scope.$selGroup,"desc")?"":"asc",this.$scope.params.group(this.$scope.$selGroup,t)},t.prototype.findGroupColumn=function(t){var e=this;return this.$scope.$columns.filter(function(n){return n.groupable(e.$scope)===t})[0]},t.prototype.isGroupingFunc=function(t){return"function"==typeof t},t.prototype.setGroup=function(t){var e=this.findGroupColumn(this.$scope.$selGroup);if(e&&e.show.assign&&e.show.assign(this.$scope,!0),this.isGroupingFunc(t))this.groupFns=[t],this.$scope.$selGroup=t,this.$scope.$selGroupTitle=t.title;else{var n=Object.keys(t||{})[0],r=this.findGroupColumn(n);r&&(this.$scope.$selGroupTitle=r.title(this.$scope),this.$scope.$selGroup=n,r.show.assign&&r.show.assign(this.$scope,!1))}},t.$inject=["$scope"],t}();e.NgTableGroupRowController=n},function(t,e,n){"use strict";function r(t,e,n){return{restrict:"A",scope:{params:"=ngTablePagination",templateUrl:"="},replace:!1,link:function(r,i){n.onAfterReloadData(function(t){r.pages=t.generatePagesArray()},r,function(t){return t===r.params}),r.$watch("templateUrl",function(n){if(void 0!==n){var s=a.element('<div ng-include="templateUrl"></div>',e);i.append(s),t(s)(r)}})}}}var a=n(0);r.$inject=["$compile","$document","ngTableEventsChannel"],e.ngTablePagination=r},function(t,e){"use strict";function n(){var t={restrict:"A",controller:r};return t}n.$inject=[],e.ngTableSelectFilterDs=n;var r=function(){function t(t,e,n,r){var a=this;this.$scope=t,this.$attrs=n,this.$q=r,this.$column=e(n.ngTableSelectFilterDs)(t),t.$watch(function(){return a.$column&&a.$column.data},function(){a.bindDataSource()})}return t.prototype.bindDataSource=function(){var t=this;this.getSelectListData(this.$column).then(function(e){e&&!t.hasEmptyOption(e)&&e.unshift({id:"",title:""}),e=e||[],t.$scope.$selectData=e})},t.prototype.hasEmptyOption=function(t){for(var e,n=0;n<t.length;n++){var r=t[n];if(r&&""===r.id){e=!0;break}}return e},t.prototype.getSelectListData=function(t){var e=t.data;return e instanceof Array?this.$q.when(e):this.$q.when(e&&e())},t.$inject=["$scope","$parse","$attrs","$q"],t}();e.NgTableSelectFilterDsController=r},function(t,e,n){"use strict";function r(){var t={restrict:"E",replace:!0,templateUrl:a,scope:!0,controller:"ngTableSorterRowController",controllerAs:"$ctrl"};return t}var a=n(50);r.$inject=[],e.ngTableSorterRow=r},function(t,e){"use strict";var n=function(){function t(t){this.$scope=t}return t.prototype.sortBy=function(t,e){var n=t.sortable&&t.sortable();if(n&&"string"==typeof n){var r=this.$scope.params.settings().defaultSort,a="asc"===r?"desc":"asc",i=this.$scope.params.sorting()&&this.$scope.params.sorting()[n]&&this.$scope.params.sorting()[n]===r,s=e.ctrlKey||e.metaKey?this.$scope.params.sorting():{};s[n]=i?a:r,this.$scope.params.parameters({sorting:s})}},t.$inject=["$scope"],t}();e.NgTableSorterRowController=n},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e,n){"use strict";var r=n(0),a=function(){function t(){function t(t,n){function a(n){var a=n.settings().filterOptions;return r.isFunction(a.filterFn)?a.filterFn:t(a.filterFilterName||e.filterFilterName)}function i(n){return t(e.sortingFilterName)}function s(t,e){if(!e.hasFilter())return t;var n=e.filter(!0),r=Object.keys(n),i=r.reduce(function(t,e){return t=c(t,n[e],e)},{}),s=a(e);return s.call(e,t,i,e.settings().filterOptions.filterComparator)}function o(t,e){var n=t.slice((e.page()-1)*e.count(),e.page()*e.count());return e.total(t.length),n}function l(t,e){var n=e.orderBy(),r=i(e);return n.length?r(t,n):t}function u(t,e){if(null==t)return[];var a=r.extend({},p,e.settings().dataOptions),i=a.applyFilter?s(t,e):t;n.publishAfterDataFiltered(e,i);var u=a.applySort?l(i,e):i;return n.publishAfterDataSorted(e,u),a.applyPaging?o(u,e):u}function c(t,e,n){var r=n.split("."),a=t,i=r[r.length-1],s=a,o=r.slice(0,r.length-1);return o.forEach(function(t){s.hasOwnProperty(t)||(s[t]={}),s=s[t]}),s[i]=e,a}var p={applyFilter:!0,applySort:!0,applyPaging:!0};return u.applyPaging=o,u.getFilterFn=a,u.getOrderByFn=i,u}this.filterFilterName="filter",this.sortingFilterName="orderBy";var e=this;this.$get=t,t.$inject=["$filter","ngTableEventsChannel"]}return t}();e.NgTableDefaultGetDataProvider=a},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e,n){"use strict";function r(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}r(n(33)),r(n(34)),r(n(35))},function(t,e,n){"use strict";function r(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}r(n(4)),r(n(6)),r(n(5)),r(n(38))},function(t,e,n){"use strict";function r(t,e){function n(n){var r,o=n.group(),l=void 0;if(s.isGroupingFun(o))r=o,l=o.sortDirection;else{var u=Object.keys(o)[0];l=o[u],r=function(t){return a(t,u)}}var c=n.settings(),p=c.dataOptions;c.dataOptions={applyPaging:!1};var g=c.getData,f=t.when(g(n));return f.then(function(t){var a={};i.forEach(t,function(t){var e=r(t);a[e]=a[e]||{data:[],$hideRows:!c.groupOptions.isExpanded,value:e},a[e].data.push(t)});var o=[];for(var u in a)o.push(a[u]);if(l){var p=e.getOrderByFn(),g=s.convertSortToOrderBy({value:l});o=p(o,g)}return e.applyPaging(o,n)}).finally(function(){c.dataOptions=p})}return n}function a(t,e){var n;if(n="string"==typeof e?e.split("."):e,void 0!==t){if(0===n.length)return t;if(null!==t)return a(t[n[0]],n.slice(1))}}var i=n(0),s=n(11);r.$inject=["$q","ngTableDefaultGetData"],e.ngTableDefaultGetGroups=r},function(t,e,n){"use strict";function r(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}r(n(4)),r(n(6)),r(n(5))},function(t,e){"use strict"},function(t,e){"use strict"},function(t,e,n){var r="ng-table/filterRow.html",a='<tr ng-show=show_filter class=ng-table-filters> <th data-title-text="{{$column.titleAlt(this) || $column.title(this)}}" ng-repeat="$column in $columns" ng-if=$column.show(this) class="filter {{$column.class(this)}}" ng-class="params.settings().filterOptions.filterLayout === \'horizontal\' ? \'filter-horizontal\' : \'\'"> <div ng-repeat="(name, filter) in $column.filter(this)" ng-include=$ctrl.config.getTemplateUrl(filter) class=filter-cell ng-class="[$ctrl.getFilterCellCss($column.filter(this), params.settings().filterOptions.filterLayout), $last ? \'last\' : \'\']"> </div> </th> </tr> ',i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/filters/number.html",a='<input type=number name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] class="input-filter form-control" placeholder="{{getFilterPlaceholderValue(filter, name)}}"/> ',i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/filters/select-multiple.html",a='<select ng-options="data.id as data.title for data in $column.data" ng-disabled=$filterRow.disabled multiple=multiple ng-multiple=true ng-model=params.filter()[name] class="filter filter-select-multiple form-control" name={{name}}> </select> ',i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/filters/select.html",a='<select ng-options="data.id as data.title for data in $selectData" ng-table-select-filter-ds=$column ng-disabled=$filterRow.disabled ng-model=params.filter()[name] class="filter filter-select form-control" name={{name}}> <option style=display:none value=""></option> </select> ',i=n(0);i.module("ng").run(["$templateCache",function(t){
t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/filters/text.html",a='<input type=text name={{name}} ng-disabled=$filterRow.disabled ng-model=params.filter()[name] class="input-filter form-control" placeholder="{{getFilterPlaceholderValue(filter, name)}}"/> ',i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/groupRow.html",a='<tr ng-if=params.hasGroup() ng-show=$groupRow.show class=ng-table-group-header> <th colspan={{$ctrl.getVisibleColumns().length}} class=sortable ng-class="{\n                    \'sort-asc\': params.hasGroup($selGroup, \'asc\'),\n                    \'sort-desc\':params.hasGroup($selGroup, \'desc\')\n                  }"> <a href="" ng-click="isSelectorOpen = !isSelectorOpen" class=ng-table-group-selector> <strong class=sort-indicator>{{$selGroupTitle}}</strong> <button class="btn btn-default btn-xs ng-table-group-close" ng-click="$groupRow.show = false; $event.preventDefault(); $event.stopPropagation();"> <span class="glyphicon glyphicon-remove"></span> </button> <button class="btn btn-default btn-xs ng-table-group-toggle" ng-click="$ctrl.toggleDetail(); $event.preventDefault(); $event.stopPropagation();"> <span class=glyphicon ng-class="{\n                    \'glyphicon-resize-small\': params.settings().groupOptions.isExpanded,\n                    \'glyphicon-resize-full\': !params.settings().groupOptions.isExpanded\n                }"></span> </button> </a> <div class=list-group ng-if=isSelectorOpen> <a href="" class=list-group-item ng-repeat="group in $ctrl.getGroupables()" ng-click=$ctrl.groupBy(group)> <strong>{{ $ctrl.getGroupTitle(group)}}</strong> <strong ng-class="$ctrl.isSelectedGroup(group) && \'sort-indicator\'"></strong> </a> </div> </th> </tr> ',i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/header.html",a="<ng-table-group-row></ng-table-group-row> <ng-table-sorter-row></ng-table-sorter-row> <ng-table-filter-row></ng-table-filter-row> ",i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/pager.html",a='<div class="ng-cloak ng-table-pager" ng-if=params.data.length> <div ng-if=params.settings().counts.length class="ng-table-counts btn-group pull-right"> <button ng-repeat="count in params.settings().counts" type=button ng-class="{\'active\':params.count() == count}" ng-click=params.count(count) class="btn btn-default"> <span ng-bind=count></span> </button> </div> <ul ng-if=pages.length class="pagination ng-table-pagination"> <li class=page-item ng-class="{\'disabled\': !page.active && !page.current, \'active\': page.current}" ng-repeat="page in pages" ng-switch=page.type> <a class=page-link ng-switch-when=prev ng-click=params.page(page.number) href="">&laquo;</a> <a class=page-link ng-switch-when=first ng-click=params.page(page.number) href=""><span ng-bind=page.number></span></a> <a class=page-link ng-switch-when=page ng-click=params.page(page.number) href=""><span ng-bind=page.number></span></a> <a class=page-link ng-switch-when=more ng-click=params.page(page.number) href="">&#8230;</a> <a class=page-link ng-switch-when=last ng-click=params.page(page.number) href=""><span ng-bind=page.number></span></a> <a class=page-link ng-switch-when=next ng-click=params.page(page.number) href="">&raquo;</a> </li> </ul> </div> ',i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){var r="ng-table/sorterRow.html",a="<tr class=ng-table-sort-header> <th title={{$column.headerTitle(this)}} ng-repeat=\"$column in $columns\" ng-class=\"{\n                    'sortable': $column.sortable(this),\n                    'sort-asc': params.sorting()[$column.sortable(this)]=='asc',\n                    'sort-desc': params.sorting()[$column.sortable(this)]=='desc'\n                  }\" ng-click=\"$ctrl.sortBy($column, $event)\" ng-if=$column.show(this) ng-init=\"template = $column.headerTemplateURL(this)\" class=\"header {{$column.class(this)}}\"> <div ng-if=!template class=ng-table-header ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'div'}\"> <span ng-bind=$column.title(this) ng-class=\"{'sort-indicator': params.settings().sortingIndicator == 'span'}\"></span> </div> <div ng-if=template ng-include=template></div> </th> </tr> ",i=n(0);i.module("ng").run(["$templateCache",function(t){t.put(r,a)}]),t.exports=r},function(t,e,n){"use strict";function r(t){for(var n in t)e.hasOwnProperty(n)||(e[n]=t[n])}var a=n(0),i=n(1),s=n(2),o=a.module("ngTable",[i.ngTableCoreModule.name,s.ngTableBrowserModule.name]);e.ngTableModule=o,r(n(1)),r(n(2))}])});

;(function (window, undefined) {
    'use strict';

    angular.module('weeklyScheduler', ['ngWeeklySchedulerTemplates']);

    /* jshint -W098 */
    var GRID_TEMPLATE = angular.element('<div class="grid-item"></div>');
    var GRID_TEMPLATE_NON_AVAILABLE = angular.element('<div class="grid-item nonAvailable"></div>');
    var CLICK_ON_A_CELL = 'clickOnACell';
    var MILISEC_ON_HOUR = 3600000;

    var isCtrl;

    function ctrlCheck(e) {
        if (e.which === 17) {
            isCtrl = e.type === 'keydown';
        }
    }

    function mouseScroll(el, delta) {
        window.addEventListener('keydown', ctrlCheck);
        window.addEventListener('keyup', ctrlCheck);

        el.addEventListener('mousewheel', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if (isCtrl) {
                var style = el.firstChild.style, currentWidth = parseInt(style.width);
                if ((e.wheelDelta || e.detail) > 0) {
                    style.width = (currentWidth + 2 * delta) + '%';
                } else {
                    var width = currentWidth - 2 * delta;
                    style.width = (width > 100 ? width : 100) + '%';
                }
            } else {
                if ((e.wheelDelta || e.detail) > 0) {
                    el.scrollLeft -= delta;
                } else {
                    el.scrollLeft += delta;
                }
            }
            return false;
        });
    }

    /*jshint +W098 */
    /* global GRID_TEMPLATE, CLICK_ON_A_CELL */
    angular.module('weeklyScheduler')
        .directive('monthlyGrid', ['weeklySchedulerTimeService', function (timeService) {
            function handleClickEvent(child, totalWidth, nbMonths, idx, scope) {
                child.bind('click', function () {
                    scope.$broadcast(CLICK_ON_A_CELL, {
                        nbElements: nbMonths,
                        idx: idx,
                        percentWidthFromBeginning: totalWidth
                    });
                });
            }

            function doGrid(scope, element, attrs, model) {
                // Clean element
                element.empty();
                // Calculation month distribution
                var months = timeService.monthDistribution(model.minDate, model.maxDate);

                var totalWidth = 0;
                // Deploy the grid system on element
                months.forEach(function (month, idx) {
                    var child = GRID_TEMPLATE.clone().css({width: month.width + '%'});
                    if (angular.isUndefined(attrs.noText)) {
                        handleClickEvent(child, totalWidth, months.length, idx, scope);
                        child.text(timeService.dF(month.start.toDate(), 'MMM yyyy'));
                    }
                    totalWidth += month.width;
                    element.append(child);
                });
            }

            return {
                restrict: 'E',
                require: '^weeklyScheduler',
                link: function (scope, element, attrs, schedulerCtrl) {
                    schedulerCtrl.$modelChangeListeners.push(function (newModel) {
                        doGrid(scope, element, attrs, newModel);
                    });
                }
            };
        }]);
    /* global GRID_TEMPLATE, CLICK_ON_A_CELL */
    angular.module('weeklyScheduler')
        .directive('weeklyGrid', [function () {
            function handleClickEvent(child, nbWeeks, idx, scope) {
                child.bind('click', function () {
                    scope.$broadcast(CLICK_ON_A_CELL, {
                        nbElements: nbWeeks,
                        idx: idx
                    });
                });
            }

            function checkGridElementAvailable(date, availableGrid) {
                var toDate = new Date(date);
                var isoWeekDay = toDate.getDay();
                var hour = toDate.getHours();

                return _.some(availableGrid, function (r) {
                    return (r.isoWeekday === isoWeekDay) && (parseInt(r.hourFrom) / MILISEC_ON_HOUR <= hour) && (hour < parseInt(r.hourTo) / MILISEC_ON_HOUR);
                });
            }

            function doGrid(scope, element, attrs, model) {
                var i;
                // Calculate week width distribution
                var tickcount = model.nbWeeks;
                var ticksize = 100 / tickcount;
                var gridItemElAvailable = angular.copy(GRID_TEMPLATE).css({width: ticksize + '%'});
                var gridItemElNonAvailable = angular.copy(GRID_TEMPLATE_NON_AVAILABLE).css({width: ticksize + '%'});
                var now = model.minDate.clone().startOf('hour');
                now = now.subtract(60, 'minute');
                // Clean element
                element.empty();

                var availableGridElement = true;
                var availableGrid = null;
                if (scope.item && scope.item.timetable && scope.item.timetable.length) {
                    availableGrid = scope.item.timetable;
                }
                var child = null;
                for (i = 0; i < tickcount; i++) {
                    now = now.add(60, 'minute');
                    if (angular.isUndefined(attrs.noText)) {
                        child = gridItemElAvailable.clone();
                        handleClickEvent(child, tickcount, i, scope);
                        child.text(now.format('HH') + ':' + now.format('mm'));
                    } else {
                        if (availableGrid) {
                            availableGridElement = checkGridElementAvailable(now, availableGrid);
                            child = availableGridElement ? gridItemElAvailable.clone() : gridItemElNonAvailable.clone();
                        } else {
                            child = gridItemElAvailable.clone();
                        }
                        // child.text('num ' + i);
                    }
                    element.append(child);
                }
            }

            return {
                restrict: 'E',
                require: '^weeklyScheduler',
                link: function (scope, element, attrs, schedulerCtrl) {
                    if (schedulerCtrl.config) {
                        doGrid(scope, element, attrs, schedulerCtrl.config);
                    }
                    schedulerCtrl.$modelChangeListeners.push(function (newModel) {
                        doGrid(scope, element, attrs, newModel);
                    });
                }
            };
        }]);
    angular.module('weeklyScheduler')
        .directive('handle', ['$document', function ($document) {
            return {
                restrict: 'A',
                scope: {
                    ondrag: '=',
                    ondragstop: '=',
                    ondragstart: '='
                },
                link: function (scope, element) {
                    var x = 0;

                    element.on('mousedown', function (event) {
                        // Prevent default dragging of selected content
                        event.preventDefault();

                        x = event.pageX;

                        $document.on('mousemove', mousemove);
                        $document.on('mouseup', mouseup);

                        if (scope.ondragstart) {
                            scope.ondragstart();
                        }
                    });

                    function mousemove(event) {
                        var delta = event.pageX - x;
                        if (scope.ondrag) {
                            scope.ondrag(delta);
                        }
                    }

                    function mouseup() {
                        $document.unbind('mousemove', mousemove);
                        $document.unbind('mouseup', mouseup);

                        if (scope.ondragstop) {
                            scope.ondragstop();
                        }
                    }
                }
            };
        }]);
    angular.module('weeklyScheduler')
        .directive('inject', [function () {

            return {
                link: function ($scope, $element, $attrs, controller, $transclude) {
                    if (!$transclude) {
                        throw 'Illegal use of ngTransclude directive in the template! No parent directive that requires a transclusion found.';
                    }
                    var innerScope = $scope.$new();
                    $transclude(innerScope, function (clone) {
                        $element.empty();
                        $element.append(clone);
                        $element.on('$destroy', function () {
                            innerScope.$destroy();
                        });
                    });
                }
            };
        }]);
    angular.module('weeklyScheduler')

        .filter('byIndex', [function () {
            return function (input, index) {
                var ret = [];
                angular.forEach(input, function (el) {
                    if (el.index === index) {
                        ret.push(el);
                    }
                });
                return ret;
            };
        }])

        .directive('multiSlider', ['weeklySchedulerTimeService', function (timeService) {
            return {
                restrict: 'E',
                require: '^weeklyScheduler',
                templateUrl: 'ng-weekly-scheduler/views/multi-slider.html',
                link: function (scope, element, attrs, schedulerCtrl) {
                    // avoid new modal on calendar scheduler (only service scheduler)
                    if (scope && !scope.worker) {
                        var conf = schedulerCtrl.config;

                        // The default scheduler block size when adding a new item
                        var defaultNewScheduleSize = parseInt(attrs.size) || 1;

                        var valToPixel = function (val) {
                            var percent = val / (conf.nbWeeks);
                            var opoer1 = percent * element[0].clientWidth;
                            return Math.floor(percent * element[0].clientWidth);
                        };

                        var pixelToVal = function (pixel) {
                            var percent = pixel / element[0].clientWidth;
                            return Math.floor(percent * (conf.nbWeeks));
                        };
                        var addSlot = function (start, end) {
                            start = start >= 0 ? start : 0;
                            end = end <= conf.nbWeeks ? end : conf.nbWeeks;

                            var startDate = timeService.addWeek(conf.minDate, start);
                            var endDate = timeService.addWeek(conf.minDate, end);

                            scope.$apply(function () {
                                var item = scope.item;
                                if (!item.schedules) {
                                    item.schedules = [];
                                }
                                //item.schedules.push({start: startDate.toDate(), end: endDate.toDate()});
                                item.scheduleToAdd = ({start: startDate.toDate(), end: endDate.toDate()});
                            });
                            scope.$emit('showReserveNew', scope.item);
                            scope.$broadcast('disableClickEvents');
                        };

                        var hoverElement = angular.element(element.find('div')[0]);
                        var hoverElementWidth = valToPixel(defaultNewScheduleSize);

                        hoverElement.css({
                            width: hoverElementWidth + 'px'
                        });

                        element.on('mousemove', function (e) {
                            var elOffX = element[0].getBoundingClientRect().left;

                            hoverElement.css({
                                left: e.pageX - elOffX - hoverElementWidth / 2 + 'px'
                            });
                        });

                        hoverElement.on('click', function (event) {
                            if (!element.attr('no-add')) {
                                var elOffX = element[0].getBoundingClientRect().left;
                                var pixelOnClick = event.pageX - elOffX;
                                var valOnClick = pixelToVal(pixelOnClick);

                                var start = Math.round(valOnClick - defaultNewScheduleSize / 2);
                                var end = start + defaultNewScheduleSize;

                                var hoverGridElement = angular.element(element.offsetParent());
                                var hoverGridElement2 = angular.element(hoverGridElement.children());
                                var hoverGridElement3 = angular.element(hoverGridElement2.children())[start];

                                if (hoverGridElement3.className.indexOf('nonAvailable') >= 0) {
                                } else {
                                    addSlot(start, end);
                                }
                            }
                        });
                    }
                }
            };
        }]);
    /* global mouseScroll, CLICK_ON_A_CELL, zoomInACell */
    angular.module('weeklyScheduler')

        .directive('weeklyScheduler', ['$parse', 'weeklySchedulerTimeService', '$log', function ($parse, timeService, $log) {

            var defaultOptions = {
                monoSchedule: false,
                selector: '.schedule-area-container'
            };

            /**
             * Configure the scheduler.
             * @param schedules
             * @param options
             * @returns {{minDate: *, maxDate: *, nbWeeks: *}}
             */
            function config(schedules, options, scheduleDay) {
                var now = '';
                if (schedules.length > 0) {
                    now = moment(schedules[0].date);
                } else {
                    if (scheduleDay !== undefined) {
                        now = scheduleDay;
                    } else {
                        now = moment();
                    }
                }

                // Calculate min date of all scheduled events
                // var minDate = (schedules ? schedules.reduce(function (minDate, slot) {
                //     return timeService.compare(slot.start, 'isBefore', minDate);
                // }, now) : now).startOf('week');
                //
                // // Calculate max date of all scheduled events
                // var maxDate = (schedules ? schedules.reduce(function (maxDate, slot) {
                //     return timeService.compare(slot.end, 'isAfter', maxDate);
                // }, now) : now).clone().add(1, 'year').endOf('week');

                var minDate = moment(now).startOf('day');
                var maxDate = minDate.clone().endOf('day');

                // Calculate nb of weeks covered by minDate => maxDate
                //var nbWeeks = timeService.weekDiff(minDate, maxDate);
                var nbWeeks = 24;

                var result = angular.extend(options, {minDate: minDate, maxDate: maxDate, nbWeeks: nbWeeks});
                // Log configuration
                $log.debug('Weekly Scheduler configuration:', result);

                return result;
            }

            return {
                restrict: 'E',
                require: 'weeklyScheduler',
                transclude: true,
                templateUrl: 'ng-weekly-scheduler/views/weekly-scheduler.html',
                controller: ['$injector', function ($injector) {
                    // Try to get the i18n service
                    var name = 'weeklySchedulerLocaleService';
                    if ($injector.has(name)) {
                        $log.info('The I18N service has successfully been initialized!');
                        var localeService = $injector.get(name);
                        defaultOptions.labels = localeService.getLang();
                    } else {
                        $log.info('No I18N found for this module, check the ng module [weeklySchedulerI18N] if you need i18n.');
                    }

                    // Will hang our model change listeners
                    this.$modelChangeListeners = [];
                }],
                controllerAs: 'schedulerCtrl',
                link: function (scope, element, attrs, schedulerCtrl) {
                    var optionsFn = $parse(attrs.options),
                        options = angular.extend(defaultOptions, optionsFn(scope) || {});

                    // Get the schedule container element
                    var el = element[0].querySelector(defaultOptions.selector);
                    schedulerCtrl.istour = attrs.istour;

                    function onModelChange(items) {
                        // Check items are present
                        if (items) {

                            // Check items are in an Array
                            if (!angular.isArray(items)) {
                                throw 'You should use weekly-scheduler directive with an Array of items';
                            }

                            // Keep track of our model (use it in template)
                            schedulerCtrl.items = items;

                            // First calculate configuration
                            schedulerCtrl.config = config(items.reduce(function (result, item) {
                                var schedules = item.schedules;

                                return result.concat(schedules && schedules.length ?
                                    // If in multiSlider mode, ensure a schedule array is present on each item
                                    // Else only use first element of schedule array
                                    (options.monoSchedule ? item.schedules = [schedules[0]] : schedules) :
                                    item.schedules = []
                                );
                            }, []), options, scope.$ctrl.model.scheduleDay);

                            // Then resize schedule area knowing the number of weeks in scope
                            el.firstChild.style.width = schedulerCtrl.config.nbWeeks / schedulerCtrl.config.nbWeeks * 100 + '%';

                            // Finally, run the sub directives listeners
                            schedulerCtrl.$modelChangeListeners.forEach(function (listener) {
                                listener(schedulerCtrl.config);
                            });
                        }
                    }

                    if (el) {
                        // Install mouse scrolling event listener for H scrolling
                        mouseScroll(el, 20);

                        // scope.$on(CLICK_ON_A_CELL, function(e, data) {
                        //     var nbElements = data.nbElements;
                        //     var idx = data.idx;
                        // });
                        schedulerCtrl.on = {
                            change: function (itemIndex, scheduleIndex, scheduleValue) {
                                var onChangeFunction = $parse(attrs.onChange)(scope);
                                if (angular.isFunction(onChangeFunction)) {
                                    return onChangeFunction(itemIndex, scheduleIndex, scheduleValue);
                                }
                            }
                        };

                        /**
                         * Watch the model items
                         */
                        scope.$watchCollection(attrs.items, onModelChange);

                        /**
                         * Listen to $locale change (brought by external module weeklySchedulerI18N)
                         */
                        scope.$on('weeklySchedulerLocaleChanged', function (e, labels) {
                            if (schedulerCtrl.config) {
                                schedulerCtrl.config.labels = labels;
                            }
                            onModelChange(angular.copy($parse(attrs.items)(scope), []));
                        });
                    }
                }
            };
        }]);

    angular.module('weeklyScheduler')
        .directive('weeklySlot', ['weeklySchedulerTimeService', 'TranslationService', function (timeService, TranslationService) {
            return {
                restrict: 'E',
                require: ['^weeklyScheduler', 'ngModel'],
                templateUrl: 'ng-weekly-scheduler/views/weekly-slot.html',
                link: function (scope, element, attrs, ctrls) {
                    var schedulerCtrl = ctrls[0], ngModelCtrl = ctrls[1];
                    var conf = schedulerCtrl.config;
                    var index = scope.$parent.$index;
                    var containerEl = element.parent();
                    var resizeDirectionIsStart = true;
                    var valuesOnDragStart = {start: _.get(scope, 'schedule.start'), end: _.get(scope, 'schedule.end')};
                    var pixelToVal = function (pixel) {
                        var percent = pixel / containerEl[0].clientWidth;
                        return Math.round((percent * conf.nbWeeks));
                    };

                    var mergeOverlaps = function () {
                        var schedule = scope.schedule;
                        var schedules = scope.item.schedules;
                        schedules.forEach(function (el) {
                            if (el !== schedule && el && schedule) {
                                // model is inside another slot
                                if (el.end >= schedule.end && el.start <= schedule.start) {
                                    schedules.splice(schedules.indexOf(el), 1);
                                    schedule.end = el.end;
                                    schedule.start = el.start;
                                }
                                // model completely covers another slot
                                else if (schedule.end >= el.end && schedule.start <= el.start) {
                                    schedules.splice(schedules.indexOf(el), 1);
                                }
                                // another slot's end is inside current model
                                else if (el.end >= schedule.start && el.end <= schedule.end) {
                                    schedules.splice(schedules.indexOf(el), 1);
                                    schedule.start = el.start;
                                }
                                // another slot's start is inside current model
                                else if (el.start >= schedule.start && el.start <= schedule.end) {
                                    schedules.splice(schedules.indexOf(el), 1);
                                    schedule.end = el.end;
                                }
                            }
                        });

                    };
                    var isNotDragged = function (originValues) {
                        var schedule = ngModelCtrl.$viewValue;

                        var oldStart = Math.round(originValues.start);
                        var oldEnd = Math.round(originValues.end);
                        var newStart = Math.round(schedule.start);
                        var newEnd = Math.round(schedule.end);
                        return (oldStart === newStart && oldEnd === newEnd);
                    };

                    var checkOverlaps = function (originValues) {
                        var schedule = scope.schedule;
                        var scheduleView = ngModelCtrl.$viewValue;
                        schedule.start.setHours(scheduleView.start);
                        schedule.end.setHours(scheduleView.end);

                        var schedules = scope.item.schedules;
                        var invalidValues = schedules.some(function (pElem) {
                            return ((pElem !== schedule) && ((pElem.end.getTime() >= schedule.start.getTime()) && (pElem.start.getTime() <= schedule.end.getTime())));
                        });

                        var isoWeekDay = schedule.start.getDay();
                        var availableGridElement = scope.item.timetable && scope.item.timetable.some(function (r) {
                            return (r.isoWeekday === isoWeekDay) && (parseInt(r.hourFrom) / MILISEC_ON_HOUR <= scheduleView.start) && (scheduleView.end <= parseInt(r.hourTo) / MILISEC_ON_HOUR);
                        });

                        if ((invalidValues) || (!availableGridElement)) {
                            swal({
                                title: TranslationService.modal.alert,
                                text: TranslationService.modal.reserve.ReserveMoveerror,
                                showCancelButton: false,
                                confirmButtonText: TranslationService.modal.button.ok
                            }).then(function (result) {
                                schedule.start = originValues.start;
                                schedule.end = originValues.end;
                                ngModelCtrl.$setViewValue({
                                    start: originValues.start,
                                    end: originValues.end,
                                    _id: ngModelCtrl.$viewValue._id
                                });
                                ngModelCtrl.$render();
                            });
                        } else {
                            swal({
                                title: TranslationService.modal.confirmation,
                                text: TranslationService.modal.reserve.ReserveMovesuccess,
                                showCancelButton: true,
                                confirmButtonText: TranslationService.modal.button.ok,
                                cancelButtonText: TranslationService.modal.button.cancel
                            }).then(function (result) {
                                if (result.value) {
                                    scope.$emit('moveReserve', schedule);
                                    scope.$broadcast('disableClickEvents');
                                } else {
                                    schedule.start = originValues.start;
                                    schedule.end = originValues.end;
                                    ngModelCtrl.$setViewValue({
                                        start: originValues.start,
                                        end: originValues.end,
                                        _id: ngModelCtrl.$viewValue._id
                                    });
                                    ngModelCtrl.$render();
                                }
                            });
                        }
                    };

                    /**
                     * Delete on right click on slot
                     */
                    var deleteSelf = function () {
                        containerEl.removeClass('dragging');
                        containerEl.removeClass('slot-hover');
                        scope.item.schedules.splice(scope.item.schedules.indexOf(scope.schedule), 1);
                        containerEl.find('weekly-slot').remove();
                        scope.$apply();
                        //item.scheduleToAdd = ({start: startDate.toDate(), end: endDate.toDate()});
                        scope.$emit('showReserveCancel', scope.schedule);
                        scope.$broadcast('disableClickEvents');
                    };

                    element.find('span').on('click', function (e) {
                        e.preventDefault();
                        scope.$emit('showReserveCancel', scope.schedule);
                        //deleteSelf();
                    });

                    element.on('mouseover', function () {
                        containerEl.addClass('slot-hover');
                    });

                    element.on('mouseleave', function () {
                        containerEl.removeClass('slot-hover');
                    });

                    element.on('click', function () {
                        if (_.get(scope, 'schedule.wtaskID')) {
                            scope.schedule['worker'] = _.get(scope, '$parent.item.worker', null);
                            scope.$emit('showWorkerTaskDetail', scope.schedule);
                        }
                    });

                    if (scope.item.editable !== false) {

                        scope.startResizeStart = function () {
                            resizeDirectionIsStart = true;
                            scope.startDrag();
                        };

                        scope.startResizeEnd = function () {
                            resizeDirectionIsStart = false;
                            scope.startDrag();
                        };

                        scope.startDrag = function () {
                            element.addClass('active');
                            containerEl.addClass('dragging');
                            containerEl.attr('no-add', true);
                            valuesOnDragStart = {
                                start: ngModelCtrl.$viewValue.start,
                                end: ngModelCtrl.$viewValue.end,
                                _id: ngModelCtrl.$viewValue._id
                            };
                        };

                        scope.endDrag = function () {
                            // this prevents user from accidentally
                            // adding new slot after resizing or dragging
                            setTimeout(function () {
                                containerEl.removeAttr('no-add');
                            }, 500);

                            element.removeClass('active');
                            containerEl.removeClass('dragging');

                            if (isNotDragged(valuesOnDragStart)) {
                                scope.$emit('showReserveCancel', scope.schedule);
                                scope.$broadcast('disableClickEvents');
                            } else {
                                checkOverlaps(valuesOnDragStart);
                            }

                            scope.$apply();
                        };

                        scope.resize = function (d) {
                            var ui = ngModelCtrl.$viewValue;
                            var delta = pixelToVal(d);


                            if (resizeDirectionIsStart) {
                                var newStart = Math.round((valuesOnDragStart.start + delta) * 2) / 2;

                                if (ui.start !== newStart && newStart <= ui.end - 1 && newStart >= 0) {
                                    ngModelCtrl.$setViewValue({
                                        start: newStart,
                                        end: ui.end,
                                        _id: ui._id
                                    });
                                    ngModelCtrl.$render();
                                }
                            } else {
                                var newEnd = Math.round((valuesOnDragStart.end + delta) * 2) / 2;

                                if (ui.end !== newEnd && newEnd >= ui.start + 1 && newEnd <= conf.nbWeeks) {
                                    ngModelCtrl.$setViewValue({
                                        start: ui.start,
                                        end: newEnd,
                                        _id: ui._id
                                    });
                                    ngModelCtrl.$render();
                                }
                            }
                        };

                        scope.drag = function (d) {

                            var ui = ngModelCtrl.$viewValue;
                            var delta = pixelToVal(d);
                            var duration = valuesOnDragStart.end - valuesOnDragStart.start;

                            var newStart = Math.round((valuesOnDragStart.start + delta) * 2) / 2;
                            var newEnd = Math.round((newStart + duration) * 2) / 2;

                            if (ui.start !== newStart && newStart >= 0 && newEnd <= conf.nbWeeks) {
                                ngModelCtrl.$setViewValue({
                                    start: newStart,
                                    end: newEnd,
                                    _id: ui._id
                                });
                                ngModelCtrl.$render();
                            }
                        };
                    }

                    // on init, merge overlaps
                    mergeOverlaps(true);

                    //// UI -> model ////////////////////////////////////
                    ngModelCtrl.$parsers.push(function onUIChange(ui) {
                        ngModelCtrl.$modelValue.start = timeService.addWeek(conf.minDate, ui.start).toDate();
                        ngModelCtrl.$modelValue.end = timeService.addWeek(conf.minDate, ui.end).toDate();
                        ngModelCtrl.$modelValue._id = ui._id;
                        //$log.debug('PARSER :', ngModelCtrl.$modelValue.$$hashKey, index, scope.$index, ngModelCtrl.$modelValue);
                        schedulerCtrl.on.change(index, scope.$index, ngModelCtrl.$modelValue);
                        return ngModelCtrl.$modelValue;
                    });

                    //// model -> UI ////////////////////////////////////
                    ngModelCtrl.$formatters.push(function onModelChange(model) {
                        return {
                            start: timeService.weekPreciseDiff(conf.minDate, moment(_.get(model, 'start')), true),
                            end: timeService.weekPreciseDiff(conf.minDate, moment(_.get(model, 'end')), true),
                            facility: _.get(model, 'facility'),
                            _id: _.get(model, '_id')
                        };
                    });

                    ngModelCtrl.$render = function () {
                        var ui = ngModelCtrl.$viewValue;
                        var css = {
                            left: (ui.start) / conf.nbWeeks * 100 + '%',
                            width: (ui.end - ui.start) / conf.nbWeeks * 100 + '%'
                        };
                        element.css(css);
                    };

                    scope.$on('weeklySchedulerLocaleChanged', function () {
                        // Simple change object reference so that ngModel triggers formatting & rendering
                        scope.schedule = angular.copy(scope.schedule);
                    });
                }
            };
        }]);
    angular.module('weeklySchedulerI18N', ['tmh.dynamicLocale']);

    angular.module('weeklySchedulerI18N')
        .provider('weeklySchedulerLocaleService', ['tmhDynamicLocaleProvider', function (tmhDynamicLocaleProvider) {

            var defaultConfig = {
                doys: {'en': 4, 'es': 4},
                lang: {
                    'en': {month: 'Month', weekNb: 'Hour', addNew: ' '},
                    'es': {month: 'Mes', weekNb: 'Hora', addNew: ' '}
                }
            };

            this.configure = function (config) {
                if (config && angular.isObject(config)) {
                    angular.merge(defaultConfig, config);

                    if (defaultConfig.localeLocationPattern) {
                        tmhDynamicLocaleProvider.localeLocationPattern(defaultConfig.localeLocationPattern);
                    }
                }
            };

            this.$get = ['$rootScope', '$locale', 'tmhDynamicLocale', function ($rootScope, $locale, tmhDynamicLocale) {
                var momentLocaleCache = {};

                function getLang() {
                    var key = $locale.id;
                    if (!momentLocaleCache[key]) {
                        momentLocaleCache[key] = getMomentLocale(key);
                        moment.locale(momentLocaleCache[key].id, momentLocaleCache[key].locale);
                    } else {
                        moment.locale(momentLocaleCache[key].id);
                    }
                    return defaultConfig.lang[key];
                }

                // We just need few moment local information
                function getMomentLocale(key) {
                    return {
                        id: key,
                        locale: {
                            week: {
                                // Angular monday = 0 whereas Moment monday = 1
                                dow: ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 1) % 7,
                                doy: defaultConfig.doys[key]
                            }
                        }
                    };
                }

                $rootScope.$on('$localeChangeSuccess', function () {
                    $rootScope.$broadcast('weeklySchedulerLocaleChanged', getLang());
                });

                return {
                    $locale: $locale,
                    getLang: getLang,
                    set: function (key) {
                        return tmhDynamicLocale.set(key);
                    }
                };
            }];
        }]);
    angular.module('weeklyScheduler')
        .service('weeklySchedulerTimeService', ['$filter', function ($filter) {

            var MONTH = 'month';
            var WEEK = 'week';
            var DAY = 'day';

            return {
                const: {
                    MONTH: MONTH,
                    WEEK: WEEK,
                    DAY: DAY,
                    FORMAT: 'YYYY-MM-DD'
                },
                dF: $filter('date'),
                compare: function (date, method, lastMin) {
                    if (date) {
                        var dateAsMoment;
                        if (angular.isDate(date)) {
                            dateAsMoment = moment(date);
                        } else if (date._isAMomentObject) {
                            dateAsMoment = date;
                        } else {
                            throw 'Could not parse date [' + date + ']';
                        }
                        return dateAsMoment[method](lastMin) ? dateAsMoment : lastMin;
                    }
                },
                addWeek: function (moment, nbWeek) {
                    return moment.clone().add(nbWeek, 'hour'); //////////////////
                },
                weekPreciseDiff: function (start, end) {
                    return end.clone().diff(start.clone(), 'hour', true); ////////////
                },
                weekDiff: function (start, end) {
                    return end.clone().endOf(WEEK).diff(start.clone().startOf(WEEK), WEEK) + 1;
                },
                monthDiff: function (start, end) {
                    return end.clone().endOf(MONTH).diff(start.clone().startOf(MONTH), MONTH) + 1;
                },
                monthDistribution: function (minDate, maxDate) {
                    var i, result = [];
                    var startDate = minDate.clone();
                    var endDate = maxDate.clone();
                    var monthDiff = this.monthDiff(startDate, endDate);
                    var dayDiff = endDate.diff(startDate, DAY);

                    var total = 0, totalDays = 0;
                    for (i = 0; i < monthDiff; i++) {
                        var startOfMonth = i === 0 ? startDate : startDate.add(1, MONTH).startOf(MONTH);
                        var endOfMonth = i === monthDiff - 1 ? endDate : startDate.clone().endOf(MONTH);
                        var dayInMonth = endOfMonth.diff(startOfMonth, DAY) + (i !== monthDiff - 1 && 1);
                        var width = Math.floor(dayInMonth / dayDiff * 1E8) / 1E6;

                        result.push({start: startOfMonth.clone(), end: endOfMonth.clone(), width: width});

                        totalDays += dayInMonth;
                        total += width;
                    }
                    return result;
                }
            };
        }]);
    angular.module('ngWeeklySchedulerTemplates', ['ng-weekly-scheduler/views/multi-slider.html', 'ng-weekly-scheduler/views/weekly-scheduler.html', 'ng-weekly-scheduler/views/weekly-slot.html']);

    angular.module('ng-weekly-scheduler/views/multi-slider.html', []).run(['$templateCache', function ($templateCache) {
        $templateCache.put('ng-weekly-scheduler/views/multi-slider.html',
            //Comentar/Descomentar para poder añadir valores
            '<div class="slot ghost" ng-class="{isTask: schedule.task}" ng-show="item.editable !== false && (!schedulerCtrl.config.monoSchedule || !item.schedules.length)">{{schedulerCtrl.config.labels.addNew || \'Add New\'}}</div>' +

            '<weekly-slot title="{{schedule.task ? schedule.task : schedule.title}}" class="slot {{schedule.color}}" ng-class="{disable: item.editable === false }" ng-repeat="schedule in item.schedules" ng-model=schedule ng-model-options="{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }"></weekly-slot>');
    }]);

    angular.module('ng-weekly-scheduler/views/weekly-scheduler.html', []).run(['$templateCache', function ($templateCache) {
        $templateCache.put('ng-weekly-scheduler/views/weekly-scheduler.html',
            '<div class=labels><div class="srow text-right">{{schedulerCtrl.config.labels.weekNb || \'Hora\'}}</div><div title="{{item.label}}" class=schedule-animate ng-repeat="item in schedulerCtrl.items" inject></div></div><div class=schedule-area-container><div class=schedule-area><div class="srow timestamps"><weekly-grid class=grid-container></weekly-grid></div><div class="srow schedule-animate" ng-repeat="item in schedulerCtrl.items"><weekly-grid class="grid-container striped" no-text></weekly-grid><multi-slider index={{$index}}></multi-slider></div></div></div>');
    }]);

    angular.module('ng-weekly-scheduler/views/weekly-slot.html', []).run(['$templateCache', function ($templateCache) {
        $templateCache.put('ng-weekly-scheduler/views/weekly-slot.html',
            '<div><div class="handle left" ondrag=resize ondragstart=startResizeStart ondragstop=endDrag handle></div><div class="handlecenter" ondrag=drag ondragstart=startDrag ondragstop=endDrag handle>{{schedule.text}}</div><div class="handle right" ondrag=resize ondragstart=startResizeEnd ondragstop=endDrag handle></div></div>');
    }]);
}(window));

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular.module('Tagaste.annoucements')
        .controller('AnnoucementsController', AnnoucementsController);

    AnnoucementsController.$inject = ['$timeout', 'MasterTableService', '$routeParams', 'toastr',
                                        'TranslationService', 'routeConf', '$log',
                                        'tmhDynamicLocale',
                                        'TourService', '$q', '$rootScope', '$location'];

    /** @ngInject */
    function AnnoucementsController($timeout, MasterTableService,$routeParams,toastr,
                                    TranslationService,routeConf, $log,
                                    tmhDynamicLocale, TourService, $q, $rootScope, $location) {
        var vm = this;

        vm.selected = {}; //from com selected row
        vm.list = []; // to com list of resid
        vm.pag = 1; // selected pag for a window (back mod)
        vm.listLoaded = false;
        vm.showAnnoucementView = false;
        vm.modeEdit = false;
        vm.total = false;
        vm.tourDummyData = [];
        vm.istour = false;
        vm.blockButtons = false;
        vm.showComments = false;
        vm.showReserveView = false;
        vm.selectedResident = null;
        function initialize(offset) {
            var defered=$q.defer();
            var promise=defered.promise;
      
            MasterTableService.get({idT:routeConf.app,idJ:routeConf.notice,offset:offset},function (data) {
                if(data.total){
                    vm.total = true;
                    if(vm.list.length > 0){
                        vm.list = _.concat(vm.list,data.data);
                    }else {
                        vm.list = data.data;
                    }
                    initialize(vm.list.length);
                }else{
                    if(vm.total){
                        vm.list = _.concat(vm.list,data.data);
                        vm.total = false;
                    }else {
                        vm.list = data.data;
                    }
                }
                vm.listLoaded = true;
                $log.debug('notice list load data: ', data);
                defered.resolve();
            },function (err) {
                $log.error('error load data notice list: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                defered.reject(err);
            });
            return promise;
        }


        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/announcements') {
                vm.anim = false;
                vm.showAnnouncementView = false;
                vm.showActivityView = false;
                vm.servic = null;
                vm.menuId = null;
                vm.newSelectCourse = null;
                vm.returncourseitem = null;
                vm.inDish = null;
                vm.appuser = null;
                vm.constant = {};
                vm.showReserveView = false;
                vm.refreshMenu = false;
                vm.selectedResident = null;
                vm.showPayment = false;
                vm.reserveList = null;
                vm.showComments = null;
                vm.showIncidentView = false;
            }
        });

        /**
         * @ngdoc method
         * @name reloadList
         * @methodOf Tagaste.annoucements.controller:AnnoucementsController
         * @description
         * Method that reload the list of bulletin
         *
         */
        vm.reloadList = function (value) {
            vm.list = [];
            initialize('');
            $log.debug('vm.listReload',vm.list);
        };

        /**
         * @ngdoc method
         * @name showActivityReserve
         * @methodOf Tagaste.annoucements.controller:AnnoucementsController
         * @description
         * Method that show a reserve list of a activity
         * @param(value) a list of users to show
         *
         */
        vm.showActivityReserve = function (value) {
            vm.reserveList = {
                list:value
            };
        };

        //If we need to init tour
        vm.initTour = function() {
            if (vm.istour){
                return;
            }
           _initTour();
        };

        vm.showReserve = function () {
            vm.modeEdit = false;
            vm.showReserveView = true;
        };

        vm.setRefreshMenu = function () {
            vm.refreshMenu = true;
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length <1){
                vm.tourDummyData.push({'addressesRead':0,'addressesCount':1,'_id':'dummy','title':'dummy',
                    'text':'dummy','date':'2018-01-14T00:00:00.999Z','done':false,'isGlobal':false,'active':true,
                    'fcm':{'error':0,'sended':0,'isPush':true},'redirect':{'functionality':'Aviso','url':'/app/notice/',
                        'isRelated':false,'isAccessAPP':false},'branches':[{'_id':'5a4df00d84c7202edca65e09',
                        'description':'León'}],'localities':'León','type':'Aviso','creationDate':'14/01/2018'});
            }
            return TourService.initAnnouncementsTour().then(function() {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
           });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            var promise = initialize('');
            promise.then(function() {
                if(TourService.shouldShowAnnouncementsTour()) {
                    _initTour();
                }
            }, function(error) {
                toastr.error(TranslationService.errors.e500, error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }, 200);
    }
})();
/*
 * Rooms component
 *
 */
angular.module('Tagaste.pages.bedrooms')
    .controller('BedroomsController', BedroomsController);

BedroomsController.$inject = ['$log', 'TranslationService', '$timeout', 'tmhDynamicLocale', 'routeConf', 'ConfigService',
    'MasterTableService', 'baUtil', 'PermissionsService', 'localStorageService', '$rootScope', '$scope', '$location',
    '$http', 'toastr', '$q'];

function BedroomsController($log, TranslationService, $timeout, tmhDynamicLocale, routeConf, ConfigService,
                            MasterTableService, baUtil, PermissionsService, localStorageService, $rootScope, $scope,
                            $location, $http, toastr, $q) {
    var vm = this;
    vm.showBedroomDetail = false;
    vm.selectedBedroom = undefined;
    vm.anim = false;
    vm.ready = false;

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        var selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));
        ConfigService.query({functionality: 'roomType', branch: _.get(selectedBranch, '_id', null)}, function (response) {
            vm.roomTypes = response;
        }, function (err) {
            $log.error('get room types error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    });

    vm.$onInit = function () {
        var promises = [];
        var selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));

        promises.push(ConfigService.query({functionality: 'inventoryTags'}));
        promises.push(ConfigService.query({functionality: 'statesRoom'}));
        promises.push(ConfigService.query({functionality: 'roomType', branch: _.get(selectedBranch, '_id', null)}));

        $q.all(promises).then(function (response) {
            vm.inventoryTags = response[0];
            vm.statesRooms = response[1];
            vm.roomTypes = response[2];
            vm.ready = true;
        }).catch(function (err) {
            $log.error('dataFields promisesArray error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };
}

/*
 * @author jjrubio
 * created on 08/01/2018
 */

/*
 * Dashboard component
 *
 */
angular.module('BlurAdmin.pages.dashboard')
    .controller('DashboardController', DashboardController);

DashboardController.$inject = ['$log', 'TourService', 'TranslationService', '$timeout', 'tmhDynamicLocale', 'routeConf',
    'MasterTableService', 'baUtil', '$rootScope', 'PermissionsService', 'ENV'];

function DashboardController($log, TourService, TranslationService, $timeout, tmhDynamicLocale, routeConf,
                             MasterTableService, baUtil, $rootScope, PermissionsService, ENV) {
    var vm = this;

    vm.occupationPieCharts = [];
    vm.menuPieCharts = [];
    vm.totalBarCharts = [];
    vm.totalDonutCharts = [];
    vm.selectedPlace = null;
    vm.minDate = null;
    vm.maxDate = null;
    vm.dateOptions = {
        showWeeks: false
    };
    vm.printMenus = true;
    vm.canteenDonutChart = [];
    vm.selectedCanteenPlace = null;
    vm.reloadCanteenMixedChart = false;

    vm.loadingOccupationPie = false;
    vm.loadingIncidencesDonuts = false;

    vm.logbookPermission = PermissionsService.gotPermission('LOGBOOK', 'read');

    function addChart(data, chartType) {
        var place = _.find(vm.totalBarCharts, {placeId: data.placeId});
        if (place) {
            place[chartType] = data;
        } else {
            var newPlace = {
                placeId: data.placeId,
                place: data.place
            };
            newPlace[chartType] = data;
            vm.totalBarCharts.push(newPlace);
            vm.totalBarCharts = _.sortBy(vm.totalBarCharts, 'place');
        }
    }

    function loadOcupationPieCharts() {
        vm.loadingOccupationPie = true;

        var pieColor = baUtil.hexToRGB('#80FEC1', 0.9);
        
        var query = {idT: routeConf.metrics, idJ: routeConf.actualOccupancy};
        query.onlyToday = true;
        MasterTableService.query(query, function (data) {
            $log.debug('occupation data: ', data);
        }, function (err) {
            $log.error('error loading occupation metrics: ', err);
            vm.loadingOccupationPie = false;
        }).$promise.then(function (data) {
            var sumTotal = 0;
            var sumBeds = 0;
            var sumEventual = 0;
            _.forEach(data, function (item) {
                var total = item.total ? item.total : 0;
                var beds = item.branch ? item.branch.beds : 0;
                var eventual = item.totalEventual ? item.totalEventual : 0;
                vm.occupationPieCharts.push({
                    color: pieColor,
                    description: item.branch ? item.branch.description : 'ERROR',
                    percentage: Math.round(total * 100 / item.branch.beds),
                    stats: {total: total, beds: beds, eventual: eventual},
                    icon: 'person',
                    icons: {total: 'fa fa-user', beds: 'fa fa-bed', eventual: 'fa fa-suitcase'}
                });
                sumTotal += total;
                sumBeds += beds;
                sumEventual += eventual;
            });
            if (data && data.length > 1) {
                vm.occupationPieCharts.unshift({
                    color: pieColor,
                    description: TranslationService.incidencesChart.totalOccupation,
                    percentage: Math.round(sumTotal * 100 / sumBeds),
                    stats: {total: sumTotal, beds: sumBeds, eventual: sumEventual},
                    icon: 'group',
                    icons: {total: 'fa fa-user', beds: 'fa fa-bed', eventual: 'fa fa-suitcase'}
                });
            }

            vm.loadingOccupationPie = false;
        });
    }

    function loadMenuPieCharts() {
        var pieColorBreakfast = baUtil.hexToRGB('#fffe71', 0.9);
        var pieColorLaunch = baUtil.hexToRGB('#b9f2a1', 0.9);
        var pieColorDinner = baUtil.hexToRGB('#15bfac', 0.9);
        MasterTableService.get({idT: routeConf.metrics, idJ: routeConf.menuReservation}, function (data) {
            $log.debug('menu pie charts data: ', data);
        }, function (err) {
            $log.error('error loading menu' +
                ' metrics: ', err);
        }).$promise.then(function (data) {
            var menuData = _.values(data);
            _.remove(menuData, function (o) {
                return !o.total;
            });
            menuData = _.sortBy(menuData, 'branch.description');
            $log.debug('menuData: ', menuData);

            _.forEach(menuData, function (item) {
                var menuData = {
                    description: item.branch.description,
                    total: item.total,
                    meals: []
                };
                if (item.arrMenu && item.arrMenu.length) {
                    _.forEach(item.arrMenu, function (meal) {
                        menuData.meals.push({
                            chartId: 'chartCanteen-' + item.branch._id,
                            color: !meal.type.hourUntil || (meal.type.hourUntil && meal.type.hourUntil) > 16 ?
                                pieColorDinner : meal.type.hourUntil < 12 ? pieColorBreakfast : pieColorLaunch,
                            description: meal.type.description,
                            icon: meal.type.icon,
                            percentage: item.total ? Math.round(meal.booked * 100 / item.total) : 0,
                            stats: meal.booked,
                            hour: meal.type.hourUntil,
                            placeId: item.branch._id,
                            typeId: meal.type._id,
                            statistics: [{
                                occupation: meal.statistics.occupation,
                                reservation: meal.statistics.reservation,
                                service: meal.statistics.service,
                                remarks: meal.statistics.remarks,
                                monthly: [{
                                    occupation: meal.statistics.monthly.occupation,
                                    reservation: meal.statistics.monthly.reservation,
                                    service: meal.statistics.monthly.service
                                }],
                                weekly: [{
                                    occupation: meal.statistics.weekly.occupation,
                                    reservation: meal.statistics.weekly.reservation,
                                    service: meal.statistics.weekly.service
                                }]
                            }]
                        });
                    });
                    if (menuData.meals.length) {
                        menuData.meals = _.sortBy(menuData.meals, 'hour');
                    }
                }
                vm.menuPieCharts.push(menuData);
            });

            vm.printMenus = true;
        });
    }

    function loadIncidencesDonutCharts() {
        vm.loadingIncidencesDonuts = true;

        var incidentsData = [];
        MasterTableService.query({idT: routeConf.metrics, idJ: routeConf.incidentsOpened}, function (data) {
            incidentsData = data;
            $log.debug('incidentsData: ', incidentsData);
        }, function (err) {
            $log.error('error loading metricsIncidentsOpened: ', err);
            vm.loadingIncidencesDonuts = false;
        }).$promise.then(function () {
            _.forEach(incidentsData, function (residence) {
                var branchData = {
                    chartId: 'chartDonut-' + residence.branch._id,
                    place: residence.branch.description,
                    placeId: residence.branch._id,
                    incidencesTotal: residence.incidencesHigh.length + residence.incidencesNormal.length,
                    incidencesHigh: residence.incidencesHigh.length,
                    incidencesNormal: residence.incidencesNormal.length,
                    timeOut: 0,
                    type: 'donut'
                };
                _.forEach(residence.incidencesHigh, function (item) {
                    if (item.timeOut) {
                        branchData.timeOut++;
                        branchData.incidencesHigh--;
                    }
                });
                _.forEach(residence.incidencesNormal, function (item) {
                    if (item.timeOut) {
                        branchData.timeOut++;
                        branchData.incidencesNormal--;
                    }
                });
                vm.totalDonutCharts.push(branchData);
                vm.totalDonutCharts = _.sortBy(vm.totalDonutCharts, 'place');
            });

            vm.loadingIncidencesDonuts = false;
        });
    }

    function loadIncidencesLineCharts() {
        var historyIncidences = [];
        var developmentMode = (ENV.env === 'dev');
        var query = {idT: routeConf.metrics, idJ: routeConf.incidentsHistory};
        if (vm.minDate) {
            query.minDate = vm.minDate;
        }
        if (vm.maxDate) {
            query.maxDate = vm.maxDate;
        }
        MasterTableService.query(query, function (data) {
            historyIncidences = data;
            $log.debug('historyIncidences: ', historyIncidences);
        }, function (err) {
            $log.error('error loading history incidents data: ', err);
        }).$promise.then(function (data) {
            //generate empty historyIncidences with places with no register
            _.forEach(vm.totalDonutCharts, function (place) {
                if (_.findIndex(data, {'branches': place.placeId}) === -1) {
                    historyIncidences.push({
                        active: true,
                        branches: place.placeId,
                        creationDate: "201800",
                        incidencesHighClose: [],
                        incidencesHighOpen: [],
                        incidencesNormalClose: [],
                        incidencesNormalOpen: [],
                        incidencesOutOfTimeClose: [],
                        key: {branch: {_id: place.placeId, description: place.place}, year: 2018, week: 0},
                        _id: "defaultNoData"
                    });
                }
            });

            var incidentsData = _.values(_.groupBy(historyIncidences, 'key.branch._id'));
            $log.debug('incidentsData: ', incidentsData);

            _.forEach(incidentsData, function (residence) {
                var branchDataTime = {
                    chartId: 'chartTime-' + residence[0].key.branch._id,
                    place: residence[0].key.branch.description,
                    placeId: residence[0].key.branch._id,
                    label: [],
                    hoursHigh: [],
                    hoursNormal: [],
                    type: 'line',
                    noData: residence[0]._id === 'defaultNoData'
                };
                var branchDataInci = {
                    chartId: 'chartInci-' + residence[0].key.branch._id,
                    place: residence[0].key.branch.description,
                    placeId: residence[0].key.branch._id,
                    label: [],
                    incidencesOpenedTotal: [],
                    incidencesOpenedHigh: [],
                    incidencesOpenedNormal: [],
                    incidencesClosedTotal: [],
                    incidencesClosedHigh: [],
                    incidencesClosedNormal: [],
                    incidencesClosedTimeOut: [],
                    type: 'mixed',
                    noData: residence[0]._id === 'defaultNoData'
                };
                residence = _.sortBy(residence, function (item) {
                    return moment().isoWeekYear(item.key.year).isoWeek(item.key.week);
                });
                _.forEach(residence, function (data) {
                    if (developmentMode) {
                        branchDataTime.label.push(moment().isoWeekYear(data.key.year).isoWeek(data.key.week).startOf('isoWeek').format('L'));
                        branchDataTime.hoursHigh.push(Math.floor((Math.random() * 100) + 1));
                        branchDataTime.hoursNormal.push(Math.floor((Math.random() * 100) + 1));

                        branchDataInci.label.push(moment().isoWeekYear(data.key.year).isoWeek(data.key.week).startOf('isoWeek').format('L'));
                        branchDataInci.incidencesClosedTotal.push(data.incidencesHighClose.length + data.incidencesNormalClose.length);
                        branchDataInci.incidencesClosedHigh.push(Math.floor((Math.random() * 100) + 1));
                        branchDataInci.incidencesClosedNormal.push(Math.floor((Math.random() * 100) + 1));
                        branchDataInci.incidencesClosedTimeOut.push(Math.floor((Math.random() * 100) + 1));
                        branchDataInci.incidencesOpenedTotal.push(data.incidencesHighOpen.length + data.incidencesNormalOpen.length);
                        branchDataInci.incidencesOpenedHigh.push(Math.floor((Math.random() * 100) + 1));
                        branchDataInci.incidencesOpenedNormal.push(Math.floor((Math.random() * 100) + 1));
                    } else {
                        branchDataTime.label.push(moment().isoWeekYear(data.key.year).isoWeek(data.key.week).startOf('isoWeek').format('L'));
                        branchDataTime.hoursHigh.push(data.avgHoursHigh ? data.avgHoursHigh : 0);
                        branchDataTime.hoursNormal.push(data.avgHoursNormal ? data.avgHoursNormal : 0);

                        branchDataInci.label.push(moment().isoWeekYear(data.key.year).isoWeek(data.key.week).startOf('isoWeek').format('L'));
                        branchDataInci.incidencesClosedTotal.push(data.incidencesHighClose.length + data.incidencesNormalClose.length);
                        branchDataInci.incidencesClosedHigh.push(data.incidencesHighClose.length);
                        branchDataInci.incidencesClosedNormal.push(data.incidencesNormalClose.length);
                        branchDataInci.incidencesClosedTimeOut.push(data.incidencesOutOfTimeClose.length);
                        branchDataInci.incidencesOpenedTotal.push(data.incidencesHighOpen.length + data.incidencesNormalOpen.length);
                        branchDataInci.incidencesOpenedHigh.push(data.incidencesHighOpen.length);
                        branchDataInci.incidencesOpenedNormal.push(data.incidencesNormalOpen.length);
                    }
                });
                addChart(branchDataTime, 'line');
                addChart(branchDataInci, 'mixed');
            });
        });
    }

    vm.reloadIncidencesLineCharts = function () {
        loadIncidencesLineCharts();
    };

    vm.$onInit = function () {
        if (PermissionsService.gotPermission('RESIDENT', 'READ')) {
            loadOcupationPieCharts();
        }
        if (PermissionsService.gotPermission('MENU', 'READ')) {
            vm.printMenus = false;
            loadMenuPieCharts();
        }
        if (PermissionsService.gotPermission('INCIDENT', 'READ')) {
            loadIncidencesDonutCharts();
            loadIncidencesLineCharts();
        }
    };

    vm.openHistoryIncidences = function (place) {
        $log.debug('selected placeId: ', place.placeId);
        vm.selectedPlace = vm.selectedPlace === place.placeId ? null : place.placeId;
        vm.selectedPlaceName = place.place;
        vm.showFilter = _.findIndex(vm.totalBarCharts, function (item) {
            return item.placeId === place.placeId && (item.line || item.mixed);
        }) !== -1;
    };

    $timeout(function () {
        tmhDynamicLocale.set(moment.locale());
        TourService.shouldShowDashboardTour().then(function (response) {
            if (response){
                TourService.dashboardTour();
            }
        });
       
    });

}
/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('myTimetable', myTimetable);

    /** @ngInject */
    function myTimetable() {
        return {
            
          restrict: 'A',
          templateUrl: 'app/pages/myTimetable/my-timetable.tpl.html',
          scope: {
            slots: '=',
            disabled: '<'
          },
          link: function (scope, element, attributes) {
            // var _days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
            var _days = moment.weekdaysShort();
            // Move Monday to last element
            _days.push(_days.shift());

              var _selection = {
              state: false,
              day: [0, 0, 0, 0, 0, 0, 0],
              hour: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
            };
            
            function _loop(begin, end, step) {
              var array = [];
              
              for (var i = begin; i <= end; i += step) {
                array.push(i);
              }
              
              return array;
            }
            
            function _toggle(what, day, hour) {
              var i = 0;
              if ( scope.disabled === true ){
                return;
              }
              switch (what) {
                case 'day':
                  _selection.day[day] = !_selection.day[day];
                  
                  for (i = 0; i < 24; i++) {
                    scope.slots[day][i] = _selection.day[day]; 
                  }
                break;
                
                case 'hour':
                  _selection.hour[hour] = !_selection.hour[hour];
                  
                  for (i = 0; i < 7; i++) {
                    scope.slots[i][hour] = _selection.hour[hour];
                  }
                break;
                
                case 'slot':
                  if (_selection.state) {
                    scope.slots[day][hour] = !scope.slots[day][hour];
                  }
                break;
              }
            }
            
            function _select(state, day, hour) {
              _selection.state = state;
              
              if (_selection.state) {
                _toggle('slot', day, hour);
              }
            }
            
            function _init() {
              scope.loop = _loop;
              scope.toggle = _toggle;
              scope.select = _select;
              
              scope.days = _days;
            }
            
            _init();
          }
        };
    }

})();

angular.module('Tagaste.pages.rooms')
    .controller('RoomsController', RoomsController);

RoomsController.$inject = ['$log', 'TranslationService', '$timeout', 'tmhDynamicLocale', 'routeConf',
    'MasterTableService', 'baUtil', 'PermissionsService', 'localStorageService', '$rootScope', '$scope'];

function RoomsController($log, TranslationService, $timeout, tmhDynamicLocale, routeConf,
                         MasterTableService, baUtil, PermissionsService, localStorageService, $rootScope, $scope) {
    var vm = this;
    vm.occupationPieCharts = [];
    vm.occupationInfo = {};
    vm.anim = false;
    vm.room = null;
    vm._CONTROLLER = 'RoomsController';
    vm.selectedBar = localStorageService.get('selectedBarResidence');
    vm.previousSelectedBar = undefined;
    vm.totalBeds = 0;
    var pieColor = baUtil.hexToRGB('#80FEC1', 0.9);

    function loadOccupationPieCharts() {
        vm.occupationPieCharts = [];
        var daySelected = sessionStorage.getItem('dayRoomList');
        var query = {idT: routeConf.metrics, idJ: routeConf.actualOccupancy};
        if (daySelected) {
            query.date = daySelected;
        } else {
            query.onlyToday = true;
        }
        if (vm.selectedBar && !vm.selectedBar.all) {
            query.branch = vm.selectedBar._id;
        }

        MasterTableService.query(query, function (data) {
            $log.debug('ROOMS:: occupation data: ', data);
        }, function (err) {
            $log.error('ROOMS:: error loading occupation metrics: ', err);
        }).$promise.then(function (data) {
            var dataInfo = _.first(_.castArray(data));
            vm.occupationInfo = {
                totalOccupancy: dataInfo.totalRes > 0 ? _.padStart(dataInfo.totalRes, 2, '0') : dataInfo.totalRes,
                totalAbsent: dataInfo.totalAbsent > 0 ? _.padStart(dataInfo.totalAbsent, 2, '0') : dataInfo.totalAbsent,
                totalGuest: dataInfo.totalGuest > 0 ? _.padStart(dataInfo.totalGuest, 2, '0') : dataInfo.totalGuest
            };
            vm.totalBeds = dataInfo.branch.beds;
            vm.occupationPieCharts.push({
                color: pieColor,
                description: 'Ocupadas',
                value: dataInfo.totalOccupancy,
                percentage: Math.round(dataInfo.totalOccupancy * 100 / dataInfo.branch.beds)
            });
            vm.occupationPieCharts.push({
                color: pieColor,
                description: 'Libres',
                value: dataInfo.totalFree,
                percentage: Math.round(dataInfo.totalFree * 100 / dataInfo.branch.beds)
            });
            vm.occupationPieCharts.push({
                color: pieColor,
                description: 'Salen hoy',
                value: dataInfo.totalCheckOut,
                percentage: Math.round(dataInfo.totalCheckOut * 100 / dataInfo.branch.beds)
            });
            vm.occupationPieCharts.push({color: pieColor, description: 'Limpiar', value: 0, percentage: 0});
            vm.occupationPieCharts.push({
                color: pieColor,
                description: 'Bloqueadas',
                value: dataInfo.totalBlocked,
                percentage: Math.round(dataInfo.totalBlocked * 100 / dataInfo.branch.beds)
            });
        });
        vm.anim = false;
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.selectedBar = localStorageService.get('selectedBarResidence');
        if (PermissionsService.gotPermission('RESIDENT', 'READ')) {
            vm.occupationPieCharts = [];
            vm.occupationInfo = [];
            if (vm.selectedBar && !vm.selectedBar.all) {
                loadOccupationPieCharts();
            }
        }
    });
    $scope.$on('$destroy', unregister);

    var updateCleaningNumberSuscribe = $rootScope.$on('updateCleaningNumber', function (event, data) {
        var index = _.findIndex(vm.occupationPieCharts, {description: 'Limpiar'});
        var percentValue = vm.totalBeds === 0 ? 0 : data * 100 / vm.totalBeds;
//        vm.occupationPieCharts.splice(index, 1, {color: pieColor, description: 'Limpiar',value: data, percentage: _.round(percentValue,0)});

        _.set(_.find(vm.occupationPieCharts, {description: 'Limpiar'}), 'value', data);
        _.set(_.find(vm.occupationPieCharts, {description: 'Limpiar'}), 'percentage', _.round(percentValue, 0));
        $rootScope.$emit('reloadOccupancyPieChart');

    });
    $scope.$on('$destroy', updateCleaningNumberSuscribe);

    vm.$onInit = function () {
        sessionStorage.removeItem('dayRoomList');
        if (PermissionsService.gotPermission('RESIDENT', 'READ')) {
            if (vm.selectedBar && !vm.selectedBar.all) {
                loadOccupationPieCharts();
            }
        }
    };
    $rootScope.$on('DateRoomListChange', function () {
        vm.anim = true;
        loadOccupationPieCharts();
    });
    $timeout(function () {
        tmhDynamicLocale.set(moment.locale());
    });

}

angular.module('BlurAdmin.components')
    .controller('ModalActivityListController', ModalActivityListController);

function ModalActivityListController($uibModalInstance, $log, MasterTableService,
                                     TranslationService, toastr, routeConf, ResidentsService, localStorageService,
                                     modalBinding, NgTableParams, HistoryAgenda) {


    var vm = this;
    vm.momentAux = moment;
    vm.modeDismiss = '';
    vm.activities = [];
    vm.reservation = {};
    vm.reservationid = modalBinding.id;

    function getOcupiedDetail () {
        return new Promise(function(fulfill, reject){
            // Get detail ocupation from id ocupation
            MasterTableService.get({idT: routeConf.occupancy, idJ: vm.reservationid}, function (data) {
                vm.reservation = data;
                vm.roomCode = vm.reservation.room.code;
                // Get detail from client / resident
                ResidentsService.query({idR: vm.reservation.client.item.id}, function (clientData) {
                    $log.debug('Resident detail: ', clientData);
                    vm.resident = clientData;
                    fulfill();
                }, function (clierr) {
                    $log.error('error load resident info: ', clierr);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    reject();
                });

            }, function (err) {
                $log.error('error load reservation detail: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                reject();
            });
        });
    }

    // Get Activities
    function getSourcesHistoryActivities() {
        return new Promise(function (full, reject) {
            var query = {idR: vm.resident._id, limit: 0};
            query.dateLimit = moment.utc().startOf('day').toDate();
            HistoryAgenda.get(query, function (data) {
                $log.debug('Load HistoryActivities list: ', data);
                return data;
            }, function (err) {
                $log.error('error getting HistoryActivities: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                reject();
            }).$promise.then(function (data) {
                vm.activities = data['data'] ? data['data'] : [];
                full();
            });
        });
    }

    vm.deleteActivity = function (row) {
        var query = {};
        query.idT = routeConf.app;
        query.idJ = routeConf.agendaSignPanel;
        query.idP = row.id;
        MasterTableService.post(query, {appUser: vm.resident}, function (data) {
            toastr.success(TranslationService.roomschedulerdetail.deleteReservation);
            vm.$onInit();
        }, function (err) {
            $log.error('error load reservation detail: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };
    vm.$onInit = function () {
        getOcupiedDetail()
            .then(getSourcesHistoryActivities)
            .then(function () {
            vm.tableParamsActivities =
                new NgTableParams(
                    {
                        page: 1,
                        count: 5,
                    },
                    {
                        total: vm.activities.length,
                        counts: [],
                        dataset: angular.copy(vm.activities)
                    }
                );
        });
    };
}

angular.module('BlurAdmin.components')
    .controller('ModalBillingForecastController', ModalBillingForecastController);

function ModalBillingForecastController($uibModalInstance, $log, TranslationService, toastr, modalBinding, ConceptService, NgTableParams,
                                        BillingService, $uibModal, ConfigService, $q) {
    var vm = this;
    vm.selection = [];
    vm.refreshBillingList = false;

    vm.cancel = function () {
        $uibModalInstance.close(vm.refreshBillingList);
    };

    function generateInvoice(concepts, clientId) {
        return new Promise(function (resolve, reject) {
            var invoice = {};
            _.set(invoice, 'branch', vm.branch._id);
            _.set(invoice, 'client', {
                item: clientId,
                kind: 'AppUser'
            });
            _.set(invoice, 'generateBilling', true);
            _.set(invoice, 'concepts', concepts);
            _.set(invoice, 'billingAddress', {ownClient: true});
            BillingService.post({}, invoice, function (data) {
                $log.debug('BillingService post data: ', data);
                resolve(data);
            }, function (err) {
                $log.error('BillingService post error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                reject(err);
            });
        });
    }

    vm.generateInvoices = function () {
        vm.loading = true;
        var groupedConcepts = _.groupBy(vm.selection, 'client.item._id');
        $log.debug('groupedConcepts: ', groupedConcepts);
        var arrayPromises = [];
        _.forOwn(groupedConcepts, function (value, key) {
            arrayPromises.push(generateInvoice(value, key));
        });
        Promise.all(arrayPromises).then(function (billings) {
            $log.debug('generated billings: ', billings);
            toastr.success(TranslationService.modal.invoicesSuccess);
            vm.getForecastConcepts();
            vm.refreshBillingList = true;
        });
    };

    vm.getConstants = function () {
        vm.constants = {};
        ConfigService.query({
            component: 'tax'
        }, function (res) {
            $log.debug('tax master table data: ', res);
            vm.constants.tax = angular.copy(res);
        }, function (err) {
            $log.error('tax master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });

        ConfigService.query({
            functionality: 'payType'
        }, function (res) {
            $log.debug('payTypes master table data: ', res);
            vm.constants.payTypes = angular.copy(res);
            if ((_.get(vm.bill, '_id') && _.get(vm.bill, 'paidData.payType.code') !== 'fianza') ||
                (!_.get(vm.bill, '_id') && !_.get(vm.resident, 'deposit'))) {
                _.remove(vm.constants.payTypes, {code: 'fianza'});
            }
        }, function (err) {
            $log.error('paytypes master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });

        ConfigService.query({
            component: 'customConcept'
        }, function (res) {
            $log.debug('customConcepts masterTable data: ', res);
            vm.constants.customConcepts = angular.copy(res);
        }, function (err) {
            $log.error('customConcept master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.openConceptDetail = function (data) {
        data.readonly = false;
        data.constants = angular.copy(vm.constants);
        data.userBranches = _.castArray(vm.branch);
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/modal/modalConceptDetail/modalConceptDetail.html',
            controller: 'ModalConceptDetailController',
            controllerAs: 'mcdc',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalBinding: function () {
                    return data;
                }
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            //close function
            if (result) {
            }
        }, function (closemsg) {
            //dismiss function
        });
    };

    vm.checkAllSelected = function () {
        return _.findIndex(_.get(vm.tableParams, '_settings.dataset'), function (d) {
            return !d.selected;
        }) === -1;
    };

    vm.checkAllDeselected = function () {
        return _.findIndex(_.get(vm.tableParams, '_settings.dataset'), function (d) {
            return d.selected;
        }) === -1;
    };

    vm.selectAll = function () {
        _.forEach(_.get(vm.tableParams, '_settings.dataset'), function (d) {
            if (!d.selected) {
                _.set(d, 'selected', true);
                vm.checkboxChanges(d);
            }
        });
    };

    vm.deselectAll = function () {
        _.forEach(_.get(vm.tableParams, '_settings.dataset'), function (d) {
            if (d.selected) {
                _.set(d, 'selected', false);
                vm.checkboxChanges(d);
            }
        });
    };

    vm.checkboxChanges = function (row) {
        if (row.selected) {
            vm.selection.push(row);
        } else {
            _.remove(vm.selection, {_id: row._id});
        }
    };

    function iniTable(list) {
        if (!list) {
            list = [];
        }
        vm.tableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 15,
                    sorting: {
                        clientName: 'asc'
                    }
                },
                {
                    total: list.length,
                    counts: [],
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getForecastConcepts = function () {
        vm.loading = true;
        ConceptService.post({idR: 'forecast'}, {branch: vm.branch._id}, function (data) {
            $log.debug('[residentDetail] getForecastConcepts data: ', data);
            var concepts = _.get(data, 'concepts', []);
            _.forEach(concepts, function (c) {
                _.set(c, 'clientName', _.get(c, 'client.item.fullName', _.join([_.get(c, 'client.item.name'), _.get(c, 'client.item.surname')], ' ')));
                switch (_.get(c, 'related.kind')) {
                    case 'Service':
                        c.typeStr = TranslationService.payments.types.service;
                        break;
                    case 'Agenda':
                        c.typeStr = TranslationService.payments.types.agenda;
                        break;
                    case 'Other':
                        c.typeStr = TranslationService.payments.types.other;
                        break;
                    case 'Occupancy':
                        c.typeStr = TranslationService.payments.types.occupancy;
                        break;
                }
            });
            iniTable(concepts);
            vm.loading = false;
        }, function (err) {
            $log.error('[residentDetail] getForecastConcepts error: ', err);
            vm.loading = false;
        });
    };

    vm.$onInit = function () {
        if (modalBinding) {
            vm.branch = modalBinding.branch;
            vm.getConstants();
            vm.getForecastConcepts();
        }
    };
}
angular.module('BlurAdmin.components')
    .controller('ModalCancelReservationController', ModalCancelReservationController);

function ModalCancelReservationController($uibModalInstance, $log, ReservationCancelBillingsService,
                                          TranslationService, toastr, modalBinding) {
    var vm = this;
    vm.generateDeposit = false;
    vm.generateTuition = false;

    vm.cancel = function() {
        $uibModalInstance.close(null);
    };

    vm.accept = function () {
        if ((vm.generateDeposit || vm.generateTuition) && vm.reservation) {
            ReservationCancelBillingsService.post({idR: _.get(vm.reservation, '_id', vm.reservation)},
                {deposit: vm.generateDeposit, tuition: vm.generateTuition, reservation: vm.reservation}, function (response) {
                    $log.debug('generate cancel reservation billings success', response);
                    $uibModalInstance.close(response);
                }, function (err) {
                    $log.error('error generate cancel reservation billings', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
        } else {
            $uibModalInstance.close(null);
        }
    };

    vm.$onInit = function () {
        if (modalBinding) {
            vm.reservation = modalBinding;
        }
    };
}
angular.module('BlurAdmin.components')
    .controller('ModalChooseRoomController', ModalChooseRoomController);

function ModalChooseRoomController($uibModalInstance, $log, TranslationService, toastr, modalBinding) {
    var vm = this;

    vm.selectedRoom = null;
    vm.invalidRoomType = false;

    vm.checkRoomType = function () {
        if (_.get(vm.reservation, 'room.roomType')) {
            vm.invalidRoomType = vm.reservation.roomType && vm.reservation.roomType._id !== vm.reservation.room.roomType;
        } else {
            vm.invalidRoomType = false;
        }
    };

    vm.selectRoom = function () {
        vm.reservation.roomType = _.find(vm.roomTypes, ['_id', vm.reservation.room.roomType]);
        if (!_.find(vm.roomTypes, ['_id', vm.reservation.room.roomType])) {
            vm.reservation.roomType = null;
        }
        vm.checkRoomType();
    };

    vm.cancel = function () {
        $uibModalInstance.close(null);
    };

    vm.accept = function () {
        if (vm.selectedRoom) {
            $log.debug('selected room: ', vm.selectedRoom);
            $uibModalInstance.close(vm.selectedRoom);
        }
    };

    vm.$onInit = function () {
        if (modalBinding) {
            vm.reservation = modalBinding.reservation;
            vm.currentRoom = vm.reservation.room;
            vm.roomTypes = modalBinding.roomTypes;
            vm.availableRooms = modalBinding.availableRooms;
            $log.debug('availableRooms: ', vm.availableRooms);
        }
    };
}
angular.module('BlurAdmin.components')
    .controller('ModalConceptDetailController', ModalConceptDetailController);

function ModalConceptDetailController($uibModalInstance, $log, MasterTableService, ConceptService,
                                      TranslationService, toastr, routeConf, localStorageService,
                                      modalBinding, NgTableParams) {
    var vm = this;
    vm.concept = {};

    $log.debug('modalBinding', modalBinding);
    vm.readonly = modalBinding.readonly;
    vm.constants = modalBinding.constants;
    vm.userBranches = modalBinding.userBranches;
    vm.taxes = vm.constants.tax;
    vm.addingTax = false;
    vm.totalWithoutTaxes = 0;
    vm.totalWithTaxes = 0;
    vm.taxesopen = false;
    vm.discountsopen = false;
    vm.submitted = false;
    vm.selectedRoomRate = null;
    vm.selectingCustomConcept = false;
    vm.selectedCustomConcept = {};
    vm.availableCustomConcepts = [];
    vm.isRequestDeposit = modalBinding.isRequestDeposit;
    vm.isTuition = modalBinding.isTuition;
    vm.acceptedRequest = modalBinding.acceptedRequest;
    vm.isOccupancy = false;

    function iniTableTaxes(list) {
        vm.taxes = list ? list : [];

        vm.tableParamsTaxes =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatIn: 'desc'
                    }
                },
                {
                    total: vm.taxes.length,
                    counts: [],
                    dataset: angular.copy(vm.taxes)
                }
            );

        vm.calcTotalTaxes();
    }

    vm.selectCustomConcept = function () {
        if (!vm.concept.branch) {
            toastr.warning(TranslationService.errors.selectBranch);
        } else {
            vm.selectingCustomConcept = true;
        }
    };

    vm.changeCustomConcept = function () {
        $log.debug('selected custom concept', vm.selectedCustomConcept);

        if (vm.selectedCustomConcept) {
            vm.concept.description = vm.selectedCustomConcept.description;
            vm.taxes = angular.copy(vm.selectedCustomConcept.taxes);
            vm.concept.amount = vm.selectedCustomConcept.amount;
            iniTableTaxes(vm.taxes);
            vm.tableParamsTaxes.reload();
            vm.concept.discountP = vm.selectedCustomConcept.discountP;
            vm.concept.discountF = vm.selectedCustomConcept.discountF;
            vm.calcTotalTaxes();
            vm.lockedConcept = vm.selectedCustomConcept.lockEdit;
        } else {
            vm.concept.description = '';
            vm.taxes = [];
            iniTableTaxes(vm.taxes);
            vm.tableParamsTaxes.reload();
            vm.concept.discountP = '';
            vm.concept.discountF = '';
            vm.concept.amount = 0;
            vm.calcTotalTaxes();
            vm.lockedConcept = false;
        }
        vm.selectingCustomConcept = false;
    };

    /** Function to select tax */
    vm.selectTax = function (tax) {
        $log.debug('Selected Tax: ', tax);
    };

    /** Function to accept contact row (new/edit) */
    vm.saveTax = function (tax, index) {
        tax.modeEdit = false;
        if (vm.addingTax) {
            vm.taxes.push(tax.value);
        } else {
            vm.tableParamsTaxes.data[index] = tax;
            vm.taxes = vm.tableParamsTaxes.data;
        }
        iniTableTaxes(vm.taxes);
        vm.tableParamsTaxes.reload();
        vm.addingTax = false;
    };

    /** Function to delete contact row */
    vm.deleteTax = function (tax, index) {
        _.pullAt(vm.taxes, index);
        iniTableTaxes(vm.taxes);
        vm.tableParamsTaxes.reload();
    };

    vm.addTax = function (tax) {
        vm.addingTax = true;
        if (!vm.tableParamsTaxes) {
            iniTableTaxes();
        }
        vm.tableParamsTaxes.settings().dataset.unshift({
            modeEdit: true
        });
        vm.tableParamsTaxes.sorting({});
        vm.tableParamsTaxes.page(1);
        vm.tableParamsTaxes.reload();
    };

    /** Function to cancel (Edit / New) contact */
    vm.cancelTax = function (tax, index) {
        tax.modeEdit = false;
        if (index === 0 && !tax._id) {
            _.remove(vm.tableParamsTaxes.settings().dataset, function (item) {
                return tax === item;
            });
        } else {
            vm.tableParamsTaxes.data[index] = vm.temporalTax;
        }
        if (vm.addingTax) {
            vm.tableParamsTaxes.reload();
            vm.addingTax = false;
        }
        vm.addingTax = false;
    };

    /** Function to save concept */
    vm.save = function (form) {
        vm.submitted = true;
        if (form.$valid) {
            var conceptToSave = angular.copy(vm.concept);
            conceptToSave.taxes = vm.taxes;
            if (vm.isRequestDeposit) {
                conceptToSave.isDeposit = true;
            }
            if (vm.isTuition) {
                conceptToSave.isTuition = true;
            }
            var query = {};
            if (vm.concept._id) {
                query.idR = vm.concept._id;
            }
            ConceptService.post(query, conceptToSave, function (data) {
                $log.debug('[payment] update concept data: ', data);
                toastr.success(TranslationService.dialog.saveok);
                $uibModalInstance.close(true);
            }, function (err) {
                $log.error('[payment] error getting concepts: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                $uibModalInstance.close(true);
            });
        } else {
            $log.error('invalid form');
        }
    };

    /** Function to calculate total amount with taxes */
    vm.calcTotalTaxes = function () {
        if (!vm.concept.amount) {
            vm.concept.amount = 0;
        }
        var tmpAmount = _.toNumber(vm.concept.amount);
        var discountF = vm.concept.discountF ? vm.concept.discountF : 0;
        var discountP = vm.concept.discountP ? tmpAmount * vm.concept.discountP / 100 : 0;
        vm.totalWithoutTaxes = tmpAmount ? tmpAmount - discountF - discountP : 0;

        vm.totalWithTaxes = JSON.parse(JSON.stringify(vm.totalWithoutTaxes));
        _.forEach(vm.taxes, function (cTax) {
            if (cTax.isPercentage) {
                vm.totalWithTaxes = parseFloat(vm.totalWithTaxes) + (tmpAmount * (cTax.rate / 100));
            } else {
                vm.totalWithTaxes = parseFloat(vm.totalWithTaxes) + parseFloat(cTax.rate);
            }
        });
        vm.totalWithTaxes = Math.round(vm.totalWithTaxes * 100) / 100;
    };

    vm.changeRoomRate = function () {
        $log.debug('selected room rate: ', vm.selectedRoomRate);
        if (vm.selectedRoomRate.price) {
            vm.concept.amount = vm.selectedRoomRate.price;
            vm.calcTotalTaxes();
        }
    };

    vm.updateAvailableCustomConcepts = function () {
        if (vm.concept && vm.concept.branch) {
            vm.availableCustomConcepts = _.filter(vm.constants.customConcepts, {'branches': [{'_id': vm.concept.branch._id}]});
        } else {
            vm.availableCustomConcepts = [];
        }
    };

    vm.$onInit = function () {
        if (modalBinding) {
            vm.concept = modalBinding;
            vm.concept.dateFrom = vm.concept.dateFrom ? moment(vm.concept.dateFrom).toDate() : new Date();
            vm.concept.dateTo = vm.concept.dateTo ? moment(vm.concept.dateTo).toDate() : new Date();

            if (vm.isRequestDeposit) {
                vm.concept.isDeposit = true;
            }

            if (vm.concept._id && vm.concept.taxes) {
                iniTableTaxes(vm.concept.taxes);
            } else {
                iniTableTaxes([]);
            }
            vm.updateAvailableCustomConcepts();
        }

        vm.isOccupancy = _.get(vm.concept, 'related.kind') === 'Occupancy';

        if (_.get(vm.concept, 'related.roomRates')) {
            _.forEach(vm.concept.related.roomRates, function (item) {
                item['descriptionAll'] = item.description + ' (' + item.price + ')';
            });

            if (vm.concept.related.roomRates.length === 1) {
                vm.selectedRoomRate = _.first(vm.concept.related.roomRates);
            } else if (vm.concept.related.roomRates.length > 1 && vm.concept.amount) {
                vm.selectedRoomRate = _.find(vm.concept.related.roomRates, {price: vm.concept.amount});
            }
        }
    };
}

angular.module('BlurAdmin.components')
    .controller('ModalMasterTablesConceptDetailController', ModalMasterTablesConceptDetailController);

function ModalMasterTablesConceptDetailController($uibModalInstance, $log, MasterTableService, ConfigService,
                                                  TranslationService, toastr, routeConf, localStorageService,
                                                  modalBinding, NgTableParams) {
    var vm = this;
    vm.concept = {};

    $log.debug('modalBinding', modalBinding);
    vm.readonly = modalBinding.readonly;
    vm.constants = modalBinding.constants;
    vm.userBranches = modalBinding.userBranches;
    vm.taxes = vm.constants.tax;
    vm.addingTax = false;
    vm.totalWithoutTaxes = 0;
    vm.totalWithTaxes = 0;
    vm.taxesopen = false;
    vm.discountsopen = false;
    vm.submitted = false;
    vm.selectedRoomRate = null;

    function iniTableTaxes(list) {
        vm.taxes = list ? list : [];

        vm.tableParamsTaxes =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatIn: 'desc'
                    }
                },
                {
                    total: vm.taxes.length,
                    counts: [],
                    dataset: angular.copy(vm.taxes)
                }
            );

        vm.calcTotalTaxes();
    }

    /** Function to select tax */
    vm.selectTax = function (tax) {
        $log.debug('Selected Tax: ', tax);
    };

    /** Function to accept contact row (new/edit) */
    vm.saveTax = function (tax, index) {
        tax.modeEdit = false;
        if (vm.addingTax) {
            vm.taxes.push(tax.value);
        } else {
            vm.tableParamsTaxes.data[index] = tax;
            vm.taxes = vm.tableParamsTaxes.data;
        }
        iniTableTaxes(vm.taxes);
        vm.tableParamsTaxes.reload();
        vm.addingTax = false;
    };

    /** Function to delete contact row */
    vm.deleteTax = function (tax, index) {
        _.pullAt(vm.taxes, index);
        iniTableTaxes(vm.taxes);
        vm.tableParamsTaxes.reload();
    };

    vm.addTax = function (tax) {
        vm.addingTax = true;
        if (!vm.tableParamsTaxes) {
            iniTableTaxes();
        }
        vm.tableParamsTaxes.settings().dataset.unshift({
            modeEdit: true
        });
        vm.tableParamsTaxes.sorting({});
        vm.tableParamsTaxes.page(1);
        vm.tableParamsTaxes.reload();
    };

    /** Function to cancel (Edit / New) contact */
    vm.cancelTax = function (tax, index) {
        tax.modeEdit = false;
        if (index === 0 && !tax._id) {
            _.remove(vm.tableParamsTaxes.settings().dataset, function (item) {
                return tax === item;
            });
        } else {
            vm.tableParamsTaxes.data[index] = vm.temporalTax;
        }
        if (vm.addingTax) {
            vm.tableParamsTaxes.reload();
            vm.addingTax = false;
        }
        vm.addingTax = false;
    };

    /** Function to save concept */
    vm.save = function (form) {
        vm.submitted = true;
        if (form.$valid) {
            var conceptToSave = angular.copy(vm.concept);
            conceptToSave.taxes = vm.taxes;
            conceptToSave.component = 'customConcept';
            conceptToSave.idR = vm.concept._id;
            conceptToSave.lockEdit = vm.concept.lockEdit;
            conceptToSave.branches = vm.concept.branches;
            // if (vm.concept._id) {
            //     query.idR = vm.concept._id;
            // }

            if (vm.concept._id) {
                ConfigService.put({idR: vm.concept._id}, conceptToSave, function (data) {
                    $log.debug('[MasterTables] custom concept data: ', data);
                    toastr.success(TranslationService.dialog.saveok);
                    $uibModalInstance.close(true);
                }, function (err) {
                    $log.error('[MasterTables] error save custom concept: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    $uibModalInstance.close(true);
                });
            } else {
                ConfigService.post(conceptToSave, function (data) {
                    $log.debug('[MasterTables] custom concept data: ', data);
                    toastr.success(TranslationService.dialog.saveok);
                    $uibModalInstance.close(true);
                }, function (err) {
                    $log.error('[MasterTables] error update custom concept: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    $uibModalInstance.close(true);
                });
            }

        } else {
            $log.error('invalid form');
        }
    };

    vm.changeLockEdit = function () {
        if (!vm.readonly) {
            if (!vm.concept.lockEdit) {
                vm.concept.lockEdit = true;
            } else {
                vm.concept.lockEdit = false;
            }
        }
    };

    /** Function to calculate total amount with taxes */
    vm.calcTotalTaxes = function () {
        if (!vm.concept.amount) {
            vm.concept.amount = 0;
        }
        var tmpAmount = _.toNumber(vm.concept.amount);
        var discountF = vm.concept.discountF ? vm.concept.discountF : 0;
        var discountP = vm.concept.discountP ? tmpAmount * vm.concept.discountP / 100 : 0;
        vm.totalWithoutTaxes = tmpAmount ? tmpAmount - discountF - discountP : 0;

        vm.totalWithTaxes = JSON.parse(JSON.stringify(vm.totalWithoutTaxes));
        _.forEach(vm.taxes, function (cTax) {
            if (cTax.isPercentage) {
                vm.totalWithTaxes = parseFloat(vm.totalWithTaxes) + (tmpAmount * (cTax.rate / 100));
            } else {
                vm.totalWithTaxes = parseFloat(vm.totalWithTaxes) + parseFloat(cTax.rate);
            }
        });
        vm.totalWithTaxes = Math.round(vm.totalWithTaxes * 100) / 100;
    };

    vm.changeRoomRate = function () {
        $log.debug('selected room rate: ', vm.selectedRoomRate);
        if (vm.selectedRoomRate.price) {
            vm.concept.amount = vm.selectedRoomRate.price;
            vm.calcTotalTaxes();
        }
    };

    vm.$onInit = function () {
        if (modalBinding) {
            vm.concept = JSON.parse(JSON.stringify(modalBinding));
            if (vm.concept._id && vm.concept.taxes) {
                iniTableTaxes(vm.concept.taxes);
            } else {
                iniTableTaxes([]);
            }
        }
    };
}

angular.module('BlurAdmin.components')
    .controller('ModalRequestVisitController', ModalRequestVisitController);

function ModalRequestVisitController($uibModalInstance, $log, MasterTableService, index, spots,
                                   TranslationService, toastr, routeConf, ResidentsService, localStorageService,
                                   modalBinding, constants, readOnly) {

    var vm = this;
    // vm.momentAux = moment;
    vm.visit = {};
    vm.isNew = true;

    vm.readonly = readOnly;
    vm.submitted = false;

    vm.constants = angular.copy(constants);
    vm.listSpots = angular.copy(spots);

    if(_.isEmpty(modalBinding)) {
        $log.debug('New visit');
        vm.isNew = true;
        vm.visit.date = moment().toDate();
    } else {
        $log.debug('Edit visit: ', (modalBinding._id ? modalBinding._id : 'pending to save...'));
        vm.isNew = false;
        vm.visit = angular.copy(modalBinding);
        vm.visit.date = moment(vm.visit.date).toDate();
        vm.visit.index = index;
    }

    vm.cancel = function() {
        vm.visit = {};
        $uibModalInstance.dismiss();
    };

    vm.changeKnowAboutUs = function() {
        vm.visit.knowAboutUsOthers = '';
    };

    vm.selectRoom = function() {
        vm.visit.roomType = _.find(vm.constants.roomType, ['_id', vm.visit.room.roomType]);
    };

    vm.save = function(visitForm) {
        vm.submitted = true;
        if ((!vm.submitted && !visitForm.$valid) || !visitForm.$valid) {
            console.error('Invalid fields!');
        } else {
            $uibModalInstance.close(vm.visit);
        }
    };
}


angular.module('BlurAdmin.components')
    .controller('ModalRoomDetailController', ModalRoomDetailController);

function ModalRoomDetailController($uibModalInstance, $log, MasterTableService,
                                   TranslationService, toastr, routeConf, ResidentsService, localStorageService,
                                   modalBinding, NgTableParams, OccupancyResident, ConceptService, BillingService) {


    var vm = this;

    vm.momentAux = moment;
    vm.modeDismiss = '';
    vm.dateOptions = {
        // minDate: moment().toDate(),
        showWeeks: false
    };

    // Init values
    vm.resevationsids = [];
    vm.workerTask = [];
    vm.incidents = [];
    vm.cleaningTasks = [];
    vm.selectedCleanTask = {};
    vm.spotId = null;
    vm.roomCode = null;

    // Reservations xhr
    vm.reservations = [];

    // Today date without hours
    var today = moment().startOf('day');

    vm.lockDF = today.toDate();
    vm.lockDT = undefined;

    vm.newcheckinDF = today.toDate();
    vm.newcheckinDT = undefined;

    vm.lockComment = null;
    vm.appUser = undefined;
    vm.appUsers = [];

    // If user click on detail of reservation scheduler, modal receives an array of reservations ids
    if (modalBinding.idArray) {
        vm.reservationsids = modalBinding.idArray;
    }

    if (modalBinding.type) {
        vm.type = modalBinding.type;
    } else {
        vm.type = null;
    }

    // To show row for block room
    vm.showLock = false;

    // Unlock room Datepicker options
    vm.unlockDTOptions = {
        minDate: today.toDate(),
        showWeeks: false
    };

    // lock room datefrom Datepicker options
    vm.lockDFOptions = {
        minDate: today.toDate(),
        showWeeks: false
    };

    // New checkin datefrom datepicker options
    vm.newcheckinDFOptions = {
        minDate: today.toDate(),
        showWeeks: false
    };

    // New checkin dateto datepicker options
    vm.newcheckinDTOptions = {
        minDate: vm.newcheckinDF,
        showWeeks: false
    };

    // lock room dateto datepicker options
    vm.lockDTOptions = {
        minDate: today.toDate(),
        showWeeks: false
    };
    // Values to show or hide accordions
    vm.accordions = {
        workertask: true,
        incidents: true
    };

    // Avatar url
    vm.avatar = undefined;

    // Value to set to clean room
    vm.setToClean = false;

    // To use moment on html template
    vm.htmlmoment = moment;

    // Get worker Tasks
    vm.getWorkerTasks = function () {
        MasterTableService.get({idT: routeConf.workerTask, idJ: 'open', spot: vm.spotId}, function (workerTaskData) {
            $log.debug('WorkerTask Data: ', workerTaskData);
            vm.workerTask = workerTaskData.data;
        }, function (wterr) {
            toastr.error(TranslationService.errors.e500);
            $log.error('Error loading workerTask', wterr);
        });
    };

    // Get Incidents
    vm.getIncidents = function () {
        MasterTableService.get({
            idT: routeConf.app,
            idJ: routeConf.incident,
            spot: vm.spotId
        }, function (incidentsData) {
            $log.debug('Incidents data: ', incidentsData);
            vm.incidents = incidentsData.data;
        }, function (incerr) {
            toastr.error(TranslationService.errors.err500);
            $log.error('Error getting incidents', incerr);
        });
    };

    // Function to cancel cleaning room settings
    vm.cancelClean = function () {
        vm.setToClean = false;
        vm.selectedCleanTask = {};
    };

    // Function to save cleaning room settings
    vm.saveSetClean = function () {
        var cleanTask = {
            branch: localStorageService.get('selectedBarResidence')._id,
            spot: vm.spotId,
            taskType: vm.selectedCleanTask._id
        };

        MasterTableService.post({idT: routeConf.workerTask}, cleanTask, function (cleanRes) {
            $log.debug(cleanRes);
            toastr.success(TranslationService.dialog.saveok);
            vm.cancelClean();
            vm.getWorkerTasks();
            vm.modeDismiss = 'toClean';
        }, function (cleanErr) {
            $log.error('error load reservation detail: ', cleanErr);
            toastr.error(TranslationService.errors.e500);
        });
    };

    // Function to check occupancy dates
    vm.checkDates = function () {
        return vm.reservation &&
            ((vm.reservation.dateTo && moment(vm.reservation.dateTo).isBefore(moment())) ||
                (vm.reservation.dateFrom && vm.reservation.dateTo && moment(vm.reservation.dateFrom).isAfter(moment(vm.reservation.dateTo))));
    };

    // Function to save occupancy dates
    vm.saveDates = function () {
        var dateFrom = moment(vm.reservation.dateFrom).format('L');
        var dateFromInitial = moment(vm.reservationInitial.dateFrom).format('L');
        var dateFromChange = dateFrom !== dateFromInitial;
        OccupancyResident.post({idT: vm.reservation._id}, {
            dateFrom: vm.reservation.dateFrom,
            dateTo: vm.reservation.dateTo,
            datesChange: true,
            dateFromChange: dateFromChange,
            client: vm.reservation.client.item.id
        }, function (res) {
            $log.debug('update occupancy dates data: ', res);
            $uibModalInstance.dismiss('datesUpdate');
            toastr.success(TranslationService.roomschedulerdetail.datesUpdate);
        }, function (err) {
            $log.error('update occupancy dates error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    // Function to post checkout
    vm.checkout = function () {
        // 1) generate pending occupancy concepts, if necessary
        ConceptService.post({idR: 'occupancy'}, {_id: vm.resident._id, checkout: true}, function (data) {
            $log.debug('[residentDetail] generateOccupancyConcepts data: ', data);
            // 2) check if resident has no paid billings
            BillingService.get({client: vm.resident._id, noPayDate: true, active: true}, function (billingData) {
                $log.debug('get resident not paid billings: ', billingData);
            }, function (err) {
                $log.error('get resident not paid billings error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            }).$promise.then(function (notPaidBillings) {
                if (notPaidBillings.data && notPaidBillings.data.length && false) {
                    toastr.warning(TranslationService.errors.notPaidBillings, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                } else {
                    // 3) check if resident has pending concepts
                    ConceptService.get({client: vm.resident._id, active: true}, function (conceptData) {
                        $log.debug('get resident pending concepts: ', conceptData);
                    }, function (err) {
                        $log.error('get resident pending concepts error: ', err);
                        toastr.error(TranslationService.errors.e500, TranslationService.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    }).$promise.then(function (pendingConcepts) {
                        if (pendingConcepts.data && pendingConcepts.data.length && false) {
                            toastr.warning(TranslationService.errors.pendingConcepts, TranslationService.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        } else {
                            // 4) do checkout
                            var query = {};
                            // if (_.get(vm.reservation, 'dateTo')) {
                            //     _.set(query, 'dateToReal', vm.reservation.dateTo);
                            // }
                            _.set(query, 'dateToReal', moment().add(2, 'hour').toDate());
                            MasterTableService.post({
                                idT: routeConf.occupancy,
                                idJ: vm.reservationid,
                                idP: 'checkout'
                            }, query, function (checkoutres) {
                                toastr.success(TranslationService.roomschedulerdetail.usercheckoutok);
                                $uibModalInstance.dismiss('checkout');
                                $log.debug('checkout response: ', checkoutres);
                            }, function (checkouterr) {
                                $log.error('error checkout: ', checkouterr);
                                toastr.error(TranslationService.errors.e500);
                            });
                        }
                    });
                }
            });
        }, function (err) {
            $log.error('[residentDetail] generateOccupancyConcepts error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    // Function to new checkin on empty room
    vm.newcheckin = function () {
        var validCheckin = true;
        if (!vm.newcheckinDF) {
            validCheckin = false;
            // TODO: Translate
            toastr.error('Falta fecha de entrada');
        }

        if (vm.newcheckinDT <= vm.newcheckinDF) {
            validCheckin = false;
            // TODO: Translate
            toastr.error('La fecha de salida no puede ser menor que la de entrada');
        }

        if (!vm.appUser) {
            validCheckin = false;
            // TODO: Translate
            toastr.error('No ha seleccionado el usuario');
        }

        if (validCheckin) {
            var isToday = moment(vm.newcheckinDF).isSame(today, 'day');
            var queryCheckin = {
                room: vm.spotId,
                branch: localStorageService.get('selectedBarResidence')._id,
                dateFrom: isToday ? moment.utc() : vm.newcheckinDF,
                client: {
                    kind: 'AppUser',
                    item: vm.appUser.id
                }
            };

            if (vm.newcheckinDT) {
                queryCheckin.dateTo = vm.newcheckinDT;
            }

            MasterTableService.post({idT: routeConf.occupancy}, queryCheckin, function (checkinres) {
                toastr.success(TranslationService.roomschedulerdetail.usercheckoutok);
                $log.debug('Checkin response: ', checkinres);
                $uibModalInstance.dismiss('checkin');
            }, function (checkinerr) {
                $log.error('error post checkin: ', checkinerr);
                toastr.error(TranslationService.errors.e500);
            });
        }
    };

    // Function to post checkout
    vm.checkin = function (reserve) {
        // room: identificador de la habitación. Obligatorio
        // branch: identificador de la residencia. Obligatorio
        // dateFrom: fecha desde. Obligatorio
        // dateTo: fecha hasta. Opcional
        // client: identificador del cliente y tipo {kind: 'appUser',item: id }. Obligatorio
        // reservation: código de la reserva. Opcional

        var queryCheckin = {
            room: reserve.room._id,
            branch: reserve.room.branch,
            // dateFrom: reserve.dateFrom,
            dateFrom: new Date(),
            reservation: reserve._id
        };

        if (reserve.dateTo) {
            queryCheckin.dateTo = reserve.dateTo;
        }

        MasterTableService.post({idT: routeConf.occupancy}, queryCheckin, function (checkinres) {
            toastr.success(TranslationService.roomschedulerdetail.usercheckoutok);
            $log.debug('Checkin response: ', checkinres);
            $uibModalInstance.dismiss('checkin');
        }, function (checkinerr) {
            $log.error('error post checkin: ', checkinerr);
            toastr.error(TranslationService.errors.e500);
        });
    };

    // Function to delete reserve
    vm.deleteReserve = function (reserve) {
        // $log.debug(queryCheckin);
        MasterTableService.delete({idT: routeConf.reservation, idJ: reserve._id}, function (checkinres) {
            toastr.success(TranslationService.roomschedulerdetail.deleteReserveOk);
            $log.debug('Checkin response: ', checkinres);
            $uibModalInstance.dismiss('reservation');
        }, function (checkinerr) {
            $log.error('error post checkin: ', checkinerr);
            toastr.error(TranslationService.errors.e500);
        });
    };

    // Function to unblock room
    vm.unblock = function () {
        var eventid = null;
        var valid = true;

        if (!vm.unlockComment) {
            valid = false;
            toastr.error(TranslationService.roomschedulerdetail.missingunblockreason);
        }

        if (valid) {
            var queryUnblock = {
                dateTo: vm.unlockDT,
                comment: vm.unlockComment
            };

            // If user open modal clicking on event detail
            if (modalBinding.id) {
                eventid = modalBinding.id;
            }

            // If user open modal clicking on room label
            if (modalBinding.today) {
                eventid = modalBinding.today.occupancyId;
            }

            MasterTableService.post({
                idT: routeConf.occupancy,
                idJ: eventid,
                idP: routeConf.unblock
            }, queryUnblock, function (unblockres) {
                toastr.success(TranslationService.dialog.saveok);
                $log.debug('unblock response: ', unblockres);
                $uibModalInstance.dismiss('unblock');
            }, function (unblockerr) {
                $log.error('error post unblock: ', unblockerr);
                toastr.error(TranslationService.errors.e500);
            });
        }
    };

    // Function to block room
    vm.block = function () {
        var validLock = true;
        if (!vm.lockComment) {
            validLock = false;
            toastr.error(TranslationService.roomschedulerdetail.missingblockreason);
        }
        if (vm.lockDT < vm.lockDF) {
            toastr.error(TranslationService.errors.checkdates);
            validLock = false;
        }

        if (validLock) {
            var queryBlock = {
                room: vm.spotId,
                branch: localStorageService.get('selectedBarResidence')._id,
                dateFrom: vm.lockDF,
                dateTo: vm.lockDT,
                isBlock: true,
                blockReason: vm.lockComment
            };

            MasterTableService.post({idT: routeConf.occupancy}, queryBlock, function (unblockres) {
                toastr.success(TranslationService.dialog.saveok);
                $log.debug('unblock response: ', unblockres);
                $uibModalInstance.dismiss('unblock');
            }, function (blockerr) {
                $log.error('error post block: ', blockerr);
                toastr.error(TranslationService.errors.e500);
            });
        }
    };

    // Function to get occupation detail
    vm.getOccupiedDetail = function () {
        // Get detail occupation from id occupation
        MasterTableService.get({idT: routeConf.occupancy, idJ: vm.reservationid}, function (data) {
            $log.debug('Reservation detail: ', data);
            data.dateFrom = moment(data.dateFrom).toDate();
            data.dateTo = moment(data.dateTo).toDate();
            vm.reservation = data;
            vm.reservationInitial = JSON.parse(JSON.stringify(vm.reservation));
            vm.spotId = vm.reservation.room._id;
            vm.roomCode = vm.reservation.room.code;
            vm.getWorkerTasks();
            vm.getIncidents();

            // Get detail from client / resident
            ResidentsService.query({idR: vm.reservation.client.item.id}, function (clientData) {
                $log.debug('Resident detail: ', clientData);
                vm.resident = clientData;
                // Get avatar
                if (vm.resident.photo && vm.resident.photo.original.key) {
                    MasterTableService.get({
                        idT: routeConf.file, idJ: routeConf.signedUrl,
                        key: vm.resident.photo.original.key,
                        bucket: vm.resident.photo.original.bucket
                    }, function (data) {
                        vm.avatar = data.url;
                        vm.avatarOri = angular.copy(vm.avatar);
                    }, function (err) {
                        toastr.error(TranslationService.errors.e500);
                    });
                }
            }, function (clierr) {
                vm.resident = {};
                vm.ready = true;
            });

            // check occupation concepts in billings
            var query = {client: vm.reservation.client.item.id};
            ConceptService.get(query, function (data) {
                $log.debug('[modal room detail modal] get concept data: ', data.data);
                var occupationConcepts = _.filter(data.data, function (concept) {
                    return _.get(concept, 'related.kind') === 'Occupancy' && concept['billing'];
                });
                if (occupationConcepts && occupationConcepts.length) {
                    vm.noAvailableDateFrom = true;
                }
            });
        }, function (err) {
            $log.error('error load reservation detail: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.getBlockDetail = function () {
        // Get detail occupation from id occupation
        var eventid = null;
        if (modalBinding.id) {
            eventid = modalBinding.id;
        }
        if (modalBinding.today) {
            eventid = modalBinding.today.occupancyId;
        }
        MasterTableService.get({idT: routeConf.occupancy, idJ: eventid}, function (data) {
            vm.reservation = data;
            $log.debug('Block detail: ', data);

            vm.lockComment = data.blockReason;
            vm.lockDF = moment(data.dateFrom).toDate();
            if (data.dateTo) {
                vm.lockDT = moment(data.dateTo).toDate();
            }
            vm.showLock = true;
            vm.roomCode = modalBinding.spot.code;
            vm.spotId = modalBinding.spot._id;

            vm.getWorkerTasks();
            vm.getIncidents();
        }, function (err) {
            $log.error('error load reservation detail: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    // Function to get detail of a reservation
    vm.getreservation = function (id) {
        return new Promise(function (f, r) {
            MasterTableService.get({idT: routeConf.app, idJ: routeConf.reservation, idP: id}, function (data) {
                f(data);
            }, function (err) {
                r(err);
            });
        });
    };

    // Function to push reservation details on reservations ng-table
    vm.getReservations = function () {
        vm.arrpromises = [];
        // Get all reservation details
        _.forEach(vm.reservationsids, function (r) {
            vm.arrpromises.push(vm.getreservation(r));
            // console.log(vm.arrpromises);
        });
        Promise.all(vm.arrpromises).then(function (arrRes) {
            vm.reservations = arrRes;
            vm.tableParamsReservations =
                new NgTableParams(
                    {
                        page: 1,
                        count: 5,
                    },
                    {
                        total: vm.reservations.length,
                        counts: [],
                        dataset: angular.copy(vm.reservations)
                    }
                );
        }, function (reservationErr) {
            toastr.error(TranslationService.errors.err500);
            $log.error('Error getting reserve detail', reservationErr);
        });
    };

    vm.parseUserList = function (users) {
        var usrList = angular.copy(users);
        var listByBran = [];
        _.forEach(usrList, function (item) {
            item.branches = item.branches[0];
            var b = _.find(listByBran, function (a) {
                return a._id === item.branches._id;
            });
            if (!b) {
                listByBran.push({
                    _id: item.branches._id,
                    usr: [item]
                });
            } else {
                b.usr.push(item);
            }
        });
        var list = [];
        _.forEach(listByBran, function (bran) {
            bran.usr = _.orderBy(bran.usr, ['room', 'asc']);
            _.forEach(bran.usr, function (i) {
                list.push(i);
            });
        });
        var lastFloor = -1;
        var out = [];
        _.forEach(list, function (user) {
            user.nameRoom = '[' + user.room + '] ' + user.name + ' ' +
                user.surname;
            out.push(user);
        });
        return out;
    };

    // Function to get residents
    vm.getResidents = function () {
        var branchid = localStorageService.get('selectedBarResidence')._id;
        MasterTableService.get({
            idT: routeConf.resident,
            branches: branchid,
            virtual: 'all',
            noRoom: true
        }, function (data) {
            vm.appUsers = vm.parseUserList(data.data);
            $log.debug('resident load success', data);
            if (vm.menu && vm.appUsers && vm.appUsers.length > 0) {
                vm.allUsers = data.data;
                $log.debug('vm.appUsers load success', vm.appUsers);
                //checkAvailableUsers(branches);
                //vm.parseUserListBy();
            }
        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    // Get Clean (first get parent task id and after get clean tasks)
    MasterTableService.query({
        idT: routeConf.masterTable,
        idJ: routeConf.config,
        functionality: 'taskTypes',
        code: 'cleaning'
    }, function (cleaningParentData) {
        $log.debug('Cleaning parent data: ', cleaningParentData);
        var cleaningParentID = cleaningParentData[0]._id;
        // Get clean tasks
        MasterTableService.query({
            idT: routeConf.masterTable, idJ: 'taskType', taskParent: cleaningParentID,
            branches: localStorageService.get('selectedBarResidence')._id
        }, function (cleaningTasksData) {
            $log.debug('Cleaning tasks: ', cleaningTasksData);
            vm.cleaningTasks = cleaningTasksData;
        }, function (clterr) {
            toastr.error(TranslationService.errors.err500);
            $log.error('Error getting cleaning parent', clterr);
        });
    }, function (clpaerr) {
        toastr.error(TranslationService.errors.err500);
        $log.error('Error getting cleaning parent', clpaerr);
    });

    if (modalBinding.type === 'isReserved') {
        $log.debug('modalBinding: ', modalBinding);
        vm.roomCode = modalBinding.spot.code;
        vm.spotId = modalBinding.spot._id;
        vm.getWorkerTasks();
        vm.getIncidents();
        vm.getReservations();
    }

    if (modalBinding.type === 'isOccupied') {
        vm.reservationid = modalBinding.id;
        vm.getOccupiedDetail();
    }

    if (modalBinding.type === 'isBlocked') {
        $log.debug('modalBinding: ', modalBinding);
        vm.roomCode = modalBinding.spot.code;
        vm.spotId = modalBinding.spot._id;
        vm.getBlockDetail();
        if (modalBinding.dateTo) {
            vm.unlockDT = moment(modalBinding.dateTo).toDate();
        } else {
            vm.unlockDT = moment().toDate();
        }
    }

    // If user clicks on label room to show today status
    if (modalBinding.today) {
        vm.spotId = modalBinding.spot._id;
        vm.roomCode = modalBinding.spot.code;

        if (modalBinding.today.isBlocked) {
            vm.type = 'isBlocked';
            vm.getBlockDetail();
        }

        if (modalBinding.today.isOccupied) {
            vm.type = 'isOccupied';
            vm.reservationid = modalBinding.today.occupancyId;
            vm.getOccupiedDetail();
            vm.getWorkerTasks();
            vm.getIncidents();
        }

        if (modalBinding.today.isReserved) {
            vm.type = 'isReserved';

            vm.reservationsids = [];
            // vm.reservationsids = modalBinding.today.reservation;
            _.forEach(modalBinding.today.reservation, function (r) {
                vm.reservationsids.push(r._id);
            });
            vm.getWorkerTasks();
            vm.getIncidents();
            vm.getReservations();
        }

        if (modalBinding.today.isEmpty) {
            vm.type = 'isEmpty';
            vm.getWorkerTasks();
            vm.getIncidents();
            vm.getResidents();
        }
    }

    $log.debug('modalBinding', modalBinding);
}

angular.module('BlurAdmin.components')
    .controller('ModalTaskDetailController', ModalTaskDetailController);

function ModalTaskDetailController($uibModalInstance, $log, MasterTableService, ConfigService,
                                      TranslationService, toastr, routeConf, localStorageService,
                                      modalBinding, NgTableParams) {
    var vm = this;
    vm.readonly = modalBinding.readonly;
    vm.constants = modalBinding.constants;
    vm.submitted = false;
    vm.task = {};
    vm.actions = [];

    function iniActionsTable(list) {
        vm.tableParamsActions = new NgTableParams(
            {
                page: 1,
                count: 5,
                sorting: {
                    dateFormatIn: 'desc'
                }
            },
            {
                total: list.length,
                counts: [],
                dataset: angular.copy(list)
            }
        );
    }

    /** Function to add new action row */
    vm.addAction = function (action) {
        vm.addingAction = true;
        vm.editingActions = true;
        vm.tableParamsActions.settings().dataset.unshift({
            name: '',
            estTime: 0,
            modeEdit: true
        });
        vm.tableParamsActions.sorting({});
        vm.tableParamsActions.page(1);
        vm.tableParamsActions.reload();
    };

    /** Function to enter edit mode action */
    vm.editAction = function (action, index) {
        vm.editingActions = true;
        if (index !== 0 || action._id) {
            vm.tempAction = angular.copy(action);
        }
        action.modeEdit = true;
        action.date = moment(action.date).toDate();

        vm.temporalAction = angular.copy(action);
    };

    /** Function to cancel (Edit / New) action */
    vm.cancelAction = function (action, index) {
        action.modeEdit = false;

        if (index === 0 && !action._id) {
            _.remove(vm.tableParamsActions.settings().dataset, function (item) {
                return action === item;
            });
        } else {
            vm.tableParamsActions.data[index] = vm.tempAction;
        }
        if (vm.addingAction) {
            vm.tableParamsActions.reload();
            vm.addingAction = false;
        }
        vm.addingAction = false;
        vm.editingActions = false;
    };

    /** Function to accept action row (new/edit) */
    vm.saveAction = function (action, index) {
        action.modeEdit = false;
        if (vm.addingAction) {
            vm.actions.push(action);
        } else {
            vm.tableParamsActions.data[index] = action;
            vm.actions = vm.tableParamsActions.data;
        }
        iniActionsTable(vm.actions);
        vm.tableParamsActions.reload();
        vm.addingAction = false;
        vm.editingActions = false;
    };

    /** Function to delete action row */
    vm.deleteAction = function (action, index) {
        _.pullAt(vm.actions, index);
        iniActionsTable(vm.actions);
        vm.tableParamsActions.reload();
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (form) {

        var configSave = {
            component: 'tasktypes'
        };

        if (form.$valid) {

            configSave['description'] = vm.task.description;
            configSave['code'] = vm.task.code;
            configSave['branch'] = vm.task.branch;
            configSave['taskParent'] = vm.task.taskParent;

            configSave['actions'] = angular.copy(vm.tableParamsActions.data);

              if (vm.task._id) {
                  configSave['_id'] = vm.task._id;
                  ConfigService.put({idR: vm.task._id}, configSave, function (res) {
                      $log.debug('[payment] update task data: ', res);
                      toastr.success(TranslationService.dialog.saveok);
                      $uibModalInstance.close(true);
                  }, function (err) {
                      $log.error('post config error: ', err);
                      var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                            TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                      toastr.error(errMsg, TranslationService.error, {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                  });
              } else {
                  ConfigService.post(configSave, function (res) {
                      $log.debug('[payment] save task data: ', res);
                      toastr.success(TranslationService.dialog.saveok);
                      $uibModalInstance.close(true);
                  }, function (err) {
                      $log.error('post config error: ', err);
                      var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                          TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                      toastr.error(errMsg, TranslationService.error, {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                  });
              }
        } else {
            $log.error('invalid form');
        }
    };

    vm.$onInit = function () {
        if (modalBinding) {
            vm.task = angular.copy(modalBinding);
            vm.actions = angular.copy(vm.task.actions);
            iniActionsTable(vm.actions);
        }
    };
}

angular
    .module('BlurAdmin.theme.components')
    .controller('ModalRenewPassController', ModalRenewPassController);

function ModalRenewPassController($scope, $uibModalInstance, TranslationService,
                                  UsersServiceChangePass, localStorageService, toastr, $log) {
    var vm = this;

    vm.windowTit = TranslationService.modal.renewPassword.title;
    var userID = localStorageService.get('user')._id;
    vm.submitted = false;
    vm.pass = '';
    vm.lastPass = '';
    vm.confirPass = '';

    vm.validPassWord = function (formInput, formInputB) {
        var valid = true;
        if (formInput && formInputB) {
            valid = (formInput.$pristine ||
                formInputB.$pristine) ||
                (vm.trimText(vm.confirPass).length >= 6 &&
                vm.trimText(vm.pass).length >= 6 &&
                vm.trimText(vm.confirPass) === vm.trimText(vm.pass));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };

    vm.trimText = function (value) {
        if (angular.isString(value)) {
            value.replace(/^\s+|\s+$/g, '');
        }
        return value;
    };

    vm.back = function () {
        $uibModalInstance.dismiss('bye');
    };

    vm.save = function (userForm) {
        if ((!vm.submitted && !userForm.$valid ) || !userForm.$valid) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            var data = {
                currentPass: vm.lastPass,
                newPass: vm.pass
            };
            UsersServiceChangePass.post({idU:userID},data, function (data) {
                var answer = data;
                toastr.success(TranslationService.modal.renewPassword.sucess);
                $uibModalInstance.close(answer);
            },function (err) {
                $log.error('UsersServiceChangePass post error: ', err);
            });
        }
    };
}
/**
 * Created by ECardo on 16/05/2017.
 */

(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name BlurAdmin.blob.service:BlobService
     * @description
     * Service that transform a base64 in blob
     */
    angular
        .module('BlurAdmin.blob.service', [])
        .service('BlobService', BlobService);

    /* @ngInject */
    function BlobService() {
        this.base64toBlob = base64toBlob;

        function base64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }
    }

})();
/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';
    /**
     * @ngdoc service
     * @name BlurAdmin.translations.service:TranslationService
     * @description
     * Service that returns the javascript translations
     */
    angular
        .module('BlurAdmin.service.translations', [
            'pascalprecht.translate'
        ])
        .service('TranslationService', TranslationService);

    TranslationService.$inject = ['$translate', '$q'];

    /* @ngInject */
    function TranslationService($translate, $q) {
        var vm = this;

        vm.all = '';
        vm.reports = {
            sucess: '',
            names: {
                listRes: '',
                dishes: ''
            }
        };
        vm.reserve = {
            msg: {
                create: '',
                edit: '',
                delete: ''
            }
        };
        vm.inChatGroupMod = '';
        vm.inChatGroupNew = '';
        vm.inChatGroupDetail = '';
        vm.floor = '';
        vm.residents = {
            windowTit: '',
            renewAccessOK: '',
            cancelAccessOK: '',
            country: '',
            state: '',
            billing: {
                manyConcepts: ''
            }
        };
        vm.users = {
            titleNew: '',
            titleMod: '',
            exportTitle: '',
            export: {
                name: '',
                surname: '',
                branch: '',
                roles: '',
                app: '',
                email: '',
                phone: ''
            }
        };
        vm.errors = {
            e500: '',
            noDataInTable: '',
            error: '',
            noImage: '',
            checkdates: '',
            onlyImage: '',
            MENU40501: '',
            MENU40502: '',
            USER40501: '',
            USER40502: '',
            USER40503: '',
            GEN40501: '',
            GEN40502: '',
            SER40501: '',
            AGENDA40501: '',
            GENERROR0: '',
            GENERROR1: '',
            ERR405002: '',
            ERR405003: '',
            ERR405007: '',
            OCC00001: '',
            createRegister: '',
            updateRegister: '',
            deleteRegister: '',
            duplicatedCode: '',
            branchRequired: '',
            modalityRequired: '',
            roomTypeRequired: '',
            saveRequestFirst: '',
            selectBranch: '',
            duplicateEmail: '',
            notPaidBillings: '',
            pendingConcepts: ''
        };
        vm.roles = {
            manager: '',
            director: ''
        };
        vm.avatar = {
            changeimage: ''
        };
        vm.canteen = {
            newCourse: '',
            editCourse: '',
            menutypes: {
                dinner: '',
                lunch: ''
            },
            state: {
                closed: '',
                opened: ''
            },
            userremarks: {
                closed: '',
                opened: ''
            },
            allergens: {
                noAllergens: '',
                allergens: ''
            },
            allergensToolTips: {
                inDish: '',
                Kal: '',
                totAppUsr: ''
            },
            export: {
                title: '',
                date: '',
                branch: '',
                bookings: '',
                services: '',
                kind: '',
                comments: '',
                condition: '',
                first: '',
                second: '',
                dessert: '',
                extra: ''
            },
            msg: {
                deleteReserveSuccess: '',
                deleteReserveError: ''
            }
        };
        vm.bulletinDetail = {
            msg: {
                success: '',
                edit: ''
            }
        };
        vm.bulletinBoardList = {
            msg: {
                success: ''
            }
        };
        vm.modal = {
            invoiceSuccess: '',
            invoicesSuccess: '',
            proformaSuccess: '',
            confirmation: '',
            deleteItem: '',
            ActiveItem: '',
            alert: '',
            AnnouncementConfirmation: '',
            button: {
                ok: '',
                cancel: ''
            },
            deleteItemOk: '',
            renewPassword: {
                title: '',
                sucess: ''
            },
            reserve: {
                ReserveMoveerror: '',
                ReserveMovesuccess: ''
            },
            newRequestDNI: '',
            cancelBookingComment: '',
            reservationNoShow: '',
            reservationAccept: '',
            warning: '',
            invoiceNumberNeeded: '',
            paySuccess: ''
        };
        vm.dialog = {
            saveok: '',
            commentisrequired: '',
            cancelReservationBillings: ''
        };
        vm.forgotpassword = {
            sucessmail: '',
            error: ''
        };
        vm.login = {
            error400: '',
            error401: '',
            errordefault: '',
            sessionexpired: ''
        };
        vm.incidentDetail = {
            tagaste: '',
            msg: {
                edit: '',
                success: ''
            },
        };
        vm.warning = '';
        vm.activityList = {
            msg: {
                delete: ''
            },
            title: '',
            export: {
                location: '',
                title: '',
                price: '',
                registred_nro: '',
                status: '',
                places_limit: '',
                description: '',
                event_location: '',
                date_and_time: '',
                residents_room: ''
            }
        };
        vm.activityDetail = {
            msg: {
                create: '',
                edit: ''
            },
            export: {
                num_habitacion: '',
                nombre_completo: '',
                telefono: '',
                email: ''
            }
        };
        vm.services = {
            activeon: '',
            activeoff: '',
            stateon: '',
            stateoff: '',
            export: {
                title: '',
                city: '',
                name: '',
                price: '',
                hour: ''
            }
        };
        vm.annoucement = {
            msg: {
                create: ''
            }
        };
        vm.resident = {
            title: '',
            titleedit: '',
            msgerrorguest: '',
            invalidawaydates: '',
            menudelivered: ''
        };
        vm.tour = {
            dashboard: {
                title: '',
                step1MenuD: '',
                step2AvatarD: '',
                step3MainmenuD: '',
                step4BreadcrumD: '',
                step5TourD: ''
            },
            bulletinBoard: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3TableRow: '',
                step4TableEditButton: '',
                step5TableDeleteButton: '',
                step6TableTotalItems: '',
                step7TableNewButton: '',
                step9BulletinDetail: '',
                step10BulletinDetailImg: '',
                step11BulletinDetailHighlight: '',
                step12BulletinDetailTooltip: '',
                step13BulletinDetailVisibleFrom: '',
                step14BulletinDetailVisibleTo: '',
                step15BulletinDetailCancelButton: '',
                step17ResumeTourButton: ''
            },
            residents: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3DelColumn: '',
                step3ResColumn: '',
                step3AbsentColumn: '',
                step3AppColumn: '',
                step4TableRow: '',
                step5TableEditButton: '',
                step6TableDeleteButton: '',
                step7TableTotalItems: '',
                step8TableNewButton: '',
                step10ResidentDetail: '',
                step11ResidentDetailImg: '',
                step12ResidentDetailTooltip: '',
                step13ResidentDetailIdentification: '',
                step14ResidentDetailStays: '',
                step15ResidentDetailCancelButton: '',
                step17ResumeTourButton: '',
                step17ResidentDetailRoom: '',
                step17ResidentDetailContactInfo: '',
                step17ResidentDetailOtherInfo: '',
                step17ResidentDetailHistory: ''
            },
            announcements: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3RelatedColumn: '',
                step4PushColumn: '',
                step5TableRow: '',
                step6TableTotalItems: '',
                step7TableNewButton: '',
                step9AnnouncementDetail: '',
                step10AnnouncementDetailPlaces: '',
                step11AnnouncementDetailGlobal: '',
                step12AnnouncementDetailResidents: '',
                step13AnnouncementDetailTitle: '',
                step14AnnouncementDetailBody: '',
                step15AnnouncementDetailPush: '',
                step16AnnouncementDetailCancel: '',
                step18ResumeTourButton: ''
            },
            menu: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3Comments: '',
                step4StatusColumn: '',
                step5TableRow: '',
                step6TableTotalItems: '',
                step7TableNewButton: '',
                step9MenuDetail: '',
                step10MenuDetailDateFrom: '',
                step11MenuDetailDateTo: '',
                step12MenuDetailPlace: '',
                step13MenuDetailType: '',
                step14MenuDetailReserve: '',
                step15MenuDetailPending: '',
                step16MenuDetailGroupInputs: '',
                step17MenuDetailPlusDish: '',
                step19MenuSelectSearch: '',
                step20MenuSelectType: '',
                step21MenuSelectAllergen: '',
                step22MenuSelectDish: '',
                step23MenuSelectEdit: '',
                step24MenuSelectNewButton: '',
                step26MenuNewDishImg: '',
                step27MenuNewDishType: '',
                step28MenuNewDishAllergen: '',
                step29MenuNewDishTitle: '',
                step30MenuNewDishKal: '',
                step31MenuNewDishTags: '',
                step32MenuNewDishSave: '',
                step33MenuNewDishBack: '',
                step35MenuSelectAddDish: '',
                step37MenuSelectBack: '',
                step39MenuDetailFirstDish: '',
                step40MenuDetailAddSecond: '',
                step41MenuDetailAddDessert: '',
                step42MenuDetailEdit: '',
                step42MenuDetailPrintReport: '',
                step43MenuDetailSave: '',
                step44MenuDetailBack: '',
                step46ResumeTourButton: ''
            },
            incidents: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3PriorityColumn: '',
                step4StatusColumn: '',
                step5TableRow: '',
                step6TableTotalItems: '',
                step7TableNewButton: '',
                step9IncidentDetail: '',
                step10IncidentDetailTootlip: '',
                step11IncidentDetailName: '',
                step12IncidentDetailPriority: '',
                step13IncidentDetailImg: '',
                step14IncidentDetailSaveButton: '',
                step15IncidentDetailCancelButton: '',
                step17IncidentFirstRow: '',
                step19IncidentDetailLeftCol: '',
                step20IncidentDetailRightCol: '',
                step21IncidentDetailPush: '',
                step22Timeout: '',
                step23ResumeTourButton: '',
                export: {
                    location: '',
                    date: '',
                    place: '',
                    text: '',
                    priority: '',
                    condition: '',
                    kind: '',
                    originUser: '',
                    username: '',
                }
            },
            services: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Scheduler: '',
                step3Filters: '',
                step4TableRow: '',
                step5TableEditButton: '',
                step6TableDeleteButton: '',
                step7TableTotalItems: '',
                step8TableNewButton: '',
                step10ServDetail: '',
                step11ServDetailTootlip: '',
                step12ServDetailTimetable: '',
                step14ServDetailSaveButton: '',
                step15ServDetailCancelButton: '',
                step16ServFirstRow: '',
                step18ServDetailPush: '',
                step20ResumeTourButton: ''
            },
            agenda: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3Footer: '',
                step4TableRow: '',
                step5TableEditButton: '',
                step6TableDeleteButton: '',
                step7TableTotalItems: '',
                step8TableNewButton: '',
                step10AgendaDetail: '',
                step11AgendaDetailTootlip: '',
                step12AgendaDetailVisible: '',
                step13AgendaDetailLimitDate: '',
                step14AgendaDetailSaveButton: '',
                step15AgendaDetailCancelButton: '',
                step17ResumeTourButton: ''
            },
            users: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3Footer: '',
                step4TableRow: '',
                step5TableEditButton: '',
                step6TableDeleteButton: '',
                step7TableTotalItems: '',
                step8TableNewButton: '',
                step10UsersDetail: '',
                step11UsersDetailImage: '',
                step12UsersDetailResidencias: '',
                step13UsersDetailTootlip: '',
                step14UsersDetailEmail: '',
                step15UsersDetailSaveButton: '',
                step16UsersDetailCancelButton: '',
                step18ResumeTourButton: ''
            },
            accessapp: {
                title: '',
                step0Welcome: '',
                step1AccessappDetail: '',
                step2AccessappDetailData: '',
                step3AccessappDetailResidents: '',
                step4AccessappDetailSaveButton: '',
                step5AccessappDetailCancelButton: ''
            },
            chat: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2FilterPlace: '',
                step3Filter: '',
                step4Row: '',
                step5Edit: '',
                step6Delete: '',
                step7New: '',
                step9ChatDetail: '',
                step10ChatDetailTooltip: '',
                step11ChatDetailSave: '',
                step13Count: '',
                step14ResumeTourButton: ''
            },
            workerTask: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Scheduler: '',
                step3Filters: '',
                step4TableRow: '',
                step5TableEditButton: '',
                step6TableDeleteButton: '',
                step7TableTotalItems: '',
                step8TableNewButton: '',
                step10ServDetail: '',
                step11ServDetailTootlip: '',
                step12ServDetailTimetable: '',
                step14ServDetailSaveButton: '',
                step15ServDetailCancelButton: '',
                step16ServFirstRow: '',
                step18ServDetailPush: '',
                step20ResumeTourButton: ''
            },
            requests: {
                title: '',
                step0Welcome: '',
                step1List: '',
                step2Filters: '',
                step3DateColumns: '',
                step4RatingColumn: '',
                step5TableRow: '',
                step6TableTotalItems: '',
                step7TableNewButton: '',
                stepDniInput: '',
                stepDniInputConfirm: '',
                stepDniInputCancel: '',
                step8RequestDetail: '',
                step9RequestDetailTooltip: '',
                step10RequestDetailSaveButton: '',
                step11RequestDetailCancelButton: '',
                step12RequestsFirstRow: '',
                step13RequestExport: '',
                step14ResumeTourButton: ''
            },
            rack: {
                title: '',
                step0Welcome: '',
                step1Filters: '',
                step2Legend: '',
                step3Rack: '',
                step4New: '',
                step6NewBedRoom: '',
                step7BedRoomDetailTooltip: '',
                step9AddInventory: '',
                step10SaveInventory: '',
                step12RoomType: '',
                step13RoomRate: '',
                step14RoomSave: '',
                step15NewRoomCancel: '',
                step17RoomDetail: '',
                step19ActiveTask: '',
                step21CleanRoom: '',
                step23SaveTask: '',
                step24IncidentPanel: '',
                step25ResumeTour: ''
            }
        };
        vm.incidents = {
            title: '',
            export: {
                location: '',
                date: '',
                place: '',
                text: '',
                priority: '',
                status: '',
                originUser: '',
                username: ''
            }
        };
        vm.notificationPush = {
            msgSuccess: ''
        };
        vm.incidencesChart = {
            incidencesHigh: '',
            incidencesHighAbbrev: '',
            incidencesNormal: '',
            incidencesNormalAbbrev: '',
            incidencesTimeOut: '',
            incidencesTimeOutAbbrev: '',
            incidencesTotal: '',
            incidencesTotalAbbrev: '',
            timeFor: '',
            occupation: '',
            totalOccupation: '',
            occupationAbbrev: '',
            units: {
                incidence: '',
                time: ''
            },
            opened: '',
            closed: ''
        };
        vm.chart = {
            label: {
                occupation: '',
                reservation: '',
                service: ''
            },
            weekly: '',
            monthly: ''
        };
        vm.roomschedulerdetail = {
            usercheckoutok: '',
            peopleList: '',
            missingblockreason: '',
            missingunblockreason: '',
            deleteReservation: '',
            datesUpdate: ''
        };
        vm.morning = '';
        vm.afternoon = '';
        vm.morningAfternoon = '';
        vm.taskDetail = {
            msg: {
                edit: '',
                create: ''
            }
        };
        vm.roomscheduler = {
            room: ''
        };

        vm.tasks = {
            title: '',
            export: {
                location: '',
                place: '',
                date: '',
                type: '',
                status: '',
                reopened: '',
                worker: ''
            }
        };
        vm.residentlist = {
            title: '',
            export: {
                room: '',
                name: '',
                residence: '',
                dni: '',
                date_of_birth: '',
                delegate: '',
                resident: '',
                app: '',
                email: '',
                phone: '',
                address: '',
                zip_code: '',
                city: '',
                province: '',
                country: '',
                tutors_name: '',
                tutors_gender: '',
                tutors_address: '',
                tutors_city: '',
                tutors_postcode: '',
                tutors_state: '',
                tutors_country: '',
                tutors_identity: '',
                tutors_email: '',
                tutors_mainPhone: '',
                tutors_secondaryPhone: '',
                tutors_studies: '',
                tutors_profession: '',
                academicdata_university: '',
                academicdata_faculty: '',
                academicdata_carrercollege: '',
                academicdata_course: '',
            }
        };

        vm.calendar = {
            title: '',
            export: {
                worker: '',
                hora: ''
            }
        };

        vm.activities = {
            title: '',
            export: {}
        };

        vm.request = {};

        vm.requests = {
            title: '',
            list: {
                name: '',
                surname: '',
                course: '',
                date: '',
                branch: '',
                depositDate: '',
                registrationDate: '',
                rating: '',
                isReservation: '',
            },
            detail: {
                header: '',
                toastMissingModalityData: '',
                toastMissingBillingData: '',
                toastMissingBranch: '',
                missingDocumentation: '',
                missingTuition: '',
                missingDeposit: '',
                depositConcept: ''
            },
            export: {
                name: '',
                surname: '',
                course: '',
                bookings: '',
                request_date: '',
                residence: '',
                billing_deposit_date: '',
                billing_tuition_date: '',
                assessment: '',
                effective: '',
                room: '',
                gender: '',
                document_type: '',
                document: '',
                document_expedition_date: '',
                email: '',
                phone: '',
                alias: '',
                birthdate: '',
                home_address: '',
                home_postal_code: '',
                home_town: '',
                home_province: '',
                home_country: '',
                citizenship: '',
                idiom: '',
                guardian_type: '',
                guardian_name: '',
                guardian_domicile_address: '',
                guardian_domicile_zip_code: '',
                guardian_domicile_city: '',
                guardian_domicile_state: '',
                guardian_domicile_country: '',
                guardian_email: '',
                guardian_main_phone: '',
                guardian_secondary_phone: '',
                guardian_document: '',
                guardian_document_type: '',
                guardian_studies: '',
                guardian_profession: '',
                academic_data_university: '',
                academic_data_faculty: '',
                academic_data_studies: '',
                academic_data_course: '',
                academic_data_comments: '',
                billing_modality: '',
                billing_form_of_payment: '',
                bank_details_account_holder: '',
                bank_details_entity: '',
                bank_account_details: '',
                swift_bank_details: '',
                data_request_modality: '',
                room_type_request_data: '',
                data_request_start_date: '',
                data_request_end_date: '',
                data_request_end_date_contract: '',
                data_request_date_signature_rules: '',
                visits: '',
            }
        };
        vm.masterTables = {
            option: {
                knowAboutUs: '',
                interviewRating: ''
            }
        };

        vm.yes = '';
        vm.no = '';
        vm.reset = '';
        vm.config = {
            university: '',
            faculty: ''
        }

        vm.reservations = {
            status: {
                cancelled: '',
                pending: '',
                confirmed: '',
                noShow: '',
            },
            exportTitle: '',
            export: {
                code: '',
                origin: '',
                name: '',
                surname: '',
                course: '',
                dateFrom: '',
                dateTo: '',
                status: '',
                roomType: '',
                room: '',
                isResident: '',
                cancelBookingComment: '',
                branch: ''
            },
            error:  {
                missingDates: '',
                isAppUser: ''
            }
        };

        vm.billing = {
            list: {
                multiple: '',
                occupancies: ''
            },
            detail: {
                resident: '',
                guest: '',
                other: ''
            },
            exportTitle: '',
            export: {
                date: '',
                proformaNumber: '',
                invoiceNumber: '',
                groupCode: '',
                clientType: '',
                payType: '',
                payDate: '',
                amount: '',
                name: '',
                surname: '',
                branch: '',
                billingName: '',
                billingDni: '',
                conceptName: '',
                conceptAmount: '',
                conceptTaxes: '',
                conceptDiscountP: '',
                conceptDiscountF: ''
            }
        };

        vm.payments = {
            types: {
                agenda: '',
                service: '',
                occupancy: '',
                other: ''
            },
            invalidInvoice: ''
        };

        vm.bedroomDetail = {
            cleanTaskObligatoryFields: '',
            selectCleanTask: ''
        };

        vm.translateAll = function () {
            $translate('REQUESTS.DETAIL.DEPOSIT_CONCEPT').then(function (translation) {
                vm.requests.detail.depositConcept = translation;
            }, function (translationId) {
                vm.requests.detail.depositConcept = translationId;
            });

            $translate('BILLING.EXPORT_TITLE').then(function (translation) {
                vm.billing.exportTitle = translation;
            }, function (translationId) {
                vm.billing.exportTitle = translationId;
            });
            $translate('BILLING.EXPORT.RECEIPT').then(function (translation) {
                vm.billing.export.proformaNumber = translation;
            }, function (translationId) {
                vm.billing.export.proformaNumber = translationId;
            });
            $translate('BILLING.EXPORT.CODE').then(function (translation) {
                vm.billing.export.invoiceNumber = translation;
            }, function (translationId) {
                vm.billing.export.invoiceNumber = translationId;
            });
            $translate('BILLING.EXPORT.GROUP_CODE').then(function (translation) {
                vm.billing.export.groupCode = translation;
            }, function (translationId) {
                vm.billing.export.groupCode = translationId;
            });
            $translate('BILLING.EXPORT.CLIENT_TYPE').then(function (translation) {
                vm.billing.export.clientType = translation;
            }, function (translationId) {
                vm.billing.export.clientType = translationId;
            });
            $translate('BILLING.EXPORT.PAY_TYPE').then(function (translation) {
                vm.billing.export.payType = translation;
            }, function (translationId) {
                vm.billing.export.payType = translationId;
            });
            $translate('BILLING.EXPORT.PAY_DATE').then(function (translation) {
                vm.billing.export.payDate = translation;
            }, function (translationId) {
                vm.billing.export.payDate = translationId;
            });
            $translate('BILLING.EXPORT.AMOUNT').then(function (translation) {
                vm.billing.export.amount = translation;
            }, function (translationId) {
                vm.billing.export.amount = translationId;
            });
            $translate('BILLING.EXPORT.NAME').then(function (translation) {
                vm.billing.export.name = translation;
            }, function (translationId) {
                vm.billing.export.name = translationId;
            });
            $translate('BILLING.EXPORT.SURNAME').then(function (translation) {
                vm.billing.export.surname = translation;
            }, function (translationId) {
                vm.billing.export.surname = translationId;
            });
            $translate('BILLING.EXPORT.DATE_BILLING').then(function (translation) {
                vm.billing.export.date = translation;
            }, function (translationId) {
                vm.billing.export.date = translationId;
            });
            $translate('BILLING.EXPORT.BRANCH').then(function (translation) {
                vm.billing.export.branch = translation;
            }, function (translationId) {
                vm.billing.export.branch = translationId;
            });
            $translate('BILLING.EXPORT.BILLING_NAME').then(function (translation) {
                vm.billing.export.billingName = translation;
            }, function (translationId) {
                vm.billing.export.billingName = translationId;
            });
            $translate('BILLING.EXPORT.BILLING_DNI').then(function (translation) {
                vm.billing.export.billingDni = translation;
            }, function (translationId) {
                vm.billing.export.billingDni = translationId;
            });
            $translate('BILLING.EXPORT.CONCEPT_NAME').then(function (translation) {
                vm.billing.export.conceptName = translation;
            }, function (translationId) {
                vm.billing.export.conceptName = translationId;
            });
            $translate('BILLING.EXPORT.CONCEPT_AMOUNT').then(function (translation) {
                vm.billing.export.conceptAmount = translation;
            }, function (translationId) {
                vm.billing.export.conceptAmount = translationId;
            });
            $translate('BILLING.EXPORT.CONCEPT_TAXES').then(function (translation) {
                vm.billing.export.conceptTaxes = translation;
            }, function (translationId) {
                vm.billing.export.conceptTaxes = translationId;
            });
            $translate('BILLING.EXPORT.CONCEPT_DISCOUNTP').then(function (translation) {
                vm.billing.export.conceptDiscountP = translation;
            }, function (translationId) {
                vm.billing.export.conceptDiscountP = translationId;
            });
            $translate('BILLING.EXPORT.CONCEPT_DISCOUNTF').then(function (translation) {
                vm.billing.export.conceptDiscountF = translation;
            }, function (translationId) {
                vm.billing.export.conceptDiscountF = translationId;
            });

            $translate('CANTEENNEWCOURSE.DELETE_RESERVE_SUCCESS').then(function (translation) {
                vm.canteen.msg.deleteReserveSuccess = translation;
            }, function (translationId) {
                vm.canteen.msg.deleteReserveSuccess = translationId;
            });
            $translate('CANTEENNEWCOURSE.DELETE_RESERVE_ERROR').then(function (translation) {
                vm.canteen.msg.deleteReserveError = translation;
            }, function (translationId) {
                vm.canteen.msg.deleteReserveError = translationId;
            });

            $translate('REQUESTS.LIST.STATUS.NOSHOW').then(function (translation) {
                vm.reservations.status.noShow = translation;
            }, function (translationId) {
                vm.reservations.status.noShow = translationId;
            });
            $translate('REQUESTS.LIST.STATUS.CANCELLED').then(function (translation) {
                vm.reservations.status.cancelled = translation;
            }, function (translationId) {
                vm.reservations.status.cancelled = translationId;
            });
            $translate('REQUESTS.LIST.STATUS.PENDING').then(function (translation) {
                vm.reservations.status.pending = translation;
            }, function (translationId) {
                vm.reservations.status.pending = translationId;
            });
            $translate('REQUESTS.LIST.STATUS.CONFIRMED').then(function (translation) {
                vm.reservations.status.confirmed = translation;
            }, function (translationId) {
                vm.reservations.status.confirmed = translationId;
            });

            $translate('MODAL.INVOICESUCCESS').then(function (translation) {
                vm.modal.invoiceSuccess = translation;
            }, function (translationId) {
                vm.modal.invoiceSuccess = translationId;
            });
            $translate('MODAL.INVOICESSUCCESS').then(function (translation) {
                vm.modal.invoicesSuccess = translation;
            }, function (translationId) {
                vm.modal.invoicesSuccess = translationId;
            });
            $translate('MODAL.PROFORMASUCCESS').then(function (translation) {
                vm.modal.proformaSuccess = translation;
            }, function (translationId) {
                vm.modal.proformaSuccess = translationId;
            });
            $translate('MODAL.PAYSUCCESS').then(function (translation) {
                vm.modal.paySuccess = translation;
            }, function (translationId) {
                vm.modal.paySuccess = translationId;
            });
            $translate('MODAL.WARNING').then(function (translation) {
                vm.modal.warning = translation;
            }, function (translationId) {
                vm.modal.warning = translationId;
            });
            $translate('MODAL.INVOICENUMBERNEEDED').then(function (translation) {
                vm.modal.invoiceNumberNeeded = translation;
            }, function (translationId) {
                vm.modal.invoiceNumberNeeded = translationId;
            });
            $translate('MODAL.PAYBILLING').then(function (translation) {
                vm.modal.payBilling = translation;
            }, function (translationId) {
                vm.modal.payBilling = translationId;
            });

            $translate('BILLING.DETAIL.RESIDENT').then(function (translation) {
                vm.billing.detail.resident = translation;
            }, function (translationId) {
                vm.billing.detail.resident = translationId;
            });
            $translate('BILLING.DETAIL.GUEST').then(function (translation) {
                vm.billing.detail.guest = translation;
            }, function (translationId) {
                vm.billing.detail.guest = translationId;
            });
            $translate('BILLING.DETAIL.OTHER').then(function (translation) {
                vm.billing.detail.other = translation;
            }, function (translationId) {
                vm.billing.detail.other = translationId;
            });

            $translate('MASTERTABLES.CONFIG.UNIVERSITY').then(function (translation) {
                vm.config.university = translation;
            }, function (translationId) {
                vm.config.university = translationId;
            });
            $translate('MASTERTABLES.CONFIG.FACULTY').then(function (translation) {
                vm.config.faculty = translation;
            }, function (translationId) {
                vm.config.faculty = translationId;
            });

            $translate('BUTTONS.YES').then(function (translation) {
                vm.yes = translation;
            }, function (translationId) {
                vm.yes = translationId;
            });
            $translate('BUTTONS.NO').then(function (translation) {
                vm.no = translation;
            }, function (translationId) {
                vm.no = translationId;
            });
            $translate('BUTTONS.RESET').then(function (translation) {
                vm.reset = translation;
            }, function (translationId) {
                vm.reset = translationId;
            });

            // **********************************************************************
            // TRANSLATE_ALL START
            // **********************************************************************
            // TOUR.REQUESTS START

            $translate('TOUR.REQUESTS.TITLE').then(function (translation) {
                vm.tour.requests.title = translation;
            }, function (translationId) {
                vm.tour.requests.title = translationId;
            });
            $translate('TOUR.REQUESTS.STEP0_WELCOME').then(function (translation) {
                vm.tour.requests.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.requests.step0Welcome = translationId;
            });
            $translate('TOUR.REQUESTS.STEP1_LIST').then(function (translation) {
                vm.tour.requests.step1List = translation;
            }, function (translationId) {
                vm.tour.requests.step1List = translationId;
            });
            $translate('TOUR.REQUESTS.STEP2_FILTERS').then(function (translation) {
                vm.tour.requests.step2Filters = translation;
            }, function (translationId) {
                vm.tour.requests.step2Filters = translationId;
            });
            $translate('TOUR.REQUESTS.STEP3_DATECOLUMNS').then(function (translation) {
                vm.tour.requests.step3DateColumns = translation;
            }, function (translationId) {
                vm.tour.requests.step3DateColumns = translationId;
            });
            $translate('TOUR.REQUESTS.STEP4_RATINGCOLUMN').then(function (translation) {
                vm.tour.requests.step4RatingColumn = translation;
            }, function (translationId) {
                vm.tour.requests.step4RatingColumn = translationId;
            });
            $translate('TOUR.REQUESTS.STEP5_ROW').then(function (translation) {
                vm.tour.requests.step5TableRow = translation;
            }, function (translationId) {
                vm.tour.requests.step5TableRow = translationId;
            });
            $translate('TOUR.REQUESTS.STEP6_TOTAL').then(function (translation) {
                vm.tour.requests.step6TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.requests.step6TableTotalItems = translationId;
            });
            $translate('TOUR.REQUESTS.STEP7_NEW').then(function (translation) {
                vm.tour.requests.step7TableNewButton = translation;
            }, function (translationId) {
                vm.tour.requests.step7TableNewButton = translationId;
            });
            $translate('TOUR.REQUESTS.STEP8_REQUESTDETAIL').then(function (translation) {
                vm.tour.requests.step8RequestDetail = translation;
            }, function (translationId) {
                vm.tour.requests.step8RequestDetail = translationId;
            });
            $translate('TOUR.REQUESTS.STEP_DNIINPUT').then(function (translation) {
                vm.tour.requests.stepDniInput = translation;
            }, function (translationId) {
                vm.tour.requests.stepDniInput = translationId;
            });
            $translate('TOUR.REQUESTS.STEP_DNIINPUTCONFIRM').then(function (translation) {
                vm.tour.requests.stepDniInputConfirm = translation;
            }, function (translationId) {
                vm.tour.requests.stepDniInputConfirm = translationId;
            });
            $translate('TOUR.REQUESTS.STEP_DNIINPUTCANCEL').then(function (translation) {
                vm.tour.requests.stepDniInputCancel = translation;
            }, function (translationId) {
                vm.tour.requests.stepDniInputCancel = translationId;
            });
            $translate('TOUR.REQUESTS.STEP9_REQUESTDETAILTOOLTIP').then(function (translation) {
                vm.tour.requests.step9RequestDetailTooltip = translation;
            }, function (translationId) {
                vm.tour.requests.step9RequestDetailTooltip = translationId;
            });
            $translate('TOUR.REQUESTS.STEP10_REQUESTDETAILSAVE').then(function (translation) {
                vm.tour.requests.step10RequestDetailSaveButton = translation;
            }, function (translationId) {
                vm.tour.requests.step10RequestDetailSaveButton = translationId;
            });
            $translate('TOUR.REQUESTS.STEP11_REQUESTDETAILCANCEL').then(function (translation) {
                vm.tour.requests.step11RequestDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.requests.step11RequestDetailCancelButton = translationId;
            });
            $translate('TOUR.REQUESTS.STEP12_REQUESTSFIRSTROW').then(function (translation) {
                vm.tour.requests.step12RequestsFirstRow = translation;
            }, function (translationId) {
                vm.tour.requests.step12RequestsFirstRow = translationId;
            });
            $translate('TOUR.REQUESTS.STEP13_REQUESTEXPORT').then(function (translation) {
                vm.tour.requests.step13RequestExport = translation;
            }, function (translationId) {
                vm.tour.requests.step13RequestExport = translationId;
            });
            $translate('TOUR.REQUESTS.STEP14_RESUMETOUR').then(function (translation) {
                vm.tour.requests.step14ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.requests.step14ResumeTourButton = translationId;
            });
            //REQUESTS TOUR END

            $translate('REQUESTS.LIST.IS_RESERVATION').then(function (translation) {
                vm.requests.list.isReservation = translation;
            }, function (translationId) {
                vm.requests.list.isReservation = translationId;
            });
            $translate('REQUESTS.LIST.AVERAGE_RATING').then(function (translation) {
                vm.requests.list.rating = translation;
            }, function (translationId) {
                vm.requests.list.rating = translationId;
            });
            $translate('REQUESTS.LIST.DATE_REGISTRATION').then(function (translation) {
                vm.requests.list.registrationDate = translation;
            }, function (translationId) {
                vm.requests.list.registrationDate = translationId;
            });
            $translate('REQUESTS.LIST.DATE_DEPOSIT').then(function (translation) {
                vm.requests.list.depositDate = translation;
            }, function (translationId) {
                vm.requests.list.depositDate = translationId;
            });
            $translate('REQUESTS.LIST.BRANCH').then(function (translation) {
                vm.requests.list.branch = translation;
            }, function (translationId) {
                vm.requests.list.branch = translationId;
            });
            $translate('REQUESTS.LIST.DATE_APPLICATION').then(function (translation) {
                vm.requests.list.date = translation;
            }, function (translationId) {
                vm.requests.list.date = translationId;
            });

            $translate('REQUESTS.LIST.COURSE').then(function (translation) {
                vm.requests.list.course = translation;
            }, function (translationId) {
                vm.requests.list.course = translationId;
            });

            $translate('REQUESTS.LIST.TABLE_LASTNAME').then(function (translation) {
                vm.requests.list.surname = translation;
            }, function (translationId) {
                vm.requests.list.surname = translationId;
            });

            $translate('REQUESTS.LIST.TABLE_NAME').then(function (translation) {
                vm.requests.list.name = translation;
            }, function (translationId) {
                vm.requests.list.name = translationId;
            });

            $translate('REQUESTS.LIST.HEADER').then(function (translation) {
                vm.requests.title = translation;
            }, function (translationId) {
                vm.requests.title = translationId;
            });

            $translate('ROOMSCHEDULER.ROOM').then(function (translation) {
                vm.roomscheduler.room = translation;
            }, function (translationId) {
                vm.roomscheduler.room = translationId;
            });

            $translate('ROOMSCHEDULERDETAIL.USERCHECKOUTOK').then(function (translation) {
                vm.roomschedulerdetail.usercheckoutok = translation;
            }, function (translationId) {
                vm.roomschedulerdetail.usercheckoutok = translationId;
            });

            $translate('ROOMSCHEDULERDETAIL.DATESUPDATE').then(function (translation) {
                vm.roomschedulerdetail.datesUpdate = translation;
            }, function (translationId) {
                vm.roomschedulerdetail.datesUpdate = translationId;
            });

            $translate('ROOMSCHEDULERDETAIL.DELETERESERVATION').then(function (translation) {
                vm.roomschedulerdetail.deleteReservation = translation;
            }, function (translationId) {
                vm.roomschedulerdetail.deleteReservation = translationId;
            });

            $translate('ROOMSCHEDULERDETAIL.PEOPLELIST').then(function (translation) {
                vm.roomschedulerdetail.peopleList = translation;
            }, function (translationId) {
                vm.roomschedulerdetail.peopleList = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.COUNTRY').then(function (translation) {
                vm.residents.country = translation;
            }, function (translationId) {
                vm.residents.country = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.BILLING.MANYCONCEPTS').then(function (translation) {
                vm.residents.billing.manyConcepts = translation;
            }, function (translationId) {
                vm.residents.billing.manyConcepts = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.INVALIDAWAYDATES').then(function (translation) {
                vm.resident.invalidawaydates = translation;
            }, function (translationId) {
                vm.resident.invalidawaydates = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.MENUDELIVERED').then(function (translation) {
                vm.resident.menudelivered = translation;
            }, function (translationId) {
                vm.resident.menudelivered = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.STATE').then(function (translation) {
                vm.residents.state = translation;
            }, function (translationId) {
                vm.residents.state = translationId;
            });

            $translate('INCIDENCESCHART.CLOSED').then(function (translation) {
                vm.incidencesChart.closed = translation;
            }, function (translationId) {
                vm.incidencesChart.closed = translationId;
            });
            $translate('INCIDENCESCHART.OPENED').then(function (translation) {
                vm.incidencesChart.opened = translation;
            }, function (translationId) {
                vm.incidencesChart.opened = translationId;
            });
            $translate('INCIDENCESCHART.UNITS.TIME').then(function (translation) {
                vm.incidencesChart.units.time = translation;
            }, function (translationId) {
                vm.incidencesChart.units.time = translationId;
            });
            $translate('INCIDENCESCHART.UNITS.INCIDENCE').then(function (translation) {
                vm.incidencesChart.units.incidence = translation;
            }, function (translationId) {
                vm.incidencesChart.units.incidence = translationId;
            });
            $translate('INCIDENCESCHART.OCCUPATIONABBREV').then(function (translation) {
                vm.incidencesChart.occupationAbbrev = translation;
            }, function (translationId) {
                vm.incidencesChart.occupationAbbrev = translationId;
            });
            $translate('INCIDENCESCHART.TOTALOCCUPATION').then(function (translation) {
                vm.incidencesChart.totalOccupation = translation;
            }, function (translationId) {
                vm.incidencesChart.totalOccupation = translationId;
            });
            $translate('INCIDENCESCHART.OCCUPATION').then(function (translation) {
                vm.incidencesChart.occupation = translation;
            }, function (translationId) {
                vm.incidencesChart.occupation = translationId;
            });
            $translate('INCIDENCESCHART.TIMEFOR').then(function (translation) {
                vm.incidencesChart.timeFor = translation;
            }, function (translationId) {
                vm.incidencesChart.timeFor = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESHIGH').then(function (translation) {
                vm.incidencesChart.incidencesHigh = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesHigh = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESHIGHABBREV').then(function (translation) {
                vm.incidencesChart.incidencesHighAbbrev = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesHighAbbrev = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESNORMAL').then(function (translation) {
                vm.incidencesChart.incidencesNormal = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesNormal = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESNORMALABBREV').then(function (translation) {
                vm.incidencesChart.incidencesNormalAbbrev = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesNormalAbbrev = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESTIMEOUT').then(function (translation) {
                vm.incidencesChart.incidencesTimeOut = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesTimeOut = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESTIMEOUTABBREV').then(function (translation) {
                vm.incidencesChart.incidencesTimeOutAbbrev = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesTimeOutAbbrev = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESTOTAL').then(function (translation) {
                vm.incidencesChart.incidencesTotal = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesTotal = translationId;
            });
            $translate('INCIDENCESCHART.INCIDENCESTOTALABBREV').then(function (translation) {
                vm.incidencesChart.incidencesTotalAbbrev = translation;
            }, function (translationId) {
                vm.incidencesChart.incidencesTotalAbbrev = translationId;
            });
            $translate('CHART.LABEL.OCCUPATION').then(function (translation) {
                vm.chart.label.occupation = translation;
            }, function (translationId) {
                vm.chart.label.occupation = translationId;
            });
            $translate('CHART.LABEL.RESERVATION').then(function (translation) {
                vm.chart.label.reservation = translation;
            }, function (translationId) {
                vm.chart.label.reservation = translationId;
            });
            $translate('CHART.LABEL.SERVICIO').then(function (translation) {
                vm.chart.label.service = translation;
            }, function (translationId) {
                vm.chart.label.service = translationId;
            });
            $translate('CHART.WEEKLY').then(function (translation) {
                vm.chart.weekly = translation;
            }, function (translationId) {
                vm.chart.weekly = translationId;
            });
            $translate('CHART.MONTHLY').then(function (translation) {
                vm.chart.monthly = translation;
            }, function (translationId) {
                vm.chart.monthly = translationId;
            });
            $translate('MODAL.RENEWPASSWORD.SUCESS').then(function (translation) {
                vm.modal.renewPassword.sucess = translation;
            }, function (translationId) {
                vm.modal.renewPassword.sucess = translationId;
            });
            $translate('MODAL.RENEWPASSWORD.TITLE').then(function (translation) {
                vm.modal.renewPassword.title = translation;
            }, function (translationId) {
                vm.modal.renewPassword.title = translationId;
            });

            //INCIDENTS TOUR
            $translate('TOUR.INCIDENTS.TITLE').then(function (translation) {
                vm.tour.incidents.title = translation;
            }, function (translationId) {
                vm.tour.incidents.title = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP0_WELCOME').then(function (translation) {
                vm.tour.incidents.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.incidents.step0Welcome = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP1_LIST').then(function (translation) {
                vm.tour.incidents.step1List = translation;
            }, function (translationId) {
                vm.tour.incidents.step1List = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP2_FILTERS').then(function (translation) {
                vm.tour.incidents.step2Filters = translation;
            }, function (translationId) {
                vm.tour.incidents.step2Filters = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP3_PRIORITYCOLUMN').then(function (translation) {
                vm.tour.incidents.step3PriorityColumn = translation;
            }, function (translationId) {
                vm.tour.incidents.step3PriorityColumn = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP4_STATUSCOLUMN').then(function (translation) {
                vm.tour.incidents.step4StatusColumn = translation;
            }, function (translationId) {
                vm.tour.incidents.step4StatusColumn = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP5_ROW').then(function (translation) {
                vm.tour.incidents.step5TableRow = translation;
            }, function (translationId) {
                vm.tour.incidents.step5TableRow = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP6_TOTAL').then(function (translation) {
                vm.tour.incidents.step6TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.incidents.step6TableTotalItems = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP7_NEW').then(function (translation) {
                vm.tour.incidents.step7TableNewButton = translation;
            }, function (translationId) {
                vm.tour.incidents.step7TableNewButton = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP9_INCIDENTDETAIL').then(function (translation) {
                vm.tour.incidents.step9IncidentDetail = translation;
            }, function (translationId) {
                vm.tour.incidents.step9IncidentDetail = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP10_INCIDENTDETAILTOOLTIP').then(function (translation) {
                vm.tour.incidents.step10IncidentDetailTootlip = translation;
            }, function (translationId) {
                vm.tour.incidents.step10IncidentDetailTootlip = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP11_INCIDENTDETAILNAME').then(function (translation) {
                vm.tour.incidents.step11IncidentDetailName = translation;
            }, function (translationId) {
                vm.tour.incidents.step11IncidentDetailName = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP12_INCIDENTDETAILPRIORITY').then(function (translation) {
                vm.tour.incidents.step12IncidentDetailPriority = translation;
            }, function (translationId) {
                vm.tour.incidents.step12IncidentDetailPriority = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP13_INCIDENTDETAILIMG').then(function (translation) {
                vm.tour.incidents.step13IncidentDetailImg = translation;
            }, function (translationId) {
                vm.tour.incidents.step13IncidentDetailImg = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP14_INCIDENTDETAILSAVE').then(function (translation) {
                vm.tour.incidents.step14IncidentDetailSaveButton = translation;
            }, function (translationId) {
                vm.tour.incidents.step14IncidentDetailSaveButton = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP15_INCIDENTDETAILCANCEL').then(function (translation) {
                vm.tour.incidents.step15IncidentDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.incidents.step15IncidentDetailCancelButton = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP17_INCIDENTSFIRSTROW').then(function (translation) {
                vm.tour.incidents.step17IncidentFirstRow = translation;
            }, function (translationId) {
                vm.tour.incidents.step17IncidentFirstRow = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP19_INCIDENTDETAILLEFTCOL').then(function (translation) {
                vm.tour.incidents.step19IncidentDetailLeftCol = translation;
            }, function (translationId) {
                vm.tour.incidents.step19IncidentDetailLeftCol = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP20_INCIDENTDETAILRIGHTCOL').then(function (translation) {
                vm.tour.incidents.step20IncidentDetailRightCol = translation;
            }, function (translationId) {
                vm.tour.incidents.step20IncidentDetailRightCol = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP21_INCIDENTDETAILPUSH').then(function (translation) {
                vm.tour.incidents.step21IncidentDetailPush = translation;
            }, function (translationId) {
                vm.tour.incidents.step21IncidentDetailPush = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP22_TIMEOUT').then(function (translation) {
                vm.tour.incidents.step22Timeout = translation;
            }, function (translationId) {
                vm.tour.incidents.step22Timeout = translationId;
            });
            $translate('TOUR.INCIDENTS.STEP23_RESUMETOUR').then(function (translation) {
                vm.tour.incidents.step23ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.incidents.step23ResumeTourButton = translationId;
            });
            //INCIDENTS TOUR END

            //SERVICES TOUR
            $translate('TOUR.SERVICES.TITLE').then(function (translation) {
                vm.tour.services.title = translation;
            }, function (translationId) {
                vm.tour.services.title = translationId;
            });
            $translate('TOUR.SERVICES.STEP0_WELCOME').then(function (translation) {
                vm.tour.services.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.services.step0Welcome = translationId;
            });
            $translate('TOUR.SERVICES.STEP1_LIST').then(function (translation) {
                vm.tour.services.step1List = translation;
            }, function (translationId) {
                vm.tour.services.step1List = translationId;
            });
            $translate('TOUR.SERVICES.STEP2_SCHEDULER').then(function (translation) {
                vm.tour.services.step2Scheduler = translation;
            }, function (translationId) {
                vm.tour.services.step2Scheduler = translationId;
            });
            $translate('TOUR.SERVICES.STEP3_FILTERS').then(function (translation) {
                vm.tour.services.step3Filters = translation;
            }, function (translationId) {
                vm.tour.services.step3Filters = translationId;
            });

            $translate('TOUR.SERVICES.STEP4_ROW').then(function (translation) {
                vm.tour.services.step4TableRow = translation;
            }, function (translationId) {
                vm.tour.services.step4TableRow = translationId;
            });
            $translate('TOUR.SERVICES.STEP5_EDIT').then(function (translation) {
                vm.tour.services.step5TableEditButton = translation;
            }, function (translationId) {
                vm.tour.services.step5TableEditButton = translationId;
            });
            $translate('TOUR.SERVICES.STEP6_DELETE').then(function (translation) {
                vm.tour.services.step6TableDeleteButton = translation;
            }, function (translationId) {
                vm.tour.services.step6TableDeleteButton = translationId;
            });
            $translate('TOUR.SERVICES.STEP7_TOTAL').then(function (translation) {
                vm.tour.services.step7TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.services.step7TableTotalItems = translationId;
            });
            $translate('TOUR.SERVICES.STEP8_NEW').then(function (translation) {
                vm.tour.services.step8TableNewButton = translation;
            }, function (translationId) {
                vm.tour.services.step8TableNewButton = translationId;
            });
            $translate('TOUR.SERVICES.STEP10_SERVDETAIL').then(function (translation) {
                vm.tour.services.step10ServDetail = translation;
            }, function (translationId) {
                vm.tour.services.step10ServDetail = translationId;
            });
            $translate('TOUR.SERVICES.STEP11_SERVICEDETAILTOOLTIP').then(function (translation) {
                vm.tour.services.step11ServDetailTootlip = translation;
            }, function (translationId) {
                vm.tour.services.step11ServDetailTootlip = translationId;
            });
            $translate('TOUR.SERVICES.STEP12_SERVICEDETAILTIMETABLE').then(function (translation) {
                vm.tour.services.step12ServDetailTimetable = translation;
            }, function (translationId) {
                vm.tour.services.step12ServDetailTimetable = translationId;
            });
            $translate('TOUR.SERVICES.STEP13_SERVICEDETAILSAVE').then(function (translation) {
                vm.tour.services.step13ServDetailSaveButton = translation;
            }, function (translationId) {
                vm.tour.services.step13ServDetailSaveButton = translationId;
            });
            $translate('TOUR.SERVICES.STEP14_SERVICEDETAILCANCEL').then(function (translation) {
                vm.tour.services.step14ServDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.services.step14ServDetailCancelButton = translationId;
            });
            $translate('TOUR.SERVICES.STEP16_SERVICEFIRSTROW').then(function (translation) {
                vm.tour.services.step16ServFirstRow = translation;
            }, function (translationId) {
                vm.tour.services.step16ServFirstRow = translationId;
            });
            $translate('TOUR.SERVICES.STEP18_SERVICEDETAILPUSH').then(function (translation) {
                vm.tour.services.step18ServDetailPush = translation;
            }, function (translationId) {
                vm.tour.services.step18ServDetailPush = translationId;
            });
            $translate('TOUR.SERVICES.STEP20_RESUMETOUR').then(function (translation) {
                vm.tour.services.step20ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.services.step20ResumeTourButton = translationId;
            });
            //SERVICES TOUR END

            //WORKERTASK TOUR
            $translate('TOUR.WORKERTASK.TITLE').then(function (translation) {
                vm.tour.workerTask.title = translation;
            }, function (translationId) {
                vm.tour.workerTask.title = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP0_WELCOME').then(function (translation) {
                vm.tour.workerTask.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.workerTask.step0Welcome = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP1_LIST').then(function (translation) {
                vm.tour.workerTask.step1List = translation;
            }, function (translationId) {
                vm.tour.workerTask.step1List = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP2_SCHEDULER').then(function (translation) {
                vm.tour.workerTask.step2Scheduler = translation;
            }, function (translationId) {
                vm.tour.workerTask.step2Scheduler = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP3_FILTERS').then(function (translation) {
                vm.tour.workerTask.step3Filters = translation;
            }, function (translationId) {
                vm.tour.workerTask.step3Filters = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP4_ROW').then(function (translation) {
                vm.tour.workerTask.step4TableRow = translation;
            }, function (translationId) {
                vm.tour.workerTask.step4TableRow = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP5_EDIT').then(function (translation) {
                vm.tour.workerTask.step5TableEditButton = translation;
            }, function (translationId) {
                vm.tour.workerTask.step5TableEditButton = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP8_NEW').then(function (translation) {
                vm.tour.workerTask.step8TableNewButton = translation;
            }, function (translationId) {
                vm.tour.workerTask.step8TableNewButton = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP10_WORKERTASKDETAIL').then(function (translation) {
                vm.tour.workerTask.step10workerTaskDetail = translation;
            }, function (translationId) {
                vm.tour.workerTask.step10workerTaskDetail = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP11_WORKERTASKDETAILTOOLTIP').then(function (translation) {
                vm.tour.workerTask.step11workerTaskDetailTootlip = translation;
            }, function (translationId) {
                vm.tour.workerTask.step11workerTaskDetailTootlip = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP13_WORKERTASKDETAILSAVE').then(function (translation) {
                vm.tour.workerTask.step13workerTaskDetailSaveButton = translation;
            }, function (translationId) {
                vm.tour.workerTask.step13workerTaskDetailSaveButton = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP14_WORKERTASKDETAILCANCEL').then(function (translation) {
                vm.tour.workerTask.step14workerTaskDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.workerTask.step14workerTaskDetailCancelButton = translationId;
            });
            $translate('TOUR.WORKERTASK.STEP20_RESUMETOUR').then(function (translation) {
                vm.tour.workerTask.step20ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.workerTask.step20ResumeTourButton = translationId;
            });
            //SERVICES TOUR END

            //AGENDA TOUR
            $translate('TOUR.AGENDA.TITLE').then(function (translation) {
                vm.tour.agenda.title = translation;
            }, function (translationId) {
                vm.tour.agenda.title = translationId;
            });
            $translate('TOUR.AGENDA.STEP0_WELCOME').then(function (translation) {
                vm.tour.agenda.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.agenda.step0Welcome = translationId;
            });
            $translate('TOUR.AGENDA.STEP1_LIST').then(function (translation) {
                vm.tour.agenda.step1List = translation;
            }, function (translationId) {
                vm.tour.agenda.step1List = translationId;
            });
            $translate('TOUR.AGENDA.STEP2_FILTERS').then(function (translation) {
                vm.tour.agenda.step2Filters = translation;
            }, function (translationId) {
                vm.tour.agenda.step2Filters = translationId;
            });
            $translate('TOUR.AGENDA.STEP3_FOOTER').then(function (translation) {
                vm.tour.agenda.step3Footer = translation;
            }, function (translationId) {
                vm.tour.agenda.step3Footer = translationId;
            });
            $translate('TOUR.AGENDA.STEP4_ROW').then(function (translation) {
                vm.tour.agenda.step4TableRow = translation;
            }, function (translationId) {
                vm.tour.agenda.step4TableRow = translationId;
            });
            $translate('TOUR.AGENDA.STEP5_EDIT').then(function (translation) {
                vm.tour.agenda.step5TableEditButton = translation;
            }, function (translationId) {
                vm.tour.agenda.step5TableEditButton = translationId;
            });
            $translate('TOUR.AGENDA.STEP6_DELETE').then(function (translation) {
                vm.tour.agenda.step6TableDeleteButton = translation;
            }, function (translationId) {
                vm.tour.agenda.step6TableDeleteButton = translationId;
            });
            $translate('TOUR.AGENDA.STEP7_TOTAL').then(function (translation) {
                vm.tour.agenda.step7TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.agenda.step7TableTotalItems = translationId;
            });
            $translate('TOUR.AGENDA.STEP8_NEW').then(function (translation) {
                vm.tour.agenda.step8TableNewButton = translation;
            }, function (translationId) {
                vm.tour.agenda.step8TableNewButton = translationId;
            });
            $translate('TOUR.AGENDA.STEP10_AGENDADETAIL').then(function (translation) {
                vm.tour.agenda.step10AgendaDetail = translation;
            }, function (translationId) {
                vm.tour.agenda.step10AgendaDetail = translationId;
            });
            $translate('TOUR.AGENDA.STEP11_AGENDADETAILTOOLTIP').then(function (translation) {
                vm.tour.agenda.step11AgendaDetailTootlip = translation;
            }, function (translationId) {
                vm.tour.agenda.step11AgendaDetailTootlip = translationId;
            });
            $translate('TOUR.AGENDA.STEP12_AGENDADETAILVISIBLETO').then(function (translation) {
                vm.tour.agenda.step12AgendaDetailVisible = translation;
            }, function (translationId) {
                vm.tour.agenda.step12AgendaDetailVisible = translationId;
            });
            $translate('TOUR.AGENDA.STEP13_AGENDADETAILLIMITDATE').then(function (translation) {
                vm.tour.agenda.step13AgendaDetailLimitDate = translation;
            }, function (translationId) {
                vm.tour.agenda.step13AgendaDetailLimitDate = translationId;
            });
            $translate('TOUR.AGENDA.STEP14_AGENDADETAILSAVE').then(function (translation) {
                vm.tour.agenda.step14AgendaDetailSaveButton = translation;
            }, function (translationId) {
                vm.tour.agenda.step14AgendaDetailSaveButton = translationId;
            });
            $translate('TOUR.AGENDA.STEP15_AGENDADETAILCANCEL').then(function (translation) {
                vm.tour.agenda.step15AgendaDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.agenda.step15AgendaDetailCancelButton = translationId;
            });
            $translate('TOUR.AGENDA.STEP17_RESUMETOUR').then(function (translation) {
                vm.tour.agenda.step17ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.agenda.step17ResumeTourButton = translationId;
            });
            //AGENDA TOUR END

            //USERS TOUR
            $translate('TOUR.USERS.TITLE').then(function (translation) {
                vm.tour.users.title = translation;
            }, function (translationId) {
                vm.tour.users.title = translationId;
            });
            $translate('TOUR.USERS.STEP0_WELCOME').then(function (translation) {
                vm.tour.users.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.users.step0Welcome = translationId;
            });
            $translate('TOUR.USERS.STEP1_LIST').then(function (translation) {
                vm.tour.users.step1List = translation;
            }, function (translationId) {
                vm.tour.users.step1List = translationId;
            });
            $translate('TOUR.USERS.STEP2_FILTERS').then(function (translation) {
                vm.tour.users.step2Filters = translation;
            }, function (translationId) {
                vm.tour.users.step2Filters = translationId;
            });
            $translate('TOUR.USERS.STEP3_FOOTER').then(function (translation) {
                vm.tour.users.step3Footer = translation;
            }, function (translationId) {
                vm.tour.users.step3Footer = translationId;
            });
            $translate('TOUR.USERS.STEP4_ROW').then(function (translation) {
                vm.tour.users.step4TableRow = translation;
            }, function (translationId) {
                vm.tour.users.step4TableRow = translationId;
            });
            $translate('TOUR.USERS.STEP5_EDIT').then(function (translation) {
                vm.tour.users.step5TableEditButton = translation;
            }, function (translationId) {
                vm.tour.users.step5TableEditButton = translationId;
            });
            $translate('TOUR.USERS.STEP6_DELETE').then(function (translation) {
                vm.tour.users.step6TableDeleteButton = translation;
            }, function (translationId) {
                vm.tour.users.step6TableDeleteButton = translationId;
            });
            $translate('TOUR.USERS.STEP7_TOTAL').then(function (translation) {
                vm.tour.users.step7TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.users.step7TableTotalItems = translationId;
            });
            $translate('TOUR.USERS.STEP8_NEW').then(function (translation) {
                vm.tour.users.step8TableNewButton = translation;
            }, function (translationId) {
                vm.tour.users.step8TableNewButton = translationId;
            });
            $translate('TOUR.USERS.STEP10_USERSDETAIL').then(function (translation) {
                vm.tour.users.step10UsersDetail = translation;
            }, function (translationId) {
                vm.tour.users.step10UsersDetail = translationId;
            });
            $translate('TOUR.USERS.STEP11_USERSDETAILIMAGE').then(function (translation) {
                vm.tour.users.step11UsersDetailImage = translation;
            }, function (translationId) {
                vm.tour.users.step11UsersDetailImage = translationId;
            });
            $translate('TOUR.USERS.STEP12_USERSDETAILRESIDENCIAS').then(function (translation) {
                vm.tour.users.step12UsersDetailResidencias = translation;
            }, function (translationId) {
                vm.tour.users.step12UsersDetailResidencias = translationId;
            });
            $translate('TOUR.USERS.STEP13_USERSDETAILTOOLTIP').then(function (translation) {
                vm.tour.users.step13UsersDetailTootlip = translation;
            }, function (translationId) {
                vm.tour.users.step13UsersDetailTootlip = translationId;
            });
            $translate('TOUR.USERS.STEP14_USERSETAILEMAIL').then(function (translation) {
                vm.tour.users.step14UsersDetailEmail = translation;
            }, function (translationId) {
                vm.tour.users.step14UsersDetailEmail = translationId;
            });
            $translate('TOUR.USERS.STEP15_USERSDETAILSAVE').then(function (translation) {
                vm.tour.users.step15UsersDetailSaveButton = translation;
            }, function (translationId) {
                vm.tour.users.step15UsersDetailSaveButton = translationId;
            });
            $translate('TOUR.USERS.STEP16_USERSDETAILCANCEL').then(function (translation) {
                vm.tour.users.step16UsersDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.users.step16UsersDetailCancelButton = translationId;
            });
            $translate('TOUR.USERS.STEP18_RESUMETOUR').then(function (translation) {
                vm.tour.users.step18ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.users.step18ResumeTourButton = translationId;
            });
            //USERS TOUR END

            //ACCESSAPP TOUR
            $translate('TOUR.ACCESSAPP.TITLE').then(function (translation) {
                vm.tour.accessapp.title = translation;
            }, function (translationId) {
                vm.tour.accessapp.title = translationId;
            });
            $translate('TOUR.ACCESSAPP.STEP0_WELCOME').then(function (translation) {
                vm.tour.accessapp.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.accessapp.step0Welcome = translationId;
            });
            $translate('TOUR.ACCESSAPP.STEP1_ACCESSAPPDETAIL').then(function (translation) {
                vm.tour.accessapp.step1AccessappDetail = translation;
            }, function (translationId) {
                vm.tour.accessapp.step1AccessappDetail = translationId;
            });
            $translate('TOUR.ACCESSAPP.STEP2_ACCESSAPPDETAILDATA').then(function (translation) {
                vm.tour.accessapp.step2AccessappDetailData = translation;
            }, function (translationId) {
                vm.tour.accessapp.step2AccessappDetailData = translationId;
            });
            $translate('TOUR.ACCESSAPP.STEP3_ACCESSAPPDETAILRESIDENTS').then(function (translation) {
                vm.tour.accessapp.step3AccessappDetailResidents = translation;
            }, function (translationId) {
                vm.tour.accessapp.step3AccessappDetailResidents = translationId;
            });
            $translate('TOUR.ACCESSAPP.STEP4_ACCESSAPPDETAILSAVE').then(function (translation) {
                vm.tour.accessapp.step4AccessappDetailSaveButton = translation;
            }, function (translationId) {
                vm.tour.accessapp.step4AccessappDetailSaveButton = translationId;
            });
            $translate('TOUR.ACCESSAPP.STEP5_ACCESSAPPDETAILCANCEL').then(function (translation) {
                vm.tour.accessapp.step5AccessappDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.accessapp.step5AccessappDetailCancelButton = translationId;
            });
            //ACCESSAPP TOUR END

            //MENU TOUR
            $translate('TOUR.MENU.TITLE').then(function (translation) {
                vm.tour.menu.title = translation;
            }, function (translationId) {
                vm.tour.menu.title = translationId;
            });
            $translate('TOUR.MENU.STEP0_WELCOME').then(function (translation) {
                vm.tour.menu.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.menu.step0Welcome = translationId;
            });
            $translate('TOUR.MENU.STEP1_LIST').then(function (translation) {
                vm.tour.menu.step1List = translation;
            }, function (translationId) {
                vm.tour.menu.step1List = translationId;
            });
            $translate('TOUR.MENU.STEP2_FILTERS').then(function (translation) {
                vm.tour.menu.step2Filters = translation;
            }, function (translationId) {
                vm.tour.menu.step2Filters = translationId;
            });
            $translate('TOUR.MENU.STEP3_COMMENTS').then(function (translation) {
                vm.tour.menu.step3Comments = translation;
            }, function (translationId) {
                vm.tour.menu.step3Comments = translationId;
            });
            $translate('TOUR.MENU.STEP4_STATUSCOLUMN').then(function (translation) {
                vm.tour.menu.step4StatusColumn = translation;
            }, function (translationId) {
                vm.tour.menu.step4StatusColumn = translationId;
            });
            $translate('TOUR.MENU.STEP5_ROW').then(function (translation) {
                vm.tour.menu.step5TableRow = translation;
            }, function (translationId) {
                vm.tour.menu.step5TableRow = translationId;
            });
            $translate('TOUR.MENU.STEP6_TOTAL').then(function (translation) {
                vm.tour.menu.step6TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.menu.step6TableTotalItems = translationId;
            });
            $translate('TOUR.MENU.STEP7_NEW').then(function (translation) {
                vm.tour.menu.step7TableNewButton = translation;
            }, function (translationId) {
                vm.tour.menu.step7TableNewButton = translationId;
            });
            $translate('TOUR.MENU.STEP9_MENUDETAIL').then(function (translation) {
                vm.tour.menu.step9MenuDetail = translation;
            }, function (translationId) {
                vm.tour.menu.step9MenuDetail = translationId;
            });
            $translate('TOUR.MENU.STEP10_MENUDETAILDATEFROM').then(function (translation) {
                vm.tour.menu.step10MenuDetailDateFrom = translation;
            }, function (translationId) {
                vm.tour.menu.step10MenuDetailDateFrom = translationId;
            });
            $translate('TOUR.MENU.STEP11_MENUDETAILDATETO').then(function (translation) {
                vm.tour.menu.step11MenuDetailDateTo = translation;
            }, function (translationId) {
                vm.tour.menu.step11MenuDetailDateTo = translationId;
            });
            $translate('TOUR.MENU.STEP12_MENUDETAILPLACE').then(function (translation) {
                vm.tour.menu.step12MenuDetailPlace = translation;
            }, function (translationId) {
                vm.tour.menu.step12MenuDetailPlace = translationId;
            });
            $translate('TOUR.MENU.STEP13_MENUDETAILTYPE').then(function (translation) {
                vm.tour.menu.step13MenuDetailType = translation;
            }, function (translationId) {
                vm.tour.menu.step13MenuDetailType = translationId;
            });
            $translate('TOUR.MENU.STEP14_MENUDETAILRESERVE').then(function (translation) {
                vm.tour.menu.step14MenuDetailReserve = translation;
            }, function (translationId) {
                vm.tour.menu.step14MenuDetailReserve = translationId;
            });
            $translate('TOUR.MENU.STEP15_MENUDETAILPENDING').then(function (translation) {
                vm.tour.menu.step15MenuDetailPending = translation;
            }, function (translationId) {
                vm.tour.menu.step15MenuDetailPending = translationId;
            });
            $translate('TOUR.MENU.STEP16_MENUDETAILGROUPINPUTS').then(function (translation) {
                vm.tour.menu.step16MenuDetailGroupInputs = translation;
            }, function (translationId) {
                vm.tour.menu.step16MenuDetailGroupInputs = translationId;
            });
            $translate('TOUR.MENU.STEP17_MENUDETAILPLUSDISH').then(function (translation) {
                vm.tour.menu.step17MenuDetailPlusDish = translation;
            }, function (translationId) {
                vm.tour.menu.step17MenuDetailPlusDish = translationId;
            });
            $translate('TOUR.MENU.STEP19_MENUSELECTSEARCH').then(function (translation) {
                vm.tour.menu.step19MenuSelectSearch = translation;
            }, function (translationId) {
                vm.tour.menu.step19MenuSelectSearch = translationId;
            });
            $translate('TOUR.MENU.STEP20_MENUSELECTTYPE').then(function (translation) {
                vm.tour.menu.step20MenuSelectType = translation;
            }, function (translationId) {
                vm.tour.menu.step20MenuSelectType = translationId;
            });
            $translate('TOUR.MENU.STEP21_MENUSELECTALLERGEN').then(function (translation) {
                vm.tour.menu.step21MenuSelectAllergen = translation;
            }, function (translationId) {
                vm.tour.menu.step21MenuSelectAllergen = translationId;
            });
            $translate('TOUR.MENU.STEP22_MENUSELECTDISH').then(function (translation) {
                vm.tour.menu.step22MenuSelectDish = translation;
            }, function (translationId) {
                vm.tour.menu.step22MenuSelectDish = translationId;
            });
            $translate('TOUR.MENU.STEP23_MENUSELECTEDIT').then(function (translation) {
                vm.tour.menu.step23MenuSelectEdit = translation;
            }, function (translationId) {
                vm.tour.menu.step23MenuSelectEdit = translationId;
            });
            $translate('TOUR.MENU.STEP24_MENUSELECTNEWBUTTON').then(function (translation) {
                vm.tour.menu.step24MenuSelectNewButton = translation;
            }, function (translationId) {
                vm.tour.menu.step24MenuSelectNewButton = translationId;
            });
            $translate('TOUR.MENU.STEP26_MENUNEWDISHIMG').then(function (translation) {
                vm.tour.menu.step26MenuNewDishImg = translation;
            }, function (translationId) {
                vm.tour.menu.step26MenuNewDishImg = translationId;
            });
            $translate('TOUR.MENU.STEP27_MENUNEWDISHTYPE').then(function (translation) {
                vm.tour.menu.step27MenuNewDishType = translation;
            }, function (translationId) {
                vm.tour.menu.step27MenuNewDishType = translationId;
            });
            $translate('TOUR.MENU.STEP28_MENUNEWDISHALLERGEN').then(function (translation) {
                vm.tour.menu.step28MenuNewDishAllergen = translation;
            }, function (translationId) {
                vm.tour.menu.step28MenuNewDishAllergen = translationId;
            });
            $translate('TOUR.MENU.STEP29_MENUNEWDISHTITLE').then(function (translation) {
                vm.tour.menu.step29MenuNewDishTitle = translation;
            }, function (translationId) {
                vm.tour.menu.step29MenuNewDishTitle = translationId;
            });
            $translate('TOUR.MENU.STEP30_MENUNEWDISHKAL').then(function (translation) {
                vm.tour.menu.step30MenuNewDishKal = translation;
            }, function (translationId) {
                vm.tour.menu.step30MenuNewDishKal = translationId;
            });
            $translate('TOUR.MENU.STEP31_MENUNEWDISHTAGS').then(function (translation) {
                vm.tour.menu.step31MenuNewDishTags = translation;
            }, function (translationId) {
                vm.tour.menu.step31MenuNewDishTags = translationId;
            });
            $translate('TOUR.MENU.STEP32_MENUNEWDISHSAVE').then(function (translation) {
                vm.tour.menu.step32MenuNewDishSave = translation;
            }, function (translationId) {
                vm.tour.menu.step32MenuNewDishSave = translationId;
            });
            $translate('TOUR.MENU.STEP33_MENUNEWDISHBACK').then(function (translation) {
                vm.tour.menu.step33MenuNewDishBack = translation;
            }, function (translationId) {
                vm.tour.menu.step33MenuNewDishBack = translationId;
            });
            $translate('TOUR.MENU.STEP35_MENUSELECTADDDISH').then(function (translation) {
                vm.tour.menu.step35MenuSelectAddDish = translation;
            }, function (translationId) {
                vm.tour.menu.step35MenuSelectAddDish = translationId;
            });
            $translate('TOUR.MENU.STEP37_MENUSELECTBACK').then(function (translation) {
                vm.tour.menu.step37MenuSelectBack = translation;
            }, function (translationId) {
                vm.tour.menu.step37MenuSelectBack = translationId;
            });
            $translate('TOUR.MENU.STEP39_MENUDETAILFIRSTDISH').then(function (translation) {
                vm.tour.menu.step39MenuDetailFirstDish = translation;
            }, function (translationId) {
                vm.tour.menu.step39MenuDetailFirstDish = translationId;
            });
            $translate('TOUR.MENU.STEP40_MENUDETAILADDSECOND').then(function (translation) {
                vm.tour.menu.step40MenuDetailAddSecond = translation;
            }, function (translationId) {
                vm.tour.menu.step40MenuDetailAddSecond = translationId;
            });
            $translate('TOUR.MENU.STEP41_MENUDETAILADDDESSERT').then(function (translation) {
                vm.tour.menu.step41MenuDetailAddDessert = translation;
            }, function (translationId) {
                vm.tour.menu.step41MenuDetailAddDessert = translationId;
            });
            $translate('TOUR.MENU.STEP42_MENUDETAILEDIT').then(function (translation) {
                vm.tour.menu.step42MenuDetailEdit = translation;
            }, function (translationId) {
                vm.tour.menu.step42MenuDetailEdit = translationId;
            });
            $translate('TOUR.MENU.STEP42_MENUDETAILPRINTREPORT').then(function (translation) {
                vm.tour.menu.step42MenuDetailPrintReport = translation;
            }, function (translationId) {
                vm.tour.menu.step42MenuDetailPrintReport = translationId;
            });
            $translate('TOUR.MENU.STEP43_MENUDETAILSAVE').then(function (translation) {
                vm.tour.menu.step43MenuDetailSave = translation;
            }, function (translationId) {
                vm.tour.menu.step43MenuDetailSave = translationId;
            });
            $translate('TOUR.MENU.STEP44_MENUDETAILBACK').then(function (translation) {
                vm.tour.menu.step44MenuDetailBack = translation;
            }, function (translationId) {
                vm.tour.menu.step44MenuDetailBack = translationId;
            });
            $translate('TOUR.MENU.STEP46_RESUMETOUR').then(function (translation) {
                vm.tour.menu.step46ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.menu.step46ResumeTourButton = translationId;
            });
            //MENU TOUR END

            //ANNOUNCEMENTS TOUR
            $translate('TOUR.ANNOUNCEMENTS.TITLE').then(function (translation) {
                vm.tour.announcements.title = translation;
            }, function (translationId) {
                vm.tour.announcements.title = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP0_WELCOME').then(function (translation) {
                vm.tour.announcements.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.announcements.step0Welcome = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP1_LIST').then(function (translation) {
                vm.tour.announcements.step1List = translation;
            }, function (translationId) {
                vm.tour.announcements.step1List = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP2_FILTERS').then(function (translation) {
                vm.tour.announcements.step2Filters = translation;
            }, function (translationId) {
                vm.tour.announcements.step2Filters = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP3_RELATEDCOLUMN').then(function (translation) {
                vm.tour.announcements.step3RelatedColumn = translation;
            }, function (translationId) {
                vm.tour.announcements.step3RelatedColumn = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP4_PUSHCOLUMN').then(function (translation) {
                vm.tour.announcements.step4PushColumn = translation;
            }, function (translationId) {
                vm.tour.announcements.step4PushColumn = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP5_ROW').then(function (translation) {
                vm.tour.announcements.step5TableRow = translation;
            }, function (translationId) {
                vm.tour.announcements.step5TableRow = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP6_TOTAL').then(function (translation) {
                vm.tour.announcements.step6TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.announcements.step6TableTotalItems = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP7_NEW').then(function (translation) {
                vm.tour.announcements.step7TableNewButton = translation;
            }, function (translationId) {
                vm.tour.announcements.step7TableNewButton = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP9_ANNOUNCEMENTDETAIL').then(function (translation) {
                vm.tour.announcements.step9AnnouncementDetail = translation;
            }, function (translationId) {
                vm.tour.announcements.step9AnnouncementDetail = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP10_ANNOUNCEMENTDETAILPLACES').then(function (translation) {
                vm.tour.announcements.step10AnnouncementDetailPlaces = translation;
            }, function (translationId) {
                vm.tour.announcements.step10AnnouncementDetailPlaces = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP11_ANNOUNCEMENTDETAILGLOBAL').then(function (translation) {
                vm.tour.announcements.step11AnnouncementDetailGlobal = translation;
            }, function (translationId) {
                vm.tour.announcements.step11AnnouncementDetailGlobal = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP12_ANNOUNCEMENTDETAILRESIDENTS').then(function (translation) {
                vm.tour.announcements.step12AnnouncementDetailResidents = translation;
            }, function (translationId) {
                vm.tour.announcements.step12AnnouncementDetailResidents = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP13_ANNOUNCEMENTDETAILTITLE').then(function (translation) {
                vm.tour.announcements.step13AnnouncementDetailTitle = translation;
            }, function (translationId) {
                vm.tour.announcements.step13AnnouncementDetailTitle = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP14_ANNOUNCEMENTDETAILBODY').then(function (translation) {
                vm.tour.announcements.step14AnnouncementDetailBody = translation;
            }, function (translationId) {
                vm.tour.announcements.step14AnnouncementDetailBody = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP15_ANNOUNCEMENTDETAILPUSH').then(function (translation) {
                vm.tour.announcements.step15AnnouncementDetailPush = translation;
            }, function (translationId) {
                vm.tour.announcements.step15AnnouncementDetailPush = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP16_ANNOUNCEMENTDETAILCANCEL').then(function (translation) {
                vm.tour.announcements.step16AnnouncementDetailCancel = translation;
            }, function (translationId) {
                vm.tour.announcements.step16AnnouncementDetailCancel = translationId;
            });
            $translate('TOUR.ANNOUNCEMENTS.STEP18_RESUMETOUR').then(function (translation) {
                vm.tour.announcements.step18ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.announcements.step18ResumeTourButton = translationId;
            });
            //ANNOUNCEMENTS TOUR END

            //RESIDENTS TOUR
            $translate('TOUR.RESIDENTS.TITLE').then(function (translation) {
                vm.tour.residents.title = translation;
            }, function (translationId) {
                vm.tour.residents.title = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP0_WELCOME').then(function (translation) {
                vm.tour.residents.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.residents.step0Welcome = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP1_LIST').then(function (translation) {
                vm.tour.residents.step1List = translation;
            }, function (translationId) {
                vm.tour.residents.step1List = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP2_FILTERS').then(function (translation) {
                vm.tour.residents.step2Filters = translation;
            }, function (translationId) {
                vm.tour.residents.step2Filters = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP3_DELEGATECOLUMN').then(function (translation) {
                vm.tour.residents.step3DelColumn = translation;
            }, function (translationId) {
                vm.tour.residents.step3DelColumn = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP3_RESIDENTCOLUMN').then(function (translation) {
                vm.tour.residents.step3ResColumn = translation;
            }, function (translationId) {
                vm.tour.residents.step3ResColumn = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP3_ABSENTCOLUMN').then(function (translation) {
                vm.tour.residents.step3AbsentColumn = translation;
            }, function (translationId) {
                vm.tour.residents.step3AbsentColumn = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP3_APPCOLUMN').then(function (translation) {
                vm.tour.residents.step3AppColumn = translation;
            }, function (translationId) {
                vm.tour.residents.step3AppColumn = translationId;
            });

            $translate('TOUR.RESIDENTS.STEP4_ROW').then(function (translation) {
                vm.tour.residents.step4TableRow = translation;
            }, function (translationId) {
                vm.tour.residents.step4TableRow = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP5_EDIT').then(function (translation) {
                vm.tour.residents.step5TableEditButton = translation;
            }, function (translationId) {
                vm.tour.residents.step5TableEditButton = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP6_DELETE').then(function (translation) {
                vm.tour.residents.step6TableDeleteButton = translation;
            }, function (translationId) {
                vm.tour.residents.step6TableDeleteButton = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP7_TOTAL').then(function (translation) {
                vm.tour.residents.step7TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.residents.step7TableTotalItems = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP8_NEW').then(function (translation) {
                vm.tour.residents.step8TableNewButton = translation;
            }, function (translationId) {
                vm.tour.residents.step8TableNewButton = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP10_RESIDENTDETAIL').then(function (translation) {
                vm.tour.residents.step10ResidentDetail = translation;
            }, function (translationId) {
                vm.tour.residents.step10ResidentDetail = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP11_RESIDENTDETAILIMG').then(function (translation) {
                vm.tour.residents.step11ResidentDetailImg = translation;
            }, function (translationId) {
                vm.tour.residents.step11ResidentDetailImg = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP12_RESIDENTDETAILTOOLTIP').then(function (translation) {
                vm.tour.residents.step12ResidentDetailTooltip = translation;
            }, function (translationId) {
                vm.tour.residents.step12ResidentDetailTooltip = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP13_RESIDENTDETAILIDENTIFICATION').then(function (translation) {
                vm.tour.residents.step13ResidentDetailIdentification = translation;
            }, function (translationId) {
                vm.tour.residents.step13ResidentDetailIdentification = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP14_RESIDENTDETAILSTAYS').then(function (translation) {
                vm.tour.residents.step14ResidentDetailStays = translation;
            }, function (translationId) {
                vm.tour.residents.step14ResidentDetailStays = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP15_RESIDENTDETAILCANCEL').then(function (translation) {
                vm.tour.residents.step15ResidentDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.residents.step15ResidentDetailCancelButton = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP17_RESUMETOUR').then(function (translation) {
                vm.tour.residents.step17ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.residents.step17ResumeTourButton = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP11_RESIDENTDETAILROOM').then(function (translation) {
                vm.tour.residents.step17ResidentDetailRoom = translation;
            }, function (translationId) {
                vm.tour.residents.step17ResidentDetailRoom = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP14_RESIDENTDETAILCONTACT').then(function (translation) {
                vm.tour.residents.step17ResidentDetailContactInfo = translation;
            }, function (translationId) {
                vm.tour.residents.step17ResidentDetailContactInfo = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP14_RESIDENTDETAILOTHERINFO').then(function (translation) {
                vm.tour.residents.step17ResidentDetailOtherInfo = translation;
            }, function (translationId) {
                vm.tour.residents.step17ResidentDetailOtherInfo = translationId;
            });
            $translate('TOUR.RESIDENTS.STEP14_RESIDENTDETAILHISTORY').then(function (translation) {
                vm.tour.residents.step17ResidentDetailHistory = translation;
            }, function (translationId) {
                vm.tour.residents.step17ResidentDetailHistory = translationId;
            });
            //RESIDENTS TOUR END

            //BULLETIN TOUR
            $translate('TOUR.BULLETINBOARD.TITLE').then(function (translation) {
                vm.tour.bulletinBoard.title = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.title = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP0_WELCOME').then(function (translation) {
                vm.tour.bulletinBoard.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step0Welcome = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP1_LIST').then(function (translation) {
                vm.tour.bulletinBoard.step1List = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step1List = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP2_FILTERS').then(function (translation) {
                vm.tour.bulletinBoard.step2Filters = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step2Filters = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP3_ROW').then(function (translation) {
                vm.tour.bulletinBoard.step3TableRow = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step3TableRow = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP4_EDIT').then(function (translation) {
                vm.tour.bulletinBoard.step4TableEditButton = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step4TableEditButton = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP5_DELETE').then(function (translation) {
                vm.tour.bulletinBoard.step5TableDeleteButton = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step5TableDeleteButton = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP6_TOTAL').then(function (translation) {
                vm.tour.bulletinBoard.step6TableTotalItems = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step6TableTotalItems = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP7_NEW').then(function (translation) {
                vm.tour.bulletinBoard.step7TableNewButton = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step7TableNewButton = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP9_BULLETINDETAIL').then(function (translation) {
                vm.tour.bulletinBoard.step9BulletinDetail = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step9BulletinDetail = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP10_BULLETINDETAILIMG').then(function (translation) {
                vm.tour.bulletinBoard.step10BulletinDetailImg = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step10BulletinDetailImg = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP11_BULLETINDETAILHIGHLIGHT').then(function (translation) {
                vm.tour.bulletinBoard.step11BulletinDetailHighlight = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step11BulletinDetailHighlight = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP12_BULLETINDETAILTOOLTIP').then(function (translation) {
                vm.tour.bulletinBoard.step12BulletinDetailTooltip = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step12BulletinDetailTooltip = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP13_BULLETINDETAILVISIBLEFROM').then(function (translation) {
                vm.tour.bulletinBoard.step13BulletinDetailVisibleFrom = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step13BulletinDetailVisibleFrom = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP14_BULLETINDETAILVISIBLETO').then(function (translation) {
                vm.tour.bulletinBoard.step14BulletinDetailVisibleTo = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step14BulletinDetailVisibleTo = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP15_BULLETINDETAILCANCEL').then(function (translation) {
                vm.tour.bulletinBoard.step15BulletinDetailCancelButton = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step15BulletinDetailCancelButton = translationId;
            });
            $translate('TOUR.BULLETINBOARD.STEP17_RESUMETOUR').then(function (translation) {
                vm.tour.bulletinBoard.step17ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.bulletinBoard.step17ResumeTourButton = translationId;
            });
            //BULLETIN TOUR END

            //DASHBOARD TOUR
            $translate('TOUR.DASHBOARD.WELCOME').then(function (translation) {
                vm.tour.dashboard.welcome = translation;
            }, function (translationId) {
                vm.tour.dashboard.welcome = translationId;
            });
            $translate('TOUR.DASHBOARD.TITLE').then(function (translation) {
                vm.tour.dashboard.title = translation;
            }, function (translationId) {
                vm.tour.dashboard.title = translationId;
            });
            $translate('TOUR.DASHBOARD.STEP1_MENU_D').then(function (translation) {
                vm.tour.dashboard.step1MenuD = translation;
            }, function (translationId) {
                vm.tour.dashboard.step1MenuD = translationId;
            });
            $translate('TOUR.DASHBOARD.STEP2_AVATAR_D').then(function (translation) {
                vm.tour.dashboard.step2AvatarD = translation;
            }, function (translationId) {
                vm.tour.dashboard.step2AvatarD = translationId;
            });
            $translate('TOUR.DASHBOARD.STEP3_MAINMENU_D').then(function (translation) {
                vm.tour.dashboard.step3MainmenuD = translation;
            }, function (translationId) {
                vm.tour.dashboard.step3MainmenuD = translationId;
            });
            $translate('TOUR.DASHBOARD.STEP4_BREADCRUM_D').then(function (translation) {
                vm.tour.dashboard.step4BreadcrumD = translation;
            }, function (translationId) {
                vm.tour.dashboard.step4BreadcrumD = translationId;
            });
            $translate('TOUR.DASHBOARD.STEP5_TOUR_D').then(function (translation) {
                vm.tour.dashboard.step5TourD = translation;
            }, function (translationId) {
                vm.tour.dashboard.step5TourD = translationId;
            });
            //DASHBOARD TOUR END

            // CHAT TOUR
            $translate('TOUR.CHAT.TITLE').then(function (translation) {
                vm.tour.chat.title = translation;
            }, function (translationId) {
                vm.tour.chat.title = translationId;
            });
            $translate('TOUR.CHAT.STEP0_WELCOME').then(function (translation) {
                vm.tour.chat.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.chat.step0Welcome = translationId;
            });
            $translate('TOUR.CHAT.STEP1_LIST').then(function (translation) {
                vm.tour.chat.step1List = translation;
            }, function (translationId) {
                vm.tour.chat.step1List = translationId;
            });
            $translate('TOUR.CHAT.STEP2_FILTERPLACE').then(function (translation) {
                vm.tour.chat.step2FilterPlace = translation;
            }, function (translationId) {
                vm.tour.chat.step2FilterPlace = translationId;
            });
            $translate('TOUR.CHAT.STEP3_FILTER').then(function (translation) {
                vm.tour.chat.step3Filter = translation;
            }, function (translationId) {
                vm.tour.chat.step3Filter = translationId;
            });
            $translate('TOUR.CHAT.STEP4_ROW').then(function (translation) {
                vm.tour.chat.step4Row = translation;
            }, function (translationId) {
                vm.tour.chat.step4Row = translationId;
            });
            $translate('TOUR.CHAT.STEP5_EDIT').then(function (translation) {
                vm.tour.chat.step5Edit = translation;
            }, function (translationId) {
                vm.tour.chat.step5Edit = translationId;
            });
            $translate('TOUR.CHAT.STEP6_DELETE').then(function (translation) {
                vm.tour.chat.step6Delete = translation;
            }, function (translationId) {
                vm.tour.chat.step6Delete = translationId;
            });
            $translate('TOUR.CHAT.STEP7_NEW').then(function (translation) {
                vm.tour.chat.step7New = translation;
            }, function (translationId) {
                vm.tour.chat.step7New = translationId;
            });
            $translate('TOUR.CHAT.STEP9_CHATDETAIL').then(function (translation) {
                vm.tour.chat.step9ChatDetail = translation;
            }, function (translationId) {
                vm.tour.chat.step9ChatDetail = translationId;
            });
            $translate('TOUR.CHAT.STEP10_CHATDETAILTOOLTIP').then(function (translation) {
                vm.tour.chat.step10ChatDetailTooltip = translation;
            }, function (translationId) {
                vm.tour.chat.step10ChatDetailTooltip = translationId;
            });
            $translate('TOUR.CHAT.STEP11_CHATDETAILSAVE').then(function (translation) {
                vm.tour.chat.step11ChatDetailSave = translation;
            }, function (translationId) {
                vm.tour.chat.step11ChatDetailSave = translationId;
            });
            $translate('TOUR.CHAT.STEP13_COUNT').then(function (translation) {
                vm.tour.chat.step13Count = translation;
            }, function (translationId) {
                vm.tour.chat.step13Count = translationId;
            });
            $translate('TOUR.CHAT.STEP14_RESUMETOUR').then(function (translation) {
                vm.tour.chat.step14ResumeTourButton = translation;
            }, function (translationId) {
                vm.tour.chat.step14ResumeTourButton = translationId;
            });
            // CHAT TOUR END

            // RACK TOUR START
            $translate('TOUR.RACK.TITLE').then(function (translation) {
                vm.tour.rack.title = translation;
            }, function (translationId) {
                vm.tour.rack.title = translationId;
            });

            $translate('TOUR.RACK.STEP0_WELCOME').then(function (translation) {
                vm.tour.rack.step0Welcome = translation;
            }, function (translationId) {
                vm.tour.rack.step0Welcome = translationId;
            });

            $translate('TOUR.RACK.STEP1_FILTERS').then(function (translation) {
                vm.tour.rack.step1Filters = translation;
            }, function (translationId) {
                vm.tour.rack.step1Filters = translationId;
            });

            $translate('TOUR.RACK.STEP2_LEGEND').then(function (translation) {
                vm.tour.rack.step2Legend = translation;
            }, function (translationId) {
                vm.tour.rack.step2Legend = translationId;
            });

            $translate('TOUR.RACK.STEP3_RACK').then(function (translation) {
                vm.tour.rack.step3Rack = translation;
            }, function (translationId) {
                vm.tour.rack.step3Rack = translationId;
            });

            $translate('TOUR.RACK.STEP4_NEW').then(function (translation) {
                vm.tour.rack.step4New = translation;
            }, function (translationId) {
                vm.tour.rack.step4New = translationId;
            });

            $translate('TOUR.RACK.STEP6_NEW_BEDROOM').then(function (translation) {
                vm.tour.rack.step6NewBedRoom = translation;
            }, function (translationId) {
                vm.tour.rack.step6NewBedRoom = translationId;
            });

            $translate('TOUR.RACK.STEP7_BEDROOM_DETAIL_TOOLTIP').then(function (translation) {
                vm.tour.rack.step7BedRoomDetailTooltip = translation;
            }, function (translationId) {
                vm.tour.rack.step7BedRoomDetailTooltip = translationId;
            });

            $translate('TOUR.RACK.STEP9_ADD_INVENTORY').then(function (translation) {
                vm.tour.rack.step9AddInventory = translation;
            }, function (translationId) {
                vm.tour.rack.step9AddInventory = translationId;
            });

            $translate('TOUR.RACK.STEP10_SAVE_INVENTORY').then(function (translation) {
                vm.tour.rack.step10SaveInventory = translation;
            }, function (translationId) {
                vm.tour.rack.step10SaveInventory = translationId;
            });

            $translate('TOUR.RACK.STEP12_ROOM_TYPE').then(function (translation) {
                vm.tour.rack.step12RoomType = translation;
            }, function (translationId) {
                vm.tour.rack.step12RoomType = translationId;
            });

            $translate('TOUR.RACK.STEP13_ROOM_RATE').then(function (translation) {
                vm.tour.rack.step13RoomRate = translation;
            }, function (translationId) {
                vm.tour.rack.step13RoomRate = translationId;
            });

            $translate('TOUR.RACK.STEP14_ROOM_SAVE').then(function (translation) {
                vm.tour.rack.step14RoomSave = translation;
            }, function (translationId) {
                vm.tour.rack.step14RoomSave = translationId;
            });

            $translate('TOUR.RACK.STEP15_NEW_ROOM_CANCEL').then(function (translation) {
                vm.tour.rack.step15NewRoomCancel = translation;
            }, function (translationId) {
                vm.tour.rack.step15NewRoomCancel = translationId;
            });

            $translate('TOUR.RACK.STEP17_ROOM_DETAIL').then(function (translation) {
                vm.tour.rack.step17RoomDetail = translation;
            }, function (translationId) {
                vm.tour.rack.step17RoomDetail = translationId;
            })

            $translate('TOUR.RACK.STEP19_ACTIVE_TASK').then(function (translation) {
                vm.tour.rack.step19ActiveTask = translation;
            }, function (translationId) {
                vm.tour.rack.step19ActiveTask = translationId;
            });

            $translate('TOUR.RACK.STEP21_CLEAN_ROOM').then(function (translation) {
                vm.tour.rack.step21CleanRoom = translation;
            }, function (translationId) {
                vm.tour.rack.step21CleanRoom = translationId;
            });

            $translate('TOUR.RACK.STEP23_SAVE_TASK').then(function (translation) {
                vm.tour.rack.step23SaveTask = translation;
            }, function (translationId) {
                vm.tour.rack.step23SaveTask = translationId;
            });

            $translate('TOUR.RACK.STEP24_INCIDENT_PANEL').then(function (translation) {
                vm.tour.rack.step24IncidentPanel = translation;
            }, function (translationId) {
                vm.tour.rack.step24IncidentPanel = translationId;
            });

            $translate('TOUR.RACK.STEP25_RESUME_TOUR').then(function (translation) {
                vm.tour.rack.step25ResumeTour = translation;
            }, function (translationId) {
                vm.tour.rack.step25ResumeTour = translationId;
            });

            // RACK TOUR END

            $translate('SERVICEMENULIST.STATE.STATEON').then(function (translation) {
                vm.services.activeon = translation;
            }, function (translationId) {
                vm.services.activeon = translationId;
            });

            $translate('SERVICEMENULIST.STATE.STATEOFF').then(function (translation) {
                vm.services.activeoff = translation;
            }, function (translationId) {
                vm.services.activeoff = translationId;
            });

            $translate('SERVICEMENULIST.ACTIVE.ACTIVEON').then(function (translation) {
                vm.services.stateon = translation;
            }, function (translationId) {
                vm.services.stateon = translationId;
            });

            $translate('SERVICEMENULIST.ACTIVE.ACTIVEFF').then(function (translation) {
                vm.services.stateoff = translation;
            }, function (translationId) {
                vm.services.stateoff = translationId;
            });

            $translate('CANTEENNEWCOURSE.TITLE').then(function (translation) {
                vm.canteen.newCourse = translation;
            }, function (translationId) {
                vm.canteen.newCourse = translationId;
            });
            $translate('CANTEENNEWCOURSE.TITLEDIT').then(function (translation) {
                vm.canteen.editCourse = translation;
            }, function (translationId) {
                vm.canteen.editCourse = translationId;
            });

            $translate('CANTEENNEWCOURSE.ALLERGENS').then(function (translation) {
                vm.canteen.allergens.allergens = translation;
            }, function (translationId) {
                vm.canteen.allergens.allergens = translationId;
            });

            $translate('CANTEENNEWCOURSE.DISH').then(function (translation) {
                vm.canteen.allergensToolTips.inDish = translation;
            }, function (translationId) {
                vm.canteen.allergensToolTips.inDish = translationId;
            });

            $translate('CANTEENNEWCOURSE.KAL').then(function (translation) {
                vm.canteen.allergensToolTips.Kal = translation;
            }, function (translationId) {
                vm.canteen.allergensToolTips.Kal = translationId;
            });

            $translate('CANTEENNEWCOURSE.TOTAPPUSR').then(function (translation) {
                vm.canteen.allergensToolTips.totAppUsr = translation;
            }, function (translationId) {
                vm.canteen.allergensToolTips.totAppUsr = translationId;
            });

            $translate('CANTEENNEWCOURSE.NOALLERGENS').then(function (translation) {
                vm.canteen.allergens.noAllergens = translation;
            }, function (translationId) {
                vm.canteen.allergens.noAllergens = translationId;
            });

            $translate('DIALOG.SAVEOK').then(function (translation) {
                vm.dialog.saveok = translation;
            }, function (translationId) {
                vm.dialog.saveok = translationId;
            });

            $translate('DIALOG.COMMENTISREQUIRED').then(function (translation) {
                vm.dialog.commentisrequired = translation;
            }, function (translationId) {
                vm.dialog.commentisrequired = translationId;
            });

            $translate('DIALOG.CANCELRESERVATIONBILLINGS').then(function (translation) {
                vm.dialog.cancelReservationBillings = translation;
            }, function (translationId) {
                vm.dialog.cancelReservationBillings = translationId;
            });

            $translate('ERROR.UPDATEREGISTERERROR').then(function (translation) {
                vm.errors.updateRegister = translation;
            }, function (translationId) {
                vm.errors.updateRegister = translationId;
            });

            $translate('ERROR.CREATEREGISTERERROR').then(function (translation) {
                vm.errors.createRegister = translation;
            }, function (translationId) {
                vm.errors.createRegister = translationId;
            });

            $translate('ERROR.DELETEREGISTERERROR').then(function (translation) {
                vm.errors.deleteRegister = translation;
            }, function (translationId) {
                vm.errors.deleteRegister = translationId;
            });

            $translate('ERROR.DUPLICATEDCODE').then(function (translation) {
                vm.errors.duplicatedCode = translation;
            }, function (translationId) {
                vm.errors.duplicatedCode = translationId;
            });

            $translate('ERROR.BRANCHREQUIRED').then(function (translation) {
                vm.errors.branchRequired = translation;
            }, function (translationId) {
                vm.errors.branchRequired = translationId;
            });

            $translate('ERROR.MODALITYREQUIRED').then(function (translation) {
                vm.errors.modalityRequired = translation;
            }, function (translationId) {
                vm.errors.modalityRequired = translationId;
            });

            $translate('ERROR.ROOMTYPEREQUIRED').then(function (translation) {
                vm.errors.roomTypeRequired = translation;
            }, function (translationId) {
                vm.errors.roomTypeRequired = translationId;
            });

            $translate('ERROR.GENERROR1').then(function (translation) {
                vm.errors.GENERROR1 = translation;
            }, function (translationId) {
                vm.errors.GENERROR1 = translationId;
            });

            $translate('ERROR.GENERROR0').then(function (translation) {
                vm.errors.GENERROR0 = translation;
            }, function (translationId) {
                vm.errors.GENERROR0 = translationId;
            });

            $translate('ERROR.CHECKDATES').then(function (translation) {
                vm.errors.checkdates = translation;
            }, function (translationId) {
                vm.errors.checkdates = translationId;
            });

            $translate('ERROR.MENU40501').then(function (translation) {
                vm.errors.MENU40501 = translation;
            }, function (translationId) {
                vm.errors.MENU40501 = translationId;
            });

            $translate('ERROR.MENU40502').then(function (translation) {
                vm.errors.MENU40502 = translation;
            }, function (translationId) {
                vm.errors.MENU40502 = translationId;
            });

            $translate('ERROR.USER40501').then(function (translation) {
                vm.errors.USER40501 = translation;
            }, function (translationId) {
                vm.errors.USER40501 = translationId;
            });

            $translate('ERROR.USER40502').then(function (translation) {
                vm.errors.USER40502 = translation;
            }, function (translationId) {
                vm.errors.USER40502 = translationId;
            });

            $translate('ERROR.USER40503').then(function (translation) {
                vm.errors.USER40503 = translation;
            }, function (translationId) {
                vm.errors.USER40503 = translationId;
            });

            $translate('ERROR.SER40501').then(function (translation) {
                vm.errors.SER40501 = translation;
            }, function (translationId) {
                vm.errors.SER40501 = translationId;
            });

            $translate('ERROR.ERR405002').then(function (translation) {
                vm.errors.ERR405002 = translation;
            }, function (translationId) {
                vm.errors.ERR405002 = translationId;
            });

            $translate('ERROR.ERR405003').then(function (translation) {
                vm.errors.ERR405003 = translation;
            }, function (translationId) {
                vm.errors.ERR405003 = translationId;
            });

            $translate('ERROR.ERR405007').then(function (translation) {
                vm.errors.ERR405007 = translation;
            }, function (translationId) {
                vm.errors.ERR405007 = translationId;
            });

            $translate('ERROR.OCC00001').then(function (translation) {
                vm.errors.OCC00001 = translation;
            }, function (translationId) {
                vm.errors.OCC00001 = translationId;
            });

            $translate('ERROR.GEN40501').then(function (translation) {
                vm.errors.GEN40501 = translation;
            }, function (translationId) {
                vm.errors.GEN40501 = translationId;
            });

            $translate('ERROR.GEN40502').then(function (translation) {
                vm.errors.GEN40502 = translation;
            }, function (translationId) {
                vm.errors.GEN40502 = translationId;
            });

            $translate('ERROR.AGENDA40501').then(function (translation) {
                vm.errors.AGENDA40501 = translation;
            }, function (translationId) {
                vm.errors.AGENDA40501 = translationId;
            });

            $translate('ERROR.500').then(function (translation) {
                vm.errors.e500 = translation;
            }, function (translationId) {
                vm.errors.e500 = translationId;
            });

            $translate('ERROR.SAVEREQUESTFIRST').then(function (translation) {
                vm.errors.saveRequestFirst = translation;
            }, function (translationId) {
                vm.errors.saveRequestFirst = translationId;
            });

            $translate('ERROR.NODATA').then(function (translation) {
                vm.errors.noDataInTable = translation;
            }, function (translationId) {
                vm.errors.noDataInTable = translationId;
            });

            $translate('ERROR.SELECTBRANCH').then(function (translation) {
                vm.errors.selectBranch = translation;
            }, function (translationId) {
                vm.errors.selectBranch = translationId;
            });

            $translate('ERROR.DUPLICATEEMAIL').then(function (translation) {
                vm.errors.duplicateEmail = translation;
            }, function (translationId) {
                vm.errors.duplicateEmail = translationId;
            });

            $translate('ERROR.NOTPAIDBILLINGS').then(function (translation) {
                vm.errors.notPaidBillings = translation;
            }, function (translationId) {
                vm.errors.notPaidBillings = translationId;
            });

            $translate('ERROR.PENDINGCONCEPTS').then(function (translation) {
                vm.errors.pendingConcepts = translation;
            }, function (translationId) {
                vm.errors.pendingConcepts = translationId;
            });

            $translate('RESIDENTSWINDOW.TITLE').then(function (translation) {
                vm.residents.windowTit = translation;
            }, function (translationId) {
                vm.residents.windowTit = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.ACCESSCANCEL').then(function (translation) {
                vm.residents.cancelAccessOK = translation;
            }, function (translationId) {
                vm.residents.cancelAccessOK = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.ACCESSRENEWOK').then(function (translation) {
                vm.residents.renewAccessOK = translation;
            }, function (translationId) {
                vm.residents.renewAccessOK = translationId;
            });

            $translate('USERWINDOWDETAIL.TITLENEW').then(function (translation) {
                vm.users.titleNew = translation;
            }, function (translationId) {
                vm.users.titleNew = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.TITLECREATE').then(function (translation) {
                vm.resident.title = translation;
            }, function (translationId) {
                vm.resident.title = translationId;
            });

            $translate('RESIDENTWINDOWDETAIL.TITLE').then(function (translation) {
                vm.resident.titleedit = translation;
            }, function (translationId) {
                vm.resident.titleedit = translationId;
            });

            $translate('USERWINDOWDETAIL.TITLEMOD').then(function (translation) {
                vm.users.titleMod = translation;
            }, function (translationId) {
                vm.users.titleMod = translationId;
            });

            $translate('ROLES.MANAGER').then(function (translation) {
                vm.roles.manager = translation;
            }, function (translationId) {
                vm.roles.manager = translationId;
            });

            $translate('ROLES.DIRECTOR').then(function (translation) {
                vm.roles.director = translation;
            }, function (translationId) {
                vm.roles.director = translationId;
            });

            $translate('ROLES.DIRECTOR').then(function (translation) {
                vm.roles.director = translation;
            }, function (translationId) {
                vm.roles.director = translationId;
            });

            $translate('CANTEENDETAIL.TYPE.DINNER').then(function (translation) {
                vm.canteen.menutypes.dinner = translation;
            }, function (translationId) {
                vm.canteen.menutypes.dinner = translationId;
            });

            $translate('CANTEENDETAIL.TYPE.LUNCH').then(function (translation) {
                vm.canteen.menutypes.lunch = translation;
            }, function (translationId) {
                vm.canteen.menutypes.lunch = translationId;
            });

            $translate('AVATAR.CHANGEIMAGE').then(function (translation) {
                vm.avatar.changeimage = translation;
            }, function (translationId) {
                vm.avatar.changeimage = translationId;
            });
            $translate('CANTEENLISTWINDOW.STATE.CLOSED').then(function (translation) {
                vm.canteen.state.closed = translation;
            }, function (translationId) {
                vm.canteen.state.closed = translationId;
            });
            $translate('CANTEENLISTWINDOW.USERREMARKS.CLOSED').then(function (translation) {
                vm.canteen.userremarks.closed = translation;
            }, function (translationId) {
                vm.canteen.userremarks.closed = translationId;
            });
            $translate('BULLETINBOARDDETAIL.MSG.SUCCESS').then(function (translation) {
                vm.bulletinDetail.msg.success = translation;
            }, function (translationId) {
                vm.bulletinDetail.msg.success = translationId;
            });

            $translate('BULLETINBOARDDETAIL.MSG.EDIT').then(function (translation) {
                vm.bulletinDetail.msg.edit = translation;
            }, function (translationId) {
                vm.bulletinDetail.msg.edit = translationId;
            });

            $translate('CANTEENLISTWINDOW.STATE.OPEN').then(function (translation) {
                vm.canteen.state.opened = translation;
            }, function (translationId) {
                vm.canteen.state.opened = translationId;
            });

            $translate('CANTEENLISTWINDOW.USERREMARKS.OPEN').then(function (translation) {
                vm.canteen.userremarks.opened = translation;
            }, function (translationId) {
                vm.canteen.userremarks.opened = translationId;
            });

            $translate('ERROR.ERROR').then(function (translation) {
                vm.errors.error = translation;
            }, function (translationId) {
                vm.errors.error = translationId;
            });

            $translate('BULLETINBOARD.MSG.SUCCESS').then(function (translation) {
                vm.bulletinBoardList.msg.success = translation;
            }, function (translationId) {
                vm.bulletinBoardList.msg.success = translationId;
            });

            $translate('MODAL.CONFIRMATION').then(function (translation) {
                vm.modal.confirmation = translation;
            }, function (translationId) {
                vm.modal.confirmation = translationId;
            });

            $translate('MODAL.DELETEITEM').then(function (translation) {
                vm.modal.deleteItem = translation;
            }, function (translationId) {
                vm.modal.deleteItem = translationId;
            });
            $translate('MODAL.ACTIVEITEM').then(function (translation) {
                vm.modal.ActiveItem = translation;
            }, function (translationId) {
                vm.modal.ActiveItem = translationId;
            });
            $translate('MODAL.ANNOUNCEMENTCONFIRMATION').then(function (translation) {
                vm.modal.AnnouncementConfirmation = translation;
            }, function (translationId) {
                vm.modal.AnnouncementConfirmation = translationId;
            });
            $translate('MODAL.RESERVE.MOVESUCCESS').then(function (translation) {
                vm.modal.reserve.ReserveMovesuccess = translation;
            }, function (translationId) {
                vm.modal.reserve.ReserveMovesuccess = translationId;
            });
            $translate('MODAL.RESERVE.MOVEERROR').then(function (translation) {
                vm.modal.reserve.ReserveMoveerror = translation;
            }, function (translationId) {
                vm.modal.reserve.ReserveMoveerror = translationId;
            });
            $translate('MODAL.ALERT').then(function (translation) {
                vm.modal.alert = translation;
            }, function (translationId) {
                vm.modal.alert = translationId;
            });
            $translate('MODAL.DELETEITEMOK').then(function (translation) {
                vm.modal.deleteItemOk = translation;
            }, function (translationId) {
                vm.modal.deleteItemOk = translationId;
            });

            $translate('MODAL.BUTTON.OK').then(function (translation) {
                vm.modal.button.ok = translation;
            }, function (translationId) {
                vm.modal.button.ok = translationId;
            });

            $translate('MODAL.BUTTON.CANCEL').then(function (translation) {
                vm.modal.button.cancel = translation;
            }, function (translationId) {
                vm.modal.button.cancel = translationId;
            });

            $translate('MODAL.NEWREQUESTDNI').then(function (translation) {
                vm.modal.newRequestDNI = translation;
            }, function (translationId) {
                vm.modal.newRequestDNI = translationId;
            });

            $translate('MODAL.CANCELBOOKINGCOMMENT').then(function (translation) {
                vm.modal.cancelBookingComment = translation;
            }, function (translationId) {
                vm.modal.cancelBookingComment = translationId;
            });

            $translate('MODAL.RESERVATIONNOSHOW').then(function (translation) {
                vm.modal.reservationNoShow = translation;
            }, function (translationId) {
                vm.modal.reservationNoShow = translationId;
            });

            $translate('MODAL.RESERVATIONACCEPT').then(function (translation) {
                vm.modal.reservationAccept = translation;
            }, function (translationId) {
                vm.modal.reservationAccept = translationId;
            });

            $translate('FORGOTPASSWORD.SUCCESSMAIL').then(function (translation) {
                vm.forgotpassword.successmail = translation;
            }, function (translationId) {
                vm.forgotpassword.successmail = translationId;
            });

            $translate('FORGOTPASSWORD.ERROR').then(function (translation) {
                vm.forgotpassword.error = translation;
            }, function (translationId) {
                vm.forgotpassword.error = translationId;
            });

            $translate('FORGOTPASSWORD.RESETOK').then(function (translation) {
                vm.forgotpassword.resetok = translation;
            }, function (translationId) {
                vm.forgotpassword.resetok = translationId;
            });

            $translate('LOGIN.ERROR400').then(function (translation) {
                vm.login.error400 = translation;
            }, function (translationId) {
                vm.login.error400 = translationId;
            });

            $translate('LOGIN.ERROR401').then(function (translation) {
                vm.login.error401 = translation;
            }, function (translationId) {
                vm.login.error401 = translationId;
            });

            $translate('LOGIN.ERRORDEFAULT').then(function (translation) {
                vm.login.errordefault = translation;
            }, function (translationId) {
                vm.login.errordefault = translationId;
            });

            $translate('LOGIN.SESSIONEXPIRED').then(function (translation) {
                vm.login.sessionexpired = translation;
            }, function (translationId) {
                vm.login.sessionexpired = translationId;
            });

            $translate('INCIDENTDETAIL.TAGASTE').then(function (translation) {
                vm.incidentDetail.tagaste = translation;
            }, function (translationId) {
                vm.incidentDetail.tagaste = translationId;
            });

            $translate('INCIDENTDETAIL.MSG.SUCCESS').then(function (translation) {
                vm.incidentDetail.msg.success = translation;
            }, function (translationId) {
                vm.incidentDetail.msg.success = translationId;
            });

            $translate('INCIDENTDETAIL.MSG.EDIT').then(function (translation) {
                vm.incidentDetail.msg.edit = translation;
            }, function (translationId) {
                vm.incidentDetail.msg.edit = translationId;
            });

            $translate('ERROR.NOIMAGE').then(function (translation) {
                vm.errors.noImage = translation;
            }, function (translationId) {
                vm.errors.noImage = translationId;
            });

            $translate('ERROR.ONLYIMAGE').then(function (translation) {
                vm.errors.onlyImage = translation;
            }, function (translationId) {
                vm.errors.onlyImage = translationId;
            });

            $translate('WARNING').then(function (translation) {
                vm.warning = translation;
            }, function (translationId) {
                vm.warning = translationId;
            });

            $translate('ACTIVITIESLIST.MSG.DELETE').then(function (translation) {
                vm.activityList.msg.delete = translation;
            }, function (translationId) {
                vm.activityList.msg.delete = translationId;
            });

            $translate('ACTIVITYDETAIL.MSG.CREATE').then(function (translation) {
                vm.activityDetail.msg.create = translation;
            }, function (translationId) {
                vm.activityDetail.msg.create = translationId;
            });

            $translate('ACTIVITYDETAIL.MSG.EDIT').then(function (translation) {
                vm.activityDetail.msg.edit = translation;
            }, function (translationId) {
                vm.activityDetail.msg.edit = translationId;
            });

            $translate('ANNCEDETAILWINDOW.MSG.CREATE').then(function (translation) {
                vm.annoucement.msg.create = translation;
            }, function (translationId) {
                vm.annoucement.msg.create = translationId;
            });

            $translate('NOTIFICATIONPUSH.MSGSUCCESS').then(function (translation) {
                vm.notificationPush.success = translation;
            }, function (translationId) {
                vm.notificationPush.success = translationId;
            });

            $translate('CHATWINDOWNEWMOD.HEADERMOD').then(function (translation) {
                vm.inChatGroupMod = translation;
            }, function (translationId) {
                vm.inChatGroupMod = translationId;
            });

            $translate('CHATWINDOWNEWMOD.HEADERNEW').then(function (translation) {
                vm.inChatGroupNew = translation;
            }, function (translationId) {
                vm.inChatGroupNew = translationId;
            });

            $translate('CHATWINDOWNEWMOD.FLOOR').then(function (translation) {
                vm.floor = translation;
            }, function (translationId) {
                vm.floor = translationId;
            });

            $translate('CHATWINDOWNEWMOD.HEADERDETAIL').then(function (translation) {
                vm.inChatGroupDetail = translation;
            }, function (translationId) {
                vm.inChatGroupDetail = translationId;
            });

            $translate('ALL').then(function (translation) {
                vm.all = translation;
            }, function (translationId) {
                vm.all = translationId;
            });

            $translate('CANTEENAPPUSERDETAIL.GENERATEDOK').then(function (translation) {
                vm.reports.sucess = translation;
            }, function (translationId) {
                vm.reports.sucess = translationId;
            });

            $translate('REPORTS.REPORTNAME.LISTRES').then(function (translation) {
                vm.reports.names.listRes = translation;
            }, function (translationId) {
                vm.reports.names.listRes = translationId;
            });

            $translate('REPORTS.REPORTNAME.DISHES').then(function (translation) {
                vm.reports.names.dishes = translation;
            }, function (translationId) {
                vm.reports.names.dishes = translationId;
            });
            $translate('RESERVE.MSG.EDIT').then(function (translation) {
                vm.reserve.msg.edit = translation;
            }, function (translationId) {
                vm.reserve.msg.edit = translationId;
            });
            $translate('RESERVE.MSG.DELETE').then(function (translation) {
                vm.reserve.msg.delete = translation;
            }, function (translationId) {
                vm.reserve.msg.delete = translationId;
            });
            $translate('RESERVE.MSG.CREATE').then(function (translation) {
                vm.reserve.msg.create = translation;
            }, function (translationId) {
                vm.reserve.msg.create = translationId;
            });
            $translate('RESIDENTWINDOWDETAIL.MSGERRORGUEST').then(function (translation) {
                vm.resident.msgerrorguest = translation;
            }, function (translationId) {
                vm.resident.msgerrorguest = translationId;
            });
            $translate('MORNING').then(function (translation) {
                vm.morning = translation;
            }, function (translationId) {
                vm.morning = translationId;
            });
            $translate('AFTERNOON').then(function (translation) {
                vm.afternoon = translation;
            }, function (translationId) {
                vm.afternoon = translationId;
            });
            $translate('TASKS.TASK_SCHEDULER_DETAIL.MSG.EDIT').then(function (translation) {
                vm.taskDetail.msg.edit = translation;
            }, function (translationId) {
                vm.taskDetail.msg.edit = translationId;
            });
            $translate('TASKS.TASK_SCHEDULER_DETAIL.MSG.CREATE').then(function (translation) {
                vm.taskDetail.msg.create = translation;
            }, function (translationId) {
                vm.taskDetail.msg.create = translationId;
            });
            $translate('MORNING_AFTERNOON').then(function (translation) {
                vm.morningAfternoon = translation;
            }, function (translationId) {
                vm.morningAfternoon = translationId;
            });
            $translate('ROOMSCHEDULERDETAIL.MISSINGBLOCKREASON').then(function (translation) {
                vm.roomschedulerdetail.missingblockreason = translation;
            }, function (translationId) {
                vm.roomschedulerdetail.missingblockreason = translationId;
            });
            $translate('ROOMSCHEDULERDETAIL.MISSINGUNBLOCKREASON').then(function (translation) {
                vm.roomschedulerdetail.missingunblockreason = translation;
            }, function (translationId) {
                vm.roomschedulerdetail.missingunblockreason = translationId;
            });
            $translate('REQUESTS.DETAIL.HEADER').then(function (translation) {
                vm.requests.detail.header = translation;
            }, function (translationId) {
                vm.requests.detail.header = translationId;
            });
            $translate('REQUESTS.DETAIL.TOAST_MISSING_MODALITYDATA').then(function (translation) {
                vm.requests.detail.toastMissingModalityData = translation;
            }, function (translationId) {
                vm.requests.detail.toastMissingModalityData = translationId;
            });
            $translate('REQUESTS.DETAIL.TOAST_MISSING_BILLINGDATA').then(function (translation) {
                vm.requests.detail.toastMissingBillingData = translation;
            }, function (translationId) {
                vm.requests.detail.toastMissingBillingData = translationId;
            });
            $translate('REQUESTS.DETAIL.TOAST_MISSING_BRANCH').then(function (translation) {
                vm.requests.detail.toastMissingBranch = translation;
            }, function (translationId) {
                vm.requests.detail.toastMissingBranch = translationId;
            });
            $translate('REQUESTS.DETAIL.MISSING_DOCUMENTATION').then(function (translation) {
                vm.requests.detail.missingDocumentation = translation;
            }, function (translationId) {
                vm.requests.detail.missingDocumentation = translationId;
            });
            $translate('REQUESTS.DETAIL.MISSING_TUITION').then(function (translation) {
                vm.requests.detail.missingTuition = translation;
            }, function (translationId) {
                vm.requests.detail.missingTuition = translationId;
            });
            $translate('REQUESTS.DETAIL.MISSING_DEPOSIT').then(function (translation) {
                vm.requests.detail.missingDeposit = translation;
            }, function (translationId) {
                vm.requests.detail.missingDeposit = translationId;
            });
            $translate('MASTERTABLES.OPTION.KNOWABOUTUS').then(function (translation) {
                vm.masterTables.option.knowAboutUs = translation;
            }, function (translationId) {
                vm.masterTables.option.knowAboutUs = translationId;
            });
            $translate('MASTERTABLES.OPTION.INTERVIEWRATING').then(function (translation) {
                vm.masterTables.option.interviewRating = translation;
            }, function (translationId) {
                vm.masterTables.option.interviewRating = translationId;
            });
            // REQUESTS.DETAIL END

            // ACTIVITYLIST.EXPORT START
            $translate('ACTIVITYLIST.EXPORT.LOCALIDAD').then(function (translation) {
                vm.activityList.export.localidad = translation;
            }, function (translationId) {
                vm.activityList.export.localidad = translationId;
            });
            $translate('ACTIVITYLIST.EXPORT.TITULO').then(function (translation) {
                vm.activityList.export.titulo = translation;
            }, function (translationId) {
                vm.activityList.export.titulo = translationId;
            });
            $translate('ACTIVITYLIST.EXPORT.PRECIO').then(function (translation) {
                vm.activityList.export.precio = translation;
            }, function (translationId) {
                vm.activityList.export.precio = translationId;
            });
            $translate('ACTIVITYLIST.EXPORT.LIMITE_PLAZAS').then(function (translation) {
                vm.activityList.export.limite_plazas = translation;
            }, function (translationId) {
                vm.activityList.export.limite_plazas = translationId;
            });
            $translate('ACTIVITYLIST.EXPORT.NUMERO_INSCRITOS').then(function (translation) {
                vm.activityList.export.numero_inscritos = translation;
            }, function (translationId) {
                vm.activityList.export.numero_inscritos = translationId;
            });
            $translate('ACTIVITYLIST.EXPORT.ESTADO').then(function (translation) {
                vm.activityList.export.estado = translation;
            }, function (translationId) {
                vm.activityList.export.estado = translationId;
            });
            // ACTIVITYLIST.EXPORT END

            // ACTIVITYDETAIL.EXPORT START
            $translate('ACTIVITYDETAIL.EXPORT.NUM_HABITACION').then(function (translation) {
                vm.activityDetail.export.num_habitacion = translation;
            }, function (translationId) {
                vm.activityDetail.export.num_habitacion = translationId;
            });
            $translate('ACTIVITYDETAIL.EXPORT.NOMBRE_COMPLETO').then(function (translation) {
                vm.activityDetail.export.nombre_completo = translation;
            }, function (translationId) {
                vm.activityDetail.export.nombre_completo = translationId;
            });
            $translate('ACTIVITYDETAIL.EXPORT.TELEFONO').then(function (translation) {
                vm.activityDetail.export.telefono = translation;
            }, function (translationId) {
                vm.activityDetail.export.telefono = translationId;
            });
            $translate('ACTIVITYDETAIL.EXPORT.EMAIL').then(function (translation) {
                vm.activityDetail.export.email = translation;
            }, function (translationId) {
                vm.activityDetail.export.email = translationId;
            });
            // ACTIVITYDETAIL.EXPORT END

            // INCIDENTS.EXPORT START
            $translate('INCIDENTS.TITLE').then(function (translation) {
                vm.incidents.title = translation;
            }, function (translationId) {
                vm.incidents.title = translationId;
            });
            $translate('INCIDENTS.EXPORT.LOCATION').then(function (translation) {
                vm.incidents.export.location = translation;
            }, function (translationId) {
                vm.incidents.export.location = translationId;
            });
            $translate('INCIDENTS.EXPORT.DATE').then(function (translation) {
                vm.incidents.export.date = translation;
            }, function (translationId) {
                vm.incidents.export.date = translationId;
            });
            $translate('INCIDENTS.EXPORT.PLACE').then(function (translation) {
                vm.incidents.export.place = translation;
            }, function (translationId) {
                vm.incidents.export.place = translationId;
            });
            $translate('INCIDENTS.EXPORT.TEXT').then(function (translation) {
                vm.incidents.export.text = translation;
            }, function (translationId) {
                vm.incidents.export.text = translationId;
            });
            $translate('INCIDENTS.EXPORT.PRIORITY').then(function (translation) {
                vm.incidents.export.priority = translation;
            }, function (translationId) {
                vm.incidents.export.priority = translationId;
            });
            $translate('INCIDENTS.EXPORT.STATUS').then(function (translation) {
                vm.incidents.export.status = translation;
            }, function (translationId) {
                vm.incidents.export.status = translationId;
            });
            $translate('INCIDENTS.EXPORT.TASKTYPE').then(function (translation) {
                vm.incidents.export.taskType = translation;
            }, function (translationId) {
                vm.incidents.export.taskType = translationId;
            });
            $translate('INCIDENTS.EXPORT.ORIGINUSER').then(function (translation) {
                vm.incidents.export.originUser = translation;
            }, function (translationId) {
                vm.incidents.export.originUser = translationId;
            });
            $translate('INCIDENTS.EXPORT.USERNAME').then(function (translation) {
                vm.incidents.export.username = translation;
            }, function (translationId) {
                vm.incidents.export.username = translationId;
            });
            // INCIDENTS.EXPORT END

            // TASKS
            $translate('TASKS.TITLE').then(function (translation) {
                vm.tasks.title = translation;
            }, function (translationId) {
                vm.tasks.title = translationId;
            });
            $translate('TASKS.EXPORT.LOCATION').then(function (translation) {
                vm.tasks.export.location = translation;
            }, function (translationId) {
                vm.tasks.export.location = translationId;
            });
            $translate('TASKS.EXPORT.PLACE').then(function (translation) {
                vm.tasks.export.place = translation;
            }, function (translationId) {
                vm.tasks.export.place = translationId;
            });
            $translate('TASKS.EXPORT.DATE').then(function (translation) {
                vm.tasks.export.date = translation;
            }, function (translationId) {
                vm.tasks.export.date = translationId;
            });
            $translate('TASKS.EXPORT.TYPE').then(function (translation) {
                vm.tasks.export.type = translation;
            }, function (translationId) {
                vm.tasks.export.type = translationId;
            });
            $translate('TASKS.EXPORT.STATUS').then(function (translation) {
                vm.tasks.export.status = translation;
            }, function (translationId) {
                vm.tasks.export.status = translationId;
            });
            $translate('TASKS.EXPORT.REOPENED').then(function (translation) {
                vm.tasks.export.reopened = translation;
            }, function (translationId) {
                vm.tasks.export.reopened = translationId;
            });
            $translate('TASKS.EXPORT.WORKER').then(function (translation) {
                vm.tasks.export.worker = translation;
            }, function (translationId) {
                vm.tasks.export.worker = translationId;
            });

            // RESIDENTLIST.EXPORT START
            $translate('RESIDENTLIST.TITLE').then(function (translation) {
                vm.residentlist.title = translation;
            }, function (translationId) {
                vm.residentlist.title = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ROOM').then(function (translation) {
                vm.residentlist.export.room = translation;
            }, function (translationId) {
                vm.residentlist.export.room = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.NAME').then(function (translation) {
                vm.residentlist.export.name = translation;
            }, function (translationId) {
                vm.residentlist.export.name = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.RESIDENCE').then(function (translation) {
                vm.residentlist.export.residence = translation;
            }, function (translationId) {
                vm.residentlist.export.residence = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.DNI').then(function (translation) {
                vm.residentlist.export.dni = translation;
            }, function (translationId) {
                vm.residentlist.export.dni = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.DATE_OF_BIRTH').then(function (translation) {
                vm.residentlist.export.date_of_birth = translation;
            }, function (translationId) {
                vm.residentlist.export.date_of_birth = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.DELEGATE').then(function (translation) {
                vm.residentlist.export.delegate = translation;
            }, function (translationId) {
                vm.residentlist.export.delegate = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ABSENT').then(function (translation) {
                vm.residentlist.export.absent = translation;
            }, function (translationId) {
                vm.residentlist.export.absent = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.RESIDENT').then(function (translation) {
                vm.residentlist.export.resident = translation;
            }, function (translationId) {
                vm.residentlist.export.resident = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.APP').then(function (translation) {
                vm.residentlist.export.app = translation;
            }, function (translationId) {
                vm.residentlist.export.app = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.EMAIL').then(function (translation) {
                vm.residentlist.export.email = translation;
            }, function (translationId) {
                vm.residentlist.export.email = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.PHONE').then(function (translation) {
                vm.residentlist.export.phone = translation;
            }, function (translationId) {
                vm.residentlist.export.phone = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ADDRESS').then(function (translation) {
                vm.residentlist.export.address = translation;
            }, function (translationId) {
                vm.residentlist.export.address = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ZIP_CODE').then(function (translation) {
                vm.residentlist.export.zip_code = translation;
            }, function (translationId) {
                vm.residentlist.export.zip_code = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.CITY').then(function (translation) {
                vm.residentlist.export.city = translation;
            }, function (translationId) {
                vm.residentlist.export.city = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.PROVINCE').then(function (translation) {
                vm.residentlist.export.province = translation;
            }, function (translationId) {
                vm.residentlist.export.province = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.COUNTRY').then(function (translation) {
                vm.residentlist.export.country = translation;
            }, function (translationId) {
                vm.residentlist.export.country = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_NAME').then(function (translation) {
                vm.residentlist.export.tutors_name = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_name = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_GENDER').then(function (translation) {
                vm.residentlist.export.tutors_gender = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_gender = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_ADDRESS').then(function (translation) {
                vm.residentlist.export.tutors_address = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_address = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_CITY').then(function (translation) {
                vm.residentlist.export.tutors_city = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_city = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_POSTCODE').then(function (translation) {
                vm.residentlist.export.tutors_postcode = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_postcode = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_STATE').then(function (translation) {
                vm.residentlist.export.tutors_state = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_state = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_COUNTRY').then(function (translation) {
                vm.residentlist.export.tutors_country = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_country = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_IDENTITY').then(function (translation) {
                vm.residentlist.export.tutors_identity = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_identity = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_EMAIL').then(function (translation) {
                vm.residentlist.export.tutors_email = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_email = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_MAINPHONE').then(function (translation) {
                vm.residentlist.export.tutors_mainPhone = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_mainPhone = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_SECONDARYPHONE').then(function (translation) {
                vm.residentlist.export.tutors_secondaryPhone = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_secondaryPhone = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_STUDIES').then(function (translation) {
                vm.residentlist.export.tutors_studies = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_studies = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.TUTORS_PROFESSION').then(function (translation) {
                vm.residentlist.export.tutors_profession = translation;
            }, function (translationId) {
                vm.residentlist.export.tutors_profession = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ACADEMICDATA_UNIVERSITY').then(function (translation) {
                vm.residentlist.export.academicdata_university = translation;
            }, function (translationId) {
                vm.residentlist.export.academicdata_university = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ACADEMICDATA_FACULTY').then(function (translation) {
                vm.residentlist.export.academicdata_faculty = translation;
            }, function (translationId) {
                vm.residentlist.export.academicdata_faculty = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ACADEMICDATA_CARRERCOLLEGE').then(function (translation) {
                vm.residentlist.export.academicdata_carrercollege = translation;
            }, function (translationId) {
                vm.residentlist.export.academicdata_carrercollege = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ACADEMICDATA_COURSE').then(function (translation) {
                vm.residentlist.export.academicdata_course = translation;
            }, function (translationId) {
                vm.residentlist.export.academicdata_course = translationId;
            });
            $translate('RESIDENTLIST.EXPORT.ACADEMICDATA_COMMENT').then(function (translation) {
                vm.residentlist.export.academicdata_comment = translation;
            }, function (translationId) {
                vm.residentlist.export.academicdata_comment = translationId;
            });
            // RESIDENTLIST.EXPORT END

            // CANTEENLISTWINDOW.EXPORT
            $translate('CANTEENLISTWINDOW.EXPORT.TITLE').then(function (translation) {
                vm.canteen.export.title = translation;
            }, function (translationId) {
                vm.canteen.export.title = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.DATE').then(function (translation) {
                vm.canteen.export.date = translation;
            }, function (translationId) {
                vm.canteen.export.date = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.BRANCH').then(function (translation) {
                vm.canteen.export.branch = translation;
            }, function (translationId) {
                vm.canteen.export.branch = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.BOOKINGS').then(function (translation) {
                vm.canteen.export.bookings = translation;
            }, function (translationId) {
                vm.canteen.export.bookings = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.SERVICES').then(function (translation) {
                vm.canteen.export.services = translation;
            }, function (translationId) {
                vm.canteen.export.services = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.KIND').then(function (translation) {
                vm.canteen.export.kind = translation;
            }, function (translationId) {
                vm.canteen.export.kind = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.COMMENTS').then(function (translation) {
                vm.canteen.export.comments = translation;
            }, function (translationId) {
                vm.canteen.export.comments = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.CONDITION').then(function (translation) {
                vm.canteen.export.condition = translation;
            }, function (translationId) {
                vm.canteen.export.condition = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.FIRST').then(function (translation) {
                vm.canteen.export.first = translation;
            }, function (translationId) {
                vm.canteen.export.first = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.SECOND').then(function (translation) {
                vm.canteen.export.second = translation;
            }, function (translationId) {
                vm.canteen.export.second = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.DESSERT').then(function (translation) {
                vm.canteen.export.dessert = translation;
            }, function (translationId) {
                vm.canteen.export.dessert = translationId;
            });
            $translate('CANTEENLISTWINDOW.EXPORT.EXTRA').then(function (translation) {
                vm.canteen.export.extra = translation;
            }, function (translationId) {
                vm.canteen.export.extra = translationId;
            });

            // SERVICEMENULIST
            $translate('SERVICEMENULIST.EXPORT.TITLE').then(function (translation) {
                vm.services.export.title = translation;
            }, function (translationId) {
                vm.services.export.title = translationId;
            });
            $translate('SERVICEMENULIST.EXPORT.CITY').then(function (translation) {
                vm.services.export.city = translation;
            }, function (translationId) {
                vm.services.export.city = translationId;
            });
            $translate('SERVICEMENULIST.EXPORT.NAME').then(function (translation) {
                vm.services.export.name = translation;
            }, function (translationId) {
                vm.services.export.name = translationId;
            });
            $translate('SERVICEMENULIST.EXPORT.PRICE').then(function (translation) {
                vm.services.export.price = translation;
            }, function (translationId) {
                vm.services.export.price = translationId;
            });
            $translate('SERVICEMENULIST.EXPORT.HOUR').then(function (translation) {
                vm.services.export.hour = translation;
            }, function (translationId) {
                vm.services.export.hour = translationId;
            });

            // ACTIVITIES
            $translate('ACTIVITIES.TITLE').then(function (translation) {
                vm.activities.title = translation;
            }, function (translationId) {
                vm.activities.title = translationId;
            });
            $translate('ACTIVITIES.EXPORT.LOCATION').then(function (translation) {
                vm.activities.export.location = translation;
            }, function (translationId) {
                vm.activities.export.location = translationId;
            });
            $translate('ACTIVITIES.EXPORT.TITLE').then(function (translation) {
                vm.activities.export.title = translation;
            }, function (translationId) {
                vm.activities.export.title = translationId;
            });
            $translate('ACTIVITIES.EXPORT.PRICE').then(function (translation) {
                vm.activities.export.price = translation;
            }, function (translationId) {
                vm.activities.export.price = translationId;
            });
            $translate('ACTIVITIES.EXPORT.REGISTRED_NRO').then(function (translation) {
                vm.activities.export.registred_nro = translation;
            }, function (translationId) {
                vm.activities.export.registred_nro = translationId;
            });
            $translate('ACTIVITIES.EXPORT.STATUS').then(function (translation) {
                vm.activities.export.status = translation;
            }, function (translationId) {
                vm.activities.export.status = translationId;
            });
            $translate('ACTIVITIES.EXPORT.PLACES_LIMIT').then(function (translation) {
                vm.activities.export.places_limit = translation;
            }, function (translationId) {
                vm.activities.export.places_limit = translationId;
            });
            $translate('ACTIVITIES.EXPORT.DESCRIPTION').then(function (translation) {
                vm.activities.export.description = translation;
            }, function (translationId) {
                vm.activities.export.description = translationId;
            });
            $translate('ACTIVITIES.EXPORT.EVENT_LOCATION').then(function (translation) {
                vm.activities.export.event_location = translation;
            }, function (translationId) {
                vm.activities.export.event_location = translationId;
            });
            $translate('ACTIVITIES.EXPORT.DATE_AND_TIME').then(function (translation) {
                vm.activities.export.date_and_time = translation;
            }, function (translationId) {
                vm.activities.export.date_and_time = translationId;
            });
            $translate('ACTIVITIES.EXPORT.RESIDENTS_ROOM').then(function (translation) {
                vm.activities.export.residents_room = translation;
            }, function (translationId) {
                vm.activities.export.residents_room = translationId;
            });

            // USERS
            $translate('USERS.EXPORT_TITLE').then(function (translation) {
                vm.users.exportTitle = translation;
            }, function (translationId) {
                vm.users.exportTitle = translationId;
            });
            $translate('USERS.EXPORT.NAME').then(function (translation) {
                vm.users.export.name = translation;
            }, function (translationId) {
                vm.users.export.name = translationId;
            });
            $translate('USERS.EXPORT.SURNAME').then(function (translation) {
                vm.users.export.surname = translation;
            }, function (translationId) {
                vm.users.export.surname = translationId;
            });
            $translate('USERS.EXPORT.BRANCH').then(function (translation) {
                vm.users.export.branch = translation;
            }, function (translationId) {
                vm.users.export.branch = translationId;
            });
            $translate('USERS.EXPORT.ROLES').then(function (translation) {
                vm.users.export.roles = translation;
            }, function (translationId) {
                vm.users.export.roles = translationId;
            });
            $translate('USERS.EXPORT.APP').then(function (translation) {
                vm.users.export.app = translation;
            }, function (translationId) {
                vm.users.export.app = translationId;
            });

            $translate('USERS.EXPORT.EMAIL').then(function (translation) {
                vm.users.export.email = translation;
            }, function (translationId) {
                vm.users.export.email = translationId;
            });
            $translate('USERS.EXPORT.PHONE').then(function (translation) {
                vm.users.export.phone = translation;
            }, function (translationId) {
                vm.users.export.phone = translationId;
            });

            // INWORKETTASKLIST
            $translate('INWORKETTASKLIST.TITLE').then(function (translation) {
                vm.calendar.title = translation;
            }, function (translationId) {
                vm.calendar.title = translationId;
            });
            $translate('INWORKETTASKLIST.EXPORT.WORKER').then(function (translation) {
                vm.calendar.export.worker = translation;
            }, function (translationId) {
                vm.calendar.export.worker = translationId;
            });
            $translate('INWORKETTASKLIST.EXPORT.HOUR').then(function (translation) {
                vm.calendar.export.hour = translation;
            }, function (translationId) {
                vm.calendar.export.hour = translationId;
            });

            // DATA REQUEST
            $translate('REQUESTS.EXPORT_TITLE').then(function (translation) {
                vm.requests.title = translation;
            }, function (translationId) {
                vm.requests.title = translationId;
            });
            $translate('REQUESTS.EXPORT.NAME').then(function (translation) {
                vm.requests.export.name = translation;
            }, function (translationId) {
                vm.requests.export.name = translationId;
            });
            $translate('REQUESTS.EXPORT.SURNAME').then(function (translation) {
                vm.requests.export.surname = translation;
            }, function (translationId) {
                vm.requests.export.surname = translationId;
            });
            $translate('REQUESTS.EXPORT.COURSE').then(function (translation) {
                vm.requests.export.course = translation;
            }, function (translationId) {
                vm.requests.export.course = translationId;
            });
            $translate('REQUESTS.EXPORT.BOOKINGS').then(function (translation) {
                vm.requests.export.bookings = translation;
            }, function (translationId) {
                vm.requests.export.bookings = translationId;
            });
            $translate('REQUESTS.EXPORT.REQUEST_DATE').then(function (translation) {
                vm.requests.export.request_date = translation;
            }, function (translationId) {
                vm.requests.export.request_date = translationId;
            });
            $translate('REQUESTS.EXPORT.RESIDENCE').then(function (translation) {
                vm.requests.export.residence = translation;
            }, function (translationId) {
                vm.requests.export.residence = translationId;
            });
            $translate('REQUESTS.EXPORT.BILLING_DEPOSIT_DATE').then(function (translation) {
                vm.requests.export.billing_deposit_date = translation;
            }, function (translationId) {
                vm.requests.export.billing_deposit_date = translationId;
            });
            $translate('REQUESTS.EXPORT.BILLING_TUITON_DATE').then(function (translation) {
                vm.requests.export.billing_tuition_date = translation;
            }, function (translationId) {
                vm.requests.export.billing_tuition_date = translationId;
            });
            $translate('REQUESTS.EXPORT.ASSESSMENT').then(function (translation) {
                vm.requests.export.assessment = translation;
            }, function (translationId) {
                vm.requests.export.assessment = translationId;
            });
            $translate('REQUESTS.EXPORT.EFFECTIVE').then(function (translation) {
                vm.requests.export.effective = translation;
            }, function (translationId) {
                vm.requests.export.effective = translationId;
            });
            $translate('REQUESTS.EXPORT.ROOM').then(function (translation) {
                vm.requests.export.room = translation;
            }, function (translationId) {
                vm.requests.export.room = translationId;
            });
            $translate('REQUESTS.EXPORT.GENDER').then(function (translation) {
                vm.requests.export.gender = translation;
            }, function (translationId) {
                vm.requests.export.gender = translationId;
            });
            $translate('REQUESTS.EXPORT.DOCUMENT').then(function (translation) {
                vm.requests.export.document = translation;
            }, function (translationId) {
                vm.requests.export.document = translationId;
            });
            $translate('REQUESTS.EXPORT.DOCUMENT_TYPE').then(function (translation) {
                vm.requests.export.document_type = translation;
            }, function (translationId) {
                vm.requests.export.document_type = translationId;
            });
            $translate('REQUESTS.EXPORT.DOCUMENT_EXPEDITION_DATE').then(function (translation) {
                vm.requests.export.document_expedition_date = translation;
            }, function (translationId) {
                vm.requests.export.document_expedition_date = translationId;
            });
            $translate('REQUESTS.EXPORT.EMAIL').then(function (translation) {
                vm.requests.export.email = translation;
            }, function (translationId) {
                vm.requests.export.email = translationId;
            });
            $translate('REQUESTS.EXPORT.PHONE').then(function (translation) {
                vm.requests.export.phone = translation;
            }, function (translationId) {
                vm.requests.export.phone = translationId;
            });
            $translate('REQUESTS.EXPORT.ALIAS').then(function (translation) {
                vm.requests.export.alias = translation;
            }, function (translationId) {
                vm.requests.export.alias = translationId;
            });
            $translate('REQUESTS.EXPORT.BIRTHDATE').then(function (translation) {
                vm.requests.export.birthdate = translation;
            }, function (translationId) {
                vm.requests.export.birthdate = translationId;
            });
            $translate('REQUESTS.EXPORT.HOME_ADDRESS').then(function (translation) {
                vm.requests.export.home_address = translation;
            }, function (translationId) {
                vm.requests.export.home_address = translationId;
            });
            $translate('REQUESTS.EXPORT.HOME_POSTAL_CODE').then(function (translation) {
                vm.requests.export.home_postal_code = translation;
            }, function (translationId) {
                vm.requests.export.home_postal_code = translationId;
            });
            $translate('REQUESTS.EXPORT.HOME_TOWN').then(function (translation) {
                vm.requests.export.home_town = translation;
            }, function (translationId) {
                vm.requests.export.home_town = translationId;
            });
            $translate('REQUESTS.EXPORT.HOME_PROVINCE').then(function (translation) {
                vm.requests.export.home_province = translation;
            }, function (translationId) {
                vm.requests.export.home_province = translationId;
            });
            $translate('REQUESTS.EXPORT.HOME_COUNTRY').then(function (translation) {
                vm.requests.export.home_country = translation;
            }, function (translationId) {
                vm.requests.export.home_country = translationId;
            });
            $translate('REQUESTS.EXPORT.CITIZENSHIP').then(function (translation) {
                vm.requests.export.citizenship = translation;
            }, function (translationId) {
                vm.requests.export.citizenship = translationId;
            });
            $translate('REQUESTS.EXPORT.IDIOM').then(function (translation) {
                vm.requests.export.idiom = translation;
            }, function (translationId) {
                vm.requests.export.idiom = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_TYPE').then(function (translation) {
                vm.requests.export.guardian_type = translation;
            }, function (translationId) {
                vm.requests.export.guardian_type = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_NAME').then(function (translation) {
                vm.requests.export.guardian_name = translation;
            }, function (translationId) {
                vm.requests.export.guardian_name = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_DOMICILE_ADDRESS').then(function (translation) {
                vm.requests.export.guardian_domicile_address = translation;
            }, function (translationId) {
                vm.requests.export.guardian_domicile_address = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_DOMICILE_ZIP_CODE').then(function (translation) {
                vm.requests.export.guardian_domicile_zip_code = translation;
            }, function (translationId) {
                vm.requests.export.guardian_domicile_zip_code = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_DOMICILE_CITY').then(function (translation) {
                vm.requests.export.guardian_domicile_city = translation;
            }, function (translationId) {
                vm.requests.export.guardian_domicile_city = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_DOMICILE_STATE').then(function (translation) {
                vm.requests.export.guardian_domicile_state = translation;
            }, function (translationId) {
                vm.requests.export.guardian_domicile_state = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_DOMICILE_COUNTRY').then(function (translation) {
                vm.requests.export.guardian_domicile_country = translation;
            }, function (translationId) {
                vm.requests.export.guardian_domicile_country = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_EMAIL').then(function (translation) {
                vm.requests.export.guardian_email = translation;
            }, function (translationId) {
                vm.requests.export.guardian_email = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_MAIN_PHONE').then(function (translation) {
                vm.requests.export.guardian_main_phone = translation;
            }, function (translationId) {
                vm.requests.export.guardian_main_phone = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_SECONDARY_PHONE').then(function (translation) {
                vm.requests.export.guardian_secondary_phone = translation;
            }, function (translationId) {
                vm.requests.export.guardian_secondary_phone = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_DOCUMENT').then(function (translation) {
                vm.requests.export.guardian_document = translation;
            }, function (translationId) {
                vm.requests.export.guardian_document = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_DOCUMENT_TYPE').then(function (translation) {
                vm.requests.export.guardian_document_type = translation;
            }, function (translationId) {
                vm.requests.export.guardian_document_type = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_STUDIES').then(function (translation) {
                vm.requests.export.guardian_studies = translation;
            }, function (translationId) {
                vm.requests.export.guardian_studies = translationId;
            });
            $translate('REQUESTS.EXPORT.GUARDIAN_PROFESSION').then(function (translation) {
                vm.requests.export.guardian_profession = translation;
            }, function (translationId) {
                vm.requests.export.guardian_profession = translationId;
            });
            $translate('REQUESTS.EXPORT.ACADEMIC_DATA_UNIVERSITY').then(function (translation) {
                vm.requests.export.academic_data_university = translation;
            }, function (translationId) {
                vm.requests.export.academic_data_university = translationId;
            });
            $translate('REQUESTS.EXPORT.ACADEMIC_DATA_FACULTY').then(function (translation) {
                vm.requests.export.academic_data_faculty = translation;
            }, function (translationId) {
                vm.requests.export.academic_data_faculty = translationId;
            });
            $translate('REQUESTS.EXPORT.ACADEMIC_DATA_STUDIES').then(function (translation) {
                vm.requests.export.academic_data_studies = translation;
            }, function (translationId) {
                vm.requests.export.academic_data_studies = translationId;
            });
            $translate('REQUESTS.EXPORT.ACADEMIC_DATA_COURSE').then(function (translation) {
                vm.requests.export.academic_data_course = translation;
            }, function (translationId) {
                vm.requests.export.academic_data_course = translationId;
            });
            $translate('REQUESTS.EXPORT.ACADEMIC_DATA_COMMENTS').then(function (translation) {
                vm.requests.export.academic_data_comments = translation;
            }, function (translationId) {
                vm.requests.export.academic_data_comments = translationId;
            });
            $translate('REQUESTS.EXPORT.BILLING_MODALITY').then(function (translation) {
                vm.requests.export.billing_modality = translation;
            }, function (translationId) {
                vm.requests.export.billing_modality = translationId;
            });
            $translate('REQUESTS.EXPORT.BILLING_FORM_OF_PAYMENT').then(function (translation) {
                vm.requests.export.billing_form_of_payment = translation;
            }, function (translationId) {
                vm.requests.export.billing_form_of_payment = translationId;
            });
            $translate('REQUESTS.EXPORT.BANK_DETAILS_ACCOUNT_HOLDER').then(function (translation) {
                vm.requests.export.bank_details_account_holder = translation;
            }, function (translationId) {
                vm.requests.export.bank_details_account_holder = translationId;
            });
            $translate('REQUESTS.EXPORT.BANK_DETAILS_ENTITY').then(function (translation) {
                vm.requests.export.bank_details_entity = translation;
            }, function (translationId) {
                vm.requests.export.bank_details_entity = translationId;
            });
            $translate('REQUESTS.EXPORT.BANK_ACCOUNT_DETAILS').then(function (translation) {
                vm.requests.export.bank_account_details = translation;
            }, function (translationId) {
                vm.requests.export.bank_account_details = translationId;
            });
            $translate('REQUESTS.EXPORT.SWIFT_BANK_DETAILS').then(function (translation) {
                vm.requests.export.swift_bank_details = translation;
            }, function (translationId) {
                vm.requests.export.swift_bank_details = translationId;
            });
            $translate('REQUESTS.EXPORT.DATA_REQUEST_MODALITY').then(function (translation) {
                vm.requests.export.data_request_modality = translation;
            }, function (translationId) {
                vm.requests.export.data_request_modality = translationId;
            });
            $translate('REQUESTS.EXPORT.ROOM_TYPE_REQUEST_DATA').then(function (translation) {
                vm.requests.export.room_type_request_data = translation;
            }, function (translationId) {
                vm.requests.export.room_type_request_data = translationId;
            });
            $translate('REQUESTS.EXPORT.DATA_REQUEST_START_DATE').then(function (translation) {
                vm.requests.export.data_request_start_date = translation;
            }, function (translationId) {
                vm.requests.export.data_request_start_date = translationId;
            });
            $translate('REQUESTS.EXPORT.DATA_REQUEST_END_DATE').then(function (translation) {
                vm.requests.export.data_request_end_date = translation;
            }, function (translationId) {
                vm.requests.export.data_request_end_date = translationId;
            });
            $translate('REQUESTS.EXPORT.DATA_REQUEST_END_DATE_CONTRACT').then(function (translation) {
                vm.requests.export.data_request_end_date_contract = translation;
            }, function (translationId) {
                vm.requests.export.data_request_end_date_contract = translationId;
            });
            $translate('REQUESTS.EXPORT.DATA_REQUEST_DATE_SIGNATURE_RULES').then(function (translation) {
                vm.requests.export.data_request_date_signature_rules = translation;
            }, function (translationId) {
                vm.requests.export.data_request_date_signature_rules = translationId;
            });
            $translate('REQUESTS.EXPORT.VISITS').then(function (translation) {
                vm.requests.export.visits = translation;
            }, function (translationId) {
                vm.requests.export.visits = translationId;
            });

            $translate('RESERVATIONS.EXPORT.CODE').then(function (translation) {
                vm.reservations.export.code = translation;
            }, function (translationId) {
                vm.reservations.export.code = translationId;
            });

            $translate('RESERVATIONS.EXPORT.COURSE').then(function (translation) {
                vm.reservations.export.course = translation;
            }, function (translationId) {
                vm.reservations.export.course = translationId;
            });

            $translate('RESERVATIONS.EXPORT.ORIGIN').then(function (translation) {
                vm.reservations.export.origin = translation;
            }, function (translationId) {
                vm.reservations.export.origin = translationId;
            });

            $translate('RESERVATIONS.EXPORT.NAME').then(function (translation) {
                vm.reservations.export.name = translation;
            }, function (translationId) {
                vm.reservations.export.name = translationId;
            });

            $translate('RESERVATIONS.EXPORT.SURNAME').then(function (translation) {
                vm.reservations.export.surname = translation;
            }, function (translationId) {
                vm.reservations.export.surname = translationId;
            });

            $translate('RESERVATIONS.EXPORT.DATEFROM').then(function (translation) {
                vm.reservations.export.dateFrom = translation;
            }, function (translationId) {
                vm.reservations.export.dateFrom = translationId;
            });

            $translate('RESERVATIONS.EXPORT.DATETO').then(function (translation) {
                vm.reservations.export.dateTo = translation;
            }, function (translationId) {
                vm.reservations.export.dateTo = translationId;
            });

            $translate('RESERVATIONS.EXPORT.STATUS').then(function (translation) {
                vm.reservations.export.status = translation;
            }, function (translationId) {
                vm.reservations.export.status = translationId;
            });

            $translate('RESERVATIONS.EXPORT.ROOM').then(function (translation) {
                vm.reservations.export.room = translation;
            }, function (translationId) {
                vm.reservations.export.room = translationId;
            });


            $translate('RESERVATIONS.EXPORT.ROOMTYPE').then(function (translation) {
                vm.reservations.export.roomType = translation;
            }, function (translationId) {
                vm.reservations.export.roomType = translationId;
            });

            $translate('RESERVATIONS.EXPORT.IS_RESIDENT').then(function (translation) {
                vm.reservations.export.isResident = translation;
            }, function (translationId) {
                vm.reservations.export.isResident = translationId;
            });

            $translate('RESERVATIONS.EXPORT.CANCELBOOKINGCOMMENT').then(function (translation) {
                vm.reservations.export.cancelBookingComment = translation;
            }, function (translationId) {
                vm.reservations.export.cancelBookingComment = translationId;
            });

            $translate('RESERVATIONS.EXPORT.BRANCH').then(function (translation) {
                vm.reservations.export.branch = translation;
            }, function (translationId) {
                vm.reservations.export.branch = translationId;
            });

            $translate('RESERVATIONS.EXPORT_TITLE').then(function (translation) {
                vm.reservations.exportTitle = translation;
            }, function (translationId) {
                vm.reservations.exportTitle = translationId;
            });

            $translate('RESERVATIONS.ERROR.MISSINGDATES').then(function (translation) {
                vm.reservations.error.missingDates = translation;
            }, function (translationId) {
                vm.reservations.error.missingDates = translationId;
            });

            $translate('RESERVATIONS.ERROR.ISAPPUSER').then(function (translation) {
                vm.reservations.error.isAppUser = translation;
            }, function (translationId) {
                vm.reservations.error.isAppUser = translationId;
            });

            $translate('BILLING.LIST.MULTIPLE').then(function (translation) {
                vm.billing.list.multiple = translation;
            }, function (translationId) {
                vm.billing.list.multiple = translationId;
            });
            $translate('BILLING.LIST.OCCUPANCIES').then(function (translation) {
                vm.billing.list.occupancies = translation;
            }, function (translationId) {
                vm.billing.list.occupancies = translationId;
            });

            $translate('PAYMENT.TYPES.AGENDA').then(function (translation) {
                vm.payments.types.agenda = translation;
            }, function (translationId) {
                vm.payments.types.agenda = translationId;
            });

            $translate('PAYMENT.TYPES.SERVICE').then(function (translation) {
                vm.payments.types.service = translation;
            }, function (translationId) {
                vm.payments.types.service = translationId;
            });

            $translate('PAYMENT.TYPES.OCCUPANCY').then(function (translation) {
                vm.payments.types.occupancy = translation;
            }, function (translationId) {
                vm.payments.types.occupancy = translationId;
            });

            $translate('PAYMENT.TYPES.OTHER').then(function (translation) {
                vm.payments.types.other = translation;
            }, function (translationId) {
                vm.payments.types.other = translationId;
            });

            $translate('PAYMENT.INVALIDINVOICE').then(function (translation) {
                vm.payments.invalidInvoice = translation;
            }, function (translationId) {
                vm.payments.invalidInvoice = translationId;
            });

            $translate('BEDROOMS_DETAIL.CLEAN_TASK_OBLIGATORY_FIELDS').then(function (translation) {
                vm.bedroomDetail.cleanTaskObligatoryFields = translation;
            }, function (translationId) {
                vm.bedroomDetail.cleanTaskObligatoryFields = translationId;
            });

            $translate('BEDROOMS_DETAIL.SELECT_CLEAN_TASK').then(function (translation) {
                vm.bedroomDetail.selectCleanTask = translation;
            }, function (translationId) {
                vm.bedroomDetail.selectCleanTask = translationId;
            });

            // **********************************************************************
            // TRANSLATE_ALL END
            // **********************************************************************
        };

        function translate(text) {
            return $q(function (resolve, reject) {
                $translate(text).then(function (translation) {
                    resolve(translation);
                }, function (translationId) {
                    reject(translationId);
                });
            });
        }
    }

})
();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('animFalse', animFalse);

    /** @ngInject */
    function animFalse($timeout, $rootScope) {
        return {
            restrict: 'A',
            link: function ($scope, elem) {
                var delay = 1000;

                if ($rootScope.$pageFinishedLoading) {
                    delay = 100;
                }

                $timeout(function () {
                    elem.removeClass('full-invisible');
                    // elem.addClass('animated none');
                }, delay);
            }
        };
    }

})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('fadeInLeft', fadeInLeft);

    /** @ngInject */
    function fadeInLeft($timeout, $rootScope) {
        return {
            restrict: 'A',
            link: function ($scope, elem) {
                var delay = 1000;

                if ($rootScope.$pageFinishedLoading) {
                    delay = 100;
                }

                $timeout(function () {
                    elem.removeClass('full-invisible');
                    elem.addClass('animated fadeInLeft');
                }, delay);
            }
        };
    }

})();
/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('fadeInRight', fadeInRight);

    /** @ngInject */
    function fadeInRight($timeout, $rootScope) {
        return {
            restrict: 'A',
            link: function ($scope, elem) {
                var delay = 1000;

                if ($rootScope.$pageFinishedLoading) {
                    delay = 100;
                }

                $timeout(function () {
                    elem.removeClass('full-invisible');
                    elem.addClass('animated fadeInRight');
                }, delay);
            }
        };
    }

})();
/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('fadeOutRight', fadeOutRight);

    /** @ngInject */
    function fadeOutRight($timeout, $rootScope) {
        return {
            restrict: 'A',
            link: function ($scope, elem) {
                var delay = 1000;
                //
                // if ($rootScope.$pageFinishedLoading) {
                //     delay = 100;
                // }

                $timeout(function () {
                    elem.addClass('animated fadeOutRight');
                }, delay);
            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
/**
 * Created by jgutierrez on 05/02/2018.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('tagasteClick', tagasteClick);

    /** @ngInject */
    function tagasteClick($parse) {
        return {
            restrict: 'A',
            compile: function($element, attrs) {
                var fn = $parse(attrs.tagasteClick);
                return function (scope, element, attrs) {
                    var disabled = false;
                    scope.$on('disableClickEvents', function () {
                        disabled = true;
                    });
                    scope.$on('enableClickEvents', function () {
                        disabled = false;
                    });
                    element.on('click', function (event) {
                        if (!disabled) {
                            scope.$apply(function () {
                                fn(scope, { $event: event });
                            });
                        }
                    });
                };
            }
        };
    }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
function activitiesList(NgTableParams, NgTableFilterService, $log, $timeout, localStorageService,
                        MasterTableService, routeConf, TranslationService, toastr,
                        $locale, $rootScope, PermissionsService, $filter, ActivitiesExportService, FileSaver, $location,
                        $scope) {
    var vm = this;

    vm.gotAccessMod = false;
    vm.gotAccessDel = false;

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('AGENDA', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('AGENDA', 'delete');
    }

    vm.select = {};
    vm.selectActivity = {};
    vm.anim = false;
    vm.readOnly = false;
    vm.showActivityView = false;
    vm.filterLocality = {
        localities: {
            id: 'text'
        }
    };
    vm.filterTitle = {
        title: {
            id: 'text'
        }
    };

    vm.filterEnrolless = {
        bookedNum: {
            id: 'number'
        }
    };

    vm.filterPrice = {
        rate: {
            id: 'number'
        }
    };

    var viewParams = localStorageService.get('activitiesViewParams') ?
        localStorageService.get('activitiesViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = {filterActivitiesList: {localities: selectedBar.description}};
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/activities') {
            viewParams = {filterActivitiesList: {localities: (!data.all) ? data.description : ''}};
            initTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);

    vm.$onInit = function () {
        vm.pagg = vm.pag;
        setPermissions();
        vm.userBranch = localStorageService.get('branches');

        vm.tableParams = null;
        initTable(vm.list);
    };

    vm.$onDestroy = function () {
        localStorageService.set('activitiesViewParams', null);
        localStorageService.set('reserverViewParams', null);
    };

    vm.$onChanges = function (changeValue) {
        vm.pagg = vm.pag;
        if (changeValue.list && changeValue.list.currentValue) {
            initTable(changeValue.list.currentValue);
        }
    };

    /**
     * @ngdoc method
     * @name initTable
     * @methodOf Tagaste.activitiesListCom.controller:activitiesList
     * @description
     * Method that load data in table of activity
     *
     */
    function initTable(list) {
        if (!list) {
            list = [];
        }
        //add all localities
        for (var i = 0; i < list.length; i++) {
            list[i].localities = '';
            for (var j = 0; j < list[i].branches.length; j++) {
                list[i].localities += _.isEmpty(list[i].localities) ? list[i].branches[j].description : ', ' +
                    list[i].branches[j].description;
            }
            if (vm.modeCreation) {
                list[i].selected = false;
            }
        }
        vm.modeCreation = false;

        var sorting = viewParams['sortingActivitiesList'] ? viewParams['sortingActivitiesList'] : {};
        var page = viewParams['pageActivitiesList'] ? viewParams['pageActivitiesList'] : 1;
        var count = viewParams['countActivitiesList'] ? viewParams['countActivitiesList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingActivitiesList'] = params._params.sorting;
                        viewParams['pageActivitiesList'] = page;
                        viewParams['countActivitiesList'] = params._params.count;
                        viewParams['filterActivitiesList'] = filterObj;
                        localStorageService.set('activitiesViewParams', viewParams);
                        vm.currentTableData = filteredData;

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterActivitiesList'] ? viewParams['filterActivitiesList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }


    /**
     * @ngdoc method
     * @name tableParamsCK
     * @methodOf Tagaste.activitiesListCom.controller:activitiesList
     * @description
     * Method that marked a row of table and show detail of activity
     *
     */
    vm.tableParamsCK = function (row) {
        $log.debug('tableParamsCK', row);
        if (vm.istour) {
            return;
        }
        if (!row.error) {
            localStorageService.set('reserverViewParams', null);
            if (vm.modeEdit || vm.modeCreation) {
                vm.showActivityView = false;
                vm.anim = false;
                vm.modeEdit = false;
                vm.modeReadOnly = false;
                vm.modeCreation = false;
                vm.animReserve = false;
                vm.notification = undefined;
                vm.animResident = false;

            } else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });
                vm.selectActivity = row._id;
                vm.modeReadOnly = true;
                vm.modeEdit = false;
                vm.showActivityView = true;
                vm.reserveList = null;
                vm.animReserve = false;
                vm.notification = undefined;
                vm.animResident = false;
                $log.debug('table click', vm.selectActivity);
            }
        }
    };

    /**
     * @ngdoc method
     * @name newActivity
     * @methodOf Tagaste.activitiesListCom.controller:activitiesList
     * @description
     * Method that redirect to create new activity
     *
     */
    vm.newActivity = function () {
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.modeReadOnly = false;
        vm.showActivityView = true;
        vm.modeEdit = false;
        vm.modeCreation = true;
    };

    /**
     * @ngdoc method
     * @name editActivity
     * @methodOf Tagaste.activitiesListCom.controller:activitiesList
     * @description
     * Method that redirect to edit a activity
     *
     */
    vm.editActivity = function (row) {
        if (vm.istour) {
            return;
        }
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        _.forEach(vm.tableParams.data, function (r) {
            r.selected = (r._id === row._id);
        });
        vm.selectActivity = row._id;
        vm.modeReadOnly = false;
        vm.showActivityView = true;
        vm.modeEdit = true;
        vm.modeCreation = false;
    };

    /**
     * @ngdoc method
     * @name deleteActivity
     * @methodOf Tagaste.activitiesListCom.controller:activitiesList
     * @description
     * Method that delete a activity
     *
     */
    vm.deleteActivity = function (row) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                MasterTableService.delete({idT: routeConf.app, idJ: routeConf.agenda, idP: row._id}, function (data) {
                    $log.debug('delete activity success');
                    toastr.success(TranslationService.activityList.msg.delete);
                    vm.onDeleted({value: ''});
                }, function (err) {
                    $log.error('delete activity error', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.exportData = function () {
        var translator = TranslationService.activities;
        var filename = translator.title.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = translator.export;

        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function (e) {
                return e._id;
            }),
            filename: filename
        };

        ActivitiesExportService.post({idR: 'export'}, requestData, function (data) {
            var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            FileSaver.saveAs(blob, filename + '.xlsx');
        }, function (err) {
            $log.error('ActivitiesExportService export error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };

    $rootScope.$on('openAgendaDetailFirstRow', function () {
        vm.tableParamsCK(vm.tableParams.data[0]);
    });

    $rootScope.$on('openAgendaDetail', function () {
        vm.newActivity();
    });

}

angular
    .module('Tagaste.activitiesListCom')
    .component('activitiesList', {
        templateUrl: 'app/components/activities/activitiesList/activitiesList.html',
        controllerAs: 'alstc',
        controller: activitiesList,
        bindings: {
            selectActivity: '=',
            list: '<',
            pag: '<',
            modeReadOnly: '=',
            showActivityView: '=',
            anim: '=',
            modeEdit: '=',
            onDeleted: '&',
            reserveList: '=',
            modeCreation: '=',
            animReserve: '=',
            notification: '=',
            animResident: '=',
            initTour: '&',
            tourDummyData: '<',
            istour: '<'
        }
    });

function activityDetailController(ENV, MasterTableService, $log, toastr, TranslationService, localStorageService, ConfigService,
                                  routeConf, $timeout, $locale, $rootScope, PermissionsService, ActivityDetailsExportService, FileSaver) {
    var vm = this;

    vm.avatarUploading = false;
    vm.accessPush = false;
    vm.newReserveView = false;
    vm.taxes = [];

    function setPermissions() {
        vm.accessPush = PermissionsService.gotPermission('PUSH', 'update');
    }

    function init() {
        vm.img = '';
        vm.popupFrom = {
            opened: false
        };
        vm.popupTo = {
            opened: false
        };
        vm.dateOptions = {
            minDate: moment().toDate(),
            showWeeks: false
        };

        $log.debug('vm.activityId', vm.activityId);
        ConfigService.query({
            component: 'tax'
        }, function (res) {
            $log.debug('tax master table data: ', res);
            vm.taxes = angular.copy(res);

            if (vm.modeReadOnly || vm.modeEdit) {
                MasterTableService.get({idT: routeConf.app, idJ: routeConf.agenda, idP: vm.activityId}, function (data) {
                    vm.activity = data;
                    if (vm.activity.photo && vm.activity.photo.original.key) {
                        MasterTableService.get({
                            idT: routeConf.file, idJ: routeConf.signedUrl, key: vm.activity.photo.original.key,
                            bucket: vm.activity.photo.original.bucket
                        }, function (data) {
                            $log.debug('load photo activity success: ', data.url);
                            vm.avatar = data.url;
                        }, function (err) {
                            $log.error('error load activity bulletin: ', err);
                        });
                    }
                    if (vm.modeEdit) {
                        loadAllLocalities();
                    } else {
                        vm.avatar = null;
                    }
                    $log.debug('load activity detail data: ', data);
                    if (vm.activity.rate) {
                        vm.activity.rate = parseNumberToString(vm.activity.rate);
                    }
                    vm.visibleFrom = moment(vm.activity.dateFrom).toDate();
                    vm.visibleTo = moment(vm.activity.dateTo).toDate();
                    if (vm.activity.dateLimit) {
                        vm.dateLimit = moment(vm.activity.dateLimit).toDate();
                    }
                    if (vm.activity.maxUsers === ENV.limitMaxUsers) {
                        delete vm.activity.maxUsers;
                    }
                    vm.calcTotal();
                }, function (err) {
                    $log.error('error load activity detail: ', err);
                    toastr.error(TranslationService.errors.e500);
                });
            } else {
                vm.activity = {};
                loadAllLocalities();
                vm.visibleFrom = moment().startOf('day').toDate();
                vm.visibleTo = moment().endOf('day').add(7, 'days').toDate();
            }
        }, function (err) {
            $log.error('tax master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });

        setPermissions();
    }

    vm.calcTotal = function () {
        if (vm.activity.rate) {
            vm.activity.rate = _.toNumber(vm.activity.rate);
            if (vm.activity.tax) {
                if (vm.activity.tax.isPercentage) {
                    vm.activity.total = _.round(vm.activity.rate + (vm.activity.rate * (vm.activity.tax.rate / 100)), 2);
                } else {
                    vm.activity.total = _.round(vm.activity.rate + vm.activity.tax.rate, 2);
                }
            } else {
                vm.activity.total = _.round(vm.activity.rate, 2);
            }
        } else {
            vm.activity.total = 0;
        }
    };

    vm.$doCheck = function () {
        if (!vm.previousActivityId) {
            vm.previousActivityId = vm.activityId;
            init();
        } else if (vm.previousActivityId !== vm.activityId) {
            vm.previousActivityId = vm.activityId;
            init();
        }
        if (vm.reloadActivity === true) {
            init();
            vm.reloadActivity = false;
        }
    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that check if press key is a number
     * @param(evt) is key pressed
     *
     */
    vm.validateKeyPress = function (evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode < 48 && charCode !== 8 && charCode !== 9) || (charCode > 57)) {
            evt.preventDefault();
        }
    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that redirect to activities list
     *
     */
    vm.cancel = function () {
        vm.showActivityView = false;
        vm.anim = false;
        vm.reserveList = null;
        vm.activity = {};
        vm.modeCreation = false;
        vm.modeEdit = false;
        vm.animReserve = false;
        vm.notification = undefined;
        vm.animResident = false;
        vm.showReserveNew({value: false});
    };

    /**
     * @ngdoc method
     * @name save
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that save an activity
     *
     */
    vm.save = function (form) {
        vm.showError = false;
        var query = {};
        if (vm.activity.photo) {
            vm.photovalid = true;
        } else {
            vm.photovalid = false;
        }
        vm.submitted = true;
        if (form.$valid && vm.photovalid) {
            vm.activity.dateFrom = moment(vm.visibleFrom).startOf('day');
            vm.activity.dateTo = moment(vm.visibleTo).endOf('day');
            if (vm.dateLimit) {
                vm.activity.dateLimit = moment(vm.dateLimit).endOf('day');
            }
            if (vm.activity.rate && !_.isNumber(vm.activity.rate)) {
                vm.activity.rate = parseStrToNumber(vm.activity.rate);
            }
            if (vm.activity.maxUsers) {
                vm.activity.maxUsers = parseInt(vm.activity.maxUsers);
            }
            $log.debug('activity to save', vm.activity);
            query.idT = routeConf.app;
            query.idJ = routeConf.agenda;
            if (vm.modeEdit) {
                query.idP = vm.activity._id;
            }
            MasterTableService.post(query, vm.activity, function (response) {
                $log.debug('create activity success', response);
                vm.showActivityView = false;
                vm.anim = false;
                vm.activity = {};
                vm.onUpdated({value: ''});
                if (vm.modeEdit) {
                    toastr.success(TranslationService.activityDetail.msg.edit);
                } else {
                    toastr.success(TranslationService.activityDetail.msg.create);
                }
            }, function (err) {
                $log.error('error create bulletin');
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            vm.showError = true;
        }
    };

    /**
     * @ngdoc method
     * @name checkDates
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that check if dateFrom is later that dateTo
     *
     */
    vm.checkDates = function () {
        return vm.visibleTo && vm.visibleFrom && moment(vm.visibleFrom).isAfter(moment(vm.visibleTo));
    };

    /**
     * @ngdoc method
     * @name checkLimitDate
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that check if dateLimit  is between date to and date from
     *
     */
    vm.checkLimitDate = function () {
        return vm.dateLimit && (vm.visibleTo && moment(vm.dateLimit).isAfter(moment(vm.visibleTo)) ||
            (vm.visibleFrom && moment(vm.dateLimit).isBefore(moment(vm.visibleFrom))));
    };

    /**
     * @ngdoc method
     * @name sendNotification
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that send a notification
     *
     */
    vm.sendNotification = function () {
        if (!vm.animReserve) {
            $timeout(function () {
                vm.animReserve = true;
            }, 401);
        }
        vm.notification = {
            user: vm.activity.userBooked,
            modeReadOnly: true,
            type: routeConf.agenda,
            branches: vm.activity.branches,
            relatedID: vm.activity._id,
            showPanel: true
        };
        vm.reserveList = null;
    };

    /**
     * @ngdoc method
     * @name showStock
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that show the reserve list panel
     *
     */
    vm.showStock = function () {
        if (!vm.animReserve) {
            $timeout(function () {
                vm.animReserve = true;
            }, 401);
        }
        vm.notification = undefined;
        vm.showNotificationButton = false;
        vm.showReserve({value: vm.activity});
    };

    /**
     * @ngdoc method
     * @name newReserve
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that show the reserve list panel
     *
     */
    vm.newReserve = function () {
        if (!vm.animReserve) {
            $timeout(function () {
                vm.animReserve = true;
            }, 401);
        }
        vm.newReserveView = true;
        vm.showReserveNew({value: true});
    };

    /**
     * @ngdoc method
     * @name loadAllLocalities
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that load all localities of a user
     *
     */
    function loadAllLocalities() {
        MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.branch}, function (data) {
            var allLocalities = data;
            $log.debug('mastertable branch load success', data);
            var userBranch = localStorageService.get('branches');
            vm.localities = [];
            for (var i = 0; i < allLocalities.length; i++) {
                for (var j = 0; j < userBranch.length; j++) {
                    if (userBranch[j] === allLocalities[i]._id) {
                        vm.localities.push(allLocalities[i]);
                    }
                }
            }
            //created filter due to ui-select multiple don´t allow track by $index
            if (vm.modeEdit) {
                vm.auxBraches = angular.copy(vm.activity.branches);
                vm.activity.branches = [];
                var auxItem = {};
                for (var l = 0; l < vm.auxBraches.length; l++) {
                    auxItem = _.find(vm.localities, function (o) {
                        return o._id === vm.auxBraches[l]._id;
                    });
                    if (auxItem) {
                        vm.activity.branches.push(auxItem);
                    }
                }
            } else {
                var selectedBar = localStorageService.get('selectedBarResidence');

                if (selectedBar && !selectedBar.all) {
                    vm.activity.branches = [];
                    vm.activity.branches.push(selectedBar);
                }
            }
            $log.debug('localities', vm.localities);
        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    }

    vm.exportData = function () {
        var tranlator = TranslationService.activityDetail;
        var filename = tranlator.title.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = tranlator.export;

        // var requestData = {columns, filename};
        var requestData = {
            columns: columns,
            filename: filename
        };

        ActivityDetailsExportService.post({idR: 'export'}, requestData, function (data) {
            var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            FileSaver.saveAs(blob, filename + '.xlsx');
        }, function (err) {
            $log.error('ActivityDetailsExportService export error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };

    /**
     * @ngdoc method
     * @name parseStrToNumber
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that change  string format to float format
     * @param(str) is string to change
     *
     */
    function parseStrToNumber(str) {
        var formats = $locale.NUMBER_FORMATS;
        var decimalSepRe = new RegExp('\\' + formats.DECIMAL_SEP, 'g');
        var groupSepRe = new RegExp('\\' + formats.GROUP_SEP, 'g');
        return parseFloat(str.replace(groupSepRe, '').replace(decimalSepRe, '.'));
    }

    /**
     * @ngdoc method
     * @name parseNumberToString
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that change  float format to string format
     * @param(num) is string to change
     *
     */
    function parseNumberToString(num) {
        var formats = $locale.NUMBER_FORMATS;
        return num.toString().replace('.', formats.DECIMAL_SEP);
    }

    $rootScope.$on('closeAgendaDetail', function () {
        vm.cancel();
    });
}

angular
    .module('Tagaste.activityDetailCom')
    .component('activityDetail', {
        templateUrl: 'app/components/activities/activityDetail/activityDetail.html',
        controllerAs: 'adc',
        controller: activityDetailController,
        bindings: {
            activityId: '=',
            modeReadOnly: '=',
            showActivityView: '=',
            anim: '=',
            onUpdated: '&',
            modeEdit: '=',
            showReserve: '&',
            reserveList: '=',
            modeCreation: '=',
            animReserve: '=',
            fromAnnouncement: '<',
            notification: '=',
            animResident: '=',
            showNotificationButton: '=',
            istour: '<',
            showReserveNew: '&',
            reloadActivity: '='
        }
    });

reserveListController.$inject = ['ENV', 'MasterTableService', '$log', 'NgTableParams', 'NgTableFilterService',
                                'localStorageService', 'UsersService', 'routeConf', '$timeout', 
                                'PermissionsService', '$filter', 'ConfigService', 'TranslationService', 'toastr', 'userKind'];

function reserveListController(ENV, MasterTableService, $log, NgTableParams, NgTableFilterService, 
                                localStorageService, UsersService, routeConf, $timeout, 
                                PermissionsService, $filter, ConfigService, TranslationService, toastr, userKind) {
    var vm = this;

    vm.filterFullName = {
        fullName: {
            id: 'text'
        }
    };
    vm.accessPush = false;

    vm._CONTROLLER='reserveListController';

    vm.residentPermission = PermissionsService.gotPermission('RESIDENT', 'read');

    function setPermissions() {
        vm.accessPush = PermissionsService.gotPermission('PUSH', 'update');
    }

    var viewParams = localStorageService.get('reserverViewParams') ?
        localStorageService.get('reserverViewParams') : {};

    vm.$doCheck = function () {
        if (!vm.init) {
            vm.notification = angular.copy(vm.reserveList.notification);
            vm.tableParams = null;
            initTable(vm.reserveList.list, vm.reserveList.listGuests);
            vm.init = true;
            setPermissions();
            $log.debug('vm.reserveList', vm.reserveList);
        }
    };

    vm.$onDestroy = function () {
        // localStorageService.set('reserverViewParams', null);
    };

    /**
     * @ngdoc method
     * @name initTable
     * @methodOf Tagaste.reserveListCom.controller:reserveListController
     * @description
     * Method that load data in table of reserve list
     *
     */
    function initTable(list, listGuests) {
        if (!list) {
            list = [];
        }
        if (!listGuests) {
            listGuests = [];
        }

        var sorting = viewParams['sortingReserverList'] ? viewParams['sortingReserverList'] : {fullName: 'asc'};

        var listCopy = angular.copy(list);
        var listGuestsCopy = angular.copy(listGuests);
        vm.residentNumber =  list.length;
        vm.guestNumber =  listGuests.length;
        vm.totalBook =  list.length + listGuests.length;
        vm.tableParams =
            new NgTableParams(
                {
                    count: list.length,
                    sorting: sorting
                },
                {
                    counts: [],
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        viewParams['sortingReserverList'] = params._params.sorting;
                        viewParams['filterReserverList'] = filterObj;
                        localStorageService.set('reserverViewParams', viewParams);

                        params.total(filteredData.length);
                        return filteredData;
                    }
                }
            );
        vm.tableParamsGuest =
            new NgTableParams(
                {
                    count: listGuests.length,
                    sorting: sorting
                },
                {
                    counts: [],
                    getData: function (params) {
                        listGuestsCopy = $filter('orderBy')(listGuestsCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listGuestsCopy, filterObj);

                        viewParams['sortingReserverlistGuests'] = params._params.sorting;
                        viewParams['filterReserverlistGuests'] = filterObj;
                        localStorageService.set('reserverViewParams', viewParams);

                        params.total(filteredData.length);
                        return filteredData;
                    }
                }
            );

        var savedFilters = viewParams['filterReserverList'] ? viewParams['filterReserverList'] : {};
        vm.tableParams.filter(savedFilters);
    }

    /**
     * @ngdoc method
     * @name tableParamsCK
     * @methodOf Tagaste.reserveListCom.controller:reserveListController
     * @description
     * Method that show the resident detail panel
     *
     */
    vm.tableParamsCK = function (row) {
        if(vm.residentPermission && (!row.kind || row.kind === userKind.appUser)) {
            if (!row.error) {
                $log.debug('reserve list element', row);
                var userID = localStorageService.get('userId');
                vm.constants = {};
                UsersService.get({idU: userID}, function (data) {
                    $log.debug('load UserService: ', data);
                }, function (err) {
                    $log.error('error loading UserService: ', err);
                }).$promise.then(function (data) {
                    vm.constants.branch = data.branches;
                    vm.ready = true;
                    ConfigService.query({functionality: 'docTypes'}, function (data2) {
                        $log.debug('load MasterTableService: ', data2);
                    }, function (err) {
                        $log.error('error loading MasterTableService: ', err);
                    }).$promise.then(function (data2) {
                        vm.constants.docType = data2;
                        ConfigService.query({
                            functionality: 'allergyTypes'
                        }, function (aller) {
                            vm.constants.allergies = aller;
                            ConfigService.query({
                                functionality: 'awayPeriod'
                            }, function (data2) {
                                vm.constants.awayPeriod = data2;
                                ConfigService.query({
                                    functionality: 'admonition'
                                }, function (data3) {
                                    vm.constants.admonitionTypes = data3;
                                    vm.selectedResident = row;
                                    vm.animResident = true;
                                }, function (err) {
                                    $log.error('error getting admonitionTypes ', err);
                                    toastr.error(TranslationService.errors.e500);
                                });
                            }, function (err) {
                                $log.error('error getting awayPeriod ', err);
                                toastr.error(TranslationService.errors.e500);
                            });
                        }, function (err) {
                            $log.error('error loading MasterTableService second time: ', err);
                        });
                    });
                });
            }
        }
    };

    vm.cancel = function () {
        vm.reserveList = null;
        vm.animReserve = false;
        vm.animResident = false;
        localStorageService.set('reserverViewParams', null);
        vm.blockButtons = false;
    };

    /**
     * @ngdoc method
     * @name notify
     * @methodOf Tagaste.reserveListCom.controller:reserveListController
     * @description
     * Method that show the notification panel
     *
     */
    vm.notify = function () {
        vm.selectedResident = {};
        $timeout(function () {
            vm.notification.showPanel = true;
        }, 101);
    };
}

angular
    .module('Tagaste.reserveListCom')
    .component('reserveList', {
        templateUrl: 'app/components/activities/reserveList/reserveList.html',
        controllerAs: 'rlc',
        controller: reserveListController,
        bindings: {
            reserveList: '=',
            animReserve: '=',
            selectedResident: '=',
            animResident: '=',
            constants: '=',
            notification: '=',
            showNotificationButton: '<',
            blockButtons: '='
        }
    });

reserveNewController.$inject = ['toastr', 'ValidationService', 'localStorageService',
    'TranslationService', 'MasterTableService', '$log', 'routeConf', 'ConfigService'];

function reserveNewController(toastr, ValidationService, localStorageService,
                              TranslationService, MasterTableService, $log, routeConf, ConfigService) {
    var vm = this;
    vm.guest = {};
    vm.selectedGuest = {};
    vm.appUser = {};
    vm.appUsers = {};
    vm.sav = {};
    vm.constants = {};
    vm.readonly = false;
    vm.isResident = true;
    vm.isGuest = false;
    vm.selectedName = '';
    vm.selectedSurname = '';
    vm.selectedDocVal = '';
    vm.selectedDocType = '';
    vm.selectedEmail = '';
    vm.selectedPhone = '';

    vm._CONTROLLER = 'reserveNewController';

    vm.setGuest = function (selectedGuest) {
        vm.guest = angular.copy(selectedGuest);
        //vm.selectedGuest = angular.copy(selectedGuest);
        vm.selectedName = selectedGuest.name;
        vm.selectedSurname = selectedGuest.surname;
        vm.selectedDocVal = selectedGuest.identity.docVal;
        vm.selectedDocType = selectedGuest.identity.docType;
        if ((selectedGuest.contact) && (selectedGuest.contact.email)) {
            vm.selectedEmail = selectedGuest.contact.email;
        } else {
            vm.selectedEmail = '';
        }
        if ((selectedGuest.contact) && (selectedGuest.contact.phone)) {
            vm.selectedPhone = selectedGuest.contact.phone;
        } else {
            vm.selectedEmail = '';
        }
    };

    function getSourcesGuests(guestName) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                idT: routeConf.guest,
                name: guestName
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error searching guest ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        });
    }

    vm.getGuestsByName = function (guestName) {
        var guestRequest = getSourcesGuests(guestName)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    vm.getGuestsBySurname = function (guestName) {
        var guestRequest = getSourcesGuests(guestName)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    function getSourcesGuestsById(identity) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                idT: routeConf.guest,
                identity: identity
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error searching guest ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        });
    }

    vm.getGuestsById = function (identity) {
        var guestRequest = getSourcesGuestsById(identity)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    vm.changeIsResident = function (value) {
        if (vm.readonly) {
            return;
        }
        vm.isResident = value;
        vm.isGuest = !value;
    };

    vm.validDNI = function (input, type, formInput) {
        var valid = true;
        if (input === undefined) {
            if (formInput.$viewValue !== undefined) {
                if (!formInput.$pristine && input !== '') {
                    if (type === undefined) {
                        if (type !== 'PAS') {
                            valid = ValidationService.validDniNie(formInput.$viewValue,
                                vm.constants.docType[0].description);
                        }
                    } else {
                        if (type !== 'PAS') {
                            valid = ValidationService.validDniNie(formInput.$viewValue, type);
                        }
                    }
                }
                formInput.$setValidity('valid', valid);
                return valid;
            }
        } else {
            if (!formInput.$pristine && input !== '') {
                if (type !== 'PAS') {
                    valid = ValidationService.validDniNie(input, type);
                }
            }
            formInput.$setValidity('valid', valid);
            return valid;
        }
    };

    vm.changeTypeIde = function (type) {
        if (vm.readonly) {
            return;
        }
        vm.cont += 1;
        if (vm.cont < vm.constants.docType.length) {
            vm.selectedDocType = vm.constants.docType[vm.cont];
        } else {
            vm.cont = 0;
            vm.selectedDocType = vm.constants.docType[0];
        }
    };

    vm.validateMobile = function (mobile, formInput) {
        var valid = true;
        if (!formInput.$pristine && mobile !== '' && mobile) {
            valid = ValidationService.validMobile(mobile);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validEmail = function (emailField, formInput) {
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,4})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (emailField) {
            valid = (!emailField || formInput.$pristine || reg.test(emailField));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };

    vm.parseUserListBy = function () {
        vm.alredyFloor = _.filter(vm.appUsers, function (appUser) {
            if (appUser.allFloor) {
                return appUser;
            }
        });
    };

    vm.parseUserList = function (users) {
        var usrList = angular.copy(users);
        var listByBran = [];
        _.forEach(usrList, function (item) {
            item.branches = item.branches[0];
            var b = _.find(listByBran, function (a) {
                return a._id === item.branches._id;
            });
            if (!b) {
                listByBran.push({
                    _id: item.branches._id,
                    usr: [item]
                });
            } else {
                b.usr.push(item);
            }
        });
        var list = [];
        _.forEach(listByBran, function (bran) {
            bran.usr = _.orderBy(bran.usr, ['room', 'asc']);
            _.forEach(bran.usr, function (i) {
                list.push(i);
            });
        });

        var lastFloor = -1;
        var out = [];
        _.forEach(list, function (user) {
            user.nameRoom = '[' + user.room + '] ' + user.name + ' ' +
                user.surname;
            out.push(user);
        });
        return out;
    };

    function clearAppUserByBrnch(br) {
        var list = [];
        _.forEach(vm.appUser, function (appUser) {
            var correct = _.find(br, function (ba) {
                return (ba._id === appUser.branches._id);
            });
            if (correct) {
                list.push(appUser);
            }
        });
        return list;
    }

    function checkAvailableUsers(branches) {
        $log.debug('checkAvailableUsers branches', branches);
        vm.appUsers = clearAppUserByBrnch(branches);
        $log.debug('vm.appUsers', vm.appUsers);
    }

    function loadAllResidents(branches) {
        MasterTableService.get({idT: routeConf.resident, branches: branches, virtual: 'all'}, function (data) {
            vm.appUsers = vm.parseUserList(data.data);
            vm.appUsersOri = (data.data);
            $log.debug('resident load success', data);
            if (vm.activity && vm.appUsers && vm.appUsers.length > 0) {
                vm.allUsers = data.data;
                $log.debug('vm.appUsers load success', vm.appUsers);
                //checkAvailableUsers(branches);
                //vm.parseUserListBy();
            }
        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    }

    vm.$onInit = function () {
        ConfigService.query({functionality: 'docTypes'}, function (data) {
            vm.constants = {
                docType: data
            };
            vm.selectedDocType = vm.constants.docType[0];
            $log.debug('vm.activityId', vm.activityId);
            MasterTableService.get({idT: routeConf.app, idJ: routeConf.agenda, idP: vm.activityId}, function (data) {
                vm.activity = data;
                if (vm.activity.photo && vm.activity.photo.original.key) {
                    MasterTableService.get({
                        idT: routeConf.file, idJ: routeConf.signedUrl, key: vm.activity.photo.original.key,
                        bucket: vm.activity.photo.original.bucket
                    }, function (data) {
                        $log.debug('load photo activity success: ', data.url);
                        vm.avatar = data.url;
                    }, function (err) {
                        $log.error('error load activity bulletin: ', err);
                    });
                }
                /*
                if (vm.activity.maxUsers === ENV.limitMaxUsers) {
                    delete vm.activity.maxUsers;
                }
                */
            }, function (err) {
                $log.error('error load activity detail: ', err);
                toastr.error(TranslationService.errors.e500);
            });
        }, function (error) {
            $log.error('load constants: ', error);
            vm.ready = true;
            toastr.error(TranslationService.errors.e500);
        });

        var userBranch = localStorageService.get('branches');
        var selectedBar = localStorageService.get('selectedBarResidence');

        vm.guest = {
            branches: (selectedBar && !selectedBar.all) ?
                selectedBar._id : userBranch,
            active: true,
            isResident: false
        };
        loadAllResidents(vm.guest.branches);
    };

    vm.cancel = function () {
        vm.guest = {};
        vm.selectedGuest = {};
        vm.appUsers = {};
        vm.isResident = true;
        vm.isGuest = false;
        vm.newReserveView = false;
        vm.reloadActivity = false;
    };

    vm.save = function (resForm) {
        vm.showError = false;
        var query = {};
        if ((!vm.submitted && !resForm.$valid) || !resForm.$valid) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            if (vm.isGuest) {
                if ((vm.selectedName !== vm.guest.name) ||
                    (vm.selectedSurname !== vm.guest.surname) ||
                    (vm.selectedDocVal !== vm.guest.identity.docVal)) {
                    vm.guest._id = null;
                    vm.guest.name = vm.selectedName;
                    vm.guest.surname = vm.selectedSurname;
                    vm.guest.identity = {
                        docType: vm.selectedDocType._id,
                        docVal: vm.selectedDocVal
                    };
                    vm.guest.contact = {
                        email: vm.selectedEmail,
                        phone: vm.selectedPhone
                    };

                    vm.sav = {
                        guest: angular.copy(vm.guest),
                        signup: true
                    };

                    query.idT = routeConf.app;
                    query.idJ = routeConf.agendaSignPanel;
                    query.idP = vm.activity._id;
                    $log.debug('activity to save', vm.activity);
                    MasterTableService.post(query, vm.sav, function (response) {
                        $log.debug('create reserve success', response);
                        vm.anim = false;
                        toastr.success(TranslationService.activityDetail.msg.edit);
                        vm.newReserveView = false;
                        vm.reloadActivity = true;
                    }, function (err) {
                        $log.error('error create reserve ', err);
                        var mensaje = err.data.error;
                        var respuestaError = TranslationService.errors.e500;
                        if (mensaje.indexOf('[AGENDA40501]') !== false) {
                            respuestaError = TranslationService.errors.AGENDA40501;
                        }
                        toastr.error(respuestaError, TranslationService.error, TranslationService.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    });
                } else {
                    vm.sav = {
                        guest: angular.copy(vm.guest),
                        signup: true
                    };

                    query.idT = routeConf.app;
                    query.idJ = routeConf.agendaSignPanel;
                    query.idP = vm.activity._id;
                    $log.debug('activity to save', vm.activity);
                    MasterTableService.post(query, vm.sav, function (response) {
                        $log.debug('create reserve success', response);
                        vm.anim = false;
                        toastr.success(TranslationService.activityDetail.msg.edit);
                        vm.newReserveView = false;
                        vm.reloadActivity = true;
                    }, function (err) {
                        $log.error('error create reserve ', err);
                        var mensaje = err.data.error;
                        var respuestaError = TranslationService.errors.e500;
                        if (mensaje.indexOf('[AGENDA40501]') !== false) {
                            respuestaError = TranslationService.errors.AGENDA40501;
                        }
                        toastr.error(respuestaError, TranslationService.error, TranslationService.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    });
                }
            } else {
                vm.sav = {
                    appUser: angular.copy(vm.appUser),
                    signup: true
                };
                query.idT = routeConf.app;
                query.idJ = routeConf.agendaSignPanel;
                query.idP = vm.activity._id;
                $log.debug('activity to save', vm.activity);
                MasterTableService.post(query, vm.sav, function (response) {
                    $log.debug('create reserve success ', response);
                    vm.anim = false;
                    toastr.success(TranslationService.activityDetail.msg.edit);
                    vm.newReserveView = false;
                    vm.reloadActivity = true;
                }, function (err) {
                    $log.error('error create reserve ', err);
                    var mensaje = err.data.error;
                    var respuestaError = TranslationService.errors.e500;
                    if (mensaje.indexOf('[AGENDA40501]') !== false) {
                        respuestaError = TranslationService.errors.AGENDA40501;
                    }
                    toastr.error(respuestaError, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }
    };
}

angular
    .module('Tagaste.reserveNewCom')
    .component('reserveNew', {
        templateUrl: 'app/components/activities/reserveNew/reserveNew.html',
        controllerAs: 'rnc',
        controller: reserveNewController,
        bindings: {
            activityId: '=',
            level: '@',
            newReserveView: '=',
            reloadActivity: '='
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */


function announcementDetail($log, MasterTableService, routeConf, toastr, TranslationService, localStorageService,
                            TourService, $rootScope, userKind, ENV, ConfigService) {
    var vm = this;
    vm.submitted = false;

    vm.toolbarOptions = ENV.toolbarOptions;
    vm.$doCheck = function () {
        if (!vm.previousAnnouncementId) {
            vm.previousAnnouncementId = vm.announcementId;
            init();
        } else if (vm.previousAnnouncementId !== vm.announcementId) {
            vm.previousAnnouncementId = vm.announcementId;
            init();
        }
    };

    vm.parseUserListBy = function () {
        vm.alredyFloor = _.filter(vm.announcement.appUsers, function (appUser) {
            if (appUser.allFloor) {
                return appUser;
            }
        });
    };

    vm.loadTemplate = function() {
        vm.announcement.html = vm.announcement.template.content;
    };

    vm.selectSource = function() {
        vm.announcement.source = vm.announcement.sender.email;
    };

    vm.parseUserList = function (users) {
        var usrList = angular.copy(users);
        var listByBran = [];
        _.forEach(usrList, function (item) {
            item.branches = item.branches[0];
            var b = _.find(listByBran, function (a) {
                return a._id === item.branches._id;
            });
            if (!b) {
                listByBran.push({
                    _id: item.branches._id,
                    usr: [item]
                });
            } else {
                b.usr.push(item);
            }
        });
        var list = [];
        _.forEach(listByBran, function (bran) {
            bran.usr = _.orderBy(bran.usr, ['room', 'asc']);
            _.forEach(bran.usr, function (i) {
                list.push(i);
            });
        });

        var lastFloor = -1;
        var out = [];
        _.forEach(list, function (user) {
            user.nameRoom = '[' + user.room + '] ' + user.name + ' ' +
                user.surname;
            if (_.get(user, 'spot.floor') && lastFloor !== _.get(user, 'spot.floor')) {
                lastFloor = _.get(user, 'spot.floor');
                out.push({
                    nameRoom: 'Planta ' + _.get(user, 'spot.floor') + ' ' + user.branches.description,
                    allFloor: _.get(user, 'spot.floor'),
                    floor: _.get(user, 'spot.floor'),
                    branches: user.branches,
                    _id: user.branches._id + _.get(user, 'spot.floor')
                });
            }
            out.push(user);
        });
        return out;
    };

    function init() {
        var queryObj = {
            component: 'email'
        };
        if (_.get(vm.selectedBranch, '_id')) {
            queryObj['branch'] = vm.selectedBranch['_id'];
        }

        ConfigService.query(queryObj, function (res) {
            $log.debug('email master table data: ', res);
            vm.templates = res;
        }, function (err) {
            $log.error('email master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });

        vm.dateOptions = {
            minDate: moment().toDate(),
            showWeeks: false
        };
        $log.debug('vm.announcementId', vm.announcementId);
        var userBranch = localStorageService.get('branches');
        if (vm.urlRedirect) {
            var urls = vm.urlRedirect.split('/');

            MasterTableService.get({idT: routeConf.app, idJ: routeConf.accessRequest, idP: urls[urls.length - 1]},
                function (data) {
                    vm.grantAccess = data;
                    vm.createdDate = moment(vm.grantAccess.date).toDate();
                    $log.debug('load grant access data', data);
                    loadAllResidents(vm.grantAccess.branch._id);
                });
        } else {
            if (vm.modeReadOnly) {
                MasterTableService.get({
                    idT: routeConf.app,
                    idJ: routeConf.notice,
                    idP: vm.announcementId
                }, function (data) {
                    vm.announcement = data;
                    $log.debug('load announcement detail data', data);
                    vm.date = moment(data.date).toDate();
                    vm.announcement.appUsers = [];
                    if (!vm.announcement.isGlobal) {
                        for (var i = 0; i < vm.announcement.addresses.length; i++) {
                            var user = _.get(vm.announcement, 'addresses['+i+'].user.item',{});
                            var isWorker = _.get(vm.announcement, 'addresses['+i+'].user.kind','none') === userKind.user;
                            user.nameRoom = isWorker? '[Trab.] ': '[Hab. ' +_.get(user, 'spot.code', user.room) +'] ';
                            user.nameRoom += '(' + _.get(user, 'branches[0].description', '---')  + ') ' +
                            _.get(user, 'fullName', '---');
                            user.floor = _.get(user, 'spot.floor', user.floor);
                            vm.announcement.appUsers.push(user);
                        }
                    }
                }, function (err) {
                    $log.error('error load announcement detail', err);
                    toastr.error(TranslationService.errors.e500);
                });
            } else {
                vm.announcement = {
                    addresses: [],
                    fcm: {
                        isPush: true
                    },
                    isGlobal: false,
                    branches: []
                };
                loadAllLocalities(userBranch);
                loadAllResidents(userBranch);
            }
        }
        if (vm.showGrantAccesView) {
            TourService.accessappTour();
        }
    }

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.announcementDetail.controller:announcementDetail
     * @description
     * Method that redirect to announcement list
     *
     */
    vm.cancel = function () {
        vm.showAnnouncementView = false;
        vm.showGrantAccesView = false;
        vm.urlRedirect = null;
        vm.anim = false;
        vm.modeReadOnly = false;
        vm.showCompleteList = false;
    };

    /**
     * @ngdoc method
     * @name availableUsers
     * @methodOf Tagaste.announcementDetail.controller:announcementDetail
     * @description
     * Method that load the available users in function of announcement branches
     *
     */
    vm.availableUsers = function () {
        loadAllResidents(vm.announcement.branches);
    };

    function getIdByUserList() {
        var appUsersParseToServer = [];

        _.forEach(vm.announcement.appUsers, function (item) {
            if (!item.allFloor) {
                appUsersParseToServer.push(item);
            } else {
                _.forEach(vm.appUsers, function (appUser) {
                    if ((appUser.branches._id === item.branches._id) &&
                        (item.floor === _.get(appUser, 'spot.floor')) && !appUser.allFloor) {
                        appUsersParseToServer.push(appUser);
                    }
                });
            }
        });
        return appUsersParseToServer;
    }

    /**
     * @ngdoc method
     * @name save
     * @methodOf Tagaste.announcementDetail.controller:announcementDetail
     * @description
     * Method that create a new announcement
     *
     */
    vm.save = function (form) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.AnnouncementConfirmation,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            vm.submitted = true;
            if (result.value) {
                vm.showError = false;
                var query = {};
                if (form.$valid) {
                    if (vm.urlRedirect) {
                        var dataToSave = {
                            branches: [],
                            deviceID: '',
                            devicePlatform: '',
                            noticeID: ''
                        };
                        dataToSave.branches.push(vm.grantAccess.branch._id);
                        dataToSave.deviceID = vm.grantAccess.device.tokenId;
                        dataToSave.devicePlatform = vm.grantAccess.device.platform;
                        dataToSave.noticeID = vm.announcementId;
                        $log.debug('grant access to save', dataToSave);
                        MasterTableService.post({
                                idT: routeConf.resident, idJ: routeConf.accessConfirmed,
                                idP: vm.grantAccess.appUser._id
                            },
                            dataToSave, function (data) {
                                $log.debug('access confirmed success', data);
                                vm.showAnnouncementView = false;
                                vm.showGrantAccesView = false;
                                vm.urlRedirect = null;
                                vm.anim = false;
                                vm.modeReadOnly = false;
                                vm.onUpdated({value: ''});
                            }, function (err) {
                                $log.error('error access confirmed', err);
                            });
                    } else {
                        var announcementToSave = angular.copy(vm.announcement);
                        announcementToSave.date = moment();

                        if (!announcementToSave.isGlobal && vm.appUsers.length > 0) {
                            var list = getIdByUserList(announcementToSave.appUsers);
                            announcementToSave.addresses = _.map(list, '_id');
                            announcementToSave.appUsers = _.map(list, '_id');
                        }
                        query.idT = routeConf.app;
                        query.idJ = routeConf.notice;
                        $log.debug('announcement to save', announcementToSave);
                        MasterTableService.post(query, announcementToSave, function (response) {
                            $log.debug('create notice success', response);
                            vm.showAnnouncementView = false;
                            vm.anim = false;
                            vm.activity = {};
                            vm.onUpdated({value: ''});
                            toastr.success(TranslationService.annoucement.msg.create);
                        }, function (err) {
                            $log.error('error create announcement');
                            toastr.error(TranslationService.errors.e500, TranslationService.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    }
                } else {
                    vm.showError = true;
                }
                if (!$rootScope.$$phase) {
                    $rootScope.$digest();
                }
            }
        });
    };

    /**
     * @ngdoc method
     * @name checkGlobal
     * @methodOf Tagaste.announcementDetail.controller:announcementDetail
     * @description
     * Method that check if switcher global option is selected
     *
     */
    vm.checkGlobal = function (value) {
        if (value) {
            vm.announcement.appUsers = [];
        }
    };


    /**
     * @ngdoc method
     * @name checkType
     * @methodOf Tagaste.announcementDetail.controller:announcementDetail
     * @description
     * Method that check if switcher type option is selected
     *
     */
    vm.checkType = function (value) {
        if (value) {
            delete vm.announcement.fcm;
            delete vm.announcement.text;
        } else {
            vm.announcement.fcm = {
                isPush: true
            };
        }
    };

    /**
     * @ngdoc method
     * @name loadAllLocalities
     * @methodOf Tagaste.announcementDetail.controller:announcementDetail
     * @description
     * Method that load all localities of a user
     *
     */
    function loadAllLocalities(userBranch) {
        MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.branch}, function (data) {
            var allLocalities = data;
            $log.debug('mastertable branch load success', data);
            vm.localities = [];
            for (var i = 0; i < allLocalities.length; i++) {
                for (var j = 0; j < userBranch.length; j++) {
                    if (userBranch[j] === allLocalities[i]._id) {
                        vm.localities.push(allLocalities[i]);
                    }
                }
            }
            $log.debug('localities', vm.localities);

            var selectedBar = localStorageService.get('selectedBarResidence');
            if (selectedBar && !selectedBar.all){
                vm.announcement.branches.push(selectedBar._id || selectedBar);
                vm.availableUsers();
            }


        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    }

    function clearAppUserByBrnch(br) {
        var list = [];
        _.forEach(vm.announcement.appUser, function (appUser) {
            var correct = _.find(br, function (ba) {
                return (ba._id === appUser.branches._id);
            });
            if (correct) {
                list.push(appUser);
            }
        });
        return list;
    }

    /**
     * @ngdoc method
     * @name loadAllResidents
     * @methodOf Tagaste.announcementDetail.controller:announcementDetail
     * @description
     * Method that load all residents available in function of list of branches
     * @param(branches) is a list of localities
     *
     */
    function loadAllResidents(branches) {
        MasterTableService.get({idT: routeConf.resident, branches: branches, virtual: 'all'}, function (data) {
            vm.appUsers = vm.parseUserList(data.data);
            vm.appUsersOri = (data.data);
            $log.debug('resident load success', data);
            if (vm.announcement && vm.announcement.appUsers && vm.announcement.appUsers.length > 0) {
                vm.allUsers = data.data;
            $log.debug('vm.appUsers load success', vm.appUsers);
            checkAvailableUsers(branches);
            vm.parseUserListBy();
            }
        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    }

    function checkAvailableUsers(branches) {
        $log.debug('checkAvailableUsers branches', branches);
        vm.announcement.appUsers = clearAppUserByBrnch(branches);
        $log.debug('vm.announcement.appUsers', vm.announcement.appUsers);
    }

    $rootScope.$on('closeAnnouncementDetail', function () {
        vm.cancel();
    });

    vm.resumeTour = function () {
        var forceTour = true;
        TourService.accessappTour(forceTour);
    };
}

angular
    .module('Tagaste.announcementDetail')
    .component('announcementDetail', {
        templateUrl: 'app/components/annoucements/announcementDetail/announcementDetail.html',
        controllerAs: 'adetc',  //stands for 'User List Component'
        controller: announcementDetail,
        bindings: {
            announcementId: '=',
            modeReadOnly: '=',
            showAnnouncementView: '=',
            anim: '=',
            onUpdated: '&',
            showGrantAccesView: '=',
            urlRedirect: '=',
            showCompleteList: '='
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */

announcementsList.$inject = ['NgTableParams', 'NgTableFilterService', '$timeout', '$log', 'localStorageService',
                            'Funcionalities', 'TourService', '$rootScope', 'PermissionsService', '$filter', '$location', '$scope'];

function announcementsList(NgTableParams, NgTableFilterService, $timeout, $log, localStorageService, Funcionalities,
                           TourService, $rootScope,PermissionsService, $filter, $location, $scope) {
    var vm = this;

    vm.tableParams = {};
    vm.announcement = {};
    vm.pagg = 0;
    vm.anim = false;
    vm.gotAccessMod = false;

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('NOTICE', 'update');
    }

    var viewParams = localStorageService.get('announcementsViewParams') ?
        localStorageService.get('announcementsViewParams') : {};


    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = {filterAnnouncementsList: {localities: selectedBar.description}};
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/announcements') {
            viewParams = {filterAnnouncementsList: {localities: (!data.all) ? data.description : ''}};
            iniTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);



    vm.$onInit = function () {
        vm.pagg = vm.pag;
        $log.debug('list', vm.list);
        vm.userBranch = localStorageService.get('branches');
        setPermissions();
        vm.tableParams = null;
        iniTable(vm.list);
    };

    vm.$onDestroy = function () {
        localStorageService.set('announcementsViewParams', null);
    };

    vm.$onChanges = function (changeValue) {
        vm.pagg = vm.pag;
        if (changeValue.list && changeValue.list.currentValue) {
            iniTable(changeValue.list.currentValue);
        }
    };

    /**
     * @ngdoc method
     * @name iniTable
     * @methodOf Tagaste.announcementsListCom.controller:announcementsList
     * @description
     * Method that load all data in table
     * @param list array data to initialize the table
     */
    function iniTable(list) {
        if (!list) {
            list = [];
        }
        for (var i = 0; i < list.length; i++) {
            list[i].localities = '';
            for (var j = 0; j < list[i].branches.length; j++) {
                list[i].localities += _.isEmpty(list[i].localities) ? list[i].branches[j].description : ', ' +
                    list[i].branches[j].description;
            }
            list[i].type = list[i].redirect.functionality;
            list[i].creationDate = moment(list[i].date).format();
        }

        var sorting = viewParams['sortingAnnouncementsList'] ? viewParams['sortingAnnouncementsList'] : {date: 'desc'};
        var page = viewParams['pageAnnouncementsList'] ? viewParams['pageAnnouncementsList'] : 1;
        var count = viewParams['countAnnouncementsList'] ? viewParams['countAnnouncementsList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingAnnouncementsList'] = params._params.sorting;
                        viewParams['pageAnnouncementsList'] = page;
                        viewParams['countAnnouncementsList'] = params._params.count;
                        viewParams['filterAnnouncementsList'] = filterObj;
                        localStorageService.set('announcementsViewParams', viewParams);

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterAnnouncementsList'] ? viewParams['filterAnnouncementsList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    /**
     * @ngdoc method
     * @name tableParamsCK
     * @methodOf Tagaste.announcementsListCom.controller:announcementsList
     * @description
     * Method that marked a row of table and show detail of announcement
     * @param(row) is a row selected in the table
     */
    vm.tableParamsCK = function (row) {
        if (vm.istour){
            return;
        }
        if (!row.error) {
            if (vm.showCompleteList) {
                vm.showAnnouncementView = false;
                vm.showActivityView = false;
                vm.showGrantAccesView = false;
                vm.showCompleteList = false;
                vm.animReserve = false;
                vm.anim = false;
                vm.servic = null;
                vm.menuId = null;
                vm.showIncidentView = false;
                vm.reserveList = undefined;
                vm.animResident = false;
                vm.appuser = null;
                vm.selectedResident = undefined;
            }
            else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });
                vm.modeReadOnly = true;
                vm.showGrantAccesView = false;
                vm.urlRedirect = null;
                if (row.redirect.isAccessAPP && !row.done) {
                    vm.showGrantAccesView = true;
                    vm.urlRedirect = row.redirect.url;
                }
                vm.showAnnouncementView = true;
                vm.modeCreation = false;
                vm.selectAnnouncement = row._id;
                $log.debug('selected announcement', row);
            }
        }
    };

    /**
     * @ngdoc method
     * @name newAnnouncemnt
     * @methodOf Tagaste.announcementsListCom.controller:announcementsList
     * @description
     * Method that show the view to create a n ew announcement
     */
    vm.newAnnouncemnt = function () {
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.showAnnouncementView = true;
        vm.minimizeList = true;
        vm.modeReadOnly = false;
        vm.showCompleteList = true;
    };

    /**
     * @ngdoc method
     * @name showLinked
     * @methodOf Tagaste.announcementsListCom.controller:announcementsList
     * @description
     * Method that show the view with related data of announcement
     */
    vm.showLinked = function (row) {
        $log.debug('showLinked', row);
        if (vm.istour){
            return;
        }
        if (row.redirect.isRelated) {
            var urls = row.redirect.url.split('/');
            switch (row.redirect.functionality) {
                case Funcionalities.activity:
                    vm.showActivityView = true;
                    break;
                case Funcionalities.service:
                    vm.servic = {
                        _id: urls[urls.length - 1],
                        fromAnnouncement: true
                    };
                    break;
                case Funcionalities.menu:
                    vm.menuId = urls[urls.length - 1];
                    break;
                case Funcionalities.incident:
                    vm.showIncidentView = true;
                    break;
            }
            vm.relatedId = urls[urls.length - 1];
            vm.modeReadOnly = true;
            vm.fromAnnouncement = true;
            vm.showCompleteList = true;
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
    };

    vm.filterPlace = {
        localities: {
            id: 'text'
        }
    };
    vm.filterTitle = {
        title: {
            id: 'text'
        }
    };
    vm.filterType = {
        type: {
            id: 'text'
        }
    };
    vm.filterSended = {
        addressesCount: {
            id: 'text'
        }
    };
    vm.filterDate = {
        creationDate: {
            id: 'text'
        }
    };

    $rootScope.$on('openAnnouncementDetail', function () {
        vm.newAnnouncemnt();
    });
}

angular
    .module('Tagaste.announcementsListCom')
    .component('announcementsList', {
        templateUrl: 'app/components/annoucements/announcementsList/announcementsList.html',
        controllerAs: 'alistc',
        controller: announcementsList,
        bindings: {
            selectAnnouncement: '=',
            list: '<',
            anim: '=',
            pag: '<',
            modeReadOnly: '=',
            showAnnouncementView: '=',
            showGrantAccesView: '=',
            onDeleted: '&',
            urlRedirect: '=',
            relatedId: '=',
            showActivityView: '=',
            fromAnnouncement: '=',
            animReserve: '=',
            servic: '=',
            menuId: '=',
            showIncidentView: '=',
            showCompleteList: '=',
            reserveList: '=',
            animResident: '=',
            appuser: '=',
            selectedResident: '=',
            initTour: '&',
            tourDummyData: '<',
            istour: '<'
        }
    });

BillingDetailController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal', 'GuestService',
    'MasterTableService', 'routeConf', '$log', 'NgTableFilterService', 'ResidentsService',
    '$rootScope', 'ValidationService', 'PermissionsService', 'CountryList', 'tmhDynamicLocale',
    'NgTableParams', 'localStorageService', 'BillingService', 'ConceptService'];

function BillingDetailController(toastr, TranslationService, RequestService, $uibModal, GuestService,
                                 MasterTableService, routeConf, $log, NgTableFilterService, ResidentsService,
                                 $rootScope, ValidationService, PermissionsService, CountryList, tmhDynamicLocale,
                                 NgTableParams, localStorageService, BillingService, ConceptService) {
    var vm = this;
    vm.lodash = _;
    vm.windowTitle = TranslationService.requests.detail.header;
    vm.moment = moment;
    vm.billingBD = {client: {}};
    vm.cont = 0;
    vm.readonly = true;
    vm.newGuestMode = false;
    vm.clientTypes = [
        {name: TranslationService.billing.detail.resident, value: 'resident', check: true},
        {name: TranslationService.billing.detail.guest, value: 'guest', check: false},
        // {name: TranslationService.billing.detail.other, value: 'other', check: true}
    ];
    vm.availableClients = [];
    vm.residents = [];
    vm.guests = [];
    vm.selectedCountry = null;
    vm.selectedState = null;
    vm.selectedCountryAddress = null;
    vm.selectedStateAddress = null;

    vm.readonlyUserInfo = false;

    vm.lockChangeClientType = false;

    vm.paymentReady = true;
    var selectedBar = localStorageService.get('selectedBarResidence');

    /** Function to set window permissions */
    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('BILLING', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('BILLING', 'delete');
    }

    /** Function to set client type */
    vm.changeClientType = function (type, form) {
        vm.billingBD.client = {};
        vm.readonlyUserInfo = false;
        if (!vm.readonly && !vm.lockChangeClientType) {
            if (type.value === 'resident') {
                vm.availableClients = vm.residents;
                vm.readonlyUserInfo = true;
                vm.billingBD.client.kind = 'resident';
            } else if (type.value === 'guest') {
                vm.availableClients = vm.guests;
                vm.billingBD.client.kind = 'guest';
            } else {
                vm.availableClients = [];
            }

            _.forEach(vm.clientTypes, function (ct) {
                if (ct.value === type.value) {
                    ct.check = true;
                    vm.clientTypeSelected = ct;
                } else {
                    ct.check = false;
                }
            });

            form.$setUntouched();
            _.set(vm.billingBD, 'billingAddress.ownClient', true);
            vm.setDocType('identity');
            vm.setDocType('identityAddress');
        }

    };

    /** Function to validate email */
    vm.validEmail = function (emailField, formInput) {
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,4})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (emailField) {
            valid = (!emailField || formInput.$pristine || reg.test(emailField));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };

    /** Function to validate phone */
    vm.validatePhone = function (phone, formInput) {
        var valid = true;
        if (!formInput.$pristine && phone !== '') {
            valid = ValidationService.validMobile(phone);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    /** Function to validate dni */
    vm.validDNI = function (input, type, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            if (type !== 'PAS') {
                valid = ValidationService.validDniNie(input, type);
            }
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    /** Function to set document type if dont have identity document **/
    vm.setDocType = function (identityVariable) {
        if (identityVariable === 'identity' && !vm.billingBD.client.identity) {
            _.set(vm.billingBD.client, 'identity', {docType: vm.constants.docType[0]});
        } else if (identityVariable === 'identityAddress' && !_.get(vm.billingBD.client, 'billingAddress.identity')) {
            _.set(vm.billingBD.client, 'billingAddress.identity', {docType: vm.constants.docType[0]});
        }
    };

    /** Function to change document type **/
    vm.changeTypeDoc = function (identityVariable) {
        if (vm.readonly) {
            return;
        }
        if (identityVariable === 'identity' && vm.billingBD.client.identity) {
            var docTypeIndex = vm.constants.docType.indexOf(vm.billingBD.client.identity.docType);
            if (docTypeIndex !== -1 && docTypeIndex < vm.constants.docType.length - 1) {
                vm.billingBD.client.identity.docType = vm.constants.docType[docTypeIndex + 1];
            } else {
                vm.billingBD.client.identity.docType = vm.constants.docType[0];
            }
        } else if (identityVariable === 'identity' && !vm.billingBD.client.identity) {
            vm.billingBD.client.identity = {docType: vm.constants.docType[0]};
        } else if (identityVariable === 'identityAddress' && vm.billingBD.billingAddress.identity) {
            var docTypeAddressIndex = vm.constants.docType.indexOf(vm.billingBD.billingAddress.identity.docType);
            if (docTypeAddressIndex !== -1 && docTypeAddressIndex < vm.constants.docType.length - 1) {
                vm.billingBD.billingAddress.identity.docType = vm.constants.docType[docTypeAddressIndex + 1];
            } else {
                vm.billingBD.billingAddress.identity.docType = vm.constants.docType[0];
            }
        } else if (identityVariable === 'identityAddress' && !vm.billingBD.billingAddress.identity) {
            vm.billingBD.billingAddress.identity = {docType: vm.constants.docType[0]};
        }
    };

    /** country/state functions **/
    function ignoreDiacritics(text) {
        return _.deburr(text.toUpperCase());
    }

    vm.getCountries = function (search, countryVariable) {
        var availableCountries = vm.countryList;
        if (search && _.findIndex(availableCountries, {name: search}) === -1) {
            availableCountries.splice(0, 1);
            availableCountries.unshift({name: search, states: []});
        }
        return availableCountries;
    };

    vm.getStates = function (search, countryVariable) {
        if (vm[countryVariable] && vm[countryVariable].states) {
            var availableStates = vm[countryVariable].states.slice();
            if (search && availableStates.indexOf(search) === -1) {
                availableStates.unshift(search);
            }
            return availableStates;
        } else {
            return [];
        }
    };

    vm.selectCountryChange = function (countryVariable) {
        if (countryVariable === 'selectedCountry') {
            vm.billingBD.client.country = vm[countryVariable] && vm[countryVariable].name ? vm[countryVariable].name : '';
        } else {
            vm.billingBD.billingAddress.country = vm.selectedCountryAddress.name ? vm.selectedCountry.name : '';
        }
        if (vm[countryVariable] && vm[countryVariable].states) {
            vm[countryVariable].states = _.uniq(vm[countryVariable].states);
        }
        vm.clearState();
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
    };

    vm.selectStateChange = function (stateVariable) {
        if (stateVariable === 'selectedStateAddress') {
            vm.billingBD.billingAddress.state = vm.selectedStateAddress ? vm.selectedStateAddress : '';
        } else {
            vm.billingBD.client.state = vm.selectedState ? vm.selectedState : '';
        }
    };

    vm.clearCountry = function (countryVariable) {
        if (countryVariable === 'selectedCountry' && vm.billingBD.client.country) {
            delete vm.billingBD.client.country;
            vm.clearState('selectedState');
        } else if (countryVariable === 'selectedCountryAddress' && vm.billingBD.billingAddress.country) {
            delete vm.billingBD.billingAddress.country;
            vm.clearState('selectedStateAddress');
        }
        vm[countryVariable] = {};
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
    };

    vm.clearState = function (stateVariable) {
        if (stateVariable === 'selectedState' && vm.billingBD.client.state) {
            delete vm.billingBD.client.state;
        } else if (stateVariable === 'selectedStateAddress' && vm.billingBD.billingAddress.state) {
            delete vm.billingBD.billingAddress.state;
        }
        vm[stateVariable] = '';
    };

    function setClientCountryState() {
        if (vm.billingBD.client.contact && vm.billingBD.client.contact.country) {
            vm.selectedCountry = _.find(vm.countryList, function (item) {
                return ignoreDiacritics(item.name) === ignoreDiacritics(vm.billingBD.client.contact.country);
            });
            if (vm.selectedCountry) {
                vm.billingBD.client.country = vm.selectedCountry.name;
                if (vm.selectedCountry.states && vm.billingBD.client.contact.state) {
                    vm.selectedCountry.states = _.uniq(vm.selectedCountry.states);
                    var state = _.find(vm.selectedCountry.states, function (item) {
                        return ignoreDiacritics(item) === ignoreDiacritics(vm.billingBD.client.contact.state);
                    });
                    vm.selectedState = state ? state : vm.billingBD.client.contact.state;
                    vm.billingBD.client.state = vm.selectedState.name;
                } else if (!vm.selectedCountry.states && vm.billingBD.client.contact.state) {
                    vm.selectedState = vm.billingBD.client.contact.state;
                    vm.billingBD.client.state = vm.selectedState;
                } else {
                    vm.selectedState = '';
                }
            } else {
                vm.selectedCountry = {name: vm.billingBD.client.contact.country, states: []};
                vm.billingBD.client.country = vm.selectedCountry.name;
                vm.selectedState = vm.billingBD.client.contact.state ? vm.billingBD.client.contact.state : '';
                vm.billingBD.client.state = vm.selectedState;
            }
        } else {
            vm.selectedCountry = {};
        }


        // BillingAddress
        if (vm.billingBD.billingAddress && vm.billingBD.billingAddress.country) {
            vm.selectedCountry = _.find(vm.countryList, function (item) {
                return ignoreDiacritics(item.name) === ignoreDiacritics(vm.billingBD.billingAddress.country);
            });
            if (vm.selectedCountryAddress) {
                vm.billingBD.billingAddress.country = vm.selectedCountryAddress.name;
                if (vm.selectedCountryAddress.states && vm.billingBD.billingAddress.state) {
                    vm.selectedCountryAddress.states = _.uniq(vm.selectedCountryAddress.states);
                    var state2 = _.find(vm.selectedCountry.states, function (item) {
                        return ignoreDiacritics(item) === ignoreDiacritics(vm.billingBD.billingAddress.state);
                    });
                    vm.selectedStateAddress = state2 ? state2 : vm.billingBD.billingAddress.state;
                    vm.billingBD.billingAddress.state = vm.selectedState.name;
                } else if (!vm.selectedCountry.states && vm.billingBD.billingAddress.state) {
                    vm.selectedStateAddress = vm.billingBD.billingAddress.state;
                    vm.billingBD.billingAddress.state = vm.selectedState;
                } else {
                    vm.selectedStateAddress = '';
                }
            } else {
                vm.selectedCountryAddress = {name: vm.billingBD.billingAddress.country, states: []};
                vm.billingBD.billingAddress.country = vm.selectedCountryAddress.name;
                vm.selectedStateAddress = vm.billingBD.billingAddress.state ? vm.billingBD.billingAddress.state : '';
                vm.billingBD.billingAddress.state = vm.selectedStateAddress;
            }
        } else {
            vm.selectedCountryAddress = {};
        }
    }

    /** end country/state functions */

    /** Function to detect change about billing address flag */
    vm.changeBillingAddress = function () {
        if (_.get(vm.billingBD, 'billingAddress.ownClient')) {
            delete vm.billingBD.billingAddress;
            vm.billingBD.billingAddress = {
                ownClient: false,
                identity: {docType: vm.constants.docType[0]}
            };
        } else {
            if (_.get(vm.billingBD, 'billingAddress')) {
                vm.billingBD.billingAddress.ownClient = !vm.billingBD.billingAddress.ownClient;
            } else {
                vm.billingBD.billingAddress = {
                    ownClient: true
                };
            }
        }
    };

    /** Create appUser remaining occupancy concepts */
    function generateOccupancyConcepts(clientId) {
        ConceptService.post({idR: 'occupancy'}, {_id: clientId}, function (data) {
            $log.debug('[billingDetail] generateOccupancyConcepts data: ', data);
        }, function (err) {
            $log.error('[billingDetail] generateOccupancyConcepts error: ', err);
        });
    }

    /** Function to detect change of client from select input form */
    vm.changeClient = function () {
        vm.paymentReady = false;
        setTimeout(function () {
            vm.paymentReady = true;
            if (!$rootScope.$$phase) {
                $rootScope.$apply();
            }
        }, 50);

        $log.debug('selected client: ', vm.billingBD.client);
        if (vm.clientTypeSelected.value === 'resident' && _.get(vm.billingBD, 'client._id')) {
            ResidentsService.query({idR: vm.billingBD.client._id}, function (data) {
                vm.billingBD.client = angular.copy(data);
                vm.setClientInfo();
                generateOccupancyConcepts(vm.billingBD.client._id);

                vm.setDocType('identity');
                vm.setDocType('identityAddress');
            }, function (err) {
                $log.error('getResident error: ', err);
                toastr.error(TranslationService.errors.e500);
            });
        } else if (_.get(vm.billing, 'client.item._id')) {
            var guestQuery = {idR: vm.billing.client.item._id};
            GuestService.query(guestQuery.value, function (guestData) {
                vm.billingBD.client = angular.copy(guestData);
                vm.setClientInfo();
                generateOccupancyConcepts(vm.billing.client.item._id);

                vm.setDocType('identity');
                vm.setDocType('identityAddress');
            }, function (err) {
                $log.error('getGuests error: ', err);
                toastr.error(TranslationService.errors.e500);
            });
        } else {
            vm.setClientInfo();
        }
    };

    vm.setClientInfo = function () {
        if (vm.billingBD.client) {
            vm.billingBD.client['email'] = _.get(vm.billingBD.client, 'contact.email');
            vm.billingBD.client['phone'] = _.get(vm.billingBD.client, 'contact.phone');
            vm.billingBD.client['address'] = _.get(vm.billingBD.client, 'contact.address');
            vm.billingBD.client['city'] = _.get(vm.billingBD.client, 'contact.city');
            vm.billingBD.client['postcode'] = _.get(vm.billingBD.client, 'contact.postcode');

            //_.set(vm.billingBD.client, 'billingAddress.ownClient', true);
            setClientCountryState();
        } else {
            vm.billingBD.client = {};
        }
    };

    /** Function to close back billing */
    vm.back = function () {
        vm.anim = false;
        vm.billing = {};
    };

    $rootScope.$on('closeBillingDetail', function () {
        vm.back();
    });

    function getGuests() {
        return new Promise(function (f, r) {
            var query = {idT: routeConf.guest};
            var selectedBranch = localStorageService.get('selectedBarResidence');
            if (selectedBranch) {
                query['branches'] = selectedBranch._id;
            }
            MasterTableService.get(query, function (data) {
                $log.debug('getGuests data: ', data);
                f(data.data);
            }, function (err) {
                $log.error('getGuests error: ', err);
                toastr.error(TranslationService.errors.e500);
                r(err);
            });
        });
    }

    function getResidents() {
        return new Promise(function (f, r) {
            var query = {idT: routeConf.resident};
            var selectedBranch = localStorageService.get('selectedBarResidence');
            if (selectedBranch) {
                query['branches'] = selectedBranch._id;
            }
            MasterTableService.get(query, function (data) {
                $log.debug('getResidents data: ', data);
                f(data.data);
            }, function (err) {
                $log.error('getResidents error: ', err);
                toastr.error(TranslationService.errors.e500);
                r(err);
            });
        });
    }

    vm.getBillingDetail = function () {
        // edit billing
        vm.lockChangeClientType = true;

        // If created new bill close detail and refresh list
        if (vm.billing._id === '0' || vm.billing._id === 0) {
            // Close detail
            delete vm.billing;
            return;
        }
        var query = {idR: vm.billing._id};
        BillingService.get(query, function (billingData) {
            $log.debug('get billing detail data: ', billingData);
        }, function (err) {
            $log.error('get billing detail error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        }).$promise.then(function (data) {
            vm.billingBD = data;
            vm.clientTypes = [
                {name: TranslationService.billing.detail.resident, value: 'resident', check: true},
                {name: TranslationService.billing.detail.guest, value: 'guest', check: false}
            ];
            var tuitionConcept = _.find(vm.billingBD.concepts, {isTuition: true});
            if (tuitionConcept) {
                vm.billingBD.comments = _.get(tuitionConcept, 'description');
            }
            if (_.get(vm.billing, 'client.kind') && vm.billing.client.kind === 'AppUser' && vm.billing.client.item) {
                vm.clientTypeSelected = {value: 'resident'};
                vm.readonlyUserInfo = true;
                ResidentsService.query({idR: vm.billing.client.item._id}, function (data) {
                    vm.billingBD.client = angular.copy(data);
                    vm.setClientInfo();
                    vm.changeClient();
                });
            } else if (_.get(vm.billing, 'client.kind') && vm.billing.client.kind !== 'AppUser' && vm.billing.client.item) {
                _.forEach(vm.clientTypes, function (ct) {
                    if (ct.value === 'guest') {
                        ct.check = true;
                        vm.clientTypeSelected = ct;
                    } else {
                        ct.check = false;
                    }
                });
                vm.readonlyUserInfo = true;
                vm.availableClients = vm.guests;
                GuestService.query({idR: vm.billing.client.item._id}, function (guestData) {
                    vm.billingBD.client = angular.copy(guestData);
                    vm.setClientInfo();
                    vm.setDocType('identity');
                    vm.setDocType('identityAddress');
                });
            }
        });
    };

    vm.newGuest = function () {
        vm.lockChangeClientType = true;
        if (selectedBar && !selectedBar.all) {
            vm.billingBD.client.branches = [selectedBar];
        }
        vm.newGuestMode = true;
    };

    vm.saveNewGuest = function (form) {
        vm.submitted = true;
        if (form.$valid) {
            vm.billingBD.client.contact = {
                email: vm.billingBD.client.email,
                phone: vm.billingBD.client.phone,
                address: vm.billingBD.client.address,
                city: vm.billingBD.client.city,
                postcode: vm.billingBD.client.postcode,
                state: vm.billingBD.client.state,
                country: vm.billingBD.client.country
            };

            vm.savingNewGuest = true;

            vm.billingBD.client.contact.email = vm.billingBD.client.email;

            GuestService.post(vm.billingBD.client, function (guestData) {
                $log.debug('Guest save data', guestData);
                getGuests().then(function (guestsData) {
                    vm.guests = guestsData;

                    vm.billingBD.client = _.find(vm.guests, {_id: guestData._id});

                    // vm.billingBD.client.email = vm.billingBD.client.email;
                    vm.newGuestMode = false;
                    vm.changeClient();
                    $rootScope.$digest();
                });
            }, function (guestErr) {
                $log.error('Guest save error: ', guestErr);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            $log.error('Missing fields');
        }
    };

    vm.$onInit = function () {
        if (vm.billing.action === 'edit') {
            vm.readonly = false;
        }
        tmhDynamicLocale.set(moment.locale());
        if (vm.initialized) {
            return;
        }
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        if (vm.billing._id === '0') {
            vm.clientTypeSelected = {value: 'resident'};
            // new billing
            vm.readonly = false;
            vm.billingBD = {
                branch: (selectedBar && !selectedBar.all) ?
                    selectedBar : vm.constants.branch[0],
                active: true,
                client: {}
            };
            _.set(vm.billingBD, 'billingAddress.ownClient', true);
            vm.setDocType('identity');
            vm.setDocType('identityAddress');
            getResidents().then(function (residentsData) {
                _.forEach(residentsData, function (r) {
                    r['roomAndName'] = '[' + (_.get(r, 'spot.description') ? r.spot.description : '---') + ']' + ' ' + r.fullName;
                });
                vm.residents = residentsData;

                // List residents on new mode
                vm.availableClients = vm.residents;
                vm.readonlyUserInfo = true;
                vm.billingBD.client.kind = 'resident';

                getGuests().then(function (guestsData) {
                    _.forEach(guestsData, function (g) {
                        g['roomAndName'] = g['fullName'];
                    });
                    vm.guests = guestsData;
                    vm.ready = true;
                });
            });

        } else {
            vm.getBillingDetail();
        }
        setPermissions();
    };
}


angular
    .module('Tagaste.billingDetailComponent')
    .component('billingDetailComponent', {
        templateUrl: 'app/components/billing/billingDetail/billingDetail.html',
        controllerAs: 'bidc',
        controller: BillingDetailController,
        bindings: {
            billing: '=',
            constants: '=',
            anim: '='
        }
    });

function BillingListController(NgTableParams, TranslationService, NgTableFilterService, toastr, $log, $rootScope,
                               PermissionsService, localStorageService, MasterTableService, routeConf, $location, $scope, $timeout, $uibModal,
                               RequestService, $filter, RequestExportService, FileSaver, ResidentsService, BillingService, BillingExportService) {
    var vm = this;
    vm.selectr = {};

    vm.anim = false;

    vm.filterDate = {
        formattedDate: {
            id: 'text'
        }
    };

    vm.filterReceipt = {
        proformaNumber: {
            id: 'text'
        }
    };

    vm.filterCode = {
        invoiceNumber: {
            id: 'text'
        }
    };

    vm.filterGroupCode = {
        groupCode: {
            id: 'text'
        }
    };

    vm.filterName = {
        clientName: {
            id: 'text'
        }
    };

    vm.filterSurname = {
        clientSurname: {
            id: 'text'
        }
    };

    vm.filterBranch = {
        branch: {
            id: 'text'
        }
    };

    vm.filterConceptsDescription = {
        conceptsDescription: {
            id: 'text'
        }
    };

    vm.filterPayType = {
        payType: {
            id: 'text'
        }
    };

    vm.filterPayDate = {
        formattedPayDate: {
            id: 'text'
        }
    };

    vm.filterClientType = {
        clientType: {
            id: 'text'
        }
    };

    vm.clientTypes = [
        {id: 'AppUser', name: TranslationService.billing.detail.resident},
        {id: 'Guest', name: TranslationService.billing.detail.guest},
        {id: 'Other', name: TranslationService.billing.detail.other}
    ];

    vm.billingPhase = 'all';
    vm.billingPaid = 'all';
    vm.billingClient = 'all';

    var viewParams = localStorageService.get('billingViewParams') ?
        localStorageService.get('billingViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar) {
        vm.selectedBranch = selectedBar;
        if (!selectedBar.all) {
            viewParams = {filterBillingList: {branch: selectedBar.description}};
        }
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/billing') {
            vm.selectedBranch = data;
            viewParams = {filterBillingList: {branch: (!data.all) ? data.description : ''}};
            iniTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);

    vm.new = function () {
        // swal({
        //     text: TranslationService.modal.newRequestDNI,
        //     input: 'text',
        //     inputLabel: 'DNI',
        //     customClass: 'dniModal',
        //     showCancelButton: true,
        //     confirmButtonText: TranslationService.modal.button.ok,
        //     cancelButtonText: TranslationService.modal.button.cancel
        // }).then(function (result) {
        //     if (result.value) {
        //         ResidentsService.query({identity: result.value}, function (resData) {
        //             if (resData.data.length) {
        //                 vm.selectr = {
        //                     _id: '0',
        //                     readonly: false,
        //                     userid: resData.data[0].id,
        //                     action: 'new'
        //                 };
        //             } else {
        //                 ResidentsService.query({identity: result.value, active: false}, function (resInactiveData) {
        //                     if (resInactiveData.data.length) {
        //                         vm.selectr = {
        //                             _id: '0',
        //                             readonly: false,
        //                             userid: resInactiveData.data[0].id,
        //                             action: 'new'
        //                         };
        //                     } else {
        //                         vm.selectr = {
        //                             _id: '0',
        //                             readonly: false,
        //                             action: 'new',
        //                             docval: result.value
        //                         };
        //                     }
        //                 });
        //             }
        //             if (!vm.anim) {
        //                 $timeout(function () {
        //                     vm.anim = true;
        //                 }, 417);
        //             }
        //         }, function (err) {
        //             $log.error('Error searching DNI', err);
        //             toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
        //                 {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        //         });
        //     }
        // });

        vm.selectr = {
            _id: '0',
            readonly: false,
            action: 'new'
        };

        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 417);
        }
    };

    vm.editRow = function (row) {
        vm.anim = false;
        if (vm.istour) {
            return;
        }
        if (vm.selectr && (vm.selectr.action === 'edit' || vm.selectr._id === '0')) {
            vm.anim = false;
            vm.selectr = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 281);
            }
            _.forEach(vm.tableParams.data, function (r) {
                r.selected = (r._id === row._id);
            });
            row.action = 'edit';
            vm.selectr = row;
        }
    };

    vm.deleteRow = function (row) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                BillingService.delete({idR: row._id}, function (data) {
                    vm.$onInit();
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    $log.error('BillingService delete error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('BILLING', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('BILLING', 'delete');
    }

    vm.getBilling = function () {
        BillingService.get({}, function (data) {
            $log.debug('Billings data: ', data);
            _.forEach(data.data, function (item) {
                item['formattedDate'] = item['date'] ? moment(item['date']).format('L') : '';
                item['clientName'] = _.get(item, 'client.item.name', item['name']);
                item['clientSurname'] = _.get(item, 'client.item.surname', item['surname']);
                var nonDiscountConcepts = _.filter(item['concepts'], function (c) {
                    return !c.amount || c.amount >= 0;
                });
                var occupancyConcepts = _.filter(nonDiscountConcepts, function(c) {
                    return _.get(c, 'related.kind') === 'Occupancy';
                });
                if (occupancyConcepts && occupancyConcepts.length > 1) {
                    item['conceptsDescription'] = TranslationService.billing.list.occupancies;
                } else if (nonDiscountConcepts && nonDiscountConcepts.length > 1) {
                    item['conceptsDescription'] = TranslationService.billing.list.multiple;
                } else {
                    item['conceptsDescription'] = nonDiscountConcepts && nonDiscountConcepts[0] ? nonDiscountConcepts[0].description : '---';
                }
                item['payType'] = _.get(item, 'paidData.payType.description');
                item['formattedPayDate'] = item['payDate'] ? moment(item['payDate']).format('L') : '';
                item['clientType'] = _.get(_.find(vm.clientTypes, {id: _.get(item, 'client.kind')}), 'name');
                item['amount'] = vm.calcTotalConcepts(item['concepts']);
            });
        }).$promise.then(function (data) {
            var list = data.data;
            _.forEach(list, function (itemBilling) {
                itemBilling['branch'] = itemBilling['branch']['description'];
            });
            iniTable(list);
            vm.initialized = true;
            vm.list = list;
            return list;
        });
    };

    vm.rowClick = function (row) {
        row.action = '';
        vm.anim = false;
        if (vm.istour) {
            return;
        }
        if (vm.selectr && (vm.selectr.action === 'edit' || vm.selectr._id === '0')) {
            vm.anim = false;
            vm.selectr = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 281);
            }
            if (vm.tableParams) {
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });
            }
            vm.selectr = row;
        }
    };

    function iniTable(list) {
        if (!list) {
            list = [];
        }

        for (var i = 0; i < list.length; i++) {
            list[i].residenceDesc = '';
        }

        var sorting = viewParams['sortingBillingList'] ? viewParams['sortingBillingList'] : {formattedDate: 'desc'};
        var page = viewParams['pageBillingList'] ? viewParams['pageBillingList'] : 1;
        var count = viewParams['countBillingList'] ? viewParams['countBillingList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingBillingList'] = params._params.sorting;
                        viewParams['pageBillingList'] = page;
                        viewParams['countBillingList'] = params._params.count;
                        viewParams['filterBillingList'] = filterObj;
                        localStorageService.set('BillingViewParams', viewParams);

                        params.total(filteredData.length);
                        vm.currentTableData = filteredData;
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );
        var savedFilters = viewParams['filterBillingList'] ? viewParams['filterBillingList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    vm.billingForecast = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/modal/modalBillingForecast/modalBillingForecast.html',
            controller: 'ModalBillingForecastController',
            controllerAs: 'mbfc',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalBinding: function () {
                    return {
                        branch: vm.selectedBranch
                    };
                }
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            if (result) {
                vm.selectr = {};
                vm.getBilling();
            }
        }, function (closemsg) {
            //dismiss function
        });
    };

    vm.exportData = function () {
        var filename = TranslationService.billing.exportTitle.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = TranslationService.billing.export;

        var billingData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function (e) {
                return e._id;
            }),
            filename: filename,
        };

        BillingExportService.post(
            {}, billingData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('BillingExportService error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
    };

    vm.$doCheck = function () {
        if (vm.selectr && vm.selectr.action === 'refList') {
            vm.initialized = false;
            vm.$onInit();
        }
    };

    vm.applyAdditionalFilters = function (option) {
        var list = JSON.parse(JSON.stringify(vm.list));
        var filteredList1 = vm.changePhaseFilter(list);
        var filteredList2 = vm.changePaidFilter(filteredList1);
        var filteredList3 = vm.changeClientFilter(filteredList2);
        iniTable(filteredList3);
    };

    vm.changePhaseFilter = function (list) {
        if (vm.billingPhase === true) {
            return _.filter(list, function (i) {
                return _.get(i, 'invoiceNumber');
            });
        } else if (vm.billingPhase === false) {
            return _.filter(list, function (i) {
                return _.get(i, 'proformaNumber') && !_.get(i, 'invoiceNumber');
            });
        } else {
            return list;
        }
    };

    vm.changePaidFilter = function (list) {
        if (vm.billingPaid === true) {
            return _.filter(list, function (i) {
                return _.get(i, 'payDate');
            });
        } else if (vm.billingPaid === false) {
            return _.filter(list, function (i) {
                return !_.get(i, 'payDate');
            });
        } else {
            return list;
        }
    };

    vm.changeClientFilter = function (list) {
        if (vm.billingClient === true) {
            return _.filter(list, function (i) {
                return _.get(i, 'clientType') === TranslationService.billing.detail.resident;
            });
        } else if (vm.billingClient === false) {
            return _.filter(list, function (i) {
                return _.get(i, 'clientType') && _.get(i, 'clientType') !== TranslationService.billing.detail.resident;
            });
        } else {
            return list;
        }
    };

    vm.calcTotalConcepts = function (selectedConcepts) {
        var conceptsTotal = 0;
        var svcTotal = 0;
        _.forEach(selectedConcepts, function (svc) {
            if (svc.amount >= 0) {
                var svcTotal = svc.amount ? svc.amount : 0;
                if (svc.discountF) {
                    svcTotal -= svc.discountF;
                }
                if (svc.discountP) {
                    svcTotal -= svc.discountP * svc.amount / 100;
                }

                _.forEach(svc.taxes, function (svcTax) {
                    if (svcTax.isPercentage) {
                        svcTotal = svcTotal + (svc.amount * (svcTax.rate / 100));
                    } else {
                        svcTotal = svcTotal + svcTax.rate;
                    }
                });
                conceptsTotal = Math.round((conceptsTotal + svcTotal) * 100) / 100;
            }
        });
        return conceptsTotal;
    };

    $rootScope.$on('openBillingDetail', function (event, billing) {
        if (billing && billing._id) {
            vm.editRow(billing);
        } else {
            vm.new();
        }
    });

    $rootScope.$on('setDummyDni', function () {
        var input = _.first(document.getElementsByClassName('swal2-input'));
        input.value = vm.dummyDni;
    });

    $rootScope.$on('confirmDummyDni', function () {
        var button = _.first(document.getElementsByClassName('swal2-confirm'));
        button.click();
    });

    $rootScope.$on('openBillingDetailFirstRow', function () {
        if (vm.tourDummyData.length < 1) {
            var row = vm.tableParams.data[0];
            if (!row.error) {
                if (vm.modeCreation) {
                    vm.showIncidentView = false;
                    vm.anim = false;
                    vm.modeReadOnly = false;
                    vm.modeCreation = false;

                } else {
                    if (!vm.anim) {
                        $timeout(function () {
                            vm.anim = true;
                        }, 401);
                    }
                    _.forEach(vm.tableParams.data, function (r) {
                        r.selected = (r._id === row._id);
                    });
                    vm.modeReadOnly = true;
                    vm.showIncidentView = true;
                    vm.modeCreation = false;
                    vm.selectBilling = row._id;
                    $log.debug('selected billing', row);
                }
            }
        } else {
            vm.new();
        }
    });

    $rootScope.$on('reloadBillingList', function () {
        vm.selectr = {};
        vm.getBilling();
    });

    vm.$onInit = function () {
        setPermissions();
        vm.selectr = {};
        vm.anim = false;
        vm.tableParams = null;
        vm.anim = false;
        vm.getBilling();
    };
}

angular
    .module('Tagaste.billingListComponent')
    .component('billingListComponent', {
        templateUrl: 'app/components/billing/billingList/billingList.html',
        controllerAs: 'bilsc',
        controller: BillingListController,
        bindings: {
            selectr: '=',
            list: '=',
            anim: '=',
            initTour: '&',
            tourDummyData: '=',
            istour: '<'
        }
    });

function bedroomDetailController($log, TranslationService, $timeout, tmhDynamicLocale, routeConf, NgTableParams,
                                 MasterTableService, baUtil, PermissionsService, localStorageService, $rootScope, $scope,
                                 $location, $http, toastr, ResidentsService, ConfigService, SpotService, CleaningTasks) {
    var vm = this;
    vm.resident = undefined;
    vm.reservation = undefined;
    vm.avatar = undefined;
    vm.selectedRoomState = undefined;
    vm.selectedRoomType = undefined;
    vm.spotId = undefined;
    vm.setToClean = false;
    vm.workerTask = [];
    vm.incidents = [];
    vm.inventory = [];
    vm.inventoryTagsAvailable = [];
    vm.accordions = {};
    vm.isDetail = false;
    vm.originalIncidents = [];
    vm.dateFrom = undefined;
    vm.dateTo = undefined;

    // Get worker Tasks
    vm.getWorkerTasks = function () {
        MasterTableService.get({idT: routeConf.workerTask, idJ: 'open', spot: vm.spotId}, function (workerTaskData) {
            $log.debug('WorkerTask Data: ', workerTaskData);
            vm.workerTask = workerTaskData.data;
        }, function (wterr) {
            toastr.error(TranslationService.errors.e500);
            $log.error('Error loading workerTask', wterr);
        });
    };

    // Get Incidents
    vm.getIncidents = function () {
        MasterTableService.get({idT: routeConf.app, idJ: routeConf.incident, spot: vm.spotId}, function (incidentsData) {
            $log.debug('Incidents data: ', incidentsData);
            vm.originalIncidents = incidentsData.data;
            vm.incidents = angular.copy(vm.originalIncidents);
        }, function (incerr) {
            toastr.error(TranslationService.errors.err500);
            $log.error('Error getting incidents', incerr);
        });
    };

    // Function to cancel cleaning room settings
    vm.cancelClean = function () {
        vm.setToClean = false;
        vm.selectedCleanTask = undefined;
        vm.showOtherCleanTak = false;
        vm.observations = undefined;
        vm.duration = undefined;
    };

    // Function to save cleaning room settings
    vm.saveSetClean = function () {
        if (vm.selectedCleanTask && vm.selectedCleanTask._id) {
            var cleanTask = {
                branch: localStorageService.get('selectedBarResidence')._id,
                spot: vm.spotId,
                taskType: vm.selectedCleanTask._id
            };

            if (vm.selectedCleanTask['code'] === CleaningTasks.others && (!vm.observations || !vm.duration)) {
                toastr.warning(TranslationService.bedroomDetail.cleanTaskObligatoryFields);
                return;
            } else {
                cleanTask['observations'] = vm.observations;
                cleanTask['duration'] = moment.duration(parseInt(vm.duration), 'minutes').asMilliseconds();
            }
            MasterTableService.post({idT: routeConf.workerTask}, cleanTask, function (cleanRes) {
                $log.debug(cleanRes);
                toastr.success(TranslationService.dialog.saveok);
                vm.cancelClean();
                vm.getWorkerTasks();
                vm.modeDismiss = 'toClean';
            }, function (cleanErr) {
                $log.error('error load reservation detail: ', cleanErr);
                toastr.error(TranslationService.errors.e500);
            });
        } else {
            toastr.warning(TranslationService.bedroomDetail.selectCleanTask);
        }
    };

    // Function to get ocupation detail
    vm.getOccupiedDetail = function (occupancyId) {
        // Get detail ocupation from id ocupation
        MasterTableService.get({idT: routeConf.occupancy, idJ: occupancyId}, function (data) {
            vm.reservation = data;

            $log.debug('Reservation detail: ', data);
            vm.spotId = vm.reservation.room._id;
            // vm.roomCode = vm.reservation.room.code;

            vm.getWorkerTasks();
            vm.getIncidents();
            //  Get detail from client / resident
            if (vm.reservation.client) {
                ResidentsService.query({idR: vm.reservation.client.item.id}, function (clientData) {
                    $log.debug('Resident detail: ', clientData);
                    vm.resident = clientData;

                    // Get avatar
                    if (vm.resident.photo && vm.resident.photo.original.key) {
                        MasterTableService.get({
                            idT: routeConf.file, idJ: routeConf.signedUrl,
                            key: vm.resident.photo.original.key,
                            bucket: vm.resident.photo.original.bucket
                        }, function (data) {
                            vm.avatar = data.url;
                            vm.avatarOri = angular.copy(vm.avatar);
                        }, function (err) {
                            $log.error(err);
                            toastr.error(TranslationService.errors.e500);
                        });
                    }

                }, function (clientErr) {
                    toastr.error(TranslationService.errors.e500);
                    vm.resident = {};
                    vm.ready = true;
                });
            }
        }, function (err) {
            $log.error('error load reservation detail: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    /** initialization room rates table */
    function iniRoomRatesTable() {
        vm.roomRatesTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'desc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: vm.roomRates.length,
                    dataset: vm.roomRates
                }
            );
    }

    /** initialization inventory table */
    function iniInventoryTable(isDetail) {
        vm.inventoryTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'desc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: isDetail ? vm.inventory.length : 0,
                    dataset: isDetail ? vm.inventory : []
                }
            );
    }

    /** Function to add new inventoryItem row */
    vm.addInventoryItem = function () {
        vm.addingInventoryItem = true;
        vm.inventoryTableParams.settings().dataset.unshift({
            modeEdit: true,
            selected: vm.inventoryTagsAvailable[0]
        });
        vm.inventoryTableParams.sorting({});
        vm.inventoryTableParams.page(1);
        vm.inventoryTableParams.reload();
    };

    /** Function to enter edit mode inventoryItem */
    vm.editInventoryItem = function (inventoryItem, index) {
        if (index !== 0 || inventoryItem._id) {
            vm.tempInventoryItem = angular.copy(inventoryItem);
        }
        inventoryItem.modeEdit = true;
        vm.temporalInventoryItem = angular.copy(inventoryItem);
    };

    /** Function to cancel (Edit / New) inventoryItem */
    vm.cancelInventoryItem = function (inventoryItem, index) {
        inventoryItem.modeEdit = false;

        if (index === 0 && !inventoryItem._id) {
            _.remove(vm.inventoryTableParams.settings().dataset, function (item) {
                return inventoryItem === item;
            });
        } else {
            vm.inventoryTableParams.data[index] = vm.tempInventoryItem;
        }
        if (vm.addingInventoryItem) {
            vm.inventoryTableParams.reload();
            vm.addingInventoryItem = false;
        }
        vm.addingInventoryItem = false;
    };

    /** Function to accept inventoryItem row (new/edit) */
    vm.saveInventoryItem = function (inventoryItem, index) {
        inventoryItem.modeEdit = false;
        vm.inventoryTableParams.data[index] = inventoryItem.selected;
        vm.inventory = vm.inventoryTableParams.data;
        iniInventoryTable(true);
        vm.inventoryTableParams.reload();
        vm.addingInventoryItem = false;
        getAvailableInventoryTags();
    };

    /** Function to delete inventoryItem row */
    vm.deleteInventoryItem = function (inventoryItem, index) {
        _.pullAt(vm.inventory, index);
        iniInventoryTable(true);
        vm.inventoryTableParams.reload();
        getAvailableInventoryTags();
    };

    vm.back = function () {
        vm.anim = false;
        vm.showBedroomDetail = false;
        vm.selectedBedroom = {};
    };

    vm.getRoomRates = function () {
        if (vm.selectedRoomType) {
            var selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));
            ConfigService.query({
                component: 'roomrate',
                roomType: _.get(vm.selectedRoomType, '_id', vm.selectedRoomType),
                branch: _.get(selectedBranch, '_id', null)
            }, function (response) {
                $log.debug('get room rates data: ', response);
                vm.roomRates = response;
                iniRoomRatesTable();
            }, function (err) {
                $log.error('get room rates error: ', err);
                toastr.error(TranslationService.errors.err500);
            });
        } else {
            vm.roomRates = [];
            iniRoomRatesTable();
        }
    };

    function getRoomStates() {
        vm.selectedRoomState = [];
        _.forOwn(vm.selectedBedroom['today'], function (value, key) {
            var state = _.find(vm.statesRooms, {code: key});
            if (value && state) {
                vm.selectedRoomState.push(state);
            }
        });
        $log.debug('bedroom states: ', vm.selectedRoomState);
    }

    vm.saveSpot = function () {
        var spotObj = angular.copy(vm.selectedBedroom.spot);
        spotObj['inventory'] = vm.inventory;
        spotObj['roomType'] = vm.selectedRoomType._id;
        SpotService.post({idS: vm.selectedBedroom.spot._id}, spotObj, function (data) {
            $log.debug('SpotService post data: ', data);
            $rootScope.$emit('refreshBedrooms');
            vm.back();
        }, function (err) {
            $log.error('SpotService post error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.$onInit = function () {

        if(vm.selectedBedroom && vm.selectedBedroom.spot) {
            vm.spotId = vm.selectedBedroom.spot._id;
        }
        // Get Clean (first get parent task id and after get clean tasks)
        MasterTableService.query({
            idT: routeConf.masterTable,
            idJ: routeConf.config,
            functionality: 'taskTypes',
            code: 'cleaning'
        }, function (cleaningParentData) {
            $log.debug('Cleaning parent data: ', cleaningParentData);
            var cleaningParentID = cleaningParentData[0]._id;
            // Get clean tasks
            MasterTableService.query({
                idT: routeConf.masterTable, idJ: 'taskType', taskParent: cleaningParentID,
                branches: localStorageService.get('selectedBarResidence')._id
            }, function (cleaningTasksData) {
                $log.debug('Cleaning tasks: ', cleaningTasksData);
                vm.cleaningTasks = cleaningTasksData;
            }, function (clterr) {
                toastr.error(TranslationService.errors.err500);
                $log.error('Error getting cleaning parent', clterr);
            });
        }, function (clpaerr) {
            toastr.error(TranslationService.errors.err500);
            $log.error('Error getting cleaning parent', clpaerr);
        });
        $log.debug('[bedroomDetail] inventory available: ', vm.inventoryTags);

        if(!vm.selectedRoomType) { vm.accordions.roomtype = true; }

    };

    function getAvailableInventoryTags() {
        vm.inventoryTagsAvailable = _.filter(vm.inventoryTags, function (item) {
            return _.findIndex(vm.inventory, {_id: item._id}) === -1;
        });
    }

    vm.$onChanges = function (changeValue) {
        vm.isDetail = changeValue.selectedBedroom && changeValue.selectedBedroom.currentValue;
        if (vm.isDetail) {
            vm.resident = undefined;
            vm.reservation = undefined;
            vm.avatar = undefined;
            vm.bedroom = angular.copy(vm.selectedBedroom);
            $log.debug('[bedroomDetail - selectedRoom]', vm.bedroom);
            vm.selectedRoomType = _.find(vm.roomTypes, {_id: _.get(vm.bedroom, 'spot.roomType._id', vm.bedroom.spot.roomType)});
            $log.debug('selectedRoomType: ', vm.selectedRoomType);
            getRoomStates();
            vm.getRoomRates();
            vm.inventory = angular.copy(vm.bedroom.spot.inventory);
            if (vm.bedroom.today && vm.bedroom.today.occupancyId) {
                $log.debug('[bedroomDetail - occupancyId]', vm.bedroom.today.occupancyId);
                vm.getOccupiedDetail(vm.bedroom.today.occupancyId);
            }
        }
        iniInventoryTable(vm.isDetail);
        getAvailableInventoryTags();
    };

    vm.filterIncidents = function () {
        var filterIncidents = vm.originalIncidents;
        if (vm.dateFrom) {
            var dateFormStartDay = moment(vm.dateFrom).startOf('day');
            filterIncidents = _.filter(filterIncidents, function (incident) {
                return moment(incident.date).startOf('day').isSameOrAfter(dateFormStartDay);
            });
        }
        if (vm.dateTo) {
            var dateToEnDay = moment(vm.dateTo).endOf('day');
            filterIncidents = _.filter(filterIncidents, function (incident) {
                return moment(incident.date).startOf('day').isSameOrBefore(dateToEnDay);
            });
        }
        vm.incidents = filterIncidents;

    };

    vm.changeCleanTask = function () {
        vm.observations = '';
        vm.duration = undefined;
        vm.showOtherCleanTak = vm.selectedCleanTask ? vm.selectedCleanTask['code'] === CleaningTasks.others : false;
    };

    $rootScope.$on('openInventory', function () {
        vm.accordions.inventory = true;
        vm.addInventoryItem();
    });

    $rootScope.$on('openRoomType', function () {
        vm.accordions.roomtype = true;
        vm.selectedRoomType = vm.roomTypes[0];
        vm.getRoomRates();
    });

    $rootScope.$on('closeRoomDetail', function () {
        vm.back();
    });

    $rootScope.$on('openActiveTask', function () {
        vm.accordions.workertask = true;
    });
    $rootScope.$on('setToClean', function () {
        vm.setToClean = true;
        vm.selectedCleanTask = vm.cleaningTasks[0];
    });
}

angular
    .module('Tagaste.bedroomDetailCom')
    .component('bedroomDetail', {
        templateUrl: 'app/components/bedrooms/bedroomDetail/bedroomDetail.html',
        controllerAs: 'brdc',
        controller: bedroomDetailController,
        bindings: {
            selectedBedroom: '<',
            statesRooms: '<',
            showBedroomDetail: '=',
            anim: '=',
            inventoryTags: '<',
            roomTypes: '<'
        }
    });

function bedroomsListController($log, TranslationService, $timeout, tmhDynamicLocale, routeConf, ConfigService,
                                MasterTableService, baUtil, PermissionsService, localStorageService, $rootScope, $scope,
                                $location, $http, toastr, TourService) {
    var vm = this;
    vm.anim = false;
    vm.bedrooms = [];
    vm.floors = [];
    vm.dateFrom = moment().toDate();
    vm.dateFromOri = angular.copy(vm.dateFrom);
    vm.istour = false;
    vm.inventoryTags = [];
    vm.inventoryTagsSelected = [];
    vm.loading = false;
    vm.originalBedrooms = [];
    vm.selectedBar = localStorageService.get('selectedBarResidence');
    vm.gotAccessCreate = false;
    vm.states = [];
    vm.typeRoom = undefined;
    vm.tourDummyData = [];
    vm.istour = false;

    var viewParams = localStorageService.get('bedroomsViewParams') ?
        localStorageService.get('bedroomsViewParams') : {};
    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.selectedBar = data;
        viewParams = {filterServicesList: {branchDescription: (!data.all) ? data.description : ''}};
        if ($location.path() === '/rooms' && !data.all) {
            getSources();
        }
    });
    $scope.$on('$destroy', unregister);

    vm.cleanFilter = function (type) {
        switch (type) {
            case 'type':
                vm.typeRoom = undefined;
                break;
            case 'state':
                vm.states = [];
                break;
            case 'inventory':
                vm.inventoryTagsSelected = [];
                break;
        }
        setFilters();
    };

    vm.checkAlert = function () {
        return _.find(vm.bedrooms, function(b) {
            return _.get(b, 'today.isCheckIn') && _.get(b, 'today.isCheckOut');
        });
    };

    vm.dayChanged = function () {
        if (vm.dateFrom && vm.dateFrom.getTime() !== vm.dateFromOri.getTime()) {
            vm.dateFromOri = vm.dateFrom;
            getBedrooms().then(function (response) {
                $log.debug('bedroomsRack: ', response);
                vm.originalBedrooms = response;
                setFilters();
            }, function (error) {
                $log.error('bedroomsRack error : ', error);
            });
        }
    };

    //If we need to init tour
    vm.initTour = function () {
        _initTour(true);
    };

    vm.onChangeFilter = function () {
        setFilters();
    };

    vm.openDetail = function (room) {
        vm.selectedBedroom = room;
        vm.showBedroomDetail = true;
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
    };

    function getBedrooms() {
        var query = {idT: routeConf.planningRoom, isRack: true};
        if (vm.selectedBar && !vm.selectedBar.all) {
            query.branch = vm.selectedBar._id;
        }
        if (vm.dateFrom) {
            query.dateFrom = vm.dateFrom;
        }
        return new Promise(function (f, r) {
            MasterTableService.query(query, function (data) {
                $log.debug('getSources data: ', data);
                var res = angular.copy(data);
                f(res[0].data);
            }, function (err) {
                $log.error('getSources error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                r(err);
            });
        });
    }

    function getSources() {
        var promiseArray = [];
        promiseArray.push(getBedrooms());
        Promise.all(promiseArray).then(function (arrRes) {
            vm.originalBedrooms = arrRes[0];
            setFilters();
            if (TourService.shouldShowRackRoomTour()) {
                _initTour(true);
            }
        }, function (err) {
            toastr.error(TranslationService.errors.e500);
            $log.error('Error getting initial data', err);
        });
    }

    function _initTour(forceTour) {
        vm.istour = true;
        if (vm.bedrooms.length < 1) {
            vm.tourDummyData.push({
                'spot': {
                    '_id': 'dummy',
                    'code': '000',
                    'description': 'H000',
                    'floor': 0,
                    'inventory': []
                },
                'schedules': {'date': '2021-08-30', 'isOccupied': false, 'isReserved': false, 'isEmpty': true},
                'today': {
                    'date': '2021-08-30',
                    'isEmpty': true,
                    'isOccupied': false,
                    'isReserved': 0,
                    'isToClean': false,
                    'reservation': []
                }
            });
            setFormatData(vm.tourDummyData);
        }
        return TourService.rackRoomTour(forceTour).then(function () {
            vm.istour = false;
        });
    }

    function setFilters() {
        var filteredRooms = angular.copy(vm.originalBedrooms);
        if (vm.typeRoom && vm.typeRoom['code']) {
            filteredRooms = _.filter(filteredRooms, function (room) {
                return vm.typeRoom['code'] === _.get(room, 'spot.roomType.code');
            });
        }
        if (vm.states.length > 0) {
            filteredRooms = _.filter(filteredRooms, function (room) {
                return _.every(vm.states, function (el) {
                    return room['today'][el];
                });
            });
        }
        if (vm.inventoryTagsSelected.length > 0) {
            filteredRooms = _.filter(filteredRooms, function (room) {
                return _.every(vm.inventoryTagsSelected, function (el) {
                    return _.findIndex(room['spot']['inventory'], function (ro) {
                        return ro['description'] === el;
                    }) !== -1;
                });
            });
        }
        setFormatData(filteredRooms);
    }

    function setFormatData(data) {
        // Array de items iterables (numero de planta y habitaciones...)
        vm.bedrooms = [];
        // Array de plantas para comprobar luego cuales son pares y cuales impares segun su indice en el array
        vm.floors = [];
        var groupedItems = _.groupBy(data, 'spot.floor');
        _.forEach(groupedItems, function (floor) {
            // Cada planta añadimos el numero de planta al array de bedrooms con solo el valor floor
            vm.bedrooms.push({floor: floor[0].spot.floor});
            // Añadimos el numero de planta al array de plantas
            vm.floors.push(floor[0].spot.floor);

            // Añadimos todas las habitaciones de esa planta al array de bedrooms
            vm.bedrooms = _.concat(vm.bedrooms, floor);
        });
        if ($scope.$root.$$phase !== '$apply' && $scope.$root.$$phase !== '$digest') {
            $scope.$digest();
        }
    }

    function setPermissions() {
        vm.gotAccessCreate = PermissionsService.gotPermission('RESIDENT', 'UPDATE');
    }

    vm.$onInit = function () {
        vm.selectedBar = localStorageService.get('selectedBarResidence');
        setPermissions();
        if (vm.selectedBar && !vm.selectedBar.all) {
            getSources();
        }
    };

    $timeout(function () {
        tmhDynamicLocale.set(moment.locale());
    });

    $rootScope.$on('refreshBedrooms', function () {
        getSources();
    });

    $rootScope.$on('openRoomDetail', function () {
        vm.openDetail(vm.bedrooms[1]);
    });

    vm.$onDestroy = function () {
        localStorageService.set('bedroomsViewParams', null);
    };
}

angular
    .module('Tagaste.bedroomsListCom')
    .component('bedroomsList', {
        templateUrl: 'app/components/bedrooms/bedroomsList/bedroomsList.html',
        controllerAs: 'blstc',
        controller: bedroomsListController,
        bindings: {
            selectedBedroom: '=',
            showBedroomDetail: '=',
            anim: '=',
            statesRooms: '<',
            inventoryTags: '<',
            roomTypes: '<'
        }
    });

function bulletinBoardDetailController(ENV, MasterTableService, $log, toastr, TranslationService, localStorageService,
                                       BulletinBoardService, routeConf, NgTableFilterService, $rootScope) {
    var vm = this;

    vm.avatarUploading = false;
    /**
     * @ngdoc method
     * @name init
     * @methodOf BlurAdmin.bulletinBoardDetailCom.controller:bulletinBoardDetailController
     * @description
     * Method that load data of bulletin
     *
     */

    var selectedBar = localStorageService.get('selectedBarResidence');
    function init() {
        vm.img = '';
        vm.popupFrom = {
            opened: false
        };
        vm.popupTo = {
            opened: false
        };
        vm.dateOptions = {
            minDate: moment().toDate(),
            showWeeks: false
        };
        $log.debug('vm.bulletinId', vm.bulletinId);
        if (vm.modeReadOnly || vm.modeEdit) {
            BulletinBoardService.get({idB: vm.bulletinId}, function (data) {
                vm.bulletin = data;
                if (vm.bulletin.photo && vm.bulletin.photo.original.key) {
                    MasterTableService.get({
                        idT: routeConf.file, idJ: routeConf.signedUrl, key: vm.bulletin.photo.original.key,
                        bucket: vm.bulletin.photo.original.bucket
                    }, function (data) {
                        $log.debug('load photo bulletin success', data.url);
                        vm.avatar = data.url;
                    }, function (err) {
                        $log.error('error load photo bulletin', err);
                    });
                }
                if (vm.modeEdit) {
                    loadAllLocalities();
                }
                else {
                    vm.avatar = null;
                }
                $log.debug('load bulletin detail data', data);
                vm.visibleFrom = moment(vm.bulletin.dateFrom).toDate();
                vm.visibleTo = moment(vm.bulletin.dateTo).toDate();
            }, function (err) {
                $log.error('error load bulletinboard detail', err);
                toastr.error(TranslationService.errors.e500);
            });
        } else {
            vm.bulletin = {
                branches : (selectedBar && !selectedBar.all ) ? [selectedBar] : []
            };
            loadAllLocalities();
            vm.visibleFrom = moment().toDate();
            vm.visibleTo = moment().add(7, 'days').toDate();
        }
    }

    vm.$doCheck = function () {
        if (!vm.previousBulletinId) {
            vm.previousBulletinId = vm.bulletinId;
            init();
        } else if (vm.previousBulletinId !== vm.bulletinId) {
            vm.previousBulletinId = vm.bulletinId;
            init();
        }
    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf BlurAdmin.bulletinBoardDetailCom.controller:bulletinBoardDetailController
     * @description
     * Method that redirect to list of bulletin board
     *
     */
    vm.cancel = function () {
        vm.showBulletinView = false;
        vm.anim = false;
        vm.bulletin = {};
        vm.modeEdit = false;
        vm.modeCreation = false;
    };

    /**
     * @ngdoc method
     * @name save
     * @methodOf BlurAdmin.bulletinBoardDetailCom.controller:bulletinBoardDetailController
     * @description
     * Method that save a new bulletin
     *
     */
    vm.save = function (form) {
        vm.showError = false;
        var query = {};
        if (form.$valid) {
            vm.bulletin.dateFrom = moment(vm.visibleFrom).startOf('day');
            vm.bulletin.dateTo = moment(vm.visibleTo).endOf('day');
            $log.debug('bulletin to save', vm.bulletin);
            if (vm.modeEdit) {
                query.idB = vm.bulletin._id;
            }
            BulletinBoardService.post(query, vm.bulletin, function (response) {
                $log.debug('create bulletin success', response);
                vm.showBulletinView = false;
                vm.anim = false;
                vm.bulletin = {};
                vm.onUpdated({value: ''});
                if (vm.modeEdit) {
                    toastr.success(TranslationService.bulletinDetail.msg.edit);
                } else {
                    toastr.success(TranslationService.bulletinDetail.msg.success);
                }

            }, function (err) {
                $log.error('error create bulletin');
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            vm.showError = true;
        }
    };

    /**
     * @ngdoc method
     * @name checkDates
     * @methodOf BlurAdmin.bulletinBoardDetailCom.controller:bulletinBoardDetailController
     * @description
     * Method that check if dateFrom is later that dateTo
     *
     */
    vm.checkDates = function () {
        return vm.visibleTo && vm.visibleFrom && moment(vm.visibleFrom).isAfter(moment(vm.visibleTo));
    };

    /**
     * @ngdoc method
     * @name loadAllLocalities
     * @methodOf BlurAdmin.bulletinBoardDetailCom.controller:bulletinBoardDetailController
     * @description
     * Method that load all localities of a user
     *
     */
    function loadAllLocalities() {
        MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.branch}, function (data) {
            var allLocalities = data;
            $log.debug('master table branch load success', data);
            var userBranch = localStorageService.get('branches');
            vm.localities = [];
            for (var i = 0; i < allLocalities.length; i++) {
                for (var j = 0; j < userBranch.length; j++) {
                    if (userBranch[j] === allLocalities[i]._id) {
                        vm.localities.push(allLocalities[i]);
                    }
                }
            }
            //created filter due to ui-select multiple don´t allow track by $index
            if (vm.modeEdit) {
                vm.auxBraches = angular.copy(vm.bulletin.branches);
                vm.bulletin.branches = [];
                var auxItem = {};
                for (var l = 0; l < vm.auxBraches.length; l++) {
                    auxItem = _.find(vm.localities, function (o) {
                        return o._id === vm.auxBraches[l]._id;
                    });
                    if (auxItem) {
                        vm.bulletin.branches.push(auxItem);
                    }
                }
            }
            $log.debug('localities', vm.localities);
        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    }

    $rootScope.$on('closeBulletinDetail', function () {
        vm.cancel();
    });
}


angular
    .module('BlurAdmin.bulletinBoardDetailCom')
    .component('bulletinBoardDetail', {
        templateUrl: 'app/components/bulletinBoard/bulletinBoardDetail/bulletinBoardDetail.html',
        controllerAs: 'bbdc',
        controller: bulletinBoardDetailController,
        bindings: {
            bulletinId: '=',
            modeReadOnly: '=',
            showBulletinView: '=',
            anim: '=',
            onUpdated: '&',
            modeEdit: '=',
            modeCreation: '=',
            istour: '<'
        }
    });
bulletinBoardListController.$inject = ['NgTableParams', 'NgTableFilterService', '$log', '$timeout',
                                    'localStorageService', 'MasterTableService', 'routeConf', 'TranslationService',
                                    'toastr', 'tmhDynamicLocale', '$rootScope', 'PermissionsService',
                                    '$filter', '$location', '$scope'];

function bulletinBoardListController(NgTableParams, NgTableFilterService, $log, $timeout, localStorageService,
                                     MasterTableService, routeConf, TranslationService, toastr, tmhDynamicLocale,
                                     $rootScope, PermissionsService, $filter, $location, $scope) {
    var vm = this;

    vm.tableParams = {};
    vm.select = {};
    vm.selectbulletin = {};
    vm.anim = false;
    vm.readOnly = false;
    vm.showBulletinView = false;
    vm.gotAccessMod = false;
    vm.gotAccessDel = false;

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('BBOARD', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('BBOARD', 'delete');
    }

    vm.filterLocality = {
        localities: {
            id: 'text'
        }
    };
    vm.filterTitle = {
        title: {
            id: 'text'
        }
    };
    vm.filterDateFrom = {
        dateFrom: {
            id: 'text'
        }
    };
    vm.filterDateTo = {
        dateTo: {
            id: 'text'
        }
    };

    var viewParams = localStorageService.get('bulletinViewParams') ?
        localStorageService.get('bulletinViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = {filterBulletinList : {localities : selectedBar.description} };
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/bulletinBoard') {
            viewParams = {filterBulletinList : {localities : (!data.all) ? data.description : ''} };
            initTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);

    vm.$onInit = function () {
        tmhDynamicLocale.set(moment.locale());
        vm.pagg = vm.pag;
        setPermissions();
        vm.userBranch = localStorageService.get('branches');
        vm.tableParams = null;
        initTable(vm.list);
    };

    vm.$onDestroy = function () {
        localStorageService.set('bulletinViewParams', null);
    };

    vm.$onChanges = function (changeValue) {
        vm.pagg = vm.pag;
        if (changeValue.list && changeValue.list.currentValue) {
            initTable(changeValue.list.currentValue);
        }
    };

    /**
     * @ngdoc method
     * @name initTable
     * @methodOf BlurAdmin.bulletinBoardListCom.controller:bulletinBoardListController
     * @description
     * Method that load data of table of bulletin board
     *
     */
    function initTable(list) {
        if (!list) {
            list = [];
        }
        //add all localities
        for (var i = 0; i < list.length; i++) {
            list[i].localities = '';
            for (var j = 0; j < list[i].branches.length; j++) {
                list[i].localities += _.isEmpty(list[i].localities) ? list[i].branches[j].description : ', ' +
                    list[i].branches[j].description;
            }
            list[i].dateFormatFrom = moment(list[i].dateFrom).format();
            list[i].dateFormatTo = moment(list[i].dateTo).format();
        }

        var sorting = viewParams['sortingBulletinList'] ? viewParams['sortingBulletinList'] : {dateFrom: 'desc'};
        var page = viewParams['pageBulletinList'] ? viewParams['pageBulletinList'] : 1;
        var count = viewParams['countBulletinList'] ? viewParams['countBulletinList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingBulletinList'] = params._params.sorting;
                        viewParams['pageBulletinList'] = page;
                        viewParams['countBulletinList'] = params._params.count;
                        viewParams['filterBulletinList'] = filterObj;
                        localStorageService.set('bulletinViewParams', viewParams);

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterBulletinList'] ? viewParams['filterBulletinList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    /**
     * @ngdoc method
     * @name tableParamsCK
     * @methodOf BlurAdmin.bulletinBoardListCom.controller:bulletinBoardListController
     * @description
     * Method that marked a row of table and show detail of bulletin
     *
     */
    vm.tableParamsCK = function (row) {
        if (vm.istour){
            return;
        }
        if (!row.error) {
            if (vm.modeEdit || vm.modeCreation) {
                vm.showBulletinView = false;
                vm.anim = false;
                vm.modeEdit = false;
                vm.modeReadOnly = false;
                vm.modeCreation = false;
            } else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });
                vm.selectbulletin = row._id;
                vm.modeReadOnly = true;
                vm.modeEdit = false;
                vm.showBulletinView = true;
                $log.debug('table click', vm.selectbulletin);
            }
        }
    };

    /**
     * @ngdoc method
     * @name newBulletin
     * @methodOf BlurAdmin.bulletinBoardListCom.controller:bulletinBoardListController
     * @description
     * Method that redirect to create new bulletin
     *
     */
    vm.newBulletin = function () {
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.modeReadOnly = false;
        vm.showBulletinView = true;
        vm.modeEdit = false;
        vm.modeCreation = true;
    };

    /**
     * @ngdoc method
     * @name editBulletin
     * @methodOf BlurAdmin.bulletinBoardListCom.controller:bulletinBoardListController
     * @description
     * Method that redirect to edit a bulletin
     *
     */
    vm.editBulletin = function (row) {
        if (vm.istour){
            return;
        }
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.selectbulletin = row._id;
        vm.modeReadOnly = false;
        vm.showBulletinView = true;
        vm.modeEdit = true;
    };

    /**
     * @ngdoc method
     * @name deleteBulletin
     * @methodOf BlurAdmin.bulletinBoardListCom.controller:bulletinBoardListController
     * @description
     * Method that delete a bulletin
     *
     */
    vm.deleteBulletin = function (row) {
        if (vm.istour){
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                MasterTableService.delete({idT: routeConf.app, idJ: routeConf.bboard, idP: row._id}, function (data) {
                    $log.debug('delete bulletin board succes');
                    toastr.success(TranslationService.bulletinBoardList.msg.success);
                    vm.onDeleted({value: ''});
                }, function (err) {
                    $log.error('delete bulletin board error', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    $rootScope.$on('openBulletinDetail', function () {
        vm.newBulletin();
    });

}

angular
    .module('BlurAdmin.bulletinBoardListCom')
    .component('bulletinBoardList', {
        templateUrl: 'app/components/bulletinBoard/bulletinBoardList/bulletinBoardList.html',
        controllerAs: 'bblc',
        controller: bulletinBoardListController,
        bindings: {
            selectbulletin: '=',
            list: '<',
            pag: '<',
            modeReadOnly: '=',
            showBulletinView: '=',
            anim: '=',
            modeEdit: '=',
            onDeleted: '&',
            modeCreation: '=',
            initTour: '&',
            tourDummyData: '<',
            istour: '<'
        }
    });

/*
 * @author sila.fernandez
 * created on 05/02/2019
 */

canteenCommentsController.$inject = ['TranslationService', 'toastr', '$log', 'MasterTableService', 
                                    'routeConf', 'SocketService', 'localStorageService'];

function canteenCommentsController(TranslationService, toastr, $log, MasterTableService, 
                                    routeConf, SocketService, localStorageService) {
    var vm = this;
    vm.comments = '';

    vm._CONTROLLER = 'canteenCommentsController';

    vm.$onInit = function () {
        vm.comments = vm.menu.menuRemark;
    };

    vm.back = function (){
        vm.blockButtons = false;
        vm.showComments = false;
    };
    
    vm.save = function () {
        var query = {};
        vm.menu.menuRemark = vm.comments; 
        query.idT = routeConf.app;
        query.idJ = routeConf.menu;
        query.idP = vm.menu._id;
        $log.debug('menu to save', vm.menu);
        MasterTableService.post(query, vm.menu, function (response) {
            $log.debug('save comments success', response);
            vm.anim = false;
            toastr.success(TranslationService.activityDetail.msg.edit);
            vm.blockButtons = false;
            vm.showComments = false;
        }, function (err) {
            $log.error('error save comments ', err);
            vm.blockButtons = false;
            vm.showComments = false;
            toastr.error(TranslationService.errors.e500, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };
}

angular
    .module('BlurAdmin.canteenCommentsCom')
    .component('canteenCommentsCom', {
        templateUrl: 'app/components/canteen/canteenComments/canteenComments.html',
        controllerAs: 'cnComm',
        controller: canteenCommentsController,
        bindings: {
            blockButtons: '=',
            showComments: '=',
            level: '@',
            menu: '='
        }
    });
/*
 * @author lavg
 * created on 17/13/2017
 */
CanteenDetailController.$inject = ['TranslationService', 'MenuService', 'toastr', 'DishTypes',
    'localStorageService', 'BranchService', 'MenuNextService', 'MenuTypeService',
    '$log', 'routeConf', '$timeout', '$rootScope', 'ResidentsService',
    'MasterTableService', 'DishService', 'PermissionsService', '$http', 'serviceConf','userKind', 'ConfigService'];

function CanteenDetailController(TranslationService, MenuService, toastr, DishTypes, localStorageService,
                                 BranchService, MenuNextService, MenuTypeService, $log, routeConf, $timeout,
                                 $rootScope, ResidentsService, MasterTableService, DishService, PermissionsService,
                                 $http, serviceConf,userKind, ConfigService) {
    var vm = this;

    vm.initialized = false;
    vm.menu = {};
    vm.menuOri = null;
    vm.menuidOri = '';
    vm.returncourse = null;
    vm.returncourseOri = null;
    vm.deletestr = '';
    vm.residences = [];
    vm.menuNext = [];
    vm.user = {};
    vm.appuserbapan = null;
    vm.showReserveView = false;
    vm.refreshMenu = false;
    vm.timeBar = 0;
    vm.downloading = false;
    vm.downloadingAppUser = false;
    vm.menuSaved = false;

    vm._CONTROLLER = 'CanteenDetailController';

    function setPermissions() {
        if (vm.readonly !== true) {
            vm.readonly = !PermissionsService.gotPermission('MENU', 'update');
        }
    }

    vm.dateOptions = {
        minDate: moment().toDate(),
        showWeeks: false
    };

    vm.checkDates = function () {
        if (vm.menu !== null) {
            return moment(vm.menu.dateLimit).isAfter(moment(vm.menu.date));
        }
    };

    vm.$doCheck = function () {
        if (vm.menuid && (vm.menuid !== vm.menuidOri)) {
            vm.menuidOri = angular.copy(vm.menuid);
            vm.initialized = false;
            if(!vm.menuSaved) {
                vm.$onInit();
            }
        }
        if (vm.returncourse !== vm.returncourseOri) {
            vm.returncourseOri = vm.returncourse;
        }
        if (vm.deletestr !== '') {
            deleteInDish(vm.deletestr);
            vm.deletestr = '';
        }
        if (vm.refreshMenu === true) {
            vm.refreshMenu = false;
            vm.initialized = false;
            vm.$onInit();
        }
    };

    function deleteInDish(deletestr) {
        _.remove(vm.menu[deletestr.type], function (ba) {
            return ba._id === deletestr._id;
        });
    }

    vm.constants = {
        menuTypes: [],
        inDishTypes: DishTypes,
        residences: []
    };

    vm.openPopupTo = function () {
        vm.popupTo.opened = true;
    };

    vm.listappUser = function () {
        vm.blockButtons = true;
        var branches = [];
        vm.showReserveView = false;
        branches.push(vm.menu.branch);
        vm.notification = {
            modeReadOnly: true,
            showPanel: false,
            type: routeConf.menu,
            branches: branches,
            relatedID: vm.menu._id,
            user: _.map(vm.menu.booking, 'user')
        };
        vm.inselnewcourse = null;
        getSourcesNoReserves(null, null, branches).then(function (value) {
            if (!vm.user.absent.length) {
                vm.user.absent = [{inDish: {_absent: true}, user: []}];
            }
            _.forEach(value.absent, function (item) {
                vm.user.absent[0]['user'].push({
                    item: {
                        fullName: item['fullName'], name: item['name'], surname: item['surname'],
                        id: item['id'], _id: item['_id'], noSelectedMenu: true
                    }
                });
            });
            vm.appuserbapan = vm.user;
            vm.appuserbapan.notification = angular.copy(vm.notification);
            vm.reserveList = undefined;
            vm.showResident = false;
            $rootScope.$digest();
        });
    };

    vm.listappNoReserveUser = function () {
        vm.blockButtons = true;
        if (vm.istour) {
            return;
        }
        vm.showReserveView = false;
        var branches = [];
        branches.push(vm.menu.branch);
        vm.inselnewcourse = null;
        getSourcesNoReserves(null, null, branches).then(function(data){
            vm.reserveList = data;
            vm.notification = undefined;
            vm.appuserbapan = null;
            vm.showResident = false;
            $rootScope.$digest();
        }).catch(function (err) {
            $log.error('ResidentsService get error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };

    function getSourcesNoReserves(queryOffset, list, branches) {
        return new Promise(function (fulfill, reject) {
            list = (list) ? list : [];
            var query = (queryOffset) ? {offset: queryOffset, virtual: 'all'} : {virtual: 'all'};
            query.dateFrom = vm.menu.date;
            query.hour = vm.menu.menuType.hourUntil;
            query.branches = vm.menu.branch._id;
            ResidentsService.get(query, function (data) {
                list = _.concat(list, data.data);
                if (data.total) {
                    getSourcesNoReserves(list.length, list);
                } else {
                    var x = _.differenceBy(list, _.map(vm.menu.booking, 'user.item'), '_id');
                    var away = _.filter(x, ['isAway', true]);
                    x = _.differenceBy(x, away);
                    var arrToNotice = [];
                    _.forEach(x, function (pItem) {
                        arrToNotice.push({kind:userKind.appUser, item: pItem});
                    });
                    var reserveList = {
                        list: x,
                        absent: away,
                        notification: {
                            modeReadOnly: true,
                            showPanel: false,
                            type: routeConf.menu,
                            branches: branches,
                            relatedID: vm.menu._id,
                            user: arrToNotice
                        },
                        showNotificationButton: true,
                        animReserve: true
                    };
                    $log.debug('vm.reserveList canteen detail', vm.reserveList);
                    fulfill(reserveList);
                }
            }, function (err) {
                $log.error('ResidentsService get error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                fulfill(list);
            });
        });
    }

    function getResidentAway(queryOffset, list) {
        return new Promise(function (fulfill, reject) {
            list = (list) ? list : [];
            var query = (queryOffset) ? {offset: queryOffset, virtual: 'all'} : {virtual: 'all'};
            query.dateFrom = vm.menu.date;
            query.hour = vm.menu.menuType.hourUntil;
            query.branches = vm.menu.branch._id;
            ResidentsService.get(query, function (data) {
                list = _.concat(list, data.data);
                if (data.total) {
                    list = getResidentAway(list.length, list).data;
                } else {
                    var x = _.filter(list, ['isAway', true]);
                    $log.debug('vm.reserveList canteen detail', vm.reserveList);
                    fulfill(x);
                }
            }, function (err) {
                reject(err);
            });
        });
    }

    vm.commentsMenu = function () {
        vm.blockButtons = true;
        vm.showComments = true;
    };

    vm.changeCourse = function (typ) {
        if (vm.inselcourse === null) {
            return;
        } else {
            vm.newCourse(typ);
        }
    };

    vm.newCourse = function (typ) {
        if ((vm.inselcourse === null) || (vm.inselnewcourse !== typ)) {
            vm.blockButtons = true;
            // vm.animselectcourse = false;
            vm.notification = undefined;
            vm.showResident = false;
            vm.reserveList = null;
            vm.inselnewcourse = typ;
            if (typ === vm.constants.inDishTypes.first) {
                vm.alreadycourses = vm.menu.first;
            } else if (typ === vm.constants.inDishTypes.second) {
                vm.alreadycourses = vm.menu.second;
            } else if (typ === vm.constants.inDishTypes.dessert) {
                vm.alreadycourses = vm.menu.dessert;
            } else if (typ === vm.constants.inDishTypes.extra) {
                vm.alreadycourses = vm.menu.extra;
            }
            vm.appuserbapan = null;

            if (vm.animselectcourse) {
                $timeout(function () {
                    $rootScope.$emit('changeDishType');
                }, 200);
            } else {
                $timeout(function () {
                    vm.animselectcourse = true;
                }, 401);
            }
        }
    };

    vm.getNumberInPlate = function (objectType, plateId) {
        var tot = 0;
        _.forEach(vm.menu.booking, function (usr) {
            if (((usr.absent === undefined) || (usr.absent !== true)) && !vm.awayUsers[_.get(usr,'user.item._id','')]) {
                var gotIt = usr[objectType] === plateId;
                if (gotIt) {
                    tot++;
                }
            }
        });
        return tot;
    };

    function formalizeMn(item) {
        if (item.date) {
            item.sdate = moment(item.date).format('L');
            item.date = moment(item.date).toDate();
        }
        if (item.dateLimit) {
            item.dateLimit = moment(item.dateLimit).toDate();
        }
        if (item.suserremarks) {
            item.suserremarks = (item.active) ?
                TranslationService.canteen.userremarks.opened : TranslationService.canteen.userremarks.opened;
        }
        if (item.active) {
            item.sactive = (item.active) ?
                TranslationService.canteen.state.opened : TranslationService.canteen.state.opened;
        }
        if (item.menuType) {
            item.smenuType = item.menuType.description;
        }
        return item;
    }

    vm.setDays = function (residence) {
        var menuInResidence = _.find(vm.menuNext, function (res) {
            return res.branch._id === residence._id;
        });
        if (menuInResidence && menuInResidence.date) {
            vm.menu.date = moment(menuInResidence.date).toDate();
        }
        if (menuInResidence && menuInResidence.dateLimit) {
            vm.menu.dateLimit = moment(menuInResidence.dateLimit).toDate();
        }
    };

    vm.changed = false;
    vm.changedItem = function (menu, menuOri) {
        if (!(menu.first === menuOri.first && menu.second === menuOri.second &&
            menu.dessert === menuOri.dessert && menu.date === menu.date &&
            menu.dateLimit === menuOri.dateLimit && menu.menuType._id === menu.menuType._id)) {
            vm.changed = true;
        }
        return vm.changed;
    };

    vm.back = function () {
        vm.anim = false;
        vm.menuid = null;
        vm.appuserbapan = null;
        vm.inselnewcourse = null;
        vm.showCompleteList = false;
        vm.notification = undefined;
        vm.showResident = false;
        vm.reserveList = null;
    };

    function getUserBookinInCourses() {
        vm.user = {
            first: [],
            second: [],
            dessert: [],
            absent: [],
            special: []
        };
        if (vm.menu.booking !== undefined) {
            vm.menu.booking.appUsers = [];
        }
        _.forEach(vm.menu.booking, function (guy) {
            var exist = {};
            var det = {};
            var userAux = _.get(guy,'user',{kind:'',item:{_id:''}});
            if (userAux.kind === 'AppUser') {
                vm.menu.booking.appUsers.push(userAux.item);
            }
            if (guy.absent || vm.awayUsers[userAux.item._id]) {
                if (!vm.user.absent.length) {
                    vm.user.absent.push({inDish: {_absent: true}, user: []});
                }
                vm.user.absent[0].user.push(userAux);
            } else {
                if (guy.specialType) {
                    vm.user.special.push({
                        inDish: {
                            type: guy.specialType,
                            comment: guy.comment
                        },
                        user: guy.user
                    });

                } else {
                    if (guy.first) {
                        exist = _.find(vm.user.first, function (firstInDish) {
                            if (firstInDish.inDish) {
                                if (firstInDish.inDish._id === guy.first) {
                                    firstInDish.user.push(guy.user);
                                    return firstInDish;
                                }
                            }
                        });
                        if (!exist) {
                            det = _.find(vm.menu.first, function (first) {
                                return first._id === guy.first;
                            });
                            det = (!det) ? {_id: guy.first} : det;
                            vm.user.first.push({
                                inDish: det,
                                user: [guy.user]
                            });
                        }
                    }
                    if (guy.second) {
                        exist = _.find(vm.user.second, function (secondInDish) {
                            if (secondInDish.inDish) {
                                if (secondInDish.inDish._id === guy.second) {
                                    secondInDish.user.push(guy.user);
                                    return secondInDish;
                                }
                            }
                        });
                        if (!exist) {
                            det = _.find(vm.menu.second, function (second) {
                                return second._id === guy.second;
                            });
                            det = (!det) ? {_id: guy.second} : det;
                            vm.user.second.push({
                                inDish: det,
                                user: [guy.user]
                            });
                        }
                    }
                    if (guy.dessert) {
                        exist = _.find(vm.user.dessert, function (dessertInDish) {
                                if (dessertInDish.inDish) {
                                    if (dessertInDish.inDish._id === guy.dessert) {
                                        dessertInDish.user.push(guy.user);
                                        return dessertInDish;
                                    }
                                }
                            }
                        );
                        if (!exist) {
                            det = _.find(vm.menu.dessert, function (dessert) {
                                return dessert._id === guy.dessert;
                            });
                            det = (!det) ? {_id: guy.dessert} : det;
                            vm.user.dessert.push({
                                inDish: det,
                                user: [guy.user]
                            });
                        }
                    }
                }
            }
        });
    }

    vm.confirm = function (form) {
        if (form.$valid) {
            if (vm.menu._id !== '0') {
                var data = vm.menu;
                MenuService.post({idM: vm.menu._id}, data, function () {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.anim = false;
                    vm.appuserbapan = null;
                    vm.inselnewcourse = null;
                    vm.menuid = 'refList';
                    vm.menuSaved = true;
                });
            } else {
                MenuService.post(vm.menu, function () {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.anim = false;
                    vm.appuserbapan = null;
                    vm.inselnewcourse = null;
                    vm.menuid = 'refList';
                    vm.menuSaved = true;
                });
            }
        }
    };

    function setMenuNextDatesTyp(menu) {
        vm.setDays(menu.branch);
        vm.menu.menuType = menu.type;
    }

    function setMenuCanSelect(menu) {
        vm.menu.canSelect = menu.branch.canSelectMenu;
    }

    vm.changeMenuNext = function () {
        if (vm.menuNext && vm.menuNext.length > 1) {
            var menu = _.find(vm.menuNext, function (men) {
                return men.branch._id === vm.menu.branch._id;
            });
            setMenuNextDatesTyp(menu);
            setMenuCanSelect(menu);
        }
    };

    vm.menuExtraCK = function () {
        vm.showAvaibleOtherMenuDish = !vm.showAvaibleOtherMenuDish;
        vm.menu.extra = [];
    };

    vm.$onInit = function () {
        if (vm.initialized) {
            return;
        }
        vm.awayUsers = [];
        vm.menuidOri = angular.copy(vm.menuid);
        setPermissions();
        vm.nextMenu = null;
        vm.appuserbapan = null;
        vm.menuNext = {};
        vm.menu = null;
        vm.inselnewcourse = null;
        vm.alreadycourses = [];
        vm.constants.residences = [];
        vm.constants.menuTypes = [];
        vm.menuSaved = false;
        vm.notification = {
            showPanel: false
        };
        vm.reserveList = undefined;
        vm.showResident = false;

        if (!vm.constants) {
            vm.constants = {};
        }

        ConfigService.query({functionality: 'allergyTypes'}, function (data) {
            vm.constants.allergies = data;
        }, function (err) {
            $log.error('MasterTableService allergyType query error: ', err);
        });
        MenuTypeService.get(function (data) {
            vm.constants.menuTypes = data;
            if (vm.menuid === '0') {
                vm.user = null;
                vm.menu = {
                    first: [],
                    second: [],
                    dessert: [],
                    extra: [],
                    sdate: [],
                    date: moment(),
                    dateLimit: moment()
                };
                vm.showAvaibleOtherMenuDish = false;
                var selectedBar = localStorageService.get('selectedBarResidence');
                MenuNextService.get(function (data) {
                    vm.menuNext = angular.copy(data);
                    vm.constants.residences = [];
                    _.forEach(vm.menuNext, function (item) {
                        vm.constants.residences.push(item.branch);
                    });

                    vm.menu.menuLimit = moment(vm.menuNext.menuLimit);

                    var menuNextBySelect = null;
                    vm.menu.branch = vm.menuNext[0].branch;
                    vm.menu.canSelect = vm.menuNext[0].branch.canSelectMenu;
                    setMenuNextDatesTyp(vm.menuNext[0]);


                    if (selectedBar && !selectedBar.all) {
                        menuNextBySelect = _.filter(vm.menuNext, function (menu) {
                            return (selectedBar._id && menu.branch._id === selectedBar._id);
                        });
                        if (menuNextBySelect && menuNextBySelect.length > 0) {
                            vm.menu.branch = menuNextBySelect[0].branch;
                            setMenuNextDatesTyp(menuNextBySelect[0]);
                        }
                    }

                    vm.menuOri = angular.copy(vm.menu);
                }, function (err) {
                    $log.error('MenuNextService get error: ', err);
                });
            } else {
                BranchService.query({}, function (data) {
                    vm.constants.residences = data;
                    MenuService.get({idM: vm.menuid}, function (data) {
                        vm.menu = formalizeMn(data);
                        vm.menuOri = angular.copy(vm.menu);
                        vm.menu.canSelect = data.canSelect;
                        getResidentAway().then(function (data) {
                            vm.awayUsers = _.groupBy(data, '_id');
                            getUserBookinInCourses();
                            if (vm.menu.first && vm.menu.first.length > 0) {
                                _.forEach(vm.menu.first, function (ab) {
                                    ab.userNumber = vm.getNumberInPlate('first', ab._id);
                                });
                            }
                            if (vm.menu.second && vm.menu.second.length > 0) {
                                _.forEach(vm.menu.second, function (ab) {
                                    ab.userNumber = vm.getNumberInPlate('second', ab._id);
                                });
                            }
                            if (vm.menu.dessert && vm.menu.dessert.length > 0) {
                                _.forEach(vm.menu.dessert, function (ab) {
                                    ab.userNumber = vm.getNumberInPlate('dessert', ab._id);
                                });
                            }
                            if (vm.menu.extra && vm.menu.extra.length > 0) {
                                vm.showAvaibleOtherMenuDish = true;
                            } else {
                                vm.showAvaibleOtherMenuDish = false;
                                vm.menu.extra = [];
                            }
                            $rootScope.$digest();
                        }).catch(function (err) {
                            $log.error('ResidentsService get error: ', err);
                        });
                    }, function (err) {
                        $log.error('MenuService get error: ', err);
                        vm.menuid = '';
                        throw err;
                    });
                }, function (err) {
                    $log.error('MenuNextService get error: ', err);
                    vm.menuid = '';
                    throw err;
                });
            }
        }, function (err) {
            $log.error('MenuTypeService get error: ', err);
        });
        vm.blockButtons = false;
        vm.showComments = false;
        vm.initialized = true;
    };

    $rootScope.$on('openNewDish', function () {
        vm.newCourse(vm.constants.inDishTypes.first);
    });

    $rootScope.$on('closeNewDish', function () {
        vm.back();
    });

    /**
     * @ngdoc method
     * @name newReserve
     * @methodOf BlurAdmin.canteenDetailCom.controller:canteenDetailController
     * @description
     * Method that show the reserve form
     *
     */
    vm.newReserve = function () {
        vm.blockButtons = true;
        if (!vm.animReserve) {
            $timeout(function () {
                vm.animReserve = true;
            }, 401);
        }
        vm.showReserveView = true;
        vm.showReserve();
    };

    function timeBarGoto30() {
        $timeout(function () {
            if (vm.timeBar >= 30) {
                vm.timeBar += 1;
                timeBarGoto30();
            }
        }, 500);
    }

    function timeBarGoto30AppUser() {
        $timeout(function () {
            if (vm.timeBarAppUser >= 30) {
                vm.timeBarAppUser += 1;
                timeBarGoto30AppUser();
            }
        }, 500);
    }

    vm.getReportAppUser = function () {
        vm.downloadingAppUser = true;
        vm.timeBarAppUser = 0;
        timeBarGoto30AppUser();
        var urlId = serviceConf.ReportMReserveService;
        urlId = urlId.replace(':idR', vm.menuid);
        var con = {
            headers: {
                'authentication': 'Bearer ' + localStorageService.get('sessionToken')
            },
            responseType: 'arraybuffer'
        };
        $http.get(urlId, con).then(function mySuccess(response) {
            vm.timeBarAppUser = 41;
            MenuService.get({idM: vm.menuid}, function (data) {
                var strName = '[' + TranslationService.reports.names.listRes + ' ' + data.branch.description + ' ]' +
                    'YYYY_MM_DD h_mm[.pdf]';
                vm.pdfName = moment().format(strName);

                vm.timeBarAppUser = 51;

                var url = window.URL;
                var myBlobObject = new Blob([response.data], {type: 'application/pdf'});
                vm.timeBarAppUser = 81;
                var fileURL = url.createObjectURL(myBlobObject);
                var link = document.createElement('a');
                link.setAttribute('type', 'hidden'); // make it hidden if needed
                link.download = vm.pdfName;
                link.href = fileURL;
                link.target = '_self';
                link.click();
                vm.downloadingAppUser = false;
                vm.timeBarAppUser = 98;
                $timeout(function () {
                    vm.timeBarAppUser = 100;
                    vm.downloadingAppUser = false;
                    toastr.success(TranslationService.reports.sucess);
                }, 501);
            });
        });
    };

    vm.getReport = function () {
        vm.downloading = true;
        vm.timeBar = 0;
        timeBarGoto30();
        var urlId = serviceConf.ReportDishesService;
        urlId = urlId.replace(':idR', vm.menuid);
        var con = {
            headers: {
                'authentication': 'Bearer ' + localStorageService.get('sessionToken')
            },
            responseType: 'arraybuffer'
        };
        $http.get(urlId, con).then(function mySuccess(response) {
            vm.timeBar = 41;
            MenuService.get({idM: vm.menuid}, function (data) {
                var strName = '[' + TranslationService.reports.names.dishes + ' ' + data.branch.description + ' ]' + 'YYYY_MM_DD h_mm[.pdf]';
                vm.pdfName = moment().format(strName);

                vm.timeBar = 51;

                var url = window.URL;
                var myBlobObject = new Blob([response.data], {type: 'application/pdf'});
                vm.timeBar = 81;
                var fileURL = url.createObjectURL(myBlobObject);
                var link = document.createElement('a');
                link.setAttribute('type', 'hidden'); // make it hidden if needed
                link.download = vm.pdfName;
                link.href = fileURL;
                link.target = '_self';
                link.click();
                vm.downloading = false;
                vm.timeBar = 98;
                $timeout(function () {
                    vm.timeBar = 100;
                    vm.downloading = false;
                    toastr.success(TranslationService.reports.sucess);
                }, 501);

            });
        });
    };

}

angular
    .module('BlurAdmin.canteenDetailCom')
    .component('canteenDetailCom', {
        templateUrl: 'app/components/canteen/canteenDetail/canteenDetail.html',
        controllerAs: 'cnde',  //stands for 'User List Component'
        controller: CanteenDetailController,
        bindings: {
            menuid: '=',
            menu: '=',
            readonly: '<',
            inselnewcourse: '=',
            alreadycourses: '=',
            appuserbapan: '=',
            showCompleteList: '=',
            notification: '=',
            animselectcourse: '=',
            reserveList: '=',
            showResident: '=',
            istour: '<',
            showReserve: '&',
            showReserveView: '=',
            refreshMenu: '=',
            modeEdit: '=',
            inselcourse: '<',
            blockButtons: '=',
            showComments: '='
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */
CanteenAppUsersListController.$inject = ['localStorageService', 'UsersService', 'MasterTableService',
                                        'routeConf', 'DishService', '$timeout', 'TranslationService', 'toastr',
                                        '$http', 'serviceConf', 'MenuService', 'ConfigService', '$log', 'PermissionsService'];

function CanteenAppUsersListController(localStorageService, UsersService, MasterTableService, routeConf,
                                       DishService, $timeout, TranslationService, toastr,
                                       $http, serviceConf, MenuService, ConfigService, $log, PermissionsService) {
    var vm = this;


    vm.timeBar = 0;
    vm.downloading = false;
    vm.notificationPermission = PermissionsService.gotPermission('NOTICE', 'update');

    function timeBarGoto30() {
        $timeout(function () {
            if (vm.timeBar >= 30) {
                vm.timeBar += 1;
                timeBarGoto30();
            }
        }, 500);
    }

    vm.getReport = function () {

        vm.downloading = true;
        vm.timeBar = 0;
        timeBarGoto30();
        var urlId = serviceConf.ReportMReserveService;
        urlId = urlId.replace(':idR', vm.menuid);
        var con = {
            headers: {
                'authentication': 'Bearer ' + localStorageService.get('sessionToken')
            },
            responseType: 'arraybuffer'
        };
        $http.get(urlId, con).then(function mySuccess(response) {

            vm.timeBar = 41;
            MenuService.get({idM: vm.menuid}, function (data) {
                var strName = '[' + TranslationService.reports.names.listRes + ' ' + data.branch.description + ' ]' +
                    'YYYY_MM_DD h_mm[.pdf]';
                vm.pdfName = moment().format(strName);

                vm.timeBar = 51;

                var url = window.URL;
                var myBlobObject = new Blob([response.data], {type: 'application/pdf'});
                vm.timeBar = 81;
                var fileURL = url.createObjectURL(myBlobObject);
                var link = document.createElement('a');
                link.setAttribute('type', 'hidden'); // make it hidden if needed
                link.download = vm.pdfName;
                link.href = fileURL;
                link.target = '_self';
                link.click();
                vm.downloading = false;

                // url.revokeObjectURL(fileURL);//revoke the object from URL
                vm.timeBar = 98;
                $timeout(function () {
                    vm.timeBar = 100;
                    vm.downloading = false;
                    toastr.success(TranslationService.reports.sucess);
                }, 501);

            });
        });
    };

    vm.$onInit = function () {
        vm.ready = false;

        if (vm.appuserbapan) {
            vm.notificationDest = angular.copy(vm.appuserbapan.notification);
        }
        _.forEach(vm.appuserbapan.first, function (item) {
            if (item.inDish._id && !item.inDish.text) {
                DishService.get({idD: item.inDish._id}, function (data) {
                    item.inDish = data;
                });
            }
        });
        _.forEach(vm.appuserbapan.second, function (item) {
            if (item.inDish._id && !item.inDish.text) {
                DishService.get({idD: item.inDish._id}, function (data) {
                    item.inDish = data;
                });
            }
        });
        _.forEach(vm.appuserbapan.dessert, function (item) {
            if (item.inDish._id && !item.inDish.text) {
                DishService.get({idD: item.inDish._id}, function (data) {
                    item.inDish = data;
                });
            }
        });
        // TODO need 3 promise
        $timeout(function () {
            vm.ready = true;
        }, 401);
    };

    /**
     * @ngdoc method
     * @name notify
     * @methodOf BlurAdmin.canteenAppUsersListComponent.controller:CanteenAppUsersListController
     * @description
     * Method that show the notification panel
     *
     */
    vm.notify = function () {
        vm.notification.showPanel = true;
    };

    /**
     * @ngdoc method
     * @name showResidentDetail
     * @methodOf BlurAdmin.canteenAppUsersListComponent.controller:CanteenAppUsersListController
     * @description
     * Method that show the resident detail panel
     *
     */
    vm.showResidentDetail = function (user) {
        var userID = localStorageService.get('userId');
        vm.constants = {};
        UsersService.get({idU: userID}, function (data) {
            vm.constants.branch = data.branches;
            vm.ready = true;
            ConfigService.query({functionality: 'docTypes'}, function (data) {
                vm.constants.docType = data;
                ConfigService.query({functionality: 'allergyTypes'}, function (aller) {
                    vm.constants.allergies = aller;
                    ConfigService.query({
                        functionality: 'awayPeriod'
                    }, function (data2) {
                        vm.constants.awayPeriod = data2;
                        ConfigService.query({
                            functionality: 'admonition'
                        }, function (data3) {
                            vm.constants.admonitionTypes = data3;
                            vm.selectedResident = user;
                            vm.animResident = true;
                        }, function (err) {
                            $log.error('error getting admonitionTypes ', err);
                            toastr.error(TranslationService.errors.e500);
                        });
                    }, function (err) {
                        $log.error('error getting awayPeriod ', err);
                        toastr.error(TranslationService.errors.e500);
                    });
                });
            });

        });
    };

        /**
     * @ngdoc method
     * @name showReserveEdit
     * @methodOf BlurAdmin.canteenAppUsersListComponent.controller:CanteenAppUsersListController
     * @description
     * Method that show the resident detail panel
     *
     */
    vm.showReserveEdit = function (user) {
        if(!user.item.noSelectedMenu) {
            var userID = localStorageService.get('userId');
            vm.constants = {};
            vm.animResident = true;
            vm.selectedResident = user;
            vm.modeEdit = true;
            vm.showReserveView = true;
        }
    };

    vm.back = function (){
        vm.appuserbapan = null;
        vm.blockButtons = false;
    };
}

angular
    .module('BlurAdmin.canteenAppUsersListComponent')
    .component('canteenAppUsersList', {
        templateUrl: 'app/components/canteen/canteenAppUsersList/canteenAppUsersList.html',
        controllerAs: 'cnaulstc',  //stands for 'User List Component'
        controller: CanteenAppUsersListController,
        bindings: {
            appuserbapan: '=',
            notification: '=',
            fromAnnouncement: '<',
            selectedResident: '=',
            animResident: '=',
            constants: '=',
            menuid: '<',
            modeEdit: '=',
            editReserve: '&',
            showReserveView: '=',
            blockButtons: '='
        }
    });

function CanteenListController(NgTableParams, NgTableFilterService, TranslationService, toastr,
                               MenuService, $log, $timeout, $rootScope, PermissionsService,
                               localStorageService, $filter, FileSaver, MenuExportService, $location, $scope) {
    var vm = this;

    vm.tableParams = {};
    vm.initialized = false;
    vm.menuid = '';
    vm.gotAccessMod = false;
    vm.dateFrom = moment().toDate();
    vm.dateFromOri = angular.copy(vm.dateFrom);

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('MENU', 'update');
    }

    function isOpen(date) {
        return (moment(date).isSameOrBefore(moment()));
    }

    vm.$doCheck = function () {
        if (vm.menuid === 'refList') {
            vm.menuid = null;
            vm.initialized = false;
            vm.$onInit();
        }
    };

    function setSourceFormating(list) {
        _.forEach(list, function (item) {
            if (item.date) {
                item.sdate = moment(item.date).format('L');
            }
            item.activeState = isOpen(moment(item.dateLimit));
            item.sactive = isOpen(moment(item.dateLimit)) ?
                TranslationService.canteen.state.opened : TranslationService.canteen.state.closed;
            item.suserremarks = (item.booking.userRemark > 0) ?
                TranslationService.canteen.userremarks.opened : TranslationService.canteen.userremarks.closed;
            if (item.menuType) {
                item.smenuType = item.menuType.description;
            }
            if (item.branch) {
                item.branchDescription = item.branch.description;
            }
        });
    }

    function getSources(queryOffset, list) {
        list = (list) ? list : [];
        var query = (queryOffset) ? {offset: queryOffset} : {};
        if (vm.dateFrom) {
            query.dateFrom = vm.dateFrom;
        } else {
            query.dateFrom = moment().toDate();
        }
        query.dateFrom = vm.dateFrom;

        MenuService.get(query, function (data) {
            $log.debug('Load canteen list: ', data);
        }, function (err) {
            $log.error('error loading canteen list: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            return list;
        }).$promise.then(function (data) {
            list = _.concat(list, data.data);
            if (data.total) {
                $log.debug('recall');
                getSources(list.length, list);
            } else {
                $log.debug('no more calls back');
                setSourceFormating(list);
                iniTable(list);
                vm.initialized = true;
                if (list.length > 0) {
                    vm.tourDummyData.splice(0, vm.tourDummyData.length);
                }
                vm.list = list;
                return list;
            }
        });
    }

    var viewParams = localStorageService.get('canteenViewParams') ?
        localStorageService.get('canteenViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = {filterCanteenList: {branchDescription: selectedBar.description}};
    }
    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/canteenPanel') {
            viewParams = {filterCanteenList: {branchDescription: (!data.all) ? data.description : ''}};
            iniTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);

    vm.$onInit = function () {
        if (vm.initialized) {
            return;
        }
        setPermissions();
        vm.menuid = '';

        vm.tableParams = null;
        getSources();
    };

    vm.$onDestroy = function () {
        localStorageService.set('canteenViewParams', null);
        localStorageService.set('reserverViewParams', null);
    };

    function iniTable(list) {
        if (!list) {
            list = [];
        }

        var sorting = viewParams['sortingCanteenList'] ? viewParams['sortingCanteenList'] : {date: 'asc'};
        var page = viewParams['pageCanteenList'] ? viewParams['pageCanteenList'] : 1;
        var count = viewParams['countCanteenList'] ? viewParams['countCanteenList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingCanteenList'] = params._params.sorting;
                        viewParams['pageCanteenList'] = page;
                        viewParams['countCanteenList'] = params._params.count;
                        viewParams['filterCanteenList'] = filterObj;
                        localStorageService.set('canteenViewParams', viewParams);
                        vm.currentTableData = filteredData;

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterCanteenList'] ? viewParams['filterCanteenList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    vm.tableParamsCK = function (row) {
        if (vm.istour) {
            return;
        }
        localStorageService.set('reserverViewParams', null);
        _.forEach(vm.tableParams.data, function (r) {
            r.selected = (r._id === row._id);
        });

        if (!vm.menuid) {
            vm.anim = false;
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.menuid = row._id;
    };

    vm.tableParamsCK2 = function (row) {
        localStorageService.set('reserverViewParams', null);
        _.forEach(vm.tableParams.data, function (r) {
            r.selected = (r._id === row._id);
        });

        if (!vm.menuid) {
            vm.anim = false;
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.menuid = row._id;
    };

    vm.newMenuDish = function () {
        vm.menuid = '0';
        vm.menuOri = vm.menuid;

        vm.anim = false;
        $timeout(function () {
            vm.anim = true;
        }, 401);
    };

    vm.tableParamsdblCK = function (row) {
        vm.menu = angular.copy(row);
        vm.menuOri = vm.menu;
    };

    vm.filtersDate = {
        sdate: {
            id: 'text'
        }
    };
    vm.filtersBranch = {
        branchDescription: {
            id: 'text'
        }
    };
    vm.filterStyp = {
        smenuType: {
            id: 'text'
        }
    };
    vm.filterAct = {
        sactive: {
            id: 'text'
        }
    };
    vm.filterUserRemarks = {
        suserremarks: {
            id: 'number'
        }
    };
    vm.filterReservations = {
        reservations: {
            id: 'number'
        }
    };
    vm.filterServices = {
        services: {
            id: 'number'
        }
    };

    $rootScope.$on('openMenuDetail', function () {
        if (vm.tourDummyData.length < 1) {
            vm.tableParamsCK2(vm.tableParams.data[0]);
        } else {
            vm.newMenuDish();
        }
    });

    vm.dayChanged = function () {
        if (vm.dateFrom && vm.dateFrom.getTime() !== vm.dateFromOri.getTime()) {
            vm.dateFromOri = vm.dateFrom;
            getSources();
        }
    };

    vm.exportData = function () {
        var exportTranslations = TranslationService.canteen.export;
        var filename = exportTranslations['title'];
        if(filename) {
            filename = filename.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        }
        var columns = angular.copy(exportTranslations);
        delete columns.title;

        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function (e) {
                return e._id;
            }),
            filename: filename
        };

        MenuExportService.post(
            {}, requestData, function (data) {
                var blob =
                    new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('MenuService export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
    };
}

angular
    .module('BlurAdmin.canteenListComponent')
    .component('canteenList', {
        templateUrl: 'app/components/canteen/canteenList/canteenList.html',
        controllerAs: 'cnltc',  //stands for 'User List Component'
        controller: CanteenListController,
        bindings: {
            list: '=',
            menuid: '=',
            inselectmenu: '=',
            appuserbapan: '=',
            anim: '=',
            initTour: '&',
            tourDummyData: '=',
            istour: '<',
            changeDateFrom: '&',
        }
    });

canteenReserveNewController.$inject = ['toastr', 'ValidationService', 'localStorageService', 'MenuService',
    'TranslationService', 'MasterTableService', '$log', 'routeConf', 'PermissionsService', '$rootScope', 'ConfigService'];

function canteenReserveNewController(toastr, ValidationService, localStorageService, MenuService, TranslationService, MasterTableService,
                                     $log, routeConf, PermissionsService, $rootScope, ConfigService) {
    var vm = this;
    vm.guest = {};
    vm.appUser = {};
    vm.appUsers = {};
    vm.readonly = false;
    vm.isResident = true;
    vm.isGuest = false;
    vm.constants = {};
    vm.checkPicnic = true;
    vm.checkTupper = false;
    vm.checkSoft = false;
    vm.firstSelected = false;
    vm.secondSelected = false;
    vm.dessertSelected = false;
    vm.extraSelected = false;
    vm.specialSelected = false;
    vm.bookingType = 'bookingMenu';
    vm.specialType = {};
    vm.specialTypeSelected = {};
    vm.menuServices = [];
    vm.menuServiceSelected = {};
    vm.idSelected = {};
    vm.submitted = false;
    vm.selectedName = '';
    vm.selectedSurname = '';
    vm.selectedDocVal = '';
    vm.selectedDocType = '';
    vm.selectedEmail = '';
    vm.selectedPhone = '';
    vm.dishLoaded = false;

    vm._CONTROLLER = 'canteenReserveNewController';

    function setPermissions() {
        if (vm.readonly !== true) {
            vm.readonly = !PermissionsService.gotPermission('MENU', 'update');
        }
    }

    vm.setGuest = function (selectedGuest) {
        vm.guest = angular.copy(selectedGuest);
        vm.selectedGuest = angular.copy(selectedGuest);
        vm.selectedName = selectedGuest.name;
        vm.selectedSurname = selectedGuest.surname;
        vm.selectedDocVal = _.get(selectedGuest, 'identity.docVal');
        vm.selectedDocType = _.get(selectedGuest, 'identity.docType');
        if ((selectedGuest.contact) && (selectedGuest.contact.email)) {
            vm.selectedEmail = selectedGuest.contact.email;
        } else {
            vm.selectedEmail = '';
        }
        if ((selectedGuest.contact) && (selectedGuest.contact.phone)) {
            vm.selectedPhone = selectedGuest.contact.phone;
        } else {
            vm.selectedEmail = '';
        }
    };

    function getSourcesGuests(guestName) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                idT: routeConf.guest,
                name: guestName
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error searching guest ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        });
    }

    vm.getGuestsByName = function (guestName) {
        var guestRequest = getSourcesGuests(guestName)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    vm.getGuestsBySurname = function (guestName) {
        var guestRequest = getSourcesGuests(guestName)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    function getSourcesGuestsById(identity) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                idT: routeConf.guest,
                identity: identity
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error searching guest ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        });
    }

    vm.getGuestsById = function (identity) {
        var guestRequest = getSourcesGuestsById(identity)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    vm.changeSpecialType = function (data) {
        vm.specialTypeSelected = data;
        vm.idSelected = data._id;
    };

    vm.changemenuSelected = function (data) {
        vm.menuServiceSelected = data;
    };

    vm.ckInFirstDish = function (data) {
        if (vm.firstSelected === data) {
            vm.firstSelected = false;
        } else {
            vm.firstSelected = data;
        }
    };

    vm.ckInSecondtDish = function (data) {
        if (vm.secondSelected === data) {
            vm.secondSelected = false;
        } else {
            vm.secondSelected = data;
        }
    };

    vm.ckInDessertDish = function (data) {
        if (vm.dessertSelected === data) {
            vm.dessertSelected = false;
        } else {
            vm.dessertSelected = data;
        }
    };

    vm.ckInExtraDish = function (data) {
        if (vm.extraSelected === data) {
            vm.extraSelected = false;
        } else {
            vm.extraSelected = data;
        }
    };

    vm.validDNI = function (input, type, formInput) {
        var valid = true;
        if (input === undefined) {
            if (formInput.$viewValue !== undefined) {
                if (!formInput.$pristine && input !== '') {
                    if (type === undefined) {
                        if (type !== 'PAS') {
                            valid = ValidationService.validDniNie(formInput.$viewValue,
                                vm.constants.docType[0].description);
                        }
                    } else {
                        if (type !== 'PAS') {
                            valid = ValidationService.validDniNie(formInput.$viewValue, type);
                        }
                    }
                }
                formInput.$setValidity('valid', valid);
                return valid;
            }
        } else {
            if (!formInput.$pristine && input !== '') {
                if (type !== 'PAS') {
                    valid = ValidationService.validDniNie(input, type);
                }
            }
            formInput.$setValidity('valid', valid);
            return valid;
        }
    };

    vm.changeIsResident = function (value) {
        if (vm.readonly) {
            return;
        }
        vm.isResident = value;
        vm.isGuest = !value;
    };

    vm.changeTypeIde = function (type) {
        if (vm.readonly) {
            return;
        }
        vm.cont += 1;
        if (vm.cont < vm.constants.docType.length) {
            vm.selectedDocType = vm.constants.docType[vm.cont];
        } else {
            vm.cont = 0;
            vm.selectedDocType = vm.constants.docType[0];
        }
    };

    vm.validateMobile = function (mobile, formInput) {
        var valid = true;
        if (!formInput.$pristine && mobile !== '') {
            valid = ValidationService.validMobile(mobile);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validEmail = function (emailField, formInput) {
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,4})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (emailField) {
            valid = (!emailField || formInput.$pristine || reg.test(emailField));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };

    vm.parseUserListBy = function () {
        vm.alredyFloor = _.filter(vm.appUsers, function (appUser) {
            if (appUser.allFloor) {
                return appUser;
            }
        });
    };

    vm.parseUserList = function (users) {
        var usrList = angular.copy(users);
        var listByBran = [];
        _.forEach(usrList, function (item) {
            item.branches = item.branches[0];
            var b = _.find(listByBran, function (a) {
                return a._id === item.branches._id;
            });
            if (!b) {
                listByBran.push({
                    _id: item.branches._id,
                    usr: [item]
                });
            } else {
                b.usr.push(item);
            }
        });
        var list = [];
        _.forEach(listByBran, function (bran) {
            bran.usr = _.orderBy(bran.usr, ['room', 'asc']);
            _.forEach(bran.usr, function (i) {
                list.push(i);
            });
        });

        var lastFloor = -1;
        var out = [];
        _.forEach(list, function (user) {
            user.nameRoom = '[' + user.room + '] ' + user.name + ' ' +
                user.surname;
            out.push(user);
        });
        return out;
    };

    function clearAppUserByBrnch(br) {
        var list = [];
        _.forEach(vm.appUser, function (appUser) {
            var correct = _.find(br, function (ba) {
                return (ba._id === appUser.branches._id);
            });
            if (correct) {
                list.push(appUser);
            }
        });
        return list;
    }

    function checkAvailableUsers(branches) {
        $log.debug('checkAvailableUsers branches', branches);
        vm.appUsers = clearAppUserByBrnch(branches);
        $log.debug('vm.appUsers', vm.appUsers);
    }

    function loadAllResidents(branches) {
        MasterTableService.get({idT: routeConf.resident, branches: branches, virtual: 'all'}, function (data) {
            vm.appUsers = vm.parseUserList(data.data);
            $log.debug('resident load success', data);
            if (vm.menu && vm.appUsers && vm.appUsers.length > 0) {
                vm.allUsers = data.data;
                $log.debug('vm.appUsers load success', vm.appUsers);
                //checkAvailableUsers(branches);
                //vm.parseUserListBy();
            }
        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    }

    function getSourcesDocType() {
        return new Promise(function (full, reject) {
            ConfigService.query({
                functionality: 'docTypes'
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error getting DocType ', err);
                toastr.error(TranslationService.errors.e500);
                vm.ready = true;
            });
        });
    }

    function getSourcesSpecialType() {
        return new Promise(function (full, reject) {
            MasterTableService.query({
                idT: routeConf.masterTable,
                functionality: 'menuSpecialType',
                sortField: 'code',
                idJ: 'config'
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error getting SpecialType ', err);
                toastr.error(TranslationService.errors.e500);
                vm.ready = true;
            });
        });
    }

    function getSourcesMenuService() {
        return new Promise(function (full, reject) {
            MasterTableService.query({
                idT: routeConf.masterTable,
                functionality: 'menuService',
                sortField: 'code',
                idJ: 'config'
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error getting SpecialType ', err);
                toastr.error(TranslationService.errors.e500);
                vm.ready = true;
            });
        });
    }

    function loadDishes() {
        return new Promise(function (full, reject) {
            if (vm.menu.first && vm.menu.first.length) {
                _.forEach(vm.menu.first, function (f) {
                    f.callback = function () {
                        vm.ckInFirstDish(f._id);
                    };
                    f.checkFirstSelected = function () {
                        return f._id === vm.firstSelected;
                    };
                    f.returnItem = function () {
                        return f;
                    };
                });
            }

            if (vm.menu.second && vm.menu.second.length) {
                _.forEach(vm.menu.second, function (f) {
                    f.callback = function () {
                        vm.ckInSecondtDish(f._id);
                    };
                    f.checkSecondSelected = function () {
                        return f._id === vm.secondSelected;
                    };
                    f.returnItem = function () {
                        return f;
                    };
                });
            }

            if (vm.menu.dessert && vm.menu.dessert.length) {
                _.forEach(vm.menu.dessert, function (f) {
                    f.callback = function () {
                        vm.ckInDessertDish(f._id);
                    };
                    f.checkDessertSelected = function () {
                        return f._id === vm.dessertSelected;
                    };
                    f.returnItem = function () {
                        return f;
                    };
                });
            }
            full();
        });
    }


    vm.$onInit = function () {
        loadDishes()
            .then(function () {
                vm.dishLoaded = true;
                return getSourcesDocType();
            })
            .then(function (result1) {
                vm.constants = {
                    residences: [],
                    docType: result1,
                    menuTypes: []
                };
                vm.selectedDocType = vm.constants.docType[0];
                return getSourcesMenuService();
            })
            .then(function (pMenuService) {
                vm.menuServices = pMenuService;
                vm.menuServiceSelected = vm.menuServices[0];
                return getSourcesSpecialType();
            })
            .then(function (result2) {
                vm.specialType = result2;
                vm.specialTypeSelected = vm.specialType[0];
                vm.idSelected = vm.specialType[0]._id;
                vm.comments = '';
                var userBranch = localStorageService.get('branches');
                var selectedBar = localStorageService.get('selectedBarResidence');

                if (vm.modeEdit === true) {
                    _.forEach(vm.menu.booking, function (item) {
                        if (item.user.item._id === vm.selectedResident.item._id) {
                            if (item.specialType) {
                                vm.bookingType = 'bookingSpecial';
                                vm.comments = item.comment;
                                _.forEach(vm.specialType, function (f) {
                                    if (f.code === item.specialType) {
                                        vm.specialTypeSelected = f;
                                        vm.idSelected = f._id;
                                    }
                                });
                                vm.firstSelected = item.first;
                                vm.secondSelected = item.second;
                                vm.dessertSelected = item.dessert;
                            } else {
                                if (item.absent === true) {
                                    vm.bookingType = 'bookingAbsent';
                                } else {
                                    vm.firstSelected = item.first;
                                    vm.secondSelected = item.second;
                                    vm.dessertSelected = item.dessert;
                                    vm.extraSelected = item.extra;
                                    _.forEach(vm.menuServices, function (f) {
                                        if (f._id === item.menuService) {
                                            vm.menuServiceSelected = f;
                                        }
                                    });
                                }
                            }
                        }
                    });
                } else {
                    vm.guest = {
                        branches: (selectedBar && !selectedBar.all) ? selectedBar._id : userBranch,
                        active: true,
                        isResident: false
                    };
                    loadAllResidents(vm.guest.branches);
                }
                $rootScope.$digest();
            }).catch(function (err) {
            // Handle errors of getSourcesDocType and getSourcesSpecialType
            $log.error('error queries', err);
            toastr.error(TranslationService.errors.e500, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };

    vm.changeFilter = function (value) {
        vm.bookingType = value;
    };

    vm.reserveBack = function () {
        vm.guest = {};
        vm.appUsers = {};
        vm.isResident = true;
        vm.isGuest = false;
        vm.showReserveView = false;
        vm.animResident = false;
        vm.blockButtons = false;
    };

    vm.remove = function (resForm) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                MenuService.post({idM: vm.menu._id, idS: 'deleteReserve'}, {user: vm.selectedResident.item}, function (response) {
                    $log.debug('delete reserve success', response);
                    vm.anim = false;
                    toastr.success(TranslationService.canteen.msg.deleteReserveSuccess);
                    vm.showReserveView = false;
                    vm.setRefreshMenu();
                    vm.refreshMenu = false;
                    vm.blockButtons = false;
                }, function (err) {
                    $log.error('error delete reserve ', err);
                    toastr.error(TranslationService.canteen.msg.deleteReserveError, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.save = function (resForm) {
        if ((vm.selectedName !== vm.guest.name) || (vm.selectedSurname !== vm.guest.surname) ||
            (vm.selectedDocVal !== vm.guest.identity.docVal)) {
            vm.guest._id = null;
        }
        vm.showError = false;
        var query = {};
        if ((!vm.submitted && !resForm.$valid) || !resForm.$valid ||
            (vm.isResident && vm.modeEdit === false && resForm.appUser.$untouched) ||
            (vm.bookingType === 'bookingMenu' &&
                (!vm.firstSelected || !vm.secondSelected || !vm.dessertSelected))) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            vm.setRefreshMenu();
            if (vm.modeEdit === true) {
                if (vm.selectedResident.kind === 'Guest') {
                    vm.sav = {
                        guest: angular.copy(vm.selectedResident.item),
                        absent: false
                    };
                } else {
                    vm.sav = {
                        appUser: angular.copy(vm.selectedResident.item),
                        absent: false
                    };
                }
                if (vm.bookingType === 'bookingMenu') {
                    vm.sav.absent = false;
                    vm.sav.first = vm.firstSelected;
                    vm.sav.second = vm.secondSelected;
                    vm.sav.dessert = vm.dessertSelected;
                    if (vm.extraSelected) {
                        vm.sav.extra = vm.extraSelected;
                    }
                    vm.sav.menuService = vm.menuServiceSelected;
                } else {
                    if (vm.bookingType === 'bookingAbsent') {
                        vm.sav.absent = true;
                        if ((vm.firstSelected) && (vm.secondSelected) && (vm.dessertSelected)) {
                            vm.sav.first = vm.firstSelected;
                            vm.sav.second = vm.secondSelected;
                            vm.sav.dessert = vm.dessertSelected;
                            if (vm.extraSelected) {
                                vm.sav.extra = vm.extraSelected;
                            }
                        }
                    } else {
                        vm.sav.absent = false;
                        vm.sav.first = vm.firstSelected;
                        vm.sav.second = vm.secondSelected;
                        vm.sav.dessert = vm.dessertSelected;
                        vm.sav.specialType = vm.specialTypeSelected.code;
                        vm.sav.comment = vm.comments;
                    }
                }
                query.idT = routeConf.app;
                query.idJ = routeConf.menuPanel;
                query.idP = vm.menu._id;
                $log.debug('menu to save', vm.menu);
                MasterTableService.post(query, vm.sav, function (response) {
                    $log.debug('create reserve success', response);
                    vm.anim = false;
                    toastr.success(TranslationService.activityDetail.msg.edit);
                    vm.showReserveView = false;
                    vm.setRefreshMenu();
                    vm.refreshMenu = false;
                    vm.blockButtons = false;
                }, function (err) {
                    $log.error('error create reserve ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            } else {
                if (vm.isGuest) {
                    if ((vm.selectedName !== vm.guest.name) || (vm.selectedSurname !== vm.guest.surname) ||
                        (vm.selectedDocVal !== vm.guest.identity.docVal)) {
                        vm.guest._id = null;
                        vm.guest.name = vm.selectedName;
                        vm.guest.surname = vm.selectedSurname;
                        vm.guest.identity = {
                            docType: vm.selectedDocType._id,
                            docVal: vm.selectedDocVal
                        };
                        vm.guest.contact = {
                            email: vm.selectedEmail,
                            phone: vm.selectedPhone
                        };

                        vm.sav = {
                            guest: angular.copy(vm.guest),
                            signup: true
                        };

                        if (vm.bookingType === 'bookingMenu') {
                            vm.sav = {
                                guest: angular.copy(vm.guest),
                                absent: false,
                                signup: true
                            };
                            vm.sav.first = vm.firstSelected;
                            vm.sav.second = vm.secondSelected;
                            vm.sav.dessert = vm.dessertSelected;
                            if (vm.extraSelected) {
                                vm.sav.extra = vm.extraSelected;
                            }
                            vm.sav.menuService = vm.menuServiceSelected;
                        } else {
                            if (vm.bookingType === 'bookingAbsent') {
                                vm.sav = {
                                    guest: angular.copy(vm.guest),
                                    absent: true,
                                    signup: true
                                };
                                if ((vm.firstSelected) && (vm.secondSelected) && (vm.dessertSelected)) {
                                    vm.sav.first = vm.firstSelected;
                                    vm.sav.second = vm.secondSelected;
                                    vm.sav.dessert = vm.dessertSelected;
                                    if (vm.extraSelected) {
                                        vm.sav.extra = vm.extraSelected;
                                    }
                                }
                            } else {
                                vm.sav = {
                                    guest: angular.copy(vm.guest),
                                    specialType: vm.specialTypeSelected.code,
                                    comment: vm.comments,
                                    signup: true
                                };
                            }
                        }
                        query.idT = routeConf.app;
                        query.idJ = routeConf.menuPanel;
                        query.idP = vm.menu._id;
                        $log.debug('menu to save', vm.menu);
                        MasterTableService.post(query, vm.sav, function (response) {
                            $log.debug('create reserve success', response);
                            vm.anim = false;
                            toastr.success(TranslationService.activityDetail.msg.edit);
                            vm.showReserveView = false;
                            vm.setRefreshMenu();
                            vm.refreshMenu = false;
                            vm.blockButtons = false;
                        }, function (err) {
                            $log.error('error create reserve ', err);
                            toastr.error(TranslationService.errors.e500, TranslationService.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    } else {
                        if (vm.bookingType === 'bookingMenu') {
                            vm.sav = {
                                guest: angular.copy(vm.guest),
                                absent: false,
                                signup: true
                            };
                            vm.sav.first = vm.firstSelected;
                            vm.sav.second = vm.secondSelected;
                            vm.sav.dessert = vm.dessertSelected;
                            if (vm.extraSelected) {
                                vm.sav.extra = vm.extraSelected;
                            }
                            vm.sav.menuService = vm.menuServiceSelected;
                        } else {
                            if (vm.bookingType === 'bookingAbsent') {
                                vm.sav = {
                                    guest: angular.copy(vm.guest),
                                    absent: true,
                                    signup: true
                                };
                                if ((vm.firstSelected) && (vm.secondSelected) && (vm.dessertSelected)) {
                                    vm.sav.first = vm.firstSelected;
                                    vm.sav.second = vm.secondSelected;
                                    vm.sav.dessert = vm.dessertSelected;
                                    if (vm.extraSelected) {
                                        vm.sav.extra = vm.extraSelected;
                                    }
                                }
                            } else {
                                vm.sav = {
                                    guest: angular.copy(vm.guest),
                                    specialType: vm.specialTypeSelected.code,
                                    comment: vm.comments,
                                    signup: true
                                };
                            }
                        }
                        query.idT = routeConf.app;
                        query.idJ = routeConf.menuPanel;
                        query.idP = vm.menu._id;
                        $log.debug('menu to save', vm.menu);
                        MasterTableService.post(query, vm.sav, function (response) {
                            $log.debug('create reserve success', response);
                            vm.anim = false;
                            toastr.success(TranslationService.activityDetail.msg.edit);
                            vm.showReserveView = false;
                            vm.setRefreshMenu();
                            vm.refreshMenu = false;
                            vm.blockButtons = false;
                        }, function (err) {
                            $log.error('error create reserve ', err);
                            toastr.error(TranslationService.errors.e500, TranslationService.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    }
                } else {
                    if (vm.bookingType === 'bookingMenu') {
                        vm.sav = {
                            appUser: vm.appUser._id,
                            absent: false
                        };
                        vm.sav.first = vm.firstSelected;
                        vm.sav.second = vm.secondSelected;
                        vm.sav.dessert = vm.dessertSelected;
                        if (vm.extraSelected) {
                            vm.sav.extra = vm.extraSelected;
                        }
                        vm.sav.menuService = vm.menuServiceSelected;
                    } else {
                        if (vm.bookingType === 'bookingAbsent') {
                            vm.sav = {
                                appUser: vm.appUser._id,
                                absent: true
                            };
                            if ((vm.firstSelected) && (vm.secondSelected) && (vm.dessertSelected)) {
                                vm.sav.first = vm.firstSelected;
                                vm.sav.second = vm.secondSelected;
                                vm.sav.dessert = vm.dessertSelected;
                                if (vm.extraSelected) {
                                    vm.sav.extra = vm.extraSelected;
                                }
                            }
                        } else {
                            vm.sav = {
                                appUser: vm.appUser._id,
                                specialType: vm.specialTypeSelected.code,
                                comment: vm.comments
                            };
                        }
                    }
                    query.idT = routeConf.app;
                    query.idJ = routeConf.menuPanel;
                    query.idP = vm.menu._id;
                    $log.debug('menu to save', vm.menu);
                    MasterTableService.post(query, vm.sav, function (response) {
                        $log.debug('create reserve success', response);
                        vm.anim = false;
                        toastr.success(TranslationService.activityDetail.msg.edit);
                        vm.showReserveView = false;
                        vm.setRefreshMenu();
                        vm.refreshMenu = false;
                        vm.blockButtons = false;
                    }, function (err) {
                        $log.error('error create reserve', err);
                        toastr.error(TranslationService.errors.e500, TranslationService.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    });
                }
            }
        }

    };

    vm.getSlidesToShow = function () {
        var number = 1;
        // var aux = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var panelReserveWidth = document.getElementById('panelCanteenNewReserve').offsetWidth;
        switch (Math.floor(panelReserveWidth / 230)) {
            case 2:
                number = 2;
                break;
            case 3:
                number = 3;
                break;
            case 4:
                number = 4;
                break;
            case 5:
                number = 5;
                break;
            default:
                number = 1;
        }
        return number;
    };

}

angular
    .module('BlurAdmin.canteenReserveNewCom')
    .component('canteenReserveNew', {
        templateUrl: 'app/components/canteen/canteenReserve/canteenReserveNew.html',
        controllerAs: 'crnc',
        controller: canteenReserveNewController,
        bindings: {
            menu: '<',
            level: '@',
            showReserveView: '=',
            modeEdit: '<',
            selectedResident: '=',
            animResident: '=',
            setRefreshMenu: '&',
            refreshMenu: '=',
            blockButtons: '='
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */


function CanteenSelectCourseController(DishService, toastr, TranslationService, DishTypes, MasterTableService,
                                       routeConf, $log, $rootScope, ConfigService) {
    var vm = this;

    vm.selected = null;
    vm.returncourse = null;
    vm.dish = null;
    vm.goedit = null;

    vm.constants = {
        inDtypes: DishTypes
    };

    vm.params = {
        findTerm: '',
        dishType: {
            code: ''
        },
        allergyType: {
            ids: []
        }
    };
    /**
     * Cantidad inicial de platos a mostrar
     */
    vm.limitDishes = 20;

    /**
     * Numero de platos que se mostraran cada vez que se da al boton ver más
     */
    vm.dishesStep = 20;

    function getSources(queryOffset, list) {
        list = (list) ? list : [];
        var query = (queryOffset) ? {offset: queryOffset} : {};
        $log.debug('recall?');

        DishService.get(query, function (data) {
            list = _.concat(list, data.data);
            if (data.total) {
                $log.debug('recall');
                getSources(list.length, list);
            } else {
                $log.debug('no more calls back');
                vm.constant.tags = loadingTags(data.data);
                vm.listInDish = list;
                return list;
            }
        }, function (err) {
            $log.error('DishService get error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            return list;
        });
    }

    vm.back = function () {
        vm.inselcourse = null;
        vm.dish = null;
        vm.update = null;
        vm.blockButtons = false; 
    };

    vm.changeParamDishType = function (typ) {
        if (vm.params.dishType.code.indexOf(typ) >= 0) {
            vm.params.dishType.code = vm.params.dishType.code.replace(typ, '');
        } else {
            vm.params.dishType.code = vm.params.dishType.code = typ;
        }
    };

    vm.changeParamAllergyType = function (typ) {
        if (!_.includes(vm.params.allergyType.ids, typ)) {
            vm.params.allergyType.ids.push(typ);
        } else {
            _.remove(vm.params.allergyType.ids, function (item) {
                return (item === typ);
            });
        }
    };

    vm.gotIn = function (ar, data) {
        return _.includes(ar, data);
    };

    vm.newInDish = function () {
        vm.dish = {};
    };

    vm.$doCheck = function () {
        if (vm.returncourse !== null) {
            vm.returncourseitem = vm.returncourse;
            vm.alreadycourses.push(vm.returncourse);
            vm.returncourse = null;
        }
        if (vm.goedit !== null) {
            vm.dish = vm.goedit;
            vm.goedit = null;
        }
        if (vm.update === 'true') {
            vm.$onInit();
            vm.dish = null;
            vm.update = true;
        }
    };

    function loadingTags(list) {
        return _.flatten(_.map(list, function (dis) {
            return dis.tags;
        }));
    }

    $rootScope.$on('openCreateNewDish', function () {
        vm.newInDish();
    });

    $rootScope.$on('backCreateNewDish', function () {
        vm.back();
    });

    $rootScope.$on('changeDishType', function () {
        vm.params.dishType = {
            code: vm.inselcourse
        };
    });

    vm.$onInit = function () {
        if (vm.inselcourse !== DishTypes.extra) {
            vm.params.dishType = {
                code: vm.inselcourse
            };
        }
        vm.dish = null;
        vm.listInDish = [];
        vm.constant = {};

        getSources();

        vm.allergens = [];
        vm.selectedAllergens = [];
        ConfigService.query({functionality: 'allergyTypes'}, function (data) {
            vm.allergens = data;
            _.forEach(vm.allergens, function (item) {
                vm.params.allergyType.ids.push(item._id);
            });
            $log.debug('Allergens: ', data);
        }, function (err) {
            $log.error('Error getting allergens: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

}

angular
    .module('BlurAdmin.canteenSelectCourseCom')
    .component('selectCourse', {
        templateUrl: 'app/components/canteen/canteenSelectCourse/canteenSelectCourse.html',
        controllerAs: 'selc',  //stands for 'User List Component'
        controller: CanteenSelectCourseController,
        bindings: {
            inselcourse: '=',
            alreadycourses: '=',
            inaddoredit: '=',
            returncourseitem: '=',
            dish: '=',
            update: '=',
            constant: '=',
            blockButtons: '='
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */

function ChatConvController(TranslationService, toastr, $log, MasterTableService, routeConf, SocketService,
                            localStorageService) {
    var vm = this;

    vm.selectedconvOri = '';
    vm.initialized = false;

    vm.$doCheck = function () {
        if (vm.initialized === true && vm.selectedconv._id !== vm.selectedconvOri) {
            vm.selectedconvOri = angular.copy(vm.selectedconv._id);
            getSources();
            vm.convTxt = '';
        }
        if(vm.selectedconv.reloadChat){
            vm.selectedconv.reloadChat = false;
            getSources();
        }
    };

    vm.$onInit = function () {
        getSources();
    };

    /**
     * @ngdoc method
     * @name sendNew
     * @methodOf BlurAdmin.chat.chatconv.controller:ChatConvController
     * @description
     * Method that send a new message of chat
     */
    vm.sendNew = function () {
        var messagePayload = {
            userFrom: {_id: localStorageService.get('userId'), userKind: localStorageService.get('userKind'), fullName: localStorageService.get('user').fullName},
            isAPP: false,
            room: vm.selectedconv._id,
            branch: localStorageService.get('branches'),
            date: moment.utc(),
            text: vm.convTxt,
            owner: true
        };
        //send message by socket
        SocketService.sendNewMsg(messagePayload);
        vm.convTxt = '';
        //format date and add to array conversation
        messagePayload.hour = moment().format('HH:mm');
        messagePayload.ownMsg = true;
        messagePayload.date = messagePayload.date.format('L');
        vm.convBund.push(messagePayload);
    };

    /**
     * @ngdoc method
     * @name formatList
     * @methodOf BlurAdmin.chat.chatconv.controller:ChatConvController
     * @description
     * Method that format a item date of a list
     * @param(list) is a list to format
     * @return(list) is a list formatted
     */
    function formatList(list) {
        _.forEach(list, function (item) {
            item.hour = moment(item.date).format('HH:mm');
            item.date = moment(item.date).format('L');

        });
        list = list.reverse();
        return list;
    }

    /**
     * @ngdoc method
     * @name getSources
     * @methodOf BlurAdmin.chat.chatconv.controller:ChatConvController
     * @description
     * Method that load messages of a chat
     * @param(queryOffset) is a param of query
     * @param(list) is a list with message chat
     * @return(list) is a list with message of chat
     */
    function getSources(queryOffset, list) {
        list = (list) ? list : [];
        var query = (queryOffset) ? {offset: queryOffset} : {};
        query.idT = routeConf.chat;
        query.idJ = routeConf.getChatMsg;
        query.chatGroup = vm.selectedconv._id;
        $log.debug('recall?');
        MasterTableService.get(query, function (data) {
            list = _.concat(list, data.data);
            if (data.total) {
                $log.debug('recall');
                getSources(list.length, list);
            } else {
                $log.debug('no more calls back');
                 vm.convBund = formatList(list);
                vm.initialized = true;
                return list;
            }
        }, function (err) {
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            $log.error('Received error: ', err);
            return list;
        });
    }
}

angular
    .module('BlurAdmin.chat.chatconv')
    .component('chatConvPanel', {
        templateUrl: 'app/components/chat/chatConv/chatConv.html',
        controllerAs: 'cnConv',
        controller: ChatConvController,
        bindings: {
            selectedconv: '=',
            convmsglist: '='
        }
    });
/*
 * @author lavg
 * created on 17/13/2017
 */

ChatListComponent.$inject = ['TranslationService', '$timeout', 'toastr', '$log', 'PermissionsService',
    'MasterTableService', 'routeConf', '$rootScope', 'localStorageService', '$location', '$scope'];

function ChatListComponent(TranslationService, $timeout, toastr, $log, PermissionsService,
                           MasterTableService, routeConf, $rootScope, localStorageService,$location,
                           $scope) {
    var vm = this;
    vm.selected = {};
    vm.anim = false;
    vm.initialized = false;
    vm.selectedBranche = null;
    vm.chatGroups = [];
    vm.findTerm = '';
    vm.selectedconv = {};
    vm.convmsglist = [];

    vm._CONTROLLER = 'ChatListComponent';

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('CHAT', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('CHAT', 'delete');
    }

    function getSources() {
        var query = {idT: routeConf.chat, idJ: routeConf.getChatGroup};
        query.branch = vm.selectedBranche._id;
        MasterTableService.get(query, function (arrChatGroup) {
            vm.chatGroups = arrChatGroup.data;
            vm.selected = {};
            vm.initialized = true;
            vm.list = vm.chatGroups;
        }, function (err) {
            $log.error('initChat error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    }

    vm.changeBranches = function () {
        $log.debug('reload chatgroups about residence ');
        getSources();
        vm.selected = {};
    };


    var selectedBar = localStorageService.get('selectedBarResidence');

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/chatPanel' && !data.all) {
            vm.selectedBranche = data;
            vm.changeBranches();
        }
    });
    $scope.$on('$destroy', unregister);

    vm.$onInit = function () {
        if (vm.initialized) {
            return;
        }

        if (selectedBar && !selectedBar.all) {
            vm.selectedBranche = selectedBar;
        } else {
            vm.selectedBranche = vm.constants.branches[0];
        }


        vm.selected = {};
        vm.anim = false;
        setPermissions();
        vm.changeBranches();
    };

    vm.$doCheck = function () {
        if (vm.selected && vm.selected.action === 'reflist') {
            vm.initialized = false;
            vm.$onInit();
        }
    };

    vm.backifModifOrNew = function () {

        if (vm.selected && (vm.selected.action === 'inEdit' || vm.selected._id === '0')) {
            vm.anim = false;
            vm.selected = null;
        }
    };

    /**
     * @ngdoc method
     * @name new
     * @methodOf BlurAdmin.chat.chatlist.controller:ChatListComponent
     * @description
     * Method that show a panel chat to create a new chat
     */
    vm.new = function () {
        vm.selectedconv = {};
        vm.selected = {
            _id: '0',
            readonly: false,
            action: 'new'
        };

        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 417);
        }
    };

    /**
     * @ngdoc method
     * @name goToConv
     * @methodOf BlurAdmin.chat.chatlist.controller:ChatListComponent
     * @description
     * Method that show a panel chat with conversation chat
     * @param(item) is a chat selected
     */
    vm.goToConv = function (item) {
        if (vm.istour) {
            return;
        }
        vm.selected = {};
        vm.selectedconv = item;
        //clean unread message
        _.find(vm.chatGroups, function (chat) {
            if (chat._id === item._id) {
                chat.unreadMsg = 0;
                return true;
            }
        });
    };

    /**
     * @ngdoc method
     * @name view
     * @methodOf BlurAdmin.chat.chatlist.controller:ChatListComponent
     * @description
     * Method that show a panel chat with information of chat seleted
     * @param(item) is a chat selected
     */
    vm.view = function (item) {
        if (vm.istour) {
            return;
        }
        item.action = 'view';
        vm.selected = item;
        vm.selectedconv = {};
        vm.selected.readonly = true;
    };

    /**
     * @ngdoc method
     * @name edit
     * @methodOf BlurAdmin.chat.chatlist.controller:ChatListComponent
     * @description
     * Method that show a panel chat to edit selected chat
     * @param(item) is a chat to edit
     */
    vm.edit = function (item) {
        if (vm.istour) {
            return;
        }
        item.action = 'edit';
        vm.selectedconv = {};
        vm.selected = item;
        vm.selected.readonly = false;
    };

    /**
     * @ngdoc method
     * @name delete
     * @methodOf BlurAdmin.chat.chatlist.controller:ChatListComponent
     * @description
     * Method that delete a chat
     * @param(item) is a chat to delete
     */
    vm.delete = function (item) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                var query = {idT: routeConf.chat, idJ: routeConf.chatGroup, idP: item._id};
                MasterTableService.delete(query, function () {
                    toastr.success(TranslationService.dialog.saveok);
                    getSources();
                });
            }
        });
    };
    /**
     /**
     * Function that create room avatar (First Initials)
     */
    vm.chatAvatar = function (str) {
        var initials;
        var tst = str.split(' ').length;
        if (str.split(' ').length > 1) {
            initials = str.split(' ')[0].charAt(0) + str.split(' ')[1].charAt(0);
        } else {
            initials = str.split(' ')[0].charAt(0);
        }
        return initials;
    };
    /**
     * Function that detect a new message has arrived
     */
    $rootScope.$on('newMsgChat', function (event, data) {
        $log.debug('newMsgChat', data);
        vm.convmsglist = [];
        if (vm.selectedconv && vm.selectedconv._id === data.room) {
            vm.selectedconv.reloadChat = true;
        } else {
            _.find(vm.chatGroups, function (chat) {
                if (chat._id === data.room) {
                    chat.unreadMsg++;
                    return true;
                }
            });
        }
        $rootScope.$digest();
    });

    $rootScope.$on('openNewChat', function () {
        vm.new();
    });

}

angular
    .module('BlurAdmin.chat.chatlist')
    .component('chatList', {
        templateUrl: 'app/components/chat/chatList/chatList.html',
        controllerAs: 'cnList',  //stands for 'chat n list'
        controller: ChatListComponent,
        bindings: {
            selected: '=',
            anim: '=',
            constants: '<',
            selectedconv: '=',
            convmsglist: '=',
            initTour: '&',
            tourDummyData: '<',
            list: '=',
            istour: '<'
        }
    });


/*
 * @author lavg
 * created on 17/13/2017
 */

ChatModNewController.$inject = ['TranslationService', 'toastr', '$log', 'MasterTableService',
                                'routeConf', 'localStorageService', '$rootScope', 'userKind'];

function ChatModNewController(TranslationService, toastr, $log,
                            MasterTableService, routeConf, localStorageService, $rootScope, userKind) {
    var vm = this;

    vm.residentList = [];
    vm.submitted = false;
    vm.alredyFloor = [];
    vm.olderBranch = {};
    vm.inReadonlyRes = false;
    vm.selectedPrev = {};
    vm.membersResidentsOrig = [];
    vm.membersUsersOrig = [];
    vm.membersResidentsAlreadyDele = [];
    vm.membersUsersAlreadyDele = [];

    vm.inChatGroupMod = TranslationService.inChatGroupMod;
    vm.inChatGroupNew = TranslationService.inChatGroupNew;
    vm.inChatGroupDetail = TranslationService.inChatGroupDetail;

    vm.$onInit = function () {
        init();
    };

    vm.$doCheck = function () {
        //check different id chat in mode detail or edit
        if (vm.selected._id !== '0' && !_.isEmpty(vm.selected) && vm.selected._id !== vm.selectedPrev._id) {
            init();
        }
        //check if chat has same id in mode edit or detail
        else if (vm.selected._id !== '0' && !_.isEmpty(vm.selected) && vm.selected._id === vm.selectedPrev._id &&
            vm.selectedPrev.action !== vm.selected.action) {
            init();
        }

    };

    /**
     * @ngdoc method
     * @name init
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that load initial data of component
     */
    function init() {
        vm.residentList = [];
        vm.submitted = false;
        vm.alredyFloor = [];
        vm.olderBranch = {};
        vm.inReadonlyRes = false;

        vm.tit = (vm.selected._id !== '0') ? vm.selected.action === 'view' ? vm.inChatGroupDetail :
            vm.inChatGroupMod : vm.inChatGroupNew;
        vm.readonly = (vm.selected.readonly);
        // if got no id , its new
        // else its mod
        vm.olderBranch = vm.constants.branches[0];
        if (vm.selected._id === '0') {
            vm.item = {
                name: '',
                isGroup: true,
                branch: vm.constants.branches[0],
                membersResidents: [],
                membersUsers: [],
                members: []
            };
            var conectedUser = _.find(vm.constants.users, function (o) {
                return o._id === localStorageService.get('userId');
            });
            vm.item.membersUsers.push(conectedUser);
            vm.membersResidentsOrig = angular.copy(vm.item.membersResidents);
            vm.membersUsersOrig = angular.copy(vm.item.membersUsers);
            vm.changeBranches();
        } else {
            vm.selectedPrev._id = vm.selected._id;
            vm.selectedPrev.action = vm.selected.action;
            var query = {idT: routeConf.chat, idJ: routeConf.getChatGroup, idP: vm.selected._id};
            MasterTableService.get(query, function (inn) {
                vm.inReadonlyRes = false;
                vm.item = {
                    _id: vm.selected._id,
                    name: inn.name,
                    isGroup: inn.name,
                    branch: inn.branch,
                    membersResidents: formatResidentList(getMembersResidents(inn.members), false),
                    membersUsers: formatUsuList(getMembersUsers(inn.members)),
                    members: inn.members
                };
                vm.membersResidentsOrig = angular.copy(vm.item.membersResidents);
                vm.membersUsersOrig = angular.copy(vm.item.membersUsers);
                vm.chatName = angular.copy(vm.item.name);
                vm.changeBranches();
            }, function (err) {
                $log.error('initChat error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                vm.selected = {};
            });
        }
    }

    /**
     * @ngdoc method
     * @name getMembersUsers
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that return a list of users active of chat
     * @return(Array) a list of residents active
     */
    function getMembersUsers(list) {
        return _.filter(list, function (item) {
            if (item.kind === userKind.user && !item.dateTo) {
                return item;
            }
        });
    }

    /**
     * @ngdoc method
     * @name getMembersResidents
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that return a list of residents active of chat
     * @return(Array) a list of active residents
     */
    function getMembersResidents(list) {
        return _.filter(list, function (item) {
            if (item.kind === userKind.appUser && !item.dateTo) {
                return item;
            }
        });
    }

    /**
     * @ngdoc method
     * @name formatUsuList
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that return a list of active users  of chat
     * @return(Array) a list of active users
     */
    function formatUsuList(list) {
        var out = [];
        _.forEach(list, function (pItem) {
            out.push(pItem.item);
        });
        return out;
    }

    /**
     * @ngdoc method
     * @name formatResidentList
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that format a list of residents
     * @return(Array) a list of residents formatted
     */
    function formatResidentList(list, isLoading) {
        list = _.orderBy(list, ['room', 'asc']);
        var lastFloor = -1;
        var out = [];

        _.forEach(list, function (user) {
            if (user.kind === userKind.appUser) {
                user = user.item;
            }
            user.nameRoom = '[' + user.room + '] ' + user.name + ' ' +
                user.surname;
            if (vm.selected.action !== 'view' && lastFloor !== user.floor && isLoading) {
                lastFloor = user.floor;
                out.push({
                    nameRoom: TranslationService.floor + user.floor,
                    allFloor: user.floor,
                    floor: user.floor,
                    branches: user.branches,
                    _id: lastFloor + user.floor
                });
            }
            out.push(user);
        });
        return out;
    }

    vm.changeBranches = function () {
        vm.residentList = [];
        if (vm.selected._id === '0' && vm.item.branch._id !== vm.olderBranch._id) {
            vm.olderBranch = vm.item.branch;
            vm.item.members = [];
        }
        vm.residentList = formatResidentList(_.filter(vm.constants.residents, function (rsdn) {
            return (rsdn.branches[0]._id === vm.item.branch._id);
        }), true);
    };

    /**
     * @ngdoc method
     * @name back
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that close component
     */
    vm.back = function () {
        vm.selected = {};
    };

    /**
     * @ngdoc method
     * @name getMembersForNewGroup
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that return a list of members of new chat
     * @return(Array) a list of members of chat
     */
    function getMembersForNewGroup() {
        var out = [];
        //add appUser members
        var arrayIdAppUsers = getIdByAppUserList(vm.item.membersResidents);
        _.forEach(arrayIdAppUsers, function (user) {
            out.push({
                appUser: user._id,
                dateFrom: new Date()
            });
        });
        //add user members
        _.forEach(vm.item.membersUsers, function (user) {
            out.push({
                user: user,
                dateFrom: new Date()
            });
        });
        return out;
    }

    /**
     * @ngdoc method
     * @name getIdByAppUserList
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that return a list with of id of app users
     * @param(inn) list of app users
     * @return(Array) a list of app users id
     */
    function getIdByAppUserList(inn) {
        var out = [];
        _.forEach(inn, function (item) {
            if (item.allFloor) {
                _.forEach(vm.constants.residents, function (appUser) {
                    if ((appUser.branches._id === item.branches._id) &&
                        (item.floor === appUser.floor) && !appUser.allFloor &&
                        _.findIndex(out, function (o) {
                            return o._id === appUser._id;
                        }) === -1) {
                        out.push({_id: appUser._id});
                    }
                });
            } else if (!item.allFloor && (_.findIndex(out, function (o) {
                    return o._id === item._id;
                }) === -1)) {
                out.push({_id: item._id});
            }
        });
        return out;
    }

    /**
     * @ngdoc method
     * @name checkAppUsersDifferent
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that check new and delete appUsers to edit a chat
     */
    function checkAppUsersDifferent(chatItem) {
        chatItem.appUserNew = _.map(getIdByAppUserList(_.differenceBy(vm.item.membersResidents,
            vm.membersResidentsOrig, '_id')), '_id');
        chatItem.appUserDelete = _.map(_.differenceBy(vm.membersResidentsOrig, vm.item.membersResidents, '_id'), '_id');
    }

    /**
     * @ngdoc method
     * @name checkUsersDifferent
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that check new and delete users to edit a chat
     */
    function checkUsersDifferent(chatItem) {
        chatItem.userNew = _.map(_.differenceBy(vm.item.membersUsers, vm.membersUsersOrig, '_id'), '_id');
        chatItem.userDelete = _.map(_.differenceBy(vm.membersUsersOrig, vm.item.membersUsers, '_id'), '_id');
    }

    /**
     * @ngdoc method
     * @name save
     * @methodOf BlurAdmin.chat.ModNew.controller:ChatModNewController
     * @description
     * Method that create or edit a chat
     * @param(Form) is form reference of html view
     */
    vm.save = function (Form) {
        if ((!vm.submitted && !Form.$valid) || !Form.$valid) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            var query = {idT: routeConf.chat, idJ: routeConf.chatGroup};
            var chatItem = {};
            if (vm.item._id) {
                query.idP = vm.selected._id;
                chatItem = {
                    appUserNew: [],
                    appUserDelete: [],
                    userNew: [],
                    userDelete: []
                };
                checkAppUsersDifferent(chatItem);
                checkUsersDifferent(chatItem);
                //check if name changed
                if (vm.chatName !== vm.item.name) {
                    chatItem.name = vm.item.name;
                }
            } else {
                chatItem = {
                    name: vm.item.name,
                    members: getMembersForNewGroup(),
                    branch: vm.item.branch,
                    isGroup: true
                };
            }
            MasterTableService.post(query, chatItem, function (arrChatGroup) {
                toastr.success(TranslationService.dialog.saveok);
                vm.selected.action = 'reflist';
                vm.selected._id = '';
            });
        }
    };

    $rootScope.$on('closeChatDetail', function () {
        vm.back();
    });
}

angular
    .module('BlurAdmin.chat.ModNew')
    .component('chatModNew', {
        templateUrl: 'app/components/chat/chatModNew/chatModNew.html',
        controllerAs: 'cnModNew',
        controller: ChatModNewController,
        bindings: {
            selected: '=',
            new: '=',
            anim: '=',
            constants: '<',
            istour: '<'
        }
    });
/*
 * @author lavg
 * created on 17/13/2017
 */
function selectCountryController(CountryList, TranslationService, $log) {
    var vm = this;

    vm.var = {};
    vm.country = {};
    vm.selectedCountry = null;
    vm.countryOri = '';
    vm.translateCountry = true;
    vm.typ = 'cn';

    vm.$doCheck = function () {
        if (vm.country && vm.country.name !== vm.countryOri) {
            vm.countryOri = vm.country.name;
            vm.var = '';
            vm.readonly = false;
            letList();
        }
    };

    vm.$onInit = function () {
        vm.translateCountry = (vm.typ === 'cn');
        if (vm.alreadyState && vm.alreadyCountry) {
            //state
            vm.list = [];
            var coun = _.find(CountryList, function (item) {
                return _.deburr(item.name.toUpperCase()) === _.deburr(vm.alreadyCountry.toUpperCase());
            });
            if (coun) {
                _.forEach(coun.states, function (item) {
                    if (_.deburr(item.toUpperCase()) === _.deburr(vm.alreadyState.toUpperCase())){
                        vm.var = {name: item};
                        vm.selected = vm.var.name;
                    }
                    vm.list.push({name: item});
                });
            } else {
                if (!vm.country) {
                    vm.list = CountryList;
                } else {
                    letList();
                }
            }
        } else if (vm.alreadyCountry) {
            //country
            vm.list = CountryList;
            vm.var = _.find(vm.list, function (item) {
                return _.deburr(item.name.toUpperCase()) === _.deburr(vm.alreadyCountry.toUpperCase());
            });
            if (vm.var && vm.var.name) {
                vm.selected = vm.var.name;
            }
        } else {
            if (!vm.country) {
                vm.list = CountryList;
            } else {
                letList();
            }
        }
        vm.title = (vm.translateCountry) ? TranslationService.residents.country : TranslationService.residents.state;
    };

    vm.selectChange = function () {
        if (!vm.country) {
            vm.selectedCountry = vm.var;
        }
        vm.selected = vm.var.name;
    };

    function letList() {
        vm.list = [];
        _.forEach(vm.country.states, function (item) {
            vm.list.push({name: item});
        });
    }

    vm.clear = function () {
        if (!vm.readonly) {
            vm.var = {};
        }
    };
}

angular
    .module('BlurAdmin.selectCountry')
    .component('selectCountry', {
        templateUrl: 'app/components/country/selectCountry/selectCountry.html',
        controllerAs: 'selc',  //stands for 'User List Component'
        controller: selectCountryController,
        bindings: {
            selected: '=',
            selectedCountry: '=',
            country: '=',
            alreadyCountry: '=',
            alreadyState: '=',
            readonly: '<',
            icon: '@',
            typ: '@'
        }
    });
/*
 * @author lavg
 * created on 17/13/2017
 */
ServiceDetailController.$inject = ['toastr', 'TranslationService', '$log', 'routeConf', '$timeout',
                                  'localStorageService', 'UsersService', 'MasterTableService', 'ENV',
                                  '$rootScope', 'PermissionsService', 'userKind', 'ConfigService'];

function ServiceDetailController(toastr, TranslationService, $log, routeConf, $timeout,
                                    localStorageService, UsersService, MasterTableService, ENV,
                                    $rootScope, PermissionsService, userKind, ConfigService) {
    var vm = this;

    vm.servic = null;
    vm.servicOri = {
        _id: '0'
    };
    vm.readOnly = false;
    vm.submitted = false;
    vm.initialized = false;
    vm.disabledPush = false;
    vm.newReserveView = false;
    var _slots = [
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      ];

    vm._CONTROLLER='ServiceDetailController';

    vm.$doCheck = function () {
        if (vm.servic && vm.servic._id !== vm.servicOri._id && (vm.servic._id !== undefined)) {
            vm.servicOri._id = angular.copy(vm.servic._id);
            vm.initialized = false;
            vm.$onInit();
        }
    };

    vm.$onInit = function () {
        vm.slots = angular.copy(_slots);
        if (vm.servic.action === 'new') {
            vm.disabledPush = PermissionsService.gotPermission('PUSH', 'update');
        }
        vm.readonly = !(vm.servic.action && (vm.servic.action === 'edit' || vm.servic.action === 'new'));
        if (!vm.readonly) {
            vm.servic.action = 'inEdit';
        }
        if (vm.initialized) {
            return;
        }
        vm.servicOri._id = angular.copy(vm.servic._id);
        var selectedBar = localStorageService.get('selectedBarResidence');

        vm.serviceBD = {};
        vm.arrInvolveds = [];
        if (vm.servic._id === '0') {
            vm.serviceBD = {
                active: true,
                rate: 0,
                branch : (selectedBar && !selectedBar.all) ? selectedBar : {}
            };
            vm.ready = true;
        } else {
            MasterTableService.get({idT: routeConf.app, idJ: routeConf.facility, idP: vm.servic._id}, function (data) {
                vm.serviceBD = angular.copy(data);
                if(vm.serviceBD.maxRange){
                    vm.serviceBD.maxRange = moment.duration(vm.serviceBD.maxRange, 'ms').hours();
                }
                vm.getSlotsFromTimetable(vm.serviceBD.timetable);
                vm.notification = vm.servic.notification;
                if (vm.serviceBD.maxUsers === ENV.limitMaxUsers) {
                    delete vm.serviceBD.maxUsers;
                }
                $log.debug('vm.serviceBD', vm.serviceBD);

                /*Check if booked and appUsers involveds*/
                var query = {idT: routeConf.app, idJ: routeConf.findScheduledFacility};
                query.facility = vm.servic._id;
                query.dateFrom = moment().toDate();
                query.dateTo = moment().add(1, 'months').toDate();
                MasterTableService.query(query, function (data) {
                    _.forEach(data, function (pElemService) {
                        if (vm.servic._id === pElemService._id) {
                            _.forEach(pElemService.schedules, function (pSchedule) {
                                _.forEach(pSchedule.involveds, function (pInvolved) {
                                    if (pInvolved.kind !== userKind.guest){
                                        vm.arrInvolveds.push(pInvolved);
                                    }
                                });
                            });
                        }
                    });
                    vm.arrInvolveds = _.uniqBy(vm.arrInvolveds, function (e) { return e.item.id; });

                    $log.debug('notification', vm.notification);
                    vm.ready = true;

                }, function (err) {
                    $log.error('getInvolveds error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});

                });

            }, function (err) {
                $log.error('getServices error: ', err);
                toastr.error(TranslationService.errors.e500);
                vm.ready = true;
                vm.servic = {};
            });
        }
        var userID = localStorageService.get('userId');
        UsersService.get({idU: userID}, function (data) {
            vm.constants = {branch: data.branches};
            vm.ready = true;
            ConfigService.query({functionality: 'docTypes'}, function (data) {
                vm.constants.docType = data;
                ConfigService.query({functionality: 'allergyTypes'}, function (aller) {
                    vm.constants.allergies = aller;
                });
            });
        });
        vm.initialized = true;
    };

    vm.formatDate = function (date) {
        return moment(date).format('DD/MM/YYYY h:mm');
    };

    /**
     * @ngdoc method
     * @name showResidentDetail
     * @methodOf BlurAdmin.inServiceDetailComponent.controller:inServiceDetailCom
     * @description
     * Method that show the detail resident panel
     * @param(row) is resident selected
     *
     */
    vm.showResidentDetail = function (row) {
        vm.servic.animNotification = false;
        $timeout(function () {
            vm.animResident = true;
        }, 301);
        vm.selectedResident = row.appUser;
    };



    vm.dateOptions = {
        showWeeks: false
    };

    vm.checkDates = function () {
        return vm.serviceBD.date &&
            vm.serviceBD.dateTo && moment(vm.serviceBD.dateTo).isAfter(moment(vm.serviceBD.date));
    };

    vm.getSlotsFromTimetable = function(timetable) {
        for (var i = 0; i < timetable.length; i++) {
            var day = timetable[i].isoWeekday - 1;
            var arrHours = _.range(timetable[i].hourFrom/3600000, timetable[i].hourTo/3600000);
            _.forEach(arrHours, function(hour) {
                vm.slots[day][hour] = true;
            });

        }
    };

    vm.getCellsData = function() {
        var cellsData = [];
        for (var dayIndex = 0; dayIndex < vm.slots.length; dayIndex++) {
            var hourFrom = null;
            for (var hourIndex = 0; hourIndex < vm.slots[dayIndex].length; hourIndex++) {
                /*first open time cell*/
                if ((hourFrom === null) && vm.slots[dayIndex][hourIndex]){
                    hourFrom = hourIndex;
                }
                /*first closed time cell after open time*/
                else if ((hourFrom !== null) && !vm.slots[dayIndex][hourIndex]){
                    cellsData.push({
                        'isoWeekday': dayIndex+1,
                        'hourFrom': hourFrom*3600000,
                        'hourTo': hourIndex*3600000 });
                    /*reset hourFrom value*/
                    hourFrom = null;
                }
            }
            /*The hours of the day are over, check if hourFrom reported*/
            if (hourFrom !== null){
                cellsData.push({
                    'isoWeekday': dayIndex+1,
                    'hourFrom': hourFrom*3600000,
                    'hourTo': (vm.slots[dayIndex].length)*3600000});
            }
        }
        return cellsData;
    };

    vm.save = function (serForm) {
        if ((!vm.submitted && !serForm.$valid ) || !serForm.$valid) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            visibleInvalids[1].focus();
        } else {
            var timetable = vm.getCellsData();
            vm.serviceBD.timetable = timetable;
            var query = {idT: routeConf.app, idJ: routeConf.facility};
            var data = angular.copy(vm.serviceBD);
            if(data.maxRange){
                var hours = parseInt(data.maxRange);
                data.maxRange = moment.duration(hours, 'h').asMilliseconds();
            }
            if (vm.servic._id !== '0') {
                query.idP = vm.serviceBD._id;
                MasterTableService.post(query, data, function (data) {
                    toastr.success(TranslationService.dialog.saveok);
                    closeAndRefresh();
                }, function (error) {
                    $log.error('Services post (update) error: ', error);
                    toastr.error(TranslationService.errors.e500);
                });
            } else {
                MasterTableService.post(query, data, function (data) {
                    toastr.success(TranslationService.dialog.saveok);
                    closeAndRefresh();
                }, function (error) {
                    $log.error('Services post (create) error: ', error);
                    toastr.error(TranslationService.errors.e500);
                });
            }
        }
    };

    function closeAndRefresh() {
        vm.servic= {};
        vm.anim = false;
        vm.showCompleteList = false;
        vm.selectedResident = {};
        vm.animResident = false;
        $rootScope.$emit('refreshServiceList');
    }

    /**
     * @ngdoc method
     * @name notify
     * @methodOf BlurAdmin.inServiceDetailComponent.controller:inServiceDetailCom
     * @description
     * Method that open notification push panel
     *
     */
    vm.notify = function () {
        var branches = [];
        branches.push(vm.serviceBD.branch);

        vm.servic.animNotification = false;
        $timeout(function () {
            vm.servic.animNotification = true;
        }, 401);

        vm.notification = {
            modeReadOnly: true,
            type: routeConf.service,
            branches: branches,
            relatedID: vm.serviceBD._id,
            user: vm.arrInvolveds,
            showPanel: true
        };
        $log.debug('notification', vm.notification);

    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf BlurAdmin.inServiceDetailComponent.controller:ServiceDetailController
     * @description
     * Method that check if press key is a number
     * @param(evt) is key pressed
     *
     */
    vm.validateKeyPress = function (evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode < 48 && charCode !== 8 && charCode !== 9) || (charCode > 57)) {
            evt.preventDefault();
        }
    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.inServiceDetailComponent.controller:ServiceDetailController
     * @description
     * Method that close de detail  without saving information
     */
    vm.cancel = function () {
        vm.anim = false;
        vm.servic = {};
        vm.showCompleteList = false;
        vm.selectedResident = {};
        vm.animResident = false;
    };

    $rootScope.$on('closeServiceDetail', function () {
        vm.cancel();
    });
}

angular
    .module('BlurAdmin.inServiceDetailComponent')
    .component('inServiceDetailCom', {
        templateUrl: 'app/components/inService/inServiceDetail/inServiceDetail.html',
        controllerAs: 'scedetc',  //stands for 'User List Component'
        controller: ServiceDetailController,
        bindings: {
            servic: '=',
            anim: '=',
            readOnly: '=',
            constants: '=',
            showCompleteList: '=',
            notification: '=',
            selectedResident: '=',
            animResident: '=',
            istour: '<'
        }
    });

function InServiceListController(NgTableParams, TranslationService, NgTableFilterService, $timeout,
                                 toastr, $log, TourService, $rootScope, PermissionsService, localStorageService,
                                 $filter, weeklySchedulerLocaleService, MasterTableService, LanguageFactory, routeConf, $uibModal,
                                 $location, ServiceListExportService, FileSaver, $scope) {
    var vm = this;

    vm.servic = {};
    vm.select = {};
    vm.listOri = null;
    vm.anim = false;
    vm.initialized = false;
    vm.gotAccessMod = false;
    vm.gotAccessDel = false;

    vm.selectedBar = localStorageService.get('selectedBarResidence');

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('SERVICE', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('SERVICE', 'delete');
    }


    vm.backifModifOrNew = function () {
        if (vm.servic && (vm.servic.action === 'inEdit' || vm.servic._id === '0')) {
            vm.anim = false;
            vm.servic = null;
        }
    };

    function strToInitials(str, pLength) {
        var arrWords = str.split(' ');
        var arrInitials = _.slice(arrWords, 0, pLength || 3);
        return arrInitials.map(function (obj) {
            return obj.charAt(0);
        }).join('');
    }

    vm.dayChanged = function (day) {
        return new Promise(function (full, reject) {
            vm.dayFrom = day;
            var query = {idT: routeConf.app, idJ: routeConf.findScheduledFacility, dateFrom: vm.dayFrom.toDate()};
            if (vm.selectedBar && !vm.selectedBar.all) {
                query.branch = vm.selectedBar._id;
            }

            var list = [];
            MasterTableService.query(query, function (data) {
                $log.debug('dayChanged data: ', data);
            }, function (err) {
                $log.error('error dayChanged masterTable scheduler: ', err);
                reject(err);
                // return list;
            }).$promise.then(function (data) {
                //order by facility name
                list = _.sortBy(data, 'label');
                _.forEach(list, function (item) {
                    if (item.branch && item.branch.description) {
                        item.branchDescription = item.branch.description;
                    } else {
                        item.branchDescription = '';
                    }
                    _.forEach(item.schedules, function (pSchedule) {
                        pSchedule.date = new Date(moment.utc(day).local());
                        pSchedule.start = new Date(pSchedule.dateFrom);
                        pSchedule.end = new Date(pSchedule.dateTo);
                        pSchedule.scheduleDay = day.toDate();

                        var bookedTo = pSchedule.involveds && pSchedule.involveds.length ? pSchedule.involveds[0] : pSchedule.createdBy;
                        pSchedule.title = bookedTo.item ? bookedTo.item.fullName : 'X X X';
                        pSchedule.text = strToInitials(bookedTo.item ? bookedTo.item.fullName : 'X X X');
                    });

                    item.text = item.description;
                    item.title = item.name;
                    item.rate = item.cost ? item.cost.value : 0;
                });
                iniTable(list);
                //overflow-y if there are more than 10 facilities
                vm.model.scroll = list.length > 10;
                vm.model.items = list;
                vm.model.scheduleDay = day;
                vm.list = list;
                vm.initialized = true;
                full(vm.model);
            });
        });
    };

    function getSources(branchFiltered) {
        var list = [];
        var query = {idT: routeConf.app, idJ: routeConf.findScheduledFacility};
        // if (branchFiltered && !branchFiltered.all) {
        //     query.branch = branchFiltered._id;
        // }
        if (vm.selectedBar && !vm.selectedBar.all) {
            query.branch = vm.selectedBar._id;
        }
        if (vm.dayFrom) {
            query.dateFrom = vm.dayFrom.toDate();
        }

        MasterTableService.query(query, function (data) {
            $log.debug('getSources data: ', data);
        }, function (err) {
            $log.error('getSources error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            // return list;
        }).$promise.then(function (data) {
            //order by facility name
            list = _.sortBy(data, 'label');
            _.forEach(list, function (servic) {
                if (servic.branch && servic.branch.description) {
                    servic.branchDescription = servic.branch.description;
                } else {
                    servic.branchDescription = '';
                }
                _.forEach(servic.schedules, function (pSchedule) {
                    pSchedule.date = vm.dayFrom ? new Date(moment.utc(vm.dayFrom).local()) : moment();
                    pSchedule.start = new Date(pSchedule.dateFrom);
                    pSchedule.end = new Date(pSchedule.dateTo);
                    pSchedule.scheduleDay = vm.dayFrom ? vm.dayFrom.toDate() : vm.dayFrom;

                    var bookedTo = pSchedule.involveds && pSchedule.involveds.length ? pSchedule.involveds[0] : pSchedule.createdBy;
                    pSchedule.title = bookedTo.item ? bookedTo.item.fullName : 'X X X';
                    pSchedule.text = strToInitials(bookedTo.item ? bookedTo.item.fullName : 'X X X');
                });

                servic.text = servic.description;
                servic.title = servic.name;
                servic.rate = servic.cost ? servic.cost.value : 0;
            });
            iniTable(list);
            //overflow-y if there are more than 10 facilities
            vm.model.scroll = list.length > 10;
            vm.model.items = list;
            vm.model.scheduleDay = vm.dayFrom;
            vm.list = list;
            vm.initialized = true;
            return vm.model;
        });
    }

    var viewParams = localStorageService.get('servicesViewParams') ?
        localStorageService.get('servicesViewParams') : {};

    if (vm.selectedBar && !vm.selectedBar.all) {
        viewParams = {filterServicesList: {branchDescription: vm.selectedBar.description}};
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/services') {
            vm.selectedBar = data;
            viewParams = {filterServicesList: {branchDescription: (!data.all) ? data.description : ''}};
            getSources(data);
        }
    });
    $scope.$on('$destroy', unregister);
    vm.$onInit = function () {
        var refresh = localStorageService.get('needRefreshSchedule');
        // if (vm.initialized) {
        //     return;
        // }
        if (refresh || !vm.tableParams) {
            localStorageService.set('needRefreshSchedule', false);
            setPermissions();
            vm.userBranch = localStorageService.get('branches');
            vm.servic = {};
            vm.anim = false;
            vm.tableParams = null;
            getSources();
        }
    };

    vm.$onDestroy = function () {
        localStorageService.set('servicesViewParams', null);
    };

    function iniTable(list) {
        if (!list) {
            list = [];
        } else if (list.length > 0) {
            list[0].selected = true;
        }

        var sorting = viewParams['sortingServicesList'] ? viewParams['sortingServicesList'] : {title: 'asc'};
        var page = viewParams['pageServicesList'] ? viewParams['pageServicesList'] : 1;
        var count = viewParams['countServicesList'] ? viewParams['countServicesList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingServicesList'] = params._params.sorting;
                        viewParams['pageServicesList'] = page;
                        viewParams['countServicesList'] = params._params.count;
                        viewParams['filterServicesList'] = filterObj;
                        localStorageService.set('servicesViewParams', viewParams);
                        vm.currentTableData = filteredData;

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterServicesList'] ? viewParams['filterServicesList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    vm.tableParamsCK = function (row) {
        if (vm.istour) {
            return;
        }
        if (vm.servic && (vm.servic.action === 'inEdit' || vm.servic._id === '0')) {
            vm.anim = false;
            vm.servic = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 500);
            }
            _.forEach(vm.tableParams.data, function (r) {
                r.selected = (r._id === row._id);
            });

            if (!vm.servicOri) {
                vm.servicOri = row._id;
            }
            vm.servic = row;
            vm.servic.notification = undefined;
            vm.servic.animNotification = false;
        }
    };

    vm.filterDescription = {
        branchDescription: {
            id: 'text'
        }
    };
    vm.filterTitle = {
        title: {
            id: 'text'
        }
    };
    vm.filterPrice = {
        rate: {
            id: 'number'
        }
    };
    vm.new = function () {
        vm.servic = {
            _id: '0'
        };
        vm.servic.action = 'new';
        _.forEach(vm.tableParams.data, function (r) {
            r.selected = false;
        });
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 417);
        }
    };

    vm.editRow = function (row) {
        vm.tableParamsCK(row);
        row.action = 'edit';
    };

    vm.deleteRow = function (row) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                var query = {idT: routeConf.app, idJ: routeConf.facility, idP: row._id};
                MasterTableService.delete(query, function (data) {
                    vm.tableParams = null;
                    vm.$onInit();
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    $rootScope.$on('openServiceDetailFirstRow', function () {
        if (vm.tourDummyData.length < 1) {
            var row = vm.tableParams.data[0];
            if (vm.servic && (vm.servic.action === 'inEdit' || vm.servic._id === '0')) {
                vm.anim = false;
                vm.servic = null;
            } else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });

                if (!vm.servicOri) {
                    vm.servicOri = row._id;
                }
                vm.servic = row;
                vm.servic.notification = undefined;
                vm.servic.animNotification = false;
            }
        } else {
            vm.new();
        }
    });

    $rootScope.$on('openServiceDetail', function () {
        vm.new();
    });

    /** SCHEDULER */
    weeklySchedulerLocaleService.set(LanguageFactory.getLanguage).then(function ($locale) {
        $log.debug('The locale changed to', $locale.id);
    });
    vm.model = {
        options: {},
        locale: weeklySchedulerLocaleService.$locale.id,
        items: []
    };

    vm.openReserveModal = function (data, modeCancel, showReserveView) {
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/components/inService/inServiceReserve/modal/inServiceReserveModal.html',
            controller: 'InServiceReserveModalController',
            controllerAs: 'mod',
            size: 'lg',
            backdrop: 'static',
            windowClass: 'inServiceReserveModal',
            resolve: {
                data: function () {
                    return data;
                },
                modeCancel: function () {
                    return modeCancel;
                },
                showReserveView: function () {
                    return showReserveView;
                }
            }
        });
        modalInstance.result.then(
            //close
            function () {
                vm.$onInit();
            },
            //dismiss
            function () {
                $log.debug('IN SERVICE RESERVE MODAL CLOSED');
            }
        );
    };

    /** Reload scheduler when info changes*/
    $rootScope.$on('refreshScheduler', function () {
        $timeout(function () {
            vm.showReserveView = false;
            vm.modeCancel = false;
            vm.$onInit();
        }, 200);
    });

    $rootScope.$on('refreshServiceList', function () {
        $timeout(function () {
            vm.tableParams = null;
            vm.$onInit();
        });
    });

    $rootScope.$on('showReserveNew', function (event, data) {
        vm.openReserveModal(data, false, true);
    });

    $rootScope.$on('showReserveCancel', function (event, resource) {
        vm.servic.resourceToCancel = resource;
        vm.openReserveModal(vm.servic, true, true);
    });

    $rootScope.$on('moveReserve', function (event, data) {
        var query = {};
        query.idT = routeConf.app;
        query.idJ = routeConf.facilityBook;
        query.idP = data._id;
        vm.sav = data;
        vm.sav.dateFrom = data.start;
        vm.sav.dateTo = data.end;
        vm.sav.dates = {dateFrom: data.start, dateTo: data.end};
        MasterTableService.post(query, vm.sav, function (response) {
            $log.debug('update reserve success', response);
            toastr.success(TranslationService.reserve.msg.edit);
            vm.showReserveView = false;
            vm.modeCancel = false;
            vm.$onInit();
        }, function (err) {
            $log.error('error update reserve ', err);
            var mensaje = err.data.error;
            var respuestaError = TranslationService.errors.e500;

            if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405002)) ||
                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405002))) {
                respuestaError = TranslationService.errors.ERR405002;
            } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405003)) ||
                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405003))) {
                respuestaError = TranslationService.errors.ERR405003;
            } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405007)) ||
                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405007))) {
                respuestaError = TranslationService.errors.ERR405007;
            }

            toastr.error(respuestaError, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            $rootScope.$emit('refreshScheduler');
        });
    });

    vm.exportData = function () {
        var exportTranslations = TranslationService.services.export;
        var filename = exportTranslations['title'];
        if (filename) {
            filename = filename.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        }
        var columns = angular.copy(exportTranslations);
        delete columns.title;

        var requestData = {
            columns: columns,
            ids: vm.currentTableData,
            filename: filename,
            day: vm.dayFrom ? moment(vm.dayFrom).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')
        };

        ServiceListExportService.post(
            {}, requestData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('ServiceListExportService export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
    };
}

angular
    .module('BlurAdmin.inServiceListComponent')
    .component('inServiceListCom', {
        templateUrl: 'app/components/inService/inServiceList/inServiceList.html',
        controllerAs: 'serlc',  //stands for 'User List Component'
        controller: InServiceListController,
        bindings: {
            servic: '=',
            list: '=',
            pag: '<',
            anim: '=',
            animSchedule: '=',
            selectedResident: '=',
            constants: '=',
            initTour: '&',
            tourDummyData: '<',
            istour: '<',
            showReserveView: '=',
            modeCancel: '='
        }
    });

inServiceReserveController.$inject = ['$rootScope', 'toastr', 'ValidationService', 'localStorageService',
    'TranslationService', 'MasterTableService', '$log', 'routeConf', '$timeout', 'ConfigService'];

function inServiceReserveController($rootScope, toastr, ValidationService, localStorageService,
                                    TranslationService, MasterTableService, $log, routeConf, $timeout, ConfigService) {
    var vm = this;
    vm.guest = {};
    vm.appUser = {};
    vm.appUsers = {};
    vm.sav = {};
    vm.constants = {};
    vm.readonly = false;
    vm.isResident = true;
    vm.isGuest = false;
    vm.branches = [];
    vm.animSchedule = false;

    vm._CONTROLLER = 'inServiceReserveController';

    vm.setGuest = function (selectedGuest) {
        vm.guest = angular.copy(selectedGuest);
        //vm.selectedGuest = angular.copy(selectedGuest);
        vm.selectedName = selectedGuest.name;
        vm.selectedSurname = selectedGuest.surname;
        if ((selectedGuest.identity) && (selectedGuest.identity.docVal !== undefined)) {
            vm.selectedDocVal = selectedGuest.identity.docVal;
        } else {
            vm.selectedDocVal = '';
        }
        if ((selectedGuest.identity) && (selectedGuest.identity.docType !== undefined)) {
            vm.selectedDocType = selectedGuest.identity.docType;
        }
        if ((selectedGuest.contact) && (selectedGuest.contact.email)) {
            vm.selectedEmail = selectedGuest.contact.email;
        } else {
            vm.selectedEmail = '';
        }
        if ((selectedGuest.contact) && (selectedGuest.contact.phone)) {
            vm.selectedPhone = selectedGuest.contact.phone;
        } else {
            vm.selectedEmail = '';
        }
    };

    function getSourcesGuests(guestName) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                idT: routeConf.guest,
                name: guestName
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error searching guest ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        });
    }

    vm.getGuestsByName = function (guestName) {
        var guestRequest = getSourcesGuests(guestName)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    vm.getGuestsBySurname = function (guestName) {
        var guestRequest = getSourcesGuests(guestName)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    function getSourcesGuestsById(identity) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                idT: routeConf.guest,
                identity: identity
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error searching guest ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        });
    }

    vm.getGuestsById = function (identity) {
        var guestRequest = getSourcesGuestsById(identity)
            .then(function (data) {
                var response = data.data;
                var guestArray = response.map(function (item) {
                    return item;
                });
                return guestArray;
            });
        return guestRequest;
    };

    vm.changeIsResident = function (value) {
        if (vm.modeCancel) {
            return;
        }
        vm.isResident = value;
        vm.isGuest = !value;
    };

    vm.validDNI = function (input, type, formInput) {
        var valid = true;
        if (input === undefined) {
            if (formInput.$viewValue !== undefined) {
                if (!formInput.$pristine && input !== '') {
                    if (type === undefined) {
                        if (type !== 'PAS') {
                            valid = ValidationService.validDniNie(formInput.$viewValue,
                                vm.constants.docType[0].description);
                        }
                    } else {
                        if (type !== 'PAS') {
                            valid = ValidationService.validDniNie(formInput.$viewValue, type);
                        }
                    }
                }
                formInput.$setValidity('valid', valid);
                return valid;
            }
        } else {
            if (!formInput.$pristine && input !== '') {
                if (type !== 'PAS') {
                    valid = ValidationService.validDniNie(input, type);
                }
            }
            formInput.$setValidity('valid', valid);
            return valid;
        }
    };

    vm.changeTypeIde = function (type) {
        if (vm.readonly) {
            return;
        }
        vm.cont += 1;
        if (vm.cont < vm.constants.docType.length) {
            vm.guest.identity.type = vm.constants.docType[vm.cont];
            vm.selectedDocType = vm.constants.docType[vm.cont];
        } else {
            vm.cont = 0;
            vm.guest.identity.type = vm.constants.docType[0];
            vm.selectedDocType = vm.constants.docType[0];
        }
    };

    vm.validateMobile = function (mobile, formInput) {
        var valid = true;
        if (!formInput.$pristine && mobile !== '') {
            valid = ValidationService.validMobile(mobile);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validEmail = function (emailField, formInput) {
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,4})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (emailField) {
            valid = (!emailField || formInput.$pristine || reg.test(emailField));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };

    vm.parseUserListBy = function () {
        vm.alredyFloor = _.filter(vm.appUsers, function (appUser) {
            if (appUser.allFloor) {
                return appUser;
            }
        });
    };

    vm.parseUserList = function (users) {
        var usrList = angular.copy(users);
        var listByBran = [];
        _.forEach(usrList, function (item) {
            item.branches = item.branches[0];
            var b = _.find(listByBran, function (a) {
                return a._id === item.branches._id;
            });
            if (!b) {
                listByBran.push({
                    _id: item.branches._id,
                    usr: [item]
                });
            } else {
                b.usr.push(item);
            }
        });
        var list = [];
        _.forEach(listByBran, function (bran) {
            bran.usr = _.orderBy(bran.usr, ['room', 'asc']);
            _.forEach(bran.usr, function (i) {
                list.push(i);
            });
        });

        var lastFloor = -1;
        var out = [];
        _.forEach(list, function (user) {
            user.nameRoom = '[' + user.room + '] ' + user.name + ' ' +
                user.surname;
            out.push(user);
        });
        return out;
    };

    function clearAppUserByBrnch(br) {
        var list = [];
        _.forEach(vm.appUser, function (appUser) {
            var correct = _.find(br, function (ba) {
                return (ba._id === appUser.branches._id);
            });
            if (correct) {
                list.push(appUser);
            }
        });
        return list;
    }

    function checkAvailableUsers(branches) {
        $log.debug('checkAvailableUsers branches', branches);
        vm.appUsers = clearAppUserByBrnch(branches);
        $log.debug('vm.appUsers', vm.appUsers);
    }

    function loadAllResidents(branches) {
        MasterTableService.get({idT: routeConf.resident, branches: branches, virtual: 'all'}, function (data) {
            vm.appUsers = vm.parseUserList(data.data);
            vm.appUsersOri = (data.data);
            $log.debug('resident load success', data);
            if (vm.service && vm.appUsers && vm.appUsers.length > 0) {
                vm.allUsers = data.data;
                $log.debug('vm.appUsers load success', vm.appUsers);
                //checkAvailableUsers(branches);
                //vm.parseUserListBy();
            }
        }, function (err) {
            $log.error('error load masterTable branch', err);
            toastr.error(TranslationService.errors.e500);
        });
    }

    vm.$onInit = function () {
        if (vm.modeCancel === true) {
            if (vm.service.resourceToCancel.involveds[0].kind === 'Guest') {
                vm.isResident = false;
                vm.isGuest = true;
                vm.setGuest(vm.service.resourceToCancel.involveds[0].item);
            } else {
                vm.isResident = true;
                vm.isGuest = false;
                vm.appUser = vm.service.resourceToCancel.involveds[0].item;
            }
        } else {
            ConfigService.query({functionality: 'docTypes'}, function (data) {
                vm.constants = {
                    docType: data
                };
                vm.guest.identity = {
                    type: vm.constants.docType[0]
                };
                vm.selectedDocType = vm.constants.docType[0];
                $log.debug('vm.service', vm.service);
            }, function (error) {
                $log.error('load constants: ', error);
                vm.ready = true;
                toastr.error(TranslationService.errors.e500);
            });

            var userBranch = localStorageService.get('branches');
            var selectedBar = localStorageService.get('selectedBarResidence');

            vm.guest = {
                branches: (selectedBar && !selectedBar.all) ?
                    selectedBar._id : userBranch,
                active: true,
                isResident: false
            };
            loadAllResidents(vm.guest.branches);
            if (!vm.animSchedule) {
                $timeout(function () {
                    vm.animSchedule = true;
                }, 500);
            }
        }
    };

    vm.back = function () {
        vm.guest = {};
        vm.appUsers = {};
        vm.isResident = true;
        vm.isGuest = false;
        vm.showReserveView = false;
        vm.modeCancel = false;
        vm.service.action = 'refList';
        vm.animSchedule = false;
        $rootScope.$emit('refreshScheduler');
    };

    vm.cancel = function () {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                MasterTableService.delete({
                        idT: routeConf.app, idJ: routeConf.facilityBook,
                        idP: vm.service.resourceToCancel._id, resource: vm.service.resourceToCancel
                    },
                    function (data) {
                        $log.debug('delete resource success');
                        toastr.success(TranslationService.reserve.msg.delete);
                        vm.showReserveView = false;
                        vm.modeCancel = false;
                        vm.service.action = 'refList';
                        localStorageService.set('needRefreshSchedule', true);
                        $timeout(function () {
                            $rootScope.$emit('refreshScheduler');
                        }, 1000);
                    }, function (err) {
                        $log.error('delete resource error', err);
                        toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    });
            }
        });
    };

    vm.save = function (resForm) {
        var dates = [];
        var datetimeData = {
            dateFrom: vm.service.scheduleToAdd.start,
            dateTo: vm.service.scheduleToAdd.end
        };
        var start = moment(vm.service.scheduleToAdd.start);
        var end = moment(vm.service.scheduleToAdd.end);

        if ((start.dayOfYear() !== end.dayOfYear()) || (start.year() !== end.year())) {
            $log.error('Reservation overlaps with opening/closing times ', datetimeData);
            toastr.error(TranslationService.errors.ERR405002, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        } else {
            dates.push(datetimeData);

            vm.showError = false;
            var query = {};
            if ((!vm.submitted && !resForm.$valid) || !resForm.$valid) {
                vm.submitted = true;
                var visibleInvalids = angular.element.find('.ng-invalid:visible');
                // first is form ...is invalid always got in 2 length
                if (visibleInvalids && visibleInvalids.length > 1) {
                    visibleInvalids[1].focus();
                }
            } else {
                if (vm.isGuest) {
                    if ((vm.selectedName !== vm.guest.name) ||
                        (vm.selectedSurname !== vm.guest.surname) ||
                        (vm.selectedDocVal !== vm.guest.identity.docVal)) {
                        vm.guest._id = null;
                        vm.guest.name = vm.selectedName;
                        vm.guest.surname = vm.selectedSurname;
                        vm.guest.identity = {
                            docType: vm.selectedDocType._id,
                            docVal: vm.selectedDocVal
                        };
                        if (vm.selectedPhone === undefined) {
                            vm.selectedPhone = '';
                        }
                        if (vm.selectedEmail === undefined) {
                            vm.selectedEmail = '';
                        }

                        vm.sav = {
                            facility: vm.service._id,
                            guest: {
                                name: vm.selectedName,
                                surname: vm.selectedSurname,
                                identity: {
                                    docType: vm.selectedDocType._id,
                                    docVal: vm.selectedDocVal
                                },
                                contact: {
                                    email: vm.selectedEmail,
                                    phone: vm.selectedPhone
                                },
                                branches: vm.branches
                            },
                            dates: dates
                        };

                        query.idT = routeConf.app;
                        query.idJ = routeConf.facilityBook;
                        $log.debug('service to save', vm.service);
                        MasterTableService.postArr(query, vm.sav, function (response) {
                            $log.debug('create reserve success', response);
                            vm.anim = false;
                            toastr.success(TranslationService.reserve.msg.edit);
                            vm.showReserveView = false;
                            vm.modeCancel = false;
                            vm.service.action = 'refList';
                            vm.animSchedule = false;
                            localStorageService.set('needRefreshSchedule', true);
                            $timeout(function () {
                                $rootScope.$emit('refreshScheduler');
                            }, 1000);
                        }, function (err) {
                            $log.error('error create reserve ', err);
                            var mensaje = err.data.error;
                            var respuestaError = TranslationService.errors.e500;

                            if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405002)) ||
                                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405002))) {
                                respuestaError = TranslationService.errors.ERR405002;
                            } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405003)) ||
                                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405003))) {
                                respuestaError = TranslationService.errors.ERR405003;
                            } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405007)) ||
                                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405007))) {
                                respuestaError = TranslationService.errors.ERR405007;
                            }
                            toastr.error(respuestaError, TranslationService.errors.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    } else {
                        vm.sav = {
                            facility: vm.service._id,
                            guest: {_id: vm.guest._id},
                            dates: dates
                        };

                        query.idT = routeConf.app;
                        query.idJ = routeConf.facilityBook;
                        $log.debug('service to save', vm.service);
                        MasterTableService.postArr(query, vm.sav, function (response) {
                            $log.debug('create reserve success', response);
                            vm.anim = false;
                            toastr.success(TranslationService.reserve.msg.edit);
                            vm.showReserveView = false;
                            vm.modeCancel = false;
                            vm.service.action = 'refList';
                            vm.animSchedule = false;
                            localStorageService.set('needRefreshSchedule', true);
                            $timeout(function () {
                                $rootScope.$emit('refreshScheduler');
                            }, 1000);
                        }, function (err) {
                            $log.error('error create reserve ', err);
                            var mensaje = err.data.error;
                            var respuestaError = TranslationService.errors.e500;

                            if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405002)) ||
                                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405002))) {
                                respuestaError = TranslationService.errors.ERR405002;
                            } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405003)) ||
                                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405003))) {
                                respuestaError = TranslationService.errors.ERR405003;
                            } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                                (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405007)) ||
                                ((mensaje.error.code !== undefined) && (mensaje.error.code === 405007))) {
                                respuestaError = TranslationService.errors.ERR405007;
                            }
                            toastr.error(respuestaError, TranslationService.errors.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    }
                } else {
                    vm.sav = {
                        facility: vm.service._id,
                        serviceData: {
                            cost: _.get(vm.service, 'cost.value'),
                            branch: vm.service.branch,
                            title: vm.service.title
                        },
                        appUser: angular.copy(vm.appUser),
                        dates: dates,
                        active: true
                    };
                    query.idT = routeConf.app;
                    query.idJ = routeConf.facilityBook;
                    $log.debug('service to save', vm.service);
                    MasterTableService.postArr(query, vm.sav, function (response) {
                        $log.debug('create reserve success ', response);
                        vm.anim = false;
                        toastr.success(TranslationService.reserve.msg.edit);
                        vm.showReserveView = false;
                        vm.modeCancel = false;
                        vm.service.action = 'refList';
                        vm.animSchedule = false;
                        localStorageService.set('needRefreshSchedule', true);
                        $timeout(function () {
                            $rootScope.$emit('refreshScheduler');
                        }, 1000);
                    }, function (err) {
                        $log.error('error create reserve ', err);
                        var mensaje = err.data.error;
                        var respuestaError = TranslationService.errors.e500;

                        if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                            (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405002)) ||
                            ((mensaje.error.code !== undefined) && (mensaje.error.code === 405002))) {
                            respuestaError = TranslationService.errors.ERR405002;
                        } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                            (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405003)) ||
                            ((mensaje.error.code !== undefined) && (mensaje.error.code === 405003))) {
                            respuestaError = TranslationService.errors.ERR405003;
                        } else if ((mensaje.error && mensaje.error.length && mensaje.error.length > 0 &&
                            (mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405007)) ||
                            ((mensaje.error.code !== undefined) && (mensaje.error.code === 405007))) {
                            respuestaError = TranslationService.errors.ERR405007;
                        }
                        toastr.error(respuestaError, TranslationService.errors.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    });
                }
            }
        }
    };
}

angular
    .module('Tagaste.inServiceReserveCom')
    .component('inServiceReserve', {
        templateUrl: 'app/components/inService/inServiceReserve/inServiceReserve.html',
        controllerAs: 'serresc',
        controller: inServiceReserveController,
        bindings: {
            service: '=',
            level: '@',
            animSchedule: '=',
            showReserveView: '=',
            modeCancel: '='
        }
    });

function incidentDetailController($log, MasterTableService, routeConf, TranslationService, localStorageService, toastr,
                                  Lightbox, $rootScope, PermissionsService, Funcionalities, UsersServiceByBranch, Roles) {
    var vm = this;

    vm.avatarUploading = false;
    vm.hideSelectResidence = false;
    vm.disabledFields = false;
    vm.accessPush = false;
    vm.historyopen = true;
    vm.attachedsopen = true;

    vm._CONTROLLER = 'incidentDetailController';

    function setPermissions() {
        vm.disabledFields = !PermissionsService.gotPermission('INCIDENT', 'update');
        vm.accessPush = PermissionsService.gotPermission('PUSH', 'update');
    }

    vm.$doCheck = function () {
        if (!vm.previousBulletinId) {
            vm.previousBulletinId = vm.incidentId;
            init();
        } else if (vm.previousBulletinId !== vm.incidentId) {
            vm.previousBulletinId = vm.incidentId;
            init();
        }
    };

    vm.changeLocality = function(){
        //vm.incident.assignedTo = {};
        getSourcesSpots(vm.incident.branch._id).then(function (dataSpots) {
            getSourcesTaskParent().then(function (dataParent) {
                getSourcesTaskType(dataParent, vm.incident.branch._id).then(function (dataTaskType) {
                    getSourcesRoleMaintenance().then(function (dataRole) {
                        vm.maintenanceRoles = dataRole;
                        getSourcesUsers(vm.incident.branch._id, dataRole).then(function (dataUser) {                            
                            vm.listSpots = dataSpots;
                            vm.listTaskType = dataTaskType;
                            vm.listUsers = angular.copy(dataUser.data);
                        });
                    });
                });
            });
        });
    };

    function getSourcesStatusType() {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.statusType};
            query.functionality = Funcionalities.incident;
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load statusType', err);
            }).$promise.then(function (data) {
                $log.debug('load statusType success', data);
                full(data);
            });
        });
    }

    function getSourcesUsers(branch, role) {
        return new Promise(function (full, reject) {
            var queryUsers = {branch:  branch};
            if (role){
                queryUsers.role=_.map(role, '_id');
            }
            UsersServiceByBranch.get(queryUsers, function (data) {
            }, function (err) {
                $log.error('error getting employees : ', err);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }
    function getSourcesTaskParent() {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.config};
            query.functionality = 'taskTypes';
            query.code = 'maintenance';
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load taskType', err);
            }).$promise.then(function (data) {
                $log.debug('load taskParent success', data);
                full(data);
            });
        });
    }

    function getSourcesRoleMaintenance() {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.role};
            query.code = Roles.maintenanceGroup;
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load taskType', err);
            }).$promise.then(function (data) {
                $log.debug('load ROLE MAINTENANCE success', data);
                full(data);
            });
        });
    }

    function getSourcesTaskType(taskParent, branch) {
        return new Promise(function (full, reject) {
            var userBranch = localStorageService.get('branches');
            var query = {
                idT: routeConf.masterTable,
                idJ: routeConf.taskType,
                branch: branch ? branch : userBranch
            };
            if (taskParent && taskParent[0] && taskParent[0]._id){
                query.taskParent = taskParent[0]._id;
            }
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load taskType', err);
            }).$promise.then(function (data) {
                $log.debug('load taskType success', data);
                full(data);
            });
        });
    }

    function getSourcesSpots(branch) {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.spot};
            query.branch = branch;
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load spots', err);
            }).$promise.then(function (data) {
                $log.debug('load spots success', data);
                full(data);
            });
        });
    }

    vm.changePriority = function (value) {
        vm.tracking.priority = value;
    };

    /**
     * @ngdoc method
     * @name init
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that load  initials data
     */
    function init() {
        vm.popup = {
            opened: false
        };
        vm.dateOptions = {
            maxDate: moment().toDate(),
            showWeeks: false
        };
        vm.tracking = {
            notify: false,
            priority: false
        };
        vm.fileShowedArray = [];
        vm.disabledFields = false;
        if (vm.modeReadOnly) {
            MasterTableService.get({idT: routeConf.app, idJ: routeConf.incident, idP: vm.incidentId}, function (data) {
                $log.debug('load incident detail success', data);
                vm.incident = data;
                $log.debug('vm.incident.date', vm.incident.date);
                vm.createdDate = moment(vm.incident.date).toDate();
                $log.debug('vm.createdDate', vm.createdDate);
                if (vm.incident.originAppUser) {
                    vm.incident.fullName = vm.incident.originAppUser.fullName;
                    vm.disabledFields = true;
                } else if (vm.incident.originUser) {
                    vm.incident.fullName = vm.incident.originUser.item.fullName;
                } else {
                    vm.incident.fullName = TranslationService.incidentDetail.tagaste;
                }
                for (var i = 0; i < vm.incident.tracking.length; i++) {
                    vm.incident.tracking[i].dateFormated = moment(vm.incident.tracking[i].date).format('L LT');
                }
                setPermissions();
                vm.statusSet = vm.incident.lastStatus.status;
                vm.tracking.priority = vm.incident.priority;
                vm.tracking.status = angular.copy(vm.statusSet);
                if (!vm.incident.attacheds) {
                    vm.incident.attacheds = [];
                }
            }, function (err) {
                $log.error('error load incident detail', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            vm.createdDate = Date.now();
            vm.incident = {
                fullName: localStorageService.get('user').name + ' ' + localStorageService.get('user').surname,
                photos: [],
                attacheds: []
            };
        }

        loadAllLocalities().then(function (data) {
            getSourcesStatusType().then(function (data2) {
                var allLocalities = data;
                $log.debug('mastertable branch load success', data);
                var selectedBar = localStorageService.get('selectedBarResidence');
                var userBranch = localStorageService.get('branches');
                if (userBranch.length === 1) {
                    vm.hideSelectResidence = true;
                    if(vm.modeCreation) {
                        vm.incident.branch = {_id:userBranch};
                    }
                    // if (vm.incident && !vm.incident.branch) {
                    //     vm.incident.branch = (selectedBar && !selectedBar.all) ? selectedBar : userBranch[0];
                    // }
                } else {
                    // if (!vm.incident) {
                    //     vm.incident = {};
                    // }

                    if(vm.modeCreation) {
                        vm.incident.branch = (selectedBar && !selectedBar.all) ? selectedBar : undefined;
                    }
                }
                vm.localities = [];
                for (var i = 0; i < allLocalities.length; i++) {
                    for (var j = 0; j < userBranch.length; j++) {
                        if (userBranch[j] === allLocalities[i]._id) {
                            vm.localities.push(allLocalities[i]);
                        }
                    }
                }
                if(vm.incident && vm.incident.branch) {
                    getSourcesSpots(vm.incident.branch._id).then(function (dataSpots) {
                        getSourcesTaskParent().then(function (dataParent) {
                            getSourcesTaskType(dataParent, vm.incident.branch._id).then(function (dataTaskType) {
                                getSourcesRoleMaintenance().then(function (dataRole) {
                                    vm.maintenanceRoles = dataRole;
                                    getSourcesUsers(vm.incident.branch._id, dataRole).then(function (dataUser) {
                                        vm.listStatusType = data2;
                                        vm.listSpots = dataSpots;
                                        vm.listTaskType = dataTaskType;
                                        vm.listUsers = angular.copy(dataUser.data);
                                        $rootScope.$digest();
                                    });
                                });
                            });
                        });
                    });
                }
            });
        });
    }

    $rootScope.$on('deleteAttach', function (event, attachment) {
        _.remove(vm.incident.attacheds, function (item) {
            if (item._id){
                return item._id === attachment._id;
            } else {
                return item.original.key === attachment.original.key;
            }
        });
       if (!vm.incident.attachToDelete) {
            vm.incident.attachToDelete = [];
        }
        vm.incident.attachToDelete.push({_id: attachment._id});
    });

    /**
     * @ngdoc method
     * @name saveIncidentTracking
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that save a new element of tracking
     */
    vm.saveIncidentTracking = function () {
        $log.debug('save tracking', vm.tracking);
        MasterTableService.post({idT: routeConf.app, idJ: routeConf.incidentStatus, idP: vm.incidentId}, vm.tracking,
            function (data) {
                $log.debug('save incident tracking success', data);
                init();
            }, function (err) {
                $log.error('error save incident tracking', err);
            });
    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that redirect to list of incidents
     */
    vm.cancel = function () {
        vm.showIncidentView = false;
        vm.anim = false;
        vm.modeCreation = false;
        vm.showCompleteList = false;
    };

    /**
     * @ngdoc method
     * @name saveIncident
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that save a new incident
     * @param form is form of html view
     *
     */
    vm.saveIncident = function (form) {
        // Update priority
        vm.incident.priority = vm.tracking.priority;
        // Update lastStatus
        vm.incident.status = vm.tracking.status;
        $log.debug('save incident', vm.incident);
        if (form.$valid) {
            vm.incident.date = moment(vm.createdDate);
            var query = {
                idT: routeConf.app,
                idJ: routeConf.incident
            };
            if (vm.modeReadOnly) {
                query.idP = vm.incident._id;
            }
            MasterTableService.post(query, vm.incident, function (data) {
                $log.debug('save incident success', data);
                vm.showIncidentView = false;
                vm.anim = false;
                vm.onUpdated({value: ''});
                if (vm.modeReadOnly) {
                    toastr.success(TranslationService.incidentDetail.msg.edit);
                } else {
                    toastr.success(TranslationService.incidentDetail.msg.success);
                }
            }, function (err) {
                $log.error('save incident error', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
        else {
            vm.showError = true;
        }
    };

    /**
     * @ngdoc method
     * @name checkDates
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that check if  a date is later that actual time
     *
     */
    vm.checkDates = function () {
        return vm.createdDate && moment(vm.createdDate).endOf('day').isAfter(moment().endOf('day'));
    };

    /**
     * @ngdoc method
     * @name deletePhoto
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that delete a photo
     * @param photo is object photo to delete
     */
    vm.deletePhoto = function (photo) {
        $log.debug('deletePhoto', photo);
        _.remove(vm.incident.photos, function (item) {
            return item._id === photo._id;
        });
        if (!vm.modeCreation) {
            if (!vm.incident.photosDel) {
                vm.incident.photosDel = [];
            }
            vm.incident.photosDel.push({_id: photo._id});
        }
    };

    /**
     * @ngdoc method
     * @name openLightboxModal
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that show an image in a modal
     * @param file is the image to show
     */
    vm.openLightboxModal = function (file) {
        $log.debug('file', file);
        var urlDownload = '';
        MasterTableService.get({
            idT: routeConf.file, idJ: routeConf.signedUrl, key: file.original.key,
            bucket: file.original.bucket
        }, function (data) {
            $log.debug('signedUrl', data);
            file.url = data.url;
            urlDownload = data.url;
            var index = _.findIndex(vm.fileShowedArray, {'_id': file._id});
            if (index < 0) {
                vm.fileShowedArray.push(file);
                index = vm.fileShowedArray.length - 1;
            }
            Lightbox.templateUrl = 'lightbox.html';
            Lightbox.openModal(vm.fileShowedArray, index);
        }, function (err) {
            $log.debug('error load attached file', err);
            toastr.error(TranslationService.errors.noImage, TranslationService.warning,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };

    /**
     * @ngdoc method
     * @name loadAllLocalities
     * @methodOf Tagaste.incidentDetailCom.controller:incidentDetailController
     * @description
     * Method that load all localities of a user
     *
     */
    function loadAllLocalities() {
        return new Promise(function (full, reject) {
            MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.branch}, function (data) {
            }, function (err) {
                $log.error('error load masterTable branch', err);
                toastr.error(TranslationService.errors.e500);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    $rootScope.$on('closeIncidentDetail', function () {
        vm.cancel();
    });

}

angular
    .module('Tagaste.incidentDetailCom')
    .component('incidentDetail', {
        templateUrl: 'app/components/incidents/incidentDetail/incidentDetail.html',
        controllerAs: 'idc',
        controller: incidentDetailController,
        bindings: {
            incidentId: '=',
            modeReadOnly: '=',
            showIncidentView: '=',
            anim: '=',
            onUpdated: '&',
            modeCreation: '=',
            showDisabled: '<',
            showCompleteList: '=',
            istour: '<'
        }
    });

function incidentsListController(NgTableParams, NgTableFilterService, $log, $timeout, localStorageService, TourService,
    $rootScope, PermissionsService, $filter, IncidentsExportService, FileSaver, TranslationService, RequestExportService, toastr,
                                 $location, $scope) {
    var vm = this;

    vm.tableParams = {};
    vm.selectIncident = null;
    vm.showIncidentView = false;
    vm.gotAccessCreate = false;

    function setPermissions() {
        vm.gotAccessCreate = PermissionsService.gotPermission('INCIDENT', 'UPDATE');
    }

    var viewParams = localStorageService.get('incidentsViewParams') ?
        localStorageService.get('incidentsViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = { filterIncidentsList: { locality: selectedBar.description } };
    }
    viewParams.sortingIncidentsList = { priority: true, placeText: 'asc' };
    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/incidents') {
            viewParams = { filterIncidentsList: { locality: (!data.all) ? data.description : '' } };
            initTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);
    vm.$onInit = function () {
        setPermissions();
        vm.userBranch = localStorageService.get('branches');
        vm.tableParams = null;
        initTable(vm.list);
    };

    vm.$onDestroy = function () {
        localStorageService.set('incidentsViewParams', null);
    };

    vm.$onChanges = function (changeValue) {
        vm.pagg = vm.pag;
        if (changeValue.list && changeValue.list.currentValue) {
            initTable(changeValue.list.currentValue);
        }
    };

    /**
     * @ngdoc method
     * @name iniTable
     * @methodOf Tagaste.incidentsListCom.controller:incidentsListController
     * @description
     * Method that load all data in table
     * @param list array data to initialize the table
     */
    function initTable(list) {
        if (!list) {
            list = [];
        }
        for (var i = 0; i < list.length; i++) {
            if (list[i].createdAt) {
                list[i].createdDate = moment(list[i].date).format('L');
                list[i].createdDateLong = moment(list[i].date).format('L LT');
            }
            if (list[i].branch.description) {
                list[i].locality = list[i].branch.description;
            } else {
                list[i].locality = 'Sin definir';
            }

            if (list[i].spot && list[i].spot.description) {
                list[i].placeText = list[i].spot.description;
            } else {
                list[i].placeText = 'Sin definir';
            }
        }

        var sorting = viewParams['sortingIncidentsList'] ? viewParams['sortingIncidentsList'] : { timeOut: 'desc' };
        var page = viewParams['pageIncidentsList'] ? viewParams['pageIncidentsList'] : 1;
        var count = viewParams['countIncidentsList'] ? viewParams['countIncidentsList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingIncidentsList'] = params._params.sorting;
                        viewParams['pageIncidentsList'] = page;
                        viewParams['countIncidentsList'] = params._params.count;
                        viewParams['filterIncidentsList'] = filterObj;
                        localStorageService.set('incidentsViewParams', viewParams);
                        vm.currentTableData = filteredData;
                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterIncidentsList'] ? viewParams['filterIncidentsList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    /**
     * @ngdoc method
     * @name tableParamsCK
     * @methodOf Tagaste.incidentsListCom.controller:incidentsListController
     * @description
     * Method that marked a row of table and show detail of bulletin
     *
     */
    vm.tableParamsCK = function (row) {
        if (vm.istour) {
            return;
        }
        if (!row.error) {
            if (vm.modeCreation) {
                vm.showIncidentView = false;
                vm.anim = false;
                vm.modeReadOnly = false;
                vm.modeCreation = false;

            } else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });
                vm.modeReadOnly = true;
                vm.showIncidentView = true;
                vm.modeCreation = false;
                vm.selectIncident = row._id;
                $log.debug('selected incident', row);
            }
        }
    };

    vm.filterLocality = {
        locality: {
            id: 'text'
        }
    };
    vm.filterText = {
        text: {
            id: 'text'
        }
    };
    vm.filterPlaceText = {
        placeText: {
            id: 'text'
        }
    };
    vm.filterDate = {
        createdDate: {
            id: 'text'
        }
    };

    vm.exportDataOld = function () {
        var filename = TranslationService.requests.title + '_' + moment().format('YYYYMMDD');
        var columns = {
            userName: TranslationService.requests.list.name,
            userSurname: TranslationService.requests.list.surname,
            userCourse: TranslationService.requests.list.course,
            formattedDate: TranslationService.requests.list.date,
            branch: TranslationService.requests.list.branch,
            depositDate: TranslationService.requests.list.depositDate,
            registrationDate: TranslationService.requests.list.registrationDate,
            averageRating: TranslationService.requests.list.rating,
            isReservation: TranslationService.requests.list.isReservation,
        };
        RequestExportService.post({idR: 'export'}, {
            data: vm.currentTableData,
            filename: filename, columns: columns
        }, function (data) {
            var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            FileSaver.saveAs(blob, filename + '.xlsx');
        }, function (err) {
            $log.error('RequestService export error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };

     vm.exportData = function () {
        var filename = TranslationService.incidents.title.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = TranslationService.incidents.export;

        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function(e) { return e._id; }),
            filename: filename,
        };

        IncidentsExportService.post(
            {  }, requestData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('IncidentsExportService export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    { progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true });
            });
    };

    /**
     * @ngdoc method
     * @name newIncident
     * @methodOf Tagaste.incidentsListCom.controller:incidentsListController
     * @description
     * Method that redirect to create new bulletin
     *
     */
    vm.newIncident = function () {
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.modeReadOnly = false;
        vm.showIncidentView = true;
        vm.modeCreation = true;
    };

    $rootScope.$on('openIncidentDetailFirstRow', function () {
        if (vm.tourDummyData.length < 1) {
            var row = vm.tableParams.data[0];
            if (!row.error) {
                if (vm.modeCreation) {
                    vm.showIncidentView = false;
                    vm.anim = false;
                    vm.modeReadOnly = false;
                    vm.modeCreation = false;

                } else {
                    if (!vm.anim) {
                        $timeout(function () {
                            vm.anim = true;
                        }, 401);
                    }
                    _.forEach(vm.tableParams.data, function (r) {
                        r.selected = (r._id === row._id);
                    });
                    vm.modeReadOnly = true;
                    vm.showIncidentView = true;
                    vm.modeCreation = false;
                    vm.selectIncident = row._id;
                    $log.debug('selected incident', row);
                }
            }
        }
        else {
            vm.newIncident();
        }
    });

    $rootScope.$on('openIncidentDetail', function () {
        vm.newIncident();
    });
}

angular
    .module('Tagaste.incidentsListCom')
    .component('incidentsList', {
        templateUrl: 'app/components/incidents/incidentsList/incidentsList.html',
        controllerAs: 'ilstc',
        controller: incidentsListController,
        bindings: {
            selectIncident: '=',
            list: '<',
            pag: '<',
            modeReadOnly: '=',
            showIncidentView: '=',
            anim: '=',
            onDeleted: '&',
            modeCreation: '=',
            initTour: '&',
            tourDummyData: '<',
            istour: '<'
        }
    });

/* nWorkerTaskDetail.
 * @author sila.fernandez
 * created on 07/05/2019
 */
WorkerTaskDetailController.$inject = ['toastr', 'TranslationService', '$log', 'routeConf', '$timeout',
    'localStorageService', 'UsersService', 'MasterTableService', 'ENV',
    '$rootScope', 'PermissionsService'];

function WorkerTaskDetailController(toastr, TranslationService, $log, routeConf, $timeout,
                                    localStorageService, UsersService, MasterTableService, ENV,
                                    $rootScope, PermissionsService) {
    var vm = this;

    vm.worker = null;
    vm.workerOri = {
        _id: '0'
    };
    vm.readOnly = false;
    vm.submitted = false;
    vm.initialized = false;
    vm.dateOptions = {
        minDate: moment().toDate(),
        showWeeks: false
    };

    vm._CONTROLLER = 'WorkerTaskDetailController';

    vm.$doCheck = function () {
        if (vm.worker && vm.worker._id !== vm.workerOri._id && (vm.worker._id !== undefined)) {
            vm.workerOri._id = angular.copy(vm.worker._id);
            vm.initialized = false;
            vm.$onInit();
        }
    };

    vm.checkDates = function () {
        return vm.visibleTo && vm.visibleFrom && moment(vm.visibleFrom).isAfter(moment(vm.visibleTo));
    };

    function getSourcesTaskType() {
        return new Promise(function (full, reject) {
            var branchSelected = localStorageService.get('selectedBarResidence');
            var userBranch = localStorageService.get('branches');
            var query = {
                idT: routeConf.masterTable,
                idJ: routeConf.taskType,
                branch: branchSelected ? branchSelected._id : userBranch
            };
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load taskType', err);
            }).$promise.then(function (data) {
                $log.debug('load taskType success', data);
                full(data);
            });
        });
    }

    vm.$onInit = function () {
        vm.readonly = !(vm.worker.action && (vm.worker.action === 'edit' || vm.worker.action === 'new'));
        if (!vm.readonly) {
            vm.worker.action = 'inEdit';
        }
        if (vm.initialized) {
            return;
        }
        vm.workerOri._id = angular.copy(vm.worker._id);
        var selectedBar = localStorageService.get('selectedBarResidence');

        vm.workerBD = {};
        if (vm.worker._id === '0') {
            vm.workerBD = {
                active: true,
                rate: 0,
                branch: (selectedBar && !selectedBar.all) ? selectedBar : {},
                dateFrom: moment().startOf('day').toDate(),
                dateTo: moment().endOf('day').add(7, 'days').toDate()
            };
            vm.ready = true;
        } else {
            MasterTableService.get({idT: routeConf.app, idJ: routeConf.facility, idP: vm.worker._id}, function (data) {
                vm.workerBD = angular.copy(data);
                if (vm.workerBD.dateFrom) {
                    vm.workerBD.dateFrom = moment(vm.workerBD.dateFrom).toDate();
                } else {
                    vm.workerBD.dateFrom = moment().startOf('day').toDate();
                }
                if (vm.workerBD.dateTo) {
                    vm.workerBD.dateTo = moment(vm.workerBD.dateTo).toDate();
                } else {
                    vm.workerBD.dateTo = moment().startOf('day').toDate();
                }

                var query = {idT: routeConf.app, idJ: routeConf.findScheduledFacility};
                query.facility = vm.worker._id;
                query.dateFrom = moment().toDate();
                query.dateTo = moment().add(1, 'months').toDate();

                getSourcesTaskType().then(function (data) {
                    vm.taskTypes = data;
                });
                /*
                vm.taskTypes = [{
                 _id: '5c752128d7e6745458f521ab',
                 description: 'Repaso',
                 code: '00',
                 selected:false,
                 subtype: [{
                     _id: '5c752128d7e6745458f521ab',
                     description: 'Barrer',
                     code: '01',
                     selected:false
                     },
                     {
                         _id: '5c752133d7e6745458f521ac',
                         description: 'Fregar',
                         code: '02',
                         selected:false
                     }]
                 },
                 {
                     _id: '5c752133d7e6745458f521ac',
                     description: 'General',
                     code: '03',
                     selected:false,
                     subtype: [{
                         _id: '5c752128d7e6745458f521ab',
                         description: 'Cambios sábanas',
                         code: '04',
                         selected:false
                     },
                     {
                         _id: '5c752133d7e6745458f521ac',
                         description: 'Amenities',
                         code: '05',
                         selected:false
                     },
                     {
                         _id: '5c752586d7e6745458f521ad',
                         description: 'Debajo de las camas',
                         code: '06',
                         selected:true
                     }]
                 }];
             */
            }, function (err) {
                $log.error('getWorkerTasks error: ', err);
                toastr.error(TranslationService.errors.e500);
                vm.ready = true;
                vm.worker = {};
            });
        }
        vm.initialized = true;
    };

    vm.formatDate = function (date) {
        return moment(date).format('DD/MM/YYYY h:mm');
    };

    vm.checkDates = function () {
        return vm.workerBD.date &&
            vm.workerBD.dateTo && moment(vm.workerBD.dateTo).isAfter(moment(vm.workerBD.date));
    };

    vm.changeTask = function (task) {
        if (!vm.readonly) {
            _.forEach(vm.taskTypes, function (t) {
                if (task.code === t.code) {
                    if (!t.selected || (t.selected === undefined)) {
                        t.selected = false;
                        _.forEach(t.subtype, function (s) {
                            s.selected = false;
                        });
                    } else {
                        t.selected = true;
                        _.forEach(t.subtype, function (s) {
                            s.selected = true;
                        });
                    }
                }

            });
        }
    };

    vm.changeSubtask = function (subtask) {
        if (!vm.readonly) {
            _.forEach(vm.taskTypes, function (t) {
                _.forEach(t.subtype, function (s) {
                    if (subtask.code === s.code) {
                        if (!s.selected || (s.selected === undefined)) {
                            s.selected = false;
                        } else {
                            s.selected = true;
                        }
                    }
                });
            });
        }
    };

    vm.save = function (serForm) {
        vm.submitted = false;
        vm.showError = false;
        if ((!vm.submitted && !serForm.$valid) || !serForm.$valid) {
            vm.submitted = true;
            vm.showError = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            visibleInvalids[1].focus();
        } else {
            vm.workerBD.tasks = angular.copy(vm.taskTypes);
            vm.anim = false;
            vm.worker = {};
            vm.worker.action = 'refList';

            if (vm.worker._id !== '0') {
                var data = vm.workerBD;
                /* TODO: to adapt API request
                var query = {idT: routeConf.app, idJ: routeConf.workerTask};
                query.idP = vm.workerBD._id;
                MasterTableWorkerTask.post(query, data, function (data) {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.anim = false;
                    vm.worker = {};
                    vm.worker.action = 'refList';
                }, function (error) {
                    $log.error('WorkerTasks post (update) error: ', error);
                    toastr.error(TranslationService.errors.e500);
                });
                */
            }
            /* TODO: to adapt API request
            else {
                var query = {idT: routeConf.app, idJ: routeConf.workerTask};
                MasterTableWorkerTask.post(query, vm.workerBD, function (data) {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.anim = false;
                    vm.worker = {};
                    vm.worker.action = 'refList';
                }, function (error) {
                    $log.error('WorkerTasks post (create) error: ', error);
                    toastr.error(TranslationService.errors.e500);
                });
            }
            */
        }
    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.inWorkerTaskDetailComponent.controller:WorkerTaskDetailController
     * @description
     * Method that close de detail  without saving information
     */
    vm.cancel = function () {
        vm.anim = false;
        vm.worker = {};
    };

    $rootScope.$on('closeWorkerTaskDetail', function () {
        vm.cancel();
    });
}

angular
    .module('BlurAdmin.inWorkerTaskDetailComponent')
    .component('inWorkerTaskDetailCom', {
        templateUrl: 'app/components/inWorkerTask/inWorkerTaskDetail/inWorkerTaskDetail.html',
        controllerAs: 'schlcdetc',
        controller: WorkerTaskDetailController,
        bindings: {
            worker: '=',
            anim: '=',
            readOnly: '=',
            constants: '=',
            showCompleteList: '=',
            animWorker: '=',
            istour: '<'
        }
    });

function InWorkerTaskListController($log, $rootScope, localStorageService, weeklySchedulerLocaleService, LanguageFactory,
                                    WorkerTaskService, $uibModal, WorkerTaskUpdateService, TranslationService, toastr, $location, $uibModalStack,
                                    InWorkerTaskListExportService, FileSaver, $scope) {
    var vm = this;

    vm.workers = [];

    weeklySchedulerLocaleService.set(LanguageFactory.getLanguage).then(function ($locale) {
        $log.debug('The locale changed to ', $locale.id);
    });
    vm.model = {
        options: {},
        locale: weeklySchedulerLocaleService.$locale.id,
        items: []
    };

    vm.dayChanged = function (day) {
        return new Promise(function (full, reject) {
            vm.dayFrom = day;
            var query = {};
            query['dateFrom'] = vm.dayFrom ? moment(vm.dayFrom).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
            query['dateTo'] = vm.dayFrom ? moment(vm.dayFrom).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
            if (vm.selectedBar && !vm.selectedBar.all) {
                query['branch'] = vm.selectedBar._id;
            }

            WorkerTaskService.query(query, function (data) {
                $log.debug('WorkerTaskService data: ', data);
            }, function (err) {
                $log.error('WorkerTaskService err: ', err);
            }).$promise.then(function (data) {
                vm.workers = _.sortBy(data, 'worker.fullname', 'desc');
                $log.debug('workers: ', vm.workers);

                var list = [];
                _.forEach(vm.workers, function (item) {
                    list.push({
                        worker: item['worker'],
                        schedules: item['real'],
                        isPlanned: false,
                        editable: false
                    });
                    list.push({
                        worker: item['worker'],
                        schedules: item['planned'],
                        isPlanned: true,
                        editable: false
                    });
                });

                _.forEach(list, function (item) {
                    _.forEach(item.schedules, function (pSchedule) {
                        pSchedule.date = vm.dayFrom ? new Date(moment.utc(vm.dayFrom).local()) : moment();
                        pSchedule.start = new Date(pSchedule.dateFrom);
                        pSchedule.end = new Date(pSchedule.dateTo);
                        pSchedule.scheduleDay = vm.dayFrom ? vm.dayFrom.toDate() : vm.dayFrom;
                        pSchedule.task = pSchedule.wtaskname;
                        pSchedule.isPlanned = item['isPlanned'];
                    });

                    item.title = !item['isPlanned'] && _.get(item, 'worker.fullname') ? _.get(item, 'worker.fullname') : '';
                    item.label = !item['isPlanned'] && _.get(item, 'worker.fullname') ? _.get(item, 'worker.fullname') : '';
                    item.name = !item['isPlanned'] && _.get(item, 'worker.fullname') ? _.get(item, 'worker.fullname') : '';
                });

                vm.model.scroll = list.length > 10;
                vm.model.items = list;
                vm.model.scheduleDay = day;

                full(vm.model);
            });
        });
    };

    vm.getWorkerTasks = function () {
        var query = {};
        query['dateFrom'] = vm.dayFrom ? moment(vm.dayFrom).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        query['dateTo'] = vm.dayFrom ? moment(vm.dayFrom).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
        if (vm.selectedBar && !vm.selectedBar.all) {
            query['branch'] = vm.selectedBar._id;
        }

        WorkerTaskService.query(query, function (data) {
            $log.debug('WorkerTaskService data: ', data);
        }, function (err) {
            $log.error('WorkerTaskService err: ', err);
        }).$promise.then(function (data) {
            vm.workers = _.sortBy(data, 'worker.fullname', 'desc');
            $log.debug('workers: ', vm.workers);

            var list = [];
            _.forEach(vm.workers, function (item) {
                list.push({
                    worker: item['worker'],
                    schedules: item['real'],
                    isPlanned: false,
                    editable: false
                });
                list.push({
                    worker: item['worker'],
                    schedules: item['planned'],
                    isPlanned: true,
                    editable: false
                });
            });

            _.forEach(list, function (item) {
                _.forEach(item.schedules, function (pSchedule) {
                    pSchedule.date = vm.dayFrom ? new Date(moment.utc(vm.dayFrom).local()) : moment();
                    pSchedule.start = new Date(pSchedule.dateFrom);
                    pSchedule.end = new Date(pSchedule.dateTo);
                    pSchedule.scheduleDay = vm.dayFrom ? vm.dayFrom.toDate() : vm.dayFrom;
                    pSchedule.task = pSchedule.wtaskname;
                    pSchedule.isPlanned = item['isPlanned'];
                });

                item.title = !item['isPlanned'] && _.get(item, 'worker.fullname') ? _.get(item, 'worker.fullname') : '';
                item.label = !item['isPlanned'] && _.get(item, 'worker.fullname') ? _.get(item, 'worker.fullname') : '';
                item.name = !item['isPlanned'] && _.get(item, 'worker.fullname') ? _.get(item, 'worker.fullname') : '';
            });

            vm.model.scroll = list.length > 10;
            vm.model.items = list;
            vm.model.scheduleDay = vm.dayFrom;
        });
    };

    vm.openWorkerTaskModal = function (task) {
        if (!task['isPlanned']) {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/components/inWorkerTask/workerTaskModal/workerTaskModal.html',
                controller: 'WorkerTaskModalController',
                controllerAs: 'mod',
                size: 'lg',
                backdrop: 'static',
                windowClass: 'workerTaskModal',
                resolve: {
                    task: function () {
                        return task;
                    }
                }
            });
            modalInstance.result.then(
                //close
                function (updatedTask) {
                    $log.debug('IN SERVICE RESERVE MODAL CLOSED. updatedTask: ', updatedTask);
                    if (updatedTask['wtaskID'] && updatedTask['periodId']) {
                        var query = {
                            idT: updatedTask['wtaskID'],
                            idP: updatedTask['periodId']
                        };
                        var dateFrom = _.clone(updatedTask['selectedDate']);
                        var dateTo = _.clone(updatedTask['selectedDate']);
                        if (updatedTask['selectedHourFrom']) {
                            dateFrom.setHours(updatedTask['selectedHourFrom'].getHours());
                            dateFrom.setMinutes(updatedTask['selectedHourFrom'].getMinutes());
                        }
                        if (updatedTask['selectedHourTo']) {
                            dateTo.setHours(updatedTask['selectedHourTo'].getHours());
                            dateTo.setMinutes(updatedTask['selectedHourTo'].getMinutes());
                        }

                        WorkerTaskUpdateService.post(query, {dateFrom: dateFrom, dateTo: dateTo}, function (response) {
                            $log.debug('WorkerTaskUpdateService response: ', response);
                            toastr.success(TranslationService.activityDetail.msg.edit);
                            $uibModalStack.dismissAll();
                            vm.getWorkerTasks();
                        }, function (err) {
                            $log.error('WorkerTaskUpdateService error: ', err);
                            toastr.error(TranslationService.errors.e500, TranslationService.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    }
                },
                //dismiss
                function () {
                    $uibModalStack.dismissAll();
                    $log.debug('IN SERVICE RESERVE MODAL DISMISSED');
                }
            );
        }
    };

    vm.exportData = function () {
        var filename = TranslationService.calendar.title.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = TranslationService.calendar.export;

        var tempList = vm.model && vm.model.items ? vm.model.items : [];
        var requestData = {
            columns: columns,
            ids: tempList,
            filename: filename,
            day: vm.dayFrom ? moment(vm.dayFrom).format('DD-MM-YYYY') : moment().format('DD-MM-YYYY')
        };

        InWorkerTaskListExportService.post(
            {}, requestData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('InWorkerTaskList export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error, {
                    progressBar: true,
                    timeOut: 8000,
                    extendedTimeOut: 1000,
                    tapToDismiss: true
                });
            });
    };

    $rootScope.$on('showWorkerTaskDetail', function (event, resource) {
        vm.openWorkerTaskModal(resource);
    });

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/workerTask') {
            vm.selectedBar = data;
            vm.getWorkerTasks();
        }
    });
    $scope.$on('$destroy', unregister);
    vm.$onInit = function () {
        vm.selectedBar = localStorageService.get('selectedBarResidence');
        vm.getWorkerTasks();
    };
}

angular
    .module('BlurAdmin.inWorkerTaskListComponent')
    .component('inWorkerTaskListCom', {
        templateUrl: 'app/components/inWorkerTask/inWorkerTaskList/inWorkerTaskList.html',
        controllerAs: 'schlc',
        controller: InWorkerTaskListController,
        bindings: {}
    });

/**
 * Created by jgutierrez on 25/10/2019.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.workerTask.workerTaskList')
        .controller('WorkerTaskModalController', WorkerTaskModalController);

    WorkerTaskModalController.$inject = ['task', '$rootScope', '$uibModalInstance'];

    /** @ngInject */
    function WorkerTaskModalController(task, $rootScope, $uibModalInstance) {
        var vm = this;

        vm.task = task;
        vm.task['plannedStart'] = vm.task['dateFromPlanned'] ? moment(vm.task['dateFromPlanned']).format('DD/MM/YYYY HH:mm') : '';
        vm.task['plannedEnd'] = vm.task['dateToPlanned'] ? moment(vm.task['dateToPlanned']).format('DD/MM/YYYY HH:mm') : '';
        vm.task['selectedDate'] = vm.task['dateFrom'] ? moment(vm.task['dateFrom']).toDate() : null;
        vm.task['selectedHourFrom'] = vm.task['dateFrom'] ? moment(vm.task['dateFrom']).toDate() : null;
        vm.task['selectedHourTo'] = vm.task['dateTo'] ? moment(vm.task['dateTo']).toDate() : null;

        vm.dateOptions = {
            minDate: moment().toDate(),
            showWeeks: false
        };

        vm.hstep = vm.task['plannedStart'] ? 1 : 0;
        vm.mstep = vm.task['plannedStart'] ? 1 : 0;
        vm.ismeridian = false;
        vm.showSpinners = false;

        vm.changedHour = function (newHour) {
        };

        vm.back = function () {
            $uibModalInstance.dismiss();
        };

        vm.save = function () {
            $uibModalInstance.close(vm.task);
        };
    }
})();

MasterTablesConfigController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', '$q'];

function MasterTablesConfigController(toastr, TranslationService, RequestService, $uibModal,
                                      MasterTableService, routeConf, $log, ConfigService, NgTableParams,
                                      PermissionsService, tmhDynamicLocale, masterTables, $rootScope, $q) {

    var vm = this;

    vm.colorPickerOptions = {
        format: 'hexString',
        case: 'lower',
        reset: {
            show: true,
            label: TranslationService.reset,
            class: '',
        }
    };

    vm.filterBranches = function (register) {
        return _.filter(vm.constants.branches, function (item) {
            return !_.find(register['branches'], function (item2) {
                return item2['_id'] === item['_id'] || item2 === item['_id'];
            });
        });
    };

    vm.branchSelection = function (register) {
        if (_.find(register['branches'], {_id: 'all'}) || _.includes(register['branches'], 'all')) {
            register['branches'] = [];
        }
    };

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        vm.currentSelection = vm.selected;
        vm.iconCol = vm.selected.resource === 'allergyTypes';
        vm.numericValueCol = vm.selected.resource === 'billingType' || vm.selected.resource === 'billingCheckoutType';
        vm.colourCol = false;
        vm.branchCol = vm.selected.branches && vm.constants['branches'] && vm.constants['branches'].length > 1;
        vm.multipleBranch = vm.selected.multipleBranch;
        switch (vm.selected.related) {
            case 'universities':
                vm.relatedCol = TranslationService.config.university;
                break;
            case 'faculties':
                vm.relatedCol = TranslationService.config.faculty;
                break;
            default:
                vm.relatedCol = null;
        }

        var queryObj = {
            functionality: vm.selected.resource,
            component: vm.selected.component
        };
        if (_.get(vm.selectedBranch, '_id')) {
            if (vm.multipleBranch) {
                queryObj['branches'] = vm.selectedBranch['_id'];
            } else {
                queryObj['branch'] = vm.selectedBranch['_id'];
            }
        }

        ConfigService.query(queryObj, function (res) {
            $log.debug('master table data: ', res);
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.addingConfig = true;
        vm.configTableParams.settings().dataset.unshift({
            code: '',
            description: '',
            modeEdit: true
        });
        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        if (index !== 0 || config._id) {
            vm.tempConfig = angular.copy(config);
        }
        config.modeEdit = true;
        vm.temporalConfig = angular.copy(config);
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function (config, index) {
        config.modeEdit = false;
        if (index === 0 && !config._id) {
            _.remove(vm.configTableParams.settings().dataset, function (item) {
                return config === item;
            });
        } else {
            _.forEach(vm.configTableParams.settings().dataset, function (item, index) {
                if (item._id === vm.tempConfig._id) {
                    vm.configTableParams.settings().dataset[index] = vm.tempConfig;
                }
            });
            vm.configTableParams.data[index] = vm.tempConfig;
        }
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (config, index) {
        if (_.includes(['roomType'], vm.selected.resource) && vm.selectedBranch && !_.get(vm.selectedBranch, 'all')) {
            config['branch'] = vm.selectedBranch._id;
        }
        if (_.includes(['roomType'], vm.selected.resource) && !(config['branches'] && config['branches'].length)) {
            toastr.warning(TranslationService.errors.branchRequired, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        } else {
            if (config['related']) {
                config['relatedTable'] = vm.selected.relatedTable;
            }
            if (vm.addingConfig) {
                config['functionality'] = vm.selected.resource;
                config['component'] = vm.selected.component;
                ConfigService.post(config, function (res) {
                    $log.debug('post config data: ', res);
                    config.modeEdit = false;
                    vm.addingConfig = false;
                    vm.getTableData();
                }, function (err) {
                    vm.cancelConfig(config, index);
                    $log.error('post config error: ', err);
                    var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                        TranslationService.errors.duplicatedCode : TranslationService.errors.createRegister;
                    toastr.error(errMsg, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            } else {
                ConfigService.put({idR: config._id}, config, function (res) {
                    $log.debug('post config data: ', res);
                    config.modeEdit = false;
                    vm.addingConfig = false;
                    vm.getTableData();
                }, function (err) {
                    vm.cancelConfig(config, index);
                    $log.error('post config error: ', err);
                    var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                        TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                    toastr.error(errMsg, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id}, function (data) {
                    $log.error('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    function loadConstants() {
        return new Promise(function (resolve, reject) {
            var info = {};
            vm.allBranches = angular.fromJson(sessionStorage.getItem('ls.branchesFull'));
            vm.selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));
            info['branches'] = !vm.selectedBranch || _.get(vm.selectedBranch, 'all') ?
                vm.allBranches : (vm.selectedBranch ? _.castArray(vm.selectedBranch) : []);
            if (info['branches'].length === vm.allBranches.length && !_.includes(['roomType'], vm.selected.resource)) {
                info['branches'].push({_id: 'all', description: TranslationService.all});
            }
            var promises = [];
            if (vm.selected.related === 'universities') {
                promises.push(ConfigService.query({functionality: 'universities'}));
            } else if (vm.selected.related === 'faculties') {
                promises.push(ConfigService.query({functionality: 'faculties'}));
            }
            if (promises.length) {
                $q.all(promises).then(function (dataFields) {
                    info['related'] = dataFields[0];
                    resolve(info);
                }).catch(function (err) {
                    $log.error('dataFields promisesArray error: ', err);
                    resolve(info);
                });
            } else {
                resolve(info);
            }
        });
    }

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.selected = vm.currentSelection ? vm.currentSelection : {};
        vm.$onInit();
    });

    vm.$onInit = function () {
        loadConstants().then(function (data) {
            vm.constants = data;
            vm.getTableData();
        });
    };
}

angular
    .module('Tagaste.masterTablesConfigComponent')
    .component('masterTablesConfigComponent', {
        templateUrl: 'app/components/masterTables/masterTablesConfig/masterTablesConfig.html',
        controllerAs: 'mtcc',
        controller: MasterTablesConfigController,
        bindings: {
            selected: '='
        }
    });

MasterTablesCustomConceptsController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal', 'localStorageService',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams', '$translate', 'UsersService',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', 'masterTablesFields'];

function MasterTablesCustomConceptsController(toastr, TranslationService, RequestService, $uibModal, localStorageService,
                                    MasterTableService, routeConf, $log, ConfigService, NgTableParams, $translate, UsersService,
                                    PermissionsService, tmhDynamicLocale, masterTables, $rootScope, masterTablesFields) {

    var vm = this;

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        var queryObj = {
            component: 'customConcept'
        };
        if (_.get(vm.selectedBranch, '_id')) {
            queryObj['branches'] = vm.selectedBranch['_id'];
        }
        ConfigService.query(queryObj, function (res) {
            $log.debug('status master table data: ', res);
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('status master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.filterBranches = function (register) {
        return _.filter(vm.constants.branches, function (item) {
            return !_.find(register['branches'], function (item2) {
                return item2['_id'] === item['_id'] || item2 === item['_id'];
            });
        });
    };

    vm.openConceptDetail = function (data, readOnly) {
        // New concept
        if (!data) {
            data = {
                readonly: false
            };
        }

        if (vm.readonly || readOnly) {
            data.readonly = true;
        } else {
            data.readonly = false;
        }

        data.constants = angular.copy(vm.constants);

        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/modal/modalMasterTablesConceptDetail/modalMasterTablesConceptDetail.html',
            controller: 'ModalMasterTablesConceptDetailController',
            controllerAs: 'mtcdc',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalBinding: function () {
                    return data;
                }
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            //close function
            if (result) {
                vm.getTableData();
            }
        }, function (closemsg) {
            //dismiss function
        });
    };


    /** Function to delete config row */
    vm.deleteConfig = function (config) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.debug('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.getConstants = function () {
        var userID = localStorageService.get('userId');
        ConfigService.query({
            component: 'tax'
        }, function (res) {
            $log.debug('tax master table data: ', res);
            vm.constants.tax = angular.copy(res);

            UsersService.get({idU: userID}, function (data) {
                vm.constants.branch = data.branches;
            }, function (error) {
                $log.error('load user: ', error);
                toastr.error(TranslationService.errors.e500);
            });

        }, function (err) {
            $log.error('tax master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.$onInit();
    });

    vm.$onInit = function () {
        vm.constants = {};
        vm.allBranches = angular.fromJson(sessionStorage.getItem('ls.branchesFull'));
        vm.selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));
        vm.constants['branches'] = !vm.selectedBranch || _.get(vm.selectedBranch, 'all') ?
            vm.allBranches : (vm.selectedBranch ? _.castArray(vm.selectedBranch) : []);
        if (vm.constants['branches'].length === vm.allBranches.length) {
            vm.constants['branches'].push({_id: 'all', description: TranslationService.all});
        }

        vm.getConstants();
        vm.getTableData();
    };
}

angular
    .module('Tagaste.masterTablesCustomConceptsComponent')
    .component('masterTablesCustomConceptsComponent', {
        templateUrl: 'app/components/masterTables/masterTablesCustomConcepts/masterTablesCustomConcepts.html',
        controllerAs: 'mtccc',
        controller: MasterTablesCustomConceptsController,
        bindings: {
            selected: '='
        }
    });

MasterTablesDishController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams', '$translate',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', 'masterTablesFields'];

function MasterTablesDishController(toastr, TranslationService, RequestService, $uibModal,
                                    MasterTableService, routeConf, $log, ConfigService, NgTableParams, $translate,
                                    PermissionsService, tmhDynamicLocale, masterTables, $rootScope, masterTablesFields) {

    var vm = this;

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        ConfigService.query({
            component: 'dishtypes'
        }, function (res) {
            $log.debug('status master table data: ', res);
            _.forEach(res, function (item) {
                item['isTakeAway'] = _.find(vm.constants.binary, {value: item['isTakeAway']});
            });
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('status master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.addingConfig = true;
        vm.configTableParams.settings().dataset.unshift({
            code: '',
            description: '',
            icon: '',
            isTakeAway: '',
            modeEdit: true
        });
        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        if (index !== 0 || config._id) {
            vm.tempConfig = angular.copy(config);
        }
        config.modeEdit = true;
        vm.temporalConfig = angular.copy(config);
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function (config, index) {
        config.modeEdit = false;
        if (index === 0 && !config._id) {
            _.remove(vm.configTableParams.settings().dataset, function (item) {
                return config === item;
            });
        } else {
            _.forEach(vm.configTableParams.settings().dataset, function (item, index) {
                if (item._id === vm.tempConfig._id) {
                    vm.configTableParams.settings().dataset[index] = vm.tempConfig;
                }
            });
            vm.configTableParams.data[index] = vm.tempConfig;
        }
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (config, index) {
        var configSave = angular.copy(config);
        configSave['component'] = 'dishtypes';
        configSave['isTakeAway'] = configSave['isTakeAway'].value;
        if (vm.addingConfig) {
            ConfigService.post(configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.createRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            ConfigService.put({idR: configSave._id}, configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.debug('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    function loadConstants() {
        vm.constants = {
            binary: _.map(masterTablesFields['binary'], function (i) {
                return {name: $translate.instant(i['translatekey']), value: i['value']};
            })
        };
    }

    vm.$onInit = function () {
        loadConstants();
        vm.getTableData();
    };
}

angular
    .module('Tagaste.masterTablesDishComponent')
    .component('masterTablesDishComponent', {
        templateUrl: 'app/components/masterTables/masterTablesDish/masterTablesDish.html',
        controllerAs: 'mtdc',
        controller: MasterTablesDishController,
        bindings: {
            selected: '='
        }
    });

MasterTablesEmailController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal', 'SESListTemplatesService',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams', '$translate',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', 'masterTablesFields', 'ENV', '$q'];

function MasterTablesEmailController(toastr, TranslationService, RequestService, $uibModal, SESListTemplatesService,
                                     MasterTableService, routeConf, $log, ConfigService, NgTableParams, $translate,
                                     PermissionsService, tmhDynamicLocale, masterTables, $rootScope, masterTablesFields, ENV, $q) {

    var vm = this;

    vm.lodash = _;

    vm.toolbarOptions = ENV.toolbarOptions;

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        vm.currentSelection = vm.selected;
        vm.branchCol = vm.selected.branches && vm.constants['branches'] && vm.constants['branches'].length > 1;

        var queryObj = {
            component: 'email'
        };
        if (_.get(vm.selectedBranch, '_id')) {
            queryObj['branch'] = vm.selectedBranch['_id'];
        }

        ConfigService.query(queryObj, function (res) {
            $log.debug('email master table data: ', res);
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('email master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.selectedEmail = {};
        vm.addingConfig = true;
        vm.modeEdit = true;

        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        vm.selectedEmail = config ? angular.copy(config) : {};
        vm.modeEdit = true;
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function () {
        vm.modeEdit = false;
        vm.selectedEmail = {};
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function () {
        var configSave = angular.copy(vm.selectedEmail);
        configSave['component'] = 'email';
        if (vm.addingConfig) {
            ConfigService.post(configSave, function (res) {
                $log.debug('post config data: ', res);
                vm.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig();
                $log.error('post config error: ', err);
                toastr.error(TranslationService.errors.createRegister, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            ConfigService.put({idR: configSave._id}, configSave, function (res) {
                $log.debug('post config data: ', res);
                vm.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig();
                $log.error('post config error: ', err);
                toastr.error(TranslationService.errors.updateRegister, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    /** Function to enable or disable save email */
    vm.disableSave = function () {
        return !(vm.selectedEmail && vm.selectedEmail.description && vm.selectedEmail.template);
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.debug('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    function loadConstants() {
        return new Promise(function (resolve, reject) {
            var info = {};
            vm.allBranches = angular.fromJson(sessionStorage.getItem('ls.branchesFull'));
            vm.selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));
            info['branches'] = !vm.selectedBranch || _.get(vm.selectedBranch, 'all') ? vm.allBranches : (vm.selectedBranch ? _.castArray(vm.selectedBranch) : []);
            if (info['branches'].length === vm.allBranches.length) {
                info['branches'].push({_id: 'all', description: TranslationService.all});
            }
            var promises = [];

            promises.push(SESListTemplatesService.query({}));
            $q.all(promises).then(function (dataFields) {
                info['templates'] = dataFields[0];
                resolve(info);
            }).catch(function (err) {
                $log.error('dataFields promisesArray error: ', err);
                resolve(info);
            });

        });
    }

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.selected = vm.currentSelection ? vm.currentSelection : {};
        vm.$onInit();
    });

    vm.$onInit = function () {
        loadConstants().then(function (data) {
            vm.constants = data;
            vm.getTableData();
        });
    };
}

angular
    .module('Tagaste.masterTablesEmailComponent')
    .component('masterTablesEmailComponent', {
        templateUrl: 'app/components/masterTables/masterTablesEmail/masterTablesEmail.html',
        controllerAs: 'mtec',
        controller: MasterTablesEmailController,
        bindings: {
            selected: '='
        }
    });

MasterTablesMenuController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope'];

function MasterTablesMenuController(toastr, TranslationService, RequestService, $uibModal,
                                      MasterTableService, routeConf, $log, ConfigService, NgTableParams,
                                      PermissionsService, tmhDynamicLocale, masterTables, $rootScope) {

    var vm = this;

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        ConfigService.query({
            component: 'menutypes'
        }, function (res) {
            $log.debug('menu master table data: ', res);
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('menu master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.addingConfig = true;
        vm.configTableParams.settings().dataset.unshift({
            code: '',
            description: '',
            icon: '',
            hourUntil: '',
            modeEdit: true
        });
        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        if (index !== 0 || config._id) {
            vm.tempConfig = angular.copy(config);
        }
        config.modeEdit = true;
        vm.temporalConfig = angular.copy(config);
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function (config, index) {
        config.modeEdit = false;
        if (index === 0 && !config._id) {
            _.remove(vm.configTableParams.settings().dataset, function (item) {
                return config === item;
            });
        } else {
            _.forEach(vm.configTableParams.settings().dataset, function (item, index) {
                if (item._id === vm.tempConfig._id) {
                    vm.configTableParams.settings().dataset[index] = vm.tempConfig;
                }
            });
            vm.configTableParams.data[index] = vm.tempConfig;
        }
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (config, index) {
        config['component'] = 'menutypes';
        if (vm.addingConfig) {
            ConfigService.post(config, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.createRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            ConfigService.put({idR: config._id}, config, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.debug('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.$onInit = function () {
        vm.getTableData();
    };
}

angular
    .module('Tagaste.masterTablesMenuComponent')
    .component('masterTablesMenuComponent', {
        templateUrl: 'app/components/masterTables/masterTablesMenu/masterTablesMenu.html',
        controllerAs: 'mtmc',
        controller: MasterTablesMenuController,
        bindings: {
            selected: '='
        }
    });

MasterTablesPanelController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
'MasterTableService', 'routeConf', '$log', 'ConfigService', '$rootScope',
'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$translate'];

function MasterTablesPanelController(toastr, TranslationService, RequestService, $uibModal,
    MasterTableService, routeConf, $log, ConfigService, $rootScope,
    PermissionsService,  tmhDynamicLocale, masterTables, $translate) {

    var vm = this;
    vm.selectedOption = '';
    vm.ready = false;
    vm.locked = false;

    vm.changeOption = function() {
        vm.ready = false;
        vm.locked = _.get(vm.selectedOption, 'locked');

        setTimeout( function() {
            vm.ready = true;
            $rootScope.$digest();
        }, 100);
    };

    vm.$onInit = function () {
        vm.mastertables = _.map(masterTables, function (item){
            item['translation'] = $translate.instant(item['translatekey']);
            return item;
        });
        vm.mastertables = _.orderBy(vm.mastertables, 'translation');
    };
}

angular
    .module('Tagaste.masterTablesPanelComponent')
    .component('masterTablesPanelComponent', {
        templateUrl: 'app/components/masterTables/masterTablesPanel/masterTablesPanel.html',
        controllerAs: 'mtpc',
        controller: MasterTablesPanelController,
        bindings: {
        }
    });

MasterTablesRoomRateController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', '$q'];

function MasterTablesRoomRateController(toastr, TranslationService, RequestService, $uibModal,
                                        MasterTableService, routeConf, $log, ConfigService, NgTableParams,
                                        PermissionsService, tmhDynamicLocale, masterTables, $rootScope, $q) {

    var vm = this;

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        vm.currentSelection = vm.selected;

        var queryObj = {
            component: vm.selected.component
        };
        if (_.get(vm.selectedBranch, '_id')) {
            queryObj['branch'] = vm.selectedBranch['_id'];
        }
        ConfigService.query(queryObj, function (res) {
            $log.debug('master table data: ', res);
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.addingConfig = true;
        vm.configTableParams.settings().dataset.unshift({
            code: '',
            description: '',
            price: '',
            related: '',
            branch: '',
            modeEdit: true
        });
        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        if (index !== 0 || config._id) {
            vm.tempConfig = angular.copy(config);
        }
        config.modeEdit = true;
        vm.temporalConfig = angular.copy(config);
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function (config, index) {
        config.modeEdit = false;
        if (index === 0 && !config._id) {
            _.remove(vm.configTableParams.settings().dataset, function (item) {
                return config === item;
            });
        } else {
            _.forEach(vm.configTableParams.settings().dataset, function (item, index) {
                if (item._id === vm.tempConfig._id) {
                    vm.configTableParams.settings().dataset[index] = vm.tempConfig;
                }
            });
            vm.configTableParams.data[index] = vm.tempConfig;
        }
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (config, index) {
        if (!config['modality']) {
            toastr.warning(TranslationService.errors.modalityRequired, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        } else if (!config['related']) {
            toastr.warning(TranslationService.errors.roomTypeRequired, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        } else if (!config['branch']) {
            toastr.warning(TranslationService.errors.branchRequired, TranslationService.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        } else {
            config['relatedTable'] = vm.selected.relatedTable;
            config['component'] = vm.selected.component;
            if (vm.addingConfig) {
                ConfigService.post(config, function (res) {
                    $log.debug('post config data: ', res);
                    config.modeEdit = false;
                    vm.addingConfig = false;
                    vm.getTableData();
                }, function (err) {
                    vm.cancelConfig(config, index);
                    $log.error('post config error: ', err);
                    var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                        TranslationService.errors.duplicatedCode : TranslationService.errors.createRegister;
                    toastr.error(errMsg, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            } else {
                ConfigService.put({idR: config._id}, config, function (res) {
                    $log.debug('post config data: ', res);
                    config.modeEdit = false;
                    vm.addingConfig = false;
                    vm.getTableData();
                }, function (err) {
                    vm.cancelConfig(config, index);
                    $log.error('post config error: ', err);
                    var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                        TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                    toastr.error(errMsg, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.error('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.filterBranches = function (register) {
        var roomType = _.get(register, 'related');
        if (roomType) {
            return _.filter(vm.constants.branches, function (item) {
                return _.find(roomType.branches, function (item2) {
                    return _.get(item2, '_id', item2) === item._id;
                });
            });
        } else {
            return [];
        }
    };

    function loadConstants() {
        return new Promise(function (resolve, reject) {
            var info = {};
            vm.allBranches = angular.fromJson(sessionStorage.getItem('ls.branchesFull'));
            vm.selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));
            info['branches'] = !vm.selectedBranch || _.get(vm.selectedBranch, 'all') ?
                vm.allBranches : (vm.selectedBranch ? _.castArray(vm.selectedBranch) : []);
            var promises = [];
            promises.push(ConfigService.query({functionality: 'roomType'}));
            promises.push(ConfigService.query({functionality: 'modality'}));
            if (promises.length) {
                $q.all(promises).then(function (dataFields) {
                    info['related'] = dataFields[0];
                    info['modality'] = dataFields[1];
                    resolve(info);
                }).catch(function (err) {
                    $log.error('dataFields promisesArray error: ', err);
                    resolve(info);
                });
            } else {
                resolve(info);
            }
        });
    }

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.selected = vm.currentSelection ? vm.currentSelection : {};
        vm.$onInit();
    });

    vm.$onInit = function () {
        loadConstants().then(function (data) {
            vm.constants = data;
            vm.getTableData();
        });
    };
}

angular
    .module('Tagaste.masterTablesRoomRateComponent')
    .component('masterTablesRoomRateComponent', {
        templateUrl: 'app/components/masterTables/masterTablesRoomRate/masterTablesRoomRate.html',
        controllerAs: 'mtrrc',
        controller: MasterTablesRoomRateController,
        bindings: {
            selected: '='
        }
    });

MasterTablesStatusController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams', '$translate',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', 'masterTablesFields'];

function MasterTablesStatusController(toastr, TranslationService, RequestService, $uibModal,
                                      MasterTableService, routeConf, $log, ConfigService, NgTableParams, $translate,
                                      PermissionsService, tmhDynamicLocale, masterTables, $rootScope, masterTablesFields) {

    var vm = this;

    vm.colorPickerOptions = {
        format: 'hexString',
        case: 'lower',
        reset: {
            show: true,
            label: TranslationService.reset,
            class: '',
        }
    };

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        ConfigService.query({
            component: 'statustypes'
        }, function (res) {
            $log.debug('status master table data: ', res);
            _.forEach(res, function (item) {
                item['isFirst'] = _.find(vm.constants.binary, {value: item['isFirst']});
                item['isLast'] = _.find(vm.constants.binary, {value: item['isLast']});
            });
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('status master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.addingConfig = true;
        vm.configTableParams.settings().dataset.unshift({
            code: '',
            description: '',
            icon: '',
            isFirst: '',
            isLast: '',
            functionality: '',
            colour: '',
            modeEdit: true
        });
        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        if (index !== 0 || config._id) {
            vm.tempConfig = angular.copy(config);
        }
        config.modeEdit = true;
        vm.temporalConfig = angular.copy(config);
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function (config, index) {
        config.modeEdit = false;
        if (index === 0 && !config._id) {
            _.remove(vm.configTableParams.settings().dataset, function (item) {
                return config === item;
            });
        } else {
            _.forEach(vm.configTableParams.settings().dataset, function (item, index) {
                if (item._id === vm.tempConfig._id) {
                    vm.configTableParams.settings().dataset[index] = vm.tempConfig;
                }
            });
            vm.configTableParams.data[index] = vm.tempConfig;
        }
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (config, index) {
        var configSave = angular.copy(config);
        configSave['component'] = 'statustypes';
        configSave['isFirst'] = configSave['isFirst'].value;
        configSave['isLast'] = configSave['isLast'].value;
        if (vm.addingConfig) {
            ConfigService.post(configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.createRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            ConfigService.put({idR: configSave._id}, configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.debug('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    function loadConstants() {
        vm.constants = {
            binary: _.map(masterTablesFields['binary'], function (i) {
                return {name: $translate.instant(i['translatekey']), value: i['value']};
            }),
            functionalities: masterTablesFields['functionalities']
        };
    }

    vm.$onInit = function () {
        loadConstants();
        vm.getTableData();
    };
}

angular
    .module('Tagaste.masterTablesStatusComponent')
    .component('masterTablesStatusComponent', {
        templateUrl: 'app/components/masterTables/masterTablesStatus/masterTablesStatus.html',
        controllerAs: 'mtsc',
        controller: MasterTablesStatusController,
        bindings: {
            selected: '='
        }
    });

MasterTablesTaskController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams', '$translate',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', 'masterTablesFields', '$q'];

function MasterTablesTaskController(toastr, TranslationService, RequestService, $uibModal,
                                    MasterTableService, routeConf, $log, ConfigService, NgTableParams, $translate,
                                    PermissionsService, tmhDynamicLocale, masterTables, $rootScope, masterTablesFields, $q) {

    var vm = this;

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        description: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        vm.currentSelection = vm.selected;
        vm.branchCol = vm.selected.branches && vm.constants['branches'] && vm.constants['branches'].length > 1;

        var queryObj = {
            component: 'tasktypes'
        };
        if (_.get(vm.selectedBranch, '_id')) {
            queryObj['branch'] = vm.selectedBranch['_id'];
        }

        ConfigService.query(queryObj, function (res) {
            $log.debug('task master table data: ', res);
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('task master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.addingConfig = true;
        vm.configTableParams.settings().dataset.unshift({
            code: '',
            description: '',
            taskParent: '',
            branch: '',
            modeEdit: true
        });
        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        // TODO: Open Modal
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function (config, index) {
        config.modeEdit = false;
        if (index === 0 && !config._id) {
            _.remove(vm.configTableParams.settings().dataset, function (item) {
                return config === item;
            });
        } else {
            _.forEach(vm.configTableParams.settings().dataset, function (item, index) {
                if (item._id === vm.tempConfig._id) {
                    vm.configTableParams.settings().dataset[index] = vm.tempConfig;
                }
            });
            vm.configTableParams.data[index] = vm.tempConfig;
        }
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (config, index) {
        var configSave = angular.copy(config);
        configSave['component'] = 'tasktypes';
        if (vm.addingConfig) {
            ConfigService.post(configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.createRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            ConfigService.put({idR: configSave._id}, configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.debug('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    /** Function to open modal task detail **/
    vm.openTaskDetail = function (data, readOnly) {
        // New task
        if (!data) {
            vm.modalBinding = {
                readonly: false
            };
        } else {
            vm.modalBinding = angular.copy(data);
        }
        vm.modalBinding.readonly = vm.readonly || readOnly;
        vm.modalBinding.constants = angular.copy(vm.constants);

        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/modal/modalTaskDetail/modalTaskDetail.html',
            controller: 'ModalTaskDetailController',
            controllerAs: 'mmtdc',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalBinding: function () {
                    return vm.modalBinding;
                }
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            //close function
            if (result) {
                // TODO: reload data
                vm.getTableData();
            }
        }, function (closemsg) {
            //dismiss function
        });
    };

    function loadConstants() {
        return new Promise(function (resolve, reject) {
            var info = {};
            vm.allBranches = angular.fromJson(sessionStorage.getItem('ls.branchesFull'));
            vm.selectedBranch = angular.fromJson(sessionStorage.getItem('ls.selectedBarResidence'));
            info['branches'] = !vm.selectedBranch || _.get(vm.selectedBranch, 'all') ? vm.allBranches : (vm.selectedBranch ? _.castArray(vm.selectedBranch) : []);
            if (info['branches'].length === vm.allBranches.length) {
                info['branches'].push({_id: 'all', description: TranslationService.all});
            }
            var promises = [];
            promises.push(ConfigService.query({functionality: 'taskTypes'}));
            $q.all(promises).then(function (dataFields) {
                info['taskParent'] = dataFields[0];
                resolve(info);
            }).catch(function (err) {
                $log.error('dataFields promisesArray error: ', err);
                resolve(info);
            });
        });
    }

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.selected = vm.currentSelection ? vm.currentSelection : {};
        vm.$onInit();
    });

    vm.$onInit = function () {
        loadConstants().then(function (data) {
            vm.constants = data;
            vm.getTableData();
        });
    };
}

angular
    .module('Tagaste.masterTablesTaskComponent')
    .component('masterTablesTaskComponent', {
        templateUrl: 'app/components/masterTables/masterTablesTask/masterTablesTask.html',
        controllerAs: 'mttc',
        controller: MasterTablesTaskController,
        bindings: {
            selected: '='
        }
    });

MasterTablesTaxController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal',
    'MasterTableService', 'routeConf', '$log', 'ConfigService', 'NgTableParams', '$translate',
    'PermissionsService', 'tmhDynamicLocale', 'masterTables', '$rootScope', 'masterTablesFields'];

function MasterTablesTaxController(toastr, TranslationService, RequestService, $uibModal,
                                      MasterTableService, routeConf, $log, ConfigService, NgTableParams, $translate,
                                      PermissionsService, tmhDynamicLocale, masterTables, $rootScope, masterTablesFields) {

    var vm = this;

    function iniConfigTable(list) {
        vm.configTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        name: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.getTableData = function () {
        ConfigService.query({
            component: 'tax'
        }, function (res) {
            $log.debug('tax master table data: ', res);
            _.forEach(res, function (item) {
                item['isPercentage'] = _.find(vm.constants.binary, {value: item['isPercentage']});
            });
            vm.tableData = angular.copy(res);
            iniConfigTable(vm.tableData);
        }, function (err) {
            $log.error('tax master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.isEditable = function (row) {
        return !vm.selected.locked && !(row && vm.selected.lockedItems && _.includes(vm.selected.lockedItems, row.code));
    };

    /** Function to add new config row */
    vm.addConfig = function () {
        vm.addingConfig = true;
        vm.configTableParams.settings().dataset.unshift({
            name: '',
            rate: '',
            isPercentage: '',
            modeEdit: true
        });
        vm.configTableParams.page(1);
        vm.configTableParams.reload();
    };

    /** Function to enter edit mode config */
    vm.editConfig = function (config, index) {
        if (index !== 0 || config._id) {
            vm.tempConfig = angular.copy(config);
        }
        config.modeEdit = true;
        vm.temporalConfig = angular.copy(config);
    };

    /** Function to cancel (Edit / New) config */
    vm.cancelConfig = function (config, index) {
        config.modeEdit = false;
        if (index === 0 && !config._id) {
            _.remove(vm.configTableParams.settings().dataset, function (item) {
                return config === item;
            });
        } else {
            _.forEach(vm.configTableParams.settings().dataset, function (item, index) {
                if (item._id === vm.tempConfig._id) {
                    vm.configTableParams.settings().dataset[index] = vm.tempConfig;
                }
            });
            vm.configTableParams.data[index] = vm.tempConfig;
        }
        if (vm.addingConfig) {
            vm.configTableParams.reload();
            vm.addingConfig = false;
        }
        vm.addingConfig = false;
    };

    /** Function to accept config row (new/edit) */
    vm.saveConfig = function (config, index) {
        var configSave = angular.copy(config);
        configSave['component'] = 'tax';
        configSave['isPercentage'] = configSave['isPercentage'].value;
        if (vm.addingConfig) {
            ConfigService.post(configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.createRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            ConfigService.put({idR: configSave._id}, configSave, function (res) {
                $log.debug('post config data: ', res);
                config.modeEdit = false;
                vm.addingConfig = false;
                vm.getTableData();
            }, function (err) {
                vm.cancelConfig(config, index);
                $log.error('post config error: ', err);
                var errMsg = _.get(err, 'data.error.error') && _.includes(err.data.error.error, 'Duplicate') ?
                    TranslationService.errors.duplicatedCode : TranslationService.errors.updateRegister;
                toastr.error(errMsg, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    /** Function to delete config row */
    vm.deleteConfig = function (config, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConfigService.delete({idR: config._id, component: vm.selected.component}, function (data) {
                    $log.debug('ConfigService delete data: ', data);
                    vm.getTableData();
                }, function (err) {
                    $log.error('ConfigService delete error: ', err);
                    toastr.error(TranslationService.errors.deleteRegister, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    function loadConstants() {
        vm.constants = {
            binary: _.map(masterTablesFields['binary'], function (i) {
                return {name: $translate.instant(i['translatekey']), value: i['value']};
            })
        };
    }

    vm.$onInit = function () {
        loadConstants();
        vm.getTableData();
    };
}

angular
    .module('Tagaste.masterTablesTaxComponent')
    .component('masterTablesTaxComponent', {
        templateUrl: 'app/components/masterTables/masterTablesTax/masterTablesTax.html',
        controllerAs: 'mttc',
        controller: MasterTablesTaxController,
        bindings: {
            selected: '='
        }
    });

ReservationDetailController.$inject = ['MasterTableService', 'routeConf', '$log', 'TranslationService', 'toastr',
    'ReservationNoShowService', 'ReservationAcceptService', 'localStorageService', 'ValidationService', '$uibModal',
    'OccupancyByRangeService'];

function ReservationDetailController(MasterTableService, routeConf, $log, TranslationService, toastr,
                                     ReservationNoShowService, ReservationAcceptService, localStorageService, ValidationService,
                                     $uibModal, OccupancyByRangeService) {
    var vm = this;
    vm.lodash = _;
    vm.moment = moment;
    vm.roomTypes = [];
    vm.invalidRoomType = false;
    vm.dateOptions = {
        minDate: moment().toDate(),
        showWeeks: false
    };
    vm.dateOptionsAfter = {
        minDate: moment().toDate(),
        showWeeks: false
    };
    vm.dateOptionsFromToday = {
        minDate: moment().toDate(),
        showWeeks: false
    };
    vm.resform = {};

    vm.submitted = false;

    /** Get occupancies of a branch */
    function getOccupancies(branch) {
        return new Promise(function (full, reject) {
            var query = {
                dateFrom: moment(vm.reservation.dateFrom).format('YYYY-MM-DD'),
                dateTo: moment(vm.reservation.dateTo).format('YYYY-MM-DD'),
                branch: _.get(branch, '_id')
            };
            OccupancyByRangeService.query(query, function (data) {
            }, function (err) {
                $log.error('error OccupancyByRange: ', err);
                toastr.error(TranslationService.errors.e500);
            }).$promise.then(function (data) {
                $log.debug('OccupancyByRange:', data);
                full(_.sortBy(data, ['dateFrom']));
            });
        });
    }

    /** Get spots of a branch */
    function getSourcesSpots(branch) {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.spot};
            query.branch = _.get(branch, '_id');
            query.isRoom = true;
            query.sort = 'code';
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load spots', err);
            }).$promise.then(function (data) {
                $log.debug('Available spots:', data);
                full(_.sortBy(data, ['description']));
            });
        });
    }

    vm.getRoomTypes = function () {
        var roomTypesTmp = [];
        vm.roomTypes = [];
        _.forEach(vm.constants.roomType, function (rt) {
            // Si la habitación esta en todas las residencias
            if (!rt.branches.length) {
                roomTypesTmp.push(rt);
            } else {
                if (_.find(rt.branches, {_id: vm.reservation.branch._id})) {
                    roomTypesTmp.push(rt);
                }
            }
        });
        vm.roomTypes = _.uniqBy(_.flatMap(roomTypesTmp), '_id');
    };

    vm.back = function () {
        vm.anim = false;
        vm.selectr = {};
    };

    vm.openCancelReservationModal = function () {
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/modal/modalCancelReservationModal/modalCancelReservation.html',
            controller: 'ModalCancelReservationController',
            controllerAs: 'mcrc',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalBinding: function () {
                    return vm.reservation;
                }
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            if (result) {
                toastr.success(TranslationService.dialog.cancelReservationBillings);
            }
        }, function (closemsg) {
            //dismiss function
        });
    };

    vm.cancelReservation = function () {
        swal({
            text: TranslationService.modal.cancelBookingComment,
            input: 'text',
            inputLabel: 'cancelbookingcomment',
            customClass: 'cancelReservationModal',
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                vm.reservation.cancelBooking = true;
                vm.reservation.cancelBookingComment = result.value;
                vm.save({cancel: true});
            }
        });
    };

    /** Function to accept Reservation */
    vm.acceptReservation = function () {
        vm.acceptSubmit = true;
        if (!vm.isGuest || _.get(vm.reservation, 'billingAccount.payType')) {
            swal({
                text: TranslationService.modal.reservationAccept,
                customClass: 'reservationNoShowModal',
                showCancelButton: true,
                confirmButtonText: TranslationService.modal.button.ok,
                cancelButtonText: TranslationService.modal.button.cancel
            }).then(function (result) {
                if (result.value) {
                    // check if room needs a change because of occupancy
                    var existingOccupancy = _.find(vm.occupancies, {room: _.get(vm.reservation, 'room._id', vm.reservation.room)});
                    $log.debug('existingOccupancy: ', existingOccupancy);
                    if (existingOccupancy) {
                        var existingOccupancies = _.map(_.filter(vm.occupancies, {isBlock: false}), 'room');
                        var availableRooms = _.filter(vm.listSpots, function (room) {
                            return !_.includes(existingOccupancies, _.get(room, '_id', room));
                        });
                        var modalInstance = $uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            templateUrl: 'app/modal/modalChooseRoom/modalChooseRoom.html',
                            controller: 'ModalChooseRoomController',
                            controllerAs: 'mcrc',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                modalBinding: function () {
                                    return {
                                        reservation: vm.reservation,
                                        roomTypes: vm.roomTypes,
                                        availableRooms: availableRooms
                                    };
                                }
                            }
                        });
                        // Function when open modal
                        modalInstance.result.then(function (result) {
                            if (result) {
                                // update reservation with new room
                                vm.selectedRoom = result;
                                vm.selectRoom();
                                vm.save(vm.resform, true);
                            }
                        }, function (closemsg) {
                            //dismiss function
                        });
                    } else {
                        ReservationAcceptService.post({idR: vm.reservationId}, vm.reservation, function (res) {
                            toastr.success(TranslationService.dialog.saveok);
                            vm.anim = false;
                            vm.selectr = {action: 'refList'};
                        }, function (err) {
                            $log.error('error: ', err);
                            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    }
                }
            });
        }
    };

    /** Function to save Reservation */
    vm.save = function (form, noClose) {
        vm.submitted = true;
        if ((form.$valid && !vm.checkDates()) || form.cancel) {
            if (vm.isGuest) {
                vm.reservation.isGuest = true;
                if (vm.reservation.phone) {
                    vm.reservation.telefono = vm.reservation.phone;
                }
                if (vm.reservation.dateFrom) {
                    vm.reservation.dateFrom = moment(vm.reservation.dateFrom).add(3, 'hours');
                }
                if (vm.reservation.dateTo) {
                    vm.reservation.dateTo = moment(vm.reservation.dateTo).add(3, 'hours');
                }
                vm.reservation.valorAuxiliar1 = 'Panel Tagaste';
            }

            _.set(vm.reservation, 'roomType', _.get(vm.reservation, 'room.roomType'));

            var query = {};
            query.idT = routeConf.app;
            query.idJ = routeConf.reservation;
            if (vm.reservation._id) {
                query.idP = vm.reservation._id;
            }
            $log.debug('reservation to save', vm.reservation);
            MasterTableService.post(query, vm.reservation, function (response) {
                toastr.success(TranslationService.dialog.saveok);

                if (form.cancel) {
                    vm.openCancelReservationModal();
                }

                if (!noClose) {
                    vm.selectr = {};
                    vm.reservation = {};
                    vm.selectr.action = 'refList';
                }
            }, function (err) {
                $log.error('MasterTableService save reservation error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            if (!vm.reservation.dateTo || !vm.reservation.dateFrom) {
                toastr.error(TranslationService.reservations.error.missingDates,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            }
        }
    };

    vm.noshow = function () {
        swal({
            text: TranslationService.modal.reservationNoShow,
            customClass: 'reservationNoShowModal',
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ReservationNoShowService.post({idR: vm.reservationId}, {}, function (res) {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.back();
                }, function (err) {
                    $log.error('error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.changeBranch = function () {
        delete vm.reservation.room;
        getSourcesSpots(vm.reservation.branch).then(function (data) {
            vm.listSpots = data;
            vm.getRoomTypes();
            vm.checkRoomType();
        });
        getOccupancies(vm.reservation.branch).then(function (data2) {
            vm.occupancies = data2;
        });
    };

    vm.changeDateFrom = function () {
        vm.dateOptionsAfter = {
            minDate: _.get(vm.resform, 'reqDateFrom.$modelValue') ? _.get(vm.resform, 'reqDateFrom.$modelValue') : moment().toDate(),
            showWeeks: false
        };
    };

    vm.validateMobile = function (mobile, formInput) {
        var valid = true;
        if (!formInput.$pristine && mobile !== '') {
            valid = ValidationService.validMobile(mobile);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validatePhone = function (phone, formInput) {
        var valid = true;
        if (!formInput.$pristine && phone !== '') {
            valid = ValidationService.validMobile(phone);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validEmail = function (emailField, formInput) {
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,4})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (emailField) {
            valid = (!emailField || formInput.$pristine || reg.test(emailField));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };

    vm.validDNI = function (input, type, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            if (input && type !== 'PAS') {
                valid = ValidationService.validDniNie(input, type);
            }
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.changePayType = function () {
        vm.reservation.billingAccount = {
            payType: vm.reservation.billingAccount.payType
        };
        if (_.get(vm.reservation, 'billingAccount.payType.code') === 'domiciliado') {
            if (_.get(vm.guest, 'billingAccounts.bank')) {
                vm.reservation.billingAccount.bank = _.get(vm.guest, 'billingAccounts.bank');
            } else {
                vm.reservation.billingAccount.bank = {};
            }
        } else if (_.get(vm.reservation, 'billingAccount.payType.code') === 'tarjeta') {
            if (_.get(vm.guest, 'billingAccounts.bankCard')) {
                vm.reservation.billingAccount.bankCard = _.get(vm.guest, 'billingAccounts.bankCard');
            } else {
                vm.reservation.billingAccount.bankCard = {};
            }
        }
    };

    vm.changeTypeIde = function (type) {
        if (vm.readonly) {
            return;
        }
        vm.cont += 1;
        if (vm.cont < vm.constants.docType.length) {
            vm.reservation.identity.docType = vm.constants.docType[vm.cont];
        } else {
            vm.cont = 0;
            vm.reservation.identity.docType = vm.constants.docType[0];
        }
    };

    vm.selectRoom = function () {
        // vm.reservation.roomType = _.find(vm.roomTypes, ['_id', _.get(vm.reservation.room.roomType, '_id', vm.reservation.room.roomType)]);
        // if (!_.find(vm.roomTypes, ['_id', _.get(vm.reservation.room.roomType, '_id', vm.reservation.room.roomType)])) {
        //     vm.reservation.roomType = null;
        // }
        // vm.checkRoomType();
        vm.reservation.room = vm.selectedRoom;
    };

    vm.checkDates = function () {
        return vm.reservation.dateTo && vm.reservation.dateFrom &&
            moment(vm.reservation.dateFrom).isSameOrAfter(moment(vm.reservation.dateTo));
    };

    vm.checkRoomType = function () {
        vm.invalidRoomType = vm.reservation.roomType &&
            vm.reservation.roomType._id !== _.get(vm.reservation.room.roomType, '_id', vm.reservation.room.roomType);
    };

    vm.$onInit = function () {
        if (!_.isEmpty(vm.guest)) {
            $log.debug('Guest: ', vm.guest);
        } else {
            $log.debug('New guest');
        }

        if (vm.selectr._id === '0') {
            vm.readonly = false;
            vm.isGuest = true;
            vm.reservation = {};
            if (!_.isEmpty(vm.guest)) {
                vm.reservation.identity = vm.guest.identity;
            } else {
                vm.reservation.identity = {
                    docType: _.last(vm.constants.docType)
                };
                if (vm.identity) {
                    vm.reservation.identity.docVal = vm.identity;
                }
            }
            var selectedBar = localStorageService.get('selectedBarResidence');
            if (selectedBar && !selectedBar.all) {
                vm.reservation.branch = selectedBar;
                vm.selectedBranch = true;
            }

            if (selectedBar && !selectedBar.all) {
                vm.getRoomTypes();
            }

            getSourcesSpots(vm.reservation.branch).then(function (data) {
                vm.listSpots = data;
                vm.checkRoomType();
            });
            getOccupancies(vm.reservation.branch).then(function (data2) {
                vm.occupancies = data2;
            });

            if (!_.isEmpty(vm.guest)) {
                vm.reservation.nombre = _.get(vm.guest, 'name');
                vm.reservation.apellidos = _.get(vm.guest, 'surname');
                vm.reservation.phone = _.get(vm.guest, 'contact.phone');
                vm.reservation.movil = _.get(vm.guest, 'contact.movil');
                vm.reservation.email = _.get(vm.guest, 'contact.email');
                vm.reservation.identity.docVal = _.get(vm.guest, 'identity.docVal');
                vm.reservation.identity.docType = _.get(vm.guest, 'identity.docType');
                //vm.reservation.identity = vm.guest.identity;
            }
        } else {
            vm.reservationId = vm.selectr._id;
            MasterTableService.get({
                idT: routeConf.app,
                idJ: routeConf.reservation,
                idP: vm.reservationId
            }, function (res) {
                $log.debug('[ReservationDetail] getDetail:', res);
                $log.debug('[ReservationDetail] selected reservation: ', vm.reservation);
                $log.debug('[ReservationDetail] constants', vm.constants);
                vm.reservation = res;
                if (vm.reservation.isGuest) {
                    vm.isGuest = true;
                }
                if (_.get(res, 'tDocumento')) {
                    vm.reservation['identity'] = {
                        docType: _.find(vm.constants.docType, {description: res['tDocumento']}),
                        docVal: res['numDocumento']
                    };
                }
                if (vm.reservation.telefono) {
                    vm.reservation.phone = vm.reservation.telefono;
                }
                if (vm.reservation.cancelBooking || vm.reservation.noShow || vm.selectr.action !== 'edit' || vm.reservation.isBooked) {
                    vm.readonly = true;
                }
                if (vm.reservation.dateFrom) {
                    vm.reservation.dateFrom = moment(vm.reservation.dateFrom).toDate();
                }
                if (vm.reservation.dateTo) {
                    vm.reservation.dateTo = moment(vm.reservation.dateTo).toDate();
                }
                if (_.get(vm.reservation, 'cliente.billingAccounts.bankCard.expDate')) {
                    vm.reservation.billingAccount.bankCard.expDate =
                        moment(vm.reservation.billingAccount.bankCard.expDate).toDate();
                }

                vm.getRoomTypes();

                if (vm.reservation.room) {
                    if (vm.reservation.roomType) {
                        _.set(vm.reservation.room, 'roomType', vm.reservation.roomType);
                    }
                    vm.selectedRoom = vm.reservation.room;
                }

                getSourcesSpots(vm.reservation.branch).then(function (data) {
                    vm.listSpots = data;
                    vm.checkRoomType();
                });
                getOccupancies(vm.reservation.branch).then(function (data2) {
                    vm.occupancies = data2;
                });
            }, function (err) {
                $log.error('error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };
}

angular
    .module('Tagaste.reservationDetailComponent')
    .component('reservationDetailComponent', {
        templateUrl: 'app/components/reservations/reservationDetail/reservationDetail.html',
        controllerAs: 'rsdc',
        controller: ReservationDetailController,
        bindings: {
            selectr: '=',
            guest: '=',
            constants: '=',
            anim: '=',
            identity: '='
        }
    });

ReservationsListController.$inject = ['NgTableParams', 'TranslationService', 'NgTableFilterService', 'toastr', '$log', '$rootScope',
    'PermissionsService', 'localStorageService', 'MasterTableService', 'routeConf', '$filter', '$timeout', 'FileSaver', 'ReservationExportListService',
    '$location', '$scope', 'ResidentsService', 'GuestService'];

function ReservationsListController(NgTableParams, TranslationService, NgTableFilterService, toastr, $log, $rootScope,
                                    PermissionsService, localStorageService, MasterTableService, routeConf, $filter, $timeout, FileSaver, ReservationExportListService,
                                    $location, $scope, ResidentsService, GuestService) {
    var vm = this;
    vm.selectr = {};
    vm.guest = {};
    vm.anim = false;

    var viewParams = localStorageService.get('reservationsViewParams') ?
        localStorageService.get('reservationsViewParams') : {};
    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = {filterReservationsList: {branch: selectedBar.description}};
    }

    vm.filterCode = {
        codigoReserva: {
            id: 'text'
        }
    };
    vm.filterName = {
        nombre: {
            id: 'text'
        }
    };
    vm.filterSurname = {
        apellidos: {
            id: 'text'
        }
    };
    vm.filterCourse = {
        userCourse: {
            id: 'text'
        }
    };
    vm.filterDateFrom = {
        dateFrom: {
            id: 'text'
        }
    };
    vm.filterDateTo = {
        dateTo: {
            id: 'text'
        }
    };
    vm.filterBranch = {
        branch: {
            id: 'text'
        }
    };
    vm.filterRoomType = {
        roomType: {
            id: 'text'
        }
    };
    vm.filterRoom = {
        room: {
            id: 'text'
        }
    };
    vm.filterStatus = {
        status: {
            id: 'text'
        }
    };
    vm.filterCancelBookingComment = {
        cancelBookingComment: {
            id: 'text'
        }
    };

    vm.reservationStatus = 'all';
    vm.reservationStatusOptions = [
        {name: 'black', isSelected: false, class: 'btn-black', value: TranslationService.reservations.status.noShow},
        {name: 'red', isSelected: false, class: 'btn-red', value: TranslationService.reservations.status.cancelled},
        {name: 'all', isSelected: true, class: 'btn-all'},
        {name: 'gold', isSelected: false, class: 'btn-gold', value: TranslationService.reservations.status.pending},
        {name: 'green', isSelected: false, class: 'btn-green', value: TranslationService.reservations.status.confirmed}
    ];
    vm.reservationStatus = vm.reservationStatusOptions[1];

    vm.exportData = function () {
        var filename = TranslationService.reservations.exportTitle.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = TranslationService.reservations.export;

        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function (e) {
                return e._id;
            }),
            filename: filename
        };

        ReservationExportListService.post(
            {}, requestData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('UserExportService export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
    };

    vm.new = function () {
        swal({
            text: TranslationService.modal.newRequestDNI,
            input: 'text',
            inputLabel: 'DNI',
            customClass: 'dniModal',
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ResidentsService.query({identity: result.value, active: 'all'}, function (appUserData) {
                    var nonActiveAppUser = _.find(appUserData.data, {active: false});
                    if (appUserData.data.length > 0 && !nonActiveAppUser) {
                        toastr.error(TranslationService.reservations.error.isAppUser,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    } else if (nonActiveAppUser) {
                        vm.selectr = {
                            _id: '0',
                            readonly: false,
                            action: 'new'
                        };
                        vm.guest = nonActiveAppUser;
                        if (!vm.anim) {
                            $timeout(function () {
                                vm.anim = true;
                            }, 417);
                        }
                    } else {
                        GuestService.query({identity: result.value, active: 'all'}, function (resData) {
                            console.log('Guest query: ', resData);
                            if (resData.data.length) {
                                vm.selectr = {
                                    _id: '0',
                                    readonly: false,
                                    action: 'new'
                                };
                                vm.guest = resData.data[0];
                            } else {
                                vm.selectr = {
                                    _id: '0',
                                    readonly: false,
                                    action: 'new',
                                };
                                vm.guest = {};
                                vm.identity = result.value;
                            }
                            if (!vm.anim) {
                                $timeout(function () {
                                    vm.anim = true;
                                }, 417);
                            }
                        }, function (err) {
                            $log.error('Error searching DNI', err);
                            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    }
                });
            }
        });
    };

    vm.editRow = function (row) {
        vm.anim = false;
        if (vm.istour) {
            return;
        }
        if (vm.selectr && (vm.selectr.action === 'inEdit' || vm.selectr._id === '0')) {
            vm.anim = false;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 401);
            }
            _.forEach(vm.tableParams.data, function (r) {
                r.selected = (r._id === row._id);
            });
            row.action = 'edit';
            vm.selectr = row;
        }
    };

    function iniTable(list) {
        if (!list) {
            list = [];
        }
        for (var i = 0; i < list.length; i++) {
            list[i].residenceDesc = '';
        }
        var sorting = viewParams['sortingReservationsList'] ? viewParams['sortingReservationsList'] : {formattedDate: 'desc'};
        var page = viewParams['pageReservationsList'] ? viewParams['pageReservationsList'] : 1;
        var count = viewParams['countReservationsList'] ? viewParams['countReservationsList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingReservationsList'] = params._params.sorting;
                        viewParams['pageReservationsList'] = page;
                        viewParams['countReservationsList'] = params._params.count;
                        viewParams['filterReservationsList'] = filterObj;
                        localStorageService.set('ReservationsViewParams', viewParams);
                        vm.currentTableData = filteredData;
                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );
        var savedFilters = viewParams['filterReservationsList'] ? viewParams['filterReservationsList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    function getReservations() {
        MasterTableService.get({idT: routeConf.app, idJ: routeConf.reservation}, function (data) {
            $log.debug('[ReservationsList] data: ', data);
            _.forEach(data.data, function (item) {
                item['branch'] = _.get(item, 'branch.description');
                item['formattedDateFrom'] = item['dateFrom'] ? moment(item['dateFrom']).format('L') : '';
                item['formattedDateFromReverse'] = item['dateFrom'] ? moment(item['dateFrom']).format('YYYY/MM/DD') : '';
                item['formattedDateTo'] = item['dateTo'] ? moment(item['dateTo']).format('L') : '';
                item['formattedDateToReverse'] = item['dateTo'] ? moment(item['dateTo']).format('YYYY/MM/DD') : '';
                item['room'] = _.get(item, 'room.description');
                item['roomType'] = _.get(item, 'roomType.description');
                item['userCourse'] = _.get(item, 'application.modalityData.course');
                item['noEditable'] = item.cancelBooking || item.noShow || item.isBooked;
                // old resident check
                vm.currentCouse = moment().month() >= 8 ? moment().year() + '/' + (moment().year() + 1) :
                    (moment().year() - 1) + '/' + moment().year();
                item['oldResident'] = _.get(item, 'cliente.item.oldReservations', []).length && _.get(item, 'cliente.item.oldReservations', []).length > 1 ?
                    _.find(item.cliente.item['oldReservations'], function (reservation) {
                        return _.get(reservation, 'course') && _.get(reservation, 'course') !== vm.currentCouse;
                    }) : false;
            });
            //item['noEditable'] = item.cancelBooking || item.noShow || item.accepted || item.isBooked;
        }).$promise.then(function (data) {
            var list = data.data;
            iniTable(list);
            vm.initialized = true;
            vm.list = list;
            return list;
        });
    }

    vm.$doCheck = function () {
        if (vm.selectr && vm.selectr.action === 'refList') {
            vm.initialized = false;
            vm.$onInit();
        }
    };

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('APPLICATION', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('APPLICATION', 'delete');
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/reservations') {
            viewParams = {filterReservationsList: {branch: (!data.all) ? data.description : ''}};
            iniTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);
    vm.rowClick = function (row) {
        row.action = '';
        vm.anim = false;
        if (vm.istour) {
            return;
        }
        if (vm.selectr && (vm.selectr.action === 'inEdit' || vm.selectr._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 401);
            }
            _.forEach(vm.tableParams.data, function (r) {
                r.selected = (r._id === row._id);
            });
            vm.selectr = row;
        }
    };

    vm.changeStatusFilter = function (list, option) {
        vm.reservationStatus.isSelected = false;
        option.isSelected = true;
        vm.reservationStatus = option;

        if (vm.reservationStatus.value) {
            return _.filter(list, function (i) {
                return _.get(i, 'status') === vm.reservationStatus.value;
            });
        } else {
            return list;
        }
    };

    vm.applyAdditionalFilters = function (option) {
        var list = JSON.parse(JSON.stringify(vm.list));
        var filteredList1 = vm.changeStatusFilter(list, option ? option : this.reservationStatus);
        iniTable(filteredList1);
    };

    vm.$onInit = function () {
        vm.selectr = {};
        vm.anim = false;
        vm.tableParams = null;
        vm.anim = false;
        setPermissions();
        getReservations();
    };
}

angular
    .module('Tagaste.reservationsListComponent')
    .component('reservationsListComponent', {
        templateUrl: 'app/components/reservations/reservationsList/reservationsList.html',
        controllerAs: 'rslsc',
        controller: ReservationsListController,
        bindings: {
            selectr: '=',
            list: '=',
            anim: '=',
            guest: '=',
            identity: '=',
            initTour: '&',
            tourDummyData: '=',
            istour: '<'
        }
    });

PaymentController.$inject = ['TranslationService', 'PermissionsService', 'tmhDynamicLocale', '$uibModal', 'ConfigService', '$rootScope',
    'NgTableParams', 'localStorageService', 'ResidentsService', 'toastr', 'BillingService', '$log', 'ConceptService', 'GuestService',
    'BillingPrintService', '$http', 'serviceConf', 'ValidationService'];

function PaymentController(TranslationService, PermissionsService, tmhDynamicLocale, $uibModal, ConfigService, $rootScope,
                           NgTableParams, localStorageService, ResidentsService, toastr, BillingService, $log, ConceptService,
                           GuestService, BillingPrintService, $http, serviceConf, ValidationService) {
    var vm = this;

    vm.initialized = false;
    vm.resdidentaBD = {};
    vm.residentOri = {};

    vm.stays = [];
    vm.services = [];

    vm.staysTotal = 0;
    vm.staysDiscount = 0;
    vm.servicesDiscount = 0;
    vm.servicesTotal = 0;

    vm.showDeposit = true;
    vm.depositdataopen = true;
    vm.useDeposit = false;
    vm.usedDeposit = 0;
    vm.applicationTotal = 0;

    vm.servicesopen = true;
    vm.staysopen = true;
    vm.staysfutureopen = true;
    vm.paymentdataopen = true;
    vm.totalsopen = true;
    vm.billdataopen = true;

    vm.submitInvoice = false;

    vm.selectedServices = [];
    vm.selectedStays = [];

    vm.constants = {};
    var selectedBar = localStorageService.get('selectedBarResidence');
    vm.$doCheck = function () {
        if (vm.resident && vm.resident._id && (vm.resident._id !== vm.residentOri._id)) {
            vm.residentOri._id = angular.copy(vm.resident._id);
            vm.$onInit();
        }
    };

    vm.dateOptionsFromToday = {
        minDate: moment().toDate(),
        showWeeks: false
    };

    vm.disablePayType = false;

    // Function get concepts
    function getSourcesConcept() {
        if (vm.resident && vm.resident._id) {
            var query = {client: vm.resident._id};
            // if (vm.bill._id && vm.menuOption === 'billings') {
            //     query['allConcepts'] = true;
            // }
            if (vm.bill._id) {
                query['billing'] = vm.bill._id;
            }
            ConceptService.get(query, function (data) {
                $log.debug('[payment] get concept data: ', data.data);
                var services = _.filter(data.data, function (svc) {
                    if (!svc.related) {
                        svc.related = {
                            kind: 'Other'
                        };
                    }
                    if (vm.bill && vm.bill.concepts) {
                        if (_.find(vm.bill.concepts, {_id: svc._id})) {
                            svc.selected = true;
                        }
                    }
                    switch (svc.related.kind) {
                        case 'Service':
                            svc.typeStr = TranslationService.payments.types.service;
                            break;
                        case 'Agenda':
                            svc.typeStr = TranslationService.payments.types.agenda;
                            break;
                        case 'Other':
                            svc.typeStr = TranslationService.payments.types.other;
                            break;
                    }
                    if (svc.amount < 0) {
                        vm.usedDeposit -= svc.amount;
                    }
                    if (_.get(svc, 'isTuition') && _.get(svc, 'related.kind') === 'Application' && vm.menuOption === 'billings') {
                        vm.applicationTotal += svc.amount;
                    }
                    return (svc.related.kind === 'Service' || svc.related.kind === 'Agenda' || svc.related.kind === 'Other') &&
                        svc.amount >= 0;
                });

                vm.services = _.unionBy(services, vm.services, '_id');
                iniTableServices(vm.services);
                setTimeout(function () {
                    vm.serviceCheckboxChanges();
                    if (!$rootScope.$$phase) {
                        $rootScope.$digest();
                    }
                }, 300);

                vm.stays = _.filter(data.data, ['related.kind', 'Occupancy']);
                iniTableStays(vm.stays);
                setTimeout(function () {
                    vm.occupancyCheckboxChanges();
                    if (!$rootScope.$$phase) {
                        $rootScope.$digest();
                    }
                }, 300);

                if (vm.applicationTotal) {
                    vm.calcTotal();
                }
            }, function (err) {
                $log.error('[payment] error getting concepts: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    }

    function getFutureConcepts() {
        ConceptService.post({idR: 'future'}, vm.resident, function (data) {
            $log.debug('[residentDetail] getFutureConcepts data: ', data);
            iniTableStaysFuture(_.get(data, 'concepts'));
        }, function (err) {
            $log.error('[residentDetail] getFutureConcepts error: ', err);
        });
    }

    function iniTableServices(list) {
        if (!list) {
            list = [];
        } else {
            _.forEach(list, function (svc) {
                svc.dateView = moment(svc.dateFrom).format('DD/MM/YYYY');
                svc.branchDescription = svc.branch ? svc.branch.description : '';
            });
        }
        vm.tableParamsServices =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateView: 'desc'
                    }
                },
                {
                    total: list.length,
                    counts: [],
                    dataset: angular.copy(list)
                }
            );
    }

    function iniTableStays(list) {
        if (!list) {
            list = [];
        } else {
            _.forEach(list, function (stay) {
                stay.dateFormatFrom = moment(stay.dateFrom).format('YYYY/MM/DD');
                stay.dateViewFrom = moment(stay.dateFrom).format('DD/MM/YYYY');
                if ((stay.dateTo !== undefined) && (stay.dateTo !== '')) {
                    stay.dateFormatTo = moment(stay.dateTo).format('YYYY/MM/DD');
                    stay.dateViewTo = moment(stay.dateTo).utc().format('DD/MM/YYYY');
                }
                stay.branchDescription = stay.branch ? stay.branch.description : '';
            });
        }
        vm.tableParamsStays =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatFrom: 'desc'
                    }
                },
                {
                    total: list.length,
                    counts: [],
                    dataset: angular.copy(list)
                }
            );
    }

    function iniTableStaysFuture(list) {
        if (!list) {
            list = [];
        } else {
            _.forEach(list, function (stay) {
                stay.dateFormatFrom = moment(stay.dateFrom).format('YYYY/MM/DD');
                stay.dateViewFrom = moment(stay.dateFrom).format('DD/MM/YYYY');
                if ((stay.dateTo !== undefined) && (stay.dateTo !== '')) {
                    stay.dateFormatTo = moment(stay.dateTo).format('YYYY/MM/DD');
                    stay.dateViewTo = moment(stay.dateTo).utc().format('DD/MM/YYYY');
                }
                stay.branchDescription = stay.branch ? stay.branch.description : '';
                if (_.isNumber(stay.amount)) {
                    stay.stayAmount = _.round(stay.amount, 2);
                }
                if (!_.isEmpty(stay.amounts)) {
                    stay.stayAmounts = '';
                    _.forOwn(stay.amounts, function(value, key) {
                        stay.stayAmounts += key + ': ' + _.round(value, 2) + '<br>';
                    });
                }
            });
        }
        vm.tableParamsStaysFuture =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatFrom: 'desc'
                    }
                },
                {
                    total: list.length,
                    counts: [],
                    dataset: angular.copy(list)
                }
            );
    }

    vm.openConceptDetail = function (data) {
        if (vm.readonly) {
            data.readonly = true;
        }

        // New concept
        if (!data) {
            if (vm.resident._id) {
                data = {
                    client: {
                        item: vm.resident._id,
                        kind: vm.userKind.value === 'guest' ? 'Guest' : 'AppUser'
                    },
                    branch: vm.bill.branch ? vm.bill.branch : undefined,
                    taxes: [],
                };
            } else {
                data = {};
            }
        }

        data.constants = angular.copy(vm.constants);
        data.userBranches = vm.resident.branches;

        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/modal/modalConceptDetail/modalConceptDetail.html',
            controller: 'ModalConceptDetailController',
            controllerAs: 'mcdc',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                modalBinding: function () {
                    return data;
                }
            }
        });
        // Function when open modal
        modalInstance.result.then(function (result) {
            //close function
            if (result) {
                getSourcesConcept();
            }
        }, function (closemsg) {
            //dismiss function
        });
    };

    vm.payInvoice = function () {
        if (!vm.bill.invoiceNumber) {
            swal({
                title: TranslationService.modal.warning,
                text: TranslationService.modal.invoiceNumberNeeded,
                confirmButtonText: TranslationService.modal.button.ok
            });
        } else {
            swal({
                title: TranslationService.modal.confirmation,
                text: TranslationService.modal.payBilling,
                showCancelButton: true,
                confirmButtonText: TranslationService.modal.button.ok,
                cancelButtonText: TranslationService.modal.button.cancel
            }).then(function (result) {
                if (result.value) {
                    var billingUpdate = {payDate: new Date(), paidData: vm.bill.paidData};
                    if (!vm.showDeposit) {
                        billingUpdate.addDeposit = true;
                    }
                    BillingService.post({idR: vm.bill._id}, billingUpdate, function (data) {
                        toastr.success(TranslationService.modal.paySuccess);
                        $rootScope.$emit('reloadBillingList');
                    }, function (err) {
                        $log.error('BillingService pay error: ', err);
                        toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    });
                }
            });
        }
    };

    vm.getConstants = function () {
        ConfigService.query({
            component: 'tax'
        }, function (res) {
            $log.debug('tax master table data: ', res);
            vm.constants.tax = angular.copy(res);
        }, function (err) {
            $log.error('tax master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });

        ConfigService.query({
            functionality: 'payType'
        }, function (res) {
            $log.debug('payTypes master table data: ', res);
            vm.constants.payTypes = angular.copy(res);
            if ((_.get(vm.bill, '_id') && _.get(vm.bill, 'paidData.payType.code') !== 'fianza') ||
                (!_.get(vm.bill, '_id') && !_.get(vm.resident, 'deposit'))) {
                _.remove(vm.constants.payTypes, {code: 'fianza'});
            }
        }, function (err) {
            $log.error('paytypes master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });

        ConfigService.query({
            component: 'customConcept'
        }, function (res) {
            $log.debug('customConcepts masterTable data: ', res);
            vm.constants.customConcepts = angular.copy(res);
        }, function (err) {
            $log.error('customConcept master table error: ', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.validSwift = function (input, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            valid = ValidationService.validSwift(input);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validIban = function (input, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            valid = ValidationService.validIban(input);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.invalidR = function (formInput) {
        var val = false;
        if (vm.resdidentaBD.branches && vm.resdidentaBD.branches.length > 0) {
            val = true;
        }
        return val;
    };

    vm.invoice = function (billForm, generateBill) {
        if (vm.selectedBill && vm.selectedBill.comments) {
            vm.bill.comments = vm.selectedBill.comments;
        }
        vm.submitInvoice = true;

        if ((vm.selectedServices.length === 0 && vm.selectedStays.length === 0)) {
            toastr.error(TranslationService.payments.invalidInvoice);
            return;
        }

        if (vm.bill.branch) {
            // Generate invoice if AppUser
            if (vm.userKind && vm.userKind.value === 'resident' && vm.resident && vm.resident._id) {
                vm.bill.client = {
                    item: vm.resident._id,
                    kind: 'AppUser'
                };
            }
            if (vm.userKind && vm.userKind.value === 'guest') {
                vm.bill.client = {
                    item: vm.resident._id,
                    kind: 'Guest'
                };

                // Update guest data
                if (!vm.resident.contact) {
                    vm.resident.contact = {};
                }

                if (vm.resident.phone) {
                    vm.resident.contact.phone = vm.resident.phone;
                }

                if (vm.resident.email) {
                    vm.resident.contact.email = vm.resident.email;
                }

                if (vm.resident.identity) {
                    vm.resident.contact.identity = vm.resident.identity;
                }

                if (vm.resident.address) {
                    vm.resident.contact.address = vm.resident.address;
                }

                if (vm.resident.city) {
                    vm.resident.contact.city = vm.resident.city;
                }

                if (vm.resident.country) {
                    vm.resident.contact.country = vm.resident.country;
                }

                if (vm.resident.postcode) {
                    vm.resident.contact.postcode = vm.resident.postcode;
                }

                if (vm.resident.state) {
                    vm.resident.contact.state = vm.resident.state;
                }

                GuestService.post({idR: vm.resident._id}, vm.resident, function (guestData) {
                    $log.debug('Guest update data', guestData);
                }, function (guestErr) {
                    $log.error('Guest update error: ', guestErr);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }

            if (generateBill) {
                vm.bill.generateBilling = true;
            }

            vm.bill.concepts = _.union(vm.selectedServices, vm.selectedStays);

            if (vm.selectedBill && vm.selectedBill.billingAddress) {
                vm.bill.billingAddress = vm.selectedBill.billingAddress;
            }

            $log.debug('Bill', vm.bill);

            var query = {};
            if (vm.bill._id && vm.bill._id !== '0' && vm.bill._id !== 0) {
                query.idR = vm.bill._id;
            }
            if (vm.bill._id === '0' || vm.bill._id === 0) {
                delete vm.bill._id;
            }

            if (!vm.bill._id && vm.menuOption && vm.menuOption === 'residents') {
                _.set(vm.bill, 'billingAddress.ownClient', true);
            }

            if (vm.useDeposit && vm.usedDeposit) {
                _.set(vm.bill, 'usedDeposit', vm.usedDeposit);
            }

            BillingService.post(query, vm.bill, function (data) {
                if (generateBill) {
                    toastr.success(TranslationService.modal.invoiceSuccess);
                } else {
                    toastr.success(TranslationService.modal.proformaSuccess);
                }

                if (vm.selectedBill) {
                    vm.selectedBill._id = data._id;
                }
                vm.services = [];
                vm.selectedServices = [];
                vm.stays = [];
                vm.selectedStays = [];
                $rootScope.$emit('reloadBillingList');
                vm.onSave();
                setTimeout(function () {
                    getSourcesConcept();
                    //vm.setSelectedConcepts();
                }, 300);
            }, function (err) {
                $log.error('BillingService post error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    vm.changeUseDeposit = function () {
        var depositPayType = _.find(vm.constants.payTypes, {code: 'fianza'});
        if (_.get(vm.resident, 'deposit')) {
            if (vm.useDeposit) {
                vm.usedDeposit = vm.total - _.get(vm.resident, 'deposit') > 0 ?
                    _.get(vm.resident, 'deposit') : vm.total;
                if (depositPayType) {
                    vm.bill.paidData.payType = depositPayType;
                }
            } else {
                vm.usedDeposit = 0;
                if (vm.bill.paidData.payType === depositPayType) {
                    vm.bill.paidData.payType = undefined;
                }
            }
        }
    };

    $rootScope.$on('setPaymentPayType', function (event, data) {
        vm.bill.paidData.payType = data.payType;
        if (data.bank) {
            vm.bill.paidData.bank = data.bank;
        }
        if (data.bankCard) {
            vm.bill.paidData.bankCard = data.bankCard;
        }
    });

    vm.calcTotalConcepts = function (conceptsType) {
        var selectedConcepts = conceptsType === 'services' ? vm.selectedServices : vm.selectedStays;
        var conceptsTotal = 0;
        _.forEach(selectedConcepts, function (svc) {
            var svcTotal = svc.amount ? svc.amount : 0;
            if (svc.discountF) {
                svcTotal -= svc.discountF;
            }
            if (svc.discountP) {
                svcTotal -= svc.discountP * svc.amount / 100;
            }
            _.forEach(svc.taxes, function (svcTax) {
                if (svcTax.isPercentage) {
                    svcTotal = svcTotal + (svc.amount * (svcTax.rate / 100));
                } else {
                    svcTotal = svcTotal + svcTax.rate;
                }
            });
            conceptsTotal = Math.round((conceptsTotal + svcTotal) * 100) / 100;
        });
        if (conceptsType === 'services') {
            vm.servicesTotal = conceptsTotal;
        } else if (conceptsType === 'stays') {
            vm.staysTotal = conceptsTotal;
        }
    };

    vm.calcTotal = function () {
        vm.total = _.round((vm.applicationTotal ? vm.applicationTotal : vm.servicesTotal + vm.staysTotal - vm.usedDeposit), 2);
    };

    vm.deleteServiceConcept = function (row) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ConceptService.delete({idR: row._id}, function (data) {
                    vm.services = [];
                    getSourcesConcept();
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    $log.error('ConceptService delete error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.serviceCheckboxChanges = function (concept) {
        vm.selectedServices = _.filter(vm.tableParamsServices.data, 'selected');
        if (_.find(vm.selectedServices, {'isDeposit': true})) {
            vm.showDeposit = false;
            vm.useDeposit = false;
        } else if (!_.find(vm.bill.concepts, function (item) {
            return item['isDeposit'] || _.get(item, 'related.kind') === 'Application';
        })) {
            vm.showDeposit = true;
        }
        vm.calcTotalConcepts('services');
        if (vm.usedDeposit) {
            vm.useDeposit = true;
        }
        if (!vm.selectedServices.length && !vm.selectedStays.length) {
            vm.useDeposit = false;
        } else {
            vm.usedDeposit = 0;
            vm.calcTotal();
        }
        vm.changeUseDeposit();
        vm.calcTotal();
    };

    vm.occupancyCheckboxChanges = function (concept) {
        vm.selectedStays = _.filter(vm.tableParamsStays.data, 'selected');
        vm.calcTotalConcepts('stays');
        if (!vm.selectedServices.length && !vm.selectedStays.length) {
            vm.useDeposit = false;
        } else {
            vm.usedDeposit = 0;
            vm.calcTotal();
        }
        vm.changeUseDeposit();
        vm.calcTotal();
    };

    vm.changePayType = function () {
        if (_.get(vm.bill, 'paidData.payType.code') === 'fianza') {
            vm.useDeposit = true;
        } else {
            vm.useDeposit = false;
            if (_.get(vm.bill, 'paidData.payType.code') === 'domiciliado') {
                vm.bill.paidData.bank = {};
            } else if (_.get(vm.bill, 'paidData.payType.code') === 'tarjeta') {
                vm.bill.paidData.bankCard = {};
            }
        }
        vm.changeUseDeposit();
        vm.calcTotal();
    };

    function formatResponsePdf(response) {
        var strName = '[' + vm.bill.invoiceNumber + ' ]' + 'YYYY_MM_DD h_mm[.pdf]';
        var url = window.URL;
        var myBlobObject = new Blob([response.data], {type: 'application/pdf'});
        var fileURL = url.createObjectURL(myBlobObject);
        var link = document.createElement('a');
        link.setAttribute('type', 'hidden'); // make it hidden if needed
        link.download = moment().format(strName);
        link.href = fileURL;
        link.target = '_self';
        link.click();
    }

    vm.printInvoice = function (type) {
        if (type === 'invoice') {
            vm.downloadingInvoicePdf = true;
        } else {
            vm.downloadingProformaPdf = true;
        }
        var urlId = serviceConf.BillingPrintService;
        urlId = urlId.replace(':idR', vm.bill._id);
        var con = {
            headers: {
                'authentication': 'Bearer ' + localStorageService.get('sessionToken'),
                'docType': type
            },
            responseType: 'arraybuffer'
        };

        $http.get(urlId, con).then(function mySuccess(response) {
            formatResponsePdf(response);
            setTimeout(function () {
                vm.downloadingInvoicePdf = false;
                vm.downloadingProformaPdf = false;
            }, 501);
        });
    };

    vm.$onInit = function () {
        tmhDynamicLocale.set(moment.locale());
        vm.getConstants();

        if (vm.selectedBill) {
            vm.bill = vm.selectedBill;

            if (vm.bill.invoiceNumber) {
                vm.readonly = true;
            }

            if (vm.bill && vm.bill.concepts && _.find(vm.bill.concepts, function (item) {
                return item['isDeposit'] || _.get(item, 'related.kind') === 'Application';
            })) {
                vm.showDeposit = false;
            }
        }

        if (!vm.bill || !vm.bill._id) {
            vm.bill = {};

            if (_.get(vm.resident, 'billingAccounts.payType')) {
                if (!vm.bill.paidData) {
                    vm.bill.paidData = {
                        payType: angular.copy(vm.resident.billingAccounts.payType)
                    };
                    if (vm.resident.billingAccounts.payType.code === 'tarjeta') {
                        vm.bill.paidData.bankCard = {
                            cardholder: _.get(vm.resident, 'billingAccounts.bankCard.cardholder') ? vm.resident.billingAccounts.bankCard.cardholder : undefined,
                            number: _.get(vm.resident, 'billingAccounts.bankCard.number') ? vm.resident.billingAccounts.bankCard.number : undefined,
                            expDate: _.get(vm.resident, 'billingAccounts.bankCard.expDate') ? vm.resident.billingAccounts.bankCard.expDate : undefined,
                            cvv: _.get(vm.resident, 'billingAccounts.bankCard.cvv') ? vm.resident.billingAccounts.bankCard.cvv : undefined,
                        };
                    }

                    if (vm.resident.billingAccounts.payType.code === 'domiciliado') {
                        vm.bill.paidData.bank = {
                            holder: _.get(vm.resident, 'billingAccounts.bank.holder') ? vm.resident.billingAccounts.bank.holder : undefined,
                            name: _.get(vm.resident, 'billingAccounts.bank.name') ? vm.resident.billingAccounts.bank.name : undefined,
                            swift: _.get(vm.resident, 'billingAccounts.bank.swift') ? vm.resident.billingAccounts.bank.swift : undefined,
                            iban: _.get(vm.resident, 'billingAccounts.bank.iban') ? vm.resident.billingAccounts.bank.iban : undefined,
                        };
                    }
                } else {
                    vm.bill.paidData.payType = angular.copy(vm.resident.billingAccounts.payType);
                }
            } else {
                vm.bill.paidData = {};
            }

            if (!_.get(vm.resident, 'deposit')) {
                _.remove(vm.constants.payTypes, {code: 'fianza'});
            }

            if (selectedBar && !selectedBar.all) {
                vm.bill.branch = selectedBar;
            }
        } else {
            if (_.get(vm.bill, 'paidData.payType') && _.get(vm.bill, 'paidData.payType.code') === 'fianza') {
                vm.disablePayType = true;
            } else if (vm.constants) {
                _.remove(vm.constants.payTypes, {code: 'fianza'});
            }
        }

        if (vm.resident && !vm.residentOri._id) {
            vm.residentOri._id = angular.copy(vm.resident._id);
        }

        if (_.get(vm.bill, 'paidData.bankCard.expDate')) {
            vm.bill.paidData.bankCard.expDate = moment(vm.bill.paidData.bankCard.expDate).toDate();
        }

        getSourcesConcept();
        getFutureConcepts();
    };
}

angular
    .module('BlurAdmin.paymentCom')
    .component('payment', {
        templateUrl: 'app/components/residents/payment/payment.html',
        controllerAs: 'pyc',
        controller: PaymentController,
        bindings: {
            resident: '=',
            selectedBill: '=',
            menuOption: '=',
            anim: '=',
            level: '@',
            istour: '<',
            readonly: '=',
            userKind: '=',
            onSave: '&',
            payButton: '<'
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */

ResidentDetailController.$inject = ['ResidentsService', 'toastr', 'TranslationService', 'BillingService',
    'MasterTableService', 'routeConf', '$log', 'ResCancelAccessService', 'ResRenewAccessService',
    '$rootScope', 'ValidationService', 'PermissionsService', 'CountryList', 'tmhDynamicLocale',
    'NgTableParams', 'localStorageService', 'Lightbox', '$http', '$window', 'FileSaver',
    'OccupancyService', 'OccupancyResident', 'GuestInvitations', 'AdmonitionService',
    'ResidentsAdmonition', 'HistoryMenu', 'HistoryAgenda', 'HistoryIncident',
    'HistoryService', '$scope', 'ConfigService', '$state', 'state', 'ConceptService'];

function ResidentDetailController(ResidentsService, toastr, TranslationService, BillingService,
                                  MasterTableService, routeConf, $log, ResCancelAccessService, ResRenewAccessService,
                                  $rootScope, ValidationService, PermissionsService, CountryList, tmhDynamicLocale,
                                  NgTableParams, localStorageService, Lightbox, $http, $window, FileSaver,
                                  OccupancyService, OccupancyResident, GuestInvitations, AdmonitionService,
                                  ResidentsAdmonition, HistoryMenu, HistoryAgenda,
                                  HistoryIncident, HistoryService, $scope, ConfigService, $state, state, ConceptService) {
    var vm = this;

    vm.lodash = _;

    vm.initialized = false;
    vm.resdidentaBD = {};
    vm.residentOri = {};
    vm.avatar = '';
    vm.avatarOri = '';
    vm.showConfigTokenA = false;
    vm.cont = 0;
    vm.submitted = false;
    vm.showConfigava = false;
    vm.avatarUploading = false;
    vm.fileUploading = false;
    vm.otherinfoopen = false;
    vm.contactinopen = true;
    vm.medicalinopen = false;
    vm.gotAccessMedical = false;
    vm.staysopen = false;
    vm.absencesopen = false;
    vm.guestsopen = false;
    vm.admonitionopen = false;
    vm.historyopen = false;
    vm.attachedsfoopen = false;
    vm.paymentdatafopen = false;
    vm.paymentlistopen = false;
    vm.attachment = undefined;
    vm.filesAux = [];
    vm.awayDayFrom = moment().toDate();
    vm.awayDayTo = moment().toDate();
    vm.timeOfDayFrom = [];
    vm.timeOfDayTo = [];
    vm.selectedCountry = {};
    vm.selectedState = '';
    vm.awayList = [];
    vm.occupancies = [];
    vm.guests = [];
    vm.guest = [];
    vm.noGuestName = false;
    vm.appUser = [];
    vm.appUsers = [];
    vm.admonitions = [];
    vm.alredyFloor = null;
    vm.showErrorAway = false;
    vm.showErrorGuest = false;

    vm.historyMenuPage = 1;
    vm.historyActivitiesPage = 1;
    vm.historyServicesPage = 1;
    vm.historyIncidentsPage = 1;

    vm.historyItemsPage = 4;

    vm.dateIn = moment().toDate();
    vm.dateOptions = {
        maxDate: moment().toDate(),
        showWeeks: false
    };
    vm.dateOptionsFromToday = {
        minDate: moment().toDate(),
        showWeeks: false
    };
    vm.dateOptionsContract = {
        showWeeks: false
    };
    vm.selectedName = '';
    vm.addingAdmonition = false;

    vm.TabHistoryMenu = false;
    vm.TabHistoryActivities = false;
    vm.TabHistoryServices = false;
    vm.TabHistoryIncidents = false;
    vm.historyMenu = [];
    vm.historyMenuTotal = 0;
    vm.historyMenuCount = 0;
    vm.historyMenuLimit = 0;
    vm.historyActivities = [];
    vm.historyActivitiesTotal = 0;
    vm.historyActivitiesCount = 0;
    vm.historyActivitiesLimit = 0;
    vm.historyServices = [];
    vm.historyServicesTotal = 0;
    vm.historyServicesCount = 0;
    vm.historyServicesLimit = '';
    vm.historyIncidents = [];
    vm.historyIncidentsTotal = 0;
    vm.historyIncidentsCount = 0;
    vm.historyIncidentsLimit = 0;
    vm.paymentType = 'cash';
    vm.momentAux = moment;

    vm.accordions = {
        billings: false,
        billingData: false
    };

    vm.universities = [];
    vm.faculties = [];
    vm.studies = [];

    vm._CONTROLLER = 'ResidentDetailController';

    function setPermissions() {
        vm.gotAccessMedical = PermissionsService.gotPermission('MEDICAL', 'read');
        vm.gotAccessBilling = PermissionsService.gotPermission('BILLING', 'update');
    }

    vm.checkIsDefaultPayMethod = function () {
        if (vm.resdidentaBD.billingAccounts && vm.resdidentaBD.billingAccounts.payType) {
            if (vm.payType.code === vm.resdidentaBD.billingAccounts.payType.code) {
                vm.isDefaultPayMethod = true;
            } else {
                vm.isDefaultPayMethod = false;
            }
        }
    };

    vm.emitPayTypeChange = function () {
        if (vm.isDefaultPayMethod) {
            console.log('billingAccounts: ', vm.resdidentaBD.billingAccounts);
            $rootScope.$emit('setPaymentPayType',
                {
                    payType: vm.payType,
                    bank: vm.resdidentaBD.billingAccounts.bank,
                    bankCard: vm.resdidentaBD.billingAccounts.bankCard
                }
            );
        }
    };

    vm.setDefaultPayMethod = function () {
        if (!vm.readonly) {
            if (!vm.payType) {
                vm.isDefaultPayMethod = false;
            } else {
                vm.isDefaultPayMethod = true;
            }

            if (!vm.resdidentaBD.billingAccounts) {
                vm.resdidentaBD.billingAccounts = {};
            }
            vm.resdidentaBD.billingAccounts.payType = angular.copy(vm.payType);
        } else {
            vm.isDefaultPayMethod = !vm.isDefaultPayMethod;
        }
        vm.emitPayTypeChange();
    };

    vm.changePayType = function () {
        vm.checkIsDefaultPayMethod();
    };

    vm.changeType = function (value) {
        vm.paymentType = value;
    };

    vm.parseCardListBy = function () {
        vm.alredy = _.filter(vm.card, function (c) {
            if (c.alredy) {
                return c;
            }
        });
    };

    /** Function to clear controller stored values from resident */
    vm.clearResidentValues = function () {
        vm.historyActivities = undefined;
        vm.historyIncidents = undefined;
        vm.historyMenu = undefined;
        vm.historyServices = undefined;

        vm.TabHistoryActivities = false;
        vm.TabHistoryIncidents = false;
        vm.TabHistoryMenu = false;
        vm.TabHistoryServices = false;

        vm.awayList = [];
        vm.occupancies = [];
        vm.guests = [];
        vm.guest = [];
        vm.appUser = [];
        vm.appUsers = [];
        vm.admonitions = [];
        vm.resdidentaBD = {};
    };

    vm.$doCheck = function () {
        if (vm.resident && (vm.resident._id !== vm.residentOri._id)) {
            vm.residentOri._id = angular.copy(vm.resident._id);
            vm.initialized = false;

            vm.clearResidentValues();

            vm.$onInit();
        }
    };

    vm.validSwift = function (input, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            valid = ValidationService.validSwift(input);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validIban = function (input, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            valid = ValidationService.validIban(input);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validDNI = function (input, type, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            if (type !== 'PAS') {
                valid = ValidationService.validDniNie(input, type);
            }
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validInteger = function (input, formInput) {
        if (input) {
            return (
                !isNaN(parseInt(input)) || !isNaN(parseInt(input)) ||
                formInput.$pristine);
        } else {
            return true;
        }
    };

    vm.validNormalInput = function (input, formInput) {
        if (input) {
            return (
                vm.trimText(input).length > 0 ||
                formInput.$pristine);
        } else {
            return true;
        }
    };

    vm.validateMobile = function (mobile, formInput) {
        var valid = true;
        if (!formInput.$pristine && mobile !== '') {
            valid = ValidationService.validMobile(mobile);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validEmail = function (emailField, formInput) {
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,4})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (!emailField || formInput.$pristine || (!formInput.required && emailField === '')) {
            valid = true;
        } else {
            valid = reg.test(emailField);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.changeTypeIde = function (type) {
        if (vm.readonly) {
            return;
        }
        vm.cont += 1;
        if (vm.cont < vm.constants.docType.length) {
            vm.resdidentaBD.identity.type = vm.constants.docType[vm.cont];
        } else {
            vm.cont = 0;
            vm.resdidentaBD.identity.type = vm.constants.docType[0];
        }
    };


    /** Function to set type document tutor dont have identity document **/
    vm.setTutorDocType = function (index) {
        if (!vm.resdidentaBD.tutors[index].identity) {
            vm.resdidentaBD.tutors[index].identity = {docType: vm.constants.docType[0]};
        }
    };

    /** Function to change Document Type of tutors **/
    vm.changeTypeDocTutor = function (index) {
        if (vm.readonly) {
            return;
        }

        if (vm.resdidentaBD.tutors[index].identity) {
            var docTypeIndex = vm.constants.docType.indexOf(vm.resdidentaBD.tutors[index].identity.docType);

            if (docTypeIndex !== -1 && docTypeIndex < vm.constants.docType.length - 1) {
                vm.resdidentaBD.tutors[index].identity.docType = vm.constants.docType[docTypeIndex + 1];
            } else {
                vm.resdidentaBD.tutors[index].identity.docType = vm.constants.docType[0];
            }
        } else {
            vm.resdidentaBD.tutors[index].identity = {docType: vm.constants.docType[0]};
        }
    };

    vm.trimText = function (value) {
        if (angular.isString(value)) {
            value.replace(/^\s+|\s+$/g, '');
        }
        return value;
    };

    vm.configava = function (renew) {
        if (renew) {
            ResRenewAccessService.post({idR: vm.resident._id}, function (data) {
                vm.showConfigava = false;
                vm.resdidentaBD.tokenApp = {};
                toastr.success(TranslationService.residents.renewAccessOK);
            });
        } else {
            ResCancelAccessService.post({idR: vm.resident._id}, {}, function (data) {
                vm.showConfigava = false;
                vm.resdidentaBD.tokenApp = null;
                toastr.success(TranslationService.residents.cancelAccessOK);
            });
        }
    };

    vm.checkDatesAway = function () {
        return vm.awayDayTo && vm.awayDayFrom && moment(vm.awayDayFrom).isAfter(moment(vm.awayDayTo));
    };

    function getSourcesSpots(branch) {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.spot};
            if (branch && branch.length) {
                query.branch = _.map(branch, '_id');
            }
            query.isRoom = true;
            query.sort = 'code';
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load spots', err);
            }).$promise.then(function (data) {
                $log.debug('load spots success', data);
                full(data);
            });
        });
    }

    function getSourcesAdmonitions() {
        return new Promise(function (full, reject) {
            ResidentsAdmonition.get({idR: vm.resdidentaBD._id}, {}, function (data) {
            }, function (err) {
                $log.error('error getting admonitions : ', err);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    function getSourcesPaymentList() {
        return new Promise(function (full, reject) {
            // TODO request to API
            /*
            var queryPaymentList = {client: vm.resdidentaBD._id};
            PaymentListService.get(queryPaymentList, function (data) {
            }, function (err) {
                $log.error('error getting PaymentList : ', err);
            }).$promise.then(function (data) {
                full(data);
            });
            */
        });
    }

    function getSourcesGuests(guestName) {
        return new Promise(function (full, reject) {
            MasterTableService.get({
                idT: routeConf.guest,
                name: guestName
            }, function (data) {
                full(data);
            }, function (err) {
                $log.error('error searching guest ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        });
    }

    function getSourcesGuestInvitations() {
        return new Promise(function (full, reject) {
            var queryInvitations = {client: vm.resdidentaBD._id};
            GuestInvitations.get(queryInvitations, function (data) {
            }, function (err) {
                $log.error('error getting invitations : ', err);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    vm.addAway = function () {
        if (vm.awayDayFrom.getTime() === vm.awayDayTo.getTime() && vm.timeOfDayFrom._id === vm.timeOfDayTo._id) {
            toastr.error(TranslationService.resident.invalidawaydates);
        } else {
            vm.showErrorAway = false;
            if ((vm.occupancies.data) && (vm.occupancies.data.length > 0)) {
                if (vm.occupancies.dateTo) {
                    if ((moment(vm.awayDayFrom).isAfter(moment(vm.occupancies.dateTo)) ||
                        moment(vm.awayDayTo).isAfter(moment(vm.occupancies.dateTo)) ||
                        moment(vm.awayDayFrom).isAfter(moment(vm.awayDayTo)))) {
                        vm.showErrorAway = true;
                    }
                } else {
                    vm.occupancies.data[0].awayList.forEach(function (element, index) {
                        if (((moment(vm.awayDayFrom).isBefore(moment(element.dateFrom)) || moment(vm.awayDayFrom).isSame(moment(element.dateFrom))) &&
                            (moment(vm.awayDayTo).isBefore(moment(element.dateTo) && (moment(vm.awayDayFrom).isAfter(moment(element.dateTo)))) ||
                                (moment(vm.awayDayFrom).isAfter(moment(element.dateFrom)) &&
                                    ((moment(vm.awayDayTo).isAfter(moment(element.dateTo))) || (moment(vm.awayDayTo).isAfter(moment(element.dateTo))))) ||
                                (moment(vm.awayDayFrom).isBefore(moment(element.dateFrom)) &&
                                    (moment(vm.awayDayTo).isAfter(moment(element.dateTo)))) ||
                                (moment(vm.awayDayFrom).isAfter(moment(element.dateFrom)) &&
                                    (moment(vm.awayDayTo).isBefore(moment(element.dateTo)))) ||
                                ((moment(vm.awayDayTo).isSame(moment(element.dateTo))) &&
                                    (vm.timeOfDayTo.code === element.timeOfDayTo.code) &&
                                    (moment(vm.awayDayFrom).isSame(moment(element.dateFrom))) &&
                                    (vm.timeOfDayFrom.code === element.timeOfDayFrom.code))))) {
                            vm.showErrorAway = true;
                        }
                    });
                }
            }
            if (vm.showErrorAway === true) {
                return;
            }
            var dataAway = {
                dateFrom: vm.awayDayFrom,
                dateTo: vm.awayDayTo,
                awayPeriodFrom: vm.timeOfDayFrom._id,
                awayPeriodTo: vm.timeOfDayTo._id
            };
            OccupancyResident.post({idT: vm.occupancies.data[0]._id, idR: 'away'}, dataAway, function (data) {
                toastr.success(TranslationService.dialog.saveok);
                vm.occupancies.data[0].awayList = Object.keys(data.awayList).map(function (e) {
                    Object.keys(data.awayList[e]).forEach(function (k) {
                        if (typeof data.awayList[e][k] === 'object') {
                            data.awayList[e][k] = Object.keys(data.awayList[e][k]).map(function (l) {
                                return data.awayList[e][k][l];
                            });
                        }
                    });
                    return data.awayList[e];
                });
                iniTableAway(vm.occupancies);
            }, function (err) {
                $log.error('error saving absence : ', err);
            }).$promise.then(function (data) {
                $log.debug('saving absence : ', vm.resdidentaBD);
            });
        }
    };

    function removeAwayEntry(elements, id) {
        elements.data[0].awayList.forEach(function (element, index) {
            if (element._id === id) {
                elements.data[0].awayList.splice(index, 1);
                removeAwayEntry(elements, id);
            }
        });
    }

    vm.deleteAway = function (away) {
        var query = {idO: away.idOccupancy, idA: away._id};
        OccupancyService.delete(query, function (data) {
            toastr.success(TranslationService.dialog.saveok);
            removeAwayEntry(vm.occupancies, away._id);
            iniTableAway(vm.occupancies);
        }, function (err) {
            $log.error('error deleting away : ', err);
        }).$promise.then(function (data) {
            $log.debug('absence borrada ', away);
        });
    };

    function removeFromList(elements, id) {
        elements.forEach(function (element, index) {
            if (element._id === id) {
                elements.splice(index, 1);
                removeFromList(elements, id);
            }
        });
    }

    vm.addAdmonition = function (admonition) {
        vm.addingAdmonition = true;
        if (!vm.tableParamsAdmonitions) {
            iniTableAdmonition();
        }
        vm.tableParamsAdmonitions.settings().dataset.unshift({
            _id: null,
            date: new Date(),
            type: vm.constants.admonitionTypes[0],
            comment: '',
            modeEdit: true
        });
        vm.tableParamsAdmonitions.sorting({});
        vm.tableParamsAdmonitions.page(1);
        vm.tableParamsAdmonitions.reload();
    };

    vm.editAdmonition = function (admonition) {
        _.forEach(vm.admonitions, function (item) {
            if (admonition._id === item._id) {
                item.modeEdit = true;
            }
        });
        admonition.modeEdit = true;
        vm.temporalAdmonition = angular.copy(admonition);
    };

    function removeNullFromList(elements) {
        elements.forEach(function (element, index) {
            if (element._id === null) {
                elements.splice(index, 1);
                removeNullFromList(elements);
            }
        });
    }

    vm.cancelAdmonition = function (admonition) {
        if (admonition._id !== null) {
            admonition.modeEdit = false;
            _.forEach(vm.admonitions, function (item, key) {
                if (admonition._id === item._id) {
                    item.modeEdit = false;
                    vm.tableParamsAdmonitions.data[key] = vm.temporalAdmonition;
                }
            });
            vm.tableParamsAdmonitions.reload();
        } else {
            _.remove(vm.tableParamsAdmonitions.settings().dataset, function (item) {
                return admonition === item;
            });
            vm.tableParamsAdmonitions.reload();
            vm.addingAdmonition = false;
        }
    };

    vm.saveAdmonition = function (admonition) {
        if (admonition.comment) {
            var query;
            if (admonition._id) {
                query = {idR: admonition._id};
            } else {
                query = {};
            }
            var dataAdmonition = {
                client: vm.resdidentaBD._id,
                type: admonition.type._id,
                comment: admonition.comment
            };
            AdmonitionService.post(query, dataAdmonition, function (data) {
                toastr.success(TranslationService.dialog.saveok);
            }, function (err) {
                $log.error('error saving admonition : ', err);
            }).$promise.then(function (data) {
                admonition.modeEdit = false;
                vm.addingAdmonition = false;
                $log.debug('saving admonition: ', admonition);

                getSourcesAdmonitions().then(function (dataAdmonitions) {
                    iniTableAdmonition(dataAdmonitions);
                    vm.tableParamsAdmonitions.reload();
                });
            });
        } else {
            toastr.error(TranslationService.dialog.commentisrequired);
        }
    };

    vm.deleteAdmonition = function (admonition) {
        var query = {idR: admonition._id};
        AdmonitionService.delete(query, function (data) {
            toastr.success(TranslationService.dialog.saveok);
        }, function (err) {
            $log.error('error deleting admonition : ', err);
            var respuestaError = TranslationService.errors.e500;
            if (err.data.error) {
                var mensaje = err.data.error;
                if (mensaje.indexOf('[GEN40501]') !== false) {
                    respuestaError = TranslationService.errors.GEN40501;
                }
            }
            toastr.error(respuestaError);
        }).$promise.then(function (data) {
            $log.debug('admonition borrada ', admonition);
            getSourcesAdmonitions().then(function (dataAdmonitions) {
                iniTableAdmonition(dataAdmonitions);
                vm.tableParamsAdmonitions.reload();
            });
        });
    };

    vm.setGuest = function (selectedGuest) {
        vm.guest = angular.copy(selectedGuest);
        vm.selectedGuest = angular.copy(selectedGuest);
        vm.selectedName = selectedGuest.fullName;
    };

    vm.getGuestsByName = function (guestName) {
        vm.guest = [];
        return getSourcesGuests(guestName)
            .then(function (data) {
                var response = data.data;
                return response.map(function (item) {
                    return item;
                });
            });
    };

    vm.addGuest = function () {
        vm.noGuestName = false;
        if (vm.selectedName === '') {
            toastr.error(TranslationService.resident.msgerrorguest);
        } else {
            if ((vm.guest._id === undefined) || (vm.guest._id === null) || (vm.guest._id === '')) {
                vm.guest._id = null;
                vm.guest.name = vm.selectedName;
            }
            var dataGuest = {
                client: vm.resdidentaBD._id,
                guest: {_id: vm.guest._id, name: vm.guest.name},
                branch: vm.resdidentaBD.branches[0]._id,
                date: moment(vm.dateIn).format('YYYY-MM-DD'),
            };

            GuestInvitations.post(dataGuest, function (data1) {
                toastr.success(TranslationService.dialog.saveok);
                getSourcesGuestInvitations().then(function (data2) {
                    vm.selectedName = '';
                    iniTableGuest(data2);
                });
            }, function (err) {
                $log.error('error saving invitation : ', err);
            }).$promise.then(function (data) {
                $log.debug('saving invitation : ', vm.guest);
            });
        }
    };

    function removeGuest(elements, id) {
        elements.forEach(function (element, index) {
            if (element._id === id) {
                elements.splice(index, 1);
                removeGuest(elements, id);
            }
        });
    }

    vm.setdateTimeIn = function (guest) {
        if (!guest.dateTimeViewIn) {
            $log.debug('entra invitado');
            var dataGuest = {
                client: vm.resdidentaBD._id,
                guest: {_id: vm.appUser._id},
                branch: vm.resdidentaBD.branches._id,
                date: moment(vm.dateIn).format('YYYY-MM-DD'),
            };
            var query = {idI: guest._id, idR: 'in'};
            GuestInvitations.post(query, dataGuest, function (data) {
                toastr.success(TranslationService.dialog.saveok);
                getSourcesGuestInvitations().then(function (data) {
                    iniTableGuest(data);
                });
            }, function (err) {
                $log.error('error saving invitation in : ', err);
            }).$promise.then(function (data) {
                $log.debug('saving invitation in : ', guest);
            });
        }
    };

    vm.setdateTimeOut = function (guest) {
        if (guest.dateTimeViewIn && !guest.dateTimeViewOut) {
            $log.debug('sale invitado');
            var dataGuest = {
                client: vm.resdidentaBD._id,
                guest: {_id: vm.appUser._id},
                branch: vm.resdidentaBD.branches._id,
                date: moment(vm.dateIn).format('YYYY-MM-DD')
            };
            var query = {idI: guest._id, idR: 'out'};
            GuestInvitations.post(query, dataGuest, function (data) {
                toastr.success(TranslationService.dialog.saveok);
                getSourcesGuestInvitations().then(function (data) {
                    iniTableGuest(data);
                });
            }, function (err) {
                $log.error('error saving invitation out : ', err);
            }).$promise.then(function (data) {
                $log.debug('saving invitation out : ', guest);
            });
        }
    };

    vm.deleteGuest = function (guest) {
        if (!guest.dateTimeViewIn) {
            $log.debug('esta disabled');
            var query = {idI: guest._id};
            GuestInvitations.delete(query, function (data) {
                toastr.success(TranslationService.dialog.saveok);
                removeGuest(vm.guests, guest._id);
                var lista = [];
                lista.data = vm.guests;
                iniTableGuest(lista);
            }, function (err) {
                $log.error('error deleting guest : ', err);
                var mensaje = err.data.error;
                var respuestaError = TranslationService.errors.e500;
                if (mensaje.indexOf('[GEN40502]') !== false) {
                    respuestaError = TranslationService.errors.GEN40502;
                }
                toastr.error(respuestaError);
            }).$promise.then(function (data) {
                $log.debug('guest borrado ', guest);
            });
        }

    };

    vm.changeAllerge = function (all, resForm) {
        if (!vm.readonly) {
            resForm.$setDirty();
            all.selected = !all.selected;
        }
    };

    /**
     * @ngdoc method
     * @name iniTable
     * @methodOf Tagaste.residentDetailController.controller:ResidentDetailController
     * @description
     * Method that load data in table
     * @param list array data to initialize the table
     */
    function iniTable(list) {
        if (!list) {
            list = [];
        } else {
            for (var i = 0; i < list.length; i++) {
                list[i].dateFormatFrom = moment(list[i].dateFrom).format('YYYY/MM/DD');
                list[i].dateViewFrom = moment(list[i].dateFrom).format('DD/MM/YYYY');
                if ((list[i].dateTo !== undefined) && (list[i].dateTo !== '')) {
                    list[i].dateFormatTo = moment(list[i].dateTo).format('YYYY/MM/DD');
                    list[i].dateViewTo = moment(list[i].dateTo).format('DD/MM/YYYY');
                }
                list[i].branchDescription = list[i].branch ? list[i].branch.description : '';
            }
        }
        vm.tableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatFrom: 'desc'
                    }
                },
                {
                    total: list.length,
                    counts: [],
                    dataset: angular.copy(list)
                }
            );
    }

    function iniTableBillings(list) {
        if (!list) {
            list = [];
        } else {
            _.forEach(list, function (bill) {
                if (bill.concepts.length > 1) {
                    bill.concept = TranslationService.residents.billing.manyConcepts;
                } else {
                    if (bill.concepts.length !== 0) {
                        bill.concept = bill.concepts[0].description;
                    }
                }
                if (bill.date) {
                    // fix utc problems
                    bill.date = moment(bill.date).add(2, 'hour').toDate();
                }
            });
            //for (var i = 0; i < list.length; i++) {
            // list[i].dateFormatFrom = moment(list[i].dateFrom).format('YYYY/MM/DD');
            // list[i].dateViewFrom = moment(list[i].dateFrom).format('DD/MM/YYYY');
            // if ((list[i].dateTo !== undefined) && (list[i].dateTo !== '')) {
            //     list[i].dateFormatTo = moment(list[i].dateTo).format('YYYY/MM/DD');
            //     list[i].dateViewTo = moment(list[i].dateTo).format('DD/MM/YYYY');
            // }
            // list[i].branchDescription = list[i].branch ? list[i].branch.description : '';
            //}
        }
        vm.billingTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatFrom: 'desc'
                    }
                },
                {
                    total: list.length,
                    counts: [],
                    dataset: angular.copy(list)
                }
            );
    }

    function iniTablePaymentList(list) {
        if (!list) {
            list = [];
        } else {
            for (var i = 0; i < list.length; i++) {
                list[i].dateFormat = moment(list[i].date).format('YYYY/MM/DD');
                list[i].dateView = moment(list[i].date).format('DD/MM/YYYY');
            }
        }
        vm.tableParamsPaymentList =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatFrom: 'desc'
                    }
                },
                {
                    total: list,
                    counts: [],
                    dataset: angular.copy(list)
                }
            );
    }

    function iniTableAway(list) {
        if (!list) {
            list = [];
        } else {
            vm.awayList = [];
            for (var i = 0; i < list.data.length; i++) {
                for (var j = 0; j < list.data[i].awayList.length; j++) {
                    list.data[i].awayList[j].dateFormatFrom = moment(list.data[i].awayList[j].dateFrom).format('YYYY/MM/DD');
                    list.data[i].awayList[j].dateViewFrom = moment(list.data[i].awayList[j].dateFrom).format('DD/MM/YYYY');
                    list.data[i].awayList[j].dateFormatTo = moment(list.data[i].awayList[j].dateTo).format('YYYY/MM/DD');
                    list.data[i].awayList[j].dateViewTo = moment(list.data[i].awayList[j].dateTo).format('DD/MM/YYYY');
                    _.forEach(vm.constants.awayPeriod, function (item) {
                        if (list.data[i].awayList[j].periodFrom === item._id) {
                            list.data[i].awayList[j].timeOfDayFrom = item;
                        }
                        if (list.data[i].awayList[j].periodTo === item._id) {
                            list.data[i].awayList[j].timeOfDayTo = item;
                        }
                    });
                    list.data[i].awayList[j].idOccupancy = list.data[i]._id;
                    vm.awayList.push(list.data[i].awayList[j]);
                }
            }
        }
        vm.tableParamsAway =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatFrom: 'desc'
                    }
                },
                {
                    total: vm.awayList.length,
                    counts: [],
                    dataset: angular.copy(vm.awayList)
                }
            );
    }

    function iniTableGuest(list) {
        if (!list) {
            list = [];
        } else {
            vm.guests = [];
            for (var i = 0; i < list.data.length; i++) {
                list.data[i].dateFormatIn = moment(list.data[i].date).format('YYYY/MM/DD');
                list.data[i].dateViewIn = moment(list.data[i].date).format('DD/MM/YYYY');
                if ((list.data[i].dateFrom !== undefined) && (list.data[i].dateFrom !== '')) {
                    list.data[i].dateTimeFormatIn = moment(list.data[i].dateFrom).format('YYYY/MM/DD HH:mm');
                    list.data[i].dateTimeViewIn = moment(list.data[i].dateFrom).format('DD/MM/YYYY HH:mm');
                }
                if ((list.data[i].dateTo !== undefined) && (list.data[i].dateTo !== '')) {
                    list.data[i].dateTimeFormatOut = moment(list.data[i].dateTo).format('YYYY/MM/DD HH:mm');
                    list.data[i].dateTimeViewOut = moment(list.data[i].dateTo).format('DD/MM/YYYY HH:mm');
                }
                vm.guests.push(list.data[i]);
            }
        }
        vm.tableParamsGuest =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatIn: 'desc'
                    }
                },
                {
                    total: vm.guests.length,
                    counts: [],
                    dataset: angular.copy(vm.guests)
                }
            );
    }

    function iniTableAdmonition(list) {
        if (!list) {
            list = [];
        } else {
            vm.admonitions = [];
            for (var i = 0; i < list.data.length; i++) {
                list.data[i].dateFormat = moment(list.data[i].date).format('YYYY/MM/DD');
                list.data[i].dateView = moment(list.data[i].date).format('DD/MM/YYYY');
                if (list.data[i].modeEdit !== true) {
                    list.data[i].modeEdit = false;
                }
                vm.admonitions.push(list.data[i]);
            }
        }

        vm.tableParamsAdmonitions =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatIn: 'desc'
                    }
                },
                {
                    total: vm.admonitions.length,
                    counts: [],
                    dataset: angular.copy(vm.admonitions)
                }
            );
    }

    //country/state functions
    function ignoreDiacritics(text) {
        return _.deburr(text.toUpperCase());
    }

    vm.getCountries = function (search) {
        var availableCountries = vm.countryList;
        if (search && _.findIndex(availableCountries, {name: search}) === -1) {
            availableCountries.splice(0, 1);
            availableCountries.unshift({name: search, states: []});
        }
        return availableCountries;
    };

    vm.getStates = function (search) {
        if (vm.selectedCountry.states) {
            var availableStates = vm.selectedCountry.states.slice();
            if (search && availableStates.indexOf(search) === -1) {
                availableStates.unshift(search);
            }
            return availableStates;
        } else {
            return [];
        }
    };

    vm.selectCountryChange = function () {
        vm.resdidentaBD.contact.country = vm.selectedCountry && vm.selectedCountry.name ? vm.selectedCountry.name : '';
        if (vm.selectedCountry && vm.selectedCountry.states) {
            vm.selectedCountry.states = _.uniq(vm.selectedCountry.states);
        }
        vm.clearState();
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        $log.debug('vm.resdidentaBD.contact.country: ', vm.resdidentaBD.contact.country);
    };

    vm.selectStateChange = function () {
        vm.resdidentaBD.contact.state = vm.selectedState ? vm.selectedState : '';
        $log.debug('vm.resdidentaBD.contact.state: ', vm.resdidentaBD.contact.state);
    };

    vm.clearCountry = function () {
        if (vm.resdidentaBD.contact.country) {
            delete vm.resdidentaBD.contact.country;
            vm.clearState();
        }
        vm.selectedCountry = {};
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        $log.debug('vm.resdidentaBD.contact.country: ', vm.resdidentaBD.contact.country);
    };

    vm.clearState = function () {
        if (vm.resdidentaBD.contact.state) {
            delete vm.resdidentaBD.contact.state;
        }
        vm.selectedState = '';
        $log.debug('vm.resdidentaBD.contact.state: ', vm.resdidentaBD.contact.state);
    };
    //end country/state functions

    /** Function to clear faculty if university changes */
    vm.selectUniversityChange = function () {
        delete vm.resdidentaBD.academicdata.faculty;
    };

    vm.$onInit = function () {
        tmhDynamicLocale.set(moment.locale());
        if (vm.initialized) {
            return;
        }
        vm.getUniversities();
        vm.getFaculties();
        vm.getCarrersCollege();
        vm.timeOfDayFrom = vm.constants.awayPeriod[0];
        vm.timeOfDayTo = vm.constants.awayPeriod[0];
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        $log.debug('vm.countryList: ', vm.countryList);
        $log.debug('onintResident', vm.resident);
        vm.readonly = !(vm.resident.action && (vm.resident.action === 'edit' || vm.resident.action === 'new'));
        if (vm.resident.action === 'edit') {
            vm.resident.action = 'inEdit';
        }
        vm.residentOri._id = angular.copy(vm.resident._id);
        vm.avatar = null;
        vm.allergies = angular.copy(vm.constants.allergies);
        vm.submitted = false;
        vm.fileShowedArray = [];
        if (vm.resident._id && vm.resident.action !== 'refList') {
            vm.cont = 0;
            vm.showConfigava = false;
            vm.resdidentaBD = {
                newPass: '',
                reNewPass: ''
            };
            var selectedBar = localStorageService.get('selectedBarResidence');
            if (vm.resident._id === '0') {
                vm.resident.windowTitle = TranslationService.resident.title;
                vm.resdidentaBD.branches = (selectedBar && !selectedBar.all) ?
                    selectedBar : vm.constants.branch[0];

                vm.resdidentaBD = {
                    branches: [(selectedBar && !selectedBar.all) ?
                        selectedBar : vm.constants.branch[0]],
                    active: true,
                    allergy: {},
                    isResident: true
                };
                vm.ready = true;
                vm.resdidentaBD.identity = {
                    type: vm.constants.docType[0]
                };
                vm.resdidentaBD.allergy = {};
                vm.resdidentaBD.contact = {};
                vm.resdidentaBD.booked = {};
                vm.resdidentaBD.attacheds = [];
                vm.awayList = [];
                getSourcesSpots(vm.resdidentaBD.branches).then(function (data) {
                    if (vm.resdidentaBD.branches && vm.resdidentaBD.branches.length > 1) {
                        var branchesIndexed = _.groupBy(vm.resdidentaBD.branches, '_id');
                        var newData = _.map(data, function (element) {
                            return _.extend({}, element, {description: _.get(branchesIndexed[element.branch], '[0].description', '') + ' ' + element.description});
                        });
                        data = newData;
                    }
                    vm.listSpots = _.orderBy(data, 'description');
                });
            } else {
                vm.resident.windowTitle = TranslationService.resident.titleedit;
                ResidentsService.query({idR: vm.resident._id}, function (data) {
                    if (data && data.birthdate) {
                        data.birthdate = moment(data.birthdate).toDate();
                    }
                    if (data && data.dateContract) {
                        data.dateContract = moment(data.dateContract).toDate();
                    }
                    if (data && data.dateRegulations) {
                        data.dateRegulations = moment(data.dateRegulations).toDate();
                    }
                    if (data && data.depositReturnDate) {
                        data.depositReturnDate = moment(data.depositReturnDate).toDate();
                    }
                    vm.resdidentaBD = angular.copy(data);

                    vm.resdidentaBD.isResident = vm.resdidentaBD.hasOwnProperty('isResident') ?
                        vm.resdidentaBD.isResident : true;
                    if (!vm.resdidentaBD.identity) {
                        vm.resdidentaBD.identity = {type: vm.constants.docType[0]};
                    } else {
                        if (vm.resdidentaBD.identity && vm.resdidentaBD.identity.docType) {
                            var tpe = _.find(vm.constants.docType, function (type) {
                                return type._id === vm.resdidentaBD.identity.docType._id;
                            });
                            vm.resdidentaBD.identity.type = (tpe) ? tpe : vm.constants.docType[0];
                            vm.resdidentaBD.identity.val = vm.resdidentaBD.identity.docVal;
                            vm.resdidentaBD.identity.expDate = vm.resdidentaBD.identity.expDate ?
                                moment(vm.resdidentaBD.identity.expDate).toDate() : undefined;
                        }
                    }

                    if (vm.resdidentaBD.branches && vm.resdidentaBD.branches.length < 1) {
                        vm.resdidentaBD.branches = [{}];
                    } else {
                        vm.resdidentaBD.branches = vm.resdidentaBD.branches;
                    }
                    if (vm.resdidentaBD.allergy) {
                        if (vm.resdidentaBD.allergy.allergyTypes) {
                            _.forEach(vm.resdidentaBD.allergy.allergyTypes, function (all) {
                                _.find(vm.allergies, function (conAll) {
                                    return conAll._id === all._id;
                                }).selected = true;
                            });
                        }
                    } else {
                        vm.resdidentaBD.allergy = {};
                    }
                    if (!vm.resdidentaBD.deposit) {
                        vm.resdidentaBD.depositReturn = true;
                    }
                    //contact
                    if (!vm.resdidentaBD.contact) {
                        vm.resdidentaBD.contact = {};
                    }
                    if (vm.resdidentaBD.contact.country) {
                        vm.selectedCountry = _.find(vm.countryList, function (item) {
                            return ignoreDiacritics(item.name) === ignoreDiacritics(vm.resdidentaBD.contact.country);
                        });
                        if (vm.selectedCountry) {
                            if (vm.selectedCountry.states && vm.resdidentaBD.contact.state) {
                                vm.selectedCountry.states = _.uniq(vm.selectedCountry.states);
                                var state = _.find(vm.selectedCountry.states, function (item) {
                                    return ignoreDiacritics(item) === ignoreDiacritics(vm.resdidentaBD.contact.state);
                                });
                                vm.selectedState = state ? state : vm.resdidentaBD.contact.state;
                            } else if (!vm.selectedCountry.states && vm.resdidentaBD.contact.state) {
                                vm.selectedState = vm.resdidentaBD.contact.state;
                            } else {
                                vm.selectedState = '';
                            }
                        } else {
                            vm.selectedCountry = {name: vm.resdidentaBD.contact.country, states: []};
                            vm.selectedState = vm.resdidentaBD.contact.state ? vm.resdidentaBD.contact.state : '';
                        }
                    } else {
                        vm.selectedCountry = {};
                    }
                    //end contact
                    if (vm.resdidentaBD.photo && vm.resdidentaBD.photo.original.key) {
                        MasterTableService.get({
                            idT: routeConf.file, idJ: routeConf.signedUrl,
                            key: vm.resdidentaBD.photo.original.key,
                            bucket: vm.resdidentaBD.photo.original.bucket
                        }, function (data) {
                            vm.avatar = data.url;
                            vm.avatarOri = angular.copy(vm.avatar);
                        }, function (err) {
                            toastr.error(TranslationService.errors.e500);
                        });
                    }
                    //attacheds
                    if (!vm.resdidentaBD.attacheds) {
                        vm.resdidentaBD.attacheds = [];
                    }
                    iniTable(vm.resdidentaBD.booked);
                    var query = {client: vm.resdidentaBD._id};
                    //var query = {client: vm.resdidentaBD._id, actual: true};
                    OccupancyResident.get(query, function (data) {
                    }, function (err) {
                        $log.error('error getting absence : ', err);
                    }).$promise.then(function (data) {
                        $log.debug('get absence : ', data);
                        vm.guests = [];
                        vm.occupancies = data;
                        vm.admonitions = [];
                        iniTableAway(vm.occupancies);

                        getSourcesSpots(vm.resdidentaBD.branches).then(function (data) {
                            if (vm.resdidentaBD.branches && vm.resdidentaBD.branches.length > 1) {
                                var branchesIndexed = _.groupBy(vm.resdidentaBD.branches, '_id');
                                var newData = _.map(data, function (element) {
                                    return _.extend({}, element, {description: _.get(branchesIndexed[element.branch], '[0].description', '') + ' ' + element.description});
                                });
                                data = newData;
                            }

                            vm.listSpots = _.orderBy(data, 'description');
                            getSourcesGuestInvitations().then(function (data2) {
                                iniTableGuest(data2);
                                iniTablePaymentList(vm.paymentList);
                                getSourcesAdmonitions().then(function (data3) {
                                    iniTableAdmonition(data3);
                                    getSourcesPaymentList().then(function (data4) {
                                        iniTablePaymentList(data4);
                                        // TODO match card list of the user's
                                        vm.cardList = vm.resdidentaBD.cardList;
                                        //var userBranch = localStorageService.get('branches');
                                        //loadAllResidents((selectedBar && !selectedBar.all) ? selectedBar._id : userBranch);
                                    });
                                });
                            });
                        });

                        // Set tutors country / state
                        if (vm.resdidentaBD.tutors && vm.resdidentaBD.tutors.length > 0) {
                            _.forEach(vm.resdidentaBD.tutors, function (tutor, index) {
                                if (tutor.country) {
                                    tutor.selectedCountry = _.find(vm.countryList, function (item) {
                                        return ignoreDiacritics(item.name) === ignoreDiacritics(tutor.country);
                                    });
                                    if (tutor.selectedCountry) {
                                        if (tutor.selectedCountry.states && tutor.state) {
                                            tutor.selectedCountry.states = _.uniq(tutor.selectedCountry.states);
                                            var state = _.find(tutor.selectedCountry.states, function (item) {
                                                return ignoreDiacritics(item) === ignoreDiacritics(tutor.state);
                                            });
                                            tutor.selectedState = state ? state : tutor.state;

                                        } else if (!tutor.selectedCountry.states && tutor.state) {
                                            tutor.selectedState = tutor.state;
                                        } else {
                                            tutor.selectedState = '';
                                        }
                                    } else {
                                        tutor.selectedCountry = {name: tutor.country, states: []};
                                        tutor.selectedState = tutor.state ? tutor.state : '';
                                    }
                                } else {
                                    tutor.selectedCountry = {};
                                }
                            });
                        }
                    });

                    if (!vm.resdidentaBD.billingAccounts) {
                        vm.resdidentaBD.billingAccounts = {};
                    } else {

                        if (vm.resdidentaBD.billingAccounts.payType) {
                            vm.payType = angular.copy(vm.resdidentaBD.billingAccounts.payType);
                            vm.checkIsDefaultPayMethod();
                        }
                        if (vm.resdidentaBD.billingAccounts.bankCard && vm.resdidentaBD.billingAccounts.bankCard.expDate) {
                            vm.resdidentaBD.billingAccounts.bankCard.expDate = new Date(vm.resdidentaBD.billingAccounts.bankCard.expDate);
                        }
                    }
                    if (PermissionsService.gotPermission('BILLING', 'read')) {
                        vm.getBillings();
                    }

                }, function (err) {
                    toastr.error(TranslationService.errors.e500);
                    vm.resident = {};
                    vm.ready = true;
                });
            }
        }
        vm.initialized = true;
        setPermissions();
    };

    vm.invalidR = function (formInput) {
        var val = false;
        if (vm.resdidentaBD.branches && vm.resdidentaBD.branches.length > 0) {
            val = true;
        }
        return val;
    };

    vm.save = function (resForm) {
        if ((!vm.submitted && !resForm.$valid) || !resForm.$valid) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            var query = {
                email: _.get(vm.resdidentaBD, 'contact.email')
            };
            ResidentsService.get(query, function (data) {
                $log.debug('residents with same mail: ', data);
            }).$promise.then(function (data) {
                if (data.data && data.data.length && !_.includes(_.map(data.data, '_id'), vm.resdidentaBD._id)) {
                    toastr.error(TranslationService.errors.duplicateEmail);
                } else {
                    var sav = angular.copy(vm.resdidentaBD);
                    if (!sav.allergy) {
                        sav.allergy = {};
                    }
                    sav.allergy.allergyTypes = [];
                    _.find(vm.allergies, function (all) {
                        if (all.selected === true) {
                            sav.allergy.allergyTypes.push(all._id);
                        }
                    });
                    if (vm.resdidentaBD.identity && vm.resdidentaBD.identity.val) {
                        sav.identity = {
                            docType: vm.resdidentaBD.identity.type,
//                    docType: vm.resdidentaBD.identity.type._id,
                            docVal: vm.resdidentaBD.identity.val,
                            expDate: vm.resdidentaBD.identity.expDate ? moment(vm.resdidentaBD.identity.expDate) : undefined
                        };
                    }
                    //sav.branches = [vm.resdidentaBD.branches];
                    sav.branches = _.map(_.castArray(vm.resdidentaBD.branches), function (ba) {
                        return ba._id;
                    });
                    sav.fromDetail = true;
                    if (vm.resident._id !== '0') {
                        ResidentsService.post({idR: sav._id}, sav, function (data) {
                            toastr.success(TranslationService.dialog.saveok);
                            vm.resident = {};
                            vm.resdidentaBD = {};
                            vm.resident.action = 'refList';
                        }, function (err) {
                            $log.error('error saving resident detail: ', err);
                            if (_.get(err, 'data.error.status') === 444) {
                                toastr.error(TranslationService.errors.OCC00001);
                            } else {
                                toastr.error(TranslationService.errors.e500);
                            }
                        });
                    } else {
                        ResidentsService.post(sav, function (data) {
                            toastr.success(TranslationService.dialog.saveok);
                            vm.resident = {};
                            vm.resdidentaBD = {};
                            vm.resident.action = 'refList';
                        }, function (cleanErr) {
                            $log.error('error load reservation detail: ', cleanErr);
                            toastr.error(TranslationService.errors.e500);
                        });
                    }
                }
            });
        }
    };

    $rootScope.$on('deleteAttach', function (event, attachment) {
        _.remove(vm.resdidentaBD.attacheds, function (item) {
            if (item._id) {
                return item._id === attachment._id;
            } else {
                return item.original.key === attachment.original.key;
            }
        });
        if (!vm.resdidentaBD.attachToDelete) {
            vm.resdidentaBD.attachToDelete = [];
        }
        vm.resdidentaBD.attachToDelete.push({_id: attachment._id});
    });

    /**
     * @ngdoc method
     * @name deleteAttach
     * @methodOf Tagaste.residentDetailCom.controller:residentDetailController
     * @description
     * Method that delete an attach
     * @param attachment is object attach to delete
     */
    function deleteAttach(attachment) {
        _.remove(vm.resdidentaBD.attacheds, function (item) {
            if (item._id) {
                return item._id === attachment._id;
            } else {
                return item.original.key === attachment.original.key;
            }
        });
        if (!vm.resdidentaBD.attachToDelete) {
            vm.resdidentaBD.attachToDelete = [];
        }
        vm.resdidentaBD.attachToDelete.push({_id: attachment._id});
    }

    function getTypeFile(extension) {
        var classExtension = '';
        switch (extension) {
            case 'pdf':
                classExtension = 'pdf';
                break;
            case 'docx':
                classExtension = 'docx';
                break;
            case 'png':
            case 'jpg':
            case 'gif':
            case 'bmp':
            case 'ico':
                classExtension = 'img';
                break;
            case 'xls':
            case 'xlt':
                classExtension = 'xls';
                break;
            case 'txt':
            case 'srt':
                classExtension = 'txt';
                break;
            case 'zip':
            case 'rar':
            case '7z':
                classExtension = 'rar';
                break;
            case 'avi':
            case 'mpeg':
            case 'mp4':
            case 'asf':
                classExtension = 'video';
                break;
            case 'mp3':
            case 'ra':
            case 'wav':
                classExtension = 'audio';
                break;
        }

        return classExtension;
    }

    vm.openLightboxModal = function (file) {
        var nameSplitted = file.filename.split('.');
        file.extension = nameSplitted.pop();
        var extension = getTypeFile(file.extension);
        var urlDownload = '';
        MasterTableService.get({
            idT: routeConf.file, idJ: routeConf.signedUrl, key: file.original.key,
            bucket: file.original.bucket
        }, function (data) {
            file.url = data.url;
            file.type = extension;
            urlDownload = data.url;
            if (extension === 'img' || extension === 'video') {
                var index = _.findIndex(vm.filesAux, {'_id': file._id});
                if (index < 0) {
                    vm.filesAux.push(file);
                    index = vm.filesAux.length - 1;
                }
                Lightbox.openModal(vm.filesAux, index);
            } else if (extension === 'pdf') {
                $window.open(file.url);
            } else {
                var config = {responseType: 'blob'};
                $http.get(file.url, config).then(function (response) {
                    $log.debug('response', response);
                    var data = response.data;
                    FileSaver.saveAs(data, file.filename, true);
                }).catch(function (response) {
                    $log.error(response.message);
                    toastr.error(response.message, TranslationService.warning,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }, function (err) {
            $log.debug('error load attached file', err);
        });
    };

    vm.checkDates = function () {
        vm.birthdate = moment(vm.resdidentaBD.birthdate);
        return vm.birthdate && moment(vm.birthdate).endOf('day').isAfter(moment().endOf('day'));
    };

    vm.back = function () {
        vm.anim = false;
        vm.showPayment = false;
        vm.appUsers = {};
        vm.resident = {};
    };

    $rootScope.$on('closeResidentDetail', function () {
        vm.back();
    });

    function iniTableHistoryMenu(list) {
        if (!list) {
            list = [];
        } else {
            vm.awayList = [];
            for (var i = 0; i < list.data.length; i++) {
                for (var j = 0; j < list.data[i].awayList.length; j++) {
                    list.data[i].awayList[j].dateFormatFrom = moment(list.data[i].awayList[j].dateFrom).format('YYYY/MM/DD');
                    list.data[i].awayList[j].dateViewFrom = moment(list.data[i].awayList[j].dateFrom).format('DD/MM/YYYY');
                    list.data[i].awayList[j].dateFormatTo = moment(list.data[i].awayList[j].dateTo).format('YYYY/MM/DD');
                    list.data[i].awayList[j].dateViewTo = moment(list.data[i].awayList[j].dateTo).format('DD/MM/YYYY');
                    _.forEach(vm.constants.awayPeriod, function (item) {
                        if (list.data[i].awayList[j].periodFrom === item._id) {
                            list.data[i].awayList[j].timeOfDayFrom = item;
                        }
                        if (list.data[i].awayList[j].periodTo === item._id) {
                            list.data[i].awayList[j].timeOfDayTo = item;
                        }
                    });
                    list.data[i].awayList[j].idOccupancy = list.data[i]._id;
                    vm.awayList.push(list.data[i].awayList[j]);
                }
            }
        }
        vm.tableParamsAway =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatFrom: 'desc'
                    }
                },
                {
                    total: vm.awayList.length,
                    counts: [],
                    dataset: angular.copy(vm.awayList)
                }
            );
    }

    function getSourcesHistoryMenu(queryOffset, list) {
        return new Promise(function (full, reject) {
            list = (list) ? list : [];
            var query = (queryOffset) ? {idR: vm.resdidentaBD._id, offset: queryOffset, limit: vm.historyMenuLimit}
                : {idR: vm.resdidentaBD._id, limit: vm.historyMenuLimit};
            query.dateFrom = vm.dateFrom;
            HistoryMenu.get(query, function (data) {
                $log.debug('Load HistoryMenu list: ', data);
            }, function (err) {
                $log.error('error getting HistoryMenu: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                return list;
            }).$promise.then(function (data) {
                list = _.concat(list, data.data);
                if (data.total) {
                    vm.historyMenuTotal = data.total;
                }
                full(list);
            });
        });
    }

    function getSourcesHistoryActivities(queryOffset, list) {
        return new Promise(function (full, reject) {
            list = (list) ? list : [];
            var query = (queryOffset) ? {
                    idR: vm.resdidentaBD._id,
                    offset: queryOffset,
                    limit: vm.historyActivitiesLimit
                }
                : {idR: vm.resdidentaBD._id, limit: vm.historyActivitiesLimit};
            query.dateFrom = vm.dateFrom;
            HistoryAgenda.get(query, function (data) {
                $log.debug('Load HistoryActivities list: ', data);
            }, function (err) {
                $log.error('error getting HistoryActivities: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                return list;
            }).$promise.then(function (data) {
                list = _.concat(list, data.data);
                if (data.total) {
                    vm.historyActivitiesTotal = data.total;
                }
                full(list);
            });
        });
    }

    function getSourcesHistoryServices(queryOffset, list) {
        return new Promise(function (full, reject) {
            list = (list) ? list : [];
            var query = (queryOffset) ? {idR: vm.resdidentaBD._id, offset: queryOffset, limit: vm.historyServicesLimit}
                : {idR: vm.resdidentaBD._id, limit: vm.historyServicesLimit};
            query.dateFrom = vm.dateFrom;
            HistoryService.get(query, function (data) {
                $log.debug('Load HistoryServices list: ', data);
            }, function (err) {
                $log.error('error getting HistoryServices: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                return list;
            }).$promise.then(function (data) {
                list = _.concat(list, data.data);
                if (data.total) {
                    vm.historyServicesTotal = data.total;
                }
                full(list);
            });
        });
    }

    function getSourcesHistoryIncidents(queryOffset, list) {
        return new Promise(function (full, reject) {
            list = (list) ? list : [];
            var query = (queryOffset) ? {idR: vm.resdidentaBD._id, offset: queryOffset, limit: vm.historyIncidentsLimit}
                : {idR: vm.resdidentaBD._id, limit: vm.historyIncidentsLimit};
            query.dateFrom = vm.dateFrom;
            HistoryIncident.get(query, function (data) {
                $log.debug('Load HistoryIncidents list: ', data);
            }, function (err) {
                $log.error('error getting HistoryIncidents: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                return list;
            }).$promise.then(function (data) {
                list = _.concat(list, data.data);
                if (data.total) {
                    vm.historyIncidentsTotal = data.total;
                }
                full(list);
            });
        });
    }

    vm.openHistory = function () {
        getSourcesHistoryMenu().then(function (data) {
            vm.historyMenu = data;
        });
    };

    vm.changeTabHistoryType = function (typ) {
        vm.TabHistoryMenu = false;
        vm.TabHistoryActivities = false;
        vm.TabHistoryServices = false;
        vm.TabHistoryIncidents = false;
        switch (typ) {
            case 'TabHistoryMenu':
                vm.TabHistoryMenu = true;
                vm.historyMenu = undefined;
                getSourcesHistoryMenu().then(function (data) {
                    $scope.$apply(function () {
                        vm.historyMenu = data;
                    });
                });
                break;
            case 'TabHistoryActivities':
                vm.TabHistoryActivities = true;
                this.historyActivities = undefined;
                getSourcesHistoryActivities().then(function (data) {
                    $scope.$apply(function () {
                        vm.historyActivities = data;
                    });
                });
                break;
            case 'TabHistoryServices':
                vm.TabHistoryServices = true;
                vm.historyMenu = undefined;
                getSourcesHistoryServices().then(function (data) {
                    $scope.$apply(function () {
                        vm.historyServices = _.orderBy(data, ['dateFrom'], ['desc']);
                    });
                });
                break;
            case 'TabHistoryIncidents':
                vm.TabHistoryIncidents = true;
                vm.historyIncidents = undefined;
                getSourcesHistoryIncidents().then(function (data) {
                    $scope.$apply(function () {
                        vm.historyIncidents = data;
                    });

                });
                break;
        }
    };

    vm.addMoreHistoryMenu = function () {
        if ((vm.historyopen === false) || (vm.historyMenu.length >= vm.historyMenuTotal)) {
            return;
        }
        getSourcesHistoryMenu(vm.historyMenu.length, vm.historyMenu).then(function (data) {
            vm.historyMenu = data;
        });
    };

    vm.addMoreHistoryActivities = function () {
        if ((vm.historyopen === false) || (vm.historyActivities.length >= vm.historyActivitiesTotal)) {
            return;
        }
        getSourcesHistoryActivities(vm.historyActivities.length, vm.historyActivities).then(function (data) {
            vm.historyActivities = data;
        });
    };

    vm.addMoreHistoryServices = function () {
        if ((vm.historyopen === false) || (vm.historyServices.length >= vm.historyServicesTotal)) {
            return;
        }
        getSourcesHistoryServices(vm.historyServices.length, vm.historyServices).then(function (data) {
            vm.historyServices = _.orderBy(data, ['dateFrom'], ['desc']);
        });
    };

    vm.addMoreHistoryIncidents = function () {
        if ((vm.historyopen === false) || (vm.historyIncidents.length >= vm.historyIncidentsTotal)) {
            return;
        }
        getSourcesHistoryIncidents(vm.historyIncidents.length, vm.historyIncidents).then(function (data) {
            vm.historyIncidents = data;
        });
    };

    vm.doPayment = function () {
        vm.showPayment = true;
    };

    /** Function to add new tutor **/
    vm.addTutor = function (event) {
        event.preventDefault();
        if (vm.resdidentaBD.tutors) {
            this.resdidentaBD.tutors.push({});
        } else {
            this.resdidentaBD.tutors = [{}];
        }
    };

    /** Function to remove tutor **/
    vm.removeTutor = function (index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {

            if (result.value) {
                _.pullAt(vm.resdidentaBD.tutors, index);
            }
        });
    };

    /** Function to get universities **/
    vm.getUniversities = function () {
        ConfigService.query({
            functionality: 'universities'
        }, function (data) {
            vm.universities = data;
        }, function (err) {
            $log.error('[residentDetail] getUniversities error: ', err);
        });
    };

    /** Function to get faculties **/
    vm.getFaculties = function () {
        ConfigService.query({
            functionality: 'faculties'
        }, function (data) {
            vm.faculties = data;
        }, function (err) {
            $log.error('[residentDetail] getFaculties error: ', err);
        });
    };

    /** Function to get faculties **/
    vm.getCarrersCollege = function () {
        ConfigService.query({
            functionality: 'studies'
        }, function (data) {
            vm.studies = data;
        }, function (err) {
            $log.error('[residentDetail] get carrersCollege error: ', err);
        });
    };


    // TUTORS Functions

    /** Function to get states list */
    vm.getTutorStates = function (search, index) {
        if (vm.resdidentaBD.tutors[index].selectedCountry) {
            if (vm.resdidentaBD.tutors[index].selectedCountry.states) {
                var availableStates = vm.resdidentaBD.tutors[index].selectedCountry.states.slice();
                if (search && availableStates.indexOf(search) === -1) {
                    availableStates.unshift(search);
                }
                availableStates = angular.copy(_.uniqBy(availableStates));
                return availableStates;
            } else {
                return [];
            }
        } else {
            vm.resdidentaBD.tutors[index].selectedCountry = {};
            return [];
        }
    };

    vm.selectCountryChangeTutor = function (index) {
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        // vm.resdidentaBD.tutors[index].selectedCountry = _.uniqBy(vm.);
        vm.resdidentaBD.tutors[index].country = vm.resdidentaBD.tutors[index].selectedCountry && vm.resdidentaBD.tutors[index].selectedCountry.name ?
            vm.resdidentaBD.tutors[index].selectedCountry.name : '';

        if (vm.resdidentaBD.tutors[index].selectedCountry && vm.resdidentaBD.tutors[index].states) {
            vm.resdidentaBD.tutors[index].states = _.uniq(vm.resdidentaBD.tutors[index].states);
        }

        vm.clearTutorState(index);
        //rqdc.requestBD.user.tutors[$index].country;
        $log.debug(vm.resdidentaBD.tutors[index].country);

    };

    vm.selectStateChangeTutor = function (index) {
        vm.resdidentaBD.tutors[index].state = vm.resdidentaBD.tutors[index].selectedState ? vm.resdidentaBD.tutors[index].selectedState : '';
    };

    /** Function to clear resident country select */
    vm.clearTutorCountry = function (index) {
        if (vm.resdidentaBD.tutors[index].country) {
            delete vm.resdidentaBD.tutors[index].country;
            vm.clearTutorState(index);
        }
        //vm.selectedCountry = {};
        //vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
    };

    /** Function to clear resident state select */
    vm.clearTutorState = function (index) {
        if (vm.resdidentaBD.tutors[index].state) {
            delete vm.resdidentaBD.tutors[index].state;
        }
        vm.resdidentaBD.tutors[index].selectedState = '';
    };

    /** Create resident remaining occupancy concepts */
    function generateOccupancyConcepts() {
        return new Promise(function (full, reject) {
            ConceptService.post({idR: 'occupancy'}, {_id: vm.resdidentaBD._id}, function (data) {
                $log.debug('[residentDetail] generateOccupancyConcepts data: ', data);
                full(data);
            }, function (err) {
                $log.error('[residentDetail] generateOccupancyConcepts error: ', err);
                full({});
            });
        });
    }

    /** Get Billings */
    vm.getBillings = function () {
        generateOccupancyConcepts().then(function (result) {
            BillingService.get({client: vm.resdidentaBD._id}, function (data) {
                $log.debug('Billings data: ', data);
                _.forEach(data.data, function (item) {
                    item.isPaid = !!item.payDate;
                });
                iniTableBillings(data.data);
            });
        });
    };

    /** Go to selected billing detail */
    vm.goDetailBilling = function (billing) {
        $state.go(state.billing);
        setTimeout(function () {
            $rootScope.$emit('openBillingDetail', billing);
        }, 1000);
    };
}

angular
    .module('BlurAdmin.residentDetailCom')
    .component('residentDetail', {
        templateUrl: 'app/components/residents/residentDetail/residentDetail.html',
        controllerAs: 'rdetc',  //stands for 'User List Component'
        controller: ResidentDetailController,
        bindings: {
            resident: '=',
            anim: '=',
            constants: '=',
            level: '@',
            istour: '<',
            showPayment: '='
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */

ResidentListController.$inject = ['NgTableParams', '$routeParams', 'NgTableFilterService', '$timeout',
    'TranslationService', 'ResidentsService', 'toastr', '$log', 'TourService',
    '$rootScope', 'PermissionsService', '$filter', 'localStorageService', 'ResidentExportService', 'FileSaver',
    '$location', '$scope'];

function ResidentListController(NgTableParams, $routeParams, NgTableFilterService, $timeout,
                                TranslationService, ResidentsService, toastr, $log, TourService,
                                $rootScope, PermissionsService, $filter, localStorageService, ResidentExportService, FileSaver,
                                $location, $scope) {
    var vm = this;

    vm.tableParams = {};
    vm.selectu = {};
    vm.anim = false;
    vm.initialized = false;
    vm.gotAccessMod = false;
    vm.gotAccessDel = false;
    vm.filteropen = false;
    vm.isVirtual = 'all';
    vm.isActive = true;

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('RESIDENT', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('RESIDENT', 'delete');
    }

    var viewParams = localStorageService.get('residentsViewParams') ?
        localStorageService.get('residentsViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = {filterResidentsList: {residenceDesc: selectedBar.description}};
    }

    // $rootScope.$on('selectedBarBranChanged', function (event, data) {
    //     viewParams = {
    //         filterResidentsList: {residenceDesc: (!data.all) ? data.description : ''}
    //     };
    //     iniTable(vm.list);
    // });
    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/residents') {
            viewParams = {
                filterResidentsList: {residenceDesc: (!data.all) ? data.description : ''}
            };
            iniTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);


    vm.$onInit = function () {
        if (vm.initialized) {
            return;
        }
        setPermissions();


        if (vm.listOri === null) {
            vm.listOri = angular.copy(vm.list);
        }
        vm.anim = false;
        vm.selectu = {};

        vm.tableParams = null;

        getSources();
    };

    vm.$onDestroy = function () {
        localStorageService.set('residentsViewParams', null);
    };

    vm.$doCheck = function () {
        if (vm.selectu && vm.selectu.action === 'refList') {
            vm.initialized = false;
            vm.$onInit();
        }
    };

    function getSources(queryOffset, list) {
        list = (list) ? list : [];
        var query = (queryOffset) ? {offset: queryOffset, virtual: vm.isVirtual, active: vm.isActive}
            : {virtual: vm.isVirtual, active: vm.isActive};
        ResidentsService.get(query, function (data) {
            $log.debug('load residents: ', data);
        }).$promise.then(function (data) {
            list = _.concat(list, data.data);
            if (list.length > 0) {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
            }
            if (data.total) {
                getSources(list.length, list);
            } else {
                setSourceFormating(list);
                iniTable(list);
                vm.initialized = true;
                vm.list = list;
                return list;
            }
        });
    }

    function setSourceFormating(source) {
        _.result(_.forEach(source, function (resident) {
            resident.residenceDesc =
                _.map(resident.branches, function (res) {
                    return res.description;
                }).toString();
            resident.nameLastname = resident.name + ' ' + resident.surname;
        }));
    }

    function iniTable(list) {
        if (!list) {
            list = [];
        }

        vm.currentCouse = moment().month() >= 8 ? moment().year() + '/' + (moment().year() + 1) :
            (moment().year() - 1) + '/' + moment().year();

        //add all residenceDesc
        for (var i = 0; i < list.length; i++) {
            list[i].residenceDesc = '';
            for (var j = 0; j < list[i].branches.length; j++) {
                list[i].residenceDesc += _.isEmpty(list[i].residenceDesc) ? list[i].branches[j].description : ', ' +
                    list[i].branches[j].description;
            }
            list[i].dateFormatFrom = moment(list[i].dateFrom).format();
            list[i].dateFormatTo = moment(list[i].dateTo).format();

            // old resident check
            list[i]['oldResident'] = _.get(list[i], 'oldReservations', []).length && _.get(list[i], 'oldReservations', []).length > 1 ?
                _.find(list[i]['oldReservations'], function (reservation) {
                    return _.get(reservation, 'course') && _.get(reservation, 'course') !== vm.currentCouse;
                }) : false;
        }

        var sorting = viewParams['sortingResidentsList'] ? viewParams['sortingResidentsList'] : {room: 'asc'};
        var page = viewParams['pageResidentsList'] ? viewParams['pageResidentsList'] : 1;
        var count = viewParams['countResidentsList'] ? viewParams['countResidentsList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingResidentsList'] = params._params.sorting;
                        viewParams['pageResidentsList'] = page;
                        viewParams['countResidentsList'] = params._params.count;
                        viewParams['filterResidentsList'] = filterObj;
                        localStorageService.set('residentsViewParams', viewParams);
                        vm.currentTableData = filteredData;

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterResidentsList'] ? viewParams['filterResidentsList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    vm.backifModifOrNew = function () {
        if (vm.selectu && (vm.selectu.action === 'inEdit' || vm.selectu._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        }
    };

    vm.tableParamsCK = function (row) {
        if (vm.istour) {
            return;
        }
        if (vm.selectu && (vm.selectu.action === 'inEdit' || vm.selectu._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 281);
            }
            _.forEach(_.get(vm.tableParams, 'data', []), function (r) {
                r.selected = (r._id === row._id);
            });
            vm.selectu = row;
        }
    };

    vm.tableParamsdblCK = function (row) {
        vm.selectu = angular.copy(row);
    };

    vm.filterNameLastname = {
        nameLastname: {
            id: 'text'
        }
    };

    vm.filterName = {
        name: {
            id: 'text'
        }
    };

    vm.filterRoom = {
        room: {
            id: 'text'
        }
    };

    vm.filterLastname = {
        surname: {
            id: 'text'
        }
    };
    vm.filterAlias = {
        nick: {
            id: 'text'
        }
    };
    vm.filterRoom = {
        room: {
            id: 'text'
        }
    };
    vm.filterApp = {
        app: {
            id: 'text'
        }
    };

    vm.filterResidenceDesc = {
        residenceDesc: {
            id: 'text'
        }
    };

    vm.new = function () {
        vm.selectu = {
            _id: '0'
        };
        vm.selectu.action = 'new';

        _.forEach(vm.tableParams.data, function (r) {
            r.selected = false;
        });

        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 417);
        }
    };


    vm.editRow = function (row) {
        vm.tableParamsCK(row);
        row.action = 'edit';
    };

    vm.deleteRow = function (row) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ResidentsService.delete({idR: row._id}, function (data) {
                    vm.$onInit();
                    toastr.success(TranslationService.modal.deleteItemOk);
                    getSources();
                }, function (err) {
                    $log.error('ResidentsService delete error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };


    vm.exportData = function () {
        var filename = TranslationService.residentlist.title.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = TranslationService.residentlist.export;

        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function (e) {
                return e.id;
            }),
            filename: filename,
        };

        ResidentExportService.post(
            {}, requestData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('ResidentsService export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
    };

    vm.changeFilter = function () {
        getSources();
    };

    $rootScope.$on('openResidentDetail', function () {
        vm.avatarUploading = false;
        vm.istour = true;
        vm.new();
    });
}

angular
    .module('BlurAdmin.residentsListCom')
    .component('residentsList', {
        templateUrl: 'app/components/residents/residentsList/residentsList.html',
        controllerAs: 'rlstc',  //stands for 'User List Component'
        controller: ResidentListController,
        bindings: {
            selectu: '=',
            list: '=',
            pag: '<',
            anim: '=',
            constants: '=',
            initTour: '&',
            tourDummyData: '=',
            istour: '<'
        }
    });

RequestDetailController.$inject = ['toastr', 'TranslationService', 'RequestService', '$uibModal', 'serviceConf',
    'MasterTableService', 'routeConf', '$log', 'NgTableFilterService', 'ConceptService', 'BillingService',
    '$rootScope', 'ValidationService', 'PermissionsService', 'CountryList', 'tmhDynamicLocale',
    'NgTableParams', 'localStorageService', 'Lightbox', '$http', '$window', 'FileSaver', '$scope',
    'ResidentsService', 'ConfigService', 'RequestAcceptService'];

function RequestDetailController(toastr, TranslationService, RequestService, $uibModal, serviceConf,
                                 MasterTableService, routeConf, $log, NgTableFilterService, ConceptService, BillingService,
                                 $rootScope, ValidationService, PermissionsService, CountryList, tmhDynamicLocale,
                                 NgTableParams, localStorageService, Lightbox, $http, $window, FileSaver, $scope,
                                 ResidentsService, ConfigService, RequestAcceptService) {
    var vm = this;
    vm.lodash = _;
    vm.windowTitle = TranslationService.requests.detail.header;
    vm.moment = moment;
    vm.requestBD = {};
    vm.avatar = '';
    vm.avatarOri = '';
    vm.cont = 0;
    vm.selectedCountry = {};
    vm.selectedState = '';
    vm.readonly = true;
    vm.addingContact = false;
    vm.tabActive = 0;
    vm.depositPaid = false;
    vm.tuitionPaid = false;
    vm.roomTypes = [];
    vm.tuitionInvoice = {};
    vm.depositInvoice = {};
    vm.tuitionPaid = false;

    vm.selectedBillingDataCountry = {};
    vm.selectedBillingDataState = '';
    vm.showPayerTutorSelect = false;

    // Temporal variable to select existing tutor
    vm.selectedPayerTutor = {};

    vm.dateOptionsFromExpCard = {
        minDate: moment().toDate(),
        showWeeks: false
    };

    /** Function to set window permissions */
    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('APPLICATION', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('APPLICATION', 'delete');
    }

    /** Function to change request branch */
    vm.changeRequestBranch = function () {
        vm.requestBD.spot = undefined;
        getSourcesSpots(vm.requestBD.branch).then(function (data) {
            vm.listSpots = data;
        });
        vm.getRoomTypes();
    };

    vm.getRoomTypes = function () {
        var roomTypesTmp = [];
        vm.roomTypes = [];
        if (vm.requestBD.branch) {
            _.forEach(vm.constants.roomType, function (rt) {
                // Si la habitación esta en todas las residencias
                if (!rt.branches.length) {
                    roomTypesTmp.push(rt);
                } else {
                    if (_.find(rt.branches, {_id: vm.requestBD.branch._id})) {
                        roomTypesTmp.push(rt);
                    }
                }
            });
            vm.roomTypes = _.uniqBy(_.flatMap(roomTypesTmp), '_id');
        } else {
            vm.roomTypes = [];
        }

    };

    $rootScope.$on('deleteAttach', function (event, attachment) {
        if (vm.requestBD.user.attacheds) {
            _.remove(vm.requestBD.user.attacheds, function (item) {
                if (item._id) {
                    return item._id === attachment._id;
                } else {
                    return item.original.key === attachment.original.key;
                }
            });
            if (!vm.requestBD.user.attachToDelete) {
                vm.requestBD.user.attachToDelete = [];
            }
            vm.requestBD.user.attachToDelete.push({_id: attachment._id});
        }
    });

    /** Function to add new contact row */
    vm.addContact = function (contact) {
        vm.addingContact = true;
        vm.contactsTableParams.settings().dataset.unshift({
            date: new Date(),
            type: null,
            professional: '',
            comment: '',
            modeEdit: true
        });
        vm.contactsTableParams.sorting({});
        vm.contactsTableParams.page(1);
        vm.contactsTableParams.reload();
    };

    /** Function to enter edit mode contact */
    vm.editContact = function (contact, index) {
        if (index !== 0 || contact._id) {
            vm.tempContact = angular.copy(contact);
        }
        contact.modeEdit = true;
        contact.date = moment(contact.date).toDate();

        vm.temporalContact = angular.copy(contact);
    };

    /** Function to cancel (Edit / New) contact */
    vm.cancelContact = function (contact, index) {
        contact.modeEdit = false;

        if (index === 0 && !contact._id) {
            _.remove(vm.contactsTableParams.settings().dataset, function (item) {
                return contact === item;
            });
        } else {
            vm.contactsTableParams.data[index] = vm.tempContact;
        }
        if (vm.addingContact) {
            vm.contactsTableParams.reload();
            vm.addingContact = false;
        }
        vm.addingContact = false;
    };

    /** Function to accept contact row (new/edit) */
    vm.saveContact = function (contact, index) {
        contact.modeEdit = false;
        if (vm.addingContact) {
            vm.contacts.push(contact);
        } else {
            vm.contactsTableParams.data[index] = contact;
            vm.contacts = vm.contactsTableParams.data;
        }
        iniContactsTable(vm.contacts);
        vm.contactsTableParams.reload();
        vm.addingContact = false;
    };

    /** Function to delete contact row */
    vm.deleteContact = function (contact, index) {
        _.pullAt(vm.contacts, index);
        iniContactsTable(vm.contacts);
        vm.contactsTableParams.reload();
    };

    var viewParams = localStorageService.get('visitsViewParams') ?
        localStorageService.get('visitsViewParams') : {};

    //country/state functions
    function ignoreDiacritics(text) {
        return _.deburr(text.toUpperCase());
    }

    /** Function to get countries list */
    vm.getCountries = function (search) {
        var availableCountries = vm.countryList;
        if (search && _.findIndex(availableCountries, {name: search}) === -1) {
            availableCountries.splice(0, 1);
            availableCountries.unshift({name: search, states: []});
        }
        return availableCountries;
    };

    /** Function to get states list */
    vm.getStates = function (search) {
        if (vm.selectedCountry.states) {
            var availableStates = vm.selectedCountry.states.slice();
            if (search && availableStates.indexOf(search) === -1) {
                availableStates.unshift(search);
            }
            return availableStates;
        } else {
            return [];
        }
    };

    /** Function to get states list */
    vm.getBillingDataStates = function (search) {
        if (vm.selectedBillingDataCountry.states) {
            var availableBillingStates = vm.selectedBillingDataCountry.states.slice();
            if (search && availableBillingStates.indexOf(search) === -1) {
                availableBillingStates.unshift(search);
            }
            return availableBillingStates;
        } else {
            return [];
        }
    };

    /** Function to get states list */
    vm.getTutorStates = function (search, index) {
        if (vm.requestBD.user.tutors[index].selectedCountry) {
            if (vm.requestBD.user.tutors[index].selectedCountry.states) {
                var availableStates = vm.requestBD.user.tutors[index].selectedCountry.states.slice();
                if (search && availableStates.indexOf(search) === -1) {
                    availableStates.unshift(search);
                }
                availableStates = angular.copy(_.uniqBy(availableStates));
                return availableStates;
            } else {
                return [];
            }
        } else {
            vm.requestBD.user.tutors[index].selectedCountry = {};
            return [];
        }
    };

    /** Function for resident country select */
    vm.selectCountryChange = function () {
        vm.requestBD.user.contact.country = vm.selectedCountry && vm.selectedCountry.name ? vm.selectedCountry.name : '';
        if (vm.selectedCountry && vm.selectedCountry.states) {
            vm.selectedCountry.states = _.uniq(vm.selectedCountry.states);
        }
        vm.clearState();
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        $log.debug('vm.requestBD.user.contact.country: ', vm.requestBD.user.contact.country);
    };

    /** Function for billing country select */
    vm.selectBillingCountryChange = function () {
        vm.requestBD.billingData.country = vm.selectedBillingDataCountry && vm.selectedBillingDataCountry.name ? vm.selectedBillingDataCountry.name : '';
        if (vm.selectedBillingDataCountry && vm.selectedBillingDataCountry.states) {
            vm.selectedBillingDataCountry.states = _.uniq(vm.selectedBillingDataCountry.states);
        }
        vm.clearBillingState();
        vm.billingCountryList = angular.copy(_.uniqBy(CountryList, 'name'));
    };

    vm.selectCountryChangeTutor = function (index) {
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        // vm.requestBD.user.tutors[index].selectedCountry = _.uniqBy(vm.);
        vm.requestBD.user.tutors[index].country = vm.requestBD.user.tutors[index].selectedCountry && vm.requestBD.user.tutors[index].selectedCountry.name ?
            vm.requestBD.user.tutors[index].selectedCountry.name : '';

        if (vm.requestBD.user.tutors[index].selectedCountry && vm.requestBD.user.tutors[index].states) {
            vm.requestBD.user.tutors[index].states = _.uniq(vm.requestBD.user.tutors[index].states);
        }

        vm.clearTutorState(index);
    };

    /** Function to clear faculty if university changes */
    vm.selectUniversityChange = function () {
        delete vm.requestBD.user.academicdata.faculty;
    };

    /** Function for resident state select */
    vm.selectStateChange = function () {
        vm.requestBD.user.contact.state = vm.selectedState ? vm.selectedState : '';
    };

    /** Function for resident state select */
    vm.selectBillingDataStateChange = function () {
        vm.requestBD.billingData.state = vm.selectedBillingDataState ? vm.selectedBillingDataState : '';
    };

    vm.selectStateChangeTutor = function (index) {
        vm.requestBD.user.tutors[index].state = vm.requestBD.user.tutors[index].selectedState ? vm.requestBD.user.tutors[index].selectedState : '';
    };

    /** Function to clear resident country select */
    vm.clearCountry = function () {
        if (vm.requestBD.user.contact.country) {
            delete vm.requestBD.user.contact.country;
            vm.clearState();
        }
        vm.selectedCountry = {};
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
    };

    /** Function to clear resident country select */
    vm.clearBillingCountry = function () {
        if (vm.requestBD.billingData.country) {
            delete vm.requestBD.billingData.country;
            vm.clearBillingState();
        }
        vm.selectedBillingDataCountry = {};
        vm.countryBillingList = angular.copy(_.uniqBy(CountryList, 'name'));
    };

    /** Function to clear resident state select */
    vm.clearState = function () {
        if (vm.requestBD.user.contact.state) {
            delete vm.requestBD.user.contact.state;
        }
        vm.selectedState = '';
    };

    /** Function to clear resident state select */
    vm.clearBillingState = function () {
        if (vm.requestBD.billingData.state) {
            delete vm.requestBD.billingData.state;
        }
        vm.selectedBillingDataState = '';
    };

    /** Function to clear resident country select */
    vm.clearTutorCountry = function (index) {
        if (vm.requestBD.user.tutors[index].country) {
            delete vm.requestBD.user.tutors[index].country;
            vm.clearTutorState(index);
        }
    };

    /** Function to clear resident state select */
    vm.clearTutorState = function (index) {
        if (vm.requestBD.user.tutors[index].state) {
            delete vm.requestBD.user.tutors[index].state;
        }
        vm.requestBD.user.tutors[index].selectedState = '';
    };

    /** Change resident identification type (DNI, NIF, NIE) */
    vm.changeTypeIde = function (type) {
        if (vm.readonly) {
            return;
        }
        vm.cont += 1;
        if (vm.cont < vm.constants.docType.length) {
            vm.requestBD.user.identity.type = vm.constants.docType[vm.cont];
        } else {
            vm.cont = 0;
            vm.requestBD.user.identity.type = vm.constants.docType[0];
        }
    };

    /** Function to change billing identification type (DNI, NIF, NIE)*/
    vm.changeTypeIdeBilling = function (type) {
        if (vm.readonly) {
            return;
        }
        vm.cont += 1;
        if (vm.cont < vm.constants.docType.length) {
            vm.requestBD.billingData.identity.docType = vm.constants.docType[vm.cont];
        } else {
            vm.cont = 0;
            vm.requestBD.billingData.identity.docType = vm.constants.docType[0];
        }
    };

    vm.checkDates = function () {
        return vm.requestBD.modalityData && vm.requestBD.modalityData.dateTo && vm.requestBD.modalityData.dateFrom &&
            moment(vm.requestBD.modalityData.dateFrom).isAfter(moment(vm.requestBD.modalityData.dateTo));
    };

    vm.checkBirthDate = function () {
        var birthdate = _.get(vm.requestBD, 'user.birthdate') ? moment(vm.requestBD.user.birthdate) : null;
        var check = birthdate && moment(birthdate).endOf('day').isAfter(moment().endOf('day'));
        vm.validBirthdate = check;
        return check;
    };

    vm.validDNI = function (input, type, formInput) {
        var valid = true;
        if (input !== '') {
            if (type !== 'PAS') {
                valid = ValidationService.validDniNie(input, type);
            }
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validEmail = function (emailField, formInput) {
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,4})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (!emailField || formInput.$pristine || (!formInput.required && emailField === '')) {
            valid = true;
        } else {
            valid = reg.test(emailField);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };


    vm.validateMobile = function (mobile, formInput) {
        var valid = true;
        if (!formInput.$pristine && mobile !== '') {
            valid = ValidationService.validMobile(mobile);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validSwift = function (input, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            valid = ValidationService.validSwift(input);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.validIban = function (input, formInput) {
        var valid = true;
        if (!formInput.$pristine && input !== '') {
            valid = ValidationService.validIban(input);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    /** Function to set type document tutor dont have identity document **/
    vm.setTutorDocType = function (index) {
        if (!vm.requestBD.user.tutors[index].identity) {
            vm.requestBD.user.tutors[index].identity = {docType: vm.constants.docType[0]};
        }
    };

    /** Function to change Document Type of tutors **/
    vm.changeTypeDocTutor = function (index) {
        if (vm.readonly) {
            return;
        }

        if (vm.requestBD.user.tutors[index].identity) {
            var docTypeIndex = vm.constants.docType.indexOf(vm.requestBD.user.tutors[index].identity.docType);

            if (docTypeIndex !== -1 && docTypeIndex < vm.constants.docType.length - 1) {
                vm.requestBD.user.tutors[index].identity.docType = vm.constants.docType[docTypeIndex + 1];
            } else {
                vm.requestBD.user.tutors[index].identity.docType = vm.constants.docType[0];
            }
        } else {
            vm.requestBD.user.tutors[index].identity = {docType: vm.constants.docType[0]};
        }

    };

    /** Function to delete visit row */
    vm.deleteVisit = function (row) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                _.pullAt(vm.requestBD.visitData, _.findIndex(vm.requestBD.visitData, row));
                iniVisitTable(vm.requestBD.visitData);
                $scope.$digest();
            }
        });
    };

    /** Function to open visit modal detail */
    vm.openVisitDetail = function (data, readOnly) {
        if (!data.error) {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/modal/modalRequestVisit/modalRequestVisit.html',
                controller: 'ModalRequestVisitController',
                controllerAs: 'mrvc',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    spots: function () {
                        return vm.listSpots;
                    },
                    constants: function () {
                        return vm.constants;
                    },
                    modalBinding: function () {
                        return data;
                    },
                    index: function () {
                        return _.findIndex(vm.requestBD.visitData, data);
                    },
                    readOnly: function () {
                        return readOnly;
                    }
                }
            });
            // Function when open modal
            modalInstance.result.then(function (result) {
                //close function
                if (result.index || result.index === 0) {
                    vm.requestBD.visitData[result.index] = result;
                } else {
                    if (!vm.requestBD.visitData) {
                        vm.requestBD.visitData = [];
                    }
                    vm.requestBD.visitData.push(result);
                }
                iniVisitTable(vm.requestBD.visitData);
            }, function (closemsg) {
                //dismiss function
                $log.debug('Closemsg:', closemsg);
            });
        }
    };

    /** Get spots of a branch */
    function getSourcesSpots(branch) {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.spot};
            query.branch = _.get(branch, '_id');
            query.isRoom = true;
            query.sort = 'code';
            MasterTableService.query(query, function (data) {
            }, function (err) {
                toastr.error(TranslationService.errors.e500);
                $log.error('error load spots', err);
            }).$promise.then(function (data) {
                $log.debug('Available spots:', data);
                full(_.sortBy(data, ['description']));
            });
        });
    }

    /** Function to add new tutor **/
    vm.addTutor = function (event) {
        event.preventDefault();
        if (vm.requestBD.user.tutors) {
            this.requestBD.user.tutors.push({
                identity: {
                    docType: vm.constants.docType[0]
                }
            });
        } else {
            this.requestBD.user.tutors = [{
                identity: {
                    docType: vm.constants.docType[0]
                }
            }];
        }
    };

    /** Function to remove tutor **/
    vm.removeTutor = function (index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                _.pullAt(vm.requestBD.user.tutors, index);
                $scope.$digest();
            }
        });
    };

    /** Function to get universities **/
    vm.getUniversities = function () {
        ConfigService.query({
            functionality: 'universities'
        }, function (data) {
            vm.universities = data;
        }, function (err) {
            toastr.error(TranslationService.errors.e500);
            $log.error('[residentDetail] getUniversities error: ', err);
        });
    };

    /** Function to get courses **/
    vm.getCourses = function () {
        var currentMonth = moment().month();
        // from current course. Check if September already to know if new course is coming
        var year = currentMonth >= 8 ? moment().year() : moment().subtract(1, 'year').year();
        vm.courses = _.map(_.range(year, 2050), function (c) {
            return {
                id: _.join([c, c + 1], ''),
                name: _.join([c, c + 1], '/')
            };
        });
    };

    /** Function to get faculties **/
    vm.getFaculties = function () {
        ConfigService.query({
            functionality: 'faculties'
        }, function (data) {
            vm.faculties = data;
        }, function (err) {
            toastr.error(TranslationService.errors.e500);
            $log.error('[residentDetail] getFaculties error: ', err);
        });
    };

    /** Function to get faculties **/
    vm.getCarrersCollege = function () {
        ConfigService.query({
            functionality: 'studies'
        }, function (data) {
            vm.studies = data;
        }, function (err) {
            toastr.error(TranslationService.errors.e500);
            $log.error('[residentDetail] get studies error: ', err);
        });
    };

    /** initialization visits table */
    function iniVisitTable(list) {
        var page = 1;
        var count = 5;

        var listCopy = angular.copy(list);
        vm.visitTableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: {}
                },
                {
                    counts: [5, 10, 20],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        // listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['pageRequestsList'] = page;
                        viewParams['countRequestsList'] = params._params.count;
                        viewParams['filterRequestsList'] = filterObj;
                        localStorageService.set('visitsViewParams', viewParams);

                        params.total(filteredData.length);

                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );
    }

    /** initialization contacts table */
    function iniContactsTable(list) {
        if (!list) {
            list = [];
        } else {
            vm.contacts = [];
            for (var i = 0; i < list.length; i++) {
                list[i].dateFormat = moment(list[i].date).format('YYYY/MM/DD');
                list[i].dateView = moment(list[i].date).format('DD/MM/YYYY');
                if (list[i].modeEdit !== true) {
                    list[i].modeEdit = false;
                }
                vm.contacts.push(list[i]);
            }
        }

        vm.contactsTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFormatIn: 'desc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: vm.contacts.length,
                    dataset: angular.copy(vm.contacts)
                }
            );
    }

    /** Checkbox billingOwnResident */
    vm.billingOwnResident = function (value) {
        if (!vm.readonly) {
            if (!value) {
                vm.requestBD.billingData.name = undefined;
                vm.requestBD.billingData.relative = undefined;
                vm.requestBD.billingData.identity = undefined;
                vm.requestBD.billingData.phone = undefined;
                vm.requestBD.billingData.address = undefined;
                vm.requestBD.billingData.city = undefined;
                vm.requestBD.billingData.state = undefined;
                vm.requestBD.billingData.country = undefined;
                vm.requestBD.billingData.surname = undefined;
                vm.requestBD.billingData.email = undefined;
                vm.requestBD.billingData.postcode = undefined;
                vm.requestBD.billingData.identity = {
                    docType: vm.constants.docType[0]
                };
                vm.clearBillingCountry();
                vm.clearBillingState();
            } else {
                if (!vm.requestBD.billingData.identity) {
                    vm.requestBD.billingData.identity = {
                        docType: vm.constants.docType[0]
                    };
                }
            }
        }
    };

    /** Checkbox documentation */
    vm.documentationCheck = function (value) {
        if (vm.readonly) {
            return;
        }
    };

    /** Checkbox tuition paid */
    vm.tuitionCheck = function (value) {
        if (vm.readonly) {
            return;
        } else {
            if (value) {
                vm.requestBD.billingData.tuition = undefined;
            }
        }

    };

    /** Checkbox deposit paid */
    vm.depositCheck = function (value) {
        if (vm.readonly) {
            return;
        } else {
            if (value) {
                vm.requestBD.billingData.deposit = undefined;
            }
        }
    };

    // Accept Request
    vm.acceptRequest = function (resForm) {
        var validRequest = true;
        if (!vm.requestBD.documentation || !vm.requestBD.documentation.documentationCheck) {
            toastr.warning(TranslationService.requests.detail.missingDocumentation);
            vm.tabActive = 7;
            validRequest = false;
            return;
        }

        // if (!_.get(vm.requestBD, 'billingData.tuitionInvoice.payDate')) {
        if (!_.get(vm.requestBD, 'billingData.tuitionPaid')) {
            toastr.warning(TranslationService.requests.detail.missingTuition);
            vm.tabActive = 3;
            validRequest = false;
            return;
        }
        // if (!_.get(vm.requestBD, 'billingData.depositInvoice.payDate')) {
        //     toastr.warning(TranslationService.requests.detail.missingDeposit);
        //     vm.tabActive = 3;
        //     validRequest = false;
        //     return;
        // }
        if (!vm.depositConcept || !_.get(vm.requestBD, 'billingData.deposit.paid')) {
            toastr.warning(TranslationService.requests.detail.missingDeposit);
            vm.tabActive = 3;
            validRequest = false;
            return;
        }
        // if (!vm.requestBD.billingData.deposit || !vm.requestBD.billingData.deposit.date ||
        //     !vm.requestBD.billingData.deposit.name || !vm.requestBD.billingData.deposit.import) {
        //     toastr.warning(TranslationService.requests.detail.missingDeposit);
        //     vm.tabActive = 3;
        //     validRequest = false;
        //     return;
        // }
        if (validRequest) {
            vm.requestBD.user.isReservation = true;
            vm.save(resForm, true);
        }
    };

    /** Function to check if payData are valid **/
    vm.validBillingData = function () {
        switch (vm.requestBD.billingData.payType.code) {
            case 'domiciliado':
                return !(!vm.resform.bankIban.$valid || !vm.resform.bankSwift.$valid || !vm.resform.bankHolder.$valid);
            case 'tarjeta':
                return !(!vm.resform.cardHolder.$valid || !vm.resform.cardCvv.$valid || !vm.resform.cardNumber.$valid || !vm.resform.cardExpDate.$valid);
            default:
                return true;
        }
    };

    /** Function to save request */
    vm.save = function (resForm, acceptRequest) {
        if (!vm.requestBD.branch || !vm.requestBD.spot) {
            toastr.warning(TranslationService.requests.detail.toastMissingBranch);
            vm.submitted = true;
            return;
        }

        if ((!vm.submitted && !resForm.$valid) || !resForm.$valid) {
            vm.submitted = true;
            if ((vm.requestBD.billingData.ownResident && !(vm.requestBD.billingData.type && vm.requestBD.billingData.payType)) ||
                (!vm.requestBD.billingData.ownResident && !(vm.requestBD.billingData.type && vm.requestBD.billingData.payType &&
                    vm.requestBD.billingData.name && vm.requestBD.billingData.relative && vm.requestBD.billingData.identity)) ||
                !vm.validBillingData()) {
                toastr.warning(TranslationService.requests.detail.toastMissingBillingData + ' [ <span class="ion-social-euro"></span> ]', {allowHtml: true});
                vm.tabActive = 3;
            } else if (!(vm.requestBD.modalityData && vm.requestBD.modalityData.type && vm.requestBD.modalityData.roomType &&
                vm.requestBD.modalityData.dateFrom && vm.requestBD.modalityData.dateTo && vm.requestBD.modalityData.course)) {
                toastr.warning(TranslationService.requests.detail.toastMissingModalityData + ' [ <span class="fa fa-file-text"></span> ]', {allowHtml: true});
                vm.tabActive = 4;
            }
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            vm.requestBD.contacts = angular.copy(vm.contacts);
            var sav = angular.copy(vm.requestBD);
            if (vm.requestBD.user.identity && vm.requestBD.user.identity.val) {
                sav.user.identity = {
                    docType: vm.requestBD.user.identity.type,
                    docVal: vm.requestBD.user.identity.val,
                    expDate: vm.requestBD.user.identity.expDate ? moment(vm.requestBD.user.identity.expDate) : undefined
                };
            }
            if (!vm.requestBD.billingData.ownResident) {
                sav.billingData.identity = {
                    docType: vm.requestBD.billingData.identity.docType,
                    docVal: vm.requestBD.billingData.identity.docVal,
                    expDate: vm.requestBD.billingData.identity.expDate ? moment(vm.requestBD.billingData.identity.expDate) : undefined
                };
            }
            if (vm.requestBD.billingData.type) {
                _.set(sav, 'user.billingAccounts.billingType', vm.requestBD.billingData.type);
            }
            if (vm.requestBD.branch) {
                _.set(sav, 'user.branches', _.castArray(vm.requestBD.branch));
            }
            if (vm.requestBD.modalityData.course) {
                _.set(sav, 'modalityData.course', _.get(vm.requestBD.modalityData.course, 'name', vm.requestBD.modalityData.course));
            }
            if (_.get(vm.requestBD.modalityData, 'dateContract')) {
                _.set(sav, 'modalityData.dateContract', moment(vm.requestBD.modalityData.dateContract).add(3, 'hours'));
                _.set(sav, 'user.dateContract', moment(vm.requestBD.modalityData.dateContract).add(3, 'hours'));
            }
            if (_.get(vm.requestBD.modalityData, 'dateRegulations')) {
                _.set(sav, 'modalityData.dateRegulations', moment(vm.requestBD.modalityData.dateRegulations).add(3, 'hours'));
                _.set(sav, 'user.dateRegulations', moment(vm.requestBD.modalityData.dateRegulations).add(3, 'hours'));
            }
            if (_.get(vm.requestBD, 'billingData.payType')) {
                _.set(sav, 'user.billingAccounts.payType', _.get(vm.requestBD.billingData.payType, '_id', vm.requestBD.billingData.payType));
                if (vm.requestBD.billingData.bank) {
                    _.set(sav, 'user.billingAccounts.bank', vm.requestBD.billingData.bank);
                }
                if (vm.requestBD.billingData.bankCard) {
                    _.set(sav, 'user.billingAccounts.bankCard', vm.requestBD.billingData.bankCard);
                }
            }
            if (_.get(vm.requestBD, 'modalityData.type')) {
                _.set(sav, 'user.modality', vm.requestBD.modalityData.type);
            }

            $log.debug('Request object to save: ', sav);
            if (vm.request._id !== '0') {
                RequestService.post({idR: sav._id}, sav, function (data) {
                    if (acceptRequest) {
                        RequestAcceptService.post({idR: vm.requestBD._id}, {depositConcept: vm.depositConcept}, function (data) {
                            $log.debug('Accept application', data);
                        }, function (err) {
                            $log.error('Error accept request', err);
                            toastr.error(TranslationService.errors.e500);
                        });
                    }
                    toastr.success(TranslationService.dialog.saveok);
                    vm.request = {};
                    vm.requestBD = {};
                    vm.request.action = 'refList';
                });
            } else {
                RequestService.post(sav, function (data) {
                    if (acceptRequest) {
                        RequestAcceptService.post({idR: vm.requestBD._id}, {depositConcept: vm.depositConcept}, function (data) {
                            $log.debug('Accept application', data);
                        }, function (err) {
                            $log.error('Error accept request', err);
                            toastr.error(TranslationService.errors.e500);
                        });
                    }
                    toastr.success(TranslationService.dialog.saveok);
                    vm.request = {};
                    vm.requestBD = {};
                    vm.request.action = 'refList';
                });
            }
        }
    };

    /** Function to close back request */
    vm.back = function () {
        vm.anim = false;
        vm.showPayment = false;
        vm.appUsers = {};
        vm.request = {};
    };

    /** Function to open new /detail tuition  */
    vm.openConceptDetail = function (data, invoice, type) {
        if (vm.requestBD._id && vm.requestBD._id !== 0) {
            if (!data) {
                if (vm.requestBD.branch) {
                    data = {
                        client: {
                            item: vm.requestBD.user._id,
                            kind: 'AppUser'
                        },
                        branch: vm.requestBD.branch ? vm.requestBD.branch : undefined,
                        taxes: [],
                        related: {
                            kind: 'Application',
                            item: vm.requestBD._id
                        }
                    };
                }
            }
            data.constants = angular.copy(vm.constants);
            data.userBranches = vm.requestBD.user.branches;

            data.readonly = !!(invoice);
            data.isRequestDeposit = (type === 'deposit');
            data.isTuition = (type === 'tuition');
            data.acceptedRequest = _.get(vm.requestBD, 'accepted');

            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/modal/modalConceptDetail/modalConceptDetail.html',
                controller: 'ModalConceptDetailController',
                controllerAs: 'mcdc',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    modalBinding: function () {
                        return data;
                    }
                }
            });
            // Function when open modal
            modalInstance.result.then(function (result) {
                //close function
                if (result) {
                    if (type === 'deposit') {
                        vm.getDepositConcept();
                    } else {
                        vm.getTuitionConcept();
                    }
                }
            }, function (closemsg) {
                //dismiss function
            });
        } else {
            toastr.error(TranslationService.errors.saveRequestFirst);
        }
    };

    $rootScope.$on('closeRequestDetail', function () {
        vm.back();
    });

    /**
     * Function to generate PDF from blob stream
     * @param {*} response
     * @param {*} fileName
     */
    function formatResponsePdf(response, fileName) {
        var url = window.URL;
        var myBlobObject = new Blob([response.data], {type: 'application/pdf'});
        var fileURL = url.createObjectURL(myBlobObject);
        var link = document.createElement('a');
        link.setAttribute('type', 'hidden'); // make it hidden if needed
        link.download = fileName; //moment().format(strName);
        link.href = fileURL;
        link.target = '_self';
        link.click();
    }

    vm.printInvoice = function (type, bill) {
        var fileName = '';
        if (type === 'invoice') {
            fileName = '[' + bill.invoiceNumber + ' ]' + 'YYYY_MM_DD h_mm[.pdf]';
            fileName = moment().format(fileName);
            vm.downloadingInvoicePdf = true;
        } else {
            fileName = '[' + bill.proformaNumber + ' ]' + 'YYYY_MM_DD h_mm[.pdf]';
            fileName = moment().format(fileName);
            vm.downloadingProformaPdf = true;
        }
        var urlId = serviceConf.BillingPrintService;
        urlId = urlId.replace(':idR', bill._id);
        var con = {
            headers: {
                'authentication': 'Bearer ' + localStorageService.get('sessionToken'),
                'docType': type
            },
            responseType: 'arraybuffer'
        };

        $http.get(urlId, con).then(function mySuccess(response) {
            formatResponsePdf(response, fileName);
            setTimeout(function () {
                vm.downloadingInvoicePdf = false;
                vm.downloadingProformaPdf = false;
            }, 501);
        });
    };

    vm.invoice = function (bill, concept, generateBill, type) {
        var query = {};
        if (bill && bill._id && bill._id !== '0' && bill._id && bill._id !== 0) {
            query.idR = bill._id;
        }
        bill = bill ? bill : {};
        bill.concepts = [concept];
        bill.client = concept.client;
        bill.generateBilling = generateBill ? true : undefined;
        bill.branch = vm.requestBD.branch;
        bill.billingAddress = {
            ownClient: vm.requestBD.billingData.ownResident,
            name: vm.requestBD.billingData.name ? vm.requestBD.billingData.name : null,
            surname: vm.requestBD.billingData.surname ? vm.requestBD.billingData.surname : null,
            relative: vm.requestBD.billingData.relative ? vm.requestBD.billingData.relative : null,
            identity: vm.requestBD.billingData.identity ? vm.requestBD.billingData.identity : null,
            country: vm.requestBD.billingData.country ? vm.requestBD.billingData.country : null,
            city: vm.requestBD.billingData.city ? vm.requestBD.billingData.city : null,
            address: vm.requestBD.billingData.address ? vm.requestBD.billingData.address : null,
            email: vm.requestBD.billingData.email ? vm.requestBD.billingData.email : null,
            phone: vm.requestBD.billingData.phone ? vm.requestBD.billingData.phone : null,
            postcode: vm.requestBD.billingData.postcode ? vm.requestBD.billingData.postcode : null,
            state: vm.requestBD.billingData.state ? vm.requestBD.billingData.state : null,
        };

        BillingService.post(query, bill, function (data) {
            if (generateBill) {
                if (type === 'deposit') {
                    $log.debug('generated deposit invoice: ', data);
                    vm.requestBD.billingData.depositInvoice = data;
                } else {
                    $log.debug('generated tuition invoice: ', data);
                    vm.requestBD.billingData.tuitionInvoice = data;
                }
                toastr.success(TranslationService.modal.invoiceSuccess);
            } else {
                if (type === 'deposit') {
                    $log.debug('generated deposit proforma: ', data);
                    vm.requestBD.billingData.depositInvoice = data;
                } else {
                    $log.debug('generated tuition proforma: ', data);
                    vm.requestBD.billingData.tuitionInvoice = data;
                }
                toastr.success(TranslationService.modal.proformaSuccess);
            }

            var objToSave = {
                user: {
                    id: vm.requestBD.user._id
                },
                billingData: {
                    ownResident: vm.requestBD.billingData.ownResident,
                    name: vm.requestBD.billingData.name ? vm.requestBD.billingData.name : undefined,
                    surname: vm.requestBD.billingData.surname ? vm.requestBD.billingData.surname : undefined,
                    relative: vm.requestBD.billingData.relative ? vm.requestBD.billingData.relative : undefined,
                    identity: vm.requestBD.billingData.identity ? vm.requestBD.billingData.identity : undefined,
                }
            };

            if (type === 'deposit') {
                _.set(objToSave, 'billingData.depositConcept', [concept]);
                _.set(objToSave, 'billingData.depositInvoice', data._id);
            } else {
                _.set(objToSave, 'billingData.tuitionConcept', [concept]);
                _.set(objToSave, 'billingData.tuitionInvoice', data._id);
            }

            RequestService.post({idR: vm.requestBD._id}, objToSave, function (dataUpdReq) {
                $log.debug(dataUpdReq);
                toastr.success(TranslationService.dialog.saveok);
            }, function (errUpdReq) {
                $log.error('RequestService post error: ', errUpdReq);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }, function (err) {
            $log.error('BillingService post error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
        });
    };

    /**
     * Function to pay bill
     * @param {*} bill
     * @param {*} type to know tuition or deposit
     */
    vm.payInvoice = function (bill, type) {
        if (!bill.invoiceNumber) {
            swal({
                title: TranslationService.modal.warning,
                text: TranslationService.modal.invoiceNumberNeeded,
                confirmButtonText: TranslationService.modal.button.ok
            });
        } else {
            swal({
                title: TranslationService.modal.confirmation,
                text: TranslationService.modal.payBilling,
                showCancelButton: true,
                confirmButtonText: TranslationService.modal.button.ok,
                cancelButtonText: TranslationService.modal.button.cancel
            }).then(function (result) {
                if (result.value) {
                    var billingUpdate =
                        {
                            payDate: new Date(),
                            paidData: {payType: _.get(vm.requestBD.billingData.payType, '_id', vm.requestBD.billingData.payType)}
                        };
                    if (type === 'deposit') {
                        billingUpdate.addDeposit = true;
                    }
                    BillingService.post({idR: bill._id}, billingUpdate, function (data) {
                        toastr.success(TranslationService.modal.paySuccess);
                        if (type === 'deposit') {
                            vm.requestBD.billingData.depositInvoice = data;
                        } else {
                            vm.requestBD.billingData.tuitionInvoice = data;
                            vm.requestBD.billingData.tuitionPaid = true;
                        }

                        $rootScope.$emit('reloadBillingList');
                    }, function (err) {
                        $log.error('BillingService pay error: ', err);
                        toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                            {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                    });
                }
            });
        }
    };

    /**
     * Function to get Deposit concept detail
     */
    vm.getDepositConcept = function () {
        if (!_.get(vm.requestBD, 'billingData.depositInvoice')) {
            var query = {'related': vm.request._id, 'isDeposit': true};
            ConceptService.get(query, function (data) {
                $log.debug('[requestDetail] get deposit concept: ', data);
                if (data.data.length > 0) {
                    vm.depositConcept = data.data[0];
                }
                $log.debug('[requestDetail] deposit detail', vm.depositConcept);
            }, function (err) {
                $log.error('Error get deposit', err);
                toastr.error(TranslationService.errors.e500);
            });
        }
    };

    /**
     * Function to get Tuition concept detail
     */
    vm.getTuitionConcept = function () {
        if (!_.get(vm.requestBD, 'billingData.tuitionInvoice')) {
            var query = {'related': vm.request._id, 'isDeposit': false};
            ConceptService.get(query, function (data) {
                $log.debug('[requestDetail] get tuition concept: ', data);
                if (data.data.length > 0) {
                    vm.tuitionConcept = data.data[0];
                }
                $log.debug('[requestDetail] tuition detail', vm.tuitionConcept);
            }, function (err) {
                $log.error('Error getTuition', err);
                toastr.error(TranslationService.errors.e500);
            });
        }
    };

    vm.selectPayerTutor = function () {
        vm.requestBD.billingData.name = vm.selectedPayerTutor.name;
        vm.requestBD.billingData.email = vm.selectedPayerTutor.email;
        vm.requestBD.billingData.address = vm.selectedPayerTutor.address;
        vm.requestBD.billingData.city = vm.selectedPayerTutor.city;
        vm.requestBD.billingData.phone = vm.selectedPayerTutor.mainPhone;
        vm.requestBD.billingData.postcode = vm.selectedPayerTutor.postcode;
        vm.selectedBillingDataCountry = vm.selectedPayerTutor.selectedCountry;
        vm.selectBillingCountryChange();
        vm.selectedBillingDataState = vm.selectedPayerTutor.selectedState;
        vm.requestBD.billingData.identity = vm.selectedPayerTutor.identity;
    };

    /**
     * Show hide tutors select dropdown
     */
    vm.showHidePayerTutorSelection = function () {
        vm.showPayerTutorSelect = !vm.showPayerTutorSelect;
    };

    vm.$onInit = function () {
        vm.getUniversities();
        vm.getCarrersCollege();
        vm.getFaculties();
        vm.getCourses();
        vm.countryList = angular.copy(_.uniqBy(CountryList, 'name'));
        if (vm.request.action === 'edit' && !vm.request.accepted) {
            vm.readonly = false;
        }
        tmhDynamicLocale.set(moment.locale());
        if (vm.initialized) {
            return;
        }

        var selectedBar = localStorageService.get('selectedBarResidence');

        // If new request
        if (vm.request._id === '0') {
            vm.readonly = false;
            vm.requestBD = {
                branch: (selectedBar && !selectedBar.all) ?
                    selectedBar : vm.constants.branch[0],
                active: true,
                allergy: {},
                isResident: true,
                billingData: {
                    ownResident: true
                }
            };
            if (vm.request.branch || vm.requestBD.branch) {
                vm.getRoomTypes();
            }


            // Workaround
            setTimeout(function () {
                $scope.$apply(function () {
                    vm.requestBD.billingData.ownResident = true;
                });
            }, 500);

            getSourcesSpots(vm.requestBD.branch).then(function (data) {
                vm.listSpots = data;
            });

            // If user not exist
            if (!vm.request.userid) {
                vm.requestBD.user = {};
                vm.requestBD.user.active = false;
                vm.requestBD.user.contact = {};
                vm.requestBD.user.identity = {
                    type: vm.constants.docType[0],
                    val: vm.request.docval
                };
                vm.requestBD.user.attacheds = [];
                vm.requestBD.billingData = {
                    type: _.find(vm.constants.billingType, {numericValue: 1})
                };
                vm.requestBD.billingData.identity = {
                    docType: vm.constants.docType[0]
                };
                // Workaround
                setTimeout(function () {
                    vm.validDNI(vm.requestBD.user.identity.val, vm.requestBD.user.identity.type.description, vm.resform.dni);
                }, 500);
            } else {
                // Create request for existing user
                $log.debug('Create request for existing user');
                $log.debug(vm.request.userid);
                vm.requestBD = {
                    branch: (selectedBar && !selectedBar.all) ?
                        selectedBar : vm.constants.branch[0],
                };
                vm.getRoomTypes();
                vm.requestBD.billingData = {};
                vm.requestBD.billingData.identity = {
                    docType: vm.constants.docType[0]
                };

                ResidentsService.get({idR: vm.request.userid}, function (res) {
                    vm.requestBD.user = angular.copy(res);

                    if (vm.requestBD.user.identity && vm.requestBD.user.identity.docType) {
                        var tpe = null;
                        if (vm.requestBD.user.identity.docType._id) {
                            tpe = _.find(vm.constants.docType, function (type) {
                                return type._id === vm.requestBD.user.identity.docType._id;
                            });
                        } else {
                            tpe = _.find(vm.constants.docType, function (type) {
                                return type._id === vm.requestBD.user.identity.docType;
                            });
                        }
                        if (vm.requestBD.user.birthdate) {
                            vm.requestBD.user.birthdate = moment(vm.requestBD.user.birthdate).toDate();
                        }

                        vm.requestBD.user.identity.type = tpe ? tpe : vm.constants.docType[0];
                        vm.requestBD.user.identity.val = vm.requestBD.user.identity.docVal;
                        vm.requestBD.user.identity.expDate = vm.requestBD.user.identity.expDate ?
                            moment(vm.requestBD.user.identity.expDate).toDate() : undefined;

                        // Set tutors country / state
                        if (vm.requestBD.user.tutors && vm.requestBD.user.tutors.length > 0) {
                            _.forEach(vm.requestBD.user.tutors, function (tutor, index) {
                                if (tutor.country) {
                                    tutor.selectedCountry = _.find(vm.countryList, function (item) {
                                        return ignoreDiacritics(item.name) === ignoreDiacritics(tutor.country);
                                    });
                                    if (tutor.selectedCountry) {
                                        if (tutor.selectedCountry.states && tutor.state) {
                                            tutor.selectedCountry.states = _.uniq(tutor.selectedCountry.states);
                                            var state = _.find(tutor.selectedCountry.states, function (item) {
                                                return ignoreDiacritics(item) === ignoreDiacritics(tutor.state);
                                            });
                                            tutor.selectedState = state ? state : tutor.state;
                                        } else if (!tutor.selectedCountry.states && tutor.state) {
                                            tutor.selectedState = tutor.state;
                                        } else {
                                            tutor.selectedState = '';
                                        }
                                    } else {
                                        tutor.selectedCountry = {name: tutor.country, states: []};
                                        tutor.selectedState = tutor.state ? tutor.state : '';
                                    }
                                } else {
                                    tutor.selectedCountry = {};
                                }
                            });
                        }

                        // Set country user contact
                        if (vm.requestBD.user.contact) {
                            if (vm.requestBD.user.contact.country) {
                                vm.selectedCountry = _.find(vm.countryList, function (item) {
                                    return ignoreDiacritics(item.name) === ignoreDiacritics(vm.requestBD.user.contact.country);
                                });
                                if (vm.selectedCountry) {
                                    if (vm.selectedCountry.states && vm.requestBD.user.contact.state) {
                                        vm.selectedCountry.states = _.uniq(vm.selectedCountry.states);
                                        var state = _.find(vm.selectedCountry.states, function (item) {
                                            return ignoreDiacritics(item) === ignoreDiacritics(vm.requestBD.user.contact.state);
                                        });
                                        vm.selectedState = state ? state : vm.requestBD.user.contact.state;
                                    } else if (!vm.selectedCountry.states && vm.requestBD.user.contact.state) {
                                        vm.selectedState = vm.requestBD.user.contact.state;
                                    } else {
                                        vm.selectedState = '';
                                    }
                                } else {
                                    vm.selectedCountry = {name: vm.requestBD.user.contact.country, states: []};
                                    vm.selectedState = vm.requestBD.user.contact.state ? vm.requestBD.user.contact.state : '';
                                }
                            } else {
                                vm.selectedCountry = {};
                            }
                        } else {
                            vm.requestBD.user.contact = {};
                            vm.requestBD.user.contact.selectedCountry = {};
                            vm.requestBD.user.contact.selectedState = '';
                            vm.selectedCountry = {};
                            vm.selectedState = '';
                        }

                        // Get user photo
                        if (vm.requestBD.user.photo && vm.requestBD.user.photo.original.key) {
                            MasterTableService.get({
                                idT: routeConf.file, idJ: routeConf.signedUrl,
                                key: vm.requestBD.user.photo.original.key,
                                bucket: vm.requestBD.user.photo.original.bucket
                            }, function (data) {
                                vm.avatar = data.url;
                                vm.avatarOri = angular.copy(vm.avatar);
                            }, function (err) {
                                toastr.error(TranslationService.errors.e500);
                                $log.error('[requestDetail] error getting avatar: ', err);
                            });
                        }
                    }
                    $log.debug('Existing user: ', vm.requestBD.user);

                }, function (err) {
                    toastr.error(TranslationService.errors.e500);
                    $log.error('[requestDetail] error getting resident: ', err);
                });


            }
            // vm.requestBD.allergy = {};
            // vm.requestBD.booked = {};
            // vm.awayList = [];
            iniContactsTable([]);
            vm.contactsTableParams.reload();
            vm.ready = true;

        } else {
            // View Edit Request
            $log.debug('Selected request:', vm.request);
            RequestService.get({idR: vm.request._id}, function (data) {
                $log.debug('Request detail:', data);
                if (data && data.user.birthdate) {
                    data.user.birthdate = moment(data.user.birthdate).toDate();
                }
                if (data && data.modalityData) {
                    data.modalityData.dateFrom = (data.modalityData.dateFrom ? moment(data.modalityData.dateFrom).toDate() : undefined);
                    data.modalityData.dateTo = (data.modalityData.dateTo ? moment(data.modalityData.dateTo).toDate() : undefined);
                    data.modalityData.dateContract = (data.modalityData.dateContract ? moment(data.modalityData.dateContract).toDate() : undefined);
                    data.modalityData.dateRegulations = (data.modalityData.dateRegulations ? moment(data.modalityData.dateRegulations).toDate() : undefined);
                    data.modalityData.dateCancel = (data.modalityData.dateCancel ? moment(data.modalityData.dateCancel).toDate() : undefined);
                }
                vm.requestBD = angular.copy(data);
                vm.getDepositConcept();
                vm.getTuitionConcept();
                if (vm.requestBD.branch) {
                    vm.getRoomTypes();
                }
                getSourcesSpots(vm.requestBD.branch).then(function (data) {
                    vm.listSpots = data;
                });

                // Set tutors country / state
                if (vm.requestBD.user.tutors && vm.requestBD.user.tutors.length > 0) {
                    _.forEach(vm.requestBD.user.tutors, function (tutor, index) {
                        if (tutor.country) {
                            tutor.selectedCountry = _.find(vm.countryList, function (item) {
                                return ignoreDiacritics(item.name) === ignoreDiacritics(tutor.country);
                            });
                            if (tutor.selectedCountry) {
                                if (tutor.selectedCountry.states && tutor.state) {
                                    tutor.selectedCountry.states = _.uniq(tutor.selectedCountry.states);
                                    var state = _.find(tutor.selectedCountry.states, function (item) {
                                        return ignoreDiacritics(item) === ignoreDiacritics(tutor.state);
                                    });
                                    tutor.selectedState = state ? state : tutor.state;
                                } else if (!tutor.selectedCountry.states && tutor.state) {
                                    tutor.selectedState = tutor.state;
                                } else {
                                    tutor.selectedState = '';
                                }
                            } else {
                                tutor.selectedCountry = {name: tutor.country, states: []};
                                tutor.selectedState = tutor.state ? tutor.state : '';
                            }
                        } else {
                            tutor.selectedCountry = {};
                        }
                    });
                }

                // Set country user contact
                if (vm.requestBD.user.contact) {
                    if (vm.requestBD.user.contact.country) {
                        vm.selectedCountry = _.find(vm.countryList, function (item) {
                            return ignoreDiacritics(item.name) === ignoreDiacritics(vm.requestBD.user.contact.country);
                        });
                        if (vm.selectedCountry) {
                            if (vm.selectedCountry.states && vm.requestBD.user.contact.state) {
                                vm.selectedCountry.states = _.uniq(vm.selectedCountry.states);
                                var state = _.find(vm.selectedCountry.states, function (item) {
                                    return ignoreDiacritics(item) === ignoreDiacritics(vm.requestBD.user.contact.state);
                                });
                                vm.selectedState = state ? state : vm.requestBD.user.contact.state;
                            } else if (!vm.selectedCountry.states && vm.requestBD.user.contact.state) {
                                vm.selectedState = vm.requestBD.user.contact.state;
                            } else {
                                vm.selectedState = '';
                            }
                        } else {
                            vm.selectedCountry = {name: vm.requestBD.user.contact.country, states: []};
                            vm.selectedState = vm.requestBD.user.contact.state ? vm.requestBD.user.contact.state : '';
                        }
                    } else {
                        vm.selectedCountry = {};
                    }
                } else {
                    vm.requestBD.user.contact = {};
                    vm.requestBD.user.contact.selectedCountry = {};
                    vm.requestBD.user.contact.selectedState = '';
                    vm.selectedCountry = {};
                    vm.selectedState = '';
                }

                if (!vm.requestBD.user.identity) {
                    vm.requestBD.user.identity = {
                        type: vm.constants.docType[0]
                    };
                } else {
                    if (vm.requestBD.user.identity && vm.requestBD.user.identity.docType) {
                        var tpe = null;
                        if (vm.requestBD.user.identity.docType._id) {
                            tpe = _.find(vm.constants.docType, function (type) {
                                return type._id === vm.requestBD.user.identity.docType._id;
                            });
                        } else {
                            tpe = _.find(vm.constants.docType, function (type) {
                                return type._id === vm.requestBD.user.identity.docType;
                            });
                        }
                        vm.requestBD.user.identity.type = (tpe) ? tpe : vm.constants.docType[0];
                        vm.requestBD.user.identity.val = vm.requestBD.user.identity.docVal;
                        vm.requestBD.user.identity.expDate = vm.requestBD.user.identity.expDate ?
                            moment(vm.requestBD.user.identity.expDate).toDate() : undefined;
                    }
                }

                if (!vm.requestBD.user.contact) {
                    vm.requestBD.user.contact = {};
                }

                if (vm.requestBD.user.photo && vm.requestBD.user.photo.original.key) {
                    MasterTableService.get({
                        idT: routeConf.file, idJ: routeConf.signedUrl,
                        key: vm.requestBD.user.photo.original.key,
                        bucket: vm.requestBD.user.photo.original.bucket
                    }, function (data) {
                        vm.avatar = data.url;
                        vm.avatarOri = angular.copy(vm.avatar);
                    }, function (err) {
                        toastr.error(TranslationService.errors.e500);
                    });
                }

                if (vm.requestBD.contacts) {
                    iniContactsTable(vm.requestBD.contacts);
                } else {
                    iniContactsTable([]);
                }

                if (vm.requestBD.visitData) {
                    iniVisitTable(vm.requestBD.visitData);
                } else {
                    iniVisitTable([]);
                }

                if (_.get(vm.requestBD, 'billingData.tuitionInvoice')) {
                    vm.tuitionConcept = vm.requestBD.billingData.tuitionInvoice.concepts[0];
                }

                if (_.get(vm.requestBD, 'billingData.depositInvoice')) {
                    vm.depositConcept = vm.requestBD.billingData.depositInvoice.concepts[0];
                }

                // TODO update this and delete (depositInvoice)
                if (vm.requestBD.billingData && vm.requestBD.billingData.deposit && vm.requestBD.billingData.deposit.date) {
                    vm.requestBD.billingData.deposit.date = moment(vm.requestBD.billingData.deposit.date).toDate();
                }

                if (vm.requestBD.billingData && !vm.requestBD.billingData.ownResident) {
                    if (!vm.requestBD.billingData.identity) {
                        vm.requestBD.billingData.identity = {
                            docType: vm.constants.docType[0],
                            docVal: ''
                        };
                    } else {
                        vm.requestBD.billingData.identity = {
                            docType: _.get(vm.requestBD.billingData.identity, 'docType', vm.constants.docType[0]),
                            docVal: _.get(vm.requestBD.billingData.identity, 'docVal', '')
                        };
                    }
                }
                if (_.get(vm.requestBD, 'billingData.bankCard')) {
                    vm.requestBD.billingData.bankCard.expDate = moment(vm.requestBD.billingData.bankCard.expDate).toDate();
                }

                if (_.get(vm.requestBD, 'billingData.state')) {
                    vm.selectedBillingDataState = vm.requestBD.billingData.state;
                }

                if (_.get(vm.requestBD, 'billingData.country')) {

                    vm.selectedBillingDataCountry = _.find(vm.countryList, function (item) {
                        return ignoreDiacritics(item.name) === ignoreDiacritics(vm.requestBD.billingData.country);
                    });
                    // vm.selectedBillingDataCountry = vm.requestBD.billingData.country;
                }

                if (_.get(vm.requestBD, 'billingData.tuitionInvoice.payDate')) {
                    vm.requestBD.billingData.tuitionPaid = true;
                }

            });
        }
        setPermissions();
    };
}

angular
    .module('Tagaste.requestsDetailComponent')
    .component('requestsDetailComponent', {
        templateUrl: 'app/components/requests/requestDetail/requestDetail.html',
        controllerAs: 'rqdc',
        controller: RequestDetailController,
        bindings: {
            // selectr: '=',
            request: '=',
            constants: '=',
            anim: '='
        }
    });

function RequestsListController(NgTableParams, TranslationService, NgTableFilterService, toastr, $log, $rootScope,
                                PermissionsService, localStorageService, MasterTableService, routeConf, $location, $scope, $timeout,
                                RequestService, $filter, RequestExportService, FileSaver, ResidentsService) {
    var vm = this;
    vm.selectr = {};

    vm.dummyDni = '12345678Z';

    vm.anim = false;

    vm.requestPhase = 'all';

    vm.requestIsReservation = 'all';

    vm.ratingOptions = [
        {name: 'all', isSelected: true, class: 'btn-all'},
        {name: 'bronze', isSelected: false, class: 'btn-bronze', value: '0'},
        {name: 'silver', isSelected: false, class: 'btn-silver', value: '5'},
        {name: 'gold', isSelected: false, class: 'btn-gold', value: '10'}
    ];

    vm.requestRating = _.first(vm.ratingOptions);

    vm.filterName = {
        userName: {
            id: 'text'
        }
    };

    vm.filterSurname = {
        userSurname: {
            id: 'text'
        }
    };

    vm.filterCourse = {
        userCourse: {
            id: 'text'
        }
    };

    vm.filterDate = {
        formattedDate: {
            id: 'text'
        }
    };

    vm.filterBranch = {
        branch: {
            id: 'text'
        }
    };

    vm.filterRegistrationDate = {
        registrationDate: {
            id: 'text'
        }
    };

    vm.filterDepositDate = {
        depositDate: {
            id: 'text'
        }
    };

    var viewParams = localStorageService.get('requestsViewParams') ?
        localStorageService.get('requestsViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = { filterRequestsList: { branch: selectedBar.description } };
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/requests') {
            viewParams = { filterRequestsList: { branch: (!data.all) ? data.description : '' } };
            iniTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);
    vm.new = function () {
        swal({
            text: TranslationService.modal.newRequestDNI,
            input: 'text',
            inputLabel: 'DNI',
            customClass: 'dniModal',
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                ResidentsService.query({identity: result.value}, function (resData) {
                    if (resData.data.length) {
                        vm.selectr = {
                            _id: '0',
                            readonly: false,
                            userid: resData.data[0].id,
                            action: 'new'
                        };
                    } else {
                        ResidentsService.query({identity: result.value, active: false}, function (resInactiveData) {
                            if (resInactiveData.data.length) {
                                vm.selectr = {
                                    _id: '0',
                                    readonly: false,
                                    userid: resInactiveData.data[0].id,
                                    action: 'new'
                                };
                            } else {
                                vm.selectr = {
                                    _id: '0',
                                    readonly: false,
                                    action: 'new',
                                    docval: result.value
                                };
                            }
                        });
                    }
                    if (!vm.anim) {
                        $timeout(function () {
                            vm.anim = true;
                        }, 417);
                    }
                }, function (err) {
                    $log.error('Error searching DNI', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    vm.editRow = function (row) {
        vm.anim = false;
        if (vm.istour) {
            return;
        }
        if (vm.selectr && (vm.selectr.action === 'inEdit' || vm.selectr._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 281);
            }
            _.forEach(vm.tableParams.data, function (r) {
                r.selected = (r._id === row._id);
            });
            row.action = 'edit';
            vm.selectr = row;
        }
    };

    vm.deleteRow = function (row) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                RequestService.delete({idR: row._id}, function (data) {
                    vm.$onInit();
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    $log.error('RequestService delete error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('APPLICATION', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('APPLICATION', 'delete');
    }

    function getRequests() {
        RequestService.get({}, function (data) {
            $log.debug('Requests data: ', data);
            _.forEach(data.data, function (item) {
                item['branch'] = _.get(item, 'branch.description');
                item['userName'] = _.get(item, 'user.name');
                item['userSurname'] = _.get(item, 'user.surname');
                item['userCourse'] = _.get(item, 'modalityData.course');
                item['formattedDate'] = item['date'] ? moment(item['date']).format('L') : '';
                item['formattedDateReverse'] = item['date'] ? moment(item['date']).format('YYYY/MM/DD') : '';
                var depositDate = _.get(item, 'billingData.depositInvoice.payDate');
                item['depositDate'] = depositDate ? moment(depositDate).format('L') : '';
                item['depositPaid'] = _.get(item, 'billingData.deposit.paid');
                var registrationDate = _.get(item, 'billingData.tuitionInvoice.payDate');
                item['registrationDate'] = registrationDate ? moment(registrationDate).format('L') : '';
                item['isReservation'] = !!(item['registrationDate']);
                // old resident check
                vm.currentCouse = moment().month() >= 8 ? moment().year() + '/' + (moment().year() + 1) :
                    (moment().year() - 1) + '/' + moment().year();
                item['oldResident'] = _.get(item, 'user.oldReservations', []).length && _.get(item, 'user.oldReservations', []).length > 1 ?
                    _.find(item.user['oldReservations'], function (reservation) {
                        return _.get(reservation, 'course') && _.get(reservation, 'course') !== vm.currentCouse;
                    }) : false;
            });
        }).$promise.then(function (data) {
            var list = data.data;
            iniTable(list);
            vm.initialized = true;
            vm.list = list;
            return list;
        });
    }

    vm.rowClick = function (row) {
        row.action = '';
        vm.anim = false;
        if (vm.istour) {
            return;
        }
        if (vm.selectr && (vm.selectr.action === 'inEdit' || vm.selectr._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 281);
            }
            _.forEach(vm.tableParams.data, function (r) {
                r.selected = (r._id === row._id);
            });
            vm.selectr = row;
        }
    };

    vm.applyAdditionalFilters = function (option) {
        var list = JSON.parse(JSON.stringify(vm.list));
        var filteredList1 = vm.changePaymentFilter(list);
        var filteredList2 = vm.changeRatingFilter(filteredList1, option ? option : this.requestRating);
        var filteredList3 = vm.changeIsReservationFilter(filteredList2);
        iniTable(filteredList3);
    };

    vm.changePaymentFilter = function (list) {
        if (vm.requestPhase === true) {
            return _.filter(list, function (i) {
                return _.get(i, 'billingData.tuition.date');
            });
        } else if (vm.requestPhase === false) {
            return _.filter(list, function (i) {
                return _.get(i, 'billingData.deposit.date');
            });
        } else {
            return list;
        }
    };

    vm.changeRatingFilter = function (list, option) {
        vm.requestRating.isSelected = false;
        option.isSelected = true;
        vm.requestRating = option;

        if (vm.requestRating.value) {
            return _.filter(list, function (i) {
                return _.get(i, 'averageRating.code') === vm.requestRating.value;
            });
        } else {
            return list;
        }
    };

    vm.changeIsReservationFilter = function (list) {
        if (vm.requestIsReservation === true) {
            return _.filter(list, function (i) {
                return _.get(i, 'isReservation');
            });
        } else if (vm.requestIsReservation === false) {
            return _.filter(list, function (i) {
                return !_.get(i, 'isReservation');
            });
        } else {
            return list;
        }
    };

    function iniTable(list) {
        if (!list) {
            list = [];
        }

        for (var i = 0; i < list.length; i++) {
            list[i].residenceDesc = '';
        }

        var sorting = viewParams['sortingRequestsList'] ? viewParams['sortingRequestsList'] : {formattedDate: 'desc'};
        var page = viewParams['pageRequestsList'] ? viewParams['pageRequestsList'] : 1;
        var count = viewParams['countRequestsList'] ? viewParams['countRequestsList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingRequestsList'] = params._params.sorting;
                        viewParams['pageRequestsList'] = page;
                        viewParams['countRequestsList'] = params._params.count;
                        viewParams['filterRequestsList'] = filterObj;
                        localStorageService.set('RequestsViewParams', viewParams);

                        params.total(filteredData.length);
                        vm.currentTableData = filteredData;
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );
        var savedFilters = viewParams['filterRequestsList'] ? viewParams['filterRequestsList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    vm.exportData = function () {
        var filename = TranslationService.requests.title.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = TranslationService.requests.export;

        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function (e) {
                return e.id;
            }),
            filename: filename,
        };

        RequestExportService.post(
            {}, requestData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('ResidentsService export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
    };

    vm.$doCheck = function () {
        if (vm.selectr && vm.selectr.action === 'refList') {
            vm.initialized = false;
            vm.$onInit();
        }
    };

    $rootScope.$on('openRequestDetail', function () {
        vm.new();
    });

    $rootScope.$on('setDummyDni', function () {
        var input = _.first(document.getElementsByClassName('swal2-input'));
        input.value = vm.dummyDni;
    });

    $rootScope.$on('confirmDummyDni', function () {
        var button = _.first(document.getElementsByClassName('swal2-confirm'));
        button.click();
    });

    $rootScope.$on('openRequestDetailFirstRow', function () {
        if (vm.tourDummyData.length < 1) {
            var row = vm.tableParams.data[0];
            if (!row.error) {
                if (vm.modeCreation) {
                    vm.showIncidentView = false;
                    vm.anim = false;
                    vm.modeReadOnly = false;
                    vm.modeCreation = false;

                } else {
                    if (!vm.anim) {
                        $timeout(function () {
                            vm.anim = true;
                        }, 401);
                    }
                    _.forEach(vm.tableParams.data, function (r) {
                        r.selected = (r._id === row._id);
                    });
                    vm.modeReadOnly = true;
                    vm.showIncidentView = true;
                    vm.modeCreation = false;
                    vm.selectRequest = row._id;
                    $log.debug('selected request', row);
                }
            }
        } else {
            vm.new();
        }
    });

    vm.$onInit = function () {
        setPermissions();
        vm.selectr = {};
        vm.anim = false;
        vm.tableParams = null;
        vm.anim = false;
        getRequests();
    };
}

angular
    .module('Tagaste.requestsListComponent')
    .component('requestsListComponent', {
        templateUrl: 'app/components/requests/requestsList/requestsList.html',
        controllerAs: 'rqlsc',
        controller: RequestsListController,
        bindings: {
            selectr: '=',
            list: '=',
            anim: '=',
            initTour: '&',
            tourDummyData: '=',
            istour: '<'
        }
    });

/*
 * @author sila.fernandez
 * created on 22/03/2019
 */
RoomsDetailController.$inject = ['localStorageService', '$rootScope'];

function RoomsDetailController(localStorageService, $rootScope) {
    var vm = this;
    vm.activetasksisopen = true;
    vm.incidentsisopen = true;

    vm.room = null;
    var _slots = [
        [0],[0],[0],[0],[0],[0],[0]
      ];

    vm._CONTROLLER='RoomsDetailController';

    vm.checkout = function () {

    };

    vm.look = function () {

    };

    vm.clean = function () {

    };    

    vm.$onInit = function () {
        vm.slots = angular.copy(_slots);

        var selectedBar = localStorageService.get('selectedBarResidence');
        /*
        MasterTableRoom.get({idT: routeConf.app, idJ: routeConf.facility, idP: vm.room._id}, 
            function (data) {
            vm.room = angular.copy(data);
            vm.getSlotsFromTimetable(vm.room.timetable);
            vm.notification = vm.room.notification;
            
            $log.debug('vm.room', vm.room);

            // Check if booked and appUsers involveds
            var query = {idT: routeConf.app, idJ: routeConf.findScheduledFacility};
            query.facility = vm.room._id;
            query.dateFrom = moment().toDate();
            query.dateTo = moment().add(1, 'months').toDate();

            MasterTableRoom.query(query, function (data) {
                _.forEach(data, function (pElemService) {
                    if (vm.room._id === pElemService._id) {
                        _.forEach(pElemService.schedules, function (pSchedule) {
                            _.forEach(pSchedule.involveds, function (pInvolved) {
                                if (pInvolved.kind === 'AppUser'){
                                    vm.arrInvolveds.push(pInvolved.item);
                                }
                            });
                        });
                    }
                });
                vm.arrInvolveds = _.uniqBy(vm.arrInvolveds, function (e) { return e.id; });

                $log.debug('notification', vm.notification);
                vm.ready = true;

            }, function (err) {
                $log.error('getInvolveds error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});

            });

        }, function (err) {
            $log.error('getServices error: ', err);
            toastr.error(TranslationService.errors.e500);
            vm.ready = true;
            vm.room = null;
        });
        */
       vm.room = {"_id":"5ae0b86c42ec4d34b40fcd4b","name":"pruebas","surname":"leon22","photo":{"_id":"5af42a65a857e503b4eb5d37","filename":".,-Mº del Mª ñ'¿+ç+``[[][^chica_1 - copia.jpg","thumb":{"signedUrl":"https://dev-tagaste.s3.eu-west-1.amazonaws.com/.-M_del_M_chica_1_-_copia-1525951069582-thumb.png?AWSAccessKeyId=AKIAJ5R2QVO5JUCFBGNQ&Expires=1553853108&Signature=2DpeGJ26aTNWYu7KHYDh2ufX8xo%3D","key":".-M_del_M_chica_1_-_copia-1525951069582-thumb.png","bucket":"dev-tagaste"},"original":{"key":".-M_del_M_chica_1_-_copia-1525951069582.jpg","bucket":"dev-tagaste"},"active":true},"attacheds":[{"_id":"5b643761c8e9c60788883954","filename":"adjuntos.png","visibility":{"relatedUSer":[],"isHierarchy":false,"isPrivate":false,"isPublic":true},"thumb":{"signedUrl":"https://dev-tagaste.s3.eu-west-1.amazonaws.com/adjuntos-1533294380997-thumb.png?AWSAccessKeyId=AKIAJ5R2QVO5JUCFBGNQ&Expires=1553853108&Signature=WMYnBUoajTbQdr0myqVeyZxAnHI%3D","key":"adjuntos-1533294380997-thumb.png","bucket":"dev-tagaste"},"original":{"key":"adjuntos-1533294380997.png","bucket":"dev-tagaste"},"active":true},{"_id":"5b643761c8e9c60788883955","filename":"Screenshot_20180518-094208.png","visibility":{"relatedUSer":[],"isHierarchy":false,"isPrivate":false,"isPublic":true},"thumb":{"signedUrl":"https://dev-tagaste.s3.eu-west-1.amazonaws.com/Screenshot_20180518-094208-1533294408574-thumb.png?AWSAccessKeyId=AKIAJ5R2QVO5JUCFBGNQ&Expires=1553853108&Signature=58fqESmDRNYDcYjnWhQY6Q9wD1k%3D","key":"Screenshot_20180518-094208-1533294408574-thumb.png","bucket":"dev-tagaste"},"original":{"key":"Screenshot_20180518-094208-1533294408574.png","bucket":"dev-tagaste"},"active":true}],"booked":[{"dateFrom":"2018-04-25T17:18:19.759Z","originType":"PANEL","isResident":true,"bookNum":"000","room":"000","dateFormatFrom":"2018/04/25","dateViewFrom":"25/04/2018","branchDescription":""}],"devices":[],"allergy":{"allergyTypes":[]},"isResident":true,"isDelegate":false,"room":"000","isVirtual":false,"branches":{"_id":"5a4df00d84c7202edca65e09","description":"León"},"contact":{"email":"email@example.com","phone":"666999888"},"active":true,"fullName":"pruebas leon22","floor":"0","id":"5ae0b86c42ec4d34b40fcd4b","identity":{"type":{"_id":"5a4baf2c7b63c217fcf72182","description":"DNI","code":"01","active":true}}};
        vm.initialized = true;
    };

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.inServiceDetailComponent.controller:ServiceDetailController
     * @description
     * Method that close de detail  without saving information
     */
    vm.cancel = function () {
        vm.anim = false;
        vm.room = null;
    };

    $rootScope.$on('closeRoomDetail', function () {
        vm.cancel();
    });
}

angular
    .module('BlurAdmin.roomsDetailCom')
    .component('roomsDetailCom', {
        templateUrl: 'app/components/rooms/roomsDetail/roomsDetail.html',
        controllerAs: 'rodetc',
        controller: RoomsDetailController,
        bindings: {
            room: '=',
            anim: '='
        }
    });
/*
 * @author sila.fernandez
 * created on 22/03/2019
 */

RoomsListController.$inject = ['NgTableParams', 'TranslationService', 'NgTableFilterService', '$timeout',
    'toastr', '$log', 'TourService', '$rootScope', 'PermissionsService', 'localStorageService',
    '$filter', 'weeklySchedulerLocaleService', 'MasterTableService', 'LanguageFactory', 'routeConf', '$uibModal',
    '$location','$scope'];


function RoomsListController(NgTableParams, TranslationService, NgTableFilterService, $timeout,
                                 toastr, $log, TourService, $rootScope, PermissionsService,
                                 localStorageService, $filter, weeklySchedulerLocaleService, MasterTableService,
                                 LanguageFactory, routeConf, $uibModal, $location,$scope) {
    var vm = this;

    vm.servic = {};
    vm.select = {};
    vm.listOri = null;
    vm.anim = false;
    vm.initialized = false;
    vm.gotAccessMod = false;
    vm.gotAccessDel = false;

    vm.selectedBar = localStorageService.get('selectedBarResidence');

    function strToInitials(str, pLength) {
        var arrWords = str.split(' ');
        var arrInitials = _.slice(arrWords, 0, pLength || 3);
        return arrInitials.map(function (obj) {
            return obj.charAt(0);
        }).join('');
    }

    vm.dayChanged = function (day) {
        return new Promise(function (full, reject) {
            vm.dayFrom = day;
            var query = {idT: routeConf.planningRoom, dateFrom: vm.dayFrom.toDate()};
            if (vm.selectedBar && !vm.selectedBar.all) {
                query.branch = vm.selectedBar._id;
            }

            var list = [];
            MasterTableService.query(query, function (data) {
                $log.debug('dayChanged data: ', data);
            }, function (err) {
                $log.error('error dayChanged masterTable scheduler: ', err);
                reject(err);
                // return list;
            }).$promise.then(function (data) {
                //order by facility name
                list = _.sortBy(data, 'label');
                _.forEach(list, function (item) {
                    if (item.branch && item.branch.description) {
                        item.branchDescription = item.branch.description;
                    } else {
                        item.branchDescription = '';
                    }
                    _.forEach(item.schedules, function (pSchedule) {
                        pSchedule.date = new Date(moment.utc(day).local());
                        pSchedule.start = new Date(pSchedule.dateFrom);
                        pSchedule.end = new Date(pSchedule.dateTo);
                        pSchedule.scheduleDay = day.toDate();

                        var bookedTo = pSchedule.involveds && pSchedule.involveds.length ? pSchedule.involveds[0] : pSchedule.createdBy;
                        pSchedule.title = bookedTo.item ? bookedTo.item.fullName : 'X X X';
                        pSchedule.text = strToInitials(bookedTo.item ? bookedTo.item.fullName : 'X X X');
                    });

                    item.text = item.description;
                    item.title = item.name;
                    item.rate = item.cost ? item.cost.value : 0;
                });
                iniTable(list);
                //overflow-y if there are more than 10 facilities
                vm.model.scroll = list.length > 10;
                vm.model.items = list;
                vm.model.scheduleDay = day;
                vm.list = list;
                vm.initialized = true;
                full(vm.model);
            });
        });
    };

    // TODO: Check and Remove if is useless
    function getSources(branchFiltered) {
        var list = [];
        var query = {idT: routeConf.planningRoom};
        if (vm.selectedBar && !vm.selectedBar.all) {
            query.branch = vm.selectedBar._id;
        }
        if (vm.dayFrom) {
            query.dateFrom = vm.dayFrom.toDate();
        }

        MasterTableService.query(query, function (data) {
            $log.debug('getSources data: ', data);
        }, function (err) {
            $log.error('getSources error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            // return list;
        }).$promise.then(function (data) {
            //order by facility name
            list = _.sortBy(data, 'label');
            _.forEach(list, function (rooms) {
                if (rooms.branch && rooms.branch.description) {
                    rooms.branchDescription = rooms.branch.description;
                } else {
                    rooms.branchDescription = '';
                }
                _.forEach(rooms.schedules, function (pSchedule) {
                    pSchedule.date = vm.dayFrom ? new Date(moment.utc(vm.dayFrom).local()) : moment();
                    pSchedule.start = new Date(pSchedule.dateFrom);
                    pSchedule.end = new Date(pSchedule.dateTo);
                    pSchedule.scheduleDay = vm.dayFrom?vm.dayFrom.toDate():vm.dayFrom;

                    var bookedTo = pSchedule.involveds && pSchedule.involveds.length ? pSchedule.involveds[0] : pSchedule.createdBy;
                    pSchedule.title = bookedTo.item ? bookedTo.item.fullName : 'X X X';
                    pSchedule.text = strToInitials(bookedTo.item ? bookedTo.item.fullName : 'X X X');
                });

                rooms.text = rooms.description;
                rooms.title = rooms.name;
                rooms.rate = rooms.cost ? rooms.cost.value : 0;
            });
            iniTable(list);
            //overflow-y if there are more than 10 facilities
            vm.model.scroll = list.length > 10;
            vm.model.items = list;
            vm.model.scheduleDay = vm.dayFrom;
            vm.list = list;
            vm.initialized = true;
            return vm.model;
        });

    }

    var viewParams = localStorageService.get('servicesViewParams') ?
        localStorageService.get('servicesViewParams') : {};

    if (vm.selectedBar && !vm.selectedBar.all) {
        viewParams = {filterServicesList: {branchDescription: vm.selectedBar.description}};
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.selectedBar = data;
        viewParams = {filterServicesList: {branchDescription: (!data.all) ? data.description : ''}};
        if($location.path() === '/occupancy') {
            getSources(data);
        }
    });
    $scope.$on('$destroy', unregister);

    vm.$onDestroy = function () {
        localStorageService.set('servicesViewParams', null);
    };

    function iniTable(list) {
        if (!list) {
            list = [];
        } else if (list.length > 0) {
            list[0].selected = true;
        }

        var sorting = viewParams['sortingServicesList'] ? viewParams['sortingServicesList'] : {title: 'asc'};
        var page = viewParams['pageServicesList'] ? viewParams['pageServicesList'] : 1;
        var count = viewParams['countServicesList'] ? viewParams['countServicesList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingServicesList'] = params._params.sorting;
                        viewParams['pageServicesList'] = page;
                        viewParams['countServicesList'] = params._params.count;
                        viewParams['filterServicesList'] = filterObj;
                        localStorageService.set('servicesViewParams', viewParams);

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterServicesList'] ? viewParams['filterServicesList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    vm.tableParamsCK = function (row) {
        if (vm.istour) {
            return;
        }
        if (vm.servic && ( vm.servic.action === 'inEdit' || vm.servic._id === '0' )) {
            vm.anim = false;
            vm.servic = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 500);
            }
            _.forEach(vm.tableParams.data, function (r) {
                r.selected = (r._id === row._id);
            });

            if (!vm.servicOri) {
                vm.servicOri = row._id;
            }
            vm.servic = row;
            vm.servic.notification = undefined;
            vm.servic.animNotification = false;
        }
    };

    vm.filterDescription = {
        branchDescription: {
            id: 'text'
        }
    };
    vm.filterTitle = {
        title: {
            id: 'text'
        }
    };
    vm.filterPrice = {
        rate: {
            id: 'number'
        }
    };
    vm.new = function () {
        vm.servic = {
            _id: '0'
        };
        vm.servic.action = 'new';
        _.forEach(vm.tableParams.data, function (r) {
            r.selected = false;
        });
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 417);
        }
    };

    vm.editRow = function (row) {
        vm.tableParamsCK(row);
        row.action = 'edit';
    };

    vm.deleteRow = function (row) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                var query = {idT: routeConf.app, idJ: routeConf.facility, idP: row._id};
                MasterTableService.delete(query, function (data) {
                    vm.$onInit();
                    // getSources();
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    $rootScope.$on('openServiceDetailFirstRow', function () {
        if (vm.tourDummyData.length < 1) {
            var row = vm.tableParams.data[0];
            if (vm.servic && ( vm.servic.action === 'inEdit' || vm.servic._id === '0' )) {
                vm.anim = false;
                vm.servic = null;
            } else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });

                if (!vm.servicOri) {
                    vm.servicOri = row._id;
                }
                vm.servic = row;
                vm.servic.notification = undefined;
                vm.servic.animNotification = false;
            }
        }
        else {
            vm.new();
        }
    });

    $rootScope.$on('openServiceDetail', function () {
        vm.new();
    });

    /** SCHEDULER */
    weeklySchedulerLocaleService.set(LanguageFactory.getLanguage).then(function ($locale) {
        $log.debug('The locale changed to', $locale.id);
    });
    vm.model = {
        options: {},
        locale: weeklySchedulerLocaleService.$locale.id,
        items: []
    };

    // vm.dayChanged = function (day) {
    //     return new Promise(function (full, reject) {
    //         vm.dayFrom = day.toDate();
    //         var query = {idT: routeConf.app, idJ: routeConf.findScheduledFacility, dateFrom: vm.dayFrom};
    //         if (vm.selectedBar && !vm.selectedBar.all) {
    //             query.branch = vm.selectedBar._id;
    //         }
    //         MasterTableService.query(query, function (data) {
    //             for (var i = 0; i < data.length; i++) {
    //                 for (var j = 0; j < data[i].schedules.length; j++) {
    //                     data[i].schedules[j].date = new Date(moment.utc(day).local());
    //                     data[i].schedules[j].start = new Date(data[i].schedules[j].dateFrom);
    //                     data[i].schedules[j].end = new Date(data[i].schedules[j].dateTo);
    //                     data[i].schedules[j].scheduleDay = day.toDate();
    //                     //data[i].schedules[j].color = '#F0F0F0';
    //                     //data[i].schedules[j].text = 'X';
    //                 }
    //             }
    //             //order by facility name
    //             data = _.sortBy(data, 'label');
    //             //overflow-y if there are more than 10 facilities
    //             vm.model.scroll = data.length > 10;
    //             vm.model.items = data;
    //             vm.model.scheduleDay = day;
    //             full(vm.model);
    //         }, function (err) {
    //             //TODO sweetalert
    //             $log.error('error dayChanged masterTable scheduler: ', err);
    //             reject(err);
    //         });
    //     });
    // };

    vm.openReserveModal = function (data, modeCancel, showReserveView) {
        var modalInstance = $uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/components/rooms/roomsReserve/modal/roomsReserveModal.html',
            controller: 'InServiceReserveModalController',
            controllerAs: 'mod',
            size: 'lg',
            backdrop: 'static',
            windowClass: 'roomsReserveModal',
            resolve: {
                data: function () {
                    return data;
                },
                modeCancel: function () {
                    return modeCancel;
                },
                showReserveView: function () {
                    return showReserveView;
                }
            }
        });
        modalInstance.result.then(
            //close
            function () {
                vm.$onInit();
            },
            //dismiss
            function () {
                $log.debug('IN SERVICE RESERVE MODAL CLOSED');
            }
        );
    };

    vm.$onInit = function () {
        vm.userBranch = localStorageService.get('branches');
        vm.rooms = {};
        vm.anim = false;
        //getSources();
    };

    /** Reload scheduler when info changes*/
    $rootScope.$on('refreshScheduler', function () {
        $timeout(function () {
            vm.showReserveView = false;
            vm.modeCancel = false;
            vm.$onInit();
        }, 200);
    });

    $rootScope.$on('showReserveNew', function (event, data) {
        // vm.servic =  data;
        // vm.modeCancel = false;
        // vm.showReserveView = true;

        //vm.openReserveModal(data, false, true);
    });

    $rootScope.$on('showReserveCancel', function (event, resource) {
        vm.servic.resourceToCancel = resource;
        // vm.modeCancel = true;
        // vm.showReserveView = true;

      //  vm.openReserveModal(vm.servic, true, true);
    });

    $rootScope.$on('moveReserve', function (event, data) {
        var query = {};
        query.idT = routeConf.planningRoom;
        query.idP = data._id;
        vm.sav = data;
        vm.sav.dateFrom = data.start;
        vm.sav.dateTo = data.end;
        vm.sav.dates = {dateFrom: data.start, dateTo: data.end};
        MasterTableService.post(query, vm.sav, function (response) {
            $log.debug('update reserve success', response);
            toastr.success(TranslationService.reserve.msg.edit);
            vm.showReserveView = false;
            vm.modeCancel = false;
            vm.$onInit();
        }, function (err) {
            $log.error('error update reserve ', err);
            var mensaje = err.data.error;
            var respuestaError = TranslationService.errors.e500;

            if (((mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405002) ) ||
                ((mensaje.error.code !== undefined ) && (mensaje.error.code === 405002 ))) {
                respuestaError = TranslationService.errors.ERR405002;
            } else {
                if (((mensaje.error['0'].err.error.code !== undefined) && (mensaje.error['0'].err.error.code === 405003) ) ||
                    ((mensaje.error.code !== undefined ) && (mensaje.error.code === 405003 ))) {
                    respuestaError = TranslationService.errors.ERR405003;
                }
            }
            toastr.error(respuestaError, TranslationService.errors.error,
                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            $rootScope.$emit('refreshScheduler');
            //getSources();
        });
    });
}

angular
    .module('BlurAdmin.roomsListCom')
    .component('roomsListCom', {
        templateUrl: 'app/components/rooms/roomsList/roomsList.html',
        controllerAs: 'rolc',
        controller: RoomsListController,
        bindings: {
            room: '=',
            anim: '='
        }
    });





function taskDetailController($log, MasterTableService, routeConf, TranslationService, localStorageService, toastr,
                              Lightbox, $rootScope, PermissionsService, Funcionalities, UsersServiceByBranch, Roles,
                              ConfigService, NgTableParams) {
    var vm = this;

    vm.hideSelectResidence = false;
    vm.disabledFields = false;
    vm.disableLocality = false;
    vm.accessPush = false;
    vm.newComment = '';
    vm.comments = [];
    vm.statusTypes = null;
    vm._CONTROLLER = 'taskDetailController';
    vm.tableParamsPeriods = null;
    vm.roleCodes = [];
    vm.workers = [];
    vm.selectedWorker = {};

    function setPermissions() {
        vm.disabledFields = !PermissionsService.gotPermission('INCIDENT', 'update');
        vm.accessPush = PermissionsService.gotPermission('PUSH', 'update');
    }

    vm.changeLocality = function () {
        getSpots(_.get(vm.task, 'branch._id')).then(function (dataSpots) {
            vm.listSpots = _.orderBy(dataSpots, 'description');
            vm.task.spot = null;
            getTaskTypes(_.get(vm.task, 'branch._id')).then(function (data) {
                vm.listTaskType = data;
                $rootScope.$digest();
            });
        });
    };

    vm.checkDates = function () {
        if (!_.get(vm.task, '_id')) {
            return vm.task && vm.task.createdDate && moment(vm.task.createdDate).endOf('day').isBefore(moment().endOf('day'));
        } else {
            return false;
        }
    };

    vm.saveTask = function (form) {
        vm.submitted = true;
        if (form.$valid) {
            var object;
            if (vm.modeCreation) {
                object = {
                    branch: _.get(vm.task, 'branch._id'),
                    spot: _.get(vm.task, 'spot._id'),
                    datePlanned: _.get(vm.task, 'createdDate'),
                    taskType: _.get(vm.task, 'taskType._id'),
                    comment: vm.newComment
                };
                MasterTableService.post({idT: routeConf.workerTask}, object, function (data) {
                    $log.debug('create task data: ', data);
                    vm.cancel();
                    vm.onUpdated('');
                }, function (err) {
                    $log.error('create task error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            } else {
                object = {
                    comments: vm.newComment,
                    assignedTo: vm.selectedWorker
                };
                MasterTableService.post({idT: routeConf.workerTask, idJ: vm.taskId}, object, function (data) {
                    $log.debug('create task data: ', data);
                    vm.cancel();
                    vm.onUpdated('');
                }, function (err) {
                    $log.error('update task error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }
    };

    vm.cancel = function () {
        vm.showTaskView = false;
        vm.anim = false;
        vm.modeCreation = false;
        vm.showCompleteList = false;
        vm.taskId = null;
    };

    vm.getWorkers = function () {
        var taskCodeGroup = vm.task.taskType.taskParent.code + 'Group';
        switch (taskCodeGroup) {
            case 'maintenanceGroup':
                vm.roleCodes = Roles.maintenanceGroup;
                break;
            case 'cleaningGroup':
                vm.roleCodes = Roles.cleaningWorker;
                break;
        }
        MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.role, code: vm.roleCodes}, function (roleData) {
            MasterTableService.get({idT: routeConf.user, role: roleData[0]._id, branch: vm.task.branch._id}, function (workerListData) {
                vm.workers = workerListData.data;
                $log.debug('Workers: ', vm.workers);
            }, function (errWorkerList) {
                $log.error('load masterTable user error: ', errWorkerList);
                toastr.error(TranslationService.errors.e500);
            });
        }, function (errRole) {
            $log.error('load masterTable role error: ', errRole);
            toastr.error(TranslationService.errors.e500);
        });
        // 2º Obtener el listado de los usuarios user?role=[id_rol]&branch=[id_residencia]
    };

    function formatTaskData(task) {
        task.createdDate = moment(task.datePlanned).toDate();
        return task;
    }

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        vm.cancel();
    });

    function init() {
        vm.popup = {
            opened: false
        };
        vm.dateOptions = {
            minDate: moment().toDate(),
            showWeeks: false
        };
        vm.tracking = {
            notify: false,
            priority: false
        };
        vm.getSourcesStatusType();
        vm.fileShowedArray = [];
        vm.disabledFields = false;
        if (!_.isEmpty(vm.taskId)) {
            MasterTableService.get({idT: routeConf.workerTask, idP: vm.taskId}, function (data) {
                $log.debug('load task detail data: ', data);
                setPermissions();
                vm.task = formatTaskData(data);
                vm.selectedWorker = _.get(vm.task, 'assignedTo.item');
                vm.getWorkers();
                vm.tableParamsPeriods =
                    new NgTableParams(
                        {
                            page: 1,
                            count: 5,
                            sorting: {
                                dateFormatFrom: 'desc'
                            }
                        },
                        {
                            total: vm.task.periods.length,
                            counts: [],
                            dataset: angular.copy(vm.task.periods)
                        }
                    );
            }, function (err) {
                $log.error('load task detail error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            vm.task.createdDate = Date.now();
            if (_.get(vm.task, 'branch._id')) {
                vm.disableLocality = true;
            }
        }
    }

    function getTaskTypes(branch) {
        return new Promise(function (full, reject) {
            ConfigService.query({
                functionality: 'taskTypes',
                code: 'cleaning'
            }, function (data) {
                $log.debug('ConfigService taskTypes data: ', data);
            }, function (err) {
                $log.error('ConfigService taskTypes error: ', err);
            }).$promise.then(function (data) {
                vm.cleaningTaskId = data[0] ? _.get(data[0], '_id') : null;
                var userBranch = localStorageService.get('branches');
                var query = {
                    idT: routeConf.masterTable,
                    idJ: routeConf.taskType,
                    branch: branch ? branch : userBranch
                };
                if (vm.cleaningTaskId) {
                    query.taskParent = vm.cleaningTaskId;
                }
                MasterTableService.query(query, function (data2) {
                    $log.debug('load taskType data: ', data2);
                }, function (err) {
                    $log.error('load taskType error: ', err);
                }).$promise.then(function (dataTypes) {
                    full(dataTypes);
                });
            });
        });
    }

    function getSpots(branch) {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.spot};
            query.branch = branch;
            MasterTableService.query(query, function (data) {
                $log.debug('load spots data: ', data);
            }, function (err) {
                $log.error('load spots error: ', err);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    function loadLocalities() {
        return new Promise(function (full, reject) {
            MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.branch}, function (data) {
                $log.debug('load masterTable branches data: ', data);
            }, function (err) {
                $log.error('load masterTable branches error: ', err);
                toastr.error(TranslationService.errors.e500);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    vm.getSourcesStatusType = function () {
        return new Promise(function (full, reject) {
            MasterTableService.query({
                idT: routeConf.masterTable,
                idJ: routeConf.statusType,
                functionality: 'workerTask',
                isLast: false,
                sortField: 'code'
            }, function (status) {
                vm.statusTypes = status;
            }, function (err) {
                $log.error('error load statusType', err);
            });
        });
    };

    vm.$doCheck = function () {
        if (vm.previousTaskId === undefined || vm.previousTaskId !== vm.taskId) {
            var selectedBar = localStorageService.get('selectedBarResidence');
            var userBranch = localStorageService.get('branches');
            if (userBranch.length === 1) {
                vm.hideSelectResidence = true;
                if (vm.modeCreation) {
                    if (!vm.task) {
                        vm.task = {};
                    }
                    vm.task.branch = {_id: userBranch};
                }
            } else {
                if (vm.modeCreation) {
                    if (!vm.task) {
                        vm.task = {};
                    }
                    vm.task.branch = (selectedBar && !selectedBar.all) ? selectedBar : undefined;
                }
            }

            vm.previousTaskId = vm.taskId;
            loadLocalities().then(function (dataLocalities) {
                vm.localities = dataLocalities;
                getSpots(_.get(vm.task, 'branch._id')).then(function (dataSpots) {
                    vm.listSpots = _.orderBy(dataSpots, 'description');
                    getTaskTypes(_.get(vm.task, 'branch._id')).then(function (dataTypes) {
                        vm.listTaskType = dataTypes;
                        init();
                        $rootScope.$digest();
                    });
                });
            });
        }
    };
}

angular
    .module('Tagaste.taskDetailCom')
    .component('taskDetail', {
        templateUrl: 'app/components/tasks/taskDetail/taskDetail.html',
        controllerAs: 'tdc',
        controller: taskDetailController,
        bindings: {
            taskId: '=',
            modeReadOnly: '=',
            showTaskView: '=',
            anim: '=',
            onUpdated: '&',
            modeCreation: '=',
            showDisabled: '<',
            showCompleteList: '='
        }
    });

function taskSchedulerDetailController($log, MasterTableService, routeConf, TranslationService, localStorageService, toastr,
                                       Lightbox, $rootScope, PermissionsService, NgTableParams) {
    var vm = this;

    vm.hideSelectResidence = false;
    vm.rangesopen = false;
    vm.previousTaskSchedulerId = undefined;
    vm.gotAccessCreate = false;
    vm.showError = false;
    vm.showTimetableError = false;
    var _slots = [
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0],
        [0, 0]
    ];

    function setPermissions() {
        vm.disabledFields = !PermissionsService.gotPermission('CLEANING', 'UPDATE');
        vm.gotAccessCreate = PermissionsService.gotPermission('CLEANING', 'UPDATE');
    }

    vm.$doCheck = function () {
        if (!vm.previousTaskSchedulerId || vm.previousTaskSchedulerId !== vm.taskSchedulerId) {
            vm.previousTaskSchedulerId = vm.taskSchedulerId;
            init();
        }
    };

    vm.checkDateFrom = function () {
        return _.get(vm.taskScheduler, 'dateFrom') && (moment(vm.taskScheduler.dateFrom).endOf('day').isBefore(moment()) ||
            (vm.taskScheduler.dateTo && moment(vm.taskScheduler.dateFrom).isSameOrAfter(moment(vm.taskScheduler.dateTo))));
    };

    vm.checkDateTo = function () {
        return _.get(vm.taskScheduler, 'dateTo') && (moment(vm.taskScheduler.dateTo).endOf('day').isBefore(moment()) ||
            (vm.taskScheduler.dateFrom && moment(vm.taskScheduler.dateFrom).isSameOrAfter(moment(vm.taskScheduler.dateTo))));
    };

    /**
     * @ngdoc method
     * @name changeLocality
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that detect a change of branch and reload spots data
     */
    vm.changeLocality = function () {
        getSourcesSpots(vm.taskScheduler.branch._id).then(function (dataSpots) {
            getSourcesTaskParent().then(function (dataParent) {
                getSourcesTaskType(dataParent, vm.taskScheduler.branch._id).then(function (dataTaskType) {
                    vm.listSpots = dataSpots;
                    vm.taskScheduler.spots = [];
                    vm.listTaskType = dataTaskType;
                    $rootScope.$digest();
                });
            });
        });
    };

    /**
     * @ngdoc method
     * @name getSourcesTaskParent
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that load tasks parent
     */
    function getSourcesTaskParent() {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.config};
            query.functionality = 'taskTypes';
            query.code = 'cleaning';
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load taskType', err);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    /**
     * @ngdoc method
     * @name getSourcesTaskType
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @param taskParent is the parent task id
     * @param branch
     * @description
     * Method that load tasks type
     */
    function getSourcesTaskType(taskParent, branch) {
        return new Promise(function (full, reject) {
            var userBranch = localStorageService.get('branches');
            var query = {
                idT: routeConf.masterTable,
                idJ: routeConf.taskType,
                branches: branch ? branch : userBranch
            };
            if (taskParent && taskParent[0] && taskParent[0]._id) {
                query.taskParent = taskParent[0]._id;
            }
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load taskType', err);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    /**
     * @ngdoc method
     * @name getSourcesSpots
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @param branch is the branch id
     * @description
     * Method that load tasks type
     */
    function getSourcesSpots(branch) {
        return new Promise(function (full, reject) {
            var query = {idT: routeConf.masterTable, idJ: routeConf.spot};
            query.branch = branch;
            MasterTableService.query(query, function (data) {
            }, function (err) {
                $log.error('error load spots', err);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    function getSlotsFromTimetable(timetable) {
        for (var i = 0; i < timetable.length; i++) {
            var day = timetable[i].isoWeekDay - 1;
            vm.slots[day][0] = timetable[i]['isMorning'];
            vm.slots[day][1] = timetable[i]['isAfternoon'];
        }
    }

    /**
     * @ngdoc method
     * @name formatTimetable
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that format time table data
     * @return an object collection with time table formatted
     */
    function formatTimetable() {
        var timetable = [];
        for (var i = 0; i < vm.slots.length; i++) {
            if (vm.slots[i][0] !== 0 || vm.slots[i][1] !== 0) {
                timetable.push({isoWeekDay: i + 1, isMorning: vm.slots[i][0], isAfternoon: vm.slots[i][1]});
            }
        }
        return timetable;
    }

    /**
     * @ngdoc method
     * @name checkSelectedTimetable
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that check if a time scheduler has been selected
     * @return boolean true if a time scheduler has been selected, false otherwise
     */
    function checkSelectedTimetable() {
        var selected = false;
        var i = 0;
        while (i < vm.slots.length && !selected) {
            if (vm.slots[i][0] === true || vm.slots[i][1] === true) {
                selected = true;
            }
            i++;
        }
        vm.showTimetableError = !selected;
        return selected;
    }

    /**
     * @ngdoc method
     * @name saveTaskScheduler
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that save a task scheduler
     */
    vm.saveTaskScheduler = function (form) {
        vm.showError = false;
        if (!form.$valid) {
            checkSelectedTimetable();
            vm.showError = true;
        } else {
            if (!checkSelectedTimetable()) {
                return;
            }
            var timetable = formatTimetable();
            var dataToSend = {};
            var query = {};
            dataToSend.name = vm.taskScheduler.name;
            if (vm.taskScheduler.comment) {
                dataToSend.comment = vm.taskScheduler.comment;
            }
            dataToSend.spots = _.map(vm.taskScheduler.spots, '_id');
            dataToSend.taskType = vm.taskScheduler.taskType._id;
            dataToSend.timetable = timetable;
            dataToSend.branch = vm.taskScheduler.branch._id;
            dataToSend.dateFrom = vm.taskScheduler.dateFrom;
            dataToSend.dateTo = vm.taskScheduler.dateTo;
            // dataToSend.excludedRanges = vm.taskScheduler.excludedRanges;
            dataToSend.excludedRanges = vm.rangesTableParams.data;
            query.idT = routeConf.planner;
            if (vm.modeEdit) {
                dataToSend._id = vm.taskScheduler._id;
                query.idJ = vm.taskScheduler._id;
            }
            MasterTableService.post(query, dataToSend, function (response) {
                vm.showTaskSchedulerView = false;
                vm.anim = false;
                vm.taskScheduler = {};
                vm.onUpdated({value: ''});
                if (vm.modeEdit) {
                    vm.modeEdit = false;
                    toastr.success(TranslationService.taskDetail.msg.edit);
                } else {
                    vm.modeCreation = false;
                    toastr.success(TranslationService.taskDetail.msg.create);
                }
            }, function (err) {
                $log.error('error create bulletin');
                toastr.error(TranslationService.errors.e500, TranslationService.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }
    };

    /**
     * @ngdoc method
     * @name init
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that load  initials data
     */
    function init() {
        vm.disabledFields = false;
        vm.slots = angular.copy(_slots);
        if (vm.modeReadOnly || vm.modeEdit) {
            MasterTableService.get({idT: routeConf.planner, idJ: vm.previousTaskSchedulerId}, function (data) {
                if (data.dateFrom) {
                    data.dateFrom = moment(data.dateFrom).toDate();
                }
                if (data.dateTo) {
                    data.dateTo = moment(data.dateTo).toDate();
                }
                vm.taskScheduler = data;
                setPermissions();
                initRangesTable(_.get(vm.taskScheduler, 'excludedRanges', []));
                getSlotsFromTimetable(vm.taskScheduler.timetable);
            }, function (err) {
                $log.error('error load incident detail', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        } else {
            setPermissions();
            vm.taskScheduler = {};
            initRangesTable([]);
        }

        loadAllLocalities().then(function (data) {
            var allLocalities = data;
            var selectedBar = localStorageService.get('selectedBarResidence');
            var userBranch = localStorageService.get('branches');
            if (userBranch.length === 1) {
                vm.hideSelectResidence = true;
                if (vm.modeCreation) {
                    vm.taskScheduler.branch = {_id: userBranch};
                }
            } else {
                if (vm.modeCreation) {
                    vm.taskScheduler.branch = (selectedBar && !selectedBar.all) ? selectedBar : undefined;
                }
            }
            vm.localities = [];
            for (var i = 0; i < allLocalities.length; i++) {
                for (var j = 0; j < userBranch.length; j++) {
                    if (userBranch[j] === allLocalities[i]._id) {
                        vm.localities.push(allLocalities[i]);
                    }
                }
            }
            if (vm.taskScheduler && vm.taskScheduler.branch) {
                getSourcesSpots(vm.taskScheduler.branch._id).then(function (dataSpots) {
                    getSourcesTaskParent().then(function (dataParent) {
                        getSourcesTaskType(dataParent).then(function (dataTaskType) {
                            vm.listSpots = dataSpots;
                            vm.listTaskType = dataTaskType;
                            $rootScope.$digest();
                        });
                    });
                });
            }
        });
    }

    /**
     * @ngdoc method
     * @name cancel
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that redirect to list of task
     */
    vm.cancel = function () {
        vm.showTaskSchedulerView = false;
        vm.anim = false;
        vm.modeCreation = false;
        vm.modeEdit = false;
    };

    /**
     * @ngdoc method
     * @name loadAllLocalities
     * @methodOf Tagaste.taskSchedulerDetailCom.controller:taskSchedulerDetailController
     * @description
     * Method that load all localities of a user
     *
     */
    function loadAllLocalities() {
        return new Promise(function (full, reject) {
            MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.branch}, function (data) {
            }, function (err) {
                $log.error('error load masterTable branch', err);
                toastr.error(TranslationService.errors.e500);
            }).$promise.then(function (data) {
                full(data);
            });
        });
    }

    /** Excluded task dates ranges functions */
    function initRangesTable(list) {
        _.forEach(list, function (item) {
            item.dateFrom = Date.parse(item.dateFrom);
            item.dateTo = Date.parse(item.dateTo);
        });
        vm.rangesTableParams =
            new NgTableParams(
                {
                    page: 1,
                    count: 5,
                    sorting: {
                        dateFrom: 'asc'
                    }
                },
                {
                    counts: [5, 10, 20],
                    total: list.length,
                    dataset: angular.copy(list)
                }
            );
    }

    vm.addRange = function () {
        vm.addingRange = true;
        vm.rangesTableParams.settings().dataset.unshift({
            dateFrom: '',
            dateTo: '',
            modeEdit: true
        });
        vm.rangesTableParams.page(1);
        vm.rangesTableParams.reload();
    };

    vm.editRange = function (range, index) {
        vm.addingRange = true;
        if (index !== 0 || range._id) {
            vm.tempRange = angular.copy(range);
        }
        range.modeEdit = true;
        vm.temporalRange = angular.copy(range);
    };

    vm.cancelRange = function (range, index) {
        range.modeEdit = false;
        if (!_.get(range, '_id') && !vm.tempRange) {
            _.pullAt(vm.rangesTableParams.settings().dataset, [0]);
        } else {
            _.forEach(vm.rangesTableParams.settings().dataset, function (item, index) {
                if (item._id === _.get(vm.tempRange, '_id')) {
                    vm.rangesTableParams.settings().dataset[index] = vm.tempRange;
                }
            });
            vm.rangesTableParams.data[index] = vm.tempRange;
        }
        if (vm.addingRange) {
            vm.rangesTableParams.reload();
            vm.addingRange = false;
        }
        if (vm.tempRange) {
            vm.tempRange = null;
        }
    };

    vm.saveRange = function (range, index) {
        if (moment(range.dateTo).isSameOrAfter(moment(range.dateFrom))) {
            vm.addingRange = false;
            if (!vm.taskScheduler.excludedRanges) {
                vm.taskScheduler.excludedRanges = [];
            }
            if (vm.tempRange) {
                _.forEach(vm.rangesTableParams.settings().dataset, function (item, index) {
                    if (item === vm.tempRange) {
                        vm.rangesTableParams.settings().dataset[index] = range;
                    }
                });
                vm.rangesTableParams.data[index] = range;
            }
            range.modeEdit = false;
        } else {
            toastr.warning(TranslationService.errors.checkdates);
        }
    };

    vm.deleteRange = function (range, index) {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                _.remove(vm.rangesTableParams.settings().dataset, function (item) {
                    return range === item;
                });
                vm.rangesTableParams.page(1);
                vm.rangesTableParams.reload();
            }
        });
    };
}

angular
    .module('Tagaste.taskSchedulerDetailCom')
    .component('taskSchedulerDetail', {
        templateUrl: 'app/components/tasks/taskSchedulerDetail/taskSchedulerDetail.html',
        controllerAs: 'tsd',
        controller: taskSchedulerDetailController,
        bindings: {
            taskSchedulerId: '=',
            modeReadOnly: '=',
            showTaskSchedulerView: '=',
            anim: '=',
            onUpdated: '&',
            modeCreation: '=',
            modeEdit: '=',
            showDisabled: '<'
        }
    });

function taskSchedulerListController(NgTableParams, NgTableFilterService, $log, $timeout, localStorageService, TourService,
                                 $rootScope, PermissionsService, $filter, $location, tmhDynamicLocale, TranslationService,
                                     MasterTableService, toastr, routeConf, $scope) {
    var vm = this;

    vm.tableParams = {};
    vm.selectTaskScheduler = null;
    vm.showTaskSchedulerView = false;
    vm.gotAccessCreate = false;
    vm.gotAccessDel = false;

    function setPermissions() {
        vm.gotAccessCreate = PermissionsService.gotPermission('CLEANING', 'UPDATE');
        vm.gotAccessDel = PermissionsService.gotPermission('CLEANING', 'delete');
    }

    var viewParams = localStorageService.get('taskSchedulerViewParams') ?
        localStorageService.get('taskSchedulerViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = {filterTaskSchedulerList: {locality: selectedBar.description}};
    }

    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/tasks') {
            viewParams = {filterTaskSchedulerList: {locality: (!data.all) ? data.description : ''}};
            vm.showTaskSchedulerView = false;
            vm.anim = false;
            vm.modeReadOnly = false;
            vm.modeCreation = false;
            vm.modeEdit = false;
            initTable(vm.list);
        }
    });

    $scope.$on('$destroy', unregister);

    $rootScope.$on('taskListClick', function (event, data) {
        _.forEach(vm.list, function (item) {
            item.selected = false;
        });
        vm.modeEdit = false;
        vm.modeCreation = false;
        initTable(vm.list);
    });

    vm.$onInit = function () {
        setPermissions();
        tmhDynamicLocale.set(moment.locale());
        vm.userBranch = localStorageService.get('branches');
        vm.tableParams = null;
        initTable(vm.list);
    };

    vm.$onChanges = function (changeValue) {
        vm.pagg = vm.pag;
        if (changeValue.list && changeValue.list.currentValue) {
            initTable(changeValue.list.currentValue);
        }
    };

    /**
     * @ngdoc method
     * @name iniTable
     * @methodOf Tagaste.incidentsListCom.controller:incidentsListController
     * @description
     * Method that load all data in table
     * @param list array data to initialize the table
     */
    function initTable(list) {
        if (!list) {
            list = [];
        }
        for (var i = 0; i < list.length; i++) {
            if(list[i].branch.description) {
                list[i].locality = list[i].branch.description;
            } else {
                list[i].locality = 'Sin definir';
            }
            if(list[i].timetable && list[i].timetable.length > 0) {
                list[i].morning = '';
                list[i].afternoon = '';
                list[i].isoWeekDay = [];
                _.forEach(list[i].timetable, function (r) {
                    if(r.isMorning || r.isAfternoon) {
                        list[i].isoWeekDay.push({day : (moment().isoWeekday(r.isoWeekDay).format('ddd')).slice(0, -1),
                        momentOfDay : r.isMorning && r.isAfternoon ? TranslationService.morningAfternoon : r.isMorning ? TranslationService.morning : TranslationService.afternoon});
                    }
                });
            }
        }

        var sorting = viewParams['sortingTaskSchedulerList'] ? viewParams['sortingTaskSchedulerList'] : {timeOut: 'desc'};
        var page = viewParams['pageTaskSchedulerList'] ? viewParams['pageTaskSchedulerList'] : 1;
        var count = viewParams['countTaskSchedulerList'] ? viewParams['countTaskSchedulerList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingTaskSchedulerList'] = params._params.sorting;
                        viewParams['pageTaskSchedulerList'] = page;
                        viewParams['countTaskSchedulerList'] = params._params.count;
                        viewParams['filterTaskSchedulerList'] = filterObj;
                        localStorageService.set('taskSchedulerViewParams', viewParams);

                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterTaskSchedulerList'] ? viewParams['filterTaskSchedulerList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    /**
     * @ngdoc method
     * @name tableParamsCK
     * @methodOf Tagaste.incidentsListCom.controller:incidentsListController
     * @description
     * Method that marked a row of table and show detail of bulletin
     *
     */
    vm.tableParamsCK = function (row) {
        if (vm.istour) {
            return;
        }
        if (!row.error) {
            $rootScope.$emit('taskSchedulerListClick');
            if (vm.modeCreation || vm.modeEdit) {
                vm.showTaskSchedulerView = false;
                vm.anim = false;
                vm.modeReadOnly = false;
                vm.modeCreation = false;
                vm.modeEdit = false;

            } else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });
                vm.modeReadOnly = true;
                vm.showTaskSchedulerView = true;
                vm.modeCreation = false;
                vm.modeEdit = false;
                vm.selectTaskScheduler = row._id;
            }
            vm.showTaskView = false;
        }
    };

    vm.filterLocality = {
        locality: {
            id: 'text'
        }
    };
    vm.filterName = {
        name: {
            id: 'text'
        }
    };


    vm.editRow = function(row) {
        vm.tableParamsCK(row);
        vm.modeEdit = true;
        vm.modeReadOnly = false;
    };

    vm.deleteRow = function (row) {
        if (vm.istour){
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                MasterTableService.delete({idT: routeConf.planner,idJ: row._id}, function (data) {
                    vm.onDeleted('');
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    $log.error('ResidentsService delete error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        });
    };

    /**
     * @ngdoc method
     * @name newTaskScheduler
     * @methodOf Tagaste.taskSchedulerListCom.controller:taskSchedulerListController
     * @description
     * Method that redirect to create new task scheduler
     *
     */
    vm.newTaskScheduler = function() {
        vm.modeEdit = false;
        vm.modeReadOnly = false;
        vm.modeCreation = true;
        vm.showTaskSchedulerView = true;
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
    };
}

angular
    .module('Tagaste.taskSchedulerListCom')
    .component('taskSchedulerList', {
        templateUrl: 'app/components/tasks/taskSchedulerList/taskSchedulerList.html',
        controllerAs: 'tsl',
        controller: taskSchedulerListController,
        bindings: {
            selectTaskScheduler: '=',
            list: '<',
            pag:'<',
            anim:'=',
            showTaskSchedulerView:'=',
            modeReadOnly: '=',
            modeEdit:'=',
            onDeleted: '&',
            modeCreation: '=',
            showTaskView:'='
        }
    });

function tasksListController(NgTableParams, NgTableFilterService, $log, $timeout, localStorageService, TourService,
    $rootScope, PermissionsService, $filter, TranslationService, routeConf, MasterTableService, toastr, TaskExportService, FileSaver) {
    var vm = this;

    vm.tableParams = {};
    vm.selectTask = null;
    vm.showTaskView = false;
    vm.gotAccessCreate = false;
    vm.gotAccessDelete = false;

    vm.taskStatus = 'all';

    var viewParams = localStorageService.get('tasksViewParams') ?
        localStorageService.get('tasksViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = { filterTasksList: { branchDescription: selectedBar.description } };
    }

    $rootScope.$on('taskSchedulerListClick', function (event, data) {
        _.forEach(vm.list, function (item) {
            item.selected = false;
        });
        vm.modeCreation = false;
        initTable(vm.list);
    });

    function setPermissions() {
        vm.gotAccessCreate = PermissionsService.gotPermission('INCIDENT', 'UPDATE');
        vm.gotAccessDelete = (PermissionsService.gotPermission('MAINTENANCE', 'UPDATE') ||
            PermissionsService.gotPermission('CLEANING', 'UPDATE') ||
            PermissionsService.gotPermission('USER', 'UPDATE'));
    }

    vm.tableParamsCK = function (row, mode) {
        if (!row.error) {
            $rootScope.$emit('taskListClick');
            if (vm.modeCreation) {
                vm.showTaskView = false;
                vm.anim = false;
                vm.modeReadOnly = false;
                vm.modeCreation = false;
            } else {
                if (!vm.anim) {
                    $timeout(function () {
                        vm.anim = true;
                    }, 401);
                }
                _.forEach(vm.tableParams.data, function (r) {
                    r.selected = (r._id === row._id);
                });
                vm.modeReadOnly = !(mode && mode === 'edit');
                vm.showTaskView = true;
                vm.modeCreation = false;
                vm.selectTask = row._id;
                $log.debug('selected task: ', row);
            }
            vm.showTaskSchedulerView = false;
        }
    };

    vm.editTask = function (task) {
        vm.tableParamsCK(task, 'edit');
    };

    vm.newTask = function () {
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 401);
        }
        vm.modeReadOnly = false;
        vm.showTaskView = true;
        vm.modeCreation = true;
    };

    vm.exportData = function () {
        var tranlator = TranslationService.tasks;
        var filename = tranlator.title.replace(/\s/gi, '-').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = tranlator.export;
        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function(e) { return e._id; }),
            filename: filename
        };

        TaskExportService.post({}, requestData, function (data) {
            var blob = new Blob([new Uint8Array(data.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, filename + '.xlsx');
        }, function (err) {
            $log.error('TaskExportService export error: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                { progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true });
        });
    };


    vm.deleteRow = function (row) {
        if (vm.istour) {
            return;
        }
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                var query = { idT: routeConf.workerTask, idP: row._id };
                MasterTableService.delete(query, function (data) {
                    vm.$onInit();
                    vm.onDeleted({ value: '' });
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        { progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true });
                });
            }
        });
    };

    function initTable(list) {
        if (!list) {
            list = [];
        }

        var sorting = viewParams['sortingTasksList'] ? viewParams['sortingTasksList'] : { timeOut: 'desc' };
        var page = viewParams['pageTasksList'] ? viewParams['pageTasksList'] : 1;
        var count = viewParams['countTasksList'] ? viewParams['countTasksList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParams =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingTasksList'] = params._params.sorting;
                        viewParams['pageTasksList'] = page;
                        viewParams['countTasksList'] = params._params.count;
                        viewParams['filterTasksList'] = filterObj;
                        localStorageService.set('tasksViewParams', viewParams);
                        vm.currentTableData = filteredData;
                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterTasksList'] ? viewParams['filterTasksList'] : {};
        vm.tableParams.filter(savedFilters);
        vm.tableParams.page(page);
    }

    function formatListData() {
        _.forEach(vm.list, function (item) {
            item['branchDescription'] = _.get(item, 'branch.description', '');
            item['spotDescription'] = _.get(item, 'spot.description', '');
            item['taskTypeDescription'] = _.get(item, 'taskType.description', '');
            item['statusDescription'] = _.get(item, 'status.description', '');
        });
    }

    function loadFilters() {
        vm.filterLocality = {
            branchDescription: {
                id: 'text'
            }
        };
        vm.filterPlace = {
            spotDescription: {
                id: 'text'
            }
        };
        vm.filterDate = {
            datePlanned: {
                id: 'text'
            }
        };
        vm.filterType = {
            taskTypeDescription: {
                id: 'text'
            }
        };
        vm.filterStatus = {
            statusDescription: {
                id: 'text'
            }
        };
    }

    vm.applyAdditionalFilters = function (option) {
        var list = JSON.parse(JSON.stringify(vm.list));
        var filteredList1 = vm.changeStatusFilter(list);
        initTable(filteredList1);
    };

    vm.changeStatusFilter = function (list) {
        if (vm.taskStatus === true) {
            return _.filter(list, function (i) {
                return _.toNumber(_.get(i, 'status.code')) === 3;
            });
        } else if (vm.taskStatus === false) {
            return _.filter(list, function (i) {
                return _.toNumber(_.get(i, 'status.code')) === 2;
            });
        } else {
            return list;
        }
    };

    $rootScope.$on('selectedBarBranChanged', function (event, data) {
        viewParams = { filterTasksList: { branchDescription: (!data.all) ? data.description : '' } };
        vm.showTaskView = false;
        vm.anim = false;
        vm.modeReadOnly = false;
        vm.modeCreation = false;
        initTable(vm.list);
    });

    $rootScope.$on('openTaskDetail', function () {
        vm.newTask();
    });

    vm.$onChanges = function (changeValue) {
        vm.pagg = vm.pag;
        if (changeValue.list && changeValue.list.currentValue) {
            initTable(changeValue.list.currentValue);
        }
    };

    vm.$onDestroy = function () {
        localStorageService.set('tasksViewParams', null);
    };

    vm.$onInit = function () {
        setPermissions();
        loadFilters();
        formatListData();
        vm.userBranch = localStorageService.get('branches');
        vm.tableParams = null;
        initTable(vm.list);
    };
}

angular
    .module('Tagaste.tasksListCom')
    .component('tasksList', {
        templateUrl: 'app/components/tasks/tasksList/tasksList.html',
        controllerAs: 'tlstc',
        controller: tasksListController,
        bindings: {
            selectTask: '=',
            list: '<',
            pag: '<',
            modeReadOnly: '=',
            showTaskView: '=',
            anim: '=',
            onDeleted: '&',
            modeCreation: '=',
            showTaskSchedulerView: '='
        }
    });

/*
 * @author lavg
 * created on 17/13/2017
 */

// UserDetailController.$inject = [];

UserDetailController.$inject = ['$routeParams', 'UsersService', 'toastr', 'TranslationService', 'Roles', '$filter',
    'MasterTableService', 'routeConf', '$log', 'ValidationService', '$rootScope',
    'localStorageService', 'PermissionsService', 'FileSaver', '$http', 'Lightbox',
    '$window', 'UsersServiceCancelAccess'];

function UserDetailController($routeParams, UsersService, toastr, TranslationService, Roles, $filter,
                              MasterTableService, routeConf, $log, ValidationService, $rootScope,
                              localStorageService, PermissionsService, FileSaver, $http, Lightbox,
                              $window, UsersServiceCancelAccess) {
    var vm = this;

    vm.userOri = {};
    vm.ready = false;
    vm.showPwd = false;
    vm.changePasswordMode = false;
    vm.mailExist = false;
    vm.usernameOrigModif = '';
    vm.avatar = '';
    vm.avatarOri = '';
    vm.submitted = false;
    vm.avatarUploading = false;
    vm.initialized = false;
    vm.fileUploading = false;
    vm.otherinfoopen = false;
    vm.medicalinopen = false;
    vm.gotAccessMedical = false;
    vm.staysopen = false;
    vm.absencesopen = false;
    vm.guestsopen = false;
    vm.historyopen = false;
    vm.attachedsfoopen = false;
    vm.attachment = undefined;
    vm.filesAux = [];

    vm._CONTROLLER = 'UserDetailController';

    function setPermissions() {
        vm.gotAccessMedical = PermissionsService.gotPermission('MEDICAL', 'read');
    }

    vm.$doCheck = function () {
        if (vm.user && (vm.user._id !== vm.userOri._id)) {
            vm.userOri._id = angular.copy(vm.user._id);
            vm.ready = false;
            vm.showPwd = false;
            vm.initialized = false;
            vm.$onInit();
            vm.avatar = '';
            vm.avatarOri = '';
        }
    };

    vm.validateMobile = function (mobile, formInput) {
        var valid = true;
        if (!formInput.$pristine && mobile !== '') {
            valid = ValidationService.validMobile(mobile);
        }
        formInput.$setValidity('valid', valid);
        return valid;
    };

    vm.emailInUse = function (email, formInput) {
        var query = {
            username: email
        };
        if (vm.usernameOrigModif !== vm.userBD.username) {
            UsersService.get(query, function (data) {
                vm.mailExist = (data.count > 0);
                formInput.$setValidity('valid', vm.mailExist);
            }, function (error) {
                $log.error('UsersService get error: ', error);
                vm.mailExist = false;
                formInput.$setValidity('valid', vm.mailExist);
            });
        }
    };

    vm.validEmail = function (emailField, formInput) {
        // TODO FIX validation Service error
        var reg = /^([\u00F1A-Za-z0-9_\-\.])+\@([\u00F1A-Za-z0-9_\-\.])+\.([\u00F1A-Za-z]{2,})$/;
        reg = new RegExp(reg);
        var valid = true;
        if (emailField) {
            valid = (!emailField || formInput.$pristine || reg.test(emailField));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };


    vm.validPassWord = function (formInput, formInputB) {
        var valid = true;
        if (formInput && formInputB) {
            valid = (!vm.changePasswordMode ||
                (formInput.$pristine ||
                    formInputB.$pristine) ||
                (vm.trimText(vm.userBD.reNewPass).length >= 6 &&
                    vm.trimText(vm.userBD.newPass).length >= 6 &&
                    vm.trimText(vm.userBD.reNewPass) === vm.trimText(vm.userBD.newPass)));
            formInput.$setValidity('valid', valid);
        }
        return valid;
    };

    vm.trimText = function (value) {
        if (angular.isString(value)) {
            value.replace(/^\s+|\s+$/g, '');
        }
        return value;
    };

    vm.changeExtraRole = function (rol) {
        if (!vm.readonly) {
            vm.userBD.extraRoles = vm.userBD.extraRoles ? vm.userBD.extraRoles : [];
            _.forEach(vm.constants.roles, function (r) {
                if (r.isExtraRole && (rol._id === r._id)) {
                    r.selected = !r.selected;
                    if (r.selected) {
                        vm.userBD.extraRoles.push(r);
                    } else {
                        _.remove(vm.userBD.extraRoles, function (item) {
                            return r._id === item._id;
                        });
                    }
                }
            });
        }
    };

    vm.changeBasicRole = function (rol) {
        if (!vm.readonly) {
            vm.userBD.role = rol;
            _.forEach(vm.constants.roles, function (r) {
                if (!r.isExtraRole) {
                    r.selected = (rol._id === r._id);
                }
            });
            if (!vm.userBD.branches) {
                vm.userBD.branches = [];
            }
            vm.userBD.branches = (rol.code === Roles.director) ? vm.constants.branch :
                (!vm.userBD.branches) ? vm.userBD.branches.push(vm.constants.branch[0]) : vm.userBD.branches;
        }
    };

    vm.changePassword = function () {
        vm.changePasswordMode = true;
    };

    vm.changeAllerge = function (all, resForm) {
        if (!vm.readonly) {
            resForm.$setDirty();
            all.selected = !all.selected;
        }
    };

    vm.$onInit = function () {
        vm.readonly = !(vm.user.action && (vm.user.action === 'edit' || vm.user.action === 'new'));

        if (vm.user.action === 'edit') {
            vm.user.action = 'inEdit';
        }

        if (vm.initialized) {
            return;
        }

        vm.userOri._id = angular.copy(vm.user._id);
        vm.allergies = angular.copy(vm.constants.allergies);

        if (vm.user.action !== 'reflist') {
            vm.constants.roleCodes = Roles;
            vm.userBD = {
                newPass: '',
                reNewPass: ''
            };

            if (vm.user._id === '0') {
                vm.changePasswordMode = (vm.user.action === 'new');
                vm.showPwd = true;
                vm.userBD = {
                    branches: [],
                    username: '',
                    active: true,
                    newPass: '',
                    reNewPass: ''
                };

                var selectedBar = localStorageService.get('selectedBarResidence');
                if (selectedBar && !selectedBar.all) {
                    vm.userBD.branches.push(selectedBar);
                }

                vm.avatar = '';
                vm.avatarOri = '';
                vm.user.name = TranslationService.users.titleNew;
                //By default when creating new user, assing first role level
                vm.changeBasicRole(_.first(vm.constants.roles));

                vm.userBD.allergy = {};
                vm.userBD.attacheds = [];

                vm.user.attacheds = [];
                vm.ready = true;
            } else {
                vm.showPwd = false;
                UsersService.query({idU: vm.user._id}, function (data) {
                    vm.userBD = data;
                    vm.userBD.tokenApp = _.toString(data.tokenApp) === 'true';
                    vm.usernameOrigModif = angular.copy(data.username);
                    vm.userBD.newPass = '';
                    vm.userBD.reNewPass = '';
                    vm.userBD.extraRoles = [];
                    //attacheds
                    if (!vm.userBD.attacheds) {
                        vm.userBD.attacheds = [];
                    }
                    _.forEach(vm.constants.roles, function (cRoles) {
                        cRoles.selected = false;
                    });
                    if (vm.userBD.role && _.castArray(vm.userBD.role).length > 0) {
                        _.forEach(_.castArray(vm.userBD.role), function (userRol) {
                            _.forEach(vm.constants.roles, function (cRol) {
                                if (userRol._id && userRol._id === cRol._id) {
                                    cRol.selected = true;
                                    if (cRol.isExtraRole) {
                                        vm.userBD.extraRoles.push(cRol);
                                    } else {
                                        vm.userBD.role = cRol;
                                    }
                                }
                            });
                        });
                    }

                    if (vm.userBD.photo && vm.userBD.photo.original.key) {
                        MasterTableService.get({
                            idT: routeConf.file, idJ: routeConf.signedUrl, key: vm.userBD.photo.original.key,
                            bucket: vm.userBD.photo.original.bucket
                        }, function (data) {
                            vm.avatar = data.url;
                            vm.avatarOri = angular.copy(data.url);
                        }, function (err) {
                            $log.error('error getting img from aws', data.url);
                            toastr.error(TranslationService.errors.e500);
                        });
                    }

                    if (vm.userBD.allergy) {
                        if (vm.userBD.allergy.allergyTypes) {
                            _.forEach(vm.userBD.allergy.allergyTypes, function (all) {
                                _.find(vm.allergies, function (conAll) {
                                    return conAll._id === all._id;
                                }).selected = true;
                            });
                        }
                    } else {
                        vm.userBD.allergy = {};
                    }

                    if (!vm.userBD.attacheds) {
                        vm.userBD.attacheds = [];
                    }

                }, function (err) {
                    $log.error('UsersService query error: ', err);
                    toastr.error(TranslationService.errors.e500);
                    vm.user = {};
                    vm.ready = true;
                });
            }
        }

        vm.initialized = true;
        setPermissions();
    };

    vm.deleteAttach = function (attachment) {
        $log.debug('deleteAttach', attachment);
        _.remove(vm.userBD.attacheds, function (item) {
            if (item._id) {
                return item._id === attachment._id;
            } else {
                return item.original.key === attachment.original.key;
            }
        });
        if (!vm.userBD.attachToDelete) {
            vm.userBD.attachToDelete = [];
        }
        vm.userBD.attachToDelete.push({_id: attachment._id});
    };

    function getTypeFile(extension) {
        var classExtension = '';
        switch (extension) {
            case 'pdf':
                classExtension = 'pdf';
                break;
            case 'docx':
                classExtension = 'docx';
                break;
            case 'png':
            case 'jpg':
            case 'gif':
            case 'bmp':
            case 'ico':
                classExtension = 'img';
                break;
            case 'xls':
            case 'xlt':
                classExtension = 'xls';
                break;
            case 'txt':
            case 'srt':
                classExtension = 'txt';
                break;
            case 'zip':
            case 'rar':
            case '7z':
                classExtension = 'rar';
                break;
            case 'avi':
            case 'mpeg':
            case 'mp4':
            case 'asf':
                classExtension = 'video';
                break;
            case 'mp3':
            case 'ra':
            case 'wav':
                classExtension = 'audio';
                break;
        }

        return classExtension;
    }

    vm.openLightboxModal = function (file) {
        var nameSplitted = file.filename.split('.');
        file.extension = nameSplitted.pop();
        var extension = getTypeFile(file.extension);
        var urlDownload = '';
        MasterTableService.get({
            idT: routeConf.file, idJ: routeConf.signedUrl, key: file.original.key,
            bucket: file.original.bucket
        }, function (data) {
            file.url = data.url;
            file.type = extension;
            urlDownload = data.url;
            if (extension === 'img' || extension === 'video') {
                var index = _.findIndex(vm.filesAux, {'_id': file._id});
                if (index < 0) {
                    vm.filesAux.push(file);
                    index = vm.filesAux.length - 1;
                }
                Lightbox.openModal(vm.filesAux, index);
            } else if (extension === 'pdf') {
                $window.open(file.url);
            } else {
                var config = {responseType: 'blob'};
                $http.get(file.url, config).then(function (response) {
                    $log.debug('response', response);
                    var data = response.data;
                    FileSaver.saveAs(data, file.filename, true);
                }).catch(function (response) {
                    $log.error(response.message);
                    toastr.error(response.message, TranslationService.warning,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }, function (err) {
            $log.debug('error load attached file', err);
        });
    };

    vm.configava = function (renew) {
        // if (renew) {
        //     UsersRenewAccessService.post({idR: vm.userBD._id}, function (data) {
        //         vm.showConfigava = false;
        //         vm.userBD.tokenApp = {};
        //         toastr.success(TranslationService.users.renewAccessOK);
        //     });
        // } else {
        // UsersService.post({idR: vm.userBD._id}, {}, function (data) {
        //     vm.showConfigava = false;
        //     vm.userBD.tokenApp = null;
        //     toastr.success(TranslationService.users.cancelAccessOK);
        // });
        // }
        UsersServiceCancelAccess.post({idU: vm.userBD._id}, {}, function (data) {
            vm.showConfigava = false;
            vm.userBD.tokenApp = null;
            toastr.success(TranslationService.residents.cancelAccessOK);
        }, function (err) {
            $log.error('UsersServiceCancelAccess post error: ', err);
        });
    };

    $rootScope.$on('deleteAttach', function (event, attachment) {
        _.remove(vm.userBD.attacheds, function (item) {
            if (item._id) {
                return item._id === attachment._id;
            } else {
                return item.original.key === attachment.original.key;
            }
        });
        if (!vm.userBD.attachToDelete) {
            vm.userBD.attachToDelete = [];
        }
        vm.userBD.attachToDelete.push({_id: attachment._id});
    });

    vm.save = function (userForm) {
        if ((!vm.submitted && !userForm.$valid) || !userForm.$valid) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form ...is invalid always got in 2 length
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            if (vm.userBD.newPass && vm.userBD.newPass.length > 0) {
                vm.userBD.password = vm.userBD.newPass;
            }
            vm.userBDtmp = angular.copy(vm.userBD);
            vm.userBDtmp.username = vm.userBDtmp.username.toLowerCase();
            var arrRoles = _.castArray(vm.userBDtmp.role);
            if (vm.userBDtmp.extraRoles) {
                arrRoles = arrRoles.concat(vm.userBDtmp.extraRoles);
            }
            vm.userBDtmp.role = _.uniq(_.map(arrRoles, function (item) {
                return item._id;
            }));

            vm.userBDtmp.branches = _.map(vm.userBDtmp.branches, function (ba) {
                return ba._id;
            });
            if (!vm.userBDtmp.allergy) {
                vm.userBDtmp.allergy = {};
            }
            vm.userBDtmp.allergy.allergyTypes = [];
            _.find(vm.allergies, function (all) {
                if (all.selected === true) {
                    vm.userBDtmp.allergy.allergyTypes.push(all._id);
                }
            });

            if (vm.userBD._id) {
                UsersService.post({idU: vm.userBD._id}, vm.userBDtmp, function (data) {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.anim = false;
                    vm.user = {};
                    vm.user = angular.copy(vm.userBD);
                    vm.userBD = {};
                    vm.user.action = 'reflist';
                }, function (err) {
                    if (err.status === 405) {
                        if (err.data && err.data.error) {
                            if (err.data.error.error.indexOf('USER40501') >= 0) {
                                toastr.error(TranslationService.errors.USER40501, TranslationService.errors.error);
                            } else if (err.data.error.error.indexOf('USER40502') >= 0) {
                                toastr.error(TranslationService.errors.USER40502, TranslationService.errors.error);
                            }
                        }
                    }
                    $log.error('UsersService post (update) error: ', err);
                });
            } else {
                UsersService.post(vm.userBDtmp, function (data) {
                    toastr.success(TranslationService.dialog.saveok);
                    vm.anim = false;
                    vm.user = angular.copy(vm.userBD);
                    vm.userBD = {};
                    vm.user.action = 'reflist';
                }, function (err) {
                    if (err.status === 405) {
                        if (err.data && err.data.error) {
                            if (err.data.error.error.indexOf('USER40501') >= 0) {
                                toastr.error(TranslationService.errors.USER40501, TranslationService.errors.error);
                            } else if (err.data.error.error.indexOf('USER40502') >= 0) {
                                vm.activeUser();
                            }
                        }
                    }
                    $log.error('UsersService post (create) error: ', err);
                });
            }
        }
    };

    vm.back = function () {
        vm.anim = false;
        vm.user = {};
        vm.userBD = {};
    };

    vm.activeUser = function () {
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.ActiveItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                var email = vm.userBD.username;
                var query = {
                    username: email,
                    active: false
                };
                if (vm.usernameOrigModif !== vm.userBD.username) {
                    UsersService.get(query, function (data) {
                        vm.userBDtmp.active = true;
                        if (data.data && data.data.length > 0) {
                            vm.userBDtmp._id = data.data[0]._id;
                            UsersService.post({idU: data.data[0]._id}, vm.userBDtmp, function (data) {
                                toastr.success(TranslationService.dialog.saveok);
                                vm.anim = false;
                                vm.user = {};
                                vm.user = angular.copy(vm.userBD);
                                vm.userBD = {};
                                vm.user.action = 'reflist';
                            }, function (err) {
                                $log.error(err);
                            });
                        } else {
                            $log.error('Error inesperado');
                        }
                    }, function (error) {
                        // vm.mailExist = false;
                        // formInput.$setValidity('valid', vm.mailExist);
                        $log.debug(error);
                    });
                }
            }
        });
    };

    $rootScope.$on('closeUsersDetail', function () {
        vm.back();
    });

}

angular
    .module('BlurAdmin.userDetailCom')
    .component('userDetail', {
        templateUrl: 'app/components/users/userDetail/userDetail.html',
        controllerAs: 'udetc',  //stands for 'User List Component'
        controller: UserDetailController,
        bindings: {
            user: '=',
            anim: '=',
            constants: '<',
            istour: '<'
        }
    });

function UsersListController(NgTableParams, NgTableFilterService, TranslationService, $timeout,
                             toastr, UsersService, $log, $rootScope,
                             PermissionsService, localStorageService, $filter,  UserExportListService, FileSaver,
                             $location, $scope) {
    var vm = this;

    vm.selectu = {};
    vm.pagg = 0;
    vm.anim = false;
    vm.listOri = [];
    vm.initialized = false;
    vm.gotAccessMod = false;
    vm.gotAccessDel = false;

    vm._CONTROLLER = 'UsersListController';

    function setPermissions() {
        vm.gotAccessMod = PermissionsService.gotPermission('USER', 'update');
        vm.gotAccessDel = PermissionsService.gotPermission('USER', 'delete');
    }

    function getSources(queryOffset, list) {
        list = (list) ? list : [];
        var query = (queryOffset) ? { offset: queryOffset } : {};
        if (vm.constants && vm.constants.roles) {
            query.role = _.map(vm.constants.roles, '_id');
        }

        UsersService.get(query, function (data) {
            $log.debug('load users: ', data);
        }, function (err) {
            $log.error('error loading users: ', err);
            toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                { progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true });
            return list;
        }).$promise.then(function (data) {
            list = _.concat(list, data.data);
            if (data.total) {
                getSources(list.length, list);
            } else {
                setSourceFormating(list);
                vm.initialized = true;
                iniTable(list);
                vm.list = list;
                return list;
            }
        });
    }

    function setSourceFormating(list) {
        _.forEach(list, function (user) {
            if (user.role && _.castArray(user.role).length > 0) {
                user.roleDesc = '';
                _.forEach(_.castArray(user.role), function (item) {
                    user.roleDesc += item.description + ', ';
                });
                if (user.roleDesc.endsWith(', ')) {
                    user.roleDesc = user.roleDesc.substr(0, user.roleDesc.length - 2);
                }
                user.nameSurname = '';
                if (user.name) {
                    user.nameSurname = user.name + ' ';
                }
                if (user.surname) {
                    user.nameSurname = user.nameSurname + user.surname;
                }
                if (user.branches) {
                    user.ABran = ' ';
                    _.forEach(user.branches, function (bran) {
                        user.ABran += bran.description + ', ';
                    });
                    if (user.ABran.endsWith(', ')) {
                        user.ABran = user.ABran.substr(0, user.ABran.length - 2);
                    }
                }
            }
        });
    }

    var viewParams = localStorageService.get('usersViewParams') ?
        localStorageService.get('usersViewParams') : {};

    var selectedBar = localStorageService.get('selectedBarResidence');
    if (selectedBar && !selectedBar.all) {
        viewParams = { filterUsersList: { ABran: selectedBar.description } };
    }
    var unregister = $rootScope.$on('selectedBarBranChanged', function (event, data) {
        if ($location.path() === '/users') {
            viewParams = { filterUsersList: { ABran: (!data.all) ? data.description : '' } };
            iniTable(vm.list);
        }
    });
    $scope.$on('$destroy', unregister);

    vm.$onInit = function () {
        if (vm.initialized) {
            return;
        }
        vm.selectu = {};
        vm.anim = false;
        setPermissions();

        vm.tableParamsU = null;
        getSources();
    };

    vm.$onDestroy = function () {
        localStorageService.set('usersViewParams', null);
    };

    vm.$doCheck = function () {
        if (vm.selectu && vm.selectu.action === 'reflist') {
            vm.initialized = false;
            vm.$onInit();
        }
    };

    function iniTable(list) {
        if (!vm.list) {
            vm.list = [];
        } else if (vm.list.length > 0) {
            vm.list[0].selected = true;
        }

        var sorting = viewParams['sortingUsersList'] ? viewParams['sortingUsersList'] : { name: 'asc' };
        var page = viewParams['pageUsersList'] ? viewParams['pageUsersList'] : 1;
        var count = viewParams['countUsersList'] ? viewParams['countUsersList'] : 10;

        var listCopy = angular.copy(list);
        vm.tableParamsU =
            new NgTableParams(
                {
                    page: page,
                    count: count,
                    sorting: sorting
                },
                {
                    counts: [10, 20, 30],
                    paginationMaxBlocks: 3,
                    paginationMinBlocks: 2,
                    getData: function (params) {
                        listCopy = $filter('orderBy')(listCopy, params.orderBy());
                        var filterObj = params.filter();
                        var filteredData = NgTableFilterService.fill(listCopy, filterObj);

                        page = Math.ceil(filteredData.length / params.count()) < page ? 1 : params.page();

                        viewParams['sortingUsersList'] = params._params.sorting;
                        viewParams['pageUsersList'] = page;
                        viewParams['countUsersList'] = params._params.count;
                        viewParams['filterUsersList'] = filterObj;
                        localStorageService.set('usersViewParams', viewParams);
                        vm.currentTableData = filteredData;
                        params.total(filteredData.length);
                        return filteredData.slice((page - 1) * params.count(),
                            page * params.count());
                    }
                }
            );

        var savedFilters = viewParams['filterUsersList'] ? viewParams['filterUsersList'] : {};
        vm.tableParamsU.filter(savedFilters);
        vm.tableParamsU.page(page);
    }


    vm.tableParamsCK = function (row) {
        if (vm.istour) {
            return;
        }
        if (vm.selectu && (vm.selectu.action === 'inEdit' || vm.selectu._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        } else {
            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 401);
            }
            _.forEach(vm.tableParamsU.data, function (r) {
                r.selected = (r._id === row._id);
            });
            vm.selectu = row;
        }
    };

    vm.backifModifOrNew = function () {
        if (vm.selectu && (vm.selectu.action === 'inEdit' || vm.selectu._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        }
    };

    vm.tableParamsdblCK = function (row) {
        vm.selectu = angular.copy(row);
    };

    vm.filterNameSurname = {
        nameSurname: {
            id: 'text'
        }
    };
    vm.filterName = {
        name: {
            id: 'text'
        }
    };
    vm.filterLastname = {
        surname: {
            id: 'text'
        }
    };
    vm.filterBR = {
        ABran: {
            id: 'text'
        }
    };
    vm.filterRole = {
        roleDesc: {
            id: 'text'
        }
    };
    vm.filterActive = {
        active: {
            id: 'text'
        }
    };

    vm.new = function () {
        vm.selectu = {
            _id: '0'
        };
        vm.selectu.action = 'new';
        _.forEach(vm.tableParamsU.data, function (r) {
            r.selected = false;
        });
        if (!vm.anim) {
            $timeout(function () {
                vm.anim = true;
            }, 417);
        }
    };

    vm.editRow = function (row) {
        row.action = 'edit';
        vm.tableParamsCK(row);
    };

    vm.deleteRow = function (row) {
        if (vm.istour) {
            return;
        }
        row.action = 'delete';
        swal({
            title: TranslationService.modal.confirmation,
            text: TranslationService.modal.deleteItem,
            showCancelButton: true,
            confirmButtonText: TranslationService.modal.button.ok,
            cancelButtonText: TranslationService.modal.button.cancel
        }).then(function (result) {
            if (result.value) {
                UsersService.delete({ idU: row._id }, function (data) {
                    vm.list = [];
                    vm.$onInit();
                    getSources();
                    toastr.success(TranslationService.modal.deleteItemOk);
                }, function (err) {
                    $log.error('UsersService delete error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        { progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true });
                });
            }
        });
    };

    vm.exportData = function () {
        var filename = TranslationService.users.exportTitle.replace(/\s/gi, '_').toLowerCase() + '_' + moment().format('YYYYMMDD');
        var columns = TranslationService.users.export;

        var requestData = {
            columns: columns,
            ids: _.map(vm.currentTableData, function(e) { return e.id; }),
            filename: filename,
        };

        UserExportListService.post(
            {  }, requestData, function (data) {
                var blob = new Blob([new Uint8Array(data.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                FileSaver.saveAs(blob, filename + '.xlsx');
            }, function (err) {
                $log.error('UserExportService export error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    { progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true });
            });
    };

    $rootScope.$on('openAgendaDetailFirstRow', function () {
        var row = vm.tableParamsU.data[0];
        if (vm.selectu && (vm.selectu.action === 'inEdit' || vm.selectu._id === '0')) {
            vm.anim = false;
            vm.selectu = null;
        } else {

            if (!vm.anim) {
                $timeout(function () {
                    vm.anim = true;
                }, 401);
            }
            _.forEach(vm.tableParamsU.data, function (r) {
                r.selected = (r._id === row._id);
            });
            vm.selectu = row;
        }
    });

    $rootScope.$on('openUsersDetail', function () {
        vm.new();
    });

}



angular
    .module('BlurAdmin.usersListCom')
    .component('usersList', {
        templateUrl: 'app/components/users/usersList/usersList.html',
        controllerAs: 'ultc',  //stands for 'User List Component'
        controller: UsersListController,
        bindings: {
            selectu: '=',
            list: '=',
            pag: '<',
            anim: '=',
            appuserbapan: '=',
            constants: '<',
            initTour: '&',
            istour: '<'
        }
    });

(function () {
    'use strict';

    angular.module('Tagaste.activities.activitiesList')
        .controller('activitiesListController', activitiesListController);

    activitiesListController.$inject = ['$timeout', 'MasterTableService', '$routeParams', '$log', 
        'toastr', 'TranslationService', 'routeConf', 'tmhDynamicLocale', 'TourService', '$q', '$rootScope',
        '$location'];

    /** @ngInject */
    function activitiesListController($timeout, MasterTableService, $routeParams, $log, toastr,
                                      TranslationService, routeConf, tmhDynamicLocale, TourService, $q, $rootScope,
                                      $location) {
        var vm = this;

        vm.selected = {}; //from com selected row
        vm.list = []; // to com list of resid
        vm.pag = 1; // selected pag for a window (back mod)
        vm.listLoaded = false;
        vm.showActivityView = false;
        vm.modeEdit = false;
        vm.total = false;
        vm.tourDummyData = [];
        vm.istour = false;
        vm.newReserveView = false;
        vm.reloadActivity = false;
        vm.blockButtons = false;
        
        vm._CONTROLLER = 'activitiesListController';


        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/activities') {
                vm.anim = false;
                vm.newReserveView = false;
                vm.reloadActivity = false;
                vm.blockButtons = false;
                vm.showActivityView = false;
                vm.reserveList = null;
                vm.notification = null;
                vm.animReserve = false;
                vm.animResident = false;
                vm.selectedResident = null;
                vm.showPayment = false;
            }
        });

        /**
         * @ngdoc method
         * @name initialize
         * @methodOf Tagaste.activities.activitiesList.controller:activitiesListController
         * @description
         * Method that load the initial data of controller
         *
         */
        function initialize(offset) {
            vm.newReserveView = false;
            var defered=$q.defer();
            var promise=defered.promise;
      
            MasterTableService.get({idT: routeConf.app, idJ: routeConf.agenda, offset: offset}, function (data) {
                if (data.total) {
                    vm.total = true;
                    if (vm.list.length > 0) {
                        vm.list = _.concat(vm.list, data.data);
                    } else {
                        vm.list = data.data;
                    }
                    initialize(vm.list.length);
                } else {
                    if (vm.total) {
                        vm.list = _.concat(vm.list, data.data);
                        vm.total = false;
                    } else {
                        vm.list = data.data;
                    }
                }
                $log.debug('activityList', vm.list);
                vm.listLoaded = true;
                defered.resolve();
            }, function (err) {
                $log.error('load activitiy list error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                defered.reject(err);
            });
            return promise;
        }

        /**
         * @ngdoc method
         * @name reloadList
         * @methodOf Tagaste.activities.activitiesList.controller:activitiesListController
         * @description
         * Method that reload the list of activities
         *
         */
        vm.reloadList = function (value) {
            vm.list = [];
            initialize('');
            $log.debug('vm.listReload', vm.list);
        };

        /**
         * @ngdoc method
         * @name showReserve
         * @methodOf Tagaste.activities.activitiesList.controller:activitiesListController
         * @description
         * Method that show the list of reserve of an activity
         *
         */
        vm.showReserve = function (value) {
            var listAux = [];
            _.forEach(value.userBooked, function (pItem) {
                pItem.item.kind = pItem.kind;
                listAux.push(pItem.item);
            });
            vm.reserveList = {
                list: listAux,
                listGuests: value.guests
            };
        };

        /**
         * @ngdoc method
         * @name showReserveNew
         * @methodOf Tagaste.activities.reserveNew.controller:reserveNewController
         * @description
         * Method that show the list of reserve of an activity
         *
         */
        vm.showReserveNew = function (value) {
            vm.newReserveView = value;
        };

        //If we need to init tour
        vm.initTour = function() {
            if (vm.istour){
                return;
            }
           _initTour();
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length < 1){
                vm.tourDummyData.push({'appUsersCount':0,'_id':'dummy','rate':1234,'title':'dummy','text':'dummy',
                'maxUsers':1234,'branches':[{'_id':'dummy','description':'Madrid'}],'localities':'Madrid',
                'isClosed':false});
            }
            return TourService.initAgendaTour().then(function() {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
           });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            var promise = initialize('');
            promise.then(function() {
                if(TourService.shouldShowAgendaTour()) {
                    _initTour();
                }
            }, function(error) {
                toastr.error(TranslationService.errors.e500, error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }, 100);
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.billing.billingList')
        .controller('billingListController', billingListController);

    billingListController.$inject = ['PermissionsService', 'TranslationService', 'toastr', 'MasterTableService', 'routeConf',
        'RolesService', 'UsersService', 'localStorageService', '$log', 'ConfigService', '$q', '$rootScope', '$location', '$timeout', 'tmhDynamicLocale',
        'TourService'];

    /** @ngInject */
    function billingListController(PermissionsService, TranslationService, toastr, MasterTableService, routeConf,
                                    RolesService, UsersService, localStorageService, $log, ConfigService, $q, $rootScope, $location, $timeout, tmhDynamicLocale,
                                    TourService) {
        var vm = this;
        vm.constants = {};
        vm.selected = {};
        vm.ready = false;
        vm.anim = false;

        vm.list = [];
        vm.listLoaded = false;
        vm.total = false;
        vm.tourDummyData = [];
        vm.istour = false;

        function getConstants() {
            var userID = localStorageService.get('userId');
            UsersService.get({idU: userID}, function (userData) {
                vm.constants.branches = userData.branches;
                ConfigService.query({functionality: 'docTypes'}, function (docTypesData) {
                    vm.constants.docType = docTypesData;
                    vm.ready = true;
                }, function(errDocTypes) {
                    $log.error('error loading docTypes: ', errDocTypes);
                });
            }, function (errUserData) {
                $log.error('error loading UserService: ', errUserData);
            });
        }

        vm.initialize = function() {
            vm.ok = loadBillingList();
        }

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/billing') {
                vm.anim = false;
                vm.selected = {};
            }
        });

        function loadBillingList() {
            RolesService.query({sortField: 'level'}, function (data) {
                vm.constants.roles = data;
                var userID = localStorageService.get('userId');
                UsersService.get({idU: userID}, function (data) {
                    vm.constants.branch = data.branches;
                    vm.ready = true;

                    var promises = [];
                    promises.push(ConfigService.query({functionality: 'payType'}));
                    $q.all(promises).then(function (dataFields) {
                        $log.debug('dataFields promisesArray success: ', dataFields);
                        vm.constants.payType = dataFields[0];
                        $log.debug('vm.constants: ', vm.constants);
                    }).catch(function (err) {
                        $log.error('dataFields promisesArray error: ', err);
                    });
                });
            }, function (error) {
                $log.error('load user: ', error);
                vm.ready = true;
                toastr.error(TranslationService.errors.e500);
            });
        }

        //If we need to init tour
        vm.initTour = function () {
            if (vm.istour) {
                return;
            }
            _initTour();
        };

        // TODO billing tour
        function _initTour() {
            vm.istour = true;
            if (vm.list.length < 1) {
                vm.tourDummyData.push({
                    'timeOut': false,
                    '_id': 'dummy',
                    'createdAt': '2018-01-14T10:43:48.795Z',
                    'text': 'dummy',
                    'branch': {'_id': '5a4df00d84c7202edca65e0a', 'description': 'Madrid'},
                    'date': '2018-01-14T10:43:18.675Z',
                    'lastStatus': {
                        'date': '2018-01-14T10:43:18.675Z',
                        'user': 'dummy',
                        'text': 'dummy',
                        'status': {
                            '_id': '5a4baf2c7b63c217fcf7217f',
                            'icon': 'ion-log-in',
                            'description': 'Recibido',
                            'code': '01'
                        }
                    },
                    'priority': false
                });
            }
            return TourService.initRequestsTour().then(function () {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
            });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            vm.initialize();
            if (TourService.shouldShowRequestsTour()) {
                _initTour();
            }
        }, 150);

        vm.$onInit = function () {
            getConstants();
        };
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.bulletinBoard.bulletinBoardList')
        .controller('bulletinBoardListController', bulletinBoardListController);

    bulletinBoardListController.$inject = ['$timeout', 'BulletinBoardService', '$routeParams', '$log', 'toastr',
        'TranslationService', 'TourService', 'tmhDynamicLocale', '$q', '$rootScope',
        '$location'];

    /** @ngInject */
    function bulletinBoardListController($timeout, BulletinBoardService, $routeParams, $log, toastr,
                                         TranslationService, TourService, tmhDynamicLocale, $q, $rootScope, $location) {
        var vm = this;

        vm.selected = {}; //from com selected row
        vm.list = []; // to com list of resid
        vm.pag = 1; // selected pag for a window (back mod)
        vm.listLoaded = false;
        vm.showBulletinView = false;
        vm.modeEdit = false;
        vm.total = false;
        vm.tourDummyData = [];
        vm.istour = false;


        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/bulletinBoard') {
                vm.anim = false;
                vm.selected = {};
                vm.showBulletinView = false;

            }
        });


        /**
         * @ngdoc method
         * @name initialize
         * @methodOf BlurAdmin.bulletinBoard.bulletinBoardList.controller:bulletinBoardListController
         * @description
         * Method that load the initial data of controller
         *
         */
        function initialize(offset) {
            var defered = $q.defer();
            var promise = defered.promise;

            BulletinBoardService.get({dateTo:'2222/12/31', offset: offset}, function (data) {
                if (data.total) {
                    vm.total = true;
                    if (vm.list.length > 0) {
                        vm.list = _.concat(vm.list, data.data);
                    } else {
                        vm.list = data.data;
                    }
                    initialize(vm.list.length);
                } else {
                    if (vm.total) {
                        vm.list = _.concat(vm.list, data.data);
                        vm.total = false;
                    } else {
                        vm.list = data.data;
                    }
                }
                $log.debug('bulletinList', vm.list);
                vm.listLoaded = true;
                defered.resolve();
            }, function (err) {
                $log.error('delete bulletin board error', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
            return promise;
        }

        /**
         * @ngdoc method
         * @name reloadList
         * @methodOf BlurAdmin.bulletinBoard.bulletinBoardList.controller:bulletinBoardListController
         * @description
         * Method that reload the list of bulletin
         *
         */
        vm.reloadList = function (value) {
            vm.list = [];
            initialize('');
            $log.debug('vm.listReload', vm.list);
        };

        //If we need to init tour
        vm.initTour = function () {
            if (vm.istour) {
                return;
            }
            _initTour();
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length < 1) {
                vm.tourDummyData.push({
                    '_id': '5aa24f75ffdcfc607354af2d',
                    'title': 'dummy',
                    'text': 'dummy',
                    'placeText': 'dummy',
                    'dateText': 'dummy',
                    'dateFrom': '2018-01-14T00:00:00.000Z',
                    'dateTo': '2018-01-14T23:59:59.999Z',
                    'active': true,
                    'highlight': true,
                    'branches': [{'_id': '5a4df00d84c7202edca65e0a', 'description': 'Madrid'}],
                    'localities': 'Madrid',
                    'dateFormatFrom': '14/01/2018',
                    'dateFormatTo': '14/01/2018'
                });
            }
            return TourService.initBulletinBoardTour().then(function () {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
            });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            var promise = initialize('');
            promise.then(function () {
                if (TourService.shouldShowBulletinBoardTour()) {
                    _initTour();
                }
            }, function (error) {
                toastr.error(TranslationService.errors.e500, error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }, 100);
    }
})();
/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.canteen.canteenPanel')
        .controller('canteenPanelController', canteenPanelController);

    canteenPanelController.$inject = ['$timeout', 'tmhDynamicLocale', 'TourService', '$rootScope', '$location'];

    /** @ngInject */
    function canteenPanelController($timeout, tmhDynamicLocale, TourService, $rootScope, $location) {
        var vm = this;

        vm.selected = {}; //from com selected row
        vm.list = []; // to com list of resid
        vm.pag = 1; // selected pag for a window (back mod)
        vm.anim = false;
        vm.menuid = null;
        vm.ready = false;
        vm.menuselect = null;
        vm.newSelectCourse = null;
        vm.returncourseitem = null;
        vm.inDish = null;
        vm.appuser = null;
        vm.constant = {};
        vm.tourDummyData = [];
        vm.istour = false;
        vm.showReserveView = false;
        vm.refreshMenu = false;
        vm.selectedResident = null;
        vm.showPayment = false;
        
        vm._CONTROLLER = 'activitiesListController';

        function initialize() {
            vm.showReserveView = false;
            vm.refreshMenu = false;
            vm.modeEdit = false;
            vm.ok = inLoadDataCanteenPanel();
        }

        function inLoadDataCanteenPanel() {
            vm.list = [];
            vm.ready = true;
        }

        //If we need to init tour
        vm.initTour = function() {
            if (vm.istour){
                return;
            }
            _initTour();
        };
 
        function _initTour() {
            vm.istour = true;     
            if (vm.list.length < 1){
                vm.tourDummyData.push({'_id':'5c5d7c2bc3ca0a1b5daa7ea1','date':'2019-02-17T00:00:00.000Z',
                'dateLimit':'2019-02-05T00:00:00.000Z','branch':{'_id':'5a4df00d84c7202edca65e09','description':'León'},
                'menuType':{'_id':'5a4baf2c7b63c217fcf72166','hourUntil':16,'icon':'ion-ios-sunny-outline',
                'description':'Comida','code':'02','active':true},
                'booking':{'userRemark':1,'delivered':0,'booked':0,'absent':0,'totalBook':0},'active':true,
                'sdate':'17/02/2019','activeState':true,'sactive':'Cerrado','suserremarks':'Hay comentarios',
                'smenuType':'Comida','branchDescription':'León'});
            }
            return TourService.initMenuTour().then(function() {
                vm.menuid = false;
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
            });
        }
 
        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            initialize();            
            if(TourService.shouldShowMenuTour()) {
                _initTour();
            }
        }, 100);

        /**
         * @ngdoc method
         * @name showReserve
         * @methodOf Tagaste.canteen.canteenReserveNew.controller:canteenReserveNewController
         * @description
         * Method that show the form of new reserve of an canteen
         *
         */
        vm.showReserve = function () {
            vm.modeEdit = false;
            vm.showReserveView = true;
        };

        vm.setRefreshMenu = function () {
            vm.refreshMenu = true;
        };

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if($location.path() === '/canteenPanel') {
                vm.anim = false;
                vm.newSelectCourse = null;
                vm.returncourseitem = null;
                vm.inDish = null;
                vm.appuser = null;
                vm.constant = {};
                vm.showReserveView = false;
                vm.refreshMenu = false;
                vm.selectedResident = null;
                vm.showPayment = false;
                vm.reserveList = null;
                vm.showComments = null;
                vm.anim = false;
                $timeout(function () {
                    vm.menuid = null;
                }, 201);
            }
        });
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular.module('Tagaste.pages.chat.panel')
        .controller('chatPanelController', chatPanelController);

    chatPanelController.$inject = ['$log', '$timeout', 'toastr', 'TranslationService', 'ResidentsService', 
                                    'routeConf', 'TourService', 'UsersService', '$rootScope', 'localStorageService',
                                    'MasterTableService'];
    /** @ngInject */
    function chatPanelController($log, $timeout, toastr, TranslationService, ResidentsService, routeConf,
                                 TourService, UsersService, $rootScope, localStorageService, MasterTableService) {
        var vm = this;

        vm.selected = {};
        vm.list = [];
        vm.anim = false;
        vm.initialized = false;
        vm.constants = {
            branches: [],
            residents: [],
            users: []
        };
        vm.tourDummyData = [];
        vm.istour = false;

        vm._CONTROLLER = 'chatPanelController';

        function getSourcesAppUsers() {
            return new Promise(function (full, reject) {
                UsersService.get(function (data) {
                    full(data.data);
                });
            });
        }

        function getSourcesResidents(queryOffset, list) {
            list = (list) ? list : [];
            var query = (queryOffset) ? {offset: queryOffset, virtual: 'all'} : {virtual: 'all'};

            ResidentsService.get(query, function (data) {
                list = _.concat(list, data.data);
                if (data.total) {
                    getSourcesResidents(list.length, list);
                } else {
                    vm.initialized = true;
                    vm.constants.residents = list;
                    return list;
                }
            }, function (err) {
                $log.error('ResidentsService get error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                return list;
            });
        }
        /**
         * @ngdoc method
         * @name getSourcesBranches
         * @description
         * Method that load all localities of a user
         *
         */
        function getSourcesBranches() {
            return new Promise(function (full, reject) {
                var userBranch = localStorageService.get('branches');
                MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.branch}, function (data) {
                    var allLocalities = data;
                    vm.localities = [];
                    for (var i = 0; i < allLocalities.length; i++) {
                        for (var j = 0; j < userBranch.length; j++) {
                            if (userBranch[j] === allLocalities[i]._id) {
                                vm.localities.push(allLocalities[i]);
                            }
                        }
                    }
                    $log.debug('vm.localities: ', vm.localities);
                    full(vm.localities);
                }, function (err) {
                    $log.error('error load masterTable branch: ', err);
                    reject(err);
                });
            });
        }

        //If we need to init tour
        vm.initTour = function() {
            _initTour();
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length <1){
                vm.tourDummyData.push({'_id':'5ad75d0f7e4e9215e185fa12','name':'dummy',
                    'branch':{'_id':'5a4df00d84c7202edca65e09','description':'León'},'isGroup':true});
            }
            return TourService.initChatTour().then(function() {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
           });
        }

        function initialize() {
            // get cons
            getSourcesAppUsers().then(function (usu) {
                vm.constants.users = usu;
                getSourcesBranches().then(function (data) {
                    vm.constants.branches = data;
                    getSourcesResidents();
                    if(TourService.shouldShowChatTour()) {
                        _initTour();
                    }
                });
            });
            $rootScope.$emit('clearNotificarionMsg');
        }

        $timeout(function () {
            initialize();
        }, 100);
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.configWb.userList')
        .controller('userListController', userListController);

        userListController.$inject = ['$timeout', 'UsersService', 'toastr', 'TranslationService',
                                    'Roles', 'localStorageService', 'RolesService', 'tmhDynamicLocale', 'TourService',
                                    '$log', 'MasterTableService', 'routeConf', '$rootScope', '$location', 'ConfigService'];

    /** @ngInject */
    function userListController($timeout, UsersService, toastr, TranslationService, Roles, localStorageService,
                                RolesService, tmhDynamicLocale, TourService, $log, MasterTableService, routeConf,
                                $rootScope, $location, ConfigService) {

        var vm = this;

        vm.select = {};
        vm.users = [];
        vm.constants = {};
        vm.usersOri = null;
        vm.istour = false;

        vm._CONTROLLER = 'userListController';

        vm.pag = 1;

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/users') {
                vm.anim = false;
                vm.user = null;
            }
        });

        function initialize() {
            RolesService.query({sortField:'level'}, function (data) {
                var userID = localStorageService.get('userId');
                //vm.constants.roles = data;
                
                var userRole = _.get(localStorageService.get('user'), 'role', []);
                var values = userRole.map(function(o) { return parseInt(o.level); });
                var minLevel = _.min(_.castArray(values));

                vm.constants.roles = _.filter(data, function (item) {
                    return (item.level >= minLevel);
                });
                
                UsersService.get({idU: userID}, function (data) {
                    vm.constants.branch = data.branches;
                    ConfigService.query({functionality: 'allergyTypes'},
                        function (aller){
                        vm.constants.allergies = aller;
                        vm.ready = true;
                        }, function (err) {
                            $log.error('error getting allergies ', err);
                            toastr.error(TranslationService.errors.e500);
                    });
                }, function (error) {
                    $log.error('UsersService get error: ', error);
                    toastr.error(TranslationService.errors.e500);
                });
            }, function (error) {
                vm.ready = true;
                $log.error('RolesService query error: ', error);
                toastr.error(TranslationService.errors.e500);
            });
        }



        //If we need to init tour
        vm.initTour = function() {
            if (vm.istour){
                return;
            }
            _initTour();
        };

        function _initTour() {
            vm.istour =true;

            return TourService.initUsersTour().then(function() {
                vm.istour = false;
            });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            initialize();
            if(TourService.shouldShowUsersTour()) {
                _initTour();
            }
        }, 100);

    }

})();

/**
 * @author sila.fernandez
 * created on 28.01.2019
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardCanteenMixedChartCtrl', DashboardCanteenMixedChartCtrl);

    /** @ngInject */
    DashboardCanteenMixedChartCtrl.$inject = ['$scope', 'baConfig', '$log', 'TranslationService'];

    function DashboardCanteenMixedChartCtrl($scope, baConfig, $log, TranslationService) {
        $log.debug('DashboardCanteenMixedChartCtrl chartData: ', $scope.chartData);

        // $scope.displayComida = 'none';
        // $scope.displayCena = 'none';
        // $scope.hayComida = false;
        // $scope.hayCena = false;

        // this.$doCheck = function () {
        //     if ($scope.reload) {
        //         window.setTimeout(function(){
        //             printChart(true);
        //         }, 1000);

        //     }
        // };

        function printChart() {
            var datasetMonthly = [];
            var datasetWeekly = [];
            //var dashboardColors = baConfig.colors.dashboard;

            var color = Chart.helpers.color;
            var chartColors = {
                occupation: 'rgb(145,250,168)',
                reservation: 'rgb(255,255,255)',
                service: 'rgb(161,161,161)'
            };

            var chartLabels = [
                TranslationService.chart.label.occupation,
                TranslationService.chart.label.reservation,
                TranslationService.chart.label.service
            ];

            var chartOptions = {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    position: 'right'
                },
                scale: {
                    ticks: {
                        display: false,
                        beginAtZero: true,
                        backdropColor: '#464444',
                        fontColor: '#FFFFFF'
                    },
                    reverse: false,
                    angleLines: {
                        display: false
                    },
                    gridLines: {
                        display: false,
                        circular: false
                    },
                    pointLabels: {
                        display: false
                    }
                },
                animation: {
                    animateRotate: true,
                    animateScale: true
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0
                    }
                }
            };

            var ctx = document.getElementById('mixedDataDiv');

            var canvasNodeWeekly, canvasNodeMonthly;
            // var canvasContainers = [];
            _.forEach($scope.chartData, function (item) {
                var ccweekly = 'canvasContainerWeekly-' + item.description;
                var ccmonthly = 'canvasContainerMonthly-' + item.description;
                canvasNodeWeekly = ctx.getElementsByClassName(ccweekly)[0];
                canvasNodeMonthly = ctx.getElementsByClassName(ccmonthly)[0];

                datasetWeekly = [
                    item.statistics[0].weekly[0].occupation,
                    item.statistics[0].weekly[0].reservation,
                    item.statistics[0].weekly[0].service
                ];
                datasetMonthly = [
                    item.statistics[0].monthly[0].occupation,
                    item.statistics[0].monthly[0].reservation,
                    item.statistics[0].monthly[0].service
                ];

                window.MonthlyChart = new Chart(canvasNodeMonthly, {
                    type: 'polarArea',
                    data: {
                        labels: chartLabels,
                        datasets: [{
                            data: datasetMonthly,
                            backgroundColor: [
                                color(chartColors.occupation).alpha(1).rgbString(),
                                color(chartColors.reservation).alpha(1).rgbString(),
                                color(chartColors.service).alpha(1).rgbString(),
                            ],
                            borderWidth: [0.4, 0.4, 0.4],
                            borderColor: ['#3a3636', '#3a3636', '#3a3636']
                        }]
                    },
                    options: chartOptions
                });
                window.WeeklyChart = new Chart(canvasNodeWeekly, {
                    type: 'polarArea',
                    data: {
                        labels: chartLabels,
                        datasets: [{
                            data: datasetWeekly,
                            backgroundColor: [
                                color(chartColors.occupation).alpha(1).rgbString(),
                                color(chartColors.reservation).alpha(1).rgbString(),
                                color(chartColors.service).alpha(1).rgbString(),
                            ],
                            borderWidth: [0.4, 0.4, 0.4],
                            borderColor: ['#3a3636', '#3a3636', '#3a3636']
                        }]
                    },
                    options: chartOptions
                });

            });
            $scope.reload = false;
        }

        window.setTimeout(function () {
            printChart();
        }, 1000);

        this.$onInit = function () {
            $scope.previuosData = $scope.chartData;
        };
    }
})();
/**
 * @author sila.fernandez
 * created on 28.01.2019
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardCanteenMixedChart', dashboardCanteenMixedChart);

    /** @ngInject */
    function dashboardCanteenMixedChart() {
        return {
            restrict: 'E',
            controller: 'DashboardCanteenMixedChartCtrl',
            templateUrl: 'app/pages/dashboard/dashboardCanteenMixedChart/dashboardCanteenMixedChart.html',
            scope: {
                chartData: '=',
                reload: '<'
            }
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .controller('DashboardIncidentsDonutChartCtrl', DashboardIncidentsDonutChartCtrl);

  /** @ngInject */
  function DashboardIncidentsDonutChartCtrl($scope, baConfig, colorHelper, $log, TranslationService) {
      $log.debug('$scope.chartData: ', $scope.chartData);
      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              TranslationService.incidencesChart.incidencesHigh,
              TranslationService.incidencesChart.incidencesNormal,
              TranslationService.incidencesChart.incidencesTimeOut
          ],
          datasets: [
              {
                  data: [$scope.chartData.incidencesHigh, $scope.chartData.incidencesNormal, $scope.chartData.timeOut],
                  backgroundColor: [
                      '#15bfac',
                      dashboardColors.gossip,
                      '#ff6961'
                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade('#15bfac', 15),
                      colorHelper.shade(dashboardColors.gossip, 15),
                      colorHelper.shade('#ff6961', 15)
                  ],
                  percentage: [
                      Math.round(($scope.chartData.incidencesHigh*100/$scope.chartData.incidencesTotal), 2),
                      Math.round(($scope.chartData.incidencesNormal*100/$scope.chartData.incidencesTotal), 2),
                      Math.round(($scope.chartData.timeOut*100/$scope.chartData.incidencesTotal), 2)
                  ],
                  borderWidth: [1,1,1],
                  borderColor: ['#3a3636','#3a3636','#3a3636']
              }]
      };

      var ctx = document.getElementById($scope.chartData.chartId);

      var totalInciSpan0 = ctx.getElementsByClassName('totalInci')[0];
      totalInciSpan0.innerHTML = $scope.chartData.incidencesTotal;

      var canvas = ctx.getElementsByTagName('canvas')[0];
      window.myDoughnut = new Chart(canvas, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              },
              tooltips: {
                  mode: 'label',
                  bodyFontSize: 11,
                  enabled: false
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardIncidentsDonutChart', dashboardIncidentsDonutChart);

    /** @ngInject */
    function dashboardIncidentsDonutChart() {
        return {
            restrict: 'E',
            controller: 'DashboardIncidentsDonutChartCtrl',
            templateUrl: 'app/pages/dashboard/dashboardIncidentsDonutChart/dashboardIncidentsDonutChart.html',
            scope: {
                chartData: '='
            }
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardIncidentsMixedChartCtrl', DashboardIncidentsMixedChartCtrl);

    /** @ngInject */
    function DashboardIncidentsMixedChartCtrl($scope, baConfig, colorHelper, $log, TranslationService, $rootScope) {

        $log.debug('chartData Mixed: ', $scope.chartData);

        this.$doCheck = function () {
            if ($scope.previuosData !== $scope.chartData) {
                $scope.previuosData = $scope.chartData;
                printChart(true);
            }
        };

        function printChart() {
            $scope.transparent = baConfig.theme.blur;
            var dashboardColors = baConfig.colors.dashboard;

            var dataset = [];
            if ($scope.chartData.type === 'mixed') {
                dataset.push({
                    type: 'line',
                    label: TranslationService.incidencesChart.incidencesHighAbbrev + ' ' +
                    TranslationService.incidencesChart.opened,
                    yAxisID: 'bar-stacked',
                    borderWidth: 2,
                    fill: false,
                    borderColor: 'rgba(21, 191, 172, 1)',
                    data: $scope.chartData.incidencesOpenedHigh
                });
                dataset.push({
                    type: 'line',
                    label: TranslationService.incidencesChart.incidencesNormalAbbrev + ' ' +
                    TranslationService.incidencesChart.opened,
                    yAxisID: 'bar-stacked',
                    borderWidth: 2,
                    fill: false,
                    borderColor: dashboardColors.gossip,
                    data: $scope.chartData.incidencesOpenedNormal
                });
                dataset.push({
                    type: 'bar',
                    label: TranslationService.incidencesChart.incidencesHighAbbrev + ' ' +
                    TranslationService.incidencesChart.closed,
                    yAxisID: 'bar-stacked',
                    backgroundColor: 'rgba(21, 191, 172, 0.5)',
                    hoverBackgroundColor: 'rgba(21, 191, 172, 0.8)',
                    borderColor: 'rgba(21, 191, 172, 1)',
                    borderWidth: 2,
                    data: $scope.chartData.incidencesClosedHigh
                });
                dataset.push({
                    type: 'bar',
                    label: TranslationService.incidencesChart.incidencesNormalAbbrev + ' ' +
                    TranslationService.incidencesChart.closed,
                    yAxisID: 'bar-stacked',
                    backgroundColor: 'rgba(185, 242, 161, 0.5)',
                    hoverBackgroundColor: 'rgba(185, 242, 161, 0.8)',
                    borderColor: 'rgba(185, 242, 161, 1)',
                    borderWidth: 2,
                    data: $scope.chartData.incidencesClosedNormal
                });
                dataset.push({
                    type: 'bar',
                    label: TranslationService.incidencesChart.incidencesTimeOutAbbrev + ' ' +
                    TranslationService.incidencesChart.closed,
                    yAxisID: 'bar-stacked',
                    backgroundColor: 'rgba(194, 59, 34, 0.5)',
                    hoverBackgroundColor: 'rgba(194, 59, 34, 0.8)',
                    borderColor: 'rgba(194, 59, 34, 1)',
                    borderWidth: 2,
                    data: $scope.chartData.incidencesClosedTimeOut
                });
            } else if ($scope.chartData.type === 'line') {
                dataset.push({
                    type: 'line',
                    label: TranslationService.incidencesChart.timeFor +
                    TranslationService.incidencesChart.incidencesHighAbbrev,
                    yAxisID: 'line-no-stacked',
                    borderWidth: 2,
                    fill: true,
                    borderColor: 'rgba(21, 191, 172, 1)',
                    data: $scope.chartData.hoursHigh
                });
                dataset.push({
                    type: 'line',
                    label: TranslationService.incidencesChart.timeFor +
                    TranslationService.incidencesChart.incidencesNormalAbbrev,
                    yAxisID: 'line-no-stacked',
                    borderWidth: 2,
                    fill: true,
                    borderColor: dashboardColors.gossip,
                    data: $scope.chartData.hoursNormal
                });
            }

            var barChartData = {
                labels: $scope.chartData.label,
                datasets: dataset
            };

            var ctx = document.getElementById($scope.chartData.chartId);
            var canvasContainer = ctx.getElementsByClassName('canvasContainer')[0];
            canvasContainer.innerHTML = '';
            var canvasNode = document.createElement('canvas');
            canvasNode.width = 650;
            canvasNode.height = 400;
            canvasContainer.appendChild(canvasNode);

            var type = null;
            var yAxes = null;
            var titleText = null;
            if ($scope.chartData.type === 'mixed') {
                type = 'bar';
                titleText = TranslationService.incidencesChart.units.incidence;
                yAxes = [
                    {
                        id: 'bar-stacked',
                        stacked: true,
                        position: 'left',
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#fff'
                        },
                        scaleLabel: {
                            display: false,
                            labelString: TranslationService.incidencesChart.units.incidence,
                            fontColor: '#fff',
                            fontSize: 10
                        }
                    }
                ];
            } else if ($scope.chartData.type === 'line') {
                type = 'line';
                titleText = TranslationService.incidencesChart.units.time;
                yAxes = [
                    {
                        id: 'line-no-stacked',
                        stacked: true,
                        position: 'left',
                        ticks: {
                            beginAtZero: true,
                            fontColor: '#fff'
                        },
                        scaleLabel: {
                            display: false,
                            labelString: TranslationService.incidencesChart.units.time,
                            fontColor: '#fff',
                            fontSize: 10
                        }
                    }
                ];
            }

            var chart = null;
            if ($scope.chartData.noData) {
                $log.debug('NO DATA [' + $scope.chartData.type + '] [' + $scope.chartData.place + ']');
            } else {
                chart = new Chart(canvasNode, {
                    type: type,
                    data: barChartData,
                    options: {
                        title: {
                            display: true,
                            text: titleText,
                            position: 'top',
                            fontColor: '#80fec1',
                            fontSize: 14
                        },
                        layout: {
                            padding: {
                                left: 0,
                                right: 0,
                                top: 0,
                                bottom: 0
                            }
                        },
                        legend: {
                            display: false,
                            position: 'bottom',
                            labels: {
                                usePointStyle: true,
                                padding: 20,
                                fontSize: 12,
                                fontColor: '#fff'
                            }
                        },
                        tooltips: {
                            // enabled: false,
                            mode: 'index',
                            position: 'nearest'
                            // custom: customTooltips
                        },
                        responsive: true,
                        scales: {
                            xAxes: [{
                                stacked: true,
                                ticks: {
                                    fontColor: '#fff'
                                }
                            }],
                            yAxes: yAxes
                        }
                    }
                });
            }
            window.mixedChart = chart;
        }

        this.$onInit = function () {
            $scope.previuosData = $scope.chartData;
            printChart(false);
        };

    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardIncidentsMixedChart', dashboardIncidentsMixedChart);

    /** @ngInject */
    function dashboardIncidentsMixedChart() {
        return {
            restrict: 'E',
            controller: 'DashboardIncidentsMixedChartCtrl',
            templateUrl: 'app/pages/dashboard/dashboardIncidentsMixedChart/dashboardIncidentsMixedChart.html',
            scope: {
                chartData: '='
            }
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardMenuPieChartCtrl', DashboardMenuPieChartCtrl);

    /** @ngInject */
    function DashboardMenuPieChartCtrl($scope, $timeout, baConfig, baUtil, $log) {

        $log.debug('pieCharts % $scope.chartData: ', $scope.chartData);
        $scope.charts = $scope.chartData;
        $scope.reloadChart = false;

        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0.1)',
                    size: 84,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 9,
                    lineCap: 'round'
                });
            });
        }

        $timeout(function () {
            loadPieCharts();
        }, 1000);
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardMenuPieChart', dashboardMenuPieChart);

    /** @ngInject */
    function dashboardMenuPieChart() {
        return {
            restrict: 'E',
            controller: 'DashboardMenuPieChartCtrl',
            templateUrl: 'app/pages/dashboard/dashboardMenuPieChart/dashboardMenuPieChart.html',
            scope: {
                chartData: '=',
                selectedCanteenPlace: '=',
                selectedCanteenPlaceName: '=',
                reloadCanteenMixedChart: '='
            },
            link: function($scope, element, attrs) {
                
                $scope.openDetailCanteen = function(chart) {
                    $scope.selectedCanteenPlace = $scope.selectedCanteenPlace === chart.meals[0].placeId ? null : chart.meals[0].placeId;
                    $scope.selectedCanteenPlaceName = chart.place;
                    if ($scope.reloadCanteenMixedChart){
                        $scope.reloadCanteenMixedChart = false;
                    } else {
                        $scope.reloadCanteenMixedChart = true;
                    }                    
                };
            }
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

    /** @ngInject */
    function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil, $log, $rootScope, localStorageService) {

        var vm = this;

        $log.debug('pieCharts % $scope.chartData: ', $scope.chartData);
        vm.charts = $scope.chartData;
        var selectedBar = localStorageService.get('selectedBarResidence');
        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            vm.selected = (selectedBar && !selectedBar.all) ? selectedBar.description : vm.charts[0].description;
        });

        $scope.ckInChartPanel = function (inChart) {
            $rootScope.$emit('ckInChartPanel', inChart.description);
            vm.selected = inChart.description;
        };

        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0.1)',
                    size: 84,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 9,
                    lineCap: 'round'
                });
            });
            vm.selected = (selectedBar && !selectedBar.all) ? selectedBar.description : vm.charts[0].description;
        }

        $timeout(function () {
            loadPieCharts();
        }, 1000);
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('dashboardPieChart', dashboardPieChart);

    /** @ngInject */
    function dashboardPieChart() {
        return {
            restrict: 'E',
            controller: 'DashboardPieChartCtrl',
            controllerAs : 'dpie',
            templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html',
            scope: {
                chartData: '='
            }
        };
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.incidents.incidentsList')
        .controller('incidentsListController', incidentsListController);

    incidentsListController.$inject = ['$timeout', '$http', '$log', 'MasterTableService', 'routeConf',
        'toastr', 'TranslationService', 'tmhDynamicLocale', 'TourService', '$q',
        '$rootScope', '$location'];

    /** @ngInject */
    function incidentsListController($timeout, $http, $log, MasterTableService, routeConf, toastr, TranslationService,
                                     tmhDynamicLocale, TourService, $q, $rootScope, $location) {
        var vm = this;

        vm.selected = {};
        vm.list = [];
        vm.pag = 1;
        vm.listLoaded = false;
        vm.showIncidentView = false;
        vm.modeEdit = false;
        vm.total = false;
        vm.tourDummyData = [];
        vm.istour = false;

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/incidents') {
                vm.anim = false;
                vm.selected = {};
                vm.showIncidentView = false;
            }
        });

        function initialize(offset) {
            var defered = $q.defer();
            var promise = defered.promise;

            MasterTableService.get({idT: routeConf.app, idJ: routeConf.incident, offset: offset}, function (data) {
                if (data.total) {
                    vm.total = true;
                    if (vm.list.length > 0) {
                        vm.list = _.concat(vm.list, data.data);
                    } else {
                        vm.list = data.data;
                    }
                    initialize(vm.list.length);
                } else {
                    if (vm.total) {
                        vm.list = _.concat(vm.list, data.data);
                        vm.total = false;
                    } else {
                        vm.list = data.data;
                    }
                }
                vm.listLoaded = true;
                $log.debug('incident list load data', data);
                defered.resolve();
            }, function (err) {
                $log.error('error load data incident list: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                defered.reject(err);
            });
            return promise;
        }

        /**
         * @ngdoc method
         * @name reloadList
         * @methodOf Tagaste.incidents.incidentsList.controller:incidentsListController
         * @description
         * Method that reload the list of bulletin
         *
         */
        vm.reloadList = function (value) {
            vm.list = [];
            initialize('');
            $log.debug('vm.listReload', vm.list);
        };

        //If we need to init tour
        vm.initTour = function () {
            if (vm.istour) {
                return;
            }
            _initTour();
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length < 1) {
                vm.tourDummyData.push({
                    'timeOut': false,
                    '_id': 'dummy',
                    'createdAt': '2018-01-14T10:43:48.795Z',
                    'text': 'dummy',
                    'branch': {'_id': '5a4df00d84c7202edca65e0a', 'description': 'Madrid'},
                    'date': '2018-01-14T10:43:18.675Z',
                    'lastStatus': {
                        'date': '2018-01-14T10:43:18.675Z',
                        'user': 'dummy',
                        'text': 'dummy',
                        'status': {
                            '_id': '5a4baf2c7b63c217fcf7217f',
                            'icon': 'ion-log-in',
                            'description': 'Recibido',
                            'code': '01'
                        }
                    },
                    'priority': false
                });
            }
            return TourService.initIncidentsTour().then(function () {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
            });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            var promise = initialize('');
            promise.then(function () {
                if (TourService.shouldShowIncidentsTour()) {
                    _initTour();
                }
            }, function (error) {
                toastr.error(TranslationService.errors.e500, error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }, 100);
    }
})();
(function () {
    'use strict';

    angular.module('Tagaste.masterTables.masterTablesList')
        .controller('masterTablesListController', masterTablesListController);

        masterTablesListController.$inject = [];

    /** @ngInject */
    function masterTablesListController() {
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.requests.requestsList')
        .controller('requestsListController', requestsListController);

    requestsListController.$inject = ['PermissionsService', 'TranslationService', 'toastr', 'MasterTableService', 'routeConf',
        'RolesService', 'UsersService', 'localStorageService', '$log', 'ConfigService', '$q', '$rootScope', '$location', '$timeout', 'tmhDynamicLocale',
    'TourService'];

    /** @ngInject */
    function requestsListController(PermissionsService, TranslationService, toastr, MasterTableService, routeConf,
                                    RolesService, UsersService, localStorageService, $log, ConfigService, $q, $rootScope, $location, $timeout, tmhDynamicLocale,
                                    TourService) {
        var vm = this;
        vm.constants = {};
        vm.selected = {};
        vm.ready = false;
        vm.anim = false;

        vm.list = [];
        vm.listLoaded = false;
        vm.total = false;
        vm.tourDummyData = [];
        vm.istour = false;

        function getConstants() {
            ConfigService.query({functionality: 'docTypes'}, function (data) {
                vm.constants.docType = data;
                vm.ready = true;
            });
        }

        function initialize() {
            vm.ok = loadRequestList();
        }

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/requests') {
                vm.anim = false;
                vm.selected = {};
            }
        });

        function loadRequestList() {
            RolesService.query({sortField: 'level'}, function (data) {
                vm.constants.roles = data;
                var userID = localStorageService.get('userId');
                UsersService.get({idU: userID}, function (data) {
                    vm.constants.branch = data.branches;
                    vm.ready = true;

                    var promises = [];
                    promises.push(ConfigService.query({functionality: 'docTypes'}));
                    promises.push(ConfigService.query({functionality: 'allergyTypes'}));
                    promises.push(ConfigService.query({functionality: 'awayPeriod'}));
                    promises.push(ConfigService.query({functionality: 'admonition'}));
                    promises.push(ConfigService.query({functionality: 'billingType'}));
                    promises.push(ConfigService.query({functionality: 'payType'}));
                    promises.push(ConfigService.query({functionality: 'roomType'}));
                    promises.push(ConfigService.query({functionality: 'modality'}));
                    promises.push(ConfigService.query({functionality: 'interviewRating'}));
                    promises.push(ConfigService.query({functionality: 'knowAboutUs'}));
                    promises.push(ConfigService.query({functionality: 'contactType'}));
                    promises.push(ConfigService.query({functionality: 'payment'}));
                    promises.push(ConfigService.query({component: 'tax'}));
                    promises.push(ConfigService.query({component: 'customConcept'}));
                    $q.all(promises).then(function (dataFields) {
                        $log.debug('dataFields promisesArray success: ', dataFields);
                        vm.constants.docType = dataFields[0];
                        vm.constants.allergies = dataFields[1];
                        vm.constants.awayPeriod = dataFields[2];
                        vm.constants.admonition = dataFields[3];
                        vm.constants.billingType = dataFields[4];
                        vm.constants.payType = dataFields[5];
                        vm.constants.roomType = dataFields[6];
                        vm.constants.modality = dataFields[7];
                        vm.constants.interviewRating = dataFields[8];
                        vm.constants.knowAboutUs = dataFields[9];
                        vm.constants.contactType = dataFields[10];
                        vm.constants.payment = dataFields[11];
                        vm.constants.tax = dataFields[12];
                        vm.constants.customConcepts = dataFields[13];
                        $log.debug('vm.constants: ', vm.constants);
                    }).catch(function (err) {
                        $log.error('dataFields promisesArray error: ', err);
                    });
                });
            }, function (error) {
                $log.error('load user: ', error);
                vm.ready = true;
                toastr.error(TranslationService.errors.e500);
            });
        }

        //If we need to init tour
        vm.initTour = function () {
            if (vm.istour) {
                return;
            }
            _initTour();
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length < 1) {
                vm.tourDummyData.push({
                    'timeOut': false,
                    '_id': 'dummy',
                    'createdAt': '2018-01-14T10:43:48.795Z',
                    'text': 'dummy',
                    'branch': {'_id': '5a4df00d84c7202edca65e0a', 'description': 'Madrid'},
                    'date': '2018-01-14T10:43:18.675Z',
                    'lastStatus': {
                        'date': '2018-01-14T10:43:18.675Z',
                        'user': 'dummy',
                        'text': 'dummy',
                        'status': {
                            '_id': '5a4baf2c7b63c217fcf7217f',
                            'icon': 'ion-log-in',
                            'description': 'Recibido',
                            'code': '01'
                        }
                    },
                    'priority': false
                });
            }
            return TourService.initRequestsTour().then(function () {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
            });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            initialize();
            if (TourService.shouldShowRequestsTour()) {
                _initTour();
            }
        }, 150);

        vm.$onInit = function () {
            // loadRequestList();
            getConstants();
        };
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.reservations.reservationsList')
        .controller('reservationsListController', reservationsListController);

    reservationsListController.$inject = ['ConfigService', '$q', '$log', '$rootScope', '$location', 'localStorageService', 'TranslationService'];

    /** @ngInject */
    function reservationsListController(ConfigService, $q, $log, $rootScope, $location, localStorageService, TranslationService) {
        var vm = this;
        vm.constants = {};

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/reservations') {
                vm.selectedBranch = data;
                vm.anim = false;
                vm.$onInit();
            }
        });

        vm.$onInit = function () {
            vm.allBranches = angular.fromJson(sessionStorage.getItem('ls.branchesFull'));
            var selectedBar = localStorageService.get('selectedBarResidence');
            vm.selectedBranch = selectedBar && !selectedBar.all ? selectedBar : null;
            vm.constants.branches = _.filter(vm.allBranches, function (item) {
                return item.description !== TranslationService.all;
            });
            vm.selected = {};
            var promises = [];
            promises.push(ConfigService.query({functionality: 'roomType', branches: _.get(vm.selectedBranch, '_id', vm.selectedBranch)}));
            promises.push(ConfigService.query({functionality: 'docTypes'}));
            promises.push(ConfigService.query({functionality: 'payType'}));
            promises.push(ConfigService.query({functionality: 'modality'}));
            $q.all(promises).then(function (dataFields) {
                $log.debug('dataFields promisesArray success: ', dataFields);
                vm.constants.roomType = dataFields[0];
                vm.constants.docType = dataFields[1];
                vm.constants.payTypes = dataFields[2];
                vm.constants.modality = dataFields[3];
                $log.debug('vm.constants: ', vm.constants);
            }).catch(function (err) {
                $log.error('dataFields promisesArray error: ', err);
            });
        };
    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.users.residentsList')
        .controller('residentsListController', residentsListController);

    residentsListController.$inject = ['$timeout', 'RolesService', '$routeParams', 'toastr', 'TranslationService',
        'UsersService', 'localStorageService', 'MasterTableService', 'routeConf',
        'tmhDynamicLocale', 'TourService', '$log', 'ConfigService', '$rootScope',
        '$location'];

    /** @ngInject */
    function residentsListController($timeout, RolesService, $routeParams, toastr, TranslationService, UsersService,
                                     localStorageService, MasterTableService, routeConf, tmhDynamicLocale, TourService,
                                     $log, ConfigService, $rootScope, $location) {
        var vm = this;

        vm.selected = {}; //from com selected row
        vm.list = []; // to com list of resid
        vm.pag = 1; // selected pag for a window (back mod)
        vm.anim = false;
        vm.showPayment = false;
        vm.constants = {};
        vm.tourDummyData = [];
        vm.istour = false;

        function initialize() {
            vm.ok = inLoadDataResidentList();
        }

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/residents') {
                vm.anim = false;
                vm.selected = {};
                vm.showPayment = false;
            }
        });

        function inLoadDataResidentList() {
            RolesService.query({sortField:'level'}, function (data) {
                vm.constants.roles = data;
                var userID = localStorageService.get('userId');
                UsersService.get({idU: userID}, function (data) {
                    vm.constants.branch = data.branches;
                    vm.ready = true;
                    ConfigService.query({functionality: 'docTypes'}, function (data) {
                        vm.constants.docType = data;
                        ConfigService.query({functionality: 'allergyTypes'},
                            function (aller) {
                                vm.constants.allergies = aller;
                                ConfigService.query({
                                    functionality: 'awayPeriod'
                                }, function (data2) {
                                    vm.constants.awayPeriod = data2;
                                    ConfigService.query({
                                        functionality: 'admonition'
                                    }, function (data3) {
                                        vm.constants.admonitionTypes = data3;
                                        ConfigService.query({
                                             functionality: 'payType'
                                        }, function (data4) {
                                            vm.constants.payTypes = data4;
                                            ConfigService.query({
                                                functionality: 'billingType'
                                            }, function (data5) {
                                                vm.constants.billingTypes = data5;
                                                ConfigService.query({
                                                    functionality: 'billingCheckoutType'
                                                }, function (data6) {
                                                    vm.constants.billingCheckoutTypes = _.orderBy(data6, 'numericValue');
                                                }, function (err) {
                                                    $log.error('error getting billingCheckoutTypes ', err);
                                                    toastr.error(TranslationService.errors.e500);
                                                });
                                            }, function (err) {
                                                $log.error('error getting billingTypes ', err);
                                                toastr.error(TranslationService.errors.e500);
                                            });
                                        }, function (err) {
                                            $log.error('error getting payTypes ', err);
                                            toastr.error(TranslationService.errors.e500);
                                        });
                                    }, function (err) {
                                        $log.error('error getting admonitionTypes ', err);
                                        toastr.error(TranslationService.errors.e500);
                                    });
                                }, function (err) {
                                    $log.error('error getting awayPeriod ', err);
                                    toastr.error(TranslationService.errors.e500);
                                });
                            });
                    });
                });
            }, function (error) {
                $log.error('load user: ', error);
                vm.ready = true;
                toastr.error(TranslationService.errors.e500);
            });
        }

        //If we need to init tour
        vm.initTour = function () {
            if (vm.istour) {
                return;
            }
            _initTour();
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length < 1) {
                vm.tourDummyData.push({
                    '_id': 'dummy', 'name': 'dummy', 'surname': 'dummy', 'photo':
                        {
                            '_id': 'dummy',
                            'filename': 'dummy.jpg',
                            'thumb': {'signedUrl': 'dummy', 'key': 'dummy.png', 'bucket': 'tagaste'},
                            'original': {'key': 'dummy.jpg', 'bucket': 'tagaste'},
                            'active': true
                        },
                    'nick': 'dummy', 'tokenApp': 'true', 'isDelegate': true, 'room': '1234', 'branches':
                        [{'_id': '5a4df00d84c7202edca65e0c', 'description': 'Barcelona'}], 'identity':
                        {'docVal': '1234', 'docType': '5a4baf2c7b63c217fcf72182'}, 'active': true, 'fullName':
                        'dummy', 'floor': '1', 'id': 'dummy', 'residenceDesc': 'Barcelona', 'nameLastname': 'dummy'
                });
            }
            return TourService.initResidentsTour().then(function () {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
            });
        }

        $timeout(function () {
            tmhDynamicLocale.set(moment.locale());
            initialize();
            if (TourService.shouldShowResidentsTour()) {
                _initTour();
            }
        }, 150);
    }
})();

/**
 * @author sila.fernandez
 * created on 22/03/2019
 */
(function () {
    'use strict';

    angular.module('Tagaste.pages.rooms')
        .directive('roomsPieChart', roomsPieChart);

    /** @ngInject */
    function roomsPieChart() {
        return {
            restrict: 'E',
            controller: 'RoomsPieChartCtrl',
            controllerAs : 'rpie',
            templateUrl: 'app/pages/rooms/roomsPieChart/roomsPieChart.html',
            scope: {
                chartData: '='
            }
        };
    }
})();

/**
 * @author sila.fernandez
 * created on 22/03/2019
 */
(function () {
    'use strict';

    angular.module('Tagaste.pages.rooms')
        .controller('RoomsPieChartCtrl', RoomsPieChartCtrl);

    /** @ngInject */
    function RoomsPieChartCtrl($scope, $timeout, $rootScope, localStorageService) {

        var vm = this;
        vm.charts = $scope.chartData;
        var selectedBar = localStorageService.get('selectedBarResidence');

        vm._CONTROLLER = 'RoomsPieChartCtrl';

        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            vm.selected = (selectedBar && !selectedBar.all) ? selectedBar.description : vm.charts[0].description;
        });

        function loadPieCharts() {
            $('.roomchart').each(function (index) {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0.1)',
                    size: 60,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 4,
                    lineCap: 'round'
                });
                chart.data('easyPieChart').update(vm.charts[index].percentage);
            });
            vm.selected = (selectedBar && !selectedBar.all) ? selectedBar.description : vm.charts[0].description;
        }

        $timeout(function () {
            loadPieCharts();
        }, 1000);

        var reloadOccupancyPieChartSuscribe = $rootScope.$on('reloadOccupancyPieChart', function () {
            loadPieCharts();
        });
        $scope.$on('$destroy', reloadOccupancyPieChartSuscribe);

    }
})();

/**
 * @author lavg
 * created on 17/13/2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.services.servicesMenu')
        .controller('ServicesMenuController', ServicesMenuController);

    ServicesMenuController.$inject = ['$timeout', '$routeParams', 'toastr', 'TranslationService',
                        'UsersService','$rootScope',
        'localStorageService', 'TourService', '$q'];

    /** @ngInject */
    function ServicesMenuController($timeout, $routeParams, toastr, TranslationService,
                        UsersService,$rootScope,
                                    localStorageService, TourService, $q) {
        var vm = this;

        vm.servic = null; //from com selected row
        vm.list = []; // to com list of resid
        vm.anim = false;
        vm.animSchedule = false;
        vm.constants = {};
        vm.pag = 1; // selected pag for a window (back mod)
        vm.tourDummyData = [];
        vm.istour = false;
        vm.newReserveView = false;

        vm._CONTROLLER = 'ServicesMenuController';

        function initialize() {
            vm.newReserveView = false;
            var defered = $q.defer();
            var promise = defered.promise;

            var userID = localStorageService.get('userId');
            UsersService.get({idU: userID}, function (data) {
                vm.constants.branches = data.branches;
                vm.ready = true;
                defered.resolve();
            }, function (err) {
                vm.ready = true;
                toastr.error(TranslationService.errors.e500);
                defered.reject(err);
            });

            return promise;
        }
        
        //If we need to init tour
        vm.initTour = function () {
            _initTour();
        };

        function _initTour() {
            vm.istour = true;
            if (vm.list.length<1){
                vm.tourDummyData.push({'appUsersCount':0,'_id':'dummy','rate':1234,
                'title':'dummy','text':'dummy','maxUsers':1234,
                'branches':[{'_id':'dummy','description':'Madrid'}],'localities':'Madrid','isClosed':false});
            }
            return TourService.initServicesTour().then(function () {
                vm.tourDummyData.splice(0, vm.tourDummyData.length);
                vm.istour = false;
            });
        }

        $timeout(function () {
            var promise = initialize();

            promise.then(function () {
                if (TourService.shouldShowServicesTour()) {
                    _initTour();
                }
            }, function (error) {
                toastr.error(TranslationService.errors.e500, error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
            });
        }, 100);
    }
})();

(function () {
    'use strict';

    angular.module('Tagaste.tasks.tasksList')
        .controller('tasksListController', tasksListController);

    tasksListController.$inject = ['$timeout', '$http', '$log', 'MasterTableService', 'routeConf',
        'toastr', 'TranslationService', 'tmhDynamicLocale', 'TourService', '$q', '$rootScope', '$location', 'ConfigService',
        'WorkerTaskOpenService'];

    /** @ngInject */
    function tasksListController($timeout, $http, $log, MasterTableService, routeConf, toastr, TranslationService,
                                 tmhDynamicLocale, TourService, $q, $rootScope, $location, ConfigService, WorkerTaskOpenService) {
        var vm = this;

        vm.selected = {};
        vm.list = [];
        vm.pag = 1;
        vm.listLoaded = false;
        vm.showTaskView = false;
        vm.modeEdit = false;
        vm.cleaningTaskId = null;
        vm.selectedBranch = null;
        vm.taskSchedulerList = [];
        vm.taskSchedulerPag = 1;
        vm.taskSchedulerTotal = false;
        vm.taskSchedulerSelected = {};
        vm.showTaskSchedulerView = false;
        vm.modeCreationTS = false;
        vm.readOnlyTS = false;
        vm.modeEditTS = false;
        vm.listTSLoaded = false;
        vm.anim = false;
        $rootScope.$on('selectedBarBranChanged', function (event, data) {
            if ($location.path() === '/tasks') {
                vm.anim = false;
                vm.selected = {};
                vm.showTaskView = false;
            }
        });

        function initialize(offset) {
            var defered = $q.defer();
            var promise = defered.promise;

            var query = {
                taskParent: vm.cleaningTaskId
            };
            if (vm.selectedBar && !vm.selectedBar.all) {
                query['branch'] = vm.selectedBar._id;
            }
            WorkerTaskOpenService.get(query, function (data) {
                $log.debug('tasks list loading data: ', data);
                vm.list = data.count ? data.data : [];
                vm.listLoaded = true;
                defered.resolve();
            }, function (err) {
                $log.error('tasks list loading data error: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                defered.reject(err);
            });
            return promise;
        }

        vm.reloadList = function (value) {
            vm.list = [];
            if (vm.cleaningTaskId) {
                var promise = initialize('');
                promise.then(function () {
                    _.forEach(vm.list, function (item) {
                        item['branchDescription'] = _.get(item, 'branch.description', '');
                        item['spotDescription'] = _.get(item, 'spot.description', '');
                        item['taskTypeDescription'] = _.get(item, 'taskType.description', '');
                        item['statusDescription'] = _.get(item, 'status.description', '');
                    });
                }, function (error) {
                    toastr.error(TranslationService.errors.e500, error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        };

        vm.loadTasksData = function(){
            $timeout(function () {
                tmhDynamicLocale.set(moment.locale());

                ConfigService.query({
                    functionality: 'taskTypes',
                    code: 'cleaning'
                }, function (data) {
                    $log.debug('ConfigService taskTypes data: ', data);
                }, function (err) {
                    $log.error('ConfigService taskTypes error: ', err);
                }).$promise.then(function (data) {
                    vm.cleaningTaskId = data[0] ? _.get(data[0], '_id') : null;
                    if (vm.cleaningTaskId) {
                        var promise = initialize('');
                        promise.then(function () {
                            $log.debug('tasksList OK');
                        }, function (error) {
                            toastr.error(TranslationService.errors.e500, error,
                                {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                        });
                    } else {
                        vm.list = [];
                    }
                });
            }, 100);
        };

        function loadTaskSchedulerData(offset) {
            tmhDynamicLocale.set(moment.locale());
            var defered = $q.defer();
            var promise = defered.promise;
            MasterTableService.get({idT: routeConf.planner, offset: offset}, function (data) {
                if (data.total) {
                    vm.taskSchedulerTotal = true;
                    if (vm.taskSchedulerList.length > 0) {
                        vm.taskSchedulerList = _.concat(vm.taskSchedulerList, data.data);
                    } else {
                        vm.taskSchedulerList = data.data;
                    }
                    loadTaskSchedulerData(vm.taskSchedulerList.length);
                } else {
                    if (vm.taskSchedulerTotal) {
                        vm.taskSchedulerList = _.concat(vm.taskSchedulerList, data.data);
                        vm.taskSchedulerTotal = false;
                    } else {
                        vm.taskSchedulerList = data.data;
                    }
                }
                vm.listTSLoaded = true;
                $log.debug('task scheduler list load data', data);
                defered.resolve();
            }, function (err) {
                $log.error('error load data task scheduler list: ', err);
                toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                    {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                defered.reject(err);
            });
            return promise;
        }

        /**
         * @ngdoc method
         * @name reloadTaskSchedulerListt
         * @methodOf Tagaste.tasks.tasksList.controller:tasksListController
         * @description
         * Method that reload the list of task scheduler
         *
         */
        vm.reloadTaskSchedulerListt = function (value) {
            vm.taskSchedulerList = [];
            loadTaskSchedulerData('');
            $log.debug('vm.listReload taskSchedulerList', vm.taskSchedulerList);
        };

        vm.$onInit = function(){
            vm.loadTasksData();
            loadTaskSchedulerData('');
        };
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author sila.fernandez
 * created on 06/05/2019
 */

(function () {
    'use strict';

    angular.module('BlurAdmin.workerTask.workerTaskList')
        .controller('WorkerTaskListController', WorkerTaskListController);

    WorkerTaskListController.$inject = [];

    /** @ngInject */
    function WorkerTaskListController() {
    }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig,ENV) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '"' + (attrs.baPanelAnim ? attrs.baPanelAnim : ENV.baPanelAnim)+ (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel($filter) {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + $filter('translate')(attrs.baPanelTitle) + '</h3></div>';
          res = titleTpl + res; // title should be before
        }
        if (attrs.baPanelTitleNoTranslate) {
            var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitleNoTranslate + '</h3></div>';
            res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl)
        .filter('gotAcessItems', function (PermissionsService) {
            return function (items) {
                return _.filter(items, function (item) {
                    if (!item.permission){
                        return true;
                    } else {
                        var hasPermission = false;
                        var arrPermission = _.split(item.permission, '|');
                        arrPermission = _.map(arrPermission, function square(item) {
                            var arrAux = item.match(/\S+/g) || ['',''];
                            return {permission: arrAux[0], mode:arrAux[1]||undefined};
                        });
                        var i = 0;
                        while (!hasPermission && i < arrPermission.length) {
                            hasPermission = PermissionsService.gotPermission(arrPermission[i].permission, arrPermission[i].mode);
                            i++;
                          }
                        return hasPermission;
                    }
                });
            };
        });

    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService) {
        $scope.menuItems = baSidebarService.getMenuItems();
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

        $scope.hoverItem = function ($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            // TODO: Change this value when change size  of topsidebar
            // var menuTopValue = 66; // e
            var menuTopValue = 80; // e
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function () {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed);
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .provider('baSidebarService', baSidebarServiceProvider);

    /** @ngInject */
    function baSidebarServiceProvider() {
        var staticMenuItems = [];

        this.addStaticItem = function () {
            staticMenuItems.push.apply(staticMenuItems, arguments);
        };

        /** @ngInject */
        this.$get = function ($state, layoutSizes) {
            return new _factory();

            function _factory() {
                var isMenuCollapsed = shouldMenuBeCollapsed();

                this.getMenuItems = function () {
                    var states = defineMenuItemStates();
                    var menuItems = states.filter(function (item) {
                        return item.level === 0;
                    });

                    menuItems.forEach(function (item) {
                        var children = states.filter(function (child) {
                            return child.level === 1 && child.name.indexOf(item.name) === 0;
                        });
                        item.subMenu = children.length ? children : null;
                    });

                    return menuItems.concat(staticMenuItems);
                };

                this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
                this.canSidebarBeHidden = canSidebarBeHidden;

                this.setMenuCollapsed = function (isCollapsed) {
                    isMenuCollapsed = isCollapsed;
                };

                this.isMenuCollapsed = function () {
                    return isMenuCollapsed;
                };

                this.toggleMenuCollapsed = function () {
                    isMenuCollapsed = !isMenuCollapsed;
                };

                this.getAllStateRefsRecursive = function (item) {
                    var result = [];
                    _iterateSubItems(item);
                    return result;

                    function _iterateSubItems(currentItem) {
                        currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
                            subItem.stateRef && result.push(subItem.stateRef);
                            _iterateSubItems(subItem);
                        });
                    }
                };

                function defineMenuItemStates() {
                    return $state.get()
                        .filter(function (s) {
                            return s.sidebarMeta;
                        })
                        .map(function (s) {
                            var meta = s.sidebarMeta;
                            return {
                                name: s.name,
                                title: s.title,
                                level: (s.name.match(/\./g) || []).length,
                                order: meta.order,
                                icon: meta.icon,
                                permission: meta.permission,
                                stateRef: s.name
                            };
                        })
                        .sort(function (a, b) {
                            return (a.level - b.level) * 100 + a.order - b.order;
                        });
                }

                function shouldMenuBeCollapsed() {
                    return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
                }

                function canSidebarBeHidden() {
                    return window.innerWidth <= layoutSizes.resWidthHideSidebar;
                }
            }

        };

    }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('MsgCenterCtrl', MsgCenterCtrl);

    /** @ngInject */
    function MsgCenterCtrl($scope, $sce, $rootScope, $log, $state, routeConf, MasterTableService, toastr, TranslationService,
                           localStorageService, state,PermissionsService) {
        var vm = this;

        $scope.message = 0;
        $scope.announcement = 0;
        $scope.announcementPermission = PermissionsService.gotPermission('NOTICE','read');
        $scope.chatPermission = PermissionsService.gotPermission('CHAT','read');

        getSources();

        $rootScope.$on('newMsgChatNotification', function (event) {
            if ($scope.message === 0) {
                getSources();
            }
            else {
                $scope.message++;
            }
        });
        $rootScope.$on('clearNotificarionMsg', function (event) {
            $scope.message = 0;
        });

        function getSources() {
            if(PermissionsService.gotPermission('CHAT', 'read')) {
                var query = {idT: routeConf.chat, idJ: routeConf.getChatGroup};
                query.branch = localStorageService.get('branches');
                MasterTableService.get(query, function (arrChatGroup) {
                    $scope.chatGroups = arrChatGroup.data;
                    // $log.debug('chatlist', $scope.chatGroups);
                    $scope.chatGroups.forEach(function (item) {
                        $scope.message = $scope.message + parseInt(item.unreadMsg) || 0;
                    });
                }, function (err) {
                    $log.error('initChat error: ', err);
                    toastr.error(TranslationService.errors.e500, TranslationService.errors.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }

        /**
         * Method that redirect to chat view
         */
        $scope.goToChat = function () {
            $scope.message = 0;
            $state.go(state.chat);
        };

        /**
         * Method that redirect to announcement view
         */
        $scope.goToAnnouncement = function () {
            $scope.announcement = 0;
            $state.go(state.announcement);
        };
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('msgCenter', msgCenter);

    /** @ngInject */
    function msgCenter() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
            controller: 'MsgCenterCtrl',
            controllerAs: 'msgC'
        };
    }

})();
/**
 * @author jjrubio
 * created on 02.01.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('BaPageTopCtrl', BaPageTopCtrl);

    /** @ngInject */
    function BaPageTopCtrl(ENV, localStorageService, $uibModal, TranslationService, $timeout,
                           ConstantsService, $log, toastr, $rootScope, serviceConf, $http, routeConf) {

        var vm = this;
        vm.isDev = ENV.env === 'dev';
        vm.constants = {branches: []};

        function getUserAvatar() {
            ConstantsService.getUser().then(function () {
                vm.userName = localStorageService.get('user').username;
                vm.userPhoto = (localStorageService.get('user').photo) ?
                    localStorageService.get('user').photo.thumb.signedUrl : null;
            });
            $timeout(function () {
                getUserAvatar();
            }, 60000);
        }

        function ini() {
            getUserAvatar();

            ConstantsService.getBranchesDetail().then(function (branches) {
                vm.constants.branches = [];
                var avaibleBranches = localStorageService.get('branches');
                vm.hideSelect = avaibleBranches.length <= 2;

                if(avaibleBranches.length <= 2 ) {
                    var allbranches = localStorageService.get('branchesFull');
                    var userbranch =  _.find(allbranches, {_id: avaibleBranches[0]});
                    localStorageService.set('selectedBarResidence', userbranch);
                }

                _.forEach(avaibleBranches, function (it) {
                    _.forEach(branches, function (item) {
                        if (item._id === it) {
                            vm.constants.branches.push(item);
                        }
                    });
                });

                vm.constants.branches.splice(0, 0, {all: true, description: TranslationService.all});
                if (vm.constants.branches.length >= 1) {
                    var selectedBar = localStorageService.get('selectedBarResidence');
                    if (selectedBar) {
                        vm.selectedBranche = selectedBar;
                    } else {
                        vm.selectedBranche = vm.constants.branches[0];
                    }
                }
            });
        }

        $rootScope.$on('ckInChartPanel', function (event, data) {
            vm.selectedBranche = vm.constants.branches[0];
            _.forEach(vm.constants.branches, function (item) {
                if (item.description === data) {
                    vm.selectedBranche = item;
                    changeResidence(item);
                }
            });
        });

        function changeResidence(res) {
            vm.selectedBranche = res;
            localStorageService.set('selectedBarResidence', res);
            $rootScope.$emit('selectedBarBranChanged', res);
        }

        vm.changeResidence = changeResidence;

        vm.renewPass = function () {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: TranslationService.modal.renewPassword.title,
                ariaDescribedBy: 'modal-body',
                templateUrl: '/app/modal/renewPass/modal.html',
                controller: 'ModalRenewPassController',
                controllerAs: 'mdPwd',
                windowClass: 'repassmodal'
            });
            // Function when open modal
            modalInstance.result.then(function () {
            }, function (err) {
                // console.error('error', err);
                if (err && (err !== 'escape key press' && err !== 'backdrop click' && err !== 'bye')) {
                    toastr.error(TranslationService.errors.e500);
                }
            });
        };

        vm.getManual = function () {
            vm.downloading = true;
            var urlId = serviceConf.MasterTableService;
            urlId = urlId.replace(':idT', routeConf.file);
            urlId = urlId.replace(':idJ/:idP', routeConf.userManual);

            var con = {
                headers: {
                    'authentication': 'Bearer ' + localStorageService.get('sessionToken')
                },
                responseType: 'arraybuffer'
            };
            $http.get(urlId, con).then(function mySuccess(response) {
                var newBlob = new Blob([response.data], {type: 'application/pdf'});

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(newBlob);
                    vm.downloading = false;
                    return;
                } else {
                    // For other browsers:
                    // Create a link pointing to the ObjectURL containing the blob.
                    var dataURL = window.URL.createObjectURL(newBlob);
                    var link = document.createElement('a');
                    link.setAttribute('id', 'tmpLinkManual');
                    link.href = dataURL;
                    link.download = 'manual.pdf';
                    // link.target = '_self';
                    link.click();
                    setTimeout(function () {
                        // For Firefox it is necessary to delay revoking the ObjectURL
                        vm.downloading = false;
                        // link.parentNode.removeChild(link);
                        // document.body.removeChild(link);
                        window.URL.revokeObjectURL(dataURL);
                    }, 100);

                }
            });
        };

        ini();
        getUserAvatar();
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('pageTop', pageTop);


    /** @ngInject */
    function pageTop() {
        return {
            restrict: 'E',
            controller: 'BaPageTopCtrl',
            controllerAs: 'baPageTop',
            templateUrl: 'app/theme/components/pageTop/pageTop.html'
        };
    }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        switcherOn:'<',
        switcherOff:'<',
        switcherReadOnly:'<',
        switcherIconOn:'<',
        switcherIconOff:'<',
        iconSize:'<',
          onChange:'&'
      },
        link : function(scope, element, attrs, ngModelCtrl){
            scope.updateModel = function(item) {
                ngModelCtrl.$setViewValue(item);
            };
        }
    };
  }

})();

/**
 * Animated load block
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .directive('taskTimeTable', ['TranslationService',taskTimeTable]);

    /** @ngInject */
    function taskTimeTable(TranslationService) {
        return {

            restrict: 'A',
            templateUrl: 'app/theme/directives/taskTimeTable/taskTimeTable.html',
            scope: {
                slots: '=',
                disabled: '<'
            },
            link: function (scope, element, attributes) {
                var _days = moment.weekdaysShort();
                // Move Monday to last element
                _days.push(_days.shift());
                var _momentsOfDay= [TranslationService.morning,TranslationService.afternoon];


                var _selection = {
                    state: false,
                    day: [0, 0, 0, 0, 0, 0, 0],
                    hour: [0, 0]
                };

                function _loop(begin, end, step) {
                    var array = [];

                    for (var i = begin; i <= end; i += step) {
                        array.push(i);
                    }

                    return array;
                }

                function _toggle(what, day, hour) {
                    var i = 0;
                    if ( scope.disabled === true ){
                        return;
                    }
                    switch (what) {
                        case 'day':
                            _selection.day[day] = !_selection.day[day];

                            for (i = 0; i < 24; i++) {
                                scope.slots[day][i] = _selection.day[day];
                            }
                            break;

                        case 'hour':
                            _selection.hour[hour] = !_selection.hour[hour];

                            for (i = 0; i < 7; i++) {
                                scope.slots[i][hour] = _selection.hour[hour];
                            }
                            break;

                        case 'slot':
                            if (_selection.state) {
                                scope.slots[day][hour] = !scope.slots[day][hour];
                            }
                            break;
                    }
                }

                function _select(state, day, hour) {
                    _selection.state = state;

                    if (_selection.state) {
                        _toggle('slot', day, hour);
                    }
                }

                function _init() {
                    scope.loop = _loop;
                    scope.toggle = _toggle;
                    scope.select = _select;

                    scope.days = _days;
                    scope.momentsOfDay = _momentsOfDay;
                    console.log('slots', scope.slots);
                }

                _init();
            }
        };
    }

})();

/*
 * @author jjrubio
 * created on 09/01/2018
 */

function CanteenNewController(TranslationService, $log, toastr, routeConf, DishService, MasterTableService,
                              $rootScope, $locale, ConfigService) {
    var vm = this;

    vm.dish = null;
    vm.imgAvatar = '';
    vm.update = '';
    vm.tit = '';
    vm.submitted = false;
    vm.avatarUploading = false;
    vm.imgAvatar = '';
    vm.photoAvatar = undefined;
    vm.olderId = '';

    vm.$doCheck = function () {
        if ((vm.dish && vm.dish._id) && (vm.olderId !== vm.dish._id)) {
            vm.olderId = angular.copy(vm.dish._id);
            vm.$onInit();
        }
    };

    vm.$onInit = function () {
        vm.submitted = false;
        vm.imgOri = vm.dish.photo;
        vm.avatarUploading = false;
        var out = [];
        _.map(vm.constant.tags, function (item) {
            if (!(_.find(out, function (tg) {
                    return tg === item;
                }))) {
                out.push(item);
            }
        });

        vm.constant.tags = out;

        _.forEach(vm.dish.nutritional, function (value, key) {
            vm.dish.nutritional[key] = parseNumberToString(value);
        });

        vm.dish.tags = (!vm.dish.tags) ? [] : vm.dish.tags;
        // Todo recorrer todos los alergenos y asignarlos a true
        if (!vm.dish._id) {
            vm.dish = {
                active: true,
                text: '',
                title: '',
                dishType: {},
                photo: {},
                tags: [],
                nutritional: {
                    calorie: '',
                    joules: '',
                    protein: '',
                    carbohydrates: '',
                    sugars: '',
                    fat: '',
                    saturedFat: '',
                    fiber: '',
                    salt: ''
                }
            };
            vm.tit = TranslationService.canteen.newCourse;
        } else {
            vm.tit = TranslationService.canteen.editCourse + ' ' + vm.dish.title;
            if (vm.dish && vm.dish.photo && vm.dish.photo.thumb) {
                vm.imgAvatar = (vm.dish.photo.thumb.signedUrl) ? vm.dish.photo.thumb.signedUrl : '';
            }
            vm.photoAvatar = angular.copy(vm.dish.photo);
        }

        vm.tagsOri = vm.dish.tags;
        vm.allergens = [];
        vm.selectedAllergens = [];

        // Get all allergens
        ConfigService.query({functionality: 'allergyTypes'}, function (data) {
            vm.allergens = data;
            $log.debug('Allergens: ', data);
            _.forEach(vm.dish.allergyTypes, function (all) {
                _.find(vm.allergens, function (conAll) {
                    return conAll._id === all._id;
                }).selected = true;

            });
            // Get menu types
            MasterTableService.query({idT: routeConf.masterTable, idJ: routeConf.dishType}, function (data) {
                vm.dishTypes = data;
                if (!vm.dish._id) {
                    vm.dish.dishType = data[0];
                }
                $log.debug('dishTypes: ', data);
            }, function (err) {
                $log.error('Error getting dishTypes', err);
                toastr.error(TranslationService.errors.e500);
            });
        }, function (err) {
            $log.error('Error getting allergens', err);
            toastr.error(TranslationService.errors.e500);
        });
    };

    vm.inTagEnter = function (find, event) {
        find = '';
    };

    vm.changeAllerge = function (all, courseFor) {
        courseFor.$setDirty();
        all.selected = !all.selected;
    };

    vm.selectTypeMe = function (type) {
        $log.error(type);
        vm.dish.dishType = {_id: type};
    };

    vm.getObjectKey = function (obj, index) {
        return Object.keys(obj)[index];
    };

    vm.getObjectKeyTranslate = function (obj, index) {
        return 'CANTEENNEWCOURSE.' + vm.getObjectKey(obj, index).toUpperCase();
    };

    vm.save = function (formName) {
        if ((!vm.submitted && !formName.$valid) || !formName.$valid) {
            vm.submitted = true;
            var visibleInvalids = angular.element.find('.ng-invalid:visible');
            // first is form... is invalid always got in 2 length
            if (visibleInvalids && visibleInvalids.length > 1) {
                visibleInvalids[1].focus();
            }
        } else {
            _.forEach(vm.dish.nutritional, function (value, key) {
                vm.dish.nutritional[key] = parseStrToNumber(value);
            });
            vm.dish.photo = angular.copy(vm.photoAvatar);
            if (!(vm.dish.allergyTypes)) {
                vm.dish.allergyTypes = [];
            }
            vm.dish.allergyTypes = [];
            if (vm.allergens.length > 0) {
                for (var i = 0; i < vm.allergens.length; i++) {
                    if (vm.allergens[i].selected) {
                        vm.dish.allergyTypes.push(vm.allergens[i]._id);
                    }
                }
            }
            if (vm.dish._id) {
                DishService.post({idD: vm.dish._id}, vm.dish, function (data) {
                    $log.debug('DishService post (update): ', data);
                    toastr.success(TranslationService.dialog.saveok);
                    vm.dish = angular.copy(data);
                    vm.update = 'true';
                }, function (error) {
                    $log.error('DishService post (update) error: ', error);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
            else {
                DishService.post(vm.dish, function (data) {
                    $log.debug('DishService post (create): ', data);
                    toastr.success(TranslationService.dialog.saveok);
                    vm.update = 'true';
                }, function (error) {
                    $log.error('DishService post (create) error: ', error);
                    toastr.error(TranslationService.errors.e500, TranslationService.error,
                        {progressBar: true, timeOut: 8000, extendedTimeOut: 1000, tapToDismiss: true});
                });
            }
        }
    };

    /**
     * @ngdoc method
     * @name parseStrToNumber
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that change  string format to float format
     * @param(strIn) is string to change
     *
     */
    function parseStrToNumber(strIn) {
        var response = 0;
        if (strIn) {
            var str = _.toString(strIn);
            var formats = $locale.NUMBER_FORMATS;
            var decimalSepRe = new RegExp('\\' + formats.DECIMAL_SEP, 'g');
            var groupSepRe = new RegExp('\\' + formats.GROUP_SEP, 'g');
            response = parseFloat(str.replace(groupSepRe, '').replace(decimalSepRe, '.'));
        }
        return response;
    }

    /**
     * @ngdoc method
     * @name parseNumberToString
     * @methodOf Tagaste.activityDetailCom.controller:activityDetailController
     * @description
     * Method that change  float format to string format
     * @param(num) is string to change
     *
     */
    function parseNumberToString(num) {
        var response = 0;
        if (num) {
            var formats = $locale.NUMBER_FORMATS;
            response = num.toString().replace('.', formats.DECIMAL_SEP);
        }
        return response;
    }

    $rootScope.$on('cancelCreateNewDish', function () {
        vm.dish = null;
    });
}

angular
    .module('BlurAdmin.canteenNewComponent')
    .component('carteenNew', {
        templateUrl: 'app/components/canteen/backItems/carteenNew/carteenNew.html',
        controllerAs: 'cnc',
        controller: CanteenNewController,
        bindings: {
            dish: '=',
            update: '=',
            constant: '=',
            istour: '<'
        }
    });

/*
 photo (imagen) → {file}.
 title (título)
 text (texto)
 dishType (tipo preferente)  → {dishType}
 foodTypes (tipos de alimento) → [{foodType}]
 allergyTypes (tipos de alergeno) → [{allergyType}]
 tags (array de etiquetas)
 active (flag de activo si/no)
 */

function InDishController($timeout, $log, $rootScope, TranslationService, DishTypes) {
    var vm = this;

    vm.tit = '';
    vm.ready = false;
    vm.chose = false;
    vm.hideReserve = false;
    vm.disba = {};
    vm.noflipper = false;

    vm.$onInit = function () {
        $log.debug('vm.disba: ', vm.disba);
        if (vm.disba === undefined) {
            vm.disba = {nutritional: {}};
        }
        // TODO Translate
        if (vm.type && vm.type !== '') {
            vm.disba.type = vm.type;
        }
        vm.disba.allergens = '';
        if (vm.disba.allergyTypes) {
            for (var i = 0; i < vm.disba.allergyTypes.length; i++) {
                if (i === (vm.disba.allergyTypes.length - 1)) {
                    vm.disba.allergens = vm.disba.allergens + vm.disba.allergyTypes[i].description;
                } else {
                    vm.disba.allergens = vm.disba.allergens + vm.disba.allergyTypes[i].description + ', ';
                }
            }
            if (vm.allergies) {
                vm.allergies = angular.copy(vm.allergies);
            } else {
                vm.allergies = angular.copy(vm.disba.allergyTypes);
            }
            if (vm.disba.allergyTypes) {
                _.forEach(vm.disba.allergyTypes, function (all) {
                    _.find(vm.allergies, function (conAll) {
                        return conAll._id === all._id;
                    }).selected = true;
                });
            }
        }

        if (vm.disba.allergens === '') {
            vm.disba.allergens = TranslationService.canteen.allergens.noAllergens;
        }

        vm.disba.titori = '"' + TranslationService.canteen.allergensToolTips.inDish + ': ' + vm.disba.text + '</br>' +
            TranslationService.canteen.allergensToolTips.Kal + ': ' + vm.disba.nutritional.calorie +
            '</br>' + TranslationService.canteen.allergens.allergens + ': ' + vm.disba.allergens;

        if (vm.disba.userNumber) {
            vm.disba.titori = vm.disba.titori + '</br>' + TranslationService.canteen.allergensToolTips.totAppUsr +
                ': ' + vm.disba.userNumber + '"';
        } else {
            vm.disba.titori = vm.disba.titori + '"';
        }

        if (vm.disba.text && vm.disba.text.length > 17) {
            vm.disba.tit = vm.disba.text.substr(0, 17) + '..';
        } else {
            vm.disba.tit = vm.disba.text;
        }

        vm.hideReserve = ( !vm.type || vm.type === DishTypes.extraVarTitle);

        if (!vm.hideReserve && (!vm.disba.userNumber || vm.disba.userNumber === '')) {
            vm.disba.userNumber = 0;
        }

        vm.ready = true;
    };

    vm.goEdit = function ($event) {
        $event.stopPropagation();
        vm.goedit = vm.disba;
    };

    vm.ck = function () {
        if (vm.isselect !== false && !vm.readonly) {
            vm.chose = !(vm.chose);
            vm.returncourse = vm.disba;
        }
    };

    $rootScope.$on('addNewDish', function () {
        vm.ck();
    });

}

angular
    .module('BlurAdmin.canteenInDish')
    .component('inDishCom', {
        templateUrl: 'app/components/canteen/backItems/inDish/inDish.html',
        controllerAs: 'dsba',
        controller: InDishController,
        bindings: {
            disba: '<',
            allergies: '<',
            isselect: '<',
            goedit: '=',
            type: '@',
            deletestr: '=',
            returncourse: '=',
            readonly: '=',
            noflipper: '=',
            showselected: '='
        }
    });
/**
 * Created by jgutierrez on 20/09/2018.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.services.servicesMenu')
        .controller('InServiceReserveModalController', InServiceReserveModalController);

    InServiceReserveModalController.$inject = ['data', 'modeCancel', 'showReserveView', '$rootScope', '$uibModalInstance'];

    /** @ngInject */
    function InServiceReserveModalController(data, modeCancel, showReserveView, $rootScope, $uibModalInstance) {
        var vm = this;

        vm.data = data;
        vm.modeCancel = modeCancel;
        vm.showReserveView = showReserveView;
        vm.animSchedule = true;

        $rootScope.$on('refreshScheduler', function () {
            $uibModalInstance.dismiss();
        });
    }
})();
/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/modal/activityList/activityList.html','<div class="modal-header modal-room-header">\n    <h4 class="panel-title">{{mrdc.resident.name}} {{mrdc.resident.surname}}</h4>\n    <div class="room-number">\n        <div class="room-label">\n            H.<b>{{mrdc.roomCode}}</b>\n        </div>\n    </div>\n</div>\n<div class="modal-body">\n    <div class="modal-room-detail">\n        <div class="container">\n            <div class="row">\n                <div class="col-12">\n                    <div class="customTitle">\n                        <b>{{\'ACTIVITYLIST.TITLE\' | translate}}</b>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-12">\n                    <div class="activity-list">\n                        <table ng-table="mrdc.tableParamsActivities" id="tableParams"\n                               class="table table-hover table-condensed fixNgTable" show-filter="false">\n                            <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                class="ng-binding">\n                                <td data-title="" ng-attr-title="">\n                                    {{row.title}}\n                                </td>\n                                <td data-title="" ng-attr-title="">\n                                    <i class="fa ion-trash-b iconNgTable edit checkin-icon margin-left"\n                                       uib-tooltip="{{\'BUTTONS.DELETERESERVE\' | translate}}"\n                                       aria-hidden="true"\n                                       tagaste-click="mrdc.deleteActivity(row); $event.stopPropagation();">\n                                    </i>\n                                </td>\n                            </tr>\n                        </table>\n                    </div>\n                    <div class="activity-list">\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button ng-click="$dismiss(mrdc.modeDismiss)" type="button" class="btn btn-success">{{\'BUTTONS.BACK\' | translate}}\n    </button>\n</div>\n');
$templateCache.put('app/modal/modalBillingForecast/modalBillingForecast.html','<div class="modal_concept">\n    <div class="modal-header modal-room-header">\n        <h4 class="panel-title">{{\'BILLING_FORECAST.TITLE\' | translate}}</h4>\n        <div class="buttons" style="float: right; margin-top: 10px;">\n            <button ng-click="mbfc.selectAll()" ng-disabled="mbfc.checkAllSelected() || mbfc.loading" type="button" class="btn btn-success">\n                {{\'BUTTONS.SELECTALL\' | translate}}\n            </button>\n            <button ng-click="mbfc.deselectAll()" ng-disabled="mbfc.checkAllDeselected() || mbfc.loading" type="button" class="btn btn-success">\n                {{\'BUTTONS.DESELECTALL\' | translate}}\n            </button>\n        </div>\n    </div>\n    <div class="modal-body">\n        <div class="row">\n            <div ng-class="\'col-xs-12\'">\n                <div class="loading-spinner" ng-if="mbfc.loading"><span\n                    class="fa fa-spinner fa-spin"></span>\n                </div>\n                <table ng-table="mbfc.tableParams" ng-hide="mbfc.loading"\n                       class="table table-hover table-condensed fixNgTable"\n                       style="font-size: 11px; color: #fff;">\n                    <colgroup>\n                        <col width="30px">\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                    </colgroup>\n                    <tr ng-repeat="row in $data track by $index" style="cursor:pointer;" class="ng-binding"\n                        tagaste-click="mbfc.openConceptDetail(row);$event.stopPropagation();">\n                        <td width="30" tagaste-click="$event.stopPropagation();">\n                            <label class="custom-checkbox custom-checkbox-light" style="margin-left: 5px;">\n                                <input type="checkbox" ng-model="row.selected"\n                                       ng-click="mbfc.checkboxChanges(row)">\n                                <span></span>\n                            </label>\n                        </td>\n                        <td data-title="\'PAYMENT.TYPE\'|translate"\n                            sortable="\'type\'"\n                            ng-attr-title="{{row.typeStr}}">\n                            {{row.typeStr}}\n                        </td>\n                        <td data-title="\'PAYMENT.CONCEPT\'|translate"\n                            sortable="\'description\'"\n                            ng-attr-title="{{row.description}}">\n                            {{row.description}}\n                        </td>\n                        <td data-title="\'PAYMENT.NAME\'|translate"\n                            sortable="\'clientName\'"\n                            ng-attr-title="{{row.clientName}}">\n                            {{row.clientName}}\n                        </td>\n                        <td data-title="\'TOTAL\'|translate"\n                            sortable="\'amount\'"\n                            ng-attr-title="{{row.amount}}">\n                            {{row.amount ? row.amount : 0}}\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer modal-footer-without-margin">\n        <button ng-click="mbfc.cancel()" type="button" class="btn btn-success">\n            <i class="ion-arrow-left-c"></i> {{\'BUTTONS.BACK\' | translate}}\n        </button>\n        <button ng-click="mbfc.generateInvoices()" type="button" class="btn btn-success"\n                ng-disabled="!(mbfc.selection && mbfc.selection.length) || mbfc.loading">\n            <i class="ion-android-checkmark-circle"></i> {{\'BUTTONS.INVOICES\' | translate}}\n        </button>\n    </div>\n</div>');
$templateCache.put('app/modal/modalCancelReservationModal/modalCancelReservation.html','<div class="modal_cancel_reservation">\n    <div class="modal-header modal-room-header">\n        <h4 class="panel-title">{{\'RESERVATIONS.CANCELMODAL.TITLE\' | translate}}</h4>\n    </div>\n    <div class="modal-body">\n        <form name="cancelReservationForm" autocomplete="false">\n            <div class="row" style="color: #fff; margin-bottom: 20px;">\n                <div class="col-md-12">\n                    <div class="accordionSubTitle">\n                        <div class="accordionSubTitleText" style="line-height: 30px;">\n                            {{\'RESERVATIONS.CANCELMODAL.DEPOSIT\' | translate}}\n                        </div>\n                        <div class="accordionSubTitleBorder"></div>\n                    </div>\n                    <div class="content">\n                        <label class="custom-checkbox" style="margin-bottom: 5px;">\n                            <input id="checkDeposit" type="checkbox" ng-model="mcrc.generateDeposit" ng-disabled="false">\n                            <span>{{\'RESERVATIONS.CANCELMODAL.RETURNDEPOSIT\' | translate}}</span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class="row" style="color: #fff; margin-bottom: 20px;">\n                <div class="col-md-12">\n                    <div class="accordionSubTitle">\n                        <div class="accordionSubTitleText" style="line-height: 30px;">\n                            {{\'RESERVATIONS.CANCELMODAL.TUITION\' | translate}}\n                        </div>\n                        <div class="accordionSubTitleBorder"></div>\n                    </div>\n                    <div class="content">\n                        <label class="custom-checkbox" style="margin-bottom: 5px;">\n                            <input id="checkTuition" type="checkbox" ng-model="mcrc.generateTuition" ng-disabled="false">\n                            <span>{{\'RESERVATIONS.CANCELMODAL.RETURNTUITION\' | translate}}</span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class="row buttons">\n                <div class="col-xs-12 text-right">\n                    <button class="btn btn-success btn-with-icon"\n                            style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                            tagaste-click="mcrc.cancel($event)">\n                        <i class="ion-close"></i>{{\'RESERVATIONS.CANCELMODAL.CANCEL\' | translate}}\n                    </button>\n                    <button class="btn btn-success btn-with-icon"\n                            style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                            ng-disabled="!(mcrc.generateDeposit || mcrc.generateTuition)"\n                            tagaste-click="mcrc.accept($event)">\n                        <i class="ion-checkmark"></i>{{\'RESERVATIONS.CANCELMODAL.ACCEPT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('app/modal/modalChooseRoom/modalChooseRoom.html','<div class="modal_concept">\n    <div class="modal-header modal-room-header">\n        <h4 class="panel-title">{{\'RESERVATIONS.DETAIL.CHOOSEANOTHERROOM\' | translate}}</h4>\n        <p style="color:#fff; padding: 5px 15px;">{{\'RESERVATIONS.DETAIL.CHOOSEANOTHERROOMEXPLANATION\' | translate}}</p>\n    </div>\n    <div class="modal-body">\n        <form name="roomForm" autocomplete="false">\n            <div class="row">\n                <div class="col-md-6">\n                    <!--room-->\n                    <div class="input-group" id="residentDetailRoom">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              tooltip-placement="top-left"\n                              uib-tooltip="{{\'RESERVATIONS.LIST.ROOM\'| translate}}">\n                            <span class="fa fa-bed" style="margin-left:-1px"></span></span>\n                        <ui-select ng-model="mcrc.selectedRoom"\n                                   class="btn-group bootstrap-select form-control"\n                                   style="-webkit-border-radius:0; -moz-border-radius:0; border-radius: 0; z-index: 9999;"\n                                   name="room"\n                                   append-to-body="true"\n                                   search-enabled="true"\n                                   ng-change="mcrc.selectRoom();">\n                            <ui-select-match placeholder="{{\'RESERVATIONS.LIST.ROOM\'| translate}}">\n                                <span> {{mcrc.selectedRoom.description}}</span>\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mcrc.availableRooms |\n                                    uiSelectFilter: {description:$select.search}">\n                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                <i ng-if="option.roomType && option.roomType.description">({{option.roomType.description}})</i>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </div>\n            <div class="modal-footer modal-footer-without-margin">\n                <button ng-click="mcrc.cancel()" type="button" class="btn btn-success">\n                    <i class="ion-arrow-left-c"></i> {{\'BUTTONS.BACK\' | translate}}\n                </button>\n                <button ng-click="mcrc.accept()" type="button" class="btn btn-success"\n                        ng-disabled="!mcrc.selectedRoom || mcrc.invalidRoomType">\n                    <i class="ion-android-checkmark-circle"></i> {{\'BUTTONS.SAVE\' | translate}}\n                </button>\n            </div>\n        </form>\n    </div>\n</div>');
$templateCache.put('app/modal/modalConceptDetail/modalConceptDetail.html','<div class="modal_concept">\n    <div class="modal-header modal-room-header">\n        <h4 class="panel-title">{{\'BILLING.CONCEPTMODAL.TITLE\' | translate}}</h4>\n    </div>\n    <div class="modal-body">\n        <form name="conceptForm" autocomplete="false">\n            <div class="row" style="margin-bottom: 10px">\n                <div class="col-md-12" ng-if="mcdc.selectingCustomConcept">\n                    <!-- customConcepts -->\n                    <div class="input-group">\n                        <span uib-tooltip="{{\'BILLING.CONCEPTMODAL.CUSTOMCONCEPT\'  | translate}}"\n                              class="input-group-addon input-group-addon-primary addon-left"\n                              tooltip-placement="top-left">\n                            <span class="ion-card"></span>\n                        </span>\n                        <ui-select ng-model="mcdc.selectedCustomConcept"\n                                   style="-webkit-border-radius:0; -moz-border-radius:0; border-radius: 0; z-index: 9999;"\n                                   class="btn-group bootstrap-select form-control"\n                                   append-to-body="true"\n                                   ng-disabled="mcdc.readonly"\n                                   name="customConcept"\n                                   ng-change="mcdc.changeCustomConcept();"\n                                   search-enabled="true">\n                            <ui-select-match\n                                allow-clear=true\n                                placeholder="{{\'BILLING.CONCEPTMODAL.CUSTOMCONCEPT\'| translate}}">\n                                {{mcdc.selectedCustomConcept.description}}\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mcdc.availableCustomConcepts">\n                                <div ng-bind-html="option.description | highlight: $select.search"></div>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n                <div class="col-md-12" ng-if="!mcdc.selectingCustomConcept && !mcdc.readonly && !mcdc.acceptedRequest && !mcdc.isOccupancy">\n                    <button type="button" ng-click="mcdc.selectCustomConcept()"\n                            class="btn btn-success btn-with-icon pull-right">\n                        <i class="ion-android-checkbox-outline"></i>{{\'BUTTONS.SELECTCUSTOMCONCEPT\' | translate}}\n                    </button>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-6">\n                    <div class="input-group">\n                        <span uib-tooltip="{{\'PAYMENT.RESIDENCE\'  | translate}}"\n                              class="input-group-addon input-group-addon-primary addon-left"\n                              tooltip-placement="top-left">\n                            <span class="ion-card"></span>\n                        </span>\n                        <ui-select ng-model="mcdc.concept.branch" ng-if="mcdc.userBranches"\n                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; z-index: 9999;"\n                                   class="btn-group bootstrap-select form-control"\n                                   append-to-body="true"\n                                   ng-disabled="mcdc.readonly"\n                                   name="branch"\n                                   required\n                                   ng-change="mcdc.updateAvailableCustomConcepts()"\n                                   ng-class="{\'select-invalid\': mcdc.submitted && !mcdc.concept.branch}"\n                                   search-enabled="true">\n                            <ui-select-match\n                                allow-clear=true\n                                placeholder="{{\'PAYMENT.RESIDENCE\'| translate}}">\n                                {{mcdc.concept.branch.description}}\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mcdc.userBranches">\n                                <div ng-bind-html="option.description | highlight: $select.search"></div>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n                <div class="col-md-6">\n                    <date-picker-comp tooltip-text="\'BILLING.CONCEPTMODAL.DATE\' | translate"\n                                      placeholder="\'BILLING.CONCEPTMODAL.DATE\' | translate"\n                                      tooltip-placement="bottom-left" date-value="mcdc.concept.dateFrom"\n                                      mode-read-only="mcdc.readonly"\n                                      form-reference="resForm" name-field="\'dateFrom\'">\n                    </date-picker-comp>\n                </div>\n                <div class="col-md-6">\n                    <div ng-if="mcdc.concept && mcdc.concept.related.kind === \'Occupancy\'">\n                        <date-picker-comp tooltip-text="\'BILLING.CONCEPTMODAL.DATETO\' | translate"\n                                          placeholder="\'BILLING.CONCEPTMODAL.DATETO\' | translate"\n                                          tooltip-placement="bottom-left" date-value="mcdc.concept.dateTo"\n                                          mode-read-only="mcdc.readonly"\n                                          form-reference="resForm" name-field="\'dateTo\'">\n                        </date-picker-comp>\n                    </div>\n                </div>\n                <div class="col-md-6" ng-if="mcdc.concept.related && mcdc.concept.related.kind === \'Occupancy\'">\n                    <div class="input-group" ng-if="mcdc.concept.related.roomRates && mcdc.concept.related.roomRates.length > 1">\n                        <span uib-tooltip="{{\'BILLING.CONCEPTMODAL.ROOMRATE\'  | translate}}"\n                              class="input-group-addon input-group-addon-primary addon-left"\n                              tooltip-placement="top-left">\n                            <span class="ion-card"></span>\n                        </span>\n                        <ui-select ng-model="mcdc.selectedRoomRate"\n                                   style="-webkit-border-radius:0; -moz-border-radius:0; border-radius: 0; z-index: 9999;"\n                                   class="btn-group bootstrap-select form-control"\n                                   append-to-body="true"\n                                   ng-disabled="mcdc.readonly"\n                                   name="roomRate"\n                                   required\n                                   ng-change="mcdc.changeRoomRate();"\n                                   ng-class="{\'select-invalid\': mcdc.submitted && !mcdc.selectedRoomRate}"\n                                   search-enabled="true">\n                            <ui-select-match\n                                allow-clear=true\n                                placeholder="{{\'BILLING.CONCEPTMODAL.ROOMRATE\'| translate}}">\n                                {{mcdc.selectedRoomRate.descriptionAll}}\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mcdc.concept.related.roomRates">\n                                <div ng-bind-html="option.descriptionAll | highlight: $select.search"></div>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class="input-group" ng-if="!(mcdc.concept.related.roomRates && mcdc.concept.related.roomRates.length > 1)">\n                        <span\n                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.ROOMRATE\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="true"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'BILLING.CONCEPTMODAL.ROOMRATE\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               ng-model="mcdc.selectedRoomRate.descriptionAll">\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-xs-12">\n                    <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              uib-tooltip="{{\'BILLING.CONCEPTMODAL.DESCRIPTION\' | translate}}"\n                              tooltip-placement="right-top" style="vertical-align: top;">\n                            <span class="ion-android-create"></span>\n                        </span>\n                        <textarea ng-model="mcdc.concept.description" name="description"\n                                  class="form-control with-primary-addon" aria-describedby="basic-addon1"\n                                  ng-disabled="mcdc.readonly || mcdc.lockedConcept"\n                                  ng-class="{\'invalid\': mcdc.submitted && conceptForm.description.$invalid}"\n                                  required\n                                  placeholder="{{\'BILLING.CONCEPTMODAL.DESCRIPTION\'|translate}}">\n                        </textarea>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <uib-accordion>\n                        <uib-accordion-group heading="{{\'RESIDENTWINDOWDETAIL.BILLING.TAXES\' | translate}}"\n                                             is-open="mcdc.taxesopen"\n                                             panel-class="panel-primary accordion-panel">\n                            <uib-accordion-heading>\n                                {{\'RESIDENTWINDOWDETAIL.BILLING.TAXES\' | translate}}\n                                <i class="pull-right glyphicon"\n                                   ng-class="{\'glyphicon-chevron-down\': mcdc.taxesopen,\n                                        \'glyphicon-chevron-right\': !mcdc.taxesopen}"></i>\n                            </uib-accordion-heading>\n                            <table ng-table="mcdc.tableParamsTaxes"\n                                   class="table table-hover table-condensed fixNgTable" show-filter="false"\n                                   style="font-size: 11px;">\n                                <colgroup>\n                                    <col>\n                                    <col>\n                                    <col width="50px" ng-if="!mcdc.readonly">\n                                </colgroup>\n                                <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                    class="ng-binding">\n                                    <!-- {{row}} -->\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_NAME\'|translate"\n                                        sortable="\'tax\'"\n                                        ng-attr-title="{{row.name}}"\n                                        ng-if="row.modeEdit">\n                                        <select class="form-control"\n                                                name="tax_{{$index +1}}"\n                                                id="tax_{{$index +1}}" ng-model="row.value"\n                                                ng-change="mcdc.selectTax(row)"\n                                                ng-options="tax.name for tax in mcdc.constants.tax track by tax._id"\n                                                required>\n                                        </select>\n                                    </td>\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_NAME\'|translate"\n                                        sortable="\'tax\'"\n                                        ng-attr-title="{{row.name}}"\n                                        ng-if="!row.modeEdit">\n                                        {{row.name}}\n                                    </td>\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_RATE\'|translate"\n                                        ng-if="row.modeEdit"\n                                        sortable="\'rate\'" ng-attr-title="{{row.value.rate}}">\n                                        {{row.value.rate}}{{row.value.isPercentage ? \'%\' : \'\'}}\n                                    </td>\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_RATE\'|translate"\n                                        ng-if="!row.modeEdit"\n                                        sortable="\'rate\'" ng-attr-title="{{row.rate}}">\n                                        {{row.rate}}{{row.isPercentage ? \'%\' : \'\'}}\n                                    </td>\n                                    <td ng-if="!rdetc.readonly && row.modeEdit">\n                                        <i class="glyphicon glyphicon-ok iconNgTable edit"\n                                           uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                                           ng-if="row.modeEdit" aria-hidden="true"\n                                           tagaste-click="mcdc.saveTax(row); $event.stopPropagation();">\n                                        </i>\n                                    </td>\n                                    <td ng-if="!mcdc.readonly && !row.modeEdit && !mcdc.lockedConcept">\n                                        <i class="fa fa-trash-o iconNgTable edit"\n                                           uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                           ng-if="!row.modeEdit" aria-hidden="true"\n                                           tagaste-click="mcdc.deleteTax(row, $index); $event.stopPropagation();">\n                                        </i>\n                                    </td>\n                                    <td ng-if="!mcdc.readonly && row.modeEdit">\n                                        <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                                           uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                                           ng-if="row.modeEdit" aria-hidden="true"\n                                           tagaste-click="mcdc.cancelTax(row); $event.stopPropagation();">\n                                        </i>\n                                    </td>\n                                </tr>\n                            </table>\n                            <div class="row">\n                                <div ng-class="\'col-md-offset-10 col-xs-2\'">\n                                    <button type="button"\n                                            style="position: relative;  margin-top: 15px;  margin-bottom: 15px; font-size: 12px;"\n                                            ng-if="!mcdc.readonly && !mcdc.addingTax && !mcdc.lockedConcept"\n                                            ng-click="mcdc.addTax()"\n                                            class="btn btn-success btn-with-icon">\n                                        <i class="ion-android-checkbox-outline"></i>{{\'BUTTONS.ADD\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <uib-accordion>\n                        <uib-accordion-group heading="{{\'RESIDENTWINDOWDETAIL.BILLING.DISCOUNTS\' | translate}}"\n                                             is-open="mcdc.discountsopen"\n                                             panel-class="panel-primary accordion-panel">\n                            <uib-accordion-heading>\n                                {{\'RESIDENTWINDOWDETAIL.BILLING.DISCOUNTS\' | translate}}\n                                <i class="pull-right glyphicon"\n                                   ng-class="{\'glyphicon-chevron-down\': mcdc.discountsopen,\n                                        \'glyphicon-chevron-right\': !mcdc.discountsopen}"></i>\n                            </uib-accordion-heading>\n                            <div class="row">\n                                <div class="col-md-6">\n                                    <div class="input-group">\n                                        <span\n                                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.FIXEDDISCOUNT\' | translate}}"\n                                            tooltip-placement="right"\n                                            class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="ion-social-euro"></span>\n                                        </span>\n                                        <input type="text"\n                                               ng-disabled="mcdc.readonly || mcdc.lockedConcept"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.CONCEPTMODAL.FIXEDDISCOUNT\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               valid-number\n                                               ng-blur="mcdc.calcTotalTaxes()"\n                                               ng-model="mcdc.concept.discountF">\n                                    </div>\n                                </div>\n                                <div class="col-md-6">\n                                    <div class="input-group">\n                                        <span\n                                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.PERCENTDISCOUNT\' | translate}}"\n                                            tooltip-placement="right"\n                                            class="input-group-addon input-group-addon-primary addon-left">\n                                            <span style="font-weight: bold;">%</span>\n                                        </span>\n                                        <input type="text"\n                                               ng-disabled="mcdc.readonly || mcdc.lockedConcept"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.CONCEPTMODAL.PERCENTDISCOUNT\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               valid-number\n                                               ng-blur="mcdc.calcTotalTaxes()"\n                                               ng-model="mcdc.concept.discountP">\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-3">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.BASE\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="mcdc.readonly || mcdc.lockedConcept"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'BILLING.CONCEPTMODAL.BASE\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               required="true"\n                               ng-blur="mcdc.calcTotalTaxes()"\n                               ng-model="mcdc.concept.amount">\n                    </div>\n                </div>\n                <div class="col-md-3">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.TOTAL\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="true"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'BILLING.CONCEPTMODAL.TOTAL\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               ng-model="mcdc.totalWithoutTaxes">\n                    </div>\n                </div>\n                <div class="col-md-6"\n                     ng-if="(!mcdc.concept._id || (mcdc.concept.related && mcdc.concept.related.kind === \'Other\')) && !mcdc.isTuition">\n                    <label class="custom-checkbox" style="color: white;">\n                        <input id="checkDesposit" type="checkbox" ng-model="mcdc.concept.isDeposit"\n                               ng-disabled="mcdc.readonly || mcdc.isRequestDeposit">\n                        <span>{{\'BILLING.CONCEPTMODAL.DEPOSITCONCEPT\' | translate}}</span>\n                    </label>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-6">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.TOTALWITHTAX\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                               style="font-weight: bold; font-size: 1.2em;"\n                               ng-disabled="true"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'BILLING.CONCEPTMODAL.TOTALWITHTAX\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               ng-model="mcdc.totalWithTaxes">\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class="modal-footer modal-footer-without-margin">\n        <button ng-click="$dismiss(mcdc.modeDismiss)" type="button" class="btn btn-success">\n            <i class="ion-arrow-left-c"></i> {{\'BUTTONS.BACK\' | translate}}\n        </button>\n        <button ng-if="!mcdc.readonly" ng-click="mcdc.save(conceptForm)" type="button" class="btn btn-success">\n            <i class="ion-android-checkmark-circle"></i> {{\'BUTTONS.SAVE\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/modal/modalMasterTablesConceptDetail/modalMasterTablesConceptDetail.html','<div class="modal_concept">\n    <div class="modal-header modal-room-header">\n        <h4 class="panel-title">{{\'BILLING.CONCEPTMODAL.TITLE\' | translate}}</h4>\n    </div>\n    <div class="modal-body">\n        <form name="conceptForm" autocomplete="false">\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="input-group">\n                        <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.RESIDENCE\' | translate}}"\n                              class="input-group-addon input-group-addon-primary addon-left"\n                              tooltip-placement="top-left">\n                            <span class="ion-card"></span>\n                        </span>\n                        <ui-select multiple ng-model="mtcdc.concept.branches"\n                                   ng-disabled="mtcdc.readonly"\n                                   append-to-body="false"\n                                   search-enabled="true">\n                            <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}">\n                                {{$item.description}}\n                            </ui-select-match>\n                            <ui-select-choices\n                                repeat="branches in mtcdc.constants.branch">\n                                <span ng-bind-html="branches.description | highlight: $select.search">\n                                </span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class="errorValidation invalidInputMsg bounceIn animate"\n                         ng-if="(mtcdc.submitted) && (mtcdc.concept.branches.length < 1)">\n                        *{{\'ERROR.NOTVALIDRESIDENCE\' | translate}}\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-xs-12">\n                    <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              uib-tooltip="{{\'BILLING.CONCEPTMODAL.DESCRIPTION\' | translate}}"\n                              tooltip-placement="right-top" style="vertical-align: top;">\n                            <span class="ion-android-create"></span>\n                        </span>\n                        <textarea ng-model="mtcdc.concept.description" name="description"\n                                  class="form-control with-primary-addon" aria-describedby="basic-addon1"\n                                  ng-disabled="mtcdc.readonly"\n                                  ng-class="{\'invalid\': mtcdc.submitted && conceptForm.description.$invalid}"\n                                  required\n                                  placeholder="{{\'BILLING.CONCEPTMODAL.DESCRIPTION\'|translate}}">\n                        </textarea>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <uib-accordion>\n                        <uib-accordion-group heading="{{\'RESIDENTWINDOWDETAIL.BILLING.TAXES\' | translate}}"\n                                             is-open="mtcdc.taxesopen"\n                                             panel-class="panel-primary accordion-panel">\n                            <uib-accordion-heading>\n                                {{\'RESIDENTWINDOWDETAIL.BILLING.TAXES\' | translate}}\n                                <i class="pull-right glyphicon"\n                                   ng-class="{\'glyphicon-chevron-down\': mtcdc.taxesopen,\n                                        \'glyphicon-chevron-right\': !mtcdc.taxesopen}"></i>\n                            </uib-accordion-heading>\n                            <table ng-table="mtcdc.tableParamsTaxes"\n                                   class="table table-hover table-condensed fixNgTable" show-filter="false"\n                                   style="font-size: 11px;">\n                                <colgroup>\n                                    <col>\n                                    <col>\n                                    <col width="50px" ng-if="!mtcdc.readonly">\n                                </colgroup>\n                                <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                    class="ng-binding">\n                                    <!-- {{row}} -->\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_NAME\'|translate"\n                                        sortable="\'tax\'"\n                                        ng-attr-title="{{row.name}}"\n                                        ng-if="row.modeEdit">\n                                        <select class="form-control"\n                                                name="tax_{{$index +1}}"\n                                                id="tax_{{$index +1}}" ng-model="row.value"\n                                                ng-change="mtcdc.selectTax(row)"\n                                                ng-options="tax.name for tax in mtcdc.constants.tax track by tax._id"\n                                                required>\n                                        </select>\n                                    </td>\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_NAME\'|translate"\n                                        sortable="\'tax\'"\n                                        ng-attr-title="{{row.name}}"\n                                        ng-if="!row.modeEdit">\n                                        {{row.name}}\n                                    </td>\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_RATE\'|translate"\n                                        ng-if="row.modeEdit"\n                                        sortable="\'rate\'" ng-attr-title="{{row.value.rate}}">\n                                        {{row.value.rate}}{{row.value.isPercentage ? \'%\' : \'\'}}\n                                    </td>\n                                    <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.TAX_RATE\'|translate"\n                                        ng-if="!row.modeEdit"\n                                        sortable="\'rate\'" ng-attr-title="{{row.rate}}">\n                                        {{row.rate}}{{row.isPercentage ? \'%\' : \'\'}}\n                                    </td>\n                                    <td ng-if="!mtcdc.readonly && row.modeEdit">\n                                        <i class="glyphicon glyphicon-ok iconNgTable edit"\n                                           uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                                           ng-if="row.modeEdit" aria-hidden="true"\n                                           tagaste-click="mtcdc.saveTax(row); $event.stopPropagation();">\n                                        </i>\n                                    </td>\n                                    <td ng-if="!mtcdc.readonly && !row.modeEdit">\n                                        <i class="fa fa-trash-o iconNgTable edit"\n                                           uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                           ng-if="!row.modeEdit" aria-hidden="true"\n                                           tagaste-click="mtcdc.deleteTax(row, $index); $event.stopPropagation();">\n                                        </i>\n                                    </td>\n                                    <td ng-if="!mtcdc.readonly && row.modeEdit">\n                                        <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                                           uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                                           ng-if="row.modeEdit" aria-hidden="true"\n                                           tagaste-click="mtcdc.cancelTax(row); $event.stopPropagation();">\n                                        </i>\n                                    </td>\n                                </tr>\n                            </table>\n                            <div class="row">\n                                <div ng-class="\'col-md-offset-10 col-xs-2\'">\n                                    <button type="button"\n                                            style="position: relative;  margin-top: 15px;  margin-bottom: 15px; font-size: 12px;"\n                                            ng-if="!mtcdc.readonly && !mtcdc.addingTax"\n                                            ng-click="mtcdc.addTax()"\n                                            class="btn btn-success btn-with-icon">\n                                        <i class="ion-android-checkbox-outline"></i>{{\'BUTTONS.ADD\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <uib-accordion>\n                        <uib-accordion-group heading="{{\'RESIDENTWINDOWDETAIL.BILLING.DISCOUNTS\' | translate}}"\n                                             is-open="mtcdc.discountsopen"\n                                             panel-class="panel-primary accordion-panel">\n                            <uib-accordion-heading>\n                                {{\'RESIDENTWINDOWDETAIL.BILLING.DISCOUNTS\' | translate}}\n                                <i class="pull-right glyphicon"\n                                   ng-class="{\'glyphicon-chevron-down\': mtcdc.discountsopen,\n                                        \'glyphicon-chevron-right\': !mtcdc.discountsopen}"></i>\n                            </uib-accordion-heading>\n                            <div class="row">\n                                <div class="col-md-6">\n                                    <div class="input-group">\n                                        <span\n                                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.FIXEDDISCOUNT\' | translate}}"\n                                            tooltip-placement="right"\n                                            class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="ion-social-euro"></span>\n                                        </span>\n                                        <input type="text"\n                                               ng-disabled="mtcdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.CONCEPTMODAL.FIXEDDISCOUNT\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               valid-number\n                                               ng-blur="mtcdc.calcTotalTaxes()"\n                                               ng-model="mtcdc.concept.discountF">\n                                    </div>\n                                </div>\n                                <div class="col-md-6">\n                                    <div class="input-group">\n                                        <span\n                                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.PERCENTDISCOUNT\' | translate}}"\n                                            tooltip-placement="right"\n                                            class="input-group-addon input-group-addon-primary addon-left">\n                                            <span style="font-weight: bold;">%</span>\n                                        </span>\n                                        <input type="text"\n                                               ng-disabled="mtcdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.CONCEPTMODAL.PERCENTDISCOUNT\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               valid-number\n                                               ng-blur="mtcdc.calcTotalTaxes()"\n                                               ng-model="mtcdc.concept.discountP">\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="checkbox">\n                        <label class="custom-checkbox">\n                            <input type="radio" id="lockEdit"\n                                   name="lockEdit"\n                                   ng-click="mtcdc.changeLockEdit()"\n                                   ng-disabled="mtcdc.readonly"\n                                   ng-checked="mtcdc.concept.lockEdit">\n                            <span>{{\'MASTERTABLES.CONFIG.LOCKEDIT\' | translate}}</span>\n                        </label>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-3">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.BASE\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="mtcdc.readonly"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'BILLING.CONCEPTMODAL.BASE\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               required="true"\n                               ng-blur="mtcdc.calcTotalTaxes()"\n                               ng-model="mtcdc.concept.amount">\n                    </div>\n                </div>\n                <div class="col-md-3">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.TOTAL\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="true"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'BILLING.CONCEPTMODAL.TOTAL\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               ng-model="mtcdc.totalWithoutTaxes">\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-6">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'BILLING.CONCEPTMODAL.TOTALWITHTAX\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                               style="font-weight: bold; font-size: 1.2em;"\n                               ng-disabled="true"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'BILLING.CONCEPTMODAL.TOTALWITHTAX\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               ng-model="mtcdc.totalWithTaxes">\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class="modal-footer modal-footer-without-margin">\n        <button ng-click="$dismiss(mtcdc.modeDismiss)" type="button" class="btn btn-success">\n            <i class="ion-arrow-left-c"></i> {{\'BUTTONS.BACK\' | translate}}\n        </button>\n        <button ng-if="!mtcdc.readonly" ng-click="mtcdc.save(conceptForm)" type="button" class="btn btn-success">\n            <i class="ion-android-checkmark-circle"></i> {{\'BUTTONS.SAVE\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/modal/modalRequestVisit/modalRequestVisit.html','<div class="modal-header modal-room-header">\n    <h4 class="panel-title">{{ mrvc.isNew ? (\'REQUESTS.DETAIL.VISIT_MODAL_NEW_TITLE\' | translate) : (\'REQUESTS.DETAIL.VISIT_MODAL_DETAIL_TITLE\' | translate) }}</h4>\n</div>\n<div class="modal-body">\n    <form name="visitForm" autocomplete="false">\n        <!-- DATE, GUIDE -->\n        <div class="row">\n            <div class="col-md-6 col-sm-12">\n                <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.VISIT_DATE\' | translate"\n                                    placeholder="\'REQUESTS.DETAIL.VISIT_DATE\' | translate"\n                                    tooltip-placement="bottom-left" date-value="mrvc.visit.date"\n                                    mode-read-only="mrvc.readonly"\n                                    required\n                                    form-reference="visitForm" name-field="\'visitDate\'">\n                </date-picker-comp>\n            </div>\n            <div class="col-md-6 col-sm-12">\n                <div class="input-group">\n                    <span uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_GUIDE\'| translate}}"\n                          class="input-group-addon input-group-addon-primary addon-left"\n                          id="residentDetailTooltip">\n                        <span class="ion-android-person"></span>\n                    </span>\n                    <input type="text" name="guide" ng-disabled="mrvc.readonly"\n                           class="form-control with-primary-addon "\n                           placeholder="{{\'REQUESTS.DETAIL.VISIT_GUIDE\'|translate}}"\n                           ng-class="{\'invalid\': (visitForm.guide.$touched || mrvc.submitted )&& !mrvc.readonly && !visitForm.guide.$valid }"\n                           ng-model="mrvc.visit.guide" required>\n                </div>\n            </div>\n        </div>\n\n        <!-- ROOM, ROOMTYPE -->\n        <div class="row">\n            <div class="col-md-6 col-sm-12">\n                <div class="input-group" id="visitRoom">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          tooltip-placement="bottom-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_ROOM\'| translate}}">\n                        <span class="fa fa-bed" style="margin-left:-1px"></span>\n                    </span>\n\n                    <ui-select ng-model="mrvc.visit.room"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               ng-change="mrvc.selectRoom()"\n                               class="btn-group bootstrap-select form-control" ng-disabled="mrvc.readonly"\n                               append-to-body="false" name="spot" search-enabled="true">\n                        <ui-select-match placeholder="{{\'REQUESTS.DETAIL.VISIT_ROOM\'| translate}}">\n                            <span> {{mrvc.visit.room.code}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mrvc.listSpots | uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n\n            <div class="col-md-6 col-sm-12">\n                <div class="input-group" id="visitRoomType">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          tooltip-placement="bottom-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_ROOMTYPE\'| translate}}">\n                        <span class="fa fa-bed" style="margin-left:-1px"></span>\n                    </span>\n\n                    <ui-select ng-model="mrvc.visit.roomType"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control" ng-disabled="mrvc.readonly"\n                               append-to-body="false" name="spot" search-enabled="true">\n                        <ui-select-match placeholder="{{\'REQUESTS.DETAIL.VISIT_ROOMTYPE\'| translate}}">\n                            <span> {{mrvc.visit.roomType.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mrvc.constants.roomType | uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n            </div>\n        </div>\n\n        <!-- KnowAboutUs -->\n        <div class="row">\n            <div class="col-md-12" ng-if="mrvc.constants.knowAboutUs">\n                <div class="input-group" id="visitKnowAboutUs" ng-class="{\'select-invalid\': (visitForm.knowAboutUs.$touched || mrvc.submitted )&& !mrvc.readonly && !visitForm.knowAboutUs.$valid }">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          tooltip-placement="bottom-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_KNOWABOUTUS\'| translate}}">\n                        <span class="fa fa-search" style="margin-left:-1px"></span>\n                    </span>\n\n                    <ui-select ng-model="mrvc.visit.knowAboutUs"\n                               required\n                               ng-change="mrvc.changeKnowAboutUs();"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control" ng-disabled="mrvc.readonly"\n                               append-to-body="false" name="knowAboutUs" search-enabled="true">\n                        <ui-select-match placeholder="{{\'REQUESTS.DETAIL.VISIT_KNOWABOUTUS\'| translate}}">\n                            <span> {{mrvc.visit.knowAboutUs.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mrvc.constants.knowAboutUs |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n        </div>\n\n        <!-- KnowAboutUsOthers -->\n        <div class="row" ng-if="mrvc.visit.knowAboutUs.code === \'others\'">\n            <div class="col-md-12">\n                <div class="input-group">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_KNOWABOUTUS\' | translate}}"\n                          tooltip-placement="bottom-left"\n                          style="vertical-align: top">\n                        <span class="fa fa-search"></span>\n                    </span>\n                    <textarea ng-model=" mrvc.visit.knowAboutUsOthers"\n                              ng-disabled="mrvc.readonly"\n                              required\n                              ng-class="{\'invalid\': (visitForm.knowAboutUsOthers.$touched || mrvc.submitted )&& !mrvc.readonly && !visitForm.knowAboutUsOthers.$valid }"\n                              name="knowAboutUsOthers"\n                              class="form-control with-primary-addon"\n                              aria-describedby="basic-addon1"\n                              ng-disabled="mrvc.readonly"\n                              placeholder="{{\'REQUESTS.DETAIL.VISIT_KNOWABOUTUSOTHER\'|translate}}">\n                    </textarea>\n                </div>\n            </div>\n        </div>\n\n        <!-- Comments -->\n        <div class="row">\n            <div class="col-md-12">\n                <div class="input-group">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_COMMENTS\' | translate}}"\n                          tooltip-placement="bottom-left"\n                          style="vertical-align: top">\n                        <span class="ion-android-create"></span>\n                    </span>\n                    <textarea ng-model=" mrvc.visit.comments"\n                              ng-disabled="mrvc.readonly"\n                              name="comments"\n                              class="form-control with-primary-addon"\n                              aria-describedby="basic-addon1"\n                              ng-disabled="mrvc.readonly"\n                              placeholder="{{\'REQUESTS.DETAIL.VISIT_COMMENTS\'|translate}}">\n                    </textarea>\n                </div>\n            </div>\n        </div>\n\n        <!-- Comptain -->\n        <div class="row">\n            <div class="col-md-12">\n                <div class="input-group">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_COMPLAIN\' | translate}}"\n                          tooltip-placement="bottom-left"\n                          style="vertical-align: top">\n                        <span class="fa fa-exclamation"></span>\n                    </span>\n                    <textarea ng-model=" mrvc.visit.complain"\n                              ng-disabled="mrvc.readonly"\n                              name="comments"\n                              class="form-control with-primary-addon"\n                              aria-describedby="basic-addon1"\n                              ng-disabled="mrvc.readonly"\n                              placeholder="{{\'REQUESTS.DETAIL.VISIT_COMPLAIN\'|translate}}">\n                    </textarea>\n                </div>\n            </div>\n        </div>\n\n        <!-- Check firstOption, check oldResidentRelative -->\n        <div class="row">\n            <div class="col-md-6 col-sm-12">\n                <div style="margin-bottom: 15px; padding-left: 5px;">\n                    <label class="custom-checkbox">\n                        <input id="checkFirstOption" type="checkbox" ng-model="mrvc.visit.firstOption"\n                               ng-click="mrvc.checkFirstOption(!mrvc.visit.firstOption)" ng-disabled="mrvc.readonly">\n                        <span>{{\'REQUESTS.DETAIL.VISIT_FIRSTOPTION\'|translate}}</span>\n                    </label>\n                </div>\n            </div>\n            <div class="col-md-6 col-sm-12">\n                <div style="margin-bottom: 15px; padding-left: 5px;">\n                    <label class="custom-checkbox">\n                        <input id="checkOldResidentRelative" type="checkbox" ng-model="mrvc.visit.oldResidentRelative"\n                               ng-click="mrvc.checkOldResidentRelative(!mrvc.visit.oldResidentRelative)" ng-disabled="mrvc.readonly">\n                        <span>{{\'REQUESTS.DETAIL.VISIT_OLDRESIDENTRELATIVE\'|translate}}</span>\n                    </label>\n                </div>\n            </div>\n        </div>\n\n        <!-- interviewData.comments -->\n        <div class="row">\n            <div class="col-md-12">\n                <div class="input-group">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_INTERVIEW_COMMENTS\' | translate}}"\n                          tooltip-placement="bottom-left"\n                          style="vertical-align: top">\n                        <span class="fa fa-info-circle"></span>\n                    </span>\n                    <textarea ng-model=" mrvc.visit.interviewData.comments"\n                              ng-disabled="mrvc.readonly"\n                              name="interviewComments"\n                              class="form-control with-primary-addon"\n                              aria-describedby="basic-addon1"\n                              ng-disabled="mrvc.readonly"\n                              placeholder="{{\'REQUESTS.DETAIL.VISIT_INTERVIEW_COMMENTS\'|translate}}">\n                    </textarea>\n                </div>\n            </div>\n        </div>\n\n        <!-- FamilyRent, homeDistance -->\n        <div class="row">\n            <div class="col-md-6 col-sm-12">\n                <div class="input-group">\n                    <span uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_FAMILYRENT\'| translate}}"\n                          class="input-group-addon input-group-addon-primary addon-left"\n                          id="familyRent">\n                        <span class="fa fa-money"></span>\n                    </span>\n                    <input type="text" name="familyRent" ng-disabled="mrvc.readonly"\n                           class="form-control with-primary-addon "\n                           ng-class="{\'invalid\': (visitForm.familyRent.$touched || mrvc.submitted )&& !mrvc.readonly && !visitForm.familyRent.$valid }"\n                           placeholder="{{\'REQUESTS.DETAIL.VISIT_FAMILYRENT\'|translate}}"\n                           ng-model="mrvc.visit.interviewData.familyRent">\n                </div>\n            </div>\n            <div class="col-md-6 col-sm-12">\n                <div class="input-group">\n                    <span uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_HOMEDISTANCE\'| translate}}"\n                          class="input-group-addon input-group-addon-primary addon-left"\n                          id="homeDistance">\n                        <span class="fa fa-map-signs"></span>\n                    </span>\n                    <input type="text" name="familyRent" ng-disabled="mrvc.readonly"\n                           class="form-control with-primary-addon"\n                           placeholder="{{\'REQUESTS.DETAIL.VISIT_HOMEDISTANCE\'|translate}}"\n                           ng-model="mrvc.visit.interviewData.homeDistance">\n                </div>\n\n            </div>\n        </div>\n\n        <!-- rating -->\n        <div class="row">\n            <div class="col-md-6 col-sm-12">\n                <div class="input-group" id="visitRating" ng-class="{\'select-invalid\': (visitForm.interviewRating.$touched || mrvc.submitted )&& !mrvc.readonly && !visitForm.interviewRating.$valid }">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          tooltip-placement="bottom-left"\n                          uib-tooltip="{{\'REQUESTS.DETAIL.VISIT_RATING\'| translate}}">\n                        <span class="fa fa-star" style="margin-left:-1px"></span>\n                    </span>\n\n                    <ui-select ng-model="mrvc.visit.interviewData.rating"\n                               required\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control" ng-disabled="mrvc.readonly"\n                               append-to-body="false" name="interviewRating" search-enabled="true">\n                        <ui-select-match placeholder="{{\'REQUESTS.DETAIL.VISIT_RATING\'| translate}}">\n                            <span> {{mrvc.visit.interviewData.rating.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mrvc.constants.interviewRating | uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n\n            </div>\n        </div>\n\n        <!-- Save -->\n        <div class="row">\n            <div class="pull-right">\n                <button class="btn btn-success btn-with-icon"\n                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                        tagaste-click="mrvc.cancel()">\n                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                </button>\n\n                <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                        tagaste-click="mrvc.save(visitForm)"\n                        ng-if="!mrvc.readonly"\n                        class="btn btn-success btn-with-icon">\n                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                </button>\n            </div>\n        </div>\n    </form>\n</div>\n');
$templateCache.put('app/modal/modalRoomDetail/modalRoomDetail.html','<div class="modal-header modal-room-header">\n    <h4 class="panel-title">{{\'ROOMSCHEDULERDETAIL.TITLE\'|translate}}</h4>\n    <div class="room-number">\n        <div class="room-label">\n            H.<b>{{mrdc.roomCode}}</b>\n        </div>\n    </div>\n</div>\n<div class="modal-body">\n    <div class="modal-room-detail">\n        <div class="user-photo" ng-if="mrdc.type === \'isOccupied\'">\n            <avatar type="person" shape="square" avatar-style="width: 150px; height: 150px"\n            readonly="true" img="mrdc.avatar"\n            photo="mrdc.resident.photo"></avatar>\n        </div>\n        <div class="room-fields">\n            <!-- Occupation User info-->\n            <div class="resident-fields" ng-if="mrdc.type === \'isOccupied\'">\n                <div class="row">\n                    <div class="col-md-3">\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                    uib-tooltip=""\n                                    tooltip-placement="top-left">\n                                <span class="ion-person-stalker"></span>\n                            </span>\n                            <input type="text" ng-readonly="true"\n                                    class="form-control with-primary-addon" required\n                                    aria-describedby="basic-addon1"\n                                    ng-model="mrdc.reservation.client.item.name">\n                        </div>\n                    </div>\n                    <div class="col-md-3">\n                            <input type="text" ng-readonly="true"\n                                class="form-control with-primary-addon" required\n                                placeholder=""\n                                aria-describedby="basic-addon1"\n                                ng-model="mrdc.reservation.client.item.surname">\n                    </div>\n                    <div class="col-md-3">\n                        <div class="input-group" >\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip=""\n                                  tooltip-placement="top-left">\n                                <span class="ion-card"></span>\n                            </span>\n                            <input type="text" ng-readonly="true" ng-if="mrdc.resident.identity"\n                                   class="form-control with-primary-addon" required\n                                   aria-describedby="basic-addon1"\n                                   ng-model="mrdc.resident.identity.docVal">\n                            <input type="text" ng-readonly="true" ng-if="!mrdc.resident.identity"\n                                   class="form-control with-primary-addon" required\n                                   aria-describedby="basic-addon1"\n                                   ng-model="mrdc.reservation.reservation.numDocumento">\n                        </div>\n                    </div>\n                    <div class="col-md-3 align-right">\n                        <button ng-click="mrdc.checkout()" type="button"  class="btn btn-success">{{\'BUTTONS.CHECKOUT\' | translate}}</button>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-3">\n                        <div class="input-group" >\n                            <date-picker-comp tooltip-text="\'ROOMSCHEDULERDETAIL.DATEFROM\' | translate"\n                                              tooltip-placement="top-left" date-value="mrdc.reservation.dateFrom"\n                                              placeholder="\'ROOMSCHEDULERDETAIL.DATEFROM\' | translate" is-required="false"\n                                              mode-read-only="(mrdc.readonly || mrdc.istour || mrdc.noAvailableDateFrom)" date-options="mrdc.dateOptions"\n                                              show-required-error="false" name-field="\'dateFrom\'">\n                            </date-picker-comp>\n                        </div>\n                    </div>\n                    <div class="col-md-3">\n                        <div class="input-group" >\n<!--                            <date-picker-comp tooltip-text="\'ROOMSCHEDULERDETAIL.DATETO\' | translate"-->\n<!--                                              tooltip-placement="top-left" date-value="mrdc.reservation.dateTo"-->\n<!--                                              placeholder="\'ROOMSCHEDULERDETAIL.DATETO\' | translate" is-required="false"-->\n<!--                                              mode-read-only="(mrdc.readonly || mrdc.istour)" date-options="mrdc.dateOptions"-->\n<!--                                              show-required-error="false" name-field="\'dateTo\'"-->\n<!--                                              special-validation="mrdc.checkDates()"-->\n<!--                                              msg-special-validation="\'ROOMSCHEDULERDETAIL.MSGDATETO\'">-->\n<!--                            </date-picker-comp>-->\n                            <date-picker-comp tooltip-text="\'ROOMSCHEDULERDETAIL.DATETO\' | translate"\n                                              tooltip-placement="top-left" date-value="mrdc.reservation.dateTo"\n                                              placeholder="\'ROOMSCHEDULERDETAIL.DATETO\' | translate" is-required="false"\n                                              mode-read-only="(mrdc.readonly || mrdc.istour)" date-options="mrdc.dateOptions"\n                                              show-required-error="false" name-field="\'dateTo\'">\n                            </date-picker-comp>\n                        </div>\n                    </div>\n                    <div class="col-md-3">\n                        <button type="button" class="btn btn-success btn-with-icon"\n                                ng-click="mrdc.saveDates()">{{\'BUTTONS.SAVEDATES\' | translate}}</button>\n                    </div>\n                </div>\n            </div>\n\n            <!-- Reservations info -->\n            <div class="reservation-list" ng-if="mrdc.type === \'isReserved\'">\n                <table ng-table="mrdc.tableParamsReservations" id="tableReserves"\n                    class="table table-hover table-condensed fixNgTable" show-filter="false">\n                    <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                        class="ng-binding">\n                        <td data-title="\'ROOMSCHEDULERDETAIL.USERNAME\'|translate"\n                            sortable="\'nombre\'"\n                            ng-attr-title="{{row.nombre}}">\n                            {{row.nombre}} {{row.apellidos}}\n                        </td>\n                        <td data-title="\'ROOMSCHEDULERDETAIL.DOCNUM\'|translate"\n                            sortable="\'numDocumento\'"\n                            ng-attr-title="{{row.numDocumento}}">\n                            {{row.numDocumento}}\n                        </td>\n                        <td data-title="\'ROOMSCHEDULERDETAIL.RESERVE\'|translate"\n                            sortable="\'codigoReserva\'" ng-attr-title="{{row.codigoReserva}}">\n                            {{row.codigoReserva}}\n                        </td>\n                        <td data-title="\'ROOMSCHEDULERDETAIL.ORIGIN\'|translate"\n                            sortable="\'valorAuxiliar1\'" ng-attr-title="{{row.valorAuxiliar1}}">\n                            {{row.valorAuxiliar1 ? row.valorAuxiliar1 : \'---\'}}\n                        </td>\n                        <td data-title="\'ROOMSCHEDULERDETAIL.DATEFROM\'|translate"\n                            sortable="\'dateFrom\'"\n                            ng-attr-title="{{row.dateFrom}}">\n                            {{mrdc.momentAux(row.dateFrom).format(\'L\')}}\n                        </td>\n                        <td data-title="\'ROOMSCHEDULERDETAIL.DATETO\'|translate"\n                            sortable="\'dateTo\'"\n                            ng-attr-title="{{row.dateTo}}">\n                            {{mrdc.momentAux(row.dateTo).format(\'L\')}}\n                        </td>\n                        <td data-title="" ng-attr-title="">\n                            <i class="fa ion-log-in iconNgTable edit checkin-icon"\n                                uib-tooltip="{{\'ROOMSCHEDULERDETAIL.CHECKIN\' | translate}}"\n                                aria-hidden="true"\n                                tagaste-click="mrdc.checkin(row); $event.stopPropagation();">\n                            </i>\n                            <i class="fa ion-trash-b iconNgTable edit checkin-icon margin-left"\n                               uib-tooltip="{{\'BUTTONS.DELETERESERVE\' | translate}}"\n                               aria-hidden="true"\n                               tagaste-click="mrdc.deleteReserve(row); $event.stopPropagation();">\n                            </i>\n                        </td>\n                    </tr>\n                </table>\n                    <!-- {{reserv.nombre}} {{reserv.apellidos}} - {{reserv.numDocumento }} - {{reserv.codigoReserva}} - "TODO:origen" - {{reserv.dateFrom}} - {{ reserve.dateTo }} -->\n            </div>\n\n            <!-- Blocked comments -->\n            <div class="blocked-room" ng-if="mrdc.type === \'isBlocked\'">\n                    <!-- Comment-->\n                    <div class="input-group" style="max-width: 550px;">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                uib-tooltip="{{\'ROOMSCHEDULERDETAIL.UNBLOCKCOMMENT\' | translate}}"\n                                tooltip-placement="top-left">\n                            <span class="ion-document-text"></span>\n                        </span>\n                        <input type="text" ng-readonly="false"\n                                class="form-control with-primary-addon" required\n                                aria-describedby="basic-addon1"\n                                placeholder="{{\'ROOMSCHEDULERDETAIL.UNBLOCKCOMMENT\' | translate}}"\n                                ng-model="mrdc.unlockComment">\n                    </div>\n                    <!-- Date to-->\n                    <date-picker-comp\n                        tooltip-text="\'ROOMSCHEDULERDETAIL.UNLOCKDATE\' | translate"\n                        date-value="mrdc.unlockDT"\n                        date-options="mrdc.unlockDTOptions">\n                    </date-picker-comp>\n\n                    <!-- Send button -->\n                    <button type="button" ng-click="mrdc.unblock()" class="btn btn-success unlock-button">{{\'ROOMSCHEDULERDETAIL.UNLOCK\' | translate }}</button>\n            </div>\n\n            <!-- New occupation -->\n            <div class="empty-room" ng-if="mrdc.type === \'isEmpty\' && mrdc.appUsers.length > 0">\n                <!-- Select Resident-->\n                <div class="input-group" style="max-width: 450px;"\n                ng-if="mrdc.appUsers.length > 0"\n                    ng-style="(crnc.isResident && resForm.appUser.$pristine || resForm.appUser.$touched && resForm.appUser.$invalid ||\n                    resForm.appUser.$error.required && crnc.showError) ?\n                    {\'margin-bottom\': 0}:\'\'">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                            uib-tooltip="{{\'RESERVE.RESIDENT\' | translate}}"\n                            tooltip-placement="bottom-left">\n                        <span class="ion-android-person"></span>\n                    </span>\n                    <ui-select ng-model="mrdc.appUser"\n                                style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                class="btn-group bootstrap-select form-control"\n                                name="appUser"\n                                ng-class="{invalid: ( crnc.isResident && resForm.appUser.$pristine ) || (resForm.appUser.$touched && resForm.appUser.$invalid ) || (resForm.appUser.$error.required && crnc.showError )}"\n                                search-enabled="true">\n                        <ui-select-match\n                            allow-clear=true\n                            placeholder="{{\'RESERVE.RESIDENT\'| translate}}">\n                            {{mrdc.appUser.fullName}}\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mrdc.appUsers |\n                        uiSelectFilter: {fullName:$select.search}">\n                             <div ng-bind-html="option.fullName | highlight: $select.search"></div>\n                        </ui-select-choices>\n                    </ui-select>\n\n                </div>\n                <!-- Date From checkin-->\n                <date-picker-comp\n                    tooltip-text="\'ROOMSCHEDULERDETAIL.NEWCHECKINDATEFROM\' | translate"\n                    date-value="mrdc.newcheckinDF"\n                    date-options="mrdc.newcheckinDFOptions">\n                </date-picker-comp>\n\n                <!-- Date to checkout-->\n                <date-picker-comp\n                    tooltip-text="\'ROOMSCHEDULERDETAIL.NEWCHECKINDATETO\' | translate"\n                    date-value="mrdc.newcheckinDT"\n                    date-options="mrdc.newcheckinDTOptions">\n                </date-picker-comp>\n                <!-- Send button -->\n                <button type="button" ng-hide="mrdc.type === \'isBlocked\'" ng-click="mrdc.newcheckin()" class="btn btn-success unlock-button">{{\'ROOMSCHEDULERDETAIL.NEWCHECKIN\' | translate }}</button>\n            </div>\n\n            <!-- Button to Show lock comments-->\n            <div ng-if="mrdc.type !== \'isBlocked\' && !mrdc.showLock && mrdc.type !== \'isOccupied\'" style="text-align: right; margin-bottom: 15px;">\n                <button type="button" ng-click="mrdc.showLock = true" class="btn btn-success unlock-button">{{\'ROOMSCHEDULERDETAIL.BLOCK\' | translate }}</button>\n            </div>\n            <!-- Lock comments -->\n            <div class="block-room" ng-if="mrdc.showLock">\n                <!-- Comment-->\n                <div class="input-group" style="max-width: 550px;">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                            uib-tooltip="{{\'ROOMSCHEDULERDETAIL.BLOCKREASON\' | translate}}"\n                            tooltip-placement="top-left">\n                        <span class="ion-document-text"></span>\n                    </span>\n                    <input type="text" ng-readonly="false"\n                            class="form-control with-primary-addon" required\n                            aria-describedby="basic-addon1"\n                            ng-disabled="mrdc.type === \'isBlocked\'"\n                            placeholder="{{\'ROOMSCHEDULERDETAIL.BLOCKREASON\' | translate }}"\n                            ng-model="mrdc.lockComment">\n                </div>\n\n                <!-- Date From block-->\n                <date-picker-comp\n                    tooltip-text="\'ROOMSCHEDULERDETAIL.DATEFROMBLOCK\' | translate"\n                    date-value="mrdc.lockDF"\n                    mode-read-only="mrdc.type === \'isBlocked\'"\n                    date-options="mrdc.lockDFOptions">\n                </date-picker-comp>\n\n                <!-- Date to block-->\n                <date-picker-comp\n                    tooltip-text="\'ROOMSCHEDULERDETAIL.DATETOBLOCK\' | translate"\n                    date-value="mrdc.lockDT"\n                    mode-read-only="mrdc.type ===  \'isBlocked\'"\n                    date-options="mrdc.lockDTOptions">\n                </date-picker-comp>\n                <!-- Send button -->\n                <button type="button" ng-hide="mrdc.type === \'isBlocked\'" ng-click="mrdc.block()" class="btn btn-success unlock-button">{{\'ROOMSCHEDULERDETAIL.BLOCK\' | translate }}</button>\n             </div>\n            <!-- Incidents and workertasks-->\n            <div class="row">\n                <div class="col-md-6 col-sm-12">\n                    <uib-accordion>\n                        <uib-accordion-group panel-class="panel-primary accordion-panel"\n                            is-open="mrdc.accordions.workertask">\n                            <uib-accordion-heading>\n                                {{\'ROOMSCHEDULERDETAIL.WORKERTASKTITLE\' | translate}}\n                                <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': mrdc.accordions.workertask,\n                                        \'glyphicon-chevron-right\': !mrdc.accordions.workertask}"></i>\n                            </uib-accordion-heading>\n                            <div ng-if="mrdc.workerTask.length === 0">\n                                {{\'ROOMSCHEDULERDETAIL.NOWORKERTASK\' | translate}}\n                            </div>\n                            <div ng-if="mrdc.workerTask.length > 0" class="room-worker-tasks">\n                                <div ng-repeat="row in mrdc.workerTask">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                                uib-tooltip=""\n                                                tooltip-placement="top-left">\n                                            <span class="ion-alert-circled"></span>\n                                        </span>\n                                        <input type="text" ng-readonly="true"\n                                                class="form-control with-primary-addon" required\n                                                aria-describedby="basic-addon1"\n                                                ng-model="row.text">\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div style="text-align: right;" ng-if="!mrdc.setToClean" >\n                                <button type="button" ng-click="mrdc.setToClean = !mrdc.setToClean" class="btn btn-success">{{\'ROOMSCHEDULERDETAIL.SETTOCLEAN\' | translate}}</button>\n                            </div>\n                            <div ng-if="mrdc.setToClean && mrdc.cleaningTasks.length > 0">\n                                <div class="accordionSubTitle">\n                                    <div class="accordionSubTitleText" style="font-weight: 500; padding: 4px;">{{\'ROOMSCHEDULERDETAIL.CLEANTYPE\'| translate}}</div>\n                                    <div class="accordionSubTitleBorder"></div>\n                                </div>\n                                <ui-select ng-model="mrdc.selectedCleanTask"\n                                    style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                    class="btn-group bootstrap-select form-control"\n                                    name="selectedCleanTask">\n                                    <ui-select-match allow-clear="true">\n                                        <span> {{mrdc.selectedCleanTask.description}}</span>\n                                    </ui-select-match>\n                                    <!-- <ui-select-choices repeat="option in mrdc.cleaningTasks | uiSelectFilter: {description:$select.search}"> -->\n                                    <ui-select-choices repeat="option in mrdc.cleaningTasks">\n                                        <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n\n                                <div class="clean-buttons">\n                                    <button type="button" ng-click="mrdc.cancelClean()" class="btn btn-success">{{\'BUTTONS.CANCEL\' | translate}}</button>\n                                    <button type="button" ng-click="mrdc.saveSetClean()" class="btn btn-success">{{\'BUTTONS.SAVE\' | translate}}</button>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n                <div class="col-md-6 col-sm-12">\n                    <uib-accordion>\n                        <uib-accordion-group panel-class="panel-primary accordion-panel"\n                            is-open="mrdc.accordions.incidents">\n                            <uib-accordion-heading>\n                                {{\'ROOMSCHEDULERDETAIL.INCIDENTSTITLE\' | translate}}\n                                <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': mrdc.accordions.incidents,\n                                        \'glyphicon-chevron-right\': !mrdc.accordions.incidents}"></i>\n                            </uib-accordion-heading>\n\n                            <div ng-if="mrdc.incidents.length === 0">\n                                {{\'ROOMSCHEDULERDETAIL.NOINCIDENTS\' | translate }}\n                            </div>\n                            <div ng-if="mrdc.incidents.length > 0" class="room-incidents">\n                                <div ng-repeat="row in mrdc.incidents" class="incident-description">\n                                    {{row.date | date}} - {{row.text}}\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="modal-footer">\n    <button ng-click="$dismiss(mrdc.modeDismiss)" type="button"  class="btn btn-success">{{\'BUTTONS.BACK\' | translate}}</button>\n</div>\n');
$templateCache.put('app/modal/modalTaskDetail/modalTaskDetail.html','<div class="modal_concept">\n    <div class="modal-header modal-room-header">\n        <h4 class="panel-title">{{\'MASTERTABLES.CONFIG.TASKDETAIL\' | translate}}</h4>\n    </div>\n    <div class="modal-body">\n        <form name="taskForm" autocomplete="false">\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'MASTERTABLES.CONFIG.DESCRIPTION\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-compose"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="mmtdc.readonly"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               ng-model="mmtdc.task.description">\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="input-group">\n                        <span style="width: 35px"\n                            uib-tooltip="{{\'MASTERTABLES.CONFIG.CODE\' | translate}}"\n                            tooltip-placement="right"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-key"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="mmtdc.readonly"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'MASTERTABLES.CONFIG.CODE\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               ng-model="mmtdc.task.code">\n                    </div>\n                </div>\n            </div>\n\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="input-group">\n                        <span style="width: 35px"\n                              uib-tooltip="{{\'MASTERTABLES.CONFIG.PARENT_TASK\' | translate}}"\n                              tooltip-placement="right"\n                              class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="fa fa-list"></span>\n                        </span>\n                        <ui-select ng-model="mmtdc.task.taskParent" id="taskParent"\n                                   name="taskParent"\n                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                   class="btn-group bootstrap-select form-control"\n                                   append-to-body="false">\n                            <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.PARENT_TASK\'|translate}}">\n                                <span> {{mmtdc.task.taskParent.description}}</span>\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mmtdc.constants.taskParent | uiSelectFilter: {description:$select.search}">\n                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </div>\n\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="input-group">\n                        <span style="width: 35px"\n                              uib-tooltip="{{\'MASTERTABLES.CONFIG.BRANCH\' | translate}}"\n                              tooltip-placement="right"\n                              class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-card"></span>\n                        </span>\n                        <ui-select ng-model="mmtdc.task.branch" id="branch"\n                                   name="branch"\n                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                   class="btn-group bootstrap-select form-control"\n                                   append-to-body="false">\n                            <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.BRANCH\'| translate}}">\n                                <span> {{mmtdc.task.branch.description}}</span>\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mmtdc.constants.branches |\n                                                uiSelectFilter: {description:$select.search}">\n                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </div>\n        </form>\n\n        <div class="row">\n            <div ng-class="\'col-md-offset-10 col-xs-2\'">\n\n                <button type="button"\n                        ng-if="!mmtdc.readonly"\n                        ng-disabled="mmtdc.addingAction || mmtdc.editingActions"\n                        tagaste-click="mmtdc.addAction({});$event.stopPropagation();"\n                        class="btn btn-success btn-with-icon pull-right newButton" id="newActionButton">\n                    <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                </button>\n            </div>\n        </div>\n\n        <table ng-table="mmtdc.tableParamsActions"\n               class="table table-hover table-condensed fixNgTable" show-filter="false">\n            <colgroup>\n                <col>\n                <col>\n                <col ng-if="!mmtdc.readonly" width="20px">\n                <col ng-if="!mmtdc.readonly" width="20px">\n            </colgroup>\n            <tr ng-repeat="row in $data track by $index" style="cursor: pointer" ng-class="ng-binding">\n                <td data-title="\'MASTERTABLES.CONFIG.TASKACTIONNAME\'|translate"\n                    sortable="\'name\'"\n                    ng-if="!row.modeEdit"\n                    ng-attr-title="{{row.name}}">\n                    {{row.name}}\n                </td>\n                <td data-title="\'MASTERTABLES.CONFIG.TASKACTIONNAME\'|translate"\n                    sortable="\'name\'" ng-attr-title="{{row.name}}"\n                    ng-if="row.modeEdit">\n                    <input type="text" ng-model="row.name" name="name"\n                           class="form-control with-primary-addon"\n                           id="name" required>\n                </td>\n\n                <td data-title="\'MASTERTABLES.CONFIG.TASKACTIONESTTIME\'|translate"\n                    sortable="\'estTime\'"\n                    ng-if="!row.modeEdit"\n                    ng-attr-title="{{row.estTime}} {{\'MASTERTABLES.CONFIG.MINUTES\' | translate}}">\n                    {{row.estTime}}\n                </td>\n\n                <td data-title="\'MASTERTABLES.CONFIG.TASKACTIONESTTIME\'|translate"\n                    sortable="\'estTime\'" ng-attr-title="{{row.estTime}}"\n                    ng-if="row.modeEdit">\n                    <input type="number" ng-model="row.estTime" name="estTime"\n                           class="form-control with-primary-addon"\n                           id="estTime" required>\n                </td>\n\n                <td ng-if="!mmtdc.readonly && !row.modeEdit">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mmtdc.addingAction && !row.error && !mmtdc.editingActions" aria-hidden="true"\n                       tagaste-click="mmtdc.editAction(row); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mmtdc.readonly && !row.modeEdit">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mmtdc.addingAction && !row.error && !mmtdc.editingActions" aria-hidden="true"\n                       tagaste-click="mmtdc.deleteAction(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mmtdc.readonly && row.modeEdit">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mmtdc.saveAction(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mmtdc.readonly && row.modeEdit">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mmtdc.cancelAction(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n\n        <div class="modal-footer">\n            <button ng-click="$dismiss(mmtdc.modeDismiss)" type="button" class="btn btn-success">\n                <i class="ion-arrow-left-c"></i> {{\'BUTTONS.BACK\' | translate}}\n            </button>\n            <button ng-if="!mmtdc.readonly" ng-click="mmtdc.saveConfig(taskForm)" type="button" class="btn btn-success">\n                <i class="ion-android-checkmark-circle"></i> {{\'BUTTONS.SAVE\' | translate}}\n            </button>\n        </div>\n    </div>\n\n</div>\n');
$templateCache.put('app/modal/renewPass/modal.html','<div ba-panel ba-panel-title-no-translate="<b>{{mdPwd.windowTit}}</b>"\n     ba-panel-class="with-scroll" ba-panel-anim="anim-false"\n     style="line-height:30px;" id="RenewPasswordModal">\n    <form name="rePwdForm" autocomplete="false">\n        <div class="row">\n            <div class="col-xs-12">\n                <div class="input-group"\n                     style="width:86%;margin-left:17px;margin-right:17px">\n                    <span\n                        uib-tooltip="{{\'MODAL.RENEWPASSWORD.LASTPASS\' | translate}}"\n                        tooltip-placement="bottom-left"\n                        class="input-group-addon input-group-addon-primary addon-left">\n                        <span class="ion-ios-locked"></span></span>\n                    <input name="lpw"\n                           required\n                           type="password" class="form-control with-primary-addon"\n                           autocomplete="new-password"\n                           placeholder="{{\'MODAL.RENEWPASSWORD.LASTPASS\'|translate}}"\n                           aria-describedby="basic-addon1"\n                           ng-model="mdPwd.lastPass">\n                </div>\n                <div class="errorValidation bounceIn animate"\n                     style="margin-left:17px;"\n                     ng-if="mdPwd.submitted && (rePwdForm.lpw.$pristine || mdPwd.lastPass === \'\')">\n                    {{\'ERROR.NOTVALIDINPUT\'|translate}}\n                </div>\n            </div>\n            <div class="col-xs-12">\n                <div class="input-group"\n                     style="width:86%;margin-left:17px;margin-right:17px">\n                    <span\n                        tooltip-append-to-body\n                        tooltip-placement="top-left"\n                        uib-tooltip="{{\'MODAL.RENEWPASSWORD.PASSWORD\' | translate}}"\n                        class="input-group-addon input-group-addon-primary addon-left">\n                                    <span class="ion-ios-locked"></span></span>\n                    <input name="pw"\n                           required\n                           type="password" class="form-control with-primary-addon"\n                           autocomplete="new-password"\n                           placeholder="{{\'MODAL.RENEWPASSWORD.PASSWORD\'|translate}}"\n                           aria-describedby="basic-addon1"\n                           ng-model="mdPwd.pass">\n                </div>\n            </div>\n            <div class="col-xs-12">\n                <div class="input-group slideInUp animated"\n                     style="width:86%;margin-left:17px;margin-right:17px"\n                     ng-if="(!mdPwd.readonly && mdPwd.pass && mdPwd.pass  !== \'\')">\n                    <span\n                        uib-tooltip="{{\'MODAL.RENEWPASSWORD.REPASSWORD\' | translate}}"\n                        tooltip-placement="top-left"\n                        class="input-group-addon input-group-addon-primary addon-left">\n                        <span class="ion-loop"></span></span>\n                        <input type="password"\n                               requited\n                               name="repw"\n                               autocomplete="new-password"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'MODAL.RENEWPASSWORD.REPASSWORD\'|translate}}"\n                               ng-model="mdPwd.confirPass">\n                </div>\n                <div class="errorValidation bounceIn animate"\n                     style="margin-left:17px;"\n                     ng-if="!mdPwd.validPassWord(rePwdForm.repw,rePwdForm.pw)">\n                    {{\'ERROR.PASSWORDNOTMATCH\'|translate}}\n                </div>\n                <div class="errorValidation bounceIn animate"\n                     style="margin-left:17px;"\n                     ng-if="mdPwd.submitted && rePwdForm.pw.$pristine">\n                    {{\'ERROR.NOTVALIDINPUT\'|translate}}\n                </div>\n            </div>\n        </div>\n        <div class="row text-center">\n            <div class="col-xs-12">\n                <button\n                    style="width:86%;margin-left:17px;margin-right:17px"\n                    type="button"\n                    onkeydown="if (event.keyCode == 13) mdPwd.save(rePwdForm)"\n                    ng-click="mdPwd.save(rePwdForm)"\n                    ng-disabled="( mdPwd.submitted &&  !rePwdForm.$valid)"\n                    class="btn btn-success btn-with-icon">\n                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.RESETPASSWORD\' |translate}}\n                </button>\n            </div>\n            <div class="col-xs-12">\n                <button\n                    style="width:86%;margin-left:17px;margin-right:17px;margin-top:13px;"\n                    type="button"\n                    onkeydown="if (event.keyCode == 13) mdPwd.back()"\n                    ng-click="mdPwd.back()"\n                    class="btn btn-success btn-with-icon">\n                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                </button>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-xs-12" style="margin-top:13px;">\n                <p ng-if="mdPwd.submitted && !rePwdForm.$valid"\n                   style="margin-right:17px;"\n                   class="pull-right errorValidation bounceIn animate">{{\'ERROR.ERRORININPUT\' |translate}}</p>\n            </div>\n        </div>\n    </form>\n</div>\n');
$templateCache.put('app/login/register/register.html','<h1>register</h1>');
$templateCache.put('app/components/cardFile/cardFile.html','<style>\n    .cardFile.nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'CARDFILE.HIERARCHY\'|translate}}";\n        vertical-align: -webkit-baseline-middle;\n        bottom: 3px;\n    }\n\n    .cardFile.nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'CARDFILE.PRIVATE\'|translate}}";\n        vertical-align: -webkit-baseline-middle;\n        bottom: 3px;\n    }\n\n    .cardFile.nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'CARDFILE.PUBLIC\'|translate}}";\n        vertical-align: -webkit-baseline-middle;\n        bottom: 3px;\n    }\n\n    .cardFile.nz-toggle-wrap.horizontal.null .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .cardFile.nz-toggle-wrap.horizontal.true .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .cardFile.nz-toggle-wrap.horizontal.false .nz-toggle-handle:before {\n        content: "";\n    }\n\n    @media screen and (max-width: 900px) {\n        .filerow {\n            flex-direction: column;\n        }\n    }\n</style>\n<script type="text/ng-template" id="modalEditCardFile.html">\n    <div class="modal-header">\n        <h3 class="modal-title">{{\'CARDFILE.TITLE\'|translate}}</h3>\n    </div>\n    <div class="modal-body" style="max-height: 400px; min-height: 200px;">\n        <form name="cardfileForm">\n            <div class="row">\n                <div class="col-xs-4" style="color: #FFF !important; margin-top: 10px !important;">\n                    {{\'CARDFILE.VISIBILITY\'|translate}}\n                </div>\n                <div class="col-xs-8">\n                    <nz-toggle tri-toggle class="cardFile" val-default="\'public\'" ng-model="$ctrl.cardFileType" ng-if="$ctrl.cardFileType" on-toggle="$ctrl.changeType($ctrl.cardFileType)" val-true="\'private\'" val-false="\'public\'" val-null="\'hierarchy\'" width="150" style="width: 25px; height: 15px;"\n                        color-false="\'#60BD68\'">\n                    </nz-toggle>\n                </div>\n            </div>\n            <div ng-if="$ctrl.cardFileType===\'public\'">\n                <div class="row">\n                    <div class="col-xs-12" style="margin-top: 10px !important; margin-bottom: 10px !important;">{{\'CARDFILE.PUBLICTEXT\'|translate}}</div>\n                </div>\n            </div>\n            <div ng-if="$ctrl.cardFileType===\'private\'">\n                <div class="row">\n                    <div class="col-xs-12" style="margin-top: 10px !important; margin-bottom: 10px !important;">{{\'CARDFILE.PRIVATETEXT\'|translate}}</div>\n                </div>\n                <div class="row">\n                    <div class="col-xs-12">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'CARDFILE.RECEIVERS\'| translate}}" class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-android-person" style="color:#8AF37E !important;"></span>\n                            </span>\n                            <ui-select multiple style="color: #FFF !important;" ng-model="$ctrl.receivers" name="recipient" append-to-body="false" ng-change="$ctrl.parseUserListBy();" ng-class="{invalid: cardfileForm.receivers.$touched && cardfileForm.receivers.$invalid}" sortable="true"\n                                close-on-select="false">\n                                <ui-select-match style="color: #FFF !important;" allow-clear=true placeholder="{{\'CARDFILE.RECEIVERS\'|translate}}">\n                                    {{$item.nameRoom}}\n                                </ui-select-match>\n                                <ui-select-choices style="color: #FFF !important;" repeat="option in $ctrl.users |\n                                    findUserGroupe:{find:$select.search,alredy:$ctrl.receivers,\n                                    alredyFloor:$ctrl.alredyFloor}">\n                                    <div ng-style="(option.allFloor) ? {\'margin-left\': \'0\',\'font-weight\' : \'900\'} : {\'margin-left\': \'17px\'}"\n                                         style="color: #FFF !important;" ng-bind-html="option.nameRoom | highlight: $select.search">\n                                    </div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div class="modal-footer">\n        <div class="row">\n            <div class="pull-right">\n                <div ng-class="\'col-xs-6\'">\n                    <button class="btn btn-success btn-with-icon" style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button" tagaste-click="$ctrl.cancel()">\n                        <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                    </button>\n                </div>\n                <div ng-class="\'col-xs-6\'">\n                    <button class="btn btn-success btn-with-icon" style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button" tagaste-click="$ctrl.save(cardfileForm)">\n                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div ng-include="\'/assets/templates/lightbox.html\'"></div>\n<!-- Img Card -->\n<div class="row filerow" style="min-height:100px; display: flex; align-items: center; margin: 0 10px;">\n    <div style="padding: 0 10px; width: 100px; text-align: center;">\n        <img style="padding:0px; max-height: 90px; max-width:90px; cursor:pointer;" ng-src="{{cflc.attached.thumb.signedUrl}}" ng-click="cflc.openLightboxModal(cflc.attached)">\n    </div>\n    <div style="flex-grow: 1">\n        <!-- {{cflc.attached.filename | cut:true:cflc.maxLongName:\' ...\'}} -->\n        {{cflc.attached.filename}}\n    </div>\n    <div style="padding: 0 10px;">\n        {{cflc.attached.visibilityType}}\n    </div>\n    <div style="padding: 0 10px;" ng-if="!cflc.readonly">\n        <i class="fa fa-pencil iconNgTable edit" style="margin: 5px;" uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}" tooltip-placement="left" tooltip-append-to-body="true" aria-hidden="true" tagaste-click="cflc.edit(cflc.attached, cflc.onlyUsers);">\n        </i>\n        <i class="fa fa-trash-o iconNgTable edit" style="margin: 5px;" uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}" tooltip-placement="left" tooltip-append-to-body="true" aria-hidden="true" tagaste-click="cflc.delete(cflc.attached);">\n        </i>\n    </div>\n\n</div>\n<!-- End image Card -->');
$templateCache.put('app/components/datePicker/datePicker.html','<div class="input-group datePickerForm"\n     ng-style="{\'margin-bottom\': (\n        (dpc.formReference[dpc.nameField].$touched && dpc.formReference[dpc.nameField].$error.required ||\n            dpc.formReference[dpc.nameField].$error.required && dpc.showRequiredError) ||\n        (dpc.formReference[dpc.nameField].$invalid && !dpc.formReference[dpc.nameField].$error.required) ||\n        (dpc.specialValidation())\n     )?\'0\':\'15px\'}">\n   <span class="input-group-addon input-group-addon-primary addon-left"\n         uib-tooltip="{{dpc.tooltipText}}"\n         tooltip-placement="{{dpc.tooltipPlacement}}">\n     <i ng-class="(dpc.iconCalendar) ? \'{{dpc.iconCalendar}}\':\'ion-calendar\'"\n        ng-style="(dpc.iconSize) ? {\'font-size\' : dpc.iconSize}:\'\'"></i>\n    </span>\n    <input type="text" class="form-control"\n           uib-datepicker-popup="{{dpc.format}}"\n           style="border-top-right-radius: 5px !important; border-bottom-right-radius: 5px !important;"\n           ng-readonly="dpc.modeReadOnly"\n           name="{{dpc.nameField}}"\n           ng-required="dpc.isRequired"\n           title=" " id="datePicker"\n           placeholder="{{dpc.placeholder}}"\n           datepicker-options="dpc.dateOptions"\n           ng-model="dpc.dateValue"\n           is-open="dpc.popup.opened"\n           close-text="{{\'DATEPICKER.BUTTON.CLOSE\'| translate}}"\n           clear-text="{{\'DATEPICKER.BUTTON.CLEAR\'| translate}}"\n           current-text="{{\'DATEPICKER.BUTTON.TODAY\'| translate}}"\n           ng-blur="dpc.specialValidation()"\n           ng-change="dpc.dateChanges()"\n           moo-focus-expression="dpc.popup.opened"\n           ng-click="dpc.openDatepicker()"\n           ng-class="{invalid: dpc.formReference[dpc.nameField].$touched && dpc.formReference[dpc.nameField].$invalid ||\n                                     dpc.formReference[dpc.nameField].$error.required && dpc.showRequiredError}"\n           datepicker-append-to-body="dpc.appendToBodyPicker">\n</div>\n<span ng-if="dpc.formReference[dpc.nameField].$touched && dpc.formReference[dpc.nameField].$error.required ||\n                       dpc.formReference[dpc.nameField].$error.required && dpc.showRequiredError" class="msgError">\n    {{dpc.msgObligatoryField ? dpc.msgObligatoryField : \'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n<span ng-if="dpc.formReference[dpc.nameField].$invalid\n                    && !dpc.formReference[dpc.nameField].$error.required" class="msgError">\n    {{dpc.msgInvalidDate ? dpc.msgInvalidDate : \'ERROR.INVALIDDATE\' | translate}}</span>\n<span ng-if="dpc.specialValidation()" class="msgError">\n    {{dpc.msgSpecialValidation ? dpc.msgSpecialValidation : \'ERROR.CHECKDATES\' | translate}}</span>\n\n\n');
$templateCache.put('app/components/logbook/logbook.html','<div class="row">\n    <div class="col-xs-12 ">\n        <div ba-panel ba-panel-title="{{\'LOGBOOK.LOGBOOK\'|translate}}"\n             id="logbook">\n            <form name="resForm" autocomplete="false">\n            <div class="row">\n                <div class="col-xs-6 col-sm-6 col-md-6">\n                    <date-picker-comp\n                        placeholder="\'LOGBOOK.DATE\' | translate"\n                        tooltip-text="\'LOGBOOK.DATE\' | translate"\n                        date-value="lbc.date"\n                        form-reference="logbookForm"\n                        name-field="\'date\'"\n                        is-required="true"\n                        date-options="lbc.dateOptions">\n                    </date-picker-comp>\n                </div>\n                <div class="col-xs-6 col-sm-6 col-md-6"\n                        ng-if="lbc.constants.residences.length > 1">\n                    <div class="input-group" id="logbookPlaces">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                uib-tooltip="{{\'LOGBOOK.SELECTRESIDENCE\' | translate}}"\n                                tooltip-placement="right">\n                                <span class="ion-card"></span>\n                            </span>\n                        <ui-select ng-model="lbc.selectedBranch"\n                                style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                class="btn-group bootstrap-select form-control"\n                                ng-change="lbc.changeBranches()"\n                                append-to-body="true"\n                                search-enabled="true">\n                            <ui-select-match placeholder="{{\'LOGBOOK.SELECTRESIDENCE\'| translate}}">\n                                {{lbc.selectedBranch.description}}\n                            </ui-select-match>\n                            <ui-select-choices\n                                repeat="branches in lbc.constants.residences|\n                            findResidence:{find:$select.search,alredy:lbc.selectedBranch}">\n                                <span ng-bind-html="branches.description | highlight: $select.search"></span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </div>\n            <div class="row" ng-if="lbc.logbookUpdate">\n                    <div class="col-xs-12">\n                        <div class=" input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                            uib-tooltip="{{\'LOGBOOK.NEWCOMMENT\' | translate}}"\n                            tooltip-placement="right-top"\n                            style="vertical-align: top;">\n                        <span class="ion-android-create"></span></span>\n                        <textarea ng-model="lbc.text" name="comment"\n                            class="form-control with-primary-addon"\n                            ng-class="{\'invalid\': (\n                                        lbc.submitted ) && !resForm.comment.$valid }"\n                            required="true"\n                            aria-describedby="basic-addon1"\n                            placeholder="{{\'LOGBOOK.NEWCOMMENT\'|translate}}">\n                        </textarea>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                            ng-if="(  lbc.submitted ) &&\n                            !resForm.comment.$valid">{{\'ERROR.NOTVALIDINPUT\' |translate}}\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row" ng-if="lbc.logbookUpdate">\n                <div class="pull-right">\n                    <button style="margin-right:10px; margin-bottom:5px;" type="button"\n                            tagaste-click="lbc.save(resForm)"\n                            class="btn btn-success btn-with-icon">\n                        <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                    </button>\n                </div>\n            </div>\n            </form>\n            <div class="row">\n                <div class="col-md-12">\n                    <div>\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                uib-tooltip="{{\'LOGBOOK.TRACKING\' | translate}}"\n                                tooltip-placement="right-top"\n                                style="vertical-align: top;">\n                                <span class="ion-android-list"></span>\n                            </span>\n                            <div style="border: 1px solid rgb(55, 55, 55);">\n                                <div style="max-height: calc(100vh - 410px); min-height: 135px; overflow-y: auto;"\n                                        ng-style="lbc.logbook.length > 1 ?\n                                            {\'overflow\' : \'auto\'}:\'\'">\n                                    <div ng-repeat="item in lbc.logbook track by $index">\n                                        <div ng-repeat="shift in item.shiftEnd track by $index">\n                                            <div class="tag-cards" ng-click="lbc.editLog(shift, item._id)">\n                                                <div\n                                                    style="padding-left: 10px; line-height: 18px; ">\n                                                    {{shift.comment}}\n                                                    <i class="ion-ios-more"\n                                                        style="font-size: 15px; margin: 0 6px;"\n                                                        uib-tooltip-html="shift.dateFormated +\n                                                            \'<br>\'+shift.user.item.fullName"\n                                                    ></i>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/roomSchedule/roomSchedule.html','<!-- https://www.angular-gantt.com/configuration/attributes -->\n\n<div class="rooms-scheduler" ng-if="rsc.selectedBranchID">\n    <div class="week-selectors">\n        <div class="week-selectors-arrows">\n            <div class="wsa-content">\n                <div class="prev-week" ng-click="rsc.prevWeek()"> <span class="ion-ios-arrow-back"></span> </div>\n                <div class="week-desc"> {{rsc.datesRange}} </div>\n                <div class="next-week" ng-click="rsc.nextWeek()"> <span class="ion-ios-arrow-forward"></span> </div>\n            </div>\n        </div>\n        <div class="week-selector-datepicker" >\n            <date-picker-comp\n                placeholder="\'ROOMSCHEDULERDETAIL.DATESEARCH\' | translate"\n                tooltip-text="\'ROOMSCHEDULERDETAIL.DATE\' | translate"\n                date-value="rsc.dpvalue"\n                date-changes="rsc.dpchangeweek()"\n                date-options="rsc.dpoptions">\n            </date-picker-comp>\n        </div>\n    </div>\n\n    <div style="max-height: calc(100vh - 530px); min-height: 200px; ">\n        <div gantt data="rsc.data" view-scale="\'day\'" from-date="rsc.dateFrom" to-date="rsc.dateTo" allow-side-resizing="false"\n            daily="true" headers="[\'diasemana\']" headers-formats="{diasemana: \'dddd\'}" current-date="rsc.options.currentDate"\n            current-date-value="rsc.options.currentDateValue" api="rsc.apigantt">\n            <gantt-table headers="{\'model.name\': rsc.roomTitle }"></gantt-table>\n        </div>\n        <div style="color: transparent;">.</div>\n    </div>\n    <div class="rooms-scheduler-legend" ng-if="rsc.statusColors">\n        <div class="rscl-item">\n            <div class="rscl-icon"><div style="width: 15px; height: 15px; background-color: {{rsc.statusColors.isOccupied}}; border-radius:100%;"></div></div>\n            <div class="rscl-name">{{\'ROOMSCHEDULER.BUSY\' | translate}}</div>\n        </div>\n        <div class="rscl-item">\n            <div class="rscl-icon"><img src="assets/tagaste/out.svg"></div>\n            <div class="rscl-name">{{\'ROOMSCHEDULER.EXITTODAY\' | translate}}</div>\n        </div>\n        <div class="rscl-item">\n            <div class="rscl-icon"><img src="assets/tagaste/clean.svg"></div>\n            <div class="rscl-name">{{\'ROOMSCHEDULER.CLEAN\' | translate}}</div>\n        </div>\n        <div class="rscl-item">\n            <div class="rscl-icon"><div style="width: 15px; height: 15px; background-color: {{rsc.statusColors.isBlocked}}; border-radius:100%;" ></div></div>\n            <div class="rscl-name">{{\'ROOMSCHEDULER.LOCKED\' | translate}}</div>\n        </div>\n        <div class="rscl-item">\n            <div class="rscl-icon"><div style="width: 15px; height: 15px; background-color: {{rsc.statusColors.isReserved}}; border-radius:100%;"></div></div>\n            <div class="rscl-name">{{\'ROOMSCHEDULER.RESERVED\' | translate}}</div>\n        </div>\n    </div>\n    <div style="display: flex; justify-content: flex-end;">\n        <button\n            class="btn btn-success btn-with-icon pull-left"\n            type="button"\n            style="margin-right:17px;margin-top:7px;margin-bottom:7px;height: 33px;width: 117px;"\n            ng-click="rsc.getPeopleIn()" >\n            <div class="progress" ng-if="rsc.downloadingAppUser" style="height:3px;margin-top:6px">\n                <div class="progress-bar progress-bar-success progress-bar-striped active"\n                     style="background-color:#51A351;"\n                     role="progressbar" aria-valuenow="{{rsc.timeBarAppUser}}"\n                     aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': rsc.timeBarAppUser  + \'%\'}">\n                </div>\n            </div>\n            <div>\n                <p><i class="fa fa-print"> </i>{{\'CANTEENAPPUSERDETAIL.PRINTRESIDENTS\' |translate}} </p>\n            </div>\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/components/schedule/schedule.html','<div class="row schedulerTitleButtons text-center">\n    <div class="col-xs-12 text-center">\n        <div class="fc-button-group">\n            <button type="button" class="fc-prev-button fc-button fc-state-default fc-corner-left"\n                    ng-click="$ctrl.subDay()"><span\n                    class="fc-icon fc-icon-left-single-arrow"></span></button>\n            <h4 class="fc-date">{{$ctrl.scheduleDay}}</h4>\n            <button type="button" class="fc-next-button fc-button fc-state-default fc-corner-right"\n                    ng-click="$ctrl.addDay()"><span\n                    class="fc-icon fc-icon-right-single-arrow"></span></button>\n        </div>\n\n    </div>\n    \n</div>\n<div class="row horizontal-scroll">\n    <div class="col-xs-12">\n        <weekly-scheduler class="scheduler"\n                          items="$ctrl.model.items"\n                          on-change="$ctrl.doSomething"\n                          on-delete="$ctrl.doSomething"\n                          ng-init="$ctrl.loaded()"\n                          ng-class="{\'calendarScroll\':$ctrl.model.scroll}"\n                          options="$ctrl.model.options"\n                          schedule-day="$ctrl.model.scheduleDay"\n                          istour="{{$ctrl.istour}}">\n            <div class="srow">{{item.label}}</div>\n        </weekly-scheduler>\n    </div>\n</div>');
$templateCache.put('app/components/tmpFile/file.html','<style>\n    .file-main{\n        position: relative;\n    }\n    .circle {\n        border-radius: 20000px;\n        display: inline-block;\n    }\n    .square {\n        border-radius: 5px !important;\n        display: inline-block;\n    }\n    .square img {\n        border-radius: 5px !important;\n    }\n    .overlayDiv {\n        position: absolute;\n        color: white;\n        background-color: rgba(0, 0, 0, 0.7);\n        top: 0;\n        left:0;\n    }\n    .overlayDiv:after {\n        content: "";\n        display: inline-block;\n        height: 100%;\n        vertical-align: bottom;\n    }\n    .overlayLabel {\n        display: inline-block;\n        vertical-align: bottom;\n        cursor: pointer;\n    }\n    .overlayLabel:hover {\n        text-decoration: underline;\n    }\n    .thumb {\n        width: 24px;\n        height: 24px;\n        float: none;\n        position: relative;\n        top: 7px;\n    }\n</style>\n\n<!-- Img Overlay -->\n<div class="file-main">\n<div class="{{flc.shape}}" ng-mouseenter="flc.showOverlay=true"\n    ng-mouseleave="flc.showOverlay=false"\n    style="position: relative; height:100%; width:100%;"\n    ng-if="!flc.styleButton">\n        <img height="100%" width="100%" class="{{flc.shape}}" ng-src="{{flc.defaultImg}}" ng-if="!flc.img">\n        <img height="100%" width="100%" ng-src="{{flc.img}}" ng-if="flc.img">\n        <div class="overlayDiv {{flc.shape}}"  ng-if="flc.showOverlay && !flc.readonly"\n            style="height: 100%; width: 100%">\n            <!--<label class="overlayLabel" ng-click="flc.labelClicked()">{{flc.label}}</label>-->\n            <label class="overlayLabel" ng-click="flc.changeFile()">{{flc.label}}</label>\n    </div>\n</div>\n<div ng-if="flc.styleButton" class="selectorImg" ng-model="flc.picFile"\n     ngf-accept="\'*/*\'" ngf-select="flc.onFileSelect(flc.picFile)" style="display: inline;">\n     <div class="progress" ng-show="flc.uploading">\n        <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"\n        aria-valuenow="{{flc.progressPercentage}}" aria-valuemin="0" aria-valuemax="100" \n        ng-style="{\'width\': flc.progressPercentage+\'%\'}">\n        <span style="color: black">{{flc.progressPercentage}}%</span> \n        </div>\n      </div>\n    <span class="addDishButton" ng-show="!flc.uploading"><span class="ion-ios-plus-outline"></span></span>\n</div>\n</div>\n<!-- End image Overlay -->');
$templateCache.put('app/components/uploadAvatar/avatar.html','<!-- Img Overlay -->\n<style>\n    .avatar-main{\n        position: relative;\n    }\n    .circle {\n        border-radius: 20000px;\n        display: inline-block;\n    }\n    .square {\n        border-radius: 5px !important;\n        display: inline-block;\n    }\n    .square img {\n        border-radius: 5px !important;\n    }\n    .overlayDiv {\n        position: absolute;\n        color: white;\n        background-color: rgba(0, 0, 0, 0.7);\n        top: 0;\n        left:0;\n    }\n    .overlayDiv:after {\n        content: "";\n        display: inline-block;\n        height: 100%;\n        vertical-align: bottom;\n    }\n    .overlayLabel {\n        display: inline-block;\n        vertical-align: bottom;\n        cursor: pointer;\n    }\n    .overlayLabel:hover {\n        text-decoration: underline;\n    }\n</style>\n<div style="{{avc.avatarStyle}}" class="avatar-main">\n    <div class="{{avc.shape}}" ng-mouseenter="avc.showOverlay=true"\n        ng-mouseleave="avc.showOverlay=false"\n        style="position: relative; height:100%; width:100%;"\n        ng-if="!avc.styleButton">\n        <img height="100%" width="100%" class="{{avc.shape}}" ng-src="{{avc.defaultImg}}" ng-if="!avc.img">\n        <img height="100%" width="100%" ng-src="{{avc.img}}" ng-if="avc.img">\n        <div class="overlayDiv {{avc.shape}}"  ng-if="avc.showOverlay && !avc.readonly"\n             style="height: 100%; width: 100%">\n            <label class="overlayLabel" ng-click="avc.changeImage()">{{avc.label}}</label>\n        </div>\n    </div>\n    <div ng-if="avc.styleButton" class="selectorImg " ng-click="avc.changeImage()"\n         style="width: 100%; height:100%; display: inline;">\n        <span class="addDishButton"><span class="ion-ios-plus-outline"></span></span></div>\n</div>\n<!-- End image Overlay -->\n\n<!-- Modal Upload File -->\n<script type="text/ng-template" id="imageCropContent.html">\n    <div class="modal-header">\n        <h3 class="modal-title" id="modal-title">{{\'AVATAR.SELECTANIMAGE\'|translate}}</h3>\n    </div>\n    <div class="modal-body" id="modal-body">\n        <div>\n            <input name="photo" type="file" ng-model="$ctrl.file" accept="image/*" base-sixty-four-input\n                   ng-change="$ctrl.onChange()" ng-disabled="$ctrl.istour">\n            <div class="cropArea" ng-if="$ctrl.file.base64" style="height: 350px;margin: 20px auto;">\n                <ui-cropper image="$ctrl.image" result-image="$ctrl.croppedImage" area-type="{{$ctrl.shape}}"\n                            result-image-size="\'max\'" result-image-quality="0.8"></ui-cropper>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-success" type="button" ng-click="$ctrl.ok()">{{\'BUTTONS.SAVE\'|translate}}</button>\n        <button class="btn" style="color:#000" type="button" ng-click="$ctrl.cancel()">{{\'BUTTONS.CANCEL\'|translate}} </button>\n    </div>\n</script>\n<!-- End Modal Upload File -->');
$templateCache.put('app/components/notificationsPush/notificationPush.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="NOTIFICATIONPUSH.HEADER"\n             ba-panel-class="with-scroll" ba-panel-anim="zoom-in"\n             style="line-height:30px;">\n            <form name="notificationForm">\n                <div class="row">\n                    <div class="col-md-12">\n                        <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'NOTIFICATIONPUSH.RECEIVERS\' | translate}}"\n                                          tooltip-placement="right"  style="vertical-align: top">\n                                        <span class="ion-android-person"></span>\n                                    </span>\n                            <ui-select multiple ng-model="npc.listUsers"\n                                       onkeypress="return false;"\n                                       name="receivers"ng-disabled="npc.isModeReadOnly()"\n                                       sortable="true" close-on-select="false">\n                                <ui-select-match allow-clear=true\n                                                 placeholder="{{\'NOTIFICATIONPUSH.RECEIVERS\'|translate}}">\n                                    {{$item.item.fullName}}\n                                </ui-select-match>\n                                <ui-select-choices search-enabled="false"\n                                    repeat="option in npc.userList | uiSelectFilter: {fullName:$select.search}">\n                                    <div ng-bind-html="option.fullName | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-12">\n                        <div class="input-group"\n                             ng-style="(notificationForm.title.$touched && notificationForm.title.$invalid ||\n                                notificationForm.title.$error.required && npc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'NOTIFICATIONPUSH.TITLE\' | translate}}"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-compose"></span>\n                                    </span>\n                            <input type="text"  name="title"\n                                   ng-required="true"\n                                   class="form-control with-primary-addon" title=" "\n                                   placeholder="{{\'NOTIFICATIONPUSH.TITLE\'|translate}}"\n                                   ng-class="{invalid: notificationForm.title.$touched &&\n                                   notificationForm.title.$invalid || notificationForm.title.$error.required &&\n                                   npc.showError}"\n                                   aria-describedby="basic-addon1"\n                                   ng-model="npc.notification.title">\n                        </div>\n                        <span ng-show="notificationForm.title.$touched && notificationForm.title.$invalid ||\n                                      notificationForm.title.$error.required && npc.showError" class="msgError">\n                            {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-12">\n                        <div class="input-group"\n                             ng-style="(notificationForm.text.$touched && notificationForm.text.$invalid ||\n                                    notificationForm.text.$error.required && npc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'NOTIFICATIONPUSH.TEXT\' | translate}}"\n                                  tooltip-placement="top-left" style="vertical-align: top;">\n                                <span class="ion-compose"></span>\n                            </span>\n                            <textarea type="text"  name="text" required\n                                      class="form-control with-primary-addon"\n                                      placeholder="{{\'NOTIFICATIONPUSH.TEXT\'|translate}}"\n                                      aria-describedby="basic-addon1"\n                                      ng-model="npc.notification.text"\n                                      ng-class="{invalid: notificationForm.text.$touched &&\n                                      notificationForm.text.$invalid || notificationForm.text.$error.required &&\n                                      npc.showError}">\n                            </textarea>\n                        </div>\n                        <span ng-show="notificationForm.text.$touched && notificationForm.text.$invalid ||\n                              notificationForm.text.$error.required && npc.showError" class="msgError">\n                            {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                </div>\n                <div class="pull-right">\n                    <button style="margin-top:30px; margin-bottom:7px;" type="button"\n                            ng-click="npc.cancel()" class="btn btn-success btn-with-icon">\n                        <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                    </button>\n                    <button style="margin-top:30px;margin-bottom:7px;" type="button"\n                            ng-click="npc.save(notificationForm)" class="btn btn-success btn-with-icon">\n                        <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/annoucements/annoucements.html','<script type="text/ng-template" id="tourAnnouncementsTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep"\n                                ng-if="tourStep.isPrev() && tourStep.stepId !== \'step9\' && tourStep.stepId !== \'step18\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div class="row">\n    <div ng-class="(ace.showAnnouncementView || ace.showActivityView || ace.servic._id || ace.menuId ||\n    ace.showIncidentView) ? ((ace.reserveList || ace.menuId && ace.appuser !== null || ace.selectedResident) ?\n    \'col-sm-3\' :  \'col-sm-4\') : \'col-sm-8\'" style="transition: all 0.5s;">\n        <announcements-list select-announcement="ace.selected" list="ace.list" pag="ace.pag" ng-if="ace.listLoaded"\n                           init-tour="ace.initTour()" tour-dummy-data="ace.tourDummyData" istour="ace.istour"\n                           mode-creation="ace.modeCreation"\n                           mode-read-only="ace.readOnly" anim="ace.anim"\n                            show-announcement-view="ace.showAnnouncementView"\n                           on-deleted="ace.reloadList(value)"\n                           show-grant-acces-view="ace.showGrantAccesView" from-announcement="ace.fromAnnouncement"\n                           url-redirect="ace.urlRedirect" related-id="ace.selected"\n                            show-activity-view="ace.showActivityView" show-complete-list="ace.showCompleteList"\n                           anim-reserve="ace.animReserve" servic="ace.servic" menu-id="ace.menuId"\n                            show-incident-view="ace.showIncidentView" reserve-list="ace.reserveList"\n                            anim-resident="ace.animResident" appuser="ace.appuser"\n                            selected-resident="ace.selectedResident"></announcements-list>\n    </div>\n    <div ng-if="ace.showAnnouncementView && ace.anim" class="col-sm-8">\n        <announcement-detail announcement-id="ace.selected" mode-read-only="ace.readOnly"\n                            on-updated="ace.reloadList(value)"\n                            show-announcement-view="ace.showAnnouncementView" anim="ace.anim"\n                            show-grant-acces-view="ace.showGrantAccesView" show-complete-list="ace.showCompleteList"\n                            url-redirect="ace.urlRedirect"></announcement-detail>\n    </div>\n    <!--  start activity related -->\n    <div ng-if="ace.showActivityView && ace.anim" ng-class="(ace.reserveList)? \'col-sm-4\' : \'col-sm-8\'">\n        <activity-detail activity-id="ace.selected" mode-read-only="ace.readOnly" on-updated="ace.reloadList(value)"\n                         show-activity-view="ace.showActivityView" anim="ace.anim"\n                         show-reserve="ace.showActivityReserve(value)"\n                         mode-creation="ace.showCompleteList" from-announcement="ace.fromAnnouncement"\n                         mode-edit="act.modeEdit"\n                         reserve-list="ace.reserveList" anim-reserve="ace.animReserve" anim-resident="ace.animResident"\n                         show-notification-button="ace.showNotificationButton"></activity-detail>\n    </div>\n    <!-- end activity related-->\n    <!-- start service related-->\n    <div ng-if="ace.servic._id && ace.anim"  ng-class="ace.animResident ? \'col-sm-4\' : \'col-sm-8\'" >\n        <in-service-detail-com\n            anim="ace.anim"\n            servic="ace.servic"\n            show-complete-list="ace.showCompleteList"\n            notification="ace.notification"\n            selected-resident="ace.selectedResident"\n            anim-resident="ace.animResident"\n            constants="ace.constants"></in-service-detail-com>\n    </div>\n    <!-- end service related-->\n    <!-- start menu related-->\n    <div ng-class="((ace.newSelectCourse) || (ace.appuser) || (ace.appuser || ace.reserveList.animReserve) ||\n        (ace.showComments) || ace.showReserveView) ? \'col-md-5 col-sm-6\' : \'col-md-8 col-sm-12\'"\n         ng-if="ace.menuId && ace.anim" >\n        <canteen-detail-com menuid="ace.menuId"\n                            menu="ace.menuselect"\n                            readonly="true"\n                            inselnewcourse="ace.newSelectCourse"\n                            returncourseitem="ace.returncourseitem"\n                            inaddoredit="ace.inaddoredit"\n                            alreadycourses="ace.alreadycourses"\n                            appuserbapan="ace.appuser"\n                            notification="ace.notification"\n                            block-buttons="ace.blockButtons"\n                            show-complete-list="ace.showCompleteList"\n                            show-resident="ace.animResident"\n                            show-comments="ace.showComments"\n                            show-reserve-view="ace.showReserveView"\n                            refresh-menu = "ace.refreshMenu"\n                            reserve-list="ace.reserveList">\n        </canteen-detail-com>\n    </div>\n    <div class="col-sm-10 col-md-3" ng-if="ace.showComments">\n    <canteen-comments-com\n        level="3"\n        show-comments="ace.showComments"\n        block-buttons="ace.blockButtons"\n        menu="ace.menuselect">\n    </canteen-comments-com>\n    </div>\n    <div class="col-sm-10 col-md-4"  ng-if="(ace.menuId && ace.appuser && !ace.animResident)">\n        <!--canteenSelectCourseCom-->\n        <canteen-app-users-list\n            notification="cntine.notification"\n            constants="ace.constants"\n            from-announcement="ace.fromAnnouncement"\n            selected-resident="ace.selectedResident"\n            anim-resident="ace.animResident"\n            block-buttons="ace.blockButtons"\n            appuserbapan="ace.appuser">\n        </canteen-app-users-list>\n    </div>\n    <div ng-if="ace.showReserveView" class="col-sm-3" >\n        <canteen-reserve-new\n            level="3"\n            menuid="ace.menuid"\n            menu="ace.menuselect"\n            selected-resident="ace.selectedResident"\n            mode-edit="ace.modeEdit"\n            show-reserve-view = "ace.showReserveView"\n            set-refresh-menu = "ace.setRefreshMenu()"\n            refresh-menu = "ace.refreshMenu"\n            anim-resident="ace.animResident"\n            block-buttons="ace.blockButtons">\n        </canteen-reserve-new>\n    </div>\n    <div ng-if="ace.reserveList && (ace.animReserve || ace.reserveList.animReserve) && !ace.animResident"\n         class="col-sm-4" >\n        <reserve-list reserve-list="ace.reserveList" anim-reserve="ace.animReserve" block-buttons="ace.blockButtons"\n                      selected-resident="ace.selectedResident" anim-resident="ace.animResident"\n                      constants="ace.constants"  show-notification-button="ace.showNotificationButton"\n                      notification="ace.notification"></reserve-list>\n    </div>\n    <!-- end menu related-->\n    <!-- start resident detail-->\n    <div ng-if="ace.selectedResident._id && ace.animResident" class="col-sm-4">\n        <resident-detail anim="ace.animResident"\n                         constants="ace.constants"\n                         level="3"\n                         resident="ace.selectedResident"></resident-detail>\n    </div>\n    <!-- end resident detail-->\n    <!-- start incident related-->\n    <div ng-if="ace.showIncidentView && ace.anim" class="col-md-8">\n        <incident-detail incident-id="ace.selected" mode-read-only="ace.readOnly" on-updated="ace.reloadList(value)"\n                         mode-creation="ace.modeCreation" show-incident-view="ace.showIncidentView" anim="ace.anim"\n                         show-disabled="ace.readOnly" show-complete-list="ace.showCompleteList"></incident-detail>\n    </div>\n    <!-- end incident related-->\n</div>\n\n\n\n\n\n\n\n\n\n\n\n');
$templateCache.put('app/pages/bedrooms/bedrooms.html','<div class="row">\n    <div ng-class="(brc.showBedroomDetail)? \'col-md-4\' : \'col-md-12\'" style="transition: all 0.5s;">\n        <bedrooms-list ng-if="brc.ready" states-rooms="brc.statesRooms" selected-bedroom="brc.selectedBedroom"\n                       show-bedroom-detail="brc.showBedroomDetail" inventory-tags="brc.inventoryTags" anim="brc.anim"\n                       room-types="brc.roomTypes"></bedrooms-list>\n    </div>\n    <div ng-if="brc.showBedroomDetail && brc.anim === true" class="col-md-8">\n        <bedroom-detail states-rooms="brc.statesRooms" selected-bedroom="brc.selectedBedroom" show-bedroom-detail="brc.showBedroomDetail"\n                        anim="brc.anim" inventory-tags="brc.inventoryTags" room-types="brc.roomTypes"></bedroom-detail>\n    </div>\n</div>\n');
$templateCache.put('app/pages/dashboard/dashboard.html','<script type="text/ng-template" id="tourDashboardTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep" ng-if="tourStep.isPrev()"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div id="tourAvatar" style="position: absolute; right: 405px; top:60px;"></div>\n<div id="tourBreadcrum" style="position: absolute; right: 540px; top:120px;"></div>\n<div class="col-lg-8 col-md-12 dashboardChartsWrapper">\n    <!--OCCUPATION PIE CHARTS-->\n    <div class="row animated fadeInLeft">\n        <div class="col-xs-12">\n            <span class="chartPlaceTitle" ng-hide="!dc.loadingOccupationPie && !(dc.occupationPieCharts && dc.occupationPieCharts.length)">\n                {{\'INCIDENCESCHART.OCCUPATION\'|translate}}</span>\n        </div>\n        <div class="col-xs-12" ng-if="dc.loadingOccupationPie">\n            <div class="loading-spinner"><span class="fa fa-spinner fa-spin"></span></div>\n        </div>\n        <div class="col-xs-12" ng-if="!dc.loadingOccupationPie && dc.occupationPieCharts && dc.occupationPieCharts.length">\n            <dashboard-pie-chart chart-data="dc.occupationPieCharts"></dashboard-pie-chart>\n        </div>\n    </div>\n\n    <!--TOTAL INCIDENCES DONUT CHARTS-->\n    <div class="row animated fadeInLeft">\n        <div class="col-xs-12">\n            <span class="chartPlaceTitle" ng-hide="!dc.loadingIncidencesDonuts && !(dc.totalDonutCharts && dc.totalDonutCharts.length)">\n                {{\'INCIDENCESCHART.INCIDENCES\'|translate}}</span>\n        </div>\n        <div class="col-xs-12" ng-if="dc.loadingIncidencesDonuts">\n            <div class="loading-spinner"><span class="fa fa-spinner fa-spin"></span></div>\n        </div>\n    </div>\n    <div class="row pie-charts donutCharts" ng-if="!dc.loadingIncidencesDonuts && dc.totalDonutCharts && dc.totalDonutCharts.length">\n        <div class="pie-chart-item-container" ng-repeat="place in dc.totalDonutCharts" ng-attr-id="{{place.chartId}}">\n            <div ba-panel ng-click="dc.openHistoryIncidences(place)"\n                 ng-class="{\'donutChartActive\': place.placeId === dc.selectedPlace}">\n                <div class="pie-chart-item">\n                    <div class="chart">\n                        <dashboard-incidents-donut-chart chart-data="place"></dashboard-incidents-donut-chart>\n                    </div>\n                    <div class="description">\n                        <div>{{ place.place }}</div>\n                        <div class="description-stats">\n                            <span\n                                class="inciNumber inciTimeOut">{{\'INCIDENCESCHART.INCIDENCESTIMEOUTABBREV\' | translate}}</span>\n                            <span>{{ place.timeOut }}</span><br>\n                            <span class="inciNumber inciHigh">{{\'INCIDENCESCHART.INCIDENCESHIGHABBREV\' | translate}}</span>\n                            <span>{{ place.incidencesHigh }}</span><br>\n                            <span\n                                class="inciNumber inciNormal">{{\'INCIDENCESCHART.INCIDENCESNORMALABBREV\' | translate}}</span>\n                            <span>{{ place.incidencesNormal }}</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!--OPENED/CLOSED INCIDENCES BAR/LINE CHARTS-->\n    <div class="row animated fadeInLeft" ng-show="dc.selectedPlace && dc.showFilter"\n         ng-class="{\'fadeOutLeft\': !dc.selectedPlace || !dc.showFilter}">\n        <div class="col-xs-12">\n            <div class="dashPickersContainer">\n                <div class="dashPickerDateBlock">\n                    <span class="chartPlaceTitle" >\n                        <span style="display: inline-block; margin-right: 10px; color: #8AF37E;"\n                              class="chartPlaceTitleWhite">{{dc.selectedPlaceName}}</span>\n                    </span>\n                </div>\n                <div class="dashPickerDateBlock">\n                    <span class="chartPlaceTitle">\n                        <span  class="chartPlaceTitleWhite">{{\'BULLETINBOARD.DATEFROM\'|translate}}</span>\n                    </span>\n                    <date-picker-comp class="datePickerDashCharts"\n                                      tooltip-text="\'INCIDENCESCHART.MINDATE\' | translate"\n                                      tooltip-placement="top-left"\n                                      date-value="dc.minDate"\n                                      mode-read-only="dc.istour"\n                                      date-options="dc.dateOptions"\n                                      form-reference="incidencesForm"\n                                      name-field="\'creationDate\'"></date-picker-comp>\n                </div>\n                <div class="dashPickerDateBlock">\n                    <span class="chartPlaceTitle">\n                        <span  class="chartPlaceTitleWhite">{{\'BULLETINBOARD.DATETO\'|translate}}</span>\n                    </span>\n                    <date-picker-comp class="datePickerDashCharts"\n                                      tooltip-text="\'INCIDENCESCHART.MAXDATE\' | translate"\n                                      tooltip-placement="top-left"\n                                      date-value="dc.maxDate"\n                                      mode-read-only="dc.istour"\n                                      date-options="dc.dateOptions"\n                                      form-reference="incidencesForm"\n                                      name-field="\'creationDate\'"></date-picker-comp>\n                    <button type="button" class="btn btn-success btn-with-icon filterButton"\n                            ng-click="dc.reloadIncidencesLineCharts()">\n                        <i class="ion-funnel"></i>\n                        <span>{{\'INCIDENCESCHART.FILTER\' |translate}}</span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="row" ng-repeat="place in dc.totalBarCharts" ng-show="place.placeId === dc.selectedPlace"\n         ng-class="{\'fadeInLeft\': place.placeId === dc.selectedPlace, \'fadeOutLeft\': place.placeId !== dc.selectedPlace}">\n        <div class="col-xs-12">\n            <div class="row">\n                <div class="barPanel col-lg-4 col-md-4" ng-if="place.line" ng-attr-id="{{place.line.chartId}}">\n                    <dashboard-incidents-mixed-chart chart-data="place.line"></dashboard-incidents-mixed-chart>\n                </div>\n                <div class="mixedPanel col-lg-4 col-md-4" ng-if="place.mixed" ng-hide="place.mixed.noData"\n                     ng-attr-id="{{place.mixed.chartId}}">\n                    <dashboard-incidents-mixed-chart chart-data="place.mixed"></dashboard-incidents-mixed-chart>\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <!--MENUS PIE CHARTS-->\n    <div class="row animated fadeInLeft">\n        <div class="col-xs-12">\n            <span class="chartPlaceTitle" ng-hide="dc.printMenus && !(dc.menuPieCharts && dc.menuPieCharts.length)">\n                {{\'MENUS\'|translate}}</span>\n        </div>\n        <div class="col-xs-12" ng-if="!dc.printMenus">\n            <div class="loading-spinner"><span class="fa fa-spinner fa-spin"></span></div>\n        </div>\n        <div class="col-xs-12 donutMenuCharts" ng-if="dc.printMenus && dc.menuPieCharts && dc.menuPieCharts.length">\n            <dashboard-menu-pie-chart chart-data="dc.menuPieCharts" selected-canteen-place="dc.selectedCanteenPlace"\n                                      reload-canteen-mixed-chart="dc.reloadCanteenMixedChart"></dashboard-menu-pie-chart>\n        </div>\n    </div>\n    <!--OPENED/CLOSED DETAILS CANTEEN CHARTS-->\n    <div class="row" ng-repeat="chart in dc.menuPieCharts"\n         ng-class="{\'fadeInLeft\': chart.meals[0].placeId === dc.selectedCanteenPlace}">\n        <div class="col-xs-12">\n            <div class="row">\n                <div ng-class="{\'col-xs-12\' : chart[\'meals\'].length > 1, \'col-xs-6\': chart[\'meals\'].length <= 1}"\n                     ng-if="chart.meals[0].placeId === dc.selectedCanteenPlace" ng-attr-id="{{chart.meals[0].chartId}}">\n                    <dashboard-canteen-mixed-chart chart-data="chart.meals"\n                                                   reload="dc.reloadCanteenMixedChart"></dashboard-canteen-mixed-chart>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="col-lg-4 col-md-12" ng-if="dc.logbookPermission">\n    <div class="row">\n        <div ng-class="\'col-md-12\'" style="transition: all 0.51s;">\n            <logbook></logbook>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/myTimetable/my-timetable.tpl.html','<style>\n   \nh1 {\n  width: 90%;\n  margin-bottom: 0;\n  color: #2cab54;\n}\n\nh2 {\n  margin-top: 0;\n  border-bottom: 1px solid #aaa;\n  font-size: 0.9em;\n  color: #808080;\n}\n\n.my-timetable{\n  /*width: 90%;*/\n  border-spacing: 0;\n  border-collapse: collapse;\n    line-height: 20px;\n    \n  -moz-user-select: -moz-none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.my-timetable th {\n  font-size: 0.8em;\n  /*color: #808080;*/\n  color: #fff;\n  cursor: pointer;\n}\n\n.my-timetable td {\n  border: 1px solid #ccc;\n  cursor: pointer;\n}\n\n.my-timetable .dayWeek {\n    text-align: center;\n    font-size: 1em;\n    color: #8AF37E;\n}\n\n\n.my-timetable td:hover {\n  background: orange;\n}\n\n.my-timetable .selected {\n  background: #2cab54;\n}\n\n.my-timetable .disabled {\n  pointer-events: none;\n}\n</style>\n<table class="my-timetable">\n    <colgroup>\n      <col span="1" width="9%">\n      <col data-ng-repeat="i in loop(0, 8, 1)" span="1" width="13%">\n    </colgroup>\n    <thead>\n      <th></th>\n      <th data-ng-repeat="day in days"  class="dayWeek" data-ng-click="toggle(\'day\', $index)">{{day}}</th>\n    </thead>\n    <tbody>\n      <tr data-ng-repeat="i in loop(0, 23, 1)">\n        <th data-ng-click="toggle(\'hour\', 0, i)">{{i + \':00\'}}</th>\n        <td data-ng-repeat="j in loop(0, 6, 1)" data-ng-mousedown="select(true, j, i)" data-ng-mouseup="select(false)" data-ng-mouseover="toggle(\'slot\', j, i)" data-ng-click="toggle(\'slot\', j, i)" data-ng-class="{selected: slots[j][i] , disabled: disabled }"></td>\n      </tr>\n    </tbody>\n  </table>');
$templateCache.put('app/pages/rooms/rooms.html','<div class="rooms-component">\n    <div class="row">\n        <div class="col-md-12" style="transition: all 0.51s;" ng-if="roc.anim === false">\n            <div ba-panel class="animated fadeInLeft"  ba-panel-title="ROOMS.OCCUPATION">\n                <div class="row" ng-if="roc.selectedBar && !roc.selectedBar.all">\n                    <div class="col-md-8 col-sm-12">\n                        <!--OCCUPATION PIE CHARTS-->\n                        <div class="col-xs-12" style="background: #302E2E;">\n                            <span class="chartRoomsTitle">{{\'ROOMS.ROOMS\'|translate}}</span>\n                        </div>\n                        <div class="col-xs-12" style="margin-top: 16px; margin-bottom: 20px;" ng-if="roc.occupationPieCharts && roc.occupationPieCharts.length > 0">\n                            <rooms-pie-chart chart-data="roc.occupationPieCharts"></rooms-pie-chart>\n                        </div>\n                        <div class="col-xs-12" ng-if="!roc.occupationPieCharts || !roc.occupationPieCharts.length">\n                            <div class="loading-spinner" ><span class="fa fa-spinner fa-spin"></span></div>\n                        </div>\n                    </div>\n                    <div class="col-md-4 col-sm-12" style="padding-bottom: 20px;">\n                        <div class="row">\n                            <div class="col-xs-12" style="background: #302E2E; ">\n                                <span class="chartRoomsTitle">{{\'ROOMS.RESIDENTS\'|translate}}</span>\n                            </div>\n                        </div>\n                        <div class="row" style="margin-top: 48px;">\n                            <div class="col-xs-4">\n                                <div class="row chartRoomsStats">{{roc.occupationInfo.totalOccupancy}}</div>\n                                <div class="row chartRoomsSubtitle">{{\'ROOMS.RPRESENTS\'|translate}}</div>\n                            </div>\n                            <div class="col-xs-4">\n                                <div class="row chartRoomsStats">{{roc.occupationInfo.totalAbsent}}</div>\n                                <div class="row chartRoomsSubtitle">{{\'ROOMS.RABSENTS\'|translate}}</div>\n                            </div>\n                            <div class="col-xs-4">\n                                <div class="row chartRoomsStats">{{roc.occupationInfo.totalGuest}}</div>\n                                <div class="row chartRoomsSubtitle">{{\'ROOMS.GUESTS\'|translate}}</div>\n                            </div>\n                        </div>\n                        <div class="col-xs-12" ng-if="!roc.occupationPieCharts || !roc.occupationPieCharts.length">\n                            <div class="loading-spinner" ><span class="fa fa-spinner fa-spin"></span></div>\n                        </div>\n                    </div>\n                </div>\n                <div class="row" ng-if="!roc.selectedBar || roc.selectedBar.all">\n                    <div class="col-xs-12">\n                        <span style="font-size: 15px">{{\'ROOMS.SELECT_BRANCH_MSG\'|translate}}</span>\n                    </div>\n                </div>\n                <div class="row">\n                    <rooms-list-com anim="roc.anim" room="roc.selected"></rooms-list-com>\n                </div>\n            </div>\n        </div>\n        <div class="col-md-12" ng-if="roc.selected._id && roc.anim === true">\n            <rooms-detail-com anim="roc.anim" room="roc.selected"></rooms-detail-com>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/activities/activitiesList/activitiesList.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="ACTIVITIESLIST.HEADER" ba-panel-class="with-scroll" id="agendaList">\n            <div class="resumeTourContainer" style="left: 250px!important;">\n                    <span class="ion-ios-information-outline" tagaste-click="alstc.initTour()" style="cursor: pointer;"\n                          ng-hide="alstc.showActivityView"></span>\n            </div>\n            <div class="horizontal-scroll" ng-class="(!alstc.showActivityView) ? \'\': \'hideTableCounts\'">\n                <table ng-table="alstc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true" style="cursor: pointer">\n\n                    <colgroup ng-if="alstc.showActivityView">\n                        <col width="100%">\n                    </colgroup>\n                    <colgroup ng-if="!alstc.showActivityView && alstc.userBranch.length > 1">\n                        <col width="5%">\n                        <col width="35%">\n                        <col width="30">\n                        <col width="5%">\n                        <col width="5%">\n                        <col width="5%">\n                        <col width="5%">\n                    </colgroup>\n                    <colgroup ng-if="!alstc.showActivityView && alstc.userBranch.length == 1">\n                        <col width="5%">\n                        <col width="75%">\n                        <col width="5%">\n                        <col width="5%">\n                        <col width="5%">\n                        <col width="5%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data |dummyDataIfEmpty:alstc.tourDummyData |showErrorNoData"\n                        ng-click="alstc.tableParamsCK(row)"\n                        ng-class="{\'firstListRow\': $index === 0, \'selectRow\': row.selected === true}"\n                        class="ng-binding">\n\n                        <td colspan="2" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title=""\n                            ng-if="!alstc.showActivityView && !row.error">\n                            <img ng-src="{{row.photo.thumb.signedUrl}}" style="max-width: 40px" check-image/>\n                        </td>\n                        <td data-title="\'ACTIVITIESLIST.LOCALITY\'|translate"\n                            sortable="\'localities\'"\n                            filter="alstc.filterLocality"\n                            ng-if="!alstc.showActivityView && alstc.userBranch.length > 1"\n                            ng-attr-title="{{row.localities}}" style="text-align: inherit">\n                            {{row.localities}}\n                        </td>\n                        <td data-title="\'ACTIVITIESLIST.TITLE\'|translate"\n                            sortable="\'title\'" style="text-align: inherit"\n                            filter="alstc.filterTitle"\n                            ng-attr-title="{{row.title}}">\n                            {{row.title}}\n                        </td>\n                        <td data-title="\'ACTIVITIESLIST.PRICE\'|translate"\n                            sortable="\'rate\'"\n                            ng-if="!alstc.showActivityView"\n                            filter="alstc.filterPrice"\n                            ng-attr-title="{{row.rate}}">\n                            {{row.rate | currency}}\n                        </td>\n                        <td data-title="\'ACTIVITIESLIST.ENROLLED\'|translate"\n                            sortable="\'bookedNum\'"\n                            ng-if="!alstc.showActivityView"\n                            filter="alstc.filterEnrolless"\n                            ng-attr-title="{{row.bookedNum}}">\n                            {{row.bookedNum}}\n                        </td>\n                        <td data-title="\'ACTIVITIESLIST.STATE.TITLE\'|translate"\n                            ng-if="!alstc.showAnnouncementView && !alstc.showGrantAccesView &&\n                            !alstc.showActivityView  && !alstc.servic._id && !alstc.menuId && !alstc.showIncidentView"\n                            sortable="\'isFull\'"\n                            ng-attr-title="{{row.isFull ? \'ACTIVITIESLIST.STATE.SPOTSNOAVAILABLE\' :\n                            \'ACTIVITIESLIST.STATE.SPOTSAVAILABLE\'| translate}}"\n                            class="text-center">\n                            <span class="iconNgTable"\n                                  ng-class="(row.isFull) ? \'ion-ios-locked\' : \'ion-ios-unlocked-outline\'">\n                            </span>\n                        </td>\n                        <td ng-if="!alstc.showActivityView && !row.error" style="white-space: nowrap">\n                            <span class="fa fa-pencil iconNgTable edit"\n                                  uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                  ng-if="alstc.gotAccessMod"\n                                  ng-click="alstc.editActivity(row); $event.stopPropagation();"></span>\n                            <span class="fa fa-trash-o iconNgTable edit"\n                                  uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                  ng-if="alstc.gotAccessDel"\n                                  style="margin-left: 10px;"\n                                  ng-click="alstc.deleteActivity(row); $event.stopPropagation();"></span>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n\n            <div class="row" ng-if="!alstc.showActivityView">\n                <div class="col-xs-12 countAndNewButton" style="display: flex; align-items: center;">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ alstc.tableParams.total() }}</span>\n                    </span>\n                    <button ng-click="alstc.newActivity()" ng-if="alstc.gotAccessMod"\n                            type="button" id="newAgendaButton" ng-disabled="alstc.istour"\n                            class="btn btn-success btn-with-icon pull-right newButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                    <button type="button"\n                    tagaste-click="alstc.exportData();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n\n        </div>\n\n    </div>\n</div>');
$templateCache.put('app/components/activities/activityDetail/activityDetail.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel">\n        <div ba-panel ba-panel-title="ACTIVITYDETAIL.HEADERDETAIL"\n             ba-panel-class="with-scroll" ba-panel-anim="zoom-in"\n             style="line-height:30px;" id="agendaDetail">\n            <div>\n                <form name="activityForm">\n                    <div style="padding-bottom: 15px; display:flex;" id="activityDetailFlex"\n                         ng-style="(adc.reserveList || adc.notification)?\n                         {\'flex-direction\':\'column\'} : {\'flex-direction\':\'row\'}">\n                        <div style="padding: 0 15px 10px 15px;\n                                    display: flex;\n                                    justify-content: center;\n                                    align-items: center;"\n                             ng-class="{\'invalid\': adc.submitted && !adc.photovalid  }">\n                            <avatar type="picture" shape="rectangle" size="150" img="adc.avatar"\n                                    avatar-style="width:150px; text-align:center;"\n                                    uploading="adc.avatarUploading"\n                                    photo="adc.activity.photo" readonly="( adc.modeReadOnly || adc.istour )"></avatar>\n                            <span ng-show="adc.submitted && !adc.photovalid" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                        </div>\n                        <div style="flex-grow: 1">\n                            <div class="row">\n                                <div class="col-xs-12 col-sm-6" style="padding-left: 15px;">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip="{{\'ACTIVITYDETAIL.LIMIT\' | translate}}"\n                                              tooltip-placement="bottom-left">\n                                            <span class="ion-person-stalker"></span>\n                                        </span>\n                                        <input type="text" ng-readonly="adc.modeReadOnly"\n                                               ng-keypress="adc.validateKeyPress($event)"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'ACTIVITYDETAIL.SPOTS\'|translate}}"\n                                               aria-describedby="basic-addon1" style="width: 75px;"\n                                               ng-model="adc.activity.maxUsers">\n                                    </div>\n                                </div>\n                                <div class="col-xs-12 col-sm-6">\n                                    <div class="pull-right">\n                                        <ba-switcher switcher-style="primary" switcher-value="adc.activity.active"\n                                                     switcher-on="\'ACTIVITYDETAIL.ACTIVE\'|translate"\n                                                     switcher-off="\'ACTIVITYDETAIL.ACTIVE\'|translate"\n                                                     switcher-read-only="adc.modeReadOnly"\n                                                     uib-tooltip="{{\'BULLETINBOARDDETAIL.ACTIVE\' | translate}}"\n                                                     tooltip-placement="bottom-left"\n                                                     ng-if="adc.modeReadOnly || adc.modeEdit">\n                                        </ba-switcher>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <!--rate-->\n                                <div class="col-xs-12 col-sm-3" style="padding-left: 15px;">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip="{{\'ACTIVITYDETAIL.PRICE\' | translate}}"\n                                              tooltip-placement="bottom-left">\n                                            <span class="ion-social-euro"></span>\n                                        </span>\n                                        <input type="text" ng-readonly="adc.modeReadOnly" valid-number\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'ACTIVITYDETAIL.PRICE\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               ng-change="adc.calcTotal()"\n                                               ng-model="adc.activity.rate">\n                                    </div>\n                                </div>\n                                <!--tax-->\n                                <div class="col-xs-12 col-sm-3" style="padding-left: 15px;">\n                                    <div class="input-group">\n                                        <span uib-tooltip="{{\'ACTIVITYDETAIL.TAX\' | translate}}"\n                                              tooltip-placement="right"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="ion ion-android-list"></span>\n                                        </span>\n                                        <ui-select ng-model="adc.activity.tax"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control"\n                                                   append-to-body="true"\n                                                   name="activityTax"\n                                                   ng-disabled="adc.modeReadOnly"\n                                                   ng-change="adc.calcTotal()"\n                                                   search-enabled="true">\n                                            <ui-select-match\n                                                allow-clear=true\n                                                placeholder="{{\'ACTIVITYDETAIL.TAX\'| translate}}">\n                                                {{adc.activity.tax.name}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in adc.taxes">\n                                                <div\n                                                    ng-bind-html="option.name | highlight: $select.search"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <!--total-->\n                                <div class="col-xs-12 col-sm-3" style="padding-left: 15px;">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip="{{\'ACTIVITYDETAIL.TOTAL\' | translate}}"\n                                              tooltip-placement="bottom-left">\n                                            <span class="ion-social-euro"></span>\n                                        </span>\n                                        <input type="text" ng-readonly="true" valid-number\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'ACTIVITYDETAIL.TOTAL\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               ng-model="adc.activity.total">\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <div class="input-group"\n                                         ng-style="(activityForm.locality.$touched &&\n                                                     activityForm.locality.$invalid ||\n                                                     activityForm.locality.$error.required && adc.showError) ?\n                                                     {\'margin-bottom\': 0}:\'\'">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'ACTIVITYDETAIL.LOCALITY\' | translate}}"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-card"></span>\n                                    </span>\n                                        <ui-select multiple ng-model="adc.activity.branches" class="activityLocality"\n                                                   ng-disabled="adc.modeReadOnly" ng-required="true" name="locality"\n                                                   ng-class="{invalid: activityForm.locality.$touched && activityForm.locality.$invalid || activityForm.locality.$error.required && adc.showError}"\n                                                   sortable="true" close-on-select="false" name="locality">\n                                            <ui-select-match allow-clear=true\n                                                             placeholder="{{\'ACTIVITYDETAIL.LOCALITY\'|translate}}">\n                                                {{$item.description}}\n                                            </ui-select-match>\n                                            <ui-select-choices\n                                                repeat="option._id as option in adc.localities | uiSelectFilter:\n                                                {description:$select.search}">\n                                                <div\n                                                    ng-bind-html="option.description | highlight: $select.search"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                    <span ng-show="activityForm.locality.$touched && activityForm.locality.$invalid ||\n                                activityForm.locality.$error.required && adc.showError" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}\n                                    </span>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <div class="input-group"\n                                         ng-style="(activityForm.title.$touched && activityForm.title.$invalid ||\n                                        activityForm.title.$error.required && adc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'ACTIVITYDETAIL.TITLE\' | translate}}"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-compose"></span>\n                                    </span>\n                                        <input type="text" ng-readonly="adc.modeReadOnly" name="title"\n                                               ng-required="true"\n                                               class="form-control with-primary-addon" title=" "\n                                               placeholder="{{\'ACTIVITYDETAIL.TITLE\'|translate}}"\n                                               ng-class="{invalid: activityForm.title.$touched &&\n                                               activityForm.title.$invalid || activityForm.title.$error.required &&\n                                               adc.showError}"\n                                               aria-describedby="basic-addon1"\n                                               ng-model="adc.activity.title">\n                                    </div>\n                                    <span ng-show="activityForm.title.$touched && activityForm.title.$invalid ||\n                                      activityForm.title.$error.required && adc.showError" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group" ng-style="(activityForm.description.$touched &&\n                            activityForm.description.$invalid || activityForm.description.$error.required &&\n                            adc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'ACTIVITYDETAIL.DESCRIPTION\' | translate}}"\n                                  tooltip-placement="top-left" style="vertical-align: top">\n                                <span class="ion-compose"/>\n                            </span>\n\n                                <textarea type="text" ng-readonly="adc.modeReadOnly" name="description" required\n                                          class="form-control with-primary-addon"\n                                          placeholder="{{\'ACTIVITYDETAIL.DESCRIPTION\'|translate}}"\n                                          aria-describedby="basic-addon1"\n                                          ng-model="adc.activity.text"\n                                          ng-class="{invalid: activityForm.description.$touched &&\n                                          activityForm.description.$invalid ||\n                                          activityForm.description.$error.required && adc.showError}">\n                            </textarea>\n                            </div>\n                            <span ng-show="activityForm.description.$touched && activityForm.description.$invalid ||\n                              activityForm.description.$error.required && adc.showError" class="msgError">\n                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}\n                            </span>\n                        </div>\n                    </div>\n                    <div class="row" style="margin-bottom: 15px">\n                        <div class="col-md-12">\n                            <div class="input-group" style="margin-bottom: 0">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'ACTIVITYDETAIL.PLACETEXT\' | translate}}"\n                                      tooltip-placement="top-left">\n                                    <span class="ion-compose"></span></span>\n                                <input type="text" ng-readonly="adc.modeReadOnly"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'ACTIVITYDETAIL.PLACETEXT\'|translate}}"\n                                       title=" "\n                                       aria-describedby="basic-addon1"\n                                       ng-model="adc.activity.placeText">\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'ACTIVITYDETAIL.DATETEXT\' | translate}}"\n                                      tooltip-placement="top-left">\n                                    <span class="ion-compose"></span></span>\n                                <input type="text" ng-readonly="adc.modeReadOnly" name="dateText"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'ACTIVITYDETAIL.DATETEXT\'|translate}}"\n                                       title=" "\n                                       aria-describedby="basic-addon1"\n                                       ng-model="adc.activity.dateText">\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); grid-column-gap:10px;">\n                                <date-picker-comp tooltip-text="\'ACTIVITYDETAIL.VISIBLEFROM\' | translate"\n                                                  tooltip-placement="top-left" date-value="adc.visibleFrom"\n                                                  is-required="true" mode-read-only="( adc.modeReadOnly || adc.istour )"\n                                                  date-options="adc.dateOptions" show-required-error="adc.showError"\n                                                  form-reference="activityForm" special-validation="adc.checkDates()"\n                                                  name-field="\'visibleFrom\'"></date-picker-comp>\n                                <date-picker-comp tooltip-text="\'ACTIVITYDETAIL.VISIBLETO\' | translate"\n                                                  tooltip-placement="top-left" date-value="adc.visibleTo"\n                                                  is-required="true" mode-read-only="( adc.modeReadOnly || adc.istour )"\n                                                  date-options="adc.dateOptions" show-required-error="adc.showError"\n                                                  form-reference="activityForm" special-validation="adc.checkDates()"\n                                                  name-field="\'visibleTo\'"></date-picker-comp>\n                                <date-picker-comp tooltip-text="\'ACTIVITYDETAIL.LIMITDATE\' | translate"\n                                                  tooltip-placement="top-left" date-value="adc.dateLimit"\n                                                  is-required="true" mode-read-only="( adc.modeReadOnly || adc.istour )"\n                                                  date-options="adc.dateOptions" show-required-error="adc.showError"\n                                                  form-reference="activityForm"\n                                                  placeholder="\'ACTIVITYDETAIL.LIMITDATE\' | translate"\n                                                  special-validation="adc.checkLimitDate()"\n                                                  msg-special-validation="\'ACTIVITYDETAIL.MSGDATELIMIT\' | translate"\n                                                  name-field="\'dateLimit\'"></date-picker-comp>\n                            </div>\n\n                        </div>\n                    </div>\n\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div ng-if="adc.modeReadOnly || adc.modeEdit">\n                                <button type="button" ng-if="!adc.fromAnnouncement"\n                                        ng-if="adc.accessPush"\n                                        ng-disabled="adc.activity.userBooked.length === 0 || adc.animResident"\n                                        ng-click="adc.sendNotification()" class="btn btn-success btn-with-icon">\n                                    <i class="ion-iphone"></i>{{\'BUTTONS.NOTIFY\' | translate}}\n                                </button>\n                                <button type="button" ng-disabled="adc.activity.userBooked.length === 0 || adc.animResident"\n                                        ng-click="adc.showStock()" class="btn btn-success btn-with-icon">\n                                    <i class="ion-share"></i>{{\'ACTIVITYDETAIL.STOCK\' | translate}}\n                                </button>\n                                <button type="button"\n                                        tagaste-click="adc.exportData();$event.stopPropagation();"\n                                        class="btn btn-success btn-with-icon newButton " style=\'display: none;\' id="exportButton">\n                                    <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n\n\n                </form>\n                <div class="panel-footer-buttons">\n                    <div class="row">\n                        <div class="col-md-12 pull-right text-right ">\n                            <button style="margin-top:30px;margin-bottom:7px;" type="button" id="agendaCancelButton"\n                                    ng-disabled="adc.istour"\n                                    ng-click="adc.cancel()" class="btn btn-success btn-with-icon">\n                                <i class="ion-arrow-left-c"></i>{{adc.modeReadOnly ? \'BUTTONS.BACK\' : \'BUTTONS.CANCEL\'\n                                | translate}}\n                            </button>\n                            <button style="margin-top:30px;margin-bottom:7px;" type="button" id="activityNewReserve"\n                                    ng-if="( !adc.modeReadOnly && adc.modeEdit )" ng-disabled="(adc.checkDates() || adc.avatarUploading || adc.checkLimitDate()|| adc.istour )"\n                                    ng-click="adc.newReserve()" class="btn btn-success btn-with-icon">\n                                <i class="ion-android-checkmark-circle"></i>{{\'ACTIVITYDETAIL.NEWRESERVE\' | translate}}\n                            </button>\n                            <button style="margin-top:30px;margin-bottom:7px;" type="button" id="agendaSaveButton"\n                                    ng-if="!adc.modeReadOnly" ng-disabled="(adc.checkDates() || adc.avatarUploading || adc.checkLimitDate()|| adc.istour )"\n                                    ng-click="adc.save(activityForm)" class="btn btn-success btn-with-icon">\n                                <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                            </button>\n\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n');
$templateCache.put('app/components/activities/reserveNew/reserveNew.html','<div class="row" style="max-height: 617px;">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel">\n        <div ba-panel ba-panel-title="RESERVE.NEWRESERVE" ba-panel-class="with-scroll"\n             ba-panel-anim="zoom-in" style="line-height:30px;">\n            <form name="resForm" autocomplete="false">\n                <div class="row">\n                    <div class="col-xs-4 col-md-4 col-sm-4">\n                        <label class="custom-checkbox">\n                            <input id="checkResidente" type="checkbox" ng-model="rnc.isResident"\n                                   ng-click="rnc.changeIsResident(true)">\n                            <span>{{\'RESERVE.RESIDENT\'|translate}}</span>\n                        </label>\n                        <br/>\n                        <label class="custom-checkbox">\n                            <input id="checkExterno" type="checkbox" ng-model="rnc.isGuest"\n                                   ng-click="rnc.changeIsResident(false)">\n                            <span>{{\'RESERVE.EXTERN\'|translate}}</span>\n                        </label>\n                    </div>\n                    <div ng-class="(rnc.level > 2) ? \'col-md-8\' : \'col-md-8\'" ng-if="!rnc.isResident">\n                        <div class="row">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'RESERVE.NAME\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-android-person"></span></span>\n                                <input type="text"\n                                       ng-class="{\'invalid\': (resForm.name.$touched ||\n                                    rnc.submitted ) && !rnc.readonly && !resForm.name.$valid }"\n                                       required="!rnc.isResident"\n                                       ng-model="rnc.selectedName"\n                                       placeholder="{{\'RESERVE.NAME\'|translate}}"\n                                       uib-typeahead="o as o.fullName for o in rnc.getGuestsByName($viewValue)"\n                                       typeahead-loading="loadingGuest"\n                                       typeahead-no-results="noGuestName" class="form-control"\n                                       typeahead-wait-ms="700" typeahead-min-length=\'3\'\n                                       typeahead-on-select="rnc.setGuest($item)">\n                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                <div ng-show="noGuestName">\n                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                </div>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="( resForm.name.$touched || rnc.submitted )&& !rnc.readonly &&\n                            !resForm.name.$valid">{{\'ERROR.NOTVALIDINPUT\' |translate}}\n                            </div>\n                            <div class="input-group">\n                                <input type="text" ng-disabled="rnc.readonly" name="surname"\n                                       class="form-control with-primary-addon"\n                                       ng-class="{\'invalid\': ( resForm.surname.$touched ||\n                                        rnc.submitted ) && !resForm.surname.$valid}"\n                                       placeholder="{{\'RESERVE.LASTNAME\'|translate}}"\n                                       style="border-radius: 5px;"\n                                       required="!rnc.isResident"\n                                       ng-model="rnc.selectedSurname"\n                                       uib-typeahead="o as o.fullName for o in rnc.getGuestsBySurname($viewValue) "\n                                       typeahead-loading="loadingGuest"\n                                       typeahead-no-results="noGuestSurname" class="form-control"\n                                       typeahead-wait-ms="700" typeahead-min-length=\'3\'\n                                       typeahead-on-select="rnc.setGuest($item)">\n                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                <div ng-show="noGuestSurname">\n                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                </div>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="( resForm.surname.$touched || rnc.submitted ) && !resForm.surname.$valid">\n                                {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'RESERVE.IDENTIFICATION\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left ">\n                                <span class="ion-card"></span></span>\n                                <input type="text" name="dni"\n                                       ng-change="rnc.validDNI(rnc.selectedDocVal,\n                                    rnc.sselectedDocType.description.description,resForm.dni)"\n                                       ng-blur="rnc.validDNI(rnc.selectedDocVal,\n                                    rnc.selectedDocType.description,resForm.dni)"\n                                       ng-disabled="rnc.readonly" class="form-control with-primary-addon"\n                                       placeholder="{{\'RESERVE.IDENTIFICATION\'|translate}}"\n                                       ng-model="rnc.selectedDocVal"\n                                       uib-typeahead="o as o.identity.docVal for o in rnc.getGuestsById($viewValue) "\n                                       typeahead-loading="loadingGuest"\n                                       typeahead-no-results="noGuestId" class="form-control"\n                                       typeahead-wait-ms="700" typeahead-min-length=\'5\'\n                                       typeahead-on-select="rnc.setGuest($item)">\n                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                <div ng-show="noGuestId">\n                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                </div>\n                                <span style="width: 51px"\n                                      class="input-group-addon input-group-addon-primary addon-right"\n                                      ng-click="rnc.changeTypeIde(rnc.selectedDocType);\n                                    rnc.validDNI(rnc.selectedDocVal,\n                                    rnc.selectedDocType.description,resForm.dni)"\n                                      ng-style="(rnc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                    {{rnc.selectedDocType.description}}</span>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="!resForm.dni.$valid">\n                                {{\'ERROR.GENERROR0\' |translate}}\n                                {{\'RESERVE.IDENTIFICATION\'|translate}}\n                                {{\'ERROR.GENERROR1\' |translate}}\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="input-group">\n                                    <span uib-tooltip="{{\'RESERVE.EMAIL\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-at"></span></span>\n                                <input type="text" ng-disabled="rnc.readonly" name="email"\n                                       ng-change="rnc.validEmail(rnc.selectedEmail,resForm.email)"\n                                       ng-blur="rnc.validEmail(rnc.selectedEmail,resForm.email)"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'RESERVE.EMAIL\'|translate}}"\n                                       ng-model="rnc.selectedEmail">\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="!resForm.email.$valid">\n                                {{\'ERROR.NOTVALIDEMAIL\' |translate}}\n                            </div>\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'RESERVE.PHONE\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left">\n                                    <span class="ion-ios-telephone"></span></span>\n                                <input type="text" name="mobile"\n                                       ng-change="rnc.validateMobile(rnc.selectedPhone,\n                                    resForm.mobile)"\n                                       ng-blur="rnc.validateMobile(rnc.selectedPhone,\n                                    resForm.mobile)"\n                                       ng-disabled="rnc.readonly" class="form-control with-primary-addon"\n                                       placeholder="{{\'RESERVE.PHONE\'|translate}}"\n                                       ng-model="rnc.selectedPhone">\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="!resForm.mobile.$valid">\n                                {{\'ERROR.GENERROR0\' |translate}}\n                                {{\'RESERVE.PHONE\'|translate}}\n                                {{\'ERROR.GENERROR1\' |translate}}\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-class="(rnc.level > 2) ? \'col-md-8\' : \'col-md-8\'" ng-if="rnc.isResident">\n                        <div class="input-group"\n                             ng-style="(resForm.appUser.$touched && resForm.appUser.$invalid ||\n                            resForm.appUser.$error.required && adetc.showError) ?\n                            {\'margin-bottom\': 0}:\'\'">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'RESERVE.RESIDENT\' | translate}}"\n                                  tooltip-placement="bottom-left">\n                                <span class="ion-android-person"></span>\n                            </span>\n                            <ui-select ng-model="rnc.appUser"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       append-to-body="true"\n                                       ng-required="rnc.isResident"\n                                       ng-disabled="rnc.readonly"\n                                       name="appUser"\n                                       ng-change="rnc.parseUserListBy();"\n                                       ng-class="{invalid: resForm.appUser.$touched && resForm.appUser.$invalid || resForm.appUser.$error.required && rnc.showError}"\n                                       search-enabled="true">\n                                <ui-select-match\n                                    allow-clear=true\n                                    placeholder="{{\'RESERVE.RESIDENT\'| translate}}">\n                                    {{rnc.appUser.fullName}}\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in rnc.appUsers |\n                                findAppUserGroupe:{find:$select.search,alredy:rnc.activity.appUsers,\n                                alredyFloor:rnc.alredyFloor}">\n                                    <div ng-style="(option.allFloor) ? {\'margin-left\': \'0\',\'font-weight\' : \'900\'}:\n                                    {\'margin-left\': \'17px\'}"\n                                         ng-bind-html="option.nameRoom | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <span ng-show="resForm.appUser.$touched && resForm.appUser.$invalid ||\n                            resForm.appUser.$error.required && adetc.showError" class="msgError">\n                            {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                    <div class="row">\n                        <div class="col-xs-12" style="margin-top:13px;">\n                            <p ng-if="rnc.submitted && !rnc.readonly && !rnc.$valid"\n                               class="pull-right errorValidation bounceIn animate">\n                                {{\'ERROR.ERRORININPUT\' |translate}}</p>\n                        </div>\n                    </div>\n                    <div class="panel-footer-buttons">\n                        <div class="row">\n                            <div class="pull-right">\n                                <button class="btn btn-success btn-with-icon"\n                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        ng-if="rnc.readonly" tagaste-click="rnc.cancel()">\n                                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                                </button>\n                                <button class="btn btn-success btn-with-icon"\n                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        tagaste-click="rnc.cancel()" ng-if="!rnc.readonly">\n                                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                                </button>\n                                <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        tagaste-click="rnc.save(resForm)"\n                                        ng-if="!rnc.readonly"\n                                        ng-disabled="rnc.submitted &&  !resForm.$valid "\n                                        class="btn btn-success btn-with-icon">\n                                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/annoucements/announcementDetail/announcementDetail.html','<!-- TOUR ACCESSAPP TEMPLATE -->\n<script type="text/ng-template" id="tourAccessappTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep" ng-if="tourStep.isPrev()"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<!-- END TOUR ACCESSAPP TEMPLATE -->\n<div class="row" id="acessappRightPanel">\n    <div class="col-md-12 col-lg-12 rightPanel">\n        <div ba-panel ba-panel-title="ANNCEDETAILWINDOW.HEADER"\n             ba-panel-class="with-scroll" ba-panel-anim="zoom-in"\n             style="line-height:30px;">\n            <div class="resumeTourContainer" style="left: 210px!important;">\n                <span class="ion-ios-information-outline" tagaste-click="adetc.resumeTour()" style="cursor: pointer;"\n                      ng-hide="!adetc.showGrantAccesView"></span>\n            </div>\n            <form name="announcementForm">\n                <div ng-if="!adetc.showGrantAccesView">\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="input-group" id="announcementDetailPlaces">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'ANNCEDETAILWINDOW.PLACE\' | translate}}"\n                                          tooltip-placement="bottom-left">\n                                        <span class="ion-card"/>\n                               </span>\n                                <ui-select multiple ng-model="adetc.announcement.branches"\n                                           ng-change="adetc.availableUsers();"\n                                           ng-disabled="adetc.modeReadOnly" ng-required="true"\n                                           ng-class="{invalid: announcementForm.locality.$touched && announcementForm.locality.$invalid || announcementForm.locality.$error.required && adetc.showError}"\n                                           sortable="true" close-on-select="false" name="locality">\n                                    <ui-select-match allow-clear=true\n                                                     placeholder="{{\'ANNCEDETAILWINDOW.PLACE\'|translate}}">\n                                        {{$item.description}}\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                        repeat="option._id as option in adetc.localities |\n                                        uiSelectFilter: {description:$select.search}">\n                                        <div ng-bind-html="option.description | highlight: $select.search"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-2">\n                            <ba-switcher switcher-style="primary" switcher-value="adetc.announcement.isGlobal"\n                                         switcher-read-only="adetc.modeReadOnly" on-change="adetc.checkGlobal(value)"\n                                         uib-tooltip="{{\'ANNCEDETAILWINDOW.GLOBALANNOUNCEMNT\' | translate}}"\n                                         tooltip-placement="bottom-left" icon-size="\'25px\'"\n                                         switcher-icon-on="\'ion-earth\'" switcher-icon-off="\'ion-ios-people\'"\n                                         id="announcementDetailGlobal">\n                            </ba-switcher>\n                        </div>\n                        <div class="col-md-4" ng-if="adetc.modeReadOnly">\n                            <date-picker-comp tooltip-text="\'ANNCEDETAILWINDOW.CREATIONDATE\' | translate"\n                                              tooltip-placement="bottom-left"\n                                              date-value="adetc.date"\n                                              mode-read-only="adet.istour"\n                                              date-options="adet.dateOptions"\n                                              form-reference="announcementForm"\n                                              name-field="\'creationDate\'"></date-picker-comp>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="input-group" id="announcementDetailResidents">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'ANNCEDETAILWINDOW.RECEIVERS\' | translate}}"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-android-person"></span>\n                                    </span>\n                                <ui-select multiple ng-model="adetc.announcement.appUsers"\n                                           ng-change="adetc.parseUserListBy();"\n                                           ng-disabled="adetc.modeReadOnly || adetc.announcement.isGlobal"\n                                           ng-required="!adetc.announcement.isGlobal"\n                                           ng-class="{invalid: announcementForm.appUser.$touched && announcementForm.appUser.$invalid || announcementForm.appUser.$error.required && adetc.showError}"\n                                           sortable="true" close-on-select="false" name="appUser">\n                                    <ui-select-match\n                                        allow-clear=true\n                                        placeholder="{{\'ANNCEDETAILWINDOW.RECEIVERS\'|translate}}">\n                                        {{$item.nameRoom}}\n                                    </ui-select-match>\n                                    <ui-select-choices repeat="option in adetc.appUsers |\n                                    findAppUserGroupe:{find:$select.search,alredy:adetc.announcement.appUsers,\n                                    alredyFloor:adetc.alredyFloor}">\n                                        <div ng-style="(option.allFloor) ? {\'margin-left\': \'0\',\'font-weight\' : \'900\'}:\n                                        {\'margin-left\': \'17px\'}"\n                                             ng-bind-html="option.nameRoom | highlight: $select.search"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-2">\n                            <ba-switcher switcher-style="primary" switcher-value="adetc.announcement.isEmail"\n                                         switcher-read-only="adetc.modeReadOnly" on-change="adetc.checkType(value)"\n                                         uib-tooltip="{{adetc.announcement.isEmail ? (\'ANNCEDETAILWINDOW.MAIL\' | translate) : (\'ANNCEDETAILWINDOW.MESSAGE\' | translate)}}"\n                                         tooltip-placement="bottom" icon-size="\'25px\'"\n                                         switcher-icon-on="\'ion-android-mail\'" switcher-icon-off="\'ion-android-chat\'"\n                                         id="announcementDetailType">\n                            </ba-switcher>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group" id="announcementDetailTitle">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'ANNCEDETAILWINDOW.TITLE\' | translate}}"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-compose"></span>\n                                    </span>\n                                <input type="text" ng-readonly="adetc.modeReadOnly" name="title"\n                                       ng-required="true"\n                                       class="form-control with-primary-addon" title=" "\n                                       placeholder="{{\'ANNCEDETAILWINDOW.TITLE\'|translate}}"\n                                       ng-class="{invalid: announcementForm.title.$touched &&\n                                       announcementForm.title.$invalid || announcementForm.title.$error.required &&\n                                       adetc.showError}" aria-describedby="basic-addon1"\n                                       ng-model="adetc.announcement.title">\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="row" ng-if="adetc.announcement.isEmail">\n                        <div class="col-sm-12">\n                            <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'ANNCEDETAILWINDOW.SENDER\' | translate}}"\n                                      tooltip-placement="bottom-left">\n                                    <span class="ion-at"/>\n                                </span>\n                                <ui-select ng-model="adetc.announcement.sender"\n                                           class="btn-group bootstrap-select form-control"\n                                           on-select="adetc.selectSource()"\n                                           ng-disabled="adetc.modeReadOnly" ng-required="true"\n                                           ng-class="{invalid: announcementForm.sender.$touched && announcementForm.sender.$invalid || announcementForm.sender.$error.required && adetc.showError}"\n                                           sortable="true" close-on-select="true" name="sender">\n\n                                    <ui-select-match placeholder="{{\'ANNCEDETAILWINDOW.SENDER\'|translate}}">\n                                        <span>{{adetc.announcement.sender.description}}</span>\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                        repeat="option in adetc.localities |\n                                        uiSelectFilter: {description:$select.search}">\n                                        <div ng-bind-html="option.description | highlight: $select.search"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="row" ng-if="adetc.announcement.isEmail">\n                        <div class="col-md-12">\n                            <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'MASTERTABLES.CONFIG.TEMPLATE\' | translate}}"\n                                      tooltip-placement="bottom-left">\n                                        <span class="ion-ios-list-outline"/>\n                                </span>\n                                <ui-select ng-model="adetc.announcement.template"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       required\n                                       ng-disabled="adetc.modeReadOnly"\n                                       ng-class="{\'select-invalid\': adetc.submitted && !adetc.announcement.template}"\n                                       on-select="adetc.loadTemplate()"\n                                       append-to-body="false">\n                                    <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.TEMPLATE\'| translate}}">\n                                        <span> {{adetc.announcement.template.description}}</span>\n                                    </ui-select-match>\n                                    <ui-select-choices repeat="option in adetc.templates | uiSelectFilter: {description:$select.search}">\n                                        <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="row" style="margin-top: 10px" ng-if="adetc.announcement.isEmail">\n                        <div class="col-md-12">\n                             <text-angular  ta-disabled="adetc.modeReadOnly" ta-toolbar="adetc.toolbarOptions"\n                                            ng-model="adetc.announcement.html"></text-angular>\n                        </div>\n                    </div>\n\n                    <div class="row" ng-if="!adetc.announcement.isEmail">\n                        <div class="col-md-12">\n                            <div class="input-group" id="announcementDetailBody">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'ACTIVITYDETAIL.DESCRIPTION\' | translate}}"\n                                  tooltip-placement="top-left" style="vertical-align: top;">\n                                <span class="ion-compose"/>\n                            </span>\n                                <textarea type="text" ng-readonly="adetc.modeReadOnly" name="description" required\n                                          class="form-control with-primary-addon"\n                                          placeholder="{{\'ACTIVITYDETAIL.DESCRIPTION\'|translate}}"\n                                          aria-describedby="basic-addon1"\n                                          ng-model="adetc.announcement.text"\n                                          ng-class="{invalid: announcementForm.description.$touched &&\n                                          announcementForm.description.$invalid ||\n                                          announcementForm.description.$error.required && adetc.showError}">\n                                </textarea>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row" ng-if="!adetc.announcement.isEmail">\n                        <div class="col-md-12">\n                            <ba-switcher switcher-style="primary" switcher-value="adetc.announcement.fcm.isPush"\n                                         uib-tooltip="{{\'ANNCEDETAILWINDOW.NOTIFICATION\' | translate}}"\n                                         tooltip-placement="bottom-left" icon-size="\'25px\'"\n                                         switcher-read-only="adetc.modeReadOnly"\n                                         switcher-icon-on="\'ion-iphone\'" switcher-icon-off="\'ion-iphone\'"\n                                         id="announcementDetailPush">\n                            </ba-switcher>\n                        </div>\n                    </div>\n                </div>\n                <div ng-if="adetc.showGrantAccesView" id="announcementForm">\n                    <div class="row">\n                        <div class="col-sm-9">\n                            <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'GRANTACCESS.PLACE\' | translate}}"\n                                          tooltip-placement="bottom-left">\n                                        <span class="ion-card"></span></span>\n                                    <ui-select ng-model="adetc.grantAccess.branch"\n                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control"\n                                               append-to-body="true"\n                                               ng-disabled="adetc.modeReadOnly"\n                                               name="branch"\n                                               search-enabled="true">\n                                    <ui-select-match placeholder="{{\'GRANTACCESS.PLACE\'| translate}}">\n                                        <span> {{adetc.grantAccess.branch.description}}</span>\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                        repeat="option in adet.appUsers | uiSelectFilter: {fullName:$select.search}">\n                                        <span ng-bind-html="option.fullName | highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                        <div class="col-sm-3">\n                            <date-picker-comp tooltip-text="\'GRANTACCESS.REQUESTDATE\' | translate"\n                                              tooltip-placement="bottom-left"\n                                              date-value="adetc.createdDate"\n                                              mode-read-only="adet.istour"\n                                              date-options="adet.dateOptions"\n                                              form-reference="announcementForm"\n                                              name-field="\'createdDate\'"></date-picker-comp>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'GRANTACCESS.NAME\' | translate}}"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-compose"></span>\n                                    </span>\n                                <input type="text" ng-readonly="true" name="title"\n                                       ng-required="true"\n                                       class="form-control with-primary-addon" title=" "\n                                       placeholder="{{\'GRANTACCESS.NAME\'|translate}}"\n                                       aria-describedby="basic-addon1"\n                                       ng-model="adetc.grantAccess.name">\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-sm-12">\n                            <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'GRANTACCESS.RECEIVERS\' | translate}}"\n                                          tooltip-placement="bottom-left">\n                                        <span class="ion-card"></span>\n                                    </span>\n                                <ui-select ng-model="adetc.grantAccess.appUser"\n                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                           class="btn-group bootstrap-select form-control"\n                                           append-to-body="true"\n                                           ng-required="true"\n                                           ng-disabled="adetc.grantAccess.done"\n                                           name="appUser"\n                                           ng-class="{noValid: announcementForm.appUser.$touched && announcementForm.appUser.$invalid || announcementForm.appUser.$error.required && adetc.showError}"\n                                           search-enabled="true">\n                                    <ui-select-match placeholder="{{\'GRANTACCESS.RECEIVERS\'| translate}}">\n                                        <span> {{adetc.grantAccess.appUser.fullName}}</span>\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                        repeat="option in adetc.appUsers | uiSelectFilter: {fullName:$select.search}">\n                                        <span ng-bind-html="option.fullName | highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n\n                        </div>\n                    </div>\n                </div>\n                <div class="pull-right">\n                    <button style="margin-top:30px;margin-bottom:7px;" type="button" id="announcementDetailCancel"\n                            tagaste-click="adetc.cancel()" class="btn btn-success btn-with-icon">\n                        <i class="ion-arrow-left-c"></i>{{adetc.modeReadOnly ?\'BUTTONS.BACK\':\'BUTTONS.CANCEL\'\n                        |translate}}\n                    </button>\n                    <button style="margin-top:30px;margin-bottom:7px;" type="button" id="announcementDetailSave"\n                            ng-if="!adetc.modeReadOnly || adetc.showGrantAccesView"\n                            tagaste-click="adetc.save(announcementForm)" class="btn btn-success btn-with-icon">\n                        <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                    </button>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/annoucements/announcementsList/announcementsList.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="ANNCELISTWINDOW.HEADER" ba-panel-class="with-scroll" id="announcementsList">\n            <div class="resumeTourContainer" style="left: 230px!important;">\n                <span class="ion-ios-information-outline"\n                      tagaste-click="alistc.initTour()"\n                      ng-hide="alistc.showAnnouncementView"\n                      style="cursor: pointer;"></span>\n            </div>\n            <div class="horizontal-scroll" ng-class="(!alistc.showAnnouncementView && !alistc.showGrantAccesView &&\n            !alistc.showActivityView &&  !alistc.servic._id && !alistc.menuId && !alistc.showIncidentView) ?\n            \'\': \'hideTableCounts\'">\n                <table ng-table="alistc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true">\n\n                    <colgroup\n                        ng-if="!alistc.showAnnouncementView && !alistc.showGrantAccesView &&\n                        !alistc.showActivityView &&  !alistc.servic._id && !alistc.menuId &&\n                        !alistc.showIncidentView ">\n                        <col width="5%">\n                        <col width="20%">\n                        <col width="40%">\n                        <col width="15%">\n                        <col width="5%">\n                        <col width="4%">\n                        <col width="4%">\n                        <col width="4%">\n                    </colgroup>\n\n                    <colgroup\n                        ng-if="alistc.showAnnouncementView || alistc.showActivityView || alistc.servic ||\n                        alistc.menuId || alistc.showIncidentView ">\n                        <col width="100%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data |\n                        dummyDataIfEmpty:alistc.tourDummyData | showErrorNoData track by $index"\n                        tagaste-click="alistc.tableParamsCK(row)"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td colspan="5" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td class="text-center"\n                            sortable="\'done\'"\n                            header-class="\'bellCol\'"\n                            ng-if="!alistc.showAnnouncementView && !row.error && !alistc.showGrantAccesView &&\n                            !alistc.showActivityView  && !alistc.servic._id && !alistc.menuId &&\n                            !alistc.showIncidentView">\n                            <span class="ion-ios-bell iconNgTable redIcon" ng-if="!row.done"></span>\n                        </td>\n                        <td data-title="\'ANNCELISTWINDOW.PLACE\'|translate"\n                            sortable="\'localities\'"\n                            style="text-align:left"\n                            filter="alistc.filterPlace"\n                            ng-if="!alistc.showAnnouncementView && !alistc.showGrantAccesView &&\n                            !alistc.showActivityView && !alistc.servic._id && !alistc.menuId &&\n                            !alistc.showIncidentView && alistc.userBranch.length > 1"\n                            ng-attr-title="{{row.localities}}">\n                            {{row.localities}}\n                        </td>\n                        <td data-title="\'ANNCELISTWINDOW.TITLE\'|translate"\n                            sortable="\'title\'" style="text-align: inherit"\n                            filter="alistc.filterTitle"\n                            ng-attr-title="{{row.title}}">\n                            {{row.title}}\n                        </td>\n                        <td data-title="\'ANNCELISTWINDOW.TYPE\'|translate"\n                            sortable="\'type\'"\n                            filter="alistc.filterType"\n                            ng-if="!alistc.showAnnouncementView && !alistc.showGrantAccesView &&\n                            !alistc.showActivityView &&  !alistc.servic._id && !alistc.menuId &&\n                            !alistc.showIncidentView "\n                            ng-attr-title="{{row.type}}">\n                            {{row.type}}\n                        </td>\n                        <td data-title="\'ANNCELISTWINDOW.CREATIONDATE\'|translate"\n                            sortable="\'date\'" style="text-align: inherit"\n                            ng-if="!alistc.showAnnouncementView && !alistc.showGrantAccesView &&\n                            !alistc.showActivityView &&  !alistc.servic._id && !alistc.menuId &&\n                            !alistc.showIncidentView "\n                            filter="alistc.filterDate"\n                            ng-attr-title="{{row.creationDate}}">\n                            {{row.creationDate}}\n                        </td>\n                        <td data-title="\'ANNCELISTWINDOW.RELATED\'|translate"\n                            sortable="\'redirect.isRelated\'"\n                            class=" text-center"\n                            ng-if="!alistc.showAnnouncementView && !row.error && !alistc.showGrantAccesView &&\n                            !alistc.showActivityView  && !alistc.servic._id && !alistc.menuId &&\n                            !alistc.showIncidentView ">\n                            <span class="fa fa-share-square-o iconNgTable edit" ng-if="row.redirect.isRelated"\n                                  uib-tooltip="{{\'ANNCELISTWINDOW.DETAIL\' | translate }}"\n                                  style="margin-left: 10px;"\n                                  ng-click="alistc.showLinked(row); $event.stopPropagation();"></span>\n\n                        </td>\n                        <td data-title="\'ANNCELISTWINDOW.NOTIFIED\'|translate"\n                            sortable="\'fcm.isPush\'"\n\n                            class=" text-center"\n                            ng-if="!alistc.showAnnouncementView && !row.error && !alistc.showGrantAccesView &&\n                            !alistc.showActivityView  && !alistc.servic._id && !alistc.menuId &&\n                            !alistc.showIncidentView">\n                            <span class="fa fa-mobile iconNgTable" style="font-size: 24px;"\n                                  ng-style="(row.fcm.isPush) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"\n                                  title="{{(row.fcm.isPush) ?\n                                  (\'ANNCELISTWINDOW.NOTIFIED\'|translate) : (\'ANNCELISTWINDOW.NOTNOTIFIED\'|translate)}}">\n                            </span>\n                        </td>\n                        <td data-title="\'ANNCELISTWINDOW.SENDED\'|translate"\n                            sortable="\'addressesCount\'"\n                            style="text-align: right;"\n                            filter="alistc.filterSended"\n                            ng-if="!alistc.showAnnouncementView && !alistc.showGrantAccesView &&\n                            !alistc.showActivityView  && !alistc.servic._id && !alistc.menuId &&\n                            !alistc.showIncidentView"\n                            ng-attr-title="{{row.addressesCount}}">\n                            {{row.addressesCount}}\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row"\n                 ng-if="!alistc.showAnnouncementView && !alistc.showGrantAccesView && !alistc.showActivityView &&\n                 !alistc.servic._id && !alistc.menuId && !alistc.showIncidentView">\n                <div class="col-xs-12 countAndNewButton">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ alistc.tableParams.total() }}</span>\n                    </span>\n                    <button type="button" id="newAnnouncementButton"\n                            ng-if="alistc.gotAccessMod"\n                            tagaste-click="alistc.newAnnouncemnt()" class="btn btn-success btn-with-icon newButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/activities/reserveList/reserveList.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel">\n        <div ba-panel ba-panel-title="ACTIVITYDETAIL.RESERVE"\n             ba-panel-class="with-scroll" ba-panel-anim="zoom-in"\n             style="line-height: 30px;">\n\n            <div class="row">\n                <div class="col-xs-12" ng-if="rlc.showNotificationButton === true">\n                    <button type="button"\n                            ng-if="rlc.accessPush"\n                            ng-click="rlc.notify()"\n                            class="btn btn-success btn-with-icon pull-right">\n                        <i class="ion-iphone"></i>{{\'BUTTONS.NOTIFY\' |translate}}\n                    </button>\n                </div>\n            </div>\n            <div class="horizontal-scroll">\n                <table ng-table="rlc.tableParams" id="tableParams" ng-show="rlc.residentNumber"\n                       class="table table-hover table-condensed fixNgTable table-scroll"\n                       show-filter="true"  ng-class="{msgPointer: rlc.residentPermission}">\n                    <tr ng-repeat="row in $data |showErrorNoData"\n                        ng-click="rlc.tableParamsCK(row)"\n                        ng-class="(row.selected === true)?\'selectRow\':\'\'"\n                        class="ng-binding">\n\n                        <td colspan="0" ng-if="row.error"\n                            class="text-left"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'ACTIVITYDETAIL.RESIDENTS\'|translate"\n                            sortable="\'fullName\'" style="text-align: inherit"\n                            ng-if="!row.error"\n                            filter="rlc.filterFullName"\n                            ng-attr-title="{{row.fullName}}">\n                            {{row.fullName}}\n                        </td>\n\n                    </tr>\n                </table>\n            </div>\n            <div class="horizontal-scroll" >\n                <table ng-table="rlc.tableParamsGuest" id="tableParamsGuest" ng-show="rlc.guestNumber"\n                       class="table table-hover table-condensed fixNgTable table-scroll"\n                       show-filter="true" style="cursor: pointer">\n                    <tr ng-repeat="row in $data |showErrorNoData"\n                        class="ng-binding">\n\n                        <td colspan="0" ng-if="row.error"\n                            class="text-left"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'ACTIVITYDETAIL.GUESTS\'|translate"\n                            sortable="\'fullName\'" style="text-align: inherit"\n                            ng-if="!row.error"\n                            filter="rlc.filterFullName"\n                            ng-attr-title="{{row.fullName}}">\n                            {{row.fullName}}\n                        </td>\n\n                    </tr>\n                </table>\n            </div>\n            <div class="row">\n                <div class="col-xs-12" style="display: flex; align-items: center;">\n                    <span style="flex-grow: 1" id="totalItems">{{ \'TOTAL\' |translate }} : {{ rlc.totalBook }}</span>\n                    <button style="margin-top:30px;margin-bottom:7px;" type="button"\n                            ng-click="rlc.cancel()" class="btn btn-success btn-with-icon">\n                        <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n\n');
$templateCache.put('app/components/billing/billingDetail/billingDetail.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel resident-detail detail-panel">\n        <div ba-panel ba-panel-title="BILLING.DETAIL.HEADER" ba-panel-class="with-scroll"\n             ba-panel-anim="zoom-in" style="line-height:30px;" id="reservationDetail">\n\n            <form name="resForm" autocomplete="false">\n                <!--CLIENT SELECTION-->\n                <div class="row">\n                    <!--select kind of user: resident, guest, other-->\n                    <div class="col-xs-4">\n                        <div ng-repeat="clientType in bidc.clientTypes track by $index" class="checkboxWrapper">\n                            <div class="checkbox" ng-click="!bidc.lockChangeClientType ? bidc.changeClientType(clientType, resForm) : \'\'">\n                                <label class="custom-checkbox">\n                                    <input type="radio" id="{{clientType.value}}"\n                                           name="{{clientType.name}}"\n                                           ng-disabled="bidc.readonly || bidc.lockChangeClientType"\n                                           ng-checked="clientType.check">\n                                    <span>{{clientType.name}}</span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <!--select resident or guest if necessary (client)-->\n                    <div class="col-xs-8">\n                        <div class="input-group" ng-disabled="false" style="position: relative; top: 9px;" ng-if="!bidc.newGuestMode">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'BILLING.DETAIL.CLIENT\' | translate}}"\n                                  tooltip-placement="right">\n                                <span class="ion-android-person"></span>\n                            </span>\n                            <ui-select ng-model="bidc.billingBD.client"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       append-to-body="true"\n                                       ng-disabled="bidc.billingBD._id"\n                                       name="client"\n                                       ng-change="bidc.changeClient()"\n                                       search-enabled="true">\n                                <ui-select-match\n                                    allow-clear=true\n                                    placeholder="{{\'BILLING.DETAIL.CLIENT\'| translate}}">\n                                    {{bidc.billingBD.client.fullName}}\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in bidc.availableClients | filter: {roomAndName: $select.search}">\n                                    <div ng-style="(option.allFloor) ? {\'margin-left\': \'0\',\'font-weight\' : \'900\'}:{\'margin-left\': \'17px\'}"\n                                         ng-bind-html="option.roomAndName | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </div>\n                <div class="row"\n                     ng-if="!bidc.billingBD._id && bidc.clientTypeSelected.value ===\'guest\' && !bidc.billingBD.client._id && !bidc.newGuestMode">\n                    <div class="col-md-12">\n                        <div class="pull-right">\n                            <button class="billingDetailCancel btn btn-success btn-with-icon"\n                                    type="button"\n                                    id="billingNewGuestButton" style="margin-bottom: 10px" tagaste-click="bidc.newGuest()">\n                                <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                            </button>\n                        </div>\n                    </div>\n                </div>\n                <!--CLIENT INFO-->\n                <div class="row" ng-if="bidc.billingBD.client._id || bidc.newGuestMode">\n                    <!--name-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.NAME\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  id="clientNameTooltip">\n                            <span class="ion-android-person"></span></span>\n                            <input type="text" name="name"\n                                   ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                   class="form-control with-primary-addon"\n                                   ng-class="{\'invalid\': (resForm.name.$touched || bidc.submitted )&& !bidc.readonly && !resForm.name.$valid }"\n                                   placeholder="{{\'BILLING.DETAIL.NAME\'|translate}}"\n                                   ng-model="bidc.billingBD.client.name" required>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(resForm.name.$touched || bidc.submitted) && !bidc.readonly && !resForm.name.$valid">\n                            {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                        </div>\n                    </div>\n                    <!--surname-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.SURNAME\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  id="clientSurnameTooltip">\n                            <span class="ion-android-person"></span></span>\n                            <input type="text" name="surname"\n                                   ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                   class="form-control with-primary-addon"\n                                   ng-class="{\'invalid\': (resForm.surname.$touched || bidc.submitted )&& !bidc.readonly && !resForm.surname.$valid }"\n                                   placeholder="{{\'BILLING.DETAIL.SURNAME\'|translate}}"\n                                   ng-model="bidc.billingBD.client.surname" required>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(resForm.surname.$touched || bidc.submitted) && !bidc.readonly && !resForm.surname.$valid">\n                            {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                        </div>\n                    </div>\n                    <!--email-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.EMAIL\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-at"></span></span>\n                            <input type="text" ng-disabled="bidc.readonly || bidc.readonlyUserInfo" name="email"\n                                   ng-change="bidc.validEmail(bidc.billingBD.client.email,resForm.email)"\n                                   ng-blur="bidc.validEmail(bidc.billingBD.client.email,resForm.email)"\n                                   ng-class="{\'invalid\': (resForm.email.$touched || bidc.submitted )&& !bidc.readonly && !resForm.email.$valid }"\n                                   autocomplete="email" class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.EMAIL\'|translate}}"\n                                   ng-model="bidc.billingBD.client.email" required>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(resForm.email.$touched || bidc.submitted ) && !resForm.email.$valid">\n                            {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                        </div>\n                    </div>\n                    <!--phone-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.PHONE\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-ios-telephone"></span></span>\n                            <input type="text" name="phone" ng-change="bidc.validatePhone(bidc.billingBD.client.phone,\n                                           resForm.phone)" ng-blur="bidc.validatePhone(bidc.billingBD.client.phone,\n                                           resForm.phone)" ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.PHONE\'|translate}}"\n                                   ng-model="bidc.billingBD.client.phone">\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(resForm.phone.$touched || bidc.submitted) && !resForm.phone.$valid">\n                            {{\'ERROR.GENERROR0\' | translate}}\n                            {{\'BILLING.DETAIL.PHONE\' | translate}}\n                            {{\'ERROR.GENERROR1\' | translate}}\n                        </div>\n                    </div>\n                    <!--address-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.ADDRESS\' | translate}}"\n                                  tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-ios-location"></span></span>\n                            <input type="text" ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.ADDRESS\'|translate}}"\n                                   ng-model="bidc.billingBD.client.address">\n                        </div>\n                    </div>\n                    <!--city-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.CITY\' | translate}}"\n                                  tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-ios-location"></span></span>\n                            <input type="text" ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.CITY\'|translate}}"\n                                   ng-model="bidc.billingBD.client.city">\n                        </div>\n                    </div>\n                    <!--postcode-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.POSTCODE\' | translate}}"\n                                  tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-pound"></span></span>\n                            <input type="text" ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.POSTCODE\'|translate}}"\n                                   ng-model="bidc.billingBD.client.postcode">\n                        </div>\n                    </div>\n                    <!--country-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'BILLING.DETAIL.COUNTRY\'|translate}}"\n                                  tooltip-placement="top-left">\n                                <span class="ion ion-flag"></span>\n                            </span>\n                            <ui-select ng-model="bidc.selectedCountry"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                       ng-change="bidc.selectCountryChange(\'selectedCountry\');"\n                                       append-to-body="true" search-enabled="true">\n                                <ui-select-match\n                                    placeholder="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}">\n                                            <span ng-if="(bidc.selectedCountry.name &&\n                                                bidc.selectedCountry.name !== \'\')">\n                                                {{bidc.selectedCountry.name}}</span>\n                                    <span ng-if="!(bidc.selectedCountry.name &&\n                                                bidc.selectedCountry.name !== \'\')" style="color: #b2b1b1;">\n                                                {{\'SELECTCOUNTRY.SELECTCOUNTRY\' | translate}}</span>\n                                </ui-select-match>\n                                <ui-select-choices repeat="country in bidc.getCountries($select.search, \'selectedCountry\') |\n                                                    uiSelectFilter: {name:$select.search}">\n                                    <span ng-bind-html="country.name| highlight: $select.search"></span>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                  ng-click="bidc.clearCountry(\'selectedCountry\')"\n                                  ng-style="{cursor: bidc.readonly ? \'default\' : \'pointer\'}" ng-if="!bidc.readonly"></span>\n                        </div>\n                    </div>\n                    <!--state-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'BILLING.DETAIL.STATE\'|translate}}"\n                                  tooltip-placement="top-left">\n                                <span class="ion ion-ios-location"></span>\n                            </span>\n                            <ui-select ng-model="bidc.selectedState"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       ng-disabled="bidc.readonly || !bidc.billingBD.client.country || bidc.readonlyUserInfo"\n                                       ng-change="bidc.selectStateChange();" append-to-body="true" search-enabled="true">\n                                <ui-select-match placeholder="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}">\n                                    <span ng-if="(bidc.selectedState && bidc.selectedState !== \'\')">\n                                        {{bidc.selectedState}} </span>\n                                    <span ng-if="!(bidc.selectedState && bidc.selectedState !== \'\')" style="color: #b2b1b1;">\n                                        {{\'SELECTCOUNTRY.SELECTSTATE\' | translate}}\n                                    </span>\n                                </ui-select-match>\n                                <ui-select-choices repeat="state in bidc.getStates($select.search, \'selectedCountry\') |\n                                                    uiSelectFilter: $select.search">\n                                    <span ng-bind-html="state| highlight: $select.search"></span>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                  ng-click="bidc.clearState(\'selectedState\')" ng-if="!bidc.readonly"\n                                  ng-style="{cursor: bidc.readonly || !bidc.billingBD.client.country ?\n                                   \'default\' : \'pointer\'}"></span>\n                        </div>\n                    </div>\n                    <!--identity-->\n                    <div class="col-xs-4">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.IDENTITY\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left ">\n                                <span class="ion-card"></span>\n                            </span>\n                            <input type="text" name="identity"\n                                   ng-change="bidc.validDNI(bidc.billingBD.client.identity.docVal,\n                                                             bidc.billingBD.client.identity.docType.description,\n                                                             resForm.identity)"\n                                   ng-blur="bidc.validDNI(bidc.billingBD.client.identity.docVal,\n                                                             bidc.billingBD.client.identity.docType.description,\n                                                             resForm.identity)"\n                                   ng-focus="bidc.setDocType(\'identity\');"\n                                   ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.IDENTITY\'|translate}}"\n                                   ng-model="bidc.billingBD.client.identity.docVal"\n                                   required>\n                            <span style="width: 51px" id="clientIdentity"\n                                  class="input-group-addon input-group-addon-primary addon-right"\n                                  ng-click="bidc.changeTypeDoc(\'identity\');\n                                            bidc.validDNI(bidc.billingBD.client.identity.docVal,\n                                            bidc.billingBD.client.identity.docType.description,\n                                            resForm.identity)"\n                                  ng-style="bidc.readonly ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                                                {{bidc.billingBD.client.identity.docType.description}}\n                                </span>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(resForm.identity.$touched || bidc.submitted) && !resForm.identity.$valid">\n                            {{\'ERROR.GENERROR0\' | translate}}\n                            {{\'BILLING.DETAIL.IDENTITY\' | translate}}\n                            {{\'ERROR.GENERROR1\' | translate}}\n                        </div>\n                    </div>\n\n                    <div class="col-xs-8">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.RESIDENCE\' | translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  tooltip-placement="right">\n                                <span class="ion-card"></span>\n                            </span>\n                            <ui-select multiple ng-model="bidc.billingBD.client.branches" name="branches"\n                                       ng-disabled="bidc.readonly || bidc.readonlyUserInfo"\n                                       ng-class="{\'invalid\': (bidc.submitted) && (!bidc.billingBD.client.branches || bidc.billingBD.client.branches.length < 1)}"\n                                       append-to-body="true" search-enabled="true">\n                                <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}">\n                                    {{$item.description}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                    repeat="branches in bidc.constants.branch|\n                                        findResidence:{find:$select.search,alredy:bidc.billingBD.client.branches}">\n                                    <div ng-bind-html="branches.description | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(bidc.submitted) && (!bidc.billingBD.client.branches || bidc.billingBD.client.branches.length < 1)">\n                            <!-- ng-if="(bidc.submitted) && (bidc.billingBD.client.branches.length < 1)"> -->\n                            *{{\'ERROR.NOTVALIDRESIDENCE\' | translate}}\n                        </div>\n                    </div>\n\n                    <div class="col-md-12" ng-if="bidc.newGuestMode">\n                        <div class="pull-right">\n                            <button style="margin-bottom:7px;" type="button" id="guestSave"\n                                    ng-disabled="bidc.savingNewGuest"\n                                    tagaste-click="bidc.saveNewGuest(resForm)" class="btn btn-success btn-with-icon">\n                                <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                            </button>\n                        </div>\n                    </div>\n                </div>\n\n                <div ng-if="bidc.billingBD.client._id">\n                    <!--BILLING ADDRESS FLAG-->\n                    <div class="row" ng-if="!bidc.readonly">\n                        <div class="col-xs-12">\n                            <div class="checkbox" ng-click="bidc.changeBillingAddress()">\n                                <label class="custom-checkbox">\n                                    <input type="checkbox"\n                                           id="billingAddress"\n                                           name="billingAddress"\n                                           ng-disabled="bidc.readonly"\n                                           ng-model="bidc.billingBD.billingAddress.ownClient">\n                                    <span>{{\'BILLING.DETAIL.SAME_BILLING_ADDRESS\' | translate}}</span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                    <!--BILLING ADDRESS INFO-->\n                    <div class="accordionSubTitle" ng-if="bidc.readonly && !bidc.billingBD.billingAddress.ownClient">\n                        <div class="accordionSubTitleText" style="font-weight: 500; padding: 4px;">\n                            {{\'BILLING.DETAIL.BILL_DATA\' | translate}}\n                        </div>\n                        <div class="accordionSubTitleBorder"></div>\n                    </div>\n                    <div class="row infoBlockWrapper" ng-if="!bidc.billingBD.billingAddress.ownClient">\n                        <!--billingAddress name-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.NAME\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left"\n                                      id="clientNameAddressTooltip">\n                                <span class="ion-android-person"></span></span>\n                                <input type="text" name="billingAddressName"\n                                       ng-disabled="bidc.readonly"\n                                       class="form-control with-primary-addon"\n                                       ng-class="{\'invalid\': (resForm.billingAddressName.$touched || bidc.submitted ) &&\n                                        !bidc.readonly && !resForm.billingAddressName.$valid }"\n                                       placeholder="{{\'BILLING.DETAIL.NAME\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.name" required>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="(resForm.billingAddressName.$touched || bidc.submitted) && !bidc.readonly && !resForm.billingAddressName.$valid">\n                                {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                            </div>\n                        </div>\n                        <!--billingAddress surname-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.SURNAME\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left"\n                                      id="clientSurnameAddressTooltip">\n                                <span class="ion-android-person"></span></span>\n                                <input type="text" name="billingAddressSurname"\n                                       ng-disabled="bidc.readonly"\n                                       class="form-control with-primary-addon"\n                                       ng-class="{\'invalid\': (resForm.billingAddressSurname.$touched || bidc.submitted ) &&\n                                        !bidc.readonly && !resForm.billingAddressSurname.$valid }"\n                                       placeholder="{{\'BILLING.DETAIL.SURNAME\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.surname" required>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="(resForm.billingAddressSurname.$touched || bidc.submitted) && !bidc.readonly && !resForm.billingAddressSurname.$valid">\n                                {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                            </div>\n                        </div>\n                        <!--billingAddress email-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.EMAIL\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-at"></span></span>\n                                <input type="text" ng-disabled="bidc.readonly" name="billingAddressEmail"\n                                       ng-change="bidc.validEmail(bidc.billingBD.billingAddress.email,resForm.billingAddressEmail)"\n                                       ng-blur="bidc.validEmail(bidc.billingBD.billingAddress.email,resForm.billingAddressEmail)"\n                                       autocomplete="billingAddressEmail" class="form-control with-primary-addon"\n                                       placeholder="{{\'BILLING.DETAIL.EMAIL\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.email" required>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="(resForm.billingAddressEmail.$touched|| bidc.submitted ) && !resForm.billingAddressEmail.$valid">\n                                {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                            </div>\n                        </div>\n                        <!--billingAddress phone-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.PHONE\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-ios-telephone"></span></span>\n                                <input type="text" name="billingAddressPhone" ng-change="bidc.validatePhone(bidc.billingBD.billingAddress.phone,\n                                            resForm.billingAddressPhone)" ng-blur="bidc.validatePhone(bidc.billingBD.billingAddress.phone,\n                                            resForm.billingAddressPhone)" ng-disabled="bidc.readonly"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'BILLING.DETAIL.PHONE\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.phone">\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="(resForm.billingAddressPhone.$touched || bidc.submitted) && !resForm.billingAddressPhone.$valid">\n                                {{\'ERROR.GENERROR0\' | translate}}\n                                {{\'BILLING.DETAIL.PHONE\' | translate}}\n                                {{\'ERROR.GENERROR1\' | translate}}\n                            </div>\n                        </div>\n                        <!--billingAddress address-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.ADDRESS\' | translate}}"\n                                      tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-ios-location"></span></span>\n                                <input type="text" ng-disabled="bidc.readonly"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'BILLING.DETAIL.ADDRESS\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.address">\n                            </div>\n                        </div>\n                        <!--billingAddress city-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.CITY\' | translate}}"\n                                      tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-ios-location"></span></span>\n                                <input type="text" ng-disabled="bidc.readonly"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'BILLING.DETAIL.CITY\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.city">\n                            </div>\n                        </div>\n                        <!--billingAddress postcode-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.POSTCODE\' | translate}}"\n                                      tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-pound"></span></span>\n                                <input type="text" ng-disabled="bidc.readonly"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'BILLING.DETAIL.POSTCODE\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.postcode">\n                            </div>\n                        </div>\n                        <!--billingAddress country-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'BILLING.DETAIL.COUNTRY\'|translate}}"\n                                      tooltip-placement="top-left">\n                                    <span class="ion ion-flag"></span>\n                                </span>\n                                <ui-select ng-model="bidc.selectedCountryAddress"\n                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                           class="btn-group bootstrap-select form-control"\n                                           ng-disabled="bidc.readonly"\n                                           ng-change="bidc.selectCountryChange(\'selectedCountryAddress\');"\n                                           append-to-body="true" search-enabled="true">\n                                    <ui-select-match\n                                        placeholder="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}">\n                                                <span ng-if="(bidc.selectedCountryAddress.name &&\n                                                    bidc.selectedCountryAddress.name !== \'\')">\n                                                    {{bidc.selectedCountryAddress.name}}</span>\n                                        <span ng-if="!(bidc.selectedCountryAddress.name &&\n                                                    bidc.selectedCountryAddress.name !== \'\')" style="color: #b2b1b1;">\n                                                    {{\'SELECTCOUNTRY.SELECTCOUNTRY\' | translate}}</span>\n                                    </ui-select-match>\n                                    <ui-select-choices repeat="country in bidc.getCountries($select.search, \'selectedCountry\') |\n                                                        uiSelectFilter: {name:$select.search}">\n                                        <span ng-bind-html="country.name| highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                                <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                      ng-click="bidc.clearCountry(\'selectedCountryAddress\')" ng-if="!bidc.readonly"\n                                      ng-style="{cursor: bidc.readonly ? \'default\' : \'pointer\'}"></span>\n                            </div>\n                        </div>\n                        <!--billingAddress state-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'BILLING.DETAIL.STATE\'|translate}}"\n                                      tooltip-placement="top-left">\n                                    <span class="ion ion-ios-location"></span>\n                                </span>\n                                <ui-select ng-model="bidc.selectedStateAddress"\n                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                           class="btn-group bootstrap-select form-control"\n                                           ng-disabled="bidc.readonly || !bidc.billingBD.billingAddress.country "\n                                           ng-change="bidc.selectStateChange(\'selectedStateAddress\');" append-to-body="true"\n                                           search-enabled="true">\n                                    <ui-select-match placeholder="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}">\n                                        <span ng-if="(bidc.selectedStateAddress && bidc.selectedStateAddress !== \'\')">\n                                            {{bidc.selectedStateAddress}} </span>\n                                        <span ng-if="!(bidc.selectedStateAddress && bidc.selectedStateAddress !== \'\')"\n                                              style="color: #b2b1b1;">\n                                            {{\'SELECTCOUNTRY.SELECTSTATE\' | translate}}\n                                        </span>\n                                    </ui-select-match>\n                                    <ui-select-choices repeat="state in bidc.getStates($select.search, \'selectedCountryAddress\') |\n                                                        uiSelectFilter: $select.search">\n                                        <span ng-bind-html="state| highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                                <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                      ng-click="bidc.clearState(\'selectedStateAddress\')" ng-if="!bidc.readonly"\n                                      ng-style="{cursor: bidc.readonly || !bidc.billingBD.billingAddress.country ?\n                                    \'default\' : \'pointer\'}"></span>\n                            </div>\n                        </div>\n                        <!--identity-->\n                        <div class="col-xs-4">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BILLING.DETAIL.IDENTITY\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left ">\n                                    <span class="ion-card"></span>\n                                </span>\n                                <input type="text" name="identityAddress"\n                                       ng-change="bidc.validDNI(bidc.billingBD.billingAddress.identity.docVal,\n                                                                bidc.billingBD.billingAddress.identity.docType.description,\n                                                                resForm.identityAddress)"\n                                       ng-blur="bidc.validDNI(bidc.billingBD.billingAddress.identity.docVal,\n                                                                bidc.billingBD.billingAddress.identity.docType.description,\n                                                                resForm.identityAddress)"\n                                       ng-focus="bidc.setDocType(\'identityAddress\');"\n                                       ng-disabled="bidc.readonly"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'BILLING.DETAIL.IDENTITY\'|translate}}"\n                                       ng-model="bidc.billingBD.billingAddress.identity.docVal"\n                                       required>\n                                <span style="width: 51px" id="clientIdentityAddress"\n                                      class="input-group-addon input-group-addon-primary addon-right"\n                                      ng-click="bidc.changeTypeDoc(\'identityAddress\');\n                                                        bidc.validDNI(bidc.billingBD.billingAddress.identity.docVal,\n                                                        bidc.billingBD.billingAddress.identity.docType.description,\n                                                        resForm.identityAddress)"\n                                      ng-style="bidc.readonly ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                                                    {{bidc.billingBD.billingAddress.identity.docType.description}}\n                                    </span>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="(resForm.identityAddress.$touched || bidc.submitted) && !resForm.identityAddress.$valid">\n                                {{\'ERROR.GENERROR0\' | translate}}\n                                {{\'BILLING.DETAIL.IDENTITY\' | translate}}\n                                {{\'ERROR.GENERROR1\' | translate}}\n                            </div>\n                        </div>\n                    </div>\n                    <!--COMMENTS-->\n                    <div class="row">\n                        <div class="col-xs-12">\n                            <textarea type="text" ng-readonly="bidc.readonly" name="comments"\n                                      class="form-control with-primary-addon"\n                                      style="margin-bottom: 20px;"\n                                      placeholder="{{\'BILLING.DETAIL.COMMENTS\'|translate}}"\n                                      aria-describedby="basic-addon1"\n                                      ng-model="bidc.billingBD.comments"\n                                      ng-class="{invalid: resForm.comments.$touched && resForm.comments.$invalid}">\n                            </textarea>\n                        </div>\n                    </div>\n                    <!--CONCEPTS && PAY INFO-->\n                    <payment resident="bidc.billingBD.client" readonly="bidc.readonly"\n                             selected-bill="bidc.billingBD" on-save="bidc.getBillingDetail()"\n                             user-kind="bidc.clientTypeSelected"\n                             ng-if="bidc.paymentReady"\n                             pay-button="true"\n                             menu-option="\'billings\'"></payment>\n\n                </div>\n                <!--BUTTONS-->\n                <div class="panel-footer-buttons">\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="pull-right">\n                                <button class="billingDetailCancel btn btn-success btn-with-icon"\n                                        style="margin-top:17px;margin-bottom:7px;" type="button"\n                                        name="cancelButton"\n                                        id="billingCancelButton" tagaste-click="bidc.back()">\n                                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' | translate}}\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/billing/billingList/billingList.html','<style>\n    .switchType .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after,\n    .switchType2 .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after,\n    .switchType3 .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.ALL\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.INVOICE2\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.TICKET2\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType2 .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.YES\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType2 .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.NO\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType3 .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'BILLING.DETAIL.RESIDENT\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType3 .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'BILLING.DETAIL.OTHER2\'|translate}}";\n        bottom: 3px;\n    }\n</style>\n<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="BILLING.LIST.HEADER" ba-panel-class="with-scroll" id="billingList">\n            <div class="filterAccordion" style="left: 280px!important;" ng-hide="bilsc.selectr._id !== undefined">\n                <uib-accordion>\n                    <uib-accordion-group panel-class="panel-primary accordion-panel " is-open="status.open">\n                        <uib-accordion-heading>{{\'RESIDENTSWINDOW.FILTERS\' | translate}}\n                            <i class="pull-right glyphicon"\n                               ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i>\n                        </uib-accordion-heading>\n                        <div class="row">\n                            <div class="col-xs-12 switchType">\n                                <nz-toggle tri-toggle val-null="\'all\'" ng-model="bilsc.billingPhase"\n                                           on-toggle="bilsc.applyAdditionalFilters()" width="150"\n                                           style="width: 25px; height: 15px;" color-false="\'#8AF37E\'" color-true="\'#8AF37E\'"\n                                           title="{{\'BILLING.LIST.PHASE\'|translate}}"></nz-toggle>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12 switchType2">\n                                <nz-toggle tri-toggle val-null="\'all\'" ng-model="bilsc.billingPaid"\n                                           on-toggle="bilsc.applyAdditionalFilters()"\n                                           width="150" style="width: 25px; height: 15px;" color-false="\'#e85656\'"\n                                           color-true="\'#8AF37E\'" title="{{\'BILLING.LIST.PAID\'|translate}}"></nz-toggle>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12 switchType3">\n                                <nz-toggle tri-toggle val-null="\'all\'" ng-model="bilsc.billingClient"\n                                           on-toggle="bilsc.applyAdditionalFilters()"\n                                           width="150" style="width: 25px; height: 15px;" color-false="\'#8AF37E\'"\n                                           color-true="\'#8AF37E\'" title="{{\'BILLING.LIST.CLIENT_TYPE\'|translate}}"></nz-toggle>\n                            </div>\n                        </div>\n                    </uib-accordion-group>\n                </uib-accordion>\n            </div>\n            <div class="resumeTourContainer" style="left: 480px!important;">\n                <span class="ion-ios-information-outline" tagaste-click="bilsc.initTour()" style="cursor: pointer;"\n                      ng-hide="bilsc.selectr._id !== undefined"></span>\n            </div>\n            <div class="horizontal-scroll" ng-class="(bilsc.selectr._id) ? \'hideTableCounts\': \'\'" ng-if="bilsc.tableParams">\n                <table ng-table="bilsc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true">\n                    <colgroup>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                    </colgroup>\n                    <tr ng-repeat="row in $data | dummyDataIfEmpty:bilsc.tourDummyData | showErrorNoData track by $index"\n                        style="cursor: pointer;"\n                        tagaste-click="bilsc.rowClick(row);$event.stopPropagation();"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td colspan="7" ng-if="row.error" ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <!-- date -->\n                        <td data-title="\'BILLING.LIST.DATE_BILLING\'|translate"\n                            sortable="\'date\'"\n                            ng-attr-title="{{row.formattedDate}}"\n                            filter="bilsc.filterDate">\n                            {{row.formattedDate}}\n                        </td>\n                        <!-- proformaNumber -->\n                        <td data-title="\'BILLING.LIST.RECEIPT\'|translate"\n                            sortable="\'proformaNumber\'"\n                            ng-attr-title="{{row.proformaNumber}}"\n                            filter="bilsc.filterReceipt">\n                            {{row.proformaNumber}}\n                        </td>\n                        <!-- invoiceNumber -->\n                        <td data-title="\'BILLING.LIST.CODE\'|translate"\n                            sortable="\'invoiceNumber\'"\n                            ng-attr-title="{{row.invoiceNumber}}"\n                            filter="bilsc.filterCode">\n                            {{row.invoiceNumber}}\n                        </td>\n                        <!-- groupCode -->\n                        <td data-title="\'BILLING.LIST.GROUP_CODE\'|translate"\n                            sortable="\'groupCode\'"\n                            ng-attr-title="{{row.groupCode}}"\n                            filter="bilsc.filterGroupCode">\n                            {{row.groupCode}}\n                        </td>\n                        <!-- client type -->\n                        <td data-title="\'BILLING.LIST.CLIENT_TYPE\'|translate"\n                            sortable="\'clientType\'"\n                            ng-attr-title="{{row.clientType}}"\n                            filter="bilsc.filterClientType">\n                            {{row.clientType}}\n                        </td>\n                        <!-- client name -->\n                        <td data-title="\'BILLING.LIST.NAME\'|translate"\n                            sortable="\'clientName\'"\n                            ng-attr-title="{{row.clientName}}"\n                            filter="bilsc.filterName">\n                            {{row.clientName}}\n                        </td>\n                        <!-- client surname -->\n                        <td data-title="\'BILLING.LIST.SURNAME\'|translate"\n                            sortable="\'clientSurname\'"\n                            ng-attr-title="{{row.clientSurname}}"\n                            filter="bilsc.filterSurname">\n                            {{row.clientSurname}}\n                        </td>\n                        <!-- branch-->\n                        <td data-title="\'BILLING.LIST.BRANCH\'|translate"\n                            sortable="\'branch\'"\n                            ng-attr-title="{{row.branch}}"\n                            filter="bilsc.filterBranch">\n                            {{row.branch}}\n                        </td>\n                        <!-- concepts -->\n                        <td data-title="\'BILLING.LIST.CONCEPTS\'|translate"\n                            sortable="\'conceptsDescription\'"\n                            ng-attr-title="{{row.conceptsDescription}}"\n                            filter="bilsc.filterConceptsDescription">\n                            {{row.conceptsDescription}}\n                        </td>\n                        <!-- payType -->\n                        <td data-title="\'BILLING.LIST.PAY_TYPE\'|translate"\n                            sortable="\'payType\'"\n                            ng-attr-title="{{row.payType}}"\n                            filter="bilsc.filterPayType">\n                            {{row.payType}}\n                        </td>\n                        <!-- payDate -->\n                        <td data-title="\'BILLING.LIST.PAY_DATE\'|translate"\n                            sortable="\'payDate\'"\n                            ng-attr-title="{{row.formattedPayDate}}"\n                            filter="bilsc.filterPayDate">\n                            {{row.formattedPayDate}}\n                        </td>\n                        <!-- Total -->\n                        <td data-title="\'BILLING.LIST.AMOUNT\'|translate"\n                            sortable="\'amount\'"\n                            ng-attr-title="Total">\n                            {{row.amount}}\n                        </td>\n                        <!-- buttons -->\n                        <td ng-if="!bilsc.selectr._id && !row.error" class="text-center" style="white-space: nowrap;">\n                            <i class="fa fa-pencil iconNgTable edit" style="padding: 0 10px;"\n                               uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                               ng-if="bilsc.gotAccessMod && !row.payDate"\n                               aria-hidden="true"\n                               tagaste-click="bilsc.editRow(row); $event.stopPropagation();">\n                            </i>\n                            <i class="fa fa-trash-o iconNgTable edit"\n                               uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                               ng-if="bilsc.gotAccessDel && !row.invoiceNumber"\n                               aria-hidden="true"\n                               tagaste-click="bilsc.deleteRow(row); $event.stopPropagation();">\n                            </i>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!bilsc.selectr._id">\n                <div class="col-xs-12 countAndNewButton">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' | translate }} : {{ bilsc.tableParams.total() }}</span></span>\n                    <button type="button"\n                            tagaste-click="bilsc.new();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="newBillingButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                    </button>\n                    <button type="button"\n                            tagaste-click="bilsc.exportData();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                    <button type="button" ng-disabled="!bilsc.selectedBranch || bilsc.selectedBranch.all"\n                            tagaste-click="bilsc.billingForecast();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="billingForecastButton">\n                        <i class="ion-social-euro"></i>{{\'BUTTONS.BILLING_FORECAST\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bedrooms/bedroomDetail/bedroomDetail.html','<div class="row bedroom-detail">\n    <div class="col-md-12 col-lg-12 rightPanel">\n        <div ba-panel ba-panel-title="BEDROOMS_DETAIL.TITLE" ba-panel-class="with-scroll" ba-panel-anim="zoom-in"  id="bedroomDetail">\n\n            <div class="row">\n                <div class="col-md-2 col-sm-12">\n                    <div class="bedroom-label">H.{{brdc.bedroom.spot.code}}</div>\n                </div>\n                <div class="col-md-8 col-sm-12">\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group" id="statesRooms">\n                                <span class="input-group-addon input-group-addon-primary addon-left" id="bedroomDetailTooltip"\n                                      uib-tooltip="{{\'BEDROOMS_DETAIL.ROOM_STATUS\' | translate}}"\n                                      tooltip-placement="bottom-left">\n                                    <span class="fa fa-flag"></span>\n                                </span>\n                                <ui-select ng-model="brdc.selectedRoomState"\n                                           name="states"\n                                           class="btn-group"\n                                           append-to-body="true"\n                                           search-enabled="true"\n                                           multiple\n                                           ng-disabled="true"\n                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; width: 100%">\n                                    <ui-select-match allow-clear=true placeholder="{{\'BEDROOMS_DETAIL.ROOM_STATUS\'|translate}}">\n                                        <span>{{$item.description}}</span>\n                                    </ui-select-match>\n                                    <ui-select-choices repeat=" option in brdc.statesRooms | uiSelectFilter: {code:$select.search}">\n                                        <div ng-bind-html="option.description | highlight: $select.search"></div>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group" ng-if="brdc.resident">\n                                <span uib-tooltip="{{\'BEDROOMS_DETAIL.RESIDENT\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left"\n                                      id="residentDetailTooltip">\n                                                <span class="ion-android-person"></span></span>\n                                <input type="text" name="name" disabled\n                                       class="form-control with-primary-addon "\n                                       placeholder="{{\'BEDROOMS_DETAIL.RESIDENT\'|translate}}"\n                                       ng-model="brdc.resident.fullName" required>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'BEDROOMS_DETAIL.COMMENTS\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left"\n                                      id="commentsDetailTooltip">\n                                        <span class="ion-quote"></span></span>\n                                <textarea type="text" name="comments" required\n                                          class="form-control with-primary-addon"\n                                          placeholder="{{\'BEDROOMS_DETAIL.COMMENTS\'|translate}}"\n                                          aria-describedby="basic-addon1"\n                                          ng-model="brdc.selectedBedroom.spot.comments">\n                                  </textarea>\n                            </div>\n                        </div>\n                    </div>\n\n                </div>\n                <div class="col-md-2 col-sm-12">\n                    <!-- <div class="user-photo" ng-if="brdc.type === \'isOccupied\'"> -->\n                    <div class="user-photo" ng-if="brdc.resident">\n                        <avatar type="person" shape="square" avatar-style="width: 150px; height: 150px"\n                                readonly="true" img="brdc.avatar"\n                                photo="brdc.resident.photo"></avatar>\n                    </div>\n                </div>\n            </div>\n            <!-- Inventory and roomType -->\n            <div class="row">\n                <div class="col-md-6 col-sm-12">\n                    <uib-accordion>\n                        <uib-accordion-group panel-class="panel-primary accordion-panel"\n                                             is-open="brdc.accordions.inventory">\n                            <uib-accordion-heading>\n                                {{\'BEDROOMS_DETAIL.INVENTORY\' | translate}}\n                                <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': brdc.accordions.inventory,\n                                        \'glyphicon-chevron-right\': !brdc.accordions.inventory}"></i>\n                            </uib-accordion-heading>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <table ng-table="brdc.inventoryTableParams"\n                                           class="table table-hover table-condensed fixNgTable" show-filter="false"\n                                           style="font-size: 11px;">\n\n                                        <colgroup>\n                                            <col>\n                                            <col width="20px">\n                                            <col width="20px">\n                                        </colgroup>\n\n                                        <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                                            class="ng-binding">\n                                            <td colspan="3" ng-if="row.error" ng-src="{{row.error}}">\n                                                {{row.error}}\n                                            </td>\n\n                                            <!-- Item (editMode)-->\n                                            <td data-title="\'BEDROOMS_DETAIL.ITEM\'|translate"\n                                                sortable="\'description\'"\n                                                ng-attr-title="{{row.description}}"\n                                                ng-if="row.modeEdit">\n                                                <select class="form-control"\n                                                        name="InventoryItem_{{$index +1}}"\n                                                        id="InventoryItem_{{$index +1}}" ng-model="row.selected"\n                                                        ng-options="selected.description for selected in brdc.inventoryTagsAvailable track by selected.code"\n                                                        required>\n                                                </select>\n                                            </td>\n\n                                            <!-- Item (readMode)-->\n                                            <td data-title="\'BEDROOMS_DETAIL.ITEM\'|translate"\n                                                sortable="\'description\'"\n                                                ng-attr-title="{{row.description}}"\n                                                ng-if="!row.modeEdit">\n                                                {{row.description}}\n                                            </td>\n\n                                            <!-- Edit button -->\n                                            <!-- <td ng-if="!brdc.readonly && !row.modeEdit">\n                                                <i class="fa fa-pencil iconNgTable edit"\n                                                    uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                                    ng-if="!row.modeEdit && !brdc.addingInventoryItem && !row.error" aria-hidden="true"\n                                                    tagaste-click="brdc.editInventoryItem(row); $event.stopPropagation();">\n                                                </i>\n                                            </td> -->\n\n                                            <!-- Delete button -->\n                                            <td ng-if="!brdc.readonly && !row.modeEdit">\n                                                <i class="fa fa-trash-o iconNgTable edit"\n                                                   uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                   ng-if="!row.modeEdit && !brdc.addingInventoryItem && !row.error" aria-hidden="true"\n                                                   tagaste-click="brdc.deleteInventoryItem(row, $index); $event.stopPropagation();">\n                                                </i>\n                                            </td>\n\n                                            <!-- Save button -->\n                                            <td ng-if="!brdc.readonly && row.modeEdit">\n                                                <i class="glyphicon glyphicon-ok iconNgTable edit" id="saveInventoryButton"\n                                                   uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                                                   ng-if="row.modeEdit" aria-hidden="true"\n                                                   tagaste-click="brdc.saveInventoryItem(row, $index); $event.stopPropagation();">\n                                                </i>\n                                            </td>\n\n                                            <!-- Cancel button -->\n                                            <td ng-if="!brdc.readonly && row.modeEdit">\n                                                <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                                                   uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                                                   ng-if="row.modeEdit" aria-hidden="true"\n                                                   tagaste-click="brdc.cancelInventoryItem(row, $index); $event.stopPropagation();">\n                                                </i>\n                                            </td>\n                                        </tr>\n                                    </table>\n                                    <div class="row">\n                                        <div class="col-xs-12 ">\n                                            <button type="button"\n                                                    ng-if="!brdc.readonly"\n                                                    tagaste-click="brdc.addInventoryItem();$event.stopPropagation();"\n                                                    class="btn btn-success btn-with-icon pull-right newButton" id="addInventoryItemButton">\n                                                <i class="fa fa-plus"></i>{{\'BUTTONS.ADD\' | translate}}\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n                <div class="col-md-6 col-sm-12">\n                    <uib-accordion>\n                        <uib-accordion-group panel-class="panel-primary accordion-panel"\n                                             is-open="brdc.accordions.roomtype">\n                            <uib-accordion-heading>\n                                {{\'BEDROOMS_DETAIL.ROOM_TYPE\' | translate}}\n                                <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': brdc.accordions.roomtype,\n                                        \'glyphicon-chevron-right\': !brdc.accordions.roomtype}"></i>\n                            </uib-accordion-heading>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <div class="input-group" id="roomRates">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip="{{\'BEDROOMS_DETAIL.ROOM_TYPE\' | translate}}"\n                                              tooltip-placement="bottom-left">\n                                            <span class="fa fa-flag"></span>\n                                        </span>\n                                        <ui-select ng-model="brdc.selectedRoomType"\n                                                   class="btn-group"\n                                                   append-to-body="true"\n                                                   search-enabled="true"\n                                                   ng-class="{\'select-invalid\': !brdc.selectedRoomType}"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; width: 100%"\n                                                   ng-change="brdc.getRoomRates()">\n                                            <ui-select-match allow-clear=true placeholder="{{\'BEDROOMS_DETAIL.ROOM_TYPE\'|translate}}">\n                                                <span>{{brdc.selectedRoomType.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices\n                                                repeat=" option in brdc.roomTypes | uiSelectFilter: {description:$select.search}">\n                                                <div ng-bind-html="option.description | highlight: $select.search"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <table ng-table="brdc.roomRatesTableParams"  id="roomRatesTable"\n                                           class="table table-hover table-condensed fixNgTable" show-filter="false"\n                                           style="font-size: 11px;">\n\n                                        <colgroup>\n                                            <col>\n                                            <col>\n                                        </colgroup>\n\n                                        <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                                            class="ng-binding">\n                                            <td colspan="3" ng-if="row.error" ng-src="{{row.error}}">\n                                                {{row.error}}\n                                            </td>\n\n                                            <!-- description -->\n                                            <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                                                sortable="\'description\'"\n                                                ng-attr-title="{{row.description}}">\n                                                {{row.description}}\n                                            </td>\n                                            <!-- price -->\n                                            <td data-title="\'MASTERTABLES.CONFIG.PRICE\'|translate"\n                                                sortable="\'price\'"\n                                                ng-attr-title="{{row.price}}">\n                                                {{row.price}} <span ng-if="row.price">\u20AC</span>\n                                            </td>\n                                        </tr>\n                                    </table>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n\n            <!-- Incidents and workertasks-->\n            <div class="row" ng-if="brdc.isDetail">\n                <div class="col-md-6 col-sm-12">\n                    <uib-accordion>\n                        <uib-accordion-group panel-class="panel-primary accordion-panel" id="workertask"\n                                             is-open="brdc.accordions.workertask">\n                            <uib-accordion-heading >\n                                {{\'BEDROOMS_DETAIL.ACTIVE_TASKS\' | translate}}\n                                <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': brdc.accordions.workertask,\n                                        \'glyphicon-chevron-right\': !brdc.accordions.workertask}"></i>\n                            </uib-accordion-heading>\n                            <div ng-if="brdc.workerTask.length === 0">\n                                {{\'BEDROOMS_DETAIL.NOWORKERTASK\' | translate}}\n                            </div>\n                            <div ng-if="brdc.workerTask.length > 0" class="room-worker-tasks">\n                                <div ng-repeat="row in brdc.workerTask">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip=""\n                                              tooltip-placement="top-left">\n                                            <span class="ion-alert-circled"></span>\n                                        </span>\n                                        <input type="text" ng-readonly="true"\n                                               class="form-control with-primary-addon" required\n                                               aria-describedby="basic-addon1"\n                                               ng-model="row.text">\n                                    </div>\n                                </div>\n                            </div>\n                            <div style="text-align: right;" ng-if="!brdc.setToClean">\n                                <button type="button" ng-click="brdc.setToClean = !brdc.setToClean" class="btn btn-success" id="buttonSetToClean">\n                                    {{\'BEDROOMS_DETAIL.SETTOCLEAN\' | translate}}\n                                </button>\n                            </div>\n                            <div ng-if="brdc.setToClean && brdc.cleaningTasks.length > 0">\n                                <div class="accordionSubTitle">\n                                    <div class="accordionSubTitleText" style="font-weight: 500; padding: 4px;">\n                                        {{\'ROOMSCHEDULERDETAIL.CLEANTYPE\' | translate}}\n                                    </div>\n                                    <div class="accordionSubTitleBorder"></div>\n                                </div>\n                                <ui-select ng-model="brdc.selectedCleanTask"\n                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                           ng-change="brdc.changeCleanTask();"\n                                           class="btn-group bootstrap-select form-control clean-task-select"\n                                           name="selectedCleanTask">\n                                    <ui-select-match allow-clear="true">\n                                        <span> {{brdc.selectedCleanTask.description}}</span>\n                                    </ui-select-match>\n                                    <!-- <ui-select-choices repeat="option in brdc.cleaningTasks | uiSelectFilter: {description:$select.search}"> -->\n                                    <ui-select-choices repeat="option in brdc.cleaningTasks">\n                                        <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                                <div ng-if="brdc.showOtherCleanTak">\n                                    <div class="input-group" >\n                                        <span uib-tooltip="{{\'BEDROOMS_DETAIL.TEXT\'| translate}}"\n                                            class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-android-person"></span></span>\n                                        <input type="text" name="name"\n                                               class="form-control with-primary-addon "\n                                               placeholder="{{\'BEDROOMS_DETAIL.TEXT\'|translate}}"\n                                               ng-model="brdc.observations" required>\n                                    </div>\n                                    <div class="input-group" >\n                                        <span uib-tooltip="{{\'BEDROOMS_DETAIL.DURATION\'| translate}}"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-android-person"></span></span>\n                                        <input type="text" name="name"\n                                               class="form-control with-primary-addon duration-field"\n                                               placeholder="{{\'BEDROOMS_DETAIL.DURATION\'|translate}}"\n                                               valid-number\n                                               ng-model="brdc.duration" required>\n                                    </div>\n                                </div>\n                                <div class="clean-buttons">\n                                    <button type="button" ng-click="brdc.cancelClean()" class="btn btn-success">\n                                        {{\'BUTTONS.CANCEL\' | translate}}\n                                    </button>\n                                    <button type="button" ng-click="brdc.saveSetClean()" class="btn btn-success" id="buttonSaveTask">\n                                        {{\'BUTTONS.SAVE\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n                <div class="col-md-6 col-sm-12">\n                    <uib-accordion>\n                        <uib-accordion-group panel-class="panel-primary accordion-panel" id="incidentPanel"\n                                             is-open="brdc.accordions.incidents">\n                            <uib-accordion-heading>\n                                {{\'BEDROOMS_DETAIL.INCIDENTS\' | translate}}\n                                <i class="pull-right glyphicon"\n                                   ng-class="{\'glyphicon-chevron-down\': brdc.accordions.incidents, \'glyphicon-chevron-right\': !brdc.accordions.incidents}"></i>\n                            </uib-accordion-heading>\n                            <div ng-if="brdc.originalIncidents.length === 0">\n                                {{\'ROOMSCHEDULERDETAIL.NOINCIDENTS\' | translate }}\n                            </div>\n                            <div ng-if="brdc.originalIncidents.length > 0" class="room-incidents">\n                                <div class="row" style="margin-top: 10px">\n                                    <div class="col-md-4 date-size">\n                                        <div style="height: 32px; padding-right: 20px;" class="dp-not-show-clear">\n                                            <date-picker-comp\n                                                placeholder="\'BEDROOMS_DETAIL.DATE_FROM\' | translate"\n                                                tooltip-text="\'BEDROOMS_DETAIL.DATE_FROM\' | translate"\n                                                tooltip-placement="right"\n                                                date-value="brdc.dateFrom"\n                                                mode-read-only="false"\n                                                name-field="\'dateFrom\'"\n                                                custom-class="\'dp-not-show-clear\'">\n                                            </date-picker-comp>\n                                        </div>\n                                    </div>\n                                    <div class="col-md-4 date-size">\n                                        <div style="height: 32px; padding-right: 20px;" class="dp-not-show-clear">\n                                            <date-picker-comp\n                                                placeholder="\'BEDROOMS_DETAIL.DATE_TO\' | translate"\n                                                tooltip-text="\'BEDROOMS_DETAIL.DATE_TO\' | translate"\n                                                tooltip-placement="bottom"\n                                                date-value="brdc.dateTo"\n                                                mode-read-only="false"\n                                                name-field="\'dateFrom\'"\n                                                custom-class="\'dp-not-show-clear\'">\n                                            </date-picker-comp>\n                                        </div>\n                                    </div>\n                                    <div class="col-md-4 button-filter">\n                                        <button style="margin-right:17px;margin-bottom:7px;" type="button"\n                                                tagaste-click="brdc.filterIncidents()"\n                                                class="btn btn-success btn-with-icon">\n                                            <i class="glyphicon glyphicon-filter"></i>{{\'BUTTONS.FILTER\' | translate}}\n                                        </button>\n                                    </div>\n                                </div>\n                                <div ng-repeat="row in brdc.incidents" class="incident-description">\n                                    {{row.date | date}} - {{row.text}}\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n\n            <div class="panel-footer-buttons">\n                <div class="row">\n                    <div class="pull-right">\n                        <button class="residentDetailCancel btn btn-success btn-with-icon"\n                                style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button" id="roomButtonCancel"\n                                tagaste-click="brdc.back()">\n                            <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' | translate}}\n                        </button>\n                        <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                tagaste-click="brdc.saveSpot()"\n                                ng-disabled="!brdc.selectedRoomType" class="btn btn-success btn-with-icon" id="roomSaveButton">\n                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bedrooms/bedroomsList/bedroomsList.html','<script type="text/ng-template" id="tourRackRoomTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep"\n                                ng-if="tourStep.isPrev()"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n\n<div class="bedrooms-detail-component">\n    <div class="row">\n        <div class="col-md-12" style="transition: all 0.51s;">\n            <div ba-panel class="animated fadeInLeft" ba-panel-title="BEDROOMS.TITLE">\n                <div class="resumeTourContainer">\n                    <span class="ion-ios-information-outline" ng-click="blstc.initTour()" style="cursor: pointer;"\n                          ng-hide="blstc.showBedroomDetail || !blstc.selectedBar || blstc.selectedBar.all"></span>\n                </div>\n                <div class="row" ng-if="blstc.selectedBar && !blstc.selectedBar.all" style="margin-bottom: 20px"\n                     id="rackFilter">\n                    <div class="col-md-3" ng-if="!blstc.showBedroomDetail">\n                        <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      tooltip-placement="bottom-left"\n                                      uib-tooltip="{{\'BEDROOMS.TYPE\'| translate}}">\n                                    <span class="fa fa-bed" style="margin-left:-1px"></span></span>\n                            <ui-select ng-model="blstc.typeRoom"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; width: 100%"\n                                       class="btn-group" on-select="blstc.onChangeFilter()"\n                                       append-to-body="true" name="spot" search-enabled="true">\n                                <ui-select-match allow-clear=true placeholder="{{\'BEDROOMS.TYPE\'| translate}}">\n                                    <span> {{blstc.typeRoom.description}}</span>\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in blstc.roomTypes |\n                                                uiSelectFilter: {description:$select.search}">\n                                    <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class="input-group-addon input-group-addon-primary addon-right"\n                                  tooltip-placement="bottom-left" ng-click="blstc.cleanFilter(\'type\')"\n                                  uib-tooltip="{{\'BEDROOMS.CLEAN\'| translate}}">\n                                            <span class="fa fa-trash-o" style="margin-left:-1px"></span></span>\n                        </div>\n                    </div>\n                    <div class="col-md-3" ng-if="!blstc.showBedroomDetail">\n                        <div class="input-group" id="statesRooms">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'BEDROOMS.STATE\' | translate}}"\n                                  tooltip-placement="top-left">\n                                <span class="fa fa-flag"></span>\n                            </span>\n                            <ui-select multiple ng-model="blstc.states"\n                                       name="states" ng-change="blstc.onChangeFilter()"\n                                       sortable="true" close-on-select="false">\n                                <ui-select-match allow-clear=true\n                                                 placeholder="{{\'BEDROOMS.STATE\'|translate}}">\n                                    {{$item.description}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                    repeat="option.code as option in blstc.statesRooms |\n                                                    uiSelectFilter: {code:$select.search}">\n                                    <div\n                                        ng-bind-html="option.description | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class="input-group-addon input-group-addon-primary addon-right"\n                                  tooltip-placement="bottom-left" ng-click="blstc.cleanFilter(\'state\')"\n                                  uib-tooltip="{{\'BEDROOMS.CLEAN\'| translate}}">\n                                            <span class="fa fa-trash-o" style="margin-left:-1px"></span></span>\n                        </div>\n                    </div>\n                    <div class="col-md-3" ng-if="!blstc.showBedroomDetail">\n                        <div class="input-group" id="inventoryTags">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'BEDROOMS.INVENTORY\' | translate}}"\n                                  tooltip-placement="top-left">\n                                            <span class="fa fa-flag"></span>\n                                        </span>\n                            <ui-select multiple ng-model="blstc.inventoryTagsSelected"\n                                       name="states" ng-change="blstc.onChangeFilter()"\n                                       sortable="true" close-on-select="false">\n                                <ui-select-match allow-clear=true\n                                                 placeholder="{{\'BEDROOMS.INVENTORY\'|translate}}">\n                                    {{$item.description}}\n                                </ui-select-match>\n                                <ui-select-choices\n                                    repeat="option.description as option in blstc.inventoryTags |\n                                                    uiSelectFilter: {description:$select.search}">\n                                    <div\n                                        ng-bind-html="option.description | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                            <span class="input-group-addon input-group-addon-primary addon-right"\n                                  tooltip-placement="bottom-left" ng-click="blstc.cleanFilter(\'inventory\')"\n                                  uib-tooltip="{{\'BEDROOMS.CLEAN\'| translate}}">\n                                            <span class="fa fa-trash-o" style="margin-left:-1px"></span></span>\n                        </div>\n                    </div>\n                    <div ng-class="{\'col-md-6\' : blstc.showBedroomDetail, \'col-md-2\': !blstc.showBedroomDetail}">\n                        <div style="height: 32px; display: flex; gap: 5px; align-items: baseline" class="dp-not-show-clear">\n                            <date-picker-comp\n                                placeholder="\'BEDROOMS.DATE\' | translate"\n                                tooltip-text="\'BEDROOMS.DATE\' | translate"\n                                date-value="blstc.dateFrom"\n                                mode-read-only="false"\n                                name-field="\'dateFrom\'"\n                                special-validation="blstc.dayChanged()"\n                                custom-class="\'dp-not-show-clear\'">\n                            </date-picker-comp>\n                            <img src="../../../../assets/icon/alert.svg" alt="alert" width="28" height="28" ng-if="blstc.checkAlert()">\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Rooms tags -->\n                <div class="rooms" ng-if="blstc.selectedBar && !blstc.selectedBar.all">\n                    <div class="room-item" ng-repeat="room in blstc.bedrooms  track by $index"\n                         ng-class="{\'oddFloor\': room.floor % 2 === 0 || room[\'spot\'][\'floor\'] % 2 === 0, \'isFirst\': room.floor || room.floor === 0}">\n                        <div class="floor-number" ng-if="room.floor || room.floor === 0">{{room.floor}}</div>\n\n                        <div class="bedroom-item" ng-if="!room.floor && !(room.floor === 0)" ng-class="{\'firstRoom\': $index === 1}" ng-click="blstc.openDetail(room)">\n\n                            <div class="bedroom-tag-img" ng-if="!room.floor"  ng-class="{\'bedroom-dirty\': room[\'today\'][\'isToClean\'],\n                            \'bedroom-occupied\': room[\'today\'][\'isOccupied\'] && !room[\'today\'][\'isToClean\'], \'bedroom-empty\': !room[ \'today\'][\'isToClean\'] && room[\'today\'][\'isEmpty\']\n                            || room[ \'today\'][\'isReserved\'],\n                            \'bedroom-blocked\': room[\'today\'][\'isBlocked\']} || true" >\n                                <svg height="100%" version="1.1" viewBox="0 0 46.085 80.166" xmlns="http://www.w3.org/2000/svg" xmlns:osb="http://www.openswatchbook.org/uri/2009/osb">\n                                    <g transform="translate(-82.791 -108.08)">\n                                    <g transform="matrix(0 -.26458 .26458 0 82.791 188.25)" fill="#5b5b5b">\n                                    <path d="m296.4 71.17-64.57-64.57c-4.2198-4.2266-9.9475-6.6012-15.92-6.6h-193.39c-12.437 0-22.52 10.083-22.52 22.52v129.14c0 12.437 10.083 22.52 22.52 22.52h193.39c5.9704 5.1e-4 11.697-2.3699 15.92-6.59l64.57-64.59c8.7881-8.7902 8.7881-23.04 0-31.83zm-93.69 15.92c0-21.383 25.851-32.088 40.97-16.97 15.118 15.118 4.4135 40.97-16.97 40.97-13.255 0-24-10.745-24-24z" color="#000000" color-rendering="auto" dominant-baseline="auto" fill-rule="evenodd" image-rendering="auto" shape-rendering="auto" solid-color="#000000" stop-color="#000000" style="font-feature-settings:normal;font-variant-alternates:normal;font-variant-caps:normal;font-variant-east-asian:normal;font-variant-ligatures:normal;font-variant-numeric:normal;font-variant-position:normal;font-variation-settings:normal;inline-size:0;isolation:auto;mix-blend-mode:normal;shape-margin:0;shape-padding:0;text-decoration-color:#000000;text-decoration-line:none;text-decoration-style:solid;text-indent:0;text-orientation:mixed;text-transform:none;white-space:normal"/>\n                                    </g>\n                                    </g>\n                                    </g>\n                                </svg>\n                            </div>\n                            <div class="bedroom-number">\n                                <div class="bedroom-number-inner">\n                                    {{room[\'spot\'][\'code\']}}\n                                </div>\n                            </div>\n                            <div class="bedroom-icons">\n                                <div class="bedroom-icons-inner">\n                                    <i class="fa fa-wrench" ng-if="room[\'today\'][\'isMaintenance\']"></i>\n                                    <i class="fa fa-long-arrow-right" ng-if="room[\'today\'][\'isCheckIn\'] && !room[\'today\'][\'isCheckOut\']"></i>\n                                    <i class="fa fa-long-arrow-left" ng-if="room[\'today\'][\'isCheckOut\'] && !room[\'today\'][\'isCheckIn\']"></i>\n                                    <i class="fa fa-exchange" ng-if="room[\'today\'][\'isCheckIn\'] && room[\'today\'][\'isCheckOut\']"></i>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <!-- Tags legends -->\n                <div class="row" ng-if="blstc.selectedBar && !blstc.selectedBar.all" id="rackLegend">\n                    <div class="col-xs-12 legend-container">\n                        <div class="legend-tags">\n                            <i class="tagaste-tag-v-small bedroom-empty"></i>\n                            <span class="legend-text">{{\'BEDROOMS.FREE\'| translate}}</span>\n                            <i class="tagaste-tag-v-small bedroom-dirty"></i>\n                            <span class="legend-text">{{\'BEDROOMS.DIRTY\'| translate}}</span>\n                            <i class="tagaste-tag-v-small bedroom-occupied"></i>\n                            <span class="legend-text">{{\'BEDROOMS.OCCUPIED\'| translate}}</span>\n                            <i class="tagaste-tag-v-small bedroom-blocked"></i>\n                            <span class="legend-text">{{\'BEDROOMS.BLOCKED\'| translate}}</span>\n                        </div>\n                        <div class="legend-tags" ng-if="!blstc.showBedroomDetail">\n                            <i class="fa fa-wrench"></i>\n                            <span class="legend-text">{{\'BEDROOMS.MAINTENANCE_TASK\'| translate}}</span>\n                            <i class="fa fa-long-arrow-right"></i>\n                            <span class="legend-text">{{\'BEDROOMS.IN_OUT\'| translate}}</span>\n                        </div>\n                    </div>\n                </div>\n                <div class="row" ng-if="!blstc.selectedBar || blstc.selectedBar.all">\n                    <div class="col-xs-12">\n                        <span style="font-size: 15px">{{\'BEDROOMS.SELECT_BRANCH_MSG\'|translate}}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/bulletinBoard/bulletinBoardDetail/bulletinBoardDetail.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel">\n        <div ba-panel ba-panel-title="BULLETINBOARDDETAIL.HEADERDETAIL"\n             ba-panel-class="with-scroll" ba-panel-anim="zoom-in"\n             style="line-height:30px;" id="bboardDetail">\n            <div>\n                <form name="bulletinForm">\n                    <div class="row" style="padding-bottom: 15px">\n                        <div class="col-sm-4 col-md-3" style="text-align: center">\n                            <avatar type="picture" shape="rectangle" size="150" img="bbdc.avatar"\n                                    avatar-style="width:150px; margin: 0 auto;"\n                                    uploading="bbdc.avatarUploading"\n                                    photo="bbdc.bulletin.photo" readonly="( bbdc.modeReadOnly || bbdc.istour )"\n                                    id="bboardDetailImg"></avatar>\n                        </div>\n                        <div class="col-sm-8 col-md-9">\n                            <div class="row">\n                                <div class="col-xs-6">\n                                    <ba-switcher switcher-style="primary" switcher-value="bbdc.bulletin.highlight"\n                                                 switcher-read-only="bbdc.modeReadOnly"\n                                                 uib-tooltip="{{\'BULLETINBOARDDETAIL.HIGHLIGHT\' | translate}}"\n                                                 switcher-icon-on="\'ion-ios-star\'"\n                                                 tooltip-placement="bottom"\n                                                 switcher-icon-off="\'ion-ios-star-outline\'"\n                                                 style="padding-top: 22px;" id="bboardDetailHighlight">\n                                    </ba-switcher>\n                                </div>\n                                <div class="col-xs-6">\n                                    <div class="pull-right">\n                                        <ba-switcher switcher-style="primary" switcher-value="bbdc.bulletin.active"\n                                                     switcher-on="\'BULLETINBOARDDETAIL.ACTIVE\'|translate"\n                                                     switcher-off="\'BULLETINBOARDDETAIL.ACTIVE\'|translate"\n                                                     switcher-read-only="bbdc.modeReadOnly"\n                                                     uib-tooltip="{{\'BULLETINBOARDDETAIL.ACTIVE\' | translate}}"\n                                                     tooltip-placement="bottom"\n                                                     ng-if="bbdc.modeReadOnly || bbdc.modeEdit">\n                                        </ba-switcher>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <div class="input-group"\n                                         ng-style="(bulletinForm.locality.$touched && bulletinForm.locality.$invalid ||\n                                         bulletinForm.locality.$error.required && bbdc.showError) ?\n                                         {\'margin-bottom\': 0}:\'\'">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'BULLETINBOARDDETAIL.LOCALITY\' | translate}}"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-card"></span>\n                                    </span>\n\n                                        <!-- bulletin.branches -->\n                                        <ui-select multiple ng-model="bbdc.bulletin.branches"\n                                                   ng-disabled="bbdc.modeReadOnly" ng-required="true" name="locality"\n                                                   ng-class="{invalid:bulletinForm.locality.$touched && bulletinForm.locality.$invalid || bulletinForm.locality.$error.required && bbdc.showError}"\n                                                   sortable="true" close-on-select="false" name="locality">\n                                            <ui-select-match allow-clear=true\n                                                             placeholder="{{\'BULLETINBOARDDETAIL.LOCALITY\'|translate}}">\n                                                {{$item.description}}\n                                            </ui-select-match>\n                                            <ui-select-choices\n                                                repeat="option._id as option in bbdc.localities |\n                                                uiSelectFilter: {description:$select.search}">\n                                                <div\n                                                    ng-bind-html="option.description | highlight: $select.search"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                    <span ng-show="bulletinForm.locality.$touched && bulletinForm.locality.$invalid ||\n                                bulletinForm.locality.$error.required && bbdc.showError" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <div class="input-group"\n                                         ng-style="(bulletinForm.title.$touched && bulletinForm.title.$invalid ||\n                                    bulletinForm.title.$error.required && bbdc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'BULLETINBOARDDETAIL.TITLE\' | translate}}"\n                                          tooltip-placement="top-left" id="bboardDetailTooltip">\n                                        <span class="ion-compose"></span>\n                                    </span>\n                                        <input type="text" ng-readonly="bbdc.modeReadOnly" name="title"\n                                               ng-required="true"\n                                               class="form-control with-primary-addon" title=" "\n                                               placeholder="{{\'BULLETINBOARDDETAIL.TITLE\'|translate}}"\n                                               ng-class="{invalid: bulletinForm.title.$touched &&\n                                               bulletinForm.title.$invalid || bulletinForm.title.$error.required &&\n                                               bbdc.showError}"\n                                               aria-describedby="basic-addon1"\n                                               ng-model="bbdc.bulletin.title">\n                                    </div>\n                                    <span ng-show="bulletinForm.title.$touched && bulletinForm.title.$invalid ||\n                                      bulletinForm.title.$error.required && bbdc.showError" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group"\n                                 ng-style="(bulletinForm.description.$touched && bulletinForm.description.$invalid ||\n                                bulletinForm.description.$error.required && bbdc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'BULLETINBOARDDETAIL.DESCRIPTION\' | translate}}"\n                                  tooltip-placement="top-left" style="vertical-align: top">\n                                <span class="ion-compose"/>\n                            </span>\n                                <textarea type="text" ng-readonly="bbdc.modeReadOnly" name="description" required\n                                          class="form-control with-primary-addon"\n                                          placeholder="{{\'BULLETINBOARDDETAIL.DESCRIPTION\'|translate}}"\n                                          aria-describedby="basic-addon1"\n                                          ng-model="bbdc.bulletin.text"\n                                          ng-class="{invalid: bulletinForm.description.$touched &&\n                                      bulletinForm.description.$invalid ||\n                                      bulletinForm.description.$error.required && bbdc.showError}">\n                            </textarea>\n                            </div>\n                            <span ng-show="bulletinForm.description.$touched && bulletinForm.description.$invalid ||\n                              bulletinForm.description.$error.required && bbdc.showError" class="msgError">\n                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                    uib-tooltip="{{\'BULLETINBOARDDETAIL.PLACETEXT\' | translate}}"\n                                    tooltip-placement="top-left">\n                                <span class="ion-compose"></span></span>\n                                            <input type="text" ng-readonly="bbdc.modeReadOnly"\n                                                class="form-control with-primary-addon"\n                                                placeholder="{{\'BULLETINBOARDDETAIL.PLACETEXT\'|translate}}"\n                                                title=" "\n                                                aria-describedby="basic-addon1"\n                                                ng-model="bbdc.bulletin.placeText">\n\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <div class="input-group" ng-style="(bulletinForm.dateText.$touched &&\n                            bulletinForm.dateText.$invalid || bulletinForm.dateText.$error.required &&\n                            bbdc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'BULLETINBOARDDETAIL.DATETEXT\' | translate}}"\n                                      tooltip-placement="top-left">\n                                    <span class="ion-compose"></span></span>\n                                            <input type="text"\n                                                   ng-readonly="bbdc.modeReadOnly"\n                                                   name="dateText"\n                                                   ng-required="true"\n                                                   class="form-control with-primary-addon"\n                                                   placeholder="{{\'BULLETINBOARDDETAIL.DATETEXT\'|translate}}"\n                                                   title=" "\n                                                   aria-describedby="basic-addon1"\n                                                   ng-model="bbdc.bulletin.dateText"\n                                                   ng-class="{invalid: bulletinForm.dateText.$touched &&\n                                                   bulletinForm.dateText.$invalid ||\n                                                   bulletinForm.dateText.$error.required && bbdc.showError}">\n\n                            </div>\n                            <span\n                                ng-show="bulletinForm.dateText.$touched && bulletinForm.dateText.$invalid ||\n                                bulletinForm.dateText.$error.required && bbdc.showError"\n                                class="msgError">{{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-4">\n                            <date-picker-comp tooltip-text="\'BULLETINBOARDDETAIL.VISIBLEFROM\' | translate"\n                                              tooltip-placement="top-left" date-value="bbdc.visibleFrom"\n                                              is-required="true" mode-read-only="( bbdc.modeReadOnly || bbdc.istour )"\n                                              date-options="bbdc.dateOptions" show-required-error="bbdc.showError"\n                                              form-reference="bulletinForm" special-validation="bbdc.checkDates()"\n                                              name-field="\'visibleFrom\'"\n                                              id="bboardDetailVisibleFrom"></date-picker-comp>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-sm-4">\n                            <date-picker-comp tooltip-text="\'BULLETINBOARDDETAIL.VISIBLETO\' | translate"\n                                              tooltip-placement="top-left" date-value="bbdc.visibleTo"\n                                              is-required="true" mode-read-only="( bbdc.modeReadOnly || bbdc.istour )"\n                                              date-options="bbdc.dateOptions" show-required-error="bbdc.showError"\n                                              form-reference="bulletinForm" special-validation="bbdc.checkDates()"\n                                              name-field="\'visibleTo\'" id="bboardDetailVisibleTo"></date-picker-comp>\n                        </div>\n                    </div>\n                    <div class="pull-right">\n                        <button style="margin-top:30px;margin-bottom:7px;" type="button" id="bboardDetailCancel"\n                                tagaste-click="bbdc.cancel()" class="btn btn-success btn-with-icon">\n                            <i class="ion-arrow-left-c"></i>{{bbdc.modeReadOnly ?\'BUTTONS.BACK\':\'BUTTONS.CANCEL\'\n                            |translate}}\n                        </button>\n                        <button style="margin-top:30px;margin-bottom:7px;" type="button" id="bboardDetailSave"\n                                ng-disabled="bbdc.invalidDates || bbdc.avatarUploading" ng-if="!bbdc.modeReadOnly"\n                                tagaste-click="bbdc.save(bulletinForm)" class="btn btn-success btn-with-icon">\n                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                        </button>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/bulletinBoard/bulletinBoardList/bulletinBoardList.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="BULLETINBOARD.HEADER" ba-panel-class="with-scroll" id="bboardList">\n            <div class="resumeTourContainer" style="left: 250px!important;">\n                <span class="ion-ios-information-outline" tagaste-click="bblc.initTour()" style="cursor: pointer;"\n                      ng-hide="bblc.showBulletinView"></span>\n            </div>\n            <div class="horizontal-scroll" ng-class="(!bblc.showBulletinView) ? \'\': \'hideTableCounts\'">\n                <table ng-table="bblc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true" style="cursor: pointer;">\n\n                    <colgroup ng-if="showBulletinView">\n                        <col width="100%">\n                    </colgroup>\n\n                    <colgroup ng-if="!bblc.showBulletinView && bblc.userBranch.length > 1">\n                        <col width="5%">\n                        <col width="35%">\n                        <col width="40%">\n                        <col width="5%">\n                        <col width="5%">\n                        <col width="5%">\n                        <col width="5%">\n                    </colgroup>\n\n                    <colgroup ng-if="!bblc.showBulletinView && bblc.userBranch.length == 1">\n                        <col width="3%">\n                        <col width="50%">\n                        <col width="7%">\n                        <col width="4%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data |dummyDataIfEmpty:bblc.tourDummyData |showErrorNoData track by $index "\n                        tagaste-click="bblc.tableParamsCK(row)"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n\n                        <td colspan="5" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title=""\n                            ng-if="!bblc.showBulletinView && !row.error">\n                            <img ng-src="{{row.photo.thumb.signedUrl}}" style="max-width: 40px" check-image/>\n                        </td>\n                        <td data-title="\'BULLETINBOARD.LOCALITY\'|translate"\n                            sortable="\'localities\'"\n                            filter="bblc.filterLocality"\n                            ng-if="!bblc.showBulletinView && bblc.userBranch.length > 1"\n                            ng-attr-title="{{row.localities}}" style="text-align: inherit">\n                            {{row.localities}}\n                        </td>\n                        <td data-title="\'BULLETINBOARD.TITLE\'|translate"\n                            sortable="\'title\'" style="text-align: inherit"\n                            filter="bblc.filterTitle"\n                            ng-attr-title="{{row.title}}">\n                            {{row.title}}\n                        </td>\n                        <td data-title="\'BULLETINBOARD.DATEFROM\'|translate"\n                            sortable="\'dateFrom\'"\n                            ng-if="!bblc.showBulletinView"\n                            filter="bblc.filterDateFrom"\n                            ng-attr-title="{{row.dateFormatFrom}}">\n                            {{row.dateFormatFrom}}\n                        </td>\n                        <td data-title="\'BULLETINBOARD.DATETO\'|translate"\n                            sortable="\'dateTo\'"\n                            ng-if="!bblc.showBulletinView"\n                            filter="bblc.filterDateTo"\n                            ng-attr-title="{{row.dateFormatTo}}">\n                            {{row.dateFormatTo}}\n                        </td>\n                        <td data-title="\'BULLETINBOARD.HIGHLIGHT\'|translate"\n                            sortable="\'highlight\'"\n                            style="text-align: center"\n                            ng-if="!bblc.showBulletinView && !row.error">\n                             <span class="iconNgTable fa fa-star"\n                                   ng-style="(row.highlight) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"\n                                   title="{{(row.highlight) ? (\'BULLETINBOARD.HIGHLIGHT\'|translate) :\n                                   (\'BULLETINBOARD.NOHIGHLIGHT\'|translate)}}"></span>\n                        </td>\n                        <td  ng-if="!bblc.showBulletinView && !row.error" style="white-space: nowrap">\n                            <span class="fa fa-pencil iconNgTable edit"\n                                  ng-if="bblc.gotAccessMod"\n                                  uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                  tagaste-click="bblc.editBulletin(row); $event.stopPropagation();"></span>\n                            <span class="fa fa-trash-o iconNgTable edit"\n                                  uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                  ng-if="bblc.gotAccessDel"\n                                  style="margin-left: 10px;"\n                                  tagaste-click="bblc.deleteBulletin(row); $event.stopPropagation();"></span>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!bblc.showBulletinView">\n                <div class="col-xs-12 countAndNewButton">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ bblc.tableParams.total() }}</span></span>\n                    <button tagaste-click="bblc.newBulletin()"\n                            ng-if="bblc.gotAccessMod"\n                            type="button" class="btn btn-success btn-with-icon pull-right newButton"\n                            id="newBulletinButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>');
$templateCache.put('app/components/canteen/canteenComments/canteenComments.html','<div class="row" style="max-height: 617px;" style="overflow-x: hidden;">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel" style="overflow-x: hidden;">\n        <div ba-panel ba-panel-title="CANTEENDETAIL.COMMENTS"\n             ba-panel-class="with-scroll"\n             ba-panel-anim="zoom-in"\n             style="line-height:30px; overflow-x: hidden;">\n            <form name="commForm" autocomplete="false">\n                <div class="row">\n                    <div class="col-xs-12">\n                        <div class=" input-group chatInput">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                      uib-tooltip="{{\'CANTEENDETAIL.COMMENTS\' | translate}}"\n                                      tooltip-placement="right-top"\n                                      style="vertical-align: top;">\n                                <span class="ion-android-create"></span></span>\n                            <textarea ng-model="cnComm.comments" name="text"\n                                      class="form-control with-primary-addon"\n                                      aria-describedby="basic-addon1"\n                                      placeholder="{{\'CANTEENDETAIL.COMMENTS\'|translate}}">\n                                </textarea>\n                        </div>\n                    </div>\n                </div>\n                <div>\n                    <div ng-repeat="booking in cnComm.menu.booking">\n                        <div ng-if="booking.userRemark">\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText"><span class="ion-android-person" style="margin-right: 10px;"></span>\n                                    {{booking.user.item.fullName}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="userRemarkComment vertical-scroll">{{booking.userRemark}}</div>\n                        </div>\n                    </div>\n                </div>\n                <div class="panel-footer-buttons">\n                    <div class="row">\n                        <div class="pull-right">\n                            <button class="residentDetailCancel btn btn-success btn-with-icon"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    tagaste-click="cnComm.back()">\n                                <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                            </button>\n                            <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    tagaste-click="cnComm.save()"\n                                    class="btn btn-success btn-with-icon">\n                                <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/canteen/canteenAppUsersList/canteenAppUsersList.html','<div class="row canteenReserves" ng-if="cnaulstc.ready">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel">\n        <div ba-panel ba-panel-title="<b>{{\'CANTEENAPPUSERDETAIL.TITLE\' |translate }}</b>"\n             ba-panel-anim="zoom-in" ba-panel-class="with-scroll">\n            <div class="row" ng-if="cnaulstc.notificationPermission">\n                <div class="col-xs-12">\n\n                    <button type="button"\n                            ng-if="!cnaulstc.fromAnnouncement"\n                            ng-click="cnaulstc.notify()" class="btn btn-success btn-with-icon pull-right">\n                        <i class="ion-iphone"></i>{{\'BUTTONS.NOTIFY\' |translate}}\n                    </button>\n                </div>\n            </div>\n            <div class="row">\n                <div class="canteenTitle">\n                    <div class="canteenTitleText">{{\'CANTEENDETAIL.COURSE.FIRST\' | translate}}</div>\n                    <div class="canteenTitleBorder"></div>\n                </div>\n                <div ng-repeat="inDishFirst in cnaulstc.appuserbapan.first" class="reservesBlock">\n                    <div class="dishBlock">\n                        <in-dish-com readonly="true" disba="inDishFirst.inDish"></in-dish-com>\n                    </div>\n                    <div class="appUsers">\n                        <div ng-repeat="user in inDishFirst.user">\n                            <!-- todo: order username -->\n                            <p ng-click="cnaulstc.showReserveEdit(user)" class="reserveAppUsers">{{user.item.name}}\n                                {{user.item.surname}}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="canteenTitle">\n                    <div class="canteenTitleText">{{\'CANTEENDETAIL.COURSE.SECOND\' | translate}}</div>\n                    <div class="canteenTitleBorder"></div>\n                </div>\n                <div ng-repeat="inDishSecond in cnaulstc.appuserbapan.second" class="reservesBlock">\n                    <div class="dishBlock">\n                        <in-dish-com readonly="true" disba="inDishSecond.inDish"></in-dish-com>\n                    </div>\n                    <div class="appUsers">\n                        <div ng-repeat="user in inDishSecond.user">\n                            <p ng-click="cnaulstc.showReserveEdit(user)" class="reserveAppUsers">{{user.item.name}}\n                                {{user.item.surname}}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="canteenTitle">\n                    <div class="canteenTitleText">{{\'CANTEENDETAIL.COURSE.DESSERT\' | translate}}</div>\n                    <div class="canteenTitleBorder"></div>\n                </div>\n                <div ng-repeat="inDishDessert in cnaulstc.appuserbapan.dessert" class="reservesBlock">\n                    <div class="dishBlock">\n                        <in-dish-com readonly="true" disba="inDishDessert.inDish"></in-dish-com>\n                    </div>\n                    <div class="appUsers">\n                        <div ng-repeat="user in inDishDessert.user">\n                            <p ng-click="cnaulstc.showReserveEdit(user)" class="reserveAppUsers">{{user.item.name}}\n                                {{user.item.surname}}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="canteenTitle">\n                    <div class="canteenTitleText">{{\'CANTEENDETAIL.COURSE.ABSENTS\' | translate}}</div>\n                    <div class="canteenTitleBorder"></div>\n                </div>\n                <div ng-repeat="absentInDish in cnaulstc.appuserbapan.absent" class="reservesBlock">\n                    <div class="appUsers">\n                        <div ng-repeat="user in absentInDish.user">\n                            <p ng-click="cnaulstc.showReserveEdit(user)" class="reserveAppUsers"\n                               ng-class="{\'noSelectMenu\': user.item.noSelectedMenu}">{{user.item.name}}\n                                {{user.item.surname}}</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="canteenTitle">\n                    <div class="canteenTitleText">{{\'CANTEENDETAIL.COURSE.SPECIAL\' | translate}}</div>\n                    <div class="canteenTitleBorder"></div>\n                </div>\n                <div ng-repeat="specialInDish in cnaulstc.appuserbapan.special" class="reservesBlock">\n                    <div class="appUsers">\n                        <p ng-click="cnaulstc.showReserveEdit(specialInDish.user)" class="reserveAppUsers">\n                                {{specialInDish.user.item.name}} {{specialInDish.user.item.surname}}</p>\n                        <span>[ {{specialInDish.inDish.type}} ] - {{specialInDish.inDish.comment}}</span>\n                        \n                    </div>\n                </div>\n            </div>\n            <div class="panel-footer-buttons">\n                <div class="row">\n                    <div class="col-xs-12">\n                        <button type="button"\n                                ng-click="cnaulstc.back();" class="btn btn-success btn-with-icon pull-right">\n                            <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/canteen/canteenDetail/canteenDetail.html','<div class="row" ng-class="cnde.menuid ? \'\' : \'full-invisible\'">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel canteen-detail">\n        <div ba-panel ba-panel-title="CANTEENDETAIL.HEADER" ba-panel-class="with-scroll" id="carteendetail"\n             ba-panel-class="with-scroll" ba-panel-anim="zoom-in"\n             style="line-height:30px;">\n            <form name="courseForm">\n                <div class="row" scroll-glue="!glued" >\n                    <div id="menuDetailFields">\n                        <div class="row">\n                            <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2">\n                                <date-picker-comp\n                                    id="menuDetailDateFrom"\n                                    placeholder="\'CANTEENDETAIL.DATECOURSEFROM\' | translate"\n                                    tooltip-text="\'CANTEENDETAIL.DATECOURSEFROM\' | translate"\n                                    tooltip-placement="right"\n                                    date-value="cnde.menu.date"\n                                    is-required="true"\n                                    date-options="cnde.dateOptions"\n                                    form-reference="courseForm"\n                                    show-required-error="cnde.showError"\n                                    mode-read-only="( cnde.readonly || cnde.istour || cnde.blockButtons)"\n                                    special-validation="cnde.checkDates()"\n                                    name-field="\'visibleFrom\'"\n                                    msg-special-validation="\'CANTEENDETAIL.MSGERRORFECHAMENU\'">\n                                </date-picker-comp>\n                            </div>\n                            <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2">\n                                <date-picker-comp\n                                    id="menuDetailDateTo"\n                                    placeholder="\'CANTEENDETAIL.ENDDATECOURSE\' | translate"\n                                    tooltip-text="\'CANTEENDETAIL.ENDDATECOURSE\' | translate"\n                                    tooltip-placement="right"\n                                    date-value="cnde.menu.dateLimit"\n                                    is-required="true"\n                                    date-options="cnde.dateOptions"\n                                    form-reference="courseForm"\n                                    special-validation="cnde.checkDates()"\n                                    mode-read-only="( cnde.readonly || cnde.istour || cnde.blockButtons)"\n                                    name-field="\'visibleMaxReserve\'"\n                                    msg-special-validation="\'CANTEENDETAIL.MSGERRORFECHAMAXMENU\'">\n                                </date-picker-comp>\n                            </div>\n                            <div class="col-xs-6 col-sm-6 col-md-3 col-lg-2">\n                                <div class="input-group" id="menuDetailPlaces">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                            uib-tooltip="{{\'CANTEENDETAIL.SELECTRESIDENCE\' | translate}}"\n                                            tooltip-placement="right">\n                                            <span class="ion-card"></span>\n                                        </span>\n                                    <ui-select ng-model="cnde.menu.branch"\n                                            style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                            class="btn-group bootstrap-select form-control"\n                                            ng-disabled="cnde.readonly || cnde.blockButtons"\n                                            ng-change="cnde.changeMenuNext()"\n                                            append-to-body="true"\n                                            search-enabled="true">\n                                        <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}">\n                                            {{cnde.menu.branch.description}}\n                                        </ui-select-match>\n                                        <ui-select-choices\n                                            repeat="branches in cnde.constants.residences|\n                                        findResidence:{find:$select.search,alredy:cnde.menu.branch}">\n                                            <span ng-bind-html="branches.description | highlight: $select.search"></span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                            </div>\n                            <div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 text-center">\n                                <div class="col-xs-6 text-center">\n                                    <p>\n                                        <button type="button" ng-disabled="cnde.readonly || cnde.blockButtons" id="menuDetailType"\n                                                ng-repeat="menuType in cnde.constants.menuTypes track by $index"\n                                                style="min-width:51px; height: 29px;"\n                                                ng-style="(cnde.menu.menuType._id === menuType._id) ?\n                                                {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                                tagaste-click="cnde.menu.menuType = menuType"\n                                                ng-class="($index === 0 ?\n                                                \'buttonMenuTypeLeft\' : (($index +1 === cnde.constants.menuTypes.length) ?\n                                                \'buttonMenuTypeRight\' : \'buttonMenuTypeCenter\' ))"\n                                                uib-tooltip="{{menuType.description}}"\n                                                tooltip-placement="bottom"\n                                                class="btn btn-success btn-with-icon  buttonMenuTypeLeft">\n                                            <i ng-class="menuType.icon"\n                                            style="font-size:27px; margin-left:-8px;\n                                            position:absolute; top:-1px; text-align: center;"></i>\n                                        </button>\n                                    </p>\n\n                                </div>\n                                <div class="col-xs-6 text-center">\n                                        <ba-switcher switcher-style="primary"\n                                        switcher-value="cnde.menu.canSelect"\n                                        switcher-icon-on="\'tagaste-spoon-knife\'"\n                                        switcher-icon-off="\'tagaste-spoon-knife\'"\n                                        switcher-read-only="cnde.readonly || cnde.blockButtons"\n                                        uib-tooltip="{{\'CANTEENDETAIL.CANSELECTMENU\' | translate}}"\n                                        tooltip-placement="bottom"></ba-switcher>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row" >\n                        <div class="col-xs-6 col-sm-3 col-md-3 col-lg-2 text-center">\n                            <button\n                                id="reserveMenuButton"\n                                type="button"\n                                style="margin-bottom:17px"\n                                ng-if="cnde.menuid !== \'0\' || cnde.istour===true"\n                                ng-disabled="!cnde.user || cnde.blockButtons ||\n                                (cnde.user.first.length === 0 && cnde.user.second.length === 0 &&\n                                cnde.user.dessert.length === 0  && cnde.user.special.length === 0 &&\n                                cnde.user.absent.length === 0  ) ||\n                                cnde.appuserbapan !== null ||\n                                cnde.reserveList.animReserve"\n                                tagaste-click="cnde.listappUser()"\n                                class="btn btn-success btn-with-icon">\n                                <i class="ion-android-checkbox-outline"></i>\n                                {{\'CANTEENDETAIL.RES\' |translate}}\n                            </button>\n                        </div>\n                        <div class="col-xs-6 col-sm-3 col-md-3 col-lg-2 text-center">\n                            <button\n                                    id="pendingMenuButton"\n                                    type="button"\n                                    style="margin-bottom:17px"\n                                    ng-if="((cnde.menuid !== \'0\')||(cnde.istour===true))"\n                                    ng-disabled="cnde.reserveList.animReserve || cnde.blockButtons ||\n                                    (cnde.reserveList.animReserve && cnde.showResident) || (cnde.appuserbapan !== null)"\n                                    ng-click="cnde.listappNoReserveUser()" class="btn btn-success btn-with-icon ">\n                                <i class="ion-android-checkbox-outline-blank"></i>\n                                {{\'CANTEENDETAIL.NORESERV\' |translate}}\n                            </button>\n                        </div>\n                        <div class="col-xs-6 col-sm-3 col-md-3 col-lg-2 text-center">\n                                <button\n                                        id="commentsMenuButton"\n                                        type="button"\n                                        style="margin-bottom:17px"\n                                        ng-if="((cnde.menuid !== \'0\')||(cnde.istour===true))"\n                                        ng-disabled="cnde.reserveList.animReserve || cnde.blockButtons ||\n                                        (cnde.reserveList.animReserve && cnde.showResident) || (cnde.appuserbapan !== null)"\n                                        ng-click="cnde.commentsMenu()" class="btn btn-success btn-with-icon ">\n                                    <i class="ion-android-checkbox-outline-blank"></i>\n                                    {{\'CANTEENDETAIL.COMMENTS\' |translate}}\n                                </button>\n                            </div>\n                        <div class="col-xs-6 col-sm-3 col-md-3 col-lg-6 text-center">\n                            <button\n                                    id="newReserveMenuButton"\n                                    type="button"\n                                    style="margin-right:17px;margin-bottom:17px"\n                                    ng-if="((cnde.menuid !== \'0\')||(cnde.istour===true))"\n                                    ng-disabled="!cnde.user || (cnde.appuserbapan !== null) || cnde.reserveList.animReserve || cnde.blockButtons"\n                                    ng-click="cnde.newReserve()" class="btn btn-success btn-with-icon ">\n                                <i class="ion-android-checkbox-outline"></i>\n                                {{\'RESERVE.NEWRESERVE\' |translate}}\n                            </button>\n                        </div>\n                    </div>\n                    <div class="row" style="padding: 6px;" id="firstDish"\n                        ng-class="(cnde.inselnewcourse === cnde.constants.inDishTypes.first) ? \'selectInDish\' : \'\'"\n                        tagaste-click="cnde.changeCourse(cnde.constants.inDishTypes.first);">\n                        <div class="col-xs-12">\n                            <div class="row">\n                                <div class="canteenTitle">\n                                    <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                        {{\'CANTEENDETAIL.COURSE.FIRST\' | translate}}\n                                    </div>\n                                    <div class="canteenTitleBorder"></div>\n                                </div>\n                            </div>\n                            <div style="overflow-x: auto; white-space: nowrap;height:167px;" scroll-glue-right="!glued;">\n                                <in-dish-com ng-repeat="plate in cnde.menu.first"\n                                            deletestr="cnde.deletestr"\n                                            type="first"\n                                            allergies="cnde.constants.allergies"\n                                            isselect="false"\n                                            readonly="cnde.readonly || cnde.blockButtons"\n                                            disba="plate"\n                                            appusr="getAppusrByInDish(plate._id)"></in-dish-com>\n                                <div tagaste-click="cnde.newCourse(cnde.constants.inDishTypes.first);"\n                                    class="addDishButton"\n                                    ng-disabled="(cnde.istour || cnde.blockButtons)"\n                                    ng-if="(!cnde.readonly) && (!cnde.blockButtons) &&\n                                    (!cnde.inselnewcourse || (cnde.inselnewcourse === cnde.constants.inDishTypes.first))">\n                                    <span class="ion-ios-plus-outline"></span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row" style="padding:6px;" id="secondDish"\n                        ng-class="(cnde.inselnewcourse === cnde.constants.inDishTypes.second) ? \'selectInDish\' : \'\'"\n                        tagaste-click="cnde.changeCourse(cnde.constants.inDishTypes.second);">\n                        <div class="col-xs-12">\n                            <div class="row">\n                                <div class="canteenTitle">\n                                    <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                        {{\'CANTEENDETAIL.COURSE.SECOND\' | translate}}\n                                    </div>\n                                    <div class="canteenTitleBorder"></div>\n                                </div>\n                            </div>\n                            <div style="overflow-x: auto; white-space: nowrap;height:167px;" scroll-glue-right="!glued">\n                                <in-dish-com ng-repeat="plate in cnde.menu.second"\n                                            type="second"\n                                            deletestr="cnde.deletestr"\n                                            allergies="cnde.constants.allergies"\n                                            isselect="false"\n                                            readonly="cnde.readonly || cnde.blockButtons"\n                                            disba="plate"\n                                            appusr="getAppusrByInDish(plate._id)"></in-dish-com>\n                                <div tagaste-click="cnde.newCourse(cnde.constants.inDishTypes.second);"\n                                    class="addDishButton"\n                                    ng-disabled="cnde.istour || cnde.blockButtons"\n                                    ng-if="(!cnde.readonly) && (!cnde.blockButtons) && (!cnde.inselnewcourse || (cnde.inselnewcourse ===\n                                    cnde.constants.inDishTypes.second))"><span class="ion-ios-plus-outline"></span></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row" style="padding:6px;" id="dessertDish"\n                        ng-class="(cnde.inselnewcourse === cnde.constants.inDishTypes.dessert) ? \'selectInDish\' : \'\'"\n                        tagaste-click="cnde.changeCourse(cnde.constants.inDishTypes.dessert);">\n                        <div class="col-xs-12">\n                            <div class="row">\n                                <div class="canteenTitle">\n                                    <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                        {{\'CANTEENDETAIL.COURSE.DESSERT\' | translate}}\n                                    </div>\n                                    <div class="canteenTitleBorder"></div>\n                                </div>\n                            </div>\n                            <div style="overflow-x: auto; white-space: nowrap;height:167px;" scroll-glue-right="!glued">\n                                <in-dish-com ng-repeat="plate in cnde.menu.dessert"\n                                            deletestr="cnde.deletestr"\n                                            isselect="false"\n                                            allergies="cnde.constants.allergies"\n                                            disba="plate"\n                                            type="dessert"\n                                            readonly="cnde.readonly || cnde.blockButtons"\n                                            appusr="getAppusrByInDish(plate._id)"></in-dish-com>\n                                <div tagaste-click="cnde.newCourse(cnde.constants.inDishTypes.dessert);"\n                                    class="addDishButton"\n                                    ng-disabled="cnde.istour || cnde.blockButtons"\n                                    ng-if="(!cnde.readonly) && (!cnde.blockButtons) && (!cnde.inselnewcourse || (cnde.inselnewcourse ===\n                                    cnde.constants.inDishTypes.dessert))"><span class="ion-ios-plus-outline"></span></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-xs-12">\n                            <div class="input-group">\n                                <p id="optionMenuXtra" name="optionMenuXtra"\n                                ng-if="(!cnde.readonly) && (!cnde.blockButtons)"\n                                ng-click="cnde.menuExtraCK()">\n                                    <span style="font-size:17px;color:#5ee38d;margin-top:-10px;"\n                                        ng-class="(cnde.showAvaibleOtherMenuDish) ? \'ion-minus-circled\' :\n                                    \'ion-plus-circled\'"> </span>\n                                    <span>  {{\'CANTEENDETAIL.OPTIONMENUXTRA\' | translate}}</span>\n                                </p>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row" style="padding:6px;"\n                        ng-if="cnde.showAvaibleOtherMenuDish"\n                        ng-class="(cnde.inselnewcourse === cnde.constants.inDishTypes.extra) ? \'selectInDish\' : \'\'"\n                        tagaste-click="cnde.changeCourse(cnde.constants.inDishTypes.extra);">\n                        <div class="col-xs-12">\n                            <div class="row">\n                                <div class="canteenTitle">\n                                    <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                        {{\'CANTEENDETAIL.COURSE.XTRA\' | translate}}\n                                    </div>\n                                    <div class="canteenTitleBorder"></div>\n                                </div>\n                            </div>\n                            <div style="overflow-x: auto; white-space: nowrap;height:167px;" scroll-glue-right="!glued">\n                                <in-dish-com ng-repeat="plate in cnde.menu.extra"\n                                            deletestr="cnde.deletestr"\n                                            isselect="false"\n                                            disba="plate"\n                                            allergies="cnde.constants.allergies"\n                                            type="extra"\n                                            readonly="cnde.readonly || cnde.blockButtons"\n                                            appusr="getAppusrByInDish(plate._id)"></in-dish-com>\n                                <div tagaste-click="cnde.newCourse(cnde.constants.inDishTypes.extra);"\n                                    class="addDishButton"\n                                    ng-disabled="cnde.istour || cnde.blockButtons"\n                                    ng-if="!cnde.readonly && (!cnde.inselnewcourse || (cnde.inselnewcourse ===\n                                    cnde.constants.inDishTypes.extra))"><span class="ion-ios-plus-outline"></span></div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="panel-footer-buttons">\n                        <div class="row">\n                            <div class="col-xs-12 text-right" id="printReports">\n                                <button\n                                    class="btn btn-success btn-with-icon pull-left"\n                                    type="button"\n                                    ng-disabled="cnde.downloading || cnde.istour || cnde.blockButtons"\n                                    style="margin-right:17px;margin-top:30px;margin-bottom:7px;height: 33px;width: 117px;"\n                                    ng-if="cnde.menuid !== \'0\' || cnde.istour===true"\n                                    ng-click="cnde.getReport()">\n                                    <div class="progress" ng-if="cnde.downloading" style="height:3px;margin-top:6px">\n                                        <div class="progress-bar progress-bar-success progress-bar-striped active"\n                                            style="background-color:#51A351;"\n                                            role="progressbar" aria-valuenow="{{cnde.timeBar}}"\n                                            aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': cnde.timeBar  + \'%\'}">\n                                        </div>\n                                    </div>\n                                    <div ng-if="!cnde.downloading">\n                                        <p><i class="fa fa-print"> </i>{{\'CANTEENAPPUSERDETAIL.PRINTDISHES\' |translate}} </p>\n                                    </div>\n                                </button>\n                                <button\n                                    class="btn btn-success btn-with-icon pull-left"\n                                    type="button"\n                                    ng-disabled="cnde.istour || cnde.blockButtons"\n                                    style="margin-right:17px;margin-top:30px;margin-bottom:7px;height: 33px;width: 117px;"\n                                    ng-if="cnde.menuid !== \'0\'"\n                                    ng-click="cnde.getReportAppUser()" >\n                                    <div class="progress" ng-if="cnde.downloadingAppUser" style="height:3px;margin-top:6px">\n                                        <div class="progress-bar progress-bar-success progress-bar-striped active"\n                                            style="background-color:#51A351;"\n                                            role="progressbar" aria-valuenow="{{cnde.timeBarAppUser}}"\n                                            aria-valuemin="0" aria-valuemax="100" ng-style="{\'width\': cnde.timeBarAppUser  + \'%\'}">\n                                        </div>\n                                    </div>\n                                    <div ng-if="!cnde.downloadingAppUser">\n                                        <p><i class="fa fa-print" ng-disabled="cnde.istour || cnde.blockButtons"> </i>{{\'CANTEENAPPUSERDETAIL.PRINTRESIDENTS\' |translate}} </p>\n                                    </div>\n                                </button>\n                                <button\n                                    id="cancelMenuChanges"\n                                    style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                                    tagaste-click="cnde.back()"\n                                    ng-disabled="cnde.istour || cnde.blockButtons"\n                                    class="btn btn-success btn-with-icon">\n                                    <i class="ion-arrow-left-c"></i>{{cnde.readonly ?\'BUTTONS.BACK\':\'BUTTONS.CANCEL\'\n                                    |translate}}\n                                </button>\n                                <button\n                                    id="saveMenuChanges"\n                                    style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                                    ng-if="!cnde.readonly"\n                                    ng-disabled="( cnde.gotEdit() || cnde.checkDates() || cnde.istour || cnde.blockButtons)"\n                                    tagaste-click="cnde.confirm(courseForm)"\n                                    class="btn btn-success btn-with-icon">\n                                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/canteen/canteenList/canteenList.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="CANTEENLISTWINDOW.HEADER" ba-panel-class="with-scroll" id="menuList">\n            <div class="resumeTourContainer" style="left: 130px!important;">\n                <span class="ion-ios-information-outline" tagaste-click="cnltc.initTour()"\n                      style="cursor: pointer;" ng-hide="cnltc.menuid"></span>\n            </div>\n            <div class="horizontal-scroll">\n                <table\n                    ng-table="cnltc.tableParams" id="tableParams"\n                    class="table table-hover table-condensed fixNgTable"\n                    show-filter="!cnltc.menuid">\n\n                    <colgroup ng-if="(!cnltc.inselectmenu || !cnltc.appuserbapan)">\n                        <col width="*">\n                        <col width="*">\n                        <col width="*">\n                        <col width="*">\n                        <col width="3%">\n                        <col width="3%">\n                        <col width="3%">\n                    </colgroup>\n                    <!-- expanded -->\n                    <colgroup ng-if="(cnltc.inselectmenu || cnltc.appuserbapan)">\n                        <col width="97%">\n                        <col width="3%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data  | dummyDataIfEmpty:cnltc.tourDummyData  |\n                        showErrorNoData track by $index" style="cursor: pointer;"\n                        tagaste-click="cnltc.tableParamsCK(row)"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td colspan="3" ng-if="row.error"\n                            class="text-left"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'CANTEENLISTWINDOW.DATE\'|translate"\n                            sortable="\'date\'" class="text-left"\n                            filter="cnltc.filtersDate"\n                            ng-attr-title="{{row.sdate}}">\n                            {{row.sdate}}\n                        </td>\n                        <td data-title="\'CANTEENLISTWINDOW.RESIDENCE\'|translate"\n                            sortable="\'branch.description\'" class="text-left"\n                            filter="cnltc.filtersBranch"\n                            ng-if=" !cnltc.menuid && !cnltc.inselectmenu && !row.error && !cnltc.appuserbapan"\n                            ng-attr-title="{{row.branchDescription}}">\n                            {{row.branchDescription}}\n                        </td>\n                        <td data-title="\'CANTEENLISTWINDOW.RESERVATIONS\'|translate"\n                            sortable="\'booking.totalBook\'" class="text-left"\n                            filter="cnltc.filterReservations"\n                            ng-if=" !cnltc.menuid && !cnltc.inselectmenu && !row.error && !cnltc.appuserbapan"\n                            ng-attr-title="{{row.booking.booked}}">\n                            {{row.booking.totalBook}}\n                        </td>\n                        <td data-title="\'CANTEENLISTWINDOW.SERVICES\'|translate"\n                            sortable="\'booking.delivered\'" class="text-left"\n                            filter="cnltc.filterServices"\n                            ng-if=" !cnltc.menuid && !cnltc.inselectmenu && !row.error && !cnltc.appuserbapan"\n                            ng-attr-title="{{row.booking.delivered}}">\n                            {{row.booking.delivered}}\n                        </td>\n                        <td data-title="\'CANTEENLISTWINDOW.TYPE\'|translate"\n                            sortable="\'smenuType \'"\n                            filter="cnltc.filterStyp"\n                            ng-attr-title="{{row.smenuType}}"\n                            ng-class="(cnltc.menuid || cnltc.inselectmenu || cnltc.appuserbapan) ?\n                            \'text-center\' : \'text-left\'">\n                            <span\n                                ng-if="!cnltc.menuid && !cnltc.inselectmenu && !cnltc.appuserbapan">\n                                {{row.smenuType }} </span>\n                            <span ng-if="cnltc.menuid || cnltc.inselectmenu || cnltc.appuserbapan"\n                                  style="font-size:27px;"\n                                  class="{{row.menuType.icon}}"></span>\n                        </td>\n                        <td data-title="\'CANTEENLISTWINDOW.USERREMARKS.TITLE\'|translate"\n                            id="menuUserRemark"\n                            sortable="\'suserremarks\'"\n                            filter="cnltc.filterUserRemarks"\n                            class="iconNgTable"\n                            ng-attr-title="{{row.suserremarks}}"\n                            ng-if="!cnltc.menuid && !cnltc.inselectmenu && !row.error && !cnltc.appuserbapan">\n                            <i style="margin-left:10px;"\n                            ng-class="(row.booking.userRemark > 0) ? \'ion-ios-chatboxes\':\'\'"\n                            aria-hidden="true"></i>\n                        </td>\n                        <td data-title="\'CANTEENLISTWINDOW.STATE.TITLE\'|translate"\n                            id="menuSactive"\n                            sortable="\'sactive\'"\n                            filter="cnltc.filterAct"\n                            class="iconNgTable"\n                            ng-attr-title="{{row.sactive}}"\n                            ng-if="!cnltc.menuid && !cnltc.inselectmenu && !row.error && !cnltc.appuserbapan">\n                            <i style="margin-left:8px;"\n                            ng-class="(row.activeState) ? \'ion-ios-locked\':\'ion-ios-unlocked-outline\'"\n                            aria-hidden="true"></i>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!cnltc.menuid">\n                <div class="col-xs-12 countAndNewButton" >\n                    <div style="flex-grow: 1; display: flex; height: 32px; justify-content: flex-end; align-items: center;" class="count">\n                        <div style="height: 32px; padding-right: 20px;" class="dp-not-show-clear">\n                            <date-picker-comp\n                                placeholder="\'CANTEENDETAIL.DATECOURSE\' | translate"\n                                tooltip-text="\'CANTEENDETAIL.DATECOURSEFROM\' | translate"\n                                date-value="cnltc.dateFrom"\n                                mode-read-only="cnltc.istour"\n                                form-reference="canteenListForm"\n                                name-field="\'dateFrom\'"\n                                custom-class="\'dp-not-show-clear\'"\n                                special-validation="cnltc.dayChanged()">\n                            </date-picker-comp>\n                        </div>\n                        <div id="totalItems" style="display: inline-block;">\n                            {{ \'TOTAL\' |translate }} : {{ cnltc.tableParams.total() }}\n                        </div>\n                        <button\n                            type="button"\n                            ng-if="cnltc.gotAccessMod"\n                            tagaste-click="cnltc.newMenuDish()"\n                            ng-disabled="cnltc.istour"\n                            class="btn btn-success btn-with-icon pull-right newButton"\n                            id="newMenuButton" style="margin-left: 30px;">\n                            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                        </button>\n                        <button type="button"\n                        tagaste-click="cnltc.exportData()"\n                        class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                            <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/canteen/canteenSelectCourse/canteenSelectCourse.html','<div class="detail-panel">\n    <div class="row">\n        <div class="col-md-12 col-lg-12 rightPanel canteen-select-course">\n            <div ba-panel ba-panel-title="CANTEENCOURSE.HEADER"  id="cartencourse" ba-panel-anim="zoom-in" style="line-height: 30px;">\n                <div class="row ">\n                    <div class="row">\n                        <div class="col-xs-12 col-md-12 col-sm-12">\n                            <div class="input-group">\n                                <span ng-click="selc.find(selc.params)"\n                                    class="input-group-addon input-group-addon-primary addon-left"><span\n                                    class="ion-ios-search-strong"></span></span>\n                                <input\n                                    id="dishSearch"\n                                    type="text"\n                                    class="form-control with-primary-addon"\n                                    placeholder="{{\'CANTEENCOURSE.SEARCHTERMS\'|translate}}"\n                                    aria-describedby="basic-addon1"\n                                    ng-model="selc.params.findTerm">\n                                <span ng-click="selc.params.findTerm = \'\'"\n                                    class="input-group-addon input-group-addon-primary addon-right"\n                                    style="cursor:pointer;">\n                                    <span class="ion-trash-a"></span></span>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row panelTitle">\n                        <div class="col-sm-12 col-md-12 col-xs-12 text-center" style="margin-top:-10px">\n                            <p id="dishTypeFilter">\n                                <button type="button"\n                                        ng-style="((selc.params.dishType.code.indexOf(selc.constants.inDtypes.first) >= 0))\n                                        ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                        ng-click="selc.changeParamDishType(selc.constants.inDtypes.first)"\n                                        class="btn btn-success btn-with-icon buttonMenuTypeLeft">\n                                    {{\'CANTEENCOURSE.COURSE.FIRST\' |translate}}\n                                </button>\n                                <button type="button"\n                                        ng-style="((selc.params.dishType.code.indexOf(selc.constants.inDtypes.second) >= 0))\n                                                                    ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                        style="margin-left:-4px;margin-right:-3.5px"\n                                        ng-click="selc.changeParamDishType(selc.constants.inDtypes.second)"\n                                        class="btn btn-success btn-with-icon buttonMenuTypeCenter">\n                                    {{\'CANTEENCOURSE.COURSE.SECOND\' |translate}}\n                                </button>\n                                <button type="button"\n                                        ng-style="((selc.params.dishType.code.indexOf(selc.constants.inDtypes.dessert) >= 0))\n                                                                    ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                        ng-click="selc.changeParamDishType(selc.constants.inDtypes.dessert)"\n                                        class="btn btn-success btn-with-icon buttonMenuTypeRight">\n                                    {{\'CANTEENCOURSE.COURSE.DESSERT\' |translate}}\n                                </button>\n                            </p>\n                        </div>\n                    </div>\n                    <div>\n                        <div class="cartenSelectCourseAllergens">\n                            <div ng-repeat="allergen in selc.allergens">\n                                <i uib-tooltip="{{allergen.description}}" ng-class="allergen.icon" class="cscAllergen"\n                                tooltip-placement="right"\n                                    ng-click="selc.changeParamAllergyType(allergen._id)"\n                                    ng-style="selc.gotIn(selc.params.allergyType.ids,allergen._id) ?\n                                    { \'color\': \'rgba(128, 254, 193, 1)\' } : { \'color\': \'rgba(128, 254, 193, 0.3)\'}">\n                                </i>\n                            </div>\n                        </div>\n                        <div ng-if="selc.listInDish.length >= 0" style="margin-left: 24px;" class="dishes">\n\n                            <!-- <div ng-repeat="x in [].constructor(99) track by $index" class="ng-animate-disabled"> -->\n                                    <in-dish-com\n                                    class="ng-animate-disabled"\n                                        ng-repeat="ind in selc.inresult = (selc.listInDish | findParams:selc.params:selc.alreadycourses) | limitTo:selc.limitDishes"\n                                        returncourse="selc.returncourse"\n                                        disba="ind"\n                                        goedit="selc.goedit"></in-dish-com>\n                            <!-- </div> -->\n\n\n                            <div ng-if="selc.inresult.length === 0" style="margin-top:13px;">\n                                <p><i>{{\'CANTEENCOURSE.NORESULT\' |translate}}</i></p>\n                            </div>\n                            <div style="cursor: pointer;" ng-click="selc.limitDishes = selc.limitDishes + selc.dishesStep" ng-if="selc.listInDish.length >= 0 && ((selc.listInDish | findParams:selc.params:selc.alreadycourses).length - selc.dishesStep) >= selc.limitDishes" >{{\'BUTTONS.VIEWMORE\' | translate }}</div>\n                        </div>\n                    </div>\n                    <div class="panel-buttons">\n                        <button id="newDishBack"\n                                style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                                tagaste-click="selc.back()"\n                                class="btn btn-success btn-with-icon">\n                            <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                        </button>\n                        <button id="newDish"\n                                style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                                ng-disabled="selc.dish !== null"\n                                tagaste-click="selc.newInDish()"\n                                class="btn btn-success btn-with-icon">\n                            <i class="fa fa-plus"></i>{{\'BUTTONS.NEWDIS\' |translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/chat/chatConv/chatConv.html','<div ba-panel ba-panel-title-no-translate="{{cnConv.selectedconv.name}}"\n     ba-panel-class="with-scroll"\n     ba-panel-anim="zoom-in"\n     id="inChatConv">\n    <form name="conv" autocomplete="false">\n        <div class="row chatConv" scroll-glue="!glued">\n            <div class="input-group col-xs-12 vertical-scroll ">\n                <div ng-repeat="conv in cnConv.convBund">\n                    <div class="row" >\n                        <div class="col-xs-10 chatMsg"\n                             ng-class="{\'pull-right\': (conv.ownMsg === true),\n                            \'pull-left\': (!conv.ownMsg || conv.ownMsg === false),\n                            \'chatMsgRight\': (conv.ownMsg === true),\n                            \'chatMsgLeft\': (!conv.ownMsg || conv.ownMsg === false)}">\n                            <p style="font-style: italic;font-size:9px;">{{conv.date}} {{conv.userFrom.fullName}}</p>\n                            <p style="font-weight: 300; line-height: normal;text-align: justify;"\n                               ng-class="{\'pull-right\': (conv.ownMsg === true),\n                               \'pull-left\': (!conv.ownMsg || conv.ownMsg === false)}">\n                                {{conv.text}}\n                            </p>\n                            <div class="msgHour">{{conv.hour}}</div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-xs-12">\n                <div class=" input-group chatInput">\n                    <span class="input-group-addon input-group-addon-primary addon-left"><span\n                        class="ion-ios-search-strong"></span></span>\n                    <input\n                        id="findTerms"\n                        type="text"\n                        ng-enter="cnConv.sendNew()"\n                        class="form-control with-primary-addon"\n                        placeholder="{{\'CHATWINDOWCONV.WRITEMSG\'|translate}}"\n                        aria-describedby="basic-addon1"\n                        ng-model="cnConv.convTxt">\n                    <span ng-click="cnConv.sendNew()"\n                          class="input-group-addon input-group-addon-primary addon-right"\n                          style="cursor:pointer;">\n                            <span class="ion-ios-paperplane"></span></span>\n                </div>\n            </div>\n        </div>\n    </form>\n</div>');
$templateCache.put('app/components/canteen/canteenReserve/canteenReserveNew.html','<style>\n    .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'RESERVE.ABSENT\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'RESERVE.SPECIAL\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'RESERVE.MENU\'|translate}}";\n    }\n</style>\n<div class="row" style="max-height: 617px;">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel">\n        <div ba-panel ba-panel-title="RESERVE.NEWRESERVE" ba-panel-class="with-scroll" id="panelCanteenNewReserve"\n             ba-panel-anim="zoom-in" style="line-height:30px;">\n             <div class="row">\n                <div class="col-xs-12" style="overflow-x: hidden;">\n                    <form name="resForm" autocomplete="false">\n                        <div class="row" scroll-glue="!glued">\n                            <div class="input-group" ng-if="crnc.modeEdit">\n                                <span uib-tooltip="{{\'RESERVE.NAME\'|translate}}"\n                                    class="input-group-addon input-group-addon-primary addon-left">\n                                    <span class="ion-android-person"></span>\n                                </span>\n                                <input type="text" name="name" id="name"\n                                    ng-disabled="true"\n                                    class="form-control with-primary-addon ng-pristine ng-untouched ng-not-empty ng-valid ng-valid-required"\n                                    placeholder="{{\'RESERVE.NAME\'|translate}}" autocomplete="false"\n                                    ng-model="crnc.selectedResident.item.fullName"\n                                    disabled="disabled">\n                            </div>\n                            <div class="row" ng-if="!crnc.modeEdit">\n                                <div class="col-xs-4 col-md-4 col-sm-4">\n                                    <label class="custom-checkbox">\n                                        <input id="checkResidente" type="checkbox" ng-model="crnc.isResident"\n                                            ng-click="crnc.changeIsResident(true)">\n                                        <span>{{\'RESERVE.RESIDENT\'|translate}}</span>\n                                    </label>\n                                    <br/>\n                                    <label class="custom-checkbox">\n                                        <input id="checkExterno" type="checkbox" ng-model="crnc.isGuest"\n                                            ng-click="crnc.changeIsResident(false)">\n                                        <span>{{\'RESERVE.EXTERN\'|translate}}</span>\n                                    </label>\n                                </div>\n                                <div ng-class="(crnc.level > 2) ? \'col-md-8\' : \'col-md-8\'" ng-if="!crnc.isResident">\n                                    <div class="row">\n                                        <div class="col-xs-12">\n                                            <div class="input-group">\n                                            <span uib-tooltip="{{\'RESERVE.NAME\'| translate}}"\n                                                class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="ion-android-person"></span></span>\n                                                <input type="text"\n                                                    ng-class="{\'invalid\': (resForm.name.$touched ||\n                                                crnc.submitted ) && !crnc.readonly && !resForm.name.$valid }"\n                                                    required="!crnc.isResident"\n                                                    ng-model="crnc.selectedName"\n                                                    placeholder="{{\'RESERVE.NAME\'|translate}}"\n                                                    uib-typeahead="o as o.fullName for o in crnc.getGuestsByName($viewValue)"\n                                                    typeahead-loading="loadingGuest"\n                                                    typeahead-no-results="noGuestName" class="form-control"\n                                                    typeahead-wait-ms="700" typeahead-min-length=\'3\'\n                                                    typeahead-on-select="crnc.setGuest($item)">\n                                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                                <div ng-show="noGuestName">\n                                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                                </div>\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                ng-if="( resForm.name.$touched || crnc.submitted )&& !crnc.readonly &&\n                                        !resForm.name.$valid">{{\'ERROR.NOTVALIDINPUT\' |translate}}\n                                            </div>\n                                            <div class="input-group">\n                                                <input type="text" ng-disabled="crnc.readonly" name="surname"\n                                                    class="form-control with-primary-addon"\n                                                    ng-class="{\'invalid\': ( resForm.surname.$touched ||\n                                                    crnc.submitted ) && !resForm.surname.$valid}"\n                                                    placeholder="{{\'RESERVE.LASTNAME\'|translate}}"\n                                                    style="border-radius: 5px;"\n                                                    required="!crnc.isResident"\n                                                    ng-model="crnc.selectedSurname"\n                                                    uib-typeahead="o as o.fullName for o in crnc.getGuestsBySurname($viewValue) "\n                                                    typeahead-loading="loadingGuest"\n                                                    typeahead-no-results="noGuestSurname" class="form-control"\n                                                    typeahead-wait-ms="700" typeahead-min-length=\'3\'\n                                                    typeahead-on-select="crnc.setGuest($item)">\n                                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                                <div ng-show="noGuestSurname">\n                                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                                </div>\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                ng-if="( resForm.surname.$touched || crnc.submitted ) &&\n                                                    !resForm.surname.$valid">\n                                                {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-xs-12">\n                                            <div class="input-group">\n                                            <span uib-tooltip="{{\'RESERVE.IDENTIFICATION\'| translate}}"\n                                                class="input-group-addon input-group-addon-primary addon-left ">\n                                            <span class="ion-card"></span></span>\n                                                <input type="text" name="dni"\n                                                    ng-change="rnc.validDNI(crnc.selectedDocVal,\n                                                crnc.sselectedDocType.description.description,resForm.dni)"\n                                                    ng-blur="rnc.validDNI(crnc.selectedDocVal,\n                                                crnc.selectedDocType.description,resForm.dni)"\n                                                    ng-disabled="crnc.readonly" class="form-control with-primary-addon"\n                                                    placeholder="{{\'RESERVE.IDENTIFICATION\'|translate}}"\n                                                    ng-model="crnc.selectedDocVal"\n                                                    uib-typeahead="o as o.identity.docVal for o in crnc.getGuestsById($viewValue) "\n                                                    typeahead-loading="loadingGuest"\n                                                    typeahead-no-results="noGuestId" class="form-control"\n                                                    typeahead-wait-ms="700" typeahead-min-length=\'5\'\n                                                    typeahead-on-select="crnc.setGuest($item)">\n                                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                                <div ng-show="noGuestId">\n                                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                                </div>\n                                                <span style="width: 51px"\n                                                    class="input-group-addon input-group-addon-primary addon-right"\n                                                    ng-click="crnc.changeTypeIde(crnc.selectedDocType);\n                                                crnc.validDNI(crnc.selectedDocVal,\n                                                crnc.selectedDocType.description,resForm.dni)"\n                                                    ng-style="(crnc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                                {{crnc.selectedDocType.description}}</span>\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                ng-if="!resForm.dni.$valid">\n                                                {{\'ERROR.GENERROR0\' |translate}}\n                                                {{\'RESERVE.IDENTIFICATION\'|translate}}\n                                                {{\'ERROR.GENERROR1\' |translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-xs-12">\n                                            <div class="input-group">\n                                                <span uib-tooltip="{{\'RESERVE.EMAIL\'| translate}}"\n                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-at"></span></span>\n                                                <input type="text" ng-disabled="crnc.readonly" name="email"\n                                                    ng-change="crnc.validEmail(crnc.selectedEmail,resForm.email)"\n                                                    ng-blur="crnc.validEmail(crnc.selectedEmail,resForm.email)"\n                                                    class="form-control with-primary-addon"\n                                                    placeholder="{{\'RESERVE.EMAIL\'|translate}}"\n                                                    ng-model="crnc.selectedEmail">\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                ng-if="!resForm.email.$valid">\n                                                {{\'ERROR.NOTVALIDEMAIL\' |translate}}\n                                            </div>\n                                            <div class="input-group">\n                                            <span uib-tooltip="{{\'RESERVE.PHONE\'| translate}}"\n                                                class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-ios-telephone"></span></span>\n                                                <input type="text" name="mobile"\n                                                    ng-change="crnc.validateMobile(crnc.selectedPhone,\n                                                resForm.mobile)"\n                                                    ng-blur="crnc.validateMobile(crnc.selectedPhone,\n                                                resForm.mobile)"\n                                                    ng-disabled="crnc.readonly" class="form-control with-primary-addon"\n                                                    placeholder="{{\'RESERVE.PHONE\'|translate}}"\n                                                    ng-model="crnc.selectedPhone">\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                ng-if="!resForm.mobile.$valid">\n                                                {{\'ERROR.GENERROR0\' |translate}}\n                                                {{\'RESERVE.PHONE\'|translate}}\n                                                {{\'ERROR.GENERROR1\' |translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <div ng-class="(crnc.level > 2) ? \'col-md-8\' : \'col-md-8\'" ng-if="crnc.isResident">\n                                    <div class="input-group"\n                                        ng-style="(crnc.isResident && resForm.appUser.$pristine || resForm.appUser.$touched && resForm.appUser.$invalid ||\n                                        resForm.appUser.$error.required && crnc.showError) ?\n                                        {\'margin-bottom\': 0}:\'\'">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                            uib-tooltip="{{\'RESERVE.RESIDENT\' | translate}}"\n                                            tooltip-placement="bottom-left">\n                                            <span class="ion-android-person"></span>\n                                        </span>\n                                        <ui-select ng-model="crnc.appUser"\n                                                style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                class="btn-group bootstrap-select form-control"\n                                                append-to-body="true"\n                                                required="crnc.isResident"\n                                                ng-disabled="crnc.readonly"\n                                                name="appUser"\n                                                ng-change="crnc.parseUserListBy();"\n                                                ng-class="{invalid: ( crnc.isResident && resForm.appUser.$pristine ) || (resForm.appUser.$touched && resForm.appUser.$invalid ) || (resForm.appUser.$error.required && crnc.showError )}"\n                                                search-enabled="true">\n                                            <ui-select-match\n                                                allow-clear=true\n                                                placeholder="{{\'RESERVE.RESIDENT\'| translate}}">\n                                                {{crnc.appUser.fullName}}\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in crnc.appUsers |\n                                                findAppUserGroupe:{find:$select.search,alredy:crnc.menu.appUsers,\n                                                alredyFloor:crnc.alredyFloor}">\n                                                <div ng-style="(option.allFloor) ? {\'margin-left\': \'0\',\'font-weight\' : \'900\'}:\n                                                    {\'margin-left\': \'17px\'}"\n                                                    ng-bind-html="option.nameRoom | highlight: $select.search"></div>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                    <span ng-show="crnc.isResident && resForm.appUser.$pristine && crnc.submitted || resForm.appUser.$touched && resForm.appUser.$invalid ||\n                                        resForm.appUser.$error.required && crnc.showError" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                            <nz-toggle tri-toggle val-default="\'bookingMenu\'" ng-model="crnc.bookingType"\n                                    on-toggle="crnc.changeFilter(crnc.bookingType)"\n                                    val-true="\'bookingSpecial\'" val-false="\'bookingMenu\'" val-null="\'bookingAbsent\'"\n                                    width="150" style="width: 25px; height: 15px;"\n                                    color-false="\'#60BD68\'">\n                            </nz-toggle>\n\n                            <div ng-repeat="category in crnc.menuServices" ng-if="( crnc.bookingType === \'bookingMenu\')">\n                                <div class="checkbox">\n                                    <label class="custom-checkbox">\n                                        <input type="checkbox"\n                                            ng-checked="crnc.menuServiceSelected && crnc.menuServiceSelected._id === category._id"\n                                            ng-click="crnc.changemenuSelected(category)" name="group"\n                                            id="{{category._id}}"/>\n                                        <span>{{category.description}}</span>\n                                    </label>\n                                </div>\n                            </div>\n\n                            <div class="row" style="padding: 6px;" id="firstDish" ng-if="( crnc.bookingType === \'bookingMenu\')">\n                                <div class="col-xs-12">\n                                    <div class="row">\n                                        <div class="canteenTitle">\n                                            <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                                {{\'CANTEENDETAIL.COURSE.FIRST\' | translate}}\n                                            </div>\n                                            <div class="canteenTitleBorder"></div>\n                                        </div>\n                                    </div>\n                                    <div style="white-space: nowrap; height:167px;" scroll-glue-right="!glued;"\n                                        ng-class="{\'invalid\': ( crnc.bookingType === \'bookingMenu\' && crnc.submitted && !crnc.firstSelected ) }">\n                                        <ui-carousel ng-if="crnc.dishLoaded"\n                                                    slides="crnc.menu.first"\n                                                    slides-to-show=crnc.getSlidesToShow()\n                                                    slides-to-scroll="1"\n                                                    initial-slide="0">\n                                            <carousel-item>\n                                                <in-dish-com readonly="true" disba="item.returnItem()" type="first"\n                                                            allergies="crnc.constants.allergies"\n                                                            noflipper="true" showselected="item.checkFirstSelected()"\n                                                            ng-click="item.callback()"></in-dish-com>\n                                            </carousel-item>\n                                            <carousel-prev>\n                                                <button class="carouselBtn carouselBtnPrev">\n                                                    <i class="glyphicon glyphicon-chevron-left"></i>\n                                                </button>\n                                            </carousel-prev>\n\n                                            <carousel-next>\n                                                <button class="carouselBtn carouselBtnNext">\n                                                    <i class="glyphicon glyphicon-chevron-right"></i>\n                                                </button>\n                                            </carousel-next>\n                                        </ui-carousel>\n\n                                        <!--<in-dish-com ng-repeat="plate in crnc.menu.first"-->\n                                        <!--readonly="true" disba="plate" type="first"-->\n                                        <!--allergies="crnc.constants.allergies"-->\n                                        <!--noflipper = "true" showselected ="(plate._id === crnc.firstSelected)"-->\n                                        <!--ng-click="crnc.ckInFirstDish(plate._id)"></in-dish-com>-->\n                                    </div>\n                                </div>\n                                <span ng-show=" crnc.bookingType === \'bookingMenu\' && crnc.submitted && !crnc.firstSelected "\n                                    class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                            </div>\n                            <div class="row" style="padding:6px;" id="secondDish" ng-if="( crnc.bookingType === \'bookingMenu\')">\n                                <div class="col-xs-12">\n                                    <div class="row">\n                                        <div class="canteenTitle">\n                                            <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                                {{\'CANTEENDETAIL.COURSE.SECOND\' | translate}}\n                                            </div>\n                                            <div class="canteenTitleBorder"></div>\n                                        </div>\n                                    </div>\n                                    <div style="white-space: nowrap;height:167px;" scroll-glue-right="!glued;"\n                                        ng-class="{\'invalid\': crnc.bookingType === \'bookingMenu\' && crnc.submitted && !crnc.secondSelected }">\n                                        <ui-carousel ng-if="crnc.dishLoaded"\n                                                    slides="crnc.menu.second"\n                                                    slides-to-show=crnc.getSlidesToShow()\n                                                    slides-to-scroll="1"\n                                                    initial-slide="0">\n                                            <carousel-item>\n                                                <in-dish-com readonly="true" disba="item.returnItem()" type="second"\n                                                            allergies="crnc.constants.allergies"\n                                                            noflipper="true" showselected="item.checkSecondSelected()"\n                                                            ng-click="item.callback()"></in-dish-com>\n                                            </carousel-item>\n                                            <carousel-prev>\n                                                <button class="carouselBtn carouselBtnPrev">\n                                                    <i class="glyphicon glyphicon-chevron-left"></i>\n                                                </button>\n                                            </carousel-prev>\n\n                                            <carousel-next>\n                                                <button class="carouselBtn carouselBtnNext">\n                                                    <i class="glyphicon glyphicon-chevron-right"></i>\n                                                </button>\n                                            </carousel-next>\n                                        </ui-carousel>\n\n                                        <!--<in-dish-com ng-repeat="plate in crnc.menu.second" -->\n                                        <!--readonly="true" disba="plate" type="second"-->\n                                        <!--allergies="crnc.constants.allergies"-->\n                                        <!--noflipper = "true" showselected ="(plate._id === crnc.secondSelected)"-->\n                                        <!--ng-click="crnc.ckInSecondtDish(plate._id)"></in-dish-com>-->\n                                    </div>\n                                </div>\n                                <span ng-show=" crnc.bookingType === \'bookingMenu\' && crnc.submitted && !crnc.secondSelected "\n                                    class="msgError">\n                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                            </div>\n                            <div class="row" style="padding:6px;" id="dessertDish" ng-if="( crnc.bookingType === \'bookingMenu\')">\n                                <div class="col-xs-12">\n                                    <div class="row">\n                                        <div class="canteenTitle">\n                                            <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                                {{\'CANTEENDETAIL.COURSE.DESSERT\' | translate}}\n                                            </div>\n                                            <div class="canteenTitleBorder"></div>\n                                        </div>\n                                    </div>\n                                    <div style="white-space: nowrap;height:167px;" scroll-glue-right="!glued"\n                                        ng-class="{\'invalid\': crnc.bookingType === \'bookingMenu\' && crnc.submitted && !crnc.dessertSelected }">\n                                        <ui-carousel ng-if="crnc.dishLoaded"\n                                                    slides="crnc.menu.dessert"\n                                                    slides-to-show=crnc.getSlidesToShow()\n                                                    slides-to-scroll="1"\n                                                    initial-slide="0"\n                                                    autoplay="false"\n                                                    autoplay-speed="2000"\n                                                    dots="false">\n                                            <carousel-item>\n                                                <in-dish-com readonly="true" disba="item.returnItem()" type="dessert"\n                                                            allergies="crnc.constants.allergies"\n                                                            noflipper="true" showselected="item.checkDessertSelected()"\n                                                            ng-click="item.callback()"></in-dish-com>\n                                            </carousel-item>\n                                            <carousel-prev>\n                                                <button class="carouselBtn carouselBtnPrev">\n                                                    <i class="glyphicon glyphicon-chevron-left"></i>\n                                                </button>\n                                            </carousel-prev>\n\n                                            <carousel-next>\n                                                <button class="carouselBtn carouselBtnNext">\n                                                    <i class="glyphicon glyphicon-chevron-right"></i>\n                                                </button>\n                                            </carousel-next>\n                                        </ui-carousel>\n                                    </div>\n                                </div>\n                                <span ng-show=" crnc.bookingType === \'bookingMenu\' && crnc.submitted && !crnc.dessertSelected "\n                                    class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                            </div>\n                            <div class="row" ng-if="( crnc.bookingType === \'bookingSpecial\')">\n                                <div ng-repeat="category in crnc.specialType" class="col-xs-12">\n                                    <div class="checkbox">\n                                        <label class="custom-checkbox">\n                                            <input type="checkbox" ng-checked="crnc.idSelected === category._id"\n                                                ng-click="crnc.changeSpecialType(category)" name="group"\n                                                id="{{category._id}}"/>\n                                            <span>{{category.description}}</span>\n                                        </label>\n                                    </div>\n                                </div>\n                                <div class="col-xs-12">\n                                    <div class="input-group">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                uib-tooltip="{{\'SERVICEMENUDETAIL.TEXT\' | translate}}"\n                                                tooltip-placement="right-top"\n                                                style="vertical-align: top;">\n                                                <span class="ion-android-create"></span></span>\n                                        <textarea ng-model="crnc.comments" name="text"\n                                                class="form-control with-primary-addon"\n                                                aria-describedby="basic-addon1" ng-disabled="crnc.readonly"\n                                                placeholder="{{\'RESIDENTWINDOWDETAIL.OTHERCOMENTS\'|translate}}">\n                                                </textarea>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12" style="margin-top:13px;">\n                                    <p ng-if="crnc.submitted && !crnc.readonly && !crnc.$valid"\n                                    class="pull-right errorValidation bounceIn animate">\n                                        {{\'ERROR.ERRORININPUT\' |translate}}</p>\n                                </div>\n                            </div>\n                            <div class="panel-footer-buttons">\n                                <div class="row">\n                                    <div class="col-xs-4" style="display: inline-block;" ng-if="crnc.modeEdit">\n                                        <button style="margin-left:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                                tagaste-click="crnc.remove(resForm)"\n                                                ng-if="!crnc.readonly"\n                                                class="btn btn-success btn-with-icon">\n                                            <i class="ion-android-delete"></i>{{\'BUTTONS.REMOVE_MENU_RESERVE\' |translate}}\n                                        </button>\n                                    </div>\n                                    <div class="text-right" ng-class="crnc.modeEdit ? \'col-xs-8\' : \'col-xs-12\'">\n                                        <button class="btn btn-success btn-with-icon"\n                                                style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                                ng-if="crnc.readonly" tagaste-click="crnc.reserveBack()">\n                                            <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                                        </button>\n                                        <button class="btn btn-success btn-with-icon"\n                                                style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                                tagaste-click="crnc.reserveBack()" ng-if="!crnc.readonly">\n                                            <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                                        </button>\n                                        <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                                tagaste-click="crnc.save(resForm)"\n                                                ng-if="!crnc.readonly"\n                                                ng-disabled="crnc.submitted &&  !resForm.$valid "\n                                                class="btn btn-success btn-with-icon">\n                                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                                        </button>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </form>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/chat/chatList/chatList.html','<div ba-panel ba-panel-title="CHATWINDOWLIST.HEADER" ba-panel-class="with-scroll" id="inChatList">\n    <div class="resumeTourContainer" style="left: 250px!important;">\n        <span class="ion-ios-information-outline" tagaste-click="cnList.initTour()" style="cursor: pointer;"\n        ></span>\n    </div>\n    <div class="row">\n        <div class="col-xs-6 col-sm-6 col-md-6"\n             mg-if="cnList.constants.branches">\n            <div class="input-group" id="menuDetailPlaces">\n                <span class="input-group-addon input-group-addon-primary addon-left"\n                        uib-tooltip="{{\'CANTEENDETAIL.SELECTRESIDENCE\' | translate}}"\n                        tooltip-placement="right">\n                    <span class="ion-card"></span>\n                </span>\n                <ui-select ng-model="cnList.selectedBranche"\n                           style="-webkit-border-radius: 0; -moz-border-radius: 0; border-radius: 0;"\n                           class="btn-group bootstrap-select form-control"\n                           ng-change="cnList.changeBranches()"\n                           append-to-body="true"\n                           search-enabled="true">\n                    <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}">\n                        {{cnList.selectedBranche.description}}\n                    </ui-select-match>\n                    <ui-select-choices\n                        repeat="branches in cnList.constants.branches|\n                                     findResidence:{find:$select.search,alredy:cnList.selectedBranche}">\n                        <span ng-bind-html="branches.description | highlight: $select.search"></span>\n                    </ui-select-choices>\n                </ui-select>\n            </div>\n        </div>\n\n        <div class="col-xs-6 col-sm-6 col-md-6">\n            <div class="input-group">\n                <span class="input-group-addon input-group-addon-primary addon-left"><span\n                    class="ion-ios-search-strong"></span></span>\n                <input\n                    id="findTerms"\n                    type="text"\n                    class="form-control with-primary-addon"\n                    placeholder="{{\'CANTEENCOURSE.SEARCHTERMS\'|translate}}"\n                    aria-describedby="basic-addon1"\n                    ng-model="cnList.findTerm">\n                <span ng-click="cnList.findTerm = \'\'"\n                    class="input-group-addon input-group-addon-primary addon-right"\n                    style="cursor: pointer;">\n                    <span class="ion-trash-a"></span>\n                </span>\n            </div>\n        </div>\n    </div>\n\n    <div class="input-group" style="border: 1px solid rgb(58,58,58); min-height: 45px">\n        <div class="row">\n            <div class="col-xs-12 chatLst">\n                <div class="vertical-scroll" \n                    ng-repeat="gr in cnList.chatGroups| dummyDataIfEmpty:cnList.tourDummyData |\n                    filterChatGroups:cnList.findTerm track by $index"\n                    ng-class="{\'firstListRow\': $index === 0, \'selectRow\': row.selected === true}">\n                        <div class="row tag-cards" ng-click="cnList.goToConv(gr)"\n                            style="cursor: pointer; padding-top: 10px; padding-bottom: 10px; display: flex;"\n                            ng-style="(gr.kind === \'User\' || gr.isWorker === true) ? {\'background-color\': \'#696969\'}: {}"\n                            ng-class="(gr._id === cnList.selectedconv._id) ? \'selectedChatRow\': {}">\n<!--                            <div ng-if="gr.isConnected === true" class="fa fa-whatsapp connectedChatIcon"></div>-->\n                            <div class="chatAvatar">{{ cnList.chatAvatar(gr.name); }}</div>\n                            <div style="flex-grow: 1">\n\n                               <span ng-if="(gr.isGroup === false)"\n                                    ng-class="((gr.kind === \'User\' || gr.isWorker === true)) ?\n                                    \'fa fa-black-tie iconNgTable\' : \'fa fa-user iconNgTable\'"\n                                    style="font-size:30px; vertical-align: middle; padding: 5px;"\n                                    title="{{((gr.kind === \'User\' || gr.isWorker === true)) ?\n                                    (\'CHATWINDOWLIST.EMPLOYEE\' | translate) :\n                                    (\'CHATWINDOWLIST.RESIDENT\' | translate)}}"\n                                    ng-style="(gr.isConnected===true) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"\n                                ></span>\n                                <span ng-if="(gr.isGroup === true)" class="fa fa-users iconNgTable" \n                                    style="font-size:30px; vertical-align: middle; padding: 5px;"\n                                    title="{{\'CHATWINDOWLIST.GROUP\' | translate }}"></span>\n                               <b> {{gr.name}}</b>\n                            </div>\n                            <!--<span ng-if="gr.unreadMsg > 0" class="notificationChat">{{gr.unreadMsg}}</span>-->\n                            <span ng-if="gr.unreadMsg > 0" class="notificationChat">{{ gr.unreadMsg > 99 ? "+99" : gr.unreadMsg}}</span>\n                            <div  ng-if="gr.isGroup" style="white-space: nowrap; display: inline-block; margin-top: 14px; margin-right: 15px;" >\n                                <i class="ion-eye iconNgTable edit" style="padding: 0 5px;"\n                                   uib-tooltip="{{\'BUTTONS.VIEW\' | translate}}"\n                                   aria-hidden="true"\n                                   tooltip-append-to-body="true"\n                                   tagaste-click="cnList.view(gr); $event.stopPropagation();">\n                                </i>\n                                <i class="fa fa-pencil iconNgTable edit" style="padding: 0 5px;"\n                                   uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                   aria-hidden="true"\n                                   tooltip-append-to-body="true"\n                                   tagaste-click="cnList.edit(gr); $event.stopPropagation();">\n                                </i>\n                                <i class="fa fa-trash-o iconNgTable edit" style="padding: 0 5px;"\n                                   uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                   aria-hidden="true"\n                                   tooltip-append-to-body="true"\n                                   tagaste-click="cnList.delete(gr); $event.stopPropagation();">\n                                </i>\n                            </div>\n                        </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="row" ng-if="!cnList.selected._id">\n        <div class="col-xs-3 pull-right">\n            <button type="button" id="newUsersButton"\n                    ng-if="cnList.gotAccessMod"\n                    ng-click="cnList.new();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton"\n                    ng-disabled="cnList.istour">\n                <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n            </button>\n        </div>\n    </div>\n</div>\n\n\n\n\n');
$templateCache.put('app/components/chat/chatModNew/chatModNew.html','<div\n    ba-panel ba-panel-title-no-translate="{{cnModNew.tit}}"\n    ba-panel-class="with-scroll"\n    ba-panel-anim="zoom-in"\n    style="line-height:30px;"\n    id="usersDetail">\n    <form name="cnModNewFrom" autocomplete="false">\n        <div class="row">\n            <div class="col-xs-12"\n                 ng-if="cnModNew.selected.action === \'new\' && cnModNew.constants.branches.length > 1">\n                <div class="input-group" id="menuDetailPlaces">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'CHATWINDOWNEWMOD.RESIDENCE\' | translate}}"\n                                          tooltip-placement="right">\n                                        <span class="ion-card"/>\n                                    </span>\n                    <ui-select ng-model="cnModNew.item.branch"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               ng-change="cnModNew.changeBranches()"\n                               append-to-body="true"\n                               search-enabled="true">\n                        <ui-select-match placeholder="{{\'CHATWINDOWNEWMOD.RESIDENCE\'| translate}}">\n                            {{cnModNew.item.branch.description}}\n                        </ui-select-match>\n                        <ui-select-choices\n                            repeat="branches in cnModNew.constants.branches|\n                                     findResidence:{find:$select.search,alredy:cnModNew.item.branch}">\n                            <span ng-bind-html="branches.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n            <div class="col-xs-12">\n                <div class="input-group">\n                                <span\n                                    uib-tooltip="{{\'CHATWINDOWNEWMOD.NAME\' | translate}}"\n                                    class="input-group-addon input-group-addon-primary addon-left"><span\n                                    class="ion-android-person"></span></span>\n                    <input type="text"\n                           name="name"\n                           required\n                           ng-disabled="cnModNew.readonly"\n                           class="form-control with-primary-addon"\n                           autocomplete="false"\n                           placeholder="{{\'CHATWINDOWNEWMOD.NAME\'|translate}}"\n                           aria-describedby="basic-addon1"\n                           ng-model="cnModNew.item.name">\n                </div>\n                <div class="errorValidation bounceIn animate"\n                     ng-if="(cnModNewFrom.name.$touched || cnModNewFrom.submitted)  &&\n                     (!cnModNewFrom.name.$valid || cnModNew.item.name === \'\')">\n                    {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-sm-12">\n                <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              uib-tooltip="{{\'CHATWINDOWNEWMOD.RESIDENTS\' | translate}}"\n                              tooltip-placement="top-left">\n                            <span class="ion-android-person"></span>\n                        </span>\n                    <ui-select multiple ng-model="cnModNew.item.membersResidents"\n                               ng-disabled="cnModNew.readonly"\n                               close-on-select="false"\n                               style="min-height: 101px"\n                               append-to-body="true"\n                               name="members">\n                        <ui-select-match\n                            allow-clear="true"\n                            placeholder="{{\'CHATWINDOWNEWMOD.SELECT\'| translate}} {{\'CHATWINDOWNEWMOD.RESIDENTS\'|\n                            translate}}">\n                            {{$item.nameRoom}}\n                        </ui-select-match>\n                        <ui-select-choices\n                            repeat="option in cnModNew.residentList |\n                            findAppUserGroup:{find:$select.search,alredy:cnModNew.item.members,\n                            alredyFloor:cnModNew.alredyFloor}">\n                            <div\n                                ng-bind-html="option.nameRoom | highlight: $select.search"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n            <div class="col-xs-12">\n                <div class="input-group" id="usu">\n                    <span class="input-group-addon input-group-addon-primary addon-left"\n                          uib-tooltip="{{\'CHATWINDOWNEWMOD.USERS\' | translate}}"\n                          tooltip-placement="right">\n                        <span class="ion-card"></span>\n                    </span>\n                    <ui-select multiple ng-model="cnModNew.item.membersUsers"\n                               append-to-body="true"\n                               ng-disabled="cnModNew.readonly"\n                               search-enabled="true">\n                        <ui-select-match\n                            placeholder="{{\'CHATWINDOWNEWMOD.SELECT\'| translate}}\n                            {{\'CHATWINDOWNEWMOD.USERS\'| translate}}">\n                            {{$item.fullName}}\n                        </ui-select-match>\n                        <ui-select-choices\n                            repeat="usu in cnModNew.constants.users\n                            |findUserRole:{find:$select.search,alredy:cnModNew.item.membersUsers}">\n                            <span ng-bind-html="usu.fullName| highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="pull-right" style="margin-top:17px;">\n                <button style="margin-right:17px;margin-top:30px;margin-bottom:7px;"\n                        name="cnModNewBack"\n                        type="button"\n                        ng-if="cnModNew.readonly"\n                        ng-click="cnModNew.back()"\n                        class="btn btn-success btn-with-icon"\n                        ng-disabled="cnModNew.istour">\n                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                </button>\n                <button\n                    style="margin-right:17px;margin-top:30px;margin-bottom:7px;"\n                    type="button"\n                    id="cnModNewCancelButton"\n                    ng-click="cnModNew.back()"\n                    ng-if="!cnModNew.readonly"\n                    class="btn btn-success btn-with-icon"\n                    ng-disabled="cnModNew.istour">\n                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                </button>\n                <button\n                    style="margin-right:17px;margin-top:30px;margin-bottom:7px;"\n                    type="button"\n                    id="cnModNewSaveButton"\n                    ng-click="cnModNew.save(cnModNewFrom)"\n                    ng-if="!cnModNew.readonly"\n                    ng-disabled="( cnModNew.submitted &&  !cnModNewFrom.$valid)||(cnModNew.istour)"\n                    class="btn btn-success btn-with-icon">\n                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                </button>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-xs-12" style="margin-top:13px;">\n                <p ng-if="cnModNew.submitted && !cnModNew.readonly && !cnModNewFrom.$valid"\n                   class="pull-right errorValidation bounceIn animate">{{\'ERROR.ERRORININPUT\' |translate}}</p>\n            </div>\n        </div>\n    </form>\n</div>');
$templateCache.put('app/components/country/selectCountry/selectCountry.html','<div class="input-group">\n    <span class="input-group-addon input-group-addon-primary addon-left"\n          uib-tooltip="{{selc.title}}"\n          tooltip-placement="top-left">\n        <span ng-class="selc.icon"></span>\n    </span>\n    <ui-select ng-model="selc.var"\n               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n               class="btn-group bootstrap-select form-control"\n               ng-disabled="selc.readonly"\n               ng-change="selc.selectChange();"\n               append-to-body="true"\n               search-enabled="true">\n        <ui-select-match placeholder="{{\'RESIDENTWINDOWDETAIL.SELECT\'| translate}} {{selc.title}}">\n            <span ng-if="(selc.var.name && selc.var.name !== \'\')"> {{selc.var.name}} </span>\n            <span ng-if="!(selc.var.name && selc.var.name !== \'\')" style="color:#b2b1b1">\n            {{\'RESIDENTWINDOWDETAIL.SELECT\'| translate}} {{selc.title}}\n            </span>\n        </ui-select-match>\n        <ui-select-choices\n            repeat="country in selc.list | uiSelectFilter: {name:$select.search}">\n            <span ng-bind-html="country.name| highlight: $select.search"></span>\n        </ui-select-choices>\n    </ui-select>\n    <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n          ng-click="selc.clear()"\n          ng-style="{cursor: (selc.readonly) ? \'default\' : \'pointer\'}">\n    </span>\n</div>');
$templateCache.put('app/components/inService/inServiceDetail/inServiceDetail.html','<div class="detail-panel">\n    <div ba-panel ba-panel-title="SERVICEMENUDETAIL.TITLE" ba-panel-class="with-scroll"\n        ba-panel-anim="zoom-in"\n        style="line-height:30px;" id="serviceDetail">\n        <form name="serForm">\n            <div class="row">\n                <div class="col-md-6">\n                    <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                uib-tooltip="{{\'CANTEENDETAIL.SELECTRESIDENCE\' | translate}}"\n                                tooltip-placement="bottom-left" id="idTootipPlacement">\n                                <span class="ion-card"></span>\n                        </span>\n                        <ui-select\n                            name="selRes"\n                            ng-disabled="scedetc.readonly"\n                            required="true"\n                            ng-class="{\'noValid\': (serForm.selRes.$touched || scedetc.submitted) && !scedetc.readonly && !serForm.selRes.$valid}"\n                            ng-model="scedetc.serviceBD.branch"\n                            class="btn-group bootstrap-select form-control"\n                            ng-disabled="false"\n                            append-to-body="true"\n                            search-enabled="true">\n                            <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}" style="min-width: 117px;">\n                                {{scedetc.serviceBD.branch.description}}\n                            </ui-select-match>\n                            <ui-select-choices\n                                repeat="branch in scedetc.constants.branch| findResidence:\n                                {alredy:scedetc.serviceBD.branch,find:$select.search}">\n                                <span ng-bind-html="branch.description | highlight: $select.search"></span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="(serForm.selRes.$touched || scedetc.submitted) && !scedetc.readonly && !serForm.selRes.$valid">\n                        {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                    </div>\n\n                </div>\n                <div class="col-md-6">\n                    <div class="row">\n                        <div class="col-md-6">\n                            <ba-switcher class="pull-right"\n                                        ng-if="scedetc.servic._id !== \'0\'"\n                                        switcher-style="primary" switcher-value="scedetc.serviceBD.active"\n                                        switcher-on="\'SERVICEMENUDETAIL.ACTIVE\'|translate"\n                                        switcher-off="\'SERVICEMENUDETAIL.ACTIVE\'|translate"\n                                        switcher-read-only="scedetc.readonly"\n                                        uib-tooltip="{{\'SERVICEMENUDETAIL.ACTIVE\' | translate}}"\n                                        tooltip-placement="bottom">\n                            </ba-switcher>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n\n            <div class="row">\n                <div class="col-md-6">\n                    <div class="input-group">\n                            <span uib-tooltip="{{\'SERVICEMENUDETAIL.SERVICENAME\' | translate}}"\n                                tooltip-placement="bottom-left"\n                                class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-ios-location"></span></span>\n                        <input type="text"\n                            required\n                            ng-class="{\'invalid\' : (serForm.name.$touched || scedetc.submitted) &&\n                            !scedetc.readonly && !serForm.name.$valid}"\n                            name="name"\n                            ng-disabled="scedetc.readonly"\n                            class="form-control with-primary-addon"\n                            placeholder="{{\'SERVICEMENUDETAIL.SERVICENAME\'|translate}}"\n                            aria-describedby="basic-addon1"\n                            ng-model="scedetc.serviceBD.name">\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="(serForm.name.$touched || scedetc.submitted) &&\n                        !scedetc.readonly && !serForm.name.$valid">\n                        {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                    </div>\n                </div>\n                <div class="col-md-6">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'SERVICEMENUDETAIL.PRICE\' | translate}}"\n                            tooltip-placement="bottom-left"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-social-euro"></span>\n                        </span>\n                        <input type="text"\n                            ng-disabled="scedetc.readonly"\n                            class="form-control with-primary-addon"\n                            placeholder="{{\'SERVICEMENUDETAIL.PRICE\'|translate}}"\n                            aria-describedby="basic-addon1"\n                            pattern="\\d+(\\.\\d{1,2})?"\n                            style="width: 70px;"\n                            name="cost"\n                            ng-model="scedetc.serviceBD.cost.value">\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="(serForm.cost.$touched|| scedetc.submitted) && !scedetc.readonly && !serForm.cost.$valid">\n                        {{\'ERROR.NOTVALIDINPUTDOUBLE\' |translate}}\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                uib-tooltip="{{\'SERVICEMENUDETAIL.TEXT\' | translate}}"\n                                tooltip-placement="bottom-left"\n                                style="vertical-align: top">\n                                <span class="ion-android-create"></span>\n                        </span>\n                        <textarea ng-model="scedetc.serviceBD.description"\n                                ng-disabled="scedetc.readonly"\n                                name="description"\n                                required\n                                ng-class="{\'invalid\': (serForm.description.$touched|| scedetc.submitted) &&\n                                !scedetc.readonly && !serForm.description.$valid}"\n                                class="form-control with-primary-addon"\n                                aria-describedby="basic-addon1"\n                                ng-disabled="scedetc.readonly"\n                                placeholder="{{\'SERVICEMENUDETAIL.TEXT\'|translate}}">\n                        </textarea>\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="(serForm.text.$touched|| scedetc.submitted) && !scedetc.readonly && !serForm.text.$valid">\n                        {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-6">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'SERVICEMENUDETAIL.MAXHOURDAY\' | translate}}"\n                            tooltip-placement="bottom-left"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-android-time"></span>\n                        </span>\n                        <input type="text"\n                               ng-disabled="scedetc.readonly"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'SERVICEMENUDETAIL.MAXHOURDAY\'|translate}}"\n                               aria-describedby="basic-addon1"\n                               valid-number\n                               ng-model="scedetc.serviceBD.maxRange">\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-md-12">\n                    <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                uib-tooltip="{{\'SERVICEMENUDETAIL.HORARIO\' | translate}}"\n                                tooltip-placement="bottom-left"\n                                style="vertical-align: top" ng-disabled="scedetc.readonly">\n                        <span class="ion-android-create"></span></span>\n                        <div data-my-timetable="" data-slots="scedetc.slots" data-disabled="(scedetc.readonly || scedetc.istour )"></div>\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-xs-12" style="margin-top:13px;">\n                    <p ng-if="scedetc.submitted && !scedetc.readonly && !serForm.$valid"\n                    class="pull-right errorValidation bounceIn animate">{{\'ERROR.ERRORININPUT\' |translate}}</p>\n                </div>\n            </div>\n        </form>\n        <div class="panel-footer-buttons">\n            <div class="row">\n                <div class="col-xs-6 pull-left">\n                    <button style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button" id="servicePush"\n                            ng-if="scedetc.readonly && !scedetc.servic.fromAnnouncement ||\n                            scedetc.servic.action === \'inEdit\' && !scedetc.servic.fromAnnouncement"\n                            ng-disabled="scedetc.arrInvolveds.length === 0 || scedetc.selectedResident._id ||\n                            scedetc.disabledPush"\n                            ng-click="scedetc.notify()" class="btn btn-success btn-with-icon">\n                        <i class="ion-iphone"></i>{{\'BUTTONS.NOTIFY\' |translate}}\n                    </button>\n                </div>\n                <div class="col-xs-6 pull-right">\n                    <button id="serviceSaveButton"\n                            style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                            ng-if="!scedetc.readonly"\n                            ng-disabled="(scedetc.istour) || (!scedetc.servic.action === \'inEdit\') || ( scedetc.submitted &&  !serForm.$valid)"\n                            ng-click="scedetc.save(serForm)" class="btn btn-success btn-with-icon pull-right">\n                        <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                    </button>\n                    <button id="serviceCancelButton"\n                            style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                            ng-if="!scedetc.readonly"\n                            ng-disabled="scedetc.istour"\n                            ng-click="scedetc.cancel()" class="btn btn-success btn-with-icon pull-right">\n                        <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                    </button>\n                    <button style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                            ng-if="scedetc.readonly"\n                            ng-disabled="scedetc.istour"\n                            ng-click="scedetc.cancel()"\n                            class="btn btn-success btn-with-icon pull-right">\n                        <i class=" ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n\n</div>\n');
$templateCache.put('app/components/inService/inServiceList/inServiceList.html','<div class="row" ng-click="serlc.backifModifOrNew();">\n    <div class="col-xs-12">\n        <div ba-panel ba-panel-title="{{\'SERVICEMENULIST.TITLE\'|translate}}"\n             ba-panel-class="with-scroll"\n             id="servicesList">\n            <div ng-if="!serlc.showReserveView" class="resumeTourContainer" style="left: 250px!important;">\n                <span class="ion-ios-information-outline"\n                      tagaste-click="serlc.initTour()"\n                      style="cursor: pointer;"></span>\n            </div>\n            <div class="horizontal-scroll" ng-class="(!serlc.servic._id) ? \'\': \'hideTableCounts\'">\n                <table ng-table="serlc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true">\n\n                    <colgroup ng-if="!serlc.servic._id  && serlc.userBranch.length === 1">\n                        <col width="80%">\n                        <col width="10%">\n                        <col width="10%">\n                    </colgroup>\n\n                    <colgroup ng-if="!serlc.servic._id  && serlc.userBranch.length > 1">\n                        <col width="17%">\n                        <col width="63%">\n                        <col width="10%">\n                        <col width="10%">\n                    </colgroup>\n\n                    <colgroup ng-if="serlc.servic._id">\n                        <col width="100%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data |dummyDataIfEmpty:serlc.tourDummyData |showErrorNoData track by $index"\n                        style="cursor:pointer;"\n                        ng-click="serlc.tableParamsCK(row);$event.stopPropagation();"\n                        ng-class="{\'firstListRow\': $index === 0, \'selectRow\': row.selected === true}"\n                        class="ng-binding">\n                        <td colspan="4" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'SERVICEMENULIST.PLACE\'|translate"\n                            sortable="\'branchDescription\'"\n                            filter="serlc.filterDescription"\n                            ng-if="!serlc.servic._id  && serlc.userBranch.length > 1"\n                            style="text-align: left;"\n                            ng-attr-title="{{row.branchDescription}}">\n                            {{row.branchDescription}}\n                        </td>\n                        <td data-title="\'SERVICEMENULIST.SERVICENAME\'|translate"\n                            sortable="\'title\'"\n                            filter="serlc.filterTitle"\n                            style="text-align: left;"\n                            ng-attr-title="{{row.title}}">\n                            {{row.title}}\n                        </td>\n                        <td data-title="\'SERVICEMENULIST.PRICE\'|translate"\n                            sortable="\'rate\'"\n                            filter="serlc.filterPrice"\n                            ng-if="!serlc.servic._id"\n                            class="text-left"\n                            ng-attr-title="{{row.rate}}">\n                            {{row.rate | currency}}\n                        </td>\n                        <td ng-if="!serlc.servic._id && !row.error" class="text-center" style="white-space: nowrap;">\n                            <span class="fa fa-pencil iconNgTable edit"\n                                  aria-hidden="true"\n                                  ng-if="serlc.gotAccessMod"\n                                  ng-click="serlc.editRow(row); $event.stopPropagation();">\n                            </span>\n                            <span class="fa fa-trash-o iconNgTable edit"\n                                  aria-hidden="true"\n                                  style="margin-left: 10px;"\n                                  ng-if="serlc.gotAccessDel"\n                                  ng-click="serlc.deleteRow(row); $event.stopPropagation();"\n                                  style="font-size:17pt;">\n                            </span>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="(!serlc.servic._id && !serlc.showReserveView)" type="button">\n                <div class="col-xs-12 countAndNewButton" style="display: flex; align-items: center;">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ serlc.tableParams.total() }}</span>\n                    </span>\n                    <button ng-click="serlc.new();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton"\n                            ng-if="serlc.gotAccessMod"\n                            ng-disabled="serlc.istour"\n                            id="newServiceButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                    <button type="button"\n                    tagaste-click="serlc.exportData();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<div class="row">\n    <div class="col-xs-12">\n        <div ba-panel id="servicesScheduler">\n            <div ng-class="(!serlc.servic._id && !serlc.showReserveView) ? \'\': \'hideTableCounts\'">\n                <!--SCHEDULER-->\n                <div class="row" style="font-size: 11px; font-weight: bold;">\n                    <schedule model="serlc.model" istour="serlc.istour" on-change="serlc.dayChanged(day)"></schedule>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/inService/inServiceReserve/inServiceReserve.html','<div class="row" style="max-height: 617px;">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="RESERVE.RESERVE"\n             ba-panel-anim="zoom-in" style="line-height: 30px;">\n            <form name="resForm" autocomplete="false">\n                <div class="row">\n                    <div class="col-xs-4 col-md-4 col-sm-4" style="z-index: 2;">\n                        <label class="custom-checkbox">\n                            <input id="checkResidente" type="checkbox" ng-model="serresc.isResident"\n                                   ng-click="serresc.changeIsResident(true)" ng-disabled="serresc.modeCancel">\n                            <span>{{\'RESERVE.RESIDENT\'|translate}}</span>\n                        </label>\n                        <br/>\n                        <label class="custom-checkbox">\n                            <input id="checkExterno" type="checkbox" ng-model="serresc.isGuest"\n                                   ng-click="serresc.changeIsResident(false)" ng-disabled="serresc.modeCancel">\n                            <span>{{\'RESERVE.EXTERN\'|translate}}</span>\n                        </label>\n                    </div>\n                    <div ng-class="(serresc.level > 2) ? \'col-md-8\' : \'col-md-8\'" ng-if="!serresc.isResident" style="z-index: 1;">\n                        <div class="row">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'RESERVE.NAME\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left">\n                                <span class="ion-android-person"></span></span>\n                                <input type="text"\n                                       ng-class="{\'invalid\': (resForm.name.$touched ||\n                                    serresc.submitted ) && !serresc.modeCancel && !resForm.name.$valid }"\n                                       required = "!serresc.isResident"\n                                       ng-model="serresc.selectedName"\n                                       placeholder="{{\'RESERVE.NAME\'|translate}}"\n                                       uib-typeahead="o as o.fullName for o in serresc.getGuestsByName($viewValue)"\n                                       typeahead-loading="loadingGuest"\n                                       typeahead-no-results="noGuestName" class="form-control"\n                                       typeahead-wait-ms="700"  typeahead-min-length=\'3\'\n                                       typeahead-on-select="serresc.setGuest($item)"\n                                       ng-disabled="serresc.modeCancel">\n                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                <div ng-show="noGuestName">\n                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                </div>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="( resForm.name.$touched || serresc.submitted )&& !serresc.modeCancel &&\n                            !resForm.name.$valid">{{\'ERROR.NOTVALIDINPUT\' |translate}}</div>\n                            <div class="input-group">\n                                <input type="text" ng-disabled="serresc.modeCancel" name="surname"\n                                       class="form-control with-primary-addon"\n                                       ng-class="{\'invalid\': ( resForm.surname.$touched ||\n                                        serresc.submitted ) && !resForm.surname.$valid}"\n                                       placeholder="{{\'RESERVE.LASTNAME\'|translate}}"\n                                       style="border-radius: 5px;"\n                                       required = "!serresc.isResident"\n                                       ng-model="serresc.selectedSurname"\n                                       uib-typeahead="o as o.fullName for o in serresc.getGuestsBySurname($viewValue) "\n                                       typeahead-loading="loadingGuest"\n                                       typeahead-no-results="noGuestSurname" class="form-control"\n                                       typeahead-wait-ms="700"  typeahead-min-length=\'3\'\n                                       typeahead-on-select="serresc.setGuest($item)"\n                                       ng-disabled="serresc.modeCancel">\n                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                <div ng-show="noGuestSurname">\n                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                </div>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="( resForm.surname.$touched || serresc.submitted ) &&\n                                        !resForm.surname.$valid">\n                                {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'RESERVE.IDENTIFICATION\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left ">\n                                <span class="ion-card"></span></span>\n                                <input type="text" name="dni"\n                                       ng-change="serresc.validDNI(serresc.selectedDocVal,\n                                    serresc.selectedDocType.description,resForm.dni)"\n                                       ng-blur="serresc.validDNI(serresc.selectedDocVal,\n                                    serresc.selectedDocType.description,resForm.dni)"\n                                       ng-disabled="serresc.modeCancel" class="form-control with-primary-addon"\n                                       placeholder="{{\'RESERVE.IDENTIFICATION\'|translate}}"\n                                       ng-model="serresc.selectedDocVal"\n                                       uib-typeahead="o as o.identity.docVal for o in serresc.getGuestsById($viewValue) "\n                                       typeahead-loading="loadingGuest"\n                                       typeahead-no-results="noGuestId" class="form-control"\n                                       typeahead-wait-ms="700"  typeahead-min-length=\'5\'\n                                       typeahead-on-select="serresc.setGuest($item)"\n                                       ng-disabled="serresc.modeCancel">\n                                <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                <div ng-show="noGuestId">\n                                    <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\'|translate}}\n                                </div>\n                                <span style="width: 51px"\n                                      class="input-group-addon input-group-addon-primary addon-right"\n                                      ng-click="serresc.changeTypeIde(serresc.selectedDocType);\n                                    serresc.validDNI(serresc.selectedDocVal,\n                                    serresc.selectedDocType,resForm.dni)"\n                                      ng-style="(serresc.modeCancel) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                    {{serresc.selectedDocType.description}}</span>\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="!resForm.dni.$valid">\n                                {{\'ERROR.GENERROR0\' |translate}}\n                                {{\'RESERVE.IDENTIFICATION\'|translate}}\n                                {{\'ERROR.GENERROR1\' |translate}}\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="input-group">\n                                    <span uib-tooltip="{{\'RESERVE.EMAIL\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-at"></span></span>\n                                <input type="text" ng-disabled="serresc.modeCancel" name="email"\n                                       ng-change="serresc.validEmail(serresc.selectedEmail,resForm.email)"\n                                       ng-blur="serresc.validEmail(serresc.selectedEmail,resForm.email)"\n                                       class="form-control with-primary-addon"\n                                       placeholder="{{\'RESERVE.EMAIL\'|translate}}"\n                                       ng-model="serresc.selectedEmail"\n                                       ng-disabled="serresc.modeCancel">\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="!resForm.email.$valid">\n                                {{\'ERROR.NOTVALIDEMAIL\' |translate}}\n                            </div>\n                            <div class="input-group">\n                                <span uib-tooltip="{{\'RESERVE.PHONE\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left">\n                                    <span class="ion-ios-telephone"></span></span>\n                                <input type="text" name="mobile"\n                                       ng-change="serresc.validateMobile(serresc.selectedPhone,\n                                    resForm.mobile)"\n                                       ng-blur="serresc.validateMobile(serresc.selectedPhone,\n                                    resForm.mobile)"\n                                       ng-disabled="serresc.modeCancel" class="form-control with-primary-addon"\n                                       placeholder="{{\'RESERVE.PHONE\'|translate}}"\n                                       ng-model="serresc.selectedPhone"\n                                       ng-disabled="serresc.modeCancel">\n                            </div>\n                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                 ng-if="!resForm.mobile.$valid">\n                                {{\'ERROR.GENERROR0\' |translate}}\n                                {{\'RESERVE.PHONE\'|translate}}\n                                {{\'ERROR.GENERROR1\' |translate}}\n                            </div>\n                        </div>\n                    </div>\n                    <div ng-class="(serresc.level > 2) ? \'col-md-8\' : \'col-md-8\'" ng-if="serresc.isResident">\n                        <div class="input-group"\n                             ng-style="(resForm.appUser.$touched && resForm.appUser.$invalid ||\n                            resForm.appUser.$error.required && adetc.showError) ?\n                            {\'margin-bottom\': 0}:\'\'"\n                             ng-disabled="serresc.modeCancel">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'RESERVE.RESIDENT\' | translate}}"\n                                  tooltip-placement="bottom-left">\n                                <span class="ion-android-person"></span>\n                            </span>\n                            <ui-select ng-model="serresc.appUser"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       append-to-body="false"\n                                       ng-required="serresc.isResident"\n                                       ng-disabled="serresc.modeCancel"\n                                       name="appUser"\n                                       ng-change="serresc.parseUserListBy();"\n                                       ng-class="{invalid: resForm.appUser.$touched && resForm.appUser.$invalid || resForm.appUser.$error.required && serresc.showError}"\n                                       search-enabled="true">\n                                <ui-select-match\n                                    allow-clear=true\n                                    placeholder="{{\'RESERVE.RESIDENT\'| translate}}">\n                                    {{serresc.appUser.fullName}}\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in serresc.appUsers |\n                                findAppUserGroupe:{find:$select.search,alredy:serresc.activity.appUsers,\n                                alredyFloor:serresc.alredyFloor}">\n                                    <div ng-style="(option.allFloor) ? {\'margin-left\': \'0\',\'font-weight\' : \'900\'}:\n                                    {\'margin-left\': \'17px\'}"\n                                         ng-bind-html="option.nameRoom | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <span ng-show="resForm.appUser.$touched && resForm.appUser.$invalid ||\n                            resForm.appUser.$error.required && adetc.showError" class="msgError">\n                            {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                    <div class="row">\n                        <div class="pull-right">\n                            <button class="btn btn-success btn-with-icon"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    tagaste-click="serresc.back()">\n                                <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                            </button>\n                            <button class="btn btn-success btn-with-icon"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    tagaste-click="serresc.cancel()" ng-if="serresc.modeCancel">\n                                <i class="ion-trash-b"></i>{{\'BUTTONS.DELETERESERVE\' |translate}}\n                            </button>\n                            <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    tagaste-click="serresc.save(resForm)"\n                                    ng-if="!serresc.modeCancel"\n                                    ng-disabled="serresc.submitted && !resForm.$valid "\n                                    class="btn btn-success btn-with-icon">\n                                <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                            </button>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-xs-12" style="margin-top:13px;">\n                            <p ng-if="serresc.submitted && !serresc.modeCancel && !serresc.$valid"\n                               class="pull-right errorValidation bounceIn animate">\n                                {{\'ERROR.ERRORININPUT\' |translate}}</p>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/inWorkerTask/inWorkerTaskDetail/inWorkerTaskDetail.html','<div ba-panel ba-panel-title="WORKERTASKDETAIL.TITLE" ba-panel-class="with-scroll"\n     ba-panel-anim="zoom-in"\n     style="line-height:30px;" id="workerTaskDetail">\n    <form name="workTaskForm">\n        <div class="row">\n            <div class="col-md-6">\n                <div class="row">\n                    <div class="col-md-12">\n                        <date-picker-comp tooltip-text="\'WORKERTASKDETAIL.DATEFROM\' | translate"\n                                          tooltip-placement="bottom-left"\n                                          date-value="schlcdetc.workerBD.dateFrom"\n                                          is-required="true" append-to-body="true"\n                                          date-options="schlcdetc.dateOptions"\n                                          show-required-error="schlcdetc.showError"\n                                          id="idWTTootipPlacement"\n                                          form-reference="workTaskForm"\n                                          special-validation="schlcdetc.checkDates()"\n                                          name-field="\'dateFrom\'"></date-picker-comp>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-12">\n                        <date-picker-comp tooltip-text="\'WORKERTASKDETAIL.DATETO\' | translate"\n                                          tooltip-placement="bottom-left"\n                                          date-value="schlcdetc.workerBD.dateTo"\n                                          is-required="true" append-to-body="true"\n                                          date-options="schlcdetc.dateOptions"\n                                          show-required-error="schlcdetc.showError"\n                                          form-reference="workTaskForm"\n                                          special-validation="schlcdetc.checkDates()"\n                                          name-field="\'dateTo\'"></date-picker-comp>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-12">\n                <div ng-repeat="task in schlcdetc.taskTypes track by $index">\n                    <div class="checkbox" ng-click="schlcdetc.changeTask(task)">\n                        <label class="custom-checkbox">\n                            <input type="checkbox" id="{{$task.code}}" name="{{$task.code}}"\n                                   ng-disabled="schlcdetc.readonly"\n                                   ng-checked="task.selected">\n                            <span>{{task.description}}</span>\n                        </label>\n                    </div>\n                    <div ng-repeat="subtask in task.subtype track by $index">\n                        <div class="checkbox" ng-click="schlcdetc.changeSubtask(subtask)"\n                             style="margin-left: 20px;">\n                            <label class="custom-checkbox">\n                                <input type="checkbox" id="{{$subtask.code}}" name="{{$subtask.code}}"\n                                       ng-disabled="schlcdetc.readonly"\n                                       ng-checked="subtask.selected">\n                                <span>{{subtask.description}}</span>\n                            </label>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-md-12">\n                <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              uib-tooltip="{{\'WORKERTASKDETAIL.COMMENTS\' | translate}}"\n                              tooltip-placement="bottom-left"\n                              style="vertical-align: top">\n                            <span class="ion-android-create"></span></span>\n                    <textarea ng-model=" schlcdetc.workerBD.comments"\n                              ng-disabled="schlcdetc.readonly"\n                              name="comments"\n                              required\n                              ng-class="{\'invalid\': (workTaskForm.comments.$touched|| schlcdetc.submitted) &&\n                              !schlcdetc.readonly && !workTaskForm.comments.$valid}"\n                              class="form-control with-primary-addon"\n                              aria-describedby="basic-addon1"\n                              ng-disabled="schlcdetc.readonly"\n                              placeholder="{{\'WORKERTASKDETAIL.COMMENTS\'|translate}}">\n                    </textarea>\n                </div>\n                <div class="errorValidation bounceIn animate"\n                     ng-if="(workTaskForm.comments.$touched|| schlcdetc.submitted) && !schlcdetc.readonly && !workTaskForm.text.$valid">\n                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                </div>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-xs-6 pull-left">\n                <button id="workerTaskSaveButton"\n                        style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                        ng-if="!schlcdetc.readonly"\n                        ng-disabled="(schlcdetc.istour) || (! schlcdetc.worker.action === \'inEdit\') || ( schlcdetc.submitted &&  !workTaskForm.$valid)"\n                        ng-click="schlcdetc.save(workTaskForm)" class="btn btn-success btn-with-icon pull-right">\n                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                </button>\n            </div>\n            <div class="col-xs-6 pull-right">\n                <button id="workerTaskCancelButton"\n                        style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                        ng-if="!schlcdetc.readonly"\n                        ng-disabled="schlcdetc.istour"\n                        ng-click="schlcdetc.cancel()" class="btn btn-success btn-with-icon pull-right">\n                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' | translate}}\n                </button>\n                <button style="margin-right:17px;margin-top:30px;margin-bottom:7px;" type="button"\n                        ng-if="schlcdetc.readonly"\n                        ng-disabled="schlcdetc.istour"\n                        ng-click="schlcdetc.cancel()"\n                        class="btn btn-success btn-with-icon pull-right">\n                    <i class=" ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' | translate}}\n                </button>\n            </div>\n        </div>\n        <div class="row">\n            <div class="col-xs-12" style="margin-top:13px;">\n                <p ng-if="schlcdetc.submitted && !schlcdetc.readonly && !workTaskForm.$valid"\n                   class="pull-right errorValidation bounceIn animate">{{\'ERROR.ERRORININPUT\' | translate}}</p>\n            </div>\n        </div>\n    </form>\n</div>\n');
$templateCache.put('app/components/inWorkerTask/inWorkerTaskList/inWorkerTaskList.html','<div class="row">\n    <div class="col-xs-12">\n        <div ba-panel ba-panel-title="{{\'WORKERTASKLIST.TITLE\'|translate}}"\n             ba-panel-class="with-scroll"\n             id="servicesList">\n            <div ba-panel id="workerTaskScheduler">\n                <!--SCHEDULER-->\n                <div class="row" style="font-size: 11px; font-weight: bold;">\n                    <schedule model="schlc.model" on-change="schlc.dayChanged(day)"></schedule>\n                    <p ng-if="!(schlc.model.items && schlc.model.items.length)"\n                    style="font-size: 18px; text-align: center; position: relative; top: 10px;">{{\'WORKERTASKLIST.NO_TASK\'|translate}}</p>\n                </div>\n            </div>\n            <div>\n                <div class="pull-right">\n                    <button type="button"\n                    tagaste-click="schlc.exportData();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                 </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/inWorkerTask/workerTaskModal/workerTaskModal.html','<div class="modal-body" style="padding: 0;">\n    <div class="row">\n        <div class="col-xs-12">\n            <div ba-panel ba-panel-title="WORKERTASKDETAIL.TASK" ba-panel-anim="zoom-in" style="line-height:30px;">\n                <!--task & worker-->\n                <div class="row">\n                    <div class="col-sm-6 col-xs-12">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'WORKERTASKDETAIL.TASK_NAME\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  id="wTaskNameTooltip">\n                                <span class="modalIcon ion-compose"></span></span>\n                            <input type="text" name="taskName" ng-disabled="true"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'WORKERTASKDETAIL.TASK_NAME\'|translate}}"\n                                   ng-model="mod.task[\'wtaskname\']">\n                        </div>\n                    </div>\n                    <div class="col-sm-6 col-xs-12">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'WORKERTASKDETAIL.WORKER_NAME\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  id="workerName">\n                                <span class="modalIcon ion-android-person"></span></span>\n                            <input type="text" name="workerName" ng-disabled="true"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'WORKERTASKDETAIL.WORKER_NAME\'|translate}}"\n                                   ng-model="mod.task[\'worker\'][\'fullname\']">\n                        </div>\n                    </div>\n                </div>\n                <!--planned & real dates-->\n                <div class="row">\n                    <div class="col-sm-6 col-xs-12">\n                        <div class="modalTitle">\n                            <div class="modalTitleText">\n                                <span>{{\'WORKERTASKDETAIL.PLANNED\'|translate}}</span>\n                            </div>\n                            <div class="modalTitleBorder"></div>\n                        </div>\n                        <div class="modalContent">\n                            <div class="row">\n                                <div class="col-sm-6 col-xs-12">\n                                    <div class="input-group" style="margin-top: 20px;">\n                                        <span uib-tooltip="{{\'WORKERTASKDETAIL.DATEFROM\'| translate}}"\n                                              class="input-group-addon input-group-addon-primary addon-left"\n                                              id="plannedStartTooltip">\n                                            <span class="modalIcon ion-calendar"></span></span>\n                                        <input type="text" name="plannedStart" ng-disabled="true"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'WORKERTASKDETAIL.DATEFROM\'|translate}}"\n                                               ng-model="mod.task[\'plannedStart\']">\n                                    </div>\n                                </div>\n                                <div class="col-sm-6 col-xs-12">\n                                    <div class="input-group" style="margin-top: 20px;">\n                                        <span uib-tooltip="{{\'WORKERTASKDETAIL.DATETO\'| translate}}"\n                                              class="input-group-addon input-group-addon-primary addon-left"\n                                              id="plannedEndTooltip">\n                                            <span class="modalIcon ion-calendar"></span></span>\n                                        <input type="text" name="plannedEnd" ng-disabled="true"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'WORKERTASKDETAIL.DATETO\'|translate}}"\n                                               ng-model="mod.task[\'plannedEnd\']">\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="col-sm-6 col-xs-12">\n                        <div class="modalTitle">\n                            <div class="modalTitleText">\n                                <span>{{\'WORKERTASKDETAIL.REAL\'|translate}}</span>\n                            </div>\n                            <div class="modalTitleBorder"></div>\n                        </div>\n                        <div class="modalContent">\n                            <div class="row">\n                                <div class="col-sm-4 col-xs-12">\n                                    <date-picker-comp\n                                        id="date"\n                                        placeholder="\'WORKERTASKDETAIL.DATE\' | translate"\n                                        tooltip-text="\'WORKERTASKDETAIL.DATE\' | translate"\n                                        tooltip-placement="bottom"\n                                        date-value="mod.task[\'selectedDate\']"\n                                        is-required="true"\n                                        date-options="mod.dateOptions"\n                                        name-field="\'date\'"\n                                        append-to-body="false"\n                                        mode-read-only="!mod.task[\'plannedStart\']">\n                                    </date-picker-comp>\n                                </div>\n                                <div class="col-sm-4 col-xs-12">\n                                    <div uib-timepicker\n                                         ng-model="mod.task[\'selectedHourFrom\']"\n                                         ng-change="mod.changedHour(mod.task[\'selectedHourFrom\'])"\n                                         hour-step="mod.hstep"\n                                         minute-step="mod.mstep"\n                                         show-meridian="mod.ismeridian"\n                                         show-spinners="mod.showSpinners"></div>\n                                </div>\n                                <div class="col-sm-4 col-xs-12">\n                                    <div uib-timepicker\n                                         ng-model="mod.task[\'selectedHourTo\']"\n                                         ng-change="mod.changedHour(mod.task[\'selectedHourTo\'])"\n                                         hour-step="mod.hstep"\n                                         minute-step="mod.mstep"\n                                         show-meridian="mod.ismeridian"\n                                         show-spinners="mod.showSpinners"></div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <!--buttons-->\n                <div class="row">\n                    <div class="col-xs-12 text-right">\n                        <button class="btn btn-success btn-with-icon"\n                                type="button"\n                                style="margin-right:17px; margin-top:17px; margin-bottom:7px;"\n                                tagaste-click="mod.back()">\n                            <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                        </button>\n                        <button style="margin-right:17px; margin-top:17px; margin-bottom:7px;"\n                                type="button"\n                                tagaste-click="mod.save()"\n                                ng-disable="!mod.task[\'plannedStart\']"\n                                class="btn btn-success btn-with-icon">\n                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/incidents/incidentDetail/incidentDetail.html','<style>\n    .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'INCIDENTDETAIL.UNLIMITED\'|translate}}";\n        margin-left: 10px;\n    }\n\n    .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'INCIDENTDETAIL.HIGH\'|translate}}";\n        margin-left: 10px;\n    }\n\n    .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'INCIDENTDETAIL.LOW\'|translate}}";\n        margin-left: 10px;\n    }\n\n    .nz-toggle-wrap.horizontal.null .nz-toggle-handle:before {\n        content: "\\f26e";\n        font-family: Ionicons;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: inherit;\n        /*--adjust as necessary--*/\n        color: #000;\n        font-size: 12px;\n        position: absolute;\n        top: -5px;\n        left: 5px;\n    }\n\n    .nz-toggle-wrap.horizontal.true .nz-toggle-handle:before {\n        content: "\\f26e";\n        font-family: Ionicons;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: inherit;\n        /*--adjust as necessary--*/\n        color: #000;\n        font-size: 12px;\n        position: absolute;\n        top: -5px;\n        left: 5px;\n    }\n\n    .nz-toggle-wrap.horizontal.false .nz-toggle-handle:before {\n        content: "\\f26e";\n        font-family: Ionicons;\n        font-style: normal;\n        font-weight: normal;\n        text-decoration: inherit;\n        /*--adjust as necessary--*/\n        color: #000;\n        font-size: 12px;\n        position: absolute;\n        top: -5px;\n        left: 5px;\n    }\n</style>\n\n\n<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel incident-panel">\n        <div ba-panel ba-panel-title="{{\'INCIDENTDETAIL.HEADER\'|translate}}" ba-panel-class="with-scroll"\n            ba-panel-anim="zoom-in" style="line-height:30px;" id="incidentDetail">\n            <div class="row">\n                <div class="col-xs-12">\n                    <form name="incidentForm">\n                        <div class="row">\n                            <!-- Left -->\n                            <div class="row">\n                                <div class="col-md-6" id="incidentLeftCol">\n                                    <!--Photos -->\n                                    <div class="row">\n                                        <div class="col-sm-12">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                    uib-tooltip="{{\'INCIDENTDETAIL.IMAGES\' | translate}}"\n                                                    tooltip-placement="right-top" style="vertical-align: top">\n                                                    <span class="ion-camera"></span>\n                                                </span>\n                                                <div style="border: 1px solid rgb(55, 55, 55); max-height: 162px; overflow: auto;"\n                                                    ng-style="idc.incident.photos.length > 2 ? {\'overflow\' : \'auto\'}:\'\'"\n                                                    id="incidentImg">\n                                                    <div ng-include="\'/assets/templates/lightbox.html\'"></div>\n                                                    <div ng-repeat="photo in idc.incident.photos track by $index"\n                                                        ng-if="idc.incident.photos.length > 0"\n                                                        style="display: inline-block; margin: 4px; position: relative;">\n                                                        <div ng-if="!idc.showDisabled">\n                                                            <span class=" ion-minus-circled inDishIcon delete "\n                                                                ng-click="idc.deletePhoto(photo)" ng-if="!idc.disabledFields"\n                                                                ng-disabled="idc.istour"></span>\n                                                        </div>\n                                                        <img ng-src="{{photo.thumb.signedUrl}}" style="width: 150px;"\n                                                            ng-click="idc.openLightboxModal(photo)" ng-disabled="idc.istour">\n                                                    </div>\n                                                    <avatar size="150" img="idc.avatar" avatar-style="display: inline"\n                                                        ng-if="idc.modeCreation || (!idc.disabledFields && !idc.showDisabled)"\n                                                        photo="bbdc.bulletin.photo" readonly="( idc.modeReadOnly || idc.istour )"\n                                                        uploading="bbdc.avatarUploading" istour="idc.istour" style-button="true"\n                                                        photo-list="idc.incident.photos">\n                                                    </avatar>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <!-- Priority Switch and tracking -->\n                                    <div class="row">\n                                        <div class="col-sm-6 col-xs-12">\n                                            <nz-toggle tri-toggle val-default="false" ng-model="idc.tracking.priority" id="priority"\n                                                on-toggle="idc.changePriority(idc.tracking.priority)" val-true="true"\n                                                val-false="false" val-null="null" width="150" style="width: 25px; height: 15px;"\n                                                color-false="\'#60BD68\'" color-true="\'#f15854\'"\n                                                uib-tooltip="{{\'INCIDENTDETAIL.PRIORITY\' | translate}}" tooltip-placement="top-left"\n                                                icon-size="\'20px\'">\n                                            </nz-toggle>\n                                        </div>\n                                        <div class="col-sm-6 col-xs-12 incidents-tracking" ng-if="idc.tracking && idc.tracking.status._id">\n                                            <label>\n                                                <input type="radio" ng-model="idc.tracking.status._id"\n                                                    ng-value="idc.listStatusType[0]._id" style="display: none" />\n                                                <i class="{{idc.listStatusType[0].icon}} radioActive"\n                                                    uib-tooltip="{{idc.listStatusType[0].description}}"></i>\n                                            </label>\n                                            <i class="ion-minus" style="font-size: 30px" ng-class="(idc.tracking.status._id === idc.listStatusType[1]._id ||\n                                                idc.tracking.status._id === idc.listStatusType[2]._id ) ?\n                                                \'radioActive\': \'radioWhite\'">\n                                            </i>\n                                            <label>\n                                                <input type="radio" ng-model="idc.tracking.status._id"\n                                                    ng-value="idc.listStatusType[1]._id" style="display: none" />\n                                                <i class="{{idc.listStatusType[1].icon}}" ng-class="(idc.tracking.status._id === idc.listStatusType[1]._id ||\n                                                    idc.tracking.status._id === idc.listStatusType[2]._id ) ?\n                                                    \'radioActive\': \'radioWhite\'"\n                                                    uib-tooltip="{{idc.listStatusType[1].description}}"></i>\n                                            </label>\n                                            <i class="ion-minus" style="font-size: 30px;" ng-class="( idc.tracking.status._id === idc.listStatusType[2]._id ) ?\n                                                \'radioActive\': \'radioWhite\'">\n                                            </i>\n                                            <label>\n                                                <input type="radio" ng-model="idc.tracking.status._id"\n                                                    ng-value="idc.listStatusType[2]._id" style="display: none" />\n                                                <i class="{{idc.listStatusType[2].icon}}" ng-class="(idc.tracking.status._id === idc.listStatusType[2]._id  ) ?\n                                                    \'radioActive\': \'radioWhite\'"\n                                                    uib-tooltip="{{idc.listStatusType[2].description}}"></i>\n                                            </label>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!-- Right -->\n                                <div class="col-md-6" id="incidentRightCol">\n                                    <div class="row">\n                                        <div class="col-sm-12">\n                                            <date-picker-comp tooltip-text="\'INCIDENTDETAIL.DATE\' | translate"\n                                                tooltip-placement="bottom-left" date-value="idc.createdDate" is-required="true"\n                                                mode-read-only="( idc.disabledFields || idc.showDisabled || idc.istour )"\n                                                date-options="idc.dateOptions" show-required-error="idc.showError"\n                                                form-reference="incidentForm" special-validation="idc.checkDates()"\n                                                name-field="\'createdDate\'"\n                                                msg-special-validation="\'INCIDENTDETAIL.MSGSPECIALVALIDATION\'">\n                                            </date-picker-comp>\n                                        </div>\n                                    </div>\n                                    <!-- Branch residence -->\n                                    <div class="row">\n                                        <div class="col-sm-12" ng-if="!idc.hideSelectResidence">\n                                            <div class="input-group" ng-style="(incidentForm.branch.$touched &&\n                                            incidentForm.branch.$invalid || incidentForm.branch.$error.required && idc.showError) ?\n                                            {\'margin-bottom\': 0}:\'\'">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                    uib-tooltip="{{\'INCIDENTDETAIL.LOCALITY\' | translate}}"\n                                                    tooltip-placement="bottom-left">\n                                                    <span class="ion-card"></span>\n                                                </span>\n                                                <ui-select ng-model="idc.incident.branch" ng-change="idc.changeLocality();"\n                                                    style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                    class="btn-group bootstrap-select form-control"\n                                                    ng-disabled="idc.disabledFields || idc.showDisabled " append-to-body="true"\n                                                    ng-required="true" name="branch"\n                                                    ng-class="{noValid: incidentForm.branch.$touched && incidentForm.branch.$invalid || incidentForm.branch.$error.required && idc.showError}"\n                                                    search-enabled="true">\n                                                    <ui-select-match placeholder="{{\'INCIDENTDETAIL.LOCALITY\'| translate}}">\n                                                        <span> {{idc.incident.branch.description}}</span>\n                                                    </ui-select-match>\n                                                    <ui-select-choices repeat="option in idc.localities |\n                                                        uiSelectFilter: {description:$select.search}">\n                                                        <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                            <span ng-show="incidentForm.branch.$touched && incidentForm.branch.$invalid ||\n                                                incidentForm.branch.$error.required && idc.showError" class="msgError">\n                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                        </div>\n                                    </div>\n\n                                    <!-- Room / Placement -->\n                                    <div class="row">\n                                        <!-- TODO New field location (API: placeText)-->\n                                        <div class="col-sm-12">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-ios-location-outline" tooltip-placement="top-left"\n                                                        uib-tooltip="{{\'INCIDENTDETAIL.PLACE\' | translate}}"></span></span>\n                                                <ui-select ng-model="idc.incident.spot"\n                                                    style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                    class="btn-group bootstrap-select form-control"\n                                                    ng-disabled="idc.disabledFields || idc.showDisabled || !idc.incident.branch" append-to-body="true"\n                                                    ng-required="true" name="spot"\n                                                    ng-class="{noValid: incidentForm.spot.$touched && incidentForm.spot.$invalid || incidentForm.spot.$error.required && idc.showError}"\n                                                    search-enabled="true">\n                                                    <ui-select-match placeholder="{{\'INCIDENTDETAIL.PLACE\'| translate}}">\n                                                        <span> {{idc.incident.spot.description}}</span>\n                                                    </ui-select-match>\n                                                    <ui-select-choices repeat="option in idc.listSpots |\n                                                        uiSelectFilter: {description:$select.search}">\n                                                        <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                            <span ng-show="incidentForm.spot.$touched && incidentForm.spot.$invalid ||\n                                                incidentForm.spot.$error.required && idc.showError" class="msgError">\n                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                        </div>\n                                    </div>\n\n                                    <!-- Task / Incident Type -->\n                                    <div class="row">\n                                        <div class="col-sm-12">\n                                            <div class="input-group" >\n                                                <span class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="fa fa-list" tooltip-placement="top-left"\n                                                        uib-tooltip="{{\'INCIDENTDETAIL.TASKTYPE\' | translate}}"></span></span>\n                                                <ui-select ng-model="idc.incident.taskType"\n                                                    style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                    class="btn-group bootstrap-select form-control"\n                                                    ng-disabled="idc.disabledFields || idc.showDisabled || !idc.incident.branch" append-to-body="true"\n                                                    ng-required="true" name="taskType"\n                                                    ng-class="{noValid: incidentForm.taskType.$touched && incidentForm.taskType.$invalid || incidentForm.spot.$error.required && idc.showError}"\n                                                    search-enabled="true">\n                                                    <ui-select-match placeholder="{{\'INCIDENTDETAIL.TASKTYPE\'| translate}}">\n                                                        <span> {{idc.incident.taskType.description}}</span>\n                                                    </ui-select-match>\n                                                    <ui-select-choices repeat="option in idc.listTaskType |\n                                                        uiSelectFilter: {description:$select.search}">\n                                                        <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                            <span ng-show="incidentForm.taskType.$touched && incidentForm.taskType.$invalid ||\n                                                incidentForm.taskType.$error.required && idc.showError" class="msgError">\n                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                        </div>\n                                    </div>\n\n                                    <!-- Genereated by -->\n                                    <div class="row">\n                                        <div class="col-sm-12">\n                                            <div class="input-group" id="incidentName">\n                                                <span class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-ios-person-outline" tooltip-placement="top-left"\n                                                        uib-tooltip="{{\'INCIDENTDETAIL.NAME\' | translate}}"></span></span>\n                                                <input type="text" ng-readonly="true" class="form-control with-primary-addon"\n                                                    placeholder="{{\'INCIDENTDETAIL.NAME\'|translate}}"\n                                                    aria-describedby="basic-addon1" ng-model="idc.incident.fullName">\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <!-- Incident detail -->\n                                    <div class="row">\n                                        <div class="col-sm-12">\n                                            <div class="input-group" ng-style="(incidentForm.text.$touched && incidentForm.text.$invalid ||\n                                                incidentForm.text.$error.required && idc.showError) ? {\'margin-bottom\': 0}:\'\'">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                    uib-tooltip="{{\'INCIDENTDETAIL.TEXT\' | translate}}" tooltip-placement="top-left"\n                                                    style="vertical-align: top">\n                                                    <span class="ion-compose"></span></span>\n                                                <textarea type="text" ng-readonly="idc.disabledFields || idc.showDisabled" required\n                                                    class="form-control with-primary-addon"\n                                                    placeholder="{{\'INCIDENTDETAIL.TEXT\'|translate}}"\n                                                    aria-describedby="basic-addon1" ng-model="idc.incident.text" name="text"\n                                                    ng-class="{invalid: incidentForm.text.$touched &&\n                                                        incidentForm.text.$invalid || incidentForm.text.$error.required &&\n                                                        idc.showError}">\n                                                </textarea>\n                                            </div>\n                                            <span ng-show="incidentForm.text.$touched && incidentForm.text.$invalid ||\n                                                incidentForm.text.$error.required && idc.showError"\n                                                class="msgError">{{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                        </div>\n                                    </div>\n                                    <!-- Person asigned -->\n                                    <div class="row">\n                                        <div class="col-sm-12">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                    uib-tooltip="{{\'INCIDENTDETAIL.ASSIGNEDUSER\' | translate}}"\n                                                    tooltip-placement="right">\n                                                    <span class="ion-android-person"></span>\n                                                </span>\n                                                <ui-select ng-model="idc.incident.assignedTo"\n                                                    style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                    class="btn-group bootstrap-select form-control" append-to-body="true"\n                                                    ng-disabled="idc.disabledFields || idc.showDisabled" name="assignedUser"\n                                                    search-enabled="true">\n                                                    <ui-select-match allow-clear=true\n                                                        placeholder="{{\'INCIDENTDETAIL.ASSIGNEDUSER\'| translate}}">\n                                                        {{idc.incident.assignedTo.fullName}}\n                                                    </ui-select-match>\n                                                    <ui-select-choices repeat="option in idc.listUsers |\n                                                    uiSelectFilter: {fullName:$select.search}">\n                                                        <div ng-style="(option.allFloor) ? {\'margin-left\': \'0\',\'font-weight\' : \'900\'}:\n                                                        {\'margin-left\': \'17px\'}"\n                                                            ng-bind-html="option.fullName | highlight: $select.search"></div>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <!-- Accordion -->\n                            <div class="row">\n                                <div class="col-sm-12" ng-if="( !idc.modeCreation || idc.istour )">\n                                    <uib-accordion>\n                                        <uib-accordion-group panel-class="panel-primary accordion-panel" is-open="true">\n                                            <uib-accordion-heading>\n                                                {{\'INCIDENTDETAIL.HISTORY\' | translate}}\n                                                <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': idc.historyopen,\n                                               \'glyphicon-chevron-right\': !idc.historyopen}"></i>\n                                            </uib-accordion-heading>\n                                            <div class="row" id="incidentNewComment">\n                                                <div class="col-sm-8">\n                                                    <div class="input-group">\n                                                        <span class="input-group-addon input-group-addon-primary addon-left">\n                                                            <span class="ion-compose" tooltip-placement="bottom-left"\n                                                                uib-tooltip="{{\'INCIDENTDETAIL.NEWCOMMENT\' | translate}}">\n                                                            </span>\n                                                        </span>\n                                                        <input type="text" class="form-control with-primary-addon"\n                                                            placeholder="{{\'INCIDENTDETAIL.NEWCOMMENT\'|translate}}"\n                                                            aria-describedby="basic-addon1" ng-model="idc.tracking.text">\n                                                    </div>\n                                                </div>\n                                                <div class="col-sm-4 pull-right">\n                                                    <ba-switcher ng-if="( idc.accessPush || idc.istour )" id="incidentPush"\n                                                        switcher-style="primary" switcher-value="idc.tracking.notify"\n                                                        uib-tooltip="{{\'INCIDENTDETAIL.NOTIFICATION\' | translate}}"\n                                                        tooltip-placement="bottom-left" icon-size="\'25px\'"\n                                                        switcher-icon-on="\'ion-iphone\'" switcher-icon-off="\'ion-iphone\'">\n                                                    </ba-switcher>\n                                                    <!-- Save -->\n                                                    <button ng-disabled="bbdc.invalidDates || !idc.tracking.text "\n                                                        ng-if="!bbdc.modeReadOnly" ng-click="idc.saveIncidentTracking()"\n                                                        class="iconButton " style="margin: 0 15px;">\n                                                        <i class="ion-ios-paperplane"></i>\n                                                    </button>\n                                                </div>\n                                            </div>\n                                            <div class="row">\n                                                <div class="col-md-12" id="incidentRightCol2">\n                                                    <div ng-if="!idc.modeCreation">\n                                                        <div class="input-group">\n                                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                                uib-tooltip="{{\'INCIDENTDETAIL.TRACKING\' | translate}}"\n                                                                tooltip-placement="right-top" style="vertical-align: top;">\n                                                                <span class="ion-android-list"></span></span>\n                                                            <div style="border: 1px solid rgb(55, 55, 55);">\n                                                                <div style="max-height: 200px;\n                                                                            min-height: 135px;\n                                                                            overflow-y: auto;" ng-style="idc.incident.tracking.length > 1 ?\n                                                                     {\'overflow\' : \'auto\'}:\'\'">\n                                                                    <div ng-repeat="item in idc.incident.tracking\n                                                                     track by $index">\n                                                                        <div class="tag-cards">\n                                                                            <div\n                                                                                style="padding-left: 10px; line-height: 18px; ">\n                                                                                {{item.text}}\n                                                                                <i class="ion-ios-more"\n                                                                                    style="font-size: 15px; margin: 0 6px;"\n                                                                                    uib-tooltip-html=" \'<i class=\\\'\' +\n                                                                                    item.status.icon + \'\\\'></i> \' +\n                                                                                    item.dateFormated+\'<br>\'+item.user.fullName"></i>\n                                                                            </div>\n                                                                        </div>\n                                                                    </div>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </uib-accordion-group>\n                                    </uib-accordion>\n                                </div>\n                            </div>\n                            <!-- Attached -->\n                            <div class="row">\n                                <div class="col-sm-12" ng-if="( !idc.modeCreation || idc.istour )">\n                                    <uib-accordion>\n                                        <uib-accordion-group panel-class="panel-primary accordion-panel" is-open="true">\n                                            <uib-accordion-heading>\n                                                {{\'INCIDENTDETAIL.ATTACHEDS\' | translate}}\n                                                <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': idc.attachedsopen,\n                                                   \'glyphicon-chevron-right\': !idc.attachedsopen}"></i>\n                                            </uib-accordion-heading>\n                                            <div class="row">\n                                                <div class="col-xs-12">\n                                                    <div class="input-group">\n                                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                                            uib-tooltip="{{\'INCIDENTDETAIL.ATTACHEDS\' | translate}}"\n                                                            tooltip-placement="right-top" style="vertical-align: top">\n                                                            <span class="ion-camera"></span>\n                                                        </span>\n                                                        <div style="border: 1px solid rgb(55, 55, 55);" id="incidentAttacheds" class="tagast-files">\n                                                            <div class="tagaste-file-add" readonly="idc.readonly">\n                                                                <file img="idc.file" file-style="display: inline"\n                                                                    style="cursor:pointer;" ng-if=\'!idc.readonly\'\n                                                                    uploading="idc.fileUploading"\n                                                                    ng-disabled="idc.disabledFields || idc.showDisabled"\n                                                                    style-button="true" attacheds-list="idc.incident.attacheds">\n                                                                </file>\n                                                            </div>\n                                                            <div style="overflow-x: hidden; overflow-y:hidden;" scroll-glue-right="!glued;" class="file-list">\n                                                                <div class="img-card-row" ng-repeat="attached in idc.incident.attacheds track by $index"\n                                                                    ng-if="idc.incident.attacheds.length > 0">\n                                                                    <card-file\n                                                                        attached="attached" readonly="idc.readonly"\n                                                                        uploading="idc.fileUploading" max-long-name="8">\n                                                                    </card-file>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </uib-accordion-group>\n                                    </uib-accordion>\n                                </div>\n                            </div>\n\n                        </div>\n                    </form>\n                </div>\n            </div>\n\n            <div class="row panel-footer-buttons">\n                <div class="col-xs-12">\n                    <div class="pull-right" style="margin-right: 10px;">\n                        <button id="incidentCancelButton" type="button" ng-click="idc.cancel()"\n                            class="btn btn-success btn-with-icon" ng-disabled="idc.istour">\n                            <i class="ion-arrow-left-c"></i>{{idc.modeReadOnly ?\'BUTTONS.BACK\':\'BUTTONS.CANCEL\'\n                        |translate}}\n                        </button>\n                        <button id="incidentSaveButton" type="button" ng-click="idc.saveIncident(incidentForm)"\n                            class="btn btn-success btn-with-icon" ng-disabled="idc.istour">\n                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/incidents/incidentsList/incidentsList.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="{{\'INCIDENTS.INCIDENTSLIST\'|translate}}" ba-panel-class="with-scroll"\n             id="incidentsList">\n            <div class="resumeTourContainer" style="left: 280px!important;" ng-hide="ilstc.showIncidentView">\n                <span class="ion-ios-information-outline" tagaste-click="ilstc.initTour()"\n                      style="cursor: pointer;"></span>\n            </div>\n            <div class="horizontal-scroll" ng-class="(ilstc.showIncidentView) ? \'hideTableCounts\': \'\'">\n                <table ng-table="ilstc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true" style="cursor: pointer">\n\n                    <colgroup ng-if="ilstc.showIncidentView">\n                        <col width="30%">\n                        <col width="70%">\n                    </colgroup>\n\n                    <colgroup ng-if="!ilstc.showIncidentView && (ilstc.userBranch.length == 1)">\n                        <col width="5%">\n                        <col width="15%">\n                        <col width="10%">\n                        <col width="53%">\n                        <col width="7%">\n                        <col width="7%">\n                    </colgroup>\n\n                    <colgroup ng-if="!ilstc.showIncidentView && (ilstc.userBranch.length > 1)">\n                        <col width="5%">\n                        <col width="10%">\n                        <col width="15%">\n                        <col width="10%">\n                        <col width="47%">\n                        <col width="5%">\n                        <col width="5%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data  |dummyDataIfEmpty:ilstc.tourDummyData |showErrorNoData track by $index"\n                        ng-click="ilstc.tableParamsCK(row)"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td colspan="5" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td class="text-center"\n                            sortable="\'timeOut\'"\n                            header-class="\'alertCol\'"\n                            ng-if="!ilstc.showIncidentView && !row.error">\n                            <span class="ion-alert-circled iconNgTable redIcon" ng-if="row.timeOut"></span>\n                        </td>\n                        <td data-title="\'INCIDENTS.LOCALITY\'|translate"\n                            sortable="\'locality\'"\n                            filter="ilstc.filterLocality"\n                            ng-if="!ilstc.showIncidentView && ilstc.userBranch.length > 1"\n                            ng-attr-title="{{row.locality}}">\n                            {{row.locality}}\n                        </td>\n                        <td data-title="\'INCIDENTS.DATE\'|translate"\n                            sortable="\'date\'"\n                            filter="ilstc.filterDate"\n                            ng-attr-title="{{row.createdDateLong}}">\n                            {{row.createdDate}}\n                        </td>\n                        <td data-title="\'INCIDENTS.PLACE\'|translate"\n                            sortable="\'placeText\'"\n                            filter="ilstc.filterPlaceText"\n                            ng-if="!ilstc.showIncidentView && !row.error"\n                            ng-attr-title="{{row.placeText}}">\n                            {{row.placeText}}\n                        </td>\n                        <td data-title="\'INCIDENTS.TEXT\'|translate"\n                            sortable="\'text\'"\n                            filter="ilstc.filterText"\n                            ng-attr-title="{{row.text}}">\n                            {{row.text}}\n                        </td>\n                        <td data-title="\'INCIDENTS.PRIORITY\'|translate"\n                            sortable="\'priority\'"\n                            style="text-align: center"\n                            ng-if="!ilstc.showIncidentView && !row.error">\n                            <span class="ion-clock iconNgTable"\n                                  ng-style="(row.priority) ? {\'opacity\': \'1\'}:{\'opacity\': \'0.3\'}"\n                                  title="{{(row.priority) ?\n                                  (\'INCIDENTS.HIGHPRIORITY\'|translate) : (\'INCIDENTS.LOWPRIORITY\'|translate) }}"\n                            ></span>\n                        </td>\n                        <td data-title="\'INCIDENTS.STATUS\'|translate"\n                            style="text-align: center"\n                            sortable="\'lastStatus.status.description\'"\n                            ng-if="!ilstc.showIncidentView && !row.error">\n                             <span style="padding-top: 3px;"\n                                   ng-class="row.lastStatus.status.icon"\n                                   class="iconNgTable" title="{{row.lastStatus.status.description}}"></span>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!ilstc.showIncidentView">\n                <div class="col-xs-12 countAndNewButton" style="display: flex; align-items: center;">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ ilstc.tableParams.total() }}</span></span>\n                    <button ng-click="ilstc.newIncident()"\n                            ng-if="ilstc.gotAccessCreate"\n                            type="button" class="btn btn-success btn-with-icon pull-right newButton"\n                            ng-disabled="ilstc.istour"\n                            id="newIncidentButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                    <button type="button"\n                    tagaste-click="ilstc.exportData();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/requests/requestDetail/requestDetail.html','<style>\n    .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.CARD\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.DIRECTDEBIT\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.CASH\'|translate}}";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.null .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.true .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.false .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .tutor-gender-toggle.nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        text-align: center;\n        content: "{{\'RESIDENTWINDOWDETAIL.TUTOR.TUTOR\' | translate}}";\n    }\n\n    .tutor-gender-toggle.nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.TUTOR.FATHER\' | translate}}";\n    }\n\n    .tutor-gender-toggle.nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.TUTOR.MOTHER\' | translate}}";\n    }\n\n    .resident-gender-toggle {\n        width: 50px;\n        border-radius: 6px;\n        text-align: left;\n        margin: 0 10px;\n    }\n\n    .resident-gender-toggle .nz-toggle-handle {\n        border-radius: 6px;\n    }\n\n    .resident-gender-toggle.nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        text-align: center;\n        font-family: \'Ionicons\';\n        content: "\\f25d \\f202";\n        font-size: 20px;\n        left: 10px;\n        bottom: 3px;\n        color: #464444;\n    }\n\n    .resident-gender-toggle.nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        font-family: \'Ionicons\';\n        font-size: 22px;\n        bottom: 3px;\n        content: "\\f202";\n        color: #464444;\n    }\n\n    .resident-gender-toggle.nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        /*content: "{{\'RESIDENTWINDOWDETAIL.GENDER.FEMALE\' | translate}}";*/\n        font-family: \'Ionicons\';\n        font-size: 22px;\n        bottom: 3px;\n        content: "\\f25d";\n        color: #464444;\n    }\n</style>\n\n<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel resident-detail detail-panel">\n        <div ba-panel ba-panel-title-no-translate="<b>{{rqdc.windowTitle}}</b>"\n             ba-panel-anim="zoom-in" style="line-height:30px;" id="requestDetail">\n            <form name="rqdc.resform" autocomplete="false">\n                <div class="row">\n                    <div class=" text-center avatarResident"\n                         ng-class="(rqdc.level > 2) ? \'col-md-12 col-xs-12\' : \'col-md-3 col-sm-12\'" ng-style="(rqdc.level > 2) ?\n                              {\'height\' : \'inherit\', \'padding-bottom\' : \'20px\'}:{\'height\': \'auto\'}" style="padding: 0;  display: flex; justify-content: center; padding-left: 25px;\n                         box-sizing: border-box; align-items: center;">\n                        <avatar type="person" shape="square" avatar-style=""\n                                readonly="( rqdc.readonly || rqdc.istour )" img="rqdc.avatar"\n                                uploading="rdect.avatarUploading" photo="rqdc.requestBD.user.photo"\n                                id="residentresidentDetailImg"></avatar>\n                    </div>\n                    <div class="pull-right" ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-9 col-xs-12\'">\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group" ng-class="{\'select-invalid\': rqdc.submitted && !rqdc.requestBD.branch }">\n                                    <span uib-tooltip="{{\'REQUESTS.DETAIL.RESIDENCE\' | translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-card"></span>\n                                    </span>\n                                    <ui-select ng-model="rqdc.requestBD.branch"\n                                               ng-change="rqdc.changeRequestBranch();"\n                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                               append-to-body="true" search-enabled="true">\n                                        <ui-select-match placeholder="{{\'REQUESTS.DETAIL.RESIDENCE\'| translate}}">\n                                            {{rqdc.requestBD.branch.description}}\n                                        </ui-select-match>\n                                        <ui-select-choices\n                                            repeat="branches in rqdc.constants.branch">\n                                            <span ng-bind-html="branches.description | highlight: $select.search">\n                                            </span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="rqdc.submitted && !rqdc.requestBD.branch">\n                                    *{{\'ERROR.NOTVALIDRESIDENCE\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6"></div>\n                        </div>\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group" id="residentDetailRoom"\n                                     ng-class="{\'select-invalid\': rqdc.submitted && !rqdc.requestBD.spot }">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          tooltip-placement="bottom-left"\n                                          uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ROOM\'| translate}}">\n                                        <span class="fa fa-bed" style="margin-left:-1px"></span></span>\n\n                                    <ui-select ng-model="rqdc.requestBD.spot"\n                                               required\n                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                               append-to-body="true" name="spot" search-enabled="true">\n                                        <ui-select-match placeholder="{{\'RESIDENTWINDOWDETAIL.ROOM\'| translate}}">\n                                            <span> {{rqdc.requestBD.spot.description}}</span>\n                                        </ui-select-match>\n                                        <ui-select-choices repeat="option in rqdc.listSpots |\n                                            uiSelectFilter: {description:$select.search}">\n                                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="rqdc.submitted && !rqdc.requestBD.spot">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n\n                            <div class="col-md-6 text-right">\n                                <nz-toggle tri-toggle class="resident-gender-toggle"\n                                           uib-tooltip="\n                                        {{(rqdc.requestBD.user.gender === \'M\') ? (\'RESIDENTWINDOWDETAIL.GENDER.MALE\' | translate) :\n                                            ((rqdc.requestBD.user.gender === \'F\') ? (\'RESIDENTWINDOWDETAIL.GENDER.FEMALE\' | translate) :\n                                              (\'RESIDENTWINDOWDETAIL.GENDER.UNDEFINED\' | translate))}}"\n                                           tooltip-placement="bottom"\n                                           val-default="\'undefined\'"\n                                           ng-disabled="rqdc.readonly"\n                                           ng-model="rqdc.requestBD.user.gender"\n                                           val-true="\'M\'"\n                                           val-false="\'F\'"\n                                           val-null="\'undefined\'"\n                                           width="60"\n                                           height="30"\n                                           color-false="\'#60BD68\'">\n                                </nz-toggle>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.NAME\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left"\n                                          id="residentDetailTooltip">\n                                        <span class="ion-android-person"></span></span>\n                                    <input type="text" name="firstname" ng-disabled="rqdc.readonly"\n                                           class="form-control with-primary-addon "\n                                           ng-class="{\'invalid\': (rqdc.resform.firstname.$touched || rqdc.submitted) && !rqdc.readonly && !rqdc.resform.firstname.$valid }"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.NAME\'|translate}}"\n                                           ng-model="rqdc.requestBD.user.name" required>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate" ng-if="( rqdc.resform.firstname.$touched || rqdc.submitted )&& !rqdc.readonly &&\n                                            !rqdc.resform.firstname.$valid">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <input type="text" ng-disabled="rqdc.readonly" name="surname"\n                                           class="form-control with-primary-addon" ng-class="{\'invalid\': ( rqdc.resform.surname.$touched ||\n                                                rqdc.submitted ) && !scedetc.readonly && !rqdc.resform.surname.$valid}"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.LASTNAME\'|translate}}"\n                                           style="border-radius: 5px;" required ng-model="rqdc.requestBD.user.surname">\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate" ng-if="( rqdc.resform.surname.$touched || rqdc.submitted )&&\n                                                !scedetc.readonly && !rqdc.resform.surname.$valid">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left ">\n                                        <span class="ion-card"></span></span>\n                                    <input type="text" name="dni" ng-change="rqdc.validDNI(rqdc.requestBD.user.identity.val,\n                                            rqdc.requestBD.user.identity.type.description,\n                                            rqdc.resform.dni)" ng-blur="rqdc.validDNI(rqdc.requestBD.user.identity.val,\n                                            rqdc.requestBD.user.identity.type.description,\n                                            rqdc.resform.dni)" ng-disabled="rqdc.readonly"\n                                           class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'|translate}}"\n                                           ng-model="rqdc.requestBD.user.identity.val">\n                                    <span style="width: 51px" id="residentDetailIdentification"\n                                          class="input-group-addon input-group-addon-primary addon-right" ng-click="rqdc.changeTypeIde(rqdc.requestBD.user.identity.type);\n                                            rqdc.validDNI(rqdc.requestBD.user.identity.val,\n                                            rqdc.requestBD.user.identity.type.description,rqdc.resform.dni)"\n                                          ng-style="(rqdc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                        {{rqdc.requestBD.user.identity.type ?\n                                        rqdc.requestBD.user.identity.type.description : rqdc.requestBD.user.identity.description}}</span>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="!rqdc.resform.dni.$valid">\n                                    {{\'ERROR.GENERROR0\' | translate}}\n                                    {{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\' | translate}}\n                                    {{\'ERROR.GENERROR1\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <date-picker-comp tooltip-text="\'RESIDENTWINDOWDETAIL.EXPDATE\' | translate"\n                                                  placeholder="\'RESIDENTWINDOWDETAIL.EXPDATE\' | translate"\n                                                  tooltip-placement="bottom-left" date-value="rqdc.requestBD.user.identity.expDate"\n                                                  mode-read-only="rqdc.readonly"\n                                                  form-reference="rqdc.resform" name-field="\'expDate\'">\n                                </date-picker-comp>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.EMAIL\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-at"></span></span>\n                                    <input type="text" ng-disabled="rqdc.readonly" name="email"\n                                           required\n                                           ng-class="{\'invalid\': (rqdc.resform.email.$touched || rqdc.submitted )&& !rqdc.readonly && !rqdc.resform.email.$valid }"\n                                           ng-change="rqdc.validEmail(rqdc.requestBD.user.contact.email,rqdc.resform.email)"\n                                           ng-blur="rqdc.validEmail(rqdc.requestBD.user.contact.email,rqdc.resform.email)"\n                                           autocomplete="new-password" class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.EMAIL\'|translate}}"\n                                           ng-model="rqdc.requestBD.user.contact.email">\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="(rqdc.resform.email.$touched|| rqdc.submitted )&& !rqdc.resform.email.$valid">\n                                    {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.PHONE\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-ios-telephone"></span></span>\n                                    <input type="text" name="mobile"\n                                           required\n                                           ng-class="{\'invalid\': (rqdc.resform.mobile.$touched || rqdc.submitted )&& !rqdc.readonly && !rqdc.resform.mobile.$valid }"\n                                           ng-change="rqdc.validateMobile(rqdc.requestBD.user.contact.phone, rqdc.resform.mobile)"\n                                           ng-blur="rqdc.validateMobile(rqdc.requestBD.user.contact.phone, rqdc.resform.mobile)"\n                                           ng-disabled="rqdc.readonly"\n                                           class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.PHONE\'|translate}}"\n                                           ng-model="rqdc.requestBD.user.contact.phone">\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="(rqdc.resform.mobile.$touched || rqdc.submitted) && !rqdc.resform.mobile.$valid">\n                                    {{\'ERROR.GENERROR0\' | translate}}\n                                    {{\'RESIDENTWINDOWDETAIL.PHONE\' | translate}}\n                                    {{\'ERROR.GENERROR1\' | translate}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class=" col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ALIAS\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-android-contact"></span></span>\n                                    <input type="text" ng-disabled="rqdc.readonly"\n                                           class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.ALIAS\'|translate}}"\n                                           ng-model="rqdc.requestBD.user.nick">\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <date-picker-comp tooltip-text="\'RESIDENTWINDOWDETAIL.FECN\' | translate"\n                                                  tooltip-placement="top-left" date-value="rqdc.requestBD.user.birthdate"\n                                                  placeholder="\'RESIDENTWINDOWDETAIL.FECN\' | translate" is-required="false"\n                                                  mode-read-only="( rqdc.readonly || rqdc.istour )" date-options="rqdc.dateOptions"\n                                                  show-required-error="true" name-field="\'birthdate\'"\n                                                  special-validation="rqdc.checkBirthDate()" form-reference="rqdc.resform"\n                                                  msg-special-validation="\'RESIDENTSWINDOW.MSGBIRTHDAY\'">\n                                </date-picker-comp>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="row" style="min-height: 286px; position:relative;">\n\n                    <uib-tabset id="residentDetailContactInfo" type="tabs" class="resident-tabs" active="rqdc.tabActive">\n                        <uib-tab index="0" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CONTACTIN\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-user\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.CONTACTIN\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-8\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ADDRE\' | translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-ios-location"></span></span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.ADDRE\'|translate}}"\n                                               ng-model="rqdc.requestBD.user.contact.address">\n                                    </div>\n                                </div>\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CITY\'| translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-ios-location"></span></span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.CITY\'|translate}}"\n                                               ng-model="rqdc.requestBD.user.contact.city">\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.POSTCODE\'| translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-pound"></span></span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.POSTCODE\'|translate}}"\n                                               ng-model="rqdc.requestBD.user.contact.postcode">\n                                    </div>\n                                </div>\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group" ng-if="rqdc.requestBD.user.contact">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}"\n                                                  tooltip-placement="top-left">\n                                                <span class="ion ion-flag"></span>\n                                            </span>\n                                        <ui-select ng-model="rqdc.selectedCountry"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control"\n                                                   ng-disabled="rqdc.readonly" ng-change="rqdc.selectCountryChange();"\n                                                   append-to-body="true" search-enabled="true">\n                                            <ui-select-match\n                                                placeholder="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}">\n                                                    <span ng-if="(rqdc.selectedCountry.name &&\n                                                        rqdc.selectedCountry.name !== \'\')">\n                                                        {{rqdc.selectedCountry.name}} </span>\n                                                <span ng-if="!(rqdc.selectedCountry.name &&\n                                                        rqdc.selectedCountry.name !== \'\')" style="color: #b2b1b1;">\n                                                        {{\'SELECTCOUNTRY.SELECTCOUNTRY\' | translate}}\n                                                    </span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="country in rqdc.getCountries($select.search) |\n                                                    uiSelectFilter: {name:$select.search}">\n                                                <span ng-bind-html="country.name| highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <span class="input-group-addon\n                                                input-group-addon-primary\n                                                addon-right ion-trash-a" ng-click="rqdc.clearCountry()"\n                                              ng-style="{cursor: rqdc.readonly ? \'default\' : \'pointer\'}">\n                                            </span>\n                                    </div>\n                                </div>\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group" ng-if="rqdc.requestBD.user.contact">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}"\n                                                  tooltip-placement="top-left">\n                                                <span class="ion ion-ios-location"></span>\n                                            </span>\n                                        <ui-select ng-model="rqdc.selectedState"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly ||\n                                                       !rqdc.requestBD.user.contact.country"\n                                                   ng-change="rqdc.selectStateChange();" append-to-body="true"\n                                                   search-enabled="true">\n                                            <ui-select-match\n                                                placeholder="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}">\n                                                    <span ng-if="(rqdc.selectedState && rqdc.selectedState !== \'\')">\n                                                        {{rqdc.selectedState}} </span>\n                                                <span ng-if="!(rqdc.selectedState && rqdc.selectedState !== \'\')"\n                                                      style="color:#b2b1b1">\n                                                        {{\'SELECTCOUNTRY.SELECTSTATE\' | translate}}\n                                                    </span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="state in rqdc.getStates($select.search) |\n                                                    uiSelectFilter: $select.search">\n                                                <span ng-bind-html="state| highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <span class="input-group-addon\n                                                 input-group-addon-primary\n                                                  addon-right ion-trash-a" ng-click="rqdc.clearState()"\n                                              ng-style="{cursor: rqdc.readonly ||\n                                                !rqdc.requestBD.user.contact.country ? \'default\' : \'pointer\'}">\n                                            </span>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.NATIONAILITY\'| translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-android-globe"></span></span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.NATIONAILITY\'|translate}}"\n                                               ng-model="rqdc.requestBD.user.nationality">\n                                    </div>\n                                </div>\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.LANGUAGE\'| translate}}"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-chatbox-working"></span>\n                                            </span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.LANGUAGE\'|translate}}"\n                                               ng-model="rqdc.requestBD.user.language">\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="1" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.TITLE\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.TUTOR.TITLE\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-male\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.TUTOR.TITLE\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n\n                            <div class="tutors" ng-if="rqdc.requestBD.user.tutors">\n                                <div class="tutor-block" ng-repeat="tutor in rqdc.requestBD.user.tutors track by $index">\n                                    <div class="row">\n                                        <div class="col-md-8">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.NAME\'|translate}}">\n                                                     <span class="ion-android-person" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'name\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       ng-class="{\'invalid\': (rqdc.resform.tutors[$index].name.$touched || rqdc.submitted )&& !rqdc.readonly && !rqdc.resform[\'tutor\' + $index + \'name\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.NAME\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].name" required>\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4 text-right">\n                                            <nz-toggle tri-toggle class="tutor-gender-toggle"\n                                                       val-default="undefined"\n                                                       ng-disabled="rqdc.readonly"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].gender"\n                                                       val-true="\'M\'"\n                                                       val-false="\'F\'"\n                                                       val-null="undefined"\n                                                       width="150"\n                                                       style="width: 25px; height: 15px;"\n                                                       color-false="\'#60BD68\'">\n                                            </nz-toggle>\n                                        </div>\n                                    </div>\n\n                                    <div class="row">\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.ADDRESS\'|translate}}">\n                                                     <span class="ion-ios-location" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'address\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon " ng-class="{\'invalid\': (rqdc.resform.tutors[$index].address.$touched ||\n                                                     rqdc.submitted )&& !rqdc.readonly &&\n                                                     !rqdc.resform[\'tutor\' + $index + \'address\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.ADDRESS\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].address">\n                                            </div>\n\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.CITY\'|translate}}">\n                                                     <span class="ion-ios-location" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'city\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon " ng-class="{\'invalid\': (rqdc.resform.tutors[$index].city.$touched ||\n                                                     rqdc.submitted )&& !rqdc.readonly &&\n                                                     !rqdc.resform[\'tutor\' + $index + \'city\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.CITY\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].city">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.POSTCODE\'|translate}}">\n                                                     <span class="ion-pound" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'postcode\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon " ng-class="{\'invalid\': (rqdc.resform.tutors[$index].postcode.$touched ||\n                                                     rqdc.submitted )&& !rqdc.readonly &&\n                                                     !rqdc.resform[\'tutor\' + $index + \'postcode\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.POSTCODE\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].postcode">\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <!-- Tutor COUNTRY -->\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      uib-tooltip="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}"\n                                                      tooltip-placement="top-left">\n                                                    <span class="ion ion-flag"></span>\n                                                </span>\n                                                <ui-select ng-model="rqdc.requestBD.user.tutors[$index].selectedCountry"\n                                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                           class="btn-group bootstrap-select form-control"\n                                                           ng-disabled="rqdc.readonly" ng-change="rqdc.selectCountryChangeTutor($index);"\n                                                           append-to-body="true" search-enabled="true">\n                                                    <ui-select-match placeholder="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}">\n                                                        <span ng-if="(rqdc.requestBD.user.tutors[$index].selectedCountry.name &&\n                                                         rqdc.requestBD.user.tutors[$index].selectedCountry.name !== \'\')">\n                                                            {{rqdc.requestBD.user.tutors[$index].country}}\n                                                        </span>\n                                                        <span ng-if="!(rqdc.requestBD.user.tutors[$index].selectedCountry.name &&\n                                                         rqdc.requestBD.user.tutors[$index].selectedCountry.name !== \'\')"\n                                                              style="color: #b2b1b1;">\n                                                                {{\'SELECTCOUNTRY.SELECTCOUNTRY\' | translate}}\n                                                        </span>\n                                                    </ui-select-match>\n                                                    <ui-select-choices\n                                                        repeat="country in rqdc.getCountries($select.search) | uiSelectFilter: {name:$select.search}">\n                                                        <span ng-bind-html="country.name| highlight: $select.search"></span>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                                <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                                      ng-click="rqdc.clearTutorCountry($index)"\n                                                      ng-style="{cursor: rqdc.readonly ? \'default\' : \'pointer\'}">\n                                                </span>\n                                            </div>\n                                        </div>\n\n                                        <!-- Tutor STATE-->\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      uib-tooltip="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}"\n                                                      tooltip-placement="top-left">\n                                                    <span class="ion ion-ios-location"></span>\n                                                </span>\n                                                <ui-select ng-model="rqdc.requestBD.user.tutors[$index].selectedState"\n                                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                           class="btn-group bootstrap-select form-control"\n                                                           ng-disabled="rqdc.readonly || !rqdc.requestBD.user.tutors[$index].country"\n                                                           ng-change="rqdc.selectStateChangeTutor($index);" append-to-body="true"\n                                                           search-enabled="true">\n                                                    <ui-select-match placeholder="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}">\n                                                            <span\n                                                                ng-if="(rqdc.requestBD.user.tutors[$index].selectedState && rqdc.requestBD.user.tutors[$index].selectedState !== \'\')">\n                                                                {{rqdc.requestBD.user.tutors[$index].state}}\n                                                            </span>\n                                                        <span\n                                                            ng-if="!(rqdc.requestBD.user.tutors[$index].selectedState && rqdc.requestBD.user.tutors[$index].selectedState !== \'\')"\n                                                            style="color:#b2b1b1">\n                                                                {{\'SELECTCOUNTRY.SELECTSTATE\' | translate}}\n                                                            </span>\n                                                    </ui-select-match>\n                                                    <ui-select-choices\n                                                        repeat="state in rqdc.getTutorStates($select.search, $index) | uiSelectFilter: $select.search">\n                                                        <span ng-bind-html="state| highlight: $select.search"></span>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                                <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                                      ng-click="rqdc.clearTutorState($index)"\n                                                      ng-style="{cursor: rqdc.readonly || !rqdc.requestBD.user.contact.country ? \'default\' : \'pointer\'}">\n                                                </span>\n                                            </div>\n                                        </div>\n\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.IDENTITY\'| translate}}"\n                                                      class="input-group-addon input-group-addon-primary addon-left ">\n                                                    <span class="ion-card"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'dni\'}}"\n                                                       ng-change="rqdc.validDNI(rqdc.requestBD.user.tutors[$index].identity.docVal,\n                                                                                 rqdc.requestBD.user.tutors[$index].identity.docType.description,\n                                                                                 rqdc.resform[\'tutor\' + $index + \'dni\'])"\n                                                       ng-blur="rqdc.validDNI(rqdc.requestBD.user.tutors[$index].identity.docVal,\n                                                                                 rqdc.requestBD.user.tutors[$index].identity.docType.description,\n                                                                                 rqdc.resform[\'tutor\' + $index + \'dni\'])"\n                                                       ng-focus="rqdc.setTutorDocType($index);"\n                                                       ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.IDENTITY\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].identity.docVal">\n\n                                                <span style="width: 51px" id="tutorIdentification{{$index}}"\n                                                      class="input-group-addon input-group-addon-primary addon-right"\n                                                      ng-click="rqdc.changeTypeDocTutor($index);\n                                                                rqdc.validDNI(rqdc.requestBD.user.tutors[$index].identity.docVal, rqdc.requestBD.user.tutors[$index].identity.docType.description, rqdc.resform[\'tutor\' + $index + \'dni\'])"\n                                                      ng-style="(rqdc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                                        {{rqdc.requestBD.user.tutors[$index].identity.docType.description}}\n                                                </span>\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                 ng-if="( rqdc.resform.tutors[$index].dni.$touched || rqdc.submitted)&& !rqdc.resform[\'tutor\' + $index + \'dni\'].$valid">\n                                                {{\'ERROR.GENERROR0\' | translate}}\n                                                {{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\' | translate}}\n                                                {{\'ERROR.GENERROR1\' | translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div class="row">\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.EMAIL\'|translate}}">\n                                                     <span class="ion-at" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'email\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       ng-class="{\'invalid\': (rqdc.resform.tutors[$index].email.$touched || rqdc.submitted )&& !rqdc.readonly && !rqdc.resform[\'tutor\' + $index + \'email\'].$valid }"\n                                                       ng-change="rqdc.validEmail(rqdc.requestBD.user.tutors[$index].email,rqdc.resform[\'tutor\' + $index + \'email\'])"\n                                                       ng-blur="rqdc.validEmail(rqdc.requestBD.user.tutors[$index].email,rqdc.resform[\'tutor\' + $index + \'email\'])"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.EMAIL\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].email">\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                 ng-if="(rqdc.resform[\'tutor\' + $index + \'email\'].$touched|| rqdc.submitted )&& !rqdc.resform[\'tutor\' + $index + \'email\'].$valid">\n                                                {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.MAINPHONE\'|translate}}">\n                                                     <span class="ion ion-ios-telephone" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'mainPhone\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.MAINPHONE\'|translate}}"\n                                                       ng-change="rqdc.validateMobile(rqdc.requestBD.user.tutors[$index].mainPhone, rqdc.resform[\'tutor\' + $index + \'mainPhone\'])"\n                                                       ng-blur="rqdc.validateMobile(rqdc.requestBD.user.tutors[$index].mainPhone, rqdc.resform[\'tutor\' + $index + \'mainPhone\'])"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].mainPhone">\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                 ng-if="(rqdc.resform[\'tutor\' + $index + \'mainPhone\'].$touched || rqdc.submitted) && !rqdc.resform[\'tutor\' + $index + \'mainPhone\'].$valid">\n                                                {{\'ERROR.GENERROR0\' | translate}}\n                                                {{\'RESIDENTWINDOWDETAIL.PHONE\' | translate}}\n                                                {{\'ERROR.GENERROR1\' | translate}}\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.SECONDARYPHONE\'|translate}}">\n                                                     <span class="ion ion-ios-telephone" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'secondaryPhone\'}}"\n                                                       ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.SECONDARYPHONE\'|translate}}"\n                                                       ng-change="rqdc.validateMobile(rqdc.requestBD.user.tutors[$index].secondaryPhone, rqdc.resform[\'tutor\' + $index + \'secondaryPhone\'])"\n                                                       ng-blur="rqdc.validateMobile(rqdc.requestBD.user.tutors[$index].secondaryPhone, rqdc.resform[\'tutor\' + $index + \'secondaryPhone\'])"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].secondaryPhone">\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                 ng-if="(rqdc.resform[\'tutor\' + $index + \'secondaryPhone\'].$touched || rqdc.submitted) && !rqdc.resform[\'tutor\' + $index + \'secondaryPhone\'].$valid">\n                                                {{\'ERROR.GENERROR0\' | translate}}\n                                                {{\'RESIDENTWINDOWDETAIL.PHONE\' | translate}}\n                                                {{\'ERROR.GENERROR1\' | translate}}\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class="row">\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.STUDIES\'|translate}}">\n                                                     <span class="ion-university" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'studies\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.STUDIES\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].studies">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.PROFESSION\'|translate}}">\n                                                     <span class="ion ion-hammer" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'profession\'}}" ng-disabled="rqdc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.PROFESSION\'|translate}}"\n                                                       ng-model="rqdc.requestBD.user.tutors[$index].profession">\n                                            </div>\n                                        </div>\n\n                                        <div class="col-md-4">\n                                            <div class="pull-right">\n                                                <button class="btn btn-success btn-with-icon"\n                                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                                        ng-if="!rqdc.readonly" tagaste-click="rqdc.removeTutor($index)">\n                                                    <i class="fa fa-trash-o"></i>{{\'RESIDENTWINDOWDETAIL.TUTOR.REMOVETUTOR\' | translate}}\n                                                </button>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="pull-right">\n                                    <button class="btn btn-success btn-with-icon"\n                                            style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                            ng-if="!rqdc.readonly" tagaste-click="rqdc.addTutor($event)">\n                                        <i class="ion-plus"></i>{{\'RESIDENTWINDOWDETAIL.TUTOR.ADDTUTOR\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="2" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ACADEMICDATA\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.ACADEMICDATA\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-book\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.ACADEMICDATA\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rqdc.level > 2) ? \'col-md-6\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'RESIDENTWINDOWDETAIL.UNIVERSITY\'| translate}}">\n                                            <span class="ion-university" style="margin-left:-1px"></span></span>\n                                        <ui-select ng-model="rqdc.requestBD.user.academicdata.university"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                                   append-to-body="true" name="university" search-enabled="true"\n                                                   ng-change="rqdc.selectUniversityChange();">\n                                            <ui-select-match placeholder="{{\'RESIDENTWINDOWDETAIL.UNIVERSITY\'| translate}}">\n                                                <span> {{rqdc.requestBD.user.academicdata.university.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rqdc.universities |\n                                                uiSelectFilter: {description:$select.search}">\n                                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-md-4">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'RESIDENTWINDOWDETAIL.FACULTY\'| translate}}">\n                                            <span class="ion-university" style="margin-left:-1px"></span></span>\n\n                                        <ui-select ng-model="rqdc.requestBD.user.academicdata.faculty"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly ||\n                                                       !rqdc.requestBD.user.academicdata.university"\n                                                   append-to-body="true" name="faculty" search-enabled="true">\n                                            <ui-select-match placeholder="{{\'RESIDENTWINDOWDETAIL.FACULTY\'| translate}}">\n                                                <span> {{rqdc.requestBD.user.academicdata.faculty.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rqdc.lodash.filter(rqdc.faculties, {\'related\': {_id: rqdc.requestBD.user.academicdata.university._id}}) |\n                                                uiSelectFilter: {description:$select.search}">\n                                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <div class="col-md-4">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CARRER\'| translate}}">\n                                            <span class="ion-university" style="margin-left:-1px"></span></span>\n\n                                        <ui-select ng-model="rqdc.requestBD.user.academicdata.carrerCollege"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                                   append-to-body="true" name="carrerCollege" search-enabled="true">\n                                            <ui-select-match placeholder="{{\'RESIDENTWINDOWDETAIL.CARRER\'| translate}}">\n                                                <span> {{rqdc.requestBD.user.academicdata.carrerCollege.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rqdc.lodash.filter(rqdc.studies, {\'related\': {_id: rqdc.requestBD.user.academicdata.faculty._id}}) |\n                                                uiSelectFilter: {description:$select.search}">\n                                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <div class="col-md-4">\n                                    <div class="input-group">\n                                       <span class="input-group-addon input-group-addon-primary addon-left"\n                                             tooltip-placement="bottom-left"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.COURSE\'|translate}}">\n                                            <span class="ion-pound" style="margin-left: -1px"></span>\n                                       </span>\n                                        <input type="text" name="name" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon "\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.COURSE\'|translate}}"\n                                               ng-model="rqdc.requestBD.user.academicdata.course">\n\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <div class="input-group">\n                                       <span class="input-group-addon input-group-addon-primary addon-left"\n                                             tooltip-placement="bottom-left"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.COMMENTS\'|translate}}">\n                                            <span class="ion-quote" style="margin-left: -1px"></span>\n                                       </span>\n                                        <textarea type="text" name="name" ng-disabled="rqdc.readonly"\n                                                  class="form-control with-primary-addon "\n                                                  placeholder="{{\'RESIDENTWINDOWDETAIL.COMMENTS\'|translate}}"\n                                                  ng-model="rqdc.requestBD.user.academicdata.comment">\n                                       </textarea>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="3" uib-tooltip="{{\'REQUESTS.DETAIL.BILLING\' | translate }}"\n                                 heading="{{\'REQUESTS.DETAIL.BILLING\' | translate }}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-eur\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.BILLING\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <label class="custom-checkbox">\n                                        <input id="checkResidente" type="checkbox" ng-model="rqdc.requestBD.billingData.ownResident"\n                                               ng-disabled="rqdc.readonly"\n                                               ng-click="rqdc.billingOwnResident(rqdc.requestBD.billingData.ownResident)">\n                                        <span>{{\'REQUESTS.DETAIL.BILLING_RESIDENT\' | translate}}</span>\n                                    </label>\n                                </div>\n                            </div>\n                            <div class="row infoBlockWrapper" ng-if="!rqdc.requestBD.billingData.ownResident">\n                                <div class="input-group">\n                                    <div class="col-md-12">\n                                        <button class="btn btn-success btn-with-icon pull-right"\n                                                type="button"\n                                                ng-if="!rqdc.readonly && !rqdc.showPayerTutorSelect" tagaste-click="rqdc.showHidePayerTutorSelection()">\n                                            <i class="ion-plus"></i>{{\'REQUESTS.DETAIL.SELECTTUTOR\' | translate}}\n                                        </button>\n                                    </div>\n                                </div>\n                                <div ng-if="rqdc.showPayerTutorSelect">\n                                    <div class="col-md-12">\n                                        <div class="row">\n                                            <div class="col-md-8">\n                                                <div class="input-group">\n                                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                                          tooltip-placement="bottom-left"\n                                                              uib-tooltip="{{\'REQUESTS.DETAIL.SELECTTUTOR\'| translate}}">\n                                                        <span class="ion-android-person" style="margin-left:-1px"></span>\n                                                    </span>\n                                                    <ui-select ng-model="rqdc.selectedPayerTutor"\n                                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                               class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                                               append-to-body="true" name="tutor" search-enabled="true"\n                                                               ng-change="rqdc.selectPayerTutor();">\n                                                        <ui-select-match placeholder="{{\'REQUESTS.DETAIL.SELECTTUTOR\'| translate}}">\n                                                            <span> {{rqdc.selectedPayerTutor.name}}</span>\n                                                        </ui-select-match>\n                                                        <ui-select-choices repeat="option in rqdc.requestBD.user.tutors|\n                                                        uiSelectFilter: {description:$select.search}">\n                                                            <span ng-bind-html="option.name | highlight: $select.search"></span>\n                                                        </ui-select-choices>\n                                                    </ui-select>\n                                                </div>\n                                            </div>\n                                            <div class="col-md-4">\n                                                <div class="input-group">\n                                                    <button class="btn btn-success btn-with-icon"\n                                                            type="button"\n                                                            ng-if="!rqdc.readonly && rqdc.showPayerTutorSelect" tagaste-click="rqdc.showHidePayerTutorSelection()">\n                                                        <i class="ion-plus"></i>{{\'BUTTONS.CANCEL\' | translate}}\n                                                    </button>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                                <!--billingAddress name-->\n                                <div class="col-xs-8">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'REQUESTS.DETAIL.BILLING_NAME\'|translate}}">\n                                             <span class="ion-android-person" style="margin-left: -1px"></span>\n                                        </span>\n                                        <input type="text" name="name" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon" required\n                                               ng-class="{\'invalid\': (rqdc.resform.name.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.name.$valid }"\n                                               placeholder="{{\'REQUESTS.DETAIL.BILLING_NAME\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.name">\n                                    </div>\n                                </div>\n\n                                <!--billingAddress email-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span uib-tooltip="{{\'BILLING.DETAIL.EMAIL\'| translate}}"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-at"></span></span>\n                                        <input type="text" ng-disabled="bidc.readonly" name="billingAddressEmail"\n                                               ng-change="rqdc.validEmail(rqdc.requestBD.billingData.email,rqdc.resform.billingAddressEmail)"\n                                               ng-blur="rqdc.validEmail(rqdc.requestBD.billingData.email,rqdc.resform.billingAddressEmail)"\n                                               autocomplete="billingAddressEmail" class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.DETAIL.EMAIL\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.email" required>\n                                    </div>\n                                    <div class="errorValidation invalidInputMsg bounceIn animate"\n                                         ng-if="(rqdc.resform.billingAddressEmail.$touched|| rqdc.submitted ) && !rqdc.resform.billingAddressEmail.$valid">\n                                        {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                                    </div>\n                                </div>\n                                <!--billingAddress phone-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span uib-tooltip="{{\'BILLING.DETAIL.PHONE\'| translate}}"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-ios-telephone"></span></span>\n                                        <input type="text" name="billingAddressPhone" ng-change="rqdc.validateMobile(rqdc.requestBD.billingData.phone,\n                                                    rqdc.resform.billingAddressPhone)" ng-blur="rqdc.validateMobile(rqdc.requestBD.billingData.phone,\n                                                    rqdc.resform.billingAddressPhone)" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.DETAIL.PHONE\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.phone">\n                                    </div>\n                                    <div class="errorValidation invalidInputMsg bounceIn animate"\n                                         ng-if="(rqdc.resform.billingAddressPhone.$touched || rqdc.submitted) && !rqdc.resform.billingAddressPhone.$valid">\n                                        {{\'ERROR.GENERROR0\' | translate}}\n                                        {{\'BILLING.DETAIL.PHONE\' | translate}}\n                                        {{\'ERROR.GENERROR1\' | translate}}\n                                    </div>\n                                </div>\n                                <!--billingAddress address-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span uib-tooltip="{{\'BILLING.DETAIL.ADDRESS\' | translate}}"\n                                              tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-ios-location"></span></span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.DETAIL.ADDRESS\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.address">\n                                    </div>\n                                </div>\n                                <!--billingAddress city-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span uib-tooltip="{{\'BILLING.DETAIL.CITY\' | translate}}"\n                                              tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-ios-location"></span></span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.DETAIL.CITY\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.city">\n                                    </div>\n                                </div>\n                                <!--billingAddress postcode-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span uib-tooltip="{{\'BILLING.DETAIL.POSTCODE\' | translate}}"\n                                              tooltip-placement="right" class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-pound"></span></span>\n                                        <input type="text" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'BILLING.DETAIL.POSTCODE\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.postcode">\n                                    </div>\n                                </div>\n                                <!--billingAddress country-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip="{{\'BILLING.DETAIL.COUNTRY\'|translate}}"\n                                              tooltip-placement="top-left">\n                                            <span class="ion ion-flag"></span>\n                                        </span>\n                                        <ui-select ng-model="rqdc.selectedBillingDataCountry"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control"\n                                                   ng-disabled="rqdc.readonly"\n                                                   ng-change="rqdc.selectBillingCountryChange();"\n                                                   append-to-body="true" search-enabled="true">\n                                            <ui-select-match placeholder="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}">\n                                                <span\n                                                    ng-if="(rqdc.selectedBillingDataCountry.name && rqdc.selectedBillingDataCountry.name !== \'\')">\n                                                            {{rqdc.selectedBillingDataCountry.name}}</span>\n                                                <span\n                                                    ng-if="!(rqdc.selectedBillingDataCountry.name && rqdc.selectedBillingDataCountry.name !== \'\')"\n                                                    style="color: #b2b1b1;">\n                                                            {{\'SELECTCOUNTRY.SELECTCOUNTRY\' | translate}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="country in rqdc.getCountries($select.search, \'selectedBillingDataCountry\') |\n                                                                uiSelectFilter: {name:$select.search}">\n                                                <span ng-bind-html="country.name| highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                              ng-click="rqdc.clearBillingCountry()"\n                                              ng-style="{cursor: rqdc.readonly ? \'default\' : \'pointer\'}"></span>\n                                    </div>\n                                </div>\n                                <!--billingAddress state-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip="{{\'BILLING.DETAIL.STATE\'|translate}}"\n                                              tooltip-placement="top-left">\n                                            <span class="ion ion-ios-location"></span>\n                                        </span>\n                                        <ui-select ng-model="rqdc.selectedBillingDataState"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control"\n                                                   ng-disabled="rqdc.readonly || !rqdc.requestBD.billingData.country"\n                                                   ng-change="rqdc.selectBillingDataStateChange(\'selectedBillingDataState\');"\n                                                   append-to-body="true"\n                                                   search-enabled="true">\n                                            <ui-select-match placeholder="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}">\n                                                <span ng-if="(rqdc.selectedBillingDataState && rqdc.selectedBillingDataState !== \'\')">\n                                                    {{rqdc.selectedBillingDataState}} </span>\n                                                <span ng-if="!(rqdc.selectedBillingDataState && rqdc.selectedBillingDataState !== \'\')"\n                                                      style="color: #b2b1b1;">\n                                                    {{\'SELECTCOUNTRY.SELECTSTATE\' | translate}}\n                                                </span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="state in rqdc.getBillingDataStates($select.search, \'selectedBillingDataCountry\') |\n                                                                uiSelectFilter: $select.search">\n                                                <span ng-bind-html="state| highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <span class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                              ng-click="rqdc.clearBillingState(\'selectedStateAddress\')"\n                                              ng-style="{cursor: rqdc.readonly || !rqdc.billingBD.billingData.country ? \'default\' : \'pointer\'}"></span>\n                                    </div>\n                                </div>\n                                <!--identity-->\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'| translate}}"\n                                              class="input-group-addon input-group-addon-primary addon-left ">\n                                        <span class="ion-card"></span></span>\n                                        <input type="text" name="billingdni"\n                                               ng-change="rqdc.validDNI(rqdc.requestBD.billingData.identity.docVal, rqdc.requestBD.billingData.identity.docType.description, rqdc.resform.billingdni)"\n                                               ng-blur="rqdc.validDNI(rqdc.requestBD.billingData.identity.docVal, rqdc.requestBD.billingData.identity.docType.description, rqdc.resform.billingdni)"\n                                               ng-disabled="rqdc.readonly" required\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.identity.docVal">\n                                        <span style="width: 51px;" id="billingDetailIdentification"\n                                              class="input-group-addon input-group-addon-primary addon-right"\n                                              ng-click="rqdc.changeTypeIdeBilling(rqdc.requestBD.billingData.identity.docType);\n                                                        rqdc.validDNI(rqdc.requestBD.billingData.identity.docVal, rqdc.requestBD.billingData.identity.docType.description,rqdc.resform.billingdni)"\n                                              ng-style="(rqdc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                                {{rqdc.requestBD.billingData.identity.docType.description}}\n                                        </span>\n                                    </div>\n                                    <div class="errorValidation invalidInputMsg bounceIn animate"\n                                         ng-if="( rqdc.resform.billingdni.$touched || rqdc.submitted) && !rqdc.resform.billingdni.$valid">\n                                        {{\'ERROR.GENERROR0\' | translate}}\n                                        {{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\' | translate}}\n                                        {{\'ERROR.GENERROR1\' | translate}}\n                                    </div>\n                                </div>\n                                <div class="col-xs-4">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'REQUESTS.DETAIL.BILLING_RELATIVE\'|translate}}">\n                                            <span class="ion-android-person" style="margin-left: -1px"></span>\n                                        </span>\n                                        <input type="text" name="relative" ng-disabled="rqdc.readonly"\n                                               class="form-control with-primary-addon" required\n                                               ng-class="{\'invalid\': (rqdc.resform.relative.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.relative.$valid }"\n                                               placeholder="{{\'REQUESTS.DETAIL.BILLING_RELATIVE\'|translate}}"\n                                               ng-model="rqdc.requestBD.billingData.relative">\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <!-- Modalidad -->\n                                <div class="col-md-6">\n                                    <div class="input-group">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  tooltip-placement="bottom-left"\n                                                  uib-tooltip="{{\'REQUESTS.DETAIL.BILLING_MODALITY\'| translate}}">\n                                                <span class="ion-android-calendar" style="margin-left:-1px"></span></span>\n                                        <ui-select ng-model="rqdc.requestBD.billingData.type"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                                   ng-class="{\'invalid\': rqdc.submitted && !rqdc.requestBD.billingData.type}"\n                                                   append-to-body="true" name="billingType" search-enabled="true" required>\n                                            <ui-select-match placeholder="{{\'REQUESTS.DETAIL.BILLING_MODALITY\'| translate}}">\n                                                <span> {{rqdc.requestBD.billingData.type.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices\n                                                repeat="option in rqdc.constants.billingType | uiSelectFilter: {name:$select.search}">\n                                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n\n                            </div>\n\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.BILLING_BANKDATA\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <div class="input-group payment">\n                                        <div class="row">\n                                            <div class="col-md-12">\n                                                <div class="row">\n                                                    <div class="col-md-12">\n                                                        <div class="input-group">\n                                                            <span uib-tooltip="{{\'PAYMENT.PAYMENTTYPE\' | translate}}"\n                                                                  tooltip-placement="right"\n                                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                                <span class="ion ion-android-list"></span>\n                                                            </span>\n                                                            <ui-select ng-model="rqdc.requestBD.billingData.payType"\n                                                                       ng-class="{\'invalid\': rqdc.submitted && !rqdc.requestBD.billingData.payType}"\n                                                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                                       class="btn-group bootstrap-select form-control"\n                                                                       append-to-body="true"\n                                                                       ng-disabled="rqdc.readonly"\n                                                                       name="payType"\n                                                                       ng-change="rqdc.changePayType();"\n                                                                       search-enabled="true">\n                                                                <ui-select-match\n                                                                    allow-clear=true\n                                                                    placeholder="{{\'PAYMENT.PAYMENTTYPE\'| translate}}">\n                                                                    {{rqdc.requestBD.billingData.payType.description}}\n                                                                </ui-select-match>\n                                                                <ui-select-choices\n                                                                    repeat="option in rqdc.constants.payType | uiSelectFilter: {name:$select.search}">\n                                                                    <span\n                                                                        ng-bind-html="option.description | highlight: $select.search"></span>\n                                                                </ui-select-choices>\n                                                            </ui-select>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <div ng-if="rqdc.requestBD.billingData.payType.code===\'domiciliado\'">\n                                                    <div class="row">\n                                                        <div class="col-md-12">\n                                                            <div class="input-group"\n                                                                 ng-style="rqdc.resform.bankHolder.$touched && (rqdc.resform.bankHolder.$invalid ||\n                                                                        rqdc.resform.bankHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                <span uib-tooltip="{{\'PAYMENT.BANKHOLDER\' | translate}}"\n                                                                      tooltip-placement="right"\n                                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                                    <span class="ion-android-person"></span>\n                                                                </span>\n                                                                <input type="text" name="bankHolder" required\n                                                                       class="form-control with-primary-addon"\n                                                                       ng-disabled="rqdc.readonly"\n                                                                       ng-class="{\'invalid\': ( rqdc.resform.bankHolder.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.bankHolder.$valid}"\n                                                                       placeholder="{{\'PAYMENT.BANKHOLDER\'|translate}}"\n                                                                       ng-model="rqdc.requestBD.billingData.bank.holder">\n                                                            </div>\n                                                            <span ng-show="rqdc.resform.bankHolder.$touched && (rqdc.resform.bankHolder.$invalid ||\n                                                                rqdc.resform.bankHolder.$error.required)" class="msgError">\n                                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                        </div>\n                                                    </div>\n                                                    <div class="row">\n                                                        <div class="col-md-12">\n                                                            <div class="input-group"\n                                                                 ng-style="rqdc.resform.bankSwift.$touched && (rqdc.resform.bankSwift.$invalid ||\n                                                                            rqdc.resform.bankSwift.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                <span uib-tooltip="{{\'PAYMENT.SWIFT\' | translate}}"\n                                                                      tooltip-placement="right"\n                                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                                    <span class="fa fa-bank"></span>\n                                                                </span>\n                                                                <input type="text" ng-disabled="rqdc.readonly"\n                                                                       name="bankSwift" required\n                                                                       class="form-control with-primary-addon"\n                                                                       ng-class="{\'invalid\': ( rqdc.resform.bankSwift.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.bankSwift.$valid}"\n                                                                       placeholder="{{\'PAYMENT.SWIFT\'|translate}}"\n                                                                       ng-model="rqdc.requestBD.billingData.bank.swift">\n                                                            </div>\n                                                            <span\n                                                                ng-show="rqdc.resform.bankSwift.$touched && rqdc.resform.bankSwift.$error.required"\n                                                                class="msgError">\n                                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                            <span\n                                                                ng-show="!rqdc.resform.bankSwift.$error.required && !rqdc.validSwift(rqdc.requestBD.billingData.bank.swift, rqdc.resform.bankSwift)"\n                                                                class="msgError">\n                                                                    {{\'ERROR.GENERROR0\' | translate}}\n                                                                    {{\'PAYMENT.SWIFT\' | translate}}\n                                                                    {{\'ERROR.GENERROR1\' | translate}}\n                                                                </span>\n                                                        </div>\n                                                    </div>\n                                                    <div class="row">\n                                                        <div class="col-md-12">\n                                                            <div class="input-group"\n                                                                 ng-style="rqdc.resform.bankIban.$touched && (rqdc.resform.bankIban.$invalid ||\n                                                                        rqdc.resform.bankIban.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                <span uib-tooltip="{{\'PAYMENT.IBAN\' | translate}}"\n                                                                      tooltip-placement="right"\n                                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                                    <span class="fa fa-bank"></span>\n                                                                </span>\n                                                                <input type="text" ng-disabled="rqdc.readonly"\n                                                                       name="bankIban" required\n                                                                       class="form-control with-primary-addon"\n                                                                       ng-class="{\'invalid\': ( rqdc.resform.bankIban.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.bankIban.$valid}"\n                                                                       placeholder="{{\'PAYMENT.IBAN\'|translate}}"\n                                                                       ng-model="rqdc.requestBD.billingData.bank.iban">\n                                                            </div>\n                                                            <span\n                                                                ng-show="rqdc.resform.bankIban.$touched && rqdc.resform.bankIban.$error.required"\n                                                                class="msgError">\n                                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                            <span ng-show="!rqdc.resform.bankIban.$error.required &&\n                                                                                !rqdc.validIban(rqdc.requestBD.billingData.bank.iban, rqdc.resform.bankIban)"\n                                                                  class="msgError">\n                                                                                {{\'ERROR.GENERROR0\' | translate}}\n                                                                                {{\'PAYMENT.IBAN\' | translate}}\n                                                                                {{\'ERROR.GENERROR1\' | translate}}</span>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                                <div ng-if="rqdc.requestBD.billingData.payType.code===\'tarjeta\'">\n                                                    <div class="row">\n                                                        <div class="col-md-12">\n                                                            <div class="input-group"\n                                                                 ng-style="rqdc.resform.cardHolder.$touched && (rqdc.resform.cardHolder.$invalid ||\n                                                    rqdc.resform.cardHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                <span uib-tooltip="{{\'PAYMENT.CARDHOLDER\' | translate}}"\n                                                                      tooltip-placement="right"\n                                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                                    <span class="ion-android-person"></span>\n                                                                </span>\n                                                                <input type="text" ng-disabled="rqdc.readonly"\n                                                                       name="cardHolder" required\n                                                                       class="form-control with-primary-addon"\n                                                                       placeholder="{{\'PAYMENT.CARDHOLDER\'|translate}}"\n                                                                       ng-class="{\'invalid\': ( rqdc.resform.cardHolder.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.cardHolder.$valid}"\n                                                                       ng-model="rqdc.requestBD.billingData.bankCard.cardholder">\n                                                            </div>\n                                                            <span\n                                                                ng-show="rqdc.resform.cardHolder.$touched && rqdc.resform.cardHolder.$error.required"\n                                                                class="msgError">\n                                                            {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                        </div>\n                                                    </div>\n                                                    <div class="row">\n                                                        <div class="col-md-12">\n                                                            <div class="input-group"\n                                                                 ng-style="rqdc.resform.cardNumber.$touched && (rqdc.resform.cardNumber.$invalid ||\n                                                    rqdc.resform.cardNumber.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                                                      tooltip-placement="right"\n                                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                                    <span class="icon ion-card"\n                                                                          style="color:#8AF37E !important;"></span>\n                                                                </span>\n                                                                <input type="text" name="cardNumber" required\n                                                                       ng-disabled="rqdc.readonly"\n                                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                                                       ng-model="rqdc.requestBD.billingData.bankCard.number"\n                                                                       ng-class="{\'invalid\': ( rqdc.resform.cardNumber.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.cardNumber.$valid}"\n                                                                       class="form-control with-primary-addon">\n                                                            </div>\n                                                            <span\n                                                                ng-show="rqdc.resform.cardNumber.$touched && rqdc.resform.cardNumber.$error.required"\n                                                                class="msgError">\n                                            {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                        </div>\n                                                    </div>\n                                                    <div class="row">\n                                                        <div class="col-md-12">\n                                                            <div class="" style="margin-bottom: 0;">\n                                                                <date-picker-comp\n                                                                    tooltip-text="\'PAYMENT.CARDEXPDATE\' | translate"\n                                                                    date-value="rqdc.requestBD.billingData.bankCard.expDate"\n                                                                    placeholder="\'PAYMENT.CARDEXPDATE\' | translate"\n                                                                    mode-read-only="rqdc.istour || rqdc.readonly"\n                                                                    date-options="rqdc.dateOptionsFromExpCard"\n                                                                    form-reference="rqdc.resform"\n                                                                    name-field="\'cardExpDate\'"\n                                                                    min-mode="\'month\'"\n                                                                    is-required="true">\n                                                                </date-picker-comp>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                    <div class="row">\n                                                        <div class="col-md-12">\n                                                            <div class="input-group"\n                                                                 ng-style="rqdc.resform.cardCvv.$touched && (rqdc.resform.cardCvv.$invalid ||\n                                                                 rqdc.resform.cardCvv.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                <span\n                                                                    uib-tooltip="{{\'PAYMENT.CVV\' | translate}}"\n                                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                                    <span class="icon ion-card"></span>\n                                                                </span>\n                                                                <input type="text" name="cardCvv"\n                                                                       ng-disabled="rqdc.readonly" required\n                                                                       class="form-control with-primary-addon"\n                                                                       placeholder="{{\'PAYMENT.CVV\'|translate}}"\n                                                                       aria-describedby="basic-addon1"\n                                                                       valid-number style="width: 70px;"\n                                                                       ng-class="{\'invalid\': ( rqdc.resform.cardCvv.$touched || rqdc.submitted ) && !rqdc.readonly && !rqdc.resform.cardCvv.$valid}"\n                                                                       ng-model="rqdc.requestBD.billingData.bankCard.cvv">\n                                                            </div>\n                                                            <span\n                                                                ng-show="rqdc.resform.cardCvv.$touched && rqdc.resform.cardCvv.$error.required"\n                                                                class="msgError">\n                                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <!-- TUITION -->\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.BILLING_TUITION_TITLE\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row" ng-if="!rqdc.tuitionConcept._id && !rqdc.readonly">\n                                <div class="col-md-12">\n                                    <button type="button" tagaste-click="rqdc.openConceptDetail(null, null, \'tuition\')"\n                                            class="btn btn-success btn-with-icon newButton" id="newTuition">\n                                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                            <div class="row" ng-if="rqdc.tuitionConcept">\n                                <div class="col-xl-10 col-md-9 col-sm-12">\n                                    <button type="button"\n                                            tagaste-click="rqdc.openConceptDetail(rqdc.tuitionConcept, rqdc.requestBD.billingData.tuitionInvoice.invoiceNumber, \'tuition\')"\n                                            class="btn btn-success btn-with-icon newButton" id="newTuitionConcept">\n                                        <i class="fa fa-eye"></i>{{\'BUTTONS.VIEWTUITION\' | translate}}\n                                    </button>\n\n                                    <button type="button"\n                                            ng-if="rqdc.tuitionConcept && !rqdc.requestBD.billingData.tuitionInvoice.invoiceNumber"\n                                            tagaste-click="rqdc.invoice(rqdc.requestBD.billingData.tuitionInvoice, rqdc.tuitionConcept, false, \'tuition\')"\n                                            class="btn btn-success btn-with-icon newButton" id="newTuitionProforma">\n                                        <i class="fa fa-eye"></i>{{\'BUTTONS.TICKET\' | translate}}\n                                    </button>\n                                    <button type="button"\n                                            ng-if="rqdc.tuitionConcept && !rqdc.requestBD.billingData.tuitionInvoice.invoiceNumber"\n                                            tagaste-click="rqdc.invoice(rqdc.requestBD.billingData.tuitionInvoice, rqdc.tuitionConcept, true, \'tuition\')"\n                                            class="btn btn-success btn-with-icon newButton" id="newTuitionInvoice">\n                                        <i class="fa fa-eye"></i>{{\'BUTTONS.INVOICE\' | translate}}\n                                    </button>\n                                    <button type="button" ng-if="rqdc.requestBD.billingData.tuitionInvoice.proformaNumber"\n                                            tagaste-click="rqdc.printInvoice(\'proforma\', rqdc.requestBD.billingData.tuitionInvoice)"\n                                            class="btn btn-success btn-with-icon newButton" id="printTuitionProforma">\n                                        <i class="fa fa-eye"></i>{{\'BUTTONS.PRINTTICKET\' | translate}}\n                                    </button>\n                                    <button type="button" ng-if="rqdc.requestBD.billingData.tuitionInvoice.invoiceNumber"\n                                            tagaste-click="rqdc.printInvoice(\'invoice\', rqdc.requestBD.billingData.tuitionInvoice)"\n                                            class="btn btn-success btn-with-icon newButton" id="printTuitionInvoice">\n                                        <i class="fa fa-eye"></i>{{\'BUTTONS.PRINTINVOICE\' | translate}}\n                                    </button>\n                                    <button\n                                        ng-if="!rqdc.requestBD.billingData.tuitionInvoice.payDate && rqdc.requestBD.billingData.tuitionInvoice.invoiceNumber"\n                                        type="button"\n                                        tagaste-click="rqdc.payInvoice(rqdc.requestBD.billingData.tuitionInvoice, \'tuition\')"\n                                        class="btn btn-success btn-with-icon">\n                                        <i class="fa fa-credit-card"></i>{{\'BUTTONS.PAY\' | translate}}\n                                    </button>\n                                </div>\n                                <div class="col-xl-2 col-md-3 col-sm-12" ng-if="rqdc.requestBD.billingData.tuitionInvoice.payDate">\n                                    <div class="input-group">\n                                        <span\n                                            uib-tooltip="{{\'REQUESTS.DETAIL.BILLING_TUITION_DONE\' | translate}}"\n                                            class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="icon ion-card"></span>\n                                        </span>\n                                        <input type="text"\n                                               ng-disabled="true"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'REQUESTS.DETAIL.BILLING_TUITION_DONE\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               value="{{rqdc.moment(rqdc.requestBD.billingData.tuitionInvoice.payDate).format(\'L\')}}">\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row" style="margin-top: 10px">\n                                <div class="col-xs-12">\n                                    <label class="custom-checkbox">\n                                        <input id="checkTuition" type="checkbox"\n                                               ng-model="rqdc.requestBD.billingData.tuitionPaid"\n                                               ng-disabled="rqdc.readonly || rqdc.requestBD.billingData.tuitionInvoice.payDate">\n                                        <span>{{\'REQUESTS.DETAIL.BILLING_TUITION_DONE\' | translate}}</span>\n                                    </label>\n                                </div>\n                            </div>\n\n                            <!-- DEPOSIT -->\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.BILLING_DEPOSIT_TITLE\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row" ng-if="!rqdc.depositConcept._id && !rqdc.readonly">\n                                <div class="col-md-12">\n                                    <button type="button" tagaste-click="rqdc.openConceptDetail(null, null, \'deposit\')"\n                                            class="btn btn-success btn-with-icon newButton" id="newDeposit">\n                                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                            <div class="row" ng-if="rqdc.depositConcept">\n                                <div class="col-xl-2 col-md-2 col-sm-12">\n                                    <button type="button"\n                                            tagaste-click="rqdc.openConceptDetail(rqdc.depositConcept, rqdc.requestBD.billingData.depositInvoice.invoiceNumber, \'deposit\')"\n                                            class="btn btn-success btn-with-icon newButton" id="newDepositConcept">\n                                        <i class="fa fa-eye"></i>{{\'BUTTONS.VIEWDEPOSIT\' | translate}}\n                                    </button>\n<!--                                    <button type="button"-->\n<!--                                            ng-if="rqdc.depositConcept && !rqdc.requestBD.billingData.depositInvoice.invoiceNumber"-->\n<!--                                            tagaste-click="rqdc.invoice(rqdc.requestBD.billingData.depositInvoice, rqdc.depositConcept, false, \'deposit\')"-->\n<!--                                            class="btn btn-success btn-with-icon newButton" id="newDepositProforma">-->\n<!--                                        <i class="fa fa-eye"></i>{{\'BUTTONS.TICKET\' | translate}}-->\n<!--                                    </button>-->\n<!--                                    <button type="button"-->\n<!--                                            ng-if="rqdc.depositConcept && !rqdc.requestBD.billingData.depositInvoice.invoiceNumber"-->\n<!--                                            tagaste-click="rqdc.invoice(rqdc.requestBD.billingData.depositInvoice, rqdc.depositConcept, true, \'deposit\')"-->\n<!--                                            class="btn btn-success btn-with-icon newButton" id="newDepositInvoice">-->\n<!--                                        <i class="fa fa-eye"></i>{{\'BUTTONS.INVOICE\' | translate}}-->\n<!--                                    </button>-->\n<!--                                    <button type="button" ng-if="rqdc.requestBD.billingData.depositInvoice.proformaNumber"-->\n<!--                                            tagaste-click="rqdc.printInvoice(\'proforma\', rqdc.requestBD.billingData.depositInvoice)"-->\n<!--                                            class="btn btn-success btn-with-icon newButton" id="printDepositProforma">-->\n<!--                                        <i class="fa fa-eye"></i>{{\'BUTTONS.PRINTTICKET\' | translate}}-->\n<!--                                    </button>-->\n<!--                                    <button type="button" ng-if="rqdc.requestBD.billingData.depositInvoice.invoiceNumber"-->\n<!--                                            tagaste-click="rqdc.printInvoice(\'invoice\', rqdc.requestBD.billingData.depositInvoice)"-->\n<!--                                            class="btn btn-success btn-with-icon newButton" id="printDepositInvoice">-->\n<!--                                        <i class="fa fa-eye"></i>{{\'BUTTONS.PRINTINVOICE\' | translate}}-->\n<!--                                    </button>-->\n<!--                                    <button-->\n<!--                                        ng-if="!rqdc.requestBD.billingData.depositInvoice.payDate && rqdc.requestBD.billingData.depositInvoice.invoiceNumber"-->\n<!--                                        type="button"-->\n<!--                                        tagaste-click="rqdc.payInvoice(rqdc.requestBD.billingData.depositInvoice, \'deposit\')"-->\n<!--                                        class="btn btn-success btn-with-icon">-->\n<!--                                        <i class="fa fa-credit-card"></i>{{\'BUTTONS.PAY\' | translate}}-->\n<!--                                    </button>-->\n<!--                                </div>-->\n<!--                                <div class="col-xl-2 col-md-3 col-sm-12" ng-if="rqdc.requestBD.billingData.depositInvoice.payDate">-->\n<!--                                    <div class="input-group">-->\n<!--                                        <span-->\n<!--                                            uib-tooltip="{{\'REQUESTS.DETAIL.BILLING_DEPOSIT_DONE\' | translate}}"-->\n<!--                                            class="input-group-addon input-group-addon-primary addon-left">-->\n<!--                                            <span class="icon ion-card"></span>-->\n<!--                                        </span>-->\n<!--                                        <input type="text"-->\n<!--                                               ng-disabled="true"-->\n<!--                                               class="form-control with-primary-addon"-->\n<!--                                               placeholder="{{\'REQUESTS.DETAIL.BILLING_DEPOSIT_DONE\'|translate}}"-->\n<!--                                               aria-describedby="basic-addon1"-->\n<!--                                               value="{{rqdc.moment(rqdc.requestBD.billingData.depositInvoice.payDate).format(\'L\')}}">-->\n<!--                                    </div>-->\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xl-10 col-md-10 col-sm-12">\n                                    <span>{{\'REQUESTS.DETAIL.EXISTING_DEPOSIT\' | translate}}: {{rqdc.requestBD.user.deposit || 0}} \u20AC</span>\n                                </div>\n                            </div>\n                            <div class="row" style="margin-top: 10px">\n                                <div class="col-xs-12">\n                                    <label class="custom-checkbox">\n                                        <input id="checkDeposit" type="checkbox"\n                                               ng-model="rqdc.requestBD.billingData.deposit.paid"\n                                               ng-disabled="rqdc.readonly || !rqdc.depositConcept._id">\n                                        <span>{{\'REQUESTS.DETAIL.BILLING_DEPOSIT_DONE\' | translate}}</span>\n                                    </label>\n                                </div>\n                            </div>\n<!--                            <div class="row">-->\n<!--                                <div class="col-md-3">-->\n<!--                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.BILLING_DEPOSIT_DATE\' | translate"-->\n<!--                                                      placeholder="\'REQUESTS.DETAIL.BILLING_DEPOSIT_DATE\' | translate"-->\n<!--                                                      tooltip-placement="bottom-left"-->\n<!--                                                      date-value="rqdc.requestBD.billingData.deposit.date"-->\n<!--                                                      mode-read-only="rqdc.readonly"-->\n<!--                                                      is-required="false"-->\n<!--                                                      form-reference="rqdc.resform" name-field="\'depositDate\'">-->\n<!--                                    </date-picker-comp>-->\n<!--                                </div>-->\n<!--                                <div class="col-md-3">-->\n<!--                                    <div class="input-group">-->\n<!--                                        <span uib-tooltip="{{\'REQUESTS.DETAIL.BILLING_DEPOSIT_IMPORT\'| translate}}"-->\n<!--                                              class="input-group-addon input-group-addon-primary addon-left">-->\n<!--                                            <span class="fa fa-eur"></span></span>-->\n<!--                                        <input type="text" name="depositimport" ng-disabled="rqdc.readonly"-->\n<!--                                               class="form-control with-primary-addon"-->\n<!--                                               ng-class="{\'invalid\': (rqdc.resform.depositimport.$touched || rqdc.submitted) && !rqdc.readonly && !rqdc.resform.depositimport.$valid }"-->\n<!--                                               placeholder="{{\'REQUESTS.DETAIL.BILLING_DEPOSIT_IMPORT\'|translate}}"-->\n<!--                                               ng-model="rqdc.requestBD.billingData.deposit.import">-->\n<!--                                    </div>-->\n<!--                                </div>-->\n<!--                                <div class="col-md-6">-->\n<!--                                    <div class="input-group">-->\n<!--                                        <span uib-tooltip="{{\'REQUESTS.DETAIL.BILLING_DEPOSIT_NAME\'| translate}}"-->\n<!--                                              class="input-group-addon input-group-addon-primary addon-left">-->\n<!--                                            <span class="ion-android-person"></span></span>-->\n<!--                                        <input type="text" name="depositname" ng-disabled="rqdc.readonly"-->\n<!--                                               class="form-control with-primary-addon"-->\n<!--                                               ng-class="{\'invalid\': (rqdc.resform.depositname.$touched || rqdc.submitted) && !rqdc.readonly && !rqdc.resform.depositname.$valid }"-->\n<!--                                               placeholder="{{\'REQUESTS.DETAIL.BILLING_DEPOSIT_NAME\'|translate}}"-->\n<!--                                               ng-model="rqdc.requestBD.billingData.deposit.name">-->\n<!--                                    </div>-->\n<!--                                </div>-->\n<!--                            </div>-->\n                        </uib-tab>\n\n                        <uib-tab index="4" uib-tooltip="{{\'REQUESTS.DETAIL.REQUEST\' | translate }}"\n                                 heading="{{\'REQUESTS.DETAIL.REQUEST\' | translate }}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-file-text\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.REQUEST\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <!-- COURSE -->\n                                <div class="col-md-6 col-sm-12">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'REQUESTS.DETAIL.COURSE\'| translate}}">\n                                            <span class="ion-android-person" style="margin-left:-1px"></span></span>\n                                        <ui-select ng-model="rqdc.requestBD.modalityData.course"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                                   ng-class="{\'invalid\': rqdc.submitted && !(rqdc.requestBD.modalityData && rqdc.requestBD.modalityData.course)}"\n                                                   append-to-body="true" name="modalityCourse" search-enabled="true" required>\n                                            <ui-select-match placeholder="{{\'REQUESTS.DETAIL.COURSE\' | translate}}">\n                                                <span> {{rqdc.requestBD.modalityData.course && rqdc.requestBD.modalityData.course.name ?\n                                                    rqdc.requestBD.modalityData.course.name : rqdc.requestBD.modalityData.course}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rqdc.courses | uiSelectFilter: {name:$select.search}">\n                                                <span ng-bind-html="option.name | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <!-- TYPE (Pension) -->\n                                <div class="col-md-6 col-sm-12">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'REQUESTS.DETAIL.REQUEST_TYPE\'| translate}}">\n                                            <span class="ion-card" style="margin-left:-1px"></span></span>\n                                        <ui-select ng-model="rqdc.requestBD.modalityData.type"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                                   ng-class="{\'invalid\': rqdc.submitted && !(rqdc.requestBD.modalityData && rqdc.requestBD.modalityData.type)}"\n                                                   append-to-body="true" name="modalityType" search-enabled="true" required>\n                                            <ui-select-match placeholder="{{\'REQUESTS.DETAIL.REQUEST_TYPE\' | translate}}">\n                                                <span> {{rqdc.requestBD.modalityData.type.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rqdc.constants.modality |\n                                                        uiSelectFilter: {name:$select.search}">\n                                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <!-- ROOM_CHOICE -->\n                                <div class="col-md-6 col-sm-12">\n                                    <div class="input-group" ng-if="rqdc.roomTypes">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'REQUESTS.DETAIL.REQUEST_ROOM_CHOICE\'| translate}}">\n                                            <span class="ion-pricetags" style="margin-left:-1px"></span></span>\n                                        <ui-select ng-model="rqdc.requestBD.modalityData.roomType"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rqdc.readonly"\n                                                   ng-class="{\'invalid\': rqdc.submitted && !(rqdc.requestBD.modalityData && rqdc.requestBD.modalityData.roomType)}"\n                                                   append-to-body="true" name="roomType" search-enabled="true" required>\n                                            <ui-select-match placeholder="{{\'REQUESTS.DETAIL.REQUEST_ROOM_CHOICE\'| translate}}">\n                                                <span> {{rqdc.requestBD.modalityData.roomType.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rqdc.roomTypes |\n                                                        uiSelectFilter: {name:$select.search}">\n                                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <!-- DATE_FROM -->\n                                <div class="col-md-6 col-sm-12">\n                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_FROM\' | translate"\n                                                      placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_FROM\' | translate"\n                                                      tooltip-placement="bottom-left" date-value="rqdc.requestBD.modalityData.dateFrom"\n                                                      mode-read-only="rqdc.readonly"\n                                                      form-reference="rqdc.resform"\n                                                      name-field="\'reqDateFrom\'"\n                                                      is-required="true"\n                                                      special-validation="rqdc.checkDates()"\n                                                      required>\n                                    </date-picker-comp>\n                                </div>\n                                <!-- DATE_TO -->\n                                <div class="col-md-6 col-sm-12">\n                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_TO\' | translate"\n                                                      placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_TO\' | translate"\n                                                      tooltip-placement="bottom-left" date-value="rqdc.requestBD.modalityData.dateTo"\n                                                      mode-read-only="rqdc.readonly"\n                                                      form-reference="rqdc.resform" name-field="\'reqDateTo\'"\n                                                      is-required="true"\n                                                      required>\n                                    </date-picker-comp>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <!-- DATE_CONTRACT_SIGN -->\n                                <div class="col-md-6 col-sm-12">\n                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_CONTRACT_SIGN\' | translate"\n                                                      placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_CONTRACT_SIGN\' | translate"\n                                                      tooltip-placement="bottom-left" date-value="rqdc.requestBD.modalityData.dateContract"\n                                                      mode-read-only="rqdc.readonly"\n                                                      form-reference="rqdc.resform" name-field="\'reqDateContract\'">\n                                    </date-picker-comp>\n                                </div>\n                                <!-- DATE_RULES_SIGN -->\n                                <div class="col-md-6 col-sm-12">\n                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_RULES_SIGN\' | translate"\n                                                      placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_RULES_SIGN\' | translate"\n                                                      tooltip-placement="bottom-left"\n                                                      date-value="rqdc.requestBD.modalityData.dateRegulations"\n                                                      mode-read-only="rqdc.readonly"\n                                                      form-reference="rqdc.resform" name-field="\'reqDateRegulations\'">\n                                    </date-picker-comp>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <!-- DATE_CANCEL -->\n                                <div class="col-md-6 col-sm-12">\n                                    <!--                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_RULES_SIGN\' | translate"-->\n                                    <!--                                                      placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_RULES_SIGN\' | translate"-->\n                                    <!--                                                      tooltip-placement="bottom-left" date-value="rqdc.requestBD.modalityData.dateRegulations"-->\n                                    <!--                                                      mode-read-only="rqdc.readonly"-->\n                                    <!--                                                      form-reference="rqdc.resform" name-field="\'reqDateRegulations\'">-->\n                                    <!--                                    </date-picker-comp>-->\n                                </div>\n                                <!-- EMPTY -->\n                                <div class="col-md-6 col-sm-12"></div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="5" uib-tooltip="{{\'REQUESTS.DETAIL.REQUEST_VISITS\' | translate }}"\n                                 heading="{{\'REQUESTS.DETAIL.REQUESTS_VISITS\' | translate }}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-eye\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.REQUEST_VISITS\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <table ng-table="rqdc.visitTableParams " id="visitTableParams"\n                                           style="font-size: 11px;"\n                                           class="table table-hover table-condensed fixNgTable"\n                                           show-filter="false">\n                                        <colgroup>\n                                            <col width="200px"> <!-- Date -->\n                                            <col> <!-- ROOM -->\n                                            <col> <!-- Rating -->\n                                        </colgroup>\n                                        <tr ng-repeat="row in $data | dummyDataIfEmpty: [] | showErrorNoData track by $index"\n                                            style="cursor: pointer;"\n                                            tagaste-click="rqdc.openVisitDetail(row, true);$event.stopPropagation();"\n                                            ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                                            class="ng-binding">\n                                            <td colspan="2" ng-if="row.error" ng-src="{{row.error}}">\n                                                {{row.error}}\n                                            </td>\n                                            <td data-title="\'REQUESTS.DETAIL.VISIT_DATE\'|translate"\n                                                ng-if="!row.error"\n                                                sortable="\'date\'"\n                                                ng-attr-title="{{row.date}}">\n                                                {{ rqdc.moment(row.date).format(\'L\') }}\n                                            </td>\n                                            <td data-title="\'REQUESTS.DETAIL.VISIT_ROOM\'|translate"\n                                                sortable="\'room.code\'"\n                                                ng-attr-title="{{row.room.code}}">\n                                                {{row.room.code}}\n                                            </td>\n\n                                            <td data-title="\'REQUESTS.DETAIL.VISIT_RATING\'|translate"\n                                                ng-attr-title="{{row.interviewData.rating.description}} ">\n                                                {{row.interviewData.rating.description}}\n                                            </td>\n\n                                            <td ng-if="!rqdc.selectr._id && !row.error && !rqdc.readonly" class="text-center"\n                                                style="white-space: nowrap;">\n                                                <i class="fa fa-pencil iconNgTable edit" style="padding: 0 10px;"\n                                                   uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                                   ng-if="rqdc.gotAccessMod"\n                                                   aria-hidden="true"\n                                                   tagaste-click="rqdc.openVisitDetail(row, false); $event.stopPropagation();">\n                                                </i>\n                                                <i class="fa fa-trash-o iconNgTable edit"\n                                                   uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                   ng-if="rqdc.gotAccessDel"\n                                                   aria-hidden="true"\n                                                   tagaste-click="rqdc.deleteVisit(row); $event.stopPropagation();">\n                                                </i>\n                                            </td>\n                                        </tr>\n                                    </table>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12 ">\n                                    <!--                                    <span style="flex-grow: 1" class="count"><span id="totalItems">-->\n                                    <!--                                        {{ \'TOTAL\' |translate }} : {{ rqlsc.tableParams.total() }}</span></span>-->\n                                    <button type="button"\n                                            ng-if="!rqdc.readonly"\n                                            tagaste-click="rqdc.openVisitDetail({});$event.stopPropagation();"\n                                            class="btn btn-success btn-with-icon pull-right newButton" id="newVisitButton">\n                                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n\n                        </uib-tab>\n\n                        <uib-tab index="6" uib-tooltip="{{\'REQUESTS.DETAIL.CONTACTS\' | translate }}"\n                                 heading="{{\'REQUESTS.DETAIL.CONTACTS\' | translate }}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-phone\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.CONTACTS\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div>\n                                <div class="input-group" style="overflow-y: hidden;">\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <table ng-table="rqdc.contactsTableParams"\n                                                   class="table table-hover table-condensed fixNgTable" show-filter="false"\n                                                   style="font-size: 11px;">\n\n                                                <colgroup>\n                                                    <col width="100px">\n                                                    <col width="100px">\n                                                    <col width="200px">\n                                                    <col>\n                                                    <col width="20px">\n                                                    <col width="20px">\n                                                </colgroup>\n\n                                                <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                                                    class="ng-binding">\n                                                    <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                                                        {{row.error}}\n                                                    </td>\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_DATE\'|translate" ng-if="!row.modeEdit"\n                                                        sortable="\'dateFormat\'" ng-attr-title="{{row.dateFormat}}">\n                                                        {{row.dateView | date:\'MM/dd/yyyy\'}}\n                                                    </td>\n\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_DATE\'|translate" ng-if="row.modeEdit"\n                                                        sortable="\'dateFormat\'" ng-attr-title="{{row.dateFormat}}">\n                                                        <input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy"\n                                                               ng-required="true"\n                                                               style="border-radius: 0;"\n                                                               id="datePicker"\n                                                               ng-click="row.datepicker.isOpen = true"\n                                                               ng-model="row.date"\n                                                               is-open="row.datepicker.isOpen"\n                                                               close-text="{{\'DATEPICKER.BUTTON.CLOSE\'| translate}}"\n                                                               clear-text="{{\'DATEPICKER.BUTTON.CLEAR\'| translate}}"\n                                                               current-text="{{\'DATEPICKER.BUTTON.TODAY\'| translate}}">\n                                                    </td>\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_TYPE\'|translate"\n                                                        sortable="\'type\'"\n                                                        ng-attr-title="{{row.type.description}}"\n                                                        ng-if="row.modeEdit">\n                                                        <select class="form-control"\n                                                                name="ContactType_{{$index +1}}"\n                                                                id="ContactType_{{$index +1}}" ng-model="row.type"\n                                                                ng-options="type.description for type in rqdc.constants.contactType track by type._id"\n                                                                required>\n                                                        </select>\n                                                    </td>\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_TYPE\'|translate"\n                                                        sortable="\'type\'"\n                                                        ng-attr-title="{{row.type.description}}"\n                                                        ng-if="!row.modeEdit">\n                                                        {{row.type.description}}\n                                                    </td>\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_PROFESSIONAL\'|translate"\n                                                        sortable="\'professional\'" ng-attr-title="{{row.professional}}"\n                                                        ng-if="row.modeEdit">\n                                                        <input type="text" ng-model="row.professional" name="professional_{{$index +1}}"\n                                                               class="form-control with-primary-addon"\n                                                               id="professional_{{$index +1}}" required>\n                                                    </td>\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_PROFESSIONAL\'|translate"\n                                                        sortable="\'professional\'" ng-attr-title="{{row.professional}}"\n                                                        ng-if="!row.modeEdit">\n                                                        {{row.professional}}\n                                                    </td>\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_ISSUE\'|translate"\n                                                        sortable="\'issue\'" ng-attr-title="{{row.issue}}"\n                                                        ng-if="row.modeEdit">\n                                                            <textarea ng-model="row.issue" name="text"\n                                                                      class="form-control with-primary-addon"\n                                                                      aria-describedby="basic-addon1"\n                                                                      ng-disabled="rqdc.readonly"\n                                                                      placeholder="{{\'RESIDENTWINDOWDETAIL.OTHERCOMENTS\'|translate}}"\n                                                                      style="height: inherit;">\n                                                            </textarea>\n                                                    </td>\n                                                    <td data-title="\'REQUESTS.DETAIL.CONTACT_ISSUE\'|translate"\n                                                        sortable="\'issue\'" ng-attr-title="{{row.issue}}"\n                                                        ng-if="!row.modeEdit">\n                                                        {{row.issue}}\n                                                    </td>\n                                                    <td ng-if="!rqdc.readonly && !row.modeEdit">\n                                                        <i class="fa fa-pencil iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                                           ng-if="!row.modeEdit && !rqdc.addingContact && !row.error" aria-hidden="true"\n                                                           tagaste-click="rqdc.editContact(row); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n\n                                                    <td ng-if="!rqdc.readonly && !row.modeEdit">\n                                                        <i class="fa fa-trash-o iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                           ng-if="!row.modeEdit && !rqdc.addingContact && !row.error" aria-hidden="true"\n                                                           tagaste-click="rqdc.deleteContact(row, $index); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n\n                                                    <td ng-if="!rqdc.readonly && row.modeEdit">\n                                                        <i class="glyphicon glyphicon-ok iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                                                           ng-if="row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="rqdc.saveContact(row, $index); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n\n                                                    <td ng-if="!rqdc.readonly && row.modeEdit">\n                                                        <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                                                           ng-if="row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="rqdc.cancelContact(row, $index); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                </tr>\n                                            </table>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div ng-class="\'col-md-offset-10 col-xs-2\'">\n\n                                            <button type="button"\n                                                    ng-if="!rqdc.readonly && !rqdc.addingContact"\n                                                    tagaste-click="rqdc.addContact({});$event.stopPropagation();"\n                                                    class="btn btn-success btn-with-icon pull-right newButton" id="newVisitButton">\n                                                <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="7" uib-tooltip="{{\'REQUESTS.DETAIL.DOCUMENTATION\' | translate}}"\n                                 heading="{{\'REQUESTS.DETAIL.DOCUMENTATION\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-paperclip\' style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.DOCUMENTATION\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <label class="custom-checkbox">\n                                        <input id="checkDocumentation" type="checkbox"\n                                               ng-model="rqdc.requestBD.documentation.documentationCheck"\n                                               ng-click="rqdc.documentationCheck(!rqdc.requestBD.documentation.documentationCheck)">\n                                        <span>{{\'REQUESTS.DETAIL.DOCUMENTATION_DELIVERED\' | translate}}</span>\n                                    </label>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <div class="input-group"\n                                         style="border-color: rgb(55, 55, 55); border-width: 1px 1px 1px 0; border-style: solid; border-radius: 4px">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'SERVICEMENUDETAIL.ATTACHEDS\' | translate}}"\n                                                  tooltip-placement="right-top" style="vertical-align: top">\n                                                <span class="ion-camera"></span>\n                                            </span>\n                                        <div id="residentAttacheds" readonly="rqdc.readonly" class="tagast-files">\n                                            <div class="tagaste-file-add" ng-if=\'!rqdc.readonly\'>\n                                                <file img="rqdc.file" file-style="display: inline"\n                                                      style="cursor:pointer;"\n                                                      uploading="rdect.fileUploading"\n                                                      ng-disabled="rqdc.user.action === \'inEdit\' || rqdc.readonly"\n                                                      style-button="true"\n                                                      attacheds-list="rqdc.requestBD.user.attacheds">\n                                                </file>\n                                            </div>\n\n                                            <div style="overflow-x: hidden; overflow-y:hidden;" scroll-glue-right="!glued;"\n                                                 class="file-list">\n                                                <div class="img-card-row"\n                                                     ng-repeat="attached in rqdc.requestBD.user.attacheds track by $index"\n                                                     ng-if="rqdc.requestBD.user.attacheds.length > 0">\n                                                    <card-file\n                                                        attached="attached" readonly="rqdc.readonly"\n                                                        uploading="rdect.fileUploading" max-long-name="8">\n                                                    </card-file>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n\n                    </uib-tabset>\n                </div>\n                <div class="row">\n                    <div class="col-xs-12" style="margin-top:13px;">\n                        <p ng-if="rqdc.submitted && !rqdc.readonly && !rqdc.resform.$valid"\n                           class="pull-right errorValidation bounceIn animate">\n                            {{\'ERROR.ERRORININPUT\'\n                        | translate}}</p>\n                    </div>\n                </div>\n                <div class="panel-footer-buttons">\n                    <div class="row">\n                        <div class="pull-right">\n                            <button class="residentDetailCancel btn btn-success btn-with-icon" id="acceptRequest"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    ng-if="!rqdc.readonly && rqdc.requestBD._id" tagaste-click="rqdc.acceptRequest(rqdc.resform)">\n                                <i class="fa fa-check"></i>{{\'REQUESTS.DETAIL.ACCEPT_REQUEST\' | translate}}\n                            </button>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="pull-right">\n                            <button class="residentDetailCancel btn btn-success btn-with-icon" id="residentDetailBack"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    ng-if="rqdc.readonly" tagaste-click="rqdc.back()">\n                                <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' | translate}}\n                            </button>\n                            <button class="residentDetailCancel btn btn-success btn-with-icon"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    id="requestCancelButton" tagaste-click="rqdc.back()" ng-if="!rqdc.readonly">\n                                <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' | translate}}\n                            </button>\n                            <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    tagaste-click="rqdc.save(rqdc.resform)" ng-if="!rqdc.readonly"\n                                    ng-disabled="rqdc.user.action === \'inEdit\' || rdect.avatarUploading ||\n                                    rqdc.addingContact || rqdc.checkDates() || rdect.fileUploading ||\n                                     rqdc.validBirthdate" class="btn btn-success btn-with-icon" id="requestSaveButton">\n                                <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                            </button>\n                            <!--                            ( rqdc.submitted &&  !rqdc.resform.$valid && (!rqdc.requestBD.branches)) ||-->\n                        </div>\n                    </div>\n\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/requests/requestsList/requestsList.html','<style>\n    .switchType .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after, .switchType2 .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.ALL\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.TUITION\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.DEPOSIT\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType2 .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.YES\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType2 .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.NO\'|translate}}";\n        bottom: 3px;\n    }\n</style>\n<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="REQUESTS.LIST.HEADER" ba-panel-class="with-scroll" id="requestsList">\n            <div class="filterAccordion" style="left: 280px!important;" ng-hide="rqlsc.selectr._id !== undefined">\n                <uib-accordion>\n                    <uib-accordion-group panel-class="panel-primary accordion-panel " is-open="status.open">\n                        <uib-accordion-heading>{{\'RESIDENTSWINDOW.FILTERS\' | translate}}\n                            <i class="pull-right glyphicon"\n                               ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i>\n                        </uib-accordion-heading>\n                        <div class="row">\n                            <div class="col-xs-12 switchType">\n                                <nz-toggle tri-toggle val-null="\'all\'" ng-model="rqlsc.requestPhase"\n                                           on-toggle="rqlsc.applyAdditionalFilters()" width="150"\n                                           style="width: 25px; height: 15px;" color-false="\'#8AF37E\'" color-true="\'#8AF37E\'"\n                                           title="{{\'REQUESTS.LIST.PAID\'|translate}}"></nz-toggle>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div id="historyTypeFilter">\n                                    <button type="button" ng-repeat="option in rqlsc.ratingOptions"\n                                            ng-style="(option.isSelected) ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                            tagaste-click="rqlsc.applyAdditionalFilters(option); $event.stopPropagation();"\n                                            class="btn btn-with-icon btn-rating-filter">\n                                        <span ng-if="option.name === \'all\'">{{\'BUTTONS.ALL\' | translate}}</span>\n                                        <i class="fa fa-circle" ng-if="option.name !== \'all\'"\n                                           ng-class="{bronze: option.name === \'bronze\',\n                                           silver: option.name === \'silver\', gold: option.name === \'gold\'}"></i>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12 switchType2">\n                                <nz-toggle tri-toggle val-null="\'all\'" ng-model="rqlsc.requestIsReservation"\n                                           on-toggle="rqlsc.applyAdditionalFilters()"\n                                           width="150" style="width: 25px; height: 15px;" color-false="\'#e85656\'"\n                                           color-true="\'#8AF37E\'" title="{{\'REQUESTS.LIST.COMPLETE\'|translate}}"></nz-toggle>\n                            </div>\n                        </div>\n                    </uib-accordion-group>\n                </uib-accordion>\n            </div>\n\n            <div class="resumeTourContainer" style="left: 480px!important;">\n                <span class="ion-ios-information-outline" tagaste-click="rqlsc.initTour()" style="cursor: pointer;"\n                      ng-hide="rqlsc.selectr._id !== undefined"></span>\n            </div>\n\n            <div class="horizontal-scroll" ng-class="(rqlsc.selectr._id) ? \'hideTableCounts\': \'\'" ng-if="rqlsc.tableParams">\n                <table ng-table="rqlsc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true">\n                    <colgroup>\n                        <col width="3%">\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                    </colgroup>\n                    <tr ng-repeat="row in $data | dummyDataIfEmpty:rqlsc.tourDummyData | showErrorNoData track by $index"\n                        style="cursor: pointer;"\n                        tagaste-click="rqlsc.rowClick(row);$event.stopPropagation();"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td>\n                            <img class="photo-icon" check-avatar\n                                 ng-src="{{row.user.photo.thumb.signedUrl}}"\n                                 ng-if="!row.error"\n                                 style="max-width: 30px;border-radius:30px"/>\n                        </td>\n                        <td colspan="7" ng-if="row.error" ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n\n                        <td data-title="\'REQUESTS.LIST.TABLE_NAME\'|translate"\n                            sortable="\'userName\'"\n                            ng-attr-title="{{row.userName}}"\n                            filter="rqlsc.filterName">\n                            {{row.userName}}\n                        </td>\n                        <td data-title="\'REQUESTS.LIST.TABLE_LASTNAME\'|translate"\n                            sortable="\'userSurname\'"\n                            ng-attr-title="{{row.userSurname}}"\n                            filter="rqlsc.filterSurname">\n                            {{row.userSurname}}\n                        </td>\n                        <td data-title="\'REQUESTS.LIST.COURSE\'|translate"\n                            sortable="\'userCourse\'"\n                            ng-attr-title="{{row.userCourse}}"\n                            filter="rqlsc.filterCourse">\n                            {{row.userCourse}}\n                        </td>\n                        <td data-title="\'REQUESTS.LIST.DATE_APPLICATION\'|translate"\n                            sortable="\'formattedDateReverse\'"\n                            ng-attr-title="{{row.formattedDate}}"\n                            filter="rqlsc.filterDate">\n                            {{row.formattedDate}}\n                        </td>\n                        <td data-title="\'REQUESTS.LIST.BRANCH\'|translate"\n                            sortable="\'branch\'"\n                            ng-attr-title="{{row.branch}}"\n                            filter="rqlsc.filterBranch">\n                            {{row.branch}}\n                        </td>\n<!--                        <td data-title="\'REQUESTS.LIST.DATE_DEPOSIT\'|translate"-->\n<!--                            sortable="\'depositDate\'"-->\n<!--                            ng-attr-title="{{row.depositDate}}"-->\n<!--                            filter="rqlsc.filterDepositDate">-->\n<!--                            {{row.depositDate}}-->\n<!--                        </td>-->\n                        <td data-title="\'REQUESTS.DETAIL.BILLING_DEPOSIT_DONE\'|translate"\n                            sortable="\'depositPaid\'" ng-attr-title="{{row.depositPaid}}"\n                            style="text-align: center">\n                            <i class="fa fa-check" ng-if="row.depositPaid"></i>\n                        </td>\n                        <td data-title="\'REQUESTS.LIST.DATE_REGISTRATION\'|translate"\n                            sortable="\'registrationDate\'"\n                            ng-attr-title="{{row.registrationDate}}"\n                            filter="rqlsc.filterRegistrationDate">\n                            {{row.registrationDate}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.OLD_RESIDENT\'|translate"\n                            sortable="\'oldResident\'" ng-attr-title="{{row.oldResident}}"\n                            style="text-align: center">\n                            <i class="fa fa-check" ng-if="row.oldResident"></i>\n                        </td>\n                        <td data-title="\'REQUESTS.LIST.AVERAGE_RATING\'|translate"\n                            sortable="\'averageRating.code\'"\n                            ng-attr-title="{{row.averageRating.description}}">\n                            <i class="fa fa-circle" ng-if="row.averageRating && row.averageRating.description"\n                               ng-class="{bronze: row.averageRating.code == \'0\',\n                               silver: row.averageRating.code == \'5\', gold: row.averageRating.code == \'10\'}"></i>\n                        </td>\n                        <td data-title="\'REQUESTS.LIST.IS_RESERVATION\'|translate"\n                            sortable="\'isReservation\'" ng-attr-title="{{row.accepted}}"\n                            style="text-align: center">\n                            <i class="fa fa-check" ng-if="row.accepted"></i>\n                        </td>\n\n                        <td ng-if="!rqlsc.selectr._id && !row.error" class="text-center" style="white-space: nowrap;">\n                            <i class="fa fa-pencil iconNgTable edit" style="padding: 0 10px;"\n                               uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                               ng-if="rqlsc.gotAccessMod"\n                               aria-hidden="true"\n                               tagaste-click="rqlsc.editRow(row); $event.stopPropagation();">\n                            </i>\n                            <i class="fa fa-trash-o iconNgTable edit"\n                               uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                               ng-if="rqlsc.gotAccessDel && !row.accepted"\n                               aria-hidden="true"\n                               tagaste-click="rqlsc.deleteRow(row); $event.stopPropagation();">\n                            </i>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!rqlsc.selectr._id">\n                <div class="col-xs-12 countAndNewButton">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' | translate }} : {{ rqlsc.tableParams.total() }}</span></span>\n                    <button type="button"\n                            tagaste-click="rqlsc.new();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="newRequestButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                    </button>\n                    <button type="button"\n                            tagaste-click="rqlsc.exportData();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/reservations/reservationDetail/reservationDetail.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel resident-detail detail-panel">\n        <div ba-panel ba-panel-title="RESERVATIONS.DETAIL.HEADER" ba-panel-class="with-scroll"\n             ba-panel-anim="zoom-in" style="line-height:30px;" id="reservationDetail">\n            <form name="rsdc.resform" autocomplete="false" ng-if="rsdc.reservation">\n                <div class="row">\n                    <div class="col-md-6">\n                        <!--is guest-->\n                        <label class="custom-checkbox" style="margin-bottom: 5px;" ng-if="rsdc.isGuest">\n                            <input id="checkGuest" type="checkbox" ng-model="rsdc.isGuest" ng-disabled="true">\n                            <span>{{\'RESERVATIONS.DETAIL.IS_GUEST\' | translate}}</span>\n                        </label>\n                    </div>\n                    <div class="col-md-6">\n                        <!--status-->\n                        <div class="input-group" ng-if="rsdc.reservationId">\n                            <input type="text" ng-disabled="true" name="status"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'RESERVATIONS.LIST.STATUS\'|translate}}"\n                                   style="border-radius: 5px;" required ng-model="rsdc.reservation.status">\n                        </div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-6">\n                        <!--name-->\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'RESERVATIONS.LIST.NAME\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  id="reservationDetailTooltip">\n                                <span class="ion-android-person"></span></span>\n                            <input type="text" name="firstname" ng-disabled="rsdc.reservationId"\n                                   class="form-control with-primary-addon "\n                                   placeholder="{{\'RESIDENTWINDOWDETAIL.NAME\'|translate}}"\n                                   ng-class="{\'invalid\': (rsdc.resform.firstname.$touched || rsdc.submitted )&& !rsdc.readonly && !rsdc.resform.firstname.$valid }"\n                                   ng-model="rsdc.reservation.nombre" required>\n                        </div>\n                    </div>\n                    <div class="col-md-6">\n                        <!--surname-->\n                        <div class="input-group">\n                            <input type="text" ng-disabled="rsdc.reservationId" name="surname"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'RESERVATIONS.LIST.SURNAME\'|translate}}"\n                                   ng-class="{\'invalid\': (rsdc.resform.surname.$touched || rsdc.submitted )&& !rsdc.readonly && !rsdc.resform.surname.$valid }"\n                                   style="border-radius: 5px;" required ng-model="rsdc.reservation.apellidos" required>\n                        </div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-6">\n                        <!--code-->\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'RESERVATIONS.LIST.CODE\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  id="reservation2DetailTooltip">\n                                <span class="ion-ios-barcode"></span></span>\n                            <input type="text" name="codigoReserva" ng-disabled="true"\n                                   class="form-control with-primary-addon "\n                                   placeholder="{{\'RESERVATIONS.LIST.CODE\'|translate}}"\n                                   ng-model="rsdc.reservation.codigoReserva" ng-required="rsdc.reservationId">\n                        </div>\n                    </div>\n                    <div class="col-md-6">\n                        <!--branch-->\n                        <div class="input-group"\n                             ng-class="{\'select-invalid\': rsdc.submitted && !rsdc.reservation.branch }">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  tooltip-placement="bottom-left"\n                                  uib-tooltip="{{\'RESERVATIONS.LIST.BRANCH\'| translate}}">\n                            <span class="ion-card"></span></span>\n                            <ui-select ng-model="rsdc.reservation.branch"\n                                       ng-disabled="rsdc.reservationId || rsdc.selectedBranch"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       required\n                                       class="btn-group bootstrap-select form-control with-primary-addon"\n                                       append-to-body="false" ng-change="rsdc.changeBranch()">\n                                <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.BRANCH\'| translate}}">\n                                    <span> {{rsdc.reservation.branch.description}}</span>\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in rsdc.constants.branches |\n                                                                uiSelectFilter: {description:$select.search}">\n                                    <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="rsdc.submitted && !rsdc.reservation.branch">\n                            {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                        </div>\n                    </div>\n                </div>\n                <div class="row" ng-if="rsdc.isGuest">\n                    <div class="col-xs-6">\n                        <!--identity-->\n                        <div class="input-group">\n                        <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'| translate}}"\n                              class="input-group-addon input-group-addon-primary addon-left ">\n                            <span class="ion-card"></span></span>\n                            <input type="text" name="dni" ng-change="rsdc.validDNI(rsdc.reservation.identity.docVal,\n                                            rsdc.reservation.identity.docType.description,\n                                            rsdc.resform.dni)" ng-blur="rsdc.validDNI(rsdc.reservation.identity.docVal,\n                                            rsdc.reservation.identity.docType.description,\n                                            rsdc.resform.dni)" ng-disabled="rsdc.readonly"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'|translate}}"\n                                   ng-model="rsdc.reservation.identity.docVal" required>\n                            <span style="width: 51px" id="reservationDetailIdentification"\n                                  class="input-group-addon input-group-addon-primary addon-right"\n                                  ng-click="rsdc.changeTypeIde(rsdc.reservation.identity.docType);\n                                            rsdc.validDNI(rsdc.reservation.identity.docVal,\n                                            rsdc.reservation.identity.docType.description,rsdc.resform.dni)"\n                                  ng-style="(rsdc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                        {{rsdc.reservation.identity.docType ?\n                                rsdc.reservation.identity.docType.description : rsdc.reservation.identity.description}}</span>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="( rsdc.resform.dni.$touched || rsdc.submitted)&& !rsdc.resform.dni.$valid">\n                            {{\'ERROR.GENERROR0\' | translate}}\n                            {{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\' | translate}}\n                            {{\'ERROR.GENERROR1\' | translate}}\n                        </div>\n                    </div>\n                    <div class="col-xs-6">\n                        <!--email-->\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.EMAIL\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-at"></span></span>\n                            <input type="text" ng-disabled="rsdc.readonly" name="email"\n                                   ng-change="rsdc.validEmail(rsdc.reservation.email,rsdc.resform.email)"\n                                   ng-blur="rsdc.validEmail(rsdc.reservation.email,rsdc.resform.email)"\n                                   ng-class="{\'invalid\': (rsdc.resform.email.$touched || rsdc.submitted )&& !rsdc.readonly && !rsdc.resform.email.$valid }"\n                                   autocomplete="email" class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.EMAIL\'|translate}}"\n                                   ng-model="rsdc.reservation.email" required>\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(rsdc.resform.email.$touched|| rsdc.submitted ) && !rsdc.resform.email.$valid">\n                            {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                        </div>\n                    </div>\n                </div>\n                <div class="row" ng-if="rsdc.isGuest">\n                    <div class="col-xs-6">\n                        <!--phone-->\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'BILLING.DETAIL.PHONE\'| translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-ios-telephone"></span></span>\n                            <input type="text" name="phone" ng-change="rsdc.validatePhone(rsdc.reservation.phone,\n                                           rsdc.resform.phone)" ng-blur="rsdc.validatePhone(rsdc.reservation.phone,\n                                           rsdc.resform.phone)" ng-disabled="rsdc.readonly"\n                                   class="form-control with-primary-addon"\n                                   placeholder="{{\'BILLING.DETAIL.PHONE\'|translate}}"\n                                   ng-model="rsdc.reservation.phone">\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(rsdc.resform.phone.$touched || rsdc.submitted) && !rsdc.resform.phone.$valid">\n                            {{\'ERROR.GENERROR0\' | translate}}\n                            {{\'BILLING.DETAIL.PHONE\' | translate}}\n                            {{\'ERROR.GENERROR1\' | translate}}\n                        </div>\n                    </div>\n                    <div class="col-xs-6">\n                        <!--mobile-->\n                        <div class="input-group">\n                                <span uib-tooltip="{{\'RESERVATIONS.DETAIL.MOBILE\'| translate}}"\n                                      class="input-group-addon input-group-addon-primary addon-left">\n                                    <span class="ion-ios-telephone"></span></span>\n                            <input type="text" name="movil"\n                                   ng-change="rsdc.validateMobile(rsdc.reservation.movil, rsdc.resform.movil)"\n                                   ng-blur="rsdc.validateMobile(rsdc.reservation.movil, rsdc.resform.movil)"\n                                   ng-disabled="rsdc.readonly" class="form-control with-primary-addon"\n                                   placeholder="{{\'RESERVATIONS.DETAIL.MOBILE\'|translate}}"\n                                   ng-model="rsdc.reservation.movil">\n                        </div>\n                        <div class="errorValidation invalidInputMsg bounceIn animate"\n                             ng-if="(rsdc.resform.movil.$touched || rsdc.submitted) && !rsdc.resform.movil.$valid">\n                            {{\'ERROR.GENERROR0\' | translate}}\n                            {{\'RESERVATIONS.DETAIL.MOBILE\' | translate}}\n                            {{\'ERROR.GENERROR1\' | translate}}\n                        </div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-md-6 col-sm-12">\n                        <!--date from-->\n                        <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_FROM\' | translate"\n                                          placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_FROM\' | translate"\n                                          tooltip-placement="bottom-left"\n                                          date-value="rsdc.reservation.dateFrom"\n                                          date-options="rsdc.dateOptions"\n                                          mode-read-only="rsdc.readonly"\n                                          form-reference="rsdc.resform"\n                                          is-required="true"\n                                          date-changes="rsdc.changeDateFrom()"\n                                          name-field="\'reqDateFrom\'">\n                        </date-picker-comp>\n                    </div>\n                    <div class="col-md-6 col-sm-12">\n                        <!--date to-->\n                        <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_TO\' | translate"\n                                          placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_TO\' | translate"\n                                          tooltip-placement="bottom-left"\n                                          date-value="rsdc.reservation.dateTo"\n                                          date-options="rsdc.dateOptionsAfter"\n                                          mode-read-only="rsdc.readonly"\n                                          form-reference="rsdc.resform"\n                                          is-required="true"\n                                          special-validation="rsdc.checkDates()"\n                                          name-field="\'reqDateTo\'">\n                        </date-picker-comp>\n                    </div>\n                </div>\n                <div class="row">\n                    <!--pay type-->\n                    <div class="col-md-6" ng-if="rsdc.isGuest">\n                        <div class="row">\n                            <div class="col-md-12">\n                                <div class="input-group"\n                                     ng-class="{\'select-invalid\': rsdc.submitted && !rsdc.reservation.billingAccount.payType }">\n                                    <span uib-tooltip="{{\'PAYMENT.PAYMENTTYPE\' | translate}}"\n                                          tooltip-placement="right"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion ion-android-list"></span>\n                                    </span>\n                                    <ui-select ng-model="rsdc.reservation.billingAccount.payType"\n                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control"\n                                               append-to-body="true"\n                                               ng-disabled="rsdc.readonly"\n                                               name="payType"\n                                               ng-change="rsdc.changePayType();"\n                                               search-enabled="true">\n                                        <ui-select-match\n                                            allow-clear=true\n                                            placeholder="{{\'PAYMENT.PAYMENTTYPE\'| translate}}">\n                                            {{rsdc.reservation.billingAccount.payType.description}}\n                                        </ui-select-match>\n                                        <ui-select-choices\n                                            repeat="option in rsdc.constants.payTypes">\n                                            <div ng-bind-html="option.description | highlight: $select.search"></div>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="rsdc.acceptSubmit && !rsdc.reservation.billingAccount.payType">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-if="rsdc.reservation.billingAccount.payType.code===\'domiciliado\'">\n                            <div class="row">\n                                <div class="col-md-10">\n                                    <div class="input-group"\n                                         ng-style="rsdc.resform.bankHolder.$touched && (rsdc.resform.bankHolder.$invalid ||\n                                                                                rsdc.resform.bankHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                        <span uib-tooltip="{{\'PAYMENT.BANKHOLDER\' | translate}}"\n                                              tooltip-placement="right"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="ion-android-person"></span>\n                                        </span>\n                                        <input type="text" name="bankHolder" required\n                                               ng-disabled="rsdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'PAYMENT.BANKHOLDER\'|translate}}"\n                                               ng-model="rsdc.reservation.billingAccount.bank.holder">\n                                    </div>\n                                    <span ng-show="rsdc.resform.bankHolder.$touched && (rsdc.resform.bankHolder.$invalid ||\n                                                rsdc.resform.bankHolder.$error.required)" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-10">\n                                    <div class="input-group"\n                                         ng-style="rsdc.resform.bankSwift.$touched && (rsdc.resform.bankSwift.$invalid ||\n                                                    rsdc.resform.bankSwift.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                        <span uib-tooltip="{{\'PAYMENT.SWIFT\' | translate}}"\n                                              tooltip-placement="right"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="fa fa-bank"></span>\n                                        </span>\n                                        <input type="text" ng-disabled="rsdc.readonly"\n                                               name="bankSwift" required\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'PAYMENT.SWIFT\'|translate}}"\n                                               ng-model="rsdc.reservation.billingAccount.bank.swift">\n                                    </div>\n                                    <span\n                                        ng-show="rsdc.resform.bankSwift.$touched && billForm.bankSwift.$error.required"\n                                        class="msgError">{{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                    <span ng-show="!rsdc.resform.bankSwift.$error.required &&\n                                    !rsdc.validSwift(rsdc.bill.paidData.bank.swift, billForm.bankSwift)"\n                                          class="msgError">\n                                    {{\'ERROR.GENERROR0\' | translate}}\n                                    {{\'PAYMENT.SWIFT\' | translate}}\n                                    {{\'ERROR.GENERROR1\' | translate}}</span>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-10">\n                                    <div class="input-group"\n                                         ng-style="rsdc.resform.bankIban.$touched && (rsdc.resform.bankIban.$invalid ||\n                                         rsdc.resform.bankIban.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                        <span uib-tooltip="{{\'PAYMENT.IBAN\' | translate}}"\n                                              tooltip-placement="right"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="fa fa-bank"></span>\n                                        </span>\n                                        <input type="text" ng-disabled="rsdc.readonly"\n                                               name="bankIban" required\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'PAYMENT.IBAN\'|translate}}"\n                                               ng-model="rsdc.reservation.billingAccount.bank.iban">\n                                    </div>\n                                    <span\n                                        ng-show="rsdc.resform.bankIban.$touched && rsdc.resform.bankIban.$error.required"\n                                        class="msgError">{{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                    <span ng-show="!rsdc.resform.bankIban.$error.required &&\n                                                    !rsdc.validIban(rsdc.reservation.billingAccount.bank.iban, rsdc.resform.bankIban)"\n                                          class="msgError">\n                                        {{\'ERROR.GENERROR0\' | translate}}\n                                        {{\'PAYMENT.IBAN\' | translate}}\n                                        {{\'ERROR.GENERROR1\' | translate}}</span>\n                                </div>\n                            </div>\n                        </div>\n                        <div ng-if="rsdc.reservation.billingAccount.payType.code===\'tarjeta\'">\n                            <div class="row">\n                                <div class="col-md-10">\n                                    <div class="input-group"\n                                         ng-style="rsdc.resform.cardHolder.$touched && (rsdc.resform.cardHolder.$invalid ||\n                                                            rsdc.resform.cardHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                        <span uib-tooltip="{{\'PAYMENT.CARDHOLDER\' | translate}}"\n                                              tooltip-placement="right"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="ion-android-person"></span>\n                                        </span>\n                                        <input type="text" ng-disabled="rsdc.readonly"\n                                               name="cardHolder" required\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'PAYMENT.CARDHOLDER\'|translate}}"\n                                               ng-model="rsdc.reservation.billingAccount.bankCard.cardholder">\n                                    </div>\n                                    <span\n                                        ng-show="rsdc.resform.cardHolder.$touched && rsdc.resform.cardHolder.$error.required"\n                                        class="msgError">{{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-10">\n                                    <div class="input-group"\n                                         ng-style="rsdc.resform.cardNumber.$touched && (rsdc.resform.cardNumber.$invalid ||\n                                                            rsdc.resform.cardNumber.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                        <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                              tooltip-placement="right"\n                                              class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="icon ion-card"\n                                                  style="color:#8AF37E !important;"></span>\n                                        </span>\n                                        <input type="text" name="cardNumber" required\n                                               ng-disabled="rsdc.readonly"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                               ng-model="rsdc.reservation.billingAccount.bankCard.number"\n                                               class="form-control with-primary-addon">\n                                    </div>\n                                    <span\n                                        ng-show="rsdc.resform.cardNumber.$touched && rsdc.resform.cardNumber.$error.required"\n                                        class="msgError">{{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-10">\n                                    <div class="input-group" style="margin-bottom: 0;">\n                                        <date-picker-comp\n                                            tooltip-text="\'PAYMENT.CARDEXPDATE\' | translate"\n                                            date-value="rsdc.reservation.billingAccount.bankCard.expDate"\n                                            placeholder="\'PAYMENT.CARDEXPDATE\' | translate"\n                                            mode-read-only="rsdc.readonly"\n                                            date-options="rsdc.dateOptionsFromToday"\n                                            form-reference="rsdc.resform"\n                                            name-field="\'cardExpDate\'"\n                                            min-mode="\'month\'"\n                                            is-required="true">\n                                        </date-picker-comp>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-md-10">\n                                    <div class="input-group"\n                                         ng-style="rsdc.resform.cardCvv.$touched && (rsdc.resform.cardCvv.$invalid ||\n                                                     rsdc.resform.cardCvv.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                        <span\n                                            uib-tooltip="{{\'PAYMENT.CVV\' | translate}}"\n                                            class="input-group-addon input-group-addon-primary addon-left">\n                                            <span class="icon ion-card"></span>\n                                        </span>\n                                        <input type="text" name="cardCvv"\n                                               ng-disabled="rsdc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'PAYMENT.CVV\'|translate}}"\n                                               aria-describedby="basic-addon1"\n                                               valid-number style="width: 70px;"\n                                               ng-model="rsdc.reservation.billingAccount.bankCard.cvv">\n                                    </div>\n                                    <span\n                                        ng-show="rsdc.resform.cardCvv.$touched && rsdc.resform.cardCvv.$error.required"\n                                        class="msgError">{{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <!-- type (pension) -->\n                    <div class="col-md-6 col-sm-12" ng-if="!rsdc.isGuest">\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  tooltip-placement="bottom-left"\n                                  uib-tooltip="{{\'REQUESTS.DETAIL.REQUEST_TYPE\'| translate}}">\n                                <span class="ion-card" style="margin-left:-1px"></span></span>\n                                <ui-select ng-model="rsdc.reservation.type"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control" ng-disabled="true"\n                                       append-to-body="true" name="modalityType" search-enabled="true">\n                                    <ui-select-match placeholder="{{\'REQUESTS.DETAIL.REQUEST_TYPE\' | translate}}">\n                                        <span> {{rsdc.reservation.type.description}}</span>\n                                    </ui-select-match>\n                                    <ui-select-choices repeat="option in rsdc.constants.modality |\n                                                            uiSelectFilter: {name:$select.search}">\n                                        <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                        </div>\n                    </div>\n                    <!--room-->\n                    <div class="col-md-6 col-sm-12">\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  tooltip-placement="top-left"\n                                  uib-tooltip="{{\'RESERVATIONS.LIST.ROOM\'| translate}}">\n                            <span class="fa fa-bed" style="margin-left:-1px"></span></span>\n                            <ui-select ng-model="rsdc.selectedRoom"\n                                       class="btn-group bootstrap-select form-control"\n                                       style="-webkit-border-radius:0; -moz-border-radius:0; border-radius: 0; z-index: 9999;"\n                                       name="room"\n                                       append-to-body="true"\n                                       search-enabled="true"\n                                       ng-change="rsdc.selectRoom();">\n                                <ui-select-match placeholder="{{\'RESERVATIONS.LIST.ROOM\'| translate}}">\n                                    <span> {{rsdc.selectedRoom.description}}<i ng-if="rsdc.selectedRoom.roomType && rsdc.selectedRoom.roomType.description">\n                                            ({{rsdc.selectedRoom.roomType.description}})</i></span>\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in rsdc.listSpots |\n                                    uiSelectFilter: {description:$select.search}">\n                                    <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                    <i ng-if="option.roomType && option.roomType.description">({{option.roomType.description}})</i>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </div>\n                <!--buttons-->\n                <div class="row" ng-if="rsdc.reservation.cancelBooking">\n                    <div class="col-md-12">\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  tooltip-placement="top-left"\n                                  uib-tooltip="{{\'RESERVATIONS.DETAIL.CANCELBOOKINGCOMMENT\'|translate}}">\n                                <span class="ion-quote" style="margin-left: -1px"></span>\n                            </span>\n                            <textarea type="text" name="name" ng-disabled="rsdc.readonly"\n                                      class="form-control with-primary-addon "\n                                      placeholder="{{\'RESERVATIONS.DETAIL.CANCELBOOKINGCOMMENT\'|translate}}"\n                                      ng-model="rsdc.reservation.cancelBookingComment">\n                           </textarea>\n                        </div>\n                    </div>\n                </div>\n                <!--buttons section-->\n                <div class="panel-footer-buttons">\n                    <div class="row">\n                        <div class="col-md-6">\n                            <div class="pull-right" ng-if="rsdc.reservation._id">\n                                <button class="btn btn-success btn-with-icon"\n                                        ng-disabled="rsdc.invalidRoomType"\n                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        ng-if="!rsdc.readonly && !rsdc.reservation.accepted" tagaste-click="rsdc.acceptReservation($event)">\n                                    <i class="ion-checkmark"></i>{{\'RESERVATIONS.DETAIL.ACCEPT_RESERVATION\' | translate}}\n                                </button>\n                                <button class="btn btn-success btn-with-icon"\n                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        ng-if="!rsdc.readonly"\n                                        tagaste-click="rsdc.cancelReservation()">\n                                    <i class="ion-close"></i>{{\'RESERVATIONS.DETAIL.CANCELBUTTON\' | translate}}\n                                </button>\n                                <button class="btn btn-success btn-with-icon"\n                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        ng-if="!rsdc.readonly" tagaste-click="rsdc.noshow()">\n                                    <i class="ion-eye-disabled"></i>{{\'RESERVATIONS.DETAIL.NOSHOWBUTTON\' | translate}}\n                                </button>\n                            </div>\n                        </div>\n                        <div class="col-md-6">\n                            <div class="pull-right">\n                                <button class="residentDetailCancel btn btn-success btn-with-icon"\n                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        id="requestCancelButton" tagaste-click="rsdc.back()">\n                                    <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' | translate}}\n                                </button>\n                                <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                        tagaste-click="rsdc.save(rsdc.resform)" ng-if="!rsdc.readonly"\n                                        ng-disabled="" class="btn btn-success btn-with-icon" id="reservationSaveButton">\n                                    <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                                </button>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/reservations/reservationsList/reservationsList.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="RESERVATIONS.LIST.HEADER" ba-panel-class="with-scroll" id="reservationsList">\n            <div class="filterAccordion" style="left: 280px!important;" ng-hide="rslsc.selectr._id !== undefined">\n                <uib-accordion>\n                    <uib-accordion-group panel-class="panel-primary accordion-panel " is-open="status.open">\n                        <uib-accordion-heading>{{\'RESIDENTSWINDOW.FILTERS\' | translate}}\n                            <i class="pull-right glyphicon"\n                               ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i>\n                        </uib-accordion-heading>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div id="historyTypeFilter">\n                                    <button type="button" ng-repeat="option in rslsc.reservationStatusOptions"\n                                            ng-style="(option.isSelected) ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                            tagaste-click="rslsc.applyAdditionalFilters(option); $event.stopPropagation();"\n                                            class="btn btn-with-icon btn-rating-filter" uib-tooltip="{{option.value}}"\n                                            tooltip-placement="bottom">\n                                        <span ng-if="option.name === \'all\'">{{\'BUTTONS.ALL\' | translate}}</span>\n                                        <i class="fa fa-circle" ng-if="option.name !== \'all\'"\n                                           ng-class="{red: option.name === \'red\', gold: option.name === \'gold\',\n                                            green: option.name === \'green\', black: option.name === \'black\'}"></i>\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                    </uib-accordion-group>\n                </uib-accordion>\n            </div>\n            <div class="horizontal-scroll" ng-class="(rslsc.selectr._id) ? \'hideTableCounts\': \'\'"\n                 ng-if="rslsc.initialized">\n                <table ng-table="rslsc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true">\n                    <colgroup>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                        <col>\n                    </colgroup>\n                    <tr ng-repeat="row in $data | dummyDataIfEmpty:rslsc.tourDummyData | showErrorNoData track by $index"\n                        style="cursor: pointer;"\n                        tagaste-click="rslsc.rowClick(row);$event.stopPropagation();"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td colspan="9" ng-if="row.error" ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.CODE\'|translate"\n                            sortable="\'codigoReserva\'"\n                            ng-attr-title="{{row.codigoReserva}}"\n                            filter="rslsc.filterCode">\n                            {{row.codigoReserva}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.NAME\'|translate"\n                            sortable="\'nombre\'"\n                            ng-attr-title="{{row.nombre}}"\n                            filter="rslsc.filterName">\n                            {{row.nombre}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.SURNAME\'|translate"\n                            sortable="\'apellidos\'"\n                            ng-attr-title="{{row.apellidos}}"\n                            filter="rslsc.filterSurname">\n                            {{row.apellidos}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.COURSE\'|translate"\n                            sortable="\'userCourse\'"\n                            ng-attr-title="{{row.userCourse}}"\n                            filter="rslsc.filterCourse">\n                            {{row.userCourse}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.DATEFROM\'|translate"\n                            sortable="\'formattedDateFromReverse\'"\n                            ng-attr-title="{{row.formattedDateFrom}}"\n                            filter="rslsc.filterDateFrom">\n                            {{row.formattedDateFrom}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.DATETO\'|translate"\n                            sortable="\'formattedDateToReverse\'"\n                            ng-attr-title="{{row.formattedDateTo}}"\n                            filter="rslsc.filterDateTo">\n                            {{row.formattedDateTo}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.BRANCH\'|translate"\n                            sortable="\'branch\'"\n                            ng-attr-title="{{row.branch}}"\n                            filter="rslsc.filterBranch">\n                            {{row.branch}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.STATUS\'|translate"\n                            sortable="\'status\'"\n                            ng-attr-title="{{row.status}}"\n                            filter="rslsc.filterStatus">\n                            {{row.status}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.ROOMTYPE\'|translate"\n                            sortable="\'roomType\'"\n                            ng-attr-title="{{row.roomType}}"\n                            filter="rslsc.filterRoomType">\n                            {{row.roomType}}\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.ROOM\'|translate"\n                            sortable="\'room\'"\n                            ng-attr-title="{{row.room}}"\n                            filter="rslsc.filterRoom">\n                            {{row.room}}\n                        </td>\n<!--                        <td data-title="\'RESERVATIONS.LIST.IS_RESIDENT\'|translate"-->\n<!--                            sortable="\'esResidente\'" ng-attr-title="{{row.esResidente}}"-->\n<!--                            style="text-align: center">-->\n<!--                            <i class="fa fa-check" ng-if="row.esResidente !== \'N\'"></i>-->\n<!--                        </td>-->\n                        <td data-title="\'RESIDENTSWINDOW.OLD_RESIDENT\'|translate"\n                            sortable="\'oldResident\'" ng-attr-title="{{row.oldResident}}"\n                            style="text-align: center">\n                            <i class="fa fa-check" ng-if="row.oldResident"></i>\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.IS_GUEST\'|translate"\n                            sortable="\'isGuest\'" ng-attr-title="{{row.isGuest}}"\n                            style="text-align: center">\n                            <i class="fa fa-check" ng-if="row.isGuest"></i>\n                        </td>\n                        <td data-title="\'RESERVATIONS.LIST.CANCELBOOKINGCOMMENT\'|translate"\n                            sortable="\'cancelBookingComment\'"\n                            ng-attr-title="{{row.cancelBookingComment}}"\n                            filter="rslsc.filterCancelBookingComment">\n                            {{row.cancelBookingComment}}\n                        </td>\n                        <td ng-if="!rslsc.selectr._id && !row.error" class="text-center" style="white-space: nowrap;">\n                            <i class="fa fa-pencil iconNgTable edit" style="padding: 0 10px;"\n                               uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                               ng-if="rslsc.gotAccessMod && !row.noEditable"\n                               aria-hidden="true"\n                               tagaste-click="rslsc.editRow(row); $event.stopPropagation();">\n                            </i>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!rslsc.selectr._id">\n                <div class="col-xs-12 countAndNewButton">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' | translate }} : {{ rslsc.tableParams.total() }}</span></span>\n                    <button type="button"\n                            tagaste-click="rslsc.new();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="newReservationButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                    </button>\n                    <button type="button"\n                            tagaste-click="rslsc.exportData();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/residents/payment/payment.html','<style>\n    .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'PAYMENT.CARD\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'PAYMENT.DIRECTDEBIT\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'PAYMENT.CASH\'|translate}}";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.null .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.true .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.false .nz-toggle-handle:before {\n        content: "";\n    }\n</style>\n\n<div class="row" ng-if="!pyc.readonly">\n    <div class="col-md-12">\n        <uib-accordion>\n            <uib-accordion-group\n                panel-class="panel-primary accordion-panel"\n                style="overflow-x: hidden; overflow-y: hidden;"\n                is-open="pyc.billdataopen">\n                <uib-accordion-heading>\n                    {{\'PAYMENT.BILLDATA\' | translate}}\n                    <i class="pull-right glyphicon"\n                       ng-class="{\'glyphicon-chevron-down\': pyc.billdataopen,\n                            \'glyphicon-chevron-right\': !pyc.billdataopen}"></i>\n                </uib-accordion-heading>\n                <div class="row">\n                    <div class="col-md-12">\n                        <div class="input-group">\n                            <span uib-tooltip="{{\'PAYMENT.RESIDENCE\'  | translate}}"\n                                  class="input-group-addon input-group-addon-primary addon-left"\n                                  tooltip-placement="right">\n                                <span class="ion-card"></span>\n                            </span>\n                            <ui-select ng-model="pyc.bill.branch" ng-if="pyc.resident.branches"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; z-index: 9999;"\n                                       class="btn-group bootstrap-select form-control"\n                                       append-to-body="true"\n                                       ng-disabled="pyc.readonly"\n                                       name="branch"\n                                       ng-class="{\'select-invalid\': !pyc.bill.branch && pyc.submitInvoice}"\n                                       search-enabled="true">\n                                <ui-select-match\n                                    allow-clear=true\n                                    placeholder="{{\'PAYMENT.RESIDENCE\'| translate}}">\n                                    {{pyc.bill.branch.description}}\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in pyc.resident.branches">\n                                    <div ng-bind-html="option.description | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                </div>\n            </uib-accordion-group>\n        </uib-accordion>\n    </div>\n</div>\n\n<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <form name="billForm" autocomplete="false">\n            <div class="row" style="min-height: 286px;">\n                <div class="col-sm-12">\n                    <div class="row" ng-if="pyc.menuOption === \'residents\'">\n                        <div class="col-md-12">\n                            <uib-accordion>\n                                <uib-accordion-group heading="{{\'PAYMENT.STAYS_FUTURE\' | translate}}"\n                                                     is-open="pyc.staysfutureopen"\n                                                     panel-class="panel-primary accordion-panel">\n                                    <uib-accordion-heading>\n                                        {{\'PAYMENT.STAYS_FUTURE\' | translate}}\n                                        <i class="pull-right glyphicon"\n                                           ng-class="{\'glyphicon-chevron-down\': pyc.staysfutureopen,\n                                                \'glyphicon-chevron-right\': !pyc.staysfutureopen}"></i>\n                                    </uib-accordion-heading>\n                                    <div class="row">\n                                        <div class="col-xs-12">\n                                            <div class="input-group">\n                                                <table ng-table="pyc.tableParamsStaysFuture"\n                                                       class="table table-hover table-condensed fixNgTable"\n                                                       show-filter="true">\n                                                    <colgroup>\n                                                        <col width="12%">\n                                                        <col width="22%">\n                                                        <col width="22%">\n                                                        <col width="22%">\n                                                        <col width="22%">\n                                                    </colgroup>\n                                                    <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                        class="ng-binding">\n                                                        <td colspan="7" ng-if="row.error"\n                                                            ng-src="{{row.error}}">\n                                                            {{row.error}}\n                                                        </td>\n                                                        <td data-title="\'RESIDENTSWINDOW.ROOM\'|translate"\n                                                            sortable="\'room\'"\n                                                            ng-attr-title="{{row.room ? row.room :\n                                                            (row.related && row.related.item && row.related.item.room ? row.related.item.room.description : \'\')}}">\n                                                            {{row.room ? row.room :\n                                                            (row.related && row.related.item && row.related.item.room ? row.related.item.room.description : \'\')}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.INDATE\'|translate"\n                                                            sortable="\'dateFormatFrom\'"\n                                                            ng-attr-title="{{row.dateFormatFrom}}">\n                                                            {{row.dateViewFrom | date:\'MM/dd/yyyy\'}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.OUTDATE\'|translate"\n                                                            sortable="\'dateFormatTo\'"\n                                                            ng-attr-title="{{row.dateFormatTo}}">\n                                                            {{row.dateViewTo | date:\'MM/dd/yyyy\'}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.RESIDENCE\'|translate"\n                                                            sortable="\'branchDescription\'"\n                                                            ng-attr-title="{{row.branchDescription}}">\n                                                            {{row.branchDescription}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.COST\'|translate">\n                                                            <span ng-bind-html="row.stayAmounts ? row.stayAmounts : row.stayAmount"></span>\n                                                        </td>\n                                                    </tr>\n                                                </table>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </uib-accordion-group>\n                            </uib-accordion>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <uib-accordion>\n                                <uib-accordion-group\n                                    heading="{{\'PAYMENT.SERVICES\' | translate}}"\n                                    is-open="pyc.servicesopen"\n                                    style="overflow-x: hidden; overflow-y: hidden;"\n                                    panel-class="panel-primary accordion-panel">\n                                    <uib-accordion-heading>\n                                        {{\'PAYMENT.SERVICES\' | translate}}\n                                        <i class="pull-right glyphicon"\n                                           ng-class="{\'glyphicon-chevron-down\': pyc.servicesopen,\n                                            \'glyphicon-chevron-right\': !pyc.servicesopen}"></i>\n                                    </uib-accordion-heading>\n                                    <div class="input-group">\n                                        <div class="row">\n                                            <div class="col-xs-12 ">\n                                                <button type="button"\n                                                        ng-if="!pyc.readonly"\n                                                        tagaste-click="pyc.openConceptDetail();$event.stopPropagation();"\n                                                        class="btn btn-success btn-with-icon pull-right newButton"\n                                                        id="newConceptButton">\n                                                    <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n                                                </button>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div ng-class="\'col-xs-12\'">\n                                                <table ng-table="pyc.tableParamsServices"\n                                                       class="table table-hover table-condensed fixNgTable"\n                                                       show-filter="false"\n                                                       style="font-size: 11px;">\n                                                    <colgroup>\n                                                        <col width="30px" ng-if="!pyc.readonly">\n                                                        <col>\n                                                        <col>\n                                                        <col>\n                                                        <col>\n                                                        <col ng-if="!pyc.readonly">\n                                                    </colgroup>\n                                                    <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                        class="ng-binding"\n                                                        tagaste-click="pyc.openConceptDetail(row);$event.stopPropagation();">\n                                                        <td width="30" tagaste-click="$event.stopPropagation();"\n                                                            ng-if="!pyc.readonly">\n                                                            <label class="custom-checkbox">\n                                                                <input type="checkbox" ng-model="row.selected"\n                                                                       ng-click="pyc.serviceCheckboxChanges(row)">\n                                                                <span></span>\n                                                            </label>\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.TYPE\'|translate"\n                                                            sortable="\'type\'"\n                                                            ng-attr-title="{{row.typeStr}}">\n                                                            {{row.typeStr}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.NAME\'|translate"\n                                                            sortable="\'description\'"\n                                                            ng-attr-title="{{row.description}}">\n                                                            {{row.description}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.DATE\'|translate"\n                                                            sortable="\'dateFormat\'"\n                                                            ng-attr-title="{{row.dateFormat}}">\n                                                            {{row.dateView | date:\'MM/dd/yyyy\'}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.RESIDENCE\'|translate"\n                                                            sortable="\'branchDescription\'"\n                                                            ng-attr-title="{{row.branchDescription}}">\n                                                            {{row.branchDescription}}\n                                                        </td>\n                                                        <!--remove button-->\n                                                        <td ng-if="!pyc.readonly && !row.billing">\n                                                            <i class="fa fa-trash-o iconNgTable edit"\n                                                               uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                               aria-hidden="true"\n                                                               tagaste-click="pyc.deleteServiceConcept(row); $event.stopPropagation();">\n                                                            </i>\n                                                        </td>\n                                                    </tr>\n                                                </table>\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                </uib-accordion-group>\n                            </uib-accordion>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-md-12">\n                            <uib-accordion>\n                                <uib-accordion-group heading="{{\'PAYMENT.STAYS\' | translate}}"\n                                                     is-open="pyc.staysopen"\n                                                     panel-class="panel-primary accordion-panel">\n                                    <uib-accordion-heading>\n                                        {{\'PAYMENT.STAYS\' | translate}}\n                                        <i class="pull-right glyphicon"\n                                           ng-class="{\'glyphicon-chevron-down\': pyc.staysopen,\n                                                \'glyphicon-chevron-right\': !pyc.staysopen}"></i>\n                                    </uib-accordion-heading>\n                                    <div class="row">\n                                        <div class="col-xs-12">\n                                            <div class="input-group">\n                                                <table ng-table="pyc.tableParamsStays"\n                                                       class="table table-hover table-condensed fixNgTable"\n                                                       show-filter="true">\n                                                    <colgroup>\n                                                        <col width="30px" ng-if="!pyc.readonly">\n                                                        <col width="10%">\n                                                        <col width="30%">\n                                                        <col width="30%">\n                                                        <col width="30%">\n                                                    </colgroup>\n                                                    <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                        class="ng-binding"\n                                                        tagaste-click="pyc.openConceptDetail(row);$event.stopPropagation();">\n                                                        <td colspan="7" ng-if="row.error"\n                                                            ng-src="{{row.error}}">\n                                                            {{row.error}}\n                                                        </td>\n                                                        <td width="30" tagaste-click="$event.stopPropagation();"\n                                                            ng-if="!pyc.readonly">\n                                                            <label class="custom-checkbox">\n                                                                <input type="checkbox" ng-model="row.selected"\n                                                                       ng-click="pyc.occupancyCheckboxChanges(row)">\n                                                                <span></span>\n                                                            </label>\n                                                        </td>\n                                                        <td data-title="\'RESIDENTSWINDOW.ROOM\'|translate"\n                                                            sortable="\'room\'"\n                                                            ng-attr-title="{{row.room ? row.room :\n                                                            (row.related && row.related.item && row.related.item.room ? row.related.item.room.description : \'\')}}">\n                                                            {{row.room ? row.room :\n                                                            (row.related && row.related.item && row.related.item.room ? row.related.item.room.description : \'\')}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.INDATE\'|translate"\n                                                            sortable="\'dateFormatFrom\'"\n                                                            ng-attr-title="{{row.dateFormatFrom}}">\n                                                            {{row.dateViewFrom | date:\'MM/dd/yyyy\'}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.OUTDATE\'|translate"\n                                                            sortable="\'dateFormatTo\'"\n                                                            ng-attr-title="{{row.dateFormatTo}}">\n                                                            {{row.dateViewTo | date:\'MM/dd/yyyy\'}}\n                                                        </td>\n                                                        <td data-title="\'PAYMENT.RESIDENCE\'|translate"\n                                                            sortable="\'branchDescription\'"\n                                                            ng-attr-title="{{row.branchDescription}}">\n                                                            {{row.branchDescription}}\n                                                        </td>\n                                                    </tr>\n                                                </table>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </uib-accordion-group>\n                            </uib-accordion>\n                        </div>\n                    </div>\n\n                    <div class="row">\n                        <div class="col-sm-8">\n                            <div class="row" ng-if="pyc.showDeposit && !pyc.readonly">\n                                <div class="col-sm-12">\n                                    <uib-accordion>\n                                        <uib-accordion-group\n                                            panel-class="panel-primary accordion-panel"\n                                            style="overflow-x: hidden; overflow-y: hidden;"\n                                            is-open="pyc.depositdataopen">\n                                            <uib-accordion-heading>\n                                                {{\'PAYMENT.DEPOSITDATA\' | translate}}\n                                                <i class="pull-right glyphicon"\n                                                   ng-class="{\'glyphicon-chevron-down\': pyc.depositdataopen,\n                                                \'glyphicon-chevron-right\': !pyc.depositdataopen}"></i>\n                                            </uib-accordion-heading>\n                                            <div class="row">\n                                                <div class="col-xs-5">\n                                                    <div class="input-group">\n                                                        <span uib-tooltip="{{\'PAYMENT.AVAILABLEDEPOSIT\' | translate}}"\n                                                              tooltip-placement="right"\n                                                              class="input-group-addon input-group-addon-primary addon-left">\n                                                            <span class="ion-social-euro"></span>\n                                                        </span>\n                                                        <input type="text"\n                                                               ng-disabled="true"\n                                                               class="form-control with-primary-addon"\n                                                               placeholder="{{\'PAYMENT.DEPOSITDATA\'|translate}}"\n                                                               aria-describedby="basic-addon1"\n                                                               valid-number\n                                                               ng-model="pyc.resident.deposit">\n                                                    </div>\n                                                </div>\n                                                <div class="col-xs-7">\n                                                    <label class="custom-checkbox">\n                                                        <input id="checkDeposit"\n                                                               type="checkbox"\n                                                               ng-model="pyc.useDeposit"\n                                                               ng-click="pyc.changeUseDeposit(); pyc.calcTotal();"\n                                                               ng-disabled="pyc.bill._id || !(pyc.selectedServices.length || pyc.selectedStays.length)">\n                                                        <span>{{\'PAYMENT.USE_DEPOSIT\' | translate}}</span>\n                                                    </label>\n                                                </div>\n                                            </div>\n                                        </uib-accordion-group>\n                                    </uib-accordion>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-sm-12">\n                                    <uib-accordion>\n                                        <uib-accordion-group\n                                            panel-class="panel-primary accordion-panel"\n                                            style="overflow-x: hidden; overflow-y: hidden;"\n                                            is-open="pyc.paymentdataopen">\n                                            <uib-accordion-heading>\n                                                {{\'PAYMENT.PAYMENTDATA\' | translate}}\n                                                <i class="pull-right glyphicon"\n                                                   ng-class="{\'glyphicon-chevron-down\': pyc.paymentdataopen,\n                                                \'glyphicon-chevron-right\': !pyc.paymentdataopen}"></i>\n                                            </uib-accordion-heading>\n                                            <div class="row">\n                                                <div class="col-xs-12">\n                                                    <div class="input-group payment">\n                                                        <div class="row">\n                                                            <div class="col-md-12">\n                                                                <div class="row">\n                                                                    <div class="col-md-12">\n                                                                        <div class="input-group">\n                                                                    <span\n                                                                        uib-tooltip="{{\'PAYMENT.PAYMENTTYPE\' | translate}}"\n                                                                        tooltip-placement="right"\n                                                                        class="input-group-addon input-group-addon-primary addon-left">\n                                                                        <span class="ion ion-android-list"></span>\n                                                                    </span>\n                                                                            <ui-select\n                                                                                ng-model="pyc.bill.paidData.payType"\n                                                                                style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                                                class="btn-group bootstrap-select form-control"\n                                                                                append-to-body="true"\n                                                                                ng-disabled="pyc.bill.payDate || pyc.disablePayType || !pyc.payButton"\n                                                                                name="payType"\n                                                                                ng-change="pyc.changePayType();"\n                                                                                search-enabled="true">\n                                                                                <ui-select-match\n                                                                                    allow-clear=true\n                                                                                    placeholder="{{\'PAYMENT.PAYMENTTYPE\'| translate}}">\n                                                                                    {{pyc.bill.paidData.payType.description}}\n                                                                                </ui-select-match>\n                                                                                <ui-select-choices\n                                                                                    repeat="option in pyc.constants.payTypes">\n                                                                                    <div\n                                                                                        ng-bind-html="option.description | highlight: $select.search"></div>\n                                                                                </ui-select-choices>\n                                                                            </ui-select>\n                                                                        </div>\n                                                                    </div>\n                                                                </div>\n                                                                <div\n                                                                    ng-if="pyc.bill.paidData.payType.code===\'domiciliado\'">\n                                                                    <div class="row">\n                                                                        <div class="col-md-12">\n                                                                            <div class="input-group"\n                                                                                 ng-style="billForm.bankHolder.$touched && (billForm.bankHolder.$invalid ||\n                                                                                billForm.bankHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                        <span\n                                                                            uib-tooltip="{{\'PAYMENT.BANKHOLDER\' | translate}}"\n                                                                            tooltip-placement="right"\n                                                                            class="input-group-addon input-group-addon-primary addon-left">\n                                                                            <span class="ion-android-person"></span>\n                                                                        </span>\n                                                                                <input type="text" name="bankHolder"\n                                                                                       required\n                                                                                       ng-disabled="pyc.bill.payDate || !pyc.payButton"\n                                                                                       class="form-control with-primary-addon"\n                                                                                       placeholder="{{\'PAYMENT.BANKHOLDER\'|translate}}"\n                                                                                       ng-model="pyc.bill.paidData.bank.holder">\n                                                                            </div>\n                                                                            <span ng-show="billForm.bankHolder.$touched && (billForm.bankHolder.$invalid ||\n                                                                        billForm.bankHolder.$error.required)"\n                                                                                  class="msgError">\n                                                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                                        </div>\n                                                                    </div>\n                                                                    <div class="row">\n                                                                        <div class="col-md-12">\n                                                                            <div class="input-group"\n                                                                                 ng-style="billForm.bankSwift.$touched && (billForm.bankSwift.$invalid ||\n                                                                                    billForm.bankSwift.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                        <span\n                                                                            uib-tooltip="{{\'PAYMENT.SWIFT\' | translate}}"\n                                                                            tooltip-placement="right"\n                                                                            class="input-group-addon input-group-addon-primary addon-left">\n                                                                            <span class="fa fa-bank"></span>\n                                                                        </span>\n                                                                                <input type="text"\n                                                                                       ng-disabled="pyc.bill.payDate || !pyc.payButton"\n                                                                                       name="bankSwift" required\n                                                                                       class="form-control with-primary-addon"\n                                                                                       placeholder="{{\'PAYMENT.SWIFT\'|translate}}"\n                                                                                       ng-model="pyc.bill.paidData.bank.swift">\n                                                                            </div>\n                                                                            <span\n                                                                                ng-show="billForm.bankSwift.$touched && billForm.bankSwift.$error.required"\n                                                                                class="msgError">\n                                                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                                            <span ng-show="!billForm.bankSwift.$error.required &&\n                                                                                        !pyc.validSwift(pyc.bill.paidData.bank.swift, billForm.bankSwift)"\n                                                                                  class="msgError">\n                                                                                        {{\'ERROR.GENERROR0\' | translate}}\n                                                                                        {{\'PAYMENT.SWIFT\' | translate}}\n                                                                                        {{\'ERROR.GENERROR1\' | translate}}</span>\n                                                                        </div>\n                                                                    </div>\n                                                                    <div class="row">\n                                                                        <div class="col-md-12">\n                                                                            <div class="input-group"\n                                                                                 ng-style="billForm.bankIban.$touched && (billForm.bankIban.$invalid ||\n                                                                                billForm.bankIban.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                        <span\n                                                                            uib-tooltip="{{\'PAYMENT.IBAN\' | translate}}"\n                                                                            tooltip-placement="right"\n                                                                            class="input-group-addon input-group-addon-primary addon-left">\n                                                                            <span class="fa fa-bank"></span>\n                                                                        </span>\n                                                                                <input type="text"\n                                                                                       ng-disabled="pyc.bill.payDate || !pyc.payButton"\n                                                                                       name="bankIban" required\n                                                                                       class="form-control with-primary-addon"\n                                                                                       placeholder="{{\'PAYMENT.IBAN\'|translate}}"\n                                                                                       ng-model="pyc.bill.paidData.bank.iban">\n                                                                            </div>\n                                                                            <span\n                                                                                ng-show="billForm.bankIban.$touched && billForm.bankIban.$error.required"\n                                                                                class="msgError">\n                                                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                                            <span ng-show="!billForm.bankIban.$error.required &&\n                                                                                        !pyc.validIban(pyc.bill.paidData.bank.iban, billForm.bankIban)"\n                                                                                  class="msgError">\n                                                                                        {{\'ERROR.GENERROR0\' | translate}}\n                                                                                        {{\'PAYMENT.IBAN\' | translate}}\n                                                                                        {{\'ERROR.GENERROR1\' | translate}}</span>\n                                                                        </div>\n                                                                    </div>\n                                                                </div>\n                                                                <div ng-if="pyc.bill.paidData.payType.code===\'tarjeta\'">\n                                                                    <div class="row">\n                                                                        <div class="col-md-12">\n                                                                            <div class="input-group"\n                                                                                 ng-style="billForm.cardHolder.$touched && (billForm.cardHolder.$invalid ||\n                                                            billForm.cardHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                        <span\n                                                                            uib-tooltip="{{\'PAYMENT.CARDHOLDER\' | translate}}"\n                                                                            tooltip-placement="right"\n                                                                            class="input-group-addon input-group-addon-primary addon-left">\n                                                                            <span class="ion-android-person"></span>\n                                                                        </span>\n                                                                                <input type="text"\n                                                                                       ng-disabled="pyc.bill.payDate || !pyc.payButton"\n                                                                                       name="cardHolder" required\n                                                                                       class="form-control with-primary-addon"\n                                                                                       placeholder="{{\'PAYMENT.CARDHOLDER\'|translate}}"\n                                                                                       ng-model="pyc.bill.paidData.bankCard.cardholder">\n                                                                            </div>\n                                                                            <span\n                                                                                ng-show="billForm.cardHolder.$touched && billForm.cardHolder.$error.required"\n                                                                                class="msgError">\n                                                                    {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                                        </div>\n                                                                    </div>\n                                                                    <div class="row">\n                                                                        <div class="col-md-12">\n                                                                            <div class="input-group"\n                                                                                 ng-style="billForm.cardNumber.$touched && (billForm.cardNumber.$invalid ||\n                                                            billForm.cardNumber.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                        <span\n                                                                            uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                                                            tooltip-placement="right"\n                                                                            class="input-group-addon input-group-addon-primary addon-left">\n                                                                            <span class="icon ion-card"\n                                                                                  style="color:#8AF37E !important;"></span>\n                                                                        </span>\n                                                                                <input type="text" name="cardNumber"\n                                                                                       required\n                                                                                       ng-disabled="pyc.bill.payDate || !pyc.payButton"\n                                                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                                                                       ng-model="pyc.bill.paidData.bankCard.number"\n                                                                                       class="form-control with-primary-addon">\n                                                                            </div>\n                                                                            <span ng-show="billForm.cardNumber.$touched && billForm.cardNumber.$error.required"\n                                                                                class="msgError">\n                                                                                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                                        </div>\n                                                                    </div>\n                                                                    <div class="row">\n                                                                        <div class="col-md-12">\n                                                                            <div class="input-group"\n                                                                                 style="margin-bottom: 0;">\n                                                                                <date-picker-comp\n                                                                                    tooltip-text="\'PAYMENT.CARDEXPDATE\' | translate"\n                                                                                    date-value="pyc.bill.paidData.bankCard.expDate"\n                                                                                    placeholder="\'PAYMENT.CARDEXPDATE\' | translate"\n                                                                                    mode-read-only="pyc.istour || pyc.bill.payDate || !pyc.payButton"\n                                                                                    date-options="pyc.dateOptionsFromToday"\n                                                                                    form-reference="billForm"\n                                                                                    name-field="\'cardExpDate\'"\n                                                                                    min-mode="\'month\'"\n                                                                                    is-required="true">\n                                                                                </date-picker-comp>\n                                                                            </div>\n                                                                        </div>\n                                                                    </div>\n                                                                    <div class="row">\n                                                                        <div class="col-md-12">\n                                                                            <div class="input-group"\n                                                                                 ng-style="billForm.cardCvv.$touched && (billForm.cardCvv.$invalid ||\n                                                                         billForm.cardCvv.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                                        <span\n                                                                            uib-tooltip="{{\'PAYMENT.CVV\' | translate}}"\n                                                                            class="input-group-addon input-group-addon-primary addon-left">\n                                                                            <span class="icon ion-card"></span>\n                                                                        </span>\n                                                                                <input type="text" name="cardCvv"\n                                                                                       ng-disabled="pyc.bill.payDate || !pyc.payButton"\n                                                                                       class="form-control with-primary-addon"\n                                                                                       placeholder="{{\'PAYMENT.CVV\'|translate}}"\n                                                                                       aria-describedby="basic-addon1"\n                                                                                       valid-number style="width: 70px;"\n                                                                                       ng-model="pyc.bill.paidData.bankCard.cvv">\n                                                                            </div>\n                                                                            <span\n                                                                                ng-show="billForm.cardCvv.$touched && billForm.cardCvv.$error.required"\n                                                                                class="msgError">\n                                                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                                        </div>\n                                                                    </div>\n                                                                </div>\n                                                                <div class="row">\n                                                                    <div class="col-xs-12 text-right">\n                                                                        <button\n                                                                            ng-if="pyc.payButton && !pyc.bill.payDate"\n                                                                            ng-disabled="!pyc.bill.paidData.payType"\n                                                                            type="button"\n                                                                            tagaste-click="pyc.payInvoice()"\n                                                                            class="btn btn-success btn-with-icon">\n                                                                            <i class="fa fa-credit-card"></i>{{\'BUTTONS.PAY\' | translate}}\n                                                                        </button>\n                                                                    </div>\n                                                                </div>\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </uib-accordion-group>\n                                    </uib-accordion>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="col-sm-4">\n                            <uib-accordion>\n                                <uib-accordion-group panel-class="panel-primary accordion-panel"\n                                                     is-open="pyc.totalsopen">\n                                    <uib-accordion-heading>\n                                        {{\'PAYMENT.TOTALS\' | translate}}\n                                        <i class="pull-right glyphicon"\n                                           ng-class="{\'glyphicon-chevron-down\': pyc.totalsopen,\n                                                \'glyphicon-chevron-right\': !pyc.totalsopen}"></i>\n                                    </uib-accordion-heading>\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <div class="input-group totalInput">\n                                                <span\n                                                    uib-tooltip="{{\'PAYMENT.SERVICESTOTAL\' | translate}}"\n                                                    tooltip-placement="right"\n                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-social-euro"></span>\n                                                </span>\n                                                <input type="text"\n                                                       ng-disabled="true"\n                                                       class="form-control with-primary-addon"\n                                                       placeholder="{{\'PAYMENT.SERVICESTOTAL\'|translate}}"\n                                                       aria-describedby="basic-addon1"\n                                                       valid-number\n                                                       ng-model="pyc.servicesTotal">\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <div class="input-group">\n                                                <span\n                                                    uib-tooltip="{{\'PAYMENT.STAYSTOTAL\' | translate}}"\n                                                    tooltip-placement="right"\n                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-social-euro"></span>\n                                                </span>\n                                                <input type="text"\n                                                       class="form-control with-primary-addon"\n                                                       ng-disabled="true"\n                                                       placeholder="{{\'PAYMENT.STAYSTOTAL\'|translate}}"\n                                                       aria-describedby="basic-addon1"\n                                                       valid-number\n                                                       ng-model="pyc.staysTotal">\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="row" ng-if="pyc.showDeposit">\n                                        <div class="col-md-12">\n                                            <div class="input-group">\n                                                <span\n                                                    uib-tooltip="{{\'PAYMENT.USEDDEPOSIT\' | translate}}"\n                                                    tooltip-placement="right"\n                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-social-euro"></span>\n                                                </span>\n                                                <input type="text"\n                                                       class="form-control with-primary-addon"\n                                                       ng-disabled="true"\n                                                       placeholder="{{\'PAYMENT.USEDDEPOSIT\'|translate}}"\n                                                       aria-describedby="basic-addon1"\n                                                       valid-number\n                                                       ng-model="pyc.usedDeposit">\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <div class="input-group">\n                                                <span\n                                                    uib-tooltip="{{\'PAYMENT.TOTAL\' | translate}}"\n                                                    tooltip-placement="right"\n                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-social-euro"></span>\n                                                </span>\n                                                <input type="text"\n                                                       ng-disabled="true"\n                                                       class="form-control with-primary-addon"\n                                                       placeholder="{{\'PAYMENT.TOTAL\'|translate}}"\n                                                       aria-describedby="basic-addon1"\n                                                       valid-number\n                                                       ng-model="pyc.total">\n                                            </div>\n                                        </div>\n                                    </div>\n                                </uib-accordion-group>\n                            </uib-accordion>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row" ng-if="!pyc.readonly">\n                <div class="col-xs-12 pull-right text-right">\n                    <button class="residentDetailCancel btn btn-success btn-with-icon"\n                            style="margin-right:17px;margin-top:17px;margin-bottom:7px;min-width: 150px;" type="button"\n                            tagaste-click="pyc.invoice(billForm, false)">\n                        <i class="fa fa-floppy-o"></i>{{\'BUTTONS.TICKET\' | translate}}\n                    </button>\n                    <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;min-width: 150px;" type="button"\n                            tagaste-click="pyc.invoice(billForm, true)"\n                            class="btn btn-success btn-with-icon">\n                        <i class="fa fa-floppy-o"></i>{{\'BUTTONS.INVOICE\' | translate}}\n                    </button>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-xs-12 pull-right text-right">\n                    <button class="residentDetailCancel btn btn-success btn-with-icon"\n                            ng-if="pyc.bill.proformaNumber"\n                            ng-disabled="pyc.downloadingInvoicePdf || pyc.downloadingProformaPdf"\n                            style="margin-right:17px;margin-top:17px;margin-bottom:7px;min-width: 150px;" type="button"\n                            tagaste-click="pyc.printInvoice(\'proforma\')">\n                        <span ng-if="!pyc.downloadingProformaPdf"><i\n                            class="fa fa-print"></i>{{\'BUTTONS.PRINTTICKET\' | translate}}</span>\n                        <i ng-if="pyc.downloadingProformaPdf" class="fa fa-spinner fa-spin"></i>\n                    </button>\n                    <button class="btn btn-success btn-with-icon"\n                            ng-if="pyc.bill.invoiceNumber"\n                            ng-disabled="pyc.downloadingInvoicePdf || pyc.downloadingProformaPdf"\n                            style="margin-right:17px;margin-top:17px;margin-bottom:7px;min-width: 150px;" type="button"\n                            tagaste-click="pyc.printInvoice(\'invoice\')">\n                        <span ng-if="!pyc.downloadingInvoicePdf"><i\n                            class="fa fa-print"></i>{{\'BUTTONS.PRINTINVOICE\' | translate}}</span>\n                        <i ng-if="pyc.downloadingInvoicePdf" class="fa fa-spinner fa-spin"></i>\n                    </button>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-xs-12" style="margin-top:13px;">\n                    <p ng-if="pyc.submitted && !pyc.readonly && !billForm.$valid"\n                       class="pull-right errorValidation bounceIn animate">\n                        {{\'ERROR.ERRORININPUT\' | translate}}</p>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n');
$templateCache.put('app/components/residents/residentDetail/residentDetail.html','<style>\n    .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.CARD\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.DIRECTDEBIT\'|translate}}";\n    }\n\n    .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.CASH\'|translate}}";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.null .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.true .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .payment.nz-toggle-wrap.horizontal.false .nz-toggle-handle:before {\n        content: "";\n    }\n\n    .tutor-gender-toggle.nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        text-align: center;\n        content: "{{\'RESIDENTWINDOWDETAIL.TUTOR.TUTOR\' | translate}}";\n    }\n\n    .tutor-gender-toggle.nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.TUTOR.FATHER\' | translate}}";\n    }\n\n    .tutor-gender-toggle.nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'RESIDENTWINDOWDETAIL.TUTOR.MOTHER\' | translate}}";\n    }\n\n    .resident-gender-toggle {\n        width: 50px;\n        border-radius: 6px;\n        text-align: left;\n        margin: 0 10px;\n    }\n\n    .resident-gender-toggle .nz-toggle-handle {\n        border-radius: 6px;\n    }\n\n    .resident-gender-toggle.nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        text-align: center;\n        font-family: \'Ionicons\';\n        content: "\\f25d \\f202";\n        font-size: 20px;\n        left: 10px;\n        bottom: 3px;\n        color: #464444;\n    }\n\n    .resident-gender-toggle.nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        font-family: \'Ionicons\';\n        font-size: 22px;\n        bottom: 3px;\n        content: "\\f202";\n        color: #464444;\n    }\n\n    .resident-gender-toggle.nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        /*content: "{{\'RESIDENTWINDOWDETAIL.GENDER.FEMALE\' | translate}}";*/\n        font-family: \'Ionicons\';\n        font-size: 22px;\n        bottom: 3px;\n        content: "\\f25d";\n        color: #464444;\n    }\n</style>\n\n<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel resident-detail detail-panel">\n        <div ba-panel ba-panel-title-no-translate="<b>{{rdetc.resident.windowTitle}}</b>"\n             ba-panel-anim="zoom-in" style="line-height:30px;" id="residentDetail">\n            <form name="resForm" autocomplete="false">\n                <div class="row">\n                    <div class=" text-center avatarResident"\n                         ng-class="(rdetc.level > 2 && rdetc.resdidentaBD._id) ? \'col-md-12 col-xs-12\' : \'col-md-3 col-sm-12\'" ng-style="(rdetc.level > 2) ?\n                              {\'height\' : \'inherit\', \'padding-bottom\' : \'20px\'}:{\'height\': \'auto\'}" style="padding: 0;  display: flex; justify-content: center; padding-left: 25px;\n                         box-sizing: border-box; align-items: center;">\n                        <avatar type="person" shape="square" avatar-style=""\n                                readonly="( rdetc.readonly || rdetc.istour )" img="rdetc.avatar"\n                                uploading="rdect.avatarUploading" photo="rdetc.resdidentaBD.photo"\n                                id="residentresidentDetailImg"></avatar>\n                    </div>\n                    <div class="pull-right" ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-9 col-xs-12\'">\n                        <!-- First row -->\n                        <div class="row">\n                            <!-- Room -->\n                            <div ng-class="(rdetc.level > 2 && rdetc.resdidentaBD._id) ? \'col-md-4\' : \'col-md-3\'">\n                                <div class="input-group" id="residentDetailRoom">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          tooltip-placement="bottom-left"\n                                          uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ROOM\'| translate}}">\n                                        <span class="fa fa-bed" style="margin-left:-1px"></span></span>\n\n                                    <ui-select ng-model="rdetc.resdidentaBD.spot"\n                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control"\n                                               ng-disabled="rdetc.readonly"\n                                               append-to-body="true" name="spot" search-enabled="true">\n                                        <ui-select-match placeholder="{{\'RESIDENTWINDOWDETAIL.ROOM\'| translate}}">\n                                            <span> {{rdetc.resdidentaBD.spot.description}}</span>\n                                        </ui-select-match>\n                                        <ui-select-choices repeat="option in rdetc.listSpots |\n                                            uiSelectFilter: {description:$select.search}">\n                                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                            </div>\n                            <!-- Modality (Pension) -->\n                            <div ng-class="(rdetc.level > 2) ? \'col-md-4\' : \'col-md-3\'" ng-if="rdetc.resdidentaBD._id">\n                                <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          tooltip-placement="bottom-left"\n                                          uib-tooltip="{{\'REQUESTS.DETAIL.REQUEST_TYPE\'| translate}}">\n                                    <span class="ion-card" style="margin-left:-1px"></span></span>\n                                    <ui-select ng-model="rdetc.resdidentaBD.modality"\n                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control" ng-disabled="true"\n                                               append-to-body="true" name="modalityType" search-enabled="true">\n                                        <ui-select-match placeholder="{{\'REQUESTS.DETAIL.REQUEST_TYPE\' | translate}}">\n                                            <span> {{rdetc.resdidentaBD.modality.description}}</span>\n                                        </ui-select-match>\n                                        <ui-select-choices repeat="option in rdetc.constants.modality |\n                                                        uiSelectFilter: {name:$select.search}">\n                                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                            </div>\n                            <!-- App user token switch -->\n                            <div ng-class="(rdetc.level > 2 && rdetc.resdidentaBD._id) ? \'col-md-4\' : \'col-md-3\'"\n                                 ng-if="rdetc.resident.action != \'new\'">\n                                <ba-switcher switcher-style="primary"\n                                             switcher-value="rdetc.resdidentaBD.tokenApp === \'true\' ? true : false"\n                                             switcher-icon-on="\'ion-iphone\'" switcher-icon-off="\'ion-iphone\'"\n                                             switcher-read-only="true"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ACESSAPP\' | translate}}"\n                                             tooltip-placement="bottom"></ba-switcher>\n                                <button type="button" style="position: absolute; top: 0; margin-left: 10px;"\n                                        ng-if="!rdetc.readonly && rdetc.resdidentaBD.tokenApp && rdetc.resdidentaBD.tokenApp !== \'false\'"\n                                        ng-click="rdetc.configava(false)" class="btn btn-success btn-with-icon">\n                                    <i class="ion-iphone"></i>{{\'BUTTONS.DELETEACCESS\' | translate}}\n                                </button>\n                            </div>\n\n                            <div class="col-md-3 text-right" ng-if="!(rdetc.level > 2)">\n                                <!-- Gender Switch -->\n                                <nz-toggle tri-toggle class="resident-gender-toggle"\n                                           uib-tooltip="\n                                            {{(rdetc.resdidentaBD.gender === \'M\') ? (\'RESIDENTWINDOWDETAIL.GENDER.MALE\' | translate) :\n                                                ((rdetc.resdidentaBD.gender === \'F\') ? (\'RESIDENTWINDOWDETAIL.GENDER.FEMALE\' | translate) :  (\'RESIDENTWINDOWDETAIL.GENDER.UNDEFINED\' | translate))}}"\n                                           tooltip-placement="bottom"\n                                           val-default="undefined"\n                                           ng-disabled="rdetc.readonly"\n                                           ng-model="rdetc.resdidentaBD.gender"\n                                           val-true="\'M\'"\n                                           val-false="\'F\'"\n                                           val-null="undefined"\n                                           width="60"\n                                           height="30"\n                                           color-false="\'#60BD68\'">\n                                </nz-toggle>\n\n                                <!-- Active switch -->\n                                <ba-switcher ng-if="rdetc.resident._id !== \'0\'" class="pull-right"\n                                             switcher-style="primary" switcher-value="rdetc.resdidentaBD.active"\n                                             switcher-on="\'SERVICEMENUDETAIL.ACTIVE\'|translate"\n                                             switcher-off="\'SERVICEMENUDETAIL.ACTIVE\'|translate"\n                                             switcher-read-only="rdetc.readonly"\n                                             uib-tooltip="{{\'SERVICEMENUDETAIL.ACTIVE\' | translate}}"\n                                             tooltip-placement="bottom">\n                                </ba-switcher>\n                            </div>\n                        </div>\n                        <!-- Second row -->\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.NAME\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left"\n                                          id="residentDetailTooltip">\n                                        <span class="ion-android-person"></span></span>\n                                    <input type="text" name="name" ng-disabled="rdetc.readonly"\n                                           class="form-control with-primary-addon " ng-class="{\'invalid\': (resForm.name.$touched ||\n                                                    rdetc.submitted )&& !rdetc.readonly &&\n                                                    !resForm.name.$valid }"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.NAME\'|translate}}"\n                                           ng-model="rdetc.resdidentaBD.name" required>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate" ng-if="( resForm.name.$touched || rdetc.submitted )&& !rdetc.readonly &&\n                                            !resForm.name.$valid">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <input type="text" ng-disabled="rdetc.readonly" name="surname"\n                                           class="form-control with-primary-addon" ng-class="{\'invalid\': ( resForm.surname.$touched ||\n                                                rdetc.submitted ) && !scedetc.readonly && !resForm.surname.$valid}"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.LASTNAME\'|translate}}"\n                                           style="border-radius: 5px;" required ng-model="rdetc.resdidentaBD.surname">\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate" ng-if="( resForm.surname.$touched || rdetc.submitted )&&\n                                                !scedetc.readonly && !resForm.surname.$valid">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n                        </div>\n                        <!-- Third row -->\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left ">\n                                        <span class="ion-card"></span></span>\n                                    <input type="text" name="dni" ng-change="rdetc.validDNI(rdetc.resdidentaBD.identity.val,\n                                            rdetc.resdidentaBD.identity.type.description,\n                                            resForm.dni)" ng-blur="rdetc.validDNI(rdetc.resdidentaBD.identity.val,\n                                            rdetc.resdidentaBD.identity.type.description,\n                                            resForm.dni)" ng-disabled="rdetc.readonly"\n                                           class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'|translate}}"\n                                           ng-model="rdetc.resdidentaBD.identity.val">\n                                    <span style="width: 51px" id="residentDetailIdentification"\n                                          class="input-group-addon input-group-addon-primary addon-right" ng-click="rdetc.changeTypeIde(rdetc.resdidentaBD.identity.type);\n                                            rdetc.validDNI(rdetc.resdidentaBD.identity.val,\n                                            rdetc.resdidentaBD.identity.type.description,resForm.dni)"\n                                          ng-style="(rdetc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                        {{rdetc.resdidentaBD.identity.type ?\n                                        rdetc.resdidentaBD.identity.type.description : rdetc.resdidentaBD.identity.description}}</span>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="( resForm.dni.$touched || rdetc.submitted)&& !resForm.dni.$valid">\n                                    {{\'ERROR.GENERROR0\' | translate}}\n                                    {{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\' | translate}}\n                                    {{\'ERROR.GENERROR1\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <date-picker-comp tooltip-text="\'RESIDENTWINDOWDETAIL.EXPDATE\' | translate"\n                                                  placeholder="\'RESIDENTWINDOWDETAIL.EXPDATE\' | translate"\n                                                  tooltip-placement="bottom-left"\n                                                  date-value="rdetc.resdidentaBD.identity.expDate"\n                                                  mode-read-only="rdetc.readonly"\n                                                  form-reference="resForm" name-field="\'expDate\'">\n                                </date-picker-comp>\n                            </div>\n                        </div>\n                        <!-- Fourth row -->\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.EMAIL\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-at"></span></span>\n                                    <input type="text" ng-disabled="rdetc.readonly" name="email"\n                                           ng-change="rdetc.validEmail(rdetc.resdidentaBD.contact.email,resForm.email)"\n                                           ng-blur="rdetc.validEmail(rdetc.resdidentaBD.contact.email,resForm.email)"\n                                           autocomplete="new-password" class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.EMAIL\'|translate}}"\n                                           ng-model="rdetc.resdidentaBD.contact.email">\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="(resForm.email.$touched|| rdetc.submitted )&& !resForm.email.$valid">\n                                    {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.PHONE\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-ios-telephone"></span></span>\n                                    <input type="text" name="mobile" ng-change="rdetc.validateMobile(rdetc.resdidentaBD.contact.phone,\n                                           resForm.mobile)" ng-blur="rdetc.validateMobile(rdetc.resdidentaBD.contact.phone,\n                                           resForm.mobile)" ng-disabled="rdetc.readonly"\n                                           class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.PHONE\'|translate}}"\n                                           ng-model="rdetc.resdidentaBD.contact.phone">\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="(resForm.mobile.$touched || rdetc.submitted) && !resForm.mobile.$valid">\n                                    {{\'ERROR.GENERROR0\' | translate}}\n                                    {{\'RESIDENTWINDOWDETAIL.PHONE\' | translate}}\n                                    {{\'ERROR.GENERROR1\' | translate}}\n                                </div>\n                            </div>\n                        </div>\n                        <!-- Fifth row -->\n                        <div class="row">\n                            <div class=" col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ALIAS\'| translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="ion-android-contact"></span></span>\n                                    <input type="text" ng-disabled="rdetc.readonly"\n                                           class="form-control with-primary-addon"\n                                           placeholder="{{\'RESIDENTWINDOWDETAIL.ALIAS\'|translate}}"\n                                           ng-model="rdetc.resdidentaBD.nick">\n                                </div>\n                            </div>\n                            <div class="col-md-6">\n                                <date-picker-comp tooltip-text="\'RESIDENTWINDOWDETAIL.FECN\' | translate"\n                                                  tooltip-placement="top-left" date-value="rdetc.resdidentaBD.birthdate"\n                                                  placeholder="\'RESIDENTWINDOWDETAIL.FECN\' | translate"\n                                                  is-required="false"\n                                                  mode-read-only="( rdetc.readonly || rdetc.istour )"\n                                                  date-options="rdetc.dateOptions"\n                                                  show-required-error="true" name-field="\'visibleFrom\'"\n                                                  special-validation="rdetc.checkDates()" form-reference="resForm"\n                                                  msg-special-validation="\'RESIDENTSWINDOW.MSGBIRTHDAY\'">\n                                </date-picker-comp>\n                            </div>\n                        </div>\n                        <!-- Sixth row -->\n                        <div class="row">\n                            <div class="col-md-6">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.RESIDENCE\' | translate}}"\n                                          class="input-group-addon input-group-addon-primary addon-left"\n                                          tooltip-placement="top-left">\n                                        <span class="ion-card"></span>\n                                    </span>\n                                    <ui-select multiple ng-model="rdetc.resdidentaBD.branches"\n                                               ng-disabled="rdetc.readonly"\n                                               append-to-body="true" search-enabled="true">\n                                        <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}">\n                                            {{$item.description}}\n                                        </ui-select-match>\n                                        <ui-select-choices\n                                            repeat="branches in rdetc.constants.branch|\n                                                findResidence:{find:$select.search,alredy:rdetc.resdidentaBD.branches}">\n                                            <span ng-bind-html="branches.description | highlight: $select.search">\n                                            </span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                                <div class="errorValidation invalidInputMsg bounceIn animate"\n                                     ng-if="(rdetc.submitted) && (rdetc.resdidentaBD.branches.length < 1)">\n                                    *{{\'ERROR.NOTVALIDRESIDENCE\' | translate}}\n                                </div>\n                            </div>\n                            <div class="col-md-6 col-md-2">\n                                <ba-switcher switcher-style="primary" switcher-value="rdetc.resdidentaBD.isResident"\n                                             class="pull-left" switcher-icon-on="\'ion-android-home\'"\n                                             switcher-icon-off="\'fa fa-suitcase\'" switcher-read-only="rdetc.readonly"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ISRESIDENT\' | translate}}"\n                                             tooltip-placement="bottom"></ba-switcher>\n                            </div>\n                            <div class="col-md-6 col-md-2">\n                                <ba-switcher switcher-style="primary" switcher-value="rdetc.resdidentaBD.isDelegate"\n                                             switcher-icon-on="\'ion-android-contact\'"\n                                             switcher-icon-off="\'ion-android-contact\'"\n                                             switcher-read-only="rdetc.readonly"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.FLOORDELEGATE\' | translate}}"\n                                             tooltip-placement="bottom"></ba-switcher>\n                            </div>\n                            <div class="col-md-6 col-md-2">\n                                <ba-switcher switcher-style="primary" switcher-value="rdetc.resdidentaBD.isVirtual"\n                                             class="pull-right" switcher-icon-on="\'tagaste-spoon-knife\'"\n                                             switcher-icon-off="\'tagaste-spoon-knife\'"\n                                             switcher-read-only="rdetc.readonly"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ISVIRTUAL\' | translate}}"\n                                             tooltip-placement="bottom"></ba-switcher>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="row" style="min-height: 286px; position:relative;">\n\n                    <uib-tabset id="residentDetailContactInfo" type="tabs" class="resident-tabs">\n                        <uib-tab index="0" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CONTACTIN\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-user\' style=\'margin-left:-1px\'></span>\n                                </div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.CONTACTIN\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-8\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ADDRE\' | translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-ios-location"></span></span>\n                                        <input type="text" ng-disabled="rdetc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.ADDRE\'|translate}}"\n                                               ng-model="rdetc.resdidentaBD.contact.address">\n                                    </div>\n                                </div>\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CITY\'| translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-ios-location"></span></span>\n                                        <input type="text" ng-disabled="rdetc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.CITY\'|translate}}"\n                                               ng-model="rdetc.resdidentaBD.contact.city">\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.POSTCODE\'| translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-pound"></span></span>\n                                        <input type="text" ng-disabled="rdetc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.POSTCODE\'|translate}}"\n                                               ng-model="rdetc.resdidentaBD.contact.postcode">\n                                    </div>\n                                </div>\n                                <!--country-->\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group" ng-if="rdetc.resdidentaBD.contact">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}"\n                                                  tooltip-placement="top-left">\n                                                <span class="ion ion-flag"></span>\n                                            </span>\n                                        <ui-select ng-model="rdetc.selectedCountry"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control"\n                                                   ng-disabled="rdetc.readonly" ng-change="rdetc.selectCountryChange();"\n                                                   append-to-body="true" search-enabled="true">\n                                            <ui-select-match\n                                                placeholder="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}">\n                                                    <span ng-if="(rdetc.selectedCountry.name &&\n                                                        rdetc.selectedCountry.name !== \'\')">\n                                                        {{rdetc.selectedCountry.name}} </span>\n                                                <span ng-if="!(rdetc.selectedCountry.name &&\n                                                        rdetc.selectedCountry.name !== \'\')" style="color: #b2b1b1;">\n                                                        {{\'SELECTCOUNTRY.SELECTCOUNTRY\' | translate}}\n                                                    </span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="country in rdetc.getCountries($select.search) |\n                                                    uiSelectFilter: {name:$select.search}">\n                                                <span ng-bind-html="country.name| highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <span class="input-group-addon\n                                                input-group-addon-primary\n                                                addon-right ion-trash-a" ng-click="rdetc.clearCountry()"\n                                              ng-style="{cursor: rdetc.readonly ? \'default\' : \'pointer\'}">\n                                            </span>\n                                    </div>\n                                </div>\n                                <!--state-->\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group" ng-if="rdetc.resdidentaBD.contact">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}"\n                                                  tooltip-placement="top-left">\n                                                <span class="ion ion-ios-location"></span>\n                                            </span>\n                                        <ui-select ng-model="rdetc.selectedState"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rdetc.readonly ||\n                                                       !rdetc.resdidentaBD.contact.country"\n                                                   ng-change="rdetc.selectStateChange();" append-to-body="true"\n                                                   search-enabled="true">\n                                            <ui-select-match\n                                                placeholder="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}">\n                                                    <span ng-if="(rdetc.selectedState && rdetc.selectedState !== \'\')">\n                                                        {{rdetc.selectedState}} </span>\n                                                <span ng-if="!(rdetc.selectedState && rdetc.selectedState !== \'\')"\n                                                      style="color:#b2b1b1">\n                                                        {{\'SELECTCOUNTRY.SELECTSTATE\' | translate}}\n                                                    </span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="state in rdetc.getStates($select.search) |\n                                                    uiSelectFilter: $select.search">\n                                                <span ng-bind-html="state| highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                        <span class="input-group-addon\n                                                 input-group-addon-primary\n                                                  addon-right ion-trash-a" ng-click="rdetc.clearState()"\n                                              ng-style="{cursor: rdetc.readonly ||\n                                                !rdetc.resdidentaBD.contact.country ? \'default\' : \'pointer\'}">\n                                            </span>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.NATIONAILITY\'| translate}}"\n                                                  tooltip-placement="right"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-android-globe"></span></span>\n                                        <input type="text" ng-disabled="rdetc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.NATIONAILITY\'|translate}}"\n                                               ng-model="rdetc.resdidentaBD.nationality">\n                                    </div>\n                                </div>\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.LANGUAGE\'| translate}}"\n                                                  class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-chatbox-working"></span>\n                                            </span>\n                                        <input type="text" ng-disabled="rdetc.readonly"\n                                               class="form-control with-primary-addon"\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.LANGUAGE\'|translate}}"\n                                               ng-model="rdetc.resdidentaBD.language">\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab id="residentDetailOtherInfo" index="1"\n                                 uib-tooltip="{{\'RESIDENTWINDOWDETAIL.OTHERINFO\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.OTHERINFO\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-info\' style=\'margin-left:-1px\'></span>\n                                </div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'REQUESTS.DETAIL.REQUEST\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <!-- DATE_CONTRACT_SIGN -->\n                                <div class="col-md-6 col-sm-12">\n                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_CONTRACT_SIGN\' | translate"\n                                                      tooltip-placement="top-left" date-value="rdetc.resdidentaBD.dateContract"\n                                                      placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_CONTRACT_SIGN\' | translate"\n                                                      is-required="false"\n                                                      mode-read-only="( rdetc.readonly || rdetc.istour )"\n                                                      date-options="rdetc.dateOptionsContract"\n                                                      show-required-error="true" name-field="\'dateContract\'"\n                                                      form-reference="resForm">\n                                    </date-picker-comp>\n                                </div>\n                                <!-- DATE_RULES_SIGN -->\n                                <div class="col-md-6 col-sm-12">\n                                    <date-picker-comp tooltip-text="\'REQUESTS.DETAIL.REQUEST_DATE_RULES_SIGN\' | translate"\n                                                      tooltip-placement="top-left" date-value="rdetc.resdidentaBD.dateRegulations"\n                                                      placeholder="\'REQUESTS.DETAIL.REQUEST_DATE_RULES_SIGN\' | translate"\n                                                      is-required="false"\n                                                      mode-read-only="( rdetc.readonly || rdetc.istour )"\n                                                      date-options="rdetc.dateOptionsContract"\n                                                      show-required-error="true" name-field="\'dateRegulations\'"\n                                                      form-reference="resForm">\n                                    </date-picker-comp>\n                                </div>\n                            </div>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.OTHERINFO\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              uib-tooltip="{{\'SERVICEMENUDETAIL.TEXT\' | translate}}"\n                                              tooltip-placement="right-top" style="vertical-align: top;">\n                                            <span class="ion-android-create"></span>\n                                        </span>\n                                        <textarea ng-model="rdetc.resdidentaBD.comments" name="text"\n                                                  class="form-control with-primary-addon"\n                                                  aria-describedby="basic-addon1"\n                                                  ng-disabled="rdetc.readonly"\n                                                  placeholder="{{\'RESIDENTWINDOWDETAIL.OTHERCOMENTS\'|translate}}">\n                                        </textarea>\n                                    </div>\n                                </div>\n                            </div>\n\n                        </uib-tab>\n\n                        <uib-tab index="2" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ATTACHEDS\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.ATTACHEDS\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-paperclip\'\n                                                                    style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.ATTACHEDS\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <div class="input-group"\n                                         style="border-color: rgb(55, 55, 55); border-width: 1px 1px 1px 0; border-style: solid; border-radius: 4px">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'SERVICEMENUDETAIL.ATTACHEDS\' | translate}}"\n                                                  tooltip-placement="right-top" style="vertical-align: top">\n                                                <span class="ion-camera"></span>\n                                            </span>\n                                        <div id="residentAttacheds" readonly="rdetc.readonly" class="tagast-files">\n                                            <!-- <div ng-class="rdetc.readonly ? \'col-md-12\': \'col-md-4\'" class="tagaste-file-add"> -->\n                                            <div class="tagaste-file-add" ng-if=\'!rdetc.readonly\'>\n                                                <file img="rdetc.file" file-style="display: inline"\n                                                      style="cursor:pointer;"\n                                                      uploading="rdect.fileUploading"\n                                                      ng-disabled="rdetc.user.action === \'inEdit\' || rdetc.readonly"\n                                                      style-button="true"\n                                                      attacheds-list="rdetc.resdidentaBD.attacheds">\n                                                </file>\n                                            </div>\n\n                                            <div style="overflow-x: hidden; overflow-y:hidden;"\n                                                 scroll-glue-right="!glued;"\n                                                 class="file-list">\n                                                <div class="img-card-row"\n                                                     ng-repeat="attached in rdetc.resdidentaBD.attacheds track by $index"\n                                                     ng-if="rdetc.resdidentaBD.attacheds.length > 0">\n                                                    <card-file\n                                                        attached="attached" readonly="rdetc.readonly"\n                                                        uploading="rdect.fileUploading" max-long-name="8">\n                                                    </card-file>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="3" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.MEDICALIN\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.MEDICALIN\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-medkit\'\n                                                                    style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.MEDICALIN\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-xs-12 col-sm-6\'">\n                                    <div class="input-group">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'SERVICEMENUDETAIL.TEXT\' | translate}}"\n                                                  tooltip-placement="bottom-left" style="vertical-align: top">\n                                                <span class="ion-android-create"></span>\n                                            </span>\n                                        <textarea ng-model="rdetc.resdidentaBD.allergy.comments" name="text"\n                                                  class="form-control with-primary-addon"\n                                                  aria-describedby="basic-addon1"\n                                                  ng-disabled="rdetc.readonly"\n                                                  placeholder="{{\'RESIDENTWINDOWDETAIL.ALLERGENS\'|translate}}">\n                                            </textarea>\n                                    </div>\n                                </div>\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-12\' : \'col-xs-12 col-sm-6\'" class="">\n                                    <p style="margin-bottom:0;margin-top:0;font-size:13px;color:#90fdc1">\n                                        {{\'RESIDENTWINDOWDETAIL.FOODALLERGENS\' | translate}}</p>\n                                    <div style="align-self: left; text-align: left;margin-bottom:7px;"\n                                         class="titleBorderTop">\n                                        <div ng-repeat="allergy in rdetc.allergies" style="display: inline-block; margin-left:4px;margin-right:4px;\n                                                     margin-bottom:-1px;font-size: 18px">\n                                            <i uib-tooltip="{{allergy.description}}" class="{{allergy.icon}}"\n                                               ng-click="rdetc.changeAllerge(allergy,resForm)" ng-style="allergy.selected ?\n                                                        { \'color\': \'rgba(128, 254, 193, 1)\' } :\n                                                        { \'color\': \'rgba(128, 254, 193, 0.3)\'}"></i>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="4" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.STAYS\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.STAYS\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-exchange\'\n                                                                    style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.STAYS\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <div class="input-group">\n                                        <table ng-table="rdetc.tableParams" id="tableStays"\n                                               class="table table-hover table-condensed fixNgTable" show-filter="true">\n\n                                            <colgroup>\n                                                <col width="3%">\n                                                <col width="27%">\n                                                <col width="27%">\n                                                <col width="9%">\n                                                <col width="9%">\n                                                <col width="27%">\n                                                <col width="3%">\n                                            </colgroup>\n\n                                            <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                class="ng-binding">\n                                                <td colspan="7" ng-if="row.error" ng-src="{{row.error}}">\n                                                    {{row.error}}\n                                                </td>\n                                                <td data-title="\'RESIDENTSWINDOW.ROOM\'|translate"\n                                                    sortable="\'room\'"\n                                                    ng-attr-title="{{row.room}}">\n                                                    {{row.room}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.BOOK\'|translate"\n                                                    sortable="\'bookNum\'" ng-attr-title="{{row.bookNum}}">\n                                                    {{row.bookNum}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.ORIGIN\'|translate"\n                                                    sortable="\'originType\'" ng-attr-title="{{row.originType}}">\n                                                    {{row.originType}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.INDATE\'|translate"\n                                                    sortable="\'dateFormatFrom\'"\n                                                    ng-attr-title="{{row.dateFormatFrom}}">\n                                                    {{row.dateViewFrom | date:\'MM/dd/yyyy\'}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.OUTDATE\'|translate"\n                                                    sortable="\'dateFormatTo\'" ng-attr-title="{{row.dateFormatTo}}">\n                                                    {{row.dateViewTo | date:\'MM/dd/yyyy\'}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.RESIDENCE\'|translate"\n                                                    sortable="\'branchDescription\'"\n                                                    ng-attr-title="{{row.branchDescription}}">\n                                                    {{row.branchDescription}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.ISRESID\'|translate"\n                                                    ng-if="!row.error"\n                                                    sortable="\'isResident\'">\n                                                        <span class="ion-android-contact icuseronNgTable"\n                                                              title="{{(row.isResident === true) ? (\'RESIDENTWINDOWDETAIL.ISRESIDENTTOOLTIP\' | translate) : (\'RESIDENTSWINDOW.NOTRESIDENTTOOLTIP\' | translate)}}"\n                                                              ng-style="(row.isResident === true) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"></span>\n                                                </td>\n                                            </tr>\n                                        </table>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="5" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ABSENCES\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.ABSENCES\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-external-link\'\n                                                                    style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.ABSENCES\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div>\n                                <div class="input-group">\n                                    <div ng-class="rdetc.readonly ? \'col-sm-12\' : \'col-sm-7\'" style="padding-left: 0">\n                                        <table ng-table="rdetc.tableParamsAway"\n                                               class="table table-hover table-condensed fixNgTable" show-filter="false">\n                                            <colgroup>\n                                                <col width="20%">\n                                                <col width="20%">\n                                                <col width="20%">\n                                                <col width="20%">\n                                                <col width="20%">\n                                            </colgroup>\n                                            <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                class="ng-binding">\n                                                {{row}}\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.DATEFROM\'|translate"\n                                                    sortable="\'dateFormatFrom\'"\n                                                    ng-attr-title="{{row.dateFormatFrom}}">\n                                                    {{row.dateViewFrom | date:\'MM/dd/yyyy\'}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.TURN\'|translate"\n                                                    sortable="\'timeOfDayFrom\'"\n                                                    ng-attr-title="{{row.timeOfDayFrom.description}}">\n                                                    {{row.timeOfDayFrom.description}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.DATETO\'|translate"\n                                                    sortable="\'dateFormatTo\'"\n                                                    ng-attr-title="{{row.dateFormatTo}}">\n                                                    {{row.dateViewTo | date:\'MM/dd/yyyy\'}}\n                                                </td>\n                                                <td data-title="\'RESIDENTWINDOWDETAIL.TURN\'|translate"\n                                                    sortable="\'timeOfDayTo\'"\n                                                    ng-attr-title="{{row.timeOfDayTo.description}}">\n                                                    {{row.timeOfDayTo.description}}\n                                                </td>\n                                                <td ng-if="!rdetc.readonly">\n                                                    <i class="fa fa-trash-o iconNgTable edit"\n                                                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                       aria-hidden="true"\n                                                       tagaste-click="rdetc.deleteAway(row); $event.stopPropagation();">\n                                                    </i>\n                                                </td>\n                                            </tr>\n                                        </table>\n                                    </div>\n\n                                    <div ng-class="\'col-sm-5\'" style="font-size: 10px; margin-left: -10px;"\n                                         ng-if="!rdetc.readonly && rdetc.occupancies && rdetc.occupancies.data.length > 0">\n                                        <div class="lightRoundedBorder">\n                                            <div class="row">\n                                                <div ng-class="\'col-xs-7\'">\n                                                    <date-picker-comp\n                                                        tooltip-text="\'RESIDENTWINDOWDETAIL.DATEFROM\' | translate"\n                                                        date-value="rdetc.awayDayFrom" mode-read-only="rdetc.istour"\n                                                        date-options="rdetc.dateOptionsFromToday"\n                                                        form-reference="absencesForm" name-field="\'awayDayFrom\'"\n                                                        show-required-error="rdetc.showErrorAway"\n                                                        special-validation="rdetc.checkDatesAway()">\n                                                    </date-picker-comp>\n                                                </div>\n                                                <div ng-class="\'col-xs-5\'">\n                                                        <span\n                                                            class="input-group-addon input-group-addon-primary addon-left"\n                                                            tooltip-append-to-body="true"\n                                                            uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TURN\' | translate}}">\n                                                            <span class="ion-card"></span>\n                                                        </span>\n                                                    <ui-select ng-model="rdetc.timeOfDayFrom"\n                                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; display: table-cell !important;"\n                                                               class="btn-group bootstrap-select form-control"\n                                                               append-to-body="true" ng-disabled="rdetc.readonly">\n                                                        <ui-select-match>\n                                                                <span ng-bind="$select.selected.description"\n                                                                      placeholder="{{\'RESIDENTWINDOWDETAIL.TURN\'| translate}}"></span>\n                                                        </ui-select-match>\n                                                        <ui-select-choices\n                                                            repeat="item in (rdetc.constants.awayPeriod | filter: $select.search) track by item._id">\n                                                            <span ng-bind="item.description"></span>\n                                                        </ui-select-choices>\n                                                    </ui-select>\n                                                </div>\n                                            </div>\n                                            <div class="row">\n                                                <div ng-class="\'col-xs-7\'">\n                                                    <date-picker-comp\n                                                        tooltip-text="\'RESIDENTWINDOWDETAIL.DATETO\' | translate"\n                                                        date-value="rdetc.awayDayTo" mode-read-only="rdetc.istour"\n                                                        date-options="rdetc.dateOptionsFromToday"\n                                                        form-reference="absencesForm" name-field="\'awayDayTo\'"\n                                                        show-required-error="rdetc.showErrorAway"\n                                                        special-validation="rdetc.checkDatesAway()">\n                                                    </date-picker-comp>\n                                                </div>\n                                                <div ng-class="\'col-xs-5\'">\n                                                        <span\n                                                            class="input-group-addon input-group-addon-primary addon-left"\n                                                            tooltip-append-to-body="true"\n                                                            uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TURN\' | translate}}">\n                                                            <span class="ion-card"></span>\n                                                        </span>\n                                                    <ui-select ng-model="rdetc.timeOfDayTo"\n                                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; ; display: table-cell !important;"\n                                                               class="btn-group bootstrap-select form-control"\n                                                               append-to-body="true" ng-disabled="rdetc.readonly">\n                                                        <ui-select-match>\n                                                                <span ng-bind="$select.selected.description"\n                                                                      placeholder="{{\'RESIDENTWINDOWDETAIL.TURN\'| translate}}"></span>\n                                                        </ui-select-match>\n                                                        <ui-select-choices\n                                                            repeat="item in (rdetc.constants.awayPeriod | filter: $select.search) track by item._id">\n                                                            <span ng-bind="item.description"></span>\n                                                        </ui-select-choices>\n                                                    </ui-select>\n                                                </div>\n                                            </div>\n\n                                            <div class="row">\n                                                <div ng-class="\'col-xs-12\'">\n                                                    <div class="pull-right">\n                                                        <button type="button"\n                                                                style="margin-left: 15px; font-size: 12px;"\n                                                                ng-if="!rdetc.readonly" ng-click="rdetc.addAway()"\n                                                                class="btn btn-success btn-with-icon">\n                                                            <i\n                                                                class="ion-android-checkbox-outline"></i>{{\'BUTTONS.ADDAWAY\' | translate}}\n                                                        </button>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                            <div class="row" style="margin-top: 30px;">\n                                                    <span ng-show="rdetc.showErrorAway" class="msgError"\n                                                          style="margin-left: -15px; font-size: 12px;">\n                                                        {{\'RESIDENTWINDOWDETAIL.MSGERRORFECHAAWAY\' | translate}}</span>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="6" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.GUEST\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.GUEST\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-group\' style=\'margin-left:-1px\'></span>\n                                </div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.GUEST\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="input-group">\n                                <div\n                                    ng-class="(!rdetc.readonly && rdetc.occupancies && rdetc.occupancies.data.length > 0) ? \'col-sm-8\' : \'col-sm-12\'"\n                                    style="padding-left: 0">\n                                    <table ng-table="rdetc.tableParamsGuest"\n                                           class="table table-hover table-condensed fixNgTable" show-filter="false">\n                                        <colgroup>\n                                            <col width="20%">\n                                            <col width="31%">\n                                            <col width="20%">\n                                            <col width="20%">\n                                            <col width="3%">\n                                            <col width="3%">\n                                            <col width="3%">\n                                        </colgroup>\n\n                                        <tr ng-repeat="row in $data track by $index"\n                                            class="ng-binding">\n                                            {{row}}\n                                            <td data-title="\'RESIDENTWINDOWDETAIL.DATEIN\'|translate"\n                                                sortable="\'dateFormatIn\'" ng-attr-title="{{row.dateFormatIn}}">\n                                                {{row.dateViewIn | date:\'MM/dd/yyyy\'}}\n                                            </td>\n                                            <td data-title="\'RESIDENTWINDOWDETAIL.PERSON\'|translate"\n                                                sortable="\'guest.item.fullName\'"\n                                                ng-attr-title="{{row.fullName}}">\n                                                {{row.guest.item.fullName}}\n                                            </td>\n                                            <td data-title="\'RESIDENTWINDOWDETAIL.DATETIMEIN\'|translate"\n                                                sortable="\'dateTimeFormatIn\'"\n                                                ng-attr-title="{{row.dateTimeFormatIn}}">\n                                                {{row.dateTimeViewIn | date:\'MM/dd/yyyy\'}}\n                                            </td>\n                                            <td data-title="\'RESIDENTWINDOWDETAIL.DATETIMEOUT\'|translate"\n                                                sortable="\'dateTimeFormatOut\'"\n                                                ng-attr-title="{{row.dateTimeFormatOut}}">\n                                                {{row.dateTimeViewOut}}\n                                            </td>\n                                            <td ng-if="!rdetc.readonly">\n                                                <i class="fa ion-log-in iconNgTable edit selectableIcon"\n                                                   uib-tooltip="{{\'BUTTONS.IN\' | translate}}"\n                                                   aria-hidden="true"\n                                                   ng-show="!row.dateTimeViewIn"\n                                                   tagaste-click="rdetc.setdateTimeIn(row); $event.stopPropagation();">\n                                                </i>\n                                            </td>\n                                            <td ng-if="!rdetc.readonly">\n                                                <i class="fa ion-log-out iconNgTable edit selectableIcon"\n                                                   ng-show="row.dateTimeViewIn && !row.dateTimeViewOut"\n                                                   uib-tooltip="{{\'BUTTONS.OUT\' | translate}}"\n                                                   aria-hidden="true"\n                                                   tagaste-click="rdetc.setdateTimeOut(row); $event.stopPropagation();">\n                                                </i>\n                                            </td>\n                                            <td ng-if="!rdetc.readonly">\n                                                <i class="fa fa-trash-o iconNgTable edit selectableIcon"\n                                                   uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                   aria-hidden="true"\n                                                   ng-show="!row.dateTimeViewIn"\n\n                                                   tagaste-click="rdetc.deleteGuest(row); $event.stopPropagation();">\n                                                </i>\n                                            </td>\n                                        </tr>\n                                    </table>\n                                </div>\n                                <div ng-class="\'col-sm-4\'"\n                                     ng-if="!rdetc.readonly && rdetc.occupancies && rdetc.occupancies.data.length > 0">\n                                    <div class="lightRoundedBorder">\n                                        <div class="row">\n                                            <div ng-class="\'col-xs-12\'">\n                                                <date-picker-comp\n                                                    tooltip-text="\'RESIDENTWINDOWDETAIL.DATEIN\' | translate"\n                                                    date-value="rdetc.dateIn" mode-read-only="rdetc.istour"\n                                                    date-options="rdetc.dateOptionsFromToday"\n                                                    form-reference="absencesForm" name-field="\'dateIn\'">\n                                                </date-picker-comp>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div class="col-xs-12">\n                                                <div class="input-group" style="margin-bottom: 4px;">\n                                                        <span uib-tooltip="{{\'RESERVE.NAME\'| translate}}"\n                                                              class="input-group-addon input-group-addon-primary addon-left">\n                                                            <span class="ion-android-person"></span>\n                                                        </span>\n                                                    <input type="text" ng-model="rdetc.selectedName"\n                                                           placeholder="{{\'RESERVE.NAME\'|translate}}"\n                                                           uib-typeahead="o as o.fullName for o in rdetc.getGuestsByName($viewValue)"\n                                                           typeahead-loading="loadingGuest"\n                                                           typeahead-append-to-body="true"\n                                                           typeahead-no-results="rdetc.noGuestName" class="form-control"\n                                                           typeahead-wait-ms="700" typeahead-min-length=\'3\'\n                                                           typeahead-on-select="rdetc.setGuest($item)">\n                                                </div>\n                                                <div>\n                                                    <i ng-show="loadingGuest" class="glyphicon glyphicon-refresh"></i>\n                                                    <div ng-show="rdetc.noGuestName">\n                                                        <i class="glyphicon glyphicon-remove"></i>{{\'ERROR.NODATA\' | translate}}\n                                                    </div>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div ng-class="\'col-xs-12\'">\n                                                <div class="pull-right">\n                                                    <button type="button"\n                                                            style="margin-top: 15px; margin-left: 15px; font-size: 12px;"\n                                                            ng-if="!rdetc.readonly" ng-click="rdetc.addGuest()"\n                                                            class="btn btn-success btn-with-icon">\n                                                        <i\n                                                            class="ion-android-checkbox-outline"></i>{{\'BUTTONS.ADDGUEST\' | translate}}\n                                                    </button>\n\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="row" style="margin-top: 30px;">\n                                                <span ng-show="rdetc.showErrorGuest" class="msgError"\n                                                      style="margin-left: -10px; font-size: 12px;">\n                                                    {{\'RESIDENTWINDOWDETAIL.MSGERRORGUEST\' | translate}}</span>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="7" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ADMONITION\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.ADMONITION\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-exclamation\'\n                                                                    style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.ADMONITION\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div>\n                                <div class="input-group" style="overflow-y: hidden;">\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <!-- Amonestaciones / Comportamiento -->\n                                            <table ng-table="rdetc.tableParamsAdmonitions"\n                                                   class="table table-hover table-condensed fixNgTable"\n                                                   show-filter="false"\n                                                   style="font-size: 11px;">\n\n                                                <colgroup>\n                                                    <col width="20%">\n                                                    <col width="30%">\n                                                    <col width="44%">\n                                                    <col width="3%">\n                                                    <col width="3%">\n                                                </colgroup>\n\n                                                <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                    class="ng-binding">\n                                                    {{row}}\n                                                    <td data-title="\'RESIDENTWINDOWDETAIL.DATE\'|translate"\n                                                        sortable="\'dateFormat\'" ng-attr-title="{{row.dateFormat}}">\n                                                        {{row.dateView | date:\'MM/dd/yyyy\'}}\n                                                    </td>\n                                                    <td data-title="\'RESIDENTWINDOWDETAIL.TYPE\'|translate"\n                                                        sortable="\'type\'"\n                                                        ng-attr-title="{{row.type.description}}"\n                                                        ng-if="row.modeEdit">\n                                                        <select class="form-control"\n                                                                name="admonitionType_{{$index +1}}"\n                                                                id="admonitionType_{{$index +1}}" ng-model="row.type"\n                                                                ng-options="type.description for type in rdetc.constants.admonitionTypes track by type._id"\n                                                                required>\n                                                        </select>\n                                                    </td>\n                                                    <td data-title="\'RESIDENTWINDOWDETAIL.TYPE\'|translate"\n                                                        sortable="\'type\'"\n                                                        ng-attr-title="{{row.type.description}}"\n                                                        ng-if="!row.modeEdit">\n                                                        {{row.type.description}}\n                                                    </td>\n                                                    <td data-title="\'RESIDENTWINDOWDETAIL.COMMENT\'|translate"\n                                                        sortable="\'comment\'" ng-attr-title="{{row.comment}}"\n                                                        ng-if="!row.modeEdit">\n                                                        {{row.comment}}\n                                                    </td>\n                                                    <td data-title="\'RESIDENTWINDOWDETAIL.COMMENT\'|translate"\n                                                        sortable="\'comment\'" ng-attr-title="{{row.comment}}"\n                                                        ng-if="row.modeEdit">\n                                                            <textarea ng-model="row.comment" name="text"\n                                                                      class="form-control with-primary-addon"\n                                                                      aria-describedby="basic-addon1"\n                                                                      ng-disabled="rdetc.readonly"\n                                                                      placeholder="{{\'RESIDENTWINDOWDETAIL.OTHERCOMENTS\'|translate}}"\n                                                                      style="height: inherit;">\n                                                            </textarea>\n                                                    </td>\n                                                    <td ng-if="!rdetc.readonly && !row.modeEdit">\n                                                        <i class="fa fa-pencil iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                                           ng-if="!row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="rdetc.editAdmonition(row); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                    <td ng-if="!rdetc.readonly && row.modeEdit">\n                                                        <i class="glyphicon glyphicon-ok iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                                                           ng-if="row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="rdetc.saveAdmonition(row); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                    <td ng-if="!rdetc.readonly && !row.modeEdit">\n                                                        <i class="fa fa-trash-o iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                           ng-if="!row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="rdetc.deleteAdmonition(row); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                    <td ng-if="!rdetc.readonly && row.modeEdit">\n                                                        <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                                                           ng-if="row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="rdetc.cancelAdmonition(row); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                </tr>\n                                            </table>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div ng-class="\'col-md-offset-10 col-xs-2\'">\n                                            <button type="button"\n                                                    style="position: relative;  margin-top: 15px;  margin-bottom: 15px; font-size: 12px;"\n                                                    ng-if="!rdetc.readonly && !rdetc.addingAdmonition"\n                                                    ng-click="rdetc.addAdmonition()"\n                                                    class="btn btn-success btn-with-icon">\n                                                <i class="ion-android-checkbox-outline"></i>{{\'BUTTONS.ADD\' | translate}}\n                                            </button>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div\n                                ng-if="(!rdetc.tableParamsAdmonitions.data || rdetc.tableParamsAdmonitions.data.length < 1) && rdetc.readonly "\n                                style="padding-left: 10px;">\n                                {{\'ERROR.NODATA\' | translate}}\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="8" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.HISTORY\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.HISTORY\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-rotate-left\'\n                                                                    style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.HISTORY\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div>\n                                <div class="row">\n                                    <div class="col-sm-12 col-md-12 col-xs-12 text-left">\n                                        <p id="historyTypeFilter">\n                                            <button type="button" ng-style="(rdetc.TabHistoryMenu)\n                                                                ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                                    tagaste-click="rdetc.changeTabHistoryType(\'TabHistoryMenu\'); $event.stopPropagation();"\n                                                    class="btn btn-success btn-with-icon buttonMenuTypeLeft">\n                                                {{\'BUTTONS.CANTEEN\' | translate}}\n                                            </button>\n                                            <button type="button" ng-style="(rdetc.TabHistoryActivities)\n                                                                ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                                    tagaste-click="rdetc.changeTabHistoryType(\'TabHistoryActivities\');$event.stopPropagation();"\n                                                    class="btn btn-success btn-with-icon buttonMenuTypeCenter">\n                                                {{\'BUTTONS.ACTIVITIES\' | translate}}\n                                            </button>\n                                            <button type="button" ng-style="(rdetc.TabHistoryServices)\n                                                                ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                                    tagaste-click="rdetc.changeTabHistoryType(\'TabHistoryServices\'); $event.stopPropagation();"\n                                                    class="btn btn-success btn-with-icon buttonMenuTypeCenter">\n                                                {{\'BUTTONS.SERVICES\' | translate}}\n                                            </button>\n                                            <button type="button" ng-style="(rdetc.TabHistoryIncidents)\n                                                                ? {\'opacity\':\'1\'} : {\'opacity\':\'0.6\'}"\n                                                    tagaste-click="rdetc.changeTabHistoryType(\'TabHistoryIncidents\'); $event.stopPropagation();"\n                                                    class="btn btn-success btn-with-icon buttonMenuTypeRight">\n                                                {{\'BUTTONS.INCIDENTS\' | translate}}\n                                            </button>\n                                        </p>\n                                    </div>\n                                </div>\n                                <!-- Canteen Comedor Tab -->\n                                <div class="row" ng-if="rdetc.TabHistoryMenu">\n                                    <div class="col-xs-12">\n                                        <!-- <div infinite-scroll="rdetc.addMoreHistoryMenu();$event.stopPropagation();"> -->\n                                        <!-- <div ng-repeat="menu in rdetc.historyMenu | limitTo : 4 : (currentPage - 1) * 4 track by rdect.historyMenu._id" class="custom-list"> -->\n                                        <div\n                                            ng-repeat="menu in rdetc.historyMenu | limitTo : rdetc.historyItemsPage : (rdetc.historyMenuPage - 1) * rdetc.historyItemsPage"\n                                            class="custom-list">\n                                            <div class="menu-history">\n                                                <div class="menu-history-date">\n                                                    <div>{{rdetc.momentAux(menu.date).format(\'L\')}}</div>\n                                                    <div class="menu-history-icon"\n                                                         uib-tooltip="{{ menu.menuType.description }}"><i\n                                                        class="{{ menu.menuType.icon }}"></i></div>\n                                                </div>\n                                                <div class="menu-history-dishes">\n                                                    <div class="col-xs-3">\n                                                        <div ng-repeat="first in menu.first"\n                                                             style="font-size: 11px; padding-left: inherit;"\n                                                             ng-style="(first._id === menu.booking[\'0\'].first._id)\n                                                                            ? {\'border\':\'#8af37e solid 1px\'} : {}">\n                                                            {{ first.title }}\n                                                        </div>\n                                                    </div>\n                                                    <div class="col-xs-3">\n                                                        <div ng-repeat="second in menu.second"\n                                                             style="font-size: 11px; padding-left: inherit;"\n                                                             ng-style="(second._id === menu.booking[\'0\'].second._id)\n                                                                            ? {\'border\':\'#8af37e solid 1px\'} : {}">\n                                                            {{ second.title }}\n                                                        </div>\n                                                    </div>\n                                                    <div class="col-xs-3">\n                                                        <div ng-repeat="dessert in menu.dessert"\n                                                             style="font-size: 11px; padding-left: inherit;"\n                                                             ng-style="(dessert._id === menu.booking[\'0\'].dessert._id)\n                                                                            ? {\'border\':\'#8af37e solid 1px\'} : {}">\n                                                            {{ dessert.title }}\n                                                        </div>\n                                                    </div>\n                                                    <div class="col-xs-3">\n                                                        <div ng-repeat="extra in menu.extra"\n                                                             style="font-size: 11px; padding-left: inherit;"\n                                                             ng-style="(extra._id === menu.booking[\'0\'].extra._id)\n                                                                            ? {\'border\':\'#8af37e solid 1px\'} : {}">\n                                                            {{ extra.text }}\n                                                        </div>\n                                                    </div>\n\n                                                </div>\n                                                <div class="menu-history-delivered">\n                                                            <span class="fa fa-check"\n                                                                  uib-tooltip="{{ \'RESIDENTWINDOWDETAIL.MENUDELIVERED\' | translate }}"\n                                                                  ng-if="menu.booking[\'0\'].isDelivered"\n                                                                  aria-hidden="true"></span>\n                                                </div>\n                                            </div>\n                                        </div>\n\n                                        <!-- </div> -->\n                                    </div>\n                                    <div class="loading-spinner" ng-if="!rdetc.historyMenu"><span\n                                        class="fa fa-spinner fa-spin"></span>\n                                    </div>\n                                    <div class="col-xs-12" ng-if="rdetc.historyMenu && rdetc.historyMenu.length < 1">\n                                        {{\'ERROR.NODATA\' | translate}}\n                                    </div>\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyMenu && rdetc.historyMenu.length > rdetc.historyItemsPage">\n                                        <ul uib-pagination total-items="rdetc.historyMenu.length"\n                                            ng-model="rdetc.historyMenuPage"\n                                            items-per-page="rdetc.historyItemsPage"\n                                            boundary-link-numbers="true" max-size=5 rotate="true" boundary-links="true"\n                                            previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;"\n                                            last-text="&raquo;"></ul>\n                                    </div>\n                                </div>\n                                <!-- Activities Actividades Tab  -->\n                                <div class="row" ng-if="rdetc.TabHistoryActivities">\n                                    <div class="col-xs-12">\n                                        <!-- <div infinite-scroll="rdetc.addMoreHistoryActivities();$event.stopPropagation();"> -->\n                                        <div class="row">\n                                            <div class="col-xs-2">\n                                                {{\'RESIDENTWINDOWDETAIL.DATE\' | translate}}\n                                            </div>\n                                            <div class="col-xs-2">\n                                                {{\'RESIDENTWINDOWDETAIL.HISTORYPLACE\' | translate}}\n                                            </div>\n                                            <div class="col-xs-8">\n                                                {{\'RESIDENTWINDOWDETAIL.HISTORYAGENDA\' | translate}}\n                                            </div>\n                                        </div>\n\n                                        <div\n                                            ng-repeat="activity in rdetc.historyActivities | limitTo : rdetc.historyItemsPage : (rdetc.historyActivitiesPage - 1) * rdetc.historyItemsPage track by $index"\n                                            class="custom-list">\n                                            <div class="row">\n                                                <div class="col-xs-2">\n                                                    {{ activity.dateText }}\n                                                </div>\n                                                <div class="col-xs-2">\n                                                    {{ activity.placeText }}\n                                                </div>\n                                                <div class="col-xs-8">\n                                                    {{ activity.title }}\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <!-- </div> -->\n                                    </div>\n                                    <div class="loading-spinner" ng-if="!rdetc.historyActivities"><span\n                                        class="fa fa-spinner fa-spin"></span></div>\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyActivities && rdetc.historyActivities.length < 1">\n                                        {{ \'ERROR.NODATA\' | translate }}\n                                    </div>\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyActivities && rdetc.historyActivities.length > rdetc.historyItemsPage">\n                                        <ul uib-pagination total-items="rdetc.historyActivities.length"\n                                            ng-model="rdetc.historyActivitiesPage"\n                                            items-per-page="rdetc.historyItemsPage"\n                                            boundary-link-numbers="true" max-size=5 rotate="true" boundary-links="true"\n                                            previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;"\n                                            last-text="&raquo;"></ul>\n                                    </div>\n                                </div>\n\n                                <!-- Services Servicios Tab-->\n                                <div class="row" ng-if="rdetc.TabHistoryServices">\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyServices && rdetc.historyServices.length > 0">\n                                        <!-- <div infinite-scroll="rdetc.addMoreHistoryServices();$event.stopPropagation();"> -->\n                                        <div class="row">\n                                            <div class="col-xs-2">\n                                                {{\'SERVICEMENUDETAIL.DATEFROM\' | translate}}\n                                            </div>\n                                            <div class="col-xs-2">\n                                                {{\'SERVICEMENUDETAIL.DATETO\' | translate}}\n                                            </div>\n                                            <div class="col-xs-8">\n                                                {{\'SERVICEMENUDETAIL.SERVICENAME\' | translate}}\n                                            </div>\n                                        </div>\n                                        <div\n                                            ng-repeat="service in rdetc.historyServices | limitTo : rdetc.historyItemsPage : (rdetc.historyServicesPage - 1) * rdetc.historyItemsPage"\n                                            class="custom-list">\n                                            <div class="row list-row">\n                                                <div class="col-xs-2">\n                                                    {{rdetc.momentAux(service.dateFrom).format(\'L LT\')}}\n                                                </div>\n                                                <div class="col-xs-2">\n                                                    {{rdetc.momentAux(service.dateTo).format(\'L LT\')}}\n                                                </div>\n                                                <div class="col-xs-8">\n                                                    {{ service.name }}\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <!-- </div> -->\n                                    </div>\n\n                                    <div class="loading-spinner" ng-if="!rdetc.historyServices"><span\n                                        class="fa fa-spinner fa-spin"></span>\n                                    </div>\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyServices && rdetc.historyServices.length < 1">\n                                        {{\'ERROR.NODATA\' | translate}}\n                                    </div>\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyServices && rdetc.historyServices.length > rdetc.historyItemsPage">\n                                        <ul uib-pagination total-items="rdetc.historyServices.length"\n                                            ng-model="rdetc.historyServicesPage"\n                                            items-per-page="rdetc.historyItemsPage"\n                                            boundary-link-numbers="true" max-size=5 rotate="true" boundary-links="true"\n                                            previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;"\n                                            last-text="&raquo;"></ul>\n                                    </div>\n                                </div>\n                                <!-- Incidents Incidencias Tab -->\n                                <div class="row" ng-if="rdetc.TabHistoryIncidents">\n                                    <div class="col-xs-12">\n                                        <!-- <div\n                                            infinite-scroll="rdetc.addMoreHistoryIncidents();$event.stopPropagation();"> -->\n                                        <div class="row">\n                                            <div class="col-xs-2">\n                                                {{\'RESIDENTWINDOWDETAIL.DATE\' | translate}}\n                                            </div>\n                                            <div class="col-xs-10">\n                                                {{\'RESIDENTWINDOWDETAIL.INCIDENTNAME\' | translate}}\n                                            </div>\n                                        </div>\n\n                                        <div\n                                            ng-repeat="incident in rdetc.historyIncidents | limitTo : rdetc.historyItemsPage : (rdetc.historyIncidentsPage - 1) * rdetc.historyItemsPage"\n                                            class="custom-list">\n                                            <div class="row">\n                                                <div class="col-xs-2">\n                                                    {{rdetc.momentAux(incident.date).format(\'L\')}}\n                                                </div>\n                                                <div class="col-xs-10">\n                                                    {{ incident.text }}\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <!-- </div> -->\n                                    </div>\n                                    <div class="loading-spinner" ng-if="!rdetc.historyIncidents"><span\n                                        class="fa fa-spinner fa-spin"></span>\n                                    </div>\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyIncidents && rdetc.historyIncidents.length < 1">\n                                        {{\'ERROR.NODATA\' | translate}}\n                                    </div>\n                                    <div class="col-xs-12"\n                                         ng-if="rdetc.historyIncidents && rdetc.historyIncidents.length > rdetc.historyItemsPage">\n                                        <ul uib-pagination total-items="rdetc.historyIncidents.length"\n                                            ng-model="rdetc.historyIncidentsPage"\n                                            items-per-page="rdetc.historyItemsPage"\n                                            boundary-link-numbers="true" max-size=5 rotate="true" boundary-links="true"\n                                            previous-text="&lsaquo;" next-text="&rsaquo;" first-text="&laquo;"\n                                            last-text="&raquo;"></ul>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n                        <uib-tab index="9" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ACADEMICDATA\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.ACADEMICDATA\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-book\' style=\'margin-left:-1px\'></span>\n                                </div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.ACADEMICDATA\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n                            <div class="row">\n                                <div ng-class="(rdetc.level > 2) ? \'col-md-6\' : \'col-md-4\'">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'RESIDENTWINDOWDETAIL.UNIVERSITY\'| translate}}">\n                                            <span class="ion-university" style="margin-left:-1px"></span></span>\n\n                                        <ui-select ng-model="rdetc.resdidentaBD.academicdata.university"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control"\n                                                   ng-disabled="rdetc.readonly"\n                                                   append-to-body="true" name="spot" search-enabled="true"\n                                                   ng-change="rdetc.selectUniversityChange();">\n                                            <ui-select-match\n                                                placeholder="{{\'RESIDENTWINDOWDETAIL.UNIVERSITY\'| translate}}">\n                                                <span> {{rdetc.resdidentaBD.academicdata.university.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rdetc.universities |\n                                                uiSelectFilter: {description:$select.search}">\n                                                <span\n                                                    ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-md-4">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'RESIDENTWINDOWDETAIL.FACULTY\'| translate}}">\n                                            <span class="ion-university" style="margin-left:-1px"></span></span>\n\n                                        <ui-select ng-model="rdetc.resdidentaBD.academicdata.faculty"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control" ng-disabled="rdetc.readonly ||\n                                                       !rdetc.resdidentaBD.academicdata.university"\n                                                   append-to-body="true" name="spot" search-enabled="true">\n                                            <ui-select-match\n                                                placeholder="{{\'RESIDENTWINDOWDETAIL.FACULTY\'| translate}}">\n                                                <span> {{rdetc.resdidentaBD.academicdata.faculty.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rdetc.lodash.filter(rdetc.faculties, {\'related\': {\'_id\': rdetc.resdidentaBD.academicdata.university._id}}) |\n                                                uiSelectFilter: {description:$select.search}">\n                                                <span\n                                                    ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n\n\n                                    </div>\n                                </div>\n                                <div class="col-md-4">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                              tooltip-placement="bottom-left"\n                                              uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CARRER\'| translate}}">\n                                            <span class="ion-university" style="margin-left:-1px"></span></span>\n\n                                        <ui-select ng-model="rdetc.resdidentaBD.academicdata.carrerCollege"\n                                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                   class="btn-group bootstrap-select form-control"\n                                                   ng-disabled="rdetc.readonly"\n                                                   append-to-body="true" name="spot" search-enabled="true">\n                                            <ui-select-match placeholder="{{\'RESIDENTWINDOWDETAIL.CARRER\'| translate}}">\n                                                <span> {{rdetc.resdidentaBD.academicdata.carrerCollege.description}}</span>\n                                            </ui-select-match>\n                                            <ui-select-choices repeat="option in rdetc.lodash.filter(rdetc.studies, {\'related\': {\'_id\': rdetc.resdidentaBD.academicdata.faculty._id}}) |\n                                                uiSelectFilter: {description:$select.search}">\n                                                <span\n                                                    ng-bind-html="option.description | highlight: $select.search"></span>\n                                            </ui-select-choices>\n                                        </ui-select>\n                                    </div>\n                                </div>\n                                <div class="col-md-4">\n                                    <div class="input-group">\n                                       <span class="input-group-addon input-group-addon-primary addon-left"\n                                             tooltip-placement="bottom-left"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.COURSE\'|translate}}">\n                                            <span class="ion-pound" style="margin-left: -1px"></span>\n                                       </span>\n                                        <input type="text" name="name" ng-disabled="rdetc.readonly"\n                                               class="form-control with-primary-addon "\n                                               placeholder="{{\'RESIDENTWINDOWDETAIL.COURSE\'|translate}}"\n                                               ng-model="rdetc.resdidentaBD.academicdata.course">\n\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="row">\n                                <div class="col-md-12">\n                                    <div class="input-group">\n                                       <span class="input-group-addon input-group-addon-primary addon-left"\n                                             tooltip-placement="bottom-left"\n                                             uib-tooltip="{{\'RESIDENTWINDOWDETAIL.COMMENTS\'|translate}}">\n                                            <span class="ion-quote" style="margin-left: -1px"></span>\n                                       </span>\n                                        <textarea type="text" name="name" ng-disabled="rdetc.readonly"\n                                                  class="form-control with-primary-addon "\n                                                  placeholder="{{\'RESIDENTWINDOWDETAIL.COMMENTS\'|translate}}"\n                                                  ng-model="rdetc.resdidentaBD.academicdata.comment">\n                                       </textarea>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="10" uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.TITLE\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.TUTOR.TITLE\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'fa fa-male\' style=\'margin-left:-1px\'></span>\n                                </div>\n                            </uib-tab-heading>\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.TUTOR.TITLE\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n\n                            <div class="tutors" ng-if="rdetc.resdidentaBD.tutors">\n                                <div class="tutor-block" ng-repeat="tutor in rdetc.resdidentaBD.tutors track by $index">\n\n                                    <div class="row">\n                                        <div class="col-md-8">\n                                            <!-- Name -->\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.NAME\'|translate}}">\n                                                     <span class="ion-android-person" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'name\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon " ng-class="{\'invalid\': (resForm.tutors[$index].name.$touched ||\n                                                     rdetc.submitted )&& !rdetc.readonly &&\n                                                     !resForm[\'tutor\' + $index + \'name\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.NAME\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].name" required>\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4 text-right">\n                                            <nz-toggle tri-toggle class="tutor-gender-toggle"\n                                                       val-default="undefined"\n                                                       ng-disabled="rdetc.readonly"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].gender"\n                                                       val-true="\'M\'"\n                                                       val-false="\'F\'"\n                                                       val-null="undefined"\n                                                       width="150"\n                                                       style="width: 25px; height: 15px;"\n                                                       color-false="\'#60BD68\'">\n                                            </nz-toggle>\n                                        </div>\n                                    </div>\n\n                                    <div class="row">\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.ADDRESS\'|translate}}">\n                                                     <span class="ion-ios-location" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'address\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon " ng-class="{\'invalid\': (resForm.tutors[$index].address.$touched ||\n                                                     rdetc.submitted )&& !rdetc.readonly &&\n                                                     !resForm[\'tutor\' + $index + \'address\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.ADDRESS\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].address">\n                                            </div>\n\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.CITY\'|translate}}">\n                                                     <span class="ion-ios-location" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'city\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon " ng-class="{\'invalid\': (resForm.tutors[$index].city.$touched ||\n                                                     rdetc.submitted )&& !rdetc.readonly &&\n                                                     !resForm[\'tutor\' + $index + \'city\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.CITY\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].city">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.POSTCODE\'|translate}}">\n                                                     <span class="ion-pound" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'postcode\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon " ng-class="{\'invalid\': (resForm.tutors[$index].postcode.$touched ||\n                                                     rdetc.submitted )&& !rdetc.readonly &&\n                                                     !resForm[\'tutor\' + $index + \'postcode\'].$valid }"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.POSTCODE\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].postcode">\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div class="row">\n                                        <!--\n                                            <div class="col-md-4">\n                                                <div class="input-group">\n                                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                                          tooltip-placement="bottom-left"\n                                                          uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.STATE\'|translate}}">\n                                                         <span class="ion-ios-location" style="margin-left: -1px"></span>\n                                                    </span>\n                                                    <input type="text" name="{{\'tutor\' + $index + \'state\'}}" ng-disabled="rdetc.readonly"\n                                                           class="form-control with-primary-addon " ng-class="{\'invalid\': (resForm.tutors[$index].state.$touched ||\n                                                         rdetc.submitted )&& !rdetc.readonly &&\n                                                         !resForm[\'tutor\' + $index + \'state\'].$valid }"\n                                                           placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.STATE\'|translate}}"\n                                                           ng-model="rdetc.resdidentaBD.tutors[$index].state">\n                                                </div>\n\n                                            </div>\n                                            <div class="col-md-4">\n                                                <div class="input-group">\n                                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                                          tooltip-placement="bottom-left"\n                                                          uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.COUNTRY\'|translate}}">\n                                                         <span class="ion ion-flag" style="margin-left: -1px"></span>\n                                                    </span>\n                                                    <input type="text" name="{{\'tutor\' + $index + \'country\'}}"ng-disabled="rdetc.readonly"\n                                                           class="form-control with-primary-addon " ng-class="{\'invalid\': (resForm.tutors[$index].country.$touched ||\n                                                         rdetc.submitted )&& !rdetc.readonly &&\n                                                         !resForm[\'tutor\' + $index + \'country\'].$valid }"\n                                                           placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.COUNTRY\'|translate}}"\n                                                           ng-model="rdetc.resdidentaBD.tutors[$index].country">\n                                                </div>\n                                            </div> -->\n\n                                        <!-- Tutor COUNTRY -->\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      uib-tooltip="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}"\n                                                      tooltip-placement="top-left">\n                                                    <span class="ion ion-flag"></span>\n                                                </span>\n                                                <ui-select ng-model="rdetc.resdidentaBD.tutors[$index].selectedCountry"\n                                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                           class="btn-group bootstrap-select form-control"\n                                                           ng-disabled="rdetc.readonly"\n                                                           ng-change="rdetc.selectCountryChangeTutor($index);"\n                                                           append-to-body="true" search-enabled="true">\n                                                    <ui-select-match\n                                                        placeholder="{{\'SELECTCOUNTRY.SELECTCOUNTRY\'|translate}}">\n                                                            <span\n                                                                ng-if="(rdetc.resdidentaBD.tutors[$index].selectedCountry.name && rdetc.resdidentaBD.tutors[$index].selectedCountry.name !== \'\')">\n                                                                {{rdetc.resdidentaBD.tutors[$index].country}}\n                                                            </span>\n                                                        <span\n                                                            ng-if="!(rdetc.resdidentaBD.tutors[$index].selectedCountry.name && rdetc.resdidentaBD.tutors[$index].selectedCountry.name !== \'\')"\n                                                            style="color: #b2b1b1;">\n                                                                {{\'SELECTCOUNTRY.SELECTCOUNTRY\' | translate}}\n                                                            </span>\n                                                    </ui-select-match>\n                                                    <ui-select-choices\n                                                        repeat="country in rdetc.getCountries($select.search) | uiSelectFilter: {name:$select.search}">\n                                                        <span\n                                                            ng-bind-html="country.name| highlight: $select.search"></span>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                                <span\n                                                    class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                                    ng-click="rdetc.clearTutorCountry()"\n                                                    ng-style="{cursor: rdetc.readonly ? \'default\' : \'pointer\'}">\n                                                </span>\n                                            </div>\n                                        </div>\n\n                                        <!-- Tutor STATE-->\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      uib-tooltip="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}"\n                                                      tooltip-placement="top-left">\n                                                    <span class="ion ion-ios-location"></span>\n                                                </span>\n                                                <ui-select ng-model="rdetc.resdidentaBD.tutors[$index].selectedState"\n                                                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                           class="btn-group bootstrap-select form-control"\n                                                           ng-disabled="rdetc.readonly || !rdetc.resdidentaBD.tutors[$index].country"\n                                                           ng-change="rdetc.selectStateChangeTutor($index);"\n                                                           append-to-body="true"\n                                                           search-enabled="true">\n                                                    <ui-select-match\n                                                        placeholder="{{\'SELECTCOUNTRY.SELECTSTATE\'|translate}}">\n                                                            <span\n                                                                ng-if="(rdetc.resdidentaBD.tutors[$index].selectedState && rdetc.resdidentaBD.tutors[$index].selectedState !== \'\')">\n                                                                {{rdetc.resdidentaBD.tutors[$index].state}}\n                                                            </span>\n                                                        <span\n                                                            ng-if="!(rdetc.resdidentaBD.tutors[$index].selectedState && rdetc.resdidentaBD.tutors[$index].selectedState !== \'\')"\n                                                            style="color:#b2b1b1">\n                                                                {{\'SELECTCOUNTRY.SELECTSTATE\' | translate}}\n                                                            </span>\n                                                    </ui-select-match>\n                                                    <ui-select-choices\n                                                        repeat="state in rdetc.getTutorStates($select.search, $index) | uiSelectFilter: $select.search">\n                                                        <span ng-bind-html="state| highlight: $select.search"></span>\n                                                    </ui-select-choices>\n                                                </ui-select>\n                                                <span\n                                                    class="input-group-addon input-group-addon-primary addon-right ion-trash-a"\n                                                    ng-click="rdetc.clearTutorState()"\n                                                    ng-style="{cursor: rdetc.readonly || !rdetc.resdidentaBD.contact.country ? \'default\' : \'pointer\'}">\n                                                </span>\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.IDENTITY\'| translate}}"\n                                                      class="input-group-addon input-group-addon-primary addon-left ">\n                                                    <span class="ion-card"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'dni\'}}"\n                                                       ng-change="rdetc.validDNI(rdetc.resdidentaBD.tutors[$index].identity.docVal,\n                                                                                 rdetc.resdidentaBD.tutors[$index].identity.docType.description,\n                                                                                 resForm[\'tutor\' + $index + \'dni\'])"\n                                                       ng-blur="rdetc.validDNI(rdetc.resdidentaBD.tutors[$index].identity.docVal,\n                                                                                 rdetc.resdidentaBD.tutors[$index].identity.docType.description,\n                                                                                 resForm[\'tutor\' + $index + \'dni\'])"\n                                                       ng-focus="rdetc.setTutorDocType($index);"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.IDENTITY\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].identity.docVal">\n                                                <!-- span    id="residentDetailIdentification" -->\n                                                <span style="width: 51px" id="tutorIdentification{{$index}}"\n                                                      class="input-group-addon input-group-addon-primary addon-right"\n                                                      ng-click="rdetc.changeTypeDocTutor($index);\n                                                                rdetc.validDNI(rdetc.resdidentaBD.tutors[$index].identity.docVal, rdetc.resdidentaBD.tutors[$index].identity.docType.description, resForm[\'tutor\' + $index + \'dni\'])"\n                                                      ng-style="(rdetc.readonly) ? {\'cursor\': \'default\'}:{\'cursor\': \'pointer\'}">\n                                                        {{rdetc.resdidentaBD.tutors[$index].identity.docType.description}}\n                                                </span>\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                 ng-if="( resForm.tutors[$index].dni.$touched || rdetc.submitted)&& !resForm[\'tutor\' + $index + \'dni\'].$valid">\n                                                {{\'ERROR.GENERROR0\' | translate}}\n                                                {{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\' | translate}}\n                                                {{\'ERROR.GENERROR1\' | translate}}\n                                            </div>\n                                        </div>\n                                    </div>\n\n                                    <div class="row">\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.EMAIL\'|translate}}">\n                                                     <span class="ion-at" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'email\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       ng-class="{\'invalid\': (resForm.tutors[$index].email.$touched || rdetc.submitted ) &&\n                                                        !rdetc.readonly && !resForm[\'tutor\' + $index + \'email\'].$valid }"\n                                                       ng-change="rdetc.validEmail(rdetc.resdidentaBD.tutors[$index].email,resForm[\'tutor\' + $index + \'email\'])"\n                                                       ng-blur="rdetc.validEmail(rdetc.resdidentaBD.tutors[$index].email,resForm[\'tutor\' + $index + \'email\'])"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.EMAIL\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].email">\n                                            </div>\n                                            <div class="errorValidation invalidInputMsg bounceIn animate"\n                                                 ng-if="(resForm[\'tutor\' + $index + \'email\'].$touched|| rdetc.submitted )&& !resForm[\'tutor\' + $index + \'email\'].$valid">\n                                                {{\'ERROR.NOTVALIDEMAIL\' | translate}}\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.MAINPHONE\'|translate}}">\n                                                     <span class="ion ion-ios-telephone"\n                                                           style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'country\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.MAINPHONE\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].mainPhone">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.SECONDARYPHONE\'|translate}}">\n                                                     <span class="ion ion-ios-telephone"\n                                                           style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'country\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon"\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.SECONDARYPHONE\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].secondaryPhone">\n                                            </div>\n                                        </div>\n\n                                    </div>\n\n                                    <div class="row">\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.STUDIES\'|translate}}">\n                                                     <span class="ion-university" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'studies\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.STUDIES\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].studies">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="input-group">\n                                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                                      tooltip-placement="bottom-left"\n                                                      uib-tooltip="{{\'RESIDENTWINDOWDETAIL.TUTOR.PROFESSION\'|translate}}">\n                                                     <span class="ion ion-hammer" style="margin-left: -1px"></span>\n                                                </span>\n                                                <input type="text" name="{{\'tutor\' + $index + \'profession\'}}"\n                                                       ng-disabled="rdetc.readonly"\n                                                       class="form-control with-primary-addon "\n                                                       placeholder="{{\'RESIDENTWINDOWDETAIL.TUTOR.PROFESSION\'|translate}}"\n                                                       ng-model="rdetc.resdidentaBD.tutors[$index].profession">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-4">\n                                            <div class="pull-right">\n                                                <button class="btn btn-success btn-with-icon"\n                                                        style="margin-right:17px;margin-top:17px;margin-bottom:7px;"\n                                                        type="button"\n                                                        ng-if="!rdetc.readonly"\n                                                        tagaste-click="rdetc.removeTutor($index)">\n                                                    <i class="fa fa-trash-o"></i>{{\'RESIDENTWINDOWDETAIL.TUTOR.REMOVETUTOR\' | translate}}\n                                                </button>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="pull-right">\n                                    <button class="btn btn-success btn-with-icon"\n                                            style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                            ng-if="!rdetc.readonly" tagaste-click="rdetc.addTutor($event)">\n                                        <i class="ion-plus"></i>{{\'RESIDENTWINDOWDETAIL.TUTOR.ADDTUTOR\' | translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </uib-tab>\n\n                        <uib-tab index="11" ng-if="rdetc.resdidentaBD._id && rdetc.gotAccessBilling"\n                                 uib-tooltip="{{\'RESIDENTWINDOWDETAIL.BILLING.TITLE\' | translate}}"\n                                 heading="{{\'RESIDENTWINDOWDETAIL.BILLING\' | translate}}">\n                            <uib-tab-heading>\n                                <div class="tab-heading-icon"><span class=\'ion-social-euro\'\n                                                                    style=\'margin-left:-1px\'></span></div>\n                            </uib-tab-heading>\n\n                            <div style="border: 1px solid #8AF37E; border-radius: 5px; padding: 10px; margin-bottom: 15px;">\n                                <uib-accordion>\n                                    <uib-accordion-group\n                                        panel-class="panel-primary accordion-panel"\n                                        style="overflow-x: hidden; overflow-y: hidden;"\n                                        is-open="rdetc.accordions.billingData">\n                                        <uib-accordion-heading>\n                                            {{\'RESIDENTWINDOWDETAIL.BILLINGDATA\' | translate}}\n                                            <i class="pull-right glyphicon"\n                                               ng-class="{\'glyphicon-chevron-down\': rdetc.accordions.billingData,\n                                                \'glyphicon-chevron-right\': !rdetc.accordions.billingData}"></i>\n                                        </uib-accordion-heading>\n\n                                        <div class="row">\n                                            <div class="col-md-12">\n                                                <div class="input-group">\n                                                <span uib-tooltip="{{\'PAYMENT.MODALITY\' | translate}}"\n                                                      tooltip-placement="right"\n                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion ion-android-list"></span>\n                                                </span>\n                                                    <ui-select ng-model="rdetc.resdidentaBD.billingAccounts.billingType"\n                                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                               class="btn-group bootstrap-select form-control"\n                                                               append-to-body="true"\n                                                               name="billingType"\n                                                               ng-disabled="rdetc.readonly"\n                                                               search-enabled="true">\n                                                        <ui-select-match\n                                                            allow-clear=true\n                                                            placeholder="{{\'PAYMENT.MODALITY\'| translate}}">\n                                                            {{rdetc.resdidentaBD.billingAccounts.billingType.description}}\n                                                        </ui-select-match>\n                                                        <ui-select-choices repeat="option in rdetc.constants.billingTypes">\n                                                            <div\n                                                                ng-bind-html="option.description | highlight: $select.search"></div>\n                                                        </ui-select-choices>\n                                                    </ui-select>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div class="col-md-12">\n                                                <div class="input-group">\n                                                <span uib-tooltip="{{\'PAYMENT.PAYMENTTYPE\' | translate}}"\n                                                      tooltip-placement="right"\n                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion ion-android-list"></span>\n                                                </span>\n                                                    <ui-select ng-model="rdetc.payType"\n                                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                               class="btn-group bootstrap-select form-control"\n                                                               append-to-body="true"\n                                                               name="payType"\n                                                               ng-change="rdetc.changePayType();"\n                                                               ng-disabled="rdetc.readonly"\n                                                               search-enabled="true">\n                                                        <ui-select-match\n                                                            allow-clear=true\n                                                            placeholder="{{\'PAYMENT.PAYMENTTYPE\'| translate}}">\n                                                            {{rdetc.payType.description}}\n                                                        </ui-select-match>\n                                                        <ui-select-choices repeat="option in rdetc.constants.payTypes">\n                                                            <div\n                                                                ng-bind-html="option.description | highlight: $select.search"></div>\n                                                        </ui-select-choices>\n                                                    </ui-select>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div ng-if="rdetc.payType.code===\'domiciliado\'">\n                                            <div class="row">\n                                                <div class="col-md-12">\n                                                    <div class="input-group"\n                                                         ng-style="resForm.bankHolder.$touched && (resForm.bankHolder.$invalid ||\n                                                            resForm.bankHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                    <span uib-tooltip="{{\'PAYMENT.BANKHOLDER\' | translate}}"\n                                                          tooltip-placement="right"\n                                                          class="input-group-addon input-group-addon-primary addon-left">\n                                                        <span class="ion-android-person"></span>\n                                                    </span>\n                                                        <input type="text" name="bankHolder" required\n                                                               ng-disabled="rdetc.readonly"\n                                                               class="form-control with-primary-addon"\n                                                               placeholder="{{\'PAYMENT.BANKHOLDER\'|translate}}"\n                                                               ng-blur="rdetc.emitPayTypeChange()"\n                                                               ng-model="rdetc.resdidentaBD.billingAccounts.bank.holder">\n                                                    </div>\n                                                    <span ng-show="resForm.bankHolder.$touched && (resForm.bankHolder.$invalid ||\n                                                            resForm.bankHolder.$error.required)" class="msgError">\n                                                    {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                </div>\n                                            </div>\n                                            <div class="row">\n                                                <div class="col-md-12">\n                                                    <div class="input-group"\n                                                         ng-style="resForm.bankSwift.$touched && (resForm.bankSwift.$invalid ||\n                                                            resForm.bankSwift.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                    <span uib-tooltip="{{\'PAYMENT.SWIFT\' | translate}}"\n                                                          tooltip-placement="right"\n                                                          class="input-group-addon input-group-addon-primary addon-left">\n                                                        <span class="fa fa-bank"></span>\n                                                    </span>\n                                                        <input type="text" name="bankSwift" required\n                                                               ng-disabled="rdetc.readonly"\n                                                               class="form-control with-primary-addon"\n                                                               placeholder="{{\'PAYMENT.SWIFT\'|translate}}"\n                                                               ng-blur="rdetc.emitPayTypeChange()"\n                                                               ng-model="rdetc.resdidentaBD.billingAccounts.bank.swift">\n                                                    </div>\n                                                    <span\n                                                        ng-show="resForm.bankSwift.$touched && resForm.bankSwift.$error.required"\n                                                        class="msgError">\n                                                    {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                    <span ng-show="!resForm.bankSwift.$error.required &&\n                                                    !rdetc.validSwift(rdetc.resdidentaBD.billingAccounts.bank.swift, resForm.bankSwift)"\n                                                          class="msgError">\n                                                    {{\'ERROR.GENERROR0\' | translate}}\n                                                    {{\'PAYMENT.SWIFT\' | translate}}\n                                                    {{\'ERROR.GENERROR1\' | translate}}</span>\n                                                </div>\n                                            </div>\n                                            <div class="row">\n                                                <div class="col-md-12">\n                                                    <div class="input-group"\n                                                         ng-style="resForm.bankIban.$touched && (resForm.bankIban.$invalid ||\n                                                            resForm.bankIban.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                    <span uib-tooltip="{{\'PAYMENT.IBAN\' | translate}}"\n                                                          tooltip-placement="right"\n                                                          class="input-group-addon input-group-addon-primary addon-left">\n                                                        <span class="fa fa-bank"></span>\n                                                    </span>\n                                                        <input type="text" name="bankIban" required\n                                                               ng-disabled="rdetc.readonly"\n                                                               class="form-control with-primary-addon"\n                                                               placeholder="{{\'PAYMENT.IBAN\'|translate}}"\n                                                               ng-blur="rdetc.emitPayTypeChange()"\n                                                               ng-model="rdetc.resdidentaBD.billingAccounts.bank.iban">\n                                                    </div>\n                                                    <span\n                                                        ng-show="resForm.bankIban.$touched && resForm.bankIban.$error.required"\n                                                        class="msgError">\n                                                    {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                    <span ng-show="!resForm.bankIban.$error.required &&\n                                                    !rdetc.validIban(rdetc.resdidentaBD.billingAccounts.bank.iban, resForm.bankIban)"\n                                                          class="msgError">\n                                                    {{\'ERROR.GENERROR0\' | translate}}\n                                                    {{\'PAYMENT.IBAN\' | translate}}\n                                                    {{\'ERROR.GENERROR1\' | translate}}</span>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div ng-if="rdetc.payType.code===\'tarjeta\'">\n                                            <div class="row">\n                                                <div class="col-md-12">\n                                                    <div class="input-group"\n                                                         ng-style="resForm.cardHolder.$touched && (resForm.cardHolder.$invalid ||\n                                                            resForm.cardHolder.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                    <span uib-tooltip="{{\'PAYMENT.CARDHOLDER\' | translate}}"\n                                                          tooltip-placement="right"\n                                                          class="input-group-addon input-group-addon-primary addon-left">\n                                                        <span class="ion-android-person"></span>\n                                                    </span>\n                                                        <input type="text" ng-disabled="rdetc.readonly" required\n                                                               class="form-control with-primary-addon" name="cardHolder"\n                                                               placeholder="{{\'PAYMENT.CARDHOLDER\'|translate}}"\n                                                               ng-blur="rdetc.emitPayTypeChange()"\n                                                               ng-model="rdetc.resdidentaBD.billingAccounts.bankCard.cardholder">\n                                                    </div>\n                                                    <span\n                                                        ng-show="resForm.cardHolder.$touched && resForm.cardHolder.$error.required"\n                                                        class="msgError">\n                                                    {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                </div>\n                                            </div>\n                                            <div class="row">\n                                                <div class="col-md-12">\n                                                    <div class="input-group"\n                                                         ng-style="resForm.cardNumber.$touched && (resForm.cardNumber.$invalid ||\n                                                            resForm.cardNumber.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                                          tooltip-placement="right"\n                                                          class="input-group-addon input-group-addon-primary addon-left">\n                                                        <span class="icon ion-card"\n                                                              style="color:#8AF37E !important;"></span>\n                                                    </span>\n                                                        <input type="text" name="cardNumber"\n                                                               ng-disabled="rdetc.readonly" required\n                                                               placeholder="{{\'RESIDENTWINDOWDETAIL.CARD\'| translate}}"\n                                                               ng-model="rdetc.resdidentaBD.billingAccounts.bankCard.number"\n                                                               ng-blur="rdetc.emitPayTypeChange()"\n                                                               class="form-control with-primary-addon">\n                                                    </div>\n                                                    <span\n                                                        ng-show="resForm.cardNumber.$touched && resForm.cardNumber.$error.required"\n                                                        class="msgError">\n                                                    {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                </div>\n                                            </div>\n                                            <div class="row">\n                                                <div class="col-md-12">\n                                                    <div class="input-group" style="margin-bottom: 0;">\n                                                        <date-picker-comp\n                                                            tooltip-text="\'PAYMENT.CARDEXPDATE\' | translate"\n                                                            date-value="rdetc.resdidentaBD.billingAccounts.bankCard.expDate"\n                                                            mode-read-only="rdetc.istour || rdetc.readonly"\n                                                            date-options="rdetc.dateOptionsFromToday"\n                                                            form-reference="resForm"\n                                                            placeholder="\'PAYMENT.CARDEXPDATE\' | translate"\n                                                            name-field="\'cardExpDate\'"\n                                                            min-mode="\'month\'"\n                                                            is-required="true"\n                                                            show-required-error="rdetc.showErrorAway"\n                                                            ng-blur="rdetc.emitPayTypeChange()"\n                                                            special-validation="rdetc.checkDatesAway()">\n                                                        </date-picker-comp>\n                                                    </div>\n                                                </div>\n                                                <div class="col-md-4">\n                                                    <div class="input-group"\n                                                         ng-style="resForm.cardCvv.$touched && (resForm.cardCvv.$invalid ||\n                                                            resForm.cardCvv.$error.required) ? {\'margin-bottom\': 0}:\'\'">\n                                                    <span\n                                                        uib-tooltip="{{\'PAYMENT.CVV\' | translate}}"\n                                                        class="input-group-addon input-group-addon-primary addon-left">\n                                                        <span class="icon ion-card"></span>\n                                                    </span>\n                                                        <input type="text" name="cardCvv"\n                                                               ng-disabled="rdetc.readonly" required\n                                                               class="form-control with-primary-addon"\n                                                               placeholder="{{\'PAYMENT.CVV\'|translate}}"\n                                                               aria-describedby="basic-addon1"\n                                                               valid-number style="width: 70px;"\n                                                               ng-blur="rdetc.emitPayTypeChange()"\n                                                               ng-model="rdetc.resdidentaBD.billingAccounts.bankCard.cvv">\n                                                    </div>\n                                                    <span\n                                                        ng-show="resForm.cardCvv.$touched && resForm.cardCvv.$error.required"\n                                                        class="msgError">\n                                                    {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="row" ng-if="rdetc.payType">\n                                            <div class="col-md-12">\n                                                <label class="custom-checkbox">\n                                                    <input id="checkPayType" type="checkbox" readonly="rdetc.readonly"\n                                                           ng-model="rdetc.isDefaultPayMethod"\n                                                           ng-click="rdetc.setDefaultPayMethod()">\n                                                    <span>{{\'RESIDENTWINDOWDETAIL.DEFAULTPAYTYPE\' | translate}}</span>\n                                                </label>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div class="col-md-12">\n                                                <div class="input-group">\n                                                <span uib-tooltip="{{\'PAYMENT.MODALITY_CHECKOUT\' | translate}}"\n                                                      tooltip-placement="right"\n                                                      class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion ion-android-list"></span>\n                                                </span>\n                                                    <ui-select ng-model="rdetc.resdidentaBD.billingAccounts.billingCheckoutType"\n                                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                                               class="btn-group bootstrap-select form-control"\n                                                               append-to-body="true"\n                                                               name="billingCheckoutType"\n                                                               ng-disabled="rdetc.readonly"\n                                                               search-enabled="true">\n                                                        <ui-select-match\n                                                            allow-clear=true\n                                                            placeholder="{{\'PAYMENT.MODALITY_CHECKOUT\'| translate}}">\n                                                            {{rdetc.resdidentaBD.billingAccounts.billingCheckoutType.description}}\n                                                        </ui-select-match>\n                                                        <ui-select-choices repeat="option in rdetc.constants.billingCheckoutTypes">\n                                                            <div\n                                                                ng-bind-html="option.description | highlight: $select.search"></div>\n                                                        </ui-select-choices>\n                                                    </ui-select>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </uib-accordion-group>\n                                </uib-accordion>\n\n                                <uib-accordion class="no-margin">\n                                    <uib-accordion-group\n                                        panel-class="panel-primary accordion-panel"\n                                        style="overflow-x: hidden; overflow-y: hidden;"\n                                        is-open="rdetc.accordions.billings">\n                                        <uib-accordion-heading>\n                                            {{\'RESIDENTWINDOWDETAIL.BILLINGS\' | translate}}\n                                            <i class="pull-right glyphicon"\n                                               ng-class="{\'glyphicon-chevron-down\': rdetc.accordions.billings,\n                                                \'glyphicon-chevron-right\': !rdetc.accordions.billings}"></i>\n                                        </uib-accordion-heading>\n                                        <div class="row" style="margin-bottom: 10px;">\n                                            <div class="col-md-6">\n                                                <label class="custom-checkbox">\n                                                    <input\n                                                        id="checkDeposit"\n                                                        type="checkbox"\n                                                        ng-model="rdetc.resdidentaBD.depositReturn"\n                                                        ng-disabled="rdetc.readonly || !rdetc.resdidentaBD.deposit">\n                                                    <span>{{\'PAYMENT.RETURN_DEPOSIT\' | translate}}</span>\n                                                </label>\n                                            </div>\n                                            <div class="col-md-6" ng-if="rdetc.resdidentaBD.depositReturn">\n                                                <date-picker-comp tooltip-text="\'RESIDENTWINDOWDETAIL.DEPOSITRETURNDATE\' | translate"\n                                                                  placeholder="\'RESIDENTWINDOWDETAIL.DEPOSITRETURNDATE\' | translate"\n                                                                  tooltip-placement="bottom-left"\n                                                                  date-value="rdetc.resdidentaBD.depositReturnDate"\n                                                                  mode-read-only="rdetc.readonly"\n                                                                  form-reference="resForm" name-field="\'depositReturnDate\'">\n                                                </date-picker-comp>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div class="col-md-12">\n                                                <div class="input-group">\n                                                    <table ng-table="rdetc.billingTableParams" id="tableBillings"\n                                                           class="table table-hover table-condensed fixNgTable"\n                                                           show-filter="true">\n\n                                                        <colgroup>\n                                                            <col>\n                                                            <col>\n                                                            <col>\n                                                            <col>\n                                                            <col>\n                                                            <col>\n                                                        </colgroup>\n\n                                                        <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                            class="ng-binding"\n                                                            ng-click="rdetc.goDetailBilling(row)">\n                                                            <td colspan="7" ng-if="row.error" ng-src="{{row.error}}">\n                                                                {{row.error}}\n                                                            </td>\n                                                            <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.CODE\'|translate"\n                                                                sortable="\'code\'"\n                                                                ng-attr-title="{{row.code}}">\n                                                                {{row.code}}\n                                                            </td>\n                                                            <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.RECEIPT\'|translate"\n                                                                sortable="\'proformaNumber\'"\n                                                                ng-attr-title="{{row.proformaNumber}}">\n                                                                {{row.proformaNumber}}\n                                                            </td>\n                                                            <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.DATE\'|translate"\n                                                                sortable="\'date\'" ng-attr-title="{{row.date}}">\n                                                                {{row.date | date:\'dd/MM/yyyy\'}}\n                                                            </td>\n                                                            <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.CONCEPT\'|translate"\n                                                                sortable="\'concept\'"\n                                                                ng-attr-title="{{row.concept}}">\n                                                                {{row.concept}}\n                                                            </td>\n                                                            <td data-title="\'RESIDENTWINDOWDETAIL.PAID\'|translate"\n                                                                sortable="\'isPaid\'" ng-attr-title="{{row.isPaid}}"\n                                                                style="text-align: center">\n                                                                <i class="fa fa-check" ng-if="row.isPaid"></i>\n                                                            </td>\n                                                            <td data-title="\'RESIDENTWINDOWDETAIL.BILLING.PAYDATE\'|translate"\n                                                                sortable="\'date\'" ng-attr-title="{{row.payDate}}">\n                                                                {{row.payDate | date:\'MM/dd/yyyy\'}}\n                                                            </td>\n                                                        </tr>\n\n                                                    </table>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </uib-accordion-group>\n                                </uib-accordion>\n                            </div>\n\n                            <div class="accordionSubTitle">\n                                <div class="accordionSubTitleText">\n                                    {{\'RESIDENTWINDOWDETAIL.CONCEPTS\' | translate}}\n                                </div>\n                                <div class="accordionSubTitleBorder"></div>\n                            </div>\n\n                            <payment resident="rdetc.resdidentaBD" readonly="rdetc.readonly"\n                                     on-save="rdetc.getBillings()"\n                                     user-kind="{value: \'resident\'}" menu-option="\'residents\'"></payment>\n                        </uib-tab>\n                    </uib-tabset>\n                </div>\n                <div class="row">\n                    <div class="col-xs-12" style="margin-top:13px;">\n                        <p ng-if="rdetc.submitted && !rdetc.readonly && !resForm.$valid"\n                           class="pull-right errorValidation bounceIn animate">\n                            {{\'ERROR.ERRORININPUT\' | translate}}</p>\n                    </div>\n                </div>\n                <div class="panel-footer-buttons">\n                    <div class="row">\n                        <div class="pull-right">\n                            <button class="residentDetailCancel btn btn-success btn-with-icon" id="residentDetailBack"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    ng-if="rdetc.readonly" tagaste-click="rdetc.back()">\n                                <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' | translate}}\n                            </button>\n                            <button class="residentDetailCancel btn btn-success btn-with-icon"\n                                    style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    id="residentDetailCancel" tagaste-click="rdetc.back()" ng-if="!rdetc.readonly">\n                                <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' | translate}}\n                            </button>\n                            <button style="margin-right:17px;margin-top:17px;margin-bottom:7px;" type="button"\n                                    tagaste-click="rdetc.save(resForm)" ng-if="!rdetc.readonly"\n                                    ng-disabled="rdetc.user.action === \'inEdit\' || rdect.avatarUploading ||\n                                    ( rdetc.submitted &&  !resForm.$valid && (!rdetc.resdidentaBD.branches)) ||\n                                    rdetc.checkDates() || rdect.fileUploading " class="btn btn-success btn-with-icon">\n                                <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                            </button>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/residents/residentsList/residentsList.html','<style>\n    .switchType .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.ALL\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchVisibility .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.RESERVES\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.CANTEEN\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.RESIDENTS\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchVisibility .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.ACTIVE\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchVisibility .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.DELETED\'|translate}}";\n        bottom: 3px;\n    }\n</style>\n<div class="row" ng-click="rlstc.backifModifOrNew()">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="RESIDENTSWINDOW.HEADER" ba-panel-class="with-scroll" id="residentsList">\n            <div class="filterAccordion" style="left: 280px!important;" ng-hide="rlstc.selectu._id !== undefined">\n                <uib-accordion>\n                    <uib-accordion-group panel-class="panel-primary accordion-panel " is-open="status.open">\n                        <uib-accordion-heading>{{\'RESIDENTSWINDOW.FILTERS\' | translate}}\n                            <i class="pull-right glyphicon" ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i>\n                        </uib-accordion-heading>\n                        <div class="row">\n                            <div class="col-xs-12 switchType">\n                                <nz-toggle tri-toggle val-null="\'all\'" ng-model="rlstc.isVirtual" on-toggle="rlstc.changeFilter()" width="150"\n                                           style="width: 25px; height: 15px;" color-false="\'#8AF37E\'" color-true="\'#8AF37E\'"></nz-toggle>\n                                <!--<span style="color: #00ffcc; font-size: 12px; position: absolute; padding-top: 10px; padding-left: 6px;">{{\'RESIDENTSWINDOW.SHOWVIRTUALS\' | translate}}</span>-->\n                            </div>\n                        </div>\n<!--                        <div class="row">-->\n<!--                            <div class="col-xs-12 switchVisibility">-->\n<!--                                <nz-toggle tri-toggle val-default="false" val-null="\'reserves\'" ng-model="rlstc.isActive" on-toggle="rlstc.changeFilter()" width="150"-->\n<!--                                           style="width: 25px; height: 15px;"  color-false="\'#8AF37E\'" color-true="\'#8AF37E\'"></nz-toggle>-->\n<!--                                &lt;!&ndash;<span style="color: #00ffcc; font-size: 12px; position: absolute; padding-top: 10px; padding-left: 6px;">{{\'RESIDENTSWINDOW.SHOWACTIVES\' | translate}}</span>&ndash;&gt;-->\n<!--                            </div>-->\n<!--                        </div>-->\n                    </uib-accordion-group>\n                </uib-accordion>\n            </div>\n            <div class="resumeTourContainer" style="left: 480px!important;">\n                <span class="ion-ios-information-outline" tagaste-click="rlstc.initTour()" style="cursor: pointer;"\n                      ng-hide="rlstc.selectu._id !== undefined"></span>\n            </div>\n            <div class="horizontal-scroll" ng-class="(rlstc.selectu._id) ? \'hideTableCounts\': \'\'">\n                <table ng-table="rlstc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true">\n\n                    <colgroup ng-if="!rlstc.selectu._id">\n                        <col width="3%">\n                        <col width="3%">\n                        <col width="27%">\n                        <col width="27%">\n                        <col width="27%">\n                        <col width="9%">\n                        <col width="3%">\n                        <col width="1%">\n                    </colgroup>\n                    <!-- expanded -->\n                    <colgroup ng-if="rlstc.selectu._id">\n                        <col width="7%">\n                        <col width="13%">\n                        <col width="65%">\n                        <col width="9%">\n                        <col width="3%">\n                        <col width="3%">\n                        <col width="3%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data |dummyDataIfEmpty:rlstc.tourDummyData |showErrorNoData track by $index"\n                        style="cursor: pointer;"\n                        tagaste-click="rlstc.tableParamsCK(row);$event.stopPropagation();"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td>\n                            <img class="photo-icon" check-avatar\n                                 ng-src="{{row.photo.thumb.signedUrl}}"\n                                 ng-if="!row.error"\n                                 style="max-width: 30px;border-radius:30px"/>\n                        </td>\n                        <td colspan="7" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.ROOM\'|translate"\n                            style="text-align: center;"\n                            sortable="\'room\'"\n                            filter="rlstc.filterRoom"\n                            ng-attr-title="{{row.room}}">\n                            {{row.room}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.NAMELASTNAME\'|translate"\n                            sortable="\'nameLastname\'"\n                            filter="rlstc.filterNameLastname"\n                            ng-if="rlstc.selectu._id"\n                            ng-attr-title="{{row.nameLastname}}">\n                            {{row.nameLastname}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.NAME\'|translate"\n                            sortable="\'name\'"\n                            filter="rlstc.filterName"\n                            ng-if="!rlstc.selectu._id"\n                            ng-attr-title="{{row.name}}">\n                            {{row.name}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.LASTNAME\'|translate"\n                            sortable="\'surname\'"\n                            filter="rlstc.filterLastname"\n                            ng-if="!rlstc.selectu._id"\n                            ng-attr-title="{{row.surname}}">\n                            {{row.surname}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.ALIAS\'|translate"\n                            sortable="\'nick\'"\n                            filter="rlstc.filterAlias"\n                            ng-if="!rlstc.selectu._id"\n                            ng-attr-title="{{row.nick}}">\n                            {{row.nick}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.RESIDENCE\'|translate"\n                            sortable="\'residenceDesc\'"\n                            filter="rlstc.filterResidenceDesc"\n                            ng-if="!rlstc.selectu._id && rlstc.constants.branch.length > 1"\n                            ng-attr-title="{{row.residenceDesc}}">\n                            {{row.residenceDesc}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.OLD_RESIDENT\'|translate"\n                            sortable="\'oldResident\'" ng-attr-title="{{row.oldResident}}"\n                            style="text-align: center">\n                            <i class="fa fa-check" ng-if="row.oldResident"></i>\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.DELEGATE\'|translate"\n                            style="text-align: center;"\n                            ng-if="!row.error"\n                            sortable="\'isDelegate\'">\n                            <!--{{row.delegateFloor}}-->\n                            <span class="ion-android-contact icuseronNgTable"\n                                  title="{{(row.isDelegate === true) ?\n                                   (\'RESIDENTSWINDOW.ISDELEGATETOOLTIP\' | translate) :\n                                   (\'RESIDENTSWINDOW.NOTDELEGATETOOLTIP\' | translate)}}"\n                                  ng-style="(row.isDelegate === true) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"></span>\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.ABSENT\'|translate"\n                            style="text-align: center;"\n                            ng-if="!row.error"\n                            sortable="\'isAway\'">\n                            <span class="fa ion-log-out icuseronNgTable"\n                                  title="{{(row.isAway === true) ?\n                                  (\'RESIDENTSWINDOW.ISABSENTTOOLTIP\' | translate) :\n                                  (\'RESIDENTSWINDOW.NOTRABSENTTOOLTIP\' | translate)}}"\n                                  ng-style="(row.isAway === true) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"></span>\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.RESIDENT\'|translate"\n                            style="text-align: center;"\n                            ng-if="!row.error"\n                            sortable="\'isResident\'">\n                            <span class="ion-android-home icuseronNgTable"\n                                  title="{{(row.isResident === true) ?\n                                  (\'RESIDENTSWINDOW.ISRESIDENTTOOLTIP\' | translate) :\n                                  (\'RESIDENTSWINDOW.NOTRESIDENTTOOLTIP\' | translate)}}"\n                                  ng-style="(row.isResident === true) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"></span>\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.APP\'|translate"\n                            sortable="\'tokenApp\'"\n                            ng-if="!row.error"\n                            class="text-center">\n                            <span class="fa fa-mobile iconNgTable" style="font-size:24px"\n                                  title="{{(row.tokenApp === true)?\n                                   (\'RESIDENTSWINDOW.INSTALLEDAPP\' | translate) :\n                                    (\'RESIDENTSWINDOW.NOTINSTALLEDAPP\' | translate)}}"\n                                  ng-style="(row.tokenApp === true) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"\n                            ></span>\n                        </td>\n                        <td ng-if="!rlstc.selectu._id && !row.error" class="text-center" style="white-space: nowrap;">\n                            <i class="fa fa-pencil iconNgTable edit" style="padding: 0 10px;"\n                               uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                               ng-if="rlstc.gotAccessMod"\n                               aria-hidden="true"\n                               tagaste-click="rlstc.editRow(row); $event.stopPropagation();">\n                            </i>\n                            <i class="fa fa-trash-o iconNgTable edit"\n                               uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                               ng-if="rlstc.gotAccessDel"\n                               aria-hidden="true"\n                               tagaste-click="rlstc.deleteRow(row); $event.stopPropagation();">\n                            </i>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!rlstc.selectu._id">\n                <div class="col-xs-12 countAndNewButton">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ rlstc.tableParams.total() }}</span></span>\n                    <button type="button"\n                            ng-if="rlstc.gotAccessMod"\n                            tagaste-click="rlstc.new();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton" id="newResidentButton">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                    <button type="button"\n                    tagaste-click="rlstc.exportData();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/rooms/roomsDetail/roomsDetail.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="ROOMS.ROOMDATA" ba-panel-class="with-scroll"\n            ba-panel-anim="zoom-in" style="line-height:30px;">\n           <form name="resForm" autocomplete="false">\n                <div class="row">\n                    <div class=" text-center avatarRoom"\n                        ng-class="\'col-md-4 col-xs-4\'"\n                        ng-style="{\'height\': \'auto\'}"\n                        style="padding: 0;  display: flex; justify-content: center; padding-left: 25px;\n                        box-sizing: border-box; align-items: center;">\n                        <avatar type="person" shape="square" avatar-style=""\n                            readonly="true" img="rodetc.avatar"\n                            photo="rodetc.room.photo" id="roomsDetailImg"></avatar>\n                    </div>\n                    <div class="pull-right" ng-class="\'col-md-8 col-xs-8\'">\n                        <div class="row">\n                            <!-- First row: Room -->\n                            <div class="input-group">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                        uib-tooltip="{{\'SERVICEMENUDETAIL.TEXT\' | translate}}"\n                                        tooltip-placement="right-top"\n                                        style="vertical-align: top;">\n                                    <span class="fa fa-bed"></span></span>\n                                    <textarea ng-model="rodetc.room.room" name="text"\n                                        class="form-control with-primary-addon"\n                                        aria-describedby="basic-addon1" ng-disabled="true"\n                                        placeholder="{{\'RESIDENTWINDOWDETAIL.OTHERCOMENTS\'|translate}}">\n                                    </textarea>\n                                </div>\n                        </div>\n                        <!-- Second row -->\n                        <div class="row">\n                            <div ng-class="\'col-md-3\'" style="padding-left:0">\n                                <div class="input-group">\n                                        <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.NAME\'| translate}}"\n                                                class="input-group-addon input-group-addon-primary addon-left"\n                                                id="residentDetailTooltip">\n                                            <span class="ion-android-person"></span></span>\n                                    <input type="text" name="name" ng-disabled="true"\n                                            class="form-control with-primary-addon "\n                                            placeholder="{{\'RESIDENTWINDOWDETAIL.NAME\'|translate}}"\n                                            ng-model="rodetc.room.name" required>\n                                </div>\n                            </div>\n                            <div ng-class="\'col-md-3\'" style="padding-left:0">\n                                <div class="input-group">\n                                    <input type="text" ng-disabled="true" name="surname"\n                                            class="form-control with-primary-addon"\n                                            placeholder="{{\'RESIDENTWINDOWDETAIL.LASTNAME\'|translate}}"\n                                            style="border-radius: 5px;"\n                                            ng-model="rodetc.room.surname">\n                                </div>\n                            </div>\n                            <div ng-class="\'col-md-3\'" style="padding-left:0">\n                                <div class="input-group">\n                                    <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'| translate}}"\n                                    class="input-group-addon input-group-addon-primary addon-left ">\n                                    <span class="ion-card"></span></span>\n                                    <input type="text" name="dni"\n                                        ng-disabled="true" class="form-control with-primary-addon"\n                                        placeholder="{{\'RESIDENTWINDOWDETAIL.IDENTIFICATION\'|translate}}"\n                                        ng-model="rodetc.room.identity.val">\n                                </div>\n                            </div>\n                            <div ng-class="\'col-md-3\'" style="padding-left:0">\n                                <div class="pull-right">\n                                    <button class="btn btn-success btn-with-icon"\n                                        type="button"\n                                        tagaste-click="rodetc.look()">\n                                        {{\'BUTTONS.LOOK\' |translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                        <!-- Third row -->\n                        <div class="row">\n                            <div class="col-md-12" style="margin-bottom: 15px;">\n                                <div class="pull-right">\n                                    <button\n                                        class="btn btn-success btn-with-icon"\n                                        type="button"\n                                        tagaste-click="rodetc.checkout()">\n                                       {{\'BUTTONS.CHECKOUT\' |translate}}\n                                    </button>\n                                </div>\n                            </div>\n                        </div>\n                        <!-- Fourth row -->\n                        <div class="row">\n                            <div class="col-md-6">\n                                <uib-accordion>\n                                    <uib-accordion-group panel-class="panel-primary accordion-panel"\n                                    is-open="rodetc.activetasksisopen">\n                                        <uib-accordion-heading>\n                                        {{\'ROOMS.ACTIVETASKS\' | translate}}\n                                        <i class="pull-right glyphicon"\n                                            ng-class="{\'glyphicon-chevron-down\': rodetc.contactinopen,\n                                            \'glyphicon-chevron-right\': !rodetc.contactinopen}"></i>\n                                        </uib-accordion-heading>\n                                        <div class="row">\n                                            <div ng-class="\'col-md-12\'">\n                                                <div class="input-group">\n                                                <span uib-tooltip="{{\'ROOMS.TASK\'| translate}}"\n                                                    tooltip-placement="right"\n                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                    <span class="ion-alert-circled"></span></span>\n                                                    <input type="text" ng-disabled="rodetc.readonly"\n                                                        class="form-control with-primary-addon"\n                                                        placeholder="{{\'ROOMS.TASK\'|translate}}"\n                                                        ng-model="rodetc.room.task1">\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div ng-class="\'col-md-12\'">\n                                                <div class="input-group">\n                                                <span uib-tooltip="{{\'ROOMS.TASK\'| translate}}"\n                                                    class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-alert-circled"></span>\n                                                </span>\n                                                <input type="text" ng-disabled="rodetc.readonly"\n                                                    class="form-control with-primary-addon"\n                                                    placeholder="{{\'ROOMS.TASK\'|translate}}"\n                                                    ng-model="rodetc.room.task2">\n                                                </div>\n                                            </div>\n                                        </div>\n                                        <div class="row">\n                                            <div ng-class="\'col-md-6 col-md-offset-5\'">\n                                                <button type="button" style="position: relative;  margin-top: 15px;  margin-bottom: 15px; font-size: 12px;"\n                                                    ng-click="rodetc.clean()" class="btn btn-success btn-with-icon ">\n                                                    <i class="ion-android-checkbox-outline"></i>{{\'BUTTONS.TOCLEAN\' |translate}}\n                                                </button>\n                                            </div>\n                                        </div>\n                                    </uib-accordion-group>\n                                </uib-accordion>\n                            </div>\n                            <div class="col-md-6">\n                                <uib-accordion>\n                                    <uib-accordion-group panel-class="panel-primary accordion-panel"\n                                    style="overflow-x: hidden; overflow-y: hidden;"\n                                    is-open="rodetc.incidentsisopen">\n                                <uib-accordion-heading>\n                                    {{\'ROOMS.INCIDENTS\' | translate}}\n                                    <i class="pull-right glyphicon"\n                                    ng-class="{\'glyphicon-chevron-down\': rodetc.admonitionopen, \'glyphicon-chevron-right\': !rodetc.admonitionopen}"></i>\n                                </uib-accordion-heading>\n                                <div class="input-group"  style="overflow-y: hidden;">\n                                    <div class="row">\n                                        <div ng-class="\'col-xs-12\'">\n                                            <table ng-table="rodetc.tableIncidents"\n                                                class="table table-hover table-condensed"\n                                                show-filter="false"\n                                                style="margin-left: -10px; font-size: 11px;">\n                                                <colgroup>\n                                                    <col width="100%">\n                                                </colgroup>\n                                                <tr ng-repeat="row in $data track by $index" style="cursor:pointer;"\n                                                    class="ng-binding">\n                                                    {{row}}\n                                                    <td>\n                                                        {{row.comment}}\n                                                    </td>\n                                                </tr>\n                                            </table>\n                                        </div>\n                                    </div>\n                                </div>\n                                </uib-accordion-group>\n                            </uib-accordion>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>\n\n');
$templateCache.put('app/components/rooms/roomsList/roomsList.html','<div>\n    <room-schedule model="rolc.model" on-change="rolc.dayChanged(day)"></room-schedule>\n</div>\n');
$templateCache.put('app/components/tasks/taskDetail/taskDetail.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel task-detail-panel">\n        <div ba-panel ba-panel-class="with-scroll" ba-panel-anim="zoom-in" style="line-height:30px;" id="taskDetail"\n             ba-panel-title-no-translate="{{(tdc.modeReadOnly ? \'TASKS.TASKDETAIL.HEADER_DETAIL\':\'TASKS.TASKDETAIL.HEADER_NEW\') | translate}}">\n\n            <form name="taskForm">\n                <div class="row">\n                    <div class="col-xs-12" ng-class="tdc.modeCreation ? \'col-md-12\' : \'col-md-6\'">\n                        <div class="row" ng-if="!tdc.hideSelectResidence">\n                            <div class="col-xs-12">\n                                <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'TASKS.TASKDETAIL.RESIDENCE\' | translate}}"\n                                          tooltip-placement="bottom-left" id="idTooltipPlacement">\n                                        <span class="ion-card"></span>\n                                    </span>\n                                    <ui-select\n                                        name="locality"\n                                        ng-change="tdc.changeLocality()"\n                                        ng-disabled="tdc.modeReadOnly || tdc.disableLocality"\n                                        required="true"\n                                        ng-class="{\'noValid\': (taskForm.locality.$touched || tdc.submitted) && !tdc.readonly && !taskForm.locality.$valid}"\n                                        ng-model="tdc.task.branch"\n                                        class="btn-group bootstrap-select form-control"\n                                        append-to-body="true"\n                                        search-enabled="true">\n                                        <ui-select-match placeholder="{{\'TASKS.TASKDETAIL.RESIDENCE\'| translate}}" style="min-width: 117px;">\n                                            {{tdc.task.branch.description}}\n                                        </ui-select-match>\n                                        <ui-select-choices\n                                            repeat="branch in tdc.localities | findResidence: {alredy:tdc.task.branch, find:$select.search}">\n                                            <span ng-bind-html="branch.description | highlight: $select.search"></span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                                <div class="errorValidation bounceIn animate"\n                                     ng-if="(taskForm.locality.$touched || tdc.submitted) && !tdc.modeReadOnly && !taskForm.locality.$valid">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="input-group" id="spotInput">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'TASKS.TASKDETAIL.ROOM\' | translate}}"\n                                          tooltip-placement="bottom-left" id="idTooltipSpot">\n                                        <span class="ion-ios-location-outline"></span>\n                                    </span>\n                                    <ui-select\n                                        name="spot"\n                                        ng-disabled="tdc.modeReadOnly || !tdc.task.branch"\n                                        required="true"\n                                        ng-class="{\'noValid\': (taskForm.spot.$touched || tdc.submitted) && !tdc.readonly && !taskForm.spot.$valid}"\n                                        ng-model="tdc.task.spot"\n                                        class="btn-group bootstrap-select form-control"\n                                        append-to-body="true"\n                                        search-enabled="true">\n                                        <ui-select-match placeholder="{{\'TASKS.TASKDETAIL.ROOM\'| translate}}" style="min-width: 117px;">\n                                            {{tdc.task.spot.description}}\n                                        </ui-select-match>\n                                        <ui-select-choices\n                                            repeat="spot in tdc.listSpots | findResidence: {alredy:tdc.task.spot, find:$select.search}">\n                                            <span ng-bind-html="spot.description | highlight: $select.search"></span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                                <div class="errorValidation bounceIn animate"\n                                     ng-if="(taskForm.spot.$touched || tdc.submitted) && !tdc.modeReadOnly && !taskForm.spot.$valid">\n                                    {{\'ERROR.NOTVALIDINPUT\' | translate}}\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <date-picker-comp tooltip-text="\'TASKS.TASKDETAIL.DATE\' | translate"\n                                                  tooltip-placement="bottom-left" date-value="tdc.task.createdDate" is-required="true"\n                                                  mode-read-only="(tdc.disabledFields || tdc.modeReadOnly)"\n                                                  date-options="tdc.dateOptions" show-required-error="tdc.showError"\n                                                  form-reference="taskForm" special-validation="tdc.checkDates()"\n                                                  name-field="\'createdDate\'" msg-special-validation="\'INCIDENTDETAIL.MSGSPECIALVALIDATIONBEFORE\'">\n                                </date-picker-comp>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="input-group"\n                                     ng-style="{\'margin-bottom\': (taskForm.taskType.$touched || tdc.submitted) && !tdc.modeReadOnly && !taskForm.taskType.$valid ? \'0\':\'15px\'}">\n                                    <span class="input-group-addon input-group-addon-primary addon-left">\n                                        <span class="fa fa-list" tooltip-placement="top-left"\n                                              uib-tooltip="{{\'TASKS.TASKDETAIL.TYPE\' | translate}}"></span>\n                                    </span>\n                                    <ui-select ng-model="tdc.task.taskType"\n                                               style="-webkit-border-radius:0; -moz-border-radius:0; border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control"\n                                               ng-class="{noValid: (taskForm.taskType.$touched || tdc.submitted) && !tdc.readonly && !taskForm.taskType.$valid}"\n                                               ng-disabled="(tdc.disabledFields || tdc.modeReadOnly)"\n                                               ng-required="true" name="taskType"\n                                               append-to-body="true"\n                                               search-enabled="true">\n                                        <ui-select-match placeholder="{{\'TASKS.TASKDETAIL.TYPE\'| translate}}">\n                                            <span> {{tdc.task.taskType.description}}</span>\n                                        </ui-select-match>\n                                        <ui-select-choices\n                                            repeat="option in tdc.listTaskType | uiSelectFilter: {description:$select.search}">\n                                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                                <span\n                                    ng-show="(taskForm.taskType.$touched || tdc.submitted) && !tdc.modeReadOnly && !taskForm.taskType.$valid"\n                                    class="msgError">\n                                            {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="row">\n                                    <div class="col-xs-12">\n                                        <div class="input-group">\n                                            <span class="input-group-addon input-group-addon-primary addon-left">\n                                                <span class="ion-compose" tooltip-placement="bottom-left" tooltip-append-to-body="true"\n                                                      uib-tooltip="{{\'TASKS.TASKDETAIL.NEWCOMMENT\' | translate}}">\n                                                </span>\n                                            </span>\n                                            <input type="text" class="form-control with-primary-addon"\n                                                   placeholder="{{\'TASKS.TASKDETAIL.NEWCOMMENT\'|translate}}" tooltip-append-to-body="true"\n                                                   aria-describedby="basic-addon1" ng-model="tdc.newComment">\n                                        </div>\n                                    </div>\n                                </div>\n                                <div class="row" ng-if="tdc.modeReadOnly">\n                                    <div class="col-xs-12">\n                                        <div class="input-group">\n                                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                                  uib-tooltip="{{\'TASKS.TASKDETAIL.COMMENTS\' | translate}}" tooltip-append-to-body="true"\n                                                  tooltip-placement="right-top" style="vertical-align: top;">\n                                                <span class="ion-android-list"></span>\n                                            </span>\n                                            <div style="border: 1px solid rgb(55, 55, 55);">\n                                                <div style="max-height: 200px; min-height: 135px; overflow-y: auto;"\n                                                     ng-style="tdc.task.comments.length > 1 ? {\'overflow\' : \'auto\'}:\'\'">\n                                                    <div ng-repeat="item in tdc.task.comments track by $index">\n                                                        <div class="tag-cards">\n                                                            <div style="padding-left: 10px; line-height: 18px;">\n                                                                {{item.text}}\n                                                            </div>\n                                                        </div>\n                                                    </div>\n                                                </div>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="col-xs-12" ng-class="tdc.modeCreation ? \'col-md-12\' : \'col-md-6\'" ng-if="!tdc.modeCreation">\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'TASKS.TASKDETAIL.WORKER\' | translate}}"\n                                          tooltip-placement="bottom-left">\n                                        <span class="ion-android-person"></span>\n                                    </span>\n                                    <ui-select ng-model="tdc.selectedWorker"\n                                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                               class="btn-group bootstrap-select form-control"\n                                               search-enabled="true">\n                                        <ui-select-match\n                                            allow-clear=true\n                                            placeholder="{{\'TASKS.TASKDETAIL.WORKER\' | translate}}">\n                                            {{tdc.selectedWorker.fullName}}\n                                        </ui-select-match>\n                                        <ui-select-choices repeat="option in tdc.workers ">\n                                            <div ng-bind-html="option.fullName | highlight: $select.search"></div>\n                                        </ui-select-choices>\n                                    </ui-select>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12 status-reopened">\n                                <div class="task-status">\n                                    <div class="col-sm-8 col-xs-12 incidents-tracking" ng-if="tdc.statusTypes">\n                                        <label ng-repeat="st in tdc.statusTypes track by $index"\n                                               ng-class="tdc.task.status.code >= st.code ? \'radioActive\': \'radioWhite\'">\n                                            <input type="radio" ng-model="tdc.tracking.status._id" ng-value="st._id" style="display: none"/>\n                                            <i class="{{st.icon}}" ng-class="tdc.task.status.code >= st.code ? \'radioActive\': \'radioWhite\'"\n                                               uib-tooltip="{{st.description}}"></i>\n                                        </label>\n                                    </div>\n                                </div>\n                                <div class="reopened-switch">\n                                    <ba-switcher switcher-style="primary" switcher-value="tdc.task.isReopened"\n                                                 switcher-icon-on="\'ion-ios-refresh-outline\'" switcher-icon-off="\'ion-ios-refresh-outline\'"\n                                                 switcher-read-only="true"\n                                                 uib-tooltip="{{\'TASKS.TASKDETAIL.REOPENED\' | translate}}"\n                                                 tooltip-placement="bottom-left">\n                                    </ba-switcher>\n                                </div>\n                            </div>\n                        </div>\n\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="accordionSubTitle">\n                                    <div class="accordionSubTitleText">{{\'TASKS.TASKDETAIL.PERIODS\' | translate }}</div>\n                                    <div class="accordionSubTitleBorder"></div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <table ng-table="tdc.tableParamsPeriods"\n                                       class="table table-hover table-condensed fixNgTable" show-filter="false"\n                                       style="font-size: 11px;">\n\n                                    <colgroup>\n                                        <col width="50%">\n                                        <col width="50%">\n                                    </colgroup>\n\n                                    <tr ng-repeat="row in $data track by $index" style="cursor:pointer;" class="ng-binding">\n                                        {{row}}\n                                        <td data-title="\'TASKS.TASKDETAIL.IN\'|translate"\n                                            sortable="\'dateFrom\'" ng-attr-title="{{row.dateFrom}}">\n                                            {{row.dateFrom | date:\'MM/dd/yyyy\'}}\n                                        </td>\n                                        <td data-title="\'TASKS.TASKDETAIL.OUT\'|translate"\n                                            sortable="\'dateTo\'" ng-attr-title="{{row.dateTo}}">\n                                            {{row.dateTo | date:\'MM/dd/yyyy\'}}\n                                        </td>\n                                    </tr>\n                                </table>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="accordionSubTitle">\n                                    <div class="accordionSubTitleText">{{\'TASKS.TASKDETAIL.ACTIONS\' | translate}}</div>\n                                    <div class="accordionSubTitleBorder"></div>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div ng-repeat="tsk in tdc.task.actions">\n                                    <label class="custom-checkbox">\n                                        <input type="checkbox" ng-model="tsk.done" disabled>\n                                        <span>{{tsk.name}}</span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="row">\n                            <div class="col-xs-12">\n                                <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                          uib-tooltip="{{\'TASKS.TASKDETAIL.ATTACHEDS\' | translate}}"\n                                          tooltip-placement="right-top" style="vertical-align: top">\n                                        <span class="ion-camera"></span>\n                                    </span>\n                                    <div style="border: 1px solid rgb(55, 55, 55);" id="incidentAttacheds" class="tagast-files">\n                                        <div style="overflow-x: hidden; overflow-y:hidden;" scroll-glue-right="!glued;" class="file-list">\n                                            <div class="img-card-row" ng-repeat="attached in tdc.task.attacheds track by $index"\n                                                 ng-if="tdc.task.attacheds.length > 0">\n                                                <card-file\n                                                    attached="attached" readonly="true" uploading="false"\n                                                    max-long-name="8">\n                                                </card-file>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </form>\n\n            <div class="row panel-footer-buttons">\n                <div class="col-xs-12">\n                    <div class="pull-right" style="margin-right: 10px;">\n                        <button id="taskCancelButton" type="button" ng-click="tdc.cancel()" class="btn btn-success btn-with-icon">\n                            <i class="ion-arrow-left-c"></i>{{(tdc.modeReadOnly ? \'BUTTONS.BACK\' : \'BUTTONS.CANCEL\') | translate}}\n                        </button>\n                        <button id="taskSaveButton" type="button" ng-click="tdc.saveTask(taskForm)"\n                                class="btn btn-success btn-with-icon">\n                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/tasks/taskSchedulerList/taskSchedulerList.html','<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="{{\'TASKS.TASK_SCHEDULER_LIST.HEADER\'|translate}}" ba-panel-class="with-scroll"\n             id="taskSchedulerList">\n            <span class="horizontal-scroll"\n                  ng-class="(tsl.showTaskSchedulerView || tsl.showTaskView) ? \'hideTableCounts\': \'\'">\n                <table ng-table="tsl.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true" style="cursor: pointer">\n\n                    <colgroup ng-if="tsl.showTaskSchedulerView || tsl.showTaskView">\n                        <col width="35%">\n                        <col width="65%">\n                    </colgroup>\n\n                    <colgroup\n                        ng-if="((!tsl.showTaskSchedulerView && !tsl.showTaskView) && (tsl.userBranch.length == 1))">\n                        <col width="45%">\n                        <col width="45%">\n                        <col width="10%">\n                    </colgroup>\n\n                    <colgroup ng-if="(!tsl.showTaskSchedulerView && !tsl.showTaskView) && (tsl.userBranch.length > 1)">\n                        <col width="10%">\n                        <col width="40%">\n                        <col width="40%">\n                        <col width="10%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data  |dummyDataIfEmpty:tsl.tourDummyData |showErrorNoData track by $index"\n                        ng-click="tsl.tableParamsCK(row)"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td colspan="4" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'TASKS.TASK_SCHEDULER_LIST.LOCALITY\'|translate"\n                            sortable="\'locality\'"\n                            filter="tsl.filterLocality"\n                            ng-if="(!tsl.showTaskSchedulerView && !tsl.showTaskView) && tsl.userBranch.length > 1 && !row.error"\n                            ng-attr-title="{{row.locality}}">\n                            {{row.locality}}\n                        </td>\n                        <td data-title="\'TASKS.TASK_SCHEDULER_LIST.NAME\'|translate" ng-if="!row.error"\n                            sortable="\'name\'"\n                            filter="tsl.filterName"\n                            ng-attr-title="{{row.name}}">\n                            {{row.name}}\n                        </td>\n                        <td data-title="\'TASKS.TASK_SCHEDULER_LIST.TIME_SCHEDULE\'|translate" ng-if="!row.error"\n                            style="word-break: break-all;">\n                            <span ng-repeat="day in row.isoWeekDay"><span class="taskSchedulerTag"\n                                                                          uib-tooltip="{{day.momentOfDay}}">{{day.day}}</span></span>\n                        </td>\n                        <td ng-if="!tsl.showTaskSchedulerView && !tsl.showTaskView && !row.error">\n                            <span class="fa fa-pencil iconNgTable edit" ng-if="tsl.gotAccessCreate"\n                                  uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                  ng-click="tsl.editRow(row); $event.stopPropagation();"></span>\n                            <span class="fa fa-trash-o iconNgTable edit"\n                                  ng-if="tsl.gotAccessDel"\n                                  uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                  style="margin-left: 10px;"\n                                  ng-click="$event.stopPropagation();tsl.deleteRow(row);"></span>\n                        </td>\n                    </tr>\n                </table>\n            </span>\n        </div>\n        <div class="row" ng-if="!tsl.showTaskSchedulerView && !tsl.showTaskView">\n            <div class="col-xs-12 countAndNewButton" style="display: flex; align-items: center;">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ tsl.tableParams.total() }}</span></span>\n                <button ng-click="tsl.newTaskScheduler()"\n                        ng-if="tsl.gotAccessCreate"\n                        type="button" class="btn btn-success btn-with-icon pull-right newButton"\n                        ng-disabled="tls.istour"\n                        id="newIncidentButton">\n                    <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                </button>               \n            </div>\n        </div>\n    </div>\n</div>\n</div>');
$templateCache.put('app/components/tasks/taskSchedulerDetail/taskSchedulerDetail.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel detail-panel">\n        <div ba-panel ba-panel-class="with-scroll"\n             ba-panel-title-no-translate="{{(tsd.modeReadOnly ? \'TASKS.TASK_SCHEDULER_DETAIL.HEADER\':\n             tsd.modeEdit ? \'TASKS.TASK_SCHEDULER_DETAIL.HEADER_EDIT\' : \'TASKS.TASK_SCHEDULER_DETAIL.HEADER_NEW\') | translate}}"\n             ba-panel-anim="zoom-in" style="line-height:30px;" id="taskSchedulerDetail">\n            <form name="taskSchedulerForm" style="margin-bottom: 15px">\n                <!-- Branch residence -->\n                <div class="row">\n                    <div class="col-sm-8" ng-if="!tsd.hideSelectResidence">\n                        <div class="input-group" ng-style="(taskSchedulerForm.branch.$touched &&\n                taskSchedulerForm.branch.$invalid || taskSchedulerForm.branch.$error.required && tsd.showError) ?\n                {\'margin-bottom\': 0}:\'\'">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'TASKS.TASK_SCHEDULER_DETAIL.LOCALITY\' | translate}}"\n                                  tooltip-placement="bottom-left">\n                            <span class="ion-card"></span>\n                            </span>\n                            <ui-select ng-model="tsd.taskScheduler.branch" ng-change="tsd.changeLocality();"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       ng-disabled="tsd.disabledFields || tsd.modeReadOnly " append-to-body="true"\n                                       ng-required="true" name="branch"\n                                       ng-class="{noValid: taskSchedulerForm.branch.$touched && taskSchedulerForm.branch.$invalid || taskSchedulerForm.branch.$error.required && tsd.showError}"\n                                       search-enabled="true">\n                                <ui-select-match placeholder="{{\'TASKS.TASK_SCHEDULER_DETAIL.LOCALITY\'| translate}}">\n                                    <span> {{tsd.taskScheduler.branch.description}}</span>\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in tsd.localities |\n                uiSelectFilter: {description:$select.search}">\n                                    <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <span ng-show="taskSchedulerForm.branch.$touched && taskSchedulerForm.branch.$invalid ||\n                taskSchedulerForm.branch.$error.required && tsd.showError" class="msgError">\n                {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-sm-12">\n                        <div class="input-group" id="taskSchedulerName" ng-style="(taskSchedulerForm.name.$touched && taskSchedulerForm.name.$invalid ||\n                                         taskSchedulerForm.name.$error.required && tsd.showError) ?\n                                         {\'margin-bottom\': 0}:\'\'">\n                            <span class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-compose" tooltip-placement="top-left"\n                                  uib-tooltip="{{\'TASKS.TASK_SCHEDULER_DETAIL.NAME\' | translate}}"></span></span>\n                            <input type="text" ng-readonly="tsd.disabledFields || tsd.modeReadOnly"\n                                   class="form-control with-primary-addon"\n                                   name="name"\n                                   ng-class="{noValid: taskSchedulerForm.name.$touched && taskSchedulerForm.name.$invalid || taskSchedulerForm.name.$error.required && tsd.showError}"\n                                   placeholder="{{\'TASKS.TASK_SCHEDULER_DETAIL.NAME\'|translate}}" ng-required="true"\n                                   aria-describedby="basic-addon1" ng-model="tsd.taskScheduler.name">\n                        </div>\n                        <span ng-show="taskSchedulerForm.name.$touched && taskSchedulerForm.name.$invalid ||\n                             taskSchedulerForm.name.$error.required && tsd.showError" class="msgError">\n                             {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-sm-12">\n                        <div class="input-group"\n                             ng-style="(taskSchedulerForm.spot.$touched && taskSchedulerForm.spot.$invalid ||\n                                         taskSchedulerForm.spot.$error.required && tsd.showError) ?\n                                         {\'margin-bottom\': 0}:\'\'">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'TASKS.TASK_SCHEDULER_DETAIL.SPOT\' | translate}}"\n                                  tooltip-placement="top-left">\n                                <span class="ion-ios-location-outline"></span>\n                            </span>\n                            <ui-select multiple ng-model="tsd.taskScheduler.spots"\n                                       ng-disabled="tsd.disabledFields || tsd.modeReadOnly || !tsd.taskScheduler.branch"\n                                       append-to-body="true"\n                                       ng-required="true" name="spot"\n                                       ng-class="{noValid: taskSchedulerForm.spot.$touched && taskSchedulerForm.spot.$invalid || taskSchedulerForm.spot.$error.required && tsd.showError}"\n                                       search-enabled="true">\n                                <ui-select-match allow-clear=true\n                                                 placeholder="{{\'TASKS.TASK_SCHEDULER_DETAIL.SPOT\'|translate}}">\n                                    <span>{{$item.description}}</span>\n                                </ui-select-match>\n                                <ui-select-choices\n                                    repeat="option as option in tsd.listSpots |\n                                                uiSelectFilter: {description:$select.search}">\n                                    <div\n                                        ng-bind-html="option.description | highlight: $select.search"></div>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <span ng-show="taskSchedulerForm.spot.$touched && taskSchedulerForm.spot.$invalid ||\n                                taskSchedulerForm.spot.$error.required && tsd.showError" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                </div>\n                <!--task dates (from/to)-->\n                <div class="row">\n                    <div class="col-xs-6">\n                        <date-picker-comp tooltip-text="\'TASKS.TASK_SCHEDULER_DETAIL.DATE_FROM\' | translate"\n                                          tooltip-placement="bottom-left" date-value="tsd.taskScheduler.dateFrom" is-required="true"\n                                          mode-read-only="(tsd.disabledFields || tsd.modeReadOnly)"\n                                          date-options="tsd.dateOptions" show-required-error="tsd.showError"\n                                          form-reference="taskSchedulerForm" special-validation="tsd.checkDateFrom()"\n                                          name-field="\'dateFrom\'" msg-special-validation="\'INCIDENTDETAIL.MSGSPECIALVALIDATIONSDATES\'">\n                        </date-picker-comp>\n                    </div>\n                    <div class="col-xs-6">\n                        <date-picker-comp tooltip-text="\'TASKS.TASK_SCHEDULER_DETAIL.DATE_TO\' | translate"\n                                          tooltip-placement="bottom-left" date-value="tsd.taskScheduler.dateTo"\n                                          mode-read-only="(tsd.disabledFields || tsd.modeReadOnly)"\n                                          date-options="tsd.dateOptions" show-required-error="tsd.showError"\n                                          form-reference="taskSchedulerForm" special-validation="tsd.checkDateTo()"\n                                          name-field="\'dateTo\'" msg-special-validation="\'INCIDENTDETAIL.MSGSPECIALVALIDATIONSDATES\'">\n                        </date-picker-comp>\n                    </div>\n                </div>\n                <!--task excluded dates ranges-->\n                <div class="row">\n                    <div class="col-md-12">\n                        <uib-accordion>\n                            <uib-accordion-group\n                                heading="{{\'TASKS.TASK_SCHEDULER_DETAIL.DATES_NO_TASK\' | translate}}"\n                                is-open="tsd.rangesopen"\n                                style="overflow-x: hidden; overflow-y: hidden;"\n                                panel-class="panel-primary accordion-panel">\n                                <uib-accordion-heading>\n                                    {{\'TASKS.TASK_SCHEDULER_DETAIL.DATES_NO_TASK\' | translate}}\n                                    <i class="pull-right glyphicon"\n                                       ng-class="{\'glyphicon-chevron-down\': tsd.rangesopen,\n                                            \'glyphicon-chevron-right\': !tsd.rangesopen}"></i>\n                                </uib-accordion-heading>\n                                <div class="input-group">\n                                    <div class="row">\n                                        <div class="col-xs-12">\n                                            <button type="button"\n                                                    ng-if="!tsd.readonly && !tsd.addingRange"\n                                                    tagaste-click="tsd.addRange();$event.stopPropagation();"\n                                                    class="btn btn-success btn-with-icon pull-right newButton" id="newRangeButton">\n                                                <i class="fa fa-plus"></i>{{\'BUTTONS.NEW_RANGE\' | translate}}\n                                            </button>\n                                        </div>\n                                    </div>\n                                    <div class="row">\n                                        <div class="col-xs-12">\n                                            <table ng-table="tsd.rangesTableParams"\n                                                   class="table table-hover table-condensed fixNgTable" show-filter="false"\n                                                   style="font-size: 11px;">\n                                                <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                                                    class="ng-binding">\n                                                    <!--dateFrom-->\n                                                    <td data-title="\'TASKS.TASK_SCHEDULER_DETAIL.DATE_FROM\'|translate"\n                                                        sortable="\'dateFrom\'" ng-attr-title="{{row.dateFrom}}">\n                                                        <input type="text"\n                                                               class="form-control"\n                                                               uib-datepicker-popup="dd/MM/yyyy"\n                                                               ng-required="true"\n                                                               style="border-radius: 0;"\n                                                               id="dateFromPicker"\n                                                               ng-click="row.dateFromPicker.isOpen = true"\n                                                               ng-model="row.dateFrom"\n                                                               is-open="row.dateFromPicker.isOpen"\n                                                               ng-disabled="!row.modeEdit"\n                                                               datepicker-append-to-body="true"\n                                                               close-text="{{\'DATEPICKER.BUTTON.CLOSE\'| translate}}"\n                                                               clear-text="{{\'DATEPICKER.BUTTON.CLEAR\'| translate}}"\n                                                               current-text="{{\'DATEPICKER.BUTTON.TODAY\'| translate}}">\n                                                    </td>\n                                                    <!--dateTo-->\n                                                    <td data-title="\'TASKS.TASK_SCHEDULER_DETAIL.DATE_TO\'|translate"\n                                                        sortable="\'dateTo\'" ng-attr-title="{{row.dateTo}}">\n                                                        <input type="text"\n                                                               class="form-control"\n                                                               uib-datepicker-popup="dd/MM/yyyy"\n                                                               ng-required="true"\n                                                               style="border-radius: 0;"\n                                                               id="dateToPicker"\n                                                               ng-click="row.dateToPicker.isOpen = true"\n                                                               ng-model="row.dateTo"\n                                                               is-open="row.dateToPicker.isOpen"\n                                                               ng-disabled="!row.modeEdit"\n                                                               datepicker-append-to-body="true"\n                                                               close-text="{{\'DATEPICKER.BUTTON.CLOSE\'| translate}}"\n                                                               clear-text="{{\'DATEPICKER.BUTTON.CLEAR\'| translate}}"\n                                                               current-text="{{\'DATEPICKER.BUTTON.TODAY\'| translate}}">\n                                                    </td>\n                                                    <!--buttons-->\n                                                    <td ng-if="!tsd.readonly && !row.modeEdit" style="width: 20px;">\n                                                        <i class="fa fa-pencil iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                                           ng-if="!row.modeEdit && !tsd.addingRange && !row.error" aria-hidden="true"\n                                                           tagaste-click="tsd.editRange(row, $index); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                    <td ng-if="!tsd.readonly && !row.modeEdit" style="width: 20px;">\n                                                        <i class="fa fa-trash-o iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                                           ng-if="!row.modeEdit && !tsd.addingRange && !row.error" aria-hidden="true"\n                                                           tagaste-click="tsd.deleteRange(row, $index); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                    <td ng-if="!tsd.readonly && row.modeEdit" style="width: 20px;">\n                                                        <i class="glyphicon glyphicon-ok iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                                                           ng-if="row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="tsd.saveRange(row, $index); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                    <td ng-if="!tsd.readonly && row.modeEdit" style="width: 20px;">\n                                                        <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                                                           uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                                                           ng-if="row.modeEdit" aria-hidden="true"\n                                                           tagaste-click="tsd.cancelRange(row, $index); $event.stopPropagation();">\n                                                        </i>\n                                                    </td>\n                                                </tr>\n                                            </table>\n                                        </div>\n                                    </div>\n                                </div>\n                            </uib-accordion-group>\n                        </uib-accordion>\n                    </div>\n                </div>\n                <!--comments-->\n                <div class="row">\n                    <div class="col-sm-12">\n                        <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'TASKS.TASK_SCHEDULER_DETAIL.DESCRIPTION\' | translate}}"\n                                  tooltip-placement="top-left"\n                                  style="vertical-align: top">\n                                <span class="ion-compose"></span>\n                            </span>\n                            <textarea type="text" ng-readonly="tsd.disabledFields || tsd.modeReadOnly"\n                                      class="form-control with-primary-addon"\n                                      placeholder="{{\'TASKS.TASK_SCHEDULER_DETAIL.DESCRIPTION\'|translate}}"\n                                      aria-describedby="basic-addon1" ng-model="tsd.taskScheduler.comment"\n                                      name="description"></textarea>\n                        </div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-sm-3">\n                        <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left">\n                        <span class="fa fa-list" tooltip-placement="top-left"\n                              uib-tooltip="{{\'TASKS.TASK_SCHEDULER_DETAIL.TASK_TYPE\' | translate}}"></span></span>\n                            <ui-select ng-model="tsd.taskScheduler.taskType"\n                                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                       class="btn-group bootstrap-select form-control"\n                                       ng-disabled="tsd.disabledFields || tsd.modeReadOnly"\n                                       append-to-body="true"\n                                       ng-required="true" name="taskType"\n                                       ng-class="{noValid: taskSchedulerForm.taskType.$touched && taskSchedulerForm.taskType.$invalid || taskSchedulerForm.taskType.$error.required && tsd.showError}"\n                                       search-enabled="true">\n                                <ui-select-match placeholder="{{\'TASKS.TASK_SCHEDULER_DETAIL.TASK_TYPE\'| translate}}">\n                                    <span> {{tsd.taskScheduler.taskType.description}}</span>\n                                </ui-select-match>\n                                <ui-select-choices repeat="option in tsd.listTaskType |\n                        uiSelectFilter: {description:$select.search}">\n                                    <span ng-bind-html="option.description | highlight: $select.search"></span>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                        <span\n                            ng-show="taskSchedulerForm.taskType.$touched && taskSchedulerForm.taskType.$invalid || taskSchedulerForm.taskType.$error.required && tsd.showError"\n                            class="msgError">\n                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                    <div class="col-sm-6 col-sm-offset-3">\n                        <div task-time-table="" data-slots="tsd.slots"\n                             data-disabled="(tsd.disabledFields || tsd.istour || tsd.modeReadOnly )"></div>\n                        <span ng-show="tsd.showTimetableError" class="msgError">\n                                        {{\'VALIDATION.OBLIGATORYFIELD\' | translate}}</span>\n                    </div>\n                </div>\n            </form>\n            <div class="row panel-footer-buttons">\n                <div class="col-xs-12">\n                    <div class="pull-right" style="margin-right: 10px;">\n                        <button id="taskSchedulerCancelButton" type="button" ng-click="tsd.cancel()"\n                                class="btn btn-success btn-with-icon" ng-disabled="tsd.istour">\n                            <i class="ion-arrow-left-c"></i>{{tsd.modeReadOnly ? \'BUTTONS.BACK\' : \'BUTTONS.CANCEL\'\n                            | translate}}\n                        </button>\n                        <button id="taskSchedulerSaveButton" type="button"\n                                ng-click="tsd.saveTaskScheduler(taskSchedulerForm)"\n                                ng-if="(tsd.modeEdit || tsd.modeCreation) && tsd.gotAccessCreate"\n                                class="btn btn-success btn-with-icon" ng-disabled="tsd.istour">\n                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                        </button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/masterTables/masterTablesConfig/masterTablesConfig.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mtcc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                class="ng-binding">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--description-->\n                <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                    sortable="\'description\'" ng-attr-title="{{row.description}}">\n                    <span ng-if="!row.modeEdit">{{row.description}}</span>\n                    <input type="text" ng-model="row.description" name="description_{{$index +1}}"\n                           class="form-control with-primary-addon" id="description_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!--code-->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'code\'" ng-attr-title="{{row.code}}">\n                    <span ng-if="!row.modeEdit">{{row.code}}</span>\n                    <input type="text" ng-model="row.code" name="code_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="code_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--quantity-->\n                <td data-title="\'MASTERTABLES.CONFIG.NUM_VALUE\'|translate"\n                    sortable="\'numericValue\'" ng-attr-title="{{row.numericValue}}" ng-if="mtcc.numericValueCol">\n                    <span ng-if="!row.modeEdit">{{row.numericValue}}</span>\n                    <input type="number" ng-model="row.numericValue" name="numericValue_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="numericValue_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--branch-->\n                <td data-title="\'MASTERTABLES.CONFIG.BRANCH\'|translate"\n                    sortable="\'branch\'" ng-attr-title="{{row.branch}}" ng-if="mtcc.branchCol && !mtcc.multipleBranch">\n                    <span ng-if="!row.modeEdit">{{row.branch ? row.branch.description : \'\'}}</span>\n                    <ui-select ng-model="row.branch" ng-if="row.modeEdit" id="branch_{{$index +1}}"\n                               name="branch_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.BRANCH\'| translate}}">\n                            <span> {{row.branch.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtcc.constants.branches |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--branches-->\n                <td data-title="\'MASTERTABLES.CONFIG.BRANCHES\'|translate" ng-if="mtcc.multipleBranch">\n                    <span ng-if="!row.modeEdit" ng-repeat="branch in row.branches" class="masterTableTag">{{branch.description}}</span>\n                    <ui-select multiple ng-model="row.branches" ng-if="row.modeEdit" id="branches_{{$index +1}}"\n                               name="branches_{{$index +1}}"\n                               style="-webkit-border-radius:0; -moz-border-radius:0; border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               close-on-select="false" append-to-body="false"\n                               ng-change="mtcc.branchSelection(row)">\n                        <ui-select-match allow-clear=true placeholder="{{\'MASTERTABLES.CONFIG.BRANCHES\'|translate}}">\n                            {{$item.description}}\n                        </ui-select-match>\n                        <ui-select-choices repeat="option._id as option in mtcc.filterBranches(row) |\n                                                uiSelectFilter: {description:$select.search}">\n                            <div ng-bind-html="option.description | highlight: $select.search"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--related-->\n                <td data-title="mtcc.relatedCol"\n                    sortable="\'related\'" ng-attr-title="{{row.related}}" ng-if="mtcc.relatedCol">\n                    <span ng-if="!row.modeEdit">{{row.related ? row.related.description : \'\'}}</span>\n                    <ui-select ng-model="row.related" ng-if="row.modeEdit" id="related_{{$index +1}}"\n                               name="related_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{mtcc.relatedCol}}">\n                            <span> {{row.related.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtcc.constants.related |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--icon-->\n                <td data-title="\'MASTERTABLES.CONFIG.ICON\'|translate"\n                    sortable="\'icon\'" ng-attr-title="{{row.icon}}"\n                    ng-if="mtcc.iconCol">\n                    <span ng-if="!row.modeEdit">{{row.icon}}</span>\n                    <input type="text" ng-model="row.icon" name="icon_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="icon_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--colour-->\n                <td data-title="\'MASTERTABLES.CONFIG.COLOUR\'|translate"\n                    sortable="\'colour\'" ng-attr-title="{{row.colour}}" ng-if="mtcc.colourCol">\n                    <span ng-if="!row.modeEdit && row.colour" ng-style="{\'background-color\': row.colour}"\n                          style="width: 20px; height: 20px; display: block"></span>\n                    <color-picker ng-if="row.modeEdit"\n                                  ng-model="row.colour"\n                                  options="mtcc.colorPickerOptions"\n                                  name="colour_{{$index +1}}"\n                                  class="form-control with-primary-addon color-picker-form"\n                                  id="colour_{{$index +1}}"></color-picker>\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mtcc.readonly && !row.modeEdit && mtcc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mtcc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtcc.editConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtcc.readonly && !row.modeEdit && mtcc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mtcc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtcc.deleteConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtcc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtcc.saveConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtcc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtcc.cancelConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mtcc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mtcc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mtcc.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/components/masterTables/masterTablesCustomConcepts/masterTablesCustomConcepts.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mtccc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                class="ng-binding" tagaste-click="mtccc.openConceptDetail(row, true)">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--description-->\n                <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                    sortable="\'description\'" ng-attr-title="{{row.description}}">\n                    <span ng-if="!row.modeEdit">{{row.description}}</span>\n                    <input type="text" ng-model="row.description" name="description_{{$index +1}}"\n                           class="form-control with-primary-addon" id="description_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!-- branches -->\n                <td data-title="\'MASTERTABLES.CONFIG.BRANCHES\'|translate">\n                    <span ng-if="!row.modeEdit" ng-repeat="branch in row.branches" class="masterTableTag">{{branch.description}}</span>\n                    <ui-select multiple ng-model="row.branches" ng-if="row.modeEdit" id="branches_{{$index +1}}"\n                               name="branches_{{$index +1}}"\n                               style="-webkit-border-radius:0; -moz-border-radius:0; border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               close-on-select="false" append-to-body="false">\n                        <ui-select-match allow-clear=true placeholder="{{\'MASTERTABLES.CONFIG.BRANCHES\'|translate}}">\n                            {{$item.description}}\n                        </ui-select-match>\n                        <ui-select-choices repeat="option._id as option in mtccc.filterBranches(row) |\n                                                uiSelectFilter: {description:$select.search}">\n                            <div ng-bind-html="option.description | highlight: $select.search"></div>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!-- code -->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'code\'" ng-attr-title="{{row.code}}">\n                    <span ng-if="!row.modeEdit">{{row.code}}</span>\n                    <input type="text" ng-model="row.code" name="code_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="code_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mtccc.readonly && !row.modeEdit" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mtccc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtccc.openConceptDetail(row); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtccc.readonly && !row.modeEdit" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mtccc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtccc.deleteConfig(row); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mtccc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mtccc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mtccc.openConceptDetail();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/components/tasks/tasksList/tasksList.html','<style>\n    .switchType .nz-toggle-wrap.horizontal.null .nz-toggle-handle:after {\n        content: "{{\'BUTTONS.ALL\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.true .nz-toggle-handle:after {\n        content: "{{\'WORKERTASKLIST.DONE\'|translate}}";\n        bottom: 3px;\n    }\n\n    .switchType .nz-toggle-wrap.horizontal.false .nz-toggle-handle:after {\n        content: "{{\'WORKERTASKLIST.IN_PROGRESS\'|translate}}";\n        bottom: 3px;\n    }\n</style>\n<div class="row">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="{{\'TASKS.TASKSLIST.TITLE\'|translate}}" ba-panel-class="with-scroll"\n             id="tasksList">\n            <div class="filterAccordion" style="left: 210px!important;" ng-hide="tlstc.selectr._id !== undefined">\n                <uib-accordion>\n                    <uib-accordion-group panel-class="panel-primary accordion-panel " is-open="status.open">\n                        <uib-accordion-heading>{{\'RESIDENTSWINDOW.FILTERS\' | translate}}\n                            <i class="pull-right glyphicon"\n                               ng-class="{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}"></i>\n                        </uib-accordion-heading>\n                        <div class="row">\n                            <div class="col-xs-12 switchType">\n                                <nz-toggle tri-toggle val-null="\'all\'" ng-model="tlstc.taskStatus"\n                                           on-toggle="tlstc.applyAdditionalFilters()" width="150"\n                                           style="width: 25px; height: 15px;" color-false="\'#8AF37E\'" color-true="\'#8AF37E\'"\n                                           title="{{\'TASKS.TASKSLIST.STATUS\'|translate}}"></nz-toggle>\n                            </div>\n                        </div>\n                    </uib-accordion-group>\n                </uib-accordion>\n            </div>\n            <div class="horizontal-scroll" ng-class="(tlstc.showTaskView || tlstc.showTaskSchedulerView) ? \'hideTableCounts\': \'\'">\n                <table ng-table="tlstc.tableParams" id="tableParams"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true" style="cursor: pointer">\n                    <colgroup ng-if="!tlstc.showTaskView && !tlstc.showTaskSchedulerView">\n                        <col width="20%">\n                        <col width="20%">\n                        <col width="10%">\n                        <col width="15%">\n                        <col width="15%">\n                        <col width="15%">\n                        <col width="5%">\n                    </colgroup>\n                    <colgroup ng-if="!tlstc.showTaskView && !tlstc.showTaskSchedulerView && (tlstc.userBranch.length == 1)">\n                        <col width="24%">\n                        <col width="14%">\n                        <col width="19%">\n                        <col width="19%">\n                        <col width="19%">\n                        <col width="5%">\n                    </colgroup>\n                    <colgroup ng-if="tlstc.showTaskView || tlstc.showTaskSchedulerView">\n                        <col width="20%">\n                        <col width="22%">\n                        <col width="25%">\n                        <col width="23%">\n                    </colgroup>\n\n                    <tr ng-repeat="row in $data | showErrorNoData track by $index"\n                        ng-click="tlstc.tableParamsCK(row)"\n                        ng-class="{\'selectRow\': row.selected === true, \'firstListRow\': $index === 0}"\n                        class="ng-binding">\n                        <td colspan="6" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'TASKS.TASKSLIST.LOCALITY\'|translate" ng-if="!tlstc.showTaskView && !tlstc.showTaskSchedulerView && !row.error"\n                            sortable="\'branchDescription\'" filter="tlstc.filterLocality"\n                            ng-attr-title="{{row.branchDescription}}">\n                            {{row.branchDescription}}\n                        </td>\n                        <td data-title="\'TASKS.TASKSLIST.PLACE\'|translate" ng-if="!row.error"\n                            sortable="\'spotDescription\'" filter="tlstc.filterPlace"\n                            ng-attr-title="{{row.spotDescription}}">\n                            {{row.spotDescription}}\n                        </td>\n                        <td data-title="\'TASKS.TASKSLIST.DATE\'|translate" ng-if="!row.error"\n                            sortable="\'datePlanned\'" filter="tlstc.filterDate"\n                            ng-attr-title="{{row.datePlanned | date:\'dd/MM/yyyy\'}}">\n                            {{row.datePlanned | date:\'dd/MM/yyyy\'}}\n                        </td>\n                        <td data-title="\'TASKS.TASKSLIST.TYPE\'|translate" ng-if="!row.error"\n                            sortable="\'taskTypeDescription\'" filter="tlstc.filterType"\n                            ng-attr-title="{{row.taskTypeDescription}}">\n                            {{row.taskTypeDescription}}\n                        </td>\n                        <td data-title="\'TASKS.TASKSLIST.STATUS\'|translate" ng-if="!row.error"\n                            sortable="\'statusDescription\'" filter="tlstc.filterStatus"\n                            ng-attr-title="{{row.statusDescription}}">\n                            {{row.statusDescription}}\n                        </td>\n                        <td data-title="\'TASKS.TASKSLIST.REOPEN\'|translate" ng-if="!tlstc.showTaskView && !tlstc.showTaskSchedulerView && !row.error"\n                            sortable="\'reOpened\'"\n                            ng-attr-title="{{(row.reOpened ? \'BUTTONS.YES\' : \'BUTTONS.NO\') | translate}}">\n                            <span ng-class="{\'ion-android-checkmark-circle\': row.reOpened}"></span>\n                        </td>\n                        <td ng-if="!tlstc.showTaskView && !tlstc.showTaskSchedulerView && !row.error" class="text-center" style="white-space: nowrap;">\n                            <span class="fa fa-trash-o iconNgTable edit" uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                style="margin-left: 10px;" ng-if="tlstc.gotAccessDelete"\n                                ng-click="tlstc.deleteRow(row); $event.stopPropagation();">\n                  </span>\n                    </td>\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!tlstc.showTaskView && !tlstc.showTaskSchedulerView">\n                <div class="col-xs-12 countAndNewButton" style="display: flex; align-items: center;">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">\n                        {{ \'TOTAL\' |translate }} : {{ tlstc.tableParams.total() }}</span></span>\n                    <button ng-if="tlstc.gotAccessCreate"\n                            id="newTaskButton"\n                            ng-click="tlstc.newTask()"\n                            class="btn btn-success btn-with-icon pull-right newButton"\n                            type="button">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                    <button type="button"\n                    tagaste-click="tlstc.exportData();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/masterTables/masterTablesDish/masterTablesDish.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mtdc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                class="ng-binding">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--description-->\n                <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                    sortable="\'description\'" ng-attr-title="{{row.description}}">\n                    <span ng-if="!row.modeEdit">{{row.description}}</span>\n                    <input type="text" ng-model="row.description" name="description_{{$index +1}}"\n                           class="form-control with-primary-addon" id="description_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!--code-->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'code\'" ng-attr-title="{{row.code}}">\n                    <span ng-if="!row.modeEdit">{{row.code}}</span>\n                    <input type="text" ng-model="row.code" name="code_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="code_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--icon-->\n                <td data-title="\'MASTERTABLES.CONFIG.ICON\'|translate"\n                    sortable="\'icon\'" ng-attr-title="{{row.icon}}">\n                    <span ng-if="!row.modeEdit">{{row.icon}}</span>\n                    <input type="text" ng-model="row.icon" name="icon_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="icon_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--isTakeAway-->\n                <td data-title="\'MASTERTABLES.CONFIG.IS_TAKE_AWAY\'|translate"\n                    sortable="\'isTakeAway\'" ng-attr-title="{{row.isTakeAway}}">\n                    <span ng-if="!row.modeEdit">{{row.isTakeAway.value ? (\'BUTTONS.YES\'|translate) : (\'BUTTONS.NO\'|translate)}}</span>\n                    <ui-select ng-model="row.isTakeAway" ng-if="row.modeEdit" id="isTakeAway_{{$index +1}}"\n                               name="isTakeAway_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.IS_TAKE_AWAY\'| translate}}">\n                            <span> {{row.isTakeAway.name}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtdc.constants.binary |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.name | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mtdc.readonly && !row.modeEdit && mtdc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mtdc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtdc.editConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtdc.readonly && !row.modeEdit && mtdc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mtdc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtdc.deleteConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtdc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtdc.saveConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtdc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtdc.cancelConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mtdc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mtdc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mtdc.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/components/masterTables/masterTablesEmail/masterTablesEmail.html','<div class="row">\n    <div ng-class="mtec.modeEdit ? \'col-sm-5\' : \'col-sm-12\'" style="transition: all 0.5s;">\n        <div class="row">\n            <div class="col-md-12">\n                <table ng-table="mtec.configTableParams"\n                       class="table table-hover table-condensed fixNgTable" show-filter="false"\n                       style="font-size: 11px;">\n\n                    <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                        class="ng-binding">\n                        <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n\n                        <!--description-->\n                        <td data-title="\'MASTERTABLES.CONFIG.NAME\'|translate"\n                            sortable="\'description\'" ng-attr-title="{{row.description}}">\n                            <span>{{row.description}}</span>\n                        </td>\n\n                        <!--template-->\n                        <td data-title="\'MASTERTABLES.CONFIG.TEMPLATE\'|translate"\n                            sortable="\'template\'" ng-attr-title="{{mtec.lodash.upperCase(row.template)}}">\n<!--                            <span>{{row.template ? row.template : \'\'}}</span>-->\n                            <span>{{mtec.lodash.upperCase(row.template)}}</span>\n                        </td>\n\n                        <!--branch-->\n                        <td data-title="\'MASTERTABLES.CONFIG.BRANCH\'|translate"\n                            sortable="\'branch.description\'" ng-attr-title="{{row.branch}}" ng-if="mtec.branchCol">\n                            <span>{{row.branch ? row.branch.description : \'\'}}</span>\n                        </td>\n\n                        <!--buttons-->\n                        <td ng-if="!mtec.readonly && !mtec.modeEdit && mtec.isEditable(row)" style="width: 20px;">\n                            <i class="fa fa-pencil iconNgTable edit"\n                               uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                               ng-if="!mtec.modeEdit && !mtec.addingConfig && !row.error" aria-hidden="true"\n                               tagaste-click="mtec.editConfig(row, $index); $event.stopPropagation();">\n                            </i>\n                        </td>\n\n                        <td ng-if="!mtec.readonly && !mtec.modeEdit && mtec.isEditable(row)" style="width: 20px;">\n                            <i class="fa fa-trash-o iconNgTable edit"\n                               uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                               ng-if="!mtec.modeEdit && !mtec.addingConfig && !row.error" aria-hidden="true"\n                               tagaste-click="mtec.deleteConfig(row, $index); $event.stopPropagation();">\n                            </i>\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div ng-if="mtec.modeEdit" class="col-sm-7">\n        <form name="emailForm" style="margin-top: 15px;">\n            <div class="row">\n                <!--title-->\n                <div class="col-xs-12">\n                    <span class="panel-title" style="font-size: 20px; padding: 10px 0;">{{mtec.selectedEmail._id ?\n                        (\'MASTERTABLES.CONFIG.EDIT_EMAIL\' | translate) : (\'MASTERTABLES.CONFIG.NEW_EMAIL\' | translate)}}</span>\n                </div>\n                <!--description-->\n                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">\n                    <div class="input-group">\n                        <span uib-tooltip="{{\'MASTERTABLES.CONFIG.NAME\'| translate}}"\n                              class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-android-create"></span></span>\n                        <input type="text" name="description"\n                               class="form-control with-primary-addon"\n                               placeholder="{{\'MASTERTABLES.CONFIG.NAME\'|translate}}"\n                               ng-model="mtec.selectedEmail.description" required>\n                    </div>\n                </div>\n                <!--template-->\n                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">\n                    <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              tooltip-placement="bottom-left"\n                              uib-tooltip="{{\'MASTERTABLES.CONFIG.TEMPLATE\'| translate}}">\n                            <span class="ion ion-document-text" style="margin-left:-1px"></span>\n                        </span>\n                        <ui-select ng-model="mtec.selectedEmail.template"\n                                   search-enabled="false"\n                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                   class="btn-group bootstrap-select form-control"\n                                   append-to-body="false">\n                            <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.TEMPLATE\'| translate}}">\n                                <span> {{mtec.lodash.upperCase(mtec.selectedEmail.template)}}</span>\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mtec.constants.templates | uiSelectFilter: {description:$select.search}">\n                                <span ng-bind-html="mtec.lodash.upperCase(option) | highlight: $select.search"></span>\n<!--                                <span ng-bind-html="option | highlight: $select.search"></span>-->\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n                <!--branch-->\n                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">\n                    <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              tooltip-placement="bottom-left"\n                              uib-tooltip="{{\'MASTERTABLES.CONFIG.BRANCH\'| translate}}">\n                            <span class="ion-card" style="margin-left:-1px"></span>\n                        </span>\n                        <ui-select ng-model="mtec.selectedEmail.branch" ng-if="mtec.modeEdit"\n                                   style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                                   class="btn-group bootstrap-select form-control with-primary-addon"\n                                   append-to-body="false">\n                            <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.BRANCH\'| translate}}">\n                                <span> {{mtec.selectedEmail.branch.description}}</span>\n                            </ui-select-match>\n                            <ui-select-choices repeat="option in mtec.constants.branches |\n                                                                uiSelectFilter: {description:$select.search}">\n                                <span ng-bind-html="option.description | highlight: $select.search"></span>\n                            </ui-select-choices>\n                        </ui-select>\n                    </div>\n                </div>\n            </div>\n            <!--content-->\n            <div class="row">\n                <div class="col-xs-12">\n                    <text-angular ta-toolbar="mtec.toolbarOptions" ng-model="mtec.selectedEmail.content"></text-angular>\n                </div>\n            </div>\n            <!--buttons-->\n            <div class="row">\n                <div class="col-xs-12 text-right">\n                    <button style="margin-top:30px;margin-bottom:7px;" type="button" id="emailDetailCancel"\n                            tagaste-click="mtec.cancelConfig()" class="btn btn-success btn-with-icon">\n                        <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' | translate}}\n                    </button>\n                    <button style="margin-top:30px;margin-bottom:7px;" type="button" id="emailDetailSave"\n                            ng-disabled="mtec.disableSave()"\n                            tagaste-click="mtec.saveConfig()" class="btn btn-success btn-with-icon">\n                        <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </form>\n    </div>\n</div>\n\n<div class="row" ng-if="!mtec.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mtec.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mtec.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n\n');
$templateCache.put('app/components/masterTables/masterTablesMenu/masterTablesMenu.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mtmc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                class="ng-binding">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--description-->\n                <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                    sortable="\'description\'" ng-attr-title="{{row.description}}">\n                    <span ng-if="!row.modeEdit">{{row.description}}</span>\n                    <input type="text" ng-model="row.description" name="description_{{$index +1}}"\n                           class="form-control with-primary-addon" id="description_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!--code-->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'code\'" ng-attr-title="{{row.code}}">\n                    <span ng-if="!row.modeEdit">{{row.code}}</span>\n                    <input type="text" ng-model="row.code" name="code_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="code_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--icon-->\n                <td data-title="\'MASTERTABLES.CONFIG.ICON\'|translate"\n                    sortable="\'icon\'" ng-attr-title="{{row.icon}}">\n                    <span ng-if="!row.modeEdit">{{row.icon}}</span>\n                    <input type="text" ng-model="row.icon" name="icon_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="icon_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--hourUntil-->\n                <td data-title="\'MASTERTABLES.CONFIG.HOUR_UNTIL\'|translate"\n                    sortable="\'hourUntil\'" ng-attr-title="{{row.hourUntil}}">\n                    <span ng-if="!row.modeEdit">{{row.hourUntil}}</span>\n                    <input type="number" ng-model="row.hourUntil" name="hourUntil_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="hourUntil_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mtmc.readonly && !row.modeEdit && mtmc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mtmc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtmc.editConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtmc.readonly && !row.modeEdit && mtmc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mtmc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtmc.deleteConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtmc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtmc.saveConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtmc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtmc.cancelConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mtmc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mtmc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mtmc.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/components/masterTables/masterTablesPanel/masterTablesPanel.html','<div class="row" ng-click="rlstc.backifModifOrNew()">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="MASTERTABLES.PANEL.HEADER" ba-panel-class="with-scroll" id="residentsList">\n            <div class="row">\n                <div class="col-sm-8 col-xs-10" style="padding-right: 0">\n                    <ui-select ng-model="mtpc.selectedOption"\n                           style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0; display: inline-block; width: 98%;"\n                           class="btn-group bootstrap-select form-control"\n                           ng-change="mtpc.changeOption()"\n                           append-to-body="false" name="option" search-enabled="true">\n                    <ui-select-match placeholder="{{\'MASTERTABLES.PANEL.PLACEHOLDER\'| translate}}">\n                        <span>{{mtpc.selectedOption.translation}}</span>\n                    </ui-select-match>\n                    <ui-select-choices repeat="option in mtpc.mastertables | uiSelectFilter: {translation:$select.search}">\n                        <span ng-bind-html="option.translation | highlight: $select.search"></span>\n                    </ui-select-choices>\n                    </ui-select>\n                </div>\n                <i class="fa iconNgTable edit"\n                ng-class="mtpc.locked ? \'fa-lock\' : \'fa-unlock\'"\n                style="display: inline-block; position: relative; left: 10px; font-size: 20px; top: 3px; cursor: default;"\n                uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                aria-hidden="true"\n                ng-model="mtpc.locked"\n                ng-if="mtpc.selectedOption">\n                </i>\n            </div>\n\n            <div ng-switch="mtpc.selectedOption.component">\n                <div ng-switch-when="config">\n                    <master-tables-config-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-config-component>\n                </div>\n                <div ng-switch-when="statustypes">\n                    <master-tables-status-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-status-component>\n                </div>\n                <div ng-switch-when="menutypes">\n                    <master-tables-menu-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-menu-component>\n                </div>\n                <div ng-switch-when="dishtypes">\n                    <master-tables-dish-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-dish-component>\n                </div>\n                <div ng-switch-when="tasktypes">\n                    <master-tables-task-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-task-component>\n                </div>\n                <div ng-switch-when="roomrate">\n                    <master-tables-room-rate-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-room-rate-component>\n                </div>\n                <div ng-switch-when="email">\n                    <master-tables-email-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-email-component>\n                </div>\n                <div ng-switch-when="tax">\n                    <master-tables-tax-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-tax-component>\n                </div>\n                <div ng-switch-when="customConcept">\n                    <master-tables-custom-concepts-component ng-if="mtpc.ready" selected="mtpc.selectedOption"></master-tables-custom-concepts-component>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/masterTables/masterTablesRoomRate/masterTablesRoomRate.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mtrrc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                class="ng-binding">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--description-->\n                <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                    sortable="\'description\'" ng-attr-title="{{row.description}}">\n                    <span ng-if="!row.modeEdit">{{row.description}}</span>\n                    <input type="text" ng-model="row.description" name="description_{{$index +1}}"\n                           class="form-control with-primary-addon" id="description_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!--code-->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'code\'" ng-attr-title="{{row.code}}">\n                    <span ng-if="!row.modeEdit">{{row.code}}</span>\n                    <input type="text" ng-model="row.code" name="code_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="code_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--price-->\n                <td data-title="\'MASTERTABLES.CONFIG.PRICE\'|translate"\n                    sortable="\'price\'" ng-attr-title="{{row.price}}">\n                    <span ng-if="!row.modeEdit">{{row.price}}</span>\n                    <input type="number" ng-model="row.price" name="price_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="price_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--modality-->\n                <td data-title="\'MASTERTABLES.CONFIG.MODALITY\'|translate"\n                    sortable="\'modality\'" ng-attr-title="{{row.modality.description}}">\n                    <span ng-if="!row.modeEdit">{{row.modality ? row.modality.description : \'\'}}</span>\n                    <ui-select ng-model="row.modality" ng-if="row.modeEdit" id="modality_{{$index +1}}"\n                               name="modality_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.MODALITY\'|translate}}">\n                            <span> {{row.modality.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtrrc.constants.modality |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--related-->\n                <td data-title="\'MASTERTABLES.CONFIG.ROOM_TYPE\'|translate"\n                    sortable="\'related\'" ng-attr-title="{{row.related.description}}">\n                    <span ng-if="!row.modeEdit">{{row.related ? row.related.description : \'\'}}</span>\n                    <ui-select ng-model="row.related" ng-if="row.modeEdit" id="related_{{$index +1}}"\n                               name="related_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.ROOM_TYPE\'|translate}}">\n                            <span> {{row.related.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtrrc.constants.related |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--branch-->\n                <td data-title="\'MASTERTABLES.CONFIG.BRANCH\'|translate"\n                    sortable="\'branch\'" ng-attr-title="{{row.branch}}">\n                    <span ng-if="!row.modeEdit">{{row.branch ? row.branch.description : \'\'}}</span>\n                    <ui-select ng-model="row.branch" ng-if="row.modeEdit" id="branch_{{$index +1}}"\n                               name="branch_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.BRANCH\'| translate}}">\n                            <span> {{row.branch.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtrrc.filterBranches(row) |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mtrrc.readonly && !row.modeEdit && mtrrc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mtrrc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtrrc.editConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtrrc.readonly && !row.modeEdit && mtrrc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mtrrc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtrrc.deleteConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtrrc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtrrc.saveConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtrrc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtrrc.cancelConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mtrrc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mtrrc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mtrrc.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/components/masterTables/masterTablesStatus/masterTablesStatus.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mtsc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                class="ng-binding">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--description-->\n                <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                    sortable="\'description\'" ng-attr-title="{{row.description}}">\n                    <span ng-if="!row.modeEdit">{{row.description}}</span>\n                    <input type="text" ng-model="row.description" name="description_{{$index +1}}"\n                           class="form-control with-primary-addon" id="description_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!--code-->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'code\'" ng-attr-title="{{row.code}}">\n                    <span ng-if="!row.modeEdit">{{row.code}}</span>\n                    <input type="text" ng-model="row.code" name="code_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="code_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--icon-->\n                <td data-title="\'MASTERTABLES.CONFIG.ICON\'|translate"\n                    sortable="\'icon\'" ng-attr-title="{{row.icon}}">\n                    <span ng-if="!row.modeEdit">{{row.icon}}</span>\n                    <input type="text" ng-model="row.icon" name="icon_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="icon_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--isFirst-->\n                <td data-title="\'MASTERTABLES.CONFIG.IS_FIRST\'|translate"\n                    sortable="\'isFirst\'" ng-attr-title="{{row.isFirst}}">\n                    <span ng-if="!row.modeEdit">{{row.isFirst.value ? (\'BUTTONS.YES\' | translate) : (\'BUTTONS.NO\' | translate)}}</span>\n                    <ui-select ng-model="row.isFirst" ng-if="row.modeEdit" id="isFirst_{{$index +1}}"\n                               name="isFirst_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.IS_FIRST\'| translate}}">\n                            <span> {{row.isFirst.name}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtsc.constants.binary |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.name | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--isLast-->\n                <td data-title="\'MASTERTABLES.CONFIG.IS_LAST\'|translate"\n                    sortable="\'isLast\'" ng-attr-title="{{row.isLast}}">\n                    <span ng-if="!row.modeEdit">{{row.isLast.value ? (\'BUTTONS.YES\' | translate) : (\'BUTTONS.NO\' | translate)}}</span>\n                    <ui-select ng-model="row.isLast" ng-if="row.modeEdit" id="isLast_{{$index +1}}"\n                               name="isLast_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.IS_LAST\'| translate}}">\n                            <span> {{row.isLast.name}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtsc.constants.binary |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.name | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--functionality-->\n                <td data-title="\'MASTERTABLES.CONFIG.FUNCTIONALITY\'|translate"\n                    sortable="\'functionality\'" ng-attr-title="{{row.functionality}}">\n                    <span ng-if="!row.modeEdit">{{row.functionality}}</span>\n                    <ui-select ng-model="row.functionality" ng-if="row.modeEdit" id="functionality_{{$index +1}}"\n                               name="functionality_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.FUNCTIONALITY\'| translate}}">\n                            <span> {{row.functionality}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mtsc.constants.functionalities |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--colour-->\n                <td data-title="\'MASTERTABLES.CONFIG.COLOUR\'|translate"\n                    sortable="\'colour\'" ng-attr-title="{{row.colour}}">\n                    <span ng-if="!row.modeEdit && row.colour" ng-style="{\'background-color\': row.colour}"\n                    style="width: 20px; height: 20px; display: block"></span>\n                    <color-picker ng-if="row.modeEdit"\n                                  ng-model="row.colour"\n                                  options="mtsc.colorPickerOptions"\n                                  name="colour_{{$index +1}}"\n                                  class="form-control with-primary-addon color-picker-form"\n                                  id="colour_{{$index +1}}"></color-picker>\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mtsc.readonly && !row.modeEdit && mtsc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mtsc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtsc.editConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtsc.readonly && !row.modeEdit && mtsc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mtsc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mtsc.deleteConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtsc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtsc.saveConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mtsc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mtsc.cancelConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mtsc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mtsc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mtsc.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/components/users/usersList/usersList.html','<div class="row" ng-click="ultc.backifModifOrNew()">\n    <div class="col-md-12 col-lg-12">\n        <div ba-panel ba-panel-title="USERWINDOWLIST.HEADER" ba-panel-class="with-scroll" id="usersList">\n            <div class="resumeTourContainer" style="left: 250px!important;">\n                <span class="ion-ios-information-outline" tagaste-click="ultc.initTour()" style="cursor: pointer;"\n                ng-hide="ultc.selectu._id !== undefined"></span>\n            </div>\n            <div class="horizontal-scroll" ng-if="ultc.list.length >= 0"\n                 ng-class="(!ultc.selectu._id) ? \'\': \'hideTableCounts\'">\n                <table ng-table="ultc.tableParamsU" id="tableParam"\n                       class="table table-hover table-condensed fixNgTable"\n                       show-filter="true">\n                    <tr ng-repeat="row in $data | showErrorNoData" style="cursor:pointer;"\n                        ng-click="ultc.tableParamsCK(row);$event.stopPropagation();"\n                        ng-class="{\'firstListRow\': $index === 0, \'selectRow\': row.selected === true}"\n                        class="ng-binding">\n\n                        <td>\n                            <img class="photo-icon" check-avatar\n                                 ng-src="{{row.photo.thumb.signedUrl}}"\n                                 ng-if="!row.error"\n                                 style="max-width: 30px;border-radius:30px"/>\n                        </td>\n                        <td colspan="5" ng-if="row.error"\n                            ng-src="{{row.error}}">\n                            {{row.error}}\n                        </td>\n                        <td data-title="\'USERWINDOWLIST.NAMESURNAME\'|translate"\n                            sortable="\'nameSurname\'"\n                            ng-if="ultc.selectu._id"\n                            filter="ultc.filterNameSurname"\n                            ng-attr-title="{{row.nameSurname}}">\n                            {{row.nameSurname}}\n                        </td>\n                        <td data-title="\'USERWINDOWLIST.NAME\'|translate"\n                            sortable="\'name\'"\n                            ng-if="!ultc.selectu._id"\n                            filter="ultc.filterName"\n                            ng-attr-title="{{row.name}}">\n                            {{row.name}}\n                        </td>\n                        <td data-title="\'USERWINDOWLIST.SURNAME\'|translate"\n                            sortable="\'surname\'"\n                            ng-if="!ultc.selectu._id"\n                            filter="ultc.filterLastname"\n                            ng-attr-title="{{row.surname}}">\n                            {{row.surname}}\n                        </td>\n                        <td data-title="\'USERWINDOWLIST.BRANCHES\'|translate"\n                            sortable="\'ABran\'"\n                            filter="ultc.filterBR"\n                            ng-if="!ultc.selectu._id"\n                            ng-attr-title="{{row.ABran}}">\n                            {{row.ABran}}\n                        </td>\n                        <td data-title="\'USERWINDOWLIST.ROLE\'|translate"\n                            sortable="\'roleDesc\'"\n                            filter="ultc.filterRole"\n                            ng-attr-title="{{row.roleDesc}}">\n                            {{row.roleDesc}}\n                        </td>\n                        <td data-title="\'RESIDENTSWINDOW.APP\'|translate"\n                            sortable="\'tokenApp\'"\n                            ng-if="!row.error"\n                            class="text-center">\n                            <span class="fa fa-mobile iconNgTable" style="font-size:24px"\n                                  title="{{(row.tokenApp === true) ?\n                                   (\'RESIDENTSWINDOW.INSTALLEDAPP\' | translate) :\n                                    (\'RESIDENTSWINDOW.NOTINSTALLEDAPP\' | translate)}}"\n                                  ng-style="(row.tokenApp=== true) ? {\'opacity\': \'1\'} : {\'opacity\': \'0.3\'}"\n                            ></span>\n                        </td>\n                        <td ng-if="!ultc.selectu._id && !row.error">\n                            <span class="fa fa-pencil iconNgTable edit"\n                                  ng-if="ultc.gotAccessMod"\n                                  uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                                  ng-click="ultc.editRow(row); $event.stopPropagation();"></span>\n                            <span class="fa fa-trash-o iconNgTable edit"\n                                  ng-if="ultc.gotAccessDel"\n                                  uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                                  style="margin-left: 10px;"\n                                  ng-click="$event.stopPropagation();ultc.deleteRow(row);"></span>\n                        </td>\n\n                    </tr>\n                </table>\n            </div>\n            <div class="row" ng-if="!ultc.selectu._id">\n                <div class="col-xs-12 countAndNewButton" style="display: flex; align-items: center;">\n                    <span style="flex-grow: 1" class="count"><span id="totalItems">{{ \'TOTAL\' |translate }} : {{ ultc.tableParamsU.total() }}</span></span>\n                    <button type="button" id="newUsersButton"\n                            ng-if="ultc.gotAccessMod"\n                            ng-click="ultc.new();$event.stopPropagation();"\n                            class="btn btn-success btn-with-icon pull-right newButton"\n                            ng-disabled="ultc.istour">\n                        <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' |translate}}\n                    </button>\n                    <button type="button"\n                    tagaste-click="ultc.exportData();$event.stopPropagation();"\n                    class="btn btn-success btn-with-icon pull-right newButton" id="exportButton">\n                        <i class="fa fa-download"></i>{{\'BUTTONS.EXPORT\' | translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n\n    </div>\n</div>\n\n');
$templateCache.put('app/pages/activities/activitiesList/activitiesList.html','<script type="text/ng-template" id="tourAgendaTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep"\n                                ng-if="tourStep.isPrev() && tourStep.stepId !== \'step10\' &&\n                                tourStep.stepId !== \'step17\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div class="row">\n    <div ng-class="(alc.showActivityView)? ((alc.reserveList || (alc.notification && alc.notification.showPanel)) ?\n    \'col-sm-3\' :\'col-sm-4\') : \'col-sm-8\'" style="transition: all 0.5s;">\n            <activities-list select-activity="alc.selected" list="alc.list" pag="alc.pag" ng-if="alc.listLoaded"\n                             mode-edit="alc.modeEdit"  init-tour="alc.initTour()" tour-dummy-data="alc.tourDummyData"\n                             mode-read-only="alc.readOnly" anim="alc.anim" show-activity-view="alc.showActivityView"\n                             on-deleted="alc.reloadList(value)" mode-creation="alc.modeCreation"\n                             anim-reserve="alc.animReserve" reserve-list="alc.reserveList"\n                             notification="alc.notification" anim-resident="alc.animResident" istour="alc.istour"></activities-list>\n    </div>\n    <div ng-if="alc.showActivityView && alc.anim"\n         ng-class="(alc.reserveList || (alc.notification && alc.notification.showPanel) || alc.newReserveView )? \'col-sm-4\' : \'col-sm-8\'">\n        <activity-detail activity-id="alc.selected" mode-read-only="alc.readOnly" on-updated="alc.reloadList(value)"\n                         mode-edit="alc.modeEdit"  mode-creation="alc.modeCreation" notification="alc.notification"\n                         show-activity-view="alc.showActivityView" anim="alc.anim" show-reserve="alc.showReserve(value)"\n                         reserve-list="alc.reserveList" anim-reserve="alc.animReserve" anim-resident="alc.animResident"\n                         show-notification-button="alc.showNotificationButton" istour="alc.istour" \n                         show-reserve-new="alc.showReserveNew(value)" \n                         reload-activity="alc.reloadActivity"></activity-detail>\n    </div>\n    <div ng-if="alc.reserveList && alc.animReserve && !alc.animResident" class="col-sm-4" >\n        <reserve-list reserve-list="alc.reserveList" anim-reserve="alc.animReserve" block-buttons="alc.blockButtons"\n                      selected-resident="alc.selectedResident" anim-resident="alc.animResident"\n                      constants="alc.constants"  show-notification-button="alc.showNotificationButton"></reserve-list>\n    </div>\n    <div ng-if="alc.selectedResident._id && alc.animResident" class="col-sm-5">\n        <resident-detail anim="alc.animResident"\n                         level="3"\n                         constants="alc.constants"\n                         show-payment="alc.showPayment"\n                         resident="alc.selectedResident"></resident-detail>\n    </div>\n    <div ng-if="alc.notification && alc.notification.showPanel && alc.animReserve" class="col-sm-4">\n        <notification-push notification="alc.notification"></notification-push>\n    </div>\n    <div ng-if="alc.newReserveView" class="col-sm-4" >\n        <reserve-new \n            level="3"\n            activity-id="alc.selected"\n            new-reserve-view = "alc.newReserveView"\n            show-reserve-new="alc.showReserveNew()"\n            reload-activity="alc.reloadActivity">\n        </reserve-new>\n    </div>\n</div>');
$templateCache.put('app/pages/billing/billingList/billingList.html','<!--TODO billing tour-->\n<script type="text/ng-template" id="tourRequestsTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep" ng-if="tourStep.isPrev() &&\n                        tourStep.stepId !== \'step9\' && tourStep.stepId !== \'step17\' && tourStep.stepId !== \'step19\'\n                        && tourStep.stepId !== \'step20\' &&  tourStep.stepId !== \'step24\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n\n\n<div class="row">\n    <div ng-class="bilc.selected._id ? \'col-md-4\' : \'col-md-12\'" style="transition: all 0.51s;">\n        <billing-list-component\n            anim="bilc.anim"\n            selectr="bilc.selected"\n            list="bilc.list"\n            init-tour="bilc.initTour()"\n            tour-dummy-data="bilc.tourDummyData"\n            istour="bilc.istour">\n        </billing-list-component>\n    </div>\n\n    <div class="col-md-8" ng-if="bilc.selected._id && bilc.ready && bilc.anim === true">\n        <billing-detail-component\n            anim="bilc.anim"\n            constants="bilc.constants"\n            billing="bilc.selected"></billing-detail-component>\n    </div>\n</div>\n');
$templateCache.put('app/pages/canteen/canteenPanel/canteenPanel.html','<script type="text/ng-template" id="tourMenuTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button"\n                                class="btn btn-sm btn-default btnPrevStep"\n                                ng-if="tourStep.isPrev() && tourStep.stepId !== \'step8\' &&\n                                tourStep.stepId !== \'step18\' && tourStep.stepId !== \'step25\' &&\n                                tourStep.stepId !== \'step34\' && tourStep.stepId !== \'step36\' &&\n                                tourStep.stepId !== \'step38\' && tourStep.stepId !== \'step45\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n\n<div class="row">\n    <div ng-class="(cntine.menuid || cntine.newSelectCourse || cntine.appuser)?\n        \'col-md-2 col-sm-6\' : \'col-md-8 col-sm-12\'" style="transition: all 0.51s;">\n        <canteen-list menuid="cntine.menuid"\n                      list="cntine.list"\n                      anim="cntine.anim"\n                      pag="cntine.pag"\n                      init-tour="cntine.initTour()" tour-dummy-data="cntine.tourDummyData"\n                      istour="cntine.istour"\n                      inselectmenu="cntine.newSelectCourse"\n                      appuserbapan="cntine.appuser"\n                      ng-if="cntine.list.length >= 0 && cntine.ready"></canteen-list>\n    </div>\n    <div\n        ng-class="((cntine.newSelectCourse) || (cntine.appuser) || cntine.reserveList || cntine.showReserveView || cntine.showComments) ?\n        \'col-md-6 col-sm-6\' : \'col-md-10 col-sm-12\'" style="transition: all 0.51s;"\n        ng-if="cntine.menuid && cntine.anim">\n        <canteen-detail-com menuid="cntine.menuid"\n                            menu="cntine.menuselect"\n                            readonly="false"\n                            animselectcourse="cntine.animselectcourse"\n                            inselnewcourse="cntine.newSelectCourse"\n                            returncourseitem="cntine.returncourseitem"\n                            inaddoredit="cntine.inaddoredit"\n                            alreadycourses="cntine.alreadycourses"\n                            show-complete-list="cntine.showCompleteList"\n                            notification="cntine.notification"\n                            appuserbapan="cntine.appuser"\n                            reserve-list="cntine.reserveList"\n                            show-resident="cntine.animResident"\n                            istour="cntine.istour"\n                            show-reserve="cntine.showReserve()"\n                            refresh-menu="cntine.refreshMenu"\n                            show-reserve-view="cntine.showReserveView"\n                            mode-edit="cntine.modeEdit"\n                            inselcourse="cntine.newSelectCourse"\n                            block-buttons="cntine.blockButtons"\n                            show-comments="cntine.showComments"\n        >\n        </canteen-detail-com>\n    </div>\n    <div ng-if="cntine.showReserveView" class="col-sm-4">\n        <canteen-reserve-new\n            level="3"\n            menuid="cntine.menuid"\n            menu="cntine.menuselect"\n            selected-resident="cntine.selectedResident"\n            mode-edit="cntine.modeEdit"\n            show-reserve-view="cntine.showReserveView"\n            set-refresh-menu="cntine.setRefreshMenu()"\n            refresh-menu="cntine.refreshMenu"\n            anim-resident="cntine.animResident"\n            block-buttons="cntine.blockButtons">\n        </canteen-reserve-new>\n    </div>\n    <div class="col-sm-10 col-md-4" style="transition: all 0.51s;">\n        <!--canteenSelectCourseCom-->\n        <canteen-app-users-list\n            ng-if="(cntine.appuser !== null && !cntine.notification.showPanel && !cntine.animResident)"\n            notification="cntine.notification"\n            selected-resident="cntine.selectedResident"\n            anim-resident="cntine.animResident"\n            appuserbapan="cntine.appuser"\n            menuid="cntine.menuid"\n            constants="cntine.constants"\n            mode-edit="cntine.modeEdit"\n            show-reserve-view="cntine.showReserveView"\n            block-buttons="cntine.blockButtons">\n        </canteen-app-users-list>\n        <reserve-list ng-if="(cntine.reserveList && !cntine.notification.showPanel && !cntine.animResident)"\n                      reserve-list="cntine.reserveList"\n                      anim-reserve="cntine.animReserve"\n                      selected-resident="cntine.selectedResident"\n                      anim-resident="cntine.animResident"\n                      constants="cntine.constants"\n                      notification="cntine.notification"\n                      show-notification-button="cntine.reserveList.showNotificationButton"\n                      block-buttons="cntine.blockButtons">\n        </reserve-list>\n        <!-- resident detail -->\n        <resident-detail anim="cntine.animResident"\n                         level="3"\n                         ng-if="cntine.selectedResident._id &&\n                         cntine.animResident && (cntine.reserveList || cntine.appuser !== null)"\n                         constants="cntine.constants"\n                         show-payment="cntine.showPayment"\n                         resident="cntine.selectedResident"></resident-detail>\n        <notification-push\n            notification="cntine.notification"\n            ng-if="cntine.notification.showPanel">\n        </notification-push>\n        <carteen-new\n            ng-if="(cntine.newSelectCourse !== null && cntine.inDish !== null)"\n            dish="cntine.inDish"\n            update="cntine.updateInDish"\n            constant="cntine.constant.tags"\n            istour="cntine.istour">\n        </carteen-new>\n        <select-course ng-if="(cntine.newSelectCourse !== null) && cntine.animselectcourse"\n                       ng-style="max-height"\n                       inselcourse="cntine.newSelectCourse"\n                       returncourseitem="cntine.returncourseitem"\n                       inaddoredit="cntine.inaddoredit"\n                       alreadycourses="cntine.alreadycourses"\n                       dish="cntine.inDish"\n                       update="cntine.updateInDish"\n                       constant="cntine.constant.tags"\n                       block-buttons="cntine.blockButtons">\n        </select-course>\n        <canteen-comments-com\n            level="3"\n            ng-if="cntine.showComments"\n            show-comments="cntine.showComments"\n            block-buttons="cntine.blockButtons"\n            menu="cntine.menuselect">\n        </canteen-comments-com>\n    </div>\n</div>\n\n\n\n\n\n\n\n');
$templateCache.put('app/pages/bulletinBoard/bulletinBoardList/bulletinBoardList.html','<script type="text/ng-template" id="tourBulletinBoardTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep"\n                                ng-if="tourStep.isPrev() && tourStep.stepId !== \'step9\' && tourStep.stepId !== \'step17\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div class="row">\n    <div ng-class="(bblst.showBulletinView)? \'col-md-4\' : \'col-md-8\'" style="transition: all 0.5s"\n         ng-style="(!bblst.showBulletinView) ? {\'width\': \'auto\'}:\'\'">\n        <bulletin-board-list selectbulletin="bblst.selected" list="bblst.list"\n                             pag="bblst.pag" ng-if="bblst.listLoaded" mode-edit="bblst.modeEdit"\n                             mode-read-only="bblst.readOnly" anim="bblst.anim"\n                             show-bulletin-view="bblst.showBulletinView" on-deleted="bblst.reloadList(value)"\n                             mode-creation="bblst.modeCreation" init-tour="bblst.initTour()"\n                             tour-dummy-data="bblst.tourDummyData" istour="bblst.istour"></bulletin-board-list>\n    </div>\n    <div ng-if="bblst.showBulletinView && bblst.anim === true" class="col-md-8" id="bboardDetail">\n        <bulletin-board-detail bulletin-id="bblst.selected" mode-read-only="bblst.readOnly"\n                               on-updated="bblst.reloadList(value)" mode-edit="bblst.modeEdit"\n                               show-bulletin-view="bblst.showBulletinView" anim="bblst.anim"\n                               mode-creation="bblst.modeCreation" istour="bblst.istour">\n        </bulletin-board-detail>\n    </div>\n</div>');
$templateCache.put('app/components/masterTables/masterTablesTask/masterTablesTask.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mttc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;" class="ng-binding">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--description-->\n                <td data-title="\'MASTERTABLES.CONFIG.DESCRIPTION\'|translate"\n                    sortable="\'description\'" ng-attr-title="{{row.description}}">\n                    <span ng-if="!row.modeEdit">{{row.description}}</span>\n                    <input type="text" ng-model="row.description" name="description_{{$index +1}}"\n                           class="form-control with-primary-addon" id="description_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!--code-->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'code\'" ng-attr-title="{{row.code}}">\n                    <span ng-if="!row.modeEdit">{{row.code}}</span>\n                    <input type="text" ng-model="row.code" name="code_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="code_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--taskParent-->\n                <td data-title="\'MASTERTABLES.CONFIG.PARENT_TASK\'|translate"\n                    sortable="\'taskParent\'" ng-attr-title="{{row.taskParent}}">\n                    <span ng-if="!row.modeEdit">{{row.taskParent ? row.taskParent.description : \'\'}}</span>\n                    <ui-select ng-model="row.taskParent" ng-if="row.modeEdit" id="taskParent_{{$index +1}}"\n                               name="taskParent_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.PARENT_TASK\'| translate}}">\n                            <span> {{row.taskParent.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mttc.constants.taskParent |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--branch-->\n                <td data-title="\'MASTERTABLES.CONFIG.BRANCH\'|translate"\n                    sortable="\'branch\'" ng-attr-title="{{row.branch}}" ng-if="mttc.branchCol">\n                    <span ng-if="!row.modeEdit">{{row.branch ? row.branch.description : \'\'}}</span>\n                    <ui-select ng-model="row.branch" ng-if="row.modeEdit" id="branch_{{$index +1}}"\n                               name="branch_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.BRANCH\'| translate}}">\n                            <span> {{row.branch.description}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mttc.constants.branches |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.description | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mttc.readonly && !row.modeEdit && mttc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mttc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mttc.openTaskDetail(row, mttc.readonly); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mttc.readonly && !row.modeEdit && mttc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mttc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mttc.deleteConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mttc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mttc.saveConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mttc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mttc.cancelConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mttc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mttc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mttc.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/pages/chat/chatPanel/chatPanel.html','<script type="text/ng-template" id="tourChatTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep"\n                                ng-if="tourStep.isPrev() && tourStep.stepId !== \'step9\' && tourStep.stepId !== \'step13\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div id="tourChatbox" style="position: absolute; right: 480px; top:60px;"></div>\n<div class="row" ng-if="cpn.initialized">\n    <div ng-class="(cpn.selected._id || 1===1)? \'col-md-5\' : \'col-md-12\'" style="transition: all 0.51s">\n        <chat-list selected="cpn.selected"\n                   anim="cpn.anim"\n                   convmsglist="cpn.convmsglist"\n                   selectedconv="cpn.selectedConv"\n                   constants="cpn.constants"\n                   init-tour="cpn.initTour()"\n                   tour-dummy-data="cpn.tourDummyData"\n                   istour="cpn.istour"\n                   list="cpn.list">\n        </chat-list>\n    </div>\n    <div class="col-md-7 rightPanel" ng-if="cpn.selected._id">\n        <chat-mod-new selected="cpn.selected" anim="cpn.anim" constants="cpn.constants" istour="cpn.istour">\n        </chat-mod-new>\n    </div>\n    <div ng-if="(cpn.selectedConv._id)" class="col-md-7 rightPanel">\n        <chat-conv-panel\n            selectedconv="cpn.selectedConv" convmsglist="cpn.convmsglist">\n        </chat-conv-panel>\n    </div>\n</div>');
$templateCache.put('app/pages/config/userList/userList.html','<script type="text/ng-template" id="tourUsersTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep" ng-if="tourStep.isPrev() &&\n                        tourStep.stepId !== \'step10\' && tourStep.stepId !== \'step18\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div class="row">\n    <div ng-class="(ulst.user._id)? \'col-md-6\' : \'col-md-12\'" style="transition: all 0.51s">\n        <users-list list="ulst.users" selectu="ulst.user"\n                    anim="ulst.anim" constants="ulst.constants"\n                    init-tour="ulst.initTour()" istour="ulst.istour"\n                    ng-if="ulst.constants.roles && ulst.constants.branch && ulst.ready">\n        </users-list>\n    </div>\n    <div ng-if="ulst.user._id && ulst.anim" class="col-md-6 rightPanel">\n        <user-detail anim="ulst.anim" constants="ulst.constants" user="ulst.user" istour="ulst.istour"></user-detail>\n    </div>\n</div>');
$templateCache.put('app/pages/dashboard/dashboardCanteenMixedChart/dashboardCanteenMixedChart.html','<style>\n    #mealChartsWrapper.pie-chart-item-container .panel-body {\n        padding-top: 0;\n        padding-left: 0;\n        padding-right: 0;\n    }\n\n    #mealChartsWrapper.pie-chart-item-container .panel-body #mixedDataDiv {\n        margin-left: 0;\n        margin-right: 0;\n    }\n\n    .meal-stats {\n        border-right: solid 1px #3a3636;\n    }\n\n    .meal-stats:last-child {\n        border-right: 0;\n    }\n\n    .meal-stats .chart-panel-title {\n        padding-top: 0;\n        padding-bottom: 12px;\n        padding-left: 25px;\n        font-weight: bold;\n    }\n\n    .meal-stats .chart-panel-title:after {\n        content: \'\';\n        position: absolute;\n        left: 50px;\n        top: 100%;\n        width: 0;\n        height: 0;\n        border-left: 20px solid transparent;\n        border-right: 0 solid transparent;\n        border-top: 20px solid;\n        clear: both;\n    }\n\n    .meal-stats .chart-panel-title i {\n        font-size: 32px;\n        position: relative;\n        top: 6px;\n        margin-right: 5px;\n    }\n\n    .meal-stats .chart-panel-title.sun {\n        background: #8af37e;\n        background: -webkit-gradient(left top, right top, color-stop(0%, #8af37e), color-stop(100%, #91ffc8));\n        background: linear-gradient(to right, #8af37e 0%, #91ffc8 100%);\n        color: #3A3636;\n    }\n\n    .meal-stats .chart-panel-title.sun:after {\n        border-top-color: #8af37e;\n    }\n\n    .meal-stats .chart-panel-title.moon {\n        background-color: #3A3636;\n        color: #8af37e;\n    }\n\n    .meal-stats .chart-panel-title.moon:after {\n        border-top-color: #3A3636;\n    }\n\n    .chartRow {\n        display: -webkit-box;\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .chartRow > [class*=\'col-\'] {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .meal-stats .description-stats {\n        margin: auto;\n        padding-left: 30px;\n    }\n\n    .meal-stats .description-stats > div {\n        font-size: 18px;\n        margin-top: 20px;\n    }\n\n    .meal-stats .description-stats > div .canteen-value {\n        margin-left: 5px;\n    }\n\n    .chartTitle {\n        font-size: 14px;\n        position: relative;\n        top: 12px;\n    }\n\n    .chartRow canvas {\n        background-color: rgba(0, 0, 0, 0.1);\n        border-radius: 5px;\n        margin-top: 15px;\n        margin-bottom: 10px;\n    }\n</style>\n<div class="pie-chart-item-container" id="mealChartsWrapper" style="max-width: 900px;">\n    <div class="panel animated fadeInLeft">\n        <div class="panel-body">\n            <div class="row" id="mixedDataDiv">\n                <div ng-class="{\'col-sm-6\': chartData.length > 1, \'col-sm-12\': chartData.length <= 1}" class="col-xs-12 meal-stats"\n                     ng-repeat="meal in chartData">\n                    <div class="row">\n                        <div class="col-xs-12 chart-panel-title"\n                             ng-class="{\'sun\': meal.icon === \'ion-ios-sunny-outline\', \'moon\': meal.icon !== \'ion-ios-sunny-outline\'}">\n                            <i ng-if="meal.icon" ng-class="meal.icon"></i>\n                            <span>{{meal.description}}</span>\n                        </div>\n                    </div>\n                    <div class="row chartRow">\n                        <div class="col-sm-3 col-xs-12 description-stats" style="width: 100px;">\n                            <div style="color: rgb(145,250,168);" title="{{\'CANTEENMIXEDCHART.OCCUPATION\' | translate }}">\n                                <i class="ion-person-stalker"></i>\n                                <span class="canteen-value">{{ meal.statistics[0].occupation }}</span>\n                            </div>\n                            <div style="color: rgb(255,255,255);" title="{{\'CANTEENMIXEDCHART.RESERVATION\' | translate }}">\n                                <i class="ion-android-list"></i>\n                                <span class="canteen-value">{{ meal.statistics[0].reservation }}</span>\n                            </div>\n                            <div style="color: rgb(161,161,161);" title="{{\'CANTEENMIXEDCHART.SERVICE\' | translate }}">\n                                <i class="tagaste-spoon-knife"></i>\n                                <span class="canteen-value">{{ meal.statistics[0].service }}</span>\n                            </div>\n                        </div>\n                        <div class="col-sm-9 col-xs-12">\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <span class="chartTitle">{{\'CANTEENMIXEDCHART.AVGWEEK\' | translate }}</span>\n                                </div>\n                                <div class="col-xs-12">\n                                    <div style="position: relative; box-sizing: border-box;">\n                                        <canvas class="canvasContainerWeekly-{{meal.description}}" width="200px"></canvas>\n                                    </div>                                    \n                                </div>\n                            </div>\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <span class="chartTitle">{{\'CANTEENMIXEDCHART.AVGMONTH\' | translate }}</span>\n                                </div>\n                                <div class="col-xs-12">\n                                    <div style="position: relative; box-sizing: border-box;">\n                                        <canvas class="canvasContainerMonthly-{{meal.description}}" width="200px"></canvas>\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/dashboard/dashboardIncidentsDonutChart/dashboardIncidentsDonutChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}">\n    <div class="chart-bg"></div>\n    <div class="traffic-chart" id="trafficChart">\n        <div class="canvas-holder">\n            <div class="traffic-text">\n                <span class="totalInci"></span>\n            </div>\n            <canvas width="280" height="280"></canvas>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/dashboard/dashboardMenuPieChart/dashboardMenuPieChart.html','<div class="pie-charts">\n    <div class="pie-chart-item-container" ng-repeat="chart in charts" ng-if="chart.meals && chart.meals.length">\n        <div ba-panel class="pie-chartPointer" ng-click="openDetailCanteen(chart)">\n            <p style="font-size: 16px;">{{ ::chart.description }}</p>\n            <div class="pie-chart-item" ng-repeat="meal in chart.meals track by $index"\n                 ng-class="{\'notLastMeal\': !$last}">\n                <div class="chart" rel="{{ meal.color }}" data-percent="{{ meal.percentage }}">\n                    <span class="percent">{{ meal.percentage }}</span>\n                </div>\n                <div class="description">\n                    <div>{{ meal.description }}</div>\n                    <div class="description-stats">\n                        <i class="{{ meal.icon }}" style="color: {{ meal.color }};"></i>\n                        <span>{{ meal.stats }}</span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/dashboard/dashboardIncidentsMixedChart/dashboardIncidentsMixedChart.html','<div class="pie-chart-item-container">\n    <div class="panel animated fadeInLeft">\n        <div class="panel-body">\n            <div class="pie-chart-item">\n                <div class="channels-block" ng-class="{\'transparent\': transparent}">\n                    <div class="row">\n                        <div class="col-xs-12">\n                            <div style="width: 100%" class="canvasContainer" ng-hide="chartData.noData">\n                            </div>\n                            <div class="canvasContainer" ng-show="chartData.noData">\n                                <span class="animate fadeIn">{{\'INCIDENCESCHART.EMPTYCHART\'|translate}}</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts">\n    <div class="pie-chart-item-container " ng-repeat="chart in dpie.charts">\n                <div ba-panel class="pie-chartPointer" ng-click="ckInChartPanel(chart)" style="border-radius:6px;" ng-class="{\'pieChartActive\': dpie.selected === chart.description}">\n            <div class="pie-chart-item">\n                <div class="chart" rel="{{ ::chart.color }}" data-percent="{{ ::chart.percentage }}">\n                    <span class="percent">{{ ::chart.percentage }}</span>\n                </div>\n                <i class="chart-icon i-{{ ::chart.icon }}"></i>\n                <div class="description">\n                    <div>{{ ::chart.description }}</div>\n                    <div class="statsIcons">\n                        <span style="margin-right: 10px;">{{::chart.stats.beds}}\n                            <span uib-tooltip="{{\'CHART.OCCUPATION.BEDS\' | translate}}"\n                                  tooltip-append-to-body="true"\n                                  class="{{::chart.icons.beds}}"></span>\n                        </span>\n                        <span style="margin-right: 10px;">{{::chart.stats.total}}\n                            <span uib-tooltip="{{\'CHART.OCCUPATION.TOTAL\' | translate}}"\n                                  tooltip-append-to-body="true"\n                                  class="{{::chart.icons.total}}"></span>\n                        </span>\n                        <span style="margin-right: 5px;">{{::chart.stats.eventual}}\n                            <span uib-tooltip="{{\'CHART.OCCUPATION.EVENTUAL\' | translate}}"\n                                  tooltip-append-to-body="true"\n                                  class="{{::chart.icons.eventual}}"></span>\n                        </span>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/incidents/incidentsList/incidentsList.html','<script type="text/ng-template" id="tourIncidentsTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep" ng-if="tourStep.isPrev() &&\n                        tourStep.stepId !== \'step9\' && tourStep.stepId !== \'step17\' && tourStep.stepId !== \'step19\'\n                        && tourStep.stepId !== \'step20\' &&  tourStep.stepId !== \'step24\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div class="row">\n    <div ng-class="(ilc.showIncidentView)? \'col-md-4\' : \'col-md-10\'" style="transition: all 0.5s;">\n        <incidents-list select-incident="ilc.selected" list="ilc.list" pag="ilc.pag" ng-if="ilc.listLoaded"\n                        mode-creation="ilc.modeCreation" init-tour="ilc.initTour()" tour-dummy-data="ilc.tourDummyData"\n                        mode-read-only="ilc.readOnly" anim="ilc.anim" show-incident-view="ilc.showIncidentView"\n                        on-deleted="ilc.reloadList(value)"\n                        istour="ilc.istour"></incidents-list>\n    </div>\n    <div ng-if="ilc.showIncidentView && ilc.anim === true" class="col-md-8">\n        <incident-detail incident-id="ilc.selected" mode-read-only="ilc.readOnly" on-updated="ilc.reloadList(value)"\n                         mode-creation="ilc.modeCreation"\n                         show-incident-view="ilc.showIncidentView" anim="ilc.anim"\n                         show-complete-list="ilc.showCompleteList"\n                         istour="ilc.istour"></incident-detail>\n    </div>\n</div>');
$templateCache.put('app/components/masterTables/masterTablesTax/masterTablesTax.html','<div class="row">\n    <div class="col-md-12">\n        <table ng-table="mttc.configTableParams"\n               class="table table-hover table-condensed fixNgTable" show-filter="false"\n               style="font-size: 11px;">\n\n            <tr ng-repeat="row in $data | showErrorNoData track by $index" style="cursor:pointer;"\n                class="ng-binding">\n                <td colspan="6" ng-if="row.error" ng-src="{{row.error}}">\n                    {{row.error}}\n                </td>\n\n                <!--name-->\n                <td data-title="\'MASTERTABLES.CONFIG.NAME\'|translate"\n                    sortable="\'name\'" ng-attr-title="{{row.name}}">\n                    <span ng-if="!row.modeEdit">{{row.name}}</span>\n                    <input type="text" ng-model="row.name" name="name_{{$index +1}}"\n                           class="form-control with-primary-addon" id="name_{{$index +1}}"\n                           required ng-if="row.modeEdit">\n                </td>\n\n                <!--rate-->\n                <td data-title="\'MASTERTABLES.CONFIG.CODE\'|translate"\n                    sortable="\'rate\'" ng-attr-title="{{row.rate}}">\n                    <span ng-if="!row.modeEdit">{{row.rate}}</span>\n                    <input type="number" ng-model="row.rate" name="rate_{{$index +1}}"\n                           class="form-control with-primary-addon"\n                           id="rate_{{$index +1}}" required ng-if="row.modeEdit">\n                </td>\n\n                <!--isPercentage-->\n                <td data-title="\'MASTERTABLES.CONFIG.IS_PERCENTAGE\'|translate"\n                    sortable="\'isPercentage\'" ng-attr-title="{{row.isPercentage}}">\n                    <span ng-if="!row.modeEdit">{{row.isPercentage.value ? (\'BUTTONS.YES\' | translate) : (\'BUTTONS.NO\' | translate)}}</span>\n                    <ui-select ng-model="row.isPercentage" ng-if="row.modeEdit" id="isPercentage_{{$index +1}}"\n                               name="isPercentage_{{$index +1}}"\n                               style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                               class="btn-group bootstrap-select form-control"\n                               append-to-body="false">\n                        <ui-select-match placeholder="{{\'MASTERTABLES.CONFIG.IS_PERCENTAGE\'| translate}}">\n                            <span> {{row.isPercentage.name}}</span>\n                        </ui-select-match>\n                        <ui-select-choices repeat="option in mttc.constants.binary |\n                                            uiSelectFilter: {description:$select.search}">\n                            <span ng-bind-html="option.name | highlight: $select.search"></span>\n                        </ui-select-choices>\n                    </ui-select>\n                </td>\n\n                <!--buttons-->\n                <td ng-if="!mttc.readonly && !row.modeEdit && mttc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-pencil iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.EDIT\' | translate}}"\n                       ng-if="!row.modeEdit && !mttc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mttc.editConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mttc.readonly && !row.modeEdit && mttc.isEditable(row)" style="width: 20px;">\n                    <i class="fa fa-trash-o iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.DELETE\' | translate}}"\n                       ng-if="!row.modeEdit && !mttc.addingConfig && !row.error" aria-hidden="true"\n                       tagaste-click="mttc.deleteConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mttc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-ok iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.SAVE\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mttc.saveConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n\n                <td ng-if="!mttc.readonly && row.modeEdit" style="width: 20px;">\n                    <i class="glyphicon glyphicon-remove  iconNgTable edit"\n                       uib-tooltip="{{\'BUTTONS.CANCEL\' | translate}}"\n                       ng-if="row.modeEdit" aria-hidden="true"\n                       tagaste-click="mttc.cancelConfig(row, $index); $event.stopPropagation();">\n                    </i>\n                </td>\n            </tr>\n        </table>\n    </div>\n</div>\n\n<div class="row" ng-if="!mttc.addingConfig">\n    <div class="col-xs-12 countAndNewButton">\n        <span style="flex-grow: 1" class="count"><span id="totalItems">\n            {{ \'TOTAL\' | translate }} : {{ mttc.configTableParams.total() }}</span></span>\n        <button type="button"\n                tagaste-click="mttc.addConfig();$event.stopPropagation();"\n                class="btn btn-success btn-with-icon pull-right newButton" id="newConfigButton">\n            <i class="fa fa-plus"></i>{{\'BUTTONS.NEW\' | translate}}\n        </button>\n    </div>\n</div>\n');
$templateCache.put('app/pages/masterTables/masterTablesList/masterTablesList.html','<master-tables-panel-component></master-tables-panel-component>');
$templateCache.put('app/components/users/userDetail/userDetail.html','<div class="detail-panel">\n    <div ng-if="udetc.userBD !== null"\n        ba-panel ba-panel-title-no-translate="<b>{{udetc.user.name}} {{udetc.user.surname}}</b>"\n        ba-panel-class="with-scroll"\n        ba-panel-anim="zoom-in"\n        style="line-height:30px;"\n        id="usersDetail">\n        <form name="usrForm" autocomplete="false">\n            <div class="row ">\n                <div class="col-md-4 col-sm-5 no-float text-center" style="vertical-align: middle">\n                    <avatar type="person" shape="square"\n                            readonly="( udetc.readonly || udetc.istour )"\n                            img="udetc.avatar"\n                            uploading="udetc.avatarUploading"\n                            photo="udetc.userBD.photo"></avatar>\n                </div>\n                <div class="col-md-8 col-sm-7 no-float" style="">\n                    <div class="row" ng-if="udetc.user._id !== \'0\'">\n                        <div class="col-xs-6">\n                            <ba-switcher switcher-style="primary"\n                                switcher-value="udetc.userBD.tokenApp"\n                                switcher-icon-on="\'ion-iphone\'" switcher-icon-off="\'ion-iphone\'"\n                                switcher-read-only="true"\n                                uib-tooltip="{{\'RESIDENTWINDOWDETAIL.ACESSAPP\' | translate}}"\n                                tooltip-placement="bottom"></ba-switcher>\n                            <button type="button" style="position: absolute; top: 0; margin-left: 10px;"\n                                    ng-if="!udetc.readonly && udetc.userBD.tokenApp"\n                                    ng-click="udetc.configava(false)" class="btn btn-success btn-with-icon">\n                                <i class="ion-iphone"></i>{{\'BUTTONS.DELETEACCESS\' |translate}}\n                            </button>\n                        </div>\n                        <div class="col-xs-6">\n                            <ba-switcher switcher-style="primary"\n                                        ng-disabled="udetc.readonly"\n                                        class="pull-right"\n                                        switcher-value="udetc.userBD.active"\n                                        switcher-on="\'BULLETINBOARDDETAIL.ACTIVE\'|translate"\n                                        switcher-off="\'BULLETINBOARDDETAIL.ACTIVE\'|translate"\n                                        switcher-read-only="udetc.readonly"\n                                        uib-tooltip="{{\'BULLETINBOARDDETAIL.ACTIVE\' | translate}}"\n                                        tooltip-placement="bottom">\n                            </ba-switcher>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-sm-6" style="line-height: 0;">\n\n                            <div ng-repeat="rol in udetc.constants.roles track by $index">\n                                <div class="checkbox" ng-click="udetc.changeBasicRole(rol)" ng-if="!rol.isExtraRole">\n                                    <label class="custom-checkbox">\n                                        <input type="checkbox" id="{{$index}}" name="{{$index}}"\n                                            ng-disabled="udetc.readonly"\n                                            ng-model="rol.selected">\n                                        <span>{{rol.description}}</span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                        <div class="col-sm-6" style="line-height: 0;">\n                            <div ng-repeat="rol in udetc.constants.roles track by $index">\n                                <div class="checkbox" ng-click="udetc.changeExtraRole(rol)" ng-if="rol.isExtraRole">\n                                    <label class="custom-checkbox">\n                                        <input type="checkbox" id="{{$index}}" name="{{$index}}"\n                                            ng-disabled="udetc.readonly"\n                                            ng-model="rol.selected">\n                                        <span>{{rol.description}}</span>\n                                    </label>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class="row">\n                        <div class="col-sm-12" style="min-height: 46px">\n                            <div class="input-group"\n                                ng-if="!(udetc.userBD.role.code === udetc.constants.roleCodes.director)">\n                                <span class="input-group-addon input-group-addon-primary addon-left"\n                                    uib-tooltip="{{\'CANTEENDETAIL.SELECTRESIDENCE\' | translate}}"\n                                    tooltip-placement="top-left">\n                                        <span class="ion-card"></span>\n                                </span>\n                                <ui-select\n                                    name="selRes"\n                                    required\n                                    multiple ng-model="udetc.userBD.branches"\n                                    ng-disabled="(udetc.readonly ||\n                                    (udetc.userBD.role.code === udetc.constants.roleCodes.director))"\n                                    ng-class="{\'invalid\' : udetc.submitted && (udetc.userBD.branches.length < 1 && !udetc.readonly)}"\n                                    append-to-body="true"\n                                    search-enabled="true">\n                                    <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}">\n                                        {{$item.description}}\n                                    </ui-select-match>\n                                    <ui-select-choices\n                                        repeat="branches in udetc.constants.branch |\n                                        findResidence:{find:$select.search,alredy:udetc.userBD.branches}">\n                                        <span ng-bind-html="branches.description | highlight: $select.search"></span>\n                                    </ui-select-choices>\n                                </ui-select>\n                            </div>\n                            <div class="errorValidation bounceIn animate"\n                                ng-if="udetc.submitted && (udetc.userBD.branches.length < 1 && !udetc.readonly)">\n                                *{{\'ERROR.NOTVALIDRESIDENCE\' |translate}}\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class="row" style="margin-left:10px;margin-right:10px">\n                <div class="col-md-12 panelTitle" style="margin-bottom:17px;">\n                    {{\'USERWINDOWDETAIL.ABOUT\' | translate}}\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-sm-6">\n                    <div class="input-group">\n                                    <span uib-tooltip="{{\'USERWINDOWDETAIL.NAME\' | translate}}"\n                                        class="input-group-addon input-group-addon-primary addon-left"><span\n                                        class="ion-android-person"></span></span>\n                                        <input type="text"\n                                            name="name"\n                                            id="name"\n                                            required\n                                            ng-class="{\'invalid\':(usrForm.name.$touched||udetc.submitted) &&\n                                            !usrForm.name.$valid }"\n                                            ng-disabled="udetc.readonly"\n                                            class="form-control with-primary-addon"\n                                            placeholder="{{\'USERWINDOWDETAIL.NAME\'|translate}}"\n                                            autocomplete="false"\n                                            ng-model="udetc.userBD.name">\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if=" (usrForm.name.$touched||udetc.submitted) && !usrForm.name.$valid">\n                        {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                    </div>\n                </div>\n                <div class="col-sm-6">\n                    <div class="input-group">\n                            <span\n                                uib-tooltip="{{\'USERWINDOWDETAIL.LASTNAME\' | translate}}"\n                                class="input-group-addon input-group-addon-primary addon-left"><span\n                                class="ion-android-person"></span></span>\n                                <input type="text"\n                                    name="lastname"\n                                    required\n                                    ng-disabled="udetc.readonly"\n                                    class="form-control with-primary-addon"\n                                    autocomplete="false"\n                                    ng-class="{\'invalid\':(usrForm.lastname.$touched || udetc.submitted) &&\n                                    !usrForm.lastname.$valid }"\n                                    placeholder="{{\'USERWINDOWDETAIL.LASTNAME\'|translate}}"\n                                    aria-describedby="basic-addon1"\n                                    ng-model="udetc.userBD.surname">\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="(usrForm.lastname.$touched || udetc.submitted) && !usrForm.lastname.$valid">\n                        {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                    </div>\n                </div>\n            </div>\n            <div class="row">\n                <div class="col-sm-6">\n                    <div class="input-group" style="z-index: 3">\n                        <span class="input-group-addon  input-group-addon-primary addon-left"\n                            uib-tooltip="{{\'USERWINDOWDETAIL.EMAIL\' | translate}}"><span\n                            class="ion-android-person"></span></span>\n                            <input type="text"\n                                ng-required="!udetc.user.action === \'inEdit\'"\n                                autocomplete="new-password"\n                                name="email"\n                                ng-class="{\'invalid\': (usrForm.email.$touched || udetc.submitted) &&\n                                usrForm.email.$pristine && !udetc.readonly && udetc.userBD.username === \'\' }"\n                                ng-disabled="udetc.readonly"\n                                class="form-control with-primary-addon has-error"\n                                placeholder="{{\'USERWINDOWDETAIL.EMAIL\'|translate}}"\n                                aria-describedby="basic-addon1"\n                                ng-blur="udetc.emailInUse(udetc.userBD.username,usrForm.email)"\n                                ng-model="udetc.userBD.username">\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="!udetc.validEmail(udetc.userBD.username,usrForm.email)">\n                        {{\'ERROR.NOTVALIDEMAIL\' |translate}}\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="udetc.mailExist && udetc.mailExist  === true">\n                        <span> {{\'ERROR.ERRORUSERALREADYINUSE\'|translate}}</span>\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="(usrForm.email.$touched|| udetc.submitted) && usrForm.email.$pristine &&\n                        !udetc.readonly && udetc.userBD.username === \'\'">\n                        {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                    </div>\n                </div>\n\n                <div class="col-sm-6">\n                    <div class="input-group">\n                        <span\n                            uib-tooltip="{{\'USERWINDOWDETAIL.PHONE\' | translate}}"\n                            class="input-group-addon input-group-addon-primary addon-left"><span\n                            class="fa fa-phone"></span></span>\n                            <input type="text"\n                                name="phon"\n                                ng-disabled="udetc.readonly"\n                                class="form-control with-primary-addon"\n                                autocomplete="false"\n                                ng-change="udetc.validateMobile(udetc.userBD.phone,usrForm.phon)"\n                                ng-blur="udetc.validateMobile(udetc.userBD.phone,usrForm.phon)"\n                                placeholder="{{\'USERWINDOWDETAIL.PHONE\'|translate}}"\n                                aria-describedby="basic-addon1"\n                                ng-model="udetc.userBD.phone">\n                    </div>\n                    <div class="errorValidation invalidInputMsg bounceIn animate"\n                        ng-if="( usrForm.phon.$touched || udetc.submitted) && !usrForm.phon.$valid">\n                        {{\'ERROR.GENERROR0\' |translate}}\n                        {{\'RESIDENTWINDOWDETAIL.PHONE\'|translate}}\n                        {{\'ERROR.GENERROR1\' |translate}}\n                    </div>\n                    <div class="input-group slideInUp animated"\n                        ng-if="(!udetc.readonly && udetc.changePasswordMode)">\n                        <span\n                            tooltip-placement="top-left"\n                            tooltip-append-to-body="true"\n                            uib-tooltip="{{\'USERWINDOWDETAIL.PASSWORD\' | translate}}"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-android-person"></span></span>\n                            <input name="pw"\n                                type="password"\n                                required\n                                class="form-control with-primary-addon"\n                                ng-disabled="udetc.readonly"\n                                autocomplete="new-password"\n                                placeholder="{{\'USERWINDOWDETAIL.PASSWORD\'|translate}}"\n                                aria-describedby="basic-addon1"\n                                ng-model="udetc.userBD.newPass">\n                    </div>\n                    <div class="input-group slideInUp animated"\n                        ng-if="(!udetc.readonly && udetc.changePasswordMode && udetc.userBD.newPass\n                    && udetc.userBD.newPass !== \'\')">\n                        <span\n                            tooltip-placement="top-left"\n                            uib-tooltip="{{\'USERWINDOWDETAIL.REPASSWORD\' | translate}}"\n                            class="input-group-addon input-group-addon-primary addon-left">\n                            <span class="ion-android-person"></span></span>\n                            <input type="password"\n                                name="repw"\n                                tooltip-append-to-body\n                                autocomplete="false"\n                                ng-disabled="udetc.readonly"\n                                class="form-control with-primary-addon"\n                                placeholder="{{\'USERWINDOWDETAIL.REPASSWORD\'|translate}}"\n                                ng-model="udetc.userBD.reNewPass">\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="!udetc.validPassWord(usrForm.repw,usrForm.pw)">\n                        {{\'ERROR.PASSWORDNOTMATCH\' |translate}}\n                    </div>\n                    <div class="errorValidation bounceIn animate"\n                        ng-if="(usrForm.pw.$touched || udetc.submitted)  && (!usrForm.pw.$valid || udetc.pass === \'\')">\n                        {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                    </div>\n                </div>\n            </div>\n\n            <div class="row">\n                <div class="col-sm-12">\n                    <uib-accordion>\n                        <uib-accordion-group heading="{{\'RESIDENTWINDOWDETAIL.OTHERINFO\' | translate}}"\n                                            is-open="udetc.otherinfoopen"\n                                            panel-class="panel-primary accordion-panel">\n                            <uib-accordion-heading>\n                                {{\'RESIDENTWINDOWDETAIL.OTHERINFO\' | translate}}\n                                <i class="pull-right glyphicon"\n                                ng-class="{\'glyphicon-chevron-down\': udetc.otherinfoopen,\n                                        \'glyphicon-chevron-right\': !udetc.otherinfoopen}"></i>\n                            </uib-accordion-heading>\n                            <div class="row">\n                                <div class="col-xs-12">\n                                    <div class="input-group">\n                                    <span class="input-group-addon input-group-addon-primary addon-left"\n                                        uib-tooltip="{{\'SERVICEMENUDETAIL.TEXT\' | translate}}"\n                                        tooltip-placement="right-top"\n                                        style="vertical-align: top;">\n                                        <span class="ion-android-create"></span></span>\n                                        <textarea ng-model="udetc.userBD.comments" name="text"\n                                                class="form-control with-primary-addon"\n                                                aria-describedby="basic-addon1" ng-disabled="udetc.readonly"\n                                                placeholder="{{\'RESIDENTWINDOWDETAIL.OTHERCOMENTS\'|translate}}">\n                                            </textarea>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                        <uib-accordion-group heading="{{\'RESIDENTWINDOWDETAIL.ATTACHEDS\' | translate}}"\n                                            is-open="udetc.attachedsfoopen"\n                                            panel-class="panel-primary accordion-panel">\n                            <uib-accordion-heading>\n                                {{\'RESIDENTWINDOWDETAIL.ATTACHEDS\' | translate}}\n                                <i class="pull-right glyphicon"\n                                ng-class="{\'glyphicon-chevron-down\': udetc.attachedsfoopen,\n                                        \'glyphicon-chevron-right\': !udetc.attachedsfoopen}"></i>\n                            </uib-accordion-heading>\n                            <div class="row">\n                                <div class="col-sm-12">\n                                    <div class="input-group">\n                                        <span class="input-group-addon input-group-addon-primary addon-left"\n                                            uib-tooltip="{{\'SERVICEMENUDETAIL.ATTACHEDS\' | translate}}"\n                                            tooltip-placement="right-top"\n                                            style="vertical-align: top">\n                                            <span class="ion-camera"></span>\n                                        </span>\n                                        <!-- <div style="border: 1px solid rgb(55, 55, 55);max-height: 167px; overflow-x:hidden;" -->\n                                        <div style="border: 1px solid rgb(55, 55, 55);overflow-x:hidden;"\n                                            ng-style="udetc.userBD.attacheds.length > 2 ? {\'overflow\' : \'auto\'}:\'\'"\n                                            class="tagast-files"\n                                            id="residentAttacheds"\n                                            readonly="udetc.readonly">\n\n                                            <div class="tagaste-file-add" ng-if=\'!udetc.readonly\'>\n                                                <file\n                                                    img="udetc.file"\n                                                    file-style="display: inline"\n                                                    style="cursor:pointer;"\n                                                    uploading="udetc.fileUploading"\n                                                    ng-disabled="udetc.readonly"\n                                                    style-button="true"\n                                                    attacheds-list="udetc.userBD.attacheds">\n                                                </file>\n                                            </div>\n                                            <div class="file-list"\n                                                style="overflow-x: hidden; overflow-y:auto;"\n                                                scroll-glue-right="!glued;">\n                                                <div class="img-card-row" ng-repeat="attached in udetc.userBD.attacheds track by $index"\n                                                    ng-if="udetc.userBD.attacheds.length > 0">\n                                                    <card-file\n                                                        attached="attached"\n                                                        readonly="udetc.readonly"\n                                                        uploading="udetc.fileUploading"\n                                                        only-users="true"\n                                                        max-long-name="8">\n                                                    </card-file>\n                                                </div>\n                                            </div>\n\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                        <uib-accordion-group panel-class="panel-primary accordion-panel "\n                                            ng-if="udetc.gotAccessMedical === true"\n                                            is-open="udetc.medicalinopen">\n                            <uib-accordion-heading>\n                                {{\'RESIDENTWINDOWDETAIL.MEDICALIN\' | translate}}\n                                <i class="pull-right glyphicon"\n                                ng-class="{\'glyphicon-chevron-down\': udetc.medicalinopen,\n                                        \'glyphicon-chevron-right\': !udetc.medicalinopen}"></i>\n                            </uib-accordion-heading>\n                            <div class="row">\n                                <div ng-class="\'col-xs-12 col-sm-6\'">\n                                    <div class="input-group">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                            uib-tooltip="{{\'SERVICEMENUDETAIL.TEXT\' | translate}}" tooltip-placement="bottom-left"\n                            style="vertical-align: top">\n                            <span class="ion-android-create"></span></span>\n                                        <textarea ng-model="udetc.userBD.allergy.comments" name="text"\n                                                class="form-control with-primary-addon"\n                                                aria-describedby="basic-addon1" ng-disabled="udetc.readonly"\n                                                placeholder="{{\'RESIDENTWINDOWDETAIL.ALLERGENS\'|translate}}">\n                                            </textarea>\n                                    </div>\n                                </div>\n                                <div ng-class="\'col-xs-12 col-sm-6\'" class="">\n                                    <p style="margin-bottom:0;margin-top:0;font-size:13px;color:#90fdc1">\n                                        {{\'RESIDENTWINDOWDETAIL.FOODALLERGENS\' |translate}}</p>\n                                    <div style="align-self:left; text-align: left;margin-bottom:7px;"\n                                        class="titleBorderTop">\n                                        <div ng-repeat="allergy in udetc.allergies" style="display: inline-block; margin-left:4px;margin-right:4px;\n                                                margin-bottom:-1px;font-size: 18px">\n                                            <i uib-tooltip="{{allergy.description}}" class="{{allergy.icon}}"\n                                            ng-click="udetc.changeAllerge(allergy,usrForm)"\n                                            ng-style="allergy.selected ?\n                                                    { \'color\': \'rgba(128, 254, 193, 1)\' } :\n                                                    { \'color\': \'rgba(128, 254, 193, 0.3)\'}"></i>\n                                            <!-- in TODO: getting styles by api -->\n                                        </div>\n                                    </div>\n                                </div>\n                            </div>\n                        </uib-accordion-group>\n                    </uib-accordion>\n                </div>\n            </div>\n\n            <div class="row">\n                <div class="col-sm-12" style="margin-top:13px;">\n                    <p ng-if="udetc.submitted && !udetc.readonly && !usrForm.$valid"\n                    class="pull-right errorValidation bounceIn animate">{{\'ERROR.ERRORININPUT\' |translate}}</p>\n                </div>\n            </div>\n        </form>\n        <div class="panel-footer-buttons">\n            <div class="row">\n                <div class="pull-right">\n                    <button style="margin-right: 17px; margin-top: 30px; margin-bottom: 7px;"\n                            type="button"\n                            ng-if="udetc.readonly"\n                            ng-click="udetc.back()"\n                            class="btn btn-success btn-with-icon">\n                        <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                    </button>\n                    <button\n                        style="margin-right: 17px; margin-top: 30px; margin-bottom: 7px;"\n                        type="button"\n                        id="usersCancelButton"\n                        ng-click="udetc.back()"\n                        ng-if="!udetc.readonly"\n                        ng-disabled="udetc.istour"\n                        class="btn btn-success btn-with-icon">\n                        <i class="ion-arrow-left-c"></i>{{\'BUTTONS.CANCEL\' |translate}}\n                    </button>\n                    <button\n                        style="margin-right: 17px; margin-top: 30px; margin-bottom: 7px;"\n                        type="button"\n                        id="usersSaveButton"\n                        ng-click="udetc.save(usrForm)"\n                        ng-if="!udetc.readonly"\n                        ng-disabled="udetc.istour || (!udetc.user.action === \'inEdit\') || ( udetc.submitted &&  !usrForm.$valid) || udetc.avatarUploading"\n                        class="btn btn-success btn-with-icon">\n                        <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/pages/requests/requestsList/requestsList.html','<script type="text/ng-template" id="tourRequestsTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep" ng-if="tourStep.isPrev() &&\n                        tourStep.stepId !== \'step9\' && tourStep.stepId !== \'step17\' && tourStep.stepId !== \'step19\'\n                        && tourStep.stepId !== \'step20\' &&  tourStep.stepId !== \'step24\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n\n\n<div class="row">\n    <div ng-class="rqlc.selected._id ? \'col-md-4\' : \'col-md-12\'" style="transition: all 0.51s;">\n        <requests-list-component \n            anim="rqlc.anim"\n            selectr="rqlc.selected"\n            list="rqlc.list"\n            init-tour="rqlc.initTour()"\n            tour-dummy-data="rqlc.tourDummyData"\n            istour="rqlc.istour">\n        </requests-list-component>\n    </div>\n\n    <div class="col-md-8" ng-if="rqlc.selected._id && rqlc.ready && rqlc.anim === true">\n        <requests-detail-component \n            anim="rqlc.anim"\n            constants="rqlc.constants" \n            request="rqlc.selected"></requests-detail-component>\n    </div>\n</div>\n');
$templateCache.put('app/pages/residents/residentsList/residentsList.html','<script type="text/ng-template" id="tourResidentsTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep"\n                                ng-if="tourStep.isPrev() && tourStep.stepId !== \'step12\' &&\n                                tourStep.stepId !== \'step19\'" ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div class="row">\n    <div ng-class="(rlst.selected._id)? \'col-md-4\' : \'col-md-12\'" style="transition: all 0.51s;">\n        <residents-list selectu="rlst.selected"\n                        list="rlst.list"\n                        anim="rlst.anim"\n                        pag="rlst.pag"\n                        constants="rlst.constants"\n                        init-tour="rlst.initTour()" tour-dummy-data="rlst.tourDummyData"\n                        ng-if="rlst.constants.roles && rlst.constants.branch && rlst.ready && rlst.showPayment === false"\n                        istour="rlst.istour">\n        </residents-list>\n    </div>\n    <div ng-if="rlst.selected._id && rlst.anim === true && rlst.showPayment === false" class="col-md-8">\n        <resident-detail\n            anim="rlst.anim"\n            constants="rlst.constants"\n            resident="rlst.selected"\n            istour="rlst.istour"\n            show-payment="rlst.showPayment">\n        </resident-detail>\n    </div>\n    <div ng-if="rlst.selected._id && rlst.anim === true && rlst.showPayment === true" class="col-md-12">\n            <payment\n                anim="rlst.anim"\n                constants="rlst.constants"\n                resident="rlst.selected"\n                istour="rlst.istour"\n                show-payment="rlst.showPayment">\n            </payment>\n        </div>\n</div>\n');
$templateCache.put('app/pages/reservations/reservationsList/reservationsList.html','\n<div class="row">\n    <div ng-class="rslc.selected._id ? \'col-md-4\' : \'col-md-12\'" style="transition: all 0.51s;">\n        <reservations-list-component\n            anim="rslc.anim"\n            selectr="rslc.selected"\n            guest="rslc.guest"\n            identity="rslc.identity"\n            list="rslc.list"\n            init-tour="rslc.initTour()"\n            tour-dummy-data="rslc.tourDummyData"\n            istour="rslc.istour">\n        </reservations-list-component>\n    </div>\n    <div class="col-md-8" ng-if="rslc.selected._id  && rslc.anim === true">\n        <reservation-detail-component\n            selectr="rslc.selected"\n            guest="rslc.guest"\n            identity="rslc.identity"\n            constants="rslc.constants"\n            anim="rslc.anim">\n        </reservation-detail-component>\n    </div>\n</div>\n');
$templateCache.put('app/pages/rooms/roomsPieChart/roomsPieChart.html','<div class="row rooms-charts">\n    <div class="rooms-chart-item-container" ng-repeat="chart in rpie.charts" >           \n        <div class="rooms-chartPointer">\n            <div class="rooms-chart-item">\n                <div class="roomchart" rel="{{ ::chart.color }}" data-percent="{{ ::chart.percentage }}">\n                    <span class="numberValue">{{ chart.value }}</span>\n                    <div class="row chartRoomsSubtitle">{{ ::chart.description}}</div>   \n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/services/servicesMenu/serviceMenu.html','<script type="text/ng-template" id="tourServicesTemplate.html">\n    <div class="popoverUserProfile">\n        <div class="popover-content tour-step-content"\n             bind-html-compile="tourStep.trustedContent || tourStep.content"></div>\n        <div class="popover-navigation tour-step-navigation">\n            <div class="row">\n                <div class="col-xs-7">\n                    <div class="btn-group">\n                        <button type="button" class="btn btn-sm btn-default btnPrevStep" ng-if="tourStep.isPrev()\n                        && tourStep.stepId !== \'step11\' && tourStep.stepId !== \'step16\' &&\n                        tourStep.stepId !== \'step18\' && tourStep.stepId !== \'step21\'"\n                                ng-click="tour.prev()">\n                            &laquo; {{\'TOUR.BUTTONS.BACK\'|translate}}\n                        </button>\n                        <button type="button" class="btn btn-sm btn-default btnNextStep" ng-if="tourStep.isNext()"\n                                ng-click="tour.next()">\n                            {{\'TOUR.BUTTONS.NEXT\'|translate}} &raquo;\n                        </button>\n                    </div>\n                </div>\n                <div class="col-xs-5 text-right">\n                    <button type="button" class="btn btn-sm btn-default btnFinishTour" ng-click="tour.end()">\n                        {{\'TOUR.BUTTONS.FINISH\'|translate}}\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</script>\n<div class="row">\n    <div ng-class="(sces.servic._id || sces.showReserveView )? ((sces.notification && sces.notification.showPanel) ? \'col-sm-4\' : \'col-sm-6\' ): \'col-sm-12\'" style="transition: all 0.51s;" class="col-xs-12">\n        <in-service-list-com servic="sces.servic"\n                             list="sces.list"\n                             anim="sces.anim"\n                             anim-schedule="sces.animSchedule"\n                             pag="sces.pag"\n                             constants="sces.constants"\n                             selected-resident="sces.selectedResident"\n                             ng-if="sces.list.length >= 0"\n                             istour="sces.istour"\n                             show-reserve-view = "sces.showReserveView"\n                             mode-cancel="sces.modeCancel"\n                             init-tour="sces.initTour()"\n                             tour-dummy-data="sces.tourDummyData"></in-service-list-com>\n    </div>\n    <div ng-if="sces.servic._id && sces.anim === true"\n         ng-class="((sces.notification && sces.notification.showPanel) || sces.animResident)? \'col-sm-4\' : \'col-md-6\'" class="col-xs-12">\n        <in-service-detail-com\n            anim="sces.anim"\n            servic="sces.servic"\n            constants="sces.constants"\n            notification="sces.notification"\n            selected-resident="sces.selectedResident"\n            anim-resident="sces.animResident"\n            constants="sces.constants"\n            show-complete-list="sces.showCompleteList"\n            istour="sces.istour"></in-service-detail-com>\n        </div>\n        \n    <div ng-if="sces.notification && sces.notification.showPanel && sces.servic.animNotification" class="col-xs-4">\n        <notification-push notification="sces.notification"></notification-push>\n    </div>\n\n    <!--<div ng-if="sces.showReserveView" class="col-xs-6" rightPanel>-->\n        <!--<in-service-reserve-->\n            <!--level="2"-->\n            <!--anim-schedule="sces.animSchedule"-->\n            <!--service="sces.servic"-->\n            <!--show-reserve-view = "sces.showReserveView"-->\n            <!--mode-cancel="sces.modeCancel">-->\n        <!--</in-service-reserve>-->\n    <!--</div>-->\n</div>');
$templateCache.put('app/pages/tasks/tasksList/tasksList.html','<div class="row">\n    <div ng-class="(tlc.showTaskView || tlc.showTaskSchedulerView)? \'col-md-4\' : \'col-md-12\'" style="transition: all 0.5s">\n\n        <tasks-list select-task="tlc.selected" list="tlc.list" pag="tlc.pag" ng-if="tlc.listLoaded" show-task-scheduler-view="tlc.showTaskSchedulerView"\n                        mode-creation="tlc.modeCreation" mode-read-only="tlc.readOnly" anim="tlc.anim"\n                        show-task-view="tlc.showTaskView" on-deleted="tlc.reloadList(value)"></tasks-list>\n\n        <task-scheduler-list select-task-scheduler="tlc.taskSchedulerSelected" list="tlc.taskSchedulerList"\n                             pag="tlc.taskSchedulerPag" ng-if="tlc.listTSLoaded"\n                             mode-creation="tlc.modeCreationTS" mode-read-only="tlc.readOnlyTS" anim="tlc.anim"\n                             show-task-scheduler-view="tlc.showTaskSchedulerView" mode-edit="tlc.modeEditTS"\n                             on-deleted="tlc.reloadTaskSchedulerListt(value)" show-task-view="tlc.showTaskView"></task-scheduler-list>\n    </div>\n    <div ng-if="(tlc.showTaskView || tlc.showTaskSchedulerView) && tlc.anim === true" class="col-md-8">\n        <div ng-if="tlc.showTaskView && !tlc.showTaskSchedulerView">\n            <task-detail task-id="tlc.selected" mode-read-only="tlc.readOnly" on-updated="tlc.reloadList(value)"\n                     mode-creation="tlc.modeCreation" show-task-view="tlc.showTaskView" anim="tlc.anim"\n                     show-complete-list="tlc.showCompleteList"></task-detail>\n        </div>\n        <div ng-if="tlc.showTaskSchedulerView && !tlc.showTaskView">\n        <task-scheduler-detail task-scheduler-id="tlc.taskSchedulerSelected" mode-read-only="tlc.readOnlyTS" mode-edit="tlc.modeEditTS"\n                               show-task-scheduler-view="tlc.showTaskSchedulerView" mode-creation="tlc.modeCreationTS"\n                               anim="tlc.anim" on-updated="tlc.reloadTaskSchedulerListt(value)"></task-scheduler-detail>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/workerTask/workerTaskList/workerTaskList.html','<div class="row">\n    <div class="col-xs-12">\n        <in-worker-task-list-com></in-worker-task-list-com>\n    </div>\n</div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets">\n  <div class="row">\n\n    <div class="col-md-6"\n         ba-panel\n         ba-panel-title="Basic"\n         ba-panel-class="with-scroll">\n      <div >\n        <div class="alert bg-success">\n          <strong>Well done!</strong> You successfully read this important alert message.\n        </div>\n        <div class="alert bg-info">\n          <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.\n        </div>\n        <div class="alert bg-warning">\n          <strong>Warning!</strong> Better check yourself, you\'re not looking too good.\n        </div>\n        <div class="alert bg-danger">\n          <strong>Oh snap!</strong> Change a few things up and try submitting again.\n        </div>\n      </div>\n    </div>\n\n    <div class="col-md-6"\n         ba-panel\n         ba-panel-title="Dismissible alerts"\n         ba-panel-class="with-scroll">\n      <div >\n        <div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n          <strong>Well done!</strong> You successfully read this important alert message.\n        </div>\n        <div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n          <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.\n        </div>\n        <div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n          <strong>Warning!</strong> Better check yourself, you\'re not looking too good.\n        </div>\n        <div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n          <strong>Oh snap!</strong> Change a few things up and try submitting again.\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n  <div class="row">\n\n    <div class="col-md-6"\n         ba-panel\n         ba-panel-title="Links in alerts"\n         ba-panel-class="with-scroll">\n      <div >\n        <div class="alert bg-success">\n          <strong>Well done!</strong> You successfully read <a href class="alert-link">this important alert message</a>.\n        </div>\n        <div class="alert bg-info">\n          <strong>Heads up!</strong> This <a href class="alert-link">alert needs your attention</a>, but it\'s not super important.\n        </div>\n        <div class="alert bg-warning">\n          <strong>Warning!</strong> Better check yourself, you\'re <a href class="alert-link">not looking too good</a>.\n        </div>\n        <div class="alert bg-danger">\n          <strong>Oh snap!</strong> <a href class="alert-link">Change a few things up</a> and try submitting again.\n        </div>\n      </div>\n    </div>\n\n    <div class="col-md-6"\n         ba-panel\n         ba-panel-title="Composite alerts"\n         ba-panel-class="with-scroll">\n      <div >\n        <div class="alert bg-warning">\n          <h4>Warning!</h4>\n          <strong>Pay attention.</strong> Change a few things up and try submitting again.\n          <div class="control-alert">\n            <button type="button" class="btn btn-danger">Pay Attention</button>\n            <button type="button" class="btn btn-primary">Ignore</button>\n          </div>\n        </div>\n      </div>\n    </div>\n\n  </div>\n\n</div>\n');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets">\n  <div class="row">\n    <div class="col-md-3"\n         ba-panel\n         ba-panel-title="Flat Buttons"\n         ba-panel-class="with-scroll button-panel">\n      <div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div>\n    </div>\n    <div class="col-md-3"\n         ba-panel\n         ba-panel-title="Raised Buttons"\n         ba-panel-class="with-scroll button-panel">\n      <div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div>\n    </div>\n    <div class="col-md-3"\n         ba-panel\n         ba-panel-title="Different sizes"\n         ba-panel-class="with-scroll button-panel df-size-button-panel">\n      <div class="button-wrapper"><button type="button" class="btn btn-default  btn-xs">Default</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-primary  btn-sm">Primary</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div>\n    </div>\n    <div class="col-md-3"\n         ba-panel\n         ba-panel-title="Disabled"\n         ba-panel-class="with-scroll button-panel">\n      <div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div>\n      <div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-6">\n      <div\n          ba-panel\n          ba-panel-title="Icon Buttons"\n          ba-panel-class="with-scroll">\n        <div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div>\n      </div>\n      <div\n          ba-panel\n          ba-panel-title="Large Buttons"\n          ba-panel-class="with-scroll large-buttons-panel">\n        <div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div>\n      </div>\n    </div>\n    <div class="col-md-6">\n      <div\n          ba-panel\n          ba-panel-title="Button Dropdowns"\n          ba-panel-class="with-scroll">\n        <div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div>\n      </div>\n      <div\n          ba-panel\n          ba-panel-title="Button Groups"\n          ba-panel-class="with-scroll">\n        <div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div>\n      </div>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-12"\n         ba-panel\n         ba-panel-title="Progress Buttons"\n         ba-panel-class="with-scroll">\n      <div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div>\n    </div>\n  </div>\n\n</div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4>\n<div class="row show-grid">\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n  <div class="col-md-1">\n    <div>.col-md-1</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-md-8">\n    <div>.col-md-8</div>\n  </div>\n  <div class="col-md-4">\n    <div>.col-md-4</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-md-4">\n    <div>.col-md-4</div>\n  </div>\n  <div class="col-md-4">\n    <div>.col-md-4</div>\n  </div>\n  <div class="col-md-4">\n    <div>.col-md-4</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-md-6">\n    <div>.col-md-6</div>\n  </div>\n  <div class="col-md-6">\n    <div>.col-md-6</div>\n  </div>\n</div>\n\n<h4 class="grid-h">Mobile and desktop</h4>\n<div class="row show-grid">\n  <div class="col-xs-12 col-md-8">\n    <div>xs-12 .col-md-8</div>\n  </div>\n  <div class="col-xs-6 col-md-4">\n    <div>xs-6 .col-md-4</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-xs-6 col-md-4">\n    <div>xs-6 .col-md-4</div>\n  </div>\n  <div class="col-xs-6 col-md-4">\n    <div>xs-6 .col-md-4</div>\n  </div>\n  <div class="col-xs-6 col-md-4">\n    <div>xs-6 .col-md-4</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-xs-6">\n    <div>.col-xs-6</div>\n  </div>\n  <div class="col-xs-6">\n    <div>.col-xs-6</div>\n  </div>\n</div>\n\n<h4 class="grid-h">Mobile, tablet, desktop</h4>\n<div class="row show-grid">\n  <div class="col-xs-12 col-sm-6 col-md-8">\n    <div>.col-xs-12 .col-sm-6 .col-md-8</div>\n  </div>\n  <div class="col-xs-6 col-md-4">\n    <div>.col-xs-6 .col-md-4</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-xs-6 col-sm-4">\n    <div>.col-xs-6 .col-sm-4</div>\n  </div>\n  <div class="col-xs-6 col-sm-4">\n    <div>.col-xs-6 .col-sm-4</div>\n  </div>\n  <div class="clearfix visible-xs-block"></div>\n  <div class="col-xs-6 col-sm-4">\n    <div>.col-xs-6 .col-sm-4</div>\n  </div>\n</div>\n\n<h4 class="grid-h">Column wrapping</h4>\n<div class="row show-grid">\n  <div class="col-xs-9">\n    <div>.col-xs-9</div>\n  </div>\n  <div class="col-xs-4">\n    <div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous\n      unit.\n    </div>\n  </div>\n  <div class="col-xs-6">\n    <div>.col-xs-6<br>Subsequent columns continue along the new line.</div>\n  </div>\n</div>\n\n<h4 class="grid-h">Responsive column resets</h4>\n<div class="row show-grid">\n  <div class="col-xs-6 col-sm-3">\n    <div>.col-xs-6 .col-sm-3 <p>Resize your viewport or check it out on your phone for an example.</p></div>\n  </div>\n  <div class="col-xs-6 col-sm-3">\n    <div>.col-xs-6 .col-sm-3</div>\n  </div>\n  <div class="clearfix visible-xs-block"></div>\n  <div class="col-xs-6 col-sm-3">\n    <div>.col-xs-6 .col-sm-3</div>\n  </div>\n  <div class="col-xs-6 col-sm-3">\n    <div>.col-xs-6 .col-sm-3</div>\n  </div>\n</div>\n\n<h4 class="grid-h">Offsetting columns</h4>\n<div class="row show-grid">\n  <div class="col-md-4">\n    <div>.col-md-4</div>\n  </div>\n  <div class="col-md-4 col-md-offset-4">\n    <div>.col-md-4 .col-md-offset-4</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-md-3 col-md-offset-3">\n    <div>.col-md-3 .col-md-offset-3</div>\n  </div>\n  <div class="col-md-3 col-md-offset-3">\n    <div>.col-md-3 .col-md-offset-3</div>\n  </div>\n</div>\n<div class="row show-grid">\n  <div class="col-md-6 col-md-offset-3">\n    <div>.col-md-6 .col-md-offset-3</div>\n  </div>\n</div>\n\n<h4 class="grid-h">Grid options</h4>\n<div class="table-responsive">\n<table class="table table-bordered table-striped">\n  <thead>\n  <tr>\n    <th></th>\n    <th> Extra small devices\n      <small>Phones (&lt;768px)</small>\n    </th>\n    <th> Small devices\n      <small>Tablets (\u2265768px)</small>\n    </th>\n    <th> Medium devices\n      <small>Desktops (\u2265992px)</small>\n    </th>\n    <th> Large devices\n      <small>Desktops (\u22651200px)</small>\n    </th>\n  </tr>\n  </thead>\n  <tbody>\n  <tr>\n    <th class="text-nowrap" scope="row">Grid behavior</th>\n    <td>Horizontal at all times</td>\n    <td colspan="3">Collapsed to start, horizontal above breakpoints</td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row">Container width</th>\n    <td>None (auto)</td>\n    <td>750px</td>\n    <td>970px</td>\n    <td>1170px</td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row">Class prefix</th>\n    <td><code>.col-xs-</code></td>\n    <td><code>.col-sm-</code></td>\n    <td><code>.col-md-</code></td>\n    <td><code>.col-lg-</code></td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row"># of columns</th>\n    <td colspan="4">12</td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row">Column width</th>\n    <td class="text-muted">Auto</td>\n    <td>~62px</td>\n    <td>~81px</td>\n    <td>~97px</td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row">Gutter width</th>\n    <td colspan="4">30px (15px on each side of a column)</td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row">Nestable</th>\n    <td colspan="4">Yes</td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row">Offsets</th>\n    <td colspan="4">Yes</td>\n  </tr>\n  <tr>\n    <th class="text-nowrap" scope="row">Column ordering</th>\n    <td colspan="4">Yes</td>\n  </tr>\n  </tbody>\n</table>\n</div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets">\n\n  <div class="row">\n    <div class="col-md-12"\n         ba-panel\n         ba-panel-title="Inline Form"\n         ba-panel-class="with-scroll">\n      <div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div>\n    </div>\n  </div>\n\n</div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets">\n\n  <div class="row">\n    <div class="col-md-6">\n      <div\n          ba-panel\n          ba-panel-title="Kameleon SVG Icons"\n          ba-panel-class="with-scroll">\n        <div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div>\n      </div>\n      <div\n          ba-panel\n          ba-panel-title="Socicon"\n          ba-panel-class="with-scroll">\n        <div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div>\n      </div>\n    </div>\n    <div class="col-md-6">\n      <div\n          ba-panel\n          ba-panel-title="Icons With Rounded Background"\n          ba-panel-class="with-scroll">\n        <div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div>\n      </div>\n      <div\n          ba-panel\n          ba-panel-title="ionicons"\n          ba-panel-class="with-scroll">\n        <div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div>\n      </div>\n      <div\n          ba-panel\n          ba-panel-title="Font Awesome Icons"\n          ba-panel-class="with-scroll">\n        <div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div>\n      </div>\n    </div>\n  </div>\n\n</div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets">\n\n  <div class="row">\n    <div class="col-md-12"\n         ba-panel\n         ba-panel-title="Modals"\n         ba-panel-class="with-scroll">\n      <div class="modal-buttons clearfix">\n        <button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button>\n        <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">\n          Large modal\n        </button>\n        <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">\n          Small modal\n        </button>\n      </div>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-6"\n         ba-panel\n         ba-panel-title="Message Modals"\n         ba-panel-class="with-scroll">\n      <div class="modal-buttons same-width clearfix">\n        <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">\n          Success Message\n        </button>\n        <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button>\n        <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">\n          Warning Message\n        </button>\n        <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">\n          Danger Message\n        </button>\n      </div>\n    </div>\n    <div class="col-md-6"\n         ba-panel\n         ba-panel-title="Notifications"\n         ba-panel-class="with-scroll">\n      <div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div>\n    </div>\n  </div>\n  <div class="row">\n    <div class="col-md-6"\n         ba-panel\n         ba-panel-title="Progress dialogs"\n         ba-panel-class="with-scroll">\n      <div class="modal-buttons same-width clearfix">\n        <button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">\n          Progress dialog\n        </button>\n      </div>\n    </div>\n  </div>\n\n</div>\n');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel ba-panel-class="with-scroll notification-panel">\n  <div class="row">\n    <div class="col-md-3 col-sm-4">\n      <div class="control">\n        <label for="title">Title</label>\n        <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ...">\n      </div>\n      <div class="control">\n        <label for="message">Message</label>\n        <textarea ng-model="options.msg" class="form-control" id="message" rows="3"\n                  placeholder="Enter a message ..."></textarea>\n      </div>\n      <div class="control-group">\n        <div class="control">\n          <label class="checkbox-inline custom-checkbox nowrap">\n            <input ng-model="options.closeButton" type="checkbox" id="closeButton">\n            <span>Close Button</span>\n          </label>\n        </div>\n        <div class="control">\n          <label class="checkbox-inline custom-checkbox nowrap">\n            <input ng-model="options.allowHtml" type="checkbox" id="html">\n            <span>Allow html</span>\n          </label>\n        </div>\n        <div class="control">\n          <label class="checkbox-inline custom-checkbox nowrap">\n            <input ng-model="options.progressBar" type="checkbox" id="progressBar">\n            <span>Progress bar</span>\n          </label>\n        </div>\n        <div class="control">\n          <label class="checkbox-inline custom-checkbox nowrap">\n            <input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates">\n            <span>Prevent duplicates</span>\n          </label>\n        </div>\n        <div class="control">\n          <label class="checkbox-inline custom-checkbox nowrap">\n            <input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates">\n            <span>Prevent open duplicates</span>\n          </label>\n        </div>\n        <div class="control">\n          <label class="checkbox-inline custom-checkbox nowrap">\n            <input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss">\n            <span>Tap to dismiss</span>\n          </label>\n        </div>\n        <div class="control">\n          <label class="checkbox-inline custom-checkbox nowrap">\n            <input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop">\n            <span>Newest on top</span>\n          </label>\n        </div>\n      </div>\n    </div>\n    <div class="col-md-2 col-sm-3 toastr-radio-setup">\n      <div id="toastTypeGroup">\n        <div class="controls radio-controls">\n          <label class="radio-header">Toast Type</label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.type" name="toasts" value="success"/><span>Success</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.type" name="toasts" value="info"/><span>Info</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.type" name="toasts" value="warning"/><span>Warning</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.type" name="toasts" value="error"/><span>Error</span>\n          </label>\n        </div>\n      </div>\n      <div id="positionGroup">\n        <div class="controls radio-controls">\n          <label class="radio-header position-header">Position</label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"/>\n            <span>Top Right</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"/>\n            <span>Bottom Right</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"/>\n            <span>Bottom Left</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"/>\n            <span>Top Left</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"/>\n            <span>Top Full Width</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"/>\n            <span>Bottom Full Width</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"/>\n            <span>Top Center</span>\n          </label>\n          <label class="radio custom-radio">\n            <input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"/>\n            <span>Bottom Center</span>\n          </label>\n        </div>\n      </div>\n    </div>\n    <div class="col-md-2 col-sm-3">\n      <div class="control">\n        <label for="timeOut">Time out</label>\n        <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms">\n        <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label>\n      </div>\n      <div class="control">\n        <label for="extendedTimeOut">Extended time out</label>\n        <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut"\n               placeholder="ms">\n      </div>\n      <div class="control">\n        <label for="maxOpened">Maximum number of toasts</label>\n        <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0">\n        <label for="maxOpened" class="sub-label">0 means no limit</label>\n      </div>\n      <div class="control">\n        <label class="checkbox-inline custom-checkbox nowrap">\n          <input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss">\n          <span>Auto dismiss</span>\n        </label>\n      </div>\n    </div>\n    <div class="col-md-5 col-sm-12">\n      <label>Result:</label>\n      <pre class="result-toastr" id=\'toastrOptions\'>{{optionsStr}}</pre>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-12 button-row">\n      <button ng-click="openToast()" class="btn btn-primary">Open Toast</button>\n      <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button>\n      <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button>\n      <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button>\n    </div>\n  </div>\n\n</div>\n');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2>\n<div class="row">\n\n  <div class="col-md-12 col-lg-4">\n    <div ba-panel ba-panel-class="xsmall-panel light-text">\n      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet\n      semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam\n      pulvinar sagittis quam.\n    </div>\n  </div>\n  <div class="col-md-12 col-lg-4">\n    <div ba-panel ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">\n      Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim.\n      Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec\n      suscipit consequat tellus.\n    </div>\n  </div>\n  <div class="col-md-12 col-lg-4">\n    <div ba-panel ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text">\n      <p>\n        Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi\n        mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada\n        pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.\n      </p>\n\n\n      <p>\n        Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla\n        dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales\n        augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam\n        condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales\n        consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero\n        vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu,\n        rutrum vehicula sem.\n      </p>\n\n      <p>\n        Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi\n        mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada\n        pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.\n      </p>\n\n      <p>\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed\n        dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam\n        sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna,\n        varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget\n        lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et\n        malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.\n      </p>\n\n    </div>\n  </div>\n</div>\n\n\n<h2>Bootstrap panels</h2>\n<div class="row">\n\n  <div class="col-md-12 col-lg-4">\n    <div class="panel panel-default bootstrap-panel xsmall-panel">\n      <div class="panel-body">\n        <p>A panel in bootstrap is a bordered box with some padding around its content.</p>\n\n        <p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a\n          <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes\n          are used to style the color of the\n          panel. See the next example on this page for more contextual classes.</p>\n      </div>\n    </div>\n  </div>\n\n  <div class="col-md-12 col-lg-4">\n    <div class="panel panel-default bootstrap-panel xsmall-panel">\n      <div class="panel-heading">Panel Heading</div>\n      <div class="panel-body">\n        <p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading\n          container to your\n          panel with .panel-heading. You may also include any\n          <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.\n        </p>\n      </div>\n    </div>\n  </div>\n\n  <div class="col-md-12 col-lg-4">\n    <div class="panel panel-default bootstrap-panel">\n      <div class="panel-body footer-panel">\n        <p class="p-with-code">\n          Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors\n          and\n          borders when\n          using contextual variations as they are not meant to be in the foreground.\n        </p>\n      </div>\n      <div class="panel-footer">Panel Footer</div>\n    </div>\n  </div>\n</div>\n\n<h2>Panels with Contextual Classes</h2>\n<div class="row">\n  <div class="col-md-6 col-lg-4">\n    <div class="panel panel-default contextual-example-panel bootstrap-panel">\n      <div class="panel-heading">Panel with panel-default class</div>\n      <div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code>\n        panel\n      </div>\n    </div>\n  </div>\n\n  <div class="col-md-6 col-lg-4">\n    <div class="panel panel-primary contextual-example-panel bootstrap-panel">\n      <div class="panel-heading">Panel with panel-primary class</div>\n      <div class="panel-body">Sample <code>.panel-primary</code> panel</div>\n    </div>\n  </div>\n\n  <div class="col-md-6 col-lg-4">\n    <div class="panel panel-success contextual-example-panel bootstrap-panel">\n      <div class="panel-heading">Panel with panel-success class</div>\n      <div class="panel-body">Sample <code>.panel-success</code> panel</div>\n    </div>\n  </div>\n\n  <div class="col-md-6 col-lg-4">\n    <div class="panel panel-info contextual-example-panel bootstrap-panel">\n      <div class="panel-heading">Panel with panel-info class</div>\n      <div class="panel-body">Sample <code>.panel-info</code> panel</div>\n    </div>\n  </div>\n\n  <div class="col-md-6 col-lg-4">\n    <div class="panel panel-warning contextual-example-panel bootstrap-panel">\n      <div class="panel-heading">Panel with panel-warning class</div>\n      <div class="panel-body">Sample <code>.panel-warning</code> panel</div>\n    </div>\n  </div>\n\n  <div class="col-md-6 col-lg-4">\n    <div class="panel panel-danger contextual-example-panel bootstrap-panel">\n      <div class="panel-heading">Panel with panel-danger class</div>\n      <div class="panel-body">Sample <code>.panel-danger</code> panel</div>\n    </div>\n  </div>\n\n</div>\n\n<div class="row">\n  <div class="col-md-12">\n    <h2>Panel Group</h2>\n\n    <div class="panel-group">\n      <div class="panel panel-default bootstrap-panel">\n        <div class="panel-heading">Panel group 1</div>\n        <div class="panel-body">\n          <p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p>\n        </div>\n      </div>\n      <div class="panel panel-default bootstrap-panel">\n        <div class="panel-heading">Panel group 2</div>\n        <div class="panel-body">\n          <p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets">\n\n  <div class="row">\n    <div class="col-md-6">\n      <div\n          ba-panel\n          ba-panel-title="Basic"\n          ba-panel-class="with-scroll">\n        <div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div>\n      </div>\n      <div\n          ba-panel\n          ba-panel-title="Striped"\n          ba-panel-class="with-scroll">\n        <div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div>\n      </div>\n    </div>\n    <div class="col-md-6">\n      <div\n          ba-panel\n          ba-panel-title="With label"\n          ba-panel-class="with-scroll">\n        <div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div>\n      </div>\n      <div\n          ba-panel\n          ba-panel-title="Animated"\n          ba-panel-class="with-scroll">\n        <div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div>\n      </div>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-12"\n         ba-panel\n         ba-panel-title="Stacked"\n         ba-panel-class="with-scroll">\n      <div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div>\n    </div>\n  </div>\n\n</div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row">\n  <div class="col-md-12">\n    <div ba-panel ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll">\n      <div class="slider-box">\n        <h5>Basic</h5>\n        <ion-slider type="single"\n                    grid="false"\n                    min="0"\n                    max="100"\n                    from="45"\n                    disable="false">\n        </ion-slider>\n      </div>\n      <div class="slider-box">\n        <h5>With prefix</h5>\n        <ion-slider type="single"\n                    grid="true"\n                    min="100"\n                    max="1200"\n                    prefix="$"\n                    from="420"\n                    disable="false">\n        </ion-slider>\n      </div>\n      <div class="slider-box">\n        <h5>With postfix</h5>\n        <ion-slider type="single"\n                    grid="true"\n                    min="-90"\n                    max="90"\n                    postfix="\xB0"\n                    from="36"\n                    disable="false">\n        </ion-slider>\n      </div>\n      <div class="slider-box">\n        <h5>Two way range</h5>\n        <ion-slider type="double"\n                    grid="true"\n                    min="100"\n                    max="1200"\n                    from="420"\n                    to="900"\n                    disable="false">\n        </ion-slider>\n      </div>\n      <div class="slider-box">\n        <h5>With Steps</h5>\n        <ion-slider type="single"\n                    grid="true"\n                    min="0"\n                    max="1000"\n                    from="300"\n                    step="50"\n                    disable="false">\n        </ion-slider>\n      </div>\n      <div class="slider-box">\n        <h5>Decorating numbers</h5>\n        <ion-slider type="single"\n                    grid="true"\n                    min="0"\n                    max="1000000"\n                    from="300000"\n                    step="1000"\n                    prettify-separator="."\n                    prettify="true"\n                    disable="false">\n        </ion-slider>\n      </div>\n      <div class="slider-box">\n        <h5>Using custom values array</h5>\n        <ion-slider type="single"\n                    grid="true"\n                    from="5"\n                    step="1000"\n                    values="[\'January\', \'February\', \'March\',\n                            \'April\', \'May\', \'June\',\n                            \'July\', \'August\', \'September\',\n                            \'October\', \'November\', \'December\']"\n                    disable="false">\n        </ion-slider>\n      </div>\n      <div class="slider-box">\n        <h5>Disabled</h5>\n        <ion-slider type="single"\n                    grid="false"\n                    min="0"\n                    max="100"\n                    from="45"\n                    disable="true">\n        </ion-slider>\n      </div>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion>\n  <uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">\n    Primary <i class="ion-heart"></i>\n  </uib-accordion-group>\n  <uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">\n    Success <i class="ion-checkmark-round"></i>\n  </uib-accordion-group>\n  <uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">\n    Info <i class="ion-information-circled"></i>\n  </uib-accordion-group>\n  <uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">\n    Warning <i class="ion-alert"></i>\n  </uib-accordion-group>\n  <uib-accordion-group  heading="Danger"  panel-class="panel-danger bootstrap-panel accordion-panel">\n    Danger <i class="ion-nuclear"></i>\n  </uib-accordion-group>\n</uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab">\n  <uib-tab heading="Start">\n    <p>\n      Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain,\n      muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the\n      way to success.\n    </p>\n\n    <p>\n      People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a\n      way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even\n      become a self-fulfilling prophecy.\n    </p>\n\n    <div class="text-center">\n      <div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div>\n      <div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div>\n      <div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div>\n    </div>\n\n    <p>\n      The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as\n      believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who\n      will be sharing the adventure with them.\n    </p>\n\n  </uib-tab>\n  <uib-tab heading="Getting Done">\n    <p>\n      You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that\n      the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma,\n      whatever. This approach has never let me down, and it has made all the difference in my life.\n    </p>\n\n    <p>\n      The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as\n      believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who\n      will be sharing the adventure with them.\n    </p>\n  </uib-tab>\n  <uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown">\n    <uib-tab-heading uib-dropdown>\n      <a uib-dropdown-toggle ng-click="$event.stopPropagation()">\n        Dropdown tab <i class="caret"></i>\n      </a>\n      <ul class="dropdown-menu" uib-dropdown-menu>\n        <li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li>\n        <li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li>\n      </ul>\n    </uib-tab-heading>\n    <div ng-show="$dropdownTabActive == 1">\n      <p>\n        Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that\n        benefit others.\n      </p>\n\n      <p>Failure is the condiment that gives success its flavor.</p>\n    </div>\n    <div ng-show="$dropdownTabActive == 2">\n      <p class="text-center">\n        <button class="btn btn-danger">I\'m just a dummy button</button>\n      </p>\n    </div>\n  </uib-tab>\n</uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion>\n  <uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">\n    This content is straight in the template.\n  </uib-accordion-group>\n  <uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default">\n    <p>The body of the uib-accordion group grows to fit the contents</p>\n    <button type="button" class="btn btn-primary btn-sm">Add Item</button>\n  </uib-accordion-group>\n  <uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">\n    Hello\n  </uib-accordion-group>\n  <uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default">\n    <uib-accordion-heading>\n      I can have markup, too! <i class="fa pull-right ion-settings"></i>\n    </uib-accordion-heading>\n    This is just some content to illustrate fancy headings.\n  </uib-accordion-group>\n</uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel\n     ba-panel-class="tabs-panel xsmall-panel with-scroll">\n  <uib-tabset class="tabs-left">\n    <uib-tab heading="Start">\n      <p class="text-center">\n        Take up one idea.\n      </p>\n\n      <div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div>\n      <p>\n        People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a\n        way to succeed. </p>\n    </uib-tab>\n    <uib-tab heading="Get it done">\n      <p>\n        You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust\n        that\n        the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma,\n        whatever. This approach has never let me down, and it has made all the difference in my life.\n      </p>\n\n      <p>\n        The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them\n        as\n        believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who\n        will be sharing the adventure with them.\n      </p>\n    </uib-tab>\n    <uib-tab heading="Achieve">\n      <p>\n        Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that\n        benefit others.\n      </p>\n\n      <p>Failure is the condiment that gives success its flavor.</p>\n    </uib-tab>\n  </uib-tabset>\n</div>\n\n<div ba-panel\n     ba-panel-class="tabs-panel xsmall-panel with-scroll">\n  <uib-tabset class="tabs-right">\n    <uib-tab heading="Start">\n      <p class="text-center">\n        Take up one idea.\n      </p>\n\n      <div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div>\n      <p>\n        People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a\n        way to succeed. </p>\n    </uib-tab>\n    <uib-tab heading="Get it done">\n      <p>\n        You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust\n        that\n        the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma,\n        whatever. This approach has never let me down, and it has made all the difference in my life.\n      </p>\n\n      <p>\n        The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them\n        as\n        believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who\n        will be sharing the adventure with them.\n      </p>\n    </uib-tab>\n    <uib-tab heading="Achieve">\n      <p>\n        Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that\n        benefit others.\n      </p>\n\n      <p>Failure is the condiment that gives success its flavor.</p>\n    </uib-tab>\n  </uib-tabset>\n</div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div>\n  <div class="row">\n    <div class="col-md-6">\n      <div\n          ba-panel\n          ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel">\n        <div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div>\n      </div>\n    </div>\n    <div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div>\n  </div>\n  <div class="row accordions-row">\n    <div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div>\n    <div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid">\n  <div class="col-xlg-3 col-lg-6  col-md-6 col-sm-6 col-xs-12 typography-widget">\n    <div ba-panel ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size">\n      <div class="section-block">\n        <h1>H1. Heading 1</h1>\n\n        <p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat\n          vestibulum eleifend pellentesque.</p>\n      </div>\n      <div class="section-block">\n        <h2>H2. Heading 2</h2>\n\n        <p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat\n          vestibulum eleifend pellentesque.</p>\n      </div>\n      <div class="section-block">\n        <h3>H3. Heading 3</h3>\n\n        <p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat\n          vestibulum eleifend pellentesque.</p>\n      </div>\n      <div class="section-block">\n        <h4>H4. Heading 4</h4>\n\n        <p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p>\n      </div>\n      <div class="section-block">\n        <h5>H5. Heading 5</h5>\n\n        <p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p>\n      </div>\n    </div>\n  </div>\n\n  <div class="col-xlg-3 col-lg-6  col-md-6 col-sm-6 col-xs-12 typography-widget">\n    <div ba-panel ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text">\n      <div class="section-block light-text">\n        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis\n          ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed\n          ornare\n          nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.\n        </p>\n      </div>\n      <div class="section-block regular-text">\n        <p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna\n          mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur\n          ridiculus\n          mus. Nullam id dolor id.\n        </p>\n      </div>\n      <div class="section-block upper-text bold-text">\n        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor,\n          quis\n          ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed\n          ornare\n          nulla. </p>\n      </div>\n      <div class="section-block bold-text">\n        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor,\n          quis\n          ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed\n          ornare\n          nulla.\n        </p>\n      </div>\n      <div class="section-block small-text">\n        <p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p>\n\n        <p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p>\n\n        <p> pellentesque, mi nam.</p>\n      </div>\n    </div>\n  </div>\n\n  <div class="col-xlg-3 col-lg-6  col-md-6 col-sm-6 col-xs-12 typography-widget">\n    <div ba-panel ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists">\n      <div class="section-block">\n        <h5 class="list-header">Unordered list:</h5>\n        <ul class="blur">\n          <li>Lorem ipsum dolor sit amet</li>\n          <li>\u0421lacinia scelerisque pharetra\n            <ul>\n              <li>Dui rhoncus quisque integer lorem\n                <ul>\n                  <li>Libero iaculis vestibulum eu vitae</li>\n                </ul>\n              </li>\n            </ul>\n          </li>\n          <li>Nisl lectus nibh habitasse suspendisse ut</li>\n          <li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li>\n        </ul>\n        <h5 class="list-header">Ordered Lists:</h5>\n        <ol class="blur">\n          <li><span>Eu non nec cursus quis mollis, amet quam nec</span></li>\n          <li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span>\n            <ol>\n              <li><span>Interdum et justo nulla</span>\n                <ol>\n                  <li><span>Magna amet, suscipit suscipit non amet</span></li>\n                </ol>\n              </li>\n            </ol>\n          </li>\n          <li><span>Metus duis eu non eu ridiculus turpis</span></li>\n          <li>\n            <span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span>\n          </li>\n        </ol>\n        <div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl\n          pulvinar,\n          lacinia scelerisque pharetra.\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <div class="col-xlg-3 col-lg-6  col-md-6 col-sm-6 col-xs-12 typography-widget">\n    <div ba-panel ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color">\n      <div class="section-block red-text ">\n        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis\n          ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed\n          ornare\n          nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis\n          dis\n          parturient montes, nascetur ridiculus mus.\n        </p>\n      </div>\n      <div class="section-block yellow-text ">\n        <p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget\n          urna\n          mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur\n          ridiculus\n          mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.\n        </p>\n      </div>\n      <div class="section-block links">\n        <p>Lorem ipsum <a href>dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor,\n          quis\n          <a href>ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a\n              href>mattis</a> vel eros. In sed ornare\n          nulla.\n        </p>\n      </div>\n      <div class="section-block links">\n        <p><a href>Active link \u2014 #209e91</a></p>\n\n        <p class="hovered"><a href>Hover link \u2014 #17857a</a></p>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class="row-fluid">\n  <div class="col-lg-12 col-sm-12 col-xs-12">\n    <div ba-panel ba-panel-class="banner-column-panel">\n      <div class="banner">\n        <div class="large-banner-wrapper">\n          <img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""/>\n        </div>\n        <div class="banner-text-wrapper">\n          <div class="banner-text">\n            <h1>Simple Banner Text</h1>\n\n            <p>Lorem ipsum dolor sit amet</p>\n\n            <p>Odio amet viverra rutrum</p>\n          </div>\n        </div>\n      </div>\n      <div class="section">\n        <h2>Columns</h2>\n\n        <div class="row">\n          <div class="col-sm-6">\n            <div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""/>\n            </div>\n            <p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a\n                href>dapibus</a> magna rutrum. Ornare neque suspendisse <a\n                href>phasellus wisi</a>, quam cras pede rutrum suspendisse, <a\n                href>felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis,\n              ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed\n              penatibus\n              arcu nulla.</p>\n          </div>\n          <div class="col-sm-6">\n            <div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""/>\n            </div>\n            <p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla,\n              fermentum\n              lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce\n              aliquet\n              fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p>\n          </div>\n        </div>\n\n        <div class="separator"></div>\n\n        <div class="row">\n          <div class="col-sm-4">\n            <h4>Column heading example</h4>\n            <div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""/></div>\n            <p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna\n              maecenas</p>\n            <a href class="learn-more">Lean more</a>\n          </div>\n          <div class="col-sm-4">\n            <h4>Yet another column heading example</h4>\n            <div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""/></div>\n            <p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat\n              in\n              velit</p>\n            <a href class="learn-more">Lean more</a>\n          </div>\n          <div class="col-sm-4">\n            <h4>Third column heading example</h4>\n            <div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""/></div>\n            <p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p>\n            <a href class="learn-more">Lean more</a>\n          </div>\n        </div>\n        <div class="separator"></div>\n      </div>\n    </div>\n  </div>\n</div>\n');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)"\n       ng-mouseleave="hoverElemTop=selectElemTop">\n  <ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight" >\n    <li ng-repeat="item in ::menuItems | gotAcessItems" class="al-sidebar-list-item"\n        ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected"\n        ba-sidebar-toggling-item="item">\n\n      <a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" id="Link{{item.title}}" class="al-sidebar-list-link">\n        <i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span>\n      </a>\n\n      <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu"\n         class="al-sidebar-list-link" ba-ui-sref-toggler>\n        <i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span>\n        <b class="fa fa-angle-down" ui-sref-active="fa-angle-up"\n           ng-if="::item.subMenu"></b>\n      </a>\n\n      <ul ng-if="::item.subMenu" class="al-sidebar-sublist"\n          ng-class="{\'slide-right\': item.slideRight}"\n          ba-ui-sref-toggling-submenu>\n        <li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected"\n            ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item">\n          <a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler\n             class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span>\n            <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}"\n               ng-if="::subitem.subMenu"></b>\n          </a>\n          <ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list"\n              ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}"\n              ba-ui-sref-toggling-submenu>\n            <li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected">\n              <a ng-mouseenter="hoverItem($event, item)" href ng-if="::subSubitem.disabled" class="al-sidebar-list-link">\n                {{ ::subSubitem.title }}\n              </a>\n              <a ng-mouseenter="hoverItem($event, item)"\n                 ui-state="subSubitem.stateRef || \'\'"\n                 ng-if="::!subSubitem.disabled"\n                 ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">\n                {{::subSubitem.title }}\n              </a>\n            </li>\n          </ul>\n          <a ng-mouseenter="hoverItem($event, item)" href ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">\n            {{ ::subitem.title }}\n          </a>\n          <a ng-mouseenter="hoverItem($event, item)"\n             ng-if="::(!subitem.subMenu && !subitem.disabled)"\n             ui-state="subitem.stateRef || \'\'"\n             ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">\n            {{ ::subitem.title}}\n          </a>\n        </li>\n      </ul>\n    </li>\n  </ul>\n  <div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}"\n       ng-class="{\'show-hover-elem\': showHoverElem }"></div>\n</aside>\n');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>\n');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix">\n  <!--<h1 class="al-title">{{ activePageTitle }}</h1>-->\n\n<!--  <ul class="breadcrumb al-breadcrumb">\n    <li>\n      &lt;!&ndash;<a href="#/dashboard">{{\'INHOME.START\' | Translate}}</a></li>&ndash;&gt;\n\n        <a href="/dashboard">Inicio</a></li>\n    <li>{{ activePageTitle }}</li>\n  </ul>-->\n</div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix">\n    <li class="hideOnMobile">\n        <div class="input-group selectBar" ng-if="!baPageTop.hideSelect">\n            <span uib-tooltip="{{\'RESIDENTWINDOWDETAIL.RESIDENCE\' | translate}}"\n                  class="input-group-addon input-group-addon-primary addon-left"\n                  uib-tooltip="{{\'CANTEENDETAIL.SELECTRESIDENCE\' | translate}}"\n                  tooltip-placement="top-left">\n    <span class="ion-card"></span>\n    </span>\n            <ui-select ng-model="baPageTop.selectedBranche"\n                       ng-change="baPageTop.changeResidence(baPageTop.selectedBranche)"\n                       style="-webkit-border-radius:0 ;-moz-border-radius:0 ;border-radius: 0;"\n                       class="btn-group bootstrap-select form-control"\n                       ng-disabled="baPageTop.hideSelect"\n                       append-to-body="true" search-enabled="true">\n                <ui-select-match placeholder="{{\'CANTEENDETAIL.SELECTRESIDENCE\'| translate}}">\n                    <!--<span ng-bind="$select.description"></span>-->\n                    <span class="text-center">\n                         {{baPageTop.selectedBranche.description}}\n                    </span>\n                </ui-select-match>\n                <ui-select-choices repeat="branches in baPageTop.constants.branches|\n                                           findResidence:{find:$select.search,alredy:baPageTop.selectedBranche}">\n                    <span ng-bind-html="branches.description | highlight: $select.search"></span>\n                </ui-select-choices>\n            </ui-select>\n        </div>\n    </li>\n\n\n    <li class="hideOnPc" ng-if="!baPageTop.hideSelect">\n        <div uib-dropdown>\n            <a uib-dropdown-toggle class="msg msgPointer">\n                <i class="selecBar-icon fa fa-globe"></i>\n            </a>\n            <ul class="profile-dropdown dropDownAppUsr" style="width: auto!important;" uib-dropdown-menu>\n                <li style="visibility: hidden"> hideme</li>\n                <li style="visibility: hidden"> hideme</li>\n                <li class="text-right"  ng-repeat="branches in baPageTop.constants.branches track by $index" style="display:inline;">\n                    <a href="#" class="dropD wnAppUsrA" style="font-size: 9pt;" ng-click="baPageTop.changeResidence(branches)"> {{branches.description}} </a>\n                </li>\n            </ul>\n        </div>\n    </li>\n\n\n    <li ng-if="announcementPermission">\n        <a ng-click="goToAnnouncement()" class="msg msgPointer">\n        <i class="ion-ios-bell"></i><span ng-if="announcement > 0">{{announcement}}</span>\n        <div ng-if="announcement > 0" class="notification-ring"></div>\n        </a>\n    </li>\n    <li ng-if="chatPermission">\n        <a ng-click="goToChat()" class="msg msgPointer" id="tourChatboxMsg">\n            <i class="ion-chatbox-working"></i><span ng-if="message > 0">{{message}}</span>\n            <div ng-if="message > 0" class="notification-ring"></div>\n        </a>\n    </li>\n</ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top page-topCustom" scroll-position="scrolled" ng-class="{\'scrolled\': scrolled}">\n    <div style="float:left;left:9px;">\n        <a href="/dashboard" class="al-logo clearfix">\n            <img src="/assets/img/app/logo_tagaste.svg" style="height: 45px; margin-top: 17px;">\n        </a>\n\n        <a href style="margin-top:24px;" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu id="sidebarToggleMenu"></a>\n    </div>\n\n    <p class="devPrint" ng-if="baPageTop.isDev">\n        Entorno desarrollo\n    </p>\n\n    <div class="user-profile clearfix">\n        <div class="al-user-profile" uib-dropdown>\n            <a uib-dropdown-toggle class="profile-toggle-link">\n                <img class="photo-icon" check-avatar ng-src="{{baPageTop.userPhoto}}" style="border-radius:30px"/>\n            </a>\n            <ul class="top-dropdown-menu profile-dropdown dropDownAppUsr"\n                uib-dropdown-menu>\n                <div class="userNameBar"> {{baPageTop.userName}}</div>\n                <div class="titleBorderTop" style="margin-bottom:9px;margin-top:3px"></div>\n                <li class="text-right ">\n                    <a href="#"\n                       class="dropDownAppUsrA"\n                       href="javascript:void(0)" ng-click="baPageTop.getManual();">\n                        <i class="fa fa-book"></i> {{\'BARINTOP.GETMANUAL\' |translate}}\n                    </a>\n                </li>\n                <li class="text-right ">\n                    <a href="#"\n                       class="dropDownAppUsrA"\n                       href="javascript:void(0)" ng-click="baPageTop.renewPass();">\n                        <i class="fa fa-key"></i> {{\'BARINTOP.CHANGEPASS\' |translate}}\n                    </a>\n                </li>\n                <li class="text-right">\n                    <a href="#"\n                       class="dropDownAppUsrA"\n                       onclick="sessionStorage.clear();\n                           window.location.href = window.location.protocol+\'//\'+window.location.host+\'/auth.html\';">\n                        <i class="fa fa-power-off"></i> {{\'BARINTOP.CLOSEUSRMSG\' |translate}}\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n    <msg-center class="notificationMsg"></msg-center>\n</div>\n\n');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200">\n    <circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"/>\n    <circle cx="100" cy="100" r="90" fill="none" id="loader" class=""\n            stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000"\n            transform="rotate(-90,100,100)" stroke-linecap="round"/>\n    <text text-anchor="middle" class="loading" x="100" y="90">Loading...</text>\n    <text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text>\n</svg>');
$templateCache.put('app/theme/directives/taskTimeTable/taskTimeTable.html','<style>\n\n    h1 {\n        width: 90%;\n        margin-bottom: 0;\n        color: #2cab54;\n    }\n\n    h2 {\n        margin-top: 0;\n        border-bottom: 1px solid #aaa;\n        font-size: 0.9em;\n        color: #808080;\n    }\n\n    .my-timetable{\n        /*width: 90%;*/\n        border-spacing: 0;\n        border-collapse: collapse;\n        line-height: 20px;\n\n        -moz-user-select: -moz-none;\n        -khtml-user-select: none;\n        -webkit-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n    }\n\n    .my-timetable th {\n        font-size: 0.8em;\n        /*color: #808080;*/\n        color: #fff;\n        cursor: pointer;\n    }\n\n    .my-timetable td {\n        border: 1px solid #ccc;\n        cursor: pointer;\n    }\n\n    .my-timetable .dayWeek {\n        text-align: center;\n        font-size: 1em;\n        color: #8AF37E;\n    }\n\n\n    .my-timetable td:hover {\n        background: orange;\n    }\n\n    .my-timetable .selected {\n        background: #2cab54;\n    }\n\n    .my-timetable .disabled {\n        pointer-events: none;\n    }\n</style>\n<table class="my-timetable">\n    <colgroup>\n        <col span="1" width="9%">\n        <col data-ng-repeat="i in loop(0, 8, 1)" span="1" width="13%">\n    </colgroup>\n    <thead>\n    <th></th>\n    <th data-ng-repeat="day in days"  class="dayWeek" data-ng-click="toggle(\'day\', $index)">{{day}}</th>\n    </thead>\n    <tbody>\n    <tr data-ng-repeat="i in loop(0, 2, 1)">\n        <th data-ng-click="toggle(\'hour\', 0, i)">{{momentsOfDay[i]}}</th>\n        <td data-ng-repeat="j in loop(0, 6, 1)" data-ng-mousedown="select(true, j, i)" data-ng-mouseup="select(false)" data-ng-mouseover="toggle(\'slot\', j, i)" data-ng-click="toggle(\'slot\', j, i)" data-ng-class="{selected: slots[j][i] , disabled: disabled }"></td>\n    </tr>\n    </tbody>\n</table>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container">\n  <input type="checkbox" ng-model="switcherValue" ng-disabled="switcherReadOnly"\n         ng-change="onChange({value :switcherValue})">\n  <div class="switcher" ng-class="::switcherStyle">\n    <div class="handle-container">\n      <span class="handle handle-on" ng-class="{\'{{switcherIconOn}}\': switcherIconOn}"\n       ng-style="(switcherReadOnly) ? {\'cursor\': \'default\'}:\'\';(iconSize) ? {\'font-size\' : iconSize} : \'\'">\n          {{switcherOn}}</span>\n      <span class="handle" ng-style="(switcherReadOnly) ? {\'cursor\': \'default\'}:\'\'"></span>\n      <span class="handle handle-off" ng-class="{\'{{switcherIconOff}}\': switcherIconOff}"\n       ng-style="(switcherReadOnly) ? {\'cursor\': \'default\'}:\'\';(iconSize) ? {\'font-size\' : iconSize} : \'\'">\n          {{switcherOff}}</span>\n    </div>\n  </div>\n</label>');
$templateCache.put('app/components/canteen/backItems/inDish/inDish.html','<div ng-class="(dsba.noflipper === true ) ? \'\' : \'flip-container\'" ontouchstart="this.classList.toggle(\'hover\');"\n     style="text-align: -webkit-center">\n    <div ng-class="(dsba.noflipper === true ) ? \'\' : \'flipper\'">\n        <div ng-class="(dsba.showselected === true ) ? \'inDishSelected\' : \'inDish\'" style="width:200px;padding:6px;"\n             tooltip-class="customClass"\n             ng-style="{ \'cursor\' : (dsba.isselect !== false || dsba.readonly === true) ? \'cell\' : \'auto\'}"\n             ng-disabled="dsba.istour" tagaste-click="dsba.ck()" ng-if="dsba.ready === true">\n\n            <div class="dishPicture" ng-class="(dsba.chose === true) ? \'selectInDish\' : \'\'"\n                 ng-style="{ \'background\':(!dsba.disba.photo) ?\n                 \'url(/assets/tagaste/imgNotFound.png)\' : \'url(\'+dsba.disba.photo.thumb.signedUrl+\')\'}">\n            </div>\n\n            <div class="dishTitle">\n                <div class="inDishTitle">\n                    <p><span>{{dsba.disba.text}}</span></p>\n                </div>\n                <div ng-if="dsba.isselect === false && !dsba.readonly" class="ion-minus-circled inDishIcon delete"\n                     ng-disabled="dsba.istour"\n                     tagaste-click="dsba.deletestr= {_id:dsba.disba._id, type : dsba.type}"></div>\n                <div ng-if="dsba.isselect !== false && !dsba.readonly" class="fa fa-pencil-square-o inDishIcon edit"\n                     ng-disabled="dsba.istour" tagaste-click="dsba.goEdit($event)">\n                </div>\n                <div ng-if="!dsba.hideReserve" uib-tooltip-html="{{\'CANTEENNEWCOURSE.RESERVETTIP\' | translate}}"\n                     tooltip-class="customClass" class="inDishReserve text-right">\n                    {{dsba.disba.userNumber}} <span class="ion-fork dish-fork"></span>\n                </div>\n            </div>\n        </div>\n\n        <div class="inDishBack" tagaste-click="dsba.ck()" ng-disabled="dsba.istour"\n             ng-style="{ \'cursor\' : (dsba.isselect !== false || dsba.readonly === true) ? \'cell\' : \'auto\'}">\n            <div ng-if="dsba.isselect === false && !dsba.readonly" class="ion-minus-circled inDishIcon delete"\n                 ng-disabled="dsba.istour" tagaste-click="dsba.deletestr= {_id:dsba.disba._id, type : dsba.type}"></div>\n            <div ng-if="dsba.isselect !== false && !dsba.readonly" class="fa fa-pencil-square-o inDishIcon edit"\n                 ng-disabled="dsba.istour" tagaste-click="dsba.goEdit($event)">\n            </div>\n\n            <div class="title">{{dsba.disba.text}}</div>\n            <!-- TODO Harcoded titles! -->\n            <div class="nutritionals">\n                <div class="nut_r">\n                    <div class="nut_c1">{{dsba.disba.nutritional.salt}}{{\'CANTEENNEWCOURSE.SALT\' | translate}}</div>\n                    <div class="nut_c2">{{dsba.disba.nutritional.fiber}}{{\'CANTEENNEWCOURSE.FIBER\' | translate}}</div>\n                    <div class="nut_c3">{{dsba.disba.nutritional.saturedFat}}{{\'CANTEENNEWCOURSE.SATUREDFAT\' |\n                        translate}}\n                    </div>\n                </div>\n                <div class="nut_r">\n                    <div class="nut_c1">{{dsba.disba.nutritional.fat}}{{\'CANTEENNEWCOURSE.FAT\' | translate}}</div>\n                    <div class="nut_c2">{{dsba.disba.nutritional.sugars}}{{\'CANTEENNEWCOURSE.SUGARS\' | translate}}</div>\n                    <div class="nut_c3">{{dsba.disba.nutritional.carbohydrates}}{{\'CANTEENNEWCOURSE.CARBOHYDRATES\' |\n                        translate}}\n                    </div>\n                </div>\n                <div class="nut_r">\n                    <div class="nut_c1">{{dsba.disba.nutritional.protein}}{{\'CANTEENNEWCOURSE.PROTEIN\' | translate}}\n                    </div>\n                    <div class="nut_c2">{{dsba.disba.nutritional.joules}} {{\'CANTEENNEWCOURSE.JOULES\' | translate}}\n                    </div>\n                    <div class="nut_c3">{{dsba.disba.nutritional.calorie}} {{\'CANTEENNEWCOURSE.CALORIE\' | translate}}\n                    </div>\n                </div>\n            </div>\n            <div class="allergyIconsInDish">\n                <div ng-repeat="allergy in dsba.allergies" style="display: inline-block;">\n                    <span style="padding-left:3px;padding-right: 3px;" tooltip-trigger="mouseenter"\n                          tooltip-append-to-body="true"\n                          uib-tooltip="{{allergy.description}}"\n                          ng-if="allergy.selected"\n                          class="{{allergy.icon}}"></span>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/components/canteen/backItems/carteenNew/carteenNew.html','<div class="row">\n    <div class="col-md-12 col-lg-12 rightPanel">\n        <div ba-panel ba-panel-title-no-translate="<b>{{cnc.tit}}</b>" ba-panel-anim="zoom-in"\n             ba-panel-class="with-scroll" class="panelRight">\n            <form name="newCourse">\n                <div style="display: flex">\n                    <div style="padding: 10px;">\n                        <avatar size="100" type="food" shape="square" img="cnc.imgAvatar"\n                                style="text-align: center;"\n                                uploading="cnc.avatarUploading"\n                                photo="cnc.photoAvatar" id="newDishImg"\n                                readonly="cnc.istour"></avatar>\n                    </div>\n                    <div style="flex-grow: 1; text-align: center">\n                        <div style="position: relative">\n                            <div style="display: inline-block;padding-top: 10px;">\n                                <ba-switcher switcher-style="primary" switcher-value="cnc.dish.active"\n                                             style="position: absolute; top: 0; right: 0"\n                                             switcher-on="\'CANTEENNEWCOURSE.ACTIVE\'|translate"\n                                             switcher-off="\'CANTEENNEWCOURSE.ACTIVE\'|translate"\n                                             switcher-read-only="false"\n                                             uib-tooltip="{{\'CANTEENNEWCOURSE.ACTIVE\' | translate}}"\n                                             tooltip-placement="bottom"\n                                             switcher-value="cnc.active">\n                                </ba-switcher>\n                            </div>\n                            <div class="buttonGroup btn-group " role="group" style="margin-top: 40px;margin-bottom: 10px;" id="newDishType">\n                                <label ng-repeat="dishType in cnc.dishTypes" class="btn btn-success"\n                                       ng-click="cnc.selectTypeMe(dishType._id)"\n                                       uib-tooltip="{{dishType.description}}"\n                                       ng-style="(dishType._id === cnc.dish.dishType._id) ?\n                                       {\'opacity\' : \'1\' } : {\'opacity\' : \'0.3\'}">\n                                    {{dishType.description}}\n                                </label>\n                            </div>\n                            <div class="errorValidation bounceIn animate"\n                                 ng-if="cnc.submitted && !cnc.dish.dishType">\n                                {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                            </div>\n                        </div>\n                        <div style="align-self:center; text-align: center;" id="newDishAllergen">\n                            <div ng-repeat="allergen in cnc.allergens"\n                                 style="display: inline-block; margin:4px; font-size: 18px"><i\n                                uib-tooltip="{{allergen.description}}" class="{{allergen.icon}}"\n                                ng-click="cnc.changeAllerge(allergen,newCourse)"\n                                ng-style="allergen.selected ?\n                            { \'color\': \'rgba(128, 254, 193, 1)\' } : { \'color\': \'rgba(128, 254, 193, 0.3)\'}"></i>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n\n                <div class="row">\n                    <div class="col-md-12">\n                        <div class="input-group" id="newDishName">\n                        <span class="input-group-addon input-group-addon-primary addon-left"\n                              uib-tooltip="{{\'CANTEENNEWCOURSE.NAME\' | translate}}"\n                              tooltip-placement="top-left">\n                            <span class="ion-compose"></span>\n                        </span>\n                            <input type="text" ng-readonly="cnc.modeReadOnly" name="text"\n                                   ng-required="true"\n                                   class="form-control with-primary-addon" required\n                                   placeholder="{{\'BULLETINBOARDDETAIL.TITLE\'|translate}}"\n                                   aria-describedby="basic-addon1"\n                                   ng-class="{\'invalid\': cnc.submitted && !newCourse.text.$valid }"\n                                   ng-model="cnc.dish.text">\n                        </div>\n                        <div class="errorValidation bounceIn animate"\n                             ng-if="cnc.submitted && !newCourse.text.$valid">\n                            {{\'ERROR.NOTVALIDINPUT\' |translate}}\n                        </div>\n                    </div>\n                    <div class="col-md-12">\n                        <div class="input-group" id="newDishTags">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{\'CANTEENNEWCOURSE.TAG\'| translate}}"\n                                  tooltip-placement="top-left">\n                                        <span class="ion-card"></span>\n                                    </span>\n                            <ui-select\n                                name="selTag"\n                                multiple\n                                ng-model="cnc.dish.tags"\n                                class="btn-group form-control"\n                                search-enabled="true">\n                                <ui-select-match placeholder="{{\'CANTEENNEWCOURSE.TAG\'| translate}}"\n                                                 style="min-width: 117px">\n                                    <span name="{{$item}}">{{$item}}</span>\n                                </ui-select-match>\n                                <ui-select-choices\n                                    repeat="tag in cnc.constant.tags |\n                                    findTags:{find:$select.search,alredy:cnc.dish.tags}">\n                                    <span ng-bind-html="tag | highlight: $select.search"></span>\n                                </ui-select-choices>\n                            </ui-select>\n                        </div>\n                    </div>\n                    <div class="col-md-12">\n                        <div class="row">\n                            <div class="canteenTitle">\n                                <div class="canteenTitleText" style="font-size: 16px; padding: 0 10px;">\n                                    {{\'CANTEENNEWCOURSE.NUTRITIONALINFO\' | translate}}\n                                </div>\n                                <div style="margin-left:7px; margin-bottom:13px;" class="canteenTitleBorder"></div>\n                            </div>\n                        </div>\n                        <div class="row" id="newDishKal">\n                            <div class="col-xs-4" ng-repeat="nu in cnc.dish.nutritional track by $index">\n                                <div class="input-group">\n                            <span class="input-group-addon input-group-addon-primary addon-left"\n                                  uib-tooltip="{{cnc.getObjectKeyTranslate(cnc.dish.nutritional,$index) |translate}}"\n                                  tooltip-placement="top-left">\n                                <span class="ion-compose"></span>\n                            </span>\n                                    <input type="text" ng-readonly="cnc.modeReadOnly" name="cale"\n                                           valid-number\n                                           class="form-control with-primary-addon" title=" "\n                                           placeholder="{{cnc.getObjectKeyTranslate(cnc.dish.nutritional,$index) |\n                                           translate}}"\n                                           aria-describedby="basic-addon1"\n                                           ng-model="cnc.dish.nutritional[cnc.getObjectKey(cnc.dish.nutritional,\n                                           $index)]">\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="row">\n                    <div class="col-xs-12">\n                        <button style="margin-top:17px;margin-bottom:7px;" type="button"\n                                class="btn btn-success btn-with-icon pull-right"\n                                ng-disabled="( cnc.avatarUploading || cnc.submitted  && (!newCourse.$valid ||\n                                newCourse.$pristine && cnd.dish.tags.length() === cnd.tagOri.length()))"\n                                tagaste-click="cnc.save(newCourse)" id="newDishSave">\n                            <i class="ion-android-checkmark-circle"></i>{{\'BUTTONS.SAVE\' |translate}}\n                        </button>\n                        <button style="margin-top:17px;margin-bottom:7px;margin-right:17px;" type="button"\n                                class="btn btn-success btn-with-icon pull-right"\n                                tagaste-click="cnc.dish = null;" id="newDishCancel">\n                            <i class="ion-arrow-left-c"></i>{{\'BUTTONS.BACK\' |translate}}\n                        </button>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/components/inService/inServiceReserve/modal/inServiceReserveModal.html','<div class="modal-body">\n    <in-service-reserve\n        level="2"\n        anim-schedule="mod.animSchedule"\n        service="mod.data"\n        mode-cancel="mod.modeCancel"\n        show-reserve-view="mod.showReserveView">\n    </in-service-reserve>\n</div>\n');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example">\n  <div class="btn-group" role="group" aria-label="Basic example">\n    <button type="button" class="btn btn-danger">Left</button>\n    <button type="button" class="btn btn-danger">Middle</button>\n    <button type="button" class="btn btn-danger">Right</button>\n  </div>\n</div>\n\n<div class="btn-toolbar-example">\n  <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">\n    <div class="btn-group" role="group" aria-label="First group">\n      <button type="button" class="btn btn-primary">1</button>\n      <button type="button" class="btn btn-primary">2</button>\n      <button type="button" class="btn btn-primary">3</button>\n      <button type="button" class="btn btn-primary">4</button>\n    </div>\n    <div class="btn-group" role="group" aria-label="Second group">\n      <button type="button" class="btn btn-primary">5</button>\n      <button type="button" class="btn btn-primary">6</button>\n      <button type="button" class="btn btn-primary">7</button>\n    </div>\n    <div class="btn-group" role="group" aria-label="Third group">\n      <button type="button" class="btn btn-primary">8</button>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns">\n  <div class="row">\n    <div class="col-md-2"><h5>Default button</h5></div>\n    <div class="col-md-10">\n      <div class="row btns-row btns-same-width-md">\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div>\n      </div>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-2"><h5 class="row-sm">Small button</h5></div>\n    <div class="col-md-10">\n    <div class="row btns-row btns-same-width-md">\n      <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div>\n      <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div>\n      <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div>\n      <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div>\n      <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div>\n      <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div>\n    </div>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div>\n    <div class="col-md-10">\n      <div class="row btns-row btns-same-width-md">\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div>\n      </div>\n    </div>\n  </div>\n\n  <div class="row">\n    <div class="col-md-2"><h5>Disabled button</h5></div>\n    <div class="col-md-10">\n      <div class="row btns-row btns-same-width-md">\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div>\n        <div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div>\n      </div>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row">\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-primary " uib-dropdown-toggle>\n        Primary <span class="caret"></span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-success " uib-dropdown-toggle>\n        Success <span class="caret"></span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-info " uib-dropdown-toggle>\n        Info <span class="caret"></span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-default " uib-dropdown-toggle>\n        Default <span class="caret"></span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-warning " uib-dropdown-toggle>\n        Warning <span class="caret"></span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-danger " uib-dropdown-toggle>\n        Danger <span class="caret"></span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n</div>\n\n<h5 class="panel-subtitle">Split button dropdowns</h5>\n\n<div class="row btns-row">\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-primary">Primary</button>\n      <button type="button" class="btn btn-primary " uib-dropdown-toggle>\n        <span class="caret"></span>\n        <span class="sr-only">Toggle Dropdown</span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-success">Success</button>\n      <button type="button" class="btn btn-success " uib-dropdown-toggle>\n        <span class="caret"></span>\n        <span class="sr-only">Toggle Dropdown</span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-info">Info</button>\n      <button type="button" class="btn btn-info " uib-dropdown-toggle>\n        <span class="caret"></span>\n        <span class="sr-only">Toggle Dropdown</span>\n      </button>\n      <ul uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-default">Default</button>\n      <button type="button" class="btn btn-default " uib-dropdown-toggle>\n        <span class="caret"></span>\n        <span class="sr-only">Toggle Dropdown</span>\n      </button>\n      <ul uib-dropdown-menu uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-warning">Warning</button>\n      <button type="button" class="btn btn-warning " uib-dropdown-toggle>\n        <span class="caret"></span>\n        <span class="sr-only">Toggle Dropdown</span>\n      </button>\n      <ul uib-dropdown-menu uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n  <div class="col-sm-4 col-xs-6">\n    <div class="btn-group" uib-dropdown dropdown-append-to-body>\n      <button type="button" class="btn btn-danger">Danger</button>\n      <button type="button" class="btn btn-danger " uib-dropdown-toggle>\n        <span class="caret"></span>\n        <span class="sr-only">Toggle Dropdown</span>\n      </button>\n      <ul uib-dropdown-menu uib-dropdown-menu>\n        <li><a href>Action</a></li>\n        <li><a href>Another action</a></li>\n        <li><a href>Something else here</a></li>\n        <li role="separator" class="divider"></li>\n        <li><a href>Separated link</a></li>\n      </ul>\n    </div>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix">\n  <li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li>\n  <li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li>\n  <li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li>\n  <li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li>\n  <li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li>\n  <li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li>\n</ul>\n\n<h5 class="panel-subtitle">Buttons with icons</h5>\n\n<ul class="btn-list clearfix">\n  <li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li>\n  <li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li>\n  <li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li>\n  <li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li>\n  <li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li>\n  <li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li>\n</ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg">\n  <div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div>\n  <div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div>\n  <div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div>\n  <div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div>\n  <div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div>\n  <div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div>\n</div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text">\n  <div class="row">\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">fill horizontal</span>\n      <button progress-button="progressFunction()" class="btn btn-success">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">fill vertical</span>\n      <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">shrink horizontal</span>\n      <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">shrink vertical</span>\n      <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button>\n    </section>\n  </div>\n  <div class="row">\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-angle-bottom <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-angle-top <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-angle-left <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-angle-right <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button>\n    </section>\n  </div>\n  <div class="row">\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-side-down <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-side-up <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-side-left <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-side-right <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button>\n    </section>\n  </div>\n  <div class="row">\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">rotate-back <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">flip-open <br/>perspective</span>\n      <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">slide-down <br/>horizontal</span>\n      <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button>\n    </section>\n    <section class="col-md-6 col-lg-3">\n      <span class="button-title">move-up <br/>horizontal</span>\n      <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button>\n    </section>\n  </div>\n  <div class="row">\n    <section class="col-md-6">\n      <span class="button-title">top-line <br/>horizontal</span>\n      <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button>\n    </section>\n    <section class="col-md-6">\n      <span class="button-title">lateral-lines <br/>vertical</span>\n      <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button>\n    </section>\n  </div>\n</div>\n');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons">\n  <div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div>\n</div>\n<a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary">\n  <div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div>\n</div>\n<a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix">\n  <div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons">\n    <div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div>\n  </div>\n</div>\n\n<a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>\n\n');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix">\n  <div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons">\n    <div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div>\n  </div>\n</div>\n\n<a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger">\n  <div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div>\n</div>\n<a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content">\n  <div class="modal-header">\n    <button type="button" class="close" ng-click="$dismiss()" aria-label="Close">\n      <em class="ion-ios-close-empty sn-link-close"></em>\n    </button>\n    <h4 class="modal-title" id="myModalLabel">Modal title</h4>\n  </div>\n  <div class="modal-body">\n    Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet\n    dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper\n    suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n  </div>\n  <div class="modal-footer">\n    <button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button>\n  </div>\n</div>\n');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content">\n  <div class="modal-header bg-danger">\n    <i class="ion-flame modal-icon"></i><span> Error</span>\n  </div>\n  <div class="modal-body text-center">Your information hasn\'t been saved!</div>\n  <div class="modal-footer">\n    <button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button>\n  </div>\n</div>\n');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content">\n  <div class="modal-header bg-info">\n    <i class="ion-information-circled modal-icon"></i><span> Information</span>\n  </div>\n  <div class="modal-body text-center">You\'ve got a new email!</div>\n  <div class="modal-footer">\n    <button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button>\n  </div>\n</div>\n');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content">\n  <div class="modal-header">\n    <button type="button" class="close" ng-click="$dismiss()" aria-label="Close">\n      <em class="ion-ios-close-empty sn-link-close"></em>\n    </button>\n    <h4 class="modal-title">Modal title</h4>\n  </div>\n  <div class="modal-body">\n    Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet\n    dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper\n    suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n  </div>\n  <div class="modal-footer">\n    <button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button>\n  </div>\n</div>\n');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content">\n  <div class="modal-header">\n    <button type="button" class="close" ng-click="$dismiss()" aria-label="Close">\n      <em class="ion-ios-close-empty sn-link-close"></em>\n    </button>\n    <h4 class="modal-title">Modal title</h4>\n  </div>\n  <div class="modal-body">\n    Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet\n    dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper\n    suscipit lobortis nisl ut aliquip ex ea commodo consequat.\n  </div>\n  <div class="modal-footer">\n    <button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button>\n  </div>\n</div>\n\n');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content">\n  <div class="modal-header bg-success">\n    <i class="ion-checkmark modal-icon"></i><span> Success</span>\n  </div>\n  <div class="modal-body text-center">Your information has been saved successfully</div>\n  <div class="modal-footer">\n    <button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button>\n  </div>\n</div>\n\n');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content">\n  <div class="modal-header bg-warning">\n    <i class="ion-android-warning modal-icon"></i><span> Warning</span>\n  </div>\n  <div class="modal-body text-center">Your computer is about to explode!</div>\n  <div class="modal-footer">\n    <button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button>\n  </div>\n</div>\n');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl">\n  <button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button>\n  <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button>\n  <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button>\n  <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button>\n</div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl">\n    <div class="modal-body">\n        <progress-bar-round>\n        </progress-bar-round>\n    </div>\n    <div class="modal-footer">\n    </div>\n</div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress">\n  <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">\n    <span class="sr-only">40% Complete (success)</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">\n    <span class="sr-only">20% Complete</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">\n    <span class="sr-only">60% Complete (warning)</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n    <span class="sr-only">80% Complete (danger)</span>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress">\n  <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">\n    <span class="sr-only">40% Complete (success)</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">\n    <span class="sr-only">20% Complete</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">\n    <span class="sr-only">60% Complete (warning)</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n    <span class="sr-only">80% Complete (danger)</span>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress">\n  <div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">\n    40% Complete (success)\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">\n    20% Complete\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">\n    60% Complete (warning)\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n    80% Complete (danger)\n  </div>\n</div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress">\n  <div class="progress-bar progress-bar-success" style="width: 35%">\n    <span class="sr-only">35% Complete (success)</span>\n  </div>\n  <div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%">\n    <span class="sr-only">20% Complete (warning)</span>\n  </div>\n  <div class="progress-bar progress-bar-danger" style="width: 10%">\n    <span class="sr-only">10% Complete (danger)</span>\n  </div>\n  <div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%">\n    <span class="sr-only">20% Complete (warning)</span>\n  </div>\n</div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress">\n  <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">\n    <span class="sr-only">40% Complete (success)</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">\n    <span class="sr-only">20% Complete</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">\n    <span class="sr-only">60% Complete (warning)</span>\n  </div>\n</div>\n<div class="progress">\n  <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">\n    <span class="sr-only">80% Complete (danger)</span>\n  </div>\n</div>');}]);